
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("iPGiI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $24ea81cab40e076f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fNobW = parcelRequire("fNobW");

var $jD5no = parcelRequire("jD5no");

var $2vSU6 = parcelRequire("2vSU6");

var $4Pf62 = parcelRequire("4Pf62");

var $79GHn = parcelRequire("79GHn");

var $29caV = parcelRequire("29caV");

var $6QFTz = parcelRequire("6QFTz");

var $dAfqg = parcelRequire("dAfqg");

var $9NiTW = parcelRequire("9NiTW");

var $38Y30 = parcelRequire("38Y30");

var $90yGq = parcelRequire("90yGq");

var $hqBSi = parcelRequire("hqBSi");

var $7tQej = parcelRequire("7tQej");
const $24ea81cab40e076f$var$JiraSoftwareSummaryApp = ()=>{
    const accountId = (0, $90yGq.useAccountId)();
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const projectData = (0, $5uXOq.useMemo)(()=>{
        if (!projectContextData) return null;
        return {
            key: projectContextData.projectKey,
            projectId: String(projectContextData.projectId),
            name: projectContextData.projectName,
            projectStyle: projectContextData.simplified ? (0, $2vSU6.TEAM_MANAGED_PROJECT) : (0, $2vSU6.COMPANY_MANAGED_PROJECT),
            projectType: (0, $2vSU6.convertToJiraProjectType)(projectContextData.projectType)
        };
    }, [
        projectContextData
    ]);
    const linksResolver = (0, $5uXOq.useCallback)((options)=>`./list?${(0, $6QFTz.generateListViewParams)(options)}`, []);
    if (!projectData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "jira-summary-use-features"
    });
    if (!accountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38Y30.RedirectToLoginPage), null);
    const hasSoftwareLicense = licensedProducts?.[(0, $4Pf62.LICENSED_PRODUCTS).JIRA_SOFTWARE];
    if (!hasSoftwareLicense) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: "/jira/projects"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
        id: "jira-summary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $79GHn.SummaryFeaturesProvider), {
        linksResolver: linksResolver
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $29caV.SummaryPage), {
        projectData: projectData
    }))));
};
var $24ea81cab40e076f$export$2e2bcd8739ae039 = $24ea81cab40e076f$var$JiraSoftwareSummaryApp;

});
parcelRegister("79GHn", function(module, exports) {

$parcel$export(module.exports, "useSummaryFeatures", () => $cb7fb21035e503c9$export$ab34b4f862c26cc7);
$parcel$export(module.exports, "SummaryFeaturesProvider", () => $cb7fb21035e503c9$export$2fe684ea577fbeaa);

var $5uXOq = parcelRequire("5uXOq");
const $cb7fb21035e503c9$var$defaultFeaturesContext = {
    linksTarget: '_self'
};
const $cb7fb21035e503c9$var$SummaryFeaturesContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $cb7fb21035e503c9$export$ab34b4f862c26cc7 = ()=>{
    const summaryFeaturesContext = (0, $5uXOq.useContext)($cb7fb21035e503c9$var$SummaryFeaturesContext);
    if (!summaryFeaturesContext) throw new Error('useSummaryFeatures must be used within a SummaryFeaturesProvider');
    return summaryFeaturesContext;
};
const $cb7fb21035e503c9$export$2fe684ea577fbeaa = ({ children: children, ...props })=>{
    const value = (0, $5uXOq.useMemo)(()=>({
            ...$cb7fb21035e503c9$var$defaultFeaturesContext,
            ...props
        }), [
        props
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb7fb21035e503c9$var$SummaryFeaturesContext.Provider, {
        value: value
    }, children);
};

});

parcelRegister("29caV", function(module, exports) {

$parcel$export(module.exports, "SummaryPage", () => $2ae557c7930a36b6$export$893608e1a22999b9);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $hTEpF = parcelRequire("hTEpF");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $8dO33 = parcelRequire("8dO33");

var $jS4lj = parcelRequire("jS4lj");

var $gEFwt = parcelRequire("gEFwt");

var $cS37j = parcelRequire("cS37j");

var $2vSU6 = parcelRequire("2vSU6");

var $2i4sA = parcelRequire("2i4sA");

var $7CMCs = parcelRequire("7CMCs");

var $7iULw = parcelRequire("7iULw");

var $coTzA = parcelRequire("coTzA");

var $id7K0 = parcelRequire("id7K0");

var $3uP2Y = parcelRequire("3uP2Y");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $efvDm = parcelRequire("efvDm");

var $9dbF6 = parcelRequire("9dbF6");

var $k9JTq = parcelRequire("k9JTq");

var $l8ruj = parcelRequire("l8ruj");


var $gECAw = parcelRequire("gECAw");

var $l2v9x = parcelRequire("l2v9x");
const $2ae557c7930a36b6$export$893608e1a22999b9 = ({ projectData: projectData, useRouteResource: useRouteResource, isEmbed: isEmbed = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const appEditions = (0, $k9JTq.useAppEditions)();
    const analyticsDataAttributes = (0, $5uXOq.useMemo)(()=>({
            // convertToProjectType handles the case where projectData.projectType is invalid
            // @ts-expect-error TS2322: Type '%future added value' is not assignable to type JiraProjectType
            projectType: (0, $2vSU6.convertToProjectType)(projectData.projectType)
        }), [
        projectData.projectType
    ]);
    const isSimplifiedProject = projectData.projectStyle === (0, $2vSU6.TEAM_MANAGED_PROJECT);
    const experienceTrackerAttributes = (0, $5uXOq.useMemo)(()=>({
            simplified: isSimplifiedProject
        }), [
        isSimplifiedProject
    ]);
    const documentTitle = `${formatMessage((0, $gECAw.default).title)} - ${projectData.name}`;
    if (projectData.projectType !== (0, $2vSU6.JIRA_PROJECT_TYPE_CORE_PROJECT) && projectData.projectType !== (0, $2vSU6.JIRA_PROJECT_TYPE_SOFTWARE_PROJECT)) throw new Error(`Unsupported project type: ${projectData.projectType}`);
    const { edition: edition, application: application, subProduct: subProduct } = {
        [(0, $2vSU6.JIRA_PROJECT_TYPE_CORE_PROJECT)]: {
            edition: appEditions.core,
            application: (0, $efvDm.JIRA_CORE),
            subProduct: 'core'
        },
        [(0, $2vSU6.JIRA_PROJECT_TYPE_SOFTWARE_PROJECT)]: {
            edition: appEditions.software,
            application: (0, $efvDm.JIRA_SOFTWARE),
            subProduct: 'software'
        }
    }[projectData.projectType];
    const breadcrumb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEFwt.default), {
        projectKey: projectData.key,
        projectName: projectData.name,
        projectId: projectData.projectId,
        isSimplifiedProject: isSimplifiedProject
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jS4lj.default), null)); // business (core) projects already have the "nav4 styling" applied originally without the FF turned on
    const shouldShowPageHeader = !(0, $3HwlS.getWillShowNav4)() && projectData.projectType !== (0, $2vSU6.JIRA_PROJECT_TYPE_CORE_PROJECT) && !isEmbed;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "jira-summary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: documentTitle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        objectType: "summary",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "summary",
        attributes: analyticsDataAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        teamName: "Helios - Reports",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
                header: formatMessage((0, $gECAw.default).emptyStateTitle),
                description: formatMessage((0, $gECAw.default).emptyStateDescription),
                primaryAction: // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
                    appearance: "primary",
                    onClick: ()=>window.location.reload()
                }, formatMessage((0, $gECAw.default).emptyStateRefreshButton)),
                imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($3uP2Y)))
            }),
        id: "summaryPage",
        packageName: "jiraSpaAppsSoftwareSummary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2i4sA.ViewExperienceTrackingProvider), {
        experience: "viewSummary",
        experienceId: projectData.projectId,
        analyticsSource: "summary",
        edition: edition,
        application: application,
        additionalAttributes: experienceTrackerAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8dO33.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: $2ae557c7930a36b6$var$containerStyles
    }, shouldShowPageHeader ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $2ae557c7930a36b6$var$headerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        truncateTitle: true,
        breadcrumbs: breadcrumb
    }, formatMessage((0, $gECAw.default).title))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $2ae557c7930a36b6$var$contentTopPaddingStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l2v9x.ProjectSummary), {
        projectKey: projectData.key,
        projectId: projectData.projectId,
        projectType: projectData.projectType,
        useRouteResource: useRouteResource
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_11q71iew _2rkoiti9 _zulpu2gc _4cvr1h6o _1e0c1txw _19pkxy5q _19bvu2gc _1tjqxzlw _h7v81bp4 _1lp7vrvc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $gECAw.default).feedbackPrompt,
        values: {
            message: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, chunks),
            button: (chunks)=>{
                const feedbackButtonCustomLabel = (0, $5uXOq.Children).toArray(chunks).join('');
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $coTzA.FeedbackCollectorButton), {
                    entrypointId: (0, $7iULw.ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT),
                    feedbackGroupId: (0, $bb0765c22d6034e5$export$14b33d63628336c2),
                    feedbackButtonCustomLabel: feedbackButtonCustomLabel
                });
            }
        }
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: subProduct
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null)));
};
const $2ae557c7930a36b6$var$containerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    paddingInline: 'space.300',
    paddingBlockEnd: 'space.300',
    marginInline: 'auto',
    maxWidth: '1200px'
});
const $2ae557c7930a36b6$var$headerContainerStyles = (0, $8CUq3.xcss)({
    width: '100%'
});
const $2ae557c7930a36b6$var$contentTopPaddingStyles = (0, $8CUq3.xcss)({
    paddingBlockStart: 'space.300'
});
const $2ae557c7930a36b6$var$promptContainerStyles = null;

});
parcelRegister("8dO33", function(module, exports) {

$parcel$export(module.exports, "SmartCardProvider", () => $08b794feb02c83c1$export$497ecb0280204df4);

var $5uXOq = parcelRequire("5uXOq");

var $3f2cs = parcelRequire("3f2cs");

var $cCcdH = parcelRequire("cCcdH");

var $k9B19 = parcelRequire("k9B19");

var $8b7fu = parcelRequire("8b7fu");

var $051X7 = parcelRequire("051X7");

var $7cFR3 = parcelRequire("7cFR3");
function $08b794feb02c83c1$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, featureFlags: featureFlags, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product }) {
    const parentContext = (0, $5uXOq.useContext)((0, $051X7.SmartCardContext));
    const defaultInitialState = (0, $5uXOq.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $5uXOq.useMemo)(()=>{
        return (0, $3f2cs.createStore)((0, $8b7fu.cardReducer), initialState);
    }, [
        initialState
    ]);
    const providerValue = (0, $5uXOq.useMemo)(()=>{
        const client = customClient || new (0, $7cFR3.default)();
        // If product is passed into provider, set it on the client if setProduct is supported
        if (product && client.setProduct) client.setProduct(product);
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, platform)=>{
            const cardState = (0, $cCcdH.getUrl)(store, url);
            return cardState.details ? (0, $k9B19.extractPreview)(cardState.details.data, platform) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            featureFlags: featureFlags,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product
        };
    }, [
        customClient,
        customAuthFlow,
        isAdminHubAIEnabled,
        product,
        renderers,
        featureFlags,
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $051X7.SmartCardContext).Provider, {
        value: parentContext || providerValue
    }, children);
}
var $08b794feb02c83c1$export$2e2bcd8739ae039 = $08b794feb02c83c1$export$497ecb0280204df4;

});
parcelRegister("cCcdH", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $ca3b29c0c8dd3593$export$94df0e59ebebf4a7);
const $ca3b29c0c8dd3593$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};

});

parcelRegister("k9B19", function(module, exports) {

$parcel$export(module.exports, "extractPreview", () => $596309a7bcc79771$export$4b0d98b1b7f6d115);

var $TFljV = parcelRequire("TFljV");

var $7OmtM = parcelRequire("7OmtM");
const $596309a7bcc79771$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = (0, $TFljV.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $7OmtM.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $7OmtM.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
};

});
parcelRegister("TFljV", function(module, exports) {

$parcel$export(module.exports, "extractPlatformIsSupported", () => $f8cdc1e628cbc347$export$3e8ad908070b68b2);
const $f8cdc1e628cbc347$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};

});

parcelRegister("7OmtM", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromLinkJsonLd", () => $0784379594099aa0$export$396ba4ef2e37dc65);
const $0784379594099aa0$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $0784379594099aa0$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
};

});


parcelRegister("8b7fu", function(module, exports) {

$parcel$export(module.exports, "cardReducer", () => $92a815d7e26b35c0$export$3c7c3113a97b6492);

var $2yPrN = parcelRequire("2yPrN");
var $fiKQs = parcelRequire("fiKQs");
const $92a815d7e26b35c0$var$isCardAction = (action)=>{
    return [
        (0, $2yPrN.ACTION_PENDING),
        (0, $2yPrN.ACTION_RESOLVING),
        (0, $2yPrN.ACTION_RESOLVED),
        (0, $2yPrN.ACTION_RELOADING),
        (0, $2yPrN.ACTION_ERROR),
        (0, $2yPrN.ACTION_ERROR_FALLBACK),
        (0, $2yPrN.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $92a815d7e26b35c0$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $fiKQs.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $92a815d7e26b35c0$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $2yPrN.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $2yPrN.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $2yPrN.ACTION_RESOLVED:
            return $92a815d7e26b35c0$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $2yPrN.ACTION_RELOADING:
            return $92a815d7e26b35c0$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $2yPrN.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $2yPrN.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $2yPrN.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $92a815d7e26b35c0$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$92a815d7e26b35c0$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $92a815d7e26b35c0$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};

});
parcelRegister("2yPrN", function(module, exports) {

$parcel$export(module.exports, "ACTION_PENDING", () => $23a1ee9f12bb755d$export$6e470aad5ba8952e);
$parcel$export(module.exports, "ACTION_RESOLVING", () => $23a1ee9f12bb755d$export$9a6a932a0a39498e);
$parcel$export(module.exports, "ACTION_RESOLVED", () => $23a1ee9f12bb755d$export$63ec8bc7a8a75482);
$parcel$export(module.exports, "ACTION_RELOADING", () => $23a1ee9f12bb755d$export$b8cfaa842c9ab487);
$parcel$export(module.exports, "ACTION_ERROR", () => $23a1ee9f12bb755d$export$6d8ed3f9433dd372);
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", () => $23a1ee9f12bb755d$export$cfbbb7126bc8a0c6);
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", () => $23a1ee9f12bb755d$export$2c5edb971b673330);
$parcel$export(module.exports, "cardAction", () => $23a1ee9f12bb755d$export$a884a52152489cc3);
// TODO: eventually move this file to @atlaskit/link-actions
const $23a1ee9f12bb755d$export$6e470aad5ba8952e = 'pending';
const $23a1ee9f12bb755d$export$9a6a932a0a39498e = 'resolving';
const $23a1ee9f12bb755d$export$63ec8bc7a8a75482 = 'resolved';
const $23a1ee9f12bb755d$export$b8cfaa842c9ab487 = 'reloading';
const $23a1ee9f12bb755d$export$6d8ed3f9433dd372 = 'errored';
const $23a1ee9f12bb755d$export$cfbbb7126bc8a0c6 = 'fallback';
const $23a1ee9f12bb755d$export$76b5c1aca20759c6 = 'preload';
const $23a1ee9f12bb755d$export$2c5edb971b673330 = 'metadata';
const $23a1ee9f12bb755d$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });

});

parcelRegister("fiKQs", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $5c2f531cb20db568$export$b70265791d2079d4);
const $5c2f531cb20db568$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $5c2f531cb20db568$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $5c2f531cb20db568$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});


parcelRegister("051X7", function(module, exports) {

$parcel$export(module.exports, "SmartCardContext", () => $b8de051ddcb2808f$export$156b523e63b4f63a);
$parcel$export(module.exports, "useSmartLinkContext", () => $b8de051ddcb2808f$export$e1d190b530cf0ee9);
$parcel$export(module.exports, "useSmartCardContext", () => $b8de051ddcb2808f$export$10e9cca30e50f657);
$parcel$export(module.exports, "EditorSmartCardProviderValueGuard", () => $b8de051ddcb2808f$export$797e3658f090919c);
$parcel$export(module.exports, "EditorSmartCardProvider", () => $b8de051ddcb2808f$export$2a29ca11e08dc129);

var $5uXOq = parcelRequire("5uXOq");

const $b8de051ddcb2808f$export$156b523e63b4f63a = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
function $b8de051ddcb2808f$export$e1d190b530cf0ee9() {
    const context = (0, $5uXOq.useContext)($b8de051ddcb2808f$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
const $b8de051ddcb2808f$export$10e9cca30e50f657 = ()=>$b8de051ddcb2808f$var$useContextMemoized($b8de051ddcb2808f$export$156b523e63b4f63a);
const $b8de051ddcb2808f$export$797e3658f090919c = ({ children: children })=>{
    const cardContext = $b8de051ddcb2808f$export$10e9cca30e50f657();
    if (!cardContext?.value) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
function $b8de051ddcb2808f$var$useContextMemoized(reactContext) {
    const value = (0, $5uXOq.useContext)(reactContext);
    const context = (0, $5uXOq.useMemo)(()=>({
            Provider: reactContext.Provider,
            Consumer: reactContext.Consumer,
            value: value
        }), [
        value,
        reactContext
    ]);
    return context;
}
const $b8de051ddcb2808f$export$2a29ca11e08dc129 = ({ children: children })=>{
    const cardContext = $b8de051ddcb2808f$export$10e9cca30e50f657();
    const Provider = cardContext.Provider;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Provider, {
        value: cardContext.value
    }, children);
};
var $b8de051ddcb2808f$export$2e2bcd8739ae039 = $b8de051ddcb2808f$export$156b523e63b4f63a;

});

parcelRegister("7cFR3", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d96ed473518bd99$export$2e2bcd8739ae039);

var $hhZW9 = parcelRequire("hhZW9");

var $hj8yn = parcelRequire("hj8yn");

var $hLXaJ = parcelRequire("hLXaJ");

var $kDZ6Z = parcelRequire("kDZ6Z");
var $itO4f = parcelRequire("itO4f");
var $fiKQs = parcelRequire("fiKQs");
var $dV0Jy = parcelRequire("dV0Jy");

var $4Bkrp = parcelRequire("4Bkrp");

var $iwKVT = parcelRequire("iwKVT");
const $8d96ed473518bd99$var$MAX_BATCH_SIZE = 50;
const $8d96ed473518bd99$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $8d96ed473518bd99$var$URL_RESPONSE_CACHE_SIZE = 100;
const $8d96ed473518bd99$export$d6a66073b5d79eb3 = new (0, $iwKVT.LRUMap)($8d96ed473518bd99$var$URL_RESPONSE_CACHE_SIZE);
class $8d96ed473518bd99$export$2e2bcd8739ae039 {
    constructor(envKey, baseUrlOverride){
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
			 * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
			 * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
			 */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $dV0Jy.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $dV0Jy.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $4Bkrp.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        // Endpoint for batch resolve url
        this.batchResolve = async (urls)=>{
            return this.postBatchResolve(urls, 'URL');
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $itO4f.getResolverUrl)(envKey, baseUrlOverride);
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
    setProduct(product) {
        this.product = product;
    }
    createLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($hLXaJ)))({
            limit: 1,
            interval: $8d96ed473518bd99$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($hhZW9)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $8d96ed473518bd99$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    getLoader(hostname) {
        if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
        return this.loadersByDomain[hostname];
    }
    async resolveUrl(url, force = false) {
        const hostname = new URL(url).hostname;
        const loader = this.getLoader(hostname);
        let responsePromise;
        responsePromise = $8d96ed473518bd99$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            responsePromise = loader.load(url);
            $8d96ed473518bd99$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $8d96ed473518bd99$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $4Bkrp.isSuccessfulResponse)(response) || (0, $fiKQs.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $8d96ed473518bd99$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async prefetchData(url) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false);
        if ((0, $4Bkrp.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($hj8yn)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false);
                    if ((0, $4Bkrp.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch (err) {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $4Bkrp.isErrorResponse)(response) && response.error.status === 429;
    }
    // Fetch data from URL
    async fetchData(url, force) {
        let response = await this.resolveUrl(url, force);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($hj8yn)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $4Bkrp.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
	 * Fetch data for multiple ARIs (batch) in one operation
	 * @param aris Array of ARIs to fetch data for
	 */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $dV0Jy.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
	 * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
	 * spec.
	 * @param data Payload including the search provider key and query. An empty search query string
	 * results in recent results being returned (pre-query).
	 * @returns JsonLd collection of search results.
	 */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $dV0Jy.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $4Bkrp.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $dV0Jy.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $dV0Jy.NetworkError)) return new (0, $kDZ6Z.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $kDZ6Z.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $kDZ6Z.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    return new (0, $kDZ6Z.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $kDZ6Z.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $kDZ6Z.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
	 * This method will strigify both enumerable and  non enumerable properties of an object
	 * @param err
	 * @returns object serialized to JSON with both enumerable and non enumerable objects
	 */ stringifyError(err) {
        /**
		 * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
		 * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
		 * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
		 */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
}

});
parcelRegister("hj8yn", function(module, exports) {
// Packages

var $fGJx3 = parcelRequire("fGJx3");
function $c99ad890679d3578$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        op = $fGJx3.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $c99ad890679d3578$var$retry;

});
parcelRegister("fGJx3", function(module, exports) {

module.exports = (parcelRequire("6Q6YB"));

});
parcelRegister("6Q6YB", function(module, exports) {

var $8vOLa = parcelRequire("8vOLa");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $8vOLa(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("8vOLa", function(module, exports) {
function $632897d2769f1314$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $632897d2769f1314$var$RetryOperation;
$632897d2769f1314$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$632897d2769f1314$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$632897d2769f1314$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$632897d2769f1314$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$632897d2769f1314$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$632897d2769f1314$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$632897d2769f1314$var$RetryOperation.prototype.start = $632897d2769f1314$var$RetryOperation.prototype.try;
$632897d2769f1314$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$632897d2769f1314$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$632897d2769f1314$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});




parcelRegister("hLXaJ", function(module, exports) {
'use strict';
class $cf04b9d0ddc5d8fc$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $cf04b9d0ddc5d8fc$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $cf04b9d0ddc5d8fc$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $cf04b9d0ddc5d8fc$var$pThrottle;
module.exports.AbortError = $cf04b9d0ddc5d8fc$var$AbortError;

});

parcelRegister("kDZ6Z", function(module, exports) {

$parcel$export(module.exports, "APIError", () => $8c263ecf028a2c14$export$3e5b797e39668f84);
class $8c263ecf028a2c14$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}

});

parcelRegister("itO4f", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $21a0efece812cd9a$export$f654b28f82155665);
$parcel$export(module.exports, "getResolverUrl", () => $21a0efece812cd9a$export$dc37652c1696f231);
const $21a0efece812cd9a$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $21a0efece812cd9a$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $21a0efece812cd9a$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $21a0efece812cd9a$export$e2b040f052407032 = {
    dev: $21a0efece812cd9a$var$devBaseUrl,
    development: $21a0efece812cd9a$var$devBaseUrl,
    stg: $21a0efece812cd9a$var$stgBaseUrl,
    staging: $21a0efece812cd9a$var$stgBaseUrl,
    prd: $21a0efece812cd9a$var$prodBaseUrl,
    prod: $21a0efece812cd9a$var$prodBaseUrl,
    production: $21a0efece812cd9a$var$prodBaseUrl
};
const $21a0efece812cd9a$export$f654b28f82155665 = (envKey)=>{
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $21a0efece812cd9a$export$e2b040f052407032 ? $21a0efece812cd9a$export$e2b040f052407032[envKey] : $21a0efece812cd9a$var$prodBaseUrl;
    // Otherwise, use the current origin of the page.
    return typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $21a0efece812cd9a$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $21a0efece812cd9a$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $21a0efece812cd9a$export$2e2bcd8739ae039 = $21a0efece812cd9a$export$e2b040f052407032;

});

parcelRegister("dV0Jy", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $5576d4e9d0a3858d$export$bae979e68e4dc802);
$parcel$export(module.exports, "request", () => $5576d4e9d0a3858d$export$b5fe3f66a567bec0);
const $5576d4e9d0a3858d$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $5576d4e9d0a3858d$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
async function $5576d4e9d0a3858d$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $5576d4e9d0a3858d$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $5576d4e9d0a3858d$export$bae979e68e4dc802(error);
        throw error;
    }
}

});

parcelRegister("4Bkrp", function(module, exports) {

$parcel$export(module.exports, "isSuccessfulResponse", () => $1e00e4fd9b26eb0f$export$1b59fe731a28a49d);
$parcel$export(module.exports, "isErrorResponse", () => $1e00e4fd9b26eb0f$export$bea7bee8a87e7c52);
const $1e00e4fd9b26eb0f$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
const $1e00e4fd9b26eb0f$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};

});



parcelRegister("coTzA", function(module, exports) {

$parcel$export(module.exports, "FeedbackCollectorButton", () => $85f5e51eda76fbac$export$b39479f42d974760);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $aEHvW = parcelRequire("aEHvW");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $koeKL = parcelRequire("koeKL");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $4uMrp = parcelRequire("4uMrp");
const $85f5e51eda76fbac$var$TooltipWrapper = ({ children: children, appearance: appearance, customLabel: customLabel })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (appearance === 'icon') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: customLabel || formatMessage((0, $4uMrp.messages).leaveFeedback),
        position: "top"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $85f5e51eda76fbac$export$b39479f42d974760 = ({ buttonAppearance: buttonAppearance = 'normal', testId: testId, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($aEHvW))), feedbackButtonCustomLabel: feedbackButtonCustomLabel, ...feedbackCollectorProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const buttonRef = (0, $5uXOq.useRef)(null);
    const onOpen = (0, $5uXOq.useCallback)(()=>{
        // Check if feedbackContext already contains the cloud ID entry
        const hasCloudId = feedbackCollectorProps?.feedbackContext?.some((entry)=>entry.id === (0, $7iULw.EntryKeys).CLOUD_ID);
        // If not, add cloud id to feedback context
        const updatedFeedbackContext = hasCloudId ? feedbackCollectorProps.feedbackContext : [
            ...feedbackCollectorProps.feedbackContext || [],
            {
                id: (0, $7iULw.EntryKeys).CLOUD_ID,
                value: cloudId
            }
        ];
        openFeedbackCollector({
            ...feedbackCollectorProps,
            feedbackContext: updatedFeedbackContext,
            triggerRef: buttonRef
        });
    }, [
        cloudId,
        feedbackCollectorProps,
        openFeedbackCollector
    ]);
    const displayAsLink = buttonAppearance === 'link';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85f5e51eda76fbac$var$TooltipWrapper, {
        appearance: buttonAppearance,
        customLabel: feedbackButtonCustomLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85f5e51eda76fbac$var$StyledButton, {
        testId: testId,
        ref: buttonRef,
        appearance: displayAsLink ? 'link' : 'subtle',
        isHighlight: buttonAppearance === 'highlight',
        spacing: displayAsLink ? 'none' : 'default',
        onClick: onOpen,
        iconBefore: displayAsLink ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon // typesupression below can be removed once icon migration completes
        , {
            // @ts-expect-error Property 'color' does not exist on type 'IntrinsicAttributes & IconProps'.ts(2322)
            color: buttonAppearance === 'highlight' ? "var(--ds-text-discovery, #5E4DB2)" : "var(--ds-text, #172B4D)",
            label: ""
        }),
        "aria-label": // Only add aria-label if this is an icon button
        buttonAppearance === 'icon' && (feedbackButtonCustomLabel || formatMessage((0, $4uMrp.messages).leaveFeedback)) || ''
    }, buttonAppearance !== 'icon' && (feedbackButtonCustomLabel || formatMessage((0, $4uMrp.messages).leaveFeedback))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $85f5e51eda76fbac$var$StyledButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isHighlight && "_1w901gqr _16hg1y1p _1fh11gqr _u1mb1hhp _r7sm8kjj _1l5a1gfe",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aEHvW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::06b2b9eec310f6566d6d86916ad7e234>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c1f64cf4f9c421f$var$_react = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7c1f64cf4f9c421f$var$_feedback = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5dqGX")));

var $7c1f64cf4f9c421f$var$_feedback2 = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("3g1Fk")));
function $7c1f64cf4f9c421f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for FeedbackIcon.
 * This component is FeedbackIcon, with `UNSAFE_fallbackIcon` set to "FeedbackIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7c1f64cf4f9c421f$var$FeedbackIcon = (props)=>/*#__PURE__*/ $7c1f64cf4f9c421f$var$_react.default.createElement($7c1f64cf4f9c421f$var$_feedback.default, Object.assign({
        LEGACY_fallbackIcon: $7c1f64cf4f9c421f$var$_feedback2.default
    }, props));
$7c1f64cf4f9c421f$var$FeedbackIcon.Name = 'FeedbackIconMigration';
var $7c1f64cf4f9c421f$var$_default = module.exports.default = $7c1f64cf4f9c421f$var$FeedbackIcon;

});
parcelRegister("5dqGX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cdeb4e8fedeb21cdc8d38f736eb852b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3cc2df171aca9493$var$_react = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3cc2df171aca9493$var$_baseNew = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3cc2df171aca9493$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3cc2df171aca9493$var$FeedbackIcon = (props)=>/*#__PURE__*/ $3cc2df171aca9493$var$_react.default.createElement($3cc2df171aca9493$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9.5V15L6 12.25h7c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2.75C1.75 6.44 2.31 7 3 7h6.75m-2-2.5 2.5 2.5-2.5 2.5"/>`
    }, props));
$3cc2df171aca9493$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $3cc2df171aca9493$var$_default = module.exports.default = $3cc2df171aca9493$var$FeedbackIcon;

});

parcelRegister("3g1Fk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25f4287f17f73dc4$var$_react = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $25f4287f17f73dc4$var$_feedback = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5dqGX")));
function $25f4287f17f73dc4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $25f4287f17f73dc4$var$FeedbackIcon = (props)=>/*#__PURE__*/ $25f4287f17f73dc4$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
    }, props, {
        newIcon: $25f4287f17f73dc4$var$_feedback.default
    }));
$25f4287f17f73dc4$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $25f4287f17f73dc4$var$_default = module.exports.default = $25f4287f17f73dc4$var$FeedbackIcon;

});


parcelRegister("4uMrp", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0c42512912e196d1$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0c42512912e196d1$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    leaveFeedback: {
        "id": "platform.feedback.feedback-collector.button.leave-feedback",
        "defaultMessage": "Give feedback"
    }
});

});


parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

parcelRegister("3uP2Y", function(module, exports) {
module.exports = new URL("generic-empty-state.1b007192.svg", import.meta.url).toString();

});

// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $3iTiR = parcelRequire("3iTiR");

var $ero6m = parcelRequire("ero6m");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $ero6m.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $dJl1T = parcelRequire("dJl1T");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("ero6m", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $0997694844c8a9e7$export$b1fe420ed15dff7b);

var $16v4H = parcelRequire("16v4H");
const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $16v4H.subProductFromProjectType)(projectType);
};

});

parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $dJl1T = parcelRequire("dJl1T");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $dJl1T.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});


const $bb0765c22d6034e5$export$14b33d63628336c2 = 'JSW Summary Page';

parcelRegister("gECAw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff8ce6e89ffe5bf1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ff8ce6e89ffe5bf1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "contextual-summary.title",
        "defaultMessage": "Summary"
    },
    feedbackPrompt: {
        "id": "contextual-summary.feedback-prompt",
        "defaultMessage": "<message>Was the information shown in this page useful?</message> <button>Give us feedback</button>"
    },
    emptyStateTitle: {
        "id": "spa-apps.software.summary.empty-state-title",
        "defaultMessage": "We\u2019re unable to show your summary"
    },
    emptyStateDescription: {
        "id": "spa-apps.software.summary.empty-state-description",
        "defaultMessage": "Try refreshing the page, or check your connection."
    },
    emptyStateRefreshButton: {
        "id": "spa-apps.software.summary.empty-state-refresh-button",
        "defaultMessage": "Refresh"
    }
});

});

parcelRegister("l2v9x", function(module, exports) {

$parcel$export(module.exports, "ProjectSummary", () => $d21806cfe6f7466a$export$5b143d3d85bf5493);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $9dZ1c = parcelRequire("9dZ1c");

var $dC5iT = parcelRequire("dC5iT");
var $bgrar = parcelRequire("bgrar");
var $8CUq3 = parcelRequire("8CUq3");

var $h9kUS = parcelRequire("h9kUS");

var $2vSU6 = parcelRequire("2vSU6");

var $6s1PB = parcelRequire("6s1PB");

var $koeKL = parcelRequire("koeKL");

var $90yGq = parcelRequire("90yGq");


var $ghgEK = parcelRequire("ghgEK");

var $1sc6Q = parcelRequire("1sc6Q");

var $aRfdq = parcelRequire("aRfdq");

var $7Ow6B = parcelRequire("7Ow6B");
const $d21806cfe6f7466a$export$5b143d3d85bf5493 = ({ projectId: projectId, projectKey: projectKey, projectType: projectType, useRouteResource: useRouteResource })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const accountId = (0, $90yGq.useAccountId)() || null;
    const relayEnvironment = (0, $8Uumt.useRelayEnvironment)();
    const isBusinessProject = projectType === (0, $2vSU6.JIRA_PROJECT_TYPE_CORE_PROJECT);
    const epicProgressOrRelatedProjectsBoundaryId = projectType === (0, $2vSU6.JIRA_PROJECT_TYPE_CORE_PROJECT) ? 'jira-summary-related-projects' : 'jira-summary-epic-progress';
    // TODO clean up or refactor WithRouteResourceData components as a part of HL-1930
    const OverviewDoneCountWithRouteResourceData = (0, $1sc6Q.useOverviewCountWithRouteResourceData)('done');
    const OverviewUpdatedCountWithRouteResourceData = (0, $1sc6Q.useOverviewCountWithRouteResourceData)('updated');
    const OverviewCreatedCountWithRouteResourceData = (0, $1sc6Q.useOverviewCountWithRouteResourceData)('created');
    const OverviewDueCountWithRouteResourceData = (0, $1sc6Q.useOverviewCountWithRouteResourceData)('due');
    const StatusOverviewWithRouteResourceData = (0, $1sc6Q.useStatusOverviewWithRouteResourceData)();
    const PriorityBreakdownWithRouteResourceData = (0, $1sc6Q.usePriorityBreakdownWithRouteResourceData)();
    const TypesOfWorkWithRouteResourceAndPaginatedData = (0, $1sc6Q.useTypesOfWorkWithRouteResourceAndPaginatedData)(cloudId, projectKey, (0, $aRfdq.SUMMARY_PAGE_DATA_QUERY));
    const TeamWorkloadWithRouteResourceAndPaginatedData = (0, $1sc6Q.useTeamWorkloadWithRouteResourceAndPaginatedData)(cloudId, projectKey, (0, $aRfdq.SUMMARY_PAGE_DATA_QUERY));
    const RecentActivityWithRouteResourceAndPaginatedData = (0, $1sc6Q.useRecentActivityWithRouteResourceAndPaginatedData)(projectKey);
    // components which don't utilise router resources
    const OverviewDoneCountWithData = (0, $1sc6Q.useOverviewCountWithData)(cloudId, projectKey, 'done', (0, $aRfdq.SUMMARY_PAGE_DATA_QUERY));
    const OverviewUpdatedCountWithData = (0, $1sc6Q.useOverviewCountWithData)(cloudId, projectKey, 'updated', (0, $aRfdq.SUMMARY_PAGE_DATA_QUERY));
    const OverviewCreatedCountWithData = (0, $1sc6Q.useOverviewCountWithData)(cloudId, projectKey, 'created', (0, $aRfdq.SUMMARY_PAGE_DATA_QUERY));
    const OverviewDueCountWithData = (0, $1sc6Q.useOverviewCountWithData)(cloudId, projectKey, 'due', (0, $aRfdq.SUMMARY_PAGE_DATA_QUERY));
    const StatusOverviewWithData = (0, $1sc6Q.useStatusOverviewWithData)(cloudId, projectKey, (0, $aRfdq.SUMMARY_PAGE_DATA_QUERY));
    const PriorityBreakdownWithData = (0, $1sc6Q.usePriorityBreakdownWithData)(cloudId, projectKey, (0, $aRfdq.SUMMARY_PAGE_DATA_QUERY));
    const RecentActivityWithPaginatedData = (0, $1sc6Q.useRecentActivityWithPaginatedData)(projectKey);
    const FastRecentActivityWithData = (0, $1sc6Q.useFastRecentActivityWithData)(projectId);
    const TypesOfWorkWithPaginatedData = (0, $1sc6Q.useTypesOfWorkWithPaginatedData)(cloudId, projectKey, (0, $aRfdq.SUMMARY_PAGE_DATA_QUERY));
    const TeamWorkloadWithPaginatedData = (0, $1sc6Q.useTeamWorkloadWithPaginatedData)(cloudId, projectKey, (0, $aRfdq.SUMMARY_PAGE_DATA_QUERY));
    const EpicProgressOrRelatedProjectsWithData = (0, $1sc6Q.useEpicProgressOrRelatedProjectsWithData)(relayEnvironment, cloudId, projectKey, projectId, projectType, accountId, epicProgressOrRelatedProjectsBoundaryId);
    const fastActivityFeedEnabled = !isBusinessProject && (0, $6s1PB.expVal)('helios_fast_activity_feed', 'isEnabled', false);
    const [config] = (0, $6s1PB.UNSAFE_noExposureExp)('tailored_onboarding_m3');
    const isTailoredOnboardingVariant = config.get('isEnabled', false);
    const { ref: summaryViewNudgeRef } = (0, $9dZ1c.useRegisterNudgeTarget)((0, $6784cbc7d62e5d7c$export$594d3436316492be), true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bgrar.default), {
        xcss: $d21806cfe6f7466a$var$responsiveStyles,
        gap: "space.300",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $d21806cfe6f7466a$var$baseStyle,
            $d21806cfe6f7466a$var$xsBoxStyles,
            $d21806cfe6f7466a$var$overviewCountDoneStyle
        ]
    }, useRouteResource ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(OverviewDoneCountWithRouteResourceData, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(OverviewDoneCountWithData, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $d21806cfe6f7466a$var$baseStyle,
            $d21806cfe6f7466a$var$xsBoxStyles,
            $d21806cfe6f7466a$var$overviewCountUpdatedStyle
        ]
    }, useRouteResource ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(OverviewUpdatedCountWithRouteResourceData, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(OverviewUpdatedCountWithData, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $d21806cfe6f7466a$var$baseStyle,
            $d21806cfe6f7466a$var$xsBoxStyles,
            $d21806cfe6f7466a$var$overviewCountCreatedStyle
        ]
    }, useRouteResource ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(OverviewCreatedCountWithRouteResourceData, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(OverviewCreatedCountWithData, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $d21806cfe6f7466a$var$baseStyle,
            $d21806cfe6f7466a$var$xsBoxStyles,
            $d21806cfe6f7466a$var$overviewCountDueStyle
        ]
    }, useRouteResource ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(OverviewDueCountWithRouteResourceData, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(OverviewDueCountWithData, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $d21806cfe6f7466a$var$baseStyle,
            $d21806cfe6f7466a$var$mdBoxStyles,
            $d21806cfe6f7466a$var$statusOverviewStyle
        ],
        ref: isTailoredOnboardingVariant ? summaryViewNudgeRef : undefined
    }, useRouteResource ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StatusOverviewWithRouteResourceData, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StatusOverviewWithData, null)), isTailoredOnboardingVariant && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ghgEK.SummaryViewNudgeAsync), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $d21806cfe6f7466a$var$baseStyle,
            $d21806cfe6f7466a$var$mdBoxStyles,
            $d21806cfe6f7466a$var$recentActivityStyle
        ]
    }, fastActivityFeedEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FastRecentActivityWithData, null) : useRouteResource ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RecentActivityWithRouteResourceAndPaginatedData, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RecentActivityWithPaginatedData, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $d21806cfe6f7466a$var$baseStyle,
            $d21806cfe6f7466a$var$mdBoxStyles,
            $d21806cfe6f7466a$var$priorityBreakdownStyle
        ]
    }, useRouteResource ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(PriorityBreakdownWithRouteResourceData, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(PriorityBreakdownWithData, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $d21806cfe6f7466a$var$baseStyle,
            $d21806cfe6f7466a$var$mdBoxStyles,
            $d21806cfe6f7466a$var$typesOfWorkStyle
        ]
    }, useRouteResource ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TypesOfWorkWithRouteResourceAndPaginatedData, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TypesOfWorkWithPaginatedData, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $d21806cfe6f7466a$var$baseStyle,
            $d21806cfe6f7466a$var$mdBoxStyles,
            $d21806cfe6f7466a$var$teamWorkloadStyle
        ]
    }, useRouteResource ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TeamWorkloadWithRouteResourceAndPaginatedData, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TeamWorkloadWithPaginatedData, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $d21806cfe6f7466a$var$baseStyle,
            $d21806cfe6f7466a$var$mdBoxStyles,
            $d21806cfe6f7466a$var$epicProgressStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(EpicProgressOrRelatedProjectsWithData, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Ow6B.UFOCustomHoverData), {
        hasHoverEvent: false
    }));
};
const $d21806cfe6f7466a$var$xsBoxStyles = (0, $8CUq3.xcss)({
    height: '64px',
    padding: 'space.050'
});
// const smHeight = xcss({ height: '260px' });
const $d21806cfe6f7466a$var$mdBoxStyles = (0, $8CUq3.xcss)({
    height: '320px',
    padding: 'space.200'
});
// const lgHeight = xcss({ height: '400px' });
const $d21806cfe6f7466a$var$baseStyle = (0, $8CUq3.xcss)({
    borderRadius: 'border.radius.200',
    outlineWidth: 'border.width',
    outlineStyle: 'solid',
    outlineColor: 'color.border',
    width: '100%',
    backgroundColor: 'elevation.surface.overlay'
});
const $d21806cfe6f7466a$var$overviewCountDoneStyle = (0, $8CUq3.xcss)({
    gridArea: 'overviewCountDone'
});
const $d21806cfe6f7466a$var$overviewCountUpdatedStyle = (0, $8CUq3.xcss)({
    gridArea: 'overviewCountUpdated'
});
const $d21806cfe6f7466a$var$overviewCountCreatedStyle = (0, $8CUq3.xcss)({
    gridArea: 'overviewCountCreated'
});
const $d21806cfe6f7466a$var$overviewCountDueStyle = (0, $8CUq3.xcss)({
    gridArea: 'overviewCountDue'
});
const $d21806cfe6f7466a$var$statusOverviewStyle = (0, $8CUq3.xcss)({
    gridArea: 'statusOverview'
});
const $d21806cfe6f7466a$var$recentActivityStyle = (0, $8CUq3.xcss)({
    gridArea: 'recentActivity'
});
const $d21806cfe6f7466a$var$priorityBreakdownStyle = (0, $8CUq3.xcss)({
    gridArea: 'priorityBreakdown'
});
const $d21806cfe6f7466a$var$typesOfWorkStyle = (0, $8CUq3.xcss)({
    gridArea: 'typesOfWork'
});
const $d21806cfe6f7466a$var$teamWorkloadStyle = (0, $8CUq3.xcss)({
    gridArea: 'teamWorkload'
});
const $d21806cfe6f7466a$var$epicProgressStyle = (0, $8CUq3.xcss)({
    gridArea: 'epicProgress'
});
const $d21806cfe6f7466a$var$responsiveStyles = (0, $8CUq3.xcss)({
    [(0, $h9kUS.media).above.xxs]: {
        gridTemplateAreas: "'overviewCountDone'\n'overviewCountUpdated'\n'overviewCountCreated'\n'overviewCountDue'\n'statusOverview'\n'recentActivity'\n'priorityBreakdown'\n'typesOfWork'\n'teamWorkload'\n'epicProgress'",
        gridTemplateColumns: '1fr'
    },
    [(0, $h9kUS.media).above.sm]: {
        gridTemplateAreas: "'overviewCountDone overviewCountUpdated overviewCountCreated overviewCountDue'\n'statusOverview statusOverview recentActivity recentActivity'\n'priorityBreakdown priorityBreakdown typesOfWork typesOfWork'\n'teamWorkload teamWorkload epicProgress epicProgress'",
        gridTemplateColumns: 'repeat(4, 1fr)'
    },
    width: '100%'
});

});
// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $6784cbc7d62e5d7c$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $6784cbc7d62e5d7c$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $6784cbc7d62e5d7c$export$e3884212029f7bef = 'should-show-welcome-modal';
const $6784cbc7d62e5d7c$export$eaf6b96a17b6476c = 'can-enroll-in-select-initial-view';
const $6784cbc7d62e5d7c$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $6784cbc7d62e5d7c$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $6784cbc7d62e5d7c$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $6784cbc7d62e5d7c$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $6784cbc7d62e5d7c$export$6e69f8dc03075ef8 = 'team-type';
const $6784cbc7d62e5d7c$export$c06666264cd35603 = 'team-type-shorthand';
const $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $6784cbc7d62e5d7c$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $6784cbc7d62e5d7c$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $6784cbc7d62e5d7c$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $6784cbc7d62e5d7c$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $6784cbc7d62e5d7c$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $6784cbc7d62e5d7c$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $6784cbc7d62e5d7c$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $6784cbc7d62e5d7c$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $6784cbc7d62e5d7c$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $6784cbc7d62e5d7c$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $6784cbc7d62e5d7c$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $6784cbc7d62e5d7c$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $6784cbc7d62e5d7c$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $6784cbc7d62e5d7c$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $6784cbc7d62e5d7c$export$468488291ccd988 = 'timelineAddItemNudge';
const $6784cbc7d62e5d7c$export$7a33548109ac931d = 'createFormNudge';
const $6784cbc7d62e5d7c$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $6784cbc7d62e5d7c$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $6784cbc7d62e5d7c$export$594d3436316492be = 'summaryViewNudge';
const $6784cbc7d62e5d7c$export$f93b83d735f01fa3 = 'pagesCreatePageNudge';
const $6784cbc7d62e5d7c$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $6784cbc7d62e5d7c$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $6784cbc7d62e5d7c$export$699265ec8ad9a740 = 'Software Development';
const $6784cbc7d62e5d7c$export$e07d1fa2da8ed874 = 'Customer Service';
const $6784cbc7d62e5d7c$export$76dcec3f438d9e56 = 'IT Support';
const $6784cbc7d62e5d7c$export$9a574c301f67ba30 = 'Human Resources';
const $6784cbc7d62e5d7c$export$363ec144a94029c8 = 'Finance';
const $6784cbc7d62e5d7c$export$df0fb32d68ae1e78 = 'Legal';
const $6784cbc7d62e5d7c$export$d9c0e3e59442fb4 = 'Marketing';
const $6784cbc7d62e5d7c$export$27dbc7d7ce66e6e3 = 'Operations';
const $6784cbc7d62e5d7c$export$a5dce388adf922bd = 'Sales';
const $6784cbc7d62e5d7c$export$e1473b31a257caff = 'Data Science';
const $6784cbc7d62e5d7c$export$85657457db93c2c2 = 'Product Management';
const $6784cbc7d62e5d7c$export$c0c2d1dfaeba89dd = 'Project Management';
const $6784cbc7d62e5d7c$export$2e6a7ad3ab9c82a3 = 'Design';
const $6784cbc7d62e5d7c$export$7b60378c3b4372e9 = 'Other or Personal';
const $6784cbc7d62e5d7c$export$572242e58bd07594 = 'CS';
const $6784cbc7d62e5d7c$export$d7de553940261eba = 'ITS';
const $6784cbc7d62e5d7c$export$4c29d0d04c15e55d = 'HR';
const $6784cbc7d62e5d7c$export$3950f7f841bf94b6 = 'FNC';
const $6784cbc7d62e5d7c$export$881249b988b6030f = 'LGL';
const $6784cbc7d62e5d7c$export$e4824f74b9879164 = 'MKT';
const $6784cbc7d62e5d7c$export$4f3cb0844009af52 = 'OPS';
const $6784cbc7d62e5d7c$export$1a65d50c4a641bb4 = 'SAL';
const $6784cbc7d62e5d7c$export$9ee64e8fbd8b03a2 = 'DS';
const $6784cbc7d62e5d7c$export$b8b1ac856ba1434b = 'DEV';
const $6784cbc7d62e5d7c$export$4f54a09a24fd1d74 = 'PDM';
const $6784cbc7d62e5d7c$export$79685802e8ff1098 = 'PJM';
const $6784cbc7d62e5d7c$export$e5c438b7501b5a24 = 'DES';
const $6784cbc7d62e5d7c$export$cbc0e551d91a692d = 'OTR';

parcelRegister("ghgEK", function(module, exports) {

$parcel$export(module.exports, "SummaryViewNudgeAsync", () => $789999f277d5d9b4$export$b531a7d8bb8249e7);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");


var $cE2Qr = parcelRequire("cE2Qr");


var $aCWJu = parcelRequire("aCWJu");
const $789999f277d5d9b4$var$runtimeProps = {};
const $789999f277d5d9b4$var$entryPointParams = {};
const $789999f277d5d9b4$export$b531a7d8bb8249e7 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $aCWJu.summaryViewNudgeEntryPoint), $789999f277d5d9b4$var$entryPointParams);
    const [nudgeStep] = (0, $cE2Qr.useNudgeStep)();
    const [hasNudgeActive] = (0, $cE2Qr.useHasNudgeActive)();
    const firstLoadRef = (0, $5uXOq.useRef)(true);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (firstLoadRef.current && hasNudgeActive && nudgeStep === (0, $6784cbc7d62e5d7c$export$594d3436316492be)) {
            entryPointActions.load();
            firstLoadRef.current = false;
        }
    }, [
        entryPointActions,
        hasNudgeActive,
        nudgeStep
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: (0, $dbbf68c32d8c4308$export$cf1943561be3a3c2),
        packageName: "jiraSummaryViewOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        runtimeProps: $789999f277d5d9b4$var$runtimeProps
    });
};

});
const $dbbf68c32d8c4308$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $dbbf68c32d8c4308$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $dbbf68c32d8c4308$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $dbbf68c32d8c4308$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $dbbf68c32d8c4308$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $dbbf68c32d8c4308$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $dbbf68c32d8c4308$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $dbbf68c32d8c4308$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $dbbf68c32d8c4308$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $dbbf68c32d8c4308$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $dbbf68c32d8c4308$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $dbbf68c32d8c4308$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $dbbf68c32d8c4308$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $dbbf68c32d8c4308$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $dbbf68c32d8c4308$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $dbbf68c32d8c4308$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $dbbf68c32d8c4308$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $dbbf68c32d8c4308$export$f8bf435a6066832c = 'button clicked';
const $dbbf68c32d8c4308$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $dbbf68c32d8c4308$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $dbbf68c32d8c4308$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $dbbf68c32d8c4308$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $dbbf68c32d8c4308$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $dbbf68c32d8c4308$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $dbbf68c32d8c4308$export$5908fa8acd2c0739 = 'filterListNudge';
const $dbbf68c32d8c4308$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $dbbf68c32d8c4308$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $dbbf68c32d8c4308$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $dbbf68c32d8c4308$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $dbbf68c32d8c4308$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $dbbf68c32d8c4308$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $dbbf68c32d8c4308$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $dbbf68c32d8c4308$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $dbbf68c32d8c4308$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $dbbf68c32d8c4308$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $dbbf68c32d8c4308$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $dbbf68c32d8c4308$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $dbbf68c32d8c4308$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $dbbf68c32d8c4308$export$a1be34032ee24f78 = 'shareProjectNudge';
const $dbbf68c32d8c4308$export$29fe6611cc093756 = 'summaryTabNudge';
const $dbbf68c32d8c4308$export$f107c06c0830f09d = 'reportsTabNudge';
const $dbbf68c32d8c4308$export$9749a972a54ad7ba = 'boardContainerNudge';

parcelRegister("aCWJu", function(module, exports) {

$parcel$export(module.exports, "summaryViewNudgeEntryPoint", () => $81e625d31894d565$export$81d6d191a3f971f5);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $81e625d31894d565$export$81d6d191a3f971f5 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("hGQHO")), {
        moduleId: "46bfac13"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hGQHO", function(module, exports) {

let $ce0f3e27ffd83fdf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ce0f3e27ffd83fdf$var$load("dEu4P").then(()=>parcelRequire('a63rx'));

});



parcelRegister("1sc6Q", function(module, exports) {

$parcel$export(module.exports, "useOverviewCountWithRouteResourceData", () => $e54af32276a850b0$export$c5dfd07da0a4ad01);
$parcel$export(module.exports, "usePriorityBreakdownWithRouteResourceData", () => $e54af32276a850b0$export$ec49213856bee27a);
$parcel$export(module.exports, "useStatusOverviewWithRouteResourceData", () => $e54af32276a850b0$export$1a37d4003af44567);
$parcel$export(module.exports, "useTypesOfWorkWithRouteResourceAndPaginatedData", () => $e54af32276a850b0$export$6de431a4fd706c80);
$parcel$export(module.exports, "useTeamWorkloadWithRouteResourceAndPaginatedData", () => $e54af32276a850b0$export$c4845e03a1d5c86e);
$parcel$export(module.exports, "useRecentActivityWithRouteResourceAndPaginatedData", () => $e54af32276a850b0$export$e2db0f9fa0609ce2);
$parcel$export(module.exports, "useOverviewCountWithData", () => $e54af32276a850b0$export$2f9cef3cb6e25745);
$parcel$export(module.exports, "useStatusOverviewWithData", () => $e54af32276a850b0$export$f73e961f16505c4f);
$parcel$export(module.exports, "usePriorityBreakdownWithData", () => $e54af32276a850b0$export$6f88d914072c0599);
$parcel$export(module.exports, "useRecentActivityWithPaginatedData", () => $e54af32276a850b0$export$c1ff471cdfcad0dd);
$parcel$export(module.exports, "useFastRecentActivityWithData", () => $e54af32276a850b0$export$37a9dd3015c8f958);
$parcel$export(module.exports, "useTypesOfWorkWithPaginatedData", () => $e54af32276a850b0$export$6ad16d797dd9cdf0);
$parcel$export(module.exports, "useTeamWorkloadWithPaginatedData", () => $e54af32276a850b0$export$d6b1b4c9e76ccd22);
$parcel$export(module.exports, "useEpicProgressOrRelatedProjectsWithData", () => $e54af32276a850b0$export$bd967538c7b160c9);
$parcel$export(module.exports, "useCsatOverTimeWithData", () => $e54af32276a850b0$export$2e85d62d6cec2968);
/** @jsx jsx */ 
var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $3zj3N = parcelRequire("3zj3N");

var $kqhaB = parcelRequire("kqhaB");

var $beAwS = parcelRequire("beAwS");

var $j2wpF = parcelRequire("j2wpF");

var $1LZJa = parcelRequire("1LZJa");

var $8p83l = parcelRequire("8p83l");

var $glVl7 = parcelRequire("glVl7");

var $9DtZr = parcelRequire("9DtZr");

var $gAWlc = parcelRequire("gAWlc");

var $7AZ3V = parcelRequire("7AZ3V");

var $eCxQU = parcelRequire("eCxQU");

var $5Up4t = parcelRequire("5Up4t");

var $ey00g = parcelRequire("ey00g");

var $mVdzu = parcelRequire("mVdzu");

var $1qZBw = parcelRequire("1qZBw");

var $3fZW3 = parcelRequire("3fZW3");

var $hgVrX = parcelRequire("hgVrX");

var $cRMny = parcelRequire("cRMny");

var $7brUi = parcelRequire("7brUi");
const $e54af32276a850b0$export$c5dfd07da0a4ad01 = (type)=>{
    const boundaryId = (0, $beAwS.overviewCountBoundaryIds)[type];
    return (0, $5uXOq.useMemo)(()=>(0, $8p83l.withBoundary)({
            Component: (0, $glVl7.withRouteResourceData)({
                Component: (0, $eCxQU.OverviewCount),
                routeResource: (0, $3zj3N.summaryDataResource),
                dataSelector: (0, $1LZJa.projectSummaryDataSelector)(type),
                FallbackComponent: (0, $j2wpF.SmallRetryWarning)
            }),
            boundaryId: boundaryId,
            Fallback: (0, $j2wpF.SmallContactSupportWarning),
            Skeleton: (0, $gAWlc.skeletons).OverviewCount
        }), [
        boundaryId,
        type
    ]);
};
const $e54af32276a850b0$export$ec49213856bee27a = ()=>(0, $5uXOq.useMemo)(()=>(0, $8p83l.withBoundary)({
            Component: (0, $glVl7.withRouteResourceData)({
                Component: (0, $5Up4t.PriorityBreakdown),
                routeResource: (0, $3zj3N.summaryDataResource),
                dataSelector: (0, $1LZJa.priorityBreakdownDataSelector),
                FallbackComponent: (0, $j2wpF.MediumRetryWarning)
            }),
            boundaryId: (0, $beAwS.BoundaryIds).PriorityBreakdown,
            Fallback: (0, $j2wpF.MediumContactSupportWarning),
            Skeleton: (0, $gAWlc.skeletons).PriorityBreakdown
        }), []);
const $e54af32276a850b0$export$1a37d4003af44567 = ()=>(0, $5uXOq.useMemo)(()=>(0, $8p83l.withBoundary)({
            Component: (0, $glVl7.withRouteResourceData)({
                Component: (0, $mVdzu.StatusOverview),
                routeResource: (0, $3zj3N.summaryDataResource),
                dataSelector: (0, $1LZJa.statusOverviewDataSelector),
                FallbackComponent: (0, $j2wpF.SmallRetryWarning)
            }),
            boundaryId: (0, $beAwS.BoundaryIds).StatusOverview,
            Fallback: (0, $j2wpF.SmallContactSupportWarning),
            Skeleton: (0, $gAWlc.skeletons).StatusOverview
        }), []);
const $e54af32276a850b0$export$6de431a4fd706c80 = (cloudId, projectKey, gqlQuery)=>{
    const fetchTypesOfWorkDataWithProjectKey = (0, $5uXOq.useCallback)((after)=>(0, $1LZJa.fetchTypesOfWorkData)(after, cloudId, projectKey, gqlQuery), [
        cloudId,
        projectKey,
        gqlQuery
    ]);
    return (0, $5uXOq.useMemo)(()=>(0, $8p83l.withBoundary)({
            Component: (0, $9DtZr.withRouteResourceAndPaginatedData)({
                Component: (0, $3fZW3.TypesOfWork),
                routeResource: (0, $3zj3N.summaryDataResource),
                dataSelector: (0, $1LZJa.typesOfWorkDataSelector),
                fetchDataFn: fetchTypesOfWorkDataWithProjectKey,
                FallbackComponent: (0, $j2wpF.MediumRetryWarning)
            }),
            boundaryId: (0, $beAwS.BoundaryIds).TypesOfWork,
            Fallback: (0, $j2wpF.MediumContactSupportWarning),
            Skeleton: (0, $gAWlc.skeletons).TypeOfWork
        }), [
        fetchTypesOfWorkDataWithProjectKey
    ]);
};
const $e54af32276a850b0$export$c4845e03a1d5c86e = (cloudId, projectKey, gqlQuery)=>{
    const fetchTeamWorkloadDataWithProjectKey = (0, $5uXOq.useCallback)((after)=>(0, $1LZJa.fetchTeamWorkloadData)(after, cloudId, projectKey, gqlQuery), [
        cloudId,
        projectKey,
        gqlQuery
    ]);
    return (0, $5uXOq.useMemo)(()=>(0, $8p83l.withBoundary)({
            Component: (0, $9DtZr.withRouteResourceAndPaginatedData)({
                Component: (0, $1qZBw.TeamWorkload),
                routeResource: (0, $3zj3N.summaryDataResource),
                dataSelector: (0, $1LZJa.teamWorkloadDataSelector),
                fetchDataFn: fetchTeamWorkloadDataWithProjectKey,
                FallbackComponent: (0, $j2wpF.MediumRetryWarning)
            }),
            boundaryId: (0, $beAwS.BoundaryIds).TeamWorkload,
            Fallback: (0, $j2wpF.MediumContactSupportWarning),
            Skeleton: (0, $gAWlc.skeletons).TeamWorkload
        }), [
        fetchTeamWorkloadDataWithProjectKey
    ]);
};
const $e54af32276a850b0$export$e2db0f9fa0609ce2 = (projectKey)=>{
    const fetchActivityFeedDataWithProjectKey = (0, $5uXOq.useCallback)((after)=>(0, $1LZJa.fetchActivityFeedData)(after, projectKey), [
        projectKey
    ]);
    return (0, $5uXOq.useMemo)(()=>(0, $8p83l.withBoundary)({
            Component: (0, $9DtZr.withRouteResourceAndPaginatedData)({
                Component: (0, $ey00g.RecentActivity),
                routeResource: (0, $kqhaB.activityFeedResource),
                dataSelector: (data)=>data,
                fetchDataFn: fetchActivityFeedDataWithProjectKey,
                FallbackComponent: (0, $j2wpF.MediumRetryWarning),
                options: {
                    fetchMode: 'replace'
                }
            }),
            boundaryId: (0, $beAwS.BoundaryIds).RecentActivity,
            Fallback: (0, $j2wpF.MediumContactSupportWarning),
            Skeleton: (0, $gAWlc.skeletons).RecentActivity
        }), [
        fetchActivityFeedDataWithProjectKey
    ]);
};
const $e54af32276a850b0$export$2f9cef3cb6e25745 = (cloudId, projectKey, type, gqlQuery)=>{
    const boundaryId = (0, $beAwS.overviewCountBoundaryIds)[type];
    return (0, $5uXOq.useMemo)(()=>(0, $8p83l.withBoundary)({
            Component: (0, $glVl7.withSummaryData)({
                Component: (0, $eCxQU.OverviewCount),
                fetchDataFn: ()=>(0, $1LZJa.fetchProjectSummaryData)(cloudId, projectKey, type, gqlQuery),
                FallbackComponent: (0, $j2wpF.SmallRetryWarning)
            }),
            boundaryId: boundaryId,
            Fallback: (0, $j2wpF.SmallContactSupportWarning),
            Skeleton: (0, $gAWlc.skeletons).OverviewCount
        }), [
        boundaryId,
        cloudId,
        projectKey,
        type,
        gqlQuery
    ]);
};
const $e54af32276a850b0$export$f73e961f16505c4f = (cloudId, projectKey, gqlQuery)=>{
    return (0, $5uXOq.useMemo)(()=>(0, $8p83l.withBoundary)({
            Component: (0, $glVl7.withSummaryData)({
                Component: (0, $mVdzu.StatusOverview),
                fetchDataFn: ()=>(0, $1LZJa.fetchStatusOverviewData)(cloudId, projectKey, gqlQuery),
                FallbackComponent: (0, $j2wpF.SmallRetryWarning)
            }),
            boundaryId: (0, $beAwS.BoundaryIds).StatusOverview,
            Fallback: (0, $j2wpF.SmallContactSupportWarning),
            Skeleton: (0, $gAWlc.skeletons).StatusOverview
        }), [
        cloudId,
        projectKey,
        gqlQuery
    ]);
};
const $e54af32276a850b0$export$6f88d914072c0599 = (cloudId, projectKey, gqlQuery)=>{
    return (0, $5uXOq.useMemo)(()=>(0, $8p83l.withBoundary)({
            Component: (0, $glVl7.withSummaryData)({
                Component: (0, $5Up4t.PriorityBreakdown),
                fetchDataFn: ()=>(0, $1LZJa.fetchPriorityBreakdownData)(cloudId, projectKey, gqlQuery),
                FallbackComponent: (0, $j2wpF.MediumRetryWarning)
            }),
            boundaryId: (0, $beAwS.BoundaryIds).PriorityBreakdown,
            Fallback: (0, $j2wpF.MediumContactSupportWarning),
            Skeleton: (0, $gAWlc.skeletons).PriorityBreakdown
        }), [
        cloudId,
        projectKey,
        gqlQuery
    ]);
};
const $e54af32276a850b0$export$c1ff471cdfcad0dd = (projectKey)=>{
    const fetchActivityFeedDataWithProjectKey = (0, $5uXOq.useCallback)((after)=>(0, $1LZJa.fetchActivityFeedData)(after, projectKey), [
        projectKey
    ]);
    return (0, $5uXOq.useMemo)(()=>(0, $8p83l.withBoundary)({
            Component: (0, $9DtZr.withPaginatedSummaryData)({
                Component: (0, $ey00g.RecentActivity),
                fetchDataFn: fetchActivityFeedDataWithProjectKey,
                FallbackComponent: (0, $j2wpF.MediumRetryWarning),
                options: {
                    fetchMode: 'replace'
                }
            }),
            boundaryId: (0, $beAwS.BoundaryIds).RecentActivity,
            Fallback: (0, $j2wpF.MediumContactSupportWarning),
            Skeleton: (0, $gAWlc.skeletons).RecentActivity
        }), [
        fetchActivityFeedDataWithProjectKey
    ]);
};
const $e54af32276a850b0$export$37a9dd3015c8f958 = (projectId)=>{
    return (0, $5uXOq.useMemo)(()=>(0, $8p83l.withBoundary)({
            Component: (0, $glVl7.withSummaryData)({
                Component: (0, $hgVrX.ActivityFeed),
                fetchDataFn: ()=>(0, $1LZJa.fetchFastActivityFeedData)(projectId),
                FallbackComponent: (0, $j2wpF.MediumRetryWarning)
            }),
            boundaryId: (0, $beAwS.BoundaryIds).RecentActivity,
            Fallback: (0, $j2wpF.MediumContactSupportWarning),
            Skeleton: (0, $gAWlc.skeletons).RecentActivity
        }), [
        projectId
    ]);
};
const $e54af32276a850b0$export$6ad16d797dd9cdf0 = (cloudId, projectKey, gqlQuery)=>{
    const fetchTypesOfWorkDataWithProjectKey = (0, $5uXOq.useCallback)((after)=>(0, $1LZJa.fetchTypesOfWorkData)(after, cloudId, projectKey, gqlQuery), [
        cloudId,
        projectKey,
        gqlQuery
    ]);
    return (0, $5uXOq.useMemo)(()=>(0, $8p83l.withBoundary)({
            Component: (0, $9DtZr.withPaginatedSummaryData)({
                Component: (0, $3fZW3.TypesOfWork),
                fetchDataFn: fetchTypesOfWorkDataWithProjectKey,
                FallbackComponent: (0, $j2wpF.MediumRetryWarning)
            }),
            boundaryId: (0, $beAwS.BoundaryIds).TypesOfWork,
            Fallback: (0, $j2wpF.MediumContactSupportWarning),
            Skeleton: (0, $gAWlc.skeletons).TypeOfWork
        }), [
        fetchTypesOfWorkDataWithProjectKey
    ]);
};
const $e54af32276a850b0$export$d6b1b4c9e76ccd22 = (cloudId, projectKey, gqlQuery)=>{
    const fetchTeamWorkloadDataWithProjectKey = (0, $5uXOq.useCallback)((after)=>(0, $1LZJa.fetchTeamWorkloadData)(after, cloudId, projectKey, gqlQuery), [
        cloudId,
        projectKey,
        gqlQuery
    ]);
    return (0, $5uXOq.useMemo)(()=>(0, $8p83l.withBoundary)({
            Component: (0, $9DtZr.withPaginatedSummaryData)({
                Component: (0, $1qZBw.TeamWorkload),
                fetchDataFn: fetchTeamWorkloadDataWithProjectKey,
                FallbackComponent: (0, $j2wpF.MediumRetryWarning)
            }),
            boundaryId: (0, $beAwS.BoundaryIds).TeamWorkload,
            Fallback: (0, $j2wpF.MediumContactSupportWarning),
            Skeleton: (0, $gAWlc.skeletons).TeamWorkload
        }), [
        fetchTeamWorkloadDataWithProjectKey
    ]);
};
const $e54af32276a850b0$export$bd967538c7b160c9 = (relayEnvironment, cloudId, projectKey, projectId, projectType, atlassianAccountId, boundaryId)=>{
    const isBusinessProject = projectType === (0, $2vSU6.JIRA_PROJECT_TYPE_CORE_PROJECT);
    return (0, $5uXOq.useMemo)(()=>isBusinessProject && (0, $4R6GH.fg)('jwm-summary-page-toggle-related-projects') ? (0, $8p83l.withBoundary)({
            Component: (0, $glVl7.withSummaryData)({
                Component: (0, $cRMny.RelatedProjects),
                fetchDataFn: ()=>(0, $1LZJa.fetchRelatedProjectsData)(cloudId, atlassianAccountId, projectId),
                FallbackComponent: (0, $j2wpF.MediumRetryWarning)
            }),
            boundaryId: boundaryId,
            Fallback: (0, $j2wpF.MediumContactSupportWarning),
            Skeleton: (0, $gAWlc.skeletons).RelatedProjects
        }) : (0, $8p83l.withBoundary)({
            Component: (0, $glVl7.withSummaryData)({
                Component: (0, $7AZ3V.EpicProgress),
                fetchDataFn: ()=>(0, $1LZJa.fetchEpicProgressData)(relayEnvironment, cloudId, projectKey, projectId),
                FallbackComponent: (0, $j2wpF.MediumRetryWarning)
            }),
            boundaryId: boundaryId,
            Fallback: (0, $j2wpF.MediumContactSupportWarning),
            Skeleton: (0, $gAWlc.skeletons).EpicProgress
        }), [
        isBusinessProject,
        boundaryId,
        cloudId,
        atlassianAccountId,
        projectId,
        relayEnvironment,
        projectKey
    ]);
};
const $e54af32276a850b0$export$2e85d62d6cec2968 = ()=>{
    return (0, $5uXOq.useMemo)(()=>(0, $8p83l.withBoundary)({
            Component: (0, $glVl7.withSummaryData)({
                Component: (0, $7brUi.CsatOverTime),
                fetchDataFn: ()=>(0, $1LZJa.fetchCsatOverTimeData)(),
                FallbackComponent: (0, $j2wpF.MediumRetryWarning)
            }),
            boundaryId: (0, $beAwS.BoundaryIds).CsatOverTime,
            Fallback: (0, $j2wpF.SmallContactSupportWarning),
            Skeleton: (0, $gAWlc.skeletons).CsatOverTime
        }), []);
};

});
parcelRegister("beAwS", function(module, exports) {

$parcel$export(module.exports, "SectionIds", () => $18ee3ea09d5a3b3b$export$4a048f22652e920c);
$parcel$export(module.exports, "BoundaryIds", () => $18ee3ea09d5a3b3b$export$ecf8cc328769d516);
$parcel$export(module.exports, "overviewCountBoundaryIds", () => $18ee3ea09d5a3b3b$export$890a3562c2fac36f);
$parcel$export(module.exports, "MetricTypes", () => $18ee3ea09d5a3b3b$export$6e4d70bec4bc2d0c);
$parcel$export(module.exports, "ColorSchemes", () => $18ee3ea09d5a3b3b$export$6e23c8fe4b8cf652);
$parcel$export(module.exports, "ActivityTypes", () => $18ee3ea09d5a3b3b$export$9c868bb967507f90);
const $18ee3ea09d5a3b3b$export$4a048f22652e920c = {
    RecentActivity: 'activityFeed',
    PriorityBreakdown: 'breakdownByPriority',
    StatusOverview: 'progressByStatus',
    TeamWorkload: 'workloadByAssignee',
    TypesOfWork: 'typesOfWork',
    OverviewCard: 'overviewCard',
    EpicProgress: 'epicProgress',
    RelatedProjects: 'relatedProjects'
};
const $18ee3ea09d5a3b3b$export$ecf8cc328769d516 = {
    OverviewDone: 'jira-summary-overview-done-count',
    OverviewUpdated: 'jira-summary-overview-updated-count',
    OverviewCreated: 'jira-summary-overview-created-count',
    OverviewDue: 'jira-summary-overview-due-count',
    StatusOverview: 'jira-summary-status-overview',
    CsatOverTime: 'jira-summary-csat-over-time',
    PriorityBreakdown: 'jira-summary-priority-breakdown',
    RecentActivity: 'jira-summary-recent-activity',
    TypesOfWork: 'jira-summary-types-of-work',
    TeamWorkload: 'jira-summary-team-workload',
    EpicProgress: 'jira-summary-epic-progress',
    RelatedProjects: 'jira-summary-related-projects'
};
const $18ee3ea09d5a3b3b$export$890a3562c2fac36f = {
    done: $18ee3ea09d5a3b3b$export$ecf8cc328769d516.OverviewDone,
    updated: $18ee3ea09d5a3b3b$export$ecf8cc328769d516.OverviewUpdated,
    created: $18ee3ea09d5a3b3b$export$ecf8cc328769d516.OverviewCreated,
    due: $18ee3ea09d5a3b3b$export$ecf8cc328769d516.OverviewDue
};
const $18ee3ea09d5a3b3b$export$6e4d70bec4bc2d0c = {
    DISTRIBUTION: 'DISTRIBUTION',
    COUNT: 'COUNT'
};
const $18ee3ea09d5a3b3b$export$6e23c8fe4b8cf652 = {
    DEFAULT: 'DEFAULT',
    BLUE: 'BLUE'
};
const $18ee3ea09d5a3b3b$export$9c868bb967507f90 = {
    STATUS_CHANGED: 'STATUS_CHANGED',
    COMMENT_ADDED: 'COMMENT_ADDED',
    ATTACHMENT_ADDED: 'ATTACHMENT_ADDED',
    PRIORITY_CHANGED: 'PRIORITY_CHANGED',
    ASSIGNEE_CHANGED: 'ASSIGNEE_CHANGED',
    SINGLE_FIELD_UPDATED: 'SINGLE_FIELD_UPDATED',
    CREATED: 'CREATED'
};

});

parcelRegister("j2wpF", function(module, exports) {

$parcel$export(module.exports, "SmallContactSupportWarning", () => $4c5422770190ef73$export$9c18625bed52ff99);
$parcel$export(module.exports, "MediumContactSupportWarning", () => $4c5422770190ef73$export$bb124bb68a658edc);
$parcel$export(module.exports, "SmallRetryWarning", () => $4c5422770190ef73$export$857251b1b127c385);
$parcel$export(module.exports, "MediumRetryWarning", () => $4c5422770190ef73$export$e47acc6b97979f6a);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kTK0a = parcelRequire("kTK0a");

var $eCeGD = parcelRequire("eCeGD");

var $l1N8i = parcelRequire("l1N8i");

var $5qRwM = parcelRequire("5qRwM");

var $e4yMr = parcelRequire("e4yMr");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $7syTW = parcelRequire("7syTW");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $34ZMJ = parcelRequire("34ZMJ");
const $4c5422770190ef73$export$9c18625bed52ff99 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $4c5422770190ef73$var$gadgetStackSmStyles
    }, /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $4c5422770190ef73$var$imageContainerSmStyles
    }, /*#__PURE__*/ $5uXOq.createElement((0, $5qRwM.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7syTW))),
        alt: formatMessage({
            id: 'iconLabel'
        }),
        className: (0, $bwpsq.default)([
            "_5ral1f51 _1bsb1osq _4t3i1osq"
        ])
    })), /*#__PURE__*/ $5uXOq.createElement((0, $cgL5K.default), {
        align: "start"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $ousew.default), {
        ...(0, $34ZMJ.default).errorMessageWithSupportLinkShort,
        values: {
            heading: (chunks)=>/*#__PURE__*/ $5uXOq.createElement((0, $cgL5K.default), {
                    maxLines: 1
                }, /*#__PURE__*/ $5uXOq.createElement((0, $l1N8i.default), {
                    size: "small"
                }, chunks)),
            text: (chunks)=>/*#__PURE__*/ $5uXOq.createElement((0, $cgL5K.default), {
                    size: "small",
                    maxLines: 1
                }, chunks),
            link: (chunks)=>/*#__PURE__*/ $5uXOq.createElement((0, $e4yMr.default), {
                    href: `${(0, $kTK0a.getATLContextUrl)('support')}/contact/#/`,
                    target: "_blank"
                }, chunks)
        }
    })));
};
const $4c5422770190ef73$export$bb124bb68a658edc = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $4c5422770190ef73$var$gadgetStackMdStyles
    }, /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $4c5422770190ef73$var$imageContainerMd
    }, /*#__PURE__*/ $5uXOq.createElement((0, $5qRwM.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7syTW))),
        alt: formatMessage({
            id: 'iconLabel'
        }),
        className: (0, $bwpsq.default)([
            "_5ral1f51 _1bsb1osq _4t3i1osq"
        ])
    })), /*#__PURE__*/ $5uXOq.createElement((0, $cgL5K.default), {
        align: "center"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $ousew.default), {
        ...(0, $34ZMJ.default).errorMessageWithSupportLinkLong,
        values: {
            heading: (chunks)=>/*#__PURE__*/ $5uXOq.createElement((0, $cgL5K.default), {
                    maxLines: 1
                }, /*#__PURE__*/ $5uXOq.createElement((0, $l1N8i.default), {
                    size: "small",
                    as: "h2"
                }, chunks)),
            text: (chunks)=>/*#__PURE__*/ $5uXOq.createElement((0, $cgL5K.default), {
                    size: "medium",
                    maxLines: 1
                }, chunks),
            link: (chunks)=>/*#__PURE__*/ $5uXOq.createElement((0, $e4yMr.default), {
                    href: `${(0, $kTK0a.getATLContextUrl)('support')}/contact/#/`,
                    target: "_blank"
                }, chunks)
        }
    })));
};
const $4c5422770190ef73$export$857251b1b127c385 = ({ handleRetry: handleRetry })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $4c5422770190ef73$var$gadgetStackSmStyles
    }, /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $4c5422770190ef73$var$imageContainerSmStyles
    }, /*#__PURE__*/ $5uXOq.createElement((0, $5qRwM.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7syTW))),
        alt: formatMessage({
            id: 'iconLabel'
        }),
        className: (0, $bwpsq.default)([
            "_5ral1f51 _1bsb1osq _4t3i1osq"
        ])
    })), /*#__PURE__*/ $5uXOq.createElement((0, $cgL5K.default), {
        align: "start"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $ousew.default), {
        ...(0, $34ZMJ.default).errorMessageWithRefreshButtonShort,
        values: {
            heading: (chunks)=>/*#__PURE__*/ $5uXOq.createElement((0, $l1N8i.default), {
                    size: "small"
                }, chunks),
            text: (chunks)=>/*#__PURE__*/ $5uXOq.createElement((0, $cgL5K.default), {
                    size: "small",
                    maxLines: 1
                }, chunks),
            button: (chunks)=>/*#__PURE__*/ $5uXOq.createElement((0, $eCeGD.default), {
                    appearance: "subtle",
                    onClick: handleRetry
                }, chunks)
        }
    })));
};
const $4c5422770190ef73$export$e47acc6b97979f6a = ({ handleRetry: handleRetry })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $4c5422770190ef73$var$gadgetStackMdStyles
    }, /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $4c5422770190ef73$var$imageContainerMd
    }, /*#__PURE__*/ $5uXOq.createElement((0, $5qRwM.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7syTW))),
        alt: formatMessage({
            id: 'iconLabel'
        }),
        className: (0, $bwpsq.default)([
            "_5ral1f51 _1bsb1osq _4t3i1osq"
        ])
    })), /*#__PURE__*/ $5uXOq.createElement((0, $cgL5K.default), {
        align: "center"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $ousew.default), {
        ...(0, $34ZMJ.default).errorMessageWithRefreshButtonLong,
        values: {
            heading: (chunks)=>/*#__PURE__*/ $5uXOq.createElement((0, $l1N8i.default), {
                    size: "small",
                    as: "h2"
                }, chunks),
            text: (chunks)=>/*#__PURE__*/ $5uXOq.createElement((0, $cgL5K.default), {
                    size: "medium",
                    maxLines: 1
                }, chunks),
            button: (chunks)=>/*#__PURE__*/ $5uXOq.createElement((0, $eCeGD.default), {
                    appearance: "subtle",
                    onClick: handleRetry
                }, chunks)
        }
    })));
};
const $4c5422770190ef73$var$gadgetStackSmStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    height: '100%'
});
const $4c5422770190ef73$var$imageContainerSmStyles = (0, $8CUq3.xcss)({
    width: '35px',
    height: '35px'
});
const $4c5422770190ef73$var$imageSmStyles = null;
const $4c5422770190ef73$var$gadgetStackMdStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    height: '100%'
});
const $4c5422770190ef73$var$imageContainerMd = (0, $8CUq3.xcss)({
    width: '90px',
    height: '90px'
});
const $4c5422770190ef73$var$imageMd = null;

});
parcelRegister("7syTW", function(module, exports) {
module.exports = new URL("exclamation-triangle.e2723ea8.svg", import.meta.url).toString();

});

parcelRegister("34ZMJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $652441836f55c7fc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $652441836f55c7fc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    iconLabel: {
        "id": "contextual-summary.common.ui.error-state.icon-label",
        "defaultMessage": "Warning icon"
    },
    errorMessageWithSupportLinkShort: {
        "id": "contextual-summary.common.ui.error-message-with-support-link-short",
        "defaultMessage": "<heading>Something went wrong</heading> <text>Try refreshing, or</text> <link>contact support</link>"
    },
    errorMessageWithSupportLinkLong: {
        "id": "contextual-summary.common.ui.error-message-with-support-link-long",
        "defaultMessage": "<heading>Something went wrong</heading> <text>Try again by refreshing and if that doesn't fix it,</text> <link>contact support</link>"
    },
    errorMessageWithRefreshButtonShort: {
        "id": "contextual-summary.common.ui.error-message-with-refresh-button-short",
        "defaultMessage": "<heading>Something went wrong</heading> <text>Try refreshing</text> <button>Refresh</button>"
    },
    errorMessageWithRefreshButtonLong: {
        "id": "contextual-summary.common.ui.error-message-with-refresh-button-long",
        "defaultMessage": "<heading>Something went wrong</heading> <text>Try again by refreshing this section.</text> <button>Refresh</button>"
    }
});

});


parcelRegister("1LZJa", function(module, exports) {

$parcel$export(module.exports, "projectSummaryDataSelector", () => $1a750aa44e157db3$export$a3b724c418fe9fdf);
$parcel$export(module.exports, "fetchProjectSummaryData", () => $1a750aa44e157db3$export$47caa3ee4ccb6602);
$parcel$export(module.exports, "statusOverviewDataSelector", () => $1a750aa44e157db3$export$32388a3132565a2a);
$parcel$export(module.exports, "fetchStatusOverviewData", () => $1a750aa44e157db3$export$1d71dd70818fe9d8);
$parcel$export(module.exports, "priorityBreakdownDataSelector", () => $1a750aa44e157db3$export$790960859d921277);
$parcel$export(module.exports, "fetchPriorityBreakdownData", () => $1a750aa44e157db3$export$b7d56ab8bc03f48a);
$parcel$export(module.exports, "fetchActivityFeedData", () => $1a750aa44e157db3$export$b61b88ec860476);
$parcel$export(module.exports, "fetchFastActivityFeedData", () => $1a750aa44e157db3$export$1859566a7f2a9210);
$parcel$export(module.exports, "typesOfWorkDataSelector", () => $1a750aa44e157db3$export$ff7317cbfbcdf84d);
$parcel$export(module.exports, "fetchTypesOfWorkData", () => $1a750aa44e157db3$export$91123b5c5792ed19);
$parcel$export(module.exports, "teamWorkloadDataSelector", () => $1a750aa44e157db3$export$80d00dab4f8ab748);
$parcel$export(module.exports, "fetchTeamWorkloadData", () => $1a750aa44e157db3$export$d7836f206e95beb9);
$parcel$export(module.exports, "fetchEpicProgressData", () => $1a750aa44e157db3$export$721c8ea05838a673);
$parcel$export(module.exports, "fetchRelatedProjectsData", () => $1a750aa44e157db3$export$84bae86afee5372f);
$parcel$export(module.exports, "fetchCsatOverTimeData", () => $1a750aa44e157db3$export$c0cae41bf4b05d4e);

var $iIMM9 = parcelRequire("iIMM9");

var $8Uumt = parcelRequire("8Uumt");

var $jlq4V = parcelRequire("jlq4V");

var $4NbWL = parcelRequire("4NbWL");


var $egekd = parcelRequire("egekd");

var $cpNcC = parcelRequire("cpNcC");

var $jXe9w = parcelRequire("jXe9w");

var $eusud = parcelRequire("eusud");

var $7f4tk = parcelRequire("7f4tk");

var $j62tG = parcelRequire("j62tG");

var $hGNo3 = parcelRequire("hGNo3");

var $bB6cs = parcelRequire("bB6cs");
const $1a750aa44e157db3$var$cachedFetchSummaryPageData = (0, $hGNo3.cacheParallelAsyncFn)((0, $j62tG.fetchSummaryPageData));
const $1a750aa44e157db3$export$a3b724c418fe9fdf = (type)=>(summaryPageData)=>{
        const { overviewItems: overviewItems } = summaryPageData;
        const countKeyMapping = {
            done: 'doneThisWeek',
            updated: 'updatedThisWeek',
            created: 'createdThisWeek',
            due: 'dueThisWeek'
        };
        const countKey = countKeyMapping[type];
        return {
            type: type,
            count: overviewItems?.[countKey] || 0
        };
    };
const $1a750aa44e157db3$export$47caa3ee4ccb6602 = async (cloudId, projectKey, type, gqlQuery)=>{
    const jqlContext = `project = "${projectKey}"`;
    const summaryPageData = await $1a750aa44e157db3$var$cachedFetchSummaryPageData({
        cloudId: cloudId,
        jqlContext: jqlContext,
        gqlQuery: gqlQuery
    });
    return $1a750aa44e157db3$export$a3b724c418fe9fdf(type)(summaryPageData);
};
const $1a750aa44e157db3$export$32388a3132565a2a = (summaryPageData)=>{
    const { issuesByStatus: issuesByStatus } = summaryPageData;
    return {
        issuesByStatus: issuesByStatus || []
    };
};
const $1a750aa44e157db3$export$1d71dd70818fe9d8 = async (cloudId, projectKey, gqlQuery)=>{
    const jqlContext = `project = "${projectKey}"`;
    const summaryPageData = await $1a750aa44e157db3$var$cachedFetchSummaryPageData({
        cloudId: cloudId,
        jqlContext: jqlContext,
        gqlQuery: gqlQuery
    });
    return $1a750aa44e157db3$export$32388a3132565a2a(summaryPageData);
};
const $1a750aa44e157db3$export$790960859d921277 = (summaryPageData)=>{
    const { issuesByPriority: issuesByPriority } = summaryPageData;
    return {
        issuesByPriority: issuesByPriority || []
    };
};
const $1a750aa44e157db3$export$b7d56ab8bc03f48a = async (cloudId, projectKey, gqlQuery)=>{
    const jqlContext = `project = "${projectKey}"`;
    const summaryPageData = await $1a750aa44e157db3$var$cachedFetchSummaryPageData({
        cloudId: cloudId,
        jqlContext: jqlContext,
        gqlQuery: gqlQuery
    });
    return $1a750aa44e157db3$export$790960859d921277(summaryPageData);
};
const $1a750aa44e157db3$export$b61b88ec860476 = async (after, projectKey)=>{
    return (0, $4NbWL.fetchActivityFeed)(after, projectKey);
};
const $1a750aa44e157db3$export$1859566a7f2a9210 = async (projectId)=>{
    const response = await (0, $eusud.performGetRequest)(`/rest/internal/data/activity-stream/project/${projectId}`);
    return response;
};
const $1a750aa44e157db3$export$ff7317cbfbcdf84d = (summaryPageData)=>{
    const { issuesByType: issuesByType } = summaryPageData;
    return issuesByType || {
        pageInfo: {
            hasNextPage: false,
            endCursor: ''
        },
        data: [],
        totalUnresolvedIssues: 0
    };
};
const $1a750aa44e157db3$export$91123b5c5792ed19 = async (after, cloudId, projectKey, gqlQuery)=>{
    const jqlContext = `project = "${projectKey}"`;
    if (after === null) {
        const summaryPageData = await $1a750aa44e157db3$var$cachedFetchSummaryPageData({
            cloudId: cloudId,
            jqlContext: jqlContext,
            gqlQuery: gqlQuery
        });
        return $1a750aa44e157db3$export$ff7317cbfbcdf84d(summaryPageData);
    }
    const QUERY_NAME = 'IssuesByTypeData';
    const response = await (0, $eusud.performPostRequest)(`/rest/gira/1/?operation=${QUERY_NAME}`, {
        body: JSON.stringify({
            query: (0, $jXe9w.ISSUES_BY_TYPE_QUERY),
            variables: {
                jql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)}`,
                pageSize: (0, $cd053842fd66588d$export$c0ecd9bd08a86184),
                after: after
            }
        })
    });
    if (response.errors != null) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
    return (0, $egekd.transformIssuesByTypeData)(response.data.issuesByType);
};
const $1a750aa44e157db3$export$80d00dab4f8ab748 = (summaryPageData)=>{
    const { issuesByAssignee: issuesByAssignee } = summaryPageData;
    return issuesByAssignee || {
        pageInfo: {
            hasNextPage: false,
            endCursor: ''
        },
        data: [],
        totalUnresolvedIssues: 0
    };
};
const $1a750aa44e157db3$export$d7836f206e95beb9 = async (after, cloudId, projectKey, gqlQuery)=>{
    const jqlContext = `project = "${projectKey}"`;
    if (after === null) {
        const summaryPageData = await $1a750aa44e157db3$var$cachedFetchSummaryPageData({
            cloudId: cloudId,
            jqlContext: jqlContext,
            gqlQuery: gqlQuery
        });
        return $1a750aa44e157db3$export$80d00dab4f8ab748(summaryPageData);
    }
    const QUERY_NAME = 'IssuesByAssigneeData';
    const response = await (0, $eusud.performPostRequest)(`/rest/gira/1/?operation=${QUERY_NAME}`, {
        body: JSON.stringify({
            query: (0, $cpNcC.ISSUES_BY_ASSIGNEE_QUERY),
            variables: {
                jql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)}`,
                pageSize: (0, $cd053842fd66588d$export$c0ecd9bd08a86184),
                after: after
            }
        })
    });
    if (response.errors != null) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
    return (0, $egekd.transformIssuesByAssigneeData)(response.data.issuesByAssignee);
};
const $1a750aa44e157db3$var$transformEpiProgressData = (response)=>{
    return response.data.values.map((value)=>{
        const epic = response.xLabels[value.xKey];
        return value.dimensionalData.map((dimension)=>({
                name: epic.summary,
                key: epic.key,
                iconUrl: epic.iconUrl,
                count: dimension.result.count,
                status: dimension.dimensionOneKey
            }));
    });
};
const $1a750aa44e157db3$export$721c8ea05838a673 = async (environment, cloudId, projectKey, projectId)=>{
    const [epicHierarchyNameQuery, epicProgressResponse] = await Promise.all([
        (0, $8Uumt.fetchQuery)(environment, (0, $iIMM9.default), {
            cloudId: cloudId,
            projectKey: projectKey
        }).toPromise(),
        (0, $eusud.performPostRequest)(`/rest/internal/data/aggregate/project/${projectId}`, {
            body: JSON.stringify({
                x: {
                    name: 'ACTIVE_PARENT',
                    extraParameters: {}
                },
                dimensionOne: {
                    name: 'STATUS_CATEGORY',
                    extraParameters: {}
                },
                aggregationType: {
                    name: 'ISSUE_COUNT',
                    extraParameters: {}
                },
                type: 'double',
                startAt: 0,
                maxResults: 100
            })
        })
    ]);
    const levelOneIssueTypeNames = epicHierarchyNameQuery?.jira?.jiraProjectByKey?.issueTypes?.edges?.map((edge)=>edge?.node?.name).filter(Boolean) || [];
    return {
        hierarchyName: epicHierarchyNameQuery?.jira?.jiraProjectByKey?.issueTypes?.edges?.[0]?.node?.hierarchy?.name || undefined,
        levelOneIssueTypeNames: levelOneIssueTypeNames,
        progress: $1a750aa44e157db3$var$transformEpiProgressData(epicProgressResponse)
    };
};
const $1a750aa44e157db3$export$84bae86afee5372f = async (cloudId, atlassianAccountId, projectId)=>{
    const MAX_RESULTS = 5;
    const graphResponse = await (0, $7f4tk.default)('/gateway/api/collaboration/v2/recommend/container', {
        method: 'POST',
        body: JSON.stringify({
            context: {
                userId: atlassianAccountId,
                tenantId: cloudId,
                containerId: projectId,
                product: 'jira'
            },
            modelRequestParams: {
                experience: 'JiraContainerNearbyContainer',
                caller: 'jira'
            },
            requestingUserId: atlassianAccountId,
            expand: 'existing',
            // existing filters out projects that could not be hydrated
            maxNumberOfResults: MAX_RESULTS
        })
    });
    return (0, $bB6cs.transformData)(graphResponse, projectId);
};
const $1a750aa44e157db3$export$c0cae41bf4b05d4e = ()=>// TODO https://hello.jira.atlassian.cloud/browse/CORCAP-2965
    new Promise((resolve)=>{
        setTimeout(()=>{
            resolve({
                averageCsat: 4.4,
                csatOverTime: [
                    {
                        csat: 4,
                        month: 'Jan'
                    },
                    {
                        csat: 5,
                        month: 'Feb'
                    },
                    {
                        csat: 3,
                        month: 'March'
                    },
                    {
                        csat: 5,
                        month: 'Apr'
                    },
                    {
                        csat: 4,
                        month: 'Jun'
                    },
                    {
                        csat: 2.5,
                        month: 'July'
                    },
                    {
                        csat: 4,
                        month: 'Aug'
                    }
                ]
            });
        }, 2000);
    });

});
parcelRegister("iIMM9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4ea90e3d898e8b9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3c66eb5230f6dc191f4452754bc4b7eb>>
 * @relayHash 4431264749d8c19cbf05196256b5702b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aca845e9da98bb9032c81ed667c51f8ff474a8b8c37987292b020b679d5c37c2
const $f4ea90e3d898e8b9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "maxHierarchyLevel": 1,
                "minHierarchyLevel": 1
            }
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            v3 /*: any*/ 
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "servicesEpicHierarchyNameQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "issueTypes(filter:{\"maxHierarchyLevel\":1,\"minHierarchyLevel\":1})"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "servicesEpicHierarchyNameQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "issueTypes(filter:{\"maxHierarchyLevel\":1,\"minHierarchyLevel\":1})"
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "aca845e9da98bb9032c81ed667c51f8ff474a8b8c37987292b020b679d5c37c2",
            "metadata": {},
            "name": "servicesEpicHierarchyNameQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f4ea90e3d898e8b9$var$node.hash = "cbdea35ab41303b2be4b674343d5e1a6";
var $f4ea90e3d898e8b9$export$2e2bcd8739ae039 = $f4ea90e3d898e8b9$var$node;

});

const $cd053842fd66588d$export$d5aac1de7fafa2b0 = 'statusCategory = Done AND statusCategoryChangedDate >= -1w';
const $cd053842fd66588d$export$b10a33c38cc20983 = 'updatedDate >= -1w';
const $cd053842fd66588d$export$48eb4b4c930c6378 = 'createdDate >= -1w';
const $cd053842fd66588d$export$2573f5b8014b4068 = 'statusCategory != Done AND (duedate >= 0d AND duedate < 1w)';
const $cd053842fd66588d$export$8cca17e1017ba894 = '(statusCategory != Done OR (statusCategory = Done AND statusCategoryChangedDate >= -2w))';
const $cd053842fd66588d$export$c49e48bfa75ab23c = 'statusCategory != Done';
const $cd053842fd66588d$export$c0ecd9bd08a86184 = 8;
const $cd053842fd66588d$export$27f4fb65edc908d0 = `
  fragment IssuesByAssigneeFragment on JWMItemGroupConnection {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      field {
        ... on UserField {
          userValue {
            accountId,
            avatarUrl,
            displayName
          }
        }
      }
      id,
      totalCount
    }
  }
`;
const $cd053842fd66588d$export$5b2a5373659a0414 = `
  fragment IssuesByTypeFragment on JWMItemGroupConnection {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      field {
        ... on IssueTypeField {
              id
              name
              iconUrl
        }
      }
      id,
      totalCount
    }
  }
`;

parcelRegister("cpNcC", function(module, exports) {

$parcel$export(module.exports, "ISSUES_BY_ASSIGNEE_QUERY", () => $b033daba467695d5$export$b50987cf704e54a4);

const $b033daba467695d5$export$b50987cf704e54a4 = `
  query JiraBusinessIssuesByAssigneeData($jql: String!, $pageSize: Int!, $after: String) {
    issuesByAssignee: jwmItemGroups(jql: $jql, first: $pageSize, after: $after, fieldIds: [], groupByFieldId: "assignee", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByAssigneeFragment
    }
  }

  ${(0, $cd053842fd66588d$export$27f4fb65edc908d0)}
`;

});

parcelRegister("jXe9w", function(module, exports) {

$parcel$export(module.exports, "ISSUES_BY_TYPE_QUERY", () => $9077874cd922f439$export$547a994d0ac40539);

const $9077874cd922f439$export$547a994d0ac40539 = `
  query JiraBusinessIssuesByTypeData($jql: String!, $pageSize: Int!, $after: String) {
    issuesByType: jwmItemGroups(jql: $jql, first: $pageSize, after: $after, fieldIds: [], groupByFieldId: "issuetype", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByTypeFragment
    }
  }

  ${(0, $cd053842fd66588d$export$5b2a5373659a0414)}
`;

});

parcelRegister("j62tG", function(module, exports) {

$parcel$export(module.exports, "fetchSummaryPageData", () => $861665eee54b6736$export$a3fa5b61d6f8cf86);

var $jlq4V = parcelRequire("jlq4V");


var $eusud = parcelRequire("eusud");

var $4R6GH = parcelRequire("4R6GH");

var $aRfdq = parcelRequire("aRfdq");

var $8S8F5 = parcelRequire("8S8F5");
const $861665eee54b6736$var$QUERY_NAME = 'SummaryPageData';
const $861665eee54b6736$export$a3fa5b61d6f8cf86 = async ({ cloudId: cloudId, jqlContext: jqlContext, gqlQuery: gqlQuery = (0, $aRfdq.SUMMARY_PAGE_DATA_QUERY) })=>{
    const query = (0, $4R6GH.fg)('jsm_project_summary_base') ? gqlQuery : (0, $aRfdq.SUMMARY_PAGE_DATA_QUERY);
    const response = await (0, $eusud.performPostRequest)(`/rest/gira/1/?operation=${$861665eee54b6736$var$QUERY_NAME}`, {
        body: JSON.stringify({
            query: query,
            variables: {
                cloudId: cloudId,
                jqlContext: jqlContext,
                doneThisWeekJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$d5aac1de7fafa2b0)}`,
                updatedThisWeekJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$b10a33c38cc20983)}`,
                createdThisWeekJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$48eb4b4c930c6378)}`,
                dueThisWeekJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$2573f5b8014b4068)}`,
                issuesByStatusJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$8cca17e1017ba894)}`,
                issuesByPriorityJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)}`,
                issuesByAssigneeJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)}`,
                issuesByTypeJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)}`,
                pagedDataPageSize: (0, $cd053842fd66588d$export$c0ecd9bd08a86184)
            }
        })
    });
    if (response.errors != null) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
    if (response.data == null) throw new Error('GraphQL response has no data');
    return (0, $8S8F5.transformData)(response.data);
};

});
parcelRegister("aRfdq", function(module, exports) {

$parcel$export(module.exports, "SUMMARY_PAGE_DATA_QUERY_WITH_CUSTOM_QUERY_NAME", () => $e36164e0e5ae5e72$export$4055b8af63772fbc);
$parcel$export(module.exports, "SUMMARY_PAGE_DATA_QUERY", () => $e36164e0e5ae5e72$export$7ea8f81ff5bf6361);
const $e36164e0e5ae5e72$var$ISSUES_BY_ASSIGNEE_FRAGMENT = `
  fragment IssuesByAssigneeFragment on JWMItemGroupConnection {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      field {
        ... on UserField {
          userValue {
            accountId,
            avatarUrl,
            displayName
          }
        }
      }
      id,
      totalCount
    }
  }
`;
const $e36164e0e5ae5e72$var$ISSUES_BY_TYPE_FRAGMENT = `
  fragment IssuesByTypeFragment on JWMItemGroupConnection {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      field {
        ... on IssueTypeField {
              id
              name
              iconUrl
        }
      }
      id,
      totalCount
    }
  }
`;
const $e36164e0e5ae5e72$export$4055b8af63772fbc = (queryName = 'JiraSoftwareSummaryPageData')=>`
  query ${queryName}($cloudId: ID!, $jqlContext: String!, $doneThisWeekJql: String!, $updatedThisWeekJql: String!, $createdThisWeekJql: String!, $dueThisWeekJql: String!, $issuesByStatusJql: String!, $issuesByPriorityJql: String!, $issuesByAssigneeJql: String!, $issuesByTypeJql: String!, $pagedDataPageSize: Int!) {
    jira {
      jqlBuilder(cloudId: $cloudId) {
        status: fieldValues(
          jqlTerm: "status"
          jqlContext: $jqlContext
          viewContext: JWM
        ) {
          edges {
            node {
              jqlTerm
              displayName
            }
          }
        }
        priority: fieldValues(
          jqlTerm: "priority"
          jqlContext: $jqlContext
          viewContext: JWM
        ) {
          edges {
            node {
              jqlTerm
              displayName
            }
          }
        }
      }
      doneThisWeek: jwmViewItems(cloudId: $cloudId, jql: $doneThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      updatedThisWeek: jwmViewItems(cloudId: $cloudId, jql: $updatedThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      createdThisWeek: jwmViewItems(cloudId: $cloudId, jql: $createdThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      dueThisWeek: jwmViewItems(cloudId: $cloudId, jql: $dueThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      totalUnresolvedIssues: jwmViewItems(cloudId: $cloudId, jql: $issuesByAssigneeJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
    }
    issuesByStatus: jwmItemGroups(jql: $issuesByStatusJql, groupByFieldId: "status", fieldIds: [], first: 50) {
      nodes {
        id
        field {
          ...on StatusField {
              name
							statusId
              category {
                key
              }
          }
        }
        totalCount
      }
    }
    issuesByPriority: jwmItemGroups(jql: $issuesByPriorityJql, groupByFieldId: "priority", fieldIds: [], first: 50) {
      nodes {
        id
        field {
          ...on PriorityField {
            iconUrl
            name
          }
        }
        totalCount
      }
    }
    issuesByAssignee: jwmItemGroups(jql: $issuesByAssigneeJql, first: $pagedDataPageSize, fieldIds: [], groupByFieldId: "assignee", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByAssigneeFragment
    }
    issuesByType: jwmItemGroups(jql: $issuesByTypeJql, first: $pagedDataPageSize, fieldIds: [], groupByFieldId: "issuetype", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByTypeFragment
    }
  }

  ${$e36164e0e5ae5e72$var$ISSUES_BY_ASSIGNEE_FRAGMENT}
  ${$e36164e0e5ae5e72$var$ISSUES_BY_TYPE_FRAGMENT}
`;
const $e36164e0e5ae5e72$export$7ea8f81ff5bf6361 = $e36164e0e5ae5e72$export$4055b8af63772fbc('JiraSoftwareSummaryPageData');

});

parcelRegister("8S8F5", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $56b1419676816318$export$3ceb62baab058c6b);

var $egekd = parcelRequire("egekd");
const $56b1419676816318$export$3ceb62baab058c6b = (data)=>{
    return {
        overviewItems: {
            doneThisWeek: data.jira.doneThisWeek?.totalCount ?? 0,
            updatedThisWeek: data.jira.updatedThisWeek?.totalCount ?? 0,
            createdThisWeek: data.jira.createdThisWeek?.totalCount ?? 0,
            dueThisWeek: data.jira.dueThisWeek?.totalCount ?? 0
        },
        issuesByStatus: // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data.issuesByStatus?.nodes.map((node)=>({
                id: node.id,
                count: node.totalCount,
                status: {
                    name: node.field.name,
                    statusId: node.field.statusId,
                    jqlTerm: data.jira.jqlBuilder?.status.edges.find((status)=>status.node.displayName === node.field.name)?.node.jqlTerm,
                    category: {
                        key: node.field.category.key
                    }
                }
            })) ?? null,
        issuesByPriority: // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data.issuesByPriority?.nodes.map((node)=>({
                id: node.id,
                count: node.totalCount,
                priority: {
                    name: node.field.name,
                    iconUrl: node.field.iconUrl,
                    jqlTerm: data.jira.jqlBuilder?.priority.edges.find((priority)=>priority.node.displayName === node.field.name)?.node.jqlTerm
                }
            })) ?? null,
        issuesByAssignee: data.issuesByAssignee ? {
            ...(0, $egekd.transformIssuesByAssigneeData)(data.issuesByAssignee),
            totalUnresolvedIssues: data.jira.totalUnresolvedIssues?.totalCount ?? 0
        } : null,
        issuesByType: data.issuesByType ? {
            ...(0, $egekd.transformIssuesByTypeData)(data.issuesByType),
            totalUnresolvedIssues: data.jira.totalUnresolvedIssues?.totalCount ?? 0
        } : null
    };
};

});


parcelRegister("hGNo3", function(module, exports) {

$parcel$export(module.exports, "cacheParallelAsyncFn", () => $24bc25b7e4b8d12a$export$9b9677666f9e4ede);
function $24bc25b7e4b8d12a$export$9b9677666f9e4ede(fn) {
    const cache = {};
    return (args)=>{
        const key = JSON.stringify(args);
        if (!cache[key]) {
            const promise = fn(args);
            cache[key] = promise;
            // removing once promise is resolved/rejected so user might retry
            promise.finally(()=>{
                delete cache[key];
            });
        }
        return cache[key];
    };
}

});

parcelRegister("bB6cs", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $48c022e29eb3fd65$export$3ceb62baab058c6b);
const $48c022e29eb3fd65$export$3ceb62baab058c6b = (graphResponse, currentProjectId)=>graphResponse.recommendedEntities.filter(({ expand: { id: id } })=>id !== currentProjectId).map(({ expand: { id: id, key: key, name: name, avatarUrl: avatarUrl, url: url, projectTypeKey: projectTypeKey } })=>({
            id: id,
            key: key,
            name: name,
            avatarUrl: avatarUrl,
            url: url,
            projectTypeKey: projectTypeKey
        }));

});


parcelRegister("8p83l", function(module, exports) {

$parcel$export(module.exports, "withBoundary", () => $0b707fe37b8f8025$export$53df44f30a56332b);

var $5uXOq = parcelRequire("5uXOq");

var $aD4Nm = parcelRequire("aD4Nm");

var $7CMCs = parcelRequire("7CMCs");

var $l8ruj = parcelRequire("l8ruj");

var $fNobW = parcelRequire("fNobW");
const $0b707fe37b8f8025$export$53df44f30a56332b = ({ Component: Component, boundaryId: boundaryId, Fallback: Fallback, Skeleton: Skeleton })=>{
    const SkeletonWithHold = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
            name: boundaryId
        }), Skeleton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null));
    return (props)=>{
        return(// eslint-disable-next-line jira/ufo/valid-labels
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
            name: boundaryId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
            teamName: "Helios - Reports",
            fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Fallback, null),
            id: boundaryId,
            packageName: "jiraSpaAppsSoftwareSummary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aD4Nm.ExperienceTracker), {
            location: boundaryId,
            parentProviders: [
                'viewSummary'
            ]
        }, ({ onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
                ...props,
                LoadingComponent: SkeletonWithHold,
                onSuccess: onExperienceSuccess,
                onError: (errorMessage)=>onExperienceFailure('', {
                        failureReason: errorMessage
                    })
            })))));
    };
};

});

parcelRegister("glVl7", function(module, exports) {

$parcel$export(module.exports, "withSummaryData", () => $ae4593b6d4ddfd96$export$4885a1689c89fd61);
$parcel$export(module.exports, "withRouteResourceData", () => $ae4593b6d4ddfd96$export$8c8bc0e47d43bba0);

var $5uXOq = parcelRequire("5uXOq");

var $2YP9W = parcelRequire("2YP9W");

var $gltVr = parcelRequire("gltVr");

var $6QFTz = parcelRequire("6QFTz");
const $ae4593b6d4ddfd96$export$4885a1689c89fd61 = ({ Component: Component, fetchDataFn: fetchDataFn, FallbackComponent: FallbackComponent })=>{
    return ({ LoadingComponent: LoadingComponent, onSuccess: onSuccess, onError: onError, ...componentProps })=>{
        const { fetchData: refresh, ...dataHookProps } = (0, $gltVr.useSummaryData)(fetchDataFn);
        const props = {
            dataHookProps: dataHookProps,
            refresh: refresh,
            loadingComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadingComponent, null),
            fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FallbackComponent, {
                handleRetry: refresh
            }),
            onSuccess: onSuccess,
            onError: onError,
            /**
			 * Typescript has difficulty inferring/converting types with more than one layer of `Omit`
			 * so we need to do some typecasting although the resulting types are identical
			 */ /* eslint-disable @typescript-eslint/consistent-type-assertions */ Component: Component,
            componentProps: componentProps
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ae4593b6d4ddfd96$var$ComponentWithFallbackLoading, props);
    };
};
const $ae4593b6d4ddfd96$export$8c8bc0e47d43bba0 = ({ Component: Component, routeResource: routeResource, dataSelector: dataSelector, FallbackComponent: FallbackComponent })=>{
    return ({ LoadingComponent: LoadingComponent, onSuccess: onSuccess, onError: onError, ...componentProps })=>{
        const { data: routeResourceData, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)(routeResource);
        const data = routeResourceData && dataSelector(routeResourceData);
        const props = {
            dataHookProps: {
                data: data,
                loading: loading,
                error: error
            },
            refresh: refresh,
            loadingComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadingComponent, null),
            fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FallbackComponent, {
                handleRetry: refresh
            }),
            onSuccess: onSuccess,
            onError: onError,
            /**
			 * Typescript has difficulty inferring/converting types with more than one layer of `Omit`
			 * so we need to do some typecasting although the resulting types are identical
			 */ /* eslint-disable @typescript-eslint/consistent-type-assertions */ Component: Component,
            componentProps: componentProps
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ae4593b6d4ddfd96$var$ComponentWithFallbackLoading, props);
    };
};
const $ae4593b6d4ddfd96$var$ComponentWithFallbackLoading = (props)=>{
    const { dataHookProps: { data: data, loading: loading, error: error }, loadingComponent: loadingComponent, onError: onError, fallbackComponent: fallbackComponent, onSuccess: onSuccess, Component: Component, componentProps: componentProps } = props;
    if (!data || loading && !data) return loadingComponent;
    if (error) {
        onError(error?.message);
        return fallbackComponent;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6QFTz.RenderSuccess), {
        onSuccess: onSuccess
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
        ...componentProps,
        data: data
    }));
};

});
parcelRegister("gltVr", function(module, exports) {

$parcel$export(module.exports, "useSummaryData", () => $849b9c83596dd6b7$export$c82acf736eaa253c);
$parcel$export(module.exports, "usePaginatedSummaryData", () => $849b9c83596dd6b7$export$c6cf29ff004990);
$parcel$export(module.exports, "useRouteResourceAndPaginatedSummaryData", () => $849b9c83596dd6b7$export$c5d5c7986a51beda);

var $5uXOq = parcelRequire("5uXOq");

var $5GlnB = parcelRequire("5GlnB");

var $2YP9W = parcelRequire("2YP9W");
const $849b9c83596dd6b7$var$reducer = (state, action)=>{
    switch(action.type){
        case 'FETCH_START':
            return {
                ...state,
                loading: true,
                error: null
            };
        case 'FETCH_SUCCESS':
            return {
                ...state,
                loading: false,
                data: action.payload
            };
        case 'FETCH_FAILURE':
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        default:
            return state;
    }
};
const $849b9c83596dd6b7$export$c82acf736eaa253c = (fetchDataFn)=>{
    const initialState = {
        data: null,
        loading: true,
        error: null
    };
    const [{ data: data, loading: loading, error: error }, dispatch] = (0, $5uXOq.useReducer)($849b9c83596dd6b7$var$reducer, initialState);
    const fetchData = (0, $5uXOq.useCallback)(async ()=>{
        dispatch({
            type: 'FETCH_START'
        });
        try {
            const response = await fetchDataFn();
            dispatch({
                type: 'FETCH_SUCCESS',
                payload: response
            });
        } catch (err) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            dispatch({
                type: 'FETCH_FAILURE',
                payload: err
            });
        }
    }, [
        fetchDataFn
    ]);
    (0, $5uXOq.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    return {
        data: data,
        loading: loading,
        error: error,
        fetchData: fetchData
    };
};
const $849b9c83596dd6b7$export$c6cf29ff004990 = (fetchDataFn, options)=>{
    const initialFetchData = (0, $5uXOq.useCallback)(()=>fetchDataFn(null), [
        fetchDataFn
    ]);
    const { data: initialData, loading: initialLoading, error: initialError, fetchData: initialFetch } = $849b9c83596dd6b7$export$c82acf736eaa253c(initialFetchData);
    return $849b9c83596dd6b7$var$usePaginatedData({
        initialData: initialData,
        initialLoading: initialLoading,
        initialError: initialError,
        initialFetch: initialFetch,
        fetchDataFn: fetchDataFn,
        options: options
    });
};
const $849b9c83596dd6b7$export$c5d5c7986a51beda = (routeResource, dataSelector, fetchDataFn, options)=>{
    const { data: initialRouteResourceData, loading: initialLoading, error: initialError, refresh: initialFetch } = (0, $2YP9W.useResource)(routeResource);
    const initialData = initialRouteResourceData && dataSelector(initialRouteResourceData);
    return $849b9c83596dd6b7$var$usePaginatedData({
        initialData: initialData,
        initialLoading: initialLoading,
        initialError: initialError,
        initialFetch: initialFetch,
        fetchDataFn: fetchDataFn,
        options: options
    });
};
const $849b9c83596dd6b7$var$usePaginatedData = ({ initialData: initialData, initialLoading: initialLoading, initialError: initialError, initialFetch: initialFetch, fetchDataFn: fetchDataFn, options: options })=>{
    const { data: data, error: nextPageError, hasNextPage: hasNextPage, loadingNext: loadingNext, fetch: fetch, fetchNext: fetchNext, reset: reset, loading: loading } = (0, $5GlnB.usePagination)(fetchDataFn, options);
    (0, $5uXOq.useEffect)(()=>{
        if (initialData != null) reset(initialData);
    }, [
        initialData,
        reset
    ]);
    // TODO: HL-1514 if this is used for retries, it would reset to first page. Implement something which uses
    // `fetch` from `usePagination` but also includes args for the current page that needs to be refetched
    const retry = (0, $5uXOq.useCallback)(()=>{
        if (initialData != null) reset(initialData);
        else initialFetch();
    }, [
        initialFetch,
        reset,
        initialData
    ]);
    // TODO HL-1370 this is to handle the endpoint used by JWM for IssuesByTypeData and IssuesByAssigneeData
    // which requires this special handling as only the initial call includes this information, but when we
    // replace with our API we need to update this logic for how our endpoint returns metadata
    const metaData = {
        totalUnresolvedIssues: initialData?.totalUnresolvedIssues
    };
    return {
        data: data,
        loading: initialLoading || loading,
        loadingNext: loadingNext,
        error: initialError || nextPageError,
        hasNextPage: hasNextPage,
        retry: retry,
        fetch: fetch,
        fetchNext: fetchNext,
        metaData: metaData
    };
};

});
parcelRegister("5GlnB", function(module, exports) {

$parcel$export(module.exports, "usePagination", () => $b194f1a2630be1d4$export$f80c710216eae131);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $5uXOq = parcelRequire("5uXOq");

var $ccvFs = parcelRequire("ccvFs");
function $b194f1a2630be1d4$var$init(options) {
    const fetchMode = options.fetchMode || 'append';
    return {
        data: null,
        pageInfo: null,
        ...options.initialData,
        loading: false,
        loadingNext: false,
        error: null,
        fetchMode: fetchMode
    };
}
function $b194f1a2630be1d4$var$resetState(state, initialData) {
    return {
        ...state,
        data: null,
        pageInfo: null,
        ...initialData,
        loading: false,
        loadingNext: false,
        error: null
    };
}
function $b194f1a2630be1d4$var$reducer(state, action) {
    switch(action.type){
        case 'reset':
            return $b194f1a2630be1d4$var$resetState(state, action.value);
        case 'fetch':
            return {
                ...$b194f1a2630be1d4$var$resetState(state),
                loading: true
            };
        case 'fetch-next':
            if (state.pageInfo == null) return {
                ...state,
                loading: true
            };
            return {
                ...state,
                loadingNext: true
            };
        case 'success':
            return {
                ...state,
                data: state.data == null || state.fetchMode === 'replace' ? action.value.data : [
                    ...state.data,
                    ...action.value.data
                ],
                pageInfo: action.value.pageInfo,
                loading: false,
                loadingNext: false,
                error: null
            };
        case 'failure':
            return {
                ...state,
                loading: false,
                loadingNext: false,
                error: action.value
            };
        default:
            break;
    }
    return state;
}
function $b194f1a2630be1d4$export$f80c710216eae131(fetchCallback, options = Object.freeze({})) {
    const [state, dispatch] = (0, $5uXOq.useReducer)($b194f1a2630be1d4$var$reducer, options, $b194f1a2630be1d4$var$init);
    const stateRef = (0, $5uXOq.useRef)(state);
    stateRef.current = state;
    const doFetch = (0, $5uXOq.useCallback)((action, args)=>{
        dispatch({
            type: action
        });
        const cursor = action === 'fetch-next' ? stateRef.current.pageInfo?.endCursor ?? null : null;
        return fetchCallback(cursor, args).then((response)=>{
            dispatch({
                type: 'success',
                value: response
            });
            return response;
        }).catch((error)=>{
            // if the request was aborted, keep showing the UI as loading
            if (error === (0, $ccvFs.ABORTED)) return null;
            dispatch({
                type: 'failure',
                value: error
            });
            throw error;
        });
    }, [
        fetchCallback
    ]);
    const fetch = (0, $5uXOq.useCallback)((args)=>doFetch('fetch', args), [
        doFetch
    ]);
    const fetchNext = (0, $5uXOq.useCallback)((args)=>{
        if (stateRef.current.loading || stateRef.current.error != null || stateRef.current.pageInfo?.hasNextPage === false) return Promise.resolve(null);
        return doFetch('fetch-next', args);
    }, [
        doFetch
    ]);
    const reset = (0, $5uXOq.useCallback)((resetData)=>dispatch({
            type: 'reset',
            value: resetData
        }), []);
    const { data: data, loading: loading, loadingNext: loadingNext, error: error, pageInfo: pageInfo } = state;
    const hasNextPage = pageInfo?.hasNextPage || false;
    return {
        data: data,
        loading: loading,
        loadingNext: loadingNext,
        error: error,
        hasNextPage: hasNextPage,
        fetch: fetch,
        fetchNext: fetchNext,
        reset: reset
    };
}

});
parcelRegister("ccvFs", function(module, exports) {

$parcel$export(module.exports, "ABORTED", () => $e04e223192d877be$export$23e29024ea698a35);
$parcel$export(module.exports, "useAbortable", () => $e04e223192d877be$export$a487c7eb4387f959);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $5uXOq = parcelRequire("5uXOq");
const $e04e223192d877be$export$23e29024ea698a35 = Symbol('ABORTED');
const $e04e223192d877be$export$a487c7eb4387f959 = (fetch)=>{
    const prevControllerRef = (0, $5uXOq.useRef)(null);
    return (0, $5uXOq.useCallback)((...args)=>{
        if (prevControllerRef.current) prevControllerRef.current.abort();
        const controller = new AbortController();
        prevControllerRef.current = controller;
        return fetch(controller.signal, ...args).catch((error)=>{
            if (controller.signal.aborted) throw $e04e223192d877be$export$23e29024ea698a35;
            else throw error;
        });
    }, [
        fetch
    ]);
};

});



parcelRegister("6QFTz", function(module, exports) {

$parcel$export(module.exports, "generateListViewParams", () => $e400305f2d8743a7$export$988195764dba62f3);
$parcel$export(module.exports, "generateJqlString", () => $e400305f2d8743a7$export$263c44d49cc8dfd1);
$parcel$export(module.exports, "escapeFilterChars", () => $e400305f2d8743a7$export$8c452be8843e23da);
$parcel$export(module.exports, "RenderSuccess", () => $e400305f2d8743a7$export$9497c55704d5023c);

var $5uXOq = parcelRequire("5uXOq");

var $cIy4l = parcelRequire("cIy4l");
const $e400305f2d8743a7$export$988195764dba62f3 = (options)=>{
    const params = new URLSearchParams();
    if (options.sortBy) {
        params.append('sortBy', options.sortBy);
        params.append('direction', options.isDescending ? 'DESC' : 'ASC');
    }
    if (options.filter) // URLSearchParams provides escaping, except for single quotes which should
    // utilise the escapeFilterChars function below
    params.append('filter', options.filter);
    if (typeof options.hideDone === 'boolean') params.append('hideDone', options.hideDone ? 'true' : 'false');
    if (options.openCreateIssueDialog) params.append('inlineCreate', 'true');
    return `${params.toString()}`;
};
const $e400305f2d8743a7$export$263c44d49cc8dfd1 = (projectKey, options)=>{
    let jqlString = `project = ${(0, $cIy4l.toQuotedString)(projectKey)}`;
    if (options.filter) jqlString += ` AND ${options.filter}`;
    if (options.hideDone) jqlString += ' AND statusCategory != Done';
    if (options.sortBy) {
        const direction = options.isDescending ? 'DESC' : 'ASC';
        jqlString += ` ORDER BY ${options.sortBy} ${direction}`;
    }
    return jqlString;
};
const $e400305f2d8743a7$export$8c452be8843e23da = (filterString)=>{
    return filterString.replace(/'/g, "\\'");
};
const $e400305f2d8743a7$export$9497c55704d5023c = ({ onSuccess: onSuccess, children: children })=>{
    (0, $5uXOq.useEffect)(()=>{
        onSuccess();
    }, [
        onSuccess
    ]);
    return children;
};

});
parcelRegister("cIy4l", function(module, exports) {

$parcel$export(module.exports, "toQuotedString", () => $ae91325110cc96a6$export$dbeab020a4aa404);
$parcel$export(module.exports, "createIssuesUrl", () => $ae91325110cc96a6$export$c623a4b2d8c439ab);
const $ae91325110cc96a6$var$ENCODE_MAP = {
    '\t': '\\t',
    '\n': '\\n',
    '\r': '\\r',
    '"': '\\"',
    "'": "\\'",
    '\\': '\\\\'
};
const $ae91325110cc96a6$export$946fe289c25510be = (character, ignoredCharacter)=>{
    if (character === ignoredCharacter) return character;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly '\t': "\\t"; readonly '\n': "\\n"; readonly '\r': "\\r"; readonly '"': "\\\""; readonly "'": "\\'"; readonly '\\': "\\\\"; }'.
    return $ae91325110cc96a6$var$ENCODE_MAP[character] || character;
};
const $ae91325110cc96a6$export$dbeab020a4aa404 = (parameter)=>{
    let escaped = '';
    for(let position = 0; position < parameter.length; position += 1)escaped += $ae91325110cc96a6$export$946fe289c25510be(parameter[position], "'");
    return `"${escaped}"`;
};
const $ae91325110cc96a6$export$c623a4b2d8c439ab = (jql)=>`/issues/?jql=${encodeURIComponent(jql)}`;

});



parcelRegister("9DtZr", function(module, exports) {

$parcel$export(module.exports, "withPaginatedSummaryData", () => $43fa98ba079d5809$export$471bfb20332c1951);
$parcel$export(module.exports, "withRouteResourceAndPaginatedData", () => $43fa98ba079d5809$export$4f666046e82aeb29);

var $5uXOq = parcelRequire("5uXOq");

var $gltVr = parcelRequire("gltVr");

var $6QFTz = parcelRequire("6QFTz");
const $43fa98ba079d5809$export$471bfb20332c1951 = ({ Component: Component, fetchDataFn: fetchDataFn, FallbackComponent: FallbackComponent, options: options })=>{
    return ({ LoadingComponent: LoadingComponent, onSuccess: onSuccess, onError: onError, ...baseComponentProps })=>{
        const { retry: retry, ...dataHookProps } = (0, $gltVr.usePaginatedSummaryData)(fetchDataFn, options);
        const props = {
            dataHookProps: dataHookProps,
            loadingComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadingComponent, null),
            onError: onError,
            fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FallbackComponent, {
                handleRetry: retry
            }),
            onSuccess: onSuccess,
            /**
			 * Typescript has difficulty inferring/converting types with more than one layer of `Omit`
			 * so we need to do some typecasting although the resulting types are identical
			 */ /* eslint-disable @typescript-eslint/consistent-type-assertions */ Component: Component,
            baseComponentProps: baseComponentProps
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($43fa98ba079d5809$var$ComponentWithFallbackLoading, props);
    };
};
const $43fa98ba079d5809$export$4f666046e82aeb29 = ({ Component: Component, routeResource: routeResource, dataSelector: dataSelector, fetchDataFn: fetchDataFn, FallbackComponent: FallbackComponent, options: options })=>{
    return ({ LoadingComponent: LoadingComponent, onSuccess: onSuccess, onError: onError, ...baseComponentProps })=>{
        const { retry: retry, ...dataHookProps } = (0, $gltVr.useRouteResourceAndPaginatedSummaryData)(routeResource, dataSelector, fetchDataFn, options);
        const props = {
            dataHookProps: dataHookProps,
            loadingComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadingComponent, null),
            onError: onError,
            fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FallbackComponent, {
                handleRetry: retry
            }),
            onSuccess: onSuccess,
            /**
			 * Typescript has difficulty inferring/converting types with more than one layer of `Omit`
			 * so we need to do some typecasting although the resulting types are identical
			 */ /* eslint-disable @typescript-eslint/consistent-type-assertions */ Component: Component,
            baseComponentProps: baseComponentProps
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($43fa98ba079d5809$var$ComponentWithFallbackLoading, props);
    };
};
const $43fa98ba079d5809$var$ComponentWithFallbackLoading = (props)=>{
    const { dataHookProps: { data: data, loading: loading, error: error, loadingNext: loadingNext, hasNextPage: hasNextPage, fetch: fetch, fetchNext: fetchNext, metaData: metaData }, loadingComponent: loadingComponent, onError: onError, fallbackComponent: fallbackComponent, onSuccess: onSuccess, Component: Component, baseComponentProps: baseComponentProps } = props;
    if (!data || !data && (loading || !error)) return loadingComponent;
    if (error) {
        onError(error?.message);
        return fallbackComponent;
    }
    const componentProps = {
        ...baseComponentProps,
        data: data,
        loadingNext: loadingNext,
        hasNextPage: hasNextPage,
        fetch: fetch,
        fetchNext: fetchNext,
        metaData: metaData
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6QFTz.RenderSuccess), {
        onSuccess: onSuccess
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, componentProps));
};

});

parcelRegister("gAWlc", function(module, exports) {

$parcel$export(module.exports, "skeletons", () => $1014f506e6a6f9fe$export$bc26d03eeb966e55);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $cgL5K = parcelRequire("cgL5K");
const $1014f506e6a6f9fe$var$skeletonFill = `var(--ds-skeleton, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`;
const $1014f506e6a6f9fe$export$bc26d03eeb966e55 = {
    OverviewCount: ()=>/*#__PURE__*/ $5uXOq.createElement("svg", {
            width: "242",
            height: "56",
            viewBox: "0 0 242 56",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: (0, $bwpsq.default)([
                "_1bsb1osq _4t3i1osq"
            ])
        }, /*#__PURE__*/ $5uXOq.createElement("defs", null, /*#__PURE__*/ $5uXOq.createElement("linearGradient", {
            id: "shimmer",
            x1: "-100%",
            x2: "100%",
            y1: "0",
            y2: "0"
        }, /*#__PURE__*/ $5uXOq.createElement("stop", {
            offset: "0%",
            "stop-color": "rgba(9, 30, 66, 0.06)"
        }, /*#__PURE__*/ $5uXOq.createElement("animate", {
            attributeName: "offset",
            values: "-2; 1",
            dur: "2s",
            repeatCount: "indefinite"
        })), /*#__PURE__*/ $5uXOq.createElement("stop", {
            offset: "50%",
            "stop-color": "rgba(9, 30, 66, 0.1)"
        }, /*#__PURE__*/ $5uXOq.createElement("animate", {
            attributeName: "offset",
            values: "-1.5; 1.5",
            dur: "2s",
            repeatCount: "indefinite"
        })), /*#__PURE__*/ $5uXOq.createElement("stop", {
            offset: "100%",
            "stop-color": "rgba(9, 30, 66, 0.06)"
        }, /*#__PURE__*/ $5uXOq.createElement("animate", {
            attributeName: "offset",
            values: "-1; 2",
            dur: "2s",
            repeatCount: "indefinite"
        })))), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "40",
            height: "40",
            rx: "4",
            transform: "translate(0 8)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "100",
            height: "20",
            transform: "translate(48 8)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "194",
            height: "16",
            transform: "translate(48 32)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        })),
    StatusOverview: ()=>/*#__PURE__*/ $5uXOq.createElement("svg", {
            width: "520",
            height: "280",
            viewBox: "0 0 520 280",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: (0, $bwpsq.default)([
                "_1bsb1osq _4t3i1osq"
            ])
        }, /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "166.353",
            height: "20",
            transform: "translate(0.803711 0.803955)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "520.392",
            height: "20",
            transform: "translate(0.803711 24.7648)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("g", {
            "clip-path": "url(#clip0_12833_49225)"
        }, /*#__PURE__*/ $5uXOq.createElement("g", {
            "clip-path": "url(#clip1_12833_49225)"
        }, /*#__PURE__*/ $5uXOq.createElement("path", {
            d: "M281.414 158.259C281.414 212.163 237.716 255.862 183.811 255.862C129.906 255.862 86.208 212.163 86.208 158.259C86.208 104.354 129.906 60.6558 183.811 60.6558C237.716 60.6558 281.414 104.354 281.414 158.259ZM115.489 158.259C115.489 195.992 146.078 226.581 183.811 226.581C221.544 226.581 252.133 195.992 252.133 158.259C252.133 120.526 221.544 89.9367 183.811 89.9367C146.078 89.9367 115.489 120.526 115.489 158.259Z",
            fill: $1014f506e6a6f9fe$var$skeletonFill,
            mask: "url(#path-1-inside-1_12833_49225)"
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "24.4008",
            height: "16.8281",
            transform: "translate(172.031 139.731)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "94.2374",
            height: "16.8281",
            transform: "translate(137.113 159.958)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }))), /*#__PURE__*/ $5uXOq.createElement("rect", {
            x: "315",
            y: "123.366",
            width: "10.0969",
            height: "10.0969",
            rx: "1.68281",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "111.066",
            height: "16.8281",
            transform: "translate(331.895 120)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            x: "315",
            y: "153.656",
            width: "10.0969",
            height: "10.0969",
            rx: "1.68281",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "111.066",
            height: "16.8281",
            transform: "translate(331.895 150.291)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "10.0969",
            height: "10.0969",
            transform: "translate(315 183.947)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "111.066",
            height: "16.8281",
            transform: "translate(331.895 180.581)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        })),
    PriorityBreakdown: ()=>/*#__PURE__*/ $5uXOq.createElement("svg", {
            width: "520",
            height: "280",
            viewBox: "0 0 520 280",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: (0, $bwpsq.default)([
                "_1bsb1osq _4t3i1osq"
            ])
        }, /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "154",
            height: "20",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "518",
            height: "20",
            transform: "translate(0 24)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("g", {
            "clip-path": "url(#clip0_12833_49513)"
        }, /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "37.4502",
            height: "11.9841",
            transform: "translate(114.505 245.721)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "37.4502",
            height: "11.9841",
            transform: "translate(171.555 245.721)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "37.4502",
            height: "11.9841",
            transform: "translate(228.604 245.721)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "37.4502",
            height: "11.9841",
            transform: "translate(285.652 245.721)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "37.4502",
            height: "11.9841",
            transform: "translate(342.701 245.721)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "37.4502",
            height: "11.9841",
            transform: "translate(399.751 245.721)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "20.5535",
            height: "91.9822",
            transform: "translate(123.678 146.249)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "20.5535",
            height: "129.181",
            transform: "translate(180.595 109.051)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "20.5535",
            height: "144.06",
            transform: "translate(237.513 94.8473)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "20.5535",
            height: "123.77",
            transform: "translate(294.344 114.868)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "20.5535",
            height: "86.5714",
            transform: "translate(351.347 152.336)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "20.5535",
            height: "110.243",
            transform: "translate(408.264 128.664)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }))),
    RecentActivity: ()=>/*#__PURE__*/ $5uXOq.createElement("svg", {
            width: "520",
            height: "280",
            viewBox: "0 0 520 280",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: (0, $bwpsq.default)([
                "_1bsb1osq _4t3i1osq"
            ])
        }, /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "200",
            height: "20",
            transform: "translate(0 2)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "494",
            height: "20",
            transform: "translate(0 28)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            y: "91",
            width: "24",
            height: "24",
            rx: "12",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "419",
            height: "24",
            transform: "translate(28 89)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "100",
            height: "20",
            transform: "translate(28 117)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "60",
            height: "20",
            transform: "translate(28 141)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "127",
            height: "20",
            transform: "translate(29 198)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            y: "170",
            width: "24",
            height: "24",
            rx: "12",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "436",
            height: "24",
            transform: "translate(28 170)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            y: "228",
            width: "24",
            height: "24",
            rx: "12",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "426",
            height: "24",
            transform: "translate(28 228)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "129",
            height: "20",
            transform: "translate(28 256)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            x: "1",
            y: "67",
            width: "56",
            height: "13",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        })),
    TypeOfWork: ()=>/*#__PURE__*/ $5uXOq.createElement("svg", {
            width: "520",
            height: "280",
            viewBox: "0 0 520 280",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: (0, $bwpsq.default)([
                "_1bsb1osq _4t3i1osq"
            ])
        }, /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "114",
            height: "20",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "509",
            height: "20",
            transform: "translate(0 24)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "76",
            height: "16",
            transform: "translate(0 68)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "189",
            height: "16",
            transform: "translate(152 68)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "56",
            height: "16",
            transform: "translate(417 68)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "105",
            height: "24",
            transform: "translate(0 99)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "242",
            height: "24",
            transform: "translate(152 99)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "30",
            height: "20",
            transform: "translate(433 101)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "106",
            height: "24",
            transform: "translate(0 139)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "242",
            height: "24",
            transform: "translate(152 139)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "30",
            height: "20",
            transform: "translate(433 141)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "108",
            height: "24",
            transform: "translate(0 179)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "242",
            height: "24",
            transform: "translate(152 179)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "30",
            height: "20",
            transform: "translate(433 181)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        })),
    TeamWorkload: ()=>/*#__PURE__*/ $5uXOq.createElement("svg", {
            width: "520",
            height: "280",
            viewBox: "0 0 520 280",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: (0, $bwpsq.default)([
                "_1bsb1osq _4t3i1osq"
            ])
        }, /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "168",
            height: "20",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "505",
            height: "20",
            transform: "translate(0 24)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "76",
            height: "16",
            transform: "translate(11 68)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "189",
            height: "16",
            transform: "translate(166 68)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "56",
            height: "16",
            transform: "translate(434 68)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            x: "4",
            y: "100",
            width: "24",
            height: "24",
            rx: "12",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "108",
            height: "20",
            transform: "translate(36 102)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "242",
            height: "24",
            transform: "translate(160 100)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "30",
            height: "20",
            transform: "translate(440 102)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            x: "4",
            y: "140",
            width: "24",
            height: "24",
            rx: "12",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "108",
            height: "20",
            transform: "translate(36 142)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "242",
            height: "24",
            transform: "translate(160 140)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "30",
            height: "20",
            transform: "translate(440 142)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            x: "4",
            y: "180",
            width: "24",
            height: "24",
            rx: "12",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "108",
            height: "20",
            transform: "translate(36 182)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("g", {
            "clip-path": "url(#clip0_11653_70962)"
        }, /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "242",
            height: "24",
            transform: "translate(160 180)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        })), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "30",
            height: "20",
            transform: "translate(440 182)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            x: "4",
            y: "220",
            width: "24",
            height: "24",
            rx: "12",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "108",
            height: "20",
            transform: "translate(36 222)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "242",
            height: "24",
            transform: "translate(160 220)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "30",
            height: "20",
            transform: "translate(440 222)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        })),
    EpicProgress: ()=>/*#__PURE__*/ $5uXOq.createElement("svg", {
            width: "520",
            height: "280",
            viewBox: "0 0 520 280",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: (0, $bwpsq.default)([
                "_1bsb1osq _4t3i1osq"
            ])
        }, /*#__PURE__*/ $5uXOq.createElement("g", {
            "clip-path": "url(#clip0_11653_70962)"
        }, /*#__PURE__*/ $5uXOq.createElement("rect", {
            y: "166",
            width: "24",
            height: "24",
            rx: "3",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "317",
            height: "20",
            transform: "translate(28 168)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("path", {
            opacity: "0.85",
            d: "M0 196C0 194.895 0.89543 194 2 194H245V216H2C0.895432 216 0 215.105 0 214V196Z",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("g", {
            "clip-path": "url(#clip1_11653_70962)"
        }, /*#__PURE__*/ $5uXOq.createElement("rect", {
            opacity: "0.85",
            x: "245",
            y: "194",
            width: "138",
            height: "22",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        })), /*#__PURE__*/ $5uXOq.createElement("g", {
            "clip-path": "url(#clip2_11653_70962)"
        }, /*#__PURE__*/ $5uXOq.createElement("rect", {
            opacity: "0.85",
            x: "383",
            y: "194",
            width: "118",
            height: "22",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        })), /*#__PURE__*/ $5uXOq.createElement("rect", {
            y: "100",
            width: "24",
            height: "24",
            rx: "3",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "339",
            height: "20",
            transform: "translate(28 102)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("g", {
            "clip-path": "url(#clip3_11653_70962)"
        }, /*#__PURE__*/ $5uXOq.createElement("path", {
            opacity: "0.85",
            d: "M0 130C0 128.895 0.895431 128 2 128H38V150H2C0.89543 150 0 149.105 0 148V130Z",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        })), /*#__PURE__*/ $5uXOq.createElement("g", {
            "clip-path": "url(#clip4_11653_70962)"
        }, /*#__PURE__*/ $5uXOq.createElement("rect", {
            opacity: "0.85",
            x: "38",
            y: "128",
            width: "276",
            height: "22",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        })), /*#__PURE__*/ $5uXOq.createElement("g", {
            "clip-path": "url(#clip5_11653_70962)"
        }, /*#__PURE__*/ $5uXOq.createElement("rect", {
            opacity: "0.85",
            x: "314",
            y: "128",
            width: "187",
            height: "22",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        })), /*#__PURE__*/ $5uXOq.createElement("rect", {
            y: "232",
            width: "24",
            height: "24",
            rx: "3",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "339",
            height: "20",
            transform: "translate(28 234)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("g", {
            "clip-path": "url(#clip6_11653_70962)"
        }, /*#__PURE__*/ $5uXOq.createElement("path", {
            opacity: "0.85",
            d: "M0 262C0 260.895 0.895431 260 2 260H285V282H2C0.895433 282 0 281.105 0 280V262Z",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        })), /*#__PURE__*/ $5uXOq.createElement("g", {
            "clip-path": "url(#clip7_11653_70962)"
        }, /*#__PURE__*/ $5uXOq.createElement("rect", {
            opacity: "0.85",
            x: "284.753",
            y: "260",
            width: "188",
            height: "22",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        })), /*#__PURE__*/ $5uXOq.createElement("g", {
            "clip-path": "url(#clip8_11653_70962)"
        }, /*#__PURE__*/ $5uXOq.createElement("rect", {
            opacity: "0.85",
            x: "472.938",
            y: "260",
            width: "28",
            height: "22",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }))), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "168",
            height: "24",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "501",
            height: "20",
            transform: "translate(0 28)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            y: "70.5",
            width: "12",
            height: "12",
            rx: "2",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "33",
            height: "16",
            transform: "translate(20 68.5)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            x: "69",
            y: "70.5",
            width: "12",
            height: "12",
            rx: "2",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "67",
            height: "16",
            transform: "translate(89 68.5)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            x: "172",
            y: "70.5",
            width: "12",
            height: "12",
            rx: "2",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "31",
            height: "16",
            transform: "translate(192 68.5)",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        })),
    RelatedProjects: ()=>/*#__PURE__*/ $5uXOq.createElement("svg", {
            width: "520",
            height: "280",
            viewBox: "0 0 520 280",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: (0, $bwpsq.default)([
                "_1bsb1osq _4t3i1osq"
            ])
        }, /*#__PURE__*/ $5uXOq.createElement("rect", {
            width: "476",
            height: "8",
            rx: "4",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            y: "16",
            width: "320",
            height: "8",
            rx: "4",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            y: "56",
            width: "48",
            height: "48",
            rx: "4",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            x: "64",
            y: "68",
            width: "160",
            height: "8",
            rx: "4",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            x: "64",
            y: "84",
            width: "80",
            height: "8",
            rx: "4",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            x: "252",
            y: "56",
            width: "48",
            height: "48",
            rx: "4",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            x: "316",
            y: "68",
            width: "160",
            height: "8",
            rx: "4",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            x: "316",
            y: "84",
            width: "80",
            height: "8",
            rx: "4",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            y: "136",
            width: "48",
            height: "48",
            rx: "4",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            x: "64",
            y: "148",
            width: "160",
            height: "8",
            rx: "4",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            x: "64",
            y: "164",
            width: "80",
            height: "8",
            rx: "4",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            x: "252",
            y: "136",
            width: "48",
            height: "48",
            rx: "4",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            x: "316",
            y: "148",
            width: "160",
            height: "8",
            rx: "4",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            x: "316",
            y: "164",
            width: "80",
            height: "8",
            rx: "4",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            y: "216",
            width: "48",
            height: "48",
            rx: "4",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            x: "64",
            y: "228",
            width: "160",
            height: "8",
            rx: "4",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            x: "64",
            y: "244",
            width: "80",
            height: "8",
            rx: "4",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            x: "252",
            y: "216",
            width: "48",
            height: "48",
            rx: "4",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            x: "316",
            y: "228",
            width: "160",
            height: "8",
            rx: "4",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            x: "316",
            y: "244",
            width: "80",
            height: "8",
            rx: "4",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        }), /*#__PURE__*/ $5uXOq.createElement("rect", {
            y: "296",
            width: "180",
            height: "16",
            rx: "8",
            fill: $1014f506e6a6f9fe$var$skeletonFill
        })),
    CsatOverTime: ()=>{
        // TODO https://hello.jira.atlassian.cloud/browse/CORCAP-2966
        return /*#__PURE__*/ $5uXOq.createElement((0, $cgL5K.default), null, "Needs design and implementation for the loading state");
    }
};
const $1014f506e6a6f9fe$var$skeletonStyles = null;

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';


parcelRegister("7AZ3V", function(module, exports) {

$parcel$export(module.exports, "CustomScalesElement", () => $2863ed5e0018a00a$export$988c7247f3d205d1);
$parcel$export(module.exports, "PercentMarkLabelsOverride", () => $2863ed5e0018a00a$export$db3ac56c204d7f0f);
$parcel$export(module.exports, "CustomLegend", () => $2863ed5e0018a00a$export$502a55a813e9c262);
$parcel$export(module.exports, "EpicProgress", () => $2863ed5e0018a00a$export$4fa9e5abf9c6881c);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $kTK0a = parcelRequire("kTK0a");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");


var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $hDzhb = parcelRequire("hDzhb");
var $lVJAU = parcelRequire("lVJAU");

var $7eO6F = parcelRequire("7eO6F");

var $bT1Sw = parcelRequire("bT1Sw");
var $17PP9 = parcelRequire("17PP9");

var $153fj = parcelRequire("153fj");

var $4BeU4 = parcelRequire("4BeU4");

var $hKvdY = parcelRequire("hKvdY");

var $79GHn = parcelRequire("79GHn");

var $6QFTz = parcelRequire("6QFTz");

var $beAwS = parcelRequire("beAwS");

var $1mhpE = parcelRequire("1mhpE");
const $2863ed5e0018a00a$export$38801bd36eb3c5d0 = (0, $bT1Sw.element)(({ epicStatus: epicStatus, legendOnly: legendOnly })=>{
    const { children: children } = (0, $17PP9.useElementProps)((0, $7eO6F.default).elements.Layout);
    if (legendOnly) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _16jlkb7n _4t3izwfg _vwz47vkz _tj9oglyw"
        ])
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_2rko1sit _1e0c1txw _2lx21bp4 _ca0q12x7 _u5f3idpf _n3td12x7 _19bvidpf _otyr1b66 _irr3xwku"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
        href: `/browse/${epicStatus[0].key}`,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c116y _4cvr1h6o _otyr1b66 _18u01b66 _9oik18uv _1bnxglyw _jf4cnqa1"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        alt: "",
        src: epicStatus[0].iconUrl,
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _4t3i7vkz"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text.subtle"
    }, epicStatus[0].key), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, epicStatus[0].name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1ul9idpf _1tkeidpf _16jlkb7n _4t3i1tcg"
        ])
    }, children));
}, {
    as: (0, $7eO6F.default).elements.Layout
});
const $2863ed5e0018a00a$var$legendContainerStyles = null;
const $2863ed5e0018a00a$var$layoutStyles = null;
const $2863ed5e0018a00a$var$epicInfoContainerStyles = null;
const $2863ed5e0018a00a$var$iconStyles = null;
const $2863ed5e0018a00a$var$percentageBarContainerStyles = null;
const $2863ed5e0018a00a$var$HorizontalStackBarChartScales = (0, $7eO6F.default).elements.Scales;
const $2863ed5e0018a00a$export$988c7247f3d205d1 = (0, $bT1Sw.element)(()=>{
    const elementProps = (0, $17PP9.useElementProps)($2863ed5e0018a00a$var$HorizontalStackBarChartScales);
    const renderChildren = (0, $5uXOq.useCallback)((scales)=>{
        // scales is not typed correctly in the library
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
        const typedScales = scales;
        typedScales.yScale.padding(0);
        return elementProps.children(typedScales);
    }, [
        elementProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2863ed5e0018a00a$var$HorizontalStackBarChartScales, null, renderChildren);
}, {
    as: $2863ed5e0018a00a$var$HorizontalStackBarChartScales
});
const $2863ed5e0018a00a$export$db3ac56c204d7f0f = (0, $bT1Sw.element)(()=>{
    const { barStacks: barStacks } = (0, $17PP9.useElementProps)((0, $7eO6F.default).elements.MarkLabels);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", null, barStacks.map((barStack)=>{
        const total = barStack.bars.reduce((acc, bar)=>{
            if (bar.datum.count) return bar.datum.count + acc;
            return acc;
        }, 0);
        return barStack.bars.map((bar)=>{
            if (bar.width && bar.width > 30) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("text", {
                key: `bar-stack-label-${barStack.key}-${bar.key}`,
                x: bar.x + 12,
                y: "50%",
                dominantBaseline: "central",
                className: (0, $bwpsq.default)([
                    "_11c81oud _ect41sbm _k48pi7a9 _vwz41j6v _lswu15cr"
                ])
            }, bar.width > 48 ? `${Math.round(bar.datum.count / total * 100)}%` : '...');
            return null;
        });
    }));
}, {
    as: (0, $7eO6F.default).elements.MarkLabels
});
const $2863ed5e0018a00a$var$labelTextStyles = null;
const $2863ed5e0018a00a$export$502a55a813e9c262 = (0, $bT1Sw.element)(({ hide: hide })=>{
    const { data: data, colorAccessor: colorAccessor, colorScale: colorScale } = (0, $17PP9.useElementProps)((0, $7eO6F.default).elements.Legend);
    if (hide) return null; // `data` is typed as unknown in the viz library
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const typedData = data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", {
        className: (0, $bwpsq.default)([
            "_zulppxbi _1e0c1txw _2lx2vrvc _19bvidpf"
        ])
    }, typedData.map((d)=>{
        const symbolSize = 12;
        const color = colorScale(colorAccessor(d));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
            key: d.label,
            className: (0, $bwpsq.default)([
                "_zulpu2gc _1e0c1txw _19pkidpf"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
            width: symbolSize,
            height: symbolSize
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
            fill: color,
            width: symbolSize,
            height: symbolSize,
            rx: 1,
            ry: 1
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            className: (0, $bwpsq.default)([
                "_11c8qk37 _19pkftgi _2hwxidpf _otyrftgi _18u0idpf _syaz131l _o5721q9c"
            ])
        }, d.label));
    }));
}, {
    as: (0, $7eO6F.default).elements.Legend
});
const $2863ed5e0018a00a$var$legendsContainerStyles = null;
const $2863ed5e0018a00a$var$singleLegendContainerStyles = null;
const $2863ed5e0018a00a$var$symbolStyles = null;
const $2863ed5e0018a00a$var$labelStyles = null;
const $2863ed5e0018a00a$var$emptyIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
    width: "96",
    height: "96",
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    d: "M12.5428 15.7959C12.5428 15.7959 9.66627 33.5856 12.6719 42.7387H42.6239C42.6239 42.7387 40.1279 28.5517 42.8858 15.7959C42.8858 15.7959 12.3438 15.9914 12.5428 15.7959Z",
    fill: "#DDDEE1"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    d: "M47.1863 15.7959C47.1863 15.7959 44.3098 33.5856 47.3155 42.7387H77.2675C77.2675 42.7387 74.7715 28.5517 77.5293 15.7959C77.5293 15.7959 46.9874 15.9914 47.1863 15.7959Z",
    fill: "#DDDEE1"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    d: "M12.5428 45.4199C12.5428 45.4199 9.66627 63.2096 12.6719 72.3628H42.6239C42.6239 72.3628 40.1279 58.1757 42.8858 45.4199C42.8858 45.4199 12.3438 45.6154 12.5428 45.4199Z",
    fill: "#DDDEE1"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    d: "M54.9259 48.9873C54.9259 48.9873 48.6597 65.8833 49.8431 75.4484L79.2296 81.2433C79.2296 81.2433 79.5263 66.8433 84.6998 54.859C84.6998 54.859 54.6989 49.1444 54.9293 48.9873H54.9259Z",
    fill: "#1868DB"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    d: "M58.0503 63.1572L75.5328 66.8017",
    stroke: "white",
    "stroke-width": "7",
    "stroke-miterlimit": "10"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    d: "M68.6137 56.2383L64.9692 73.7173",
    stroke: "white",
    "stroke-width": "7",
    "stroke-miterlimit": "10"
}));
const $2863ed5e0018a00a$var$emptyStatus = {
    count: 0,
    name: '',
    key: '',
    iconUrl: ''
};
const $2863ed5e0018a00a$var$CustomHorizontalStackBarChart = ({ epicStatus: epicStatus, legendOnly: legendOnly = false, onBarClick: onBarClick })=>{
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { linksResolver: linksResolver, linksTarget: linksTarget } = (0, $79GHn.useSummaryFeatures)();
    const config = {
        done: {
            label: formatMessage((0, $1mhpE.default).doneLabel),
            color: "var(--ds-chart-lime-bold, #6A9A23)"
        },
        indeterminate: {
            label: formatMessage((0, $1mhpE.default).inProgressLabel),
            color: `var(--ds-chart-blue-bold, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`
        },
        new: {
            label: formatMessage((0, $1mhpE.default).toDoLabel),
            color: `var(--ds-chart-neutral, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`
        }
    };
    const allowedStatusCategories = [
        'done',
        'indeterminate',
        'new'
    ];
    const filteredEpicStatus = legendOnly ? allowedStatusCategories.map((status)=>({
            status: status,
            label: config[status].label,
            ...$2863ed5e0018a00a$var$emptyStatus
        })) : epicStatus.sort((a, b)=>allowedStatusCategories.indexOf(a.status) - allowedStatusCategories.indexOf(b.status)) // Filter to include only allowed status categories
    // This excludes 'unknown', which is a legacy status category for unmapped statuses
    .filter((status)=>allowedStatusCategories.includes(status.status)).map((status)=>({
            ...status,
            label: config[status.status].label
        }));
    const fillStyles = filteredEpicStatus.map(({ status: status })=>config[status].color);
    const onClickTooltip = (0, $5uXOq.useCallback)(({ event: event })=>{
        // this only gets emitted on a PointerEvent
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const buttonNumber = event?.button;
        if (buttonNumber === 2) // ignore right clicks
        return;
        onBarClick?.();
        const onClickHref = linksResolver({
            filter: `parent = '${epicStatus[0].key}'`
        });
        if (buttonNumber === 1) // middle button should open in new tab
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(onClickHref, '_blank');
        else if (linksTarget === '_self') push(onClickHref);
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(onClickHref, linksTarget);
    }, [
        epicStatus,
        push,
        linksResolver,
        onBarClick,
        linksTarget
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7eO6F.default), {
        data: filteredEpicStatus,
        xAccessor: "name",
        yAccessor: "count",
        colorAccessor: "label"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2863ed5e0018a00a$export$38801bd36eb3c5d0, {
        epicStatus: filteredEpicStatus,
        legendOnly: legendOnly
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2863ed5e0018a00a$export$502a55a813e9c262, {
        hide: !legendOnly
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2863ed5e0018a00a$export$988c7247f3d205d1, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7eO6F.default).elements.AxisBottom, {
        hide: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7eO6F.default).elements.AxisLeft, {
        hide: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7eO6F.default).elements.Grid, {
        hide: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7eO6F.default).elements.TooltipOverlay, {
        hide: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7eO6F.default).elements.TooltipEmitter, {
        onClick: onClickTooltip
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7eO6F.default).elements.Theme, {
        fillStyles: fillStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7eO6F.default).elements.Marks, {
        roundedCorners: true,
        baseRoundedCorners: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2863ed5e0018a00a$export$db3ac56c204d7f0f, null));
};
const $2863ed5e0018a00a$export$4fa9e5abf9c6881c = ({ data: { progress: progress, hierarchyName: hierarchyName, levelOneIssueTypeNames: levelOneIssueTypeNames } })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { linksResolver: linksResolver, linksTarget: linksTarget } = (0, $79GHn.useSummaryFeatures)();
    const { fireSectionAnalytics: fireSectionAnalytics } = (0, $153fj.useSectionAnalytics)((0, $beAwS.SectionIds).EpicProgress, (0, $beAwS.BoundaryIds).EpicProgress);
    const defaultHierarchyName = formatMessage((0, $1mhpE.default).defaultHierarchyName);
    const headingText = formatMessage((0, $1mhpE.default).title, {
        hierarchyName: hierarchyName ?? defaultHierarchyName
    });
    const onBarClick = (0, $5uXOq.useCallback)(()=>{
        fireSectionAnalytics('viewWithFilter');
    }, [
        fireSectionAnalytics
    ]);
    const handleLinkClick = (0, $5uXOq.useCallback)(()=>{
        fireSectionAnalytics('view');
    }, [
        fireSectionAnalytics
    ]);
    if (!progress.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKvdY.EmptyState), {
        icon: $2863ed5e0018a00a$var$emptyIcon,
        headingText: headingText,
        descriptionText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $1mhpE.default).emptyDescription,
            values: {
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
                        href: `${(0, $kTK0a.getATLContextUrl)('support')}/jira-software-cloud/docs/what-is-an-epic/`,
                        target: "_blank",
                        onClick: handleLinkClick
                    }, chunks)
            }
        })
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4BeU4.ChartWithHeaderContainer), {
        header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            size: "small",
            as: "h2"
        }, headingText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $1mhpE.default).description,
            values: {
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
                        href: linksResolver({
                            filter: `type IN (${levelOneIssueTypeNames.map((name)=>`'${(0, $6QFTz.escapeFilterChars)(name)}'`).join(', ')})`
                        }),
                        target: linksTarget,
                        onClick: handleLinkClick
                    }, chunks)
            }
        }))),
        chart: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                "_18m91wug _2hwxxmi2 _u5f3utpp"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2863ed5e0018a00a$var$CustomHorizontalStackBarChart, {
            epicStatus: progress[0],
            legendOnly: true
        }), progress.map((epicStatus)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2863ed5e0018a00a$var$CustomHorizontalStackBarChart, {
                key: epicStatus[0].key,
                epicStatus: epicStatus,
                onBarClick: onBarClick
            })))
    });
};
const $2863ed5e0018a00a$var$containerStyles = null;

});
parcelRegister("7eO6F", function(module, exports) {

$parcel$export(module.exports, "default", () => $5450b5549f36bb10$export$2e2bcd8739ae039);

var $epG85 = parcelRequire("epG85");

var $eqDul = parcelRequire("eqDul");

var $hKzok = parcelRequire("hKzok");

var $5Yue6 = parcelRequire("5Yue6");

var $svh8v = parcelRequire("svh8v");

var $2OMIu = parcelRequire("2OMIu");
function $5450b5549f36bb10$export$2e2bcd8739ae039(_ref) {
    let { children: children, ...props } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $epG85.default), {
        ...props,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $svh8v.BarStackHorizontalScalesElement), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqDul.BarStackHorizontal), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $epG85.default).elements.TooltipOverlay, {
                horizontal: true
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $epG85.default).elements.TooltipEmitter, {
                horizontal: true
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $epG85.default).elements.Grid, {
                rowLineStyle: "hidden",
                columnLineStyle: "solid"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $epG85.default).elements.AxisLeftLine, {
                hide: true
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $epG85.default).elements.AxisLeftTick, {
                hide: true
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $epG85.default).elements.AxisBottomTick, {
                hide: true
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $epG85.default).elements.AxisBottomLine, {
                hide: true
            }),
            children
        ]
    });
}
$5450b5549f36bb10$export$2e2bcd8739ae039.elements = {
    ...(0, $epG85.default).elements,
    Scales: (0, $svh8v.BarStackHorizontalScalesElement),
    Marks: (0, $5Yue6.BarStackHorizontalMarks).Component,
    MarkLabels: (0, $hKzok.BarStackHorizontalLabels).Component
};

});
parcelRegister("epG85", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7e4147ff34f7841$export$2e2bcd8739ae039);

var $17PP9 = parcelRequire("17PP9");

var $lOXm0 = parcelRequire("lOXm0");

var $hqZma = parcelRequire("hqZma");

var $cXzUG = parcelRequire("cXzUG");
parcelRequire("lWVLr");
var $7Nxvv = parcelRequire("7Nxvv");
var $lWVLr = parcelRequire("lWVLr");

var $e2CtX = parcelRequire("e2CtX");

var $erST8 = parcelRequire("erST8");

var $3B9ij = parcelRequire("3B9ij");

var $chU1I = parcelRequire("chU1I");
var $PfPCm = parcelRequire("PfPCm");

var $iTGbP = parcelRequire("iTGbP");

var $cgmj2 = parcelRequire("cgmj2");

var $doqD0 = parcelRequire("doqD0");
var $l6fAT = parcelRequire("l6fAT");

var $1Tf3y = parcelRequire("1Tf3y");

var $lA40p = parcelRequire("lA40p");

var $02ifK = parcelRequire("02ifK");

var $e0UVN = parcelRequire("e0UVN");

var $2pOyr = parcelRequire("2pOyr");

var $arL7j = parcelRequire("arL7j");

var $dwg9t = parcelRequire("dwg9t");

var $ggVTz = parcelRequire("ggVTz");

var $cKYPp = parcelRequire("cKYPp");

var $fAwZ6 = parcelRequire("fAwZ6");

var $2OMIu = parcelRequire("2OMIu");
function $a7e4147ff34f7841$export$2e2bcd8739ae039(_ref) {
    let { width: width, height: height, data: data, children: children, ...restProps } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $17PP9.ElementsProvider), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e0UVN.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $PfPCm.MenuProvider), {
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $02ifK.default), {
                    children: [
                        children,
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lWVLr.LayoutContainer), {
                            width: width,
                            height: height,
                            data: data,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e2CtX.DimensionsWrapper), {
                                children: (_ref2)=>{
                                    let { margin: margin, plotHeight: plotHeight, plotWidth: plotWidth, plotSvgRef: plotSvgRef } = _ref2;
                                    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fAwZ6.PureBarChart), {
                                        svgRef: plotSvgRef,
                                        height: plotHeight,
                                        width: plotWidth,
                                        margin: margin,
                                        data: data,
                                        ...restProps
                                    });
                                }
                            })
                        })
                    ]
                })
            })
        })
    });
}
$a7e4147ff34f7841$export$2e2bcd8739ae039.elements = {
    // All of the Axis Left components
    AxisLeft: (0, $cXzUG.AxisLeft).Component,
    AxisLeftText: (0, $cXzUG.AxisLeftText).Component,
    AxisLeftTick: (0, $cXzUG.AxisLeftTick).Component,
    AxisLeftLine: (0, $cXzUG.AxisLeftLine).Component,
    // AxisBottomComponents
    AxisBottom: (0, $hqZma.AxisBottom).Component,
    AxisBottomText: (0, $hqZma.AxisBottomText).Component,
    AxisBottomTick: (0, $hqZma.AxisBottomTick).Component,
    AxisBottomLine: (0, $hqZma.AxisBottomLine).Component,
    Grid: (0, $erST8.Grid).Component,
    Legend: (0, $3B9ij.OrdinalLegend).Component,
    Layout: (0, $7Nxvv.Layout).Component,
    Title: (0, $l6fAT.Title).Component,
    SubTitle: (0, $doqD0.Subtitle).Component,
    Marks: (0, $dwg9t.BarGroupMarks).Component,
    Mark: (0, $iTGbP.Bar).Component,
    MarkLabels: (0, $arL7j.BarGroupMarkLabels).Component,
    Scales: (0, $ggVTz.BarScalesElement).Component,
    Theme: (0, $cgmj2.Theme).Component,
    // Tooltip component
    Tooltip: (0, $2pOyr.MultiSeriesTooltip).Component,
    TooltipHeader: (0, $1Tf3y.TooltipHeader).Component,
    TooltipRow: (0, $lA40p.TooltipRow).Component,
    // Tooltip overlay that adds svg marks
    TooltipOverlay: (0, $cKYPp.BarTooltipOverlayElement).Component,
    // Emitter which captures events
    TooltipEmitter: (0, $cKYPp.BarTooltipOverlayEmitterElement).Component,
    Menu: (0, $chU1I.Menu).Component,
    DataTable: (0, $lOXm0.DataTable).Component
};

});
parcelRegister("17PP9", function(module, exports) {

$parcel$export(module.exports, "ElementsProvider", () => $0d1ea50b01d1ff20$export$71c0ba76abe92a7e);
$parcel$export(module.exports, "useElements", () => $0d1ea50b01d1ff20$export$83d5c6859f2ae3df);
$parcel$export(module.exports, "useElementProps", () => $0d1ea50b01d1ff20$export$8edbe6dd5606980);

var $5uXOq = parcelRequire("5uXOq");

var $2OMIu = parcelRequire("2OMIu");

var $6cAn5 = parcelRequire("6cAn5");
const $0d1ea50b01d1ff20$export$a92ee76f0b1f4e66 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
function $0d1ea50b01d1ff20$export$71c0ba76abe92a7e(_ref) {
    let { children: children, defaultProps: defaultProps, kind: kind } = _ref;
    const ctx = $0d1ea50b01d1ff20$export$83d5c6859f2ae3df();
    const value = (0, $5uXOq.useMemo)(()=>{
        // If kind is specified, we assume we are in nested element so we get the parent registry
        // Ideally we'd use WeakMap but node < 20 does not support symbols as keys
        const registry = kind && (ctx === null || ctx === void 0 ? void 0 : ctx.registry) || new Map();
        const registeredOverrideComponents = kind && (ctx === null || ctx === void 0 ? void 0 : ctx.registeredOverrideComponents) || new Map();
        return {
            registry: registry,
            registeredOverrideComponents: registeredOverrideComponents,
            register: (kind, value)=>{
                if (!registeredOverrideComponents.get(kind)) registeredOverrideComponents.set(kind, []);
                const overrideComps = registeredOverrideComponents.get(kind) || [];
                if (!overrideComps.includes(value.Component)) overrideComps.push(value.Component);
                if (overrideComps[overrideComps.length - 1] === value.Component) registry.set(kind, value);
            },
            retrieve: (kind)=>registry.get(kind),
            isNested: (k)=>k === kind || Boolean(ctx === null || ctx === void 0 ? void 0 : ctx.isNested(k)),
            getProps: (k)=>k === kind ? defaultProps : ctx === null || ctx === void 0 ? void 0 : ctx.getProps(k),
            getOuterProps: (k)=>{
                var _registry$get;
                return Boolean(ctx === null || ctx === void 0 ? void 0 : ctx.isNested(k)) ? (_registry$get = registry.get(k)) === null || _registry$get === void 0 ? void 0 : _registry$get.outerProps : null;
            }
        };
    }, [
        kind,
        defaultProps
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($0d1ea50b01d1ff20$export$a92ee76f0b1f4e66.Provider, {
        value: value,
        children: children
    });
}
const $0d1ea50b01d1ff20$export$83d5c6859f2ae3df = ()=>(0, $5uXOq.useContext)($0d1ea50b01d1ff20$export$a92ee76f0b1f4e66);
function $0d1ea50b01d1ff20$export$8edbe6dd5606980(element, _temp) {
    var _process, _process$env, _useElements, _useElements2, _useElements3;
    let { mergeWith: mergeWith } = _temp === void 0 ? {} : _temp;
    if (typeof element.kind !== 'symbol') throw new Error('Invalid element argument. It must be an element or an element Component.');
    if (((_process = $6cAn5) === null || _process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : _process$env.NODE_ENV) === 'development' && !((_useElements = $0d1ea50b01d1ff20$export$83d5c6859f2ae3df()) !== null && _useElements !== void 0 && _useElements.isNested(element.kind))) throw new Error('Invalid element argument. Only props of parent elements can be retrieved.');
    return {
        ...(_useElements2 = $0d1ea50b01d1ff20$export$83d5c6859f2ae3df()) === null || _useElements2 === void 0 ? void 0 : _useElements2.getProps(element.kind),
        ...(_useElements3 = $0d1ea50b01d1ff20$export$83d5c6859f2ae3df()) === null || _useElements3 === void 0 ? void 0 : _useElements3.getOuterProps(element.kind),
        ...mergeWith
    };
}

});

parcelRegister("lOXm0", function(module, exports) {

$parcel$export(module.exports, "DataTable", () => $fe2c4ef74d91a16f$export$df30df7ec97b32b5);
$parcel$export(module.exports, "DataTableModal", () => $fe2c4ef74d91a16f$export$4717a7afeef78908);
/* DataTable.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $42CjB = parcelRequire("42CjB");

var $k3qRI = parcelRequire("k3qRI");

var $lLLkM = parcelRequire("lLLkM");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $jgVsb = parcelRequire("jgVsb");

var $bT1Sw = parcelRequire("bT1Sw");

var $l6fAT = parcelRequire("l6fAT");

var $ltC0t = parcelRequire("ltC0t");

var $2OMIu = parcelRequire("2OMIu");
const $fe2c4ef74d91a16f$var$gridStyles = null;
const $fe2c4ef74d91a16f$export$a8a28302b48950e6 = null;
function $fe2c4ef74d91a16f$var$getHeaders(headers) {
    const cellHeaders = headers.map((header)=>({
            key: header,
            content: (0, $ltC0t.toSentenceCase)(header),
            isSortable: true
        }));
    return {
        cells: cellHeaders
    };
}
function $fe2c4ef74d91a16f$var$getRows(data) {
    if (!data.length) {
        const keys = Object.keys(data);
        const rowData = keys.map((k)=>{
            var _data;
            const cellData = (_data = data[k]) === null || _data === void 0 ? void 0 : _data.toString();
            return {
                key: cellData,
                content: cellData
            };
        });
        return [
            {
                key: 'row-0',
                cells: rowData
            }
        ];
    }
    const rows = data.map((d, i)=>{
        const keys = Object.keys(d);
        const rowData = keys.map((k)=>{
            var _d$k;
            const cellData = (_d$k = d[k]) === null || _d$k === void 0 ? void 0 : _d$k.toString();
            return {
                key: cellData,
                content: cellData
            };
        });
        return {
            key: `row-${i}`,
            cells: rowData
        };
    });
    return rows;
}
function $fe2c4ef74d91a16f$export$84cbf2d941927b3b(_ref) {
    let { data: data, headers: userDefinedHeaders } = _ref;
    if (!data || Array.isArray(data) && data.length === 0) return null;
    const headers = userDefinedHeaders ? $fe2c4ef74d91a16f$var$getHeaders(userDefinedHeaders) : data && $fe2c4ef74d91a16f$var$getHeaders(Object.keys(data[0]));
    const rows = $fe2c4ef74d91a16f$var$getRows(data);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_n3tdu2gc _1reo1wug _18m91wug _ect41sbm _opvxu2gc _91ih1gjq _1ouib76v _cnoh16g6 _a2nzu2gc _9f9g1oud _slyj1fxt _1xc811bn"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k3qRI.default), {
            head: headers,
            rows: rows,
            rowsPerPage: 10,
            defaultPage: 1,
            loadingSpinnerSize: "large"
        })
    });
}
const $fe2c4ef74d91a16f$export$df30df7ec97b32b5 = (0, $bT1Sw.element)($fe2c4ef74d91a16f$export$84cbf2d941927b3b);
function $fe2c4ef74d91a16f$export$4717a7afeef78908(_ref2) {
    let { data: data, closeModal: closeModal } = _ref2;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1R1Ge.default), {
        onClose: closeModal,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jgVsb.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                    className: (0, $bwpsq.default)([
                        "_1bsb1osq _1e0c11p5 _zulppxbi _1lmcg5aa _yv0e1ghl _4cvr1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            className: (0, $bwpsq.default)([
                                "_1bahh9n0 _nd5l1bvj"
                            ]),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                                appearance: "subtle",
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($lLLkM))),
                                label: "Close Modal",
                                onClick: closeModal
                            })
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            className: (0, $bwpsq.default)([
                                "_1bahv2br _nd5l1cy2"
                            ]),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l6fAT.Title), {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7QSqG.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($fe2c4ef74d91a16f$export$df30df7ec97b32b5, {
                    data: data
                })
            })
        ]
    });
}

});
parcelRegister("k3qRI", function(module, exports) {

$parcel$export(module.exports, "default", () => $60e4f0159aa1c87c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $gS5Cm = parcelRequire("gS5Cm");

var $dHbUn = parcelRequire("dHbUn");
class $60e4f0159aa1c87c$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            defaultPage: 1,
            isLoading: false,
            isFixedSize: false,
            isRankable: false,
            onSetPage: (0, $eGmKJ.default),
            onSort: (0, $eGmKJ.default),
            rowsPerPage: Infinity
        };
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        const sortKey = newProps.sortKey || this.state.sortKey;
        const sortOrder = newProps.sortOrder || this.state.sortOrder;
        const page = newProps.page || this.state.page;
        this.setState({
            page: page,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rows: newProps.rows
        });
    }
    render() {
        const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
        const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHbUn.default), {
            paginationi18n: paginationi18n,
            caption: caption,
            emptyView: emptyView,
            head: head,
            highlightedRowIndex: highlightedRowIndex,
            loadingSpinnerSize: loadingSpinnerSize,
            isLoading: isLoading,
            loadingLabel: loadingLabel,
            isFixedSize: isFixedSize,
            onSetPage: this.onSetPageHandler,
            onSort: this.onSortHandler,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRankable: isRankable,
            isRankingDisabled: isRankingDisabled,
            onRankEnd: this.onRankEndHandler,
            onRankStart: onRankStart,
            onPageRowsUpdate: onPageRowsUpdate,
            testId: testId,
            label: label
        });
    }
    constructor(...args){
        super(...args), this.state = {
            page: this.props.defaultPage,
            sortKey: this.props.defaultSortKey,
            sortOrder: this.props.defaultSortOrder,
            rows: this.props.rows
        }, this.onSetPageHandler = (page, analyticsEvent)=>{
            const { onSetPage: onSetPage } = this.props;
            if (onSetPage) {
                onSetPage(page, analyticsEvent);
                this.setState({
                    page: page
                });
            }
        }, this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
            const { onSort: onSort } = this.props;
            if (onSort) {
                onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrder
                }, analyticsEvent);
                this.setState({
                    sortKey: key,
                    sortOrder: sortOrder
                });
            }
        }, this.onRankEndIfExistsHandler = (params)=>{
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        }, this.onRankEndHandler = (params)=>{
            const { destination: destination } = params;
            const { rows: rows, page: page } = this.state;
            const { rowsPerPage: rowsPerPage } = this.props;
            if (!destination || !rows) {
                this.onRankEndIfExistsHandler(params);
                return;
            }
            const reordered = (0, $gS5Cm.reorderRows)(params, rows, page, rowsPerPage);
            this.setState({
                rows: reordered
            });
            this.onRankEndIfExistsHandler(params);
        };
    }
}

});
parcelRegister("gS5Cm", function(module, exports) {

$parcel$export(module.exports, "getPageRows", () => $7f55105045703159$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $7f55105045703159$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $7f55105045703159$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $7f55105045703159$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $7f55105045703159$export$c476bbe5da59992d);
const $7f55105045703159$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $7f55105045703159$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $7f55105045703159$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $7f55105045703159$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $7f55105045703159$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $7f55105045703159$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $7f55105045703159$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $7f55105045703159$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("dHbUn", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb6422faa785b221$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");


var $gS5Cm = parcelRequire("gS5Cm");

var $hiWL0 = parcelRequire("hiWL0");

var $kF3yx = parcelRequire("kF3yx");

var $fkvnY = parcelRequire("fkvnY");

var $hK8cd = parcelRequire("hK8cd");

var $dDBI6 = parcelRequire("dDBI6");

var $dk72m = parcelRequire("dk72m");

var $50Tma = parcelRequire("50Tma");

var $jlnvO = parcelRequire("jlnvO");
function $cb6422faa785b221$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65:
            return 0, $d43e0bb5a9200c87$export$1dee026a19752d6b;
        case 0, $d43e0bb5a9200c87$export$1dee026a19752d6b:
            return 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
const $cb6422faa785b221$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $eGmKJ.default), onSort: providedOnSort = (0, $eGmKJ.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $eGmKJ.default), onRankEnd: providedOnRankEnd = (0, $eGmKJ.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous',
    next: 'Next',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $5uXOq.useState)(false);
    const tableBodyRef = (0, $5uXOq.useRef)(null);
    const onSort = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $5uXOq.useEffect)(()=>{
        (0, $gS5Cm.validateSortKey)(sortKey, head);
        (0, $gS5Cm.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) : $cb6422faa785b221$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $gS5Cm.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3) : (0, $d43e0bb5a9200c87$export$71dd4c8ecd45e95f);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kF3yx.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kF3yx.EmptyViewContainer), {
            testId: testId
        }, emptyView);
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dk72m.default), {
        isLoading: isLoading && rowsExist,
        spinnerSize: spinnerSize,
        targetRef: ()=>tableBodyRef.current,
        testId: testId,
        loadingLabel: loadingLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hiWL0.Table), {
        isFixedSize: isFixedSize,
        "aria-label": label,
        hasDataRow: rowsExist,
        testId: testId,
        isLoading: isLoading
    }, !!caption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hiWL0.Caption), null, caption), head && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jlnvO.default), {
        head: head,
        onSort: onSortHandler,
        sortKey: sortKey,
        sortOrder: sortOrder,
        isRanking: isRanking,
        isRankable: isRankable,
        testId: testId
    }), rowsExist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb6422faa785b221$var$TableBody, {
        ref: tableBodyRef,
        highlightedRowIndex: highlightedRowIndex,
        rows: rows,
        head: head,
        sortKey: sortKey,
        sortOrder: sortOrder,
        rowsPerPage: rowsPerPage,
        page: getPageNumber,
        isFixedSize: isFixedSize || false,
        onPageRowsUpdate: onPageRowsUpdate,
        isTotalPagesControlledExternally: isTotalPagesControlledExternally,
        testId: testId,
        isRankable: isRankable,
        isRanking: isRanking,
        onRankStart: onRankStartHandler,
        onRankEnd: onRankEndHandler,
        isRankingDisabled: isRankingDisabled || isLoading || false
    }))), totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hiWL0.PaginationWrapper), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $50Tma.default), {
        value: getPageNumber,
        onChange: onSetPageHandler,
        total: totalPages,
        i18n: paginationi18n,
        isDisabled: isLoading,
        testId: testId
    })), !rowsExist && emptyBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dDBI6.default), {
        isLoading: isLoading,
        spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
        testId: testId,
        loadingLabel: loadingLabel
    }, emptyBody));
};

const $cb6422faa785b221$var$RankableTableBody = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("8DmN8")));
const $cb6422faa785b221$var$TableBody = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fkvnY.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hK8cd.ErrorBoundary), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb6422faa785b221$var$RankableTableBody, {
        ref: ref,
        ...bodyProps,
        isRanking: isRanking,
        onRankStart: onRankStart,
        onRankEnd: onRankEnd,
        isRankingDisabled: isRankingDisabled
    }))) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cb6422faa785b221$export$2e2bcd8739ae039 = $cb6422faa785b221$var$DynamicTable;

});
const $d43e0bb5a9200c87$export$1dee026a19752d6b = 'ASC';
const $d43e0bb5a9200c87$export$b6abcf7fa1d94f65 = 'DESC';
const $d43e0bb5a9200c87$export$71dd4c8ecd45e95f = 'small';
const $d43e0bb5a9200c87$export$7b93a10c0fefe3e3 = 'large';
const $d43e0bb5a9200c87$export$3843c586a90b9cbf = 0.22;

parcelRegister("hiWL0", function(module, exports) {

$parcel$export(module.exports, "tableRowCSSVars", () => $3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb);
$parcel$export(module.exports, "Table", () => $3b29b0d00cd7b5c6$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $3b29b0d00cd7b5c6$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $3b29b0d00cd7b5c6$export$3e5e12dc01f20a43);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $54lmm = parcelRequire("54lmm");
function $3b29b0d00cd7b5c6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb = {
    CSS_VAR_HOVER_BACKGROUND: '--local-dynamic-table-hover-bg',
    CSS_VAR_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-highlighted-bg',
    CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-hover-highlighted-bg',
    CSS_VAR_ROW_FOCUS_OUTLINE: '--local-dynamic-table-row-focus-outline'
};
const $3b29b0d00cd7b5c6$var$fixedSizeTableStyles = {
    name: "wgb42e",
    styles: "table-layout:fixed"
};
const $3b29b0d00cd7b5c6$var$tableStyles = {
    name: "mul4pg",
    styles: "width:100%;border-collapse:separate;border-spacing:0px"
};
const $3b29b0d00cd7b5c6$var$bodyBorder = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $54lmm.tableBorder).borderColor}`
});
const $3b29b0d00cd7b5c6$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("table", {
        inert: isLoading ? '' : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_BACKGROUND]: (0, $54lmm.row).hoverBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HIGHLIGHTED_BACKGROUND]: (0, $54lmm.row).highlightedBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND]: (0, $54lmm.row).hoverHighlightedBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_ROW_FOCUS_OUTLINE]: (0, $54lmm.row).focusOutline
        },
        css: [
            $3b29b0d00cd7b5c6$var$tableStyles,
            isFixedSize && $3b29b0d00cd7b5c6$var$fixedSizeTableStyles,
            hasDataRow && $3b29b0d00cd7b5c6$var$bodyBorder
        ],
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`
    }, children);
});
const $3b29b0d00cd7b5c6$var$captionStyles = {
    name: "h9a27i",
    styles: "font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-100, 8px);margin-block-start:var(--ds-space-300, 24px);will-change:transform"
};
const $3b29b0d00cd7b5c6$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("caption", {
        css: $3b29b0d00cd7b5c6$var$captionStyles
    }, children);
const $3b29b0d00cd7b5c6$var$paginationWrapperStyles = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $3b29b0d00cd7b5c6$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $3b29b0d00cd7b5c6$var$paginationWrapperStyles,
        "data-testid": testId && `${testId}--pagination--container`
    }, children);

});
parcelRegister("54lmm", function(module, exports) {

$parcel$export(module.exports, "MSThemeColors", () => $b728acac6d8ee4bc$export$34af08ce45c78352);
$parcel$export(module.exports, "arrow", () => $b728acac6d8ee4bc$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "row", () => $b728acac6d8ee4bc$export$120ff0929b202a6d);
$parcel$export(module.exports, "head", () => $b728acac6d8ee4bc$export$5fd5031fecdacec3);
$parcel$export(module.exports, "tableBorder", () => $b728acac6d8ee4bc$export$38d703b73e2cf64d);

const $b728acac6d8ee4bc$export$34af08ce45c78352 = {
    Background: 'Canvas',
    Text: 'CanvasText',
    SelectedBackground: 'Highlight',
    SelectedText: 'HighlightText'
};
const $b728acac6d8ee4bc$export$f2120bbfa5450bd2 = {
    defaultColor: `var(--ds-icon-disabled, ${$829f609a65d26a98$export$1ce2d1575d444ceb})`,
    selectedColor: `var(--ds-icon-subtle, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`
};
const $b728acac6d8ee4bc$export$120ff0929b202a6d = {
    focusOutline: `var(--ds-border-focused, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`,
    highlightedBackground: `var(--ds-background-selected, ${$829f609a65d26a98$export$226de0355ed012f8})`,
    hoverBackground: `var(--ds-background-neutral-subtle-hovered, ${$829f609a65d26a98$export$e655ef011c4aa1a2})`,
    hoverHighlightedBackground: `var(--ds-background-selected-hovered, ${$829f609a65d26a98$export$8c13c2ee36917869})`
};
const $b728acac6d8ee4bc$export$5fd5031fecdacec3 = {
    textColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`
};
const $b728acac6d8ee4bc$export$38d703b73e2cf64d = {
    borderColor: `var(--ds-border, ${$829f609a65d26a98$export$1ce2d1575d444ceb})`
};

});


parcelRegister("kF3yx", function(module, exports) {

$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $0852c529eaab7231$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $0852c529eaab7231$export$381ea436de119582);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $f8Sb3 = parcelRequire("f8Sb3");
function $0852c529eaab7231$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0852c529eaab7231$var$fixedHeightStyles = {
    name: "50gc26",
    styles: "height:9rem"
};
const $0852c529eaab7231$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $0852c529eaab7231$var$fixedHeightStyles,
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`
    }, children);
const $0852c529eaab7231$var$emptyViewContainerStyles = {
    name: "1yld51o",
    styles: "width:50%;margin:auto;padding:10px;text-align:center"
};
const $0852c529eaab7231$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $0852c529eaab7231$var$emptyViewContainerStyles,
        "data-testid": testId && `${testId}--empty-view-container`
    }, children);
};

});

parcelRegister("fkvnY", function(module, exports) {

$parcel$export(module.exports, "default", () => $32bba7afdbc8736a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7bJDt = parcelRequire("7bJDt");

var $ggqAE = parcelRequire("ggqAE");
class $32bba7afdbc8736a$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef
        }, pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ggqAE.default), {
                head: head,
                isFixedSize: isFixedSize,
                key: row.key || rowIndex,
                row: row,
                isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                testId: testId
            })));
    }
}
const $32bba7afdbc8736a$var$Body = (0, $7bJDt.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($32bba7afdbc8736a$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$32bba7afdbc8736a$export$2e2bcd8739ae039 = $32bba7afdbc8736a$var$Body;

});
parcelRegister("7bJDt", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc6eeecb3dc05edd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


var $gS5Cm = parcelRequire("gS5Cm");
const $dc6eeecb3dc05edd$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $dc6eeecb3dc05edd$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $dc6eeecb3dc05edd$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $dc6eeecb3dc05edd$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $dc6eeecb3dc05edd$export$2e2bcd8739ae039(WrappedComponent) {
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $gS5Cm.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $dc6eeecb3dc05edd$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $gS5Cm.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args), this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("ggqAE", function(module, exports) {

$parcel$export(module.exports, "default", () => $136b57fea50cecd2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1g0dL = parcelRequire("1g0dL");

var $d9WgS = parcelRequire("d9WgS");
const $136b57fea50cecd2$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9WgS.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`
    }, cells.map((cell, cellIndex)=>{
        const { content: content, testId: cellTestId, ...restCellProps } = cell;
        const { shouldTruncate: shouldTruncate, width: width } = (head || {
            cells: []
        }).cells[cellIndex] || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1g0dL.TableBodyCell), {
            "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
            ...restCellProps,
            isFixedSize: isFixedSize,
            key: cellIndex,
            shouldTruncate: shouldTruncate,
            width: width
        }, content);
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$136b57fea50cecd2$export$2e2bcd8739ae039 = $136b57fea50cecd2$var$Row;

});
parcelRegister("1g0dL", function(module, exports) {

$parcel$export(module.exports, "TableBodyCell", () => $11c3ea74eda01ab8$export$948e91fcef170792);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $9GQPi = parcelRequire("9GQPi");
const $11c3ea74eda01ab8$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $9GQPi.getTruncationStyleVars)({
            width: width
        }),
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $9GQPi.truncationWidthStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isFixedSize && shouldTruncate && (0, $9GQPi.fixedSizeTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isFixedSize && (0, $9GQPi.overflowTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $9GQPi.cellStyles)
        ],
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        ...props
    });

});
parcelRegister("9GQPi", function(module, exports) {

$parcel$export(module.exports, "truncationWidthStyles", () => $99c9652c1fab2b08$export$708a733455f59a29);
$parcel$export(module.exports, "fixedSizeTruncateStyles", () => $99c9652c1fab2b08$export$616c93ee022c8812);
$parcel$export(module.exports, "overflowTruncateStyles", () => $99c9652c1fab2b08$export$7f2cd17defa265d8);
$parcel$export(module.exports, "getTruncationStyleVars", () => $99c9652c1fab2b08$export$5e6497a652ae30b5);
$parcel$export(module.exports, "cellStyles", () => $99c9652c1fab2b08$export$f7913df521f684e2);

var $f8Sb3 = parcelRequire("f8Sb3");
function $99c9652c1fab2b08$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $99c9652c1fab2b08$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $99c9652c1fab2b08$export$708a733455f59a29 = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: `var(${$99c9652c1fab2b08$var$CSS_VAR_WIDTH})`
});
const $99c9652c1fab2b08$export$616c93ee022c8812 = {
    name: "1s7jr4j",
    styles: "text-overflow:ellipsis;white-space:nowrap"
};
const $99c9652c1fab2b08$export$7f2cd17defa265d8 = {
    name: "d3v9zr",
    styles: "overflow:hidden"
};
const $99c9652c1fab2b08$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$99c9652c1fab2b08$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;
const $99c9652c1fab2b08$export$f7913df521f684e2 = /*#__PURE__*/ (0, $f8Sb3.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
    border: 'none',
    textAlign: 'left',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        paddingInlineStart: "var(--ds-space-0, 0px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:last-child': {
        paddingInlineEnd: "var(--ds-space-0, 0px)"
    }
});

});


parcelRegister("d9WgS", function(module, exports) {

$parcel$export(module.exports, "TableBodyRow", () => $ba9cb59faf06ce7f$export$45f39d9c38b886d5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $hiWL0 = parcelRequire("hiWL0");
const $ba9cb59faf06ce7f$var$rowStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    '&:focus-visible': {
        outline: `2px solid ${`var(--ds-border-focused, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $hiWL0.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`}`,
        outlineOffset: `-2px`
    }
});
const $ba9cb59faf06ce7f$var$rowBackgroundStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $hiWL0.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`
    }
});
const $ba9cb59faf06ce7f$var$rowHighlightedBackgroundStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    backgroundColor: `var(--ds-background-selected, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    `var(${(0, $hiWL0.tableRowCSSVars).CSS_VAR_HIGHLIGHTED_BACKGROUND})`})`,
    '&:hover': {
        backgroundColor: `var(--ds-background-selected-hovered, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $hiWL0.tableRowCSSVars).CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND})`})`
    }
});
const $ba9cb59faf06ce7f$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("tr", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        css: [
            $ba9cb59faf06ce7f$var$rowStyles,
            isHighlighted ? $ba9cb59faf06ce7f$var$rowHighlightedBackgroundStyles : $ba9cb59faf06ce7f$var$rowBackgroundStyles
        ],
        ...rest,
        ref: ref,
        "data-testid": testId
    }, children);
});

});



parcelRegister("hK8cd", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $883137116243a6a0$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");
class $883137116243a6a0$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("dDBI6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e4b90b361173610$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");


var $lLAKY = parcelRequire("lLAKY");
class $2e4b90b361173610$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
            contentsOpacity: (0, $d43e0bb5a9200c87$export$3843c586a90b9cbf),
            loadingLabel: 'Loading table'
        };
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLAKY.Container), {
            testId: testId
        }, !isLoading ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLAKY.ContentsContainer), {
            contentsOpacity: contentsOpacity,
            testId: testId
        }, children), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLAKY.SpinnerContainer), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        })));
    }
}

});
parcelRegister("lLAKY", function(module, exports) {

$parcel$export(module.exports, "Container", () => $d0e2766ad96d94ad$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $d0e2766ad96d94ad$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $d0e2766ad96d94ad$export$a5e06607a5ac6158);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $f8Sb3 = parcelRequire("f8Sb3");
function $d0e2766ad96d94ad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d0e2766ad96d94ad$export$c335a80381ec61f5 = '--contents-opacity';
const $d0e2766ad96d94ad$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $d0e2766ad96d94ad$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $d0e2766ad96d94ad$var$containerStyles,
        "data-testid": testId && `${testId}--container`
    }, children);
const $d0e2766ad96d94ad$var$contentsContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    opacity: `var(${$d0e2766ad96d94ad$export$c335a80381ec61f5})`,
    pointerEvents: 'none'
});
const $d0e2766ad96d94ad$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$d0e2766ad96d94ad$export$c335a80381ec61f5]: contentsOpacity
        },
        css: [
            $d0e2766ad96d94ad$var$contentsContainerStyles
        ],
        "data-testid": testId && `${testId}--contents--container`
    }, children);
const $d0e2766ad96d94ad$var$spinnerContainerStyles = {
    name: "su4u96",
    styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center"
};
const $d0e2766ad96d94ad$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $d0e2766ad96d94ad$var$spinnerContainerStyles,
        "data-testid": testId && `${testId}--spinner--container`
    }, children);

});


parcelRegister("dk72m", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba39c903b39a83b1$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");


var $4xXH4 = parcelRequire("4xXH4");
class $ba39c903b39a83b1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
            contentsOpacity: `var(--ds-opacity-loading, ${`${0, $d43e0bb5a9200c87$export$3843c586a90b9cbf}`})`,
            loadingLabel: 'Loading table'
        };
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4xXH4.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef
        }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4xXH4.SpinnerBackdrop), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4xXH4.SpinnerContainer), {
            ref: this.spinnerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        }))));
    }
    constructor(...args){
        super(...args), this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        }, this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        }, this.componentWillUnmount = ()=>{
            this.detachListeners();
        }, this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        }, this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps), this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        }, this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        }, this.handleResize = ()=>{
            this.updateSpinnerPosition();
        }, this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        }, this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        }, this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});
parcelRegister("4xXH4", function(module, exports) {

$parcel$export(module.exports, "Container", () => $48301faf1109874f$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $48301faf1109874f$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $48301faf1109874f$export$a5e06607a5ac6158);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");
function $48301faf1109874f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $48301faf1109874f$var$containerStyles = {
    name: "17fhw1k",
    styles: "position:relative;margin-block-end:var(--ds-space-300, 24px)"
};
const $48301faf1109874f$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $48301faf1109874f$var$containerStyles,
        ...rest,
        "data-testid": testId,
        ref: ref
    }, children));
});
const $48301faf1109874f$var$spinnerBackdropStyles = {
    name: "1yy6mjk",
    styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center;pointer-events:none"
};
const $48301faf1109874f$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $48301faf1109874f$var$spinnerBackdropStyles,
        "data-testid": testId && `${testId}--spinner-backdrop`
    }, children);
const $48301faf1109874f$var$spinnerContainerStyles = {
    name: "vi3nlf",
    styles: "position:relative;inset-block-start:0"
};
const $48301faf1109874f$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $48301faf1109874f$var$spinnerContainerStyles,
        ref: ref
    }, children));

});


parcelRegister("50Tma", function(module, exports) {

$parcel$export(module.exports, "default", () => $21d5ee5c6331aeb9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $xBgAj = parcelRequire("xBgAj");
class $21d5ee5c6331aeb9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xBgAj.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args), this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});
parcelRegister("xBgAj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aaadfaafd170b3c$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $33etG = parcelRequire("33etG");

var $fmJTX = parcelRequire("fmJTX");

var $6s76W = parcelRequire("6s76W");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $5HBW9 = parcelRequire("5HBW9");

var $15F6T = parcelRequire("15F6T");

var $lmPue = parcelRequire("lmPue");

var $fc5SA = parcelRequire("fc5SA");

var $gRWrA = parcelRequire("gRWrA");
const $8aaadfaafd170b3c$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t",
    navigatorIconWrapper: "_18zr12x7"
};
const $8aaadfaafd170b3c$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $8aaadfaafd170b3c$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($fmJTX))) : (0, (/*@__PURE__*/$parcel$interopDefault($6s76W)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        as: "span",
        xcss: $8aaadfaafd170b3c$var$styles.navigatorIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Chevron, {
        label: "",
        LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
        color: "currentColor"
    }));
}
function $8aaadfaafd170b3c$var$InnerPagination({ components: components = (0, $fc5SA.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $fc5SA.emptyObject), max: max = 7, onChange: onChange = (0, $eGmKJ.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $lmPue.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $33etG.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$8aaadfaafd170b3c$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
            as: "li",
            xcss: $8aaadfaafd170b3c$var$styles.paginationMenuItem,
            key: `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $15F6T.default), {
            component: components.Page,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: currPageIndex
                }),
            "aria-current": isCurrentPage ? 'page' : undefined,
            "aria-label": pageIndexLabel,
            isSelected: isCurrentPage,
            isDisabled: isDisabled,
            page: page,
            testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`
        }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.0",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5HBW9.default), {
        key: "left-navigator",
        component: components.Previous,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue - 1
            }),
        isDisabled: isDisabled || selectedIndexValue === 0,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aaadfaafd170b3c$var$NavigatorIcon, {
            chevronDirection: "left"
        }),
        "aria-label": previousLabel,
        testId: testId && `${testId}--left-navigator`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.0",
        alignBlock: "baseline",
        as: "ul",
        xcss: $8aaadfaafd170b3c$var$styles.paginationMenu
    }, (0, $gRWrA.default)(pages, selectedIndexValue, {
        max: max,
        ellipsis: renderEllipsis,
        transform: transform
    }, testId)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5HBW9.default), {
        key: "right-navigator",
        component: components.Next,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue + 1
            }),
        isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aaadfaafd170b3c$var$NavigatorIcon, {
            chevronDirection: "right"
        }),
        "aria-label": nextLabel,
        testId: testId && `${testId}--right-navigator`
    }))));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $8aaadfaafd170b3c$var$Pagination = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)($8aaadfaafd170b3c$var$InnerPagination));
var $8aaadfaafd170b3c$export$2e2bcd8739ae039 = $8aaadfaafd170b3c$var$Pagination;

});
parcelRegister("fmJTX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17932ebf54d3f380634494a3a0e710ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2fc843461eabf96$var$_react = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b2fc843461eabf96$var$_chevronLeft = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("lRheX")));

var $b2fc843461eabf96$var$_chevronLeftLarge = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("a88oa")));
function $b2fc843461eabf96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2fc843461eabf96$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $b2fc843461eabf96$var$_react.default.createElement($b2fc843461eabf96$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $b2fc843461eabf96$var$_chevronLeftLarge.default
    }, props));
$b2fc843461eabf96$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $b2fc843461eabf96$var$_default = module.exports.default = $b2fc843461eabf96$var$ChevronLeftIcon;

});
parcelRegister("lRheX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6122da5228d1f3e4cce8be42702737a4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fe9bebc953515e63$var$_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $fe9bebc953515e63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;

});

parcelRegister("a88oa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("lRheX")));
function $7601289634e055f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $7601289634e055f6$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $7601289634e055f6$var$_chevronLeft.default,
        iconType: "utility"
    }));
$7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;

});


parcelRegister("6s76W", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ef383524276f158d595d267ad16f45a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));

var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
function $4b2adfad98efb792$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
    }, props));
$4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;

});
parcelRegister("h1toL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
function $c6495598d3d7027d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $c6495598d3d7027d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $c6495598d3d7027d$var$_chevronRight.default,
        iconType: "utility"
    }));
$c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;

});


parcelRegister("c0aEF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed572e62fc5b1cd0$export$2e2bcd8739ae039);
/* inline.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3JT92 = parcelRequire("3JT92");

var $bUmQV = parcelRequire("bUmQV");
const $ed572e62fc5b1cd0$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
const $ed572e62fc5b1cd0$var$Separator = ({ children: children })=>/*#__PURE__*/ $5uXOq.createElement("span", {
        className: (0, $bwpsq.default)([
            $ed572e62fc5b1cd0$var$styles.separator
        ])
    }, children);
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $ed572e62fc5b1cd0$var$Inline = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $5uXOq.createElement($ed572e62fc5b1cd0$var$Separator, null, separator) : separator;
    const children = separatorComponent ? (0, $5uXOq.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ $5uXOq.createElement((0, $5uXOq.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $5uXOq.createElement((0, $bUmQV.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $3JT92.cx)(grow === 'hug' && $ed572e62fc5b1cd0$var$styles.hug, grow === 'fill' && $ed572e62fc5b1cd0$var$styles.fill, // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- TODO: We need to handle pass-through `xcss` => `xcss` here.
        xcss),
        testId: testId,
        ref: ref
    }, children);
}));
$ed572e62fc5b1cd0$var$Inline.displayName = 'Inline';
var $ed572e62fc5b1cd0$export$2e2bcd8739ae039 = $ed572e62fc5b1cd0$var$Inline;

});
parcelRegister("bUmQV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0ccb72b8ddc20b7$export$2e2bcd8739ae039);
/* flex.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d0ccb72b8ddc20b7$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $d0ccb72b8ddc20b7$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $d0ccb72b8ddc20b7$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $d0ccb72b8ddc20b7$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
const $d0ccb72b8ddc20b7$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
const $d0ccb72b8ddc20b7$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $d0ccb72b8ddc20b7$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const $d0ccb72b8ddc20b7$var$Flex = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss }, ref)=>{
    return /*#__PURE__*/ $5uXOq.createElement(Component, {
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            $d0ccb72b8ddc20b7$var$styles.root,
            gap && $d0ccb72b8ddc20b7$var$columnGapMap[gap],
            columnGap && $d0ccb72b8ddc20b7$var$columnGapMap[columnGap],
            gap && $d0ccb72b8ddc20b7$var$rowGapMap[gap],
            rowGap && $d0ccb72b8ddc20b7$var$rowGapMap[rowGap],
            alignItems && $d0ccb72b8ddc20b7$var$alignItemsMap[alignItems],
            direction && $d0ccb72b8ddc20b7$var$flexDirectionMap[direction],
            justifyContent && $d0ccb72b8ddc20b7$var$justifyContentMap[justifyContent],
            wrap && $d0ccb72b8ddc20b7$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$d0ccb72b8ddc20b7$var$Flex.displayName = 'Flex';
var $d0ccb72b8ddc20b7$export$2e2bcd8739ae039 = $d0ccb72b8ddc20b7$var$Flex;

});


parcelRegister("5HBW9", function(module, exports) {

$parcel$export(module.exports, "default", () => $63acbbc2953d9b5a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
function $63acbbc2953d9b5a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("15F6T", function(module, exports) {

$parcel$export(module.exports, "default", () => $097dd42f19f41562$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
function $097dd42f19f41562$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("lmPue", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d144cd0d91a90ab$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $jldZL = parcelRequire("jldZL");
const $3d144cd0d91a90ab$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $3d144cd0d91a90ab$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        as: "li",
        testId: testId,
        key: key,
        xcss: $3d144cd0d91a90ab$var$styles.container,
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        testId: testId && `${testId}-text`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
}

});

parcelRegister("fc5SA", function(module, exports) {

$parcel$export(module.exports, "emptyObject", () => $cbef1c2cfb373aca$export$3f860eba1218f8d3);
const $cbef1c2cfb373aca$export$3f860eba1218f8d3 = {};

});

parcelRegister("gRWrA", function(module, exports) {

$parcel$export(module.exports, "default", () => $48fbac64848b775a$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $48fbac64848b775a$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $8QpSo.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $48fbac64848b775a$export$2e2bcd8739ae039 = $48fbac64848b775a$var$collapseRange;

});



parcelRegister("jlnvO", function(module, exports) {

$parcel$export(module.exports, "default", () => $097ee65829e33b82$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $gS5Cm = parcelRequire("gS5Cm");

var $9Ooyy = parcelRequire("9Ooyy");

var $a41RA = parcelRequire("a41RA");

var $7gEwE = parcelRequire("7gEwE");

var $dpXLF = parcelRequire("dpXLF");

var $BQUUh = parcelRequire("BQUUh");
class $097ee65829e33b82$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
    UNSAFE_componentWillMount() {
        (0, $gS5Cm.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $gS5Cm.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        const { activeSortButtonId: activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponentOld = isRankable ? (0, $7gEwE.default) : (0, $BQUUh.default);
        const HeadCellComponent = isRankable ? (0, $a41RA.default) : (0, $dpXLF.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Ooyy.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tr", null, cells.map((cell, index)=>{
            const { ascendingSortTooltip: ascendingSortTooltip, buttonAriaRoleDescription: buttonAriaRoleDescription, colSpan: colSpan, content: content, descendingSortTooltip: descendingSortTooltip, isIconOnlyHeader: isIconOnlyHeader, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
            // the API.
            ...restCellProps } = cell;
            const headCellId = `head-cell-${index}`;
            const handleClick = ()=>{
                this.setState({
                    activeSortButtonId: headCellId
                });
                if (isSortable) onSort(cell)();
            };
            return (0, $VSDnB.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HeadCellComponent, {
                colSpan: colSpan,
                content: content,
                isFixedSize: isFixedSize,
                isIconOnlyHeader: isIconOnlyHeader,
                isSortable: !!isSortable,
                isRanking: isRanking,
                key: key || index,
                headCellId: headCellId,
                activeSortButtonId: activeSortButtonId,
                onClick: handleClick,
                testId: cellTestId || testId,
                shouldTruncate: shouldTruncate,
                sortOrder: key === sortKey ? sortOrder : undefined,
                width: width,
                ascendingSortTooltip: ascendingSortTooltip,
                descendingSortTooltip: descendingSortTooltip,
                buttonAriaRoleDescription: buttonAriaRoleDescription,
                ...restCellProps
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HeadCellComponentOld, {
                colSpan: colSpan,
                content: content,
                isFixedSize: isFixedSize,
                isSortable: !!isSortable,
                isRanking: isRanking,
                key: key || index,
                onClick: isSortable ? onSort(cell) : undefined,
                testId: cellTestId || testId,
                shouldTruncate: shouldTruncate,
                sortOrder: key === sortKey ? sortOrder : undefined,
                width: width,
                ...restCellProps
            });
        })));
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$097ee65829e33b82$export$2e2bcd8739ae039 = $097ee65829e33b82$var$TableHead;

});
parcelRegister("9Ooyy", function(module, exports) {

$parcel$export(module.exports, "Head", () => $e002e0403dc403bb$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $e002e0403dc403bb$export$4e8024263ace498b);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");



var $54lmm = parcelRequire("54lmm");

var $9GQPi = parcelRequire("9GQPi");
function $e002e0403dc403bb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $e002e0403dc403bb$var$rankingStyles = {
    name: "4zleql",
    styles: "display:block"
};
const $e002e0403dc403bb$var$headStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    borderBlockEnd: `none`
});
const $e002e0403dc403bb$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("thead", {
        css: [
            $e002e0403dc403bb$var$headStyles,
            isRanking && $e002e0403dc403bb$var$rankingStyles
        ],
        "data-testid": testId,
        ...props
    });
};
const $e002e0403dc403bb$var$headCellBaseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    boxSizing: 'border-box',
    position: 'relative',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $54lmm.tableBorder).borderColor}`,
    color: `var(--ds-text-subtle, ${`var(${$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR})`})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    textAlign: 'left',
    verticalAlign: 'middle',
    '&:focus-visible': {
        outline: `solid 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`
    }
});
const $e002e0403dc403bb$var$headCellBaseStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    boxSizing: 'border-box',
    position: 'relative',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $54lmm.tableBorder).borderColor}`,
    color: `var(--ds-text-subtle, ${`var(${$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR})`})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    textAlign: 'left',
    verticalAlign: 'top',
    '&:focus-visible': {
        outline: `solid 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`
    }
});
const $e002e0403dc403bb$var$onClickStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
        cursor: 'pointer'
    }
});
const $e002e0403dc403bb$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        padding: "var(--ds-space-0, 0)",
        position: 'relative',
        appearance: 'none',
        background: 'none',
        border: 'none',
        color: 'inherit',
        cursor: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontWeight: 'inherit',
        '&::before, &::after': {
            display: 'block',
            width: 0,
            height: 0,
            position: 'absolute',
            border: '3px solid transparent',
            content: '""',
            insetInlineEnd: "var(--ds-space-negative-100, -8px)"
        },
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockEnd: `3px solid ${(0, $54lmm.arrow).defaultColor}`,
            insetBlockEnd: "var(--ds-space-100, 8px)"
        },
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockStart: `3px solid ${(0, $54lmm.arrow).defaultColor}`,
            insetBlockEnd: 0
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::before, &::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                border: `3px solid ${(0, $54lmm.MSThemeColors).Background}`
            },
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockEnd: `3px solid ${(0, $54lmm.MSThemeColors).Text}`
            },
            '&::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockStart: `3px solid ${(0, $54lmm.MSThemeColors).Text}`
            }
        }
    }
});
const $e002e0403dc403bb$var$ascendingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockEnd: `3px solid ${(0, $54lmm.arrow).selectedColor}`
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockEnd: `3px solid ${(0, $54lmm.MSThemeColors).SelectedBackground}`
            }
        }
    }
});
const $e002e0403dc403bb$var$descendingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockStart: `3px solid ${(0, $54lmm.arrow).selectedColor}`
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockStart: `3px solid ${(0, $54lmm.MSThemeColors).SelectedBackground}`
            }
        }
    }
});
const $e002e0403dc403bb$export$4e8024263ace498b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $9GQPi.getTruncationStyleVars)({
            width: width
        }),
        [$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR]: (0, $54lmm.head).textColor
    };
    const isASC = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    const isVisuallyRefreshed = (0, $VSDnB.fg)('platform-component-visual-refresh');
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $9GQPi.cellStyles),
            isVisuallyRefreshed ? $e002e0403dc403bb$var$headCellBaseStyles : $e002e0403dc403bb$var$headCellBaseStylesOld,
            !isVisuallyRefreshed && onClick && $e002e0403dc403bb$var$onClickStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $9GQPi.truncationWidthStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            isFixedSize && shouldTruncate && (0, $9GQPi.fixedSizeTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            isFixedSize && (0, $9GQPi.overflowTruncateStyles),
            !isVisuallyRefreshed && isSortable && $e002e0403dc403bb$var$baseStyles,
            !isVisuallyRefreshed && isASC && $e002e0403dc403bb$var$ascendingStyles,
            !isVisuallyRefreshed && isDESC && $e002e0403dc403bb$var$descendingStyles
        ],
        onClick: !isVisuallyRefreshed ? onClick : undefined,
        ref: ref,
        "data-testid": testId,
        ...rest
    }, children);
});

});

parcelRegister("a41RA", function(module, exports) {

$parcel$export(module.exports, "default", () => $669a06e89a9827f7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cVljL = parcelRequire("cVljL");

var $gS5Cm = parcelRequire("gS5Cm");

var $dpXLF = parcelRequire("dpXLF");
class $669a06e89a9827f7$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $gS5Cm.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpXLF.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $669a06e89a9827f7$var$RankableTableHeadCell = (0, $cVljL.default)($669a06e89a9827f7$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$669a06e89a9827f7$export$2e2bcd8739ae039 = $669a06e89a9827f7$var$RankableTableHeadCell;

});
parcelRegister("cVljL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e49a9b167764eb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $a3e49a9b167764eb$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.state = {
                refWidth: 0,
                refHeight: 0
            }, this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            }, this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("dpXLF", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9c80f4a483cfd6a$export$2e2bcd8739ae039);
/* table-head-cell.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $cC5ib = parcelRequire("cC5ib");

var $kcHZS = parcelRequire("kcHZS");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");
var $3Lty3 = parcelRequire("3Lty3");
var $dS3PR = parcelRequire("dS3PR");

var $3bDjY = parcelRequire("3bDjY");


var $9Ooyy = parcelRequire("9Ooyy");
const $d9c80f4a483cfd6a$var$styles = {
    buttonWrapper: "_1e0c1txw _bfhk18uv _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
const $d9c80f4a483cfd6a$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o"
};
const $d9c80f4a483cfd6a$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, sortOrder: sortOrder, onClick: onClick, headCellId: headCellId, activeSortButtonId: activeSortButtonId, ascendingSortTooltip: ascendingSortTooltip = 'Sort ascending', descendingSortTooltip: descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription: buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader: isIconOnlyHeader, ...rest })=>{
    const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, $5uXOq.useCallback)(()=>{
        setIsFocused?.(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, $5uXOq.useCallback)(()=>{
        setIsFocused?.(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, $5uXOq.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, $5uXOq.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $d9c80f4a483cfd6a$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? ascendingSortTooltip : descendingSortTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Lty3.default), {
        onClick: onClick,
        xcss: $d9c80f4a483cfd6a$var$styles.buttonWrapper,
        "aria-roledescription": buttonAriaRoleDescription
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        xcss: isVisibleIconOnlyHeader ? $d9c80f4a483cfd6a$var$styles.hideIconHeaderWrapper : $d9c80f4a483cfd6a$var$styles.visibleHeaderWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        size: "small",
        color: "color.text.subtle",
        weight: "bold",
        maxLines: 1
    }, content)), shouldRenderSortIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        xcss: isSortIconVisible ? $d9c80f4a483cfd6a$var$styles.sortIconVisibleWrapper : $d9c80f4a483cfd6a$var$styles.sortIconHiddenWrapper
    }, sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kcHZS))), {
        label: "",
        color: "var(--ds-text-subtle, #44546F)",
        testId: testId && `${testId}--up--icon`
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cC5ib))), {
        label: "",
        color: "var(--ds-text-subtle, #44546F)",
        testId: testId && `${testId}--down--icon`
    })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Ooyy.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        isSortable: isSortable,
        sortOrder: sortOrder
    }, isSortable ? visuallyRefreshedButton : content);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d9c80f4a483cfd6a$export$2e2bcd8739ae039 = $d9c80f4a483cfd6a$var$TableHeadCell;

});
parcelRegister("cC5ib", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::980468f720de67e44e700795aed02102>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92ed238f23140736$var$_react = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $92ed238f23140736$var$_baseNew = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $92ed238f23140736$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $92ed238f23140736$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $92ed238f23140736$var$_react.default.createElement($92ed238f23140736$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 1v12.75m-5-4.5 5 5 5-5"/>`
    }, props));
$92ed238f23140736$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $92ed238f23140736$var$_default = module.exports.default = $92ed238f23140736$var$ArrowDownIcon;

});

parcelRegister("kcHZS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::656cb3b07e22a80c807b482f8fbbfa44>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb570e807ab2e210$var$_react = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eb570e807ab2e210$var$_baseNew = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $eb570e807ab2e210$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb570e807ab2e210$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $eb570e807ab2e210$var$_react.default.createElement($eb570e807ab2e210$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 15V2.25m-5 4.5 5-5 5 5"/>`
    }, props));
$eb570e807ab2e210$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $eb570e807ab2e210$var$_default = module.exports.default = $eb570e807ab2e210$var$ArrowUpIcon;

});

parcelRegister("3Lty3", function(module, exports) {

$parcel$export(module.exports, "default", () => $70eb08f4038c94d3$export$2e2bcd8739ae039);
/* pressable.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $DEWI6 = parcelRequire("DEWI6");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $6wxJn = parcelRequire("6wxJn");

var $a1dy0 = parcelRequire("a1dy0");
const $70eb08f4038c94d3$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
}; /**
    * __Pressable__
    *
    * A primitive for building custom buttons.
    *
    * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
    * - [Code](https://atlassian.design/components/primitives/pressable/code)
    * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
    */ 
const $70eb08f4038c94d3$var$Pressable = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $eGmKJ.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $5uXOq.useContext)((0, $6wxJn.default));
    const handleClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ $5uXOq.createElement((0, $a1dy0.default // @ts-expect-error we don't allow `button` on Focusable for makers as they should use Pressable instead
    ), {
        as: "button" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- TODO: Properly type this and allow pass-through if we can determine the type
        ,
        style: style,
        ...safeHtmlAttributes,
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $DEWI6.cx)($70eb08f4038c94d3$var$styles.root, isDisabled && $70eb08f4038c94d3$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }, children);
});
var $70eb08f4038c94d3$export$2e2bcd8739ae039 = $70eb08f4038c94d3$var$Pressable;

});



parcelRegister("7gEwE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fc2a0c6e4ccfbc5$export$2e2bcd8739ae039);
// Delete this file when cleaning up platform-component-visual-refresh FG

var $5uXOq = parcelRequire("5uXOq");

var $cVljL = parcelRequire("cVljL");

var $gS5Cm = parcelRequire("gS5Cm");

var $BQUUh = parcelRequire("BQUUh");
class $5fc2a0c6e4ccfbc5$var$RankableTableHeadCellComponentOld extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $gS5Cm.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BQUUh.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $5fc2a0c6e4ccfbc5$var$RankableTableHeadCellOld = (0, $cVljL.default)($5fc2a0c6e4ccfbc5$var$RankableTableHeadCellComponentOld);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5fc2a0c6e4ccfbc5$export$2e2bcd8739ae039 = $5fc2a0c6e4ccfbc5$var$RankableTableHeadCellOld;

});
parcelRegister("BQUUh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bd2f57a58531c0d$export$2e2bcd8739ae039);
// Delete this file when cleaning up platform-component-visual-refresh FG

var $5uXOq = parcelRequire("5uXOq");

var $9Ooyy = parcelRequire("9Ooyy");
const $4bd2f57a58531c0d$var$TableHeadCellOld = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Ooyy.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        onClick: onClick,
        isSortable: isSortable
    }, isSortable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("button", {
        type: "button",
        "aria-roledescription": "Sort button"
    }, content) : content);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4bd2f57a58531c0d$export$2e2bcd8739ae039 = $4bd2f57a58531c0d$var$TableHeadCellOld;

});



parcelRegister("8DmN8", function(module, exports) {

let $6493a52e1cae0609$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6493a52e1cae0609$var$load("cM9em"),
    $6493a52e1cae0609$var$load("fr9NE"),
    $6493a52e1cae0609$var$load("bz1jP")
]).then(()=>parcelRequire('4THp8'));

});



parcelRegister("bT1Sw", function(module, exports) {

$parcel$export(module.exports, "element", () => $8a7649c186b65558$export$8454457683f90105);
// Chart element takes a chart type generic which says what kind of overrides we can do

var $17PP9 = parcelRequire("17PP9");

var $2OMIu = parcelRequire("2OMIu");
function $8a7649c186b65558$export$8454457683f90105(DefaultComponent, options) {
    var _options$as;
    if (options === void 0) options = {};
    const displayName = DefaultComponent.displayName || DefaultComponent.name || options.displayName;
    const kind = ((_options$as = options.as) === null || _options$as === void 0 ? void 0 : _options$as.kind) || Symbol(displayName);
    if (options.as && !options.as.kind) throw new Error('Invalid "as" component. It must be an `element` or `element.Component` value.');
    /**
   * When used outside its own slot, it will register the override
   * while when its used inside the slot, it will render the component
   */ const ElementComponent = (outerProps)=>{
        const ctx = (0, $17PP9.useElements)();
        if (!ctx) throw new Error('Element must be used inside an ElementsProvider');
        // Check if we are rendering under the own ElementComponent, if so, just render
        if (ctx !== null && ctx !== void 0 && ctx.isNested(kind)) return /*#__PURE__*/ (0, $2OMIu.jsx)(DefaultComponent, {
            ...!options.as && ctx.getProps(kind),
            ...outerProps
        });
        else {
            ctx.register(kind, {
                Component: DefaultComponent,
                outerProps: outerProps
            });
            return null;
        }
    };
    ElementComponent.kind = kind;
    // When as is defined we return the component without any slot implementation
    if (options.as) return ElementComponent;
    /**
   * Defines the slot where the element will be rendered, grabbing the implementation from the context
   */ const ElementSlot = (defaultProps)=>{
        const ctx = (0, $17PP9.useElements)();
        const { Component: Component = DefaultComponent, outerProps: outerProps } = (ctx === null || ctx === void 0 ? void 0 : ctx.retrieve(kind)) || {};
        const isSelf = Component === DefaultComponent;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $17PP9.ElementsProvider), {
            kind: kind,
            defaultProps: defaultProps,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                ...isSelf && defaultProps,
                ...outerProps
            })
        });
    };
    ElementSlot.kind = kind;
    ElementSlot.Component = ElementComponent;
    ElementSlot.displayName = `element(${displayName})`;
    return ElementSlot;
}

});

parcelRegister("l6fAT", function(module, exports) {

$parcel$export(module.exports, "Title", () => $f5c641277358ed4b$export$f99233281efd08a0);
/* title.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $bT1Sw = parcelRequire("bT1Sw");

var $2OMIu = parcelRequire("2OMIu");
const $f5c641277358ed4b$var$titleTextStyle = null;
function $f5c641277358ed4b$var$Title(_ref) {
    let { children: children } = _ref;
    if (!children) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("h2", {
        className: (0, $bwpsq.default)([
            "_syaz1gjq _k48pni7l _zg8l4jg8 _ect4e86e _1wyb7vkz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt461nu"
        ]),
        children: children
    });
}
const $f5c641277358ed4b$export$f99233281efd08a0 = (0, $bT1Sw.element)($f5c641277358ed4b$var$Title);

});

parcelRegister("ltC0t", function(module, exports) {

$parcel$export(module.exports, "toSentenceCase", () => $fa29c9baa9a7a709$export$dcbb097fa84257c1);
$parcel$export(module.exports, "default", () => $fa29c9baa9a7a709$export$2e2bcd8739ae039);

var $hjll3 = parcelRequire("hjll3");
const $fa29c9baa9a7a709$var$formatNumberAbbreviated = (value)=>{
    if (value === null) return 'null';
    let numberValue;
    if (typeof value === 'string') {
        const parsedValue = Number(value);
        if (isNaN(parsedValue)) return value;
        numberValue = parsedValue;
    } else numberValue = value;
    return new Intl.NumberFormat('en-US', {
        notation: 'compact',
        compactDisplay: 'short'
    }).format(numberValue);
};
const $fa29c9baa9a7a709$var$percentChange = (currentValue, previousValue)=>{
    if (previousValue === 0) return (currentValue * 100).toFixed();
    return (Math.abs(previousValue - currentValue) / previousValue * 100).toFixed();
};
const $fa29c9baa9a7a709$var$formatMillisecond = (0, $hjll3.timeFormat)('.%L'), $fa29c9baa9a7a709$var$formatSecond = (0, $hjll3.timeFormat)(':%S'), $fa29c9baa9a7a709$var$formatMinute = (0, $hjll3.timeFormat)('%I:%M'), $fa29c9baa9a7a709$var$formatHour = (0, $hjll3.timeFormat)('%I %p'), $fa29c9baa9a7a709$var$formatDay = (0, $hjll3.timeFormat)('%b %d'), $fa29c9baa9a7a709$var$formatWeek = (0, $hjll3.timeFormat)('%b %d'), $fa29c9baa9a7a709$var$formatMonth = (0, $hjll3.timeFormat)('%b'), $fa29c9baa9a7a709$var$formatYear = (0, $hjll3.timeFormat)('%Y');
function $fa29c9baa9a7a709$export$16cec29b78b14126(date) {
    return ((0, $hjll3.timeSecond)(date) < date ? $fa29c9baa9a7a709$var$formatMillisecond : (0, $hjll3.timeMinute)(date) < date ? $fa29c9baa9a7a709$var$formatSecond : (0, $hjll3.timeHour)(date) < date ? $fa29c9baa9a7a709$var$formatMinute : (0, $hjll3.timeDay)(date) < date ? $fa29c9baa9a7a709$var$formatHour : (0, $hjll3.timeMonth)(date) < date ? (0, $hjll3.timeWeek)(date) < date ? $fa29c9baa9a7a709$var$formatDay : $fa29c9baa9a7a709$var$formatWeek : (0, $hjll3.timeYear)(date) < date ? $fa29c9baa9a7a709$var$formatMonth : $fa29c9baa9a7a709$var$formatYear)(date);
}
function $fa29c9baa9a7a709$export$dcbb097fa84257c1(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
var $fa29c9baa9a7a709$export$2e2bcd8739ae039 = {
    formatNumberAbbreviated: $fa29c9baa9a7a709$var$formatNumberAbbreviated,
    percentChange: $fa29c9baa9a7a709$var$percentChange,
    multiTimeFormat: $fa29c9baa9a7a709$export$16cec29b78b14126,
    toSentenceCase: $fa29c9baa9a7a709$export$dcbb097fa84257c1
};

});
parcelRegister("hjll3", function(module, exports) {
// https://d3js.org v7.7.0 Copyright 2010-2022 Mike Bostock
(function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    'use strict';
    var version = "7.7.0";
    function ascending$3(a, b) {
        return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
    }
    function descending$2(a, b) {
        return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
    }
    function bisector(f) {
        let compare1, compare2, delta;
        // If an accessor is specified, promote it to a comparator. In this case we
        // can test whether the search value is (self-) comparable. We can’t do this
        // for a comparator (except for specific, known comparators) because we can’t
        // tell if the comparator is symmetric, and an asymmetric comparator can’t be
        // used to test whether a single value is comparable.
        if (f.length !== 2) {
            compare1 = ascending$3;
            compare2 = (d, x)=>ascending$3(f(d), x);
            delta = (d, x)=>f(d) - x;
        } else {
            compare1 = f === ascending$3 || f === descending$2 ? f : zero$1;
            compare2 = f;
            delta = f;
        }
        function left(a, x, lo = 0, hi = a.length) {
            if (lo < hi) {
                if (compare1(x, x) !== 0) return hi;
                do {
                    const mid = lo + hi >>> 1;
                    if (compare2(a[mid], x) < 0) lo = mid + 1;
                    else hi = mid;
                }while (lo < hi);
            }
            return lo;
        }
        function right(a, x, lo = 0, hi = a.length) {
            if (lo < hi) {
                if (compare1(x, x) !== 0) return hi;
                do {
                    const mid = lo + hi >>> 1;
                    if (compare2(a[mid], x) <= 0) lo = mid + 1;
                    else hi = mid;
                }while (lo < hi);
            }
            return lo;
        }
        function center(a, x, lo = 0, hi = a.length) {
            const i = left(a, x, lo, hi - 1);
            return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
        }
        return {
            left: left,
            center: center,
            right: right
        };
    }
    function zero$1() {
        return 0;
    }
    function number$3(x) {
        return x === null ? NaN : +x;
    }
    function* numbers(values, valueof) {
        if (valueof === undefined) {
            for (let value of values)if (value != null && (value = +value) >= value) yield value;
        } else {
            let index = -1;
            for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
        }
    }
    const ascendingBisect = bisector(ascending$3);
    const bisectRight = ascendingBisect.right;
    const bisectLeft = ascendingBisect.left;
    const bisectCenter = bisector(number$3).center;
    var bisect = bisectRight;
    function blur(values, r) {
        if (!((r = +r) >= 0)) throw new RangeError("invalid r");
        let length = values.length;
        if (!((length = Math.floor(length)) >= 0)) throw new RangeError("invalid length");
        if (!length || !r) return values;
        const blur = blurf(r);
        const temp = values.slice();
        blur(values, temp, 0, length, 1);
        blur(temp, values, 0, length, 1);
        blur(values, temp, 0, length, 1);
        return values;
    }
    const blur2 = Blur2(blurf);
    const blurImage = Blur2(blurfImage);
    function Blur2(blur) {
        return function(data, rx, ry = rx) {
            if (!((rx = +rx) >= 0)) throw new RangeError("invalid rx");
            if (!((ry = +ry) >= 0)) throw new RangeError("invalid ry");
            let { data: values, width: width, height: height } = data;
            if (!((width = Math.floor(width)) >= 0)) throw new RangeError("invalid width");
            if (!((height = Math.floor(height !== undefined ? height : values.length / width)) >= 0)) throw new RangeError("invalid height");
            if (!width || !height || !rx && !ry) return data;
            const blurx = rx && blur(rx);
            const blury = ry && blur(ry);
            const temp = values.slice();
            if (blurx && blury) {
                blurh(blurx, temp, values, width, height);
                blurh(blurx, values, temp, width, height);
                blurh(blurx, temp, values, width, height);
                blurv(blury, values, temp, width, height);
                blurv(blury, temp, values, width, height);
                blurv(blury, values, temp, width, height);
            } else if (blurx) {
                blurh(blurx, values, temp, width, height);
                blurh(blurx, temp, values, width, height);
                blurh(blurx, values, temp, width, height);
            } else if (blury) {
                blurv(blury, values, temp, width, height);
                blurv(blury, temp, values, width, height);
                blurv(blury, values, temp, width, height);
            }
            return data;
        };
    }
    function blurh(blur, T, S, w, h) {
        for(let y = 0, n = w * h; y < n;)blur(T, S, y, y += w, 1);
    }
    function blurv(blur, T, S, w, h) {
        for(let x = 0, n = w * h; x < w; ++x)blur(T, S, x, x + n, w);
    }
    function blurfImage(radius) {
        const blur = blurf(radius);
        return (T, S, start, stop, step)=>{
            start <<= 2, stop <<= 2, step <<= 2;
            blur(T, S, start + 0, stop + 0, step);
            blur(T, S, start + 1, stop + 1, step);
            blur(T, S, start + 2, stop + 2, step);
            blur(T, S, start + 3, stop + 3, step);
        };
    }
    // Given a target array T, a source array S, sets each value T[i] to the average
    // of {S[i - r], …, S[i], …, S[i + r]}, where r = ⌊radius⌋, start <= i < stop,
    // for each i, i + step, i + 2 * step, etc., and where S[j] is clamped between
    // S[start] (inclusive) and S[stop] (exclusive). If the given radius is not an
    // integer, S[i - r - 1] and S[i + r + 1] are added to the sum, each weighted
    // according to r - ⌊radius⌋.
    function blurf(radius) {
        const radius0 = Math.floor(radius);
        if (radius0 === radius) return bluri(radius);
        const t = radius - radius0;
        const w = 2 * radius + 1;
        return (T, S, start, stop, step)=>{
            if (!((stop -= step) >= start)) return; // inclusive stop
            let sum = radius0 * S[start];
            const s0 = step * radius0;
            const s1 = s0 + step;
            for(let i = start, j = start + s0; i < j; i += step)sum += S[Math.min(stop, i)];
            for(let i = start, j = stop; i <= j; i += step){
                sum += S[Math.min(stop, i + s0)];
                T[i] = (sum + t * (S[Math.max(start, i - s1)] + S[Math.min(stop, i + s1)])) / w;
                sum -= S[Math.max(start, i - s0)];
            }
        };
    }
    // Like blurf, but optimized for integer radius.
    function bluri(radius) {
        const w = 2 * radius + 1;
        return (T, S, start, stop, step)=>{
            if (!((stop -= step) >= start)) return; // inclusive stop
            let sum = radius * S[start];
            const s = step * radius;
            for(let i = start, j = start + s; i < j; i += step)sum += S[Math.min(stop, i)];
            for(let i = start, j = stop; i <= j; i += step){
                sum += S[Math.min(stop, i + s)];
                T[i] = sum / w;
                sum -= S[Math.max(start, i - s)];
            }
        };
    }
    function count$1(values, valueof) {
        let count = 0;
        if (valueof === undefined) {
            for (let value of values)if (value != null && (value = +value) >= value) ++count;
        } else {
            let index = -1;
            for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
        }
        return count;
    }
    function length$3(array) {
        return array.length | 0;
    }
    function empty$2(length) {
        return !(length > 0);
    }
    function arrayify(values) {
        return typeof values !== "object" || "length" in values ? values : Array.from(values);
    }
    function reducer(reduce) {
        return (values)=>reduce(...values);
    }
    function cross$2(...values) {
        const reduce = typeof values[values.length - 1] === "function" && reducer(values.pop());
        values = values.map(arrayify);
        const lengths = values.map(length$3);
        const j = values.length - 1;
        const index = new Array(j + 1).fill(0);
        const product = [];
        if (j < 0 || lengths.some(empty$2)) return product;
        while(true){
            product.push(index.map((j, i)=>values[i][j]));
            let i = j;
            while(++index[i] === lengths[i]){
                if (i === 0) return reduce ? product.map(reduce) : product;
                index[i--] = 0;
            }
        }
    }
    function cumsum(values, valueof) {
        var sum = 0, index = 0;
        return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
    }
    function variance(values, valueof) {
        let count = 0;
        let delta;
        let mean = 0;
        let sum = 0;
        if (valueof === undefined) {
            for (let value of values)if (value != null && (value = +value) >= value) {
                delta = value - mean;
                mean += delta / ++count;
                sum += delta * (value - mean);
            }
        } else {
            let index = -1;
            for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
                delta = value - mean;
                mean += delta / ++count;
                sum += delta * (value - mean);
            }
        }
        if (count > 1) return sum / (count - 1);
    }
    function deviation(values, valueof) {
        const v = variance(values, valueof);
        return v ? Math.sqrt(v) : v;
    }
    function extent$1(values, valueof) {
        let min;
        let max;
        if (valueof === undefined) {
            for (const value of values)if (value != null) {
                if (min === undefined) {
                    if (value >= value) min = max = value;
                } else {
                    if (min > value) min = value;
                    if (max < value) max = value;
                }
            }
        } else {
            let index = -1;
            for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
                if (min === undefined) {
                    if (value >= value) min = max = value;
                } else {
                    if (min > value) min = value;
                    if (max < value) max = value;
                }
            }
        }
        return [
            min,
            max
        ];
    }
    // https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
    class Adder {
        constructor(){
            this._partials = new Float64Array(32);
            this._n = 0;
        }
        add(x) {
            const p = this._partials;
            let i = 0;
            for(let j = 0; j < this._n && j < 32; j++){
                const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
                if (lo) p[i++] = lo;
                x = hi;
            }
            p[i] = x;
            this._n = i + 1;
            return this;
        }
        valueOf() {
            const p = this._partials;
            let n = this._n, x, y, lo, hi = 0;
            if (n > 0) {
                hi = p[--n];
                while(n > 0){
                    x = hi;
                    y = p[--n];
                    hi = x + y;
                    lo = y - (hi - x);
                    if (lo) break;
                }
                if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                    y = lo * 2;
                    x = hi + y;
                    if (y == x - hi) hi = x;
                }
            }
            return hi;
        }
    }
    function fsum(values, valueof) {
        const adder = new Adder();
        if (valueof === undefined) {
            for (let value of values)if (value = +value) adder.add(value);
        } else {
            let index = -1;
            for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
        }
        return +adder;
    }
    function fcumsum(values, valueof) {
        const adder = new Adder();
        let index = -1;
        return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
    }
    class InternMap extends Map {
        constructor(entries, key = keyof){
            super();
            Object.defineProperties(this, {
                _intern: {
                    value: new Map()
                },
                _key: {
                    value: key
                }
            });
            if (entries != null) for (const [key, value] of entries)this.set(key, value);
        }
        get(key) {
            return super.get(intern_get(this, key));
        }
        has(key) {
            return super.has(intern_get(this, key));
        }
        set(key, value) {
            return super.set(intern_set(this, key), value);
        }
        delete(key) {
            return super.delete(intern_delete(this, key));
        }
    }
    class InternSet extends Set {
        constructor(values, key = keyof){
            super();
            Object.defineProperties(this, {
                _intern: {
                    value: new Map()
                },
                _key: {
                    value: key
                }
            });
            if (values != null) for (const value of values)this.add(value);
        }
        has(value) {
            return super.has(intern_get(this, value));
        }
        add(value) {
            return super.add(intern_set(this, value));
        }
        delete(value) {
            return super.delete(intern_delete(this, value));
        }
    }
    function intern_get({ _intern: _intern, _key: _key }, value) {
        const key = _key(value);
        return _intern.has(key) ? _intern.get(key) : value;
    }
    function intern_set({ _intern: _intern, _key: _key }, value) {
        const key = _key(value);
        if (_intern.has(key)) return _intern.get(key);
        _intern.set(key, value);
        return value;
    }
    function intern_delete({ _intern: _intern, _key: _key }, value) {
        const key = _key(value);
        if (_intern.has(key)) {
            value = _intern.get(key);
            _intern.delete(key);
        }
        return value;
    }
    function keyof(value) {
        return value !== null && typeof value === "object" ? value.valueOf() : value;
    }
    function identity$9(x) {
        return x;
    }
    function group(values, ...keys) {
        return nest(values, identity$9, identity$9, keys);
    }
    function groups(values, ...keys) {
        return nest(values, Array.from, identity$9, keys);
    }
    function flatten$1(groups, keys) {
        for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                    ...g,
                    key,
                    value
                ]));
        return groups;
    }
    function flatGroup(values, ...keys) {
        return flatten$1(groups(values, ...keys), keys);
    }
    function flatRollup(values, reduce, ...keys) {
        return flatten$1(rollups(values, reduce, ...keys), keys);
    }
    function rollup(values, reduce, ...keys) {
        return nest(values, identity$9, reduce, keys);
    }
    function rollups(values, reduce, ...keys) {
        return nest(values, Array.from, reduce, keys);
    }
    function index$4(values, ...keys) {
        return nest(values, identity$9, unique, keys);
    }
    function indexes(values, ...keys) {
        return nest(values, Array.from, unique, keys);
    }
    function unique(values) {
        if (values.length !== 1) throw new Error("duplicate key");
        return values[0];
    }
    function nest(values, map, reduce, keys) {
        return function regroup(values, i) {
            if (i >= keys.length) return reduce(values);
            const groups = new InternMap();
            const keyof = keys[i++];
            let index = -1;
            for (const value of values){
                const key = keyof(value, ++index, values);
                const group = groups.get(key);
                if (group) group.push(value);
                else groups.set(key, [
                    value
                ]);
            }
            for (const [key, values] of groups)groups.set(key, regroup(values, i));
            return map(groups);
        }(values, 0);
    }
    function permute(source, keys) {
        return Array.from(keys, (key)=>source[key]);
    }
    function sort(values, ...F) {
        if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
        values = Array.from(values);
        let [f] = F;
        if (f && f.length !== 2 || F.length > 1) {
            const index = Uint32Array.from(values, (d, i)=>i);
            if (F.length > 1) {
                F = F.map((f)=>values.map(f));
                index.sort((i, j)=>{
                    for (const f of F){
                        const c = ascendingDefined(f[i], f[j]);
                        if (c) return c;
                    }
                });
            } else {
                f = values.map(f);
                index.sort((i, j)=>ascendingDefined(f[i], f[j]));
            }
            return permute(values, index);
        }
        return values.sort(compareDefined(f));
    }
    function compareDefined(compare = ascending$3) {
        if (compare === ascending$3) return ascendingDefined;
        if (typeof compare !== "function") throw new TypeError("compare is not a function");
        return (a, b)=>{
            const x = compare(a, b);
            if (x || x === 0) return x;
            return (compare(b, b) === 0) - (compare(a, a) === 0);
        };
    }
    function ascendingDefined(a, b) {
        return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
    }
    function groupSort(values, reduce, key) {
        return (reduce.length !== 2 ? sort(rollup(values, reduce, key), ([ak, av], [bk, bv])=>ascending$3(av, bv) || ascending$3(ak, bk)) : sort(group(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || ascending$3(ak, bk))).map(([key])=>key);
    }
    var array$5 = Array.prototype;
    var slice$3 = array$5.slice;
    function constant$b(x) {
        return ()=>x;
    }
    var e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
    function ticks(start, stop, count) {
        var reverse, i = -1, n, ticks, step;
        stop = +stop, start = +start, count = +count;
        if (start === stop && count > 0) return [
            start
        ];
        if (reverse = stop < start) n = start, start = stop, stop = n;
        if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
        if (step > 0) {
            let r0 = Math.round(start / step), r1 = Math.round(stop / step);
            if (r0 * step < start) ++r0;
            if (r1 * step > stop) --r1;
            ticks = new Array(n = r1 - r0 + 1);
            while(++i < n)ticks[i] = (r0 + i) * step;
        } else {
            step = -step;
            let r0 = Math.round(start * step), r1 = Math.round(stop * step);
            if (r0 / step < start) ++r0;
            if (r1 / step > stop) --r1;
            ticks = new Array(n = r1 - r0 + 1);
            while(++i < n)ticks[i] = (r0 + i) / step;
        }
        if (reverse) ticks.reverse();
        return ticks;
    }
    function tickIncrement(start, stop, count) {
        var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
        return power >= 0 ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
    }
    function tickStep(start, stop, count) {
        var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
        if (error >= e10) step1 *= 10;
        else if (error >= e5) step1 *= 5;
        else if (error >= e2) step1 *= 2;
        return stop < start ? -step1 : step1;
    }
    function nice$1(start, stop, count) {
        let prestep;
        while(true){
            const step = tickIncrement(start, stop, count);
            if (step === prestep || step === 0 || !isFinite(step)) return [
                start,
                stop
            ];
            else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            }
            prestep = step;
        }
    }
    function thresholdSturges(values) {
        return Math.ceil(Math.log(count$1(values)) / Math.LN2) + 1;
    }
    function bin() {
        var value = identity$9, domain = extent$1, threshold = thresholdSturges;
        function histogram(data) {
            if (!Array.isArray(data)) data = Array.from(data);
            var i, n = data.length, x, step, values = new Array(n);
            for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
            var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
            // Convert number of thresholds into uniform thresholds, and nice the
            // default domain accordingly.
            if (!Array.isArray(tz)) {
                const max = x1, tn = +tz;
                if (domain === extent$1) [x0, x1] = nice$1(x0, x1, tn);
                tz = ticks(x0, x1, tn);
                // If the domain is aligned with the first tick (which it will by
                // default), then we can use quantization rather than bisection to bin
                // values, which is substantially faster.
                if (tz[0] <= x0) step = tickIncrement(x0, x1, tn);
                // If the last threshold is coincident with the domain’s upper bound, the
                // last bin will be zero-width. If the default domain is used, and this
                // last threshold is coincident with the maximum input value, we can
                // extend the niced upper bound by one tick to ensure uniform bin widths;
                // otherwise, we simply remove the last threshold. Note that we don’t
                // coerce values or the domain to numbers, and thus must be careful to
                // compare order (>=) rather than strict equality (===)!
                if (tz[tz.length - 1] >= x1) {
                    if (max >= x1 && domain === extent$1) {
                        const step = tickIncrement(x0, x1, tn);
                        if (isFinite(step)) {
                            if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                            else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                        }
                    } else tz.pop();
                }
            }
            // Remove any thresholds outside the domain.
            // Be careful not to mutate an array owned by the user!
            var m = tz.length, a = 0, b = m;
            while(tz[a] <= x0)++a;
            while(tz[b - 1] > x1)--b;
            if (a || b < m) tz = tz.slice(a, b), m = b - a;
            var bins = new Array(m + 1), bin;
            // Initialize bins.
            for(i = 0; i <= m; ++i){
                bin = bins[i] = [];
                bin.x0 = i > 0 ? tz[i - 1] : x0;
                bin.x1 = i < m ? tz[i] : x1;
            }
            // Assign data to bins by value, ignoring any outside the domain.
            if (isFinite(step)) {
                if (step > 0) {
                    for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
                } else if (step < 0) {
                    for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                        const j = Math.floor((x0 - x) * step);
                        bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                    }
                }
            } else {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[bisect(tz, x, 0, m)].push(data[i]);
            }
            return bins;
        }
        histogram.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : constant$b(_), histogram) : value;
        };
        histogram.domain = function(_) {
            return arguments.length ? (domain = typeof _ === "function" ? _ : constant$b([
                _[0],
                _[1]
            ]), histogram) : domain;
        };
        histogram.thresholds = function(_) {
            return arguments.length ? (threshold = typeof _ === "function" ? _ : constant$b(Array.isArray(_) ? slice$3.call(_) : _), histogram) : threshold;
        };
        return histogram;
    }
    function max$3(values, valueof) {
        let max;
        if (valueof === undefined) {
            for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
        } else {
            let index = -1;
            for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
        }
        return max;
    }
    function maxIndex(values, valueof) {
        let max;
        let maxIndex = -1;
        let index = -1;
        if (valueof === undefined) for (const value of values){
            ++index;
            if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
        }
        else {
            for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
        }
        return maxIndex;
    }
    function min$2(values, valueof) {
        let min;
        if (valueof === undefined) {
            for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
        } else {
            let index = -1;
            for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
        }
        return min;
    }
    function minIndex(values, valueof) {
        let min;
        let minIndex = -1;
        let index = -1;
        if (valueof === undefined) for (const value of values){
            ++index;
            if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
        }
        else {
            for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
        }
        return minIndex;
    }
    // Based on https://github.com/mourner/quickselect
    // ISC license, Copyright 2018 Vladimir Agafonkin.
    function quickselect(array, k, left = 0, right = Infinity, compare) {
        k = Math.floor(k);
        left = Math.floor(Math.max(0, left));
        right = Math.floor(Math.min(array.length - 1, right));
        if (!(left <= k && k <= right)) return array;
        compare = compare === undefined ? ascendingDefined : compareDefined(compare);
        while(right > left){
            if (right - left > 600) {
                const n = right - left + 1;
                const m = k - left + 1;
                const z = Math.log(n);
                const s = 0.5 * Math.exp(2 * z / 3);
                const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
                const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
                const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
                quickselect(array, k, newLeft, newRight, compare);
            }
            const t = array[k];
            let i = left;
            let j = right;
            swap$1(array, left, k);
            if (compare(array[right], t) > 0) swap$1(array, left, right);
            while(i < j){
                swap$1(array, i, j), ++i, --j;
                while(compare(array[i], t) < 0)++i;
                while(compare(array[j], t) > 0)--j;
            }
            if (compare(array[left], t) === 0) swap$1(array, left, j);
            else ++j, swap$1(array, j, right);
            if (j <= k) left = j + 1;
            if (k <= j) right = j - 1;
        }
        return array;
    }
    function swap$1(array, i, j) {
        const t = array[i];
        array[i] = array[j];
        array[j] = t;
    }
    function greatest(values, compare = ascending$3) {
        let max;
        let defined = false;
        if (compare.length === 1) {
            let maxValue;
            for (const element of values){
                const value = compare(element);
                if (defined ? ascending$3(value, maxValue) > 0 : ascending$3(value, value) === 0) {
                    max = element;
                    maxValue = value;
                    defined = true;
                }
            }
        } else {
            for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
                max = value;
                defined = true;
            }
        }
        return max;
    }
    function quantile$1(values, p, valueof) {
        values = Float64Array.from(numbers(values, valueof));
        if (!(n = values.length) || isNaN(p = +p)) return;
        if (p <= 0 || n < 2) return min$2(values);
        if (p >= 1) return max$3(values);
        var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = max$3(quickselect(values, i0).subarray(0, i0 + 1)), value1 = min$2(values.subarray(i0 + 1));
        return value0 + (value1 - value0) * (i - i0);
    }
    function quantileSorted(values, p, valueof = number$3) {
        if (!(n = values.length) || isNaN(p = +p)) return;
        if (p <= 0 || n < 2) return +valueof(values[0], 0, values);
        if (p >= 1) return +valueof(values[n - 1], n - 1, values);
        var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
        return value0 + (value1 - value0) * (i - i0);
    }
    function quantileIndex(values, p, valueof) {
        values = Float64Array.from(numbers(values, valueof));
        if (!(n = values.length) || isNaN(p = +p)) return;
        if (p <= 0 || n < 2) return minIndex(values);
        if (p >= 1) return maxIndex(values);
        var n, i = Math.floor((n - 1) * p), order = (i, j)=>ascendingDefined(values[i], values[j]), index = quickselect(Uint32Array.from(values, (_, i)=>i), i, 0, n - 1, order);
        return greatest(index.subarray(0, i + 1), (i)=>values[i]);
    }
    function thresholdFreedmanDiaconis(values, min, max) {
        return Math.ceil((max - min) / (2 * (quantile$1(values, 0.75) - quantile$1(values, 0.25)) * Math.pow(count$1(values), -1 / 3)));
    }
    function thresholdScott(values, min, max) {
        return Math.ceil((max - min) * Math.cbrt(count$1(values)) / (3.49 * deviation(values)));
    }
    function mean(values, valueof) {
        let count = 0;
        let sum = 0;
        if (valueof === undefined) {
            for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
        } else {
            let index = -1;
            for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
        }
        if (count) return sum / count;
    }
    function median(values, valueof) {
        return quantile$1(values, 0.5, valueof);
    }
    function medianIndex(values, valueof) {
        return quantileIndex(values, 0.5, valueof);
    }
    function* flatten(arrays) {
        for (const array of arrays)yield* array;
    }
    function merge(arrays) {
        return Array.from(flatten(arrays));
    }
    function mode(values, valueof) {
        const counts = new InternMap();
        if (valueof === undefined) {
            for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
        } else {
            let index = -1;
            for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
        }
        let modeValue;
        let modeCount = 0;
        for (const [value, count] of counts)if (count > modeCount) {
            modeCount = count;
            modeValue = value;
        }
        return modeValue;
    }
    function pairs(values, pairof = pair) {
        const pairs1 = [];
        let previous;
        let first = false;
        for (const value of values){
            if (first) pairs1.push(pairof(previous, value));
            previous = value;
            first = true;
        }
        return pairs1;
    }
    function pair(a, b) {
        return [
            a,
            b
        ];
    }
    function range$2(start, stop, step) {
        start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
        var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
        while(++i < n)range[i] = start + i * step;
        return range;
    }
    function rank(values, valueof = ascending$3) {
        if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
        let V = Array.from(values);
        const R = new Float64Array(V.length);
        if (valueof.length !== 2) V = V.map(valueof), valueof = ascending$3;
        const compareIndex = (i, j)=>valueof(V[i], V[j]);
        let k, r;
        Uint32Array.from(V, (_, i)=>i).sort(valueof === ascending$3 ? (i, j)=>ascendingDefined(V[i], V[j]) : compareDefined(compareIndex)).forEach((j, i)=>{
            const c = compareIndex(j, k === undefined ? j : k);
            if (c >= 0) {
                if (k === undefined || c > 0) k = j, r = i;
                R[j] = r;
            } else R[j] = NaN;
        });
        return R;
    }
    function least(values, compare = ascending$3) {
        let min;
        let defined = false;
        if (compare.length === 1) {
            let minValue;
            for (const element of values){
                const value = compare(element);
                if (defined ? ascending$3(value, minValue) < 0 : ascending$3(value, value) === 0) {
                    min = element;
                    minValue = value;
                    defined = true;
                }
            }
        } else {
            for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
                min = value;
                defined = true;
            }
        }
        return min;
    }
    function leastIndex(values, compare = ascending$3) {
        if (compare.length === 1) return minIndex(values, compare);
        let minValue;
        let min = -1;
        let index = -1;
        for (const value of values){
            ++index;
            if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
                minValue = value;
                min = index;
            }
        }
        return min;
    }
    function greatestIndex(values, compare = ascending$3) {
        if (compare.length === 1) return maxIndex(values, compare);
        let maxValue;
        let max = -1;
        let index = -1;
        for (const value of values){
            ++index;
            if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
                maxValue = value;
                max = index;
            }
        }
        return max;
    }
    function scan(values, compare) {
        const index = leastIndex(values, compare);
        return index < 0 ? undefined : index;
    }
    var shuffle$1 = shuffler(Math.random);
    function shuffler(random) {
        return function shuffle(array, i0 = 0, i1 = array.length) {
            let m = i1 - (i0 = +i0);
            while(m){
                const i = random() * m-- | 0, t = array[m + i0];
                array[m + i0] = array[i + i0];
                array[i + i0] = t;
            }
            return array;
        };
    }
    function sum$2(values, valueof) {
        let sum = 0;
        if (valueof === undefined) {
            for (let value of values)if (value = +value) sum += value;
        } else {
            let index = -1;
            for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
        }
        return sum;
    }
    function transpose(matrix) {
        if (!(n = matrix.length)) return [];
        for(var i = -1, m = min$2(matrix, length$2), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
        return transpose;
    }
    function length$2(d) {
        return d.length;
    }
    function zip() {
        return transpose(arguments);
    }
    function every(values, test) {
        if (typeof test !== "function") throw new TypeError("test is not a function");
        let index = -1;
        for (const value of values){
            if (!test(value, ++index, values)) return false;
        }
        return true;
    }
    function some(values, test) {
        if (typeof test !== "function") throw new TypeError("test is not a function");
        let index = -1;
        for (const value of values){
            if (test(value, ++index, values)) return true;
        }
        return false;
    }
    function filter$1(values, test) {
        if (typeof test !== "function") throw new TypeError("test is not a function");
        const array = [];
        let index = -1;
        for (const value of values)if (test(value, ++index, values)) array.push(value);
        return array;
    }
    function map$1(values, mapper) {
        if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
        if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
        return Array.from(values, (value, index)=>mapper(value, index, values));
    }
    function reduce(values, reducer, value) {
        if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
        const iterator = values[Symbol.iterator]();
        let done, next, index = -1;
        if (arguments.length < 3) {
            ({ done: done, value: value } = iterator.next());
            if (done) return;
            ++index;
        }
        while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
        return value;
    }
    function reverse$1(values) {
        if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
        return Array.from(values).reverse();
    }
    function difference(values, ...others) {
        values = new InternSet(values);
        for (const other of others)for (const value of other)values.delete(value);
        return values;
    }
    function disjoint(values, other) {
        const iterator = other[Symbol.iterator](), set = new InternSet();
        for (const v of values){
            if (set.has(v)) return false;
            let value, done;
            while({ value: value, done: done } = iterator.next()){
                if (done) break;
                if (Object.is(v, value)) return false;
                set.add(value);
            }
        }
        return true;
    }
    function intersection(values, ...others) {
        values = new InternSet(values);
        others = others.map(set$2);
        out: for (const value of values){
            for (const other of others)if (!other.has(value)) {
                values.delete(value);
                continue out;
            }
        }
        return values;
    }
    function set$2(values) {
        return values instanceof InternSet ? values : new InternSet(values);
    }
    function superset(values, other) {
        const iterator = values[Symbol.iterator](), set = new Set();
        for (const o of other){
            const io = intern(o);
            if (set.has(io)) continue;
            let value, done;
            while({ value: value, done: done } = iterator.next()){
                if (done) return false;
                const ivalue = intern(value);
                set.add(ivalue);
                if (Object.is(io, ivalue)) break;
            }
        }
        return true;
    }
    function intern(value) {
        return value !== null && typeof value === "object" ? value.valueOf() : value;
    }
    function subset(values, other) {
        return superset(other, values);
    }
    function union(...others) {
        const set = new InternSet();
        for (const other of others)for (const o of other)set.add(o);
        return set;
    }
    function identity$8(x) {
        return x;
    }
    var top = 1, right = 2, bottom = 3, left = 4, epsilon$6 = 1e-6;
    function translateX(x) {
        return "translate(" + x + ",0)";
    }
    function translateY(y) {
        return "translate(0," + y + ")";
    }
    function number$2(scale) {
        return (d)=>+scale(d);
    }
    function center$1(scale, offset) {
        offset = Math.max(0, scale.bandwidth() - offset * 2) / 2;
        if (scale.round()) offset = Math.round(offset);
        return (d)=>+scale(d) + offset;
    }
    function entering() {
        return !this.__axis;
    }
    function axis(orient, scale) {
        var tickArguments = [], tickValues = null, tickFormat = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, offset = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5, k = orient === top || orient === left ? -1 : 1, x = orient === left || orient === right ? "x" : "y", transform = orient === top || orient === bottom ? translateX : translateY;
        function axis(context) {
            var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format = tickFormat == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity$8 : tickFormat, spacing = Math.max(tickSizeInner, 0) + tickPadding, range = scale.range(), range0 = +range[0] + offset, range1 = +range[range.length - 1] + offset, position = (scale.bandwidth ? center$1 : number$2)(scale.copy(), offset), selection = context.selection ? context.selection() : context, path = selection.selectAll(".domain").data([
                null
            ]), tick = selection.selectAll(".tick").data(values, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line = tick.select("line"), text = tick.select("text");
            path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
            tick = tick.merge(tickEnter);
            line = line.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x + "2", k * tickSizeInner));
            text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x, k * spacing).attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));
            if (context !== selection) {
                path = path.transition(context);
                tick = tick.transition(context);
                line = line.transition(context);
                text = text.transition(context);
                tickExit = tickExit.transition(context).attr("opacity", epsilon$6).attr("transform", function(d) {
                    return isFinite(d = position(d)) ? transform(d + offset) : this.getAttribute("transform");
                });
                tickEnter.attr("opacity", epsilon$6).attr("transform", function(d) {
                    var p = this.parentNode.__axis;
                    return transform((p && isFinite(p = p(d)) ? p : position(d)) + offset);
                });
            }
            tickExit.remove();
            path.attr("d", orient === left || orient === right ? tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H" + offset + "V" + range1 + "H" + k * tickSizeOuter : "M" + offset + "," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V" + offset + "H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + "," + offset + "H" + range1);
            tick.attr("opacity", 1).attr("transform", function(d) {
                return transform(position(d) + offset);
            });
            line.attr(x + "2", k * tickSizeInner);
            text.attr(x, k * spacing).text(format);
            selection.filter(entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");
            selection.each(function() {
                this.__axis = position;
            });
        }
        axis.scale = function(_) {
            return arguments.length ? (scale = _, axis) : scale;
        };
        axis.ticks = function() {
            return tickArguments = Array.from(arguments), axis;
        };
        axis.tickArguments = function(_) {
            return arguments.length ? (tickArguments = _ == null ? [] : Array.from(_), axis) : tickArguments.slice();
        };
        axis.tickValues = function(_) {
            return arguments.length ? (tickValues = _ == null ? null : Array.from(_), axis) : tickValues && tickValues.slice();
        };
        axis.tickFormat = function(_) {
            return arguments.length ? (tickFormat = _, axis) : tickFormat;
        };
        axis.tickSize = function(_) {
            return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
        };
        axis.tickSizeInner = function(_) {
            return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
        };
        axis.tickSizeOuter = function(_) {
            return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
        };
        axis.tickPadding = function(_) {
            return arguments.length ? (tickPadding = +_, axis) : tickPadding;
        };
        axis.offset = function(_) {
            return arguments.length ? (offset = +_, axis) : offset;
        };
        return axis;
    }
    function axisTop(scale) {
        return axis(top, scale);
    }
    function axisRight(scale) {
        return axis(right, scale);
    }
    function axisBottom(scale) {
        return axis(bottom, scale);
    }
    function axisLeft(scale) {
        return axis(left, scale);
    }
    var noop$3 = {
        value: ()=>{}
    };
    function dispatch() {
        for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
            if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
            _[t] = [];
        }
        return new Dispatch(_);
    }
    function Dispatch(_) {
        this._ = _;
    }
    function parseTypenames$1(typenames, types) {
        return typenames.trim().split(/^|\s+/).map(function(t) {
            var name = "", i = t.indexOf(".");
            if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
            if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
            return {
                type: t,
                name: name
            };
        });
    }
    Dispatch.prototype = dispatch.prototype = {
        constructor: Dispatch,
        on: function(typename, callback) {
            var _ = this._, T = parseTypenames$1(typename + "", _), t, i = -1, n = T.length;
            // If no callback was specified, return the callback of the given type and name.
            if (arguments.length < 2) {
                while(++i < n)if ((t = (typename = T[i]).type) && (t = get$1(_[t], typename.name))) return t;
                return;
            }
            // If a type was specified, set the callback for the given type and name.
            // Otherwise, if a null callback was specified, remove callbacks of the given name.
            if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
            while(++i < n){
                if (t = (typename = T[i]).type) _[t] = set$1(_[t], typename.name, callback);
                else if (callback == null) for(t in _)_[t] = set$1(_[t], typename.name, null);
            }
            return this;
        },
        copy: function() {
            var copy = {}, _ = this._;
            for(var t in _)copy[t] = _[t].slice();
            return new Dispatch(copy);
        },
        call: function(type, that) {
            if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
            if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
            for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
        },
        apply: function(type, that, args) {
            if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
            for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
        }
    };
    function get$1(type, name) {
        for(var i = 0, n = type.length, c; i < n; ++i){
            if ((c = type[i]).name === name) return c.value;
        }
    }
    function set$1(type, name, callback) {
        for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
            type[i] = noop$3, type = type.slice(0, i).concat(type.slice(i + 1));
            break;
        }
        if (callback != null) type.push({
            name: name,
            value: callback
        });
        return type;
    }
    var xhtml = "http://www.w3.org/1999/xhtml";
    var namespaces = {
        svg: "http://www.w3.org/2000/svg",
        xhtml: xhtml,
        xlink: "http://www.w3.org/1999/xlink",
        xml: "http://www.w3.org/XML/1998/namespace",
        xmlns: "http://www.w3.org/2000/xmlns/"
    };
    function namespace(name) {
        var prefix = name += "", i = prefix.indexOf(":");
        if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
        return namespaces.hasOwnProperty(prefix) ? {
            space: namespaces[prefix],
            local: name
        } : name; // eslint-disable-line no-prototype-builtins
    }
    function creatorInherit(name) {
        return function() {
            var document1 = this.ownerDocument, uri = this.namespaceURI;
            return uri === xhtml && document1.documentElement.namespaceURI === xhtml ? document1.createElement(name) : document1.createElementNS(uri, name);
        };
    }
    function creatorFixed(fullname) {
        return function() {
            return this.ownerDocument.createElementNS(fullname.space, fullname.local);
        };
    }
    function creator(name) {
        var fullname = namespace(name);
        return (fullname.local ? creatorFixed : creatorInherit)(fullname);
    }
    function none$2() {}
    function selector(selector) {
        return selector == null ? none$2 : function() {
            return this.querySelector(selector);
        };
    }
    function selection_select(select) {
        if (typeof select !== "function") select = selector(select);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
                if ("__data__" in node) subnode.__data__ = node.__data__;
                subgroup[i] = subnode;
            }
        }
        return new Selection$1(subgroups, this._parents);
    }
    // Given something array like (or null), returns something that is strictly an
    // array. This is used to ensure that array-like objects passed to d3.selectAll
    // or selection.selectAll are converted into proper arrays when creating a
    // selection; we don’t ever want to create a selection backed by a live
    // HTMLCollection or NodeList. However, note that selection.selectAll will use a
    // static NodeList as a group, since it safely derived from querySelectorAll.
    function array$4(x) {
        return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
    }
    function empty$1() {
        return [];
    }
    function selectorAll(selector) {
        return selector == null ? empty$1 : function() {
            return this.querySelectorAll(selector);
        };
    }
    function arrayAll(select) {
        return function() {
            return array$4(select.apply(this, arguments));
        };
    }
    function selection_selectAll(select) {
        if (typeof select === "function") select = arrayAll(select);
        else select = selectorAll(select);
        for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                subgroups.push(select.call(node, node.__data__, i, group));
                parents.push(node);
            }
        }
        return new Selection$1(subgroups, parents);
    }
    function matcher(selector) {
        return function() {
            return this.matches(selector);
        };
    }
    function childMatcher(selector) {
        return function(node) {
            return node.matches(selector);
        };
    }
    var find$1 = Array.prototype.find;
    function childFind(match) {
        return function() {
            return find$1.call(this.children, match);
        };
    }
    function childFirst() {
        return this.firstElementChild;
    }
    function selection_selectChild(match) {
        return this.select(match == null ? childFirst : childFind(typeof match === "function" ? match : childMatcher(match)));
    }
    var filter = Array.prototype.filter;
    function children() {
        return Array.from(this.children);
    }
    function childrenFilter(match) {
        return function() {
            return filter.call(this.children, match);
        };
    }
    function selection_selectChildren(match) {
        return this.selectAll(match == null ? children : childrenFilter(typeof match === "function" ? match : childMatcher(match)));
    }
    function selection_filter(match) {
        if (typeof match !== "function") match = matcher(match);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
        }
        return new Selection$1(subgroups, this._parents);
    }
    function sparse(update) {
        return new Array(update.length);
    }
    function selection_enter() {
        return new Selection$1(this._enter || this._groups.map(sparse), this._parents);
    }
    function EnterNode(parent, datum) {
        this.ownerDocument = parent.ownerDocument;
        this.namespaceURI = parent.namespaceURI;
        this._next = null;
        this._parent = parent;
        this.__data__ = datum;
    }
    EnterNode.prototype = {
        constructor: EnterNode,
        appendChild: function(child) {
            return this._parent.insertBefore(child, this._next);
        },
        insertBefore: function(child, next) {
            return this._parent.insertBefore(child, next);
        },
        querySelector: function(selector) {
            return this._parent.querySelector(selector);
        },
        querySelectorAll: function(selector) {
            return this._parent.querySelectorAll(selector);
        }
    };
    function constant$a(x) {
        return function() {
            return x;
        };
    }
    function bindIndex(parent, group, enter, update, exit, data) {
        var i = 0, node, groupLength = group.length, dataLength = data.length;
        // Put any non-null nodes that fit into update.
        // Put any null nodes into enter.
        // Put any remaining data into enter.
        for(; i < dataLength; ++i)if (node = group[i]) {
            node.__data__ = data[i];
            update[i] = node;
        } else enter[i] = new EnterNode(parent, data[i]);
        // Put any non-null nodes that don’t fit into exit.
        for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
    }
    function bindKey(parent, group, enter, update, exit, data, key) {
        var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
        // Compute the key for each node.
        // If multiple nodes have the same key, the duplicates are added to exit.
        for(i = 0; i < groupLength; ++i)if (node = group[i]) {
            keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
            if (nodeByKeyValue.has(keyValue)) exit[i] = node;
            else nodeByKeyValue.set(keyValue, node);
        }
        // Compute the key for each datum.
        // If there a node associated with this key, join and add it to update.
        // If there is not (or the key is a duplicate), add it to enter.
        for(i = 0; i < dataLength; ++i){
            keyValue = key.call(parent, data[i], i, data) + "";
            if (node = nodeByKeyValue.get(keyValue)) {
                update[i] = node;
                node.__data__ = data[i];
                nodeByKeyValue.delete(keyValue);
            } else enter[i] = new EnterNode(parent, data[i]);
        }
        // Add any remaining nodes that were not bound to data to exit.
        for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
    }
    function datum(node) {
        return node.__data__;
    }
    function selection_data(value, key) {
        if (!arguments.length) return Array.from(this, datum);
        var bind = key ? bindKey : bindIndex, parents = this._parents, groups = this._groups;
        if (typeof value !== "function") value = constant$a(value);
        for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
            var parent = parents[j], group = groups[j], groupLength = group.length, data = arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
            bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
            // Now connect the enter nodes to their following update node, such that
            // appendChild can insert the materialized enter node before this node,
            // rather than at the end of the parent node.
            for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
                if (i0 >= i1) i1 = i0 + 1;
                while(!(next = updateGroup[i1]) && ++i1 < dataLength);
                previous._next = next || null;
            }
        }
        update = new Selection$1(update, parents);
        update._enter = enter;
        update._exit = exit;
        return update;
    }
    // Given some data, this returns an array-like view of it: an object that
    // exposes a length property and allows numeric indexing. Note that unlike
    // selectAll, this isn’t worried about “live” collections because the resulting
    // array will only be used briefly while data is being bound. (It is possible to
    // cause the data to change while iterating by using a key function, but please
    // don’t; we’d rather avoid a gratuitous copy.)
    function arraylike(data) {
        return typeof data === "object" && "length" in data ? data // Array, TypedArray, NodeList, array-like
         : Array.from(data); // Map, Set, iterable, string, or anything else
    }
    function selection_exit() {
        return new Selection$1(this._exit || this._groups.map(sparse), this._parents);
    }
    function selection_join(onenter, onupdate, onexit) {
        var enter = this.enter(), update = this, exit = this.exit();
        if (typeof onenter === "function") {
            enter = onenter(enter);
            if (enter) enter = enter.selection();
        } else enter = enter.append(onenter + "");
        if (onupdate != null) {
            update = onupdate(update);
            if (update) update = update.selection();
        }
        if (onexit == null) exit.remove();
        else onexit(exit);
        return enter && update ? enter.merge(update).order() : update;
    }
    function selection_merge(context) {
        var selection = context.selection ? context.selection() : context;
        for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
            for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
        }
        for(; j < m0; ++j)merges[j] = groups0[j];
        return new Selection$1(merges, this._parents);
    }
    function selection_order() {
        for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
            for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
                if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
                next = node;
            }
        }
        return this;
    }
    function selection_sort(compare) {
        if (!compare) compare = ascending$2;
        function compareNode(a, b) {
            return a && b ? compare(a.__data__, b.__data__) : !a - !b;
        }
        for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
            sortgroup.sort(compareNode);
        }
        return new Selection$1(sortgroups, this._parents).order();
    }
    function ascending$2(a, b) {
        return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
    }
    function selection_call() {
        var callback = arguments[0];
        arguments[0] = this;
        callback.apply(null, arguments);
        return this;
    }
    function selection_nodes() {
        return Array.from(this);
    }
    function selection_node() {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
            var node = group[i];
            if (node) return node;
        }
        return null;
    }
    function selection_size() {
        let size = 0;
        for (const node of this)++size; // eslint-disable-line no-unused-vars
        return size;
    }
    function selection_empty() {
        return !this.node();
    }
    function selection_each(callback) {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
            for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
        }
        return this;
    }
    function attrRemove$1(name) {
        return function() {
            this.removeAttribute(name);
        };
    }
    function attrRemoveNS$1(fullname) {
        return function() {
            this.removeAttributeNS(fullname.space, fullname.local);
        };
    }
    function attrConstant$1(name, value) {
        return function() {
            this.setAttribute(name, value);
        };
    }
    function attrConstantNS$1(fullname, value) {
        return function() {
            this.setAttributeNS(fullname.space, fullname.local, value);
        };
    }
    function attrFunction$1(name, value) {
        return function() {
            var v = value.apply(this, arguments);
            if (v == null) this.removeAttribute(name);
            else this.setAttribute(name, v);
        };
    }
    function attrFunctionNS$1(fullname, value) {
        return function() {
            var v = value.apply(this, arguments);
            if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
            else this.setAttributeNS(fullname.space, fullname.local, v);
        };
    }
    function selection_attr(name, value) {
        var fullname = namespace(name);
        if (arguments.length < 2) {
            var node = this.node();
            return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
        }
        return this.each((value == null ? fullname.local ? attrRemoveNS$1 : attrRemove$1 : typeof value === "function" ? fullname.local ? attrFunctionNS$1 : attrFunction$1 : fullname.local ? attrConstantNS$1 : attrConstant$1)(fullname, value));
    }
    function defaultView(node) {
        return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
         || node.document && node // node is a Window
         || node.defaultView; // node is a Document
    }
    function styleRemove$1(name) {
        return function() {
            this.style.removeProperty(name);
        };
    }
    function styleConstant$1(name, value, priority) {
        return function() {
            this.style.setProperty(name, value, priority);
        };
    }
    function styleFunction$1(name, value, priority) {
        return function() {
            var v = value.apply(this, arguments);
            if (v == null) this.style.removeProperty(name);
            else this.style.setProperty(name, v, priority);
        };
    }
    function selection_style(name, value, priority) {
        return arguments.length > 1 ? this.each((value == null ? styleRemove$1 : typeof value === "function" ? styleFunction$1 : styleConstant$1)(name, value, priority == null ? "" : priority)) : styleValue(this.node(), name);
    }
    function styleValue(node, name) {
        return node.style.getPropertyValue(name) || defaultView(node).getComputedStyle(node, null).getPropertyValue(name);
    }
    function propertyRemove(name) {
        return function() {
            delete this[name];
        };
    }
    function propertyConstant(name, value) {
        return function() {
            this[name] = value;
        };
    }
    function propertyFunction(name, value) {
        return function() {
            var v = value.apply(this, arguments);
            if (v == null) delete this[name];
            else this[name] = v;
        };
    }
    function selection_property(name, value) {
        return arguments.length > 1 ? this.each((value == null ? propertyRemove : typeof value === "function" ? propertyFunction : propertyConstant)(name, value)) : this.node()[name];
    }
    function classArray(string) {
        return string.trim().split(/^|\s+/);
    }
    function classList(node) {
        return node.classList || new ClassList(node);
    }
    function ClassList(node) {
        this._node = node;
        this._names = classArray(node.getAttribute("class") || "");
    }
    ClassList.prototype = {
        add: function(name) {
            var i = this._names.indexOf(name);
            if (i < 0) {
                this._names.push(name);
                this._node.setAttribute("class", this._names.join(" "));
            }
        },
        remove: function(name) {
            var i = this._names.indexOf(name);
            if (i >= 0) {
                this._names.splice(i, 1);
                this._node.setAttribute("class", this._names.join(" "));
            }
        },
        contains: function(name) {
            return this._names.indexOf(name) >= 0;
        }
    };
    function classedAdd(node, names) {
        var list = classList(node), i = -1, n = names.length;
        while(++i < n)list.add(names[i]);
    }
    function classedRemove(node, names) {
        var list = classList(node), i = -1, n = names.length;
        while(++i < n)list.remove(names[i]);
    }
    function classedTrue(names) {
        return function() {
            classedAdd(this, names);
        };
    }
    function classedFalse(names) {
        return function() {
            classedRemove(this, names);
        };
    }
    function classedFunction(names, value) {
        return function() {
            (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
        };
    }
    function selection_classed(name, value) {
        var names = classArray(name + "");
        if (arguments.length < 2) {
            var list = classList(this.node()), i = -1, n = names.length;
            while(++i < n)if (!list.contains(names[i])) return false;
            return true;
        }
        return this.each((typeof value === "function" ? classedFunction : value ? classedTrue : classedFalse)(names, value));
    }
    function textRemove() {
        this.textContent = "";
    }
    function textConstant$1(value) {
        return function() {
            this.textContent = value;
        };
    }
    function textFunction$1(value) {
        return function() {
            var v = value.apply(this, arguments);
            this.textContent = v == null ? "" : v;
        };
    }
    function selection_text(value) {
        return arguments.length ? this.each(value == null ? textRemove : (typeof value === "function" ? textFunction$1 : textConstant$1)(value)) : this.node().textContent;
    }
    function htmlRemove() {
        this.innerHTML = "";
    }
    function htmlConstant(value) {
        return function() {
            this.innerHTML = value;
        };
    }
    function htmlFunction(value) {
        return function() {
            var v = value.apply(this, arguments);
            this.innerHTML = v == null ? "" : v;
        };
    }
    function selection_html(value) {
        return arguments.length ? this.each(value == null ? htmlRemove : (typeof value === "function" ? htmlFunction : htmlConstant)(value)) : this.node().innerHTML;
    }
    function raise() {
        if (this.nextSibling) this.parentNode.appendChild(this);
    }
    function selection_raise() {
        return this.each(raise);
    }
    function lower() {
        if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
    }
    function selection_lower() {
        return this.each(lower);
    }
    function selection_append(name) {
        var create = typeof name === "function" ? name : creator(name);
        return this.select(function() {
            return this.appendChild(create.apply(this, arguments));
        });
    }
    function constantNull() {
        return null;
    }
    function selection_insert(name, before) {
        var create = typeof name === "function" ? name : creator(name), select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
        return this.select(function() {
            return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
        });
    }
    function remove() {
        var parent = this.parentNode;
        if (parent) parent.removeChild(this);
    }
    function selection_remove() {
        return this.each(remove);
    }
    function selection_cloneShallow() {
        var clone = this.cloneNode(false), parent = this.parentNode;
        return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
    }
    function selection_cloneDeep() {
        var clone = this.cloneNode(true), parent = this.parentNode;
        return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
    }
    function selection_clone(deep) {
        return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
    }
    function selection_datum(value) {
        return arguments.length ? this.property("__data__", value) : this.node().__data__;
    }
    function contextListener(listener) {
        return function(event) {
            listener.call(this, event, this.__data__);
        };
    }
    function parseTypenames(typenames) {
        return typenames.trim().split(/^|\s+/).map(function(t) {
            var name = "", i = t.indexOf(".");
            if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
            return {
                type: t,
                name: name
            };
        });
    }
    function onRemove(typename) {
        return function() {
            var on = this.__on;
            if (!on) return;
            for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
            else on[++i] = o;
            if (++i) on.length = i;
            else delete this.__on;
        };
    }
    function onAdd(typename, value, options) {
        return function() {
            var on = this.__on, o, listener = contextListener(value);
            if (on) {
                for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                    this.removeEventListener(o.type, o.listener, o.options);
                    this.addEventListener(o.type, o.listener = listener, o.options = options);
                    o.value = value;
                    return;
                }
            }
            this.addEventListener(typename.type, listener, options);
            o = {
                type: typename.type,
                name: typename.name,
                value: value,
                listener: listener,
                options: options
            };
            if (!on) this.__on = [
                o
            ];
            else on.push(o);
        };
    }
    function selection_on(typename, value, options) {
        var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;
        if (arguments.length < 2) {
            var on = this.node().__on;
            if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
                if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
            }
            return;
        }
        on = value ? onAdd : onRemove;
        for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
        return this;
    }
    function dispatchEvent(node, type, params) {
        var window1 = defaultView(node), event = window1.CustomEvent;
        if (typeof event === "function") event = new event(type, params);
        else {
            event = window1.document.createEvent("Event");
            if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
            else event.initEvent(type, false, false);
        }
        node.dispatchEvent(event);
    }
    function dispatchConstant(type, params) {
        return function() {
            return dispatchEvent(this, type, params);
        };
    }
    function dispatchFunction(type, params) {
        return function() {
            return dispatchEvent(this, type, params.apply(this, arguments));
        };
    }
    function selection_dispatch(type, params) {
        return this.each((typeof params === "function" ? dispatchFunction : dispatchConstant)(type, params));
    }
    function* selection_iterator() {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
            for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
        }
    }
    var root$1 = [
        null
    ];
    function Selection$1(groups, parents) {
        this._groups = groups;
        this._parents = parents;
    }
    function selection() {
        return new Selection$1([
            [
                document.documentElement
            ]
        ], root$1);
    }
    function selection_selection() {
        return this;
    }
    Selection$1.prototype = selection.prototype = {
        constructor: Selection$1,
        select: selection_select,
        selectAll: selection_selectAll,
        selectChild: selection_selectChild,
        selectChildren: selection_selectChildren,
        filter: selection_filter,
        data: selection_data,
        enter: selection_enter,
        exit: selection_exit,
        join: selection_join,
        merge: selection_merge,
        selection: selection_selection,
        order: selection_order,
        sort: selection_sort,
        call: selection_call,
        nodes: selection_nodes,
        node: selection_node,
        size: selection_size,
        empty: selection_empty,
        each: selection_each,
        attr: selection_attr,
        style: selection_style,
        property: selection_property,
        classed: selection_classed,
        text: selection_text,
        html: selection_html,
        raise: selection_raise,
        lower: selection_lower,
        append: selection_append,
        insert: selection_insert,
        remove: selection_remove,
        clone: selection_clone,
        datum: selection_datum,
        on: selection_on,
        dispatch: selection_dispatch,
        [Symbol.iterator]: selection_iterator
    };
    function select(selector) {
        return typeof selector === "string" ? new Selection$1([
            [
                document.querySelector(selector)
            ]
        ], [
            document.documentElement
        ]) : new Selection$1([
            [
                selector
            ]
        ], root$1);
    }
    function create$1(name) {
        return select(creator(name).call(document.documentElement));
    }
    var nextId = 0;
    function local$1() {
        return new Local;
    }
    function Local() {
        this._ = "@" + (++nextId).toString(36);
    }
    Local.prototype = local$1.prototype = {
        constructor: Local,
        get: function(node) {
            var id = this._;
            while(!(id in node))if (!(node = node.parentNode)) return;
            return node[id];
        },
        set: function(node, value) {
            return node[this._] = value;
        },
        remove: function(node) {
            return this._ in node && delete node[this._];
        },
        toString: function() {
            return this._;
        }
    };
    function sourceEvent(event) {
        let sourceEvent;
        while(sourceEvent = event.sourceEvent)event = sourceEvent;
        return event;
    }
    function pointer(event, node) {
        event = sourceEvent(event);
        if (node === undefined) node = event.currentTarget;
        if (node) {
            var svg = node.ownerSVGElement || node;
            if (svg.createSVGPoint) {
                var point = svg.createSVGPoint();
                point.x = event.clientX, point.y = event.clientY;
                point = point.matrixTransform(node.getScreenCTM().inverse());
                return [
                    point.x,
                    point.y
                ];
            }
            if (node.getBoundingClientRect) {
                var rect = node.getBoundingClientRect();
                return [
                    event.clientX - rect.left - node.clientLeft,
                    event.clientY - rect.top - node.clientTop
                ];
            }
        }
        return [
            event.pageX,
            event.pageY
        ];
    }
    function pointers(events, node) {
        if (events.target) {
            events = sourceEvent(events);
            if (node === undefined) node = events.currentTarget;
            events = events.touches || [
                events
            ];
        }
        return Array.from(events, (event)=>pointer(event, node));
    }
    function selectAll(selector) {
        return typeof selector === "string" ? new Selection$1([
            document.querySelectorAll(selector)
        ], [
            document.documentElement
        ]) : new Selection$1([
            array$4(selector)
        ], root$1);
    }
    // These are typically used in conjunction with noevent to ensure that we can
    // preventDefault on the event.
    const nonpassive = {
        passive: false
    };
    const nonpassivecapture = {
        capture: true,
        passive: false
    };
    function nopropagation$2(event) {
        event.stopImmediatePropagation();
    }
    function noevent$2(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    }
    function dragDisable(view) {
        var root = view.document.documentElement, selection = select(view).on("dragstart.drag", noevent$2, nonpassivecapture);
        if ("onselectstart" in root) selection.on("selectstart.drag", noevent$2, nonpassivecapture);
        else {
            root.__noselect = root.style.MozUserSelect;
            root.style.MozUserSelect = "none";
        }
    }
    function yesdrag(view, noclick) {
        var root = view.document.documentElement, selection = select(view).on("dragstart.drag", null);
        if (noclick) {
            selection.on("click.drag", noevent$2, nonpassivecapture);
            setTimeout(function() {
                selection.on("click.drag", null);
            }, 0);
        }
        if ("onselectstart" in root) selection.on("selectstart.drag", null);
        else {
            root.style.MozUserSelect = root.__noselect;
            delete root.__noselect;
        }
    }
    var constant$9 = (x)=>()=>x;
    function DragEvent(type, { sourceEvent: sourceEvent, subject: subject, target: target, identifier: identifier, active: active, x: x, y: y, dx: dx, dy: dy, dispatch: dispatch }) {
        Object.defineProperties(this, {
            type: {
                value: type,
                enumerable: true,
                configurable: true
            },
            sourceEvent: {
                value: sourceEvent,
                enumerable: true,
                configurable: true
            },
            subject: {
                value: subject,
                enumerable: true,
                configurable: true
            },
            target: {
                value: target,
                enumerable: true,
                configurable: true
            },
            identifier: {
                value: identifier,
                enumerable: true,
                configurable: true
            },
            active: {
                value: active,
                enumerable: true,
                configurable: true
            },
            x: {
                value: x,
                enumerable: true,
                configurable: true
            },
            y: {
                value: y,
                enumerable: true,
                configurable: true
            },
            dx: {
                value: dx,
                enumerable: true,
                configurable: true
            },
            dy: {
                value: dy,
                enumerable: true,
                configurable: true
            },
            _: {
                value: dispatch
            }
        });
    }
    DragEvent.prototype.on = function() {
        var value = this._.on.apply(this._, arguments);
        return value === this._ ? this : value;
    };
    // Ignore right-click, since that should open the context menu.
    function defaultFilter$2(event) {
        return !event.ctrlKey && !event.button;
    }
    function defaultContainer() {
        return this.parentNode;
    }
    function defaultSubject(event, d) {
        return d == null ? {
            x: event.x,
            y: event.y
        } : d;
    }
    function defaultTouchable$2() {
        return navigator.maxTouchPoints || "ontouchstart" in this;
    }
    function drag() {
        var filter = defaultFilter$2, container = defaultContainer, subject = defaultSubject, touchable = defaultTouchable$2, gestures = {}, listeners = dispatch("start", "drag", "end"), active = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
        function drag(selection) {
            selection.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved, nonpassive).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
        }
        function mousedowned(event, d) {
            if (touchending || !filter.call(this, event, d)) return;
            var gesture = beforestart(this, container.call(this, event, d), event, d, "mouse");
            if (!gesture) return;
            select(event.view).on("mousemove.drag", mousemoved, nonpassivecapture).on("mouseup.drag", mouseupped, nonpassivecapture);
            dragDisable(event.view);
            nopropagation$2(event);
            mousemoving = false;
            mousedownx = event.clientX;
            mousedowny = event.clientY;
            gesture("start", event);
        }
        function mousemoved(event) {
            noevent$2(event);
            if (!mousemoving) {
                var dx = event.clientX - mousedownx, dy = event.clientY - mousedowny;
                mousemoving = dx * dx + dy * dy > clickDistance2;
            }
            gestures.mouse("drag", event);
        }
        function mouseupped(event) {
            select(event.view).on("mousemove.drag mouseup.drag", null);
            yesdrag(event.view, mousemoving);
            noevent$2(event);
            gestures.mouse("end", event);
        }
        function touchstarted(event, d) {
            if (!filter.call(this, event, d)) return;
            var touches = event.changedTouches, c = container.call(this, event, d), n = touches.length, i, gesture;
            for(i = 0; i < n; ++i)if (gesture = beforestart(this, c, event, d, touches[i].identifier, touches[i])) {
                nopropagation$2(event);
                gesture("start", event, touches[i]);
            }
        }
        function touchmoved(event) {
            var touches = event.changedTouches, n = touches.length, i, gesture;
            for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
                noevent$2(event);
                gesture("drag", event, touches[i]);
            }
        }
        function touchended(event) {
            var touches = event.changedTouches, n = touches.length, i, gesture;
            if (touchending) clearTimeout(touchending);
            touchending = setTimeout(function() {
                touchending = null;
            }, 500); // Ghost clicks are delayed!
            for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
                nopropagation$2(event);
                gesture("end", event, touches[i]);
            }
        }
        function beforestart(that, container, event, d, identifier, touch) {
            var dispatch = listeners.copy(), p = pointer(touch || event, container), dx, dy, s;
            if ((s = subject.call(that, new DragEvent("beforestart", {
                sourceEvent: event,
                target: drag,
                identifier: identifier,
                active: active,
                x: p[0],
                y: p[1],
                dx: 0,
                dy: 0,
                dispatch: dispatch
            }), d)) == null) return;
            dx = s.x - p[0] || 0;
            dy = s.y - p[1] || 0;
            return function gesture(type, event, touch) {
                var p0 = p, n;
                switch(type){
                    case "start":
                        gestures[identifier] = gesture, n = active++;
                        break;
                    case "end":
                        delete gestures[identifier], --active; // falls through
                    case "drag":
                        p = pointer(touch || event, container), n = active;
                        break;
                }
                dispatch.call(type, that, new DragEvent(type, {
                    sourceEvent: event,
                    subject: s,
                    target: drag,
                    identifier: identifier,
                    active: n,
                    x: p[0] + dx,
                    y: p[1] + dy,
                    dx: p[0] - p0[0],
                    dy: p[1] - p0[1],
                    dispatch: dispatch
                }), d);
            };
        }
        drag.filter = function(_) {
            return arguments.length ? (filter = typeof _ === "function" ? _ : constant$9(!!_), drag) : filter;
        };
        drag.container = function(_) {
            return arguments.length ? (container = typeof _ === "function" ? _ : constant$9(_), drag) : container;
        };
        drag.subject = function(_) {
            return arguments.length ? (subject = typeof _ === "function" ? _ : constant$9(_), drag) : subject;
        };
        drag.touchable = function(_) {
            return arguments.length ? (touchable = typeof _ === "function" ? _ : constant$9(!!_), drag) : touchable;
        };
        drag.on = function() {
            var value = listeners.on.apply(listeners, arguments);
            return value === listeners ? drag : value;
        };
        drag.clickDistance = function(_) {
            return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
        };
        return drag;
    }
    function define(constructor, factory, prototype) {
        constructor.prototype = factory.prototype = prototype;
        prototype.constructor = constructor;
    }
    function extend(parent, definition) {
        var prototype = Object.create(parent.prototype);
        for(var key in definition)prototype[key] = definition[key];
        return prototype;
    }
    function Color() {}
    var darker = 0.7;
    var brighter = 1 / darker;
    var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
    var named = {
        aliceblue: 0xf0f8ff,
        antiquewhite: 0xfaebd7,
        aqua: 0x00ffff,
        aquamarine: 0x7fffd4,
        azure: 0xf0ffff,
        beige: 0xf5f5dc,
        bisque: 0xffe4c4,
        black: 0x000000,
        blanchedalmond: 0xffebcd,
        blue: 0x0000ff,
        blueviolet: 0x8a2be2,
        brown: 0xa52a2a,
        burlywood: 0xdeb887,
        cadetblue: 0x5f9ea0,
        chartreuse: 0x7fff00,
        chocolate: 0xd2691e,
        coral: 0xff7f50,
        cornflowerblue: 0x6495ed,
        cornsilk: 0xfff8dc,
        crimson: 0xdc143c,
        cyan: 0x00ffff,
        darkblue: 0x00008b,
        darkcyan: 0x008b8b,
        darkgoldenrod: 0xb8860b,
        darkgray: 0xa9a9a9,
        darkgreen: 0x006400,
        darkgrey: 0xa9a9a9,
        darkkhaki: 0xbdb76b,
        darkmagenta: 0x8b008b,
        darkolivegreen: 0x556b2f,
        darkorange: 0xff8c00,
        darkorchid: 0x9932cc,
        darkred: 0x8b0000,
        darksalmon: 0xe9967a,
        darkseagreen: 0x8fbc8f,
        darkslateblue: 0x483d8b,
        darkslategray: 0x2f4f4f,
        darkslategrey: 0x2f4f4f,
        darkturquoise: 0x00ced1,
        darkviolet: 0x9400d3,
        deeppink: 0xff1493,
        deepskyblue: 0x00bfff,
        dimgray: 0x696969,
        dimgrey: 0x696969,
        dodgerblue: 0x1e90ff,
        firebrick: 0xb22222,
        floralwhite: 0xfffaf0,
        forestgreen: 0x228b22,
        fuchsia: 0xff00ff,
        gainsboro: 0xdcdcdc,
        ghostwhite: 0xf8f8ff,
        gold: 0xffd700,
        goldenrod: 0xdaa520,
        gray: 0x808080,
        green: 0x008000,
        greenyellow: 0xadff2f,
        grey: 0x808080,
        honeydew: 0xf0fff0,
        hotpink: 0xff69b4,
        indianred: 0xcd5c5c,
        indigo: 0x4b0082,
        ivory: 0xfffff0,
        khaki: 0xf0e68c,
        lavender: 0xe6e6fa,
        lavenderblush: 0xfff0f5,
        lawngreen: 0x7cfc00,
        lemonchiffon: 0xfffacd,
        lightblue: 0xadd8e6,
        lightcoral: 0xf08080,
        lightcyan: 0xe0ffff,
        lightgoldenrodyellow: 0xfafad2,
        lightgray: 0xd3d3d3,
        lightgreen: 0x90ee90,
        lightgrey: 0xd3d3d3,
        lightpink: 0xffb6c1,
        lightsalmon: 0xffa07a,
        lightseagreen: 0x20b2aa,
        lightskyblue: 0x87cefa,
        lightslategray: 0x778899,
        lightslategrey: 0x778899,
        lightsteelblue: 0xb0c4de,
        lightyellow: 0xffffe0,
        lime: 0x00ff00,
        limegreen: 0x32cd32,
        linen: 0xfaf0e6,
        magenta: 0xff00ff,
        maroon: 0x800000,
        mediumaquamarine: 0x66cdaa,
        mediumblue: 0x0000cd,
        mediumorchid: 0xba55d3,
        mediumpurple: 0x9370db,
        mediumseagreen: 0x3cb371,
        mediumslateblue: 0x7b68ee,
        mediumspringgreen: 0x00fa9a,
        mediumturquoise: 0x48d1cc,
        mediumvioletred: 0xc71585,
        midnightblue: 0x191970,
        mintcream: 0xf5fffa,
        mistyrose: 0xffe4e1,
        moccasin: 0xffe4b5,
        navajowhite: 0xffdead,
        navy: 0x000080,
        oldlace: 0xfdf5e6,
        olive: 0x808000,
        olivedrab: 0x6b8e23,
        orange: 0xffa500,
        orangered: 0xff4500,
        orchid: 0xda70d6,
        palegoldenrod: 0xeee8aa,
        palegreen: 0x98fb98,
        paleturquoise: 0xafeeee,
        palevioletred: 0xdb7093,
        papayawhip: 0xffefd5,
        peachpuff: 0xffdab9,
        peru: 0xcd853f,
        pink: 0xffc0cb,
        plum: 0xdda0dd,
        powderblue: 0xb0e0e6,
        purple: 0x800080,
        rebeccapurple: 0x663399,
        red: 0xff0000,
        rosybrown: 0xbc8f8f,
        royalblue: 0x4169e1,
        saddlebrown: 0x8b4513,
        salmon: 0xfa8072,
        sandybrown: 0xf4a460,
        seagreen: 0x2e8b57,
        seashell: 0xfff5ee,
        sienna: 0xa0522d,
        silver: 0xc0c0c0,
        skyblue: 0x87ceeb,
        slateblue: 0x6a5acd,
        slategray: 0x708090,
        slategrey: 0x708090,
        snow: 0xfffafa,
        springgreen: 0x00ff7f,
        steelblue: 0x4682b4,
        tan: 0xd2b48c,
        teal: 0x008080,
        thistle: 0xd8bfd8,
        tomato: 0xff6347,
        turquoise: 0x40e0d0,
        violet: 0xee82ee,
        wheat: 0xf5deb3,
        white: 0xffffff,
        whitesmoke: 0xf5f5f5,
        yellow: 0xffff00,
        yellowgreen: 0x9acd32
    };
    define(Color, color, {
        copy (channels) {
            return Object.assign(new this.constructor, this, channels);
        },
        displayable () {
            return this.rgb().displayable();
        },
        hex: color_formatHex,
        formatHex: color_formatHex,
        formatHex8: color_formatHex8,
        formatHsl: color_formatHsl,
        formatRgb: color_formatRgb,
        toString: color_formatRgb
    });
    function color_formatHex() {
        return this.rgb().formatHex();
    }
    function color_formatHex8() {
        return this.rgb().formatHex8();
    }
    function color_formatHsl() {
        return hslConvert(this).formatHsl();
    }
    function color_formatRgb() {
        return this.rgb().formatRgb();
    }
    function color(format) {
        var m, l;
        format = (format + "").trim().toLowerCase();
        return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
         : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
         : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
         : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
         : null // invalid hex
        ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
         : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
         : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
         : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
         : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
         : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
         : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
         : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
    }
    function rgbn(n) {
        return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
    }
    function rgba(r, g, b, a) {
        if (a <= 0) r = g = b = NaN;
        return new Rgb(r, g, b, a);
    }
    function rgbConvert(o) {
        if (!(o instanceof Color)) o = color(o);
        if (!o) return new Rgb;
        o = o.rgb();
        return new Rgb(o.r, o.g, o.b, o.opacity);
    }
    function rgb(r, g, b, opacity) {
        return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
    }
    function Rgb(r, g, b, opacity) {
        this.r = +r;
        this.g = +g;
        this.b = +b;
        this.opacity = +opacity;
    }
    define(Rgb, rgb, extend(Color, {
        brighter (k) {
            k = k == null ? brighter : Math.pow(brighter, k);
            return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
        },
        darker (k) {
            k = k == null ? darker : Math.pow(darker, k);
            return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
        },
        rgb () {
            return this;
        },
        clamp () {
            return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
        },
        displayable () {
            return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
        },
        hex: rgb_formatHex,
        formatHex: rgb_formatHex,
        formatHex8: rgb_formatHex8,
        formatRgb: rgb_formatRgb,
        toString: rgb_formatRgb
    }));
    function rgb_formatHex() {
        return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
    }
    function rgb_formatHex8() {
        return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
    }
    function rgb_formatRgb() {
        const a = clampa(this.opacity);
        return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
    }
    function clampa(opacity) {
        return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
    }
    function clampi(value) {
        return Math.max(0, Math.min(255, Math.round(value) || 0));
    }
    function hex(value) {
        value = clampi(value);
        return (value < 16 ? "0" : "") + value.toString(16);
    }
    function hsla(h, s, l, a) {
        if (a <= 0) h = s = l = NaN;
        else if (l <= 0 || l >= 1) h = s = NaN;
        else if (s <= 0) h = NaN;
        return new Hsl(h, s, l, a);
    }
    function hslConvert(o) {
        if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
        if (!(o instanceof Color)) o = color(o);
        if (!o) return new Hsl;
        if (o instanceof Hsl) return o;
        o = o.rgb();
        var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
        if (s) {
            if (r === max) h = (g - b) / s + (g < b) * 6;
            else if (g === max) h = (b - r) / s + 2;
            else h = (r - g) / s + 4;
            s /= l < 0.5 ? max + min : 2 - max - min;
            h *= 60;
        } else s = l > 0 && l < 1 ? 0 : h;
        return new Hsl(h, s, l, o.opacity);
    }
    function hsl$2(h, s, l, opacity) {
        return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
    }
    function Hsl(h, s, l, opacity) {
        this.h = +h;
        this.s = +s;
        this.l = +l;
        this.opacity = +opacity;
    }
    define(Hsl, hsl$2, extend(Color, {
        brighter (k) {
            k = k == null ? brighter : Math.pow(brighter, k);
            return new Hsl(this.h, this.s, this.l * k, this.opacity);
        },
        darker (k) {
            k = k == null ? darker : Math.pow(darker, k);
            return new Hsl(this.h, this.s, this.l * k, this.opacity);
        },
        rgb () {
            var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
            return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
        },
        clamp () {
            return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
        },
        displayable () {
            return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
        },
        formatHsl () {
            const a = clampa(this.opacity);
            return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
        }
    }));
    function clamph(value) {
        value = (value || 0) % 360;
        return value < 0 ? value + 360 : value;
    }
    function clampt(value) {
        return Math.max(0, Math.min(1, value || 0));
    }
    /* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
        return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
    }
    const radians$1 = Math.PI / 180;
    const degrees$2 = 180 / Math.PI;
    // https://observablehq.com/@mbostock/lab-and-rgb
    const K = 18, Xn = 0.96422, Yn = 1, Zn = 0.82521, t0$1 = 4 / 29, t1$1 = 6 / 29, t2 = 3 * t1$1 * t1$1, t3 = t1$1 * t1$1 * t1$1;
    function labConvert(o) {
        if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
        if (o instanceof Hcl) return hcl2lab(o);
        if (!(o instanceof Rgb)) o = rgbConvert(o);
        var r = rgb2lrgb(o.r), g = rgb2lrgb(o.g), b = rgb2lrgb(o.b), y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
        if (r === g && g === b) x = z = y;
        else {
            x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
            z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
        }
        return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
    }
    function gray(l, opacity) {
        return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
    }
    function lab$1(l, a, b, opacity) {
        return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
    }
    function Lab(l, a, b, opacity) {
        this.l = +l;
        this.a = +a;
        this.b = +b;
        this.opacity = +opacity;
    }
    define(Lab, lab$1, extend(Color, {
        brighter (k) {
            return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
        },
        darker (k) {
            return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
        },
        rgb () {
            var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
            x = Xn * lab2xyz(x);
            y = Yn * lab2xyz(y);
            z = Zn * lab2xyz(z);
            return new Rgb(lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
        }
    }));
    function xyz2lab(t) {
        return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0$1;
    }
    function lab2xyz(t) {
        return t > t1$1 ? t * t * t : t2 * (t - t0$1);
    }
    function lrgb2rgb(x) {
        return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
    }
    function rgb2lrgb(x) {
        return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
    }
    function hclConvert(o) {
        if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
        if (!(o instanceof Lab)) o = labConvert(o);
        if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
        var h = Math.atan2(o.b, o.a) * degrees$2;
        return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
    }
    function lch(l, c, h, opacity) {
        return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
    }
    function hcl$2(h, c, l, opacity) {
        return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
    }
    function Hcl(h, c, l, opacity) {
        this.h = +h;
        this.c = +c;
        this.l = +l;
        this.opacity = +opacity;
    }
    function hcl2lab(o) {
        if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
        var h = o.h * radians$1;
        return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
    }
    define(Hcl, hcl$2, extend(Color, {
        brighter (k) {
            return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
        },
        darker (k) {
            return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
        },
        rgb () {
            return hcl2lab(this).rgb();
        }
    }));
    var A = -0.14861, B$1 = 1.78277, C = -0.29227, D$1 = -0.90649, E = 1.97294, ED = E * D$1, EB = E * B$1, BC_DA = B$1 * C - D$1 * A;
    function cubehelixConvert(o) {
        if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
        if (!(o instanceof Rgb)) o = rgbConvert(o);
        var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB), bl = b - l, k = (E * (g - l) - C * bl) / D$1, s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), h = s ? Math.atan2(k, bl) * degrees$2 - 120 : NaN;
        return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
    }
    function cubehelix$3(h, s, l, opacity) {
        return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
    }
    function Cubehelix(h, s, l, opacity) {
        this.h = +h;
        this.s = +s;
        this.l = +l;
        this.opacity = +opacity;
    }
    define(Cubehelix, cubehelix$3, extend(Color, {
        brighter (k) {
            k = k == null ? brighter : Math.pow(brighter, k);
            return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
        },
        darker (k) {
            k = k == null ? darker : Math.pow(darker, k);
            return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
        },
        rgb () {
            var h = isNaN(this.h) ? 0 : (this.h + 120) * radians$1, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
            return new Rgb(255 * (l + a * (A * cosh + B$1 * sinh)), 255 * (l + a * (C * cosh + D$1 * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
        }
    }));
    function basis$1(t1, v0, v1, v2, v3) {
        var t2 = t1 * t1, t3 = t2 * t1;
        return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
    }
    function basis$2(values) {
        var n = values.length - 1;
        return function(t) {
            var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
            return basis$1((t - i / n) * n, v0, v1, v2, v3);
        };
    }
    function basisClosed$1(values) {
        var n = values.length;
        return function(t) {
            var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
            return basis$1((t - i / n) * n, v0, v1, v2, v3);
        };
    }
    var constant$8 = (x)=>()=>x;
    function linear$2(a, d) {
        return function(t) {
            return a + t * d;
        };
    }
    function exponential$1(a, b, y) {
        return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
            return Math.pow(a + t * b, y);
        };
    }
    function hue$1(a, b) {
        var d = b - a;
        return d ? linear$2(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant$8(isNaN(a) ? b : a);
    }
    function gamma$1(y) {
        return (y = +y) === 1 ? nogamma : function(a, b) {
            return b - a ? exponential$1(a, b, y) : constant$8(isNaN(a) ? b : a);
        };
    }
    function nogamma(a, b) {
        var d = b - a;
        return d ? linear$2(a, d) : constant$8(isNaN(a) ? b : a);
    }
    var interpolateRgb = function rgbGamma(y) {
        var color = gamma$1(y);
        function rgb$1(start, end) {
            var r = color((start = rgb(start)).r, (end = rgb(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = nogamma(start.opacity, end.opacity);
            return function(t) {
                start.r = r(t);
                start.g = g(t);
                start.b = b(t);
                start.opacity = opacity(t);
                return start + "";
            };
        }
        rgb$1.gamma = rgbGamma;
        return rgb$1;
    }(1);
    function rgbSpline(spline) {
        return function(colors) {
            var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
            for(i = 0; i < n; ++i){
                color = rgb(colors[i]);
                r[i] = color.r || 0;
                g[i] = color.g || 0;
                b[i] = color.b || 0;
            }
            r = spline(r);
            g = spline(g);
            b = spline(b);
            color.opacity = 1;
            return function(t) {
                color.r = r(t);
                color.g = g(t);
                color.b = b(t);
                return color + "";
            };
        };
    }
    var rgbBasis = rgbSpline(basis$2);
    var rgbBasisClosed = rgbSpline(basisClosed$1);
    function numberArray(a, b) {
        if (!b) b = [];
        var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
        return function(t) {
            for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
            return c;
        };
    }
    function isNumberArray(x) {
        return ArrayBuffer.isView(x) && !(x instanceof DataView);
    }
    function array$3(a, b) {
        return (isNumberArray(b) ? numberArray : genericArray)(a, b);
    }
    function genericArray(a, b) {
        var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
        for(i = 0; i < na; ++i)x[i] = interpolate$2(a[i], b[i]);
        for(; i < nb; ++i)c[i] = b[i];
        return function(t) {
            for(i = 0; i < na; ++i)c[i] = x[i](t);
            return c;
        };
    }
    function date$1(a, b) {
        var d = new Date;
        return a = +a, b = +b, function(t) {
            return d.setTime(a * (1 - t) + b * t), d;
        };
    }
    function interpolateNumber(a, b) {
        return a = +a, b = +b, function(t) {
            return a * (1 - t) + b * t;
        };
    }
    function object$1(a, b) {
        var i = {}, c = {}, k;
        if (a === null || typeof a !== "object") a = {};
        if (b === null || typeof b !== "object") b = {};
        for(k in b)if (k in a) i[k] = interpolate$2(a[k], b[k]);
        else c[k] = b[k];
        return function(t) {
            for(k in i)c[k] = i[k](t);
            return c;
        };
    }
    var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
    function zero(b) {
        return function() {
            return b;
        };
    }
    function one(b) {
        return function(t) {
            return b(t) + "";
        };
    }
    function interpolateString(a, b) {
        var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
        // Coerce inputs to strings.
        a = a + "", b = b + "";
        // Interpolate pairs of numbers in a & b.
        while((am = reA.exec(a)) && (bm = reB.exec(b))){
            if ((bs = bm.index) > bi) {
                bs = b.slice(bi, bs);
                if (s[i]) s[i] += bs; // coalesce with previous string
                else s[++i] = bs;
            }
            if ((am = am[0]) === (bm = bm[0])) {
                if (s[i]) s[i] += bm; // coalesce with previous string
                else s[++i] = bm;
            } else {
                s[++i] = null;
                q.push({
                    i: i,
                    x: interpolateNumber(am, bm)
                });
            }
            bi = reB.lastIndex;
        }
        // Add remains of b.
        if (bi < b.length) {
            bs = b.slice(bi);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        // Special optimization for only a single match.
        // Otherwise, interpolate each of the numbers and rejoin the string.
        return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function(t) {
            for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        });
    }
    function interpolate$2(a, b) {
        var t = typeof b, c;
        return b == null || t === "boolean" ? constant$8(b) : (t === "number" ? interpolateNumber : t === "string" ? (c = color(b)) ? (b = c, interpolateRgb) : interpolateString : b instanceof color ? interpolateRgb : b instanceof Date ? date$1 : isNumberArray(b) ? numberArray : Array.isArray(b) ? genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object$1 : interpolateNumber)(a, b);
    }
    function discrete(range) {
        var n = range.length;
        return function(t) {
            return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
        };
    }
    function hue(a, b) {
        var i = hue$1(+a, +b);
        return function(t) {
            var x = i(t);
            return x - 360 * Math.floor(x / 360);
        };
    }
    function interpolateRound(a, b) {
        return a = +a, b = +b, function(t) {
            return Math.round(a * (1 - t) + b * t);
        };
    }
    var degrees$1 = 180 / Math.PI;
    var identity$7 = {
        translateX: 0,
        translateY: 0,
        rotate: 0,
        skewX: 0,
        scaleX: 1,
        scaleY: 1
    };
    function decompose(a, b, c, d, e, f) {
        var scaleX, scaleY, skewX;
        if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
        if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
        if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
        if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
        return {
            translateX: e,
            translateY: f,
            rotate: Math.atan2(b, a) * degrees$1,
            skewX: Math.atan(skewX) * degrees$1,
            scaleX: scaleX,
            scaleY: scaleY
        };
    }
    var svgNode;
    /* eslint-disable no-undef */ function parseCss(value) {
        const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
        return m.isIdentity ? identity$7 : decompose(m.a, m.b, m.c, m.d, m.e, m.f);
    }
    function parseSvg(value) {
        if (value == null) return identity$7;
        if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
        svgNode.setAttribute("transform", value);
        if (!(value = svgNode.transform.baseVal.consolidate())) return identity$7;
        value = value.matrix;
        return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
    }
    function interpolateTransform(parse, pxComma, pxParen, degParen) {
        function pop(s) {
            return s.length ? s.pop() + " " : "";
        }
        function translate(xa, ya, xb, yb, s, q) {
            if (xa !== xb || ya !== yb) {
                var i = s.push("translate(", null, pxComma, null, pxParen);
                q.push({
                    i: i - 4,
                    x: interpolateNumber(xa, xb)
                }, {
                    i: i - 2,
                    x: interpolateNumber(ya, yb)
                });
            } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
        }
        function rotate(a, b, s, q) {
            if (a !== b) {
                if (a - b > 180) b += 360;
                else if (b - a > 180) a += 360; // shortest path
                q.push({
                    i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                    x: interpolateNumber(a, b)
                });
            } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
        }
        function skewX(a, b, s, q) {
            if (a !== b) q.push({
                i: s.push(pop(s) + "skewX(", null, degParen) - 2,
                x: interpolateNumber(a, b)
            });
            else if (b) s.push(pop(s) + "skewX(" + b + degParen);
        }
        function scale(xa, ya, xb, yb, s, q) {
            if (xa !== xb || ya !== yb) {
                var i = s.push(pop(s) + "scale(", null, ",", null, ")");
                q.push({
                    i: i - 4,
                    x: interpolateNumber(xa, xb)
                }, {
                    i: i - 2,
                    x: interpolateNumber(ya, yb)
                });
            } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
        }
        return function(a, b) {
            var s = [], q = []; // number interpolators
            a = parse(a), b = parse(b);
            translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
            rotate(a.rotate, b.rotate, s, q);
            skewX(a.skewX, b.skewX, s, q);
            scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
            a = b = null; // gc
            return function(t) {
                var i = -1, n = q.length, o;
                while(++i < n)s[(o = q[i]).i] = o.x(t);
                return s.join("");
            };
        };
    }
    var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
    var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
    var epsilon2$1 = 1e-12;
    function cosh(x) {
        return ((x = Math.exp(x)) + 1 / x) / 2;
    }
    function sinh(x) {
        return ((x = Math.exp(x)) - 1 / x) / 2;
    }
    function tanh(x) {
        return ((x = Math.exp(2 * x)) - 1) / (x + 1);
    }
    var interpolateZoom = function zoomRho(rho, rho2, rho4) {
        // p0 = [ux0, uy0, w0]
        // p1 = [ux1, uy1, w1]
        function zoom(p0, p1) {
            var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
            // Special case for u0 ≅ u1.
            if (d2 < epsilon2$1) {
                S = Math.log(w1 / w0) / rho;
                i = function(t) {
                    return [
                        ux0 + t * dx,
                        uy0 + t * dy,
                        w0 * Math.exp(rho * t * S)
                    ];
                };
            } else {
                var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
                S = (r1 - r0) / rho;
                i = function(t) {
                    var s = t * S, coshr0 = cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
                    return [
                        ux0 + u * dx,
                        uy0 + u * dy,
                        w0 * coshr0 / cosh(rho * s + r0)
                    ];
                };
            }
            i.duration = S * 1000 * rho / Math.SQRT2;
            return i;
        }
        zoom.rho = function(_) {
            var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
            return zoomRho(_1, _2, _4);
        };
        return zoom;
    }(Math.SQRT2, 2, 4);
    function hsl(hue) {
        return function(start, end) {
            var h = hue((start = hsl$2(start)).h, (end = hsl$2(end)).h), s = nogamma(start.s, end.s), l = nogamma(start.l, end.l), opacity = nogamma(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(t);
                start.opacity = opacity(t);
                return start + "";
            };
        };
    }
    var hsl$1 = hsl(hue$1);
    var hslLong = hsl(nogamma);
    function lab(start, end) {
        var l = nogamma((start = lab$1(start)).l, (end = lab$1(end)).l), a = nogamma(start.a, end.a), b = nogamma(start.b, end.b), opacity = nogamma(start.opacity, end.opacity);
        return function(t) {
            start.l = l(t);
            start.a = a(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    function hcl(hue) {
        return function(start, end) {
            var h = hue((start = hcl$2(start)).h, (end = hcl$2(end)).h), c = nogamma(start.c, end.c), l = nogamma(start.l, end.l), opacity = nogamma(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.c = c(t);
                start.l = l(t);
                start.opacity = opacity(t);
                return start + "";
            };
        };
    }
    var hcl$1 = hcl(hue$1);
    var hclLong = hcl(nogamma);
    function cubehelix$1(hue) {
        return function cubehelixGamma(y) {
            y = +y;
            function cubehelix(start, end) {
                var h = hue((start = cubehelix$3(start)).h, (end = cubehelix$3(end)).h), s = nogamma(start.s, end.s), l = nogamma(start.l, end.l), opacity = nogamma(start.opacity, end.opacity);
                return function(t) {
                    start.h = h(t);
                    start.s = s(t);
                    start.l = l(Math.pow(t, y));
                    start.opacity = opacity(t);
                    return start + "";
                };
            }
            cubehelix.gamma = cubehelixGamma;
            return cubehelix;
        }(1);
    }
    var cubehelix$2 = cubehelix$1(hue$1);
    var cubehelixLong = cubehelix$1(nogamma);
    function piecewise(interpolate, values) {
        if (values === undefined) values = interpolate, interpolate = interpolate$2;
        var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
        while(i < n)I[i] = interpolate(v, v = values[++i]);
        return function(t) {
            var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
            return I[i](t - i);
        };
    }
    function quantize$1(interpolator, n) {
        var samples = new Array(n);
        for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
        return samples;
    }
    var frame = 0, timeout$1 = 0, interval$1 = 0, pokeDelay = 1000, taskHead, taskTail, clockLast = 0, clockNow = 0, clockSkew = 0, clock = typeof performance === "object" && performance.now ? performance : Date, setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
        setTimeout(f, 17);
    };
    function now() {
        return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
    }
    function clearNow() {
        clockNow = 0;
    }
    function Timer() {
        this._call = this._time = this._next = null;
    }
    Timer.prototype = timer.prototype = {
        constructor: Timer,
        restart: function(callback, delay, time) {
            if (typeof callback !== "function") throw new TypeError("callback is not a function");
            time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
            if (!this._next && taskTail !== this) {
                if (taskTail) taskTail._next = this;
                else taskHead = this;
                taskTail = this;
            }
            this._call = callback;
            this._time = time;
            sleep();
        },
        stop: function() {
            if (this._call) {
                this._call = null;
                this._time = Infinity;
                sleep();
            }
        }
    };
    function timer(callback, delay, time) {
        var t = new Timer;
        t.restart(callback, delay, time);
        return t;
    }
    function timerFlush() {
        now(); // Get the current time, if not already set.
        ++frame; // Pretend we’ve set an alarm, if we haven’t already.
        var t = taskHead, e;
        while(t){
            if ((e = clockNow - t._time) >= 0) t._call.call(undefined, e);
            t = t._next;
        }
        --frame;
    }
    function wake() {
        clockNow = (clockLast = clock.now()) + clockSkew;
        frame = timeout$1 = 0;
        try {
            timerFlush();
        } finally{
            frame = 0;
            nap();
            clockNow = 0;
        }
    }
    function poke() {
        var now = clock.now(), delay = now - clockLast;
        if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
    }
    function nap() {
        var t0, t1 = taskHead, t2, time = Infinity;
        while(t1)if (t1._call) {
            if (time > t1._time) time = t1._time;
            t0 = t1, t1 = t1._next;
        } else {
            t2 = t1._next, t1._next = null;
            t1 = t0 ? t0._next = t2 : taskHead = t2;
        }
        taskTail = t0;
        sleep(time);
    }
    function sleep(time) {
        if (frame) return; // Soonest alarm already set, or will be.
        if (timeout$1) timeout$1 = clearTimeout(timeout$1);
        var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
        if (delay > 24) {
            if (time < Infinity) timeout$1 = setTimeout(wake, time - clock.now() - clockSkew);
            if (interval$1) interval$1 = clearInterval(interval$1);
        } else {
            if (!interval$1) clockLast = clock.now(), interval$1 = setInterval(poke, pokeDelay);
            frame = 1, setFrame(wake);
        }
    }
    function timeout(callback, delay, time) {
        var t = new Timer;
        delay = delay == null ? 0 : +delay;
        t.restart((elapsed)=>{
            t.stop();
            callback(elapsed + delay);
        }, delay, time);
        return t;
    }
    function interval(callback, delay, time) {
        var t = new Timer, total = delay;
        if (delay == null) return t.restart(callback, delay, time), t;
        t._restart = t.restart;
        t.restart = function(callback, delay, time) {
            delay = +delay, time = time == null ? now() : +time;
            t._restart(function tick(elapsed) {
                elapsed += total;
                t._restart(tick, total += delay, time);
                callback(elapsed);
            }, delay, time);
        };
        t.restart(callback, delay, time);
        return t;
    }
    var emptyOn = dispatch("start", "end", "cancel", "interrupt");
    var emptyTween = [];
    var CREATED = 0;
    var SCHEDULED = 1;
    var STARTING = 2;
    var STARTED = 3;
    var RUNNING = 4;
    var ENDING = 5;
    var ENDED = 6;
    function schedule(node, name, id, index, group, timing) {
        var schedules = node.__transition;
        if (!schedules) node.__transition = {};
        else if (id in schedules) return;
        create(node, id, {
            name: name,
            index: index,
            group: group,
            on: emptyOn,
            tween: emptyTween,
            time: timing.time,
            delay: timing.delay,
            duration: timing.duration,
            ease: timing.ease,
            timer: null,
            state: CREATED
        });
    }
    function init(node, id) {
        var schedule = get(node, id);
        if (schedule.state > CREATED) throw new Error("too late; already scheduled");
        return schedule;
    }
    function set(node, id) {
        var schedule = get(node, id);
        if (schedule.state > STARTED) throw new Error("too late; already running");
        return schedule;
    }
    function get(node, id) {
        var schedule = node.__transition;
        if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
        return schedule;
    }
    function create(node, id, self) {
        var schedules = node.__transition, tween;
        // Initialize the self timer when the transition is created.
        // Note the actual delay is not known until the first callback!
        schedules[id] = self;
        self.timer = timer(schedule, 0, self.time);
        function schedule(elapsed) {
            self.state = SCHEDULED;
            self.timer.restart(start, self.delay, self.time);
            // If the elapsed delay is less than our first sleep, start immediately.
            if (self.delay <= elapsed) start(elapsed - self.delay);
        }
        function start(elapsed) {
            var i, j, n, o;
            // If the state is not SCHEDULED, then we previously errored on start.
            if (self.state !== SCHEDULED) return stop();
            for(i in schedules){
                o = schedules[i];
                if (o.name !== self.name) continue;
                // While this element already has a starting transition during this frame,
                // defer starting an interrupting transition until that transition has a
                // chance to tick (and possibly end); see d3/d3-transition#54!
                if (o.state === STARTED) return timeout(start);
                // Interrupt the active transition, if any.
                if (o.state === RUNNING) {
                    o.state = ENDED;
                    o.timer.stop();
                    o.on.call("interrupt", node, node.__data__, o.index, o.group);
                    delete schedules[i];
                } else if (+i < id) {
                    o.state = ENDED;
                    o.timer.stop();
                    o.on.call("cancel", node, node.__data__, o.index, o.group);
                    delete schedules[i];
                }
            }
            // Defer the first tick to end of the current frame; see d3/d3#1576.
            // Note the transition may be canceled after start and before the first tick!
            // Note this must be scheduled before the start event; see d3/d3-transition#16!
            // Assuming this is successful, subsequent callbacks go straight to tick.
            timeout(function() {
                if (self.state === STARTED) {
                    self.state = RUNNING;
                    self.timer.restart(tick, self.delay, self.time);
                    tick(elapsed);
                }
            });
            // Dispatch the start event.
            // Note this must be done before the tween are initialized.
            self.state = STARTING;
            self.on.call("start", node, node.__data__, self.index, self.group);
            if (self.state !== STARTING) return; // interrupted
            self.state = STARTED;
            // Initialize the tween, deleting null tween.
            tween = new Array(n = self.tween.length);
            for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
            tween.length = j + 1;
        }
        function tick(elapsed) {
            var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1), i = -1, n = tween.length;
            while(++i < n)tween[i].call(node, t);
            // Dispatch the end event.
            if (self.state === ENDING) {
                self.on.call("end", node, node.__data__, self.index, self.group);
                stop();
            }
        }
        function stop() {
            self.state = ENDED;
            self.timer.stop();
            delete schedules[id];
            for(var i in schedules)return; // eslint-disable-line no-unused-vars
            delete node.__transition;
        }
    }
    function interrupt(node, name) {
        var schedules = node.__transition, schedule, active, empty = true, i;
        if (!schedules) return;
        name = name == null ? null : name + "";
        for(i in schedules){
            if ((schedule = schedules[i]).name !== name) {
                empty = false;
                continue;
            }
            active = schedule.state > STARTING && schedule.state < ENDING;
            schedule.state = ENDED;
            schedule.timer.stop();
            schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
            delete schedules[i];
        }
        if (empty) delete node.__transition;
    }
    function selection_interrupt(name) {
        return this.each(function() {
            interrupt(this, name);
        });
    }
    function tweenRemove(id, name) {
        var tween0, tween1;
        return function() {
            var schedule = set(this, id), tween = schedule.tween;
            // If this node shared tween with the previous node,
            // just assign the updated shared tween and we’re done!
            // Otherwise, copy-on-write.
            if (tween !== tween0) {
                tween1 = tween0 = tween;
                for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                    tween1 = tween1.slice();
                    tween1.splice(i, 1);
                    break;
                }
            }
            schedule.tween = tween1;
        };
    }
    function tweenFunction(id, name, value) {
        var tween0, tween1;
        if (typeof value !== "function") throw new Error;
        return function() {
            var schedule = set(this, id), tween = schedule.tween;
            // If this node shared tween with the previous node,
            // just assign the updated shared tween and we’re done!
            // Otherwise, copy-on-write.
            if (tween !== tween0) {
                tween1 = (tween0 = tween).slice();
                for(var t = {
                    name: name,
                    value: value
                }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                    tween1[i] = t;
                    break;
                }
                if (i === n) tween1.push(t);
            }
            schedule.tween = tween1;
        };
    }
    function transition_tween(name, value) {
        var id = this._id;
        name += "";
        if (arguments.length < 2) {
            var tween = get(this.node(), id).tween;
            for(var i = 0, n = tween.length, t; i < n; ++i){
                if ((t = tween[i]).name === name) return t.value;
            }
            return null;
        }
        return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
    }
    function tweenValue(transition, name, value) {
        var id = transition._id;
        transition.each(function() {
            var schedule = set(this, id);
            (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
        });
        return function(node) {
            return get(node, id).value[name];
        };
    }
    function interpolate$1(a, b) {
        var c;
        return (typeof b === "number" ? interpolateNumber : b instanceof color ? interpolateRgb : (c = color(b)) ? (b = c, interpolateRgb) : interpolateString)(a, b);
    }
    function attrRemove(name) {
        return function() {
            this.removeAttribute(name);
        };
    }
    function attrRemoveNS(fullname) {
        return function() {
            this.removeAttributeNS(fullname.space, fullname.local);
        };
    }
    function attrConstant(name, interpolate, value1) {
        var string00, string1 = value1 + "", interpolate0;
        return function() {
            var string0 = this.getAttribute(name);
            return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
        };
    }
    function attrConstantNS(fullname, interpolate, value1) {
        var string00, string1 = value1 + "", interpolate0;
        return function() {
            var string0 = this.getAttributeNS(fullname.space, fullname.local);
            return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
        };
    }
    function attrFunction(name, interpolate, value) {
        var string00, string10, interpolate0;
        return function() {
            var string0, value1 = value(this), string1;
            if (value1 == null) return void this.removeAttribute(name);
            string0 = this.getAttribute(name);
            string1 = value1 + "";
            return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
        };
    }
    function attrFunctionNS(fullname, interpolate, value) {
        var string00, string10, interpolate0;
        return function() {
            var string0, value1 = value(this), string1;
            if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
            string0 = this.getAttributeNS(fullname.space, fullname.local);
            string1 = value1 + "";
            return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
        };
    }
    function transition_attr(name, value) {
        var fullname = namespace(name), i = fullname === "transform" ? interpolateTransformSvg : interpolate$1;
        return this.attrTween(name, typeof value === "function" ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, tweenValue(this, "attr." + name, value)) : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname) : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value));
    }
    function attrInterpolate(name, i) {
        return function(t) {
            this.setAttribute(name, i.call(this, t));
        };
    }
    function attrInterpolateNS(fullname, i) {
        return function(t) {
            this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
        };
    }
    function attrTweenNS(fullname, value) {
        var t0, i0;
        function tween() {
            var i = value.apply(this, arguments);
            if (i !== i0) t0 = (i0 = i) && attrInterpolateNS(fullname, i);
            return t0;
        }
        tween._value = value;
        return tween;
    }
    function attrTween(name, value) {
        var t0, i0;
        function tween() {
            var i = value.apply(this, arguments);
            if (i !== i0) t0 = (i0 = i) && attrInterpolate(name, i);
            return t0;
        }
        tween._value = value;
        return tween;
    }
    function transition_attrTween(name, value) {
        var key = "attr." + name;
        if (arguments.length < 2) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        var fullname = namespace(name);
        return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
    }
    function delayFunction(id, value) {
        return function() {
            init(this, id).delay = +value.apply(this, arguments);
        };
    }
    function delayConstant(id, value) {
        return value = +value, function() {
            init(this, id).delay = value;
        };
    }
    function transition_delay(value) {
        var id = this._id;
        return arguments.length ? this.each((typeof value === "function" ? delayFunction : delayConstant)(id, value)) : get(this.node(), id).delay;
    }
    function durationFunction(id, value) {
        return function() {
            set(this, id).duration = +value.apply(this, arguments);
        };
    }
    function durationConstant(id, value) {
        return value = +value, function() {
            set(this, id).duration = value;
        };
    }
    function transition_duration(value) {
        var id = this._id;
        return arguments.length ? this.each((typeof value === "function" ? durationFunction : durationConstant)(id, value)) : get(this.node(), id).duration;
    }
    function easeConstant(id, value) {
        if (typeof value !== "function") throw new Error;
        return function() {
            set(this, id).ease = value;
        };
    }
    function transition_ease(value) {
        var id = this._id;
        return arguments.length ? this.each(easeConstant(id, value)) : get(this.node(), id).ease;
    }
    function easeVarying(id, value) {
        return function() {
            var v = value.apply(this, arguments);
            if (typeof v !== "function") throw new Error;
            set(this, id).ease = v;
        };
    }
    function transition_easeVarying(value) {
        if (typeof value !== "function") throw new Error;
        return this.each(easeVarying(this._id, value));
    }
    function transition_filter(match) {
        if (typeof match !== "function") match = matcher(match);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
        }
        return new Transition(subgroups, this._parents, this._name, this._id);
    }
    function transition_merge(transition) {
        if (transition._id !== this._id) throw new Error;
        for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
            for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
        }
        for(; j < m0; ++j)merges[j] = groups0[j];
        return new Transition(merges, this._parents, this._name, this._id);
    }
    function start(name) {
        return (name + "").trim().split(/^|\s+/).every(function(t) {
            var i = t.indexOf(".");
            if (i >= 0) t = t.slice(0, i);
            return !t || t === "start";
        });
    }
    function onFunction(id, name, listener) {
        var on0, on1, sit = start(name) ? init : set;
        return function() {
            var schedule = sit(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
            schedule.on = on1;
        };
    }
    function transition_on(name, listener) {
        var id = this._id;
        return arguments.length < 2 ? get(this.node(), id).on.on(name) : this.each(onFunction(id, name, listener));
    }
    function removeFunction(id) {
        return function() {
            var parent = this.parentNode;
            for(var i in this.__transition)if (+i !== id) return;
            if (parent) parent.removeChild(this);
        };
    }
    function transition_remove() {
        return this.on("end.remove", removeFunction(this._id));
    }
    function transition_select(select) {
        var name = this._name, id = this._id;
        if (typeof select !== "function") select = selector(select);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
                if ("__data__" in node) subnode.__data__ = node.__data__;
                subgroup[i] = subnode;
                schedule(subgroup[i], name, id, i, subgroup, get(node, id));
            }
        }
        return new Transition(subgroups, this._parents, name, id);
    }
    function transition_selectAll(select) {
        var name = this._name, id = this._id;
        if (typeof select !== "function") select = selectorAll(select);
        for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                for(var children = select.call(node, node.__data__, i, group), child, inherit = get(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) schedule(child, name, id, k, children, inherit);
                subgroups.push(children);
                parents.push(node);
            }
        }
        return new Transition(subgroups, parents, name, id);
    }
    var Selection = selection.prototype.constructor;
    function transition_selection() {
        return new Selection(this._groups, this._parents);
    }
    function styleNull(name, interpolate) {
        var string00, string10, interpolate0;
        return function() {
            var string0 = styleValue(this, name), string1 = (this.style.removeProperty(name), styleValue(this, name));
            return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
        };
    }
    function styleRemove(name) {
        return function() {
            this.style.removeProperty(name);
        };
    }
    function styleConstant(name, interpolate, value1) {
        var string00, string1 = value1 + "", interpolate0;
        return function() {
            var string0 = styleValue(this, name);
            return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
        };
    }
    function styleFunction(name, interpolate, value) {
        var string00, string10, interpolate0;
        return function() {
            var string0 = styleValue(this, name), value1 = value(this), string1 = value1 + "";
            if (value1 == null) string1 = value1 = (this.style.removeProperty(name), styleValue(this, name));
            return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
        };
    }
    function styleMaybeRemove(id, name) {
        var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
        return function() {
            var schedule = set(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = styleRemove(name)) : undefined;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
            schedule.on = on1;
        };
    }
    function transition_style(name, value, priority) {
        var i = (name += "") === "transform" ? interpolateTransformCss : interpolate$1;
        return value == null ? this.styleTween(name, styleNull(name, i)).on("end.style." + name, styleRemove(name)) : typeof value === "function" ? this.styleTween(name, styleFunction(name, i, tweenValue(this, "style." + name, value))).each(styleMaybeRemove(this._id, name)) : this.styleTween(name, styleConstant(name, i, value), priority).on("end.style." + name, null);
    }
    function styleInterpolate(name, i, priority) {
        return function(t) {
            this.style.setProperty(name, i.call(this, t), priority);
        };
    }
    function styleTween(name, value, priority) {
        var t, i0;
        function tween() {
            var i = value.apply(this, arguments);
            if (i !== i0) t = (i0 = i) && styleInterpolate(name, i, priority);
            return t;
        }
        tween._value = value;
        return tween;
    }
    function transition_styleTween(name, value, priority) {
        var key = "style." + (name += "");
        if (arguments.length < 2) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
    }
    function textConstant(value) {
        return function() {
            this.textContent = value;
        };
    }
    function textFunction(value) {
        return function() {
            var value1 = value(this);
            this.textContent = value1 == null ? "" : value1;
        };
    }
    function transition_text(value) {
        return this.tween("text", typeof value === "function" ? textFunction(tweenValue(this, "text", value)) : textConstant(value == null ? "" : value + ""));
    }
    function textInterpolate(i) {
        return function(t) {
            this.textContent = i.call(this, t);
        };
    }
    function textTween(value) {
        var t0, i0;
        function tween() {
            var i = value.apply(this, arguments);
            if (i !== i0) t0 = (i0 = i) && textInterpolate(i);
            return t0;
        }
        tween._value = value;
        return tween;
    }
    function transition_textTween(value) {
        var key = "text";
        if (arguments.length < 1) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        return this.tween(key, textTween(value));
    }
    function transition_transition() {
        var name = this._name, id0 = this._id, id1 = newId();
        for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                var inherit = get(node, id0);
                schedule(node, name, id1, i, group, {
                    time: inherit.time + inherit.delay + inherit.duration,
                    delay: 0,
                    duration: inherit.duration,
                    ease: inherit.ease
                });
            }
        }
        return new Transition(groups, this._parents, name, id1);
    }
    function transition_end() {
        var on0, on1, that = this, id = that._id, size = that.size();
        return new Promise(function(resolve, reject) {
            var cancel = {
                value: reject
            }, end = {
                value: function() {
                    if (--size === 0) resolve();
                }
            };
            that.each(function() {
                var schedule = set(this, id), on = schedule.on;
                // If this node shared a dispatch with the previous node,
                // just assign the updated shared dispatch and we’re done!
                // Otherwise, copy-on-write.
                if (on !== on0) {
                    on1 = (on0 = on).copy();
                    on1._.cancel.push(cancel);
                    on1._.interrupt.push(cancel);
                    on1._.end.push(end);
                }
                schedule.on = on1;
            });
            // The selection was empty, resolve end immediately
            if (size === 0) resolve();
        });
    }
    var id = 0;
    function Transition(groups, parents, name, id) {
        this._groups = groups;
        this._parents = parents;
        this._name = name;
        this._id = id;
    }
    function transition(name) {
        return selection().transition(name);
    }
    function newId() {
        return ++id;
    }
    var selection_prototype = selection.prototype;
    Transition.prototype = transition.prototype = {
        constructor: Transition,
        select: transition_select,
        selectAll: transition_selectAll,
        selectChild: selection_prototype.selectChild,
        selectChildren: selection_prototype.selectChildren,
        filter: transition_filter,
        merge: transition_merge,
        selection: transition_selection,
        transition: transition_transition,
        call: selection_prototype.call,
        nodes: selection_prototype.nodes,
        node: selection_prototype.node,
        size: selection_prototype.size,
        empty: selection_prototype.empty,
        each: selection_prototype.each,
        on: transition_on,
        attr: transition_attr,
        attrTween: transition_attrTween,
        style: transition_style,
        styleTween: transition_styleTween,
        text: transition_text,
        textTween: transition_textTween,
        remove: transition_remove,
        tween: transition_tween,
        delay: transition_delay,
        duration: transition_duration,
        ease: transition_ease,
        easeVarying: transition_easeVarying,
        end: transition_end,
        [Symbol.iterator]: selection_prototype[Symbol.iterator]
    };
    const linear$1 = (t)=>+t;
    function quadIn(t) {
        return t * t;
    }
    function quadOut(t) {
        return t * (2 - t);
    }
    function quadInOut(t) {
        return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
    }
    function cubicIn(t) {
        return t * t * t;
    }
    function cubicOut(t) {
        return --t * t * t + 1;
    }
    function cubicInOut(t) {
        return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
    }
    var exponent$1 = 3;
    var polyIn = function custom(e) {
        e = +e;
        function polyIn(t) {
            return Math.pow(t, e);
        }
        polyIn.exponent = custom;
        return polyIn;
    }(exponent$1);
    var polyOut = function custom(e) {
        e = +e;
        function polyOut(t) {
            return 1 - Math.pow(1 - t, e);
        }
        polyOut.exponent = custom;
        return polyOut;
    }(exponent$1);
    var polyInOut = function custom(e) {
        e = +e;
        function polyInOut(t) {
            return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
        }
        polyInOut.exponent = custom;
        return polyInOut;
    }(exponent$1);
    var pi$4 = Math.PI, halfPi$3 = pi$4 / 2;
    function sinIn(t) {
        return +t === 1 ? 1 : 1 - Math.cos(t * halfPi$3);
    }
    function sinOut(t) {
        return Math.sin(t * halfPi$3);
    }
    function sinInOut(t) {
        return (1 - Math.cos(pi$4 * t)) / 2;
    }
    // tpmt is two power minus ten times t scaled to [0,1]
    function tpmt(x) {
        return (Math.pow(2, -10 * x) - 0.0009765625) * 1.0009775171065494;
    }
    function expIn(t) {
        return tpmt(1 - +t);
    }
    function expOut(t) {
        return 1 - tpmt(t);
    }
    function expInOut(t) {
        return ((t *= 2) <= 1 ? tpmt(1 - t) : 2 - tpmt(t - 1)) / 2;
    }
    function circleIn(t) {
        return 1 - Math.sqrt(1 - t * t);
    }
    function circleOut(t) {
        return Math.sqrt(1 - --t * t);
    }
    function circleInOut(t) {
        return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
    }
    var b1 = 4 / 11, b2 = 6 / 11, b3 = 8 / 11, b4 = 3 / 4, b5 = 9 / 11, b6 = 10 / 11, b7 = 15 / 16, b8 = 21 / 22, b9 = 63 / 64, b0 = 1 / b1 / b1;
    function bounceIn(t) {
        return 1 - bounceOut(1 - t);
    }
    function bounceOut(t) {
        return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
    }
    function bounceInOut(t) {
        return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
    }
    var overshoot = 1.70158;
    var backIn = function custom(s) {
        s = +s;
        function backIn(t) {
            return (t = +t) * t * (s * (t - 1) + t);
        }
        backIn.overshoot = custom;
        return backIn;
    }(overshoot);
    var backOut = function custom(s) {
        s = +s;
        function backOut(t) {
            return --t * t * ((t + 1) * s + t) + 1;
        }
        backOut.overshoot = custom;
        return backOut;
    }(overshoot);
    var backInOut = function custom(s) {
        s = +s;
        function backInOut(t) {
            return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
        }
        backInOut.overshoot = custom;
        return backInOut;
    }(overshoot);
    var tau$5 = 2 * Math.PI, amplitude = 1, period = 0.3;
    var elasticIn = function custom(a, p) {
        var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau$5);
        function elasticIn(t) {
            return a * tpmt(- --t) * Math.sin((s - t) / p);
        }
        elasticIn.amplitude = function(a) {
            return custom(a, p * tau$5);
        };
        elasticIn.period = function(p) {
            return custom(a, p);
        };
        return elasticIn;
    }(amplitude, period);
    var elasticOut = function custom(a, p) {
        var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau$5);
        function elasticOut(t) {
            return 1 - a * tpmt(t = +t) * Math.sin((t + s) / p);
        }
        elasticOut.amplitude = function(a) {
            return custom(a, p * tau$5);
        };
        elasticOut.period = function(p) {
            return custom(a, p);
        };
        return elasticOut;
    }(amplitude, period);
    var elasticInOut = function custom(a, p) {
        var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau$5);
        function elasticInOut(t) {
            return ((t = t * 2 - 1) < 0 ? a * tpmt(-t) * Math.sin((s - t) / p) : 2 - a * tpmt(t) * Math.sin((s + t) / p)) / 2;
        }
        elasticInOut.amplitude = function(a) {
            return custom(a, p * tau$5);
        };
        elasticInOut.period = function(p) {
            return custom(a, p);
        };
        return elasticInOut;
    }(amplitude, period);
    var defaultTiming = {
        time: null,
        delay: 0,
        duration: 250,
        ease: cubicInOut
    };
    function inherit(node, id) {
        var timing;
        while(!(timing = node.__transition) || !(timing = timing[id])){
            if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
        }
        return timing;
    }
    function selection_transition(name) {
        var id, timing;
        if (name instanceof Transition) id = name._id, name = name._name;
        else id = newId(), (timing = defaultTiming).time = now(), name = name == null ? null : name + "";
        for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) schedule(node, name, id, i, group, timing || inherit(node, id));
        }
        return new Transition(groups, this._parents, name, id);
    }
    selection.prototype.interrupt = selection_interrupt;
    selection.prototype.transition = selection_transition;
    var root = [
        null
    ];
    function active(node, name) {
        var schedules = node.__transition, schedule, i;
        if (schedules) {
            name = name == null ? null : name + "";
            for(i in schedules){
                if ((schedule = schedules[i]).state > SCHEDULED && schedule.name === name) return new Transition([
                    [
                        node
                    ]
                ], root, name, +i);
            }
        }
        return null;
    }
    var constant$7 = (x)=>()=>x;
    function BrushEvent(type, { sourceEvent: sourceEvent, target: target, selection: selection, mode: mode, dispatch: dispatch }) {
        Object.defineProperties(this, {
            type: {
                value: type,
                enumerable: true,
                configurable: true
            },
            sourceEvent: {
                value: sourceEvent,
                enumerable: true,
                configurable: true
            },
            target: {
                value: target,
                enumerable: true,
                configurable: true
            },
            selection: {
                value: selection,
                enumerable: true,
                configurable: true
            },
            mode: {
                value: mode,
                enumerable: true,
                configurable: true
            },
            _: {
                value: dispatch
            }
        });
    }
    function nopropagation$1(event) {
        event.stopImmediatePropagation();
    }
    function noevent$1(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    }
    var MODE_DRAG = {
        name: "drag"
    }, MODE_SPACE = {
        name: "space"
    }, MODE_HANDLE = {
        name: "handle"
    }, MODE_CENTER = {
        name: "center"
    };
    const { abs: abs$3, max: max$2, min: min$1 } = Math;
    function number1(e) {
        return [
            +e[0],
            +e[1]
        ];
    }
    function number2(e) {
        return [
            number1(e[0]),
            number1(e[1])
        ];
    }
    var X = {
        name: "x",
        handles: [
            "w",
            "e"
        ].map(type),
        input: function(x, e) {
            return x == null ? null : [
                [
                    +x[0],
                    e[0][1]
                ],
                [
                    +x[1],
                    e[1][1]
                ]
            ];
        },
        output: function(xy) {
            return xy && [
                xy[0][0],
                xy[1][0]
            ];
        }
    };
    var Y = {
        name: "y",
        handles: [
            "n",
            "s"
        ].map(type),
        input: function(y, e) {
            return y == null ? null : [
                [
                    e[0][0],
                    +y[0]
                ],
                [
                    e[1][0],
                    +y[1]
                ]
            ];
        },
        output: function(xy) {
            return xy && [
                xy[0][1],
                xy[1][1]
            ];
        }
    };
    var XY = {
        name: "xy",
        handles: [
            "n",
            "w",
            "e",
            "s",
            "nw",
            "ne",
            "sw",
            "se"
        ].map(type),
        input: function(xy) {
            return xy == null ? null : number2(xy);
        },
        output: function(xy) {
            return xy;
        }
    };
    var cursors = {
        overlay: "crosshair",
        selection: "move",
        n: "ns-resize",
        e: "ew-resize",
        s: "ns-resize",
        w: "ew-resize",
        nw: "nwse-resize",
        ne: "nesw-resize",
        se: "nwse-resize",
        sw: "nesw-resize"
    };
    var flipX = {
        e: "w",
        w: "e",
        nw: "ne",
        ne: "nw",
        se: "sw",
        sw: "se"
    };
    var flipY = {
        n: "s",
        s: "n",
        nw: "sw",
        ne: "se",
        se: "ne",
        sw: "nw"
    };
    var signsX = {
        overlay: 1,
        selection: 1,
        n: null,
        e: 1,
        s: null,
        w: -1,
        nw: -1,
        ne: 1,
        se: 1,
        sw: -1
    };
    var signsY = {
        overlay: 1,
        selection: 1,
        n: -1,
        e: null,
        s: 1,
        w: null,
        nw: -1,
        ne: -1,
        se: 1,
        sw: 1
    };
    function type(t) {
        return {
            type: t
        };
    }
    // Ignore right-click, since that should open the context menu.
    function defaultFilter$1(event) {
        return !event.ctrlKey && !event.button;
    }
    function defaultExtent$1() {
        var svg = this.ownerSVGElement || this;
        if (svg.hasAttribute("viewBox")) {
            svg = svg.viewBox.baseVal;
            return [
                [
                    svg.x,
                    svg.y
                ],
                [
                    svg.x + svg.width,
                    svg.y + svg.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                svg.width.baseVal.value,
                svg.height.baseVal.value
            ]
        ];
    }
    function defaultTouchable$1() {
        return navigator.maxTouchPoints || "ontouchstart" in this;
    }
    // Like d3.local, but with the name “__brush” rather than auto-generated.
    function local(node) {
        while(!node.__brush)if (!(node = node.parentNode)) return;
        return node.__brush;
    }
    function empty(extent) {
        return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
    }
    function brushSelection(node) {
        var state = node.__brush;
        return state ? state.dim.output(state.selection) : null;
    }
    function brushX() {
        return brush$1(X);
    }
    function brushY() {
        return brush$1(Y);
    }
    function brush() {
        return brush$1(XY);
    }
    function brush$1(dim) {
        var extent = defaultExtent$1, filter = defaultFilter$1, touchable = defaultTouchable$1, keys = true, listeners = dispatch("start", "brush", "end"), handleSize = 6, touchending;
        function brush(group) {
            var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
                type("overlay")
            ]);
            overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", cursors.overlay).merge(overlay).each(function() {
                var extent = local(this).extent;
                select(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
            });
            group.selectAll(".selection").data([
                type("selection")
            ]).enter().append("rect").attr("class", "selection").attr("cursor", cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
            var handle = group.selectAll(".handle").data(dim.handles, function(d) {
                return d.type;
            });
            handle.exit().remove();
            handle.enter().append("rect").attr("class", function(d) {
                return "handle handle--" + d.type;
            }).attr("cursor", function(d) {
                return cursors[d.type];
            });
            group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
        }
        brush.move = function(group, selection, event) {
            if (group.tween) group.on("start.brush", function(event) {
                emitter(this, arguments).beforestart().start(event);
            }).on("interrupt.brush end.brush", function(event) {
                emitter(this, arguments).end(event);
            }).tween("brush", function() {
                var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = interpolate$2(selection0, selection1);
                function tween(t) {
                    state.selection = t === 1 && selection1 === null ? null : i(t);
                    redraw.call(that);
                    emit.brush();
                }
                return selection0 !== null && selection1 !== null ? tween : tween(1);
            });
            else group.each(function() {
                var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
                interrupt(that);
                state.selection = selection1 === null ? null : selection1;
                redraw.call(that);
                emit.start(event).brush(event).end(event);
            });
        };
        brush.clear = function(group, event) {
            brush.move(group, null, event);
        };
        function redraw() {
            var group = select(this), selection = local(this).selection;
            if (selection) {
                group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
                group.selectAll(".handle").style("display", null).attr("x", function(d) {
                    return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
                }).attr("y", function(d) {
                    return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
                }).attr("width", function(d) {
                    return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
                }).attr("height", function(d) {
                    return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
                });
            } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
        }
        function emitter(that, args, clean) {
            var emit = that.__brush.emitter;
            return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
        }
        function Emitter(that, args, clean) {
            this.that = that;
            this.args = args;
            this.state = that.__brush;
            this.active = 0;
            this.clean = clean;
        }
        Emitter.prototype = {
            beforestart: function() {
                if (++this.active === 1) this.state.emitter = this, this.starting = true;
                return this;
            },
            start: function(event, mode) {
                if (this.starting) this.starting = false, this.emit("start", event, mode);
                else this.emit("brush", event);
                return this;
            },
            brush: function(event, mode) {
                this.emit("brush", event, mode);
                return this;
            },
            end: function(event, mode) {
                if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
                return this;
            },
            emit: function(type, event, mode) {
                var d = select(this.that).datum();
                listeners.call(type, this.that, new BrushEvent(type, {
                    sourceEvent: event,
                    target: brush,
                    selection: dim.output(this.state.selection),
                    mode: mode,
                    dispatch: listeners
                }), d);
            }
        };
        function started(event) {
            if (touchending && !event.touches) return;
            if (!filter.apply(this, arguments)) return;
            var that = this, type = event.target.__data__.type, mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : keys && event.altKey ? MODE_CENTER : MODE_HANDLE, signX = dim === Y ? null : signsX[type], signY = dim === X ? null : signsY[type], state = local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [
                event
            ], (t)=>{
                const i = t.identifier;
                t = pointer(t, that);
                t.point0 = t.slice();
                t.identifier = i;
                return t;
            });
            interrupt(that);
            var emit = emitter(that, arguments, true).beforestart();
            if (type === "overlay") {
                if (selection) moving = true;
                const pts = [
                    points[0],
                    points[1] || points[0]
                ];
                state.selection = selection = [
                    [
                        w0 = dim === Y ? W : min$1(pts[0][0], pts[1][0]),
                        n0 = dim === X ? N : min$1(pts[0][1], pts[1][1])
                    ],
                    [
                        e0 = dim === Y ? E : max$2(pts[0][0], pts[1][0]),
                        s0 = dim === X ? S : max$2(pts[0][1], pts[1][1])
                    ]
                ];
                if (points.length > 1) move(event);
            } else {
                w0 = selection[0][0];
                n0 = selection[0][1];
                e0 = selection[1][0];
                s0 = selection[1][1];
            }
            w1 = w0;
            n1 = n0;
            e1 = e0;
            s1 = s0;
            var group = select(that).attr("pointer-events", "none");
            var overlay = group.selectAll(".overlay").attr("cursor", cursors[type]);
            if (event.touches) {
                emit.moved = moved;
                emit.ended = ended;
            } else {
                var view = select(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
                if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
                dragDisable(event.view);
            }
            redraw.call(that);
            emit.start(event, mode.name);
            function moved(event) {
                for (const p of event.changedTouches || [
                    event
                ]){
                    for (const d of points)if (d.identifier === p.identifier) d.cur = pointer(p, that);
                }
                if (shifting && !lockX && !lockY && points.length === 1) {
                    const point = points[0];
                    if (abs$3(point.cur[0] - point[0]) > abs$3(point.cur[1] - point[1])) lockY = true;
                    else lockX = true;
                }
                for (const point of points)if (point.cur) point[0] = point.cur[0], point[1] = point.cur[1];
                moving = true;
                noevent$1(event);
                move(event);
            }
            function move(event) {
                const point = points[0], point0 = point.point0;
                var t;
                dx = point[0] - point0[0];
                dy = point[1] - point0[1];
                switch(mode){
                    case MODE_SPACE:
                    case MODE_DRAG:
                        if (signX) dx = max$2(W - w0, min$1(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                        if (signY) dy = max$2(N - n0, min$1(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                        break;
                    case MODE_HANDLE:
                        if (points[1]) {
                            if (signX) w1 = max$2(W, min$1(E, points[0][0])), e1 = max$2(W, min$1(E, points[1][0])), signX = 1;
                            if (signY) n1 = max$2(N, min$1(S, points[0][1])), s1 = max$2(N, min$1(S, points[1][1])), signY = 1;
                        } else {
                            if (signX < 0) dx = max$2(W - w0, min$1(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                            else if (signX > 0) dx = max$2(W - e0, min$1(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                            if (signY < 0) dy = max$2(N - n0, min$1(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                            else if (signY > 0) dy = max$2(N - s0, min$1(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                        }
                        break;
                    case MODE_CENTER:
                        if (signX) w1 = max$2(W, min$1(E, w0 - dx * signX)), e1 = max$2(W, min$1(E, e0 + dx * signX));
                        if (signY) n1 = max$2(N, min$1(S, n0 - dy * signY)), s1 = max$2(N, min$1(S, s0 + dy * signY));
                        break;
                }
                if (e1 < w1) {
                    signX *= -1;
                    t = w0, w0 = e0, e0 = t;
                    t = w1, w1 = e1, e1 = t;
                    if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
                }
                if (s1 < n1) {
                    signY *= -1;
                    t = n0, n0 = s0, s0 = t;
                    t = n1, n1 = s1, s1 = t;
                    if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
                }
                if (state.selection) selection = state.selection; // May be set by brush.move!
                if (lockX) w1 = selection[0][0], e1 = selection[1][0];
                if (lockY) n1 = selection[0][1], s1 = selection[1][1];
                if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                    state.selection = [
                        [
                            w1,
                            n1
                        ],
                        [
                            e1,
                            s1
                        ]
                    ];
                    redraw.call(that);
                    emit.brush(event, mode.name);
                }
            }
            function ended(event) {
                nopropagation$1(event);
                if (event.touches) {
                    if (event.touches.length) return;
                    if (touchending) clearTimeout(touchending);
                    touchending = setTimeout(function() {
                        touchending = null;
                    }, 500); // Ghost clicks are delayed!
                } else {
                    yesdrag(event.view, moving);
                    view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
                }
                group.attr("pointer-events", "all");
                overlay.attr("cursor", cursors.overlay);
                if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
                if (empty(selection)) state.selection = null, redraw.call(that);
                emit.end(event, mode.name);
            }
            function keydowned(event) {
                switch(event.keyCode){
                    case 16:
                        shifting = signX && signY;
                        break;
                    case 18:
                        if (mode === MODE_HANDLE) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = MODE_CENTER;
                            move(event);
                        }
                        break;
                    case 32:
                        if (mode === MODE_HANDLE || mode === MODE_CENTER) {
                            if (signX < 0) e0 = e1 - dx;
                            else if (signX > 0) w0 = w1 - dx;
                            if (signY < 0) s0 = s1 - dy;
                            else if (signY > 0) n0 = n1 - dy;
                            mode = MODE_SPACE;
                            overlay.attr("cursor", cursors.selection);
                            move(event);
                        }
                        break;
                    default:
                        return;
                }
                noevent$1(event);
            }
            function keyupped(event) {
                switch(event.keyCode){
                    case 16:
                        if (shifting) {
                            lockX = lockY = shifting = false;
                            move(event);
                        }
                        break;
                    case 18:
                        if (mode === MODE_CENTER) {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = MODE_HANDLE;
                            move(event);
                        }
                        break;
                    case 32:
                        if (mode === MODE_SPACE) {
                            if (event.altKey) {
                                if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                                if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                                mode = MODE_CENTER;
                            } else {
                                if (signX < 0) e0 = e1;
                                else if (signX > 0) w0 = w1;
                                if (signY < 0) s0 = s1;
                                else if (signY > 0) n0 = n1;
                                mode = MODE_HANDLE;
                            }
                            overlay.attr("cursor", cursors[type]);
                            move(event);
                        }
                        break;
                    default:
                        return;
                }
                noevent$1(event);
            }
        }
        function touchmoved(event) {
            emitter(this, arguments).moved(event);
        }
        function touchended(event) {
            emitter(this, arguments).ended(event);
        }
        function initialize() {
            var state = this.__brush || {
                selection: null
            };
            state.extent = number2(extent.apply(this, arguments));
            state.dim = dim;
            return state;
        }
        brush.extent = function(_) {
            return arguments.length ? (extent = typeof _ === "function" ? _ : constant$7(number2(_)), brush) : extent;
        };
        brush.filter = function(_) {
            return arguments.length ? (filter = typeof _ === "function" ? _ : constant$7(!!_), brush) : filter;
        };
        brush.touchable = function(_) {
            return arguments.length ? (touchable = typeof _ === "function" ? _ : constant$7(!!_), brush) : touchable;
        };
        brush.handleSize = function(_) {
            return arguments.length ? (handleSize = +_, brush) : handleSize;
        };
        brush.keyModifiers = function(_) {
            return arguments.length ? (keys = !!_, brush) : keys;
        };
        brush.on = function() {
            var value = listeners.on.apply(listeners, arguments);
            return value === listeners ? brush : value;
        };
        return brush;
    }
    var abs$2 = Math.abs;
    var cos$2 = Math.cos;
    var sin$2 = Math.sin;
    var pi$3 = Math.PI;
    var halfPi$2 = pi$3 / 2;
    var tau$4 = pi$3 * 2;
    var max$1 = Math.max;
    var epsilon$5 = 1e-12;
    function range$1(i, j) {
        return Array.from({
            length: j - i
        }, (_, k)=>i + k);
    }
    function compareValue(compare) {
        return function(a, b) {
            return compare(a.source.value + a.target.value, b.source.value + b.target.value);
        };
    }
    function chord() {
        return chord$1(false, false);
    }
    function chordTranspose() {
        return chord$1(false, true);
    }
    function chordDirected() {
        return chord$1(true, false);
    }
    function chord$1(directed, transpose) {
        var padAngle = 0, sortGroups = null, sortSubgroups = null, sortChords = null;
        function chord(matrix) {
            var n = matrix.length, groupSums = new Array(n), groupIndex = range$1(0, n), chords = new Array(n * n), groups = new Array(n), k = 0, dx;
            matrix = Float64Array.from({
                length: n * n
            }, transpose ? (_, i)=>matrix[i % n][i / n | 0] : (_, i)=>matrix[i / n | 0][i % n]);
            // Compute the scaling factor from value to angle in [0, 2pi].
            for(let i = 0; i < n; ++i){
                let x = 0;
                for(let j = 0; j < n; ++j)x += matrix[i * n + j] + directed * matrix[j * n + i];
                k += groupSums[i] = x;
            }
            k = max$1(0, tau$4 - padAngle * n) / k;
            dx = k ? padAngle : tau$4 / n;
            // Compute the angles for each group and constituent chord.
            {
                let x = 0;
                if (sortGroups) groupIndex.sort((a, b)=>sortGroups(groupSums[a], groupSums[b]));
                for (const i of groupIndex){
                    const x0 = x;
                    if (directed) {
                        const subgroupIndex = range$1(~n + 1, n).filter((j)=>j < 0 ? matrix[~j * n + i] : matrix[i * n + j]);
                        if (sortSubgroups) subgroupIndex.sort((a, b)=>sortSubgroups(a < 0 ? -matrix[~a * n + i] : matrix[i * n + a], b < 0 ? -matrix[~b * n + i] : matrix[i * n + b]));
                        for (const j of subgroupIndex)if (j < 0) {
                            const chord = chords[~j * n + i] || (chords[~j * n + i] = {
                                source: null,
                                target: null
                            });
                            chord.target = {
                                index: i,
                                startAngle: x,
                                endAngle: x += matrix[~j * n + i] * k,
                                value: matrix[~j * n + i]
                            };
                        } else {
                            const chord = chords[i * n + j] || (chords[i * n + j] = {
                                source: null,
                                target: null
                            });
                            chord.source = {
                                index: i,
                                startAngle: x,
                                endAngle: x += matrix[i * n + j] * k,
                                value: matrix[i * n + j]
                            };
                        }
                        groups[i] = {
                            index: i,
                            startAngle: x0,
                            endAngle: x,
                            value: groupSums[i]
                        };
                    } else {
                        const subgroupIndex = range$1(0, n).filter((j)=>matrix[i * n + j] || matrix[j * n + i]);
                        if (sortSubgroups) subgroupIndex.sort((a, b)=>sortSubgroups(matrix[i * n + a], matrix[i * n + b]));
                        for (const j of subgroupIndex){
                            let chord;
                            if (i < j) {
                                chord = chords[i * n + j] || (chords[i * n + j] = {
                                    source: null,
                                    target: null
                                });
                                chord.source = {
                                    index: i,
                                    startAngle: x,
                                    endAngle: x += matrix[i * n + j] * k,
                                    value: matrix[i * n + j]
                                };
                            } else {
                                chord = chords[j * n + i] || (chords[j * n + i] = {
                                    source: null,
                                    target: null
                                });
                                chord.target = {
                                    index: i,
                                    startAngle: x,
                                    endAngle: x += matrix[i * n + j] * k,
                                    value: matrix[i * n + j]
                                };
                                if (i === j) chord.source = chord.target;
                            }
                            if (chord.source && chord.target && chord.source.value < chord.target.value) {
                                const source = chord.source;
                                chord.source = chord.target;
                                chord.target = source;
                            }
                        }
                        groups[i] = {
                            index: i,
                            startAngle: x0,
                            endAngle: x,
                            value: groupSums[i]
                        };
                    }
                    x += dx;
                }
            }
            // Remove empty chords.
            chords = Object.values(chords);
            chords.groups = groups;
            return sortChords ? chords.sort(sortChords) : chords;
        }
        chord.padAngle = function(_) {
            return arguments.length ? (padAngle = max$1(0, _), chord) : padAngle;
        };
        chord.sortGroups = function(_) {
            return arguments.length ? (sortGroups = _, chord) : sortGroups;
        };
        chord.sortSubgroups = function(_) {
            return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
        };
        chord.sortChords = function(_) {
            return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
        };
        return chord;
    }
    const pi$2 = Math.PI, tau$3 = 2 * pi$2, epsilon$4 = 1e-6, tauEpsilon = tau$3 - epsilon$4;
    function Path$1() {
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
    }
    function path() {
        return new Path$1;
    }
    Path$1.prototype = path.prototype = {
        constructor: Path$1,
        moveTo: function(x, y) {
            this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
        },
        closePath: function() {
            if (this._x1 !== null) {
                this._x1 = this._x0, this._y1 = this._y0;
                this._ += "Z";
            }
        },
        lineTo: function(x, y) {
            this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
        },
        quadraticCurveTo: function(x1, y1, x, y) {
            this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
        },
        bezierCurveTo: function(x1, y1, x2, y2, x, y) {
            this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
        },
        arcTo: function(x1, y1, x2, y2, r) {
            x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
            var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
            // Is the radius negative? Error.
            if (r < 0) throw new Error("negative radius: " + r);
            // Is this path empty? Move to (x1,y1).
            if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
            else if (!(l01_2 > epsilon$4)) ;
            else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon$4) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
            else {
                var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan((pi$2 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
                // If the start tangent is not coincident with (x0,y0), line to.
                if (Math.abs(t01 - 1) > epsilon$4) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
                this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
            }
        },
        arc: function(x, y, r, a0, a1, ccw) {
            x = +x, y = +y, r = +r, ccw = !!ccw;
            var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
            // Is the radius negative? Error.
            if (r < 0) throw new Error("negative radius: " + r);
            // Is this path empty? Move to (x0,y0).
            if (this._x1 === null) this._ += "M" + x0 + "," + y0;
            else if (Math.abs(this._x1 - x0) > epsilon$4 || Math.abs(this._y1 - y0) > epsilon$4) this._ += "L" + x0 + "," + y0;
            // Is this arc empty? We’re done.
            if (!r) return;
            // Does the angle go the wrong way? Flip the direction.
            if (da < 0) da = da % tau$3 + tau$3;
            // Is this a complete circle? Draw two arcs to complete the circle.
            if (da > tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
            else if (da > epsilon$4) this._ += "A" + r + "," + r + ",0," + +(da >= pi$2) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
        },
        rect: function(x, y, w, h) {
            this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
        },
        toString: function() {
            return this._;
        }
    };
    var slice$2 = Array.prototype.slice;
    function constant$6(x) {
        return function() {
            return x;
        };
    }
    function defaultSource$1(d) {
        return d.source;
    }
    function defaultTarget(d) {
        return d.target;
    }
    function defaultRadius$1(d) {
        return d.radius;
    }
    function defaultStartAngle(d) {
        return d.startAngle;
    }
    function defaultEndAngle(d) {
        return d.endAngle;
    }
    function defaultPadAngle() {
        return 0;
    }
    function defaultArrowheadRadius() {
        return 10;
    }
    function ribbon(headRadius) {
        var source = defaultSource$1, target = defaultTarget, sourceRadius = defaultRadius$1, targetRadius = defaultRadius$1, startAngle = defaultStartAngle, endAngle = defaultEndAngle, padAngle = defaultPadAngle, context = null;
        function ribbon() {
            var buffer, s = source.apply(this, arguments), t = target.apply(this, arguments), ap = padAngle.apply(this, arguments) / 2, argv = slice$2.call(arguments), sr = +sourceRadius.apply(this, (argv[0] = s, argv)), sa0 = startAngle.apply(this, argv) - halfPi$2, sa1 = endAngle.apply(this, argv) - halfPi$2, tr = +targetRadius.apply(this, (argv[0] = t, argv)), ta0 = startAngle.apply(this, argv) - halfPi$2, ta1 = endAngle.apply(this, argv) - halfPi$2;
            if (!context) context = buffer = path();
            if (ap > epsilon$5) {
                if (abs$2(sa1 - sa0) > ap * 2 + epsilon$5) sa1 > sa0 ? (sa0 += ap, sa1 -= ap) : (sa0 -= ap, sa1 += ap);
                else sa0 = sa1 = (sa0 + sa1) / 2;
                if (abs$2(ta1 - ta0) > ap * 2 + epsilon$5) ta1 > ta0 ? (ta0 += ap, ta1 -= ap) : (ta0 -= ap, ta1 += ap);
                else ta0 = ta1 = (ta0 + ta1) / 2;
            }
            context.moveTo(sr * cos$2(sa0), sr * sin$2(sa0));
            context.arc(0, 0, sr, sa0, sa1);
            if (sa0 !== ta0 || sa1 !== ta1) {
                if (headRadius) {
                    var hr = +headRadius.apply(this, arguments), tr2 = tr - hr, ta2 = (ta0 + ta1) / 2;
                    context.quadraticCurveTo(0, 0, tr2 * cos$2(ta0), tr2 * sin$2(ta0));
                    context.lineTo(tr * cos$2(ta2), tr * sin$2(ta2));
                    context.lineTo(tr2 * cos$2(ta1), tr2 * sin$2(ta1));
                } else {
                    context.quadraticCurveTo(0, 0, tr * cos$2(ta0), tr * sin$2(ta0));
                    context.arc(0, 0, tr, ta0, ta1);
                }
            }
            context.quadraticCurveTo(0, 0, sr * cos$2(sa0), sr * sin$2(sa0));
            context.closePath();
            if (buffer) return context = null, buffer + "" || null;
        }
        if (headRadius) ribbon.headRadius = function(_) {
            return arguments.length ? (headRadius = typeof _ === "function" ? _ : constant$6(+_), ribbon) : headRadius;
        };
        ribbon.radius = function(_) {
            return arguments.length ? (sourceRadius = targetRadius = typeof _ === "function" ? _ : constant$6(+_), ribbon) : sourceRadius;
        };
        ribbon.sourceRadius = function(_) {
            return arguments.length ? (sourceRadius = typeof _ === "function" ? _ : constant$6(+_), ribbon) : sourceRadius;
        };
        ribbon.targetRadius = function(_) {
            return arguments.length ? (targetRadius = typeof _ === "function" ? _ : constant$6(+_), ribbon) : targetRadius;
        };
        ribbon.startAngle = function(_) {
            return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$6(+_), ribbon) : startAngle;
        };
        ribbon.endAngle = function(_) {
            return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$6(+_), ribbon) : endAngle;
        };
        ribbon.padAngle = function(_) {
            return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$6(+_), ribbon) : padAngle;
        };
        ribbon.source = function(_) {
            return arguments.length ? (source = _, ribbon) : source;
        };
        ribbon.target = function(_) {
            return arguments.length ? (target = _, ribbon) : target;
        };
        ribbon.context = function(_) {
            return arguments.length ? (context = _ == null ? null : _, ribbon) : context;
        };
        return ribbon;
    }
    function ribbon$1() {
        return ribbon();
    }
    function ribbonArrow() {
        return ribbon(defaultArrowheadRadius);
    }
    var array$2 = Array.prototype;
    var slice$1 = array$2.slice;
    function ascending$1(a, b) {
        return a - b;
    }
    function area$3(ring) {
        var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
        while(++i < n)area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
        return area;
    }
    var constant$5 = (x)=>()=>x;
    function contains$2(ring, hole) {
        var i = -1, n = hole.length, c;
        while(++i < n)if (c = ringContains(ring, hole[i])) return c;
        return 0;
    }
    function ringContains(ring, point) {
        var x = point[0], y = point[1], contains = -1;
        for(var i = 0, n = ring.length, j = n - 1; i < n; j = i++){
            var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
            if (segmentContains(pi, pj, point)) return 0;
            if (yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) contains = -contains;
        }
        return contains;
    }
    function segmentContains(a, b, c) {
        var i;
        return collinear$1(a, b, c) && within(a[i = +(a[0] === b[0])], c[i], b[i]);
    }
    function collinear$1(a, b, c) {
        return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
    }
    function within(p, q, r) {
        return p <= q && q <= r || r <= q && q <= p;
    }
    function noop$2() {}
    var cases = [
        [],
        [
            [
                [
                    1.0,
                    1.5
                ],
                [
                    0.5,
                    1.0
                ]
            ]
        ],
        [
            [
                [
                    1.5,
                    1.0
                ],
                [
                    1.0,
                    1.5
                ]
            ]
        ],
        [
            [
                [
                    1.5,
                    1.0
                ],
                [
                    0.5,
                    1.0
                ]
            ]
        ],
        [
            [
                [
                    1.0,
                    0.5
                ],
                [
                    1.5,
                    1.0
                ]
            ]
        ],
        [
            [
                [
                    1.0,
                    1.5
                ],
                [
                    0.5,
                    1.0
                ]
            ],
            [
                [
                    1.0,
                    0.5
                ],
                [
                    1.5,
                    1.0
                ]
            ]
        ],
        [
            [
                [
                    1.0,
                    0.5
                ],
                [
                    1.0,
                    1.5
                ]
            ]
        ],
        [
            [
                [
                    1.0,
                    0.5
                ],
                [
                    0.5,
                    1.0
                ]
            ]
        ],
        [
            [
                [
                    0.5,
                    1.0
                ],
                [
                    1.0,
                    0.5
                ]
            ]
        ],
        [
            [
                [
                    1.0,
                    1.5
                ],
                [
                    1.0,
                    0.5
                ]
            ]
        ],
        [
            [
                [
                    0.5,
                    1.0
                ],
                [
                    1.0,
                    0.5
                ]
            ],
            [
                [
                    1.5,
                    1.0
                ],
                [
                    1.0,
                    1.5
                ]
            ]
        ],
        [
            [
                [
                    1.5,
                    1.0
                ],
                [
                    1.0,
                    0.5
                ]
            ]
        ],
        [
            [
                [
                    0.5,
                    1.0
                ],
                [
                    1.5,
                    1.0
                ]
            ]
        ],
        [
            [
                [
                    1.0,
                    1.5
                ],
                [
                    1.5,
                    1.0
                ]
            ]
        ],
        [
            [
                [
                    0.5,
                    1.0
                ],
                [
                    1.0,
                    1.5
                ]
            ]
        ],
        []
    ];
    function Contours() {
        var dx = 1, dy = 1, threshold = thresholdSturges, smooth = smoothLinear;
        function contours(values) {
            var tz = threshold(values);
            // Convert number of thresholds into uniform thresholds.
            if (!Array.isArray(tz)) {
                const e = extent$1(values), ts = tickStep(e[0], e[1], tz);
                tz = ticks(Math.floor(e[0] / ts) * ts, Math.floor(e[1] / ts - 1) * ts, tz);
            } else tz = tz.slice().sort(ascending$1);
            return tz.map((value)=>contour(values, value));
        }
        // Accumulate, smooth contour rings, assign holes to exterior rings.
        // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
        function contour(values, value) {
            var polygons = [], holes = [];
            isorings(values, value, function(ring) {
                smooth(ring, values, value);
                if (area$3(ring) > 0) polygons.push([
                    ring
                ]);
                else holes.push(ring);
            });
            holes.forEach(function(hole) {
                for(var i = 0, n = polygons.length, polygon; i < n; ++i)if (contains$2((polygon = polygons[i])[0], hole) !== -1) {
                    polygon.push(hole);
                    return;
                }
            });
            return {
                type: "MultiPolygon",
                value: value,
                coordinates: polygons
            };
        }
        // Marching squares with isolines stitched into rings.
        // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
        function isorings(values, value, callback) {
            var fragmentByStart = new Array, fragmentByEnd = new Array, x, y, t0, t1, t2, t3;
            // Special case for the first row (y = -1, t2 = t3 = 0).
            x = y = -1;
            t1 = values[0] >= value;
            cases[t1 << 1].forEach(stitch);
            while(++x < dx - 1){
                t0 = t1, t1 = values[x + 1] >= value;
                cases[t0 | t1 << 1].forEach(stitch);
            }
            cases[t1 << 0].forEach(stitch);
            // General case for the intermediate rows.
            while(++y < dy - 1){
                x = -1;
                t1 = values[y * dx + dx] >= value;
                t2 = values[y * dx] >= value;
                cases[t1 << 1 | t2 << 2].forEach(stitch);
                while(++x < dx - 1){
                    t0 = t1, t1 = values[y * dx + dx + x + 1] >= value;
                    t3 = t2, t2 = values[y * dx + x + 1] >= value;
                    cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
                }
                cases[t1 | t2 << 3].forEach(stitch);
            }
            // Special case for the last row (y = dy - 1, t0 = t1 = 0).
            x = -1;
            t2 = values[y * dx] >= value;
            cases[t2 << 2].forEach(stitch);
            while(++x < dx - 1){
                t3 = t2, t2 = values[y * dx + x + 1] >= value;
                cases[t2 << 2 | t3 << 3].forEach(stitch);
            }
            cases[t2 << 3].forEach(stitch);
            function stitch(line) {
                var start = [
                    line[0][0] + x,
                    line[0][1] + y
                ], end = [
                    line[1][0] + x,
                    line[1][1] + y
                ], startIndex = index(start), endIndex = index(end), f, g;
                if (f = fragmentByEnd[startIndex]) {
                    if (g = fragmentByStart[endIndex]) {
                        delete fragmentByEnd[f.end];
                        delete fragmentByStart[g.start];
                        if (f === g) {
                            f.ring.push(end);
                            callback(f.ring);
                        } else fragmentByStart[f.start] = fragmentByEnd[g.end] = {
                            start: f.start,
                            end: g.end,
                            ring: f.ring.concat(g.ring)
                        };
                    } else {
                        delete fragmentByEnd[f.end];
                        f.ring.push(end);
                        fragmentByEnd[f.end = endIndex] = f;
                    }
                } else if (f = fragmentByStart[endIndex]) {
                    if (g = fragmentByEnd[startIndex]) {
                        delete fragmentByStart[f.start];
                        delete fragmentByEnd[g.end];
                        if (f === g) {
                            f.ring.push(end);
                            callback(f.ring);
                        } else fragmentByStart[g.start] = fragmentByEnd[f.end] = {
                            start: g.start,
                            end: f.end,
                            ring: g.ring.concat(f.ring)
                        };
                    } else {
                        delete fragmentByStart[f.start];
                        f.ring.unshift(start);
                        fragmentByStart[f.start = startIndex] = f;
                    }
                } else fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {
                    start: startIndex,
                    end: endIndex,
                    ring: [
                        start,
                        end
                    ]
                };
            }
        }
        function index(point) {
            return point[0] * 2 + point[1] * (dx + 1) * 4;
        }
        function smoothLinear(ring, values, value) {
            ring.forEach(function(point) {
                var x = point[0], y = point[1], xt = x | 0, yt = y | 0, v0, v1 = values[yt * dx + xt];
                if (x > 0 && x < dx && xt === x) {
                    v0 = values[yt * dx + xt - 1];
                    point[0] = x + (value - v0) / (v1 - v0) - 0.5;
                }
                if (y > 0 && y < dy && yt === y) {
                    v0 = values[(yt - 1) * dx + xt];
                    point[1] = y + (value - v0) / (v1 - v0) - 0.5;
                }
            });
        }
        contours.contour = contour;
        contours.size = function(_) {
            if (!arguments.length) return [
                dx,
                dy
            ];
            var _0 = Math.floor(_[0]), _1 = Math.floor(_[1]);
            if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
            return dx = _0, dy = _1, contours;
        };
        contours.thresholds = function(_) {
            return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant$5(slice$1.call(_)) : constant$5(_), contours) : threshold;
        };
        contours.smooth = function(_) {
            return arguments.length ? (smooth = _ ? smoothLinear : noop$2, contours) : smooth === smoothLinear;
        };
        return contours;
    }
    function defaultX$1(d) {
        return d[0];
    }
    function defaultY$1(d) {
        return d[1];
    }
    function defaultWeight() {
        return 1;
    }
    function density() {
        var x = defaultX$1, y = defaultY$1, weight = defaultWeight, dx = 960, dy = 500, r = 20, k = 2, o = r * 3, n = dx + o * 2 >> k, m = dy + o * 2 >> k, threshold = constant$5(20);
        function grid(data) {
            var values = new Float32Array(n * m), pow2k = Math.pow(2, -k), i = -1;
            for (const d of data){
                var xi = (x(d, ++i, data) + o) * pow2k, yi = (y(d, i, data) + o) * pow2k, wi = +weight(d, i, data);
                if (xi >= 0 && xi < n && yi >= 0 && yi < m) {
                    var x0 = Math.floor(xi), y0 = Math.floor(yi), xt = xi - x0 - 0.5, yt = yi - y0 - 0.5;
                    values[x0 + y0 * n] += (1 - xt) * (1 - yt) * wi;
                    values[x0 + 1 + y0 * n] += xt * (1 - yt) * wi;
                    values[x0 + 1 + (y0 + 1) * n] += xt * yt * wi;
                    values[x0 + (y0 + 1) * n] += (1 - xt) * yt * wi;
                }
            }
            blur2({
                data: values,
                width: n,
                height: m
            }, r * pow2k);
            return values;
        }
        function density(data) {
            var values = grid(data), tz = threshold(values), pow4k = Math.pow(2, 2 * k);
            // Convert number of thresholds into uniform thresholds.
            if (!Array.isArray(tz)) tz = ticks(Number.MIN_VALUE, max$3(values) / pow4k, tz);
            return Contours().size([
                n,
                m
            ]).thresholds(tz.map((d)=>d * pow4k))(values).map((c, i)=>(c.value = +tz[i], transform(c)));
        }
        density.contours = function(data) {
            var values = grid(data), contours = Contours().size([
                n,
                m
            ]), pow4k = Math.pow(2, 2 * k), contour = (value)=>{
                value = +value;
                var c = transform(contours.contour(values, value * pow4k));
                c.value = value; // preserve exact threshold value
                return c;
            };
            Object.defineProperty(contour, "max", {
                get: ()=>max$3(values) / pow4k
            });
            return contour;
        };
        function transform(geometry) {
            geometry.coordinates.forEach(transformPolygon);
            return geometry;
        }
        function transformPolygon(coordinates) {
            coordinates.forEach(transformRing);
        }
        function transformRing(coordinates) {
            coordinates.forEach(transformPoint);
        }
        // TODO Optimize.
        function transformPoint(coordinates) {
            coordinates[0] = coordinates[0] * Math.pow(2, k) - o;
            coordinates[1] = coordinates[1] * Math.pow(2, k) - o;
        }
        function resize() {
            o = r * 3;
            n = dx + o * 2 >> k;
            m = dy + o * 2 >> k;
            return density;
        }
        density.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : constant$5(+_), density) : x;
        };
        density.y = function(_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : constant$5(+_), density) : y;
        };
        density.weight = function(_) {
            return arguments.length ? (weight = typeof _ === "function" ? _ : constant$5(+_), density) : weight;
        };
        density.size = function(_) {
            if (!arguments.length) return [
                dx,
                dy
            ];
            var _0 = +_[0], _1 = +_[1];
            if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
            return dx = _0, dy = _1, resize();
        };
        density.cellSize = function(_) {
            if (!arguments.length) return 1 << k;
            if (!((_ = +_) >= 1)) throw new Error("invalid cell size");
            return k = Math.floor(Math.log(_) / Math.LN2), resize();
        };
        density.thresholds = function(_) {
            return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant$5(slice$1.call(_)) : constant$5(_), density) : threshold;
        };
        density.bandwidth = function(_) {
            if (!arguments.length) return Math.sqrt(r * (r + 1));
            if (!((_ = +_) >= 0)) throw new Error("invalid bandwidth");
            return r = (Math.sqrt(4 * _ * _ + 1) - 1) / 2, resize();
        };
        return density;
    }
    const epsilon$3 = 1.1102230246251565e-16;
    const splitter = 134217729;
    const resulterrbound = (3 + 8 * epsilon$3) * epsilon$3;
    // fast_expansion_sum_zeroelim routine from oritinal code
    function sum$1(elen, e, flen, f, h) {
        let Q, Qnew, hh, bvirt;
        let enow = e[0];
        let fnow = f[0];
        let eindex = 0;
        let findex = 0;
        if (fnow > enow === fnow > -enow) {
            Q = enow;
            enow = e[++eindex];
        } else {
            Q = fnow;
            fnow = f[++findex];
        }
        let hindex = 0;
        if (eindex < elen && findex < flen) {
            if (fnow > enow === fnow > -enow) {
                Qnew = enow + Q;
                hh = Q - (Qnew - enow);
                enow = e[++eindex];
            } else {
                Qnew = fnow + Q;
                hh = Q - (Qnew - fnow);
                fnow = f[++findex];
            }
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
            while(eindex < elen && findex < flen){
                if (fnow > enow === fnow > -enow) {
                    Qnew = Q + enow;
                    bvirt = Qnew - Q;
                    hh = Q - (Qnew - bvirt) + (enow - bvirt);
                    enow = e[++eindex];
                } else {
                    Qnew = Q + fnow;
                    bvirt = Qnew - Q;
                    hh = Q - (Qnew - bvirt) + (fnow - bvirt);
                    fnow = f[++findex];
                }
                Q = Qnew;
                if (hh !== 0) h[hindex++] = hh;
            }
        }
        while(eindex < elen){
            Qnew = Q + enow;
            bvirt = Qnew - Q;
            hh = Q - (Qnew - bvirt) + (enow - bvirt);
            enow = e[++eindex];
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
        }
        while(findex < flen){
            Qnew = Q + fnow;
            bvirt = Qnew - Q;
            hh = Q - (Qnew - bvirt) + (fnow - bvirt);
            fnow = f[++findex];
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
        }
        if (Q !== 0 || hindex === 0) h[hindex++] = Q;
        return hindex;
    }
    function estimate(elen, e) {
        let Q = e[0];
        for(let i = 1; i < elen; i++)Q += e[i];
        return Q;
    }
    function vec(n) {
        return new Float64Array(n);
    }
    const ccwerrboundA = (3 + 16 * epsilon$3) * epsilon$3;
    const ccwerrboundB = (2 + 12 * epsilon$3) * epsilon$3;
    const ccwerrboundC = (9 + 64 * epsilon$3) * epsilon$3 * epsilon$3;
    const B = vec(4);
    const C1 = vec(8);
    const C2 = vec(12);
    const D = vec(16);
    const u = vec(4);
    function orient2dadapt(ax, ay, bx, by, cx, cy, detsum) {
        let acxtail, acytail, bcxtail, bcytail;
        let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
        const acx = ax - cx;
        const bcx = bx - cx;
        const acy = ay - cy;
        const bcy = by - cy;
        s1 = acx * bcy;
        c = splitter * acx;
        ahi = c - (c - acx);
        alo = acx - ahi;
        c = splitter * bcy;
        bhi = c - (c - bcy);
        blo = bcy - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = acy * bcx;
        c = splitter * acy;
        ahi = c - (c - acy);
        alo = acy - ahi;
        c = splitter * bcx;
        bhi = c - (c - bcx);
        blo = bcx - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        B[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        B[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        B[2] = _j - (u3 - bvirt) + (_i - bvirt);
        B[3] = u3;
        let det = estimate(4, B);
        let errbound = ccwerrboundB * detsum;
        if (det >= errbound || -det >= errbound) return det;
        bvirt = ax - acx;
        acxtail = ax - (acx + bvirt) + (bvirt - cx);
        bvirt = bx - bcx;
        bcxtail = bx - (bcx + bvirt) + (bvirt - cx);
        bvirt = ay - acy;
        acytail = ay - (acy + bvirt) + (bvirt - cy);
        bvirt = by - bcy;
        bcytail = by - (bcy + bvirt) + (bvirt - cy);
        if (acxtail === 0 && acytail === 0 && bcxtail === 0 && bcytail === 0) return det;
        errbound = ccwerrboundC * detsum + resulterrbound * Math.abs(det);
        det += acx * bcytail + bcy * acxtail - (acy * bcxtail + bcx * acytail);
        if (det >= errbound || -det >= errbound) return det;
        s1 = acxtail * bcy;
        c = splitter * acxtail;
        ahi = c - (c - acxtail);
        alo = acxtail - ahi;
        c = splitter * bcy;
        bhi = c - (c - bcy);
        blo = bcy - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = acytail * bcx;
        c = splitter * acytail;
        ahi = c - (c - acytail);
        alo = acytail - ahi;
        c = splitter * bcx;
        bhi = c - (c - bcx);
        blo = bcx - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        u[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        u[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        u[2] = _j - (u3 - bvirt) + (_i - bvirt);
        u[3] = u3;
        const C1len = sum$1(4, B, 4, u, C1);
        s1 = acx * bcytail;
        c = splitter * acx;
        ahi = c - (c - acx);
        alo = acx - ahi;
        c = splitter * bcytail;
        bhi = c - (c - bcytail);
        blo = bcytail - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = acy * bcxtail;
        c = splitter * acy;
        ahi = c - (c - acy);
        alo = acy - ahi;
        c = splitter * bcxtail;
        bhi = c - (c - bcxtail);
        blo = bcxtail - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        u[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        u[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        u[2] = _j - (u3 - bvirt) + (_i - bvirt);
        u[3] = u3;
        const C2len = sum$1(C1len, C1, 4, u, C2);
        s1 = acxtail * bcytail;
        c = splitter * acxtail;
        ahi = c - (c - acxtail);
        alo = acxtail - ahi;
        c = splitter * bcytail;
        bhi = c - (c - bcytail);
        blo = bcytail - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = acytail * bcxtail;
        c = splitter * acytail;
        ahi = c - (c - acytail);
        alo = acytail - ahi;
        c = splitter * bcxtail;
        bhi = c - (c - bcxtail);
        blo = bcxtail - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        u[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        u[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        u[2] = _j - (u3 - bvirt) + (_i - bvirt);
        u[3] = u3;
        const Dlen = sum$1(C2len, C2, 4, u, D);
        return D[Dlen - 1];
    }
    function orient2d(ax, ay, bx, by, cx, cy) {
        const detleft = (ay - cy) * (bx - cx);
        const detright = (ax - cx) * (by - cy);
        const det = detleft - detright;
        if (detleft === 0 || detright === 0 || detleft > 0 !== detright > 0) return det;
        const detsum = Math.abs(detleft + detright);
        if (Math.abs(det) >= ccwerrboundA * detsum) return det;
        return -orient2dadapt(ax, ay, bx, by, cx, cy, detsum);
    }
    const EPSILON = Math.pow(2, -52);
    const EDGE_STACK = new Uint32Array(512);
    class Delaunator {
        static from(points, getX = defaultGetX, getY = defaultGetY) {
            const n = points.length;
            const coords = new Float64Array(n * 2);
            for(let i = 0; i < n; i++){
                const p = points[i];
                coords[2 * i] = getX(p);
                coords[2 * i + 1] = getY(p);
            }
            return new Delaunator(coords);
        }
        constructor(coords){
            const n = coords.length >> 1;
            if (n > 0 && typeof coords[0] !== 'number') throw new Error('Expected coords to contain numbers.');
            this.coords = coords;
            // arrays that will store the triangulation graph
            const maxTriangles = Math.max(2 * n - 5, 0);
            this._triangles = new Uint32Array(maxTriangles * 3);
            this._halfedges = new Int32Array(maxTriangles * 3);
            // temporary arrays for tracking the edges of the advancing convex hull
            this._hashSize = Math.ceil(Math.sqrt(n));
            this._hullPrev = new Uint32Array(n); // edge to prev edge
            this._hullNext = new Uint32Array(n); // edge to next edge
            this._hullTri = new Uint32Array(n); // edge to adjacent triangle
            this._hullHash = new Int32Array(this._hashSize).fill(-1); // angular edge hash
            // temporary arrays for sorting points
            this._ids = new Uint32Array(n);
            this._dists = new Float64Array(n);
            this.update();
        }
        update() {
            const { coords: coords, _hullPrev: hullPrev, _hullNext: hullNext, _hullTri: hullTri, _hullHash: hullHash } = this;
            const n = coords.length >> 1;
            // populate an array of point indices; calculate input data bbox
            let minX = Infinity;
            let minY = Infinity;
            let maxX = -Infinity;
            let maxY = -Infinity;
            for(let i = 0; i < n; i++){
                const x = coords[2 * i];
                const y = coords[2 * i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
                this._ids[i] = i;
            }
            const cx = (minX + maxX) / 2;
            const cy = (minY + maxY) / 2;
            let minDist = Infinity;
            let i0, i1, i2;
            // pick a seed point close to the center
            for(let i = 0; i < n; i++){
                const d = dist(cx, cy, coords[2 * i], coords[2 * i + 1]);
                if (d < minDist) {
                    i0 = i;
                    minDist = d;
                }
            }
            const i0x = coords[2 * i0];
            const i0y = coords[2 * i0 + 1];
            minDist = Infinity;
            // find the point closest to the seed
            for(let i = 0; i < n; i++){
                if (i === i0) continue;
                const d = dist(i0x, i0y, coords[2 * i], coords[2 * i + 1]);
                if (d < minDist && d > 0) {
                    i1 = i;
                    minDist = d;
                }
            }
            let i1x = coords[2 * i1];
            let i1y = coords[2 * i1 + 1];
            let minRadius = Infinity;
            // find the third point which forms the smallest circumcircle with the first two
            for(let i = 0; i < n; i++){
                if (i === i0 || i === i1) continue;
                const r = circumradius(i0x, i0y, i1x, i1y, coords[2 * i], coords[2 * i + 1]);
                if (r < minRadius) {
                    i2 = i;
                    minRadius = r;
                }
            }
            let i2x = coords[2 * i2];
            let i2y = coords[2 * i2 + 1];
            if (minRadius === Infinity) {
                // order collinear points by dx (or dy if all x are identical)
                // and return the list as a hull
                for(let i = 0; i < n; i++)this._dists[i] = coords[2 * i] - coords[0] || coords[2 * i + 1] - coords[1];
                quicksort(this._ids, this._dists, 0, n - 1);
                const hull = new Uint32Array(n);
                let j = 0;
                for(let i = 0, d0 = -Infinity; i < n; i++){
                    const id = this._ids[i];
                    if (this._dists[id] > d0) {
                        hull[j++] = id;
                        d0 = this._dists[id];
                    }
                }
                this.hull = hull.subarray(0, j);
                this.triangles = new Uint32Array(0);
                this.halfedges = new Uint32Array(0);
                return;
            }
            // swap the order of the seed points for counter-clockwise orientation
            if (orient2d(i0x, i0y, i1x, i1y, i2x, i2y) < 0) {
                const i = i1;
                const x = i1x;
                const y = i1y;
                i1 = i2;
                i1x = i2x;
                i1y = i2y;
                i2 = i;
                i2x = x;
                i2y = y;
            }
            const center = circumcenter(i0x, i0y, i1x, i1y, i2x, i2y);
            this._cx = center.x;
            this._cy = center.y;
            for(let i = 0; i < n; i++)this._dists[i] = dist(coords[2 * i], coords[2 * i + 1], center.x, center.y);
            // sort the points by distance from the seed triangle circumcenter
            quicksort(this._ids, this._dists, 0, n - 1);
            // set up the seed triangle as the starting hull
            this._hullStart = i0;
            let hullSize = 3;
            hullNext[i0] = hullPrev[i2] = i1;
            hullNext[i1] = hullPrev[i0] = i2;
            hullNext[i2] = hullPrev[i1] = i0;
            hullTri[i0] = 0;
            hullTri[i1] = 1;
            hullTri[i2] = 2;
            hullHash.fill(-1);
            hullHash[this._hashKey(i0x, i0y)] = i0;
            hullHash[this._hashKey(i1x, i1y)] = i1;
            hullHash[this._hashKey(i2x, i2y)] = i2;
            this.trianglesLen = 0;
            this._addTriangle(i0, i1, i2, -1, -1, -1);
            for(let k = 0, xp, yp; k < this._ids.length; k++){
                const i = this._ids[k];
                const x = coords[2 * i];
                const y = coords[2 * i + 1];
                // skip near-duplicate points
                if (k > 0 && Math.abs(x - xp) <= EPSILON && Math.abs(y - yp) <= EPSILON) continue;
                xp = x;
                yp = y;
                // skip seed triangle points
                if (i === i0 || i === i1 || i === i2) continue;
                // find a visible edge on the convex hull using edge hash
                let start = 0;
                for(let j = 0, key = this._hashKey(x, y); j < this._hashSize; j++){
                    start = hullHash[(key + j) % this._hashSize];
                    if (start !== -1 && start !== hullNext[start]) break;
                }
                start = hullPrev[start];
                let e = start, q;
                while(q = hullNext[e], orient2d(x, y, coords[2 * e], coords[2 * e + 1], coords[2 * q], coords[2 * q + 1]) >= 0){
                    e = q;
                    if (e === start) {
                        e = -1;
                        break;
                    }
                }
                if (e === -1) continue; // likely a near-duplicate point; skip it
                // add the first triangle from the point
                let t = this._addTriangle(e, i, hullNext[e], -1, -1, hullTri[e]);
                // recursively flip triangles from the point until they satisfy the Delaunay condition
                hullTri[i] = this._legalize(t + 2);
                hullTri[e] = t; // keep track of boundary triangles on the hull
                hullSize++;
                // walk forward through the hull, adding more triangles and flipping recursively
                let n = hullNext[e];
                while(q = hullNext[n], orient2d(x, y, coords[2 * n], coords[2 * n + 1], coords[2 * q], coords[2 * q + 1]) < 0){
                    t = this._addTriangle(n, i, q, hullTri[i], -1, hullTri[n]);
                    hullTri[i] = this._legalize(t + 2);
                    hullNext[n] = n; // mark as removed
                    hullSize--;
                    n = q;
                }
                // walk backward from the other side, adding more triangles and flipping
                if (e === start) while(q = hullPrev[e], orient2d(x, y, coords[2 * q], coords[2 * q + 1], coords[2 * e], coords[2 * e + 1]) < 0){
                    t = this._addTriangle(q, i, e, -1, hullTri[e], hullTri[q]);
                    this._legalize(t + 2);
                    hullTri[q] = t;
                    hullNext[e] = e; // mark as removed
                    hullSize--;
                    e = q;
                }
                // update the hull indices
                this._hullStart = hullPrev[i] = e;
                hullNext[e] = hullPrev[n] = i;
                hullNext[i] = n;
                // save the two new edges in the hash table
                hullHash[this._hashKey(x, y)] = i;
                hullHash[this._hashKey(coords[2 * e], coords[2 * e + 1])] = e;
            }
            this.hull = new Uint32Array(hullSize);
            for(let i = 0, e = this._hullStart; i < hullSize; i++){
                this.hull[i] = e;
                e = hullNext[e];
            }
            // trim typed triangle mesh arrays
            this.triangles = this._triangles.subarray(0, this.trianglesLen);
            this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
        }
        _hashKey(x, y) {
            return Math.floor(pseudoAngle(x - this._cx, y - this._cy) * this._hashSize) % this._hashSize;
        }
        _legalize(a) {
            const { _triangles: triangles, _halfedges: halfedges, coords: coords } = this;
            let i = 0;
            let ar = 0;
            // recursion eliminated with a fixed-size stack
            while(true){
                const b = halfedges[a];
                /* if the pair of triangles doesn't satisfy the Delaunay condition
             * (p1 is inside the circumcircle of [p0, pl, pr]), flip them,
             * then do the same check/flip recursively for the new pair of triangles
             *
             *           pl                    pl
             *          /||\                  /  \
             *       al/ || \bl            al/    \a
             *        /  ||  \              /      \
             *       /  a||b  \    flip    /___ar___\
             *     p0\   ||   /p1   =>   p0\---bl---/p1
             *        \  ||  /              \      /
             *       ar\ || /br             b\    /br
             *          \||/                  \  /
             *           pr                    pr
             */ const a0 = a - a % 3;
                ar = a0 + (a + 2) % 3;
                if (b === -1) {
                    if (i === 0) break;
                    a = EDGE_STACK[--i];
                    continue;
                }
                const b0 = b - b % 3;
                const al = a0 + (a + 1) % 3;
                const bl = b0 + (b + 2) % 3;
                const p0 = triangles[ar];
                const pr = triangles[a];
                const pl = triangles[al];
                const p1 = triangles[bl];
                const illegal = inCircle(coords[2 * p0], coords[2 * p0 + 1], coords[2 * pr], coords[2 * pr + 1], coords[2 * pl], coords[2 * pl + 1], coords[2 * p1], coords[2 * p1 + 1]);
                if (illegal) {
                    triangles[a] = p1;
                    triangles[b] = p0;
                    const hbl = halfedges[bl];
                    // edge swapped on the other side of the hull (rare); fix the halfedge reference
                    if (hbl === -1) {
                        let e = this._hullStart;
                        do {
                            if (this._hullTri[e] === bl) {
                                this._hullTri[e] = a;
                                break;
                            }
                            e = this._hullPrev[e];
                        }while (e !== this._hullStart);
                    }
                    this._link(a, hbl);
                    this._link(b, halfedges[ar]);
                    this._link(ar, bl);
                    const br = b0 + (b + 1) % 3;
                    // don't worry about hitting the cap: it can only happen on extremely degenerate input
                    if (i < EDGE_STACK.length) EDGE_STACK[i++] = br;
                } else {
                    if (i === 0) break;
                    a = EDGE_STACK[--i];
                }
            }
            return ar;
        }
        _link(a, b) {
            this._halfedges[a] = b;
            if (b !== -1) this._halfedges[b] = a;
        }
        // add a new triangle given vertex indices and adjacent half-edge ids
        _addTriangle(i0, i1, i2, a, b, c) {
            const t = this.trianglesLen;
            this._triangles[t] = i0;
            this._triangles[t + 1] = i1;
            this._triangles[t + 2] = i2;
            this._link(t, a);
            this._link(t + 1, b);
            this._link(t + 2, c);
            this.trianglesLen += 3;
            return t;
        }
    }
    // monotonically increases with real angle, but doesn't need expensive trigonometry
    function pseudoAngle(dx, dy) {
        const p = dx / (Math.abs(dx) + Math.abs(dy));
        return (dy > 0 ? 3 - p : 1 + p) / 4; // [0..1]
    }
    function dist(ax, ay, bx, by) {
        const dx = ax - bx;
        const dy = ay - by;
        return dx * dx + dy * dy;
    }
    function inCircle(ax, ay, bx, by, cx, cy, px, py) {
        const dx = ax - px;
        const dy = ay - py;
        const ex = bx - px;
        const ey = by - py;
        const fx = cx - px;
        const fy = cy - py;
        const ap = dx * dx + dy * dy;
        const bp = ex * ex + ey * ey;
        const cp = fx * fx + fy * fy;
        return dx * (ey * cp - bp * fy) - dy * (ex * cp - bp * fx) + ap * (ex * fy - ey * fx) < 0;
    }
    function circumradius(ax, ay, bx, by, cx, cy) {
        const dx = bx - ax;
        const dy = by - ay;
        const ex = cx - ax;
        const ey = cy - ay;
        const bl = dx * dx + dy * dy;
        const cl = ex * ex + ey * ey;
        const d = 0.5 / (dx * ey - dy * ex);
        const x = (ey * bl - dy * cl) * d;
        const y = (dx * cl - ex * bl) * d;
        return x * x + y * y;
    }
    function circumcenter(ax, ay, bx, by, cx, cy) {
        const dx = bx - ax;
        const dy = by - ay;
        const ex = cx - ax;
        const ey = cy - ay;
        const bl = dx * dx + dy * dy;
        const cl = ex * ex + ey * ey;
        const d = 0.5 / (dx * ey - dy * ex);
        const x = ax + (ey * bl - dy * cl) * d;
        const y = ay + (dx * cl - ex * bl) * d;
        return {
            x: x,
            y: y
        };
    }
    function quicksort(ids, dists, left, right) {
        if (right - left <= 20) for(let i = left + 1; i <= right; i++){
            const temp = ids[i];
            const tempDist = dists[temp];
            let j = i - 1;
            while(j >= left && dists[ids[j]] > tempDist)ids[j + 1] = ids[j--];
            ids[j + 1] = temp;
        }
        else {
            const median = left + right >> 1;
            let i = left + 1;
            let j = right;
            swap(ids, median, i);
            if (dists[ids[left]] > dists[ids[right]]) swap(ids, left, right);
            if (dists[ids[i]] > dists[ids[right]]) swap(ids, i, right);
            if (dists[ids[left]] > dists[ids[i]]) swap(ids, left, i);
            const temp = ids[i];
            const tempDist = dists[temp];
            while(true){
                do i++;
                while (dists[ids[i]] < tempDist);
                do j--;
                while (dists[ids[j]] > tempDist);
                if (j < i) break;
                swap(ids, i, j);
            }
            ids[left + 1] = ids[j];
            ids[j] = temp;
            if (right - i + 1 >= j - left) {
                quicksort(ids, dists, i, right);
                quicksort(ids, dists, left, j - 1);
            } else {
                quicksort(ids, dists, left, j - 1);
                quicksort(ids, dists, i, right);
            }
        }
    }
    function swap(arr, i, j) {
        const tmp = arr[i];
        arr[i] = arr[j];
        arr[j] = tmp;
    }
    function defaultGetX(p) {
        return p[0];
    }
    function defaultGetY(p) {
        return p[1];
    }
    const epsilon$2 = 1e-6;
    class Path {
        constructor(){
            this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
            this._ = "";
        }
        moveTo(x, y) {
            this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
        }
        closePath() {
            if (this._x1 !== null) {
                this._x1 = this._x0, this._y1 = this._y0;
                this._ += "Z";
            }
        }
        lineTo(x, y) {
            this._ += `L${this._x1 = +x},${this._y1 = +y}`;
        }
        arc(x, y, r) {
            x = +x, y = +y, r = +r;
            const x0 = x + r;
            const y0 = y;
            if (r < 0) throw new Error("negative radius");
            if (this._x1 === null) this._ += `M${x0},${y0}`;
            else if (Math.abs(this._x1 - x0) > epsilon$2 || Math.abs(this._y1 - y0) > epsilon$2) this._ += "L" + x0 + "," + y0;
            if (!r) return;
            this._ += `A${r},${r},0,1,1,${x - r},${y}A${r},${r},0,1,1,${this._x1 = x0},${this._y1 = y0}`;
        }
        rect(x, y, w, h) {
            this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${+w}v${+h}h${-w}Z`;
        }
        value() {
            return this._ || null;
        }
    }
    class Polygon {
        constructor(){
            this._ = [];
        }
        moveTo(x, y) {
            this._.push([
                x,
                y
            ]);
        }
        closePath() {
            this._.push(this._[0].slice());
        }
        lineTo(x, y) {
            this._.push([
                x,
                y
            ]);
        }
        value() {
            return this._.length ? this._ : null;
        }
    }
    class Voronoi {
        constructor(delaunay, [xmin, ymin, xmax, ymax] = [
            0,
            0,
            960,
            500
        ]){
            if (!((xmax = +xmax) >= (xmin = +xmin)) || !((ymax = +ymax) >= (ymin = +ymin))) throw new Error("invalid bounds");
            this.delaunay = delaunay;
            this._circumcenters = new Float64Array(delaunay.points.length * 2);
            this.vectors = new Float64Array(delaunay.points.length * 2);
            this.xmax = xmax, this.xmin = xmin;
            this.ymax = ymax, this.ymin = ymin;
            this._init();
        }
        update() {
            this.delaunay.update();
            this._init();
            return this;
        }
        _init() {
            const { delaunay: { points: points, hull: hull, triangles: triangles }, vectors: vectors } = this;
            // Compute circumcenters.
            const circumcenters = this.circumcenters = this._circumcenters.subarray(0, triangles.length / 3 * 2);
            for(let i = 0, j = 0, n = triangles.length, x, y; i < n; i += 3, j += 2){
                const t1 = triangles[i] * 2;
                const t2 = triangles[i + 1] * 2;
                const t3 = triangles[i + 2] * 2;
                const x1 = points[t1];
                const y1 = points[t1 + 1];
                const x2 = points[t2];
                const y2 = points[t2 + 1];
                const x3 = points[t3];
                const y3 = points[t3 + 1];
                const dx = x2 - x1;
                const dy = y2 - y1;
                const ex = x3 - x1;
                const ey = y3 - y1;
                const ab = (dx * ey - dy * ex) * 2;
                if (Math.abs(ab) < 1e-9) {
                    // degenerate case (collinear diagram)
                    // almost equal points (degenerate triangle)
                    // the circumcenter is at the infinity, in a
                    // direction that is:
                    // 1. orthogonal to the halfedge.
                    let a = 1e9;
                    // 2. points away from the center; since the list of triangles starts
                    // in the center, the first point of the first triangle
                    // will be our reference
                    const r = triangles[0] * 2;
                    a *= Math.sign((points[r] - x1) * ey - (points[r + 1] - y1) * ex);
                    x = (x1 + x3) / 2 - a * ey;
                    y = (y1 + y3) / 2 + a * ex;
                } else {
                    const d = 1 / ab;
                    const bl = dx * dx + dy * dy;
                    const cl = ex * ex + ey * ey;
                    x = x1 + (ey * bl - dy * cl) * d;
                    y = y1 + (dx * cl - ex * bl) * d;
                }
                circumcenters[j] = x;
                circumcenters[j + 1] = y;
            }
            // Compute exterior cell rays.
            let h = hull[hull.length - 1];
            let p0, p1 = h * 4;
            let x0, x1 = points[2 * h];
            let y0, y1 = points[2 * h + 1];
            vectors.fill(0);
            for(let i = 0; i < hull.length; ++i){
                h = hull[i];
                p0 = p1, x0 = x1, y0 = y1;
                p1 = h * 4, x1 = points[2 * h], y1 = points[2 * h + 1];
                vectors[p0 + 2] = vectors[p1] = y0 - y1;
                vectors[p0 + 3] = vectors[p1 + 1] = x1 - x0;
            }
        }
        render(context) {
            const buffer = context == null ? context = new Path : undefined;
            const { delaunay: { halfedges: halfedges, inedges: inedges, hull: hull }, circumcenters: circumcenters, vectors: vectors } = this;
            if (hull.length <= 1) return null;
            for(let i = 0, n = halfedges.length; i < n; ++i){
                const j = halfedges[i];
                if (j < i) continue;
                const ti = Math.floor(i / 3) * 2;
                const tj = Math.floor(j / 3) * 2;
                const xi = circumcenters[ti];
                const yi = circumcenters[ti + 1];
                const xj = circumcenters[tj];
                const yj = circumcenters[tj + 1];
                this._renderSegment(xi, yi, xj, yj, context);
            }
            let h0, h1 = hull[hull.length - 1];
            for(let i = 0; i < hull.length; ++i){
                h0 = h1, h1 = hull[i];
                const t = Math.floor(inedges[h1] / 3) * 2;
                const x = circumcenters[t];
                const y = circumcenters[t + 1];
                const v = h0 * 4;
                const p = this._project(x, y, vectors[v + 2], vectors[v + 3]);
                if (p) this._renderSegment(x, y, p[0], p[1], context);
            }
            return buffer && buffer.value();
        }
        renderBounds(context) {
            const buffer = context == null ? context = new Path : undefined;
            context.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin);
            return buffer && buffer.value();
        }
        renderCell(i, context) {
            const buffer = context == null ? context = new Path : undefined;
            const points = this._clip(i);
            if (points === null || !points.length) return;
            context.moveTo(points[0], points[1]);
            let n = points.length;
            while(points[0] === points[n - 2] && points[1] === points[n - 1] && n > 1)n -= 2;
            for(let i = 2; i < n; i += 2)if (points[i] !== points[i - 2] || points[i + 1] !== points[i - 1]) context.lineTo(points[i], points[i + 1]);
            context.closePath();
            return buffer && buffer.value();
        }
        *cellPolygons() {
            const { delaunay: { points: points } } = this;
            for(let i = 0, n = points.length / 2; i < n; ++i){
                const cell = this.cellPolygon(i);
                if (cell) cell.index = i, yield cell;
            }
        }
        cellPolygon(i) {
            const polygon = new Polygon;
            this.renderCell(i, polygon);
            return polygon.value();
        }
        _renderSegment(x0, y0, x1, y1, context) {
            let S;
            const c0 = this._regioncode(x0, y0);
            const c1 = this._regioncode(x1, y1);
            if (c0 === 0 && c1 === 0) {
                context.moveTo(x0, y0);
                context.lineTo(x1, y1);
            } else if (S = this._clipSegment(x0, y0, x1, y1, c0, c1)) {
                context.moveTo(S[0], S[1]);
                context.lineTo(S[2], S[3]);
            }
        }
        contains(i, x, y) {
            if ((x = +x, x !== x) || (y = +y, y !== y)) return false;
            return this.delaunay._step(i, x, y) === i;
        }
        *neighbors(i) {
            const ci = this._clip(i);
            if (ci) for (const j of this.delaunay.neighbors(i)){
                const cj = this._clip(j);
                // find the common edge
                if (cj) loop: for(let ai = 0, li = ci.length; ai < li; ai += 2){
                    for(let aj = 0, lj = cj.length; aj < lj; aj += 2)if (ci[ai] == cj[aj] && ci[ai + 1] == cj[aj + 1] && ci[(ai + 2) % li] == cj[(aj + lj - 2) % lj] && ci[(ai + 3) % li] == cj[(aj + lj - 1) % lj]) {
                        yield j;
                        break loop;
                    }
                }
            }
        }
        _cell(i) {
            const { circumcenters: circumcenters, delaunay: { inedges: inedges, halfedges: halfedges, triangles: triangles } } = this;
            const e0 = inedges[i];
            if (e0 === -1) return null; // coincident point
            const points = [];
            let e = e0;
            do {
                const t = Math.floor(e / 3);
                points.push(circumcenters[t * 2], circumcenters[t * 2 + 1]);
                e = e % 3 === 2 ? e - 2 : e + 1;
                if (triangles[e] !== i) break; // bad triangulation
                e = halfedges[e];
            }while (e !== e0 && e !== -1);
            return points;
        }
        _clip(i) {
            // degenerate case (1 valid point: return the box)
            if (i === 0 && this.delaunay.hull.length === 1) return [
                this.xmax,
                this.ymin,
                this.xmax,
                this.ymax,
                this.xmin,
                this.ymax,
                this.xmin,
                this.ymin
            ];
            const points = this._cell(i);
            if (points === null) return null;
            const { vectors: V } = this;
            const v = i * 4;
            return V[v] || V[v + 1] ? this._clipInfinite(i, points, V[v], V[v + 1], V[v + 2], V[v + 3]) : this._clipFinite(i, points);
        }
        _clipFinite(i, points) {
            const n = points.length;
            let P = null;
            let x0, y0, x1 = points[n - 2], y1 = points[n - 1];
            let c0, c1 = this._regioncode(x1, y1);
            let e0, e1 = 0;
            for(let j = 0; j < n; j += 2){
                x0 = x1, y0 = y1, x1 = points[j], y1 = points[j + 1];
                c0 = c1, c1 = this._regioncode(x1, y1);
                if (c0 === 0 && c1 === 0) {
                    e0 = e1, e1 = 0;
                    if (P) P.push(x1, y1);
                    else P = [
                        x1,
                        y1
                    ];
                } else {
                    let S, sx0, sy0, sx1, sy1;
                    if (c0 === 0) {
                        if ((S = this._clipSegment(x0, y0, x1, y1, c0, c1)) === null) continue;
                        [sx0, sy0, sx1, sy1] = S;
                    } else {
                        if ((S = this._clipSegment(x1, y1, x0, y0, c1, c0)) === null) continue;
                        [sx1, sy1, sx0, sy0] = S;
                        e0 = e1, e1 = this._edgecode(sx0, sy0);
                        if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                        if (P) P.push(sx0, sy0);
                        else P = [
                            sx0,
                            sy0
                        ];
                    }
                    e0 = e1, e1 = this._edgecode(sx1, sy1);
                    if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                    if (P) P.push(sx1, sy1);
                    else P = [
                        sx1,
                        sy1
                    ];
                }
            }
            if (P) {
                e0 = e1, e1 = this._edgecode(P[0], P[1]);
                if (e0 && e1) this._edge(i, e0, e1, P, P.length);
            } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) return [
                this.xmax,
                this.ymin,
                this.xmax,
                this.ymax,
                this.xmin,
                this.ymax,
                this.xmin,
                this.ymin
            ];
            return P;
        }
        _clipSegment(x0, y0, x1, y1, c0, c1) {
            while(true){
                if (c0 === 0 && c1 === 0) return [
                    x0,
                    y0,
                    x1,
                    y1
                ];
                if (c0 & c1) return null;
                let x, y, c = c0 || c1;
                if (c & 8) x = x0 + (x1 - x0) * (this.ymax - y0) / (y1 - y0), y = this.ymax;
                else if (c & 4) x = x0 + (x1 - x0) * (this.ymin - y0) / (y1 - y0), y = this.ymin;
                else if (c & 2) y = y0 + (y1 - y0) * (this.xmax - x0) / (x1 - x0), x = this.xmax;
                else y = y0 + (y1 - y0) * (this.xmin - x0) / (x1 - x0), x = this.xmin;
                if (c0) x0 = x, y0 = y, c0 = this._regioncode(x0, y0);
                else x1 = x, y1 = y, c1 = this._regioncode(x1, y1);
            }
        }
        _clipInfinite(i, points, vx0, vy0, vxn, vyn) {
            let P = Array.from(points), p;
            if (p = this._project(P[0], P[1], vx0, vy0)) P.unshift(p[0], p[1]);
            if (p = this._project(P[P.length - 2], P[P.length - 1], vxn, vyn)) P.push(p[0], p[1]);
            if (P = this._clipFinite(i, P)) for(let j = 0, n = P.length, c0, c1 = this._edgecode(P[n - 2], P[n - 1]); j < n; j += 2){
                c0 = c1, c1 = this._edgecode(P[j], P[j + 1]);
                if (c0 && c1) j = this._edge(i, c0, c1, P, j), n = P.length;
            }
            else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) P = [
                this.xmin,
                this.ymin,
                this.xmax,
                this.ymin,
                this.xmax,
                this.ymax,
                this.xmin,
                this.ymax
            ];
            return P;
        }
        _edge(i, e0, e1, P, j) {
            while(e0 !== e1){
                let x, y;
                switch(e0){
                    case 5:
                        e0 = 4;
                        continue; // top-left
                    case 4:
                        e0 = 6, x = this.xmax, y = this.ymin;
                        break; // top
                    case 6:
                        e0 = 2;
                        continue; // top-right
                    case 2:
                        e0 = 10, x = this.xmax, y = this.ymax;
                        break; // right
                    case 10:
                        e0 = 8;
                        continue; // bottom-right
                    case 8:
                        e0 = 9, x = this.xmin, y = this.ymax;
                        break; // bottom
                    case 9:
                        e0 = 1;
                        continue; // bottom-left
                    case 1:
                        e0 = 5, x = this.xmin, y = this.ymin;
                        break; // left
                }
                // Note: this implicitly checks for out of bounds: if P[j] or P[j+1] are
                // undefined, the conditional statement will be executed.
                if ((P[j] !== x || P[j + 1] !== y) && this.contains(i, x, y)) P.splice(j, 0, x, y), j += 2;
            }
            if (P.length > 4) for(let i = 0; i < P.length; i += 2){
                const j = (i + 2) % P.length, k = (i + 4) % P.length;
                if (P[i] === P[j] && P[j] === P[k] || P[i + 1] === P[j + 1] && P[j + 1] === P[k + 1]) P.splice(j, 2), i -= 2;
            }
            return j;
        }
        _project(x0, y0, vx, vy) {
            let t = Infinity, c, x, y;
            if (vy < 0) {
                if (y0 <= this.ymin) return null;
                if ((c = (this.ymin - y0) / vy) < t) y = this.ymin, x = x0 + (t = c) * vx;
            } else if (vy > 0) {
                if (y0 >= this.ymax) return null;
                if ((c = (this.ymax - y0) / vy) < t) y = this.ymax, x = x0 + (t = c) * vx;
            }
            if (vx > 0) {
                if (x0 >= this.xmax) return null;
                if ((c = (this.xmax - x0) / vx) < t) x = this.xmax, y = y0 + (t = c) * vy;
            } else if (vx < 0) {
                if (x0 <= this.xmin) return null;
                if ((c = (this.xmin - x0) / vx) < t) x = this.xmin, y = y0 + (t = c) * vy;
            }
            return [
                x,
                y
            ];
        }
        _edgecode(x, y) {
            return (x === this.xmin ? 1 : x === this.xmax ? 2 : 0) | (y === this.ymin ? 4 : y === this.ymax ? 8 : 0);
        }
        _regioncode(x, y) {
            return (x < this.xmin ? 1 : x > this.xmax ? 2 : 0) | (y < this.ymin ? 4 : y > this.ymax ? 8 : 0);
        }
    }
    const tau$2 = 2 * Math.PI, pow$2 = Math.pow;
    function pointX(p) {
        return p[0];
    }
    function pointY(p) {
        return p[1];
    }
    // A triangulation is collinear if all its triangles have a non-null area
    function collinear(d) {
        const { triangles: triangles, coords: coords } = d;
        for(let i = 0; i < triangles.length; i += 3){
            const a = 2 * triangles[i], b = 2 * triangles[i + 1], c = 2 * triangles[i + 2], cross = (coords[c] - coords[a]) * (coords[b + 1] - coords[a + 1]) - (coords[b] - coords[a]) * (coords[c + 1] - coords[a + 1]);
            if (cross > 1e-10) return false;
        }
        return true;
    }
    function jitter(x, y, r) {
        return [
            x + Math.sin(x + y) * r,
            y + Math.cos(x - y) * r
        ];
    }
    class Delaunay {
        static from(points, fx = pointX, fy = pointY, that) {
            return new Delaunay("length" in points ? flatArray(points, fx, fy, that) : Float64Array.from(flatIterable(points, fx, fy, that)));
        }
        constructor(points){
            this._delaunator = new Delaunator(points);
            this.inedges = new Int32Array(points.length / 2);
            this._hullIndex = new Int32Array(points.length / 2);
            this.points = this._delaunator.coords;
            this._init();
        }
        update() {
            this._delaunator.update();
            this._init();
            return this;
        }
        _init() {
            const d = this._delaunator, points = this.points;
            // check for collinear
            if (d.hull && d.hull.length > 2 && collinear(d)) {
                this.collinear = Int32Array.from({
                    length: points.length / 2
                }, (_, i)=>i).sort((i, j)=>points[2 * i] - points[2 * j] || points[2 * i + 1] - points[2 * j + 1]); // for exact neighbors
                const e = this.collinear[0], f = this.collinear[this.collinear.length - 1], bounds = [
                    points[2 * e],
                    points[2 * e + 1],
                    points[2 * f],
                    points[2 * f + 1]
                ], r = 1e-8 * Math.hypot(bounds[3] - bounds[1], bounds[2] - bounds[0]);
                for(let i = 0, n = points.length / 2; i < n; ++i){
                    const p = jitter(points[2 * i], points[2 * i + 1], r);
                    points[2 * i] = p[0];
                    points[2 * i + 1] = p[1];
                }
                this._delaunator = new Delaunator(points);
            } else delete this.collinear;
            const halfedges = this.halfedges = this._delaunator.halfedges;
            const hull = this.hull = this._delaunator.hull;
            const triangles = this.triangles = this._delaunator.triangles;
            const inedges = this.inedges.fill(-1);
            const hullIndex = this._hullIndex.fill(-1);
            // Compute an index from each point to an (arbitrary) incoming halfedge
            // Used to give the first neighbor of each point; for this reason,
            // on the hull we give priority to exterior halfedges
            for(let e = 0, n = halfedges.length; e < n; ++e){
                const p = triangles[e % 3 === 2 ? e - 2 : e + 1];
                if (halfedges[e] === -1 || inedges[p] === -1) inedges[p] = e;
            }
            for(let i = 0, n = hull.length; i < n; ++i)hullIndex[hull[i]] = i;
            // degenerate case: 1 or 2 (distinct) points
            if (hull.length <= 2 && hull.length > 0) {
                this.triangles = new Int32Array(3).fill(-1);
                this.halfedges = new Int32Array(3).fill(-1);
                this.triangles[0] = hull[0];
                inedges[hull[0]] = 1;
                if (hull.length === 2) {
                    inedges[hull[1]] = 0;
                    this.triangles[1] = hull[1];
                    this.triangles[2] = hull[1];
                }
            }
        }
        voronoi(bounds) {
            return new Voronoi(this, bounds);
        }
        *neighbors(i) {
            const { inedges: inedges, hull: hull, _hullIndex: _hullIndex, halfedges: halfedges, triangles: triangles, collinear: collinear } = this;
            // degenerate case with several collinear points
            if (collinear) {
                const l = collinear.indexOf(i);
                if (l > 0) yield collinear[l - 1];
                if (l < collinear.length - 1) yield collinear[l + 1];
                return;
            }
            const e0 = inedges[i];
            if (e0 === -1) return; // coincident point
            let e = e0, p0 = -1;
            do {
                yield p0 = triangles[e];
                e = e % 3 === 2 ? e - 2 : e + 1;
                if (triangles[e] !== i) return; // bad triangulation
                e = halfedges[e];
                if (e === -1) {
                    const p = hull[(_hullIndex[i] + 1) % hull.length];
                    if (p !== p0) yield p;
                    return;
                }
            }while (e !== e0);
        }
        find(x, y, i = 0) {
            if ((x = +x, x !== x) || (y = +y, y !== y)) return -1;
            const i0 = i;
            let c;
            while((c = this._step(i, x, y)) >= 0 && c !== i && c !== i0)i = c;
            return c;
        }
        _step(i, x, y) {
            const { inedges: inedges, hull: hull, _hullIndex: _hullIndex, halfedges: halfedges, triangles: triangles, points: points } = this;
            if (inedges[i] === -1 || !points.length) return (i + 1) % (points.length >> 1);
            let c = i;
            let dc = pow$2(x - points[i * 2], 2) + pow$2(y - points[i * 2 + 1], 2);
            const e0 = inedges[i];
            let e = e0;
            do {
                let t = triangles[e];
                const dt = pow$2(x - points[t * 2], 2) + pow$2(y - points[t * 2 + 1], 2);
                if (dt < dc) dc = dt, c = t;
                e = e % 3 === 2 ? e - 2 : e + 1;
                if (triangles[e] !== i) break; // bad triangulation
                e = halfedges[e];
                if (e === -1) {
                    e = hull[(_hullIndex[i] + 1) % hull.length];
                    if (e !== t) {
                        if (pow$2(x - points[e * 2], 2) + pow$2(y - points[e * 2 + 1], 2) < dc) return e;
                    }
                    break;
                }
            }while (e !== e0);
            return c;
        }
        render(context) {
            const buffer = context == null ? context = new Path : undefined;
            const { points: points, halfedges: halfedges, triangles: triangles } = this;
            for(let i = 0, n = halfedges.length; i < n; ++i){
                const j = halfedges[i];
                if (j < i) continue;
                const ti = triangles[i] * 2;
                const tj = triangles[j] * 2;
                context.moveTo(points[ti], points[ti + 1]);
                context.lineTo(points[tj], points[tj + 1]);
            }
            this.renderHull(context);
            return buffer && buffer.value();
        }
        renderPoints(context, r) {
            if (r === undefined && (!context || typeof context.moveTo !== "function")) r = context, context = null;
            r = r == undefined ? 2 : +r;
            const buffer = context == null ? context = new Path : undefined;
            const { points: points } = this;
            for(let i = 0, n = points.length; i < n; i += 2){
                const x = points[i], y = points[i + 1];
                context.moveTo(x + r, y);
                context.arc(x, y, r, 0, tau$2);
            }
            return buffer && buffer.value();
        }
        renderHull(context) {
            const buffer = context == null ? context = new Path : undefined;
            const { hull: hull, points: points } = this;
            const h = hull[0] * 2, n = hull.length;
            context.moveTo(points[h], points[h + 1]);
            for(let i = 1; i < n; ++i){
                const h = 2 * hull[i];
                context.lineTo(points[h], points[h + 1]);
            }
            context.closePath();
            return buffer && buffer.value();
        }
        hullPolygon() {
            const polygon = new Polygon;
            this.renderHull(polygon);
            return polygon.value();
        }
        renderTriangle(i, context) {
            const buffer = context == null ? context = new Path : undefined;
            const { points: points, triangles: triangles } = this;
            const t0 = triangles[i *= 3] * 2;
            const t1 = triangles[i + 1] * 2;
            const t2 = triangles[i + 2] * 2;
            context.moveTo(points[t0], points[t0 + 1]);
            context.lineTo(points[t1], points[t1 + 1]);
            context.lineTo(points[t2], points[t2 + 1]);
            context.closePath();
            return buffer && buffer.value();
        }
        *trianglePolygons() {
            const { triangles: triangles } = this;
            for(let i = 0, n = triangles.length / 3; i < n; ++i)yield this.trianglePolygon(i);
        }
        trianglePolygon(i) {
            const polygon = new Polygon;
            this.renderTriangle(i, polygon);
            return polygon.value();
        }
    }
    function flatArray(points, fx, fy, that) {
        const n = points.length;
        const array = new Float64Array(n * 2);
        for(let i = 0; i < n; ++i){
            const p = points[i];
            array[i * 2] = fx.call(that, p, i, points);
            array[i * 2 + 1] = fy.call(that, p, i, points);
        }
        return array;
    }
    function* flatIterable(points, fx, fy, that) {
        let i = 0;
        for (const p of points){
            yield fx.call(that, p, i, points);
            yield fy.call(that, p, i, points);
            ++i;
        }
    }
    var EOL = {}, EOF = {}, QUOTE = 34, NEWLINE = 10, RETURN = 13;
    function objectConverter(columns) {
        return new Function("d", "return {" + columns.map(function(name, i) {
            return JSON.stringify(name) + ": d[" + i + "] || \"\"";
        }).join(",") + "}");
    }
    function customConverter(columns, f) {
        var object = objectConverter(columns);
        return function(row, i) {
            return f(object(row), i, columns);
        };
    }
    // Compute unique columns in order of discovery.
    function inferColumns(rows) {
        var columnSet = Object.create(null), columns = [];
        rows.forEach(function(row) {
            for(var column in row)if (!(column in columnSet)) columns.push(columnSet[column] = column);
        });
        return columns;
    }
    function pad$1(value, width) {
        var s = value + "", length = s.length;
        return length < width ? new Array(width - length + 1).join(0) + s : s;
    }
    function formatYear$1(year) {
        return year < 0 ? "-" + pad$1(-year, 6) : year > 9999 ? "+" + pad$1(year, 6) : pad$1(year, 4);
    }
    function formatDate(date) {
        var hours = date.getUTCHours(), minutes = date.getUTCMinutes(), seconds = date.getUTCSeconds(), milliseconds = date.getUTCMilliseconds();
        return isNaN(date) ? "Invalid Date" : formatYear$1(date.getUTCFullYear()) + "-" + pad$1(date.getUTCMonth() + 1, 2) + "-" + pad$1(date.getUTCDate(), 2) + (milliseconds ? "T" + pad$1(hours, 2) + ":" + pad$1(minutes, 2) + ":" + pad$1(seconds, 2) + "." + pad$1(milliseconds, 3) + "Z" : seconds ? "T" + pad$1(hours, 2) + ":" + pad$1(minutes, 2) + ":" + pad$1(seconds, 2) + "Z" : minutes || hours ? "T" + pad$1(hours, 2) + ":" + pad$1(minutes, 2) + "Z" : "");
    }
    function dsvFormat(delimiter) {
        var reFormat = new RegExp("[\"" + delimiter + "\n\r]"), DELIMITER = delimiter.charCodeAt(0);
        function parse(text, f) {
            var convert, columns, rows = parseRows(text, function(row, i) {
                if (convert) return convert(row, i - 1);
                columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
            });
            rows.columns = columns || [];
            return rows;
        }
        function parseRows(text, f) {
            var rows = [], N = text.length, I = 0, n = 0, t, eof = N <= 0, eol = false; // current token followed by EOL?
            // Strip the trailing newline.
            if (text.charCodeAt(N - 1) === NEWLINE) --N;
            if (text.charCodeAt(N - 1) === RETURN) --N;
            function token() {
                if (eof) return EOF;
                if (eol) return eol = false, EOL;
                // Unescape quotes.
                var i, j = I, c;
                if (text.charCodeAt(j) === QUOTE) {
                    while(I++ < N && text.charCodeAt(I) !== QUOTE || text.charCodeAt(++I) === QUOTE);
                    if ((i = I) >= N) eof = true;
                    else if ((c = text.charCodeAt(I++)) === NEWLINE) eol = true;
                    else if (c === RETURN) {
                        eol = true;
                        if (text.charCodeAt(I) === NEWLINE) ++I;
                    }
                    return text.slice(j + 1, i - 1).replace(/""/g, "\"");
                }
                // Find next delimiter or newline.
                while(I < N){
                    if ((c = text.charCodeAt(i = I++)) === NEWLINE) eol = true;
                    else if (c === RETURN) {
                        eol = true;
                        if (text.charCodeAt(I) === NEWLINE) ++I;
                    } else if (c !== DELIMITER) continue;
                    return text.slice(j, i);
                }
                // Return last token before EOF.
                return eof = true, text.slice(j, N);
            }
            while((t = token()) !== EOF){
                var row = [];
                while(t !== EOL && t !== EOF)row.push(t), t = token();
                if (f && (row = f(row, n++)) == null) continue;
                rows.push(row);
            }
            return rows;
        }
        function preformatBody(rows, columns) {
            return rows.map(function(row) {
                return columns.map(function(column) {
                    return formatValue(row[column]);
                }).join(delimiter);
            });
        }
        function format(rows, columns) {
            if (columns == null) columns = inferColumns(rows);
            return [
                columns.map(formatValue).join(delimiter)
            ].concat(preformatBody(rows, columns)).join("\n");
        }
        function formatBody(rows, columns) {
            if (columns == null) columns = inferColumns(rows);
            return preformatBody(rows, columns).join("\n");
        }
        function formatRows(rows) {
            return rows.map(formatRow).join("\n");
        }
        function formatRow(row) {
            return row.map(formatValue).join(delimiter);
        }
        function formatValue(value) {
            return value == null ? "" : value instanceof Date ? formatDate(value) : reFormat.test(value += "") ? "\"" + value.replace(/"/g, "\"\"") + "\"" : value;
        }
        return {
            parse: parse,
            parseRows: parseRows,
            format: format,
            formatBody: formatBody,
            formatRows: formatRows,
            formatRow: formatRow,
            formatValue: formatValue
        };
    }
    var csv$1 = dsvFormat(",");
    var csvParse = csv$1.parse;
    var csvParseRows = csv$1.parseRows;
    var csvFormat = csv$1.format;
    var csvFormatBody = csv$1.formatBody;
    var csvFormatRows = csv$1.formatRows;
    var csvFormatRow = csv$1.formatRow;
    var csvFormatValue = csv$1.formatValue;
    var tsv$1 = dsvFormat("\t");
    var tsvParse = tsv$1.parse;
    var tsvParseRows = tsv$1.parseRows;
    var tsvFormat = tsv$1.format;
    var tsvFormatBody = tsv$1.formatBody;
    var tsvFormatRows = tsv$1.formatRows;
    var tsvFormatRow = tsv$1.formatRow;
    var tsvFormatValue = tsv$1.formatValue;
    function autoType(object) {
        for(var key in object){
            var value = object[key].trim(), number, m;
            if (!value) value = null;
            else if (value === "true") value = true;
            else if (value === "false") value = false;
            else if (value === "NaN") value = NaN;
            else if (!isNaN(number = +value)) value = number;
            else if (m = value.match(/^([-+]\d{2})?\d{4}(-\d{2}(-\d{2})?)?(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[-+]\d{2}:\d{2})?)?$/)) {
                if (fixtz && !!m[4] && !m[7]) value = value.replace(/-/g, "/").replace(/T/, " ");
                value = new Date(value);
            } else continue;
            object[key] = value;
        }
        return object;
    }
    // https://github.com/d3/d3-dsv/issues/45
    const fixtz = new Date("2019-01-01T00:00").getHours() || new Date("2019-07-01T00:00").getHours();
    function responseBlob(response) {
        if (!response.ok) throw new Error(response.status + " " + response.statusText);
        return response.blob();
    }
    function blob(input, init) {
        return fetch(input, init).then(responseBlob);
    }
    function responseArrayBuffer(response) {
        if (!response.ok) throw new Error(response.status + " " + response.statusText);
        return response.arrayBuffer();
    }
    function buffer(input, init) {
        return fetch(input, init).then(responseArrayBuffer);
    }
    function responseText(response) {
        if (!response.ok) throw new Error(response.status + " " + response.statusText);
        return response.text();
    }
    function text(input, init) {
        return fetch(input, init).then(responseText);
    }
    function dsvParse(parse) {
        return function(input, init, row) {
            if (arguments.length === 2 && typeof init === "function") row = init, init = undefined;
            return text(input, init).then(function(response) {
                return parse(response, row);
            });
        };
    }
    function dsv(delimiter, input, init, row) {
        if (arguments.length === 3 && typeof init === "function") row = init, init = undefined;
        var format = dsvFormat(delimiter);
        return text(input, init).then(function(response) {
            return format.parse(response, row);
        });
    }
    var csv = dsvParse(csvParse);
    var tsv = dsvParse(tsvParse);
    function image(input, init) {
        return new Promise(function(resolve, reject) {
            var image = new Image;
            for(var key in init)image[key] = init[key];
            image.onerror = reject;
            image.onload = function() {
                resolve(image);
            };
            image.src = input;
        });
    }
    function responseJson(response) {
        if (!response.ok) throw new Error(response.status + " " + response.statusText);
        if (response.status === 204 || response.status === 205) return;
        return response.json();
    }
    function json(input, init) {
        return fetch(input, init).then(responseJson);
    }
    function parser(type) {
        return (input, init)=>text(input, init).then((text)=>(new DOMParser).parseFromString(text, type));
    }
    var xml = parser("application/xml");
    var html = parser("text/html");
    var svg = parser("image/svg+xml");
    function center(x, y) {
        var nodes, strength = 1;
        if (x == null) x = 0;
        if (y == null) y = 0;
        function force() {
            var i, n = nodes.length, node, sx = 0, sy = 0;
            for(i = 0; i < n; ++i)node = nodes[i], sx += node.x, sy += node.y;
            for(sx = (sx / n - x) * strength, sy = (sy / n - y) * strength, i = 0; i < n; ++i)node = nodes[i], node.x -= sx, node.y -= sy;
        }
        force.initialize = function(_) {
            nodes = _;
        };
        force.x = function(_) {
            return arguments.length ? (x = +_, force) : x;
        };
        force.y = function(_) {
            return arguments.length ? (y = +_, force) : y;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = +_, force) : strength;
        };
        return force;
    }
    function tree_add(d) {
        const x = +this._x.call(null, d), y = +this._y.call(null, d);
        return add(this.cover(x, y), x, y, d);
    }
    function add(tree, x, y, d) {
        if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
        var parent, node = tree._root, leaf = {
            data: d
        }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
        // If the tree is empty, initialize the root as a leaf.
        if (!node) return tree._root = leaf, tree;
        // Find the existing leaf for the new point, or add it.
        while(node.length){
            if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
            else x1 = xm;
            if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
            else y1 = ym;
            if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
        }
        // Is the new point is exactly coincident with the existing point?
        xp = +tree._x.call(null, node.data);
        yp = +tree._y.call(null, node.data);
        if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
        // Otherwise, split the leaf node until the old and new point are separated.
        do {
            parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
            if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
            else x1 = xm;
            if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
            else y1 = ym;
        }while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
        return parent[j] = node, parent[i] = leaf, tree;
    }
    function addAll(data) {
        var d, i, n = data.length, x, y, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
        // Compute the points and their extent.
        for(i = 0; i < n; ++i){
            if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
            xz[i] = x;
            yz[i] = y;
            if (x < x0) x0 = x;
            if (x > x1) x1 = x;
            if (y < y0) y0 = y;
            if (y > y1) y1 = y;
        }
        // If there were no (valid) points, abort.
        if (x0 > x1 || y0 > y1) return this;
        // Expand the tree to cover the new points.
        this.cover(x0, y0).cover(x1, y1);
        // Add the new points.
        for(i = 0; i < n; ++i)add(this, xz[i], yz[i], data[i]);
        return this;
    }
    function tree_cover(x, y) {
        if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
        var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
        // If the quadtree has no extent, initialize them.
        // Integer extent are necessary so that if we later double the extent,
        // the existing quadrant boundaries don’t change due to floating point error!
        if (isNaN(x0)) {
            x1 = (x0 = Math.floor(x)) + 1;
            y1 = (y0 = Math.floor(y)) + 1;
        } else {
            var z = x1 - x0 || 1, node = this._root, parent, i;
            while(x0 > x || x >= x1 || y0 > y || y >= y1){
                i = (y < y0) << 1 | x < x0;
                parent = new Array(4), parent[i] = node, node = parent, z *= 2;
                switch(i){
                    case 0:
                        x1 = x0 + z, y1 = y0 + z;
                        break;
                    case 1:
                        x0 = x1 - z, y1 = y0 + z;
                        break;
                    case 2:
                        x1 = x0 + z, y0 = y1 - z;
                        break;
                    case 3:
                        x0 = x1 - z, y0 = y1 - z;
                        break;
                }
            }
            if (this._root && this._root.length) this._root = node;
        }
        this._x0 = x0;
        this._y0 = y0;
        this._x1 = x1;
        this._y1 = y1;
        return this;
    }
    function tree_data() {
        var data = [];
        this.visit(function(node) {
            if (!node.length) do data.push(node.data);
            while (node = node.next);
        });
        return data;
    }
    function tree_extent(_) {
        return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [
            [
                this._x0,
                this._y0
            ],
            [
                this._x1,
                this._y1
            ]
        ];
    }
    function Quad(node, x0, y0, x1, y1) {
        this.node = node;
        this.x0 = x0;
        this.y0 = y0;
        this.x1 = x1;
        this.y1 = y1;
    }
    function tree_find(x, y, radius) {
        var data, x0 = this._x0, y0 = this._y0, x1, y1, x2, y2, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
        if (node) quads.push(new Quad(node, x0, y0, x3, y3));
        if (radius == null) radius = Infinity;
        else {
            x0 = x - radius, y0 = y - radius;
            x3 = x + radius, y3 = y + radius;
            radius *= radius;
        }
        while(q = quads.pop()){
            // Stop searching if this quadrant can’t contain a closer node.
            if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
            // Bisect the current quadrant.
            if (node.length) {
                var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2;
                quads.push(new Quad(node[3], xm, ym, x2, y2), new Quad(node[2], x1, ym, xm, y2), new Quad(node[1], xm, y1, x2, ym), new Quad(node[0], x1, y1, xm, ym));
                // Visit the closest quadrant first.
                if (i = (y >= ym) << 1 | x >= xm) {
                    q = quads[quads.length - 1];
                    quads[quads.length - 1] = quads[quads.length - 1 - i];
                    quads[quads.length - 1 - i] = q;
                }
            } else {
                var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
                if (d2 < radius) {
                    var d = Math.sqrt(radius = d2);
                    x0 = x - d, y0 = y - d;
                    x3 = x + d, y3 = y + d;
                    data = node.data;
                }
            }
        }
        return data;
    }
    function tree_remove(d) {
        if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
        var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x, y, xm, ym, right, bottom, i, j;
        // If the tree is empty, initialize the root as a leaf.
        if (!node) return this;
        // Find the leaf node for the point.
        // While descending, also retain the deepest parent with a non-removed sibling.
        if (node.length) while(true){
            if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
            else x1 = xm;
            if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
            else y1 = ym;
            if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
            if (!node.length) break;
            if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
        }
        // Find the point to remove.
        while(node.data !== d)if (!(previous = node, node = node.next)) return this;
        if (next = node.next) delete node.next;
        // If there are multiple coincident points, remove just the point.
        if (previous) return next ? previous.next = next : delete previous.next, this;
        // If this is the root point, remove it.
        if (!parent) return this._root = next, this;
        // Remove this leaf.
        next ? parent[i] = next : delete parent[i];
        // If the parent now contains exactly one leaf, collapse superfluous parents.
        if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
            if (retainer) retainer[j] = node;
            else this._root = node;
        }
        return this;
    }
    function removeAll(data) {
        for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
        return this;
    }
    function tree_root() {
        return this._root;
    }
    function tree_size() {
        var size = 0;
        this.visit(function(node) {
            if (!node.length) do ++size;
            while (node = node.next);
        });
        return size;
    }
    function tree_visit(callback) {
        var quads = [], q, node = this._root, child, x0, y0, x1, y1;
        if (node) quads.push(new Quad(node, this._x0, this._y0, this._x1, this._y1));
        while(q = quads.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
            var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
            if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
            if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
            if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
            if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
        }
        return this;
    }
    function tree_visitAfter(callback) {
        var quads = [], next = [], q;
        if (this._root) quads.push(new Quad(this._root, this._x0, this._y0, this._x1, this._y1));
        while(q = quads.pop()){
            var node = q.node;
            if (node.length) {
                var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
                if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
                if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
                if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
                if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
            }
            next.push(q);
        }
        while(q = next.pop())callback(q.node, q.x0, q.y0, q.x1, q.y1);
        return this;
    }
    function defaultX(d) {
        return d[0];
    }
    function tree_x(_) {
        return arguments.length ? (this._x = _, this) : this._x;
    }
    function defaultY(d) {
        return d[1];
    }
    function tree_y(_) {
        return arguments.length ? (this._y = _, this) : this._y;
    }
    function quadtree(nodes, x, y) {
        var tree = new Quadtree(x == null ? defaultX : x, y == null ? defaultY : y, NaN, NaN, NaN, NaN);
        return nodes == null ? tree : tree.addAll(nodes);
    }
    function Quadtree(x, y, x0, y0, x1, y1) {
        this._x = x;
        this._y = y;
        this._x0 = x0;
        this._y0 = y0;
        this._x1 = x1;
        this._y1 = y1;
        this._root = undefined;
    }
    function leaf_copy(leaf) {
        var copy = {
            data: leaf.data
        }, next = copy;
        while(leaf = leaf.next)next = next.next = {
            data: leaf.data
        };
        return copy;
    }
    var treeProto = quadtree.prototype = Quadtree.prototype;
    treeProto.copy = function() {
        var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
        if (!node) return copy;
        if (!node.length) return copy._root = leaf_copy(node), copy;
        nodes = [
            {
                source: node,
                target: copy._root = new Array(4)
            }
        ];
        while(node = nodes.pop()){
            for(var i = 0; i < 4; ++i)if (child = node.source[i]) {
                if (child.length) nodes.push({
                    source: child,
                    target: node.target[i] = new Array(4)
                });
                else node.target[i] = leaf_copy(child);
            }
        }
        return copy;
    };
    treeProto.add = tree_add;
    treeProto.addAll = addAll;
    treeProto.cover = tree_cover;
    treeProto.data = tree_data;
    treeProto.extent = tree_extent;
    treeProto.find = tree_find;
    treeProto.remove = tree_remove;
    treeProto.removeAll = removeAll;
    treeProto.root = tree_root;
    treeProto.size = tree_size;
    treeProto.visit = tree_visit;
    treeProto.visitAfter = tree_visitAfter;
    treeProto.x = tree_x;
    treeProto.y = tree_y;
    function constant$4(x) {
        return function() {
            return x;
        };
    }
    function jiggle(random) {
        return (random() - 0.5) * 1e-6;
    }
    function x$4(d) {
        return d.x + d.vx;
    }
    function y$3(d) {
        return d.y + d.vy;
    }
    function collide(radius) {
        var nodes, radii, random, strength = 1, iterations = 1;
        if (typeof radius !== "function") radius = constant$4(radius == null ? 1 : +radius);
        function force() {
            var i, n = nodes.length, tree, node, xi, yi, ri, ri2;
            for(var k = 0; k < iterations; ++k){
                tree = quadtree(nodes, x$4, y$3).visitAfter(prepare);
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    ri = radii[node.index], ri2 = ri * ri;
                    xi = node.x + node.vx;
                    yi = node.y + node.vy;
                    tree.visit(apply);
                }
            }
            function apply(quad, x0, y0, x1, y1) {
                var data = quad.data, rj = quad.r, r = ri + rj;
                if (data) {
                    if (data.index > node.index) {
                        var x = xi - data.x - data.vx, y = yi - data.y - data.vy, l = x * x + y * y;
                        if (l < r * r) {
                            if (x === 0) x = jiggle(random), l += x * x;
                            if (y === 0) y = jiggle(random), l += y * y;
                            l = (r - (l = Math.sqrt(l))) / l * strength;
                            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
                            node.vy += (y *= l) * r;
                            data.vx -= x * (r = 1 - r);
                            data.vy -= y * r;
                        }
                    }
                    return;
                }
                return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
            }
        }
        function prepare(quad) {
            if (quad.data) return quad.r = radii[quad.data.index];
            for(var i = quad.r = 0; i < 4; ++i)if (quad[i] && quad[i].r > quad.r) quad.r = quad[i].r;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, node;
            radii = new Array(n);
            for(i = 0; i < n; ++i)node = nodes[i], radii[node.index] = +radius(node, i, nodes);
        }
        force.initialize = function(_nodes, _random) {
            nodes = _nodes;
            random = _random;
            initialize();
        };
        force.iterations = function(_) {
            return arguments.length ? (iterations = +_, force) : iterations;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = +_, force) : strength;
        };
        force.radius = function(_) {
            return arguments.length ? (radius = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : radius;
        };
        return force;
    }
    function index$3(d) {
        return d.index;
    }
    function find(nodeById, nodeId) {
        var node = nodeById.get(nodeId);
        if (!node) throw new Error("node not found: " + nodeId);
        return node;
    }
    function link$2(links) {
        var id = index$3, strength = defaultStrength, strengths, distance = constant$4(30), distances, nodes, count, bias, random, iterations = 1;
        if (links == null) links = [];
        function defaultStrength(link) {
            return 1 / Math.min(count[link.source.index], count[link.target.index]);
        }
        function force(alpha) {
            for(var k = 0, n = links.length; k < iterations; ++k)for(var i = 0, link, source, target, x, y, l, b; i < n; ++i){
                link = links[i], source = link.source, target = link.target;
                x = target.x + target.vx - source.x - source.vx || jiggle(random);
                y = target.y + target.vy - source.y - source.vy || jiggle(random);
                l = Math.sqrt(x * x + y * y);
                l = (l - distances[i]) / l * alpha * strengths[i];
                x *= l, y *= l;
                target.vx -= x * (b = bias[i]);
                target.vy -= y * b;
                source.vx += x * (b = 1 - b);
                source.vy += y * b;
            }
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, m = links.length, nodeById = new Map(nodes.map((d, i)=>[
                    id(d, i, nodes),
                    d
                ])), link;
            for(i = 0, count = new Array(n); i < m; ++i){
                link = links[i], link.index = i;
                if (typeof link.source !== "object") link.source = find(nodeById, link.source);
                if (typeof link.target !== "object") link.target = find(nodeById, link.target);
                count[link.source.index] = (count[link.source.index] || 0) + 1;
                count[link.target.index] = (count[link.target.index] || 0) + 1;
            }
            for(i = 0, bias = new Array(m); i < m; ++i)link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
            strengths = new Array(m), initializeStrength();
            distances = new Array(m), initializeDistance();
        }
        function initializeStrength() {
            if (!nodes) return;
            for(var i = 0, n = links.length; i < n; ++i)strengths[i] = +strength(links[i], i, links);
        }
        function initializeDistance() {
            if (!nodes) return;
            for(var i = 0, n = links.length; i < n; ++i)distances[i] = +distance(links[i], i, links);
        }
        force.initialize = function(_nodes, _random) {
            nodes = _nodes;
            random = _random;
            initialize();
        };
        force.links = function(_) {
            return arguments.length ? (links = _, initialize(), force) : links;
        };
        force.id = function(_) {
            return arguments.length ? (id = _, force) : id;
        };
        force.iterations = function(_) {
            return arguments.length ? (iterations = +_, force) : iterations;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : constant$4(+_), initializeStrength(), force) : strength;
        };
        force.distance = function(_) {
            return arguments.length ? (distance = typeof _ === "function" ? _ : constant$4(+_), initializeDistance(), force) : distance;
        };
        return force;
    }
    // https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
    const a$2 = 1664525;
    const c$4 = 1013904223;
    const m$1 = 4294967296; // 2^32
    function lcg$2() {
        let s = 1;
        return ()=>(s = (a$2 * s + c$4) % m$1) / m$1;
    }
    function x$3(d) {
        return d.x;
    }
    function y$2(d) {
        return d.y;
    }
    var initialRadius = 10, initialAngle = Math.PI * (3 - Math.sqrt(5));
    function simulation(nodes) {
        var simulation, alpha = 1, alphaMin = 0.001, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = new Map(), stepper = timer(step), event = dispatch("tick", "end"), random = lcg$2();
        if (nodes == null) nodes = [];
        function step() {
            tick();
            event.call("tick", simulation);
            if (alpha < alphaMin) {
                stepper.stop();
                event.call("end", simulation);
            }
        }
        function tick(iterations) {
            var i, n = nodes.length, node;
            if (iterations === undefined) iterations = 1;
            for(var k = 0; k < iterations; ++k){
                alpha += (alphaTarget - alpha) * alphaDecay;
                forces.forEach(function(force) {
                    force(alpha);
                });
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    if (node.fx == null) node.x += node.vx *= velocityDecay;
                    else node.x = node.fx, node.vx = 0;
                    if (node.fy == null) node.y += node.vy *= velocityDecay;
                    else node.y = node.fy, node.vy = 0;
                }
            }
            return simulation;
        }
        function initializeNodes() {
            for(var i = 0, n = nodes.length, node; i < n; ++i){
                node = nodes[i], node.index = i;
                if (node.fx != null) node.x = node.fx;
                if (node.fy != null) node.y = node.fy;
                if (isNaN(node.x) || isNaN(node.y)) {
                    var radius = initialRadius * Math.sqrt(0.5 + i), angle = i * initialAngle;
                    node.x = radius * Math.cos(angle);
                    node.y = radius * Math.sin(angle);
                }
                if (isNaN(node.vx) || isNaN(node.vy)) node.vx = node.vy = 0;
            }
        }
        function initializeForce(force) {
            if (force.initialize) force.initialize(nodes, random);
            return force;
        }
        initializeNodes();
        return simulation = {
            tick: tick,
            restart: function() {
                return stepper.restart(step), simulation;
            },
            stop: function() {
                return stepper.stop(), simulation;
            },
            nodes: function(_) {
                return arguments.length ? (nodes = _, initializeNodes(), forces.forEach(initializeForce), simulation) : nodes;
            },
            alpha: function(_) {
                return arguments.length ? (alpha = +_, simulation) : alpha;
            },
            alphaMin: function(_) {
                return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
            },
            alphaDecay: function(_) {
                return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
            },
            alphaTarget: function(_) {
                return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
            },
            velocityDecay: function(_) {
                return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
            },
            randomSource: function(_) {
                return arguments.length ? (random = _, forces.forEach(initializeForce), simulation) : random;
            },
            force: function(name, _) {
                return arguments.length > 1 ? (_ == null ? forces.delete(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
            },
            find: function(x, y, radius) {
                var i = 0, n = nodes.length, dx, dy, d2, node, closest;
                if (radius == null) radius = Infinity;
                else radius *= radius;
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    dx = x - node.x;
                    dy = y - node.y;
                    d2 = dx * dx + dy * dy;
                    if (d2 < radius) closest = node, radius = d2;
                }
                return closest;
            },
            on: function(name, _) {
                return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
            }
        };
    }
    function manyBody() {
        var nodes, node, random, alpha, strength = constant$4(-30), strengths, distanceMin2 = 1, distanceMax2 = Infinity, theta2 = 0.81;
        function force(_) {
            var i, n = nodes.length, tree = quadtree(nodes, x$3, y$2).visitAfter(accumulate);
            for(alpha = _, i = 0; i < n; ++i)node = nodes[i], tree.visit(apply);
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, node;
            strengths = new Array(n);
            for(i = 0; i < n; ++i)node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
        }
        function accumulate(quad) {
            var strength = 0, q, c, weight = 0, x, y, i;
            // For internal nodes, accumulate forces from child quadrants.
            if (quad.length) {
                for(x = y = i = 0; i < 4; ++i)if ((q = quad[i]) && (c = Math.abs(q.value))) strength += q.value, weight += c, x += c * q.x, y += c * q.y;
                quad.x = x / weight;
                quad.y = y / weight;
            } else {
                q = quad;
                q.x = q.data.x;
                q.y = q.data.y;
                do strength += strengths[q.data.index];
                while (q = q.next);
            }
            quad.value = strength;
        }
        function apply(quad, x1, _, x2) {
            if (!quad.value) return true;
            var x = quad.x - node.x, y = quad.y - node.y, w = x2 - x1, l = x * x + y * y;
            // Apply the Barnes-Hut approximation if possible.
            // Limit forces for very close nodes; randomize direction if coincident.
            if (w * w / theta2 < l) {
                if (l < distanceMax2) {
                    if (x === 0) x = jiggle(random), l += x * x;
                    if (y === 0) y = jiggle(random), l += y * y;
                    if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
                    node.vx += x * quad.value * alpha / l;
                    node.vy += y * quad.value * alpha / l;
                }
                return true;
            } else if (quad.length || l >= distanceMax2) return;
            // Limit forces for very close nodes; randomize direction if coincident.
            if (quad.data !== node || quad.next) {
                if (x === 0) x = jiggle(random), l += x * x;
                if (y === 0) y = jiggle(random), l += y * y;
                if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
            }
            do if (quad.data !== node) {
                w = strengths[quad.data.index] * alpha / l;
                node.vx += x * w;
                node.vy += y * w;
            }
            while (quad = quad.next);
        }
        force.initialize = function(_nodes, _random) {
            nodes = _nodes;
            random = _random;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : strength;
        };
        force.distanceMin = function(_) {
            return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
        };
        force.distanceMax = function(_) {
            return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
        };
        force.theta = function(_) {
            return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
        };
        return force;
    }
    function radial$1(radius, x, y) {
        var nodes, strength = constant$4(0.1), strengths, radiuses;
        if (typeof radius !== "function") radius = constant$4(+radius);
        if (x == null) x = 0;
        if (y == null) y = 0;
        function force(alpha) {
            for(var i = 0, n = nodes.length; i < n; ++i){
                var node = nodes[i], dx = node.x - x || 1e-6, dy = node.y - y || 1e-6, r = Math.sqrt(dx * dx + dy * dy), k = (radiuses[i] - r) * strengths[i] * alpha / r;
                node.vx += dx * k;
                node.vy += dy * k;
            }
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length;
            strengths = new Array(n);
            radiuses = new Array(n);
            for(i = 0; i < n; ++i){
                radiuses[i] = +radius(nodes[i], i, nodes);
                strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
            }
        }
        force.initialize = function(_) {
            nodes = _, initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : strength;
        };
        force.radius = function(_) {
            return arguments.length ? (radius = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : radius;
        };
        force.x = function(_) {
            return arguments.length ? (x = +_, force) : x;
        };
        force.y = function(_) {
            return arguments.length ? (y = +_, force) : y;
        };
        return force;
    }
    function x$2(x) {
        var strength = constant$4(0.1), nodes, strengths, xz;
        if (typeof x !== "function") x = constant$4(x == null ? 0 : +x);
        function force(alpha) {
            for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length;
            strengths = new Array(n);
            xz = new Array(n);
            for(i = 0; i < n; ++i)strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
        }
        force.initialize = function(_) {
            nodes = _;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : strength;
        };
        force.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : x;
        };
        return force;
    }
    function y$1(y) {
        var strength = constant$4(0.1), nodes, strengths, yz;
        if (typeof y !== "function") y = constant$4(y == null ? 0 : +y);
        function force(alpha) {
            for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length;
            strengths = new Array(n);
            yz = new Array(n);
            for(i = 0; i < n; ++i)strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
        }
        force.initialize = function(_) {
            nodes = _;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : strength;
        };
        force.y = function(_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : y;
        };
        return force;
    }
    function formatDecimal(x) {
        return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
    }
    // Computes the decimal coefficient and exponent of the specified number x with
    // significant digits p, where x is positive and p is in [1, 21] or undefined.
    // For example, formatDecimalParts(1.23) returns ["123", 0].
    function formatDecimalParts(x, p) {
        if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
        var i, coefficient = x.slice(0, i);
        // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
        // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
        return [
            coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
            +x.slice(i + 1)
        ];
    }
    function exponent(x) {
        return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
    }
    function formatGroup(grouping, thousands) {
        return function(value, width) {
            var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
            while(i > 0 && g > 0){
                if (length + g + 1 > width) g = Math.max(1, width - length);
                t.push(value.substring(i -= g, i + g));
                if ((length += g + 1) > width) break;
                g = grouping[j = (j + 1) % grouping.length];
            }
            return t.reverse().join(thousands);
        };
    }
    function formatNumerals(numerals) {
        return function(value) {
            return value.replace(/[0-9]/g, function(i) {
                return numerals[+i];
            });
        };
    }
    // [[fill]align][sign][symbol][0][width][,][.precision][~][type]
    var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
    function formatSpecifier(specifier) {
        if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
        var match;
        return new FormatSpecifier({
            fill: match[1],
            align: match[2],
            sign: match[3],
            symbol: match[4],
            zero: match[5],
            width: match[6],
            comma: match[7],
            precision: match[8] && match[8].slice(1),
            trim: match[9],
            type: match[10]
        });
    }
    formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
    function FormatSpecifier(specifier) {
        this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
        this.align = specifier.align === undefined ? ">" : specifier.align + "";
        this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
        this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
        this.zero = !!specifier.zero;
        this.width = specifier.width === undefined ? undefined : +specifier.width;
        this.comma = !!specifier.comma;
        this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
        this.trim = !!specifier.trim;
        this.type = specifier.type === undefined ? "" : specifier.type + "";
    }
    FormatSpecifier.prototype.toString = function() {
        return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
    };
    // Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
    function formatTrim(s) {
        out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
            case ".":
                i0 = i1 = i;
                break;
            case "0":
                if (i0 === 0) i0 = i;
                i1 = i;
                break;
            default:
                if (!+s[i]) break out;
                if (i0 > 0) i0 = 0;
                break;
        }
        return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
    }
    var prefixExponent;
    function formatPrefixAuto(x, p) {
        var d = formatDecimalParts(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1], i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
        return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0]; // less than 1y!
    }
    function formatRounded(x, p) {
        var d = formatDecimalParts(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1];
        return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
    }
    var formatTypes = {
        "%": (x, p)=>(x * 100).toFixed(p),
        "b": (x)=>Math.round(x).toString(2),
        "c": (x)=>x + "",
        "d": formatDecimal,
        "e": (x, p)=>x.toExponential(p),
        "f": (x, p)=>x.toFixed(p),
        "g": (x, p)=>x.toPrecision(p),
        "o": (x)=>Math.round(x).toString(8),
        "p": (x, p)=>formatRounded(x * 100, p),
        "r": formatRounded,
        "s": formatPrefixAuto,
        "X": (x)=>Math.round(x).toString(16).toUpperCase(),
        "x": (x)=>Math.round(x).toString(16)
    };
    function identity$6(x) {
        return x;
    }
    var map = Array.prototype.map, prefixes = [
        "y",
        "z",
        "a",
        "f",
        "p",
        "n",
        "\xB5",
        "m",
        "",
        "k",
        "M",
        "G",
        "T",
        "P",
        "E",
        "Z",
        "Y"
    ];
    function formatLocale$1(locale) {
        var group = locale.grouping === undefined || locale.thousands === undefined ? identity$6 : formatGroup(map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? identity$6 : formatNumerals(map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
        function newFormat(specifier) {
            specifier = formatSpecifier(specifier);
            var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
            // The "n" type is an alias for ",g".
            if (type === "n") comma = true, type = "g";
            else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";
            // If zero fill is specified, padding goes after sign and before digits.
            if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
            // Compute the prefix and suffix.
            // For SI-prefix, the suffix is lazily computed.
            var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
            // What format function should we use?
            // Is this an integer type?
            // Can this type generate exponential notation?
            var formatType = formatTypes[type], maybeSuffix = /[defgprs%]/.test(type);
            // Set the default precision if not specified,
            // or clamp the specified precision to the supported range.
            // For significant precision, it must be in [1, 21].
            // For fixed precision, it must be in [0, 20].
            precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
            function format(value) {
                var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
                if (type === "c") {
                    valueSuffix = formatType(value) + valueSuffix;
                    value = "";
                } else {
                    value = +value;
                    // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                    var valueNegative = value < 0 || 1 / value < 0;
                    // Perform the initial formatting.
                    value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                    // Trim insignificant zeros.
                    if (trim) value = formatTrim(value);
                    // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                    if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                    // Compute the prefix and suffix.
                    valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                    valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                    // Break the formatted value into the integer “value” part that can be
                    // grouped, and fractional or exponential “suffix” part that is not.
                    if (maybeSuffix) {
                        i = -1, n = value.length;
                        while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                            valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                            value = value.slice(0, i);
                            break;
                        }
                    }
                }
                // If the fill character is not "0", grouping is applied before padding.
                if (comma && !zero) value = group(value, Infinity);
                // Compute the padding.
                var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
                // If the fill character is "0", grouping is applied after padding.
                if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
                // Reconstruct the final output based on the desired alignment.
                switch(align){
                    case "<":
                        value = valuePrefix + value + valueSuffix + padding;
                        break;
                    case "=":
                        value = valuePrefix + padding + value + valueSuffix;
                        break;
                    case "^":
                        value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                        break;
                    default:
                        value = padding + valuePrefix + value + valueSuffix;
                        break;
                }
                return numerals(value);
            }
            format.toString = function() {
                return specifier + "";
            };
            return format;
        }
        function formatPrefix(specifier, value) {
            var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3, k = Math.pow(10, -e), prefix = prefixes[8 + e / 3];
            return function(value) {
                return f(k * value) + prefix;
            };
        }
        return {
            format: newFormat,
            formatPrefix: formatPrefix
        };
    }
    var locale$1;
    exports1.format = void 0;
    exports1.formatPrefix = void 0;
    defaultLocale$1({
        thousands: ",",
        grouping: [
            3
        ],
        currency: [
            "$",
            ""
        ]
    });
    function defaultLocale$1(definition) {
        locale$1 = formatLocale$1(definition);
        exports1.format = locale$1.format;
        exports1.formatPrefix = locale$1.formatPrefix;
        return locale$1;
    }
    function precisionFixed(step) {
        return Math.max(0, -exponent(Math.abs(step)));
    }
    function precisionPrefix(step, value) {
        return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
    }
    function precisionRound(step, max) {
        step = Math.abs(step), max = Math.abs(max) - step;
        return Math.max(0, exponent(max) - exponent(step)) + 1;
    }
    var epsilon$1 = 1e-6;
    var epsilon2 = 1e-12;
    var pi$1 = Math.PI;
    var halfPi$1 = pi$1 / 2;
    var quarterPi = pi$1 / 4;
    var tau$1 = pi$1 * 2;
    var degrees = 180 / pi$1;
    var radians = pi$1 / 180;
    var abs$1 = Math.abs;
    var atan = Math.atan;
    var atan2$1 = Math.atan2;
    var cos$1 = Math.cos;
    var ceil = Math.ceil;
    var exp = Math.exp;
    var hypot = Math.hypot;
    var log$1 = Math.log;
    var pow$1 = Math.pow;
    var sin$1 = Math.sin;
    var sign$1 = Math.sign || function(x) {
        return x > 0 ? 1 : x < 0 ? -1 : 0;
    };
    var sqrt$2 = Math.sqrt;
    var tan = Math.tan;
    function acos$1(x) {
        return x > 1 ? 0 : x < -1 ? pi$1 : Math.acos(x);
    }
    function asin$1(x) {
        return x > 1 ? halfPi$1 : x < -1 ? -halfPi$1 : Math.asin(x);
    }
    function haversin(x) {
        return (x = sin$1(x / 2)) * x;
    }
    function noop$1() {}
    function streamGeometry(geometry, stream) {
        if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) streamGeometryType[geometry.type](geometry, stream);
    }
    var streamObjectType = {
        Feature: function(object, stream) {
            streamGeometry(object.geometry, stream);
        },
        FeatureCollection: function(object, stream) {
            var features = object.features, i = -1, n = features.length;
            while(++i < n)streamGeometry(features[i].geometry, stream);
        }
    };
    var streamGeometryType = {
        Sphere: function(object, stream) {
            stream.sphere();
        },
        Point: function(object, stream) {
            object = object.coordinates;
            stream.point(object[0], object[1], object[2]);
        },
        MultiPoint: function(object, stream) {
            var coordinates = object.coordinates, i = -1, n = coordinates.length;
            while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
        },
        LineString: function(object, stream) {
            streamLine(object.coordinates, stream, 0);
        },
        MultiLineString: function(object, stream) {
            var coordinates = object.coordinates, i = -1, n = coordinates.length;
            while(++i < n)streamLine(coordinates[i], stream, 0);
        },
        Polygon: function(object, stream) {
            streamPolygon(object.coordinates, stream);
        },
        MultiPolygon: function(object, stream) {
            var coordinates = object.coordinates, i = -1, n = coordinates.length;
            while(++i < n)streamPolygon(coordinates[i], stream);
        },
        GeometryCollection: function(object, stream) {
            var geometries = object.geometries, i = -1, n = geometries.length;
            while(++i < n)streamGeometry(geometries[i], stream);
        }
    };
    function streamLine(coordinates, stream, closed) {
        var i = -1, n = coordinates.length - closed, coordinate;
        stream.lineStart();
        while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
        stream.lineEnd();
    }
    function streamPolygon(coordinates, stream) {
        var i = -1, n = coordinates.length;
        stream.polygonStart();
        while(++i < n)streamLine(coordinates[i], stream, 1);
        stream.polygonEnd();
    }
    function geoStream(object, stream) {
        if (object && streamObjectType.hasOwnProperty(object.type)) streamObjectType[object.type](object, stream);
        else streamGeometry(object, stream);
    }
    var areaRingSum$1 = new Adder();
    // hello?
    var areaSum$1 = new Adder(), lambda00$2, phi00$2, lambda0$2, cosPhi0$1, sinPhi0$1;
    var areaStream$1 = {
        point: noop$1,
        lineStart: noop$1,
        lineEnd: noop$1,
        polygonStart: function() {
            areaRingSum$1 = new Adder();
            areaStream$1.lineStart = areaRingStart$1;
            areaStream$1.lineEnd = areaRingEnd$1;
        },
        polygonEnd: function() {
            var areaRing = +areaRingSum$1;
            areaSum$1.add(areaRing < 0 ? tau$1 + areaRing : areaRing);
            this.lineStart = this.lineEnd = this.point = noop$1;
        },
        sphere: function() {
            areaSum$1.add(tau$1);
        }
    };
    function areaRingStart$1() {
        areaStream$1.point = areaPointFirst$1;
    }
    function areaRingEnd$1() {
        areaPoint$1(lambda00$2, phi00$2);
    }
    function areaPointFirst$1(lambda, phi) {
        areaStream$1.point = areaPoint$1;
        lambda00$2 = lambda, phi00$2 = phi;
        lambda *= radians, phi *= radians;
        lambda0$2 = lambda, cosPhi0$1 = cos$1(phi = phi / 2 + quarterPi), sinPhi0$1 = sin$1(phi);
    }
    function areaPoint$1(lambda, phi) {
        lambda *= radians, phi *= radians;
        phi = phi / 2 + quarterPi; // half the angular distance from south pole
        // Spherical excess E for a spherical triangle with vertices: south pole,
        // previous point, current point.  Uses a formula derived from Cagnoli’s
        // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
        var dLambda = lambda - lambda0$2, sdLambda = dLambda >= 0 ? 1 : -1, adLambda = sdLambda * dLambda, cosPhi = cos$1(phi), sinPhi = sin$1(phi), k = sinPhi0$1 * sinPhi, u = cosPhi0$1 * cosPhi + k * cos$1(adLambda), v = k * sdLambda * sin$1(adLambda);
        areaRingSum$1.add(atan2$1(v, u));
        // Advance the previous points.
        lambda0$2 = lambda, cosPhi0$1 = cosPhi, sinPhi0$1 = sinPhi;
    }
    function area$2(object) {
        areaSum$1 = new Adder();
        geoStream(object, areaStream$1);
        return areaSum$1 * 2;
    }
    function spherical(cartesian) {
        return [
            atan2$1(cartesian[1], cartesian[0]),
            asin$1(cartesian[2])
        ];
    }
    function cartesian(spherical) {
        var lambda = spherical[0], phi = spherical[1], cosPhi = cos$1(phi);
        return [
            cosPhi * cos$1(lambda),
            cosPhi * sin$1(lambda),
            sin$1(phi)
        ];
    }
    function cartesianDot(a, b) {
        return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
    }
    function cartesianCross(a, b) {
        return [
            a[1] * b[2] - a[2] * b[1],
            a[2] * b[0] - a[0] * b[2],
            a[0] * b[1] - a[1] * b[0]
        ];
    }
    // TODO return a
    function cartesianAddInPlace(a, b) {
        a[0] += b[0], a[1] += b[1], a[2] += b[2];
    }
    function cartesianScale(vector, k) {
        return [
            vector[0] * k,
            vector[1] * k,
            vector[2] * k
        ];
    }
    // TODO return d
    function cartesianNormalizeInPlace(d) {
        var l = sqrt$2(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
        d[0] /= l, d[1] /= l, d[2] /= l;
    }
    var lambda0$1, phi0, lambda1, phi1, lambda2, lambda00$1, phi00$1, p0, deltaSum, ranges, range;
    var boundsStream$2 = {
        point: boundsPoint$1,
        lineStart: boundsLineStart,
        lineEnd: boundsLineEnd,
        polygonStart: function() {
            boundsStream$2.point = boundsRingPoint;
            boundsStream$2.lineStart = boundsRingStart;
            boundsStream$2.lineEnd = boundsRingEnd;
            deltaSum = new Adder();
            areaStream$1.polygonStart();
        },
        polygonEnd: function() {
            areaStream$1.polygonEnd();
            boundsStream$2.point = boundsPoint$1;
            boundsStream$2.lineStart = boundsLineStart;
            boundsStream$2.lineEnd = boundsLineEnd;
            if (areaRingSum$1 < 0) lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
            else if (deltaSum > epsilon$1) phi1 = 90;
            else if (deltaSum < -epsilon$1) phi0 = -90;
            range[0] = lambda0$1, range[1] = lambda1;
        },
        sphere: function() {
            lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
        }
    };
    function boundsPoint$1(lambda, phi) {
        ranges.push(range = [
            lambda0$1 = lambda,
            lambda1 = lambda
        ]);
        if (phi < phi0) phi0 = phi;
        if (phi > phi1) phi1 = phi;
    }
    function linePoint(lambda, phi) {
        var p = cartesian([
            lambda * radians,
            phi * radians
        ]);
        if (p0) {
            var normal = cartesianCross(p0, p), equatorial = [
                normal[1],
                -normal[0],
                0
            ], inflection = cartesianCross(equatorial, normal);
            cartesianNormalizeInPlace(inflection);
            inflection = spherical(inflection);
            var delta = lambda - lambda2, sign = delta > 0 ? 1 : -1, lambdai = inflection[0] * degrees * sign, phii, antimeridian = abs$1(delta) > 180;
            if (antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
                phii = inflection[1] * degrees;
                if (phii > phi1) phi1 = phii;
            } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
                phii = -inflection[1] * degrees;
                if (phii < phi0) phi0 = phii;
            } else {
                if (phi < phi0) phi0 = phi;
                if (phi > phi1) phi1 = phi;
            }
            if (antimeridian) {
                if (lambda < lambda2) {
                    if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
                } else if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
            } else if (lambda1 >= lambda0$1) {
                if (lambda < lambda0$1) lambda0$1 = lambda;
                if (lambda > lambda1) lambda1 = lambda;
            } else {
                if (lambda > lambda2) {
                    if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
                } else if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
            }
        } else ranges.push(range = [
            lambda0$1 = lambda,
            lambda1 = lambda
        ]);
        if (phi < phi0) phi0 = phi;
        if (phi > phi1) phi1 = phi;
        p0 = p, lambda2 = lambda;
    }
    function boundsLineStart() {
        boundsStream$2.point = linePoint;
    }
    function boundsLineEnd() {
        range[0] = lambda0$1, range[1] = lambda1;
        boundsStream$2.point = boundsPoint$1;
        p0 = null;
    }
    function boundsRingPoint(lambda, phi) {
        if (p0) {
            var delta = lambda - lambda2;
            deltaSum.add(abs$1(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
        } else lambda00$1 = lambda, phi00$1 = phi;
        areaStream$1.point(lambda, phi);
        linePoint(lambda, phi);
    }
    function boundsRingStart() {
        areaStream$1.lineStart();
    }
    function boundsRingEnd() {
        boundsRingPoint(lambda00$1, phi00$1);
        areaStream$1.lineEnd();
        if (abs$1(deltaSum) > epsilon$1) lambda0$1 = -(lambda1 = 180);
        range[0] = lambda0$1, range[1] = lambda1;
        p0 = null;
    }
    // Finds the left-right distance between two longitudes.
    // This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
    // the distance between ±180° to be 360°.
    function angle(lambda0, lambda1) {
        return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
    }
    function rangeCompare(a, b) {
        return a[0] - b[0];
    }
    function rangeContains(range, x) {
        return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
    }
    function bounds(feature) {
        var i, n, a, b, merged, deltaMax, delta;
        phi1 = lambda1 = -(lambda0$1 = phi0 = Infinity);
        ranges = [];
        geoStream(feature, boundsStream$2);
        // First, sort ranges by their minimum longitudes.
        if (n = ranges.length) {
            ranges.sort(rangeCompare);
            // Then, merge any ranges that overlap.
            for(i = 1, a = ranges[0], merged = [
                a
            ]; i < n; ++i){
                b = ranges[i];
                if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
                    if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
                    if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
                } else merged.push(a = b);
            }
            // Finally, find the largest gap between the merged ranges.
            // The final bounding box will be the inverse of this gap.
            for(deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i){
                b = merged[i];
                if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0$1 = b[0], lambda1 = a[1];
            }
        }
        ranges = range = null;
        return lambda0$1 === Infinity || phi0 === Infinity ? [
            [
                NaN,
                NaN
            ],
            [
                NaN,
                NaN
            ]
        ] : [
            [
                lambda0$1,
                phi0
            ],
            [
                lambda1,
                phi1
            ]
        ];
    }
    var W0, W1, X0$1, Y0$1, Z0$1, X1$1, Y1$1, Z1$1, X2$1, Y2$1, Z2$1, lambda00, phi00, x0$4, y0$4, z0; // previous point
    var centroidStream$1 = {
        sphere: noop$1,
        point: centroidPoint$1,
        lineStart: centroidLineStart$1,
        lineEnd: centroidLineEnd$1,
        polygonStart: function() {
            centroidStream$1.lineStart = centroidRingStart$1;
            centroidStream$1.lineEnd = centroidRingEnd$1;
        },
        polygonEnd: function() {
            centroidStream$1.lineStart = centroidLineStart$1;
            centroidStream$1.lineEnd = centroidLineEnd$1;
        }
    };
    // Arithmetic mean of Cartesian vectors.
    function centroidPoint$1(lambda, phi) {
        lambda *= radians, phi *= radians;
        var cosPhi = cos$1(phi);
        centroidPointCartesian(cosPhi * cos$1(lambda), cosPhi * sin$1(lambda), sin$1(phi));
    }
    function centroidPointCartesian(x, y, z) {
        ++W0;
        X0$1 += (x - X0$1) / W0;
        Y0$1 += (y - Y0$1) / W0;
        Z0$1 += (z - Z0$1) / W0;
    }
    function centroidLineStart$1() {
        centroidStream$1.point = centroidLinePointFirst;
    }
    function centroidLinePointFirst(lambda, phi) {
        lambda *= radians, phi *= radians;
        var cosPhi = cos$1(phi);
        x0$4 = cosPhi * cos$1(lambda);
        y0$4 = cosPhi * sin$1(lambda);
        z0 = sin$1(phi);
        centroidStream$1.point = centroidLinePoint;
        centroidPointCartesian(x0$4, y0$4, z0);
    }
    function centroidLinePoint(lambda, phi) {
        lambda *= radians, phi *= radians;
        var cosPhi = cos$1(phi), x = cosPhi * cos$1(lambda), y = cosPhi * sin$1(lambda), z = sin$1(phi), w = atan2$1(sqrt$2((w = y0$4 * z - z0 * y) * w + (w = z0 * x - x0$4 * z) * w + (w = x0$4 * y - y0$4 * x) * w), x0$4 * x + y0$4 * y + z0 * z);
        W1 += w;
        X1$1 += w * (x0$4 + (x0$4 = x));
        Y1$1 += w * (y0$4 + (y0$4 = y));
        Z1$1 += w * (z0 + (z0 = z));
        centroidPointCartesian(x0$4, y0$4, z0);
    }
    function centroidLineEnd$1() {
        centroidStream$1.point = centroidPoint$1;
    }
    // See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
    // J. Applied Mechanics 42, 239 (1975).
    function centroidRingStart$1() {
        centroidStream$1.point = centroidRingPointFirst;
    }
    function centroidRingEnd$1() {
        centroidRingPoint(lambda00, phi00);
        centroidStream$1.point = centroidPoint$1;
    }
    function centroidRingPointFirst(lambda, phi) {
        lambda00 = lambda, phi00 = phi;
        lambda *= radians, phi *= radians;
        centroidStream$1.point = centroidRingPoint;
        var cosPhi = cos$1(phi);
        x0$4 = cosPhi * cos$1(lambda);
        y0$4 = cosPhi * sin$1(lambda);
        z0 = sin$1(phi);
        centroidPointCartesian(x0$4, y0$4, z0);
    }
    function centroidRingPoint(lambda, phi) {
        lambda *= radians, phi *= radians;
        var cosPhi = cos$1(phi), x = cosPhi * cos$1(lambda), y = cosPhi * sin$1(lambda), z = sin$1(phi), cx = y0$4 * z - z0 * y, cy = z0 * x - x0$4 * z, cz = x0$4 * y - y0$4 * x, m = hypot(cx, cy, cz), w = asin$1(m), v = m && -w / m; // area weight multiplier
        X2$1.add(v * cx);
        Y2$1.add(v * cy);
        Z2$1.add(v * cz);
        W1 += w;
        X1$1 += w * (x0$4 + (x0$4 = x));
        Y1$1 += w * (y0$4 + (y0$4 = y));
        Z1$1 += w * (z0 + (z0 = z));
        centroidPointCartesian(x0$4, y0$4, z0);
    }
    function centroid$1(object) {
        W0 = W1 = X0$1 = Y0$1 = Z0$1 = X1$1 = Y1$1 = Z1$1 = 0;
        X2$1 = new Adder();
        Y2$1 = new Adder();
        Z2$1 = new Adder();
        geoStream(object, centroidStream$1);
        var x = +X2$1, y = +Y2$1, z = +Z2$1, m = hypot(x, y, z);
        // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
        if (m < epsilon2) {
            x = X1$1, y = Y1$1, z = Z1$1;
            // If the feature has zero length, fall back to arithmetic mean of point vectors.
            if (W1 < epsilon$1) x = X0$1, y = Y0$1, z = Z0$1;
            m = hypot(x, y, z);
            // If the feature still has an undefined ccentroid, then return.
            if (m < epsilon2) return [
                NaN,
                NaN
            ];
        }
        return [
            atan2$1(y, x) * degrees,
            asin$1(z / m) * degrees
        ];
    }
    function constant$3(x) {
        return function() {
            return x;
        };
    }
    function compose(a, b) {
        function compose(x, y) {
            return x = a(x, y), b(x[0], x[1]);
        }
        if (a.invert && b.invert) compose.invert = function(x, y) {
            return x = b.invert(x, y), x && a.invert(x[0], x[1]);
        };
        return compose;
    }
    function rotationIdentity(lambda, phi) {
        return [
            abs$1(lambda) > pi$1 ? lambda + Math.round(-lambda / tau$1) * tau$1 : lambda,
            phi
        ];
    }
    rotationIdentity.invert = rotationIdentity;
    function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
        return (deltaLambda %= tau$1) ? deltaPhi || deltaGamma ? compose(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma)) : rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma) : rotationIdentity;
    }
    function forwardRotationLambda(deltaLambda) {
        return function(lambda, phi) {
            return lambda += deltaLambda, [
                lambda > pi$1 ? lambda - tau$1 : lambda < -pi$1 ? lambda + tau$1 : lambda,
                phi
            ];
        };
    }
    function rotationLambda(deltaLambda) {
        var rotation = forwardRotationLambda(deltaLambda);
        rotation.invert = forwardRotationLambda(-deltaLambda);
        return rotation;
    }
    function rotationPhiGamma(deltaPhi, deltaGamma) {
        var cosDeltaPhi = cos$1(deltaPhi), sinDeltaPhi = sin$1(deltaPhi), cosDeltaGamma = cos$1(deltaGamma), sinDeltaGamma = sin$1(deltaGamma);
        function rotation(lambda, phi) {
            var cosPhi = cos$1(phi), x = cos$1(lambda) * cosPhi, y = sin$1(lambda) * cosPhi, z = sin$1(phi), k = z * cosDeltaPhi + x * sinDeltaPhi;
            return [
                atan2$1(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
                asin$1(k * cosDeltaGamma + y * sinDeltaGamma)
            ];
        }
        rotation.invert = function(lambda, phi) {
            var cosPhi = cos$1(phi), x = cos$1(lambda) * cosPhi, y = sin$1(lambda) * cosPhi, z = sin$1(phi), k = z * cosDeltaGamma - y * sinDeltaGamma;
            return [
                atan2$1(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
                asin$1(k * cosDeltaPhi - x * sinDeltaPhi)
            ];
        };
        return rotation;
    }
    function rotation(rotate) {
        rotate = rotateRadians(rotate[0] * radians, rotate[1] * radians, rotate.length > 2 ? rotate[2] * radians : 0);
        function forward(coordinates) {
            coordinates = rotate(coordinates[0] * radians, coordinates[1] * radians);
            return coordinates[0] *= degrees, coordinates[1] *= degrees, coordinates;
        }
        forward.invert = function(coordinates) {
            coordinates = rotate.invert(coordinates[0] * radians, coordinates[1] * radians);
            return coordinates[0] *= degrees, coordinates[1] *= degrees, coordinates;
        };
        return forward;
    }
    // Generates a circle centered at [0°, 0°], with a given radius and precision.
    function circleStream(stream, radius, delta, direction, t0, t1) {
        if (!delta) return;
        var cosRadius = cos$1(radius), sinRadius = sin$1(radius), step = direction * delta;
        if (t0 == null) {
            t0 = radius + direction * tau$1;
            t1 = radius - step / 2;
        } else {
            t0 = circleRadius(cosRadius, t0);
            t1 = circleRadius(cosRadius, t1);
            if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * tau$1;
        }
        for(var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step){
            point = spherical([
                cosRadius,
                -sinRadius * cos$1(t),
                -sinRadius * sin$1(t)
            ]);
            stream.point(point[0], point[1]);
        }
    }
    // Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
    function circleRadius(cosRadius, point) {
        point = cartesian(point), point[0] -= cosRadius;
        cartesianNormalizeInPlace(point);
        var radius = acos$1(-point[1]);
        return ((-point[2] < 0 ? -radius : radius) + tau$1 - epsilon$1) % tau$1;
    }
    function circle$2() {
        var center = constant$3([
            0,
            0
        ]), radius = constant$3(90), precision = constant$3(6), ring, rotate, stream = {
            point: point
        };
        function point(x, y) {
            ring.push(x = rotate(x, y));
            x[0] *= degrees, x[1] *= degrees;
        }
        function circle() {
            var c = center.apply(this, arguments), r = radius.apply(this, arguments) * radians, p = precision.apply(this, arguments) * radians;
            ring = [];
            rotate = rotateRadians(-c[0] * radians, -c[1] * radians, 0).invert;
            circleStream(stream, r, p, 1);
            c = {
                type: "Polygon",
                coordinates: [
                    ring
                ]
            };
            ring = rotate = null;
            return c;
        }
        circle.center = function(_) {
            return arguments.length ? (center = typeof _ === "function" ? _ : constant$3([
                +_[0],
                +_[1]
            ]), circle) : center;
        };
        circle.radius = function(_) {
            return arguments.length ? (radius = typeof _ === "function" ? _ : constant$3(+_), circle) : radius;
        };
        circle.precision = function(_) {
            return arguments.length ? (precision = typeof _ === "function" ? _ : constant$3(+_), circle) : precision;
        };
        return circle;
    }
    function clipBuffer() {
        var lines = [], line;
        return {
            point: function(x, y, m) {
                line.push([
                    x,
                    y,
                    m
                ]);
            },
            lineStart: function() {
                lines.push(line = []);
            },
            lineEnd: noop$1,
            rejoin: function() {
                if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
            },
            result: function() {
                var result = lines;
                lines = [];
                line = null;
                return result;
            }
        };
    }
    function pointEqual(a, b) {
        return abs$1(a[0] - b[0]) < epsilon$1 && abs$1(a[1] - b[1]) < epsilon$1;
    }
    function Intersection(point, points, other, entry) {
        this.x = point;
        this.z = points;
        this.o = other; // another intersection
        this.e = entry; // is an entry?
        this.v = false; // visited
        this.n = this.p = null; // next & previous
    }
    // A generalized polygon clipping algorithm: given a polygon that has been cut
    // into its visible line segments, and rejoins the segments by interpolating
    // along the clip edge.
    function clipRejoin(segments, compareIntersection, startInside, interpolate, stream) {
        var subject = [], clip = [], i, n;
        segments.forEach(function(segment) {
            if ((n = segment.length - 1) <= 0) return;
            var n, p0 = segment[0], p1 = segment[n], x;
            if (pointEqual(p0, p1)) {
                if (!p0[2] && !p1[2]) {
                    stream.lineStart();
                    for(i = 0; i < n; ++i)stream.point((p0 = segment[i])[0], p0[1]);
                    stream.lineEnd();
                    return;
                }
                // handle degenerate cases by moving the point
                p1[0] += 2 * epsilon$1;
            }
            subject.push(x = new Intersection(p0, segment, null, true));
            clip.push(x.o = new Intersection(p0, null, x, false));
            subject.push(x = new Intersection(p1, segment, null, false));
            clip.push(x.o = new Intersection(p1, null, x, true));
        });
        if (!subject.length) return;
        clip.sort(compareIntersection);
        link$1(subject);
        link$1(clip);
        for(i = 0, n = clip.length; i < n; ++i)clip[i].e = startInside = !startInside;
        var start = subject[0], points, point;
        while(true){
            // Find first unvisited intersection.
            var current = start, isSubject = true;
            while(current.v)if ((current = current.n) === start) return;
            points = current.z;
            stream.lineStart();
            do {
                current.v = current.o.v = true;
                if (current.e) {
                    if (isSubject) for(i = 0, n = points.length; i < n; ++i)stream.point((point = points[i])[0], point[1]);
                    else interpolate(current.x, current.n.x, 1, stream);
                    current = current.n;
                } else {
                    if (isSubject) {
                        points = current.p.z;
                        for(i = points.length - 1; i >= 0; --i)stream.point((point = points[i])[0], point[1]);
                    } else interpolate(current.x, current.p.x, -1, stream);
                    current = current.p;
                }
                current = current.o;
                points = current.z;
                isSubject = !isSubject;
            }while (!current.v);
            stream.lineEnd();
        }
    }
    function link$1(array) {
        if (!(n = array.length)) return;
        var n, i = 0, a = array[0], b;
        while(++i < n){
            a.n = b = array[i];
            b.p = a;
            a = b;
        }
        a.n = b = array[0];
        b.p = a;
    }
    function longitude(point) {
        return abs$1(point[0]) <= pi$1 ? point[0] : sign$1(point[0]) * ((abs$1(point[0]) + pi$1) % tau$1 - pi$1);
    }
    function polygonContains(polygon, point) {
        var lambda = longitude(point), phi = point[1], sinPhi = sin$1(phi), normal = [
            sin$1(lambda),
            -cos$1(lambda),
            0
        ], angle = 0, winding = 0;
        var sum = new Adder();
        if (sinPhi === 1) phi = halfPi$1 + epsilon$1;
        else if (sinPhi === -1) phi = -halfPi$1 - epsilon$1;
        for(var i = 0, n = polygon.length; i < n; ++i){
            if (!(m = (ring = polygon[i]).length)) continue;
            var ring, m, point0 = ring[m - 1], lambda0 = longitude(point0), phi0 = point0[1] / 2 + quarterPi, sinPhi0 = sin$1(phi0), cosPhi0 = cos$1(phi0);
            for(var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1){
                var point1 = ring[j], lambda1 = longitude(point1), phi1 = point1[1] / 2 + quarterPi, sinPhi1 = sin$1(phi1), cosPhi1 = cos$1(phi1), delta = lambda1 - lambda0, sign = delta >= 0 ? 1 : -1, absDelta = sign * delta, antimeridian = absDelta > pi$1, k = sinPhi0 * sinPhi1;
                sum.add(atan2$1(k * sign * sin$1(absDelta), cosPhi0 * cosPhi1 + k * cos$1(absDelta)));
                angle += antimeridian ? delta + sign * tau$1 : delta;
                // Are the longitudes either side of the point’s meridian (lambda),
                // and are the latitudes smaller than the parallel (phi)?
                if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
                    var arc = cartesianCross(cartesian(point0), cartesian(point1));
                    cartesianNormalizeInPlace(arc);
                    var intersection = cartesianCross(normal, arc);
                    cartesianNormalizeInPlace(intersection);
                    var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * asin$1(intersection[2]);
                    if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) winding += antimeridian ^ delta >= 0 ? 1 : -1;
                }
            }
        }
        // First, determine whether the South pole is inside or outside:
        //
        // It is inside if:
        // * the polygon winds around it in a clockwise direction.
        // * the polygon does not (cumulatively) wind around it, but has a negative
        //   (counter-clockwise) area.
        //
        // Second, count the (signed) number of times a segment crosses a lambda
        // from the point to the South pole.  If it is zero, then the point is the
        // same side as the South pole.
        return (angle < -epsilon$1 || angle < epsilon$1 && sum < -epsilon2) ^ winding & 1;
    }
    function clip(pointVisible, clipLine, interpolate, start) {
        return function(sink) {
            var line = clipLine(sink), ringBuffer = clipBuffer(), ringSink = clipLine(ringBuffer), polygonStarted = false, polygon, segments, ring;
            var clip = {
                point: point,
                lineStart: lineStart,
                lineEnd: lineEnd,
                polygonStart: function() {
                    clip.point = pointRing;
                    clip.lineStart = ringStart;
                    clip.lineEnd = ringEnd;
                    segments = [];
                    polygon = [];
                },
                polygonEnd: function() {
                    clip.point = point;
                    clip.lineStart = lineStart;
                    clip.lineEnd = lineEnd;
                    segments = merge(segments);
                    var startInside = polygonContains(polygon, start);
                    if (segments.length) {
                        if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                        clipRejoin(segments, compareIntersection, startInside, interpolate, sink);
                    } else if (startInside) {
                        if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                        sink.lineStart();
                        interpolate(null, null, 1, sink);
                        sink.lineEnd();
                    }
                    if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
                    segments = polygon = null;
                },
                sphere: function() {
                    sink.polygonStart();
                    sink.lineStart();
                    interpolate(null, null, 1, sink);
                    sink.lineEnd();
                    sink.polygonEnd();
                }
            };
            function point(lambda, phi) {
                if (pointVisible(lambda, phi)) sink.point(lambda, phi);
            }
            function pointLine(lambda, phi) {
                line.point(lambda, phi);
            }
            function lineStart() {
                clip.point = pointLine;
                line.lineStart();
            }
            function lineEnd() {
                clip.point = point;
                line.lineEnd();
            }
            function pointRing(lambda, phi) {
                ring.push([
                    lambda,
                    phi
                ]);
                ringSink.point(lambda, phi);
            }
            function ringStart() {
                ringSink.lineStart();
                ring = [];
            }
            function ringEnd() {
                pointRing(ring[0][0], ring[0][1]);
                ringSink.lineEnd();
                var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m, segment, point;
                ring.pop();
                polygon.push(ring);
                ring = null;
                if (!n) return;
                // No intersections.
                if (clean & 1) {
                    segment = ringSegments[0];
                    if ((m = segment.length - 1) > 0) {
                        if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                        sink.lineStart();
                        for(i = 0; i < m; ++i)sink.point((point = segment[i])[0], point[1]);
                        sink.lineEnd();
                    }
                    return;
                }
                // Rejoin connected segments.
                // TODO reuse ringBuffer.rejoin()?
                if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
                segments.push(ringSegments.filter(validSegment));
            }
            return clip;
        };
    }
    function validSegment(segment) {
        return segment.length > 1;
    }
    // Intersections are sorted along the clip edge. For both antimeridian cutting
    // and circle clipping, the same comparison is used.
    function compareIntersection(a, b) {
        return ((a = a.x)[0] < 0 ? a[1] - halfPi$1 - epsilon$1 : halfPi$1 - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfPi$1 - epsilon$1 : halfPi$1 - b[1]);
    }
    var clipAntimeridian = clip(function() {
        return true;
    }, clipAntimeridianLine, clipAntimeridianInterpolate, [
        -pi$1,
        -halfPi$1
    ]);
    // Takes a line and cuts into visible segments. Return values: 0 - there were
    // intersections or the line was empty; 1 - no intersections; 2 - there were
    // intersections, and the first and last segments should be rejoined.
    function clipAntimeridianLine(stream) {
        var lambda0 = NaN, phi0 = NaN, sign0 = NaN, clean; // no intersections
        return {
            lineStart: function() {
                stream.lineStart();
                clean = 1;
            },
            point: function(lambda1, phi1) {
                var sign1 = lambda1 > 0 ? pi$1 : -pi$1, delta = abs$1(lambda1 - lambda0);
                if (abs$1(delta - pi$1) < epsilon$1) {
                    stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? halfPi$1 : -halfPi$1);
                    stream.point(sign0, phi0);
                    stream.lineEnd();
                    stream.lineStart();
                    stream.point(sign1, phi0);
                    stream.point(lambda1, phi0);
                    clean = 0;
                } else if (sign0 !== sign1 && delta >= pi$1) {
                    if (abs$1(lambda0 - sign0) < epsilon$1) lambda0 -= sign0 * epsilon$1; // handle degeneracies
                    if (abs$1(lambda1 - sign1) < epsilon$1) lambda1 -= sign1 * epsilon$1;
                    phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
                    stream.point(sign0, phi0);
                    stream.lineEnd();
                    stream.lineStart();
                    stream.point(sign1, phi0);
                    clean = 0;
                }
                stream.point(lambda0 = lambda1, phi0 = phi1);
                sign0 = sign1;
            },
            lineEnd: function() {
                stream.lineEnd();
                lambda0 = phi0 = NaN;
            },
            clean: function() {
                return 2 - clean; // if intersections, rejoin first and last segments
            }
        };
    }
    function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
        var cosPhi0, cosPhi1, sinLambda0Lambda1 = sin$1(lambda0 - lambda1);
        return abs$1(sinLambda0Lambda1) > epsilon$1 ? atan((sin$1(phi0) * (cosPhi1 = cos$1(phi1)) * sin$1(lambda1) - sin$1(phi1) * (cosPhi0 = cos$1(phi0)) * sin$1(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
    }
    function clipAntimeridianInterpolate(from, to, direction, stream) {
        var phi;
        if (from == null) {
            phi = direction * halfPi$1;
            stream.point(-pi$1, phi);
            stream.point(0, phi);
            stream.point(pi$1, phi);
            stream.point(pi$1, 0);
            stream.point(pi$1, -phi);
            stream.point(0, -phi);
            stream.point(-pi$1, -phi);
            stream.point(-pi$1, 0);
            stream.point(-pi$1, phi);
        } else if (abs$1(from[0] - to[0]) > epsilon$1) {
            var lambda = from[0] < to[0] ? pi$1 : -pi$1;
            phi = direction * lambda / 2;
            stream.point(-lambda, phi);
            stream.point(0, phi);
            stream.point(lambda, phi);
        } else stream.point(to[0], to[1]);
    }
    function clipCircle(radius) {
        var cr = cos$1(radius), delta = 6 * radians, smallRadius = cr > 0, notHemisphere = abs$1(cr) > epsilon$1; // TODO optimise for this common case
        function interpolate(from, to, direction, stream) {
            circleStream(stream, radius, delta, direction, from, to);
        }
        function visible(lambda, phi) {
            return cos$1(lambda) * cos$1(phi) > cr;
        }
        // Takes a line and cuts into visible segments. Return values used for polygon
        // clipping: 0 - there were intersections or the line was empty; 1 - no
        // intersections 2 - there were intersections, and the first and last segments
        // should be rejoined.
        function clipLine(stream) {
            var point0, c0, v0, v00, clean; // no intersections
            return {
                lineStart: function() {
                    v00 = v0 = false;
                    clean = 1;
                },
                point: function(lambda, phi) {
                    var point1 = [
                        lambda,
                        phi
                    ], point2, v = visible(lambda, phi), c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? pi$1 : -pi$1), phi) : 0;
                    if (!point0 && (v00 = v0 = v)) stream.lineStart();
                    if (v !== v0) {
                        point2 = intersect(point0, point1);
                        if (!point2 || pointEqual(point0, point2) || pointEqual(point1, point2)) point1[2] = 1;
                    }
                    if (v !== v0) {
                        clean = 0;
                        if (v) {
                            // outside going in
                            stream.lineStart();
                            point2 = intersect(point1, point0);
                            stream.point(point2[0], point2[1]);
                        } else {
                            // inside going out
                            point2 = intersect(point0, point1);
                            stream.point(point2[0], point2[1], 2);
                            stream.lineEnd();
                        }
                        point0 = point2;
                    } else if (notHemisphere && point0 && smallRadius ^ v) {
                        var t;
                        // If the codes for two points are different, or are both zero,
                        // and there this segment intersects with the small circle.
                        if (!(c & c0) && (t = intersect(point1, point0, true))) {
                            clean = 0;
                            if (smallRadius) {
                                stream.lineStart();
                                stream.point(t[0][0], t[0][1]);
                                stream.point(t[1][0], t[1][1]);
                                stream.lineEnd();
                            } else {
                                stream.point(t[1][0], t[1][1]);
                                stream.lineEnd();
                                stream.lineStart();
                                stream.point(t[0][0], t[0][1], 3);
                            }
                        }
                    }
                    if (v && (!point0 || !pointEqual(point0, point1))) stream.point(point1[0], point1[1]);
                    point0 = point1, v0 = v, c0 = c;
                },
                lineEnd: function() {
                    if (v0) stream.lineEnd();
                    point0 = null;
                },
                // Rejoin first and last segments if there were intersections and the first
                // and last points were visible.
                clean: function() {
                    return clean | (v00 && v0) << 1;
                }
            };
        }
        // Intersects the great circle between a and b with the clip circle.
        function intersect(a, b, two) {
            var pa = cartesian(a), pb = cartesian(b);
            // We have two planes, n1.p = d1 and n2.p = d2.
            // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
            var n1 = [
                1,
                0,
                0
            ], n2 = cartesianCross(pa, pb), n2n2 = cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
            // Two polar points.
            if (!determinant) return !two && a;
            var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = cartesianCross(n1, n2), A = cartesianScale(n1, c1), B = cartesianScale(n2, c2);
            cartesianAddInPlace(A, B);
            // Solve |p(t)|^2 = 1.
            var u = n1xn2, w = cartesianDot(A, u), uu = cartesianDot(u, u), t2 = w * w - uu * (cartesianDot(A, A) - 1);
            if (t2 < 0) return;
            var t = sqrt$2(t2), q = cartesianScale(u, (-w - t) / uu);
            cartesianAddInPlace(q, A);
            q = spherical(q);
            if (!two) return q;
            // Two intersection points.
            var lambda0 = a[0], lambda1 = b[0], phi0 = a[1], phi1 = b[1], z;
            if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
            var delta = lambda1 - lambda0, polar = abs$1(delta - pi$1) < epsilon$1, meridian = polar || delta < epsilon$1;
            if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
            // Check that the first point is between a and b.
            if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < (abs$1(q[0] - lambda0) < epsilon$1 ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > pi$1 ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
                var q1 = cartesianScale(u, (-w + t) / uu);
                cartesianAddInPlace(q1, A);
                return [
                    q,
                    spherical(q1)
                ];
            }
        }
        // Generates a 4-bit vector representing the location of a point relative to
        // the small circle's bounding box.
        function code(lambda, phi) {
            var r = smallRadius ? radius : pi$1 - radius, code = 0;
            if (lambda < -r) code |= 1; // left
            else if (lambda > r) code |= 2; // right
            if (phi < -r) code |= 4; // below
            else if (phi > r) code |= 8; // above
            return code;
        }
        return clip(visible, clipLine, interpolate, smallRadius ? [
            0,
            -radius
        ] : [
            -pi$1,
            radius - pi$1
        ]);
    }
    function clipLine(a, b, x0, y0, x1, y1) {
        var ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
        r = x0 - ax;
        if (!dx && r > 0) return;
        r /= dx;
        if (dx < 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        } else if (dx > 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        }
        r = x1 - ax;
        if (!dx && r < 0) return;
        r /= dx;
        if (dx < 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        } else if (dx > 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        }
        r = y0 - ay;
        if (!dy && r > 0) return;
        r /= dy;
        if (dy < 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        } else if (dy > 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        }
        r = y1 - ay;
        if (!dy && r < 0) return;
        r /= dy;
        if (dy < 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        } else if (dy > 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        }
        if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
        if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
        return true;
    }
    var clipMax = 1e9, clipMin = -clipMax;
    // TODO Use d3-polygon’s polygonContains here for the ring check?
    // TODO Eliminate duplicate buffering in clipBuffer and polygon.push?
    function clipRectangle(x0, y0, x1, y1) {
        function visible(x, y) {
            return x0 <= x && x <= x1 && y0 <= y && y <= y1;
        }
        function interpolate(from, to, direction, stream) {
            var a = 0, a1 = 0;
            if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
            while ((a = (a + direction + 4) % 4) !== a1);
            else stream.point(to[0], to[1]);
        }
        function corner(p, direction) {
            return abs$1(p[0] - x0) < epsilon$1 ? direction > 0 ? 0 : 3 : abs$1(p[0] - x1) < epsilon$1 ? direction > 0 ? 2 : 1 : abs$1(p[1] - y0) < epsilon$1 ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
        }
        function compareIntersection(a, b) {
            return comparePoint(a.x, b.x);
        }
        function comparePoint(a, b) {
            var ca = corner(a, 1), cb = corner(b, 1);
            return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
        }
        return function(stream) {
            var activeStream = stream, bufferStream = clipBuffer(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first, clean;
            var clipStream = {
                point: point,
                lineStart: lineStart,
                lineEnd: lineEnd,
                polygonStart: polygonStart,
                polygonEnd: polygonEnd
            };
            function point(x, y) {
                if (visible(x, y)) activeStream.point(x, y);
            }
            function polygonInside() {
                var winding = 0;
                for(var i = 0, n = polygon.length; i < n; ++i)for(var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j){
                    a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
                    if (a1 <= y1) {
                        if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
                    } else if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
                }
                return winding;
            }
            // Buffer geometry within a polygon and then clip it en masse.
            function polygonStart() {
                activeStream = bufferStream, segments = [], polygon = [], clean = true;
            }
            function polygonEnd() {
                var startInside = polygonInside(), cleanInside = clean && startInside, visible = (segments = merge(segments)).length;
                if (cleanInside || visible) {
                    stream.polygonStart();
                    if (cleanInside) {
                        stream.lineStart();
                        interpolate(null, null, 1, stream);
                        stream.lineEnd();
                    }
                    if (visible) clipRejoin(segments, compareIntersection, startInside, interpolate, stream);
                    stream.polygonEnd();
                }
                activeStream = stream, segments = polygon = ring = null;
            }
            function lineStart() {
                clipStream.point = linePoint;
                if (polygon) polygon.push(ring = []);
                first = true;
                v_ = false;
                x_ = y_ = NaN;
            }
            // TODO rather than special-case polygons, simply handle them separately.
            // Ideally, coincident intersection points should be jittered to avoid
            // clipping issues.
            function lineEnd() {
                if (segments) {
                    linePoint(x__, y__);
                    if (v__ && v_) bufferStream.rejoin();
                    segments.push(bufferStream.result());
                }
                clipStream.point = point;
                if (v_) activeStream.lineEnd();
            }
            function linePoint(x, y) {
                var v = visible(x, y);
                if (polygon) ring.push([
                    x,
                    y
                ]);
                if (first) {
                    x__ = x, y__ = y, v__ = v;
                    first = false;
                    if (v) {
                        activeStream.lineStart();
                        activeStream.point(x, y);
                    }
                } else if (v && v_) activeStream.point(x, y);
                else {
                    var a = [
                        x_ = Math.max(clipMin, Math.min(clipMax, x_)),
                        y_ = Math.max(clipMin, Math.min(clipMax, y_))
                    ], b = [
                        x = Math.max(clipMin, Math.min(clipMax, x)),
                        y = Math.max(clipMin, Math.min(clipMax, y))
                    ];
                    if (clipLine(a, b, x0, y0, x1, y1)) {
                        if (!v_) {
                            activeStream.lineStart();
                            activeStream.point(a[0], a[1]);
                        }
                        activeStream.point(b[0], b[1]);
                        if (!v) activeStream.lineEnd();
                        clean = false;
                    } else if (v) {
                        activeStream.lineStart();
                        activeStream.point(x, y);
                        clean = false;
                    }
                }
                x_ = x, y_ = y, v_ = v;
            }
            return clipStream;
        };
    }
    function extent() {
        var x0 = 0, y0 = 0, x1 = 960, y1 = 500, cache, cacheStream, clip;
        return clip = {
            stream: function(stream) {
                return cache && cacheStream === stream ? cache : cache = clipRectangle(x0, y0, x1, y1)(cacheStream = stream);
            },
            extent: function(_) {
                return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [
                    [
                        x0,
                        y0
                    ],
                    [
                        x1,
                        y1
                    ]
                ];
            }
        };
    }
    var lengthSum$1, lambda0, sinPhi0, cosPhi0;
    var lengthStream$1 = {
        sphere: noop$1,
        point: noop$1,
        lineStart: lengthLineStart,
        lineEnd: noop$1,
        polygonStart: noop$1,
        polygonEnd: noop$1
    };
    function lengthLineStart() {
        lengthStream$1.point = lengthPointFirst$1;
        lengthStream$1.lineEnd = lengthLineEnd;
    }
    function lengthLineEnd() {
        lengthStream$1.point = lengthStream$1.lineEnd = noop$1;
    }
    function lengthPointFirst$1(lambda, phi) {
        lambda *= radians, phi *= radians;
        lambda0 = lambda, sinPhi0 = sin$1(phi), cosPhi0 = cos$1(phi);
        lengthStream$1.point = lengthPoint$1;
    }
    function lengthPoint$1(lambda, phi) {
        lambda *= radians, phi *= radians;
        var sinPhi = sin$1(phi), cosPhi = cos$1(phi), delta = abs$1(lambda - lambda0), cosDelta = cos$1(delta), sinDelta = sin$1(delta), x = cosPhi * sinDelta, y = cosPhi0 * sinPhi - sinPhi0 * cosPhi * cosDelta, z = sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosDelta;
        lengthSum$1.add(atan2$1(sqrt$2(x * x + y * y), z));
        lambda0 = lambda, sinPhi0 = sinPhi, cosPhi0 = cosPhi;
    }
    function length$1(object) {
        lengthSum$1 = new Adder();
        geoStream(object, lengthStream$1);
        return +lengthSum$1;
    }
    var coordinates = [
        null,
        null
    ], object = {
        type: "LineString",
        coordinates: coordinates
    };
    function distance(a, b) {
        coordinates[0] = a;
        coordinates[1] = b;
        return length$1(object);
    }
    var containsObjectType = {
        Feature: function(object, point) {
            return containsGeometry(object.geometry, point);
        },
        FeatureCollection: function(object, point) {
            var features = object.features, i = -1, n = features.length;
            while(++i < n)if (containsGeometry(features[i].geometry, point)) return true;
            return false;
        }
    };
    var containsGeometryType = {
        Sphere: function() {
            return true;
        },
        Point: function(object, point) {
            return containsPoint(object.coordinates, point);
        },
        MultiPoint: function(object, point) {
            var coordinates = object.coordinates, i = -1, n = coordinates.length;
            while(++i < n)if (containsPoint(coordinates[i], point)) return true;
            return false;
        },
        LineString: function(object, point) {
            return containsLine(object.coordinates, point);
        },
        MultiLineString: function(object, point) {
            var coordinates = object.coordinates, i = -1, n = coordinates.length;
            while(++i < n)if (containsLine(coordinates[i], point)) return true;
            return false;
        },
        Polygon: function(object, point) {
            return containsPolygon(object.coordinates, point);
        },
        MultiPolygon: function(object, point) {
            var coordinates = object.coordinates, i = -1, n = coordinates.length;
            while(++i < n)if (containsPolygon(coordinates[i], point)) return true;
            return false;
        },
        GeometryCollection: function(object, point) {
            var geometries = object.geometries, i = -1, n = geometries.length;
            while(++i < n)if (containsGeometry(geometries[i], point)) return true;
            return false;
        }
    };
    function containsGeometry(geometry, point) {
        return geometry && containsGeometryType.hasOwnProperty(geometry.type) ? containsGeometryType[geometry.type](geometry, point) : false;
    }
    function containsPoint(coordinates, point) {
        return distance(coordinates, point) === 0;
    }
    function containsLine(coordinates, point) {
        var ao, bo, ab;
        for(var i = 0, n = coordinates.length; i < n; i++){
            bo = distance(coordinates[i], point);
            if (bo === 0) return true;
            if (i > 0) {
                ab = distance(coordinates[i], coordinates[i - 1]);
                if (ab > 0 && ao <= ab && bo <= ab && (ao + bo - ab) * (1 - Math.pow((ao - bo) / ab, 2)) < epsilon2 * ab) return true;
            }
            ao = bo;
        }
        return false;
    }
    function containsPolygon(coordinates, point) {
        return !!polygonContains(coordinates.map(ringRadians), pointRadians(point));
    }
    function ringRadians(ring) {
        return ring = ring.map(pointRadians), ring.pop(), ring;
    }
    function pointRadians(point) {
        return [
            point[0] * radians,
            point[1] * radians
        ];
    }
    function contains$1(object, point) {
        return (object && containsObjectType.hasOwnProperty(object.type) ? containsObjectType[object.type] : containsGeometry)(object, point);
    }
    function graticuleX(y0, y1, dy) {
        var y = range$2(y0, y1 - epsilon$1, dy).concat(y1);
        return function(x) {
            return y.map(function(y) {
                return [
                    x,
                    y
                ];
            });
        };
    }
    function graticuleY(x0, x1, dx) {
        var x = range$2(x0, x1 - epsilon$1, dx).concat(x1);
        return function(y) {
            return x.map(function(x) {
                return [
                    x,
                    y
                ];
            });
        };
    }
    function graticule() {
        var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
        function graticule() {
            return {
                type: "MultiLineString",
                coordinates: lines()
            };
        }
        function lines() {
            return range$2(ceil(X0 / DX) * DX, X1, DX).map(X).concat(range$2(ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(range$2(ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
                return abs$1(x % DX) > epsilon$1;
            }).map(x)).concat(range$2(ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
                return abs$1(y % DY) > epsilon$1;
            }).map(y));
        }
        graticule.lines = function() {
            return lines().map(function(coordinates) {
                return {
                    type: "LineString",
                    coordinates: coordinates
                };
            });
        };
        graticule.outline = function() {
            return {
                type: "Polygon",
                coordinates: [
                    X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))
                ]
            };
        };
        graticule.extent = function(_) {
            if (!arguments.length) return graticule.extentMinor();
            return graticule.extentMajor(_).extentMinor(_);
        };
        graticule.extentMajor = function(_) {
            if (!arguments.length) return [
                [
                    X0,
                    Y0
                ],
                [
                    X1,
                    Y1
                ]
            ];
            X0 = +_[0][0], X1 = +_[1][0];
            Y0 = +_[0][1], Y1 = +_[1][1];
            if (X0 > X1) _ = X0, X0 = X1, X1 = _;
            if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
            return graticule.precision(precision);
        };
        graticule.extentMinor = function(_) {
            if (!arguments.length) return [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
            x0 = +_[0][0], x1 = +_[1][0];
            y0 = +_[0][1], y1 = +_[1][1];
            if (x0 > x1) _ = x0, x0 = x1, x1 = _;
            if (y0 > y1) _ = y0, y0 = y1, y1 = _;
            return graticule.precision(precision);
        };
        graticule.step = function(_) {
            if (!arguments.length) return graticule.stepMinor();
            return graticule.stepMajor(_).stepMinor(_);
        };
        graticule.stepMajor = function(_) {
            if (!arguments.length) return [
                DX,
                DY
            ];
            DX = +_[0], DY = +_[1];
            return graticule;
        };
        graticule.stepMinor = function(_) {
            if (!arguments.length) return [
                dx,
                dy
            ];
            dx = +_[0], dy = +_[1];
            return graticule;
        };
        graticule.precision = function(_) {
            if (!arguments.length) return precision;
            precision = +_;
            x = graticuleX(y0, y1, 90);
            y = graticuleY(x0, x1, precision);
            X = graticuleX(Y0, Y1, 90);
            Y = graticuleY(X0, X1, precision);
            return graticule;
        };
        return graticule.extentMajor([
            [
                -180,
                -90 + epsilon$1
            ],
            [
                180,
                90 - epsilon$1
            ]
        ]).extentMinor([
            [
                -180,
                -80 - epsilon$1
            ],
            [
                180,
                80 + epsilon$1
            ]
        ]);
    }
    function graticule10() {
        return graticule()();
    }
    function interpolate(a, b) {
        var x0 = a[0] * radians, y0 = a[1] * radians, x1 = b[0] * radians, y1 = b[1] * radians, cy0 = cos$1(y0), sy0 = sin$1(y0), cy1 = cos$1(y1), sy1 = sin$1(y1), kx0 = cy0 * cos$1(x0), ky0 = cy0 * sin$1(x0), kx1 = cy1 * cos$1(x1), ky1 = cy1 * sin$1(x1), d = 2 * asin$1(sqrt$2(haversin(y1 - y0) + cy0 * cy1 * haversin(x1 - x0))), k = sin$1(d);
        var interpolate = d ? function(t) {
            var B = sin$1(t *= d) / k, A = sin$1(d - t) / k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
            return [
                atan2$1(y, x) * degrees,
                atan2$1(z, sqrt$2(x * x + y * y)) * degrees
            ];
        } : function() {
            return [
                x0 * degrees,
                y0 * degrees
            ];
        };
        interpolate.distance = d;
        return interpolate;
    }
    var identity$5 = (x)=>x;
    var areaSum = new Adder(), areaRingSum = new Adder(), x00$2, y00$2, x0$3, y0$3;
    var areaStream = {
        point: noop$1,
        lineStart: noop$1,
        lineEnd: noop$1,
        polygonStart: function() {
            areaStream.lineStart = areaRingStart;
            areaStream.lineEnd = areaRingEnd;
        },
        polygonEnd: function() {
            areaStream.lineStart = areaStream.lineEnd = areaStream.point = noop$1;
            areaSum.add(abs$1(areaRingSum));
            areaRingSum = new Adder();
        },
        result: function() {
            var area = areaSum / 2;
            areaSum = new Adder();
            return area;
        }
    };
    function areaRingStart() {
        areaStream.point = areaPointFirst;
    }
    function areaPointFirst(x, y) {
        areaStream.point = areaPoint;
        x00$2 = x0$3 = x, y00$2 = y0$3 = y;
    }
    function areaPoint(x, y) {
        areaRingSum.add(y0$3 * x - x0$3 * y);
        x0$3 = x, y0$3 = y;
    }
    function areaRingEnd() {
        areaPoint(x00$2, y00$2);
    }
    var pathArea = areaStream;
    var x0$2 = Infinity, y0$2 = x0$2, x1 = -x0$2, y1 = x1;
    var boundsStream = {
        point: boundsPoint,
        lineStart: noop$1,
        lineEnd: noop$1,
        polygonStart: noop$1,
        polygonEnd: noop$1,
        result: function() {
            var bounds = [
                [
                    x0$2,
                    y0$2
                ],
                [
                    x1,
                    y1
                ]
            ];
            x1 = y1 = -(y0$2 = x0$2 = Infinity);
            return bounds;
        }
    };
    function boundsPoint(x, y) {
        if (x < x0$2) x0$2 = x;
        if (x > x1) x1 = x;
        if (y < y0$2) y0$2 = y;
        if (y > y1) y1 = y;
    }
    var boundsStream$1 = boundsStream;
    // TODO Enforce positive area for exterior, negative area for interior?
    var X0 = 0, Y0 = 0, Z0 = 0, X1 = 0, Y1 = 0, Z1 = 0, X2 = 0, Y2 = 0, Z2 = 0, x00$1, y00$1, x0$1, y0$1;
    var centroidStream = {
        point: centroidPoint,
        lineStart: centroidLineStart,
        lineEnd: centroidLineEnd,
        polygonStart: function() {
            centroidStream.lineStart = centroidRingStart;
            centroidStream.lineEnd = centroidRingEnd;
        },
        polygonEnd: function() {
            centroidStream.point = centroidPoint;
            centroidStream.lineStart = centroidLineStart;
            centroidStream.lineEnd = centroidLineEnd;
        },
        result: function() {
            var centroid = Z2 ? [
                X2 / Z2,
                Y2 / Z2
            ] : Z1 ? [
                X1 / Z1,
                Y1 / Z1
            ] : Z0 ? [
                X0 / Z0,
                Y0 / Z0
            ] : [
                NaN,
                NaN
            ];
            X0 = Y0 = Z0 = X1 = Y1 = Z1 = X2 = Y2 = Z2 = 0;
            return centroid;
        }
    };
    function centroidPoint(x, y) {
        X0 += x;
        Y0 += y;
        ++Z0;
    }
    function centroidLineStart() {
        centroidStream.point = centroidPointFirstLine;
    }
    function centroidPointFirstLine(x, y) {
        centroidStream.point = centroidPointLine;
        centroidPoint(x0$1 = x, y0$1 = y);
    }
    function centroidPointLine(x, y) {
        var dx = x - x0$1, dy = y - y0$1, z = sqrt$2(dx * dx + dy * dy);
        X1 += z * (x0$1 + x) / 2;
        Y1 += z * (y0$1 + y) / 2;
        Z1 += z;
        centroidPoint(x0$1 = x, y0$1 = y);
    }
    function centroidLineEnd() {
        centroidStream.point = centroidPoint;
    }
    function centroidRingStart() {
        centroidStream.point = centroidPointFirstRing;
    }
    function centroidRingEnd() {
        centroidPointRing(x00$1, y00$1);
    }
    function centroidPointFirstRing(x, y) {
        centroidStream.point = centroidPointRing;
        centroidPoint(x00$1 = x0$1 = x, y00$1 = y0$1 = y);
    }
    function centroidPointRing(x, y) {
        var dx = x - x0$1, dy = y - y0$1, z = sqrt$2(dx * dx + dy * dy);
        X1 += z * (x0$1 + x) / 2;
        Y1 += z * (y0$1 + y) / 2;
        Z1 += z;
        z = y0$1 * x - x0$1 * y;
        X2 += z * (x0$1 + x);
        Y2 += z * (y0$1 + y);
        Z2 += z * 3;
        centroidPoint(x0$1 = x, y0$1 = y);
    }
    var pathCentroid = centroidStream;
    function PathContext(context) {
        this._context = context;
    }
    PathContext.prototype = {
        _radius: 4.5,
        pointRadius: function(_) {
            return this._radius = _, this;
        },
        polygonStart: function() {
            this._line = 0;
        },
        polygonEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._point = 0;
        },
        lineEnd: function() {
            if (this._line === 0) this._context.closePath();
            this._point = NaN;
        },
        point: function(x, y) {
            switch(this._point){
                case 0:
                    this._context.moveTo(x, y);
                    this._point = 1;
                    break;
                case 1:
                    this._context.lineTo(x, y);
                    break;
                default:
                    this._context.moveTo(x + this._radius, y);
                    this._context.arc(x, y, this._radius, 0, tau$1);
                    break;
            }
        },
        result: noop$1
    };
    var lengthSum = new Adder(), lengthRing, x00, y00, x0, y0;
    var lengthStream = {
        point: noop$1,
        lineStart: function() {
            lengthStream.point = lengthPointFirst;
        },
        lineEnd: function() {
            if (lengthRing) lengthPoint(x00, y00);
            lengthStream.point = noop$1;
        },
        polygonStart: function() {
            lengthRing = true;
        },
        polygonEnd: function() {
            lengthRing = null;
        },
        result: function() {
            var length = +lengthSum;
            lengthSum = new Adder();
            return length;
        }
    };
    function lengthPointFirst(x, y) {
        lengthStream.point = lengthPoint;
        x00 = x0 = x, y00 = y0 = y;
    }
    function lengthPoint(x, y) {
        x0 -= x, y0 -= y;
        lengthSum.add(sqrt$2(x0 * x0 + y0 * y0));
        x0 = x, y0 = y;
    }
    var pathMeasure = lengthStream;
    function PathString() {
        this._string = [];
    }
    PathString.prototype = {
        _radius: 4.5,
        _circle: circle$1(4.5),
        pointRadius: function(_) {
            if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
            return this;
        },
        polygonStart: function() {
            this._line = 0;
        },
        polygonEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._point = 0;
        },
        lineEnd: function() {
            if (this._line === 0) this._string.push("Z");
            this._point = NaN;
        },
        point: function(x, y) {
            switch(this._point){
                case 0:
                    this._string.push("M", x, ",", y);
                    this._point = 1;
                    break;
                case 1:
                    this._string.push("L", x, ",", y);
                    break;
                default:
                    if (this._circle == null) this._circle = circle$1(this._radius);
                    this._string.push("M", x, ",", y, this._circle);
                    break;
            }
        },
        result: function() {
            if (this._string.length) {
                var result = this._string.join("");
                this._string = [];
                return result;
            } else return null;
        }
    };
    function circle$1(radius) {
        return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
    }
    function index$2(projection, context) {
        var pointRadius = 4.5, projectionStream, contextStream;
        function path(object) {
            if (object) {
                if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
                geoStream(object, projectionStream(contextStream));
            }
            return contextStream.result();
        }
        path.area = function(object) {
            geoStream(object, projectionStream(pathArea));
            return pathArea.result();
        };
        path.measure = function(object) {
            geoStream(object, projectionStream(pathMeasure));
            return pathMeasure.result();
        };
        path.bounds = function(object) {
            geoStream(object, projectionStream(boundsStream$1));
            return boundsStream$1.result();
        };
        path.centroid = function(object) {
            geoStream(object, projectionStream(pathCentroid));
            return pathCentroid.result();
        };
        path.projection = function(_) {
            return arguments.length ? (projectionStream = _ == null ? (projection = null, identity$5) : (projection = _).stream, path) : projection;
        };
        path.context = function(_) {
            if (!arguments.length) return context;
            contextStream = _ == null ? (context = null, new PathString) : new PathContext(context = _);
            if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
            return path;
        };
        path.pointRadius = function(_) {
            if (!arguments.length) return pointRadius;
            pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
            return path;
        };
        return path.projection(projection).context(context);
    }
    function transform$1(methods) {
        return {
            stream: transformer$3(methods)
        };
    }
    function transformer$3(methods) {
        return function(stream) {
            var s = new TransformStream;
            for(var key in methods)s[key] = methods[key];
            s.stream = stream;
            return s;
        };
    }
    function TransformStream() {}
    TransformStream.prototype = {
        constructor: TransformStream,
        point: function(x, y) {
            this.stream.point(x, y);
        },
        sphere: function() {
            this.stream.sphere();
        },
        lineStart: function() {
            this.stream.lineStart();
        },
        lineEnd: function() {
            this.stream.lineEnd();
        },
        polygonStart: function() {
            this.stream.polygonStart();
        },
        polygonEnd: function() {
            this.stream.polygonEnd();
        }
    };
    function fit(projection, fitBounds, object) {
        var clip = projection.clipExtent && projection.clipExtent();
        projection.scale(150).translate([
            0,
            0
        ]);
        if (clip != null) projection.clipExtent(null);
        geoStream(object, projection.stream(boundsStream$1));
        fitBounds(boundsStream$1.result());
        if (clip != null) projection.clipExtent(clip);
        return projection;
    }
    function fitExtent(projection, extent, object) {
        return fit(projection, function(b) {
            var w = extent[1][0] - extent[0][0], h = extent[1][1] - extent[0][1], k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2, y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
            projection.scale(150 * k).translate([
                x,
                y
            ]);
        }, object);
    }
    function fitSize(projection, size, object) {
        return fitExtent(projection, [
            [
                0,
                0
            ],
            size
        ], object);
    }
    function fitWidth(projection, width, object) {
        return fit(projection, function(b) {
            var w = +width, k = w / (b[1][0] - b[0][0]), x = (w - k * (b[1][0] + b[0][0])) / 2, y = -k * b[0][1];
            projection.scale(150 * k).translate([
                x,
                y
            ]);
        }, object);
    }
    function fitHeight(projection, height, object) {
        return fit(projection, function(b) {
            var h = +height, k = h / (b[1][1] - b[0][1]), x = -k * b[0][0], y = (h - k * (b[1][1] + b[0][1])) / 2;
            projection.scale(150 * k).translate([
                x,
                y
            ]);
        }, object);
    }
    var maxDepth = 16, cosMinDistance = cos$1(30 * radians); // cos(minimum angular distance)
    function resample(project, delta2) {
        return +delta2 ? resample$1(project, delta2) : resampleNone(project);
    }
    function resampleNone(project) {
        return transformer$3({
            point: function(x, y) {
                x = project(x, y);
                this.stream.point(x[0], x[1]);
            }
        });
    }
    function resample$1(project, delta2) {
        function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
            var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
            if (d2 > 4 * delta2 && depth--) {
                var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = sqrt$2(a * a + b * b + c * c), phi2 = asin$1(c /= m), lambda2 = abs$1(abs$1(c) - 1) < epsilon$1 || abs$1(lambda0 - lambda1) < epsilon$1 ? (lambda0 + lambda1) / 2 : atan2$1(b, a), p = project(lambda2, phi2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
                if (dz * dz / d2 > delta2 // perpendicular projected distance
                 || abs$1((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
                 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
                    resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
                    stream.point(x2, y2);
                    resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
                }
            }
        }
        return function(stream) {
            var lambda00, x00, y00, a00, b00, c00, lambda0, x0, y0, a0, b0, c0; // previous point
            var resampleStream = {
                point: point,
                lineStart: lineStart,
                lineEnd: lineEnd,
                polygonStart: function() {
                    stream.polygonStart();
                    resampleStream.lineStart = ringStart;
                },
                polygonEnd: function() {
                    stream.polygonEnd();
                    resampleStream.lineStart = lineStart;
                }
            };
            function point(x, y) {
                x = project(x, y);
                stream.point(x[0], x[1]);
            }
            function lineStart() {
                x0 = NaN;
                resampleStream.point = linePoint;
                stream.lineStart();
            }
            function linePoint(lambda, phi) {
                var c = cartesian([
                    lambda,
                    phi
                ]), p = project(lambda, phi);
                resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
                stream.point(x0, y0);
            }
            function lineEnd() {
                resampleStream.point = point;
                stream.lineEnd();
            }
            function ringStart() {
                lineStart();
                resampleStream.point = ringPoint;
                resampleStream.lineEnd = ringEnd;
            }
            function ringPoint(lambda, phi) {
                linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
                resampleStream.point = linePoint;
            }
            function ringEnd() {
                resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
                resampleStream.lineEnd = lineEnd;
                lineEnd();
            }
            return resampleStream;
        };
    }
    var transformRadians = transformer$3({
        point: function(x, y) {
            this.stream.point(x * radians, y * radians);
        }
    });
    function transformRotate(rotate) {
        return transformer$3({
            point: function(x, y) {
                var r = rotate(x, y);
                return this.stream.point(r[0], r[1]);
            }
        });
    }
    function scaleTranslate(k, dx, dy, sx, sy) {
        function transform(x, y) {
            x *= sx;
            y *= sy;
            return [
                dx + k * x,
                dy - k * y
            ];
        }
        transform.invert = function(x, y) {
            return [
                (x - dx) / k * sx,
                (dy - y) / k * sy
            ];
        };
        return transform;
    }
    function scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
        if (!alpha) return scaleTranslate(k, dx, dy, sx, sy);
        var cosAlpha = cos$1(alpha), sinAlpha = sin$1(alpha), a = cosAlpha * k, b = sinAlpha * k, ai = cosAlpha / k, bi = sinAlpha / k, ci = (sinAlpha * dy - cosAlpha * dx) / k, fi = (sinAlpha * dx + cosAlpha * dy) / k;
        function transform(x, y) {
            x *= sx;
            y *= sy;
            return [
                a * x - b * y + dx,
                dy - b * x - a * y
            ];
        }
        transform.invert = function(x, y) {
            return [
                sx * (ai * x - bi * y + ci),
                sy * (fi - bi * x - ai * y)
            ];
        };
        return transform;
    }
    function projection(project) {
        return projectionMutator(function() {
            return project;
        })();
    }
    function projectionMutator(projectAt) {
        var project, k = 150, x = 480, y = 250, lambda = 0, phi = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, alpha = 0, sx = 1, sy = 1, theta = null, preclip = clipAntimeridian, x0 = null, y0, x1, y1, postclip = identity$5, delta2 = 0.5, projectResample, projectTransform, projectRotateTransform, cache, cacheStream;
        function projection(point) {
            return projectRotateTransform(point[0] * radians, point[1] * radians);
        }
        function invert(point) {
            point = projectRotateTransform.invert(point[0], point[1]);
            return point && [
                point[0] * degrees,
                point[1] * degrees
            ];
        }
        projection.stream = function(stream) {
            return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
        };
        projection.preclip = function(_) {
            return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
        };
        projection.postclip = function(_) {
            return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
        };
        projection.clipAngle = function(_) {
            return arguments.length ? (preclip = +_ ? clipCircle(theta = _ * radians) : (theta = null, clipAntimeridian), reset()) : theta * degrees;
        };
        projection.clipExtent = function(_) {
            return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity$5) : clipRectangle(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        };
        projection.scale = function(_) {
            return arguments.length ? (k = +_, recenter()) : k;
        };
        projection.translate = function(_) {
            return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [
                x,
                y
            ];
        };
        projection.center = function(_) {
            return arguments.length ? (lambda = _[0] % 360 * radians, phi = _[1] % 360 * radians, recenter()) : [
                lambda * degrees,
                phi * degrees
            ];
        };
        projection.rotate = function(_) {
            return arguments.length ? (deltaLambda = _[0] % 360 * radians, deltaPhi = _[1] % 360 * radians, deltaGamma = _.length > 2 ? _[2] % 360 * radians : 0, recenter()) : [
                deltaLambda * degrees,
                deltaPhi * degrees,
                deltaGamma * degrees
            ];
        };
        projection.angle = function(_) {
            return arguments.length ? (alpha = _ % 360 * radians, recenter()) : alpha * degrees;
        };
        projection.reflectX = function(_) {
            return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
        };
        projection.reflectY = function(_) {
            return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
        };
        projection.precision = function(_) {
            return arguments.length ? (projectResample = resample(projectTransform, delta2 = _ * _), reset()) : sqrt$2(delta2);
        };
        projection.fitExtent = function(extent, object) {
            return fitExtent(projection, extent, object);
        };
        projection.fitSize = function(size, object) {
            return fitSize(projection, size, object);
        };
        projection.fitWidth = function(width, object) {
            return fitWidth(projection, width, object);
        };
        projection.fitHeight = function(height, object) {
            return fitHeight(projection, height, object);
        };
        function recenter() {
            var center = scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)), transform = scaleTranslateRotate(k, x - center[0], y - center[1], sx, sy, alpha);
            rotate = rotateRadians(deltaLambda, deltaPhi, deltaGamma);
            projectTransform = compose(project, transform);
            projectRotateTransform = compose(rotate, projectTransform);
            projectResample = resample(projectTransform, delta2);
            return reset();
        }
        function reset() {
            cache = cacheStream = null;
            return projection;
        }
        return function() {
            project = projectAt.apply(this, arguments);
            projection.invert = project.invert && invert;
            return recenter();
        };
    }
    function conicProjection(projectAt) {
        var phi0 = 0, phi1 = pi$1 / 3, m = projectionMutator(projectAt), p = m(phi0, phi1);
        p.parallels = function(_) {
            return arguments.length ? m(phi0 = _[0] * radians, phi1 = _[1] * radians) : [
                phi0 * degrees,
                phi1 * degrees
            ];
        };
        return p;
    }
    function cylindricalEqualAreaRaw(phi0) {
        var cosPhi0 = cos$1(phi0);
        function forward(lambda, phi) {
            return [
                lambda * cosPhi0,
                sin$1(phi) / cosPhi0
            ];
        }
        forward.invert = function(x, y) {
            return [
                x / cosPhi0,
                asin$1(y * cosPhi0)
            ];
        };
        return forward;
    }
    function conicEqualAreaRaw(y0, y1) {
        var sy0 = sin$1(y0), n = (sy0 + sin$1(y1)) / 2;
        // Are the parallels symmetrical around the Equator?
        if (abs$1(n) < epsilon$1) return cylindricalEqualAreaRaw(y0);
        var c = 1 + sy0 * (2 * n - sy0), r0 = sqrt$2(c) / n;
        function project(x, y) {
            var r = sqrt$2(c - 2 * n * sin$1(y)) / n;
            return [
                r * sin$1(x *= n),
                r0 - r * cos$1(x)
            ];
        }
        project.invert = function(x, y) {
            var r0y = r0 - y, l = atan2$1(x, abs$1(r0y)) * sign$1(r0y);
            if (r0y * n < 0) l -= pi$1 * sign$1(x) * sign$1(r0y);
            return [
                l / n,
                asin$1((c - (x * x + r0y * r0y) * n * n) / (2 * n))
            ];
        };
        return project;
    }
    function conicEqualArea() {
        return conicProjection(conicEqualAreaRaw).scale(155.424).center([
            0,
            33.6442
        ]);
    }
    function albers() {
        return conicEqualArea().parallels([
            29.5,
            45.5
        ]).scale(1070).translate([
            480,
            250
        ]).rotate([
            96,
            0
        ]).center([
            -0.6,
            38.7
        ]);
    }
    // The projections must have mutually exclusive clip regions on the sphere,
    // as this will avoid emitting interleaving lines and polygons.
    function multiplex(streams) {
        var n = streams.length;
        return {
            point: function(x, y) {
                var i = -1;
                while(++i < n)streams[i].point(x, y);
            },
            sphere: function() {
                var i = -1;
                while(++i < n)streams[i].sphere();
            },
            lineStart: function() {
                var i = -1;
                while(++i < n)streams[i].lineStart();
            },
            lineEnd: function() {
                var i = -1;
                while(++i < n)streams[i].lineEnd();
            },
            polygonStart: function() {
                var i = -1;
                while(++i < n)streams[i].polygonStart();
            },
            polygonEnd: function() {
                var i = -1;
                while(++i < n)streams[i].polygonEnd();
            }
        };
    }
    // A composite projection for the United States, configured by default for
    // 960×500. The projection also works quite well at 960×600 if you change the
    // scale to 1285 and adjust the translate accordingly. The set of standard
    // parallels for each region comes from USGS, which is published here:
    // http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
    function albersUsa() {
        var cache, cacheStream, lower48 = albers(), lower48Point, alaska = conicEqualArea().rotate([
            154,
            0
        ]).center([
            -2,
            58.5
        ]).parallels([
            55,
            65
        ]), alaskaPoint, hawaii = conicEqualArea().rotate([
            157,
            0
        ]).center([
            -3,
            19.9
        ]).parallels([
            8,
            18
        ]), hawaiiPoint, point, pointStream = {
            point: function(x, y) {
                point = [
                    x,
                    y
                ];
            }
        };
        function albersUsa(coordinates) {
            var x = coordinates[0], y = coordinates[1];
            return point = null, (lower48Point.point(x, y), point) || (alaskaPoint.point(x, y), point) || (hawaiiPoint.point(x, y), point);
        }
        albersUsa.invert = function(coordinates) {
            var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
            return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates);
        };
        albersUsa.stream = function(stream) {
            return cache && cacheStream === stream ? cache : cache = multiplex([
                lower48.stream(cacheStream = stream),
                alaska.stream(stream),
                hawaii.stream(stream)
            ]);
        };
        albersUsa.precision = function(_) {
            if (!arguments.length) return lower48.precision();
            lower48.precision(_), alaska.precision(_), hawaii.precision(_);
            return reset();
        };
        albersUsa.scale = function(_) {
            if (!arguments.length) return lower48.scale();
            lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
            return albersUsa.translate(lower48.translate());
        };
        albersUsa.translate = function(_) {
            if (!arguments.length) return lower48.translate();
            var k = lower48.scale(), x = +_[0], y = +_[1];
            lower48Point = lower48.translate(_).clipExtent([
                [
                    x - 0.455 * k,
                    y - 0.238 * k
                ],
                [
                    x + 0.455 * k,
                    y + 0.238 * k
                ]
            ]).stream(pointStream);
            alaskaPoint = alaska.translate([
                x - 0.307 * k,
                y + 0.201 * k
            ]).clipExtent([
                [
                    x - 0.425 * k + epsilon$1,
                    y + 0.120 * k + epsilon$1
                ],
                [
                    x - 0.214 * k - epsilon$1,
                    y + 0.234 * k - epsilon$1
                ]
            ]).stream(pointStream);
            hawaiiPoint = hawaii.translate([
                x - 0.205 * k,
                y + 0.212 * k
            ]).clipExtent([
                [
                    x - 0.214 * k + epsilon$1,
                    y + 0.166 * k + epsilon$1
                ],
                [
                    x - 0.115 * k - epsilon$1,
                    y + 0.234 * k - epsilon$1
                ]
            ]).stream(pointStream);
            return reset();
        };
        albersUsa.fitExtent = function(extent, object) {
            return fitExtent(albersUsa, extent, object);
        };
        albersUsa.fitSize = function(size, object) {
            return fitSize(albersUsa, size, object);
        };
        albersUsa.fitWidth = function(width, object) {
            return fitWidth(albersUsa, width, object);
        };
        albersUsa.fitHeight = function(height, object) {
            return fitHeight(albersUsa, height, object);
        };
        function reset() {
            cache = cacheStream = null;
            return albersUsa;
        }
        return albersUsa.scale(1070);
    }
    function azimuthalRaw(scale) {
        return function(x, y) {
            var cx = cos$1(x), cy = cos$1(y), k = scale(cx * cy);
            if (k === Infinity) return [
                2,
                0
            ];
            return [
                k * cy * sin$1(x),
                k * sin$1(y)
            ];
        };
    }
    function azimuthalInvert(angle) {
        return function(x, y) {
            var z = sqrt$2(x * x + y * y), c = angle(z), sc = sin$1(c), cc = cos$1(c);
            return [
                atan2$1(x * sc, z * cc),
                asin$1(z && y * sc / z)
            ];
        };
    }
    var azimuthalEqualAreaRaw = azimuthalRaw(function(cxcy) {
        return sqrt$2(2 / (1 + cxcy));
    });
    azimuthalEqualAreaRaw.invert = azimuthalInvert(function(z) {
        return 2 * asin$1(z / 2);
    });
    function azimuthalEqualArea() {
        return projection(azimuthalEqualAreaRaw).scale(124.75).clipAngle(179.999);
    }
    var azimuthalEquidistantRaw = azimuthalRaw(function(c) {
        return (c = acos$1(c)) && c / sin$1(c);
    });
    azimuthalEquidistantRaw.invert = azimuthalInvert(function(z) {
        return z;
    });
    function azimuthalEquidistant() {
        return projection(azimuthalEquidistantRaw).scale(79.4188).clipAngle(179.999);
    }
    function mercatorRaw(lambda, phi) {
        return [
            lambda,
            log$1(tan((halfPi$1 + phi) / 2))
        ];
    }
    mercatorRaw.invert = function(x, y) {
        return [
            x,
            2 * atan(exp(y)) - halfPi$1
        ];
    };
    function mercator() {
        return mercatorProjection(mercatorRaw).scale(961 / tau$1);
    }
    function mercatorProjection(project) {
        var m = projection(project), center = m.center, scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, x0 = null, y0, x1, y1; // clip extent
        m.scale = function(_) {
            return arguments.length ? (scale(_), reclip()) : scale();
        };
        m.translate = function(_) {
            return arguments.length ? (translate(_), reclip()) : translate();
        };
        m.center = function(_) {
            return arguments.length ? (center(_), reclip()) : center();
        };
        m.clipExtent = function(_) {
            return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        };
        function reclip() {
            var k = pi$1 * scale(), t = m(rotation(m.rotate()).invert([
                0,
                0
            ]));
            return clipExtent(x0 == null ? [
                [
                    t[0] - k,
                    t[1] - k
                ],
                [
                    t[0] + k,
                    t[1] + k
                ]
            ] : project === mercatorRaw ? [
                [
                    Math.max(t[0] - k, x0),
                    y0
                ],
                [
                    Math.min(t[0] + k, x1),
                    y1
                ]
            ] : [
                [
                    x0,
                    Math.max(t[1] - k, y0)
                ],
                [
                    x1,
                    Math.min(t[1] + k, y1)
                ]
            ]);
        }
        return reclip();
    }
    function tany(y) {
        return tan((halfPi$1 + y) / 2);
    }
    function conicConformalRaw(y0, y1) {
        var cy0 = cos$1(y0), n = y0 === y1 ? sin$1(y0) : log$1(cy0 / cos$1(y1)) / log$1(tany(y1) / tany(y0)), f = cy0 * pow$1(tany(y0), n) / n;
        if (!n) return mercatorRaw;
        function project(x, y) {
            if (f > 0) {
                if (y < -halfPi$1 + epsilon$1) y = -halfPi$1 + epsilon$1;
            } else if (y > halfPi$1 - epsilon$1) y = halfPi$1 - epsilon$1;
            var r = f / pow$1(tany(y), n);
            return [
                r * sin$1(n * x),
                f - r * cos$1(n * x)
            ];
        }
        project.invert = function(x, y) {
            var fy = f - y, r = sign$1(n) * sqrt$2(x * x + fy * fy), l = atan2$1(x, abs$1(fy)) * sign$1(fy);
            if (fy * n < 0) l -= pi$1 * sign$1(x) * sign$1(fy);
            return [
                l / n,
                2 * atan(pow$1(f / r, 1 / n)) - halfPi$1
            ];
        };
        return project;
    }
    function conicConformal() {
        return conicProjection(conicConformalRaw).scale(109.5).parallels([
            30,
            30
        ]);
    }
    function equirectangularRaw(lambda, phi) {
        return [
            lambda,
            phi
        ];
    }
    equirectangularRaw.invert = equirectangularRaw;
    function equirectangular() {
        return projection(equirectangularRaw).scale(152.63);
    }
    function conicEquidistantRaw(y0, y1) {
        var cy0 = cos$1(y0), n = y0 === y1 ? sin$1(y0) : (cy0 - cos$1(y1)) / (y1 - y0), g = cy0 / n + y0;
        if (abs$1(n) < epsilon$1) return equirectangularRaw;
        function project(x, y) {
            var gy = g - y, nx = n * x;
            return [
                gy * sin$1(nx),
                g - gy * cos$1(nx)
            ];
        }
        project.invert = function(x, y) {
            var gy = g - y, l = atan2$1(x, abs$1(gy)) * sign$1(gy);
            if (gy * n < 0) l -= pi$1 * sign$1(x) * sign$1(gy);
            return [
                l / n,
                g - sign$1(n) * sqrt$2(x * x + gy * gy)
            ];
        };
        return project;
    }
    function conicEquidistant() {
        return conicProjection(conicEquidistantRaw).scale(131.154).center([
            0,
            13.9389
        ]);
    }
    var A1 = 1.340264, A2 = -0.081106, A3 = 0.000893, A4 = 0.003796, M = sqrt$2(3) / 2, iterations = 12;
    function equalEarthRaw(lambda, phi) {
        var l = asin$1(M * sin$1(phi)), l2 = l * l, l6 = l2 * l2 * l2;
        return [
            lambda * cos$1(l) / (M * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2))),
            l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2))
        ];
    }
    equalEarthRaw.invert = function(x, y) {
        var l = y, l2 = l * l, l6 = l2 * l2 * l2;
        for(var i = 0, delta, fy, fpy; i < iterations; ++i){
            fy = l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2)) - y;
            fpy = A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2);
            l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
            if (abs$1(delta) < epsilon2) break;
        }
        return [
            M * x * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2)) / cos$1(l),
            asin$1(sin$1(l) / M)
        ];
    };
    function equalEarth() {
        return projection(equalEarthRaw).scale(177.158);
    }
    function gnomonicRaw(x, y) {
        var cy = cos$1(y), k = cos$1(x) * cy;
        return [
            cy * sin$1(x) / k,
            sin$1(y) / k
        ];
    }
    gnomonicRaw.invert = azimuthalInvert(atan);
    function gnomonic() {
        return projection(gnomonicRaw).scale(144.049).clipAngle(60);
    }
    function identity$4() {
        var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, alpha = 0, ca, sa, x0 = null, y0, x1, y1, kx = 1, ky = 1, transform = transformer$3({
            point: function(x, y) {
                var p = projection([
                    x,
                    y
                ]);
                this.stream.point(p[0], p[1]);
            }
        }), postclip = identity$5, cache, cacheStream;
        function reset() {
            kx = k * sx;
            ky = k * sy;
            cache = cacheStream = null;
            return projection;
        }
        function projection(p) {
            var x = p[0] * kx, y = p[1] * ky;
            if (alpha) {
                var t = y * ca - x * sa;
                x = x * ca + y * sa;
                y = t;
            }
            return [
                x + tx,
                y + ty
            ];
        }
        projection.invert = function(p) {
            var x = p[0] - tx, y = p[1] - ty;
            if (alpha) {
                var t = y * ca + x * sa;
                x = x * ca - y * sa;
                y = t;
            }
            return [
                x / kx,
                y / ky
            ];
        };
        projection.stream = function(stream) {
            return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
        };
        projection.postclip = function(_) {
            return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
        };
        projection.clipExtent = function(_) {
            return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity$5) : clipRectangle(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        };
        projection.scale = function(_) {
            return arguments.length ? (k = +_, reset()) : k;
        };
        projection.translate = function(_) {
            return arguments.length ? (tx = +_[0], ty = +_[1], reset()) : [
                tx,
                ty
            ];
        };
        projection.angle = function(_) {
            return arguments.length ? (alpha = _ % 360 * radians, sa = sin$1(alpha), ca = cos$1(alpha), reset()) : alpha * degrees;
        };
        projection.reflectX = function(_) {
            return arguments.length ? (sx = _ ? -1 : 1, reset()) : sx < 0;
        };
        projection.reflectY = function(_) {
            return arguments.length ? (sy = _ ? -1 : 1, reset()) : sy < 0;
        };
        projection.fitExtent = function(extent, object) {
            return fitExtent(projection, extent, object);
        };
        projection.fitSize = function(size, object) {
            return fitSize(projection, size, object);
        };
        projection.fitWidth = function(width, object) {
            return fitWidth(projection, width, object);
        };
        projection.fitHeight = function(height, object) {
            return fitHeight(projection, height, object);
        };
        return projection;
    }
    function naturalEarth1Raw(lambda, phi) {
        var phi2 = phi * phi, phi4 = phi2 * phi2;
        return [
            lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
            phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
        ];
    }
    naturalEarth1Raw.invert = function(x, y) {
        var phi = y, i = 25, delta;
        do {
            var phi2 = phi * phi, phi4 = phi2 * phi2;
            phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) / (1.007226 + phi2 * (0.045255 + phi4 * (-0.311325 + 0.259866 * phi2 - 0.005916 * 11 * phi4)));
        }while (abs$1(delta) > epsilon$1 && --i > 0);
        return [
            x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
            phi
        ];
    };
    function naturalEarth1() {
        return projection(naturalEarth1Raw).scale(175.295);
    }
    function orthographicRaw(x, y) {
        return [
            cos$1(y) * sin$1(x),
            sin$1(y)
        ];
    }
    orthographicRaw.invert = azimuthalInvert(asin$1);
    function orthographic() {
        return projection(orthographicRaw).scale(249.5).clipAngle(90 + epsilon$1);
    }
    function stereographicRaw(x, y) {
        var cy = cos$1(y), k = 1 + cos$1(x) * cy;
        return [
            cy * sin$1(x) / k,
            sin$1(y) / k
        ];
    }
    stereographicRaw.invert = azimuthalInvert(function(z) {
        return 2 * atan(z);
    });
    function stereographic() {
        return projection(stereographicRaw).scale(250).clipAngle(142);
    }
    function transverseMercatorRaw(lambda, phi) {
        return [
            log$1(tan((halfPi$1 + phi) / 2)),
            -lambda
        ];
    }
    transverseMercatorRaw.invert = function(x, y) {
        return [
            -y,
            2 * atan(exp(x)) - halfPi$1
        ];
    };
    function transverseMercator() {
        var m = mercatorProjection(transverseMercatorRaw), center = m.center, rotate = m.rotate;
        m.center = function(_) {
            return arguments.length ? center([
                -_[1],
                _[0]
            ]) : (_ = center(), [
                _[1],
                -_[0]
            ]);
        };
        m.rotate = function(_) {
            return arguments.length ? rotate([
                _[0],
                _[1],
                _.length > 2 ? _[2] + 90 : 90
            ]) : (_ = rotate(), [
                _[0],
                _[1],
                _[2] - 90
            ]);
        };
        return rotate([
            0,
            0,
            90
        ]).scale(159.155);
    }
    function defaultSeparation$1(a, b) {
        return a.parent === b.parent ? 1 : 2;
    }
    function meanX(children) {
        return children.reduce(meanXReduce, 0) / children.length;
    }
    function meanXReduce(x, c) {
        return x + c.x;
    }
    function maxY(children) {
        return 1 + children.reduce(maxYReduce, 0);
    }
    function maxYReduce(y, c) {
        return Math.max(y, c.y);
    }
    function leafLeft(node) {
        var children;
        while(children = node.children)node = children[0];
        return node;
    }
    function leafRight(node) {
        var children;
        while(children = node.children)node = children[children.length - 1];
        return node;
    }
    function cluster() {
        var separation = defaultSeparation$1, dx = 1, dy = 1, nodeSize = false;
        function cluster(root) {
            var previousNode, x = 0;
            // First walk, computing the initial x & y values.
            root.eachAfter(function(node) {
                var children = node.children;
                if (children) {
                    node.x = meanX(children);
                    node.y = maxY(children);
                } else {
                    node.x = previousNode ? x += separation(node, previousNode) : 0;
                    node.y = 0;
                    previousNode = node;
                }
            });
            var left = leafLeft(root), right = leafRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
            // Second walk, normalizing x & y to the desired size.
            return root.eachAfter(nodeSize ? function(node) {
                node.x = (node.x - root.x) * dx;
                node.y = (root.y - node.y) * dy;
            } : function(node) {
                node.x = (node.x - x0) / (x1 - x0) * dx;
                node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
            });
        }
        cluster.separation = function(x) {
            return arguments.length ? (separation = x, cluster) : separation;
        };
        cluster.size = function(x) {
            return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : nodeSize ? null : [
                dx,
                dy
            ];
        };
        cluster.nodeSize = function(x) {
            return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : nodeSize ? [
                dx,
                dy
            ] : null;
        };
        return cluster;
    }
    function count(node) {
        var sum = 0, children = node.children, i = children && children.length;
        if (!i) sum = 1;
        else while(--i >= 0)sum += children[i].value;
        node.value = sum;
    }
    function node_count() {
        return this.eachAfter(count);
    }
    function node_each(callback, that) {
        let index = -1;
        for (const node of this)callback.call(that, node, ++index, this);
        return this;
    }
    function node_eachBefore(callback, that) {
        var node = this, nodes = [
            node
        ], children, i, index = -1;
        while(node = nodes.pop()){
            callback.call(that, node, ++index, this);
            if (children = node.children) for(i = children.length - 1; i >= 0; --i)nodes.push(children[i]);
        }
        return this;
    }
    function node_eachAfter(callback, that) {
        var node = this, nodes = [
            node
        ], next = [], children, i, n, index = -1;
        while(node = nodes.pop()){
            next.push(node);
            if (children = node.children) for(i = 0, n = children.length; i < n; ++i)nodes.push(children[i]);
        }
        while(node = next.pop())callback.call(that, node, ++index, this);
        return this;
    }
    function node_find(callback, that) {
        let index = -1;
        for (const node of this){
            if (callback.call(that, node, ++index, this)) return node;
        }
    }
    function node_sum(value) {
        return this.eachAfter(function(node) {
            var sum = +value(node.data) || 0, children = node.children, i = children && children.length;
            while(--i >= 0)sum += children[i].value;
            node.value = sum;
        });
    }
    function node_sort(compare) {
        return this.eachBefore(function(node) {
            if (node.children) node.children.sort(compare);
        });
    }
    function node_path(end) {
        var start = this, ancestor = leastCommonAncestor(start, end), nodes = [
            start
        ];
        while(start !== ancestor){
            start = start.parent;
            nodes.push(start);
        }
        var k = nodes.length;
        while(end !== ancestor){
            nodes.splice(k, 0, end);
            end = end.parent;
        }
        return nodes;
    }
    function leastCommonAncestor(a, b) {
        if (a === b) return a;
        var aNodes = a.ancestors(), bNodes = b.ancestors(), c = null;
        a = aNodes.pop();
        b = bNodes.pop();
        while(a === b){
            c = a;
            a = aNodes.pop();
            b = bNodes.pop();
        }
        return c;
    }
    function node_ancestors() {
        var node = this, nodes = [
            node
        ];
        while(node = node.parent)nodes.push(node);
        return nodes;
    }
    function node_descendants() {
        return Array.from(this);
    }
    function node_leaves() {
        var leaves = [];
        this.eachBefore(function(node) {
            if (!node.children) leaves.push(node);
        });
        return leaves;
    }
    function node_links() {
        var root = this, links = [];
        root.each(function(node) {
            if (node !== root) links.push({
                source: node.parent,
                target: node
            });
        });
        return links;
    }
    function* node_iterator() {
        var node = this, current, next = [
            node
        ], children, i, n;
        do {
            current = next.reverse(), next = [];
            while(node = current.pop()){
                yield node;
                if (children = node.children) for(i = 0, n = children.length; i < n; ++i)next.push(children[i]);
            }
        }while (next.length);
    }
    function hierarchy(data, children) {
        if (data instanceof Map) {
            data = [
                undefined,
                data
            ];
            if (children === undefined) children = mapChildren;
        } else if (children === undefined) children = objectChildren;
        var root = new Node$1(data), node, nodes = [
            root
        ], child, childs, i, n;
        while(node = nodes.pop())if ((childs = children(node.data)) && (n = (childs = Array.from(childs)).length)) {
            node.children = childs;
            for(i = n - 1; i >= 0; --i){
                nodes.push(child = childs[i] = new Node$1(childs[i]));
                child.parent = node;
                child.depth = node.depth + 1;
            }
        }
        return root.eachBefore(computeHeight);
    }
    function node_copy() {
        return hierarchy(this).eachBefore(copyData);
    }
    function objectChildren(d) {
        return d.children;
    }
    function mapChildren(d) {
        return Array.isArray(d) ? d[1] : null;
    }
    function copyData(node) {
        if (node.data.value !== undefined) node.value = node.data.value;
        node.data = node.data.data;
    }
    function computeHeight(node) {
        var height = 0;
        do node.height = height;
        while ((node = node.parent) && node.height < ++height);
    }
    function Node$1(data) {
        this.data = data;
        this.depth = this.height = 0;
        this.parent = null;
    }
    Node$1.prototype = hierarchy.prototype = {
        constructor: Node$1,
        count: node_count,
        each: node_each,
        eachAfter: node_eachAfter,
        eachBefore: node_eachBefore,
        find: node_find,
        sum: node_sum,
        sort: node_sort,
        path: node_path,
        ancestors: node_ancestors,
        descendants: node_descendants,
        leaves: node_leaves,
        links: node_links,
        copy: node_copy,
        [Symbol.iterator]: node_iterator
    };
    function optional(f) {
        return f == null ? null : required(f);
    }
    function required(f) {
        if (typeof f !== "function") throw new Error;
        return f;
    }
    function constantZero() {
        return 0;
    }
    function constant$2(x) {
        return function() {
            return x;
        };
    }
    // https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
    const a$1 = 1664525;
    const c$3 = 1013904223;
    const m = 4294967296; // 2^32
    function lcg$1() {
        let s = 1;
        return ()=>(s = (a$1 * s + c$3) % m) / m;
    }
    function array$1(x) {
        return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
         : Array.from(x); // Map, Set, iterable, string, or anything else
    }
    function shuffle(array, random) {
        let m = array.length, t, i;
        while(m){
            i = random() * m-- | 0;
            t = array[m];
            array[m] = array[i];
            array[i] = t;
        }
        return array;
    }
    function enclose(circles) {
        return packEncloseRandom(circles, lcg$1());
    }
    function packEncloseRandom(circles, random) {
        var i = 0, n = (circles = shuffle(Array.from(circles), random)).length, B = [], p, e;
        while(i < n){
            p = circles[i];
            if (e && enclosesWeak(e, p)) ++i;
            else e = encloseBasis(B = extendBasis(B, p)), i = 0;
        }
        return e;
    }
    function extendBasis(B, p) {
        var i, j;
        if (enclosesWeakAll(p, B)) return [
            p
        ];
        // If we get here then B must have at least one element.
        for(i = 0; i < B.length; ++i){
            if (enclosesNot(p, B[i]) && enclosesWeakAll(encloseBasis2(B[i], p), B)) return [
                B[i],
                p
            ];
        }
        // If we get here then B must have at least two elements.
        for(i = 0; i < B.length - 1; ++i)for(j = i + 1; j < B.length; ++j){
            if (enclosesNot(encloseBasis2(B[i], B[j]), p) && enclosesNot(encloseBasis2(B[i], p), B[j]) && enclosesNot(encloseBasis2(B[j], p), B[i]) && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) return [
                B[i],
                B[j],
                p
            ];
        }
        // If we get here then something is very wrong.
        throw new Error;
    }
    function enclosesNot(a, b) {
        var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
        return dr < 0 || dr * dr < dx * dx + dy * dy;
    }
    function enclosesWeak(a, b) {
        var dr = a.r - b.r + Math.max(a.r, b.r, 1) * 1e-9, dx = b.x - a.x, dy = b.y - a.y;
        return dr > 0 && dr * dr > dx * dx + dy * dy;
    }
    function enclosesWeakAll(a, B) {
        for(var i = 0; i < B.length; ++i){
            if (!enclosesWeak(a, B[i])) return false;
        }
        return true;
    }
    function encloseBasis(B) {
        switch(B.length){
            case 1:
                return encloseBasis1(B[0]);
            case 2:
                return encloseBasis2(B[0], B[1]);
            case 3:
                return encloseBasis3(B[0], B[1], B[2]);
        }
    }
    function encloseBasis1(a) {
        return {
            x: a.x,
            y: a.y,
            r: a.r
        };
    }
    function encloseBasis2(a, b) {
        var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1, l = Math.sqrt(x21 * x21 + y21 * y21);
        return {
            x: (x1 + x2 + x21 / l * r21) / 2,
            y: (y1 + y2 + y21 / l * r21) / 2,
            r: (l + r1 + r2) / 2
        };
    }
    function encloseBasis3(a, b, c) {
        var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x3 = c.x, y3 = c.y, r3 = c.r, a2 = x1 - x2, a3 = x1 - x3, b2 = y1 - y2, b3 = y1 - y3, c2 = r2 - r1, c3 = r3 - r1, d1 = x1 * x1 + y1 * y1 - r1 * r1, d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2, d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3, ab = a3 * b2 - a2 * b3, xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1, xb = (b3 * c2 - b2 * c3) / ab, ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1, yb = (a2 * c3 - a3 * c2) / ab, A = xb * xb + yb * yb - 1, B = 2 * (r1 + xa * xb + ya * yb), C = xa * xa + ya * ya - r1 * r1, r = -(Math.abs(A) > 1e-6 ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
        return {
            x: x1 + xa + xb * r,
            y: y1 + ya + yb * r,
            r: r
        };
    }
    function place(b, a, c) {
        var dx = b.x - a.x, x, a2, dy = b.y - a.y, y, b2, d2 = dx * dx + dy * dy;
        if (d2) {
            a2 = a.r + c.r, a2 *= a2;
            b2 = b.r + c.r, b2 *= b2;
            if (a2 > b2) {
                x = (d2 + b2 - a2) / (2 * d2);
                y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
                c.x = b.x - x * dx - y * dy;
                c.y = b.y - x * dy + y * dx;
            } else {
                x = (d2 + a2 - b2) / (2 * d2);
                y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
                c.x = a.x + x * dx - y * dy;
                c.y = a.y + x * dy + y * dx;
            }
        } else {
            c.x = a.x + c.r;
            c.y = a.y;
        }
    }
    function intersects(a, b) {
        var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
        return dr > 0 && dr * dr > dx * dx + dy * dy;
    }
    function score(node) {
        var a = node._, b = node.next._, ab = a.r + b.r, dx = (a.x * b.r + b.x * a.r) / ab, dy = (a.y * b.r + b.y * a.r) / ab;
        return dx * dx + dy * dy;
    }
    function Node(circle) {
        this._ = circle;
        this.next = null;
        this.previous = null;
    }
    function packSiblingsRandom(circles, random) {
        if (!(n = (circles = array$1(circles)).length)) return 0;
        var a, b, c, n, aa, ca, i, j, k, sj, sk;
        // Place the first circle.
        a = circles[0], a.x = 0, a.y = 0;
        if (!(n > 1)) return a.r;
        // Place the second circle.
        b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
        if (!(n > 2)) return a.r + b.r;
        // Place the third circle.
        place(b, a, c = circles[2]);
        // Initialize the front-chain using the first three circles a, b and c.
        a = new Node(a), b = new Node(b), c = new Node(c);
        a.next = c.previous = b;
        b.next = a.previous = c;
        c.next = b.previous = a;
        // Attempt to place each remaining circle…
        pack: for(i = 3; i < n; ++i){
            place(a._, b._, c = circles[i]), c = new Node(c);
            // Find the closest intersecting circle on the front-chain, if any.
            // “Closeness” is determined by linear distance along the front-chain.
            // “Ahead” or “behind” is likewise determined by linear distance.
            j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
            do if (sj <= sk) {
                if (intersects(j._, c._)) {
                    b = j, a.next = b, b.previous = a, --i;
                    continue pack;
                }
                sj += j._.r, j = j.next;
            } else {
                if (intersects(k._, c._)) {
                    a = k, a.next = b, b.previous = a, --i;
                    continue pack;
                }
                sk += k._.r, k = k.previous;
            }
            while (j !== k.next);
            // Success! Insert the new circle c between a and b.
            c.previous = a, c.next = b, a.next = b.previous = b = c;
            // Compute the new closest circle pair to the centroid.
            aa = score(a);
            while((c = c.next) !== b)if ((ca = score(c)) < aa) a = c, aa = ca;
            b = a.next;
        }
        // Compute the enclosing circle of the front chain.
        a = [
            b._
        ], c = b;
        while((c = c.next) !== b)a.push(c._);
        c = packEncloseRandom(a, random);
        // Translate the circles to put the enclosing circle around the origin.
        for(i = 0; i < n; ++i)a = circles[i], a.x -= c.x, a.y -= c.y;
        return c.r;
    }
    function siblings(circles) {
        packSiblingsRandom(circles, lcg$1());
        return circles;
    }
    function defaultRadius(d) {
        return Math.sqrt(d.value);
    }
    function index$1() {
        var radius = null, dx = 1, dy = 1, padding = constantZero;
        function pack(root) {
            const random = lcg$1();
            root.x = dx / 2, root.y = dy / 2;
            if (radius) root.eachBefore(radiusLeaf(radius)).eachAfter(packChildrenRandom(padding, 0.5, random)).eachBefore(translateChild(1));
            else root.eachBefore(radiusLeaf(defaultRadius)).eachAfter(packChildrenRandom(constantZero, 1, random)).eachAfter(packChildrenRandom(padding, root.r / Math.min(dx, dy), random)).eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
            return root;
        }
        pack.radius = function(x) {
            return arguments.length ? (radius = optional(x), pack) : radius;
        };
        pack.size = function(x) {
            return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [
                dx,
                dy
            ];
        };
        pack.padding = function(x) {
            return arguments.length ? (padding = typeof x === "function" ? x : constant$2(+x), pack) : padding;
        };
        return pack;
    }
    function radiusLeaf(radius) {
        return function(node) {
            if (!node.children) node.r = Math.max(0, +radius(node) || 0);
        };
    }
    function packChildrenRandom(padding, k, random) {
        return function(node) {
            if (children = node.children) {
                var children, i, n = children.length, r = padding(node) * k || 0, e;
                if (r) for(i = 0; i < n; ++i)children[i].r += r;
                e = packSiblingsRandom(children, random);
                if (r) for(i = 0; i < n; ++i)children[i].r -= r;
                node.r = e + r;
            }
        };
    }
    function translateChild(k) {
        return function(node) {
            var parent = node.parent;
            node.r *= k;
            if (parent) {
                node.x = parent.x + k * node.x;
                node.y = parent.y + k * node.y;
            }
        };
    }
    function roundNode(node) {
        node.x0 = Math.round(node.x0);
        node.y0 = Math.round(node.y0);
        node.x1 = Math.round(node.x1);
        node.y1 = Math.round(node.y1);
    }
    function treemapDice(parent, x0, y0, x1, y1) {
        var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (x1 - x0) / parent.value;
        while(++i < n){
            node = nodes[i], node.y0 = y0, node.y1 = y1;
            node.x0 = x0, node.x1 = x0 += node.value * k;
        }
    }
    function partition() {
        var dx = 1, dy = 1, padding = 0, round = false;
        function partition(root) {
            var n = root.height + 1;
            root.x0 = root.y0 = padding;
            root.x1 = dx;
            root.y1 = dy / n;
            root.eachBefore(positionNode(dy, n));
            if (round) root.eachBefore(roundNode);
            return root;
        }
        function positionNode(dy, n) {
            return function(node) {
                if (node.children) treemapDice(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
                var x0 = node.x0, y0 = node.y0, x1 = node.x1 - padding, y1 = node.y1 - padding;
                if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
                if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
                node.x0 = x0;
                node.y0 = y0;
                node.x1 = x1;
                node.y1 = y1;
            };
        }
        partition.round = function(x) {
            return arguments.length ? (round = !!x, partition) : round;
        };
        partition.size = function(x) {
            return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [
                dx,
                dy
            ];
        };
        partition.padding = function(x) {
            return arguments.length ? (padding = +x, partition) : padding;
        };
        return partition;
    }
    var preroot = {
        depth: -1
    }, ambiguous = {}, imputed = {};
    function defaultId(d) {
        return d.id;
    }
    function defaultParentId(d) {
        return d.parentId;
    }
    function stratify() {
        var id = defaultId, parentId = defaultParentId, path;
        function stratify(data) {
            var nodes = Array.from(data), currentId = id, currentParentId = parentId, n, d, i, root, parent, node, nodeId, nodeKey, nodeByKey = new Map;
            if (path != null) {
                const I = nodes.map((d, i)=>normalize$1(path(d, i, data)));
                const P = I.map(parentof);
                const S = new Set(I).add("");
                for (const i of P)if (!S.has(i)) {
                    S.add(i);
                    I.push(i);
                    P.push(parentof(i));
                    nodes.push(imputed);
                }
                currentId = (_, i)=>I[i];
                currentParentId = (_, i)=>P[i];
            }
            for(i = 0, n = nodes.length; i < n; ++i){
                d = nodes[i], node = nodes[i] = new Node$1(d);
                if ((nodeId = currentId(d, i, data)) != null && (nodeId += "")) {
                    nodeKey = node.id = nodeId;
                    nodeByKey.set(nodeKey, nodeByKey.has(nodeKey) ? ambiguous : node);
                }
                if ((nodeId = currentParentId(d, i, data)) != null && (nodeId += "")) node.parent = nodeId;
            }
            for(i = 0; i < n; ++i){
                node = nodes[i];
                if (nodeId = node.parent) {
                    parent = nodeByKey.get(nodeId);
                    if (!parent) throw new Error("missing: " + nodeId);
                    if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
                    if (parent.children) parent.children.push(node);
                    else parent.children = [
                        node
                    ];
                    node.parent = parent;
                } else {
                    if (root) throw new Error("multiple roots");
                    root = node;
                }
            }
            if (!root) throw new Error("no root");
            // When imputing internal nodes, only introduce roots if needed.
            // Then replace the imputed marker data with null.
            if (path != null) {
                while(root.data === imputed && root.children.length === 1)root = root.children[0], --n;
                for(let i = nodes.length - 1; i >= 0; --i){
                    node = nodes[i];
                    if (node.data !== imputed) break;
                    node.data = null;
                }
            }
            root.parent = preroot;
            root.eachBefore(function(node) {
                node.depth = node.parent.depth + 1;
                --n;
            }).eachBefore(computeHeight);
            root.parent = null;
            if (n > 0) throw new Error("cycle");
            return root;
        }
        stratify.id = function(x) {
            return arguments.length ? (id = optional(x), stratify) : id;
        };
        stratify.parentId = function(x) {
            return arguments.length ? (parentId = optional(x), stratify) : parentId;
        };
        stratify.path = function(x) {
            return arguments.length ? (path = optional(x), stratify) : path;
        };
        return stratify;
    }
    // To normalize a path, we coerce to a string, strip the trailing slash if any
    // (as long as the trailing slash is not immediately preceded by another slash),
    // and add leading slash if missing.
    function normalize$1(path) {
        path = `${path}`;
        let i = path.length;
        if (slash(path, i - 1) && !slash(path, i - 2)) path = path.slice(0, -1);
        return path[0] === "/" ? path : `/${path}`;
    }
    // Walk backwards to find the first slash that is not the leading slash, e.g.:
    // "/foo/bar" ⇥ "/foo", "/foo" ⇥ "/", "/" ↦ "". (The root is special-cased
    // because the id of the root must be a truthy value.)
    function parentof(path) {
        let i = path.length;
        if (i < 2) return "";
        while(--i > 1)if (slash(path, i)) break;
        return path.slice(0, i);
    }
    // Slashes can be escaped; to determine whether a slash is a path delimiter, we
    // count the number of preceding backslashes escaping the forward slash: an odd
    // number indicates an escaped forward slash.
    function slash(path, i) {
        if (path[i] === "/") {
            let k = 0;
            while(i > 0 && path[--i] === "\\")++k;
            if ((k & 1) === 0) return true;
        }
        return false;
    }
    function defaultSeparation(a, b) {
        return a.parent === b.parent ? 1 : 2;
    }
    // function radialSeparation(a, b) {
    //   return (a.parent === b.parent ? 1 : 2) / a.depth;
    // }
    // This function is used to traverse the left contour of a subtree (or
    // subforest). It returns the successor of v on this contour. This successor is
    // either given by the leftmost child of v or by the thread of v. The function
    // returns null if and only if v is on the highest level of its subtree.
    function nextLeft(v) {
        var children = v.children;
        return children ? children[0] : v.t;
    }
    // This function works analogously to nextLeft.
    function nextRight(v) {
        var children = v.children;
        return children ? children[children.length - 1] : v.t;
    }
    // Shifts the current subtree rooted at w+. This is done by increasing
    // prelim(w+) and mod(w+) by shift.
    function moveSubtree(wm, wp, shift) {
        var change = shift / (wp.i - wm.i);
        wp.c -= change;
        wp.s += shift;
        wm.c += change;
        wp.z += shift;
        wp.m += shift;
    }
    // All other shifts, applied to the smaller subtrees between w- and w+, are
    // performed by this function. To prepare the shifts, we have to adjust
    // change(w+), shift(w+), and change(w-).
    function executeShifts(v) {
        var shift = 0, change = 0, children = v.children, i = children.length, w;
        while(--i >= 0){
            w = children[i];
            w.z += shift;
            w.m += shift;
            shift += w.s + (change += w.c);
        }
    }
    // If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
    // returns the specified (default) ancestor.
    function nextAncestor(vim, v, ancestor) {
        return vim.a.parent === v.parent ? vim.a : ancestor;
    }
    function TreeNode(node, i) {
        this._ = node;
        this.parent = null;
        this.children = null;
        this.A = null; // default ancestor
        this.a = this; // ancestor
        this.z = 0; // prelim
        this.m = 0; // mod
        this.c = 0; // change
        this.s = 0; // shift
        this.t = null; // thread
        this.i = i; // number
    }
    TreeNode.prototype = Object.create(Node$1.prototype);
    function treeRoot(root) {
        var tree = new TreeNode(root, 0), node, nodes = [
            tree
        ], child, children, i, n;
        while(node = nodes.pop())if (children = node._.children) {
            node.children = new Array(n = children.length);
            for(i = n - 1; i >= 0; --i){
                nodes.push(child = node.children[i] = new TreeNode(children[i], i));
                child.parent = node;
            }
        }
        (tree.parent = new TreeNode(null, 0)).children = [
            tree
        ];
        return tree;
    }
    // Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
    function tree() {
        var separation = defaultSeparation, dx = 1, dy = 1, nodeSize = null;
        function tree(root) {
            var t = treeRoot(root);
            // Compute the layout using Buchheim et al.’s algorithm.
            t.eachAfter(firstWalk), t.parent.m = -t.z;
            t.eachBefore(secondWalk);
            // If a fixed node size is specified, scale x and y.
            if (nodeSize) root.eachBefore(sizeNode);
            else {
                var left = root, right = root, bottom = root;
                root.eachBefore(function(node) {
                    if (node.x < left.x) left = node;
                    if (node.x > right.x) right = node;
                    if (node.depth > bottom.depth) bottom = node;
                });
                var s = left === right ? 1 : separation(left, right) / 2, tx = s - left.x, kx = dx / (right.x + s + tx), ky = dy / (bottom.depth || 1);
                root.eachBefore(function(node) {
                    node.x = (node.x + tx) * kx;
                    node.y = node.depth * ky;
                });
            }
            return root;
        }
        // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
        // applied recursively to the children of v, as well as the function
        // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
        // node v is placed to the midpoint of its outermost children.
        function firstWalk(v) {
            var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
            if (children) {
                executeShifts(v);
                var midpoint = (children[0].z + children[children.length - 1].z) / 2;
                if (w) {
                    v.z = w.z + separation(v._, w._);
                    v.m = v.z - midpoint;
                } else v.z = midpoint;
            } else if (w) v.z = w.z + separation(v._, w._);
            v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
        }
        // Computes all real x-coordinates by summing up the modifiers recursively.
        function secondWalk(v) {
            v._.x = v.z + v.parent.m;
            v.m += v.parent.m;
        }
        // The core of the algorithm. Here, a new subtree is combined with the
        // previous subtrees. Threads are used to traverse the inside and outside
        // contours of the left and right subtree up to the highest common level. The
        // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
        // superscript o means outside and i means inside, the subscript - means left
        // subtree and + means right subtree. For summing up the modifiers along the
        // contour, we use respective variables si+, si-, so-, and so+. Whenever two
        // nodes of the inside contours conflict, we compute the left one of the
        // greatest uncommon ancestors using the function ANCESTOR and call MOVE
        // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
        // Finally, we add a new thread (if necessary).
        function apportion(v, w, ancestor) {
            if (w) {
                var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
                while(vim = nextRight(vim), vip = nextLeft(vip), vim && vip){
                    vom = nextLeft(vom);
                    vop = nextRight(vop);
                    vop.a = v;
                    shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
                    if (shift > 0) {
                        moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
                        sip += shift;
                        sop += shift;
                    }
                    sim += vim.m;
                    sip += vip.m;
                    som += vom.m;
                    sop += vop.m;
                }
                if (vim && !nextRight(vop)) {
                    vop.t = vim;
                    vop.m += sim - sop;
                }
                if (vip && !nextLeft(vom)) {
                    vom.t = vip;
                    vom.m += sip - som;
                    ancestor = v;
                }
            }
            return ancestor;
        }
        function sizeNode(node) {
            node.x *= dx;
            node.y = node.depth * dy;
        }
        tree.separation = function(x) {
            return arguments.length ? (separation = x, tree) : separation;
        };
        tree.size = function(x) {
            return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : nodeSize ? null : [
                dx,
                dy
            ];
        };
        tree.nodeSize = function(x) {
            return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : nodeSize ? [
                dx,
                dy
            ] : null;
        };
        return tree;
    }
    function treemapSlice(parent, x0, y0, x1, y1) {
        var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (y1 - y0) / parent.value;
        while(++i < n){
            node = nodes[i], node.x0 = x0, node.x1 = x1;
            node.y0 = y0, node.y1 = y0 += node.value * k;
        }
    }
    var phi = (1 + Math.sqrt(5)) / 2;
    function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
        var rows = [], nodes = parent.children, row, nodeValue, i0 = 0, i1 = 0, n = nodes.length, dx, dy, value = parent.value, sumValue, minValue, maxValue, newRatio, minRatio, alpha, beta;
        while(i0 < n){
            dx = x1 - x0, dy = y1 - y0;
            // Find the next non-empty node.
            do sumValue = nodes[i1++].value;
            while (!sumValue && i1 < n);
            minValue = maxValue = sumValue;
            alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
            beta = sumValue * sumValue * alpha;
            minRatio = Math.max(maxValue / beta, beta / minValue);
            // Keep adding nodes while the aspect ratio maintains or improves.
            for(; i1 < n; ++i1){
                sumValue += nodeValue = nodes[i1].value;
                if (nodeValue < minValue) minValue = nodeValue;
                if (nodeValue > maxValue) maxValue = nodeValue;
                beta = sumValue * sumValue * alpha;
                newRatio = Math.max(maxValue / beta, beta / minValue);
                if (newRatio > minRatio) {
                    sumValue -= nodeValue;
                    break;
                }
                minRatio = newRatio;
            }
            // Position and record the row orientation.
            rows.push(row = {
                value: sumValue,
                dice: dx < dy,
                children: nodes.slice(i0, i1)
            });
            if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
            else treemapSlice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
            value -= sumValue, i0 = i1;
        }
        return rows;
    }
    var squarify = function custom(ratio) {
        function squarify(parent, x0, y0, x1, y1) {
            squarifyRatio(ratio, parent, x0, y0, x1, y1);
        }
        squarify.ratio = function(x) {
            return custom((x = +x) > 1 ? x : 1);
        };
        return squarify;
    }(phi);
    function index() {
        var tile = squarify, round = false, dx = 1, dy = 1, paddingStack = [
            0
        ], paddingInner = constantZero, paddingTop = constantZero, paddingRight = constantZero, paddingBottom = constantZero, paddingLeft = constantZero;
        function treemap(root) {
            root.x0 = root.y0 = 0;
            root.x1 = dx;
            root.y1 = dy;
            root.eachBefore(positionNode);
            paddingStack = [
                0
            ];
            if (round) root.eachBefore(roundNode);
            return root;
        }
        function positionNode(node) {
            var p = paddingStack[node.depth], x0 = node.x0 + p, y0 = node.y0 + p, x1 = node.x1 - p, y1 = node.y1 - p;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            node.x0 = x0;
            node.y0 = y0;
            node.x1 = x1;
            node.y1 = y1;
            if (node.children) {
                p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
                x0 += paddingLeft(node) - p;
                y0 += paddingTop(node) - p;
                x1 -= paddingRight(node) - p;
                y1 -= paddingBottom(node) - p;
                if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
                if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
                tile(node, x0, y0, x1, y1);
            }
        }
        treemap.round = function(x) {
            return arguments.length ? (round = !!x, treemap) : round;
        };
        treemap.size = function(x) {
            return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [
                dx,
                dy
            ];
        };
        treemap.tile = function(x) {
            return arguments.length ? (tile = required(x), treemap) : tile;
        };
        treemap.padding = function(x) {
            return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
        };
        treemap.paddingInner = function(x) {
            return arguments.length ? (paddingInner = typeof x === "function" ? x : constant$2(+x), treemap) : paddingInner;
        };
        treemap.paddingOuter = function(x) {
            return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
        };
        treemap.paddingTop = function(x) {
            return arguments.length ? (paddingTop = typeof x === "function" ? x : constant$2(+x), treemap) : paddingTop;
        };
        treemap.paddingRight = function(x) {
            return arguments.length ? (paddingRight = typeof x === "function" ? x : constant$2(+x), treemap) : paddingRight;
        };
        treemap.paddingBottom = function(x) {
            return arguments.length ? (paddingBottom = typeof x === "function" ? x : constant$2(+x), treemap) : paddingBottom;
        };
        treemap.paddingLeft = function(x) {
            return arguments.length ? (paddingLeft = typeof x === "function" ? x : constant$2(+x), treemap) : paddingLeft;
        };
        return treemap;
    }
    function binary(parent, x0, y0, x1, y1) {
        var nodes = parent.children, i, n = nodes.length, sum, sums = new Array(n + 1);
        for(sums[0] = sum = i = 0; i < n; ++i)sums[i + 1] = sum += nodes[i].value;
        partition(0, n, parent.value, x0, y0, x1, y1);
        function partition(i, j, value, x0, y0, x1, y1) {
            if (i >= j - 1) {
                var node = nodes[i];
                node.x0 = x0, node.y0 = y0;
                node.x1 = x1, node.y1 = y1;
                return;
            }
            var valueOffset = sums[i], valueTarget = value / 2 + valueOffset, k = i + 1, hi = j - 1;
            while(k < hi){
                var mid = k + hi >>> 1;
                if (sums[mid] < valueTarget) k = mid + 1;
                else hi = mid;
            }
            if (valueTarget - sums[k - 1] < sums[k] - valueTarget && i + 1 < k) --k;
            var valueLeft = sums[k] - valueOffset, valueRight = value - valueLeft;
            if (x1 - x0 > y1 - y0) {
                var xk = value ? (x0 * valueRight + x1 * valueLeft) / value : x1;
                partition(i, k, valueLeft, x0, y0, xk, y1);
                partition(k, j, valueRight, xk, y0, x1, y1);
            } else {
                var yk = value ? (y0 * valueRight + y1 * valueLeft) / value : y1;
                partition(i, k, valueLeft, x0, y0, x1, yk);
                partition(k, j, valueRight, x0, yk, x1, y1);
            }
        }
    }
    function sliceDice(parent, x0, y0, x1, y1) {
        (parent.depth & 1 ? treemapSlice : treemapDice)(parent, x0, y0, x1, y1);
    }
    var resquarify = function custom(ratio) {
        function resquarify(parent, x0, y0, x1, y1) {
            if ((rows = parent._squarify) && rows.ratio === ratio) {
                var rows, row, nodes, i, j = -1, n, m = rows.length, value = parent.value;
                while(++j < m){
                    row = rows[j], nodes = row.children;
                    for(i = row.value = 0, n = nodes.length; i < n; ++i)row.value += nodes[i].value;
                    if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += (y1 - y0) * row.value / value : y1);
                    else treemapSlice(row, x0, y0, value ? x0 += (x1 - x0) * row.value / value : x1, y1);
                    value -= row.value;
                }
            } else {
                parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1);
                rows.ratio = ratio;
            }
        }
        resquarify.ratio = function(x) {
            return custom((x = +x) > 1 ? x : 1);
        };
        return resquarify;
    }(phi);
    function area$1(polygon) {
        var i = -1, n = polygon.length, a, b = polygon[n - 1], area = 0;
        while(++i < n){
            a = b;
            b = polygon[i];
            area += a[1] * b[0] - a[0] * b[1];
        }
        return area / 2;
    }
    function centroid(polygon) {
        var i = -1, n = polygon.length, x = 0, y = 0, a, b = polygon[n - 1], c, k = 0;
        while(++i < n){
            a = b;
            b = polygon[i];
            k += c = a[0] * b[1] - b[0] * a[1];
            x += (a[0] + b[0]) * c;
            y += (a[1] + b[1]) * c;
        }
        return k *= 3, [
            x / k,
            y / k
        ];
    }
    // Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
    // the 3D cross product in a quadrant I Cartesian coordinate system (+x is
    // right, +y is up). Returns a positive value if ABC is counter-clockwise,
    // negative if clockwise, and zero if the points are collinear.
    function cross$1(a, b, c) {
        return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
    }
    function lexicographicOrder(a, b) {
        return a[0] - b[0] || a[1] - b[1];
    }
    // Computes the upper convex hull per the monotone chain algorithm.
    // Assumes points.length >= 3, is sorted by x, unique in y.
    // Returns an array of indices into points in left-to-right order.
    function computeUpperHullIndexes(points) {
        const n = points.length, indexes = [
            0,
            1
        ];
        let size = 2, i;
        for(i = 2; i < n; ++i){
            while(size > 1 && cross$1(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0)--size;
            indexes[size++] = i;
        }
        return indexes.slice(0, size); // remove popped points
    }
    function hull(points) {
        if ((n = points.length) < 3) return null;
        var i, n, sortedPoints = new Array(n), flippedPoints = new Array(n);
        for(i = 0; i < n; ++i)sortedPoints[i] = [
            +points[i][0],
            +points[i][1],
            i
        ];
        sortedPoints.sort(lexicographicOrder);
        for(i = 0; i < n; ++i)flippedPoints[i] = [
            sortedPoints[i][0],
            -sortedPoints[i][1]
        ];
        var upperIndexes = computeUpperHullIndexes(sortedPoints), lowerIndexes = computeUpperHullIndexes(flippedPoints);
        // Construct the hull polygon, removing possible duplicate endpoints.
        var skipLeft = lowerIndexes[0] === upperIndexes[0], skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1], hull = [];
        // Add upper hull in right-to-l order.
        // Then add lower hull in left-to-right order.
        for(i = upperIndexes.length - 1; i >= 0; --i)hull.push(points[sortedPoints[upperIndexes[i]][2]]);
        for(i = +skipLeft; i < lowerIndexes.length - skipRight; ++i)hull.push(points[sortedPoints[lowerIndexes[i]][2]]);
        return hull;
    }
    function contains(polygon, point) {
        var n = polygon.length, p = polygon[n - 1], x = point[0], y = point[1], x0 = p[0], y0 = p[1], x1, y1, inside = false;
        for(var i = 0; i < n; ++i){
            p = polygon[i], x1 = p[0], y1 = p[1];
            if (y1 > y !== y0 > y && x < (x0 - x1) * (y - y1) / (y0 - y1) + x1) inside = !inside;
            x0 = x1, y0 = y1;
        }
        return inside;
    }
    function length(polygon) {
        var i = -1, n = polygon.length, b = polygon[n - 1], xa, ya, xb = b[0], yb = b[1], perimeter = 0;
        while(++i < n){
            xa = xb;
            ya = yb;
            b = polygon[i];
            xb = b[0];
            yb = b[1];
            xa -= xb;
            ya -= yb;
            perimeter += Math.hypot(xa, ya);
        }
        return perimeter;
    }
    var defaultSource = Math.random;
    var uniform = function sourceRandomUniform(source) {
        function randomUniform(min, max) {
            min = min == null ? 0 : +min;
            max = max == null ? 1 : +max;
            if (arguments.length === 1) max = min, min = 0;
            else max -= min;
            return function() {
                return source() * max + min;
            };
        }
        randomUniform.source = sourceRandomUniform;
        return randomUniform;
    }(defaultSource);
    var int = function sourceRandomInt(source) {
        function randomInt(min, max) {
            if (arguments.length < 2) max = min, min = 0;
            min = Math.floor(min);
            max = Math.floor(max) - min;
            return function() {
                return Math.floor(source() * max + min);
            };
        }
        randomInt.source = sourceRandomInt;
        return randomInt;
    }(defaultSource);
    var normal = function sourceRandomNormal(source) {
        function randomNormal(mu, sigma) {
            var x, r;
            mu = mu == null ? 0 : +mu;
            sigma = sigma == null ? 1 : +sigma;
            return function() {
                var y;
                // If available, use the second previously-generated uniform random.
                if (x != null) y = x, x = null;
                else do {
                    x = source() * 2 - 1;
                    y = source() * 2 - 1;
                    r = x * x + y * y;
                }while (!r || r > 1);
                return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
            };
        }
        randomNormal.source = sourceRandomNormal;
        return randomNormal;
    }(defaultSource);
    var logNormal = function sourceRandomLogNormal(source) {
        var N = normal.source(source);
        function randomLogNormal() {
            var randomNormal = N.apply(this, arguments);
            return function() {
                return Math.exp(randomNormal());
            };
        }
        randomLogNormal.source = sourceRandomLogNormal;
        return randomLogNormal;
    }(defaultSource);
    var irwinHall = function sourceRandomIrwinHall(source) {
        function randomIrwinHall(n) {
            if ((n = +n) <= 0) return ()=>0;
            return function() {
                for(var sum = 0, i = n; i > 1; --i)sum += source();
                return sum + i * source();
            };
        }
        randomIrwinHall.source = sourceRandomIrwinHall;
        return randomIrwinHall;
    }(defaultSource);
    var bates = function sourceRandomBates(source) {
        var I = irwinHall.source(source);
        function randomBates(n) {
            // use limiting distribution at n === 0
            if ((n = +n) === 0) return source;
            var randomIrwinHall = I(n);
            return function() {
                return randomIrwinHall() / n;
            };
        }
        randomBates.source = sourceRandomBates;
        return randomBates;
    }(defaultSource);
    var exponential = function sourceRandomExponential(source) {
        function randomExponential(lambda) {
            return function() {
                return -Math.log1p(-source()) / lambda;
            };
        }
        randomExponential.source = sourceRandomExponential;
        return randomExponential;
    }(defaultSource);
    var pareto = function sourceRandomPareto(source) {
        function randomPareto(alpha) {
            if ((alpha = +alpha) < 0) throw new RangeError("invalid alpha");
            alpha = 1 / -alpha;
            return function() {
                return Math.pow(1 - source(), alpha);
            };
        }
        randomPareto.source = sourceRandomPareto;
        return randomPareto;
    }(defaultSource);
    var bernoulli = function sourceRandomBernoulli(source) {
        function randomBernoulli(p) {
            if ((p = +p) < 0 || p > 1) throw new RangeError("invalid p");
            return function() {
                return Math.floor(source() + p);
            };
        }
        randomBernoulli.source = sourceRandomBernoulli;
        return randomBernoulli;
    }(defaultSource);
    var geometric = function sourceRandomGeometric(source) {
        function randomGeometric(p) {
            if ((p = +p) < 0 || p > 1) throw new RangeError("invalid p");
            if (p === 0) return ()=>Infinity;
            if (p === 1) return ()=>1;
            p = Math.log1p(-p);
            return function() {
                return 1 + Math.floor(Math.log1p(-source()) / p);
            };
        }
        randomGeometric.source = sourceRandomGeometric;
        return randomGeometric;
    }(defaultSource);
    var gamma = function sourceRandomGamma(source) {
        var randomNormal = normal.source(source)();
        function randomGamma(k, theta) {
            if ((k = +k) < 0) throw new RangeError("invalid k");
            // degenerate distribution if k === 0
            if (k === 0) return ()=>0;
            theta = theta == null ? 1 : +theta;
            // exponential distribution if k === 1
            if (k === 1) return ()=>-Math.log1p(-source()) * theta;
            var d = (k < 1 ? k + 1 : k) - 1 / 3, c = 1 / (3 * Math.sqrt(d)), multiplier = k < 1 ? ()=>Math.pow(source(), 1 / k) : ()=>1;
            return function() {
                do {
                    do var x = randomNormal(), v = 1 + c * x;
                    while (v <= 0);
                    v *= v * v;
                    var u = 1 - source();
                }while (u >= 1 - 0.0331 * x * x * x * x && Math.log(u) >= 0.5 * x * x + d * (1 - v + Math.log(v)));
                return d * v * multiplier() * theta;
            };
        }
        randomGamma.source = sourceRandomGamma;
        return randomGamma;
    }(defaultSource);
    var beta = function sourceRandomBeta(source) {
        var G = gamma.source(source);
        function randomBeta(alpha, beta) {
            var X = G(alpha), Y = G(beta);
            return function() {
                var x = X();
                return x === 0 ? 0 : x / (x + Y());
            };
        }
        randomBeta.source = sourceRandomBeta;
        return randomBeta;
    }(defaultSource);
    var binomial = function sourceRandomBinomial(source) {
        var G = geometric.source(source), B = beta.source(source);
        function randomBinomial(n, p) {
            n = +n;
            if ((p = +p) >= 1) return ()=>n;
            if (p <= 0) return ()=>0;
            return function() {
                var acc = 0, nn = n, pp = p;
                while(nn * pp > 16 && nn * (1 - pp) > 16){
                    var i = Math.floor((nn + 1) * pp), y = B(i, nn - i + 1)();
                    if (y <= pp) {
                        acc += i;
                        nn -= i;
                        pp = (pp - y) / (1 - y);
                    } else {
                        nn = i - 1;
                        pp /= y;
                    }
                }
                var sign = pp < 0.5, pFinal = sign ? pp : 1 - pp, g = G(pFinal);
                for(var s = g(), k = 0; s <= nn; ++k)s += g();
                return acc + (sign ? k : nn - k);
            };
        }
        randomBinomial.source = sourceRandomBinomial;
        return randomBinomial;
    }(defaultSource);
    var weibull = function sourceRandomWeibull(source) {
        function randomWeibull(k, a, b) {
            var outerFunc;
            if ((k = +k) === 0) outerFunc = (x)=>-Math.log(x);
            else {
                k = 1 / k;
                outerFunc = (x)=>Math.pow(x, k);
            }
            a = a == null ? 0 : +a;
            b = b == null ? 1 : +b;
            return function() {
                return a + b * outerFunc(-Math.log1p(-source()));
            };
        }
        randomWeibull.source = sourceRandomWeibull;
        return randomWeibull;
    }(defaultSource);
    var cauchy = function sourceRandomCauchy(source) {
        function randomCauchy(a, b) {
            a = a == null ? 0 : +a;
            b = b == null ? 1 : +b;
            return function() {
                return a + b * Math.tan(Math.PI * source());
            };
        }
        randomCauchy.source = sourceRandomCauchy;
        return randomCauchy;
    }(defaultSource);
    var logistic = function sourceRandomLogistic(source) {
        function randomLogistic(a, b) {
            a = a == null ? 0 : +a;
            b = b == null ? 1 : +b;
            return function() {
                var u = source();
                return a + b * Math.log(u / (1 - u));
            };
        }
        randomLogistic.source = sourceRandomLogistic;
        return randomLogistic;
    }(defaultSource);
    var poisson = function sourceRandomPoisson(source) {
        var G = gamma.source(source), B = binomial.source(source);
        function randomPoisson(lambda) {
            return function() {
                var acc = 0, l = lambda;
                while(l > 16){
                    var n = Math.floor(0.875 * l), t = G(n)();
                    if (t > l) return acc + B(n - 1, l / t)();
                    acc += n;
                    l -= t;
                }
                for(var s = -Math.log1p(-source()), k = 0; s <= l; ++k)s -= Math.log1p(-source());
                return acc + k;
            };
        }
        randomPoisson.source = sourceRandomPoisson;
        return randomPoisson;
    }(defaultSource);
    // https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
    const mul = 0x19660D;
    const inc = 0x3C6EF35F;
    const eps = 1 / 0x100000000;
    function lcg(seed = Math.random()) {
        let state = (0 <= seed && seed < 1 ? seed / eps : Math.abs(seed)) | 0;
        return ()=>(state = mul * state + inc | 0, eps * (state >>> 0));
    }
    function initRange(domain, range) {
        switch(arguments.length){
            case 0:
                break;
            case 1:
                this.range(domain);
                break;
            default:
                this.range(range).domain(domain);
                break;
        }
        return this;
    }
    function initInterpolator(domain, interpolator) {
        switch(arguments.length){
            case 0:
                break;
            case 1:
                if (typeof domain === "function") this.interpolator(domain);
                else this.range(domain);
                break;
            default:
                this.domain(domain);
                if (typeof interpolator === "function") this.interpolator(interpolator);
                else this.range(interpolator);
                break;
        }
        return this;
    }
    const implicit = Symbol("implicit");
    function ordinal() {
        var index = new InternMap(), domain = [], range = [], unknown = implicit;
        function scale(d) {
            let i = index.get(d);
            if (i === undefined) {
                if (unknown !== implicit) return unknown;
                index.set(d, i = domain.push(d) - 1);
            }
            return range[i % range.length];
        }
        scale.domain = function(_) {
            if (!arguments.length) return domain.slice();
            domain = [], index = new InternMap();
            for (const value of _){
                if (index.has(value)) continue;
                index.set(value, domain.push(value) - 1);
            }
            return scale;
        };
        scale.range = function(_) {
            return arguments.length ? (range = Array.from(_), scale) : range.slice();
        };
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : unknown;
        };
        scale.copy = function() {
            return ordinal(domain, range).unknown(unknown);
        };
        initRange.apply(scale, arguments);
        return scale;
    }
    function band() {
        var scale = ordinal().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
        delete scale.unknown;
        function rescale() {
            var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
            step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
            if (round) step = Math.floor(step);
            start += (stop - start - step * (n - paddingInner)) * align;
            bandwidth = step * (1 - paddingInner);
            if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
            var values = range$2(n).map(function(i) {
                return start + step * i;
            });
            return ordinalRange(reverse ? values.reverse() : values);
        }
        scale.domain = function(_) {
            return arguments.length ? (domain(_), rescale()) : domain();
        };
        scale.range = function(_) {
            return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
                r0,
                r1
            ];
        };
        scale.rangeRound = function(_) {
            return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
        };
        scale.bandwidth = function() {
            return bandwidth;
        };
        scale.step = function() {
            return step;
        };
        scale.round = function(_) {
            return arguments.length ? (round = !!_, rescale()) : round;
        };
        scale.padding = function(_) {
            return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
        };
        scale.paddingInner = function(_) {
            return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
        };
        scale.paddingOuter = function(_) {
            return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
        };
        scale.align = function(_) {
            return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
        };
        scale.copy = function() {
            return band(domain(), [
                r0,
                r1
            ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
        };
        return initRange.apply(rescale(), arguments);
    }
    function pointish(scale) {
        var copy = scale.copy;
        scale.padding = scale.paddingOuter;
        delete scale.paddingInner;
        delete scale.paddingOuter;
        scale.copy = function() {
            return pointish(copy());
        };
        return scale;
    }
    function point$4() {
        return pointish(band.apply(null, arguments).paddingInner(1));
    }
    function constants(x) {
        return function() {
            return x;
        };
    }
    function number$1(x) {
        return +x;
    }
    var unit = [
        0,
        1
    ];
    function identity$3(x) {
        return x;
    }
    function normalize(a, b) {
        return (b -= a = +a) ? function(x) {
            return (x - a) / b;
        } : constants(isNaN(b) ? NaN : 0.5);
    }
    function clamper(a, b) {
        var t;
        if (a > b) t = a, a = b, b = t;
        return function(x) {
            return Math.max(a, Math.min(b, x));
        };
    }
    // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
    // interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
    function bimap(domain, range, interpolate) {
        var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
        if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
        else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
        return function(x) {
            return r0(d0(x));
        };
    }
    function polymap(domain, range, interpolate) {
        var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
        // Reverse descending domains.
        if (domain[j] < domain[0]) {
            domain = domain.slice().reverse();
            range = range.slice().reverse();
        }
        while(++i < j){
            d[i] = normalize(domain[i], domain[i + 1]);
            r[i] = interpolate(range[i], range[i + 1]);
        }
        return function(x) {
            var i = bisect(domain, x, 1, j) - 1;
            return r[i](d[i](x));
        };
    }
    function copy$1(source, target) {
        return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
    }
    function transformer$2() {
        var domain = unit, range = unit, interpolate = interpolate$2, transform, untransform, unknown, clamp = identity$3, piecewise, output, input;
        function rescale() {
            var n = Math.min(domain.length, range.length);
            if (clamp !== identity$3) clamp = clamper(domain[0], domain[n - 1]);
            piecewise = n > 2 ? polymap : bimap;
            output = input = null;
            return scale;
        }
        function scale(x) {
            return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
        }
        scale.invert = function(y) {
            return clamp(untransform((input || (input = piecewise(range, domain.map(transform), interpolateNumber)))(y)));
        };
        scale.domain = function(_) {
            return arguments.length ? (domain = Array.from(_, number$1), rescale()) : domain.slice();
        };
        scale.range = function(_) {
            return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
        };
        scale.rangeRound = function(_) {
            return range = Array.from(_), interpolate = interpolateRound, rescale();
        };
        scale.clamp = function(_) {
            return arguments.length ? (clamp = _ ? true : identity$3, rescale()) : clamp !== identity$3;
        };
        scale.interpolate = function(_) {
            return arguments.length ? (interpolate = _, rescale()) : interpolate;
        };
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : unknown;
        };
        return function(t, u) {
            transform = t, untransform = u;
            return rescale();
        };
    }
    function continuous() {
        return transformer$2()(identity$3, identity$3);
    }
    function tickFormat(start, stop, count, specifier) {
        var step = tickStep(start, stop, count), precision;
        specifier = formatSpecifier(specifier == null ? ",f" : specifier);
        switch(specifier.type){
            case "s":
                var value = Math.max(Math.abs(start), Math.abs(stop));
                if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
                return exports1.formatPrefix(specifier, value);
            case "":
            case "e":
            case "g":
            case "p":
            case "r":
                if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
                break;
            case "f":
            case "%":
                if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
                break;
        }
        return exports1.format(specifier);
    }
    function linearish(scale) {
        var domain = scale.domain;
        scale.ticks = function(count) {
            var d = domain();
            return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
        };
        scale.tickFormat = function(count, specifier) {
            var d = domain();
            return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
        };
        scale.nice = function(count) {
            if (count == null) count = 10;
            var d = domain();
            var i0 = 0;
            var i1 = d.length - 1;
            var start = d[i0];
            var stop = d[i1];
            var prestep;
            var step;
            var maxIter = 10;
            if (stop < start) {
                step = start, start = stop, stop = step;
                step = i0, i0 = i1, i1 = step;
            }
            while(maxIter-- > 0){
                step = tickIncrement(start, stop, count);
                if (step === prestep) {
                    d[i0] = start;
                    d[i1] = stop;
                    return domain(d);
                } else if (step > 0) {
                    start = Math.floor(start / step) * step;
                    stop = Math.ceil(stop / step) * step;
                } else if (step < 0) {
                    start = Math.ceil(start * step) / step;
                    stop = Math.floor(stop * step) / step;
                } else break;
                prestep = step;
            }
            return scale;
        };
        return scale;
    }
    function linear() {
        var scale = continuous();
        scale.copy = function() {
            return copy$1(scale, linear());
        };
        initRange.apply(scale, arguments);
        return linearish(scale);
    }
    function identity$2(domain) {
        var unknown;
        function scale(x) {
            return x == null || isNaN(x = +x) ? unknown : x;
        }
        scale.invert = scale;
        scale.domain = scale.range = function(_) {
            return arguments.length ? (domain = Array.from(_, number$1), scale) : domain.slice();
        };
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : unknown;
        };
        scale.copy = function() {
            return identity$2(domain).unknown(unknown);
        };
        domain = arguments.length ? Array.from(domain, number$1) : [
            0,
            1
        ];
        return linearish(scale);
    }
    function nice(domain, interval) {
        domain = domain.slice();
        var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
        if (x1 < x0) {
            t = i0, i0 = i1, i1 = t;
            t = x0, x0 = x1, x1 = t;
        }
        domain[i0] = interval.floor(x0);
        domain[i1] = interval.ceil(x1);
        return domain;
    }
    function transformLog(x) {
        return Math.log(x);
    }
    function transformExp(x) {
        return Math.exp(x);
    }
    function transformLogn(x) {
        return -Math.log(-x);
    }
    function transformExpn(x) {
        return -Math.exp(-x);
    }
    function pow10(x) {
        return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
    }
    function powp(base) {
        return base === 10 ? pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
    }
    function logp(base) {
        return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
    }
    function reflect(f) {
        return (x, k)=>-f(-x, k);
    }
    function loggish(transform) {
        const scale = transform(transformLog, transformExp);
        const domain = scale.domain;
        let base = 10;
        let logs;
        let pows;
        function rescale() {
            logs = logp(base), pows = powp(base);
            if (domain()[0] < 0) {
                logs = reflect(logs), pows = reflect(pows);
                transform(transformLogn, transformExpn);
            } else transform(transformLog, transformExp);
            return scale;
        }
        scale.base = function(_) {
            return arguments.length ? (base = +_, rescale()) : base;
        };
        scale.domain = function(_) {
            return arguments.length ? (domain(_), rescale()) : domain();
        };
        scale.ticks = (count)=>{
            const d = domain();
            let u = d[0];
            let v = d[d.length - 1];
            const r = v < u;
            if (r) [u, v] = [
                v,
                u
            ];
            let i = logs(u);
            let j = logs(v);
            let k;
            let t;
            const n = count == null ? 10 : +count;
            let z = [];
            if (!(base % 1) && j - i < n) {
                i = Math.floor(i), j = Math.ceil(j);
                if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                    t = i < 0 ? k / pows(-i) : k * pows(i);
                    if (t < u) continue;
                    if (t > v) break;
                    z.push(t);
                }
                else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                    t = i > 0 ? k / pows(-i) : k * pows(i);
                    if (t < u) continue;
                    if (t > v) break;
                    z.push(t);
                }
                if (z.length * 2 < n) z = ticks(u, v, n);
            } else z = ticks(i, j, Math.min(j - i, n)).map(pows);
            return r ? z.reverse() : z;
        };
        scale.tickFormat = (count, specifier)=>{
            if (count == null) count = 10;
            if (specifier == null) specifier = base === 10 ? "s" : ",";
            if (typeof specifier !== "function") {
                if (!(base % 1) && (specifier = formatSpecifier(specifier)).precision == null) specifier.trim = true;
                specifier = exports1.format(specifier);
            }
            if (count === Infinity) return specifier;
            const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
            return (d)=>{
                let i = d / pows(Math.round(logs(d)));
                if (i * base < base - 0.5) i *= base;
                return i <= k ? specifier(d) : "";
            };
        };
        scale.nice = ()=>{
            return domain(nice(domain(), {
                floor: (x)=>pows(Math.floor(logs(x))),
                ceil: (x)=>pows(Math.ceil(logs(x)))
            }));
        };
        return scale;
    }
    function log() {
        const scale = loggish(transformer$2()).domain([
            1,
            10
        ]);
        scale.copy = ()=>copy$1(scale, log()).base(scale.base());
        initRange.apply(scale, arguments);
        return scale;
    }
    function transformSymlog(c) {
        return function(x) {
            return Math.sign(x) * Math.log1p(Math.abs(x / c));
        };
    }
    function transformSymexp(c) {
        return function(x) {
            return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
        };
    }
    function symlogish(transform) {
        var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));
        scale.constant = function(_) {
            return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
        };
        return linearish(scale);
    }
    function symlog() {
        var scale = symlogish(transformer$2());
        scale.copy = function() {
            return copy$1(scale, symlog()).constant(scale.constant());
        };
        return initRange.apply(scale, arguments);
    }
    function transformPow(exponent) {
        return function(x) {
            return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
        };
    }
    function transformSqrt(x) {
        return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
    }
    function transformSquare(x) {
        return x < 0 ? -x * x : x * x;
    }
    function powish(transform) {
        var scale = transform(identity$3, identity$3), exponent = 1;
        function rescale() {
            return exponent === 1 ? transform(identity$3, identity$3) : exponent === 0.5 ? transform(transformSqrt, transformSquare) : transform(transformPow(exponent), transformPow(1 / exponent));
        }
        scale.exponent = function(_) {
            return arguments.length ? (exponent = +_, rescale()) : exponent;
        };
        return linearish(scale);
    }
    function pow() {
        var scale = powish(transformer$2());
        scale.copy = function() {
            return copy$1(scale, pow()).exponent(scale.exponent());
        };
        initRange.apply(scale, arguments);
        return scale;
    }
    function sqrt$1() {
        return pow.apply(null, arguments).exponent(0.5);
    }
    function square$1(x) {
        return Math.sign(x) * x * x;
    }
    function unsquare(x) {
        return Math.sign(x) * Math.sqrt(Math.abs(x));
    }
    function radial() {
        var squared = continuous(), range = [
            0,
            1
        ], round = false, unknown;
        function scale(x) {
            var y = unsquare(squared(x));
            return isNaN(y) ? unknown : round ? Math.round(y) : y;
        }
        scale.invert = function(y) {
            return squared.invert(square$1(y));
        };
        scale.domain = function(_) {
            return arguments.length ? (squared.domain(_), scale) : squared.domain();
        };
        scale.range = function(_) {
            return arguments.length ? (squared.range((range = Array.from(_, number$1)).map(square$1)), scale) : range.slice();
        };
        scale.rangeRound = function(_) {
            return scale.range(_).round(true);
        };
        scale.round = function(_) {
            return arguments.length ? (round = !!_, scale) : round;
        };
        scale.clamp = function(_) {
            return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
        };
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : unknown;
        };
        scale.copy = function() {
            return radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
        };
        initRange.apply(scale, arguments);
        return linearish(scale);
    }
    function quantile() {
        var domain = [], range = [], thresholds = [], unknown;
        function rescale() {
            var i = 0, n = Math.max(1, range.length);
            thresholds = new Array(n - 1);
            while(++i < n)thresholds[i - 1] = quantileSorted(domain, i / n);
            return scale;
        }
        function scale(x) {
            return x == null || isNaN(x = +x) ? unknown : range[bisect(thresholds, x)];
        }
        scale.invertExtent = function(y) {
            var i = range.indexOf(y);
            return i < 0 ? [
                NaN,
                NaN
            ] : [
                i > 0 ? thresholds[i - 1] : domain[0],
                i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
            ];
        };
        scale.domain = function(_) {
            if (!arguments.length) return domain.slice();
            domain = [];
            for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
            domain.sort(ascending$3);
            return rescale();
        };
        scale.range = function(_) {
            return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
        };
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : unknown;
        };
        scale.quantiles = function() {
            return thresholds.slice();
        };
        scale.copy = function() {
            return quantile().domain(domain).range(range).unknown(unknown);
        };
        return initRange.apply(scale, arguments);
    }
    function quantize() {
        var x0 = 0, x1 = 1, n = 1, domain = [
            0.5
        ], range = [
            0,
            1
        ], unknown;
        function scale(x) {
            return x != null && x <= x ? range[bisect(domain, x, 0, n)] : unknown;
        }
        function rescale() {
            var i = -1;
            domain = new Array(n);
            while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
            return scale;
        }
        scale.domain = function(_) {
            return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
                x0,
                x1
            ];
        };
        scale.range = function(_) {
            return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
        };
        scale.invertExtent = function(y) {
            var i = range.indexOf(y);
            return i < 0 ? [
                NaN,
                NaN
            ] : i < 1 ? [
                x0,
                domain[0]
            ] : i >= n ? [
                domain[n - 1],
                x1
            ] : [
                domain[i - 1],
                domain[i]
            ];
        };
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : scale;
        };
        scale.thresholds = function() {
            return domain.slice();
        };
        scale.copy = function() {
            return quantize().domain([
                x0,
                x1
            ]).range(range).unknown(unknown);
        };
        return initRange.apply(linearish(scale), arguments);
    }
    function threshold() {
        var domain = [
            0.5
        ], range = [
            0,
            1
        ], unknown, n = 1;
        function scale(x) {
            return x != null && x <= x ? range[bisect(domain, x, 0, n)] : unknown;
        }
        scale.domain = function(_) {
            return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
        };
        scale.range = function(_) {
            return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
        };
        scale.invertExtent = function(y) {
            var i = range.indexOf(y);
            return [
                domain[i - 1],
                domain[i]
            ];
        };
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : unknown;
        };
        scale.copy = function() {
            return threshold().domain(domain).range(range).unknown(unknown);
        };
        return initRange.apply(scale, arguments);
    }
    const t0 = new Date, t1 = new Date;
    function timeInterval(floori, offseti, count, field) {
        function interval(date) {
            return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
        }
        interval.floor = (date)=>{
            return floori(date = new Date(+date)), date;
        };
        interval.ceil = (date)=>{
            return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
        };
        interval.round = (date)=>{
            const d0 = interval(date), d1 = interval.ceil(date);
            return date - d0 < d1 - date ? d0 : d1;
        };
        interval.offset = (date, step)=>{
            return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
        };
        interval.range = (start, stop, step)=>{
            const range = [];
            start = interval.ceil(start);
            step = step == null ? 1 : Math.floor(step);
            if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
            let previous;
            do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
            while (previous < start && start < stop);
            return range;
        };
        interval.filter = (test)=>{
            return timeInterval((date)=>{
                if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
            }, (date, step)=>{
                if (date >= date) {
                    if (step < 0) while(++step <= 0){
                        while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                    }
                    else while(--step >= 0){
                        while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                    }
                }
            });
        };
        if (count) {
            interval.count = (start, end)=>{
                t0.setTime(+start), t1.setTime(+end);
                floori(t0), floori(t1);
                return Math.floor(count(t0, t1));
            };
            interval.every = (step)=>{
                step = Math.floor(step);
                return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d)=>field(d) % step === 0 : (d)=>interval.count(0, d) % step === 0);
            };
        }
        return interval;
    }
    const millisecond = timeInterval(()=>{
    // noop
    }, (date, step)=>{
        date.setTime(+date + step);
    }, (start, end)=>{
        return end - start;
    });
    // An optimized implementation for this simple case.
    millisecond.every = (k)=>{
        k = Math.floor(k);
        if (!isFinite(k) || !(k > 0)) return null;
        if (!(k > 1)) return millisecond;
        return timeInterval((date)=>{
            date.setTime(Math.floor(date / k) * k);
        }, (date, step)=>{
            date.setTime(+date + step * k);
        }, (start, end)=>{
            return (end - start) / k;
        });
    };
    const milliseconds = millisecond.range;
    const durationSecond = 1000;
    const durationMinute = durationSecond * 60;
    const durationHour = durationMinute * 60;
    const durationDay = durationHour * 24;
    const durationWeek = durationDay * 7;
    const durationMonth = durationDay * 30;
    const durationYear = durationDay * 365;
    const second = timeInterval((date)=>{
        date.setTime(date - date.getMilliseconds());
    }, (date, step)=>{
        date.setTime(+date + step * durationSecond);
    }, (start, end)=>{
        return (end - start) / durationSecond;
    }, (date)=>{
        return date.getUTCSeconds();
    });
    const seconds = second.range;
    const timeMinute = timeInterval((date)=>{
        date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond);
    }, (date, step)=>{
        date.setTime(+date + step * durationMinute);
    }, (start, end)=>{
        return (end - start) / durationMinute;
    }, (date)=>{
        return date.getMinutes();
    });
    const timeMinutes = timeMinute.range;
    const utcMinute = timeInterval((date)=>{
        date.setUTCSeconds(0, 0);
    }, (date, step)=>{
        date.setTime(+date + step * durationMinute);
    }, (start, end)=>{
        return (end - start) / durationMinute;
    }, (date)=>{
        return date.getUTCMinutes();
    });
    const utcMinutes = utcMinute.range;
    const timeHour = timeInterval((date)=>{
        date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond - date.getMinutes() * durationMinute);
    }, (date, step)=>{
        date.setTime(+date + step * durationHour);
    }, (start, end)=>{
        return (end - start) / durationHour;
    }, (date)=>{
        return date.getHours();
    });
    const timeHours = timeHour.range;
    const utcHour = timeInterval((date)=>{
        date.setUTCMinutes(0, 0, 0);
    }, (date, step)=>{
        date.setTime(+date + step * durationHour);
    }, (start, end)=>{
        return (end - start) / durationHour;
    }, (date)=>{
        return date.getUTCHours();
    });
    const utcHours = utcHour.range;
    const timeDay = timeInterval((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay, (date)=>date.getDate() - 1);
    const timeDays = timeDay.range;
    const utcDay = timeInterval((date)=>{
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step);
    }, (start, end)=>{
        return (end - start) / durationDay;
    }, (date)=>{
        return date.getUTCDate() - 1;
    });
    const utcDays = utcDay.range;
    const unixDay = timeInterval((date)=>{
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step);
    }, (start, end)=>{
        return (end - start) / durationDay;
    }, (date)=>{
        return Math.floor(date / durationDay);
    });
    const unixDays = unixDay.range;
    function timeWeekday(i) {
        return timeInterval((date)=>{
            date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
            date.setHours(0, 0, 0, 0);
        }, (date, step)=>{
            date.setDate(date.getDate() + step * 7);
        }, (start, end)=>{
            return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
        });
    }
    const timeSunday = timeWeekday(0);
    const timeMonday = timeWeekday(1);
    const timeTuesday = timeWeekday(2);
    const timeWednesday = timeWeekday(3);
    const timeThursday = timeWeekday(4);
    const timeFriday = timeWeekday(5);
    const timeSaturday = timeWeekday(6);
    const timeSundays = timeSunday.range;
    const timeMondays = timeMonday.range;
    const timeTuesdays = timeTuesday.range;
    const timeWednesdays = timeWednesday.range;
    const timeThursdays = timeThursday.range;
    const timeFridays = timeFriday.range;
    const timeSaturdays = timeSaturday.range;
    function utcWeekday(i) {
        return timeInterval((date)=>{
            date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
            date.setUTCHours(0, 0, 0, 0);
        }, (date, step)=>{
            date.setUTCDate(date.getUTCDate() + step * 7);
        }, (start, end)=>{
            return (end - start) / durationWeek;
        });
    }
    const utcSunday = utcWeekday(0);
    const utcMonday = utcWeekday(1);
    const utcTuesday = utcWeekday(2);
    const utcWednesday = utcWeekday(3);
    const utcThursday = utcWeekday(4);
    const utcFriday = utcWeekday(5);
    const utcSaturday = utcWeekday(6);
    const utcSundays = utcSunday.range;
    const utcMondays = utcMonday.range;
    const utcTuesdays = utcTuesday.range;
    const utcWednesdays = utcWednesday.range;
    const utcThursdays = utcThursday.range;
    const utcFridays = utcFriday.range;
    const utcSaturdays = utcSaturday.range;
    const timeMonth = timeInterval((date)=>{
        date.setDate(1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setMonth(date.getMonth() + step);
    }, (start, end)=>{
        return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
    }, (date)=>{
        return date.getMonth();
    });
    const timeMonths = timeMonth.range;
    const utcMonth = timeInterval((date)=>{
        date.setUTCDate(1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCMonth(date.getUTCMonth() + step);
    }, (start, end)=>{
        return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
    }, (date)=>{
        return date.getUTCMonth();
    });
    const utcMonths = utcMonth.range;
    const timeYear = timeInterval((date)=>{
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setFullYear(date.getFullYear() + step);
    }, (start, end)=>{
        return end.getFullYear() - start.getFullYear();
    }, (date)=>{
        return date.getFullYear();
    });
    // An optimized implementation for this simple case.
    timeYear.every = (k)=>{
        return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : timeInterval((date)=>{
            date.setFullYear(Math.floor(date.getFullYear() / k) * k);
            date.setMonth(0, 1);
            date.setHours(0, 0, 0, 0);
        }, (date, step)=>{
            date.setFullYear(date.getFullYear() + step * k);
        });
    };
    const timeYears = timeYear.range;
    const utcYear = timeInterval((date)=>{
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCFullYear(date.getUTCFullYear() + step);
    }, (start, end)=>{
        return end.getUTCFullYear() - start.getUTCFullYear();
    }, (date)=>{
        return date.getUTCFullYear();
    });
    // An optimized implementation for this simple case.
    utcYear.every = (k)=>{
        return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : timeInterval((date)=>{
            date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
            date.setUTCMonth(0, 1);
            date.setUTCHours(0, 0, 0, 0);
        }, (date, step)=>{
            date.setUTCFullYear(date.getUTCFullYear() + step * k);
        });
    };
    const utcYears = utcYear.range;
    function ticker(year, month, week, day, hour, minute) {
        const tickIntervals = [
            [
                second,
                1,
                durationSecond
            ],
            [
                second,
                5,
                5 * durationSecond
            ],
            [
                second,
                15,
                15 * durationSecond
            ],
            [
                second,
                30,
                30 * durationSecond
            ],
            [
                minute,
                1,
                durationMinute
            ],
            [
                minute,
                5,
                5 * durationMinute
            ],
            [
                minute,
                15,
                15 * durationMinute
            ],
            [
                minute,
                30,
                30 * durationMinute
            ],
            [
                hour,
                1,
                durationHour
            ],
            [
                hour,
                3,
                3 * durationHour
            ],
            [
                hour,
                6,
                6 * durationHour
            ],
            [
                hour,
                12,
                12 * durationHour
            ],
            [
                day,
                1,
                durationDay
            ],
            [
                day,
                2,
                2 * durationDay
            ],
            [
                week,
                1,
                durationWeek
            ],
            [
                month,
                1,
                durationMonth
            ],
            [
                month,
                3,
                3 * durationMonth
            ],
            [
                year,
                1,
                durationYear
            ]
        ];
        function ticks(start, stop, count) {
            const reverse = stop < start;
            if (reverse) [start, stop] = [
                stop,
                start
            ];
            const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
            const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
            return reverse ? ticks.reverse() : ticks;
        }
        function tickInterval(start, stop, count) {
            const target = Math.abs(stop - start) / count;
            const i = bisector(([, , step])=>step).right(tickIntervals, target);
            if (i === tickIntervals.length) return year.every(tickStep(start / durationYear, stop / durationYear, count));
            if (i === 0) return millisecond.every(Math.max(tickStep(start, stop, count), 1));
            const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
            return t.every(step);
        }
        return [
            ticks,
            tickInterval
        ];
    }
    const [utcTicks, utcTickInterval] = ticker(utcYear, utcMonth, utcSunday, unixDay, utcHour, utcMinute);
    const [timeTicks, timeTickInterval] = ticker(timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute);
    function localDate(d) {
        if (0 <= d.y && d.y < 100) {
            var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
            date.setFullYear(d.y);
            return date;
        }
        return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
    }
    function utcDate(d) {
        if (0 <= d.y && d.y < 100) {
            var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
            date.setUTCFullYear(d.y);
            return date;
        }
        return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
    }
    function newDate(y, m, d) {
        return {
            y: y,
            m: m,
            d: d,
            H: 0,
            M: 0,
            S: 0,
            L: 0
        };
    }
    function formatLocale(locale) {
        var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
        var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
        var formats = {
            "a": formatShortWeekday,
            "A": formatWeekday,
            "b": formatShortMonth,
            "B": formatMonth,
            "c": null,
            "d": formatDayOfMonth,
            "e": formatDayOfMonth,
            "f": formatMicroseconds,
            "g": formatYearISO,
            "G": formatFullYearISO,
            "H": formatHour24,
            "I": formatHour12,
            "j": formatDayOfYear,
            "L": formatMilliseconds,
            "m": formatMonthNumber,
            "M": formatMinutes,
            "p": formatPeriod,
            "q": formatQuarter,
            "Q": formatUnixTimestamp,
            "s": formatUnixTimestampSeconds,
            "S": formatSeconds,
            "u": formatWeekdayNumberMonday,
            "U": formatWeekNumberSunday,
            "V": formatWeekNumberISO,
            "w": formatWeekdayNumberSunday,
            "W": formatWeekNumberMonday,
            "x": null,
            "X": null,
            "y": formatYear,
            "Y": formatFullYear,
            "Z": formatZone,
            "%": formatLiteralPercent
        };
        var utcFormats = {
            "a": formatUTCShortWeekday,
            "A": formatUTCWeekday,
            "b": formatUTCShortMonth,
            "B": formatUTCMonth,
            "c": null,
            "d": formatUTCDayOfMonth,
            "e": formatUTCDayOfMonth,
            "f": formatUTCMicroseconds,
            "g": formatUTCYearISO,
            "G": formatUTCFullYearISO,
            "H": formatUTCHour24,
            "I": formatUTCHour12,
            "j": formatUTCDayOfYear,
            "L": formatUTCMilliseconds,
            "m": formatUTCMonthNumber,
            "M": formatUTCMinutes,
            "p": formatUTCPeriod,
            "q": formatUTCQuarter,
            "Q": formatUnixTimestamp,
            "s": formatUnixTimestampSeconds,
            "S": formatUTCSeconds,
            "u": formatUTCWeekdayNumberMonday,
            "U": formatUTCWeekNumberSunday,
            "V": formatUTCWeekNumberISO,
            "w": formatUTCWeekdayNumberSunday,
            "W": formatUTCWeekNumberMonday,
            "x": null,
            "X": null,
            "y": formatUTCYear,
            "Y": formatUTCFullYear,
            "Z": formatUTCZone,
            "%": formatLiteralPercent
        };
        var parses = {
            "a": parseShortWeekday,
            "A": parseWeekday,
            "b": parseShortMonth,
            "B": parseMonth,
            "c": parseLocaleDateTime,
            "d": parseDayOfMonth,
            "e": parseDayOfMonth,
            "f": parseMicroseconds,
            "g": parseYear,
            "G": parseFullYear,
            "H": parseHour24,
            "I": parseHour24,
            "j": parseDayOfYear,
            "L": parseMilliseconds,
            "m": parseMonthNumber,
            "M": parseMinutes,
            "p": parsePeriod,
            "q": parseQuarter,
            "Q": parseUnixTimestamp,
            "s": parseUnixTimestampSeconds,
            "S": parseSeconds,
            "u": parseWeekdayNumberMonday,
            "U": parseWeekNumberSunday,
            "V": parseWeekNumberISO,
            "w": parseWeekdayNumberSunday,
            "W": parseWeekNumberMonday,
            "x": parseLocaleDate,
            "X": parseLocaleTime,
            "y": parseYear,
            "Y": parseFullYear,
            "Z": parseZone,
            "%": parseLiteralPercent
        };
        // These recursive directive definitions must be deferred.
        formats.x = newFormat(locale_date, formats);
        formats.X = newFormat(locale_time, formats);
        formats.c = newFormat(locale_dateTime, formats);
        utcFormats.x = newFormat(locale_date, utcFormats);
        utcFormats.X = newFormat(locale_time, utcFormats);
        utcFormats.c = newFormat(locale_dateTime, utcFormats);
        function newFormat(specifier, formats) {
            return function(date) {
                var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
                if (!(date instanceof Date)) date = new Date(+date);
                while(++i < n)if (specifier.charCodeAt(i) === 37) {
                    string.push(specifier.slice(j, i));
                    if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                    else pad = c === "e" ? " " : "0";
                    if (format = formats[c]) c = format(date, pad);
                    string.push(c);
                    j = i + 1;
                }
                string.push(specifier.slice(j, i));
                return string.join("");
            };
        }
        function newParse(specifier, Z) {
            return function(string) {
                var d = newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
                if (i != string.length) return null;
                // If a UNIX timestamp is specified, return it.
                if ("Q" in d) return new Date(d.Q);
                if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
                // If this is utcParse, never use the local timezone.
                if (Z && !("Z" in d)) d.Z = 0;
                // The am-pm flag is 0 for AM, and 1 for PM.
                if ("p" in d) d.H = d.H % 12 + d.p * 12;
                // If the month was not specified, inherit from the quarter.
                if (d.m === undefined) d.m = "q" in d ? d.q : 0;
                // Convert day-of-week and week-of-year to day-of-year.
                if ("V" in d) {
                    if (d.V < 1 || d.V > 53) return null;
                    if (!("w" in d)) d.w = 1;
                    if ("Z" in d) {
                        week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
                        week = day > 4 || day === 0 ? utcMonday.ceil(week) : utcMonday(week);
                        week = utcDay.offset(week, (d.V - 1) * 7);
                        d.y = week.getUTCFullYear();
                        d.m = week.getUTCMonth();
                        d.d = week.getUTCDate() + (d.w + 6) % 7;
                    } else {
                        week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
                        week = day > 4 || day === 0 ? timeMonday.ceil(week) : timeMonday(week);
                        week = timeDay.offset(week, (d.V - 1) * 7);
                        d.y = week.getFullYear();
                        d.m = week.getMonth();
                        d.d = week.getDate() + (d.w + 6) % 7;
                    }
                } else if ("W" in d || "U" in d) {
                    if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                    day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
                    d.m = 0;
                    d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
                }
                // If a time zone is specified, all fields are interpreted as UTC and then
                // offset according to the specified time zone.
                if ("Z" in d) {
                    d.H += d.Z / 100 | 0;
                    d.M += d.Z % 100;
                    return utcDate(d);
                }
                // Otherwise, all fields are in local time.
                return localDate(d);
            };
        }
        function parseSpecifier(d, specifier, string, j) {
            var i = 0, n = specifier.length, m = string.length, c, parse;
            while(i < n){
                if (j >= m) return -1;
                c = specifier.charCodeAt(i++);
                if (c === 37) {
                    c = specifier.charAt(i++);
                    parse = parses[c in pads ? specifier.charAt(i++) : c];
                    if (!parse || (j = parse(d, string, j)) < 0) return -1;
                } else if (c != string.charCodeAt(j++)) return -1;
            }
            return j;
        }
        function parsePeriod(d, string, i) {
            var n = periodRe.exec(string.slice(i));
            return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
        }
        function parseShortWeekday(d, string, i) {
            var n = shortWeekdayRe.exec(string.slice(i));
            return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
        }
        function parseWeekday(d, string, i) {
            var n = weekdayRe.exec(string.slice(i));
            return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
        }
        function parseShortMonth(d, string, i) {
            var n = shortMonthRe.exec(string.slice(i));
            return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
        }
        function parseMonth(d, string, i) {
            var n = monthRe.exec(string.slice(i));
            return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
        }
        function parseLocaleDateTime(d, string, i) {
            return parseSpecifier(d, locale_dateTime, string, i);
        }
        function parseLocaleDate(d, string, i) {
            return parseSpecifier(d, locale_date, string, i);
        }
        function parseLocaleTime(d, string, i) {
            return parseSpecifier(d, locale_time, string, i);
        }
        function formatShortWeekday(d) {
            return locale_shortWeekdays[d.getDay()];
        }
        function formatWeekday(d) {
            return locale_weekdays[d.getDay()];
        }
        function formatShortMonth(d) {
            return locale_shortMonths[d.getMonth()];
        }
        function formatMonth(d) {
            return locale_months[d.getMonth()];
        }
        function formatPeriod(d) {
            return locale_periods[+(d.getHours() >= 12)];
        }
        function formatQuarter(d) {
            return 1 + ~~(d.getMonth() / 3);
        }
        function formatUTCShortWeekday(d) {
            return locale_shortWeekdays[d.getUTCDay()];
        }
        function formatUTCWeekday(d) {
            return locale_weekdays[d.getUTCDay()];
        }
        function formatUTCShortMonth(d) {
            return locale_shortMonths[d.getUTCMonth()];
        }
        function formatUTCMonth(d) {
            return locale_months[d.getUTCMonth()];
        }
        function formatUTCPeriod(d) {
            return locale_periods[+(d.getUTCHours() >= 12)];
        }
        function formatUTCQuarter(d) {
            return 1 + ~~(d.getUTCMonth() / 3);
        }
        return {
            format: function(specifier) {
                var f = newFormat(specifier += "", formats);
                f.toString = function() {
                    return specifier;
                };
                return f;
            },
            parse: function(specifier) {
                var p = newParse(specifier += "", false);
                p.toString = function() {
                    return specifier;
                };
                return p;
            },
            utcFormat: function(specifier) {
                var f = newFormat(specifier += "", utcFormats);
                f.toString = function() {
                    return specifier;
                };
                return f;
            },
            utcParse: function(specifier) {
                var p = newParse(specifier += "", true);
                p.toString = function() {
                    return specifier;
                };
                return p;
            }
        };
    }
    var pads = {
        "-": "",
        "_": " ",
        "0": "0"
    }, numberRe = /^\s*\d+/, percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
    function pad(value, fill, width) {
        var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
        return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
    }
    function requote(s) {
        return s.replace(requoteRe, "\\$&");
    }
    function formatRe(names) {
        return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
    }
    function formatLookup(names) {
        return new Map(names.map((name, i)=>[
                name.toLowerCase(),
                i
            ]));
    }
    function parseWeekdayNumberSunday(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 1));
        return n ? (d.w = +n[0], i + n[0].length) : -1;
    }
    function parseWeekdayNumberMonday(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 1));
        return n ? (d.u = +n[0], i + n[0].length) : -1;
    }
    function parseWeekNumberSunday(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 2));
        return n ? (d.U = +n[0], i + n[0].length) : -1;
    }
    function parseWeekNumberISO(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 2));
        return n ? (d.V = +n[0], i + n[0].length) : -1;
    }
    function parseWeekNumberMonday(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 2));
        return n ? (d.W = +n[0], i + n[0].length) : -1;
    }
    function parseFullYear(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 4));
        return n ? (d.y = +n[0], i + n[0].length) : -1;
    }
    function parseYear(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 2));
        return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
    }
    function parseZone(d, string, i) {
        var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
        return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
    }
    function parseQuarter(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 1));
        return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
    }
    function parseMonthNumber(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 2));
        return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
    }
    function parseDayOfMonth(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 2));
        return n ? (d.d = +n[0], i + n[0].length) : -1;
    }
    function parseDayOfYear(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 3));
        return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
    }
    function parseHour24(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 2));
        return n ? (d.H = +n[0], i + n[0].length) : -1;
    }
    function parseMinutes(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 2));
        return n ? (d.M = +n[0], i + n[0].length) : -1;
    }
    function parseSeconds(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 2));
        return n ? (d.S = +n[0], i + n[0].length) : -1;
    }
    function parseMilliseconds(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 3));
        return n ? (d.L = +n[0], i + n[0].length) : -1;
    }
    function parseMicroseconds(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 6));
        return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
    }
    function parseLiteralPercent(d, string, i) {
        var n = percentRe.exec(string.slice(i, i + 1));
        return n ? i + n[0].length : -1;
    }
    function parseUnixTimestamp(d, string, i) {
        var n = numberRe.exec(string.slice(i));
        return n ? (d.Q = +n[0], i + n[0].length) : -1;
    }
    function parseUnixTimestampSeconds(d, string, i) {
        var n = numberRe.exec(string.slice(i));
        return n ? (d.s = +n[0], i + n[0].length) : -1;
    }
    function formatDayOfMonth(d, p) {
        return pad(d.getDate(), p, 2);
    }
    function formatHour24(d, p) {
        return pad(d.getHours(), p, 2);
    }
    function formatHour12(d, p) {
        return pad(d.getHours() % 12 || 12, p, 2);
    }
    function formatDayOfYear(d, p) {
        return pad(1 + timeDay.count(timeYear(d), d), p, 3);
    }
    function formatMilliseconds(d, p) {
        return pad(d.getMilliseconds(), p, 3);
    }
    function formatMicroseconds(d, p) {
        return formatMilliseconds(d, p) + "000";
    }
    function formatMonthNumber(d, p) {
        return pad(d.getMonth() + 1, p, 2);
    }
    function formatMinutes(d, p) {
        return pad(d.getMinutes(), p, 2);
    }
    function formatSeconds(d, p) {
        return pad(d.getSeconds(), p, 2);
    }
    function formatWeekdayNumberMonday(d) {
        var day = d.getDay();
        return day === 0 ? 7 : day;
    }
    function formatWeekNumberSunday(d, p) {
        return pad(timeSunday.count(timeYear(d) - 1, d), p, 2);
    }
    function dISO(d) {
        var day = d.getDay();
        return day >= 4 || day === 0 ? timeThursday(d) : timeThursday.ceil(d);
    }
    function formatWeekNumberISO(d, p) {
        d = dISO(d);
        return pad(timeThursday.count(timeYear(d), d) + (timeYear(d).getDay() === 4), p, 2);
    }
    function formatWeekdayNumberSunday(d) {
        return d.getDay();
    }
    function formatWeekNumberMonday(d, p) {
        return pad(timeMonday.count(timeYear(d) - 1, d), p, 2);
    }
    function formatYear(d, p) {
        return pad(d.getFullYear() % 100, p, 2);
    }
    function formatYearISO(d, p) {
        d = dISO(d);
        return pad(d.getFullYear() % 100, p, 2);
    }
    function formatFullYear(d, p) {
        return pad(d.getFullYear() % 10000, p, 4);
    }
    function formatFullYearISO(d, p) {
        var day = d.getDay();
        d = day >= 4 || day === 0 ? timeThursday(d) : timeThursday.ceil(d);
        return pad(d.getFullYear() % 10000, p, 4);
    }
    function formatZone(d) {
        var z = d.getTimezoneOffset();
        return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
    }
    function formatUTCDayOfMonth(d, p) {
        return pad(d.getUTCDate(), p, 2);
    }
    function formatUTCHour24(d, p) {
        return pad(d.getUTCHours(), p, 2);
    }
    function formatUTCHour12(d, p) {
        return pad(d.getUTCHours() % 12 || 12, p, 2);
    }
    function formatUTCDayOfYear(d, p) {
        return pad(1 + utcDay.count(utcYear(d), d), p, 3);
    }
    function formatUTCMilliseconds(d, p) {
        return pad(d.getUTCMilliseconds(), p, 3);
    }
    function formatUTCMicroseconds(d, p) {
        return formatUTCMilliseconds(d, p) + "000";
    }
    function formatUTCMonthNumber(d, p) {
        return pad(d.getUTCMonth() + 1, p, 2);
    }
    function formatUTCMinutes(d, p) {
        return pad(d.getUTCMinutes(), p, 2);
    }
    function formatUTCSeconds(d, p) {
        return pad(d.getUTCSeconds(), p, 2);
    }
    function formatUTCWeekdayNumberMonday(d) {
        var dow = d.getUTCDay();
        return dow === 0 ? 7 : dow;
    }
    function formatUTCWeekNumberSunday(d, p) {
        return pad(utcSunday.count(utcYear(d) - 1, d), p, 2);
    }
    function UTCdISO(d) {
        var day = d.getUTCDay();
        return day >= 4 || day === 0 ? utcThursday(d) : utcThursday.ceil(d);
    }
    function formatUTCWeekNumberISO(d, p) {
        d = UTCdISO(d);
        return pad(utcThursday.count(utcYear(d), d) + (utcYear(d).getUTCDay() === 4), p, 2);
    }
    function formatUTCWeekdayNumberSunday(d) {
        return d.getUTCDay();
    }
    function formatUTCWeekNumberMonday(d, p) {
        return pad(utcMonday.count(utcYear(d) - 1, d), p, 2);
    }
    function formatUTCYear(d, p) {
        return pad(d.getUTCFullYear() % 100, p, 2);
    }
    function formatUTCYearISO(d, p) {
        d = UTCdISO(d);
        return pad(d.getUTCFullYear() % 100, p, 2);
    }
    function formatUTCFullYear(d, p) {
        return pad(d.getUTCFullYear() % 10000, p, 4);
    }
    function formatUTCFullYearISO(d, p) {
        var day = d.getUTCDay();
        d = day >= 4 || day === 0 ? utcThursday(d) : utcThursday.ceil(d);
        return pad(d.getUTCFullYear() % 10000, p, 4);
    }
    function formatUTCZone() {
        return "+0000";
    }
    function formatLiteralPercent() {
        return "%";
    }
    function formatUnixTimestamp(d) {
        return +d;
    }
    function formatUnixTimestampSeconds(d) {
        return Math.floor(+d / 1000);
    }
    var locale;
    exports1.timeFormat = void 0;
    exports1.timeParse = void 0;
    exports1.utcFormat = void 0;
    exports1.utcParse = void 0;
    defaultLocale({
        dateTime: "%x, %X",
        date: "%-m/%-d/%Y",
        time: "%-I:%M:%S %p",
        periods: [
            "AM",
            "PM"
        ],
        days: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        shortDays: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        months: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        shortMonths: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ]
    });
    function defaultLocale(definition) {
        locale = formatLocale(definition);
        exports1.timeFormat = locale.format;
        exports1.timeParse = locale.parse;
        exports1.utcFormat = locale.utcFormat;
        exports1.utcParse = locale.utcParse;
        return locale;
    }
    var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
    function formatIsoNative(date) {
        return date.toISOString();
    }
    var formatIso = Date.prototype.toISOString ? formatIsoNative : exports1.utcFormat(isoSpecifier);
    var formatIso$1 = formatIso;
    function parseIsoNative(string) {
        var date = new Date(string);
        return isNaN(date) ? null : date;
    }
    var parseIso = +new Date("2000-01-01T00:00:00.000Z") ? parseIsoNative : exports1.utcParse(isoSpecifier);
    var parseIso$1 = parseIso;
    function date(t) {
        return new Date(t);
    }
    function number(t) {
        return t instanceof Date ? +t : +new Date(+t);
    }
    function calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
        var scale = continuous(), invert = scale.invert, domain = scale.domain;
        var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
        function tickFormat(date) {
            return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
        }
        scale.invert = function(y) {
            return new Date(invert(y));
        };
        scale.domain = function(_) {
            return arguments.length ? domain(Array.from(_, number)) : domain().map(date);
        };
        scale.ticks = function(interval) {
            var d = domain();
            return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
        };
        scale.tickFormat = function(count, specifier) {
            return specifier == null ? tickFormat : format(specifier);
        };
        scale.nice = function(interval) {
            var d = domain();
            if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
            return interval ? domain(nice(d, interval)) : scale;
        };
        scale.copy = function() {
            return copy$1(scale, calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
        };
        return scale;
    }
    function time() {
        return initRange.apply(calendar(timeTicks, timeTickInterval, timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute, second, exports1.timeFormat).domain([
            new Date(2000, 0, 1),
            new Date(2000, 0, 2)
        ]), arguments);
    }
    function utcTime() {
        return initRange.apply(calendar(utcTicks, utcTickInterval, utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute, second, exports1.utcFormat).domain([
            Date.UTC(2000, 0, 1),
            Date.UTC(2000, 0, 2)
        ]), arguments);
    }
    function transformer$1() {
        var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = identity$3, clamp = false, unknown;
        function scale(x) {
            return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
        }
        scale.domain = function(_) {
            return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
                x0,
                x1
            ];
        };
        scale.clamp = function(_) {
            return arguments.length ? (clamp = !!_, scale) : clamp;
        };
        scale.interpolator = function(_) {
            return arguments.length ? (interpolator = _, scale) : interpolator;
        };
        function range(interpolate) {
            return function(_) {
                var r0, r1;
                return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                    interpolator(0),
                    interpolator(1)
                ];
            };
        }
        scale.range = range(interpolate$2);
        scale.rangeRound = range(interpolateRound);
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : unknown;
        };
        return function(t) {
            transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
            return scale;
        };
    }
    function copy(source, target) {
        return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
    }
    function sequential() {
        var scale = linearish(transformer$1()(identity$3));
        scale.copy = function() {
            return copy(scale, sequential());
        };
        return initInterpolator.apply(scale, arguments);
    }
    function sequentialLog() {
        var scale = loggish(transformer$1()).domain([
            1,
            10
        ]);
        scale.copy = function() {
            return copy(scale, sequentialLog()).base(scale.base());
        };
        return initInterpolator.apply(scale, arguments);
    }
    function sequentialSymlog() {
        var scale = symlogish(transformer$1());
        scale.copy = function() {
            return copy(scale, sequentialSymlog()).constant(scale.constant());
        };
        return initInterpolator.apply(scale, arguments);
    }
    function sequentialPow() {
        var scale = powish(transformer$1());
        scale.copy = function() {
            return copy(scale, sequentialPow()).exponent(scale.exponent());
        };
        return initInterpolator.apply(scale, arguments);
    }
    function sequentialSqrt() {
        return sequentialPow.apply(null, arguments).exponent(0.5);
    }
    function sequentialQuantile() {
        var domain = [], interpolator = identity$3;
        function scale(x) {
            if (x != null && !isNaN(x = +x)) return interpolator((bisect(domain, x, 1) - 1) / (domain.length - 1));
        }
        scale.domain = function(_) {
            if (!arguments.length) return domain.slice();
            domain = [];
            for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
            domain.sort(ascending$3);
            return scale;
        };
        scale.interpolator = function(_) {
            return arguments.length ? (interpolator = _, scale) : interpolator;
        };
        scale.range = function() {
            return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
        };
        scale.quantiles = function(n) {
            return Array.from({
                length: n + 1
            }, (_, i)=>quantile$1(domain, i / n));
        };
        scale.copy = function() {
            return sequentialQuantile(interpolator).domain(domain);
        };
        return initInterpolator.apply(scale, arguments);
    }
    function transformer() {
        var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = identity$3, transform, clamp = false, unknown;
        function scale(x) {
            return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
        }
        scale.domain = function(_) {
            return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
                x0,
                x1,
                x2
            ];
        };
        scale.clamp = function(_) {
            return arguments.length ? (clamp = !!_, scale) : clamp;
        };
        scale.interpolator = function(_) {
            return arguments.length ? (interpolator = _, scale) : interpolator;
        };
        function range(interpolate) {
            return function(_) {
                var r0, r1, r2;
                return arguments.length ? ([r0, r1, r2] = _, interpolator = piecewise(interpolate, [
                    r0,
                    r1,
                    r2
                ]), scale) : [
                    interpolator(0),
                    interpolator(0.5),
                    interpolator(1)
                ];
            };
        }
        scale.range = range(interpolate$2);
        scale.rangeRound = range(interpolateRound);
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : unknown;
        };
        return function(t) {
            transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
            return scale;
        };
    }
    function diverging$1() {
        var scale = linearish(transformer()(identity$3));
        scale.copy = function() {
            return copy(scale, diverging$1());
        };
        return initInterpolator.apply(scale, arguments);
    }
    function divergingLog() {
        var scale = loggish(transformer()).domain([
            0.1,
            1,
            10
        ]);
        scale.copy = function() {
            return copy(scale, divergingLog()).base(scale.base());
        };
        return initInterpolator.apply(scale, arguments);
    }
    function divergingSymlog() {
        var scale = symlogish(transformer());
        scale.copy = function() {
            return copy(scale, divergingSymlog()).constant(scale.constant());
        };
        return initInterpolator.apply(scale, arguments);
    }
    function divergingPow() {
        var scale = powish(transformer());
        scale.copy = function() {
            return copy(scale, divergingPow()).exponent(scale.exponent());
        };
        return initInterpolator.apply(scale, arguments);
    }
    function divergingSqrt() {
        return divergingPow.apply(null, arguments).exponent(0.5);
    }
    function colors(specifier) {
        var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
        while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
        return colors;
    }
    var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
    var Accent = colors("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");
    var Dark2 = colors("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");
    var Paired = colors("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");
    var Pastel1 = colors("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");
    var Pastel2 = colors("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");
    var Set1 = colors("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");
    var Set2 = colors("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");
    var Set3 = colors("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");
    var Tableau10 = colors("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");
    var ramp$1 = (scheme)=>rgbBasis(scheme[scheme.length - 1]);
    var scheme$q = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map(colors);
    var BrBG = ramp$1(scheme$q);
    var scheme$p = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map(colors);
    var PRGn = ramp$1(scheme$p);
    var scheme$o = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map(colors);
    var PiYG = ramp$1(scheme$o);
    var scheme$n = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map(colors);
    var PuOr = ramp$1(scheme$n);
    var scheme$m = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map(colors);
    var RdBu = ramp$1(scheme$m);
    var scheme$l = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map(colors);
    var RdGy = ramp$1(scheme$l);
    var scheme$k = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map(colors);
    var RdYlBu = ramp$1(scheme$k);
    var scheme$j = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map(colors);
    var RdYlGn = ramp$1(scheme$j);
    var scheme$i = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map(colors);
    var Spectral = ramp$1(scheme$i);
    var scheme$h = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map(colors);
    var BuGn = ramp$1(scheme$h);
    var scheme$g = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map(colors);
    var BuPu = ramp$1(scheme$g);
    var scheme$f = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map(colors);
    var GnBu = ramp$1(scheme$f);
    var scheme$e = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map(colors);
    var OrRd = ramp$1(scheme$e);
    var scheme$d = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map(colors);
    var PuBuGn = ramp$1(scheme$d);
    var scheme$c = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map(colors);
    var PuBu = ramp$1(scheme$c);
    var scheme$b = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map(colors);
    var PuRd = ramp$1(scheme$b);
    var scheme$a = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map(colors);
    var RdPu = ramp$1(scheme$a);
    var scheme$9 = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map(colors);
    var YlGnBu = ramp$1(scheme$9);
    var scheme$8 = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map(colors);
    var YlGn = ramp$1(scheme$8);
    var scheme$7 = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map(colors);
    var YlOrBr = ramp$1(scheme$7);
    var scheme$6 = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map(colors);
    var YlOrRd = ramp$1(scheme$6);
    var scheme$5 = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map(colors);
    var Blues = ramp$1(scheme$5);
    var scheme$4 = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map(colors);
    var Greens = ramp$1(scheme$4);
    var scheme$3 = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map(colors);
    var Greys = ramp$1(scheme$3);
    var scheme$2 = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map(colors);
    var Purples = ramp$1(scheme$2);
    var scheme$1 = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map(colors);
    var Reds = ramp$1(scheme$1);
    var scheme = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map(colors);
    var Oranges = ramp$1(scheme);
    function cividis(t) {
        t = Math.max(0, Math.min(1, t));
        return "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67))))))) + ")";
    }
    var cubehelix = cubehelixLong(cubehelix$3(300, 0.5, 0.0), cubehelix$3(-240, 0.5, 1.0));
    var warm = cubehelixLong(cubehelix$3(-100, 0.75, 0.35), cubehelix$3(80, 1.50, 0.8));
    var cool = cubehelixLong(cubehelix$3(260, 0.75, 0.35), cubehelix$3(80, 1.50, 0.8));
    var c$2 = cubehelix$3();
    function rainbow(t) {
        if (t < 0 || t > 1) t -= Math.floor(t);
        var ts = Math.abs(t - 0.5);
        c$2.h = 360 * t - 100;
        c$2.s = 1.5 - 1.5 * ts;
        c$2.l = 0.8 - 0.9 * ts;
        return c$2 + "";
    }
    var c$1 = rgb(), pi_1_3 = Math.PI / 3, pi_2_3 = Math.PI * 2 / 3;
    function sinebow(t) {
        var x;
        t = (0.5 - t) * Math.PI;
        c$1.r = 255 * (x = Math.sin(t)) * x;
        c$1.g = 255 * (x = Math.sin(t + pi_1_3)) * x;
        c$1.b = 255 * (x = Math.sin(t + pi_2_3)) * x;
        return c$1 + "";
    }
    function turbo(t) {
        t = Math.max(0, Math.min(1, t));
        return "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
    }
    function ramp(range) {
        var n = range.length;
        return function(t) {
            return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
        };
    }
    var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
    var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
    var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
    var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
    function constant$1(x) {
        return function constant() {
            return x;
        };
    }
    const abs = Math.abs;
    const atan2 = Math.atan2;
    const cos = Math.cos;
    const max = Math.max;
    const min = Math.min;
    const sin = Math.sin;
    const sqrt = Math.sqrt;
    const epsilon = 1e-12;
    const pi = Math.PI;
    const halfPi = pi / 2;
    const tau = 2 * pi;
    function acos(x) {
        return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
    }
    function asin(x) {
        return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
    }
    function arcInnerRadius(d) {
        return d.innerRadius;
    }
    function arcOuterRadius(d) {
        return d.outerRadius;
    }
    function arcStartAngle(d) {
        return d.startAngle;
    }
    function arcEndAngle(d) {
        return d.endAngle;
    }
    function arcPadAngle(d) {
        return d && d.padAngle; // Note: optional!
    }
    function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
        var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
        if (t * t < epsilon) return;
        t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
        return [
            x0 + t * x10,
            y0 + t * y10
        ];
    }
    // Compute perpendicular offset line of length rc.
    // http://mathworld.wolfram.com/Circle-LineIntersection.html
    function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
        var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
        // Pick the closer of the two intersection points.
        // TODO Is there a faster way to determine which intersection to use?
        if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
        return {
            cx: cx0,
            cy: cy0,
            x01: -ox,
            y01: -oy,
            x11: cx0 * (r1 / r - 1),
            y11: cy0 * (r1 / r - 1)
        };
    }
    function arc() {
        var innerRadius = arcInnerRadius, outerRadius = arcOuterRadius, cornerRadius = constant$1(0), padRadius = null, startAngle = arcStartAngle, endAngle = arcEndAngle, padAngle = arcPadAngle, context = null;
        function arc() {
            var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - halfPi, a1 = endAngle.apply(this, arguments) - halfPi, da = abs(a1 - a0), cw = a1 > a0;
            if (!context) context = buffer = path();
            // Ensure that the outer radius is always larger than the inner radius.
            if (r1 < r0) r = r1, r1 = r0, r0 = r;
            // Is it a point?
            if (!(r1 > epsilon)) context.moveTo(0, 0);
            else if (da > tau - epsilon) {
                context.moveTo(r1 * cos(a0), r1 * sin(a0));
                context.arc(0, 0, r1, a0, a1, !cw);
                if (r0 > epsilon) {
                    context.moveTo(r0 * cos(a1), r0 * sin(a1));
                    context.arc(0, 0, r0, a1, a0, cw);
                }
            } else {
                var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > epsilon && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)), rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
                // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
                if (rp > epsilon) {
                    var p0 = asin(rp / r0 * sin(ap)), p1 = asin(rp / r1 * sin(ap));
                    if ((da0 -= p0 * 2) > epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                    else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                    if ((da1 -= p1 * 2) > epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                    else da1 = 0, a01 = a11 = (a0 + a1) / 2;
                }
                var x01 = r1 * cos(a01), y01 = r1 * sin(a01), x10 = r0 * cos(a10), y10 = r0 * sin(a10);
                // Apply rounded corners?
                if (rc > epsilon) {
                    var x11 = r1 * cos(a11), y11 = r1 * sin(a11), x00 = r0 * cos(a00), y00 = r0 * sin(a00), oc;
                    // Restrict the corner radius according to the sector angle.
                    if (da < pi && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                        var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2), lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
                        rc0 = min(rc, (r0 - lc) / (kc - 1));
                        rc1 = min(rc, (r1 - lc) / (kc + 1));
                    }
                }
                // Is the sector collapsed to a line?
                if (!(da1 > epsilon)) context.moveTo(x01, y01);
                else if (rc1 > epsilon) {
                    t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                    t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                    context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                    // Have the corners merged?
                    if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
                    else {
                        context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
                        context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                        context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
                    }
                } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
                // Is there no inner ring, and it’s a circular sector?
                // Or perhaps it’s an annular sector collapsed due to padding?
                if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
                else if (rc0 > epsilon) {
                    t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                    t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                    context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                    // Have the corners merged?
                    if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
                    else {
                        context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
                        context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                        context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
                    }
                } else context.arc(0, 0, r0, a10, a00, cw);
            }
            context.closePath();
            if (buffer) return context = null, buffer + "" || null;
        }
        arc.centroid = function() {
            var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
            return [
                cos(a) * r,
                sin(a) * r
            ];
        };
        arc.innerRadius = function(_) {
            return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : innerRadius;
        };
        arc.outerRadius = function(_) {
            return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : outerRadius;
        };
        arc.cornerRadius = function(_) {
            return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : cornerRadius;
        };
        arc.padRadius = function(_) {
            return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), arc) : padRadius;
        };
        arc.startAngle = function(_) {
            return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : startAngle;
        };
        arc.endAngle = function(_) {
            return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : endAngle;
        };
        arc.padAngle = function(_) {
            return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : padAngle;
        };
        arc.context = function(_) {
            return arguments.length ? (context = _ == null ? null : _, arc) : context;
        };
        return arc;
    }
    var slice = Array.prototype.slice;
    function array(x) {
        return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
         : Array.from(x); // Map, Set, iterable, string, or anything else
    }
    function Linear(context) {
        this._context = context;
    }
    Linear.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._point = 0;
        },
        lineEnd: function() {
            if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
            this._line = 1 - this._line;
        },
        point: function(x, y) {
            x = +x, y = +y;
            switch(this._point){
                case 0:
                    this._point = 1;
                    this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                    break;
                case 1:
                    this._point = 2; // falls through
                default:
                    this._context.lineTo(x, y);
                    break;
            }
        }
    };
    function curveLinear(context) {
        return new Linear(context);
    }
    function x$1(p) {
        return p[0];
    }
    function y(p) {
        return p[1];
    }
    function line(x, y$1) {
        var defined = constant$1(true), context = null, curve = curveLinear, output = null;
        x = typeof x === "function" ? x : x === undefined ? x$1 : constant$1(x);
        y$1 = typeof y$1 === "function" ? y$1 : y$1 === undefined ? y : constant$1(y$1);
        function line(data) {
            var i, n = (data = array(data)).length, d, defined0 = false, buffer;
            if (context == null) output = curve(buffer = path());
            for(i = 0; i <= n; ++i){
                if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                    if (defined0 = !defined0) output.lineStart();
                    else output.lineEnd();
                }
                if (defined0) output.point(+x(d, i, data), +y$1(d, i, data));
            }
            if (buffer) return output = null, buffer + "" || null;
        }
        line.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : constant$1(+_), line) : x;
        };
        line.y = function(_) {
            return arguments.length ? (y$1 = typeof _ === "function" ? _ : constant$1(+_), line) : y$1;
        };
        line.defined = function(_) {
            return arguments.length ? (defined = typeof _ === "function" ? _ : constant$1(!!_), line) : defined;
        };
        line.curve = function(_) {
            return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
        };
        line.context = function(_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
        };
        return line;
    }
    function area(x0, y0, y1) {
        var x1 = null, defined = constant$1(true), context = null, curve = curveLinear, output = null;
        x0 = typeof x0 === "function" ? x0 : x0 === undefined ? x$1 : constant$1(+x0);
        y0 = typeof y0 === "function" ? y0 : y0 === undefined ? constant$1(0) : constant$1(+y0);
        y1 = typeof y1 === "function" ? y1 : y1 === undefined ? y : constant$1(+y1);
        function area(data) {
            var i, j, k, n = (data = array(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
            if (context == null) output = curve(buffer = path());
            for(i = 0; i <= n; ++i){
                if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                    if (defined0 = !defined0) {
                        j = i;
                        output.areaStart();
                        output.lineStart();
                    } else {
                        output.lineEnd();
                        output.lineStart();
                        for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                        output.lineEnd();
                        output.areaEnd();
                    }
                }
                if (defined0) {
                    x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                    output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
                }
            }
            if (buffer) return output = null, buffer + "" || null;
        }
        function arealine() {
            return line().defined(defined).curve(curve).context(context);
        }
        area.x = function(_) {
            return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$1(+_), x1 = null, area) : x0;
        };
        area.x0 = function(_) {
            return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$1(+_), area) : x0;
        };
        area.x1 = function(_) {
            return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), area) : x1;
        };
        area.y = function(_) {
            return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$1(+_), y1 = null, area) : y0;
        };
        area.y0 = function(_) {
            return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$1(+_), area) : y0;
        };
        area.y1 = function(_) {
            return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), area) : y1;
        };
        area.lineX0 = area.lineY0 = function() {
            return arealine().x(x0).y(y0);
        };
        area.lineY1 = function() {
            return arealine().x(x0).y(y1);
        };
        area.lineX1 = function() {
            return arealine().x(x1).y(y0);
        };
        area.defined = function(_) {
            return arguments.length ? (defined = typeof _ === "function" ? _ : constant$1(!!_), area) : defined;
        };
        area.curve = function(_) {
            return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
        };
        area.context = function(_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
        };
        return area;
    }
    function descending$1(a, b) {
        return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
    }
    function identity$1(d) {
        return d;
    }
    function pie() {
        var value = identity$1, sortValues = descending$1, sort = null, startAngle = constant$1(0), endAngle = constant$1(tau), padAngle = constant$1(0);
        function pie(data) {
            var i, n = (data = array(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
            for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
            // Optionally sort the arcs by previously-computed values or by data.
            if (sortValues != null) index.sort(function(i, j) {
                return sortValues(arcs[i], arcs[j]);
            });
            else if (sort != null) index.sort(function(i, j) {
                return sort(data[i], data[j]);
            });
            // Compute the arcs! They are stored in the original data's order.
            for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
                data: data[j],
                index: i,
                value: v,
                startAngle: a0,
                endAngle: a1,
                padAngle: p
            };
            return arcs;
        }
        pie.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : constant$1(+_), pie) : value;
        };
        pie.sortValues = function(_) {
            return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
        };
        pie.sort = function(_) {
            return arguments.length ? (sort = _, sortValues = null, pie) : sort;
        };
        pie.startAngle = function(_) {
            return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : startAngle;
        };
        pie.endAngle = function(_) {
            return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : endAngle;
        };
        pie.padAngle = function(_) {
            return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : padAngle;
        };
        return pie;
    }
    var curveRadialLinear = curveRadial(curveLinear);
    function Radial(curve) {
        this._curve = curve;
    }
    Radial.prototype = {
        areaStart: function() {
            this._curve.areaStart();
        },
        areaEnd: function() {
            this._curve.areaEnd();
        },
        lineStart: function() {
            this._curve.lineStart();
        },
        lineEnd: function() {
            this._curve.lineEnd();
        },
        point: function(a, r) {
            this._curve.point(r * Math.sin(a), r * -Math.cos(a));
        }
    };
    function curveRadial(curve) {
        function radial(context) {
            return new Radial(curve(context));
        }
        radial._curve = curve;
        return radial;
    }
    function lineRadial(l) {
        var c = l.curve;
        l.angle = l.x, delete l.x;
        l.radius = l.y, delete l.y;
        l.curve = function(_) {
            return arguments.length ? c(curveRadial(_)) : c()._curve;
        };
        return l;
    }
    function lineRadial$1() {
        return lineRadial(line().curve(curveRadialLinear));
    }
    function areaRadial() {
        var a = area().curve(curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
        a.angle = a.x, delete a.x;
        a.startAngle = a.x0, delete a.x0;
        a.endAngle = a.x1, delete a.x1;
        a.radius = a.y, delete a.y;
        a.innerRadius = a.y0, delete a.y0;
        a.outerRadius = a.y1, delete a.y1;
        a.lineStartAngle = function() {
            return lineRadial(x0());
        }, delete a.lineX0;
        a.lineEndAngle = function() {
            return lineRadial(x1());
        }, delete a.lineX1;
        a.lineInnerRadius = function() {
            return lineRadial(y0());
        }, delete a.lineY0;
        a.lineOuterRadius = function() {
            return lineRadial(y1());
        }, delete a.lineY1;
        a.curve = function(_) {
            return arguments.length ? c(curveRadial(_)) : c()._curve;
        };
        return a;
    }
    function pointRadial(x, y) {
        return [
            (y = +y) * Math.cos(x -= Math.PI / 2),
            y * Math.sin(x)
        ];
    }
    class Bump {
        constructor(context, x){
            this._context = context;
            this._x = x;
        }
        areaStart() {
            this._line = 0;
        }
        areaEnd() {
            this._line = NaN;
        }
        lineStart() {
            this._point = 0;
        }
        lineEnd() {
            if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
            this._line = 1 - this._line;
        }
        point(x, y) {
            x = +x, y = +y;
            switch(this._point){
                case 0:
                    this._point = 1;
                    if (this._line) this._context.lineTo(x, y);
                    else this._context.moveTo(x, y);
                    break;
                case 1:
                    this._point = 2; // falls through
                default:
                    if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                    else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                    break;
            }
            this._x0 = x, this._y0 = y;
        }
    }
    class BumpRadial {
        constructor(context){
            this._context = context;
        }
        lineStart() {
            this._point = 0;
        }
        lineEnd() {}
        point(x, y) {
            x = +x, y = +y;
            if (this._point++ === 0) this._x0 = x, this._y0 = y;
            else {
                const p0 = pointRadial(this._x0, this._y0);
                const p1 = pointRadial(this._x0, this._y0 = (this._y0 + y) / 2);
                const p2 = pointRadial(x, this._y0);
                const p3 = pointRadial(x, y);
                this._context.moveTo(...p0);
                this._context.bezierCurveTo(...p1, ...p2, ...p3);
            }
        }
    }
    function bumpX(context) {
        return new Bump(context, true);
    }
    function bumpY(context) {
        return new Bump(context, false);
    }
    function bumpRadial(context) {
        return new BumpRadial(context);
    }
    function linkSource(d) {
        return d.source;
    }
    function linkTarget(d) {
        return d.target;
    }
    function link(curve) {
        let source = linkSource;
        let target = linkTarget;
        let x = x$1;
        let y$1 = y;
        let context = null;
        let output = null;
        function link() {
            let buffer;
            const argv = slice.call(arguments);
            const s = source.apply(this, argv);
            const t = target.apply(this, argv);
            if (context == null) output = curve(buffer = path());
            output.lineStart();
            argv[0] = s, output.point(+x.apply(this, argv), +y$1.apply(this, argv));
            argv[0] = t, output.point(+x.apply(this, argv), +y$1.apply(this, argv));
            output.lineEnd();
            if (buffer) return output = null, buffer + "" || null;
        }
        link.source = function(_) {
            return arguments.length ? (source = _, link) : source;
        };
        link.target = function(_) {
            return arguments.length ? (target = _, link) : target;
        };
        link.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : constant$1(+_), link) : x;
        };
        link.y = function(_) {
            return arguments.length ? (y$1 = typeof _ === "function" ? _ : constant$1(+_), link) : y$1;
        };
        link.context = function(_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
        };
        return link;
    }
    function linkHorizontal() {
        return link(bumpX);
    }
    function linkVertical() {
        return link(bumpY);
    }
    function linkRadial() {
        const l = link(bumpRadial);
        l.angle = l.x, delete l.x;
        l.radius = l.y, delete l.y;
        return l;
    }
    const sqrt3$2 = sqrt(3);
    var asterisk = {
        draw (context, size) {
            const r = sqrt(size + min(size / 28, 0.75)) * 0.59436;
            const t = r / 2;
            const u = t * sqrt3$2;
            context.moveTo(0, r);
            context.lineTo(0, -r);
            context.moveTo(-u, -t);
            context.lineTo(u, t);
            context.moveTo(-u, t);
            context.lineTo(u, -t);
        }
    };
    var circle = {
        draw (context, size) {
            const r = sqrt(size / pi);
            context.moveTo(r, 0);
            context.arc(0, 0, r, 0, tau);
        }
    };
    var cross = {
        draw (context, size) {
            const r = sqrt(size / 5) / 2;
            context.moveTo(-3 * r, -r);
            context.lineTo(-r, -r);
            context.lineTo(-r, -3 * r);
            context.lineTo(r, -3 * r);
            context.lineTo(r, -r);
            context.lineTo(3 * r, -r);
            context.lineTo(3 * r, r);
            context.lineTo(r, r);
            context.lineTo(r, 3 * r);
            context.lineTo(-r, 3 * r);
            context.lineTo(-r, r);
            context.lineTo(-3 * r, r);
            context.closePath();
        }
    };
    const tan30 = sqrt(1 / 3);
    const tan30_2 = tan30 * 2;
    var diamond = {
        draw (context, size) {
            const y = sqrt(size / tan30_2);
            const x = y * tan30;
            context.moveTo(0, -y);
            context.lineTo(x, 0);
            context.lineTo(0, y);
            context.lineTo(-x, 0);
            context.closePath();
        }
    };
    var diamond2 = {
        draw (context, size) {
            const r = sqrt(size) * 0.62625;
            context.moveTo(0, -r);
            context.lineTo(r, 0);
            context.lineTo(0, r);
            context.lineTo(-r, 0);
            context.closePath();
        }
    };
    var plus = {
        draw (context, size) {
            const r = sqrt(size - min(size / 7, 2)) * 0.87559;
            context.moveTo(-r, 0);
            context.lineTo(r, 0);
            context.moveTo(0, r);
            context.lineTo(0, -r);
        }
    };
    var square = {
        draw (context, size) {
            const w = sqrt(size);
            const x = -w / 2;
            context.rect(x, x, w, w);
        }
    };
    var square2 = {
        draw (context, size) {
            const r = sqrt(size) * 0.4431;
            context.moveTo(r, r);
            context.lineTo(r, -r);
            context.lineTo(-r, -r);
            context.lineTo(-r, r);
            context.closePath();
        }
    };
    const ka = 0.89081309152928522810;
    const kr = sin(pi / 10) / sin(7 * pi / 10);
    const kx = sin(tau / 10) * kr;
    const ky = -cos(tau / 10) * kr;
    var star = {
        draw (context, size) {
            const r = sqrt(size * ka);
            const x = kx * r;
            const y = ky * r;
            context.moveTo(0, -r);
            context.lineTo(x, y);
            for(let i = 1; i < 5; ++i){
                const a = tau * i / 5;
                const c = cos(a);
                const s = sin(a);
                context.lineTo(s * r, -c * r);
                context.lineTo(c * x - s * y, s * x + c * y);
            }
            context.closePath();
        }
    };
    const sqrt3$1 = sqrt(3);
    var triangle = {
        draw (context, size) {
            const y = -sqrt(size / (sqrt3$1 * 3));
            context.moveTo(0, y * 2);
            context.lineTo(-sqrt3$1 * y, -y);
            context.lineTo(sqrt3$1 * y, -y);
            context.closePath();
        }
    };
    const sqrt3 = sqrt(3);
    var triangle2 = {
        draw (context, size) {
            const s = sqrt(size) * 0.6824;
            const t = s / 2;
            const u = s * sqrt3 / 2; // cos(Math.PI / 6)
            context.moveTo(0, -s);
            context.lineTo(u, t);
            context.lineTo(-u, t);
            context.closePath();
        }
    };
    const c = -0.5;
    const s = sqrt(3) / 2;
    const k = 1 / sqrt(12);
    const a = (k / 2 + 1) * 3;
    var wye = {
        draw (context, size) {
            const r = sqrt(size / a);
            const x0 = r / 2, y0 = r * k;
            const x1 = x0, y1 = r * k + r;
            const x2 = -x1, y2 = y1;
            context.moveTo(x0, y0);
            context.lineTo(x1, y1);
            context.lineTo(x2, y2);
            context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
            context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
            context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
            context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
            context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
            context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
            context.closePath();
        }
    };
    var x = {
        draw (context, size) {
            const r = sqrt(size - min(size / 6, 1.7)) * 0.6189;
            context.moveTo(-r, -r);
            context.lineTo(r, r);
            context.moveTo(-r, r);
            context.lineTo(r, -r);
        }
    };
    // These symbols are designed to be filled.
    const symbolsFill = [
        circle,
        cross,
        diamond,
        square,
        star,
        triangle,
        wye
    ];
    // These symbols are designed to be stroked (with a width of 1.5px and round caps).
    const symbolsStroke = [
        circle,
        plus,
        x,
        triangle2,
        asterisk,
        square2,
        diamond2
    ];
    function Symbol$1(type, size) {
        let context = null;
        type = typeof type === "function" ? type : constant$1(type || circle);
        size = typeof size === "function" ? size : constant$1(size === undefined ? 64 : +size);
        function symbol() {
            let buffer;
            if (!context) context = buffer = path();
            type.apply(this, arguments).draw(context, +size.apply(this, arguments));
            if (buffer) return context = null, buffer + "" || null;
        }
        symbol.type = function(_) {
            return arguments.length ? (type = typeof _ === "function" ? _ : constant$1(_), symbol) : type;
        };
        symbol.size = function(_) {
            return arguments.length ? (size = typeof _ === "function" ? _ : constant$1(+_), symbol) : size;
        };
        symbol.context = function(_) {
            return arguments.length ? (context = _ == null ? null : _, symbol) : context;
        };
        return symbol;
    }
    function noop() {}
    function point$3(that, x, y) {
        that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
    }
    function Basis(context) {
        this._context = context;
    }
    Basis.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._x0 = this._x1 = this._y0 = this._y1 = NaN;
            this._point = 0;
        },
        lineEnd: function() {
            switch(this._point){
                case 3:
                    point$3(this, this._x1, this._y1); // falls through
                case 2:
                    this._context.lineTo(this._x1, this._y1);
                    break;
            }
            if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
            this._line = 1 - this._line;
        },
        point: function(x, y) {
            x = +x, y = +y;
            switch(this._point){
                case 0:
                    this._point = 1;
                    this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                    break;
                case 1:
                    this._point = 2;
                    break;
                case 2:
                    this._point = 3;
                    this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // falls through
                default:
                    point$3(this, x, y);
                    break;
            }
            this._x0 = this._x1, this._x1 = x;
            this._y0 = this._y1, this._y1 = y;
        }
    };
    function basis(context) {
        return new Basis(context);
    }
    function BasisClosed(context) {
        this._context = context;
    }
    BasisClosed.prototype = {
        areaStart: noop,
        areaEnd: noop,
        lineStart: function() {
            this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
            this._point = 0;
        },
        lineEnd: function() {
            switch(this._point){
                case 1:
                    this._context.moveTo(this._x2, this._y2);
                    this._context.closePath();
                    break;
                case 2:
                    this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                    this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                    this._context.closePath();
                    break;
                case 3:
                    this.point(this._x2, this._y2);
                    this.point(this._x3, this._y3);
                    this.point(this._x4, this._y4);
                    break;
            }
        },
        point: function(x, y) {
            x = +x, y = +y;
            switch(this._point){
                case 0:
                    this._point = 1;
                    this._x2 = x, this._y2 = y;
                    break;
                case 1:
                    this._point = 2;
                    this._x3 = x, this._y3 = y;
                    break;
                case 2:
                    this._point = 3;
                    this._x4 = x, this._y4 = y;
                    this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                    break;
                default:
                    point$3(this, x, y);
                    break;
            }
            this._x0 = this._x1, this._x1 = x;
            this._y0 = this._y1, this._y1 = y;
        }
    };
    function basisClosed(context) {
        return new BasisClosed(context);
    }
    function BasisOpen(context) {
        this._context = context;
    }
    BasisOpen.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._x0 = this._x1 = this._y0 = this._y1 = NaN;
            this._point = 0;
        },
        lineEnd: function() {
            if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
            this._line = 1 - this._line;
        },
        point: function(x, y) {
            x = +x, y = +y;
            switch(this._point){
                case 0:
                    this._point = 1;
                    break;
                case 1:
                    this._point = 2;
                    break;
                case 2:
                    this._point = 3;
                    var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                    this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                    break;
                case 3:
                    this._point = 4; // falls through
                default:
                    point$3(this, x, y);
                    break;
            }
            this._x0 = this._x1, this._x1 = x;
            this._y0 = this._y1, this._y1 = y;
        }
    };
    function basisOpen(context) {
        return new BasisOpen(context);
    }
    function Bundle(context, beta) {
        this._basis = new Basis(context);
        this._beta = beta;
    }
    Bundle.prototype = {
        lineStart: function() {
            this._x = [];
            this._y = [];
            this._basis.lineStart();
        },
        lineEnd: function() {
            var x = this._x, y = this._y, j = x.length - 1;
            if (j > 0) {
                var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
                while(++i <= j){
                    t = i / j;
                    this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
                }
            }
            this._x = this._y = null;
            this._basis.lineEnd();
        },
        point: function(x, y) {
            this._x.push(+x);
            this._y.push(+y);
        }
    };
    var bundle = function custom(beta) {
        function bundle(context) {
            return beta === 1 ? new Basis(context) : new Bundle(context, beta);
        }
        bundle.beta = function(beta) {
            return custom(+beta);
        };
        return bundle;
    }(0.85);
    function point$2(that, x, y) {
        that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
    }
    function Cardinal(context, tension) {
        this._context = context;
        this._k = (1 - tension) / 6;
    }
    Cardinal.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
            this._point = 0;
        },
        lineEnd: function() {
            switch(this._point){
                case 2:
                    this._context.lineTo(this._x2, this._y2);
                    break;
                case 3:
                    point$2(this, this._x1, this._y1);
                    break;
            }
            if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
            this._line = 1 - this._line;
        },
        point: function(x, y) {
            x = +x, y = +y;
            switch(this._point){
                case 0:
                    this._point = 1;
                    this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                    break;
                case 1:
                    this._point = 2;
                    this._x1 = x, this._y1 = y;
                    break;
                case 2:
                    this._point = 3; // falls through
                default:
                    point$2(this, x, y);
                    break;
            }
            this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
            this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
        }
    };
    var cardinal = function custom(tension) {
        function cardinal(context) {
            return new Cardinal(context, tension);
        }
        cardinal.tension = function(tension) {
            return custom(+tension);
        };
        return cardinal;
    }(0);
    function CardinalClosed(context, tension) {
        this._context = context;
        this._k = (1 - tension) / 6;
    }
    CardinalClosed.prototype = {
        areaStart: noop,
        areaEnd: noop,
        lineStart: function() {
            this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
            this._point = 0;
        },
        lineEnd: function() {
            switch(this._point){
                case 1:
                    this._context.moveTo(this._x3, this._y3);
                    this._context.closePath();
                    break;
                case 2:
                    this._context.lineTo(this._x3, this._y3);
                    this._context.closePath();
                    break;
                case 3:
                    this.point(this._x3, this._y3);
                    this.point(this._x4, this._y4);
                    this.point(this._x5, this._y5);
                    break;
            }
        },
        point: function(x, y) {
            x = +x, y = +y;
            switch(this._point){
                case 0:
                    this._point = 1;
                    this._x3 = x, this._y3 = y;
                    break;
                case 1:
                    this._point = 2;
                    this._context.moveTo(this._x4 = x, this._y4 = y);
                    break;
                case 2:
                    this._point = 3;
                    this._x5 = x, this._y5 = y;
                    break;
                default:
                    point$2(this, x, y);
                    break;
            }
            this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
            this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
        }
    };
    var cardinalClosed = function custom(tension) {
        function cardinal(context) {
            return new CardinalClosed(context, tension);
        }
        cardinal.tension = function(tension) {
            return custom(+tension);
        };
        return cardinal;
    }(0);
    function CardinalOpen(context, tension) {
        this._context = context;
        this._k = (1 - tension) / 6;
    }
    CardinalOpen.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
            this._point = 0;
        },
        lineEnd: function() {
            if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
            this._line = 1 - this._line;
        },
        point: function(x, y) {
            x = +x, y = +y;
            switch(this._point){
                case 0:
                    this._point = 1;
                    break;
                case 1:
                    this._point = 2;
                    break;
                case 2:
                    this._point = 3;
                    this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                    break;
                case 3:
                    this._point = 4; // falls through
                default:
                    point$2(this, x, y);
                    break;
            }
            this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
            this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
        }
    };
    var cardinalOpen = function custom(tension) {
        function cardinal(context) {
            return new CardinalOpen(context, tension);
        }
        cardinal.tension = function(tension) {
            return custom(+tension);
        };
        return cardinal;
    }(0);
    function point$1(that, x, y) {
        var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
        if (that._l01_a > epsilon) {
            var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
            x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
            y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
        }
        if (that._l23_a > epsilon) {
            var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
            x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
            y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
        }
        that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
    }
    function CatmullRom(context, alpha) {
        this._context = context;
        this._alpha = alpha;
    }
    CatmullRom.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
            this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
        },
        lineEnd: function() {
            switch(this._point){
                case 2:
                    this._context.lineTo(this._x2, this._y2);
                    break;
                case 3:
                    this.point(this._x2, this._y2);
                    break;
            }
            if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
            this._line = 1 - this._line;
        },
        point: function(x, y) {
            x = +x, y = +y;
            if (this._point) {
                var x23 = this._x2 - x, y23 = this._y2 - y;
                this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
            }
            switch(this._point){
                case 0:
                    this._point = 1;
                    this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                    break;
                case 1:
                    this._point = 2;
                    break;
                case 2:
                    this._point = 3; // falls through
                default:
                    point$1(this, x, y);
                    break;
            }
            this._l01_a = this._l12_a, this._l12_a = this._l23_a;
            this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
            this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
            this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
        }
    };
    var catmullRom = function custom(alpha) {
        function catmullRom(context) {
            return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
        }
        catmullRom.alpha = function(alpha) {
            return custom(+alpha);
        };
        return catmullRom;
    }(0.5);
    function CatmullRomClosed(context, alpha) {
        this._context = context;
        this._alpha = alpha;
    }
    CatmullRomClosed.prototype = {
        areaStart: noop,
        areaEnd: noop,
        lineStart: function() {
            this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
            this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
        },
        lineEnd: function() {
            switch(this._point){
                case 1:
                    this._context.moveTo(this._x3, this._y3);
                    this._context.closePath();
                    break;
                case 2:
                    this._context.lineTo(this._x3, this._y3);
                    this._context.closePath();
                    break;
                case 3:
                    this.point(this._x3, this._y3);
                    this.point(this._x4, this._y4);
                    this.point(this._x5, this._y5);
                    break;
            }
        },
        point: function(x, y) {
            x = +x, y = +y;
            if (this._point) {
                var x23 = this._x2 - x, y23 = this._y2 - y;
                this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
            }
            switch(this._point){
                case 0:
                    this._point = 1;
                    this._x3 = x, this._y3 = y;
                    break;
                case 1:
                    this._point = 2;
                    this._context.moveTo(this._x4 = x, this._y4 = y);
                    break;
                case 2:
                    this._point = 3;
                    this._x5 = x, this._y5 = y;
                    break;
                default:
                    point$1(this, x, y);
                    break;
            }
            this._l01_a = this._l12_a, this._l12_a = this._l23_a;
            this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
            this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
            this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
        }
    };
    var catmullRomClosed = function custom(alpha) {
        function catmullRom(context) {
            return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
        }
        catmullRom.alpha = function(alpha) {
            return custom(+alpha);
        };
        return catmullRom;
    }(0.5);
    function CatmullRomOpen(context, alpha) {
        this._context = context;
        this._alpha = alpha;
    }
    CatmullRomOpen.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
            this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
        },
        lineEnd: function() {
            if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
            this._line = 1 - this._line;
        },
        point: function(x, y) {
            x = +x, y = +y;
            if (this._point) {
                var x23 = this._x2 - x, y23 = this._y2 - y;
                this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
            }
            switch(this._point){
                case 0:
                    this._point = 1;
                    break;
                case 1:
                    this._point = 2;
                    break;
                case 2:
                    this._point = 3;
                    this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                    break;
                case 3:
                    this._point = 4; // falls through
                default:
                    point$1(this, x, y);
                    break;
            }
            this._l01_a = this._l12_a, this._l12_a = this._l23_a;
            this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
            this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
            this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
        }
    };
    var catmullRomOpen = function custom(alpha) {
        function catmullRom(context) {
            return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
        }
        catmullRom.alpha = function(alpha) {
            return custom(+alpha);
        };
        return catmullRom;
    }(0.5);
    function LinearClosed(context) {
        this._context = context;
    }
    LinearClosed.prototype = {
        areaStart: noop,
        areaEnd: noop,
        lineStart: function() {
            this._point = 0;
        },
        lineEnd: function() {
            if (this._point) this._context.closePath();
        },
        point: function(x, y) {
            x = +x, y = +y;
            if (this._point) this._context.lineTo(x, y);
            else this._point = 1, this._context.moveTo(x, y);
        }
    };
    function linearClosed(context) {
        return new LinearClosed(context);
    }
    function sign(x) {
        return x < 0 ? -1 : 1;
    }
    // Calculate the slopes of the tangents (Hermite-type interpolation) based on
    // the following paper: Steffen, M. 1990. A Simple Method for Monotonic
    // Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
    // NOV(II), P. 443, 1990.
    function slope3(that, x2, y2) {
        var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
        return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
    }
    // Calculate a one-sided slope.
    function slope2(that, t) {
        var h = that._x1 - that._x0;
        return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
    }
    // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
    // "you can express cubic Hermite interpolation in terms of cubic Bézier curves
    // with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
    function point(that, t0, t1) {
        var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
        that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
    }
    function MonotoneX(context) {
        this._context = context;
    }
    MonotoneX.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
            this._point = 0;
        },
        lineEnd: function() {
            switch(this._point){
                case 2:
                    this._context.lineTo(this._x1, this._y1);
                    break;
                case 3:
                    point(this, this._t0, slope2(this, this._t0));
                    break;
            }
            if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
            this._line = 1 - this._line;
        },
        point: function(x, y) {
            var t1 = NaN;
            x = +x, y = +y;
            if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
            switch(this._point){
                case 0:
                    this._point = 1;
                    this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                    break;
                case 1:
                    this._point = 2;
                    break;
                case 2:
                    this._point = 3;
                    point(this, slope2(this, t1 = slope3(this, x, y)), t1);
                    break;
                default:
                    point(this, this._t0, t1 = slope3(this, x, y));
                    break;
            }
            this._x0 = this._x1, this._x1 = x;
            this._y0 = this._y1, this._y1 = y;
            this._t0 = t1;
        }
    };
    function MonotoneY(context) {
        this._context = new ReflectContext(context);
    }
    (MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
        MonotoneX.prototype.point.call(this, y, x);
    };
    function ReflectContext(context) {
        this._context = context;
    }
    ReflectContext.prototype = {
        moveTo: function(x, y) {
            this._context.moveTo(y, x);
        },
        closePath: function() {
            this._context.closePath();
        },
        lineTo: function(x, y) {
            this._context.lineTo(y, x);
        },
        bezierCurveTo: function(x1, y1, x2, y2, x, y) {
            this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
        }
    };
    function monotoneX(context) {
        return new MonotoneX(context);
    }
    function monotoneY(context) {
        return new MonotoneY(context);
    }
    function Natural(context) {
        this._context = context;
    }
    Natural.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._x = [];
            this._y = [];
        },
        lineEnd: function() {
            var x = this._x, y = this._y, n = x.length;
            if (n) {
                this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
                if (n === 2) this._context.lineTo(x[1], y[1]);
                else {
                    var px = controlPoints(x), py = controlPoints(y);
                    for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
                }
            }
            if (this._line || this._line !== 0 && n === 1) this._context.closePath();
            this._line = 1 - this._line;
            this._x = this._y = null;
        },
        point: function(x, y) {
            this._x.push(+x);
            this._y.push(+y);
        }
    };
    // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
    function controlPoints(x) {
        var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
        a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
        for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
        a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
        for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
        a[n - 1] = r[n - 1] / b[n - 1];
        for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
        b[n - 1] = (x[n] + a[n - 1]) / 2;
        for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
        return [
            a,
            b
        ];
    }
    function natural(context) {
        return new Natural(context);
    }
    function Step(context, t) {
        this._context = context;
        this._t = t;
    }
    Step.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._x = this._y = NaN;
            this._point = 0;
        },
        lineEnd: function() {
            if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
            if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
            if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
        },
        point: function(x, y) {
            x = +x, y = +y;
            switch(this._point){
                case 0:
                    this._point = 1;
                    this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                    break;
                case 1:
                    this._point = 2; // falls through
                default:
                    if (this._t <= 0) {
                        this._context.lineTo(this._x, y);
                        this._context.lineTo(x, y);
                    } else {
                        var x1 = this._x * (1 - this._t) + x * this._t;
                        this._context.lineTo(x1, this._y);
                        this._context.lineTo(x1, y);
                    }
                    break;
            }
            this._x = x, this._y = y;
        }
    };
    function step(context) {
        return new Step(context, 0.5);
    }
    function stepBefore(context) {
        return new Step(context, 0);
    }
    function stepAfter(context) {
        return new Step(context, 1);
    }
    function none$1(series, order) {
        if (!((n = series.length) > 1)) return;
        for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
            s0 = s1, s1 = series[order[i]];
            for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
        }
    }
    function none(series) {
        var n = series.length, o = new Array(n);
        while(--n >= 0)o[n] = n;
        return o;
    }
    function stackValue(d, key) {
        return d[key];
    }
    function stackSeries(key) {
        const series = [];
        series.key = key;
        return series;
    }
    function stack() {
        var keys = constant$1([]), order = none, offset = none$1, value = stackValue;
        function stack(data) {
            var sz = Array.from(keys.apply(this, arguments), stackSeries), i, n = sz.length, j = -1, oz;
            for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
                0,
                +value(d, sz[i].key, j, data)
            ]).data = d;
            for(i = 0, oz = array(order(sz)); i < n; ++i)sz[oz[i]].index = i;
            offset(sz, oz);
            return sz;
        }
        stack.keys = function(_) {
            return arguments.length ? (keys = typeof _ === "function" ? _ : constant$1(Array.from(_)), stack) : keys;
        };
        stack.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : constant$1(+_), stack) : value;
        };
        stack.order = function(_) {
            return arguments.length ? (order = _ == null ? none : typeof _ === "function" ? _ : constant$1(Array.from(_)), stack) : order;
        };
        stack.offset = function(_) {
            return arguments.length ? (offset = _ == null ? none$1 : _, stack) : offset;
        };
        return stack;
    }
    function expand(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
            for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
            if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
        }
        none$1(series, order);
    }
    function diverging(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
            if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
            else if (dy < 0) d[1] = yn, d[0] = yn += dy;
            else d[0] = 0, d[1] = dy;
        }
    }
    function silhouette(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
            for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
            s0[j][1] += s0[j][0] = -y / 2;
        }
        none$1(series, order);
    }
    function wiggle(series, order) {
        if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
        for(var y = 0, j = 1, s0, m, n; j < m; ++j){
            for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
                var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
                for(var k = 0; k < i; ++k){
                    var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                    s3 += skj0 - skj1;
                }
                s1 += sij0, s2 += s3 * sij0;
            }
            s0[j - 1][1] += s0[j - 1][0] = y;
            if (s1) y -= s2 / s1;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        none$1(series, order);
    }
    function appearance(series) {
        var peaks = series.map(peak);
        return none(series).sort(function(a, b) {
            return peaks[a] - peaks[b];
        });
    }
    function peak(series) {
        var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
        while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
        return j;
    }
    function ascending(series) {
        var sums = series.map(sum);
        return none(series).sort(function(a, b) {
            return sums[a] - sums[b];
        });
    }
    function sum(series) {
        var s = 0, i = -1, n = series.length, v;
        while(++i < n)if (v = +series[i][1]) s += v;
        return s;
    }
    function descending(series) {
        return ascending(series).reverse();
    }
    function insideOut(series) {
        var n = series.length, i, j, sums = series.map(sum), order = appearance(series), top = 0, bottom = 0, tops = [], bottoms = [];
        for(i = 0; i < n; ++i){
            j = order[i];
            if (top < bottom) {
                top += sums[j];
                tops.push(j);
            } else {
                bottom += sums[j];
                bottoms.push(j);
            }
        }
        return bottoms.reverse().concat(tops);
    }
    function reverse(series) {
        return none(series).reverse();
    }
    var constant = (x)=>()=>x;
    function ZoomEvent(type, { sourceEvent: sourceEvent, target: target, transform: transform, dispatch: dispatch }) {
        Object.defineProperties(this, {
            type: {
                value: type,
                enumerable: true,
                configurable: true
            },
            sourceEvent: {
                value: sourceEvent,
                enumerable: true,
                configurable: true
            },
            target: {
                value: target,
                enumerable: true,
                configurable: true
            },
            transform: {
                value: transform,
                enumerable: true,
                configurable: true
            },
            _: {
                value: dispatch
            }
        });
    }
    function Transform(k, x, y) {
        this.k = k;
        this.x = x;
        this.y = y;
    }
    Transform.prototype = {
        constructor: Transform,
        scale: function(k) {
            return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
        },
        translate: function(x, y) {
            return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
        },
        apply: function(point) {
            return [
                point[0] * this.k + this.x,
                point[1] * this.k + this.y
            ];
        },
        applyX: function(x) {
            return x * this.k + this.x;
        },
        applyY: function(y) {
            return y * this.k + this.y;
        },
        invert: function(location) {
            return [
                (location[0] - this.x) / this.k,
                (location[1] - this.y) / this.k
            ];
        },
        invertX: function(x) {
            return (x - this.x) / this.k;
        },
        invertY: function(y) {
            return (y - this.y) / this.k;
        },
        rescaleX: function(x) {
            return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
        },
        rescaleY: function(y) {
            return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
        },
        toString: function() {
            return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
        }
    };
    var identity = new Transform(1, 0, 0);
    transform.prototype = Transform.prototype;
    function transform(node) {
        while(!node.__zoom)if (!(node = node.parentNode)) return identity;
        return node.__zoom;
    }
    function nopropagation(event) {
        event.stopImmediatePropagation();
    }
    function noevent(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    }
    // Ignore right-click, since that should open the context menu.
    // except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
    function defaultFilter(event) {
        return (!event.ctrlKey || event.type === 'wheel') && !event.button;
    }
    function defaultExtent() {
        var e = this;
        if (e instanceof SVGElement) {
            e = e.ownerSVGElement || e;
            if (e.hasAttribute("viewBox")) {
                e = e.viewBox.baseVal;
                return [
                    [
                        e.x,
                        e.y
                    ],
                    [
                        e.x + e.width,
                        e.y + e.height
                    ]
                ];
            }
            return [
                [
                    0,
                    0
                ],
                [
                    e.width.baseVal.value,
                    e.height.baseVal.value
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.clientWidth,
                e.clientHeight
            ]
        ];
    }
    function defaultTransform() {
        return this.__zoom || identity;
    }
    function defaultWheelDelta(event) {
        return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
    }
    function defaultTouchable() {
        return navigator.maxTouchPoints || "ontouchstart" in this;
    }
    function defaultConstrain(transform, extent, translateExtent) {
        var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
        return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
    }
    function zoom() {
        var filter = defaultFilter, extent = defaultExtent, constrain = defaultConstrain, wheelDelta = defaultWheelDelta, touchable = defaultTouchable, scaleExtent = [
            0,
            Infinity
        ], translateExtent = [
            [
                -Infinity,
                -Infinity
            ],
            [
                Infinity,
                Infinity
            ]
        ], duration = 250, interpolate = interpolateZoom, listeners = dispatch("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
        function zoom(selection) {
            selection.property("__zoom", defaultTransform).on("wheel.zoom", wheeled, {
                passive: false
            }).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
        }
        zoom.transform = function(collection, transform, point, event) {
            var selection = collection.selection ? collection.selection() : collection;
            selection.property("__zoom", defaultTransform);
            if (collection !== selection) schedule(collection, transform, point, event);
            else selection.interrupt().each(function() {
                gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
            });
        };
        zoom.scaleBy = function(selection, k, p, event) {
            zoom.scaleTo(selection, function() {
                var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
                return k0 * k1;
            }, p, event);
        };
        zoom.scaleTo = function(selection, k, p, event) {
            zoom.transform(selection, function() {
                var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
                return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
            }, p, event);
        };
        zoom.translateBy = function(selection, x, y, event) {
            zoom.transform(selection, function() {
                return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
            }, null, event);
        };
        zoom.translateTo = function(selection, x, y, p, event) {
            zoom.transform(selection, function() {
                var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
                return constrain(identity.translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
            }, p, event);
        };
        function scale(transform, k) {
            k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
            return k === transform.k ? transform : new Transform(k, transform.x, transform.y);
        }
        function translate(transform, p0, p1) {
            var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
            return x === transform.x && y === transform.y ? transform : new Transform(transform.k, x, y);
        }
        function centroid(extent) {
            return [
                (+extent[0][0] + +extent[1][0]) / 2,
                (+extent[0][1] + +extent[1][1]) / 2
            ];
        }
        function schedule(transition, transform, point, event) {
            transition.on("start.zoom", function() {
                gesture(this, arguments).event(event).start();
            }).on("interrupt.zoom end.zoom", function() {
                gesture(this, arguments).event(event).end();
            }).tween("zoom", function() {
                var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
                return function(t) {
                    if (t === 1) t = b; // Avoid rounding error on end.
                    else {
                        var l = i(t), k = w / l[2];
                        t = new Transform(k, p[0] - l[0] * k, p[1] - l[1] * k);
                    }
                    g.zoom(null, t);
                };
            });
        }
        function gesture(that, args, clean) {
            return !clean && that.__zooming || new Gesture(that, args);
        }
        function Gesture(that, args) {
            this.that = that;
            this.args = args;
            this.active = 0;
            this.sourceEvent = null;
            this.extent = extent.apply(that, args);
            this.taps = 0;
        }
        Gesture.prototype = {
            event: function(event) {
                if (event) this.sourceEvent = event;
                return this;
            },
            start: function() {
                if (++this.active === 1) {
                    this.that.__zooming = this;
                    this.emit("start");
                }
                return this;
            },
            zoom: function(key, transform) {
                if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
                if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
                if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
                this.that.__zoom = transform;
                this.emit("zoom");
                return this;
            },
            end: function() {
                if (--this.active === 0) {
                    delete this.that.__zooming;
                    this.emit("end");
                }
                return this;
            },
            emit: function(type) {
                var d = select(this.that).datum();
                listeners.call(type, this.that, new ZoomEvent(type, {
                    sourceEvent: this.sourceEvent,
                    target: zoom,
                    type: type,
                    transform: this.that.__zoom,
                    dispatch: listeners
                }), d);
            }
        };
        function wheeled(event, ...args) {
            if (!filter.apply(this, arguments)) return;
            var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = pointer(event);
            // If the mouse is in the same location as before, reuse it.
            // If there were recent wheel events, reset the wheel idle timeout.
            if (g.wheel) {
                if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
                clearTimeout(g.wheel);
            } else if (t.k === k) return;
            else {
                g.mouse = [
                    p,
                    t.invert(p)
                ];
                interrupt(this);
                g.start();
            }
            noevent(event);
            g.wheel = setTimeout(wheelidled, wheelDelay);
            g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
            function wheelidled() {
                g.wheel = null;
                g.end();
            }
        }
        function mousedowned(event, ...args) {
            if (touchending || !filter.apply(this, arguments)) return;
            var currentTarget = event.currentTarget, g = gesture(this, args, true).event(event), v = select(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = pointer(event, currentTarget), x0 = event.clientX, y0 = event.clientY;
            dragDisable(event.view);
            nopropagation(event);
            g.mouse = [
                p,
                this.__zoom.invert(p)
            ];
            interrupt(this);
            g.start();
            function mousemoved(event) {
                noevent(event);
                if (!g.moved) {
                    var dx = event.clientX - x0, dy = event.clientY - y0;
                    g.moved = dx * dx + dy * dy > clickDistance2;
                }
                g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = pointer(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
            }
            function mouseupped(event) {
                v.on("mousemove.zoom mouseup.zoom", null);
                yesdrag(event.view, g.moved);
                noevent(event);
                g.event(event).end();
            }
        }
        function dblclicked(event, ...args) {
            if (!filter.apply(this, arguments)) return;
            var t0 = this.__zoom, p0 = pointer(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
            noevent(event);
            if (duration > 0) select(this).transition().duration(duration).call(schedule, t1, p0, event);
            else select(this).call(zoom.transform, t1, p0, event);
        }
        function touchstarted(event, ...args) {
            if (!filter.apply(this, arguments)) return;
            var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
            nopropagation(event);
            for(i = 0; i < n; ++i){
                t = touches[i], p = pointer(t, this);
                p = [
                    p,
                    this.__zoom.invert(p),
                    t.identifier
                ];
                if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
                else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
            }
            if (touchstarting) touchstarting = clearTimeout(touchstarting);
            if (started) {
                if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                    touchstarting = null;
                }, touchDelay);
                interrupt(this);
                g.start();
            }
        }
        function touchmoved(event, ...args) {
            if (!this.__zooming) return;
            var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
            noevent(event);
            for(i = 0; i < n; ++i){
                t = touches[i], p = pointer(t, this);
                if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
                else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
            }
            t = g.that.__zoom;
            if (g.touch1) {
                var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
                t = scale(t, Math.sqrt(dp / dl));
                p = [
                    (p0[0] + p1[0]) / 2,
                    (p0[1] + p1[1]) / 2
                ];
                l = [
                    (l0[0] + l1[0]) / 2,
                    (l0[1] + l1[1]) / 2
                ];
            } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
            else return;
            g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
        }
        function touchended(event, ...args) {
            if (!this.__zooming) return;
            var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
            nopropagation(event);
            if (touchending) clearTimeout(touchending);
            touchending = setTimeout(function() {
                touchending = null;
            }, touchDelay);
            for(i = 0; i < n; ++i){
                t = touches[i];
                if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
                else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
            }
            if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
            if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
            else {
                g.end();
                // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
                if (g.taps === 2) {
                    t = pointer(t, this);
                    if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                        var p = select(this).on("dblclick.zoom");
                        if (p) p.apply(this, arguments);
                    }
                }
            }
        }
        zoom.wheelDelta = function(_) {
            return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : constant(+_), zoom) : wheelDelta;
        };
        zoom.filter = function(_) {
            return arguments.length ? (filter = typeof _ === "function" ? _ : constant(!!_), zoom) : filter;
        };
        zoom.touchable = function(_) {
            return arguments.length ? (touchable = typeof _ === "function" ? _ : constant(!!_), zoom) : touchable;
        };
        zoom.extent = function(_) {
            return arguments.length ? (extent = typeof _ === "function" ? _ : constant([
                [
                    +_[0][0],
                    +_[0][1]
                ],
                [
                    +_[1][0],
                    +_[1][1]
                ]
            ]), zoom) : extent;
        };
        zoom.scaleExtent = function(_) {
            return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
                scaleExtent[0],
                scaleExtent[1]
            ];
        };
        zoom.translateExtent = function(_) {
            return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
                [
                    translateExtent[0][0],
                    translateExtent[0][1]
                ],
                [
                    translateExtent[1][0],
                    translateExtent[1][1]
                ]
            ];
        };
        zoom.constrain = function(_) {
            return arguments.length ? (constrain = _, zoom) : constrain;
        };
        zoom.duration = function(_) {
            return arguments.length ? (duration = +_, zoom) : duration;
        };
        zoom.interpolate = function(_) {
            return arguments.length ? (interpolate = _, zoom) : interpolate;
        };
        zoom.on = function() {
            var value = listeners.on.apply(listeners, arguments);
            return value === listeners ? zoom : value;
        };
        zoom.clickDistance = function(_) {
            return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
        };
        zoom.tapDistance = function(_) {
            return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
        };
        return zoom;
    }
    exports1.Adder = Adder;
    exports1.Delaunay = Delaunay;
    exports1.FormatSpecifier = FormatSpecifier;
    exports1.InternMap = InternMap;
    exports1.InternSet = InternSet;
    exports1.Node = Node$1;
    exports1.Voronoi = Voronoi;
    exports1.ZoomTransform = Transform;
    exports1.active = active;
    exports1.arc = arc;
    exports1.area = area;
    exports1.areaRadial = areaRadial;
    exports1.ascending = ascending$3;
    exports1.autoType = autoType;
    exports1.axisBottom = axisBottom;
    exports1.axisLeft = axisLeft;
    exports1.axisRight = axisRight;
    exports1.axisTop = axisTop;
    exports1.bin = bin;
    exports1.bisect = bisect;
    exports1.bisectCenter = bisectCenter;
    exports1.bisectLeft = bisectLeft;
    exports1.bisectRight = bisectRight;
    exports1.bisector = bisector;
    exports1.blob = blob;
    exports1.blur = blur;
    exports1.blur2 = blur2;
    exports1.blurImage = blurImage;
    exports1.brush = brush;
    exports1.brushSelection = brushSelection;
    exports1.brushX = brushX;
    exports1.brushY = brushY;
    exports1.buffer = buffer;
    exports1.chord = chord;
    exports1.chordDirected = chordDirected;
    exports1.chordTranspose = chordTranspose;
    exports1.cluster = cluster;
    exports1.color = color;
    exports1.contourDensity = density;
    exports1.contours = Contours;
    exports1.count = count$1;
    exports1.create = create$1;
    exports1.creator = creator;
    exports1.cross = cross$2;
    exports1.csv = csv;
    exports1.csvFormat = csvFormat;
    exports1.csvFormatBody = csvFormatBody;
    exports1.csvFormatRow = csvFormatRow;
    exports1.csvFormatRows = csvFormatRows;
    exports1.csvFormatValue = csvFormatValue;
    exports1.csvParse = csvParse;
    exports1.csvParseRows = csvParseRows;
    exports1.cubehelix = cubehelix$3;
    exports1.cumsum = cumsum;
    exports1.curveBasis = basis;
    exports1.curveBasisClosed = basisClosed;
    exports1.curveBasisOpen = basisOpen;
    exports1.curveBumpX = bumpX;
    exports1.curveBumpY = bumpY;
    exports1.curveBundle = bundle;
    exports1.curveCardinal = cardinal;
    exports1.curveCardinalClosed = cardinalClosed;
    exports1.curveCardinalOpen = cardinalOpen;
    exports1.curveCatmullRom = catmullRom;
    exports1.curveCatmullRomClosed = catmullRomClosed;
    exports1.curveCatmullRomOpen = catmullRomOpen;
    exports1.curveLinear = curveLinear;
    exports1.curveLinearClosed = linearClosed;
    exports1.curveMonotoneX = monotoneX;
    exports1.curveMonotoneY = monotoneY;
    exports1.curveNatural = natural;
    exports1.curveStep = step;
    exports1.curveStepAfter = stepAfter;
    exports1.curveStepBefore = stepBefore;
    exports1.descending = descending$2;
    exports1.deviation = deviation;
    exports1.difference = difference;
    exports1.disjoint = disjoint;
    exports1.dispatch = dispatch;
    exports1.drag = drag;
    exports1.dragDisable = dragDisable;
    exports1.dragEnable = yesdrag;
    exports1.dsv = dsv;
    exports1.dsvFormat = dsvFormat;
    exports1.easeBack = backInOut;
    exports1.easeBackIn = backIn;
    exports1.easeBackInOut = backInOut;
    exports1.easeBackOut = backOut;
    exports1.easeBounce = bounceOut;
    exports1.easeBounceIn = bounceIn;
    exports1.easeBounceInOut = bounceInOut;
    exports1.easeBounceOut = bounceOut;
    exports1.easeCircle = circleInOut;
    exports1.easeCircleIn = circleIn;
    exports1.easeCircleInOut = circleInOut;
    exports1.easeCircleOut = circleOut;
    exports1.easeCubic = cubicInOut;
    exports1.easeCubicIn = cubicIn;
    exports1.easeCubicInOut = cubicInOut;
    exports1.easeCubicOut = cubicOut;
    exports1.easeElastic = elasticOut;
    exports1.easeElasticIn = elasticIn;
    exports1.easeElasticInOut = elasticInOut;
    exports1.easeElasticOut = elasticOut;
    exports1.easeExp = expInOut;
    exports1.easeExpIn = expIn;
    exports1.easeExpInOut = expInOut;
    exports1.easeExpOut = expOut;
    exports1.easeLinear = linear$1;
    exports1.easePoly = polyInOut;
    exports1.easePolyIn = polyIn;
    exports1.easePolyInOut = polyInOut;
    exports1.easePolyOut = polyOut;
    exports1.easeQuad = quadInOut;
    exports1.easeQuadIn = quadIn;
    exports1.easeQuadInOut = quadInOut;
    exports1.easeQuadOut = quadOut;
    exports1.easeSin = sinInOut;
    exports1.easeSinIn = sinIn;
    exports1.easeSinInOut = sinInOut;
    exports1.easeSinOut = sinOut;
    exports1.every = every;
    exports1.extent = extent$1;
    exports1.fcumsum = fcumsum;
    exports1.filter = filter$1;
    exports1.flatGroup = flatGroup;
    exports1.flatRollup = flatRollup;
    exports1.forceCenter = center;
    exports1.forceCollide = collide;
    exports1.forceLink = link$2;
    exports1.forceManyBody = manyBody;
    exports1.forceRadial = radial$1;
    exports1.forceSimulation = simulation;
    exports1.forceX = x$2;
    exports1.forceY = y$1;
    exports1.formatDefaultLocale = defaultLocale$1;
    exports1.formatLocale = formatLocale$1;
    exports1.formatSpecifier = formatSpecifier;
    exports1.fsum = fsum;
    exports1.geoAlbers = albers;
    exports1.geoAlbersUsa = albersUsa;
    exports1.geoArea = area$2;
    exports1.geoAzimuthalEqualArea = azimuthalEqualArea;
    exports1.geoAzimuthalEqualAreaRaw = azimuthalEqualAreaRaw;
    exports1.geoAzimuthalEquidistant = azimuthalEquidistant;
    exports1.geoAzimuthalEquidistantRaw = azimuthalEquidistantRaw;
    exports1.geoBounds = bounds;
    exports1.geoCentroid = centroid$1;
    exports1.geoCircle = circle$2;
    exports1.geoClipAntimeridian = clipAntimeridian;
    exports1.geoClipCircle = clipCircle;
    exports1.geoClipExtent = extent;
    exports1.geoClipRectangle = clipRectangle;
    exports1.geoConicConformal = conicConformal;
    exports1.geoConicConformalRaw = conicConformalRaw;
    exports1.geoConicEqualArea = conicEqualArea;
    exports1.geoConicEqualAreaRaw = conicEqualAreaRaw;
    exports1.geoConicEquidistant = conicEquidistant;
    exports1.geoConicEquidistantRaw = conicEquidistantRaw;
    exports1.geoContains = contains$1;
    exports1.geoDistance = distance;
    exports1.geoEqualEarth = equalEarth;
    exports1.geoEqualEarthRaw = equalEarthRaw;
    exports1.geoEquirectangular = equirectangular;
    exports1.geoEquirectangularRaw = equirectangularRaw;
    exports1.geoGnomonic = gnomonic;
    exports1.geoGnomonicRaw = gnomonicRaw;
    exports1.geoGraticule = graticule;
    exports1.geoGraticule10 = graticule10;
    exports1.geoIdentity = identity$4;
    exports1.geoInterpolate = interpolate;
    exports1.geoLength = length$1;
    exports1.geoMercator = mercator;
    exports1.geoMercatorRaw = mercatorRaw;
    exports1.geoNaturalEarth1 = naturalEarth1;
    exports1.geoNaturalEarth1Raw = naturalEarth1Raw;
    exports1.geoOrthographic = orthographic;
    exports1.geoOrthographicRaw = orthographicRaw;
    exports1.geoPath = index$2;
    exports1.geoProjection = projection;
    exports1.geoProjectionMutator = projectionMutator;
    exports1.geoRotation = rotation;
    exports1.geoStereographic = stereographic;
    exports1.geoStereographicRaw = stereographicRaw;
    exports1.geoStream = geoStream;
    exports1.geoTransform = transform$1;
    exports1.geoTransverseMercator = transverseMercator;
    exports1.geoTransverseMercatorRaw = transverseMercatorRaw;
    exports1.gray = gray;
    exports1.greatest = greatest;
    exports1.greatestIndex = greatestIndex;
    exports1.group = group;
    exports1.groupSort = groupSort;
    exports1.groups = groups;
    exports1.hcl = hcl$2;
    exports1.hierarchy = hierarchy;
    exports1.histogram = bin;
    exports1.hsl = hsl$2;
    exports1.html = html;
    exports1.image = image;
    exports1.index = index$4;
    exports1.indexes = indexes;
    exports1.interpolate = interpolate$2;
    exports1.interpolateArray = array$3;
    exports1.interpolateBasis = basis$2;
    exports1.interpolateBasisClosed = basisClosed$1;
    exports1.interpolateBlues = Blues;
    exports1.interpolateBrBG = BrBG;
    exports1.interpolateBuGn = BuGn;
    exports1.interpolateBuPu = BuPu;
    exports1.interpolateCividis = cividis;
    exports1.interpolateCool = cool;
    exports1.interpolateCubehelix = cubehelix$2;
    exports1.interpolateCubehelixDefault = cubehelix;
    exports1.interpolateCubehelixLong = cubehelixLong;
    exports1.interpolateDate = date$1;
    exports1.interpolateDiscrete = discrete;
    exports1.interpolateGnBu = GnBu;
    exports1.interpolateGreens = Greens;
    exports1.interpolateGreys = Greys;
    exports1.interpolateHcl = hcl$1;
    exports1.interpolateHclLong = hclLong;
    exports1.interpolateHsl = hsl$1;
    exports1.interpolateHslLong = hslLong;
    exports1.interpolateHue = hue;
    exports1.interpolateInferno = inferno;
    exports1.interpolateLab = lab;
    exports1.interpolateMagma = magma;
    exports1.interpolateNumber = interpolateNumber;
    exports1.interpolateNumberArray = numberArray;
    exports1.interpolateObject = object$1;
    exports1.interpolateOrRd = OrRd;
    exports1.interpolateOranges = Oranges;
    exports1.interpolatePRGn = PRGn;
    exports1.interpolatePiYG = PiYG;
    exports1.interpolatePlasma = plasma;
    exports1.interpolatePuBu = PuBu;
    exports1.interpolatePuBuGn = PuBuGn;
    exports1.interpolatePuOr = PuOr;
    exports1.interpolatePuRd = PuRd;
    exports1.interpolatePurples = Purples;
    exports1.interpolateRainbow = rainbow;
    exports1.interpolateRdBu = RdBu;
    exports1.interpolateRdGy = RdGy;
    exports1.interpolateRdPu = RdPu;
    exports1.interpolateRdYlBu = RdYlBu;
    exports1.interpolateRdYlGn = RdYlGn;
    exports1.interpolateReds = Reds;
    exports1.interpolateRgb = interpolateRgb;
    exports1.interpolateRgbBasis = rgbBasis;
    exports1.interpolateRgbBasisClosed = rgbBasisClosed;
    exports1.interpolateRound = interpolateRound;
    exports1.interpolateSinebow = sinebow;
    exports1.interpolateSpectral = Spectral;
    exports1.interpolateString = interpolateString;
    exports1.interpolateTransformCss = interpolateTransformCss;
    exports1.interpolateTransformSvg = interpolateTransformSvg;
    exports1.interpolateTurbo = turbo;
    exports1.interpolateViridis = viridis;
    exports1.interpolateWarm = warm;
    exports1.interpolateYlGn = YlGn;
    exports1.interpolateYlGnBu = YlGnBu;
    exports1.interpolateYlOrBr = YlOrBr;
    exports1.interpolateYlOrRd = YlOrRd;
    exports1.interpolateZoom = interpolateZoom;
    exports1.interrupt = interrupt;
    exports1.intersection = intersection;
    exports1.interval = interval;
    exports1.isoFormat = formatIso$1;
    exports1.isoParse = parseIso$1;
    exports1.json = json;
    exports1.lab = lab$1;
    exports1.lch = lch;
    exports1.least = least;
    exports1.leastIndex = leastIndex;
    exports1.line = line;
    exports1.lineRadial = lineRadial$1;
    exports1.link = link;
    exports1.linkHorizontal = linkHorizontal;
    exports1.linkRadial = linkRadial;
    exports1.linkVertical = linkVertical;
    exports1.local = local$1;
    exports1.map = map$1;
    exports1.matcher = matcher;
    exports1.max = max$3;
    exports1.maxIndex = maxIndex;
    exports1.mean = mean;
    exports1.median = median;
    exports1.medianIndex = medianIndex;
    exports1.merge = merge;
    exports1.min = min$2;
    exports1.minIndex = minIndex;
    exports1.mode = mode;
    exports1.namespace = namespace;
    exports1.namespaces = namespaces;
    exports1.nice = nice$1;
    exports1.now = now;
    exports1.pack = index$1;
    exports1.packEnclose = enclose;
    exports1.packSiblings = siblings;
    exports1.pairs = pairs;
    exports1.partition = partition;
    exports1.path = path;
    exports1.permute = permute;
    exports1.pie = pie;
    exports1.piecewise = piecewise;
    exports1.pointRadial = pointRadial;
    exports1.pointer = pointer;
    exports1.pointers = pointers;
    exports1.polygonArea = area$1;
    exports1.polygonCentroid = centroid;
    exports1.polygonContains = contains;
    exports1.polygonHull = hull;
    exports1.polygonLength = length;
    exports1.precisionFixed = precisionFixed;
    exports1.precisionPrefix = precisionPrefix;
    exports1.precisionRound = precisionRound;
    exports1.quadtree = quadtree;
    exports1.quantile = quantile$1;
    exports1.quantileIndex = quantileIndex;
    exports1.quantileSorted = quantileSorted;
    exports1.quantize = quantize$1;
    exports1.quickselect = quickselect;
    exports1.radialArea = areaRadial;
    exports1.radialLine = lineRadial$1;
    exports1.randomBates = bates;
    exports1.randomBernoulli = bernoulli;
    exports1.randomBeta = beta;
    exports1.randomBinomial = binomial;
    exports1.randomCauchy = cauchy;
    exports1.randomExponential = exponential;
    exports1.randomGamma = gamma;
    exports1.randomGeometric = geometric;
    exports1.randomInt = int;
    exports1.randomIrwinHall = irwinHall;
    exports1.randomLcg = lcg;
    exports1.randomLogNormal = logNormal;
    exports1.randomLogistic = logistic;
    exports1.randomNormal = normal;
    exports1.randomPareto = pareto;
    exports1.randomPoisson = poisson;
    exports1.randomUniform = uniform;
    exports1.randomWeibull = weibull;
    exports1.range = range$2;
    exports1.rank = rank;
    exports1.reduce = reduce;
    exports1.reverse = reverse$1;
    exports1.rgb = rgb;
    exports1.ribbon = ribbon$1;
    exports1.ribbonArrow = ribbonArrow;
    exports1.rollup = rollup;
    exports1.rollups = rollups;
    exports1.scaleBand = band;
    exports1.scaleDiverging = diverging$1;
    exports1.scaleDivergingLog = divergingLog;
    exports1.scaleDivergingPow = divergingPow;
    exports1.scaleDivergingSqrt = divergingSqrt;
    exports1.scaleDivergingSymlog = divergingSymlog;
    exports1.scaleIdentity = identity$2;
    exports1.scaleImplicit = implicit;
    exports1.scaleLinear = linear;
    exports1.scaleLog = log;
    exports1.scaleOrdinal = ordinal;
    exports1.scalePoint = point$4;
    exports1.scalePow = pow;
    exports1.scaleQuantile = quantile;
    exports1.scaleQuantize = quantize;
    exports1.scaleRadial = radial;
    exports1.scaleSequential = sequential;
    exports1.scaleSequentialLog = sequentialLog;
    exports1.scaleSequentialPow = sequentialPow;
    exports1.scaleSequentialQuantile = sequentialQuantile;
    exports1.scaleSequentialSqrt = sequentialSqrt;
    exports1.scaleSequentialSymlog = sequentialSymlog;
    exports1.scaleSqrt = sqrt$1;
    exports1.scaleSymlog = symlog;
    exports1.scaleThreshold = threshold;
    exports1.scaleTime = time;
    exports1.scaleUtc = utcTime;
    exports1.scan = scan;
    exports1.schemeAccent = Accent;
    exports1.schemeBlues = scheme$5;
    exports1.schemeBrBG = scheme$q;
    exports1.schemeBuGn = scheme$h;
    exports1.schemeBuPu = scheme$g;
    exports1.schemeCategory10 = category10;
    exports1.schemeDark2 = Dark2;
    exports1.schemeGnBu = scheme$f;
    exports1.schemeGreens = scheme$4;
    exports1.schemeGreys = scheme$3;
    exports1.schemeOrRd = scheme$e;
    exports1.schemeOranges = scheme;
    exports1.schemePRGn = scheme$p;
    exports1.schemePaired = Paired;
    exports1.schemePastel1 = Pastel1;
    exports1.schemePastel2 = Pastel2;
    exports1.schemePiYG = scheme$o;
    exports1.schemePuBu = scheme$c;
    exports1.schemePuBuGn = scheme$d;
    exports1.schemePuOr = scheme$n;
    exports1.schemePuRd = scheme$b;
    exports1.schemePurples = scheme$2;
    exports1.schemeRdBu = scheme$m;
    exports1.schemeRdGy = scheme$l;
    exports1.schemeRdPu = scheme$a;
    exports1.schemeRdYlBu = scheme$k;
    exports1.schemeRdYlGn = scheme$j;
    exports1.schemeReds = scheme$1;
    exports1.schemeSet1 = Set1;
    exports1.schemeSet2 = Set2;
    exports1.schemeSet3 = Set3;
    exports1.schemeSpectral = scheme$i;
    exports1.schemeTableau10 = Tableau10;
    exports1.schemeYlGn = scheme$8;
    exports1.schemeYlGnBu = scheme$9;
    exports1.schemeYlOrBr = scheme$7;
    exports1.schemeYlOrRd = scheme$6;
    exports1.select = select;
    exports1.selectAll = selectAll;
    exports1.selection = selection;
    exports1.selector = selector;
    exports1.selectorAll = selectorAll;
    exports1.shuffle = shuffle$1;
    exports1.shuffler = shuffler;
    exports1.some = some;
    exports1.sort = sort;
    exports1.stack = stack;
    exports1.stackOffsetDiverging = diverging;
    exports1.stackOffsetExpand = expand;
    exports1.stackOffsetNone = none$1;
    exports1.stackOffsetSilhouette = silhouette;
    exports1.stackOffsetWiggle = wiggle;
    exports1.stackOrderAppearance = appearance;
    exports1.stackOrderAscending = ascending;
    exports1.stackOrderDescending = descending;
    exports1.stackOrderInsideOut = insideOut;
    exports1.stackOrderNone = none;
    exports1.stackOrderReverse = reverse;
    exports1.stratify = stratify;
    exports1.style = styleValue;
    exports1.subset = subset;
    exports1.sum = sum$2;
    exports1.superset = superset;
    exports1.svg = svg;
    exports1.symbol = Symbol$1;
    exports1.symbolAsterisk = asterisk;
    exports1.symbolCircle = circle;
    exports1.symbolCross = cross;
    exports1.symbolDiamond = diamond;
    exports1.symbolDiamond2 = diamond2;
    exports1.symbolPlus = plus;
    exports1.symbolSquare = square;
    exports1.symbolSquare2 = square2;
    exports1.symbolStar = star;
    exports1.symbolTriangle = triangle;
    exports1.symbolTriangle2 = triangle2;
    exports1.symbolWye = wye;
    exports1.symbolX = x;
    exports1.symbols = symbolsFill;
    exports1.symbolsFill = symbolsFill;
    exports1.symbolsStroke = symbolsStroke;
    exports1.text = text;
    exports1.thresholdFreedmanDiaconis = thresholdFreedmanDiaconis;
    exports1.thresholdScott = thresholdScott;
    exports1.thresholdSturges = thresholdSturges;
    exports1.tickFormat = tickFormat;
    exports1.tickIncrement = tickIncrement;
    exports1.tickStep = tickStep;
    exports1.ticks = ticks;
    exports1.timeDay = timeDay;
    exports1.timeDays = timeDays;
    exports1.timeFormatDefaultLocale = defaultLocale;
    exports1.timeFormatLocale = formatLocale;
    exports1.timeFriday = timeFriday;
    exports1.timeFridays = timeFridays;
    exports1.timeHour = timeHour;
    exports1.timeHours = timeHours;
    exports1.timeInterval = timeInterval;
    exports1.timeMillisecond = millisecond;
    exports1.timeMilliseconds = milliseconds;
    exports1.timeMinute = timeMinute;
    exports1.timeMinutes = timeMinutes;
    exports1.timeMonday = timeMonday;
    exports1.timeMondays = timeMondays;
    exports1.timeMonth = timeMonth;
    exports1.timeMonths = timeMonths;
    exports1.timeSaturday = timeSaturday;
    exports1.timeSaturdays = timeSaturdays;
    exports1.timeSecond = second;
    exports1.timeSeconds = seconds;
    exports1.timeSunday = timeSunday;
    exports1.timeSundays = timeSundays;
    exports1.timeThursday = timeThursday;
    exports1.timeThursdays = timeThursdays;
    exports1.timeTickInterval = timeTickInterval;
    exports1.timeTicks = timeTicks;
    exports1.timeTuesday = timeTuesday;
    exports1.timeTuesdays = timeTuesdays;
    exports1.timeWednesday = timeWednesday;
    exports1.timeWednesdays = timeWednesdays;
    exports1.timeWeek = timeSunday;
    exports1.timeWeeks = timeSundays;
    exports1.timeYear = timeYear;
    exports1.timeYears = timeYears;
    exports1.timeout = timeout;
    exports1.timer = timer;
    exports1.timerFlush = timerFlush;
    exports1.transition = transition;
    exports1.transpose = transpose;
    exports1.tree = tree;
    exports1.treemap = index;
    exports1.treemapBinary = binary;
    exports1.treemapDice = treemapDice;
    exports1.treemapResquarify = resquarify;
    exports1.treemapSlice = treemapSlice;
    exports1.treemapSliceDice = sliceDice;
    exports1.treemapSquarify = squarify;
    exports1.tsv = tsv;
    exports1.tsvFormat = tsvFormat;
    exports1.tsvFormatBody = tsvFormatBody;
    exports1.tsvFormatRow = tsvFormatRow;
    exports1.tsvFormatRows = tsvFormatRows;
    exports1.tsvFormatValue = tsvFormatValue;
    exports1.tsvParse = tsvParse;
    exports1.tsvParseRows = tsvParseRows;
    exports1.union = union;
    exports1.unixDay = unixDay;
    exports1.unixDays = unixDays;
    exports1.utcDay = utcDay;
    exports1.utcDays = utcDays;
    exports1.utcFriday = utcFriday;
    exports1.utcFridays = utcFridays;
    exports1.utcHour = utcHour;
    exports1.utcHours = utcHours;
    exports1.utcMillisecond = millisecond;
    exports1.utcMilliseconds = milliseconds;
    exports1.utcMinute = utcMinute;
    exports1.utcMinutes = utcMinutes;
    exports1.utcMonday = utcMonday;
    exports1.utcMondays = utcMondays;
    exports1.utcMonth = utcMonth;
    exports1.utcMonths = utcMonths;
    exports1.utcSaturday = utcSaturday;
    exports1.utcSaturdays = utcSaturdays;
    exports1.utcSecond = second;
    exports1.utcSeconds = seconds;
    exports1.utcSunday = utcSunday;
    exports1.utcSundays = utcSundays;
    exports1.utcThursday = utcThursday;
    exports1.utcThursdays = utcThursdays;
    exports1.utcTickInterval = utcTickInterval;
    exports1.utcTicks = utcTicks;
    exports1.utcTuesday = utcTuesday;
    exports1.utcTuesdays = utcTuesdays;
    exports1.utcWednesday = utcWednesday;
    exports1.utcWednesdays = utcWednesdays;
    exports1.utcWeek = utcSunday;
    exports1.utcWeeks = utcSundays;
    exports1.utcYear = utcYear;
    exports1.utcYears = utcYears;
    exports1.variance = variance;
    exports1.version = version;
    exports1.window = defaultView;
    exports1.xml = xml;
    exports1.zip = zip;
    exports1.zoom = zoom;
    exports1.zoomIdentity = identity;
    exports1.zoomTransform = transform;
});

});



parcelRegister("hqZma", function(module, exports) {

$parcel$export(module.exports, "AxisBottomTick", () => $cb1475830d00691d$export$34bea378c04af713);
$parcel$export(module.exports, "AxisBottomLine", () => $cb1475830d00691d$export$84b05a0ae8b61ab5);
$parcel$export(module.exports, "AxisBottomText", () => $cb1475830d00691d$export$ebfad67a29d89d08);
$parcel$export(module.exports, "AxisBottom", () => $cb1475830d00691d$export$deea0fad05dcb466);
/* AxisBottom.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $bT1Sw = parcelRequire("bT1Sw");

var $eFK63 = parcelRequire("eFK63");

var $jxg43 = parcelRequire("jxg43");

var $42C9W = parcelRequire("42C9W");

var $f8uii = parcelRequire("f8uii");

var $da7Ww = parcelRequire("da7Ww");

var $l5ab7 = parcelRequire("l5ab7");

var $2vbO1 = parcelRequire("2vbO1");

var $kq3PX = parcelRequire("kq3PX");

var $2OMIu = parcelRequire("2OMIu");
const $cb1475830d00691d$export$cd0785a309729df9 = {
    color: "var(--ds-text-subtlest, grey)",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    fontSize: 12,
    textAlign: 'center'
};
const $cb1475830d00691d$var$tickLength = 8;
const $cb1475830d00691d$var$orientation = (0, $jxg43.default).bottom;
const $cb1475830d00691d$export$34bea378c04af713 = (0, $bT1Sw.element)((0, $l5ab7.Tick));
const $cb1475830d00691d$export$84b05a0ae8b61ab5 = (0, $bT1Sw.element)((_ref)=>{
    let { width: width, top: top, hide: hide } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $da7Ww.AxisLine), {
        hide: hide,
        style: {
            borderBottom: `${(0, $da7Ww.axisLineStroke)} solid 2px`,
            width: `${width}px`,
            position: 'absolute',
            top: `${top}px`
        }
    });
});
const $cb1475830d00691d$export$ebfad67a29d89d08 = (0, $bT1Sw.element)((_ref2)=>{
    let { width: width, formatter: formatter, truncate: truncate, singleline: singleline, children: children, transform: transform } = _ref2;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2vbO1.TickText), {
        style: {
            width: width,
            transform: transform
        },
        formatter: formatter,
        truncate: truncate,
        singleline: singleline,
        children: children
    });
});
function $cb1475830d00691d$var$AxisBottom(_ref3) {
    let { scale: scale, numTicks: numTicks, tickValues: tickValues, top: top, left: left, rangePadding: rangePadding, hideZero: hideZero, label: label, hide: hide } = _ref3;
    if (hide) return null;
    const { ticks: ticks } = (0, $kq3PX.useAxisTicks)({
        scale: scale,
        numTicks: numTicks,
        tickValues: tickValues,
        orientation: $cb1475830d00691d$var$orientation,
        rangePadding: rangePadding,
        hideZero: hideZero,
        tickLength: $cb1475830d00691d$var$tickLength
    });
    const TickTextsComponent = ticks.map((_ref4)=>{
        let { value: value, index: index, from: from, to: to } = _ref4;
        const formatter = (0, $f8uii.default)(scale);
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            style: {
                left: `${to.x}px`
            },
            className: (0, $bwpsq.default)([
                "_yyhykb7n _1ii7kb7n _kqswh2mm _1bsbidpf _syaz13nv _ect41wi2 _1wyb1crf _y3gn1h6o"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($cb1475830d00691d$export$ebfad67a29d89d08, {
                width: Number(scale.range()[1]) / ticks.length,
                formatter: formatter,
                truncate: (0, $42C9W.default)(scale) === 'string',
                transform: "translateX(-50%)",
                children: value
            })
        }, `axis-bottom-text-${index}-${value}-${from.toArray()}-${to.toArray()}`);
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                style: {
                    gridArea: 'plot'
                },
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($cb1475830d00691d$export$84b05a0ae8b61ab5, {
                    width: left,
                    top: top
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                style: {
                    gridArea: 'axis-bottom',
                    display: 'grid',
                    gridTemplateRows: 'auto min-content'
                },
                "data-axis-type": "axis-bottom",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            "_1e0c11p5 _yv0ehkll _2z05hkll _ca0q1crf _lcxvglyw"
                        ]),
                        children: TickTextsComponent
                    }),
                    label && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        style: {
                            paddingTop: '8px',
                            width: '100%',
                            textAlign: 'center',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            ...(0, $eFK63.defaultTextHTMLProps)
                        },
                        children: label
                    })
                ]
            })
        ]
    });
}
const $cb1475830d00691d$export$deea0fad05dcb466 = (0, $bT1Sw.element)($cb1475830d00691d$var$AxisBottom);

});
parcelRegister("eFK63", function(module, exports) {

$parcel$export(module.exports, "defaultTextHTMLProps", () => $aae8a6d9dacb0080$export$51ee3858fd381684);
const $aae8a6d9dacb0080$export$554ff5554bedd348 = {
    textAnchor: 'middle',
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    fontSize: 12,
    color: "var(--ds-text-subtlest, lightgrey)"
};
const $aae8a6d9dacb0080$export$51ee3858fd381684 = {
    textAlign: 'center',
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    fontSize: 12,
    color: "var(--ds-text-subtlest, lightgrey)"
};

});

parcelRegister("jxg43", function(module, exports) {

$parcel$export(module.exports, "default", () => $e38d8f70dd0cbed6$export$2e2bcd8739ae039);
const $e38d8f70dd0cbed6$var$Orientation = {
    top: 'top',
    left: 'left',
    right: 'right',
    bottom: 'bottom'
};
var $e38d8f70dd0cbed6$export$2e2bcd8739ae039 = $e38d8f70dd0cbed6$var$Orientation;

});

parcelRegister("42C9W", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f14f2f7f7ffed93$export$2e2bcd8739ae039);
/**
 * Uses the scale domain to check the type of data.
 *
 * If domainValues[0] ends up being null, we will return string. Since null
 * can only be value on ordinal axis.
 */ function $2f14f2f7f7ffed93$export$2e2bcd8739ae039(scale) {
    const domainValues = scale.domain();
    if (domainValues.length === 0) return 'string';
    if (domainValues[0] instanceof Date || domainValues[domainValues.length - 1] instanceof Date) return 'time';
    else if (typeof domainValues[0] === 'number') return 'number';
    else return 'string';
}

});

parcelRegister("f8uii", function(module, exports) {

$parcel$export(module.exports, "default", () => $b04f1a26b98e19d6$export$2e2bcd8739ae039);

var $ltC0t = parcelRequire("ltC0t");
function $b04f1a26b98e19d6$export$2e2bcd8739ae039(scale) {
    // Broaden type before using 'xxx' in s as typeguard.
    const s = scale;
    // For point or band scales,
    // have to add offset to make the tick centered.
    if (scale.domain()[0] instanceof Date || scale.domain()[1] instanceof Date) return (0, $ltC0t.default).multiTimeFormat;
    else if ('tickFormat' in s) return (0, $ltC0t.default).formatNumberAbbreviated;
    return String;
}

});

parcelRegister("da7Ww", function(module, exports) {

$parcel$export(module.exports, "axisLineStroke", () => $99525ed62f9828e4$export$1b23eda9d50a8331);
$parcel$export(module.exports, "AxisLine", () => $99525ed62f9828e4$export$6b38ce563ca3e26b);

var $bT1Sw = parcelRequire("bT1Sw");

var $2OMIu = parcelRequire("2OMIu");
const $99525ed62f9828e4$export$1b23eda9d50a8331 = "var(--ds-border-bold, lightgrey)";
const $99525ed62f9828e4$export$6b38ce563ca3e26b = (0, $bT1Sw.element)((props)=>{
    const { style: style, hide: hide } = props;
    if (hide) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: style
    });
});

});

parcelRegister("l5ab7", function(module, exports) {

$parcel$export(module.exports, "Tick", () => $f591f5cc8874127e$export$b1778e7c62739fdb);

var $bT1Sw = parcelRequire("bT1Sw");

var $2OMIu = parcelRequire("2OMIu");
const $f591f5cc8874127e$var$tickStroke = "var(--ds-border-bold, lightgrey)";
const $f591f5cc8874127e$var$TICK_LENGTH = 8;
const $f591f5cc8874127e$var$STROKE_WIDTH = 1;
const $f591f5cc8874127e$export$b1778e7c62739fdb = (0, $bT1Sw.element)((props)=>{
    const { from: from, to: to, hide: hide } = props;
    const isHorizontal = (from === null || from === void 0 ? void 0 : from.y) === (to === null || to === void 0 ? void 0 : to.y);
    if (hide) return null;
    const border = isHorizontal ? {
        borderBottom: `${$f591f5cc8874127e$var$STROKE_WIDTH}px solid ${$f591f5cc8874127e$var$tickStroke}`
    } : {
        borderLeft: `${$f591f5cc8874127e$var$STROKE_WIDTH}px solid ${$f591f5cc8874127e$var$tickStroke}`
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            ...border,
            width: isHorizontal ? $f591f5cc8874127e$var$TICK_LENGTH : 0,
            height: !isHorizontal ? $f591f5cc8874127e$var$TICK_LENGTH : 0,
            position: 'absolute',
            top: `calc(${to === null || to === void 0 ? void 0 : to.y}px)`,
            left: `calc(${from === null || from === void 0 ? void 0 : from.x}px)`,
            transform: isHorizontal ? `translateX(-${$f591f5cc8874127e$var$TICK_LENGTH}px)` : ``
        }
    });
});

});

parcelRegister("2vbO1", function(module, exports) {

$parcel$export(module.exports, "TickText", () => $1d27a2655db0185a$export$d3f6b56e9fbffff3);

var $3bDjY = parcelRequire("3bDjY");

var $hjll3 = parcelRequire("hjll3");

var $5uXOq = parcelRequire("5uXOq");

var $bT1Sw = parcelRequire("bT1Sw");

var $2OMIu = parcelRequire("2OMIu");
const $1d27a2655db0185a$var$TRUNCATE_STYLES = {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
};
const $1d27a2655db0185a$export$d3f6b56e9fbffff3 = (0, $bT1Sw.element)((props)=>{
    // TODO: Force singleline
    const { formatter: formatter, style: style, truncate: truncate, singleline: singleline, children: children } = props;
    const ref = (0, $5uXOq.useRef)(null);
    const truncateStyles = truncate ? $1d27a2655db0185a$var$TRUNCATE_STYLES : {};
    const tickContent = typeof formatter === 'function' ? formatter(children) : (0, $hjll3.timeFormat)(formatter)(children);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        tag: 'div',
        position: "bottom",
        content: tickContent,
        canAppear: ()=>{
            const element = ref.current;
            if (!element) return false;
            return element.offsetWidth < element.scrollWidth;
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ref: ref,
            style: {
                ...style,
                ...truncateStyles,
                pointerEvents: 'auto'
            },
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                children: tickContent
            })
        })
    });
});

});

parcelRegister("kq3PX", function(module, exports) {

$parcel$export(module.exports, "useAxisTicks", () => $edd9364b3322512a$export$b1d0fead756358a0);

var $cMo1a = parcelRequire("cMo1a");
var $eOdM1 = parcelRequire("eOdM1");
var $elPt5 = parcelRequire("elPt5");
var $2YVVm = parcelRequire("2YVVm");

var $jxg43 = parcelRequire("jxg43");


var $8LERT = parcelRequire("8LERT");

var $4ZQLi = parcelRequire("4ZQLi");
function $edd9364b3322512a$export$b1d0fead756358a0(_ref) {
    let { scale: scale, numTicks: numTicks, tickValues: tickValues, tickLength: tickLength, orientation: orientation, hideZero: hideZero = false } = _ref;
    const isLeft = orientation === (0, $jxg43.default).left;
    const isTop = orientation === (0, $jxg43.default).top;
    const horizontal = isTop || orientation === (0, $jxg43.default).bottom;
    const tickPosition = (0, $4ZQLi.default)(scale);
    const tickSign = isLeft || isTop ? -1 : 1;
    const range = scale.range();
    const scaleType = (0, $elPt5.default)(scale);
    const isNumeric = scaleType === 'linear' || scaleType === 'log';
    const tempCalcTicks = Math.round(Math.abs((range[1] || 1) - (range[0] || 0)) / (isLeft ? isNumeric ? (0, $22cf0ae7e72c2bef$export$b3026b3c8d26dc41) : 18 : (0, $22cf0ae7e72c2bef$export$b3026b3c8d26dc41)));
    const calculatedNumTicks = numTicks !== undefined ? numTicks : tempCalcTicks < 2 ? 2 : tempCalcTicks;
    let calculatedScale = scale;
    // Doing a detection here to figure out if we want the ticks to use temporal instead of the
    // ordinal tick detection.
    if ('timeUnit' in scale && typeof scale.timeUnit === 'function' && scale.timeUnit()) {
        const domain = scale.domain();
        if (domain.length > 0) calculatedScale = (0, $2YVVm.default)({
            range: scale.range(),
            domain: [
                scale.domain()[0],
                scale.domain()[scale.domain().length - 1]
            ]
        });
    }
    const filteredTickValues = (tickValues !== null && tickValues !== void 0 ? tickValues : (0, $eOdM1.default)(calculatedScale, calculatedNumTicks)).filter((value)=>!hideZero || value !== 0 && value !== '0').map((value, index)=>({
            value: value,
            index: index
        }));
    const ticks = filteredTickValues.reduce((filtered, _ref2)=>{
        let { value: value, index: index } = _ref2;
        const scaledValue = (0, $cMo1a.default)(tickPosition(value));
        if (tickPosition(value) !== undefined) filtered.push({
            value: value,
            index: index,
            from: (0, $8LERT.default)({
                x: scaledValue,
                y: 0
            }, horizontal),
            to: (0, $8LERT.default)({
                x: scaledValue,
                y: tickLength * tickSign
            }, horizontal)
        });
        return filtered;
    }, []);
    return {
        ticks: ticks
    };
}

});
parcelRegister("cMo1a", function(module, exports) {

$parcel$export(module.exports, "default", () => $94dc992be9846d59$export$2e2bcd8739ae039);
function $94dc992be9846d59$export$2e2bcd8739ae039(val) {
    if ((typeof val === 'function' || typeof val === 'object' && !!val) && 'valueOf' in val) {
        var num = val.valueOf();
        if (typeof num === 'number') return num;
    }
    return val;
}

});

parcelRegister("eOdM1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac806b5b20fff3c3$export$2e2bcd8739ae039);
function $ac806b5b20fff3c3$export$2e2bcd8739ae039(scale, numTicks) {
    // Because `Scale` is generic type which maybe a subset of AnyD3Scale
    // that may not have `ticks` field,
    // TypeScript will not let us do the `'ticks' in scale` check directly.
    // Have to manually cast and expand type first.
    var s = scale;
    if ('ticks' in s) return s.ticks(numTicks);
    return s.domain().filter(function(_, index, arr) {
        return numTicks == null || arr.length <= numTicks || index % Math.round((arr.length - 1) / numTicks) === 0;
    });
}

});

parcelRegister("elPt5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a72af3598e52f8a9$export$2e2bcd8739ae039);

var $jjmqp = parcelRequire("jjmqp");
function $a72af3598e52f8a9$export$2e2bcd8739ae039(scale) {
    // Try a sequence of typeguards to figure out the scale type
    if ('paddingInner' in scale) return 'band';
    if ('padding' in scale) return 'point';
    if ('quantiles' in scale) return 'quantile';
    if ('base' in scale) return 'log';
    if ('exponent' in scale) return scale.exponent() === 0.5 ? 'sqrt' : 'pow';
    if ('constant' in scale) return 'symlog';
    if ('clamp' in scale) {
        // Linear, Time or Utc scales
        if (scale.ticks()[0] instanceof Date) return (0, $jjmqp.default)(scale) ? 'utc' : 'time';
        return 'linear';
    }
    if ('nice' in scale) return 'quantize';
    if ('invertExtent' in scale) return 'threshold';
    return 'ordinal';
}

});
parcelRegister("jjmqp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0f12fc7b7a74157$export$2e2bcd8739ae039);
var $e0f12fc7b7a74157$var$TEST_TIME = new Date(Date.UTC(2020, 1, 2, 3, 4, 5));
var $e0f12fc7b7a74157$var$TEST_FORMAT = '%Y-%m-%d %H:%M';
function $e0f12fc7b7a74157$export$2e2bcd8739ae039(scale) {
    // The only difference between time and utc scale is
    // whether the tick format function is utcFormat or timeFormat
    var output = scale.tickFormat(1, $e0f12fc7b7a74157$var$TEST_FORMAT)($e0f12fc7b7a74157$var$TEST_TIME);
    return output === '2020-02-02 03:04';
}

});


parcelRegister("2YVVm", function(module, exports) {

$parcel$export(module.exports, "default", () => $22be1de14d945e20$export$2e2bcd8739ae039);

var $hV9DI = parcelRequire("hV9DI");

var $caWsP = parcelRequire("caWsP");
var $22be1de14d945e20$export$a5ffb43f629473d4 = (0, $caWsP.default)('domain', 'range', 'reverse', 'clamp', 'interpolate', 'nice', 'round');
function $22be1de14d945e20$export$2e2bcd8739ae039(config) {
    return $22be1de14d945e20$export$a5ffb43f629473d4((0, $hV9DI.default)(), config);
}

});
parcelRegister("hV9DI", function(module, exports) {

$parcel$export(module.exports, "calendar", () => $d0bf3cbc94db3d51$export$56bbcdb8aca31149);
$parcel$export(module.exports, "default", () => $d0bf3cbc94db3d51$export$2e2bcd8739ae039);

var $cRW5v = parcelRequire("cRW5v");
var $kSdfl = parcelRequire("kSdfl");
var $7yDT1 = parcelRequire("7yDT1");
var $2jkSd = parcelRequire("2jkSd");
var $dayZI = parcelRequire("dayZI");
var $dCu2z = parcelRequire("dCu2z");
var $8vb39 = parcelRequire("8vb39");
var $idw3k = parcelRequire("idw3k");

var $duk0X = parcelRequire("duk0X");

var $jhkFB = parcelRequire("jhkFB");

var $l4Hc4 = parcelRequire("l4Hc4");

var $8h2kZ = parcelRequire("8h2kZ");
function $d0bf3cbc94db3d51$var$date(t) {
    return new Date(t);
}
function $d0bf3cbc94db3d51$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $d0bf3cbc94db3d51$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $jhkFB.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $d0bf3cbc94db3d51$var$number)) : domain().map($d0bf3cbc94db3d51$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $8h2kZ.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $jhkFB.copy)(scale, $d0bf3cbc94db3d51$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $d0bf3cbc94db3d51$export$2e2bcd8739ae039() {
    return (0, $l4Hc4.initRange).apply($d0bf3cbc94db3d51$export$56bbcdb8aca31149((0, $dCu2z.timeTicks), (0, $dCu2z.timeTickInterval), (0, $idw3k.timeYear), (0, $2jkSd.timeMonth), (0, $8vb39.timeSunday), (0, $cRW5v.timeDay), (0, $kSdfl.timeHour), (0, $7yDT1.timeMinute), (0, $dayZI.second), (0, $duk0X.timeFormat)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("cRW5v", function(module, exports) {

$parcel$export(module.exports, "timeDay", () => $95e77e521447ed47$export$8888529b966033e5);
$parcel$export(module.exports, "utcDay", () => $95e77e521447ed47$export$c8cbc42cefd47140);
$parcel$export(module.exports, "unixDay", () => $95e77e521447ed47$export$fb065be2d7ea4a71);

var $ecWlt = parcelRequire("ecWlt");

var $fUrRw = parcelRequire("fUrRw");
const $95e77e521447ed47$export$8888529b966033e5 = (0, $ecWlt.timeInterval)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $fUrRw.durationMinute)) / (0, $fUrRw.durationDay), (date)=>date.getDate() - 1);
const $95e77e521447ed47$export$6657a54f3034cf45 = $95e77e521447ed47$export$8888529b966033e5.range;
const $95e77e521447ed47$export$c8cbc42cefd47140 = (0, $ecWlt.timeInterval)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $fUrRw.durationDay);
}, (date)=>{
    return date.getUTCDate() - 1;
});
const $95e77e521447ed47$export$d277e198508549a1 = $95e77e521447ed47$export$c8cbc42cefd47140.range;
const $95e77e521447ed47$export$fb065be2d7ea4a71 = (0, $ecWlt.timeInterval)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $fUrRw.durationDay);
}, (date)=>{
    return Math.floor(date / (0, $fUrRw.durationDay));
});
const $95e77e521447ed47$export$a491caaf5e9481aa = $95e77e521447ed47$export$fb065be2d7ea4a71.range;

});
parcelRegister("ecWlt", function(module, exports) {

$parcel$export(module.exports, "timeInterval", () => $a57f71df9770069e$export$1a539c8b2950ab40);
const $a57f71df9770069e$var$t0 = new Date, $a57f71df9770069e$var$t1 = new Date;
function $a57f71df9770069e$export$1a539c8b2950ab40(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = (date)=>{
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = (date)=>{
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = (date)=>{
        const d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = (date, step)=>{
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = (start, stop, step)=>{
        const range = [];
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        let previous;
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = (test)=>{
        return $a57f71df9770069e$export$1a539c8b2950ab40((date)=>{
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, (date, step)=>{
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = (start, end)=>{
            $a57f71df9770069e$var$t0.setTime(+start), $a57f71df9770069e$var$t1.setTime(+end);
            floori($a57f71df9770069e$var$t0), floori($a57f71df9770069e$var$t1);
            return Math.floor(count($a57f71df9770069e$var$t0, $a57f71df9770069e$var$t1));
        };
        interval.every = (step)=>{
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d)=>field(d) % step === 0 : (d)=>interval.count(0, d) % step === 0);
        };
    }
    return interval;
}

});

parcelRegister("fUrRw", function(module, exports) {

$parcel$export(module.exports, "durationSecond", () => $b951b2d60ecd41a7$export$79ef0e34099623dc);
$parcel$export(module.exports, "durationMinute", () => $b951b2d60ecd41a7$export$683905d551c33fa9);
$parcel$export(module.exports, "durationHour", () => $b951b2d60ecd41a7$export$4157bf0c8e241659);
$parcel$export(module.exports, "durationDay", () => $b951b2d60ecd41a7$export$353686095f4fbf45);
$parcel$export(module.exports, "durationWeek", () => $b951b2d60ecd41a7$export$c241eb88520d5016);
$parcel$export(module.exports, "durationMonth", () => $b951b2d60ecd41a7$export$ab95684df7020b26);
$parcel$export(module.exports, "durationYear", () => $b951b2d60ecd41a7$export$61f8ee2d834c6959);
const $b951b2d60ecd41a7$export$79ef0e34099623dc = 1000;
const $b951b2d60ecd41a7$export$683905d551c33fa9 = $b951b2d60ecd41a7$export$79ef0e34099623dc * 60;
const $b951b2d60ecd41a7$export$4157bf0c8e241659 = $b951b2d60ecd41a7$export$683905d551c33fa9 * 60;
const $b951b2d60ecd41a7$export$353686095f4fbf45 = $b951b2d60ecd41a7$export$4157bf0c8e241659 * 24;
const $b951b2d60ecd41a7$export$c241eb88520d5016 = $b951b2d60ecd41a7$export$353686095f4fbf45 * 7;
const $b951b2d60ecd41a7$export$ab95684df7020b26 = $b951b2d60ecd41a7$export$353686095f4fbf45 * 30;
const $b951b2d60ecd41a7$export$61f8ee2d834c6959 = $b951b2d60ecd41a7$export$353686095f4fbf45 * 365;

});


parcelRegister("kSdfl", function(module, exports) {

$parcel$export(module.exports, "timeHour", () => $f32320462d9111c0$export$46c68a5833bc315b);
$parcel$export(module.exports, "utcHour", () => $f32320462d9111c0$export$31f6f2b3c63ac75e);

var $ecWlt = parcelRequire("ecWlt");

var $fUrRw = parcelRequire("fUrRw");
const $f32320462d9111c0$export$46c68a5833bc315b = (0, $ecWlt.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $fUrRw.durationSecond) - date.getMinutes() * (0, $fUrRw.durationMinute));
}, (date, step)=>{
    date.setTime(+date + step * (0, $fUrRw.durationHour));
}, (start, end)=>{
    return (end - start) / (0, $fUrRw.durationHour);
}, (date)=>{
    return date.getHours();
});
const $f32320462d9111c0$export$fb843f9087cd5235 = $f32320462d9111c0$export$46c68a5833bc315b.range;
const $f32320462d9111c0$export$31f6f2b3c63ac75e = (0, $ecWlt.timeInterval)((date)=>{
    date.setUTCMinutes(0, 0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $fUrRw.durationHour));
}, (start, end)=>{
    return (end - start) / (0, $fUrRw.durationHour);
}, (date)=>{
    return date.getUTCHours();
});
const $f32320462d9111c0$export$6e7a76cd5f50b719 = $f32320462d9111c0$export$31f6f2b3c63ac75e.range;

});

parcelRegister("7yDT1", function(module, exports) {

$parcel$export(module.exports, "timeMinute", () => $580aa6047b58c4b1$export$a7e4c34a52f0576);
$parcel$export(module.exports, "utcMinute", () => $580aa6047b58c4b1$export$efe6712d6003761b);

var $ecWlt = parcelRequire("ecWlt");

var $fUrRw = parcelRequire("fUrRw");
const $580aa6047b58c4b1$export$a7e4c34a52f0576 = (0, $ecWlt.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $fUrRw.durationSecond));
}, (date, step)=>{
    date.setTime(+date + step * (0, $fUrRw.durationMinute));
}, (start, end)=>{
    return (end - start) / (0, $fUrRw.durationMinute);
}, (date)=>{
    return date.getMinutes();
});
const $580aa6047b58c4b1$export$186d65358374c0a2 = $580aa6047b58c4b1$export$a7e4c34a52f0576.range;
const $580aa6047b58c4b1$export$efe6712d6003761b = (0, $ecWlt.timeInterval)((date)=>{
    date.setUTCSeconds(0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $fUrRw.durationMinute));
}, (start, end)=>{
    return (end - start) / (0, $fUrRw.durationMinute);
}, (date)=>{
    return date.getUTCMinutes();
});
const $580aa6047b58c4b1$export$cedd563624e8ee50 = $580aa6047b58c4b1$export$efe6712d6003761b.range;

});

parcelRegister("2jkSd", function(module, exports) {

$parcel$export(module.exports, "timeMonth", () => $1aed8c22031a7431$export$7e1084fb688591c1);
$parcel$export(module.exports, "utcMonth", () => $1aed8c22031a7431$export$cd49b3d2bcfe50d5);

var $ecWlt = parcelRequire("ecWlt");
const $1aed8c22031a7431$export$7e1084fb688591c1 = (0, $ecWlt.timeInterval)((date)=>{
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setMonth(date.getMonth() + step);
}, (start, end)=>{
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, (date)=>{
    return date.getMonth();
});
const $1aed8c22031a7431$export$3e24aa839cd0f1c4 = $1aed8c22031a7431$export$7e1084fb688591c1.range;
const $1aed8c22031a7431$export$cd49b3d2bcfe50d5 = (0, $ecWlt.timeInterval)((date)=>{
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCMonth(date.getUTCMonth() + step);
}, (start, end)=>{
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, (date)=>{
    return date.getUTCMonth();
});
const $1aed8c22031a7431$export$49159f585997498 = $1aed8c22031a7431$export$cd49b3d2bcfe50d5.range;

});

parcelRegister("dayZI", function(module, exports) {

$parcel$export(module.exports, "second", () => $99675ab62f0ed735$export$3d3c77ce7df7d30d);

var $ecWlt = parcelRequire("ecWlt");

var $fUrRw = parcelRequire("fUrRw");
const $99675ab62f0ed735$export$3d3c77ce7df7d30d = (0, $ecWlt.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds());
}, (date, step)=>{
    date.setTime(+date + step * (0, $fUrRw.durationSecond));
}, (start, end)=>{
    return (end - start) / (0, $fUrRw.durationSecond);
}, (date)=>{
    return date.getUTCSeconds();
});
const $99675ab62f0ed735$export$4792e48abc550fa1 = $99675ab62f0ed735$export$3d3c77ce7df7d30d.range;

});

parcelRegister("dCu2z", function(module, exports) {

$parcel$export(module.exports, "utcTicks", () => $9ea6205f05c3bf94$export$826ba5ae907e9767);
$parcel$export(module.exports, "utcTickInterval", () => $9ea6205f05c3bf94$export$6262d8d056ea44c4);
$parcel$export(module.exports, "timeTicks", () => $9ea6205f05c3bf94$export$60c76498552d28a6);
$parcel$export(module.exports, "timeTickInterval", () => $9ea6205f05c3bf94$export$69511150134dd174);

var $88EGG = parcelRequire("88EGG");
var $80JJl = parcelRequire("80JJl");

var $fUrRw = parcelRequire("fUrRw");

var $co6MX = parcelRequire("co6MX");

var $dayZI = parcelRequire("dayZI");

var $7yDT1 = parcelRequire("7yDT1");

var $kSdfl = parcelRequire("kSdfl");

var $cRW5v = parcelRequire("cRW5v");

var $8vb39 = parcelRequire("8vb39");

var $2jkSd = parcelRequire("2jkSd");

var $idw3k = parcelRequire("idw3k");
function $9ea6205f05c3bf94$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, $dayZI.second),
            1,
            (0, $fUrRw.durationSecond)
        ],
        [
            (0, $dayZI.second),
            5,
            5 * (0, $fUrRw.durationSecond)
        ],
        [
            (0, $dayZI.second),
            15,
            15 * (0, $fUrRw.durationSecond)
        ],
        [
            (0, $dayZI.second),
            30,
            30 * (0, $fUrRw.durationSecond)
        ],
        [
            minute,
            1,
            (0, $fUrRw.durationMinute)
        ],
        [
            minute,
            5,
            5 * (0, $fUrRw.durationMinute)
        ],
        [
            minute,
            15,
            15 * (0, $fUrRw.durationMinute)
        ],
        [
            minute,
            30,
            30 * (0, $fUrRw.durationMinute)
        ],
        [
            hour,
            1,
            (0, $fUrRw.durationHour)
        ],
        [
            hour,
            3,
            3 * (0, $fUrRw.durationHour)
        ],
        [
            hour,
            6,
            6 * (0, $fUrRw.durationHour)
        ],
        [
            hour,
            12,
            12 * (0, $fUrRw.durationHour)
        ],
        [
            day,
            1,
            (0, $fUrRw.durationDay)
        ],
        [
            day,
            2,
            2 * (0, $fUrRw.durationDay)
        ],
        [
            week,
            1,
            (0, $fUrRw.durationWeek)
        ],
        [
            month,
            1,
            (0, $fUrRw.durationMonth)
        ],
        [
            month,
            3,
            3 * (0, $fUrRw.durationMonth)
        ],
        [
            year,
            1,
            (0, $fUrRw.durationYear)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $88EGG.default)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $80JJl.tickStep)(start / (0, $fUrRw.durationYear), stop / (0, $fUrRw.durationYear), count));
        if (i === 0) return (0, $co6MX.millisecond).every(Math.max((0, $80JJl.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$9ea6205f05c3bf94$export$826ba5ae907e9767, $9ea6205f05c3bf94$export$6262d8d056ea44c4] = $9ea6205f05c3bf94$var$ticker((0, $idw3k.utcYear), (0, $2jkSd.utcMonth), (0, $8vb39.utcSunday), (0, $cRW5v.unixDay), (0, $kSdfl.utcHour), (0, $7yDT1.utcMinute));
const [$9ea6205f05c3bf94$export$60c76498552d28a6, $9ea6205f05c3bf94$export$69511150134dd174] = $9ea6205f05c3bf94$var$ticker((0, $idw3k.timeYear), (0, $2jkSd.timeMonth), (0, $8vb39.timeSunday), (0, $cRW5v.timeDay), (0, $kSdfl.timeHour), (0, $7yDT1.timeMinute));

});
parcelRegister("88EGG", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ecea1c7e6e17c2e$export$2e2bcd8739ae039);

var $9eRkP = parcelRequire("9eRkP");

var $jaL7t = parcelRequire("jaL7t");
function $5ecea1c7e6e17c2e$export$2e2bcd8739ae039(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = (0, $9eRkP.default);
        compare2 = (d, x)=>(0, $9eRkP.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === (0, $9eRkP.default) || f === (0, $jaL7t.default) ? f : $5ecea1c7e6e17c2e$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $5ecea1c7e6e17c2e$var$zero() {
    return 0;
}

});
parcelRegister("9eRkP", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b9ecb1327aa878a$export$2e2bcd8739ae039);
function $6b9ecb1327aa878a$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("jaL7t", function(module, exports) {

$parcel$export(module.exports, "default", () => $df538075a00c34cb$export$2e2bcd8739ae039);
function $df538075a00c34cb$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRegister("80JJl", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d51cbe8842854f5$export$2e2bcd8739ae039);
$parcel$export(module.exports, "tickIncrement", () => $5d51cbe8842854f5$export$bc64d00cc98e7e95);
$parcel$export(module.exports, "tickStep", () => $5d51cbe8842854f5$export$81087d9b915d4ede);
const $5d51cbe8842854f5$var$e10 = Math.sqrt(50), $5d51cbe8842854f5$var$e5 = Math.sqrt(10), $5d51cbe8842854f5$var$e2 = Math.sqrt(2);
function $5d51cbe8842854f5$var$tickSpec(start, stop, count) {
    const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= $5d51cbe8842854f5$var$e10 ? 10 : error >= $5d51cbe8842854f5$var$e5 ? 5 : error >= $5d51cbe8842854f5$var$e2 ? 2 : 1;
    let i1, i2, inc;
    if (power < 0) {
        inc = Math.pow(10, -power) / factor;
        i1 = Math.round(start * inc);
        i2 = Math.round(stop * inc);
        if (i1 / inc < start) ++i1;
        if (i2 / inc > stop) --i2;
        inc = -inc;
    } else {
        inc = Math.pow(10, power) * factor;
        i1 = Math.round(start / inc);
        i2 = Math.round(stop / inc);
        if (i1 * inc < start) ++i1;
        if (i2 * inc > stop) --i2;
    }
    if (i2 < i1 && 0.5 <= count && count < 2) return $5d51cbe8842854f5$var$tickSpec(start, stop, count * 2);
    return [
        i1,
        i2,
        inc
    ];
}
function $5d51cbe8842854f5$export$2e2bcd8739ae039(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    if (!(count > 0)) return [];
    if (start === stop) return [
        start
    ];
    const reverse = stop < start, [i1, i2, inc] = reverse ? $5d51cbe8842854f5$var$tickSpec(stop, start, count) : $5d51cbe8842854f5$var$tickSpec(start, stop, count);
    if (!(i2 >= i1)) return [];
    const n = i2 - i1 + 1, ticks = new Array(n);
    if (reverse) {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
    } else {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
    }
    return ticks;
}
function $5d51cbe8842854f5$export$bc64d00cc98e7e95(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    return $5d51cbe8842854f5$var$tickSpec(start, stop, count)[2];
}
function $5d51cbe8842854f5$export$81087d9b915d4ede(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    const reverse = stop < start, inc = reverse ? $5d51cbe8842854f5$export$bc64d00cc98e7e95(stop, start, count) : $5d51cbe8842854f5$export$bc64d00cc98e7e95(start, stop, count);
    return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}

});

parcelRegister("co6MX", function(module, exports) {

$parcel$export(module.exports, "millisecond", () => $904cfdfe660e697c$export$edc5e5cb87280477);

var $ecWlt = parcelRequire("ecWlt");
const $904cfdfe660e697c$export$edc5e5cb87280477 = (0, $ecWlt.timeInterval)(()=>{
// noop
}, (date, step)=>{
    date.setTime(+date + step);
}, (start, end)=>{
    return end - start;
});
// An optimized implementation for this simple case.
$904cfdfe660e697c$export$edc5e5cb87280477.every = (k)=>{
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $904cfdfe660e697c$export$edc5e5cb87280477;
    return (0, $ecWlt.timeInterval)((date)=>{
        date.setTime(Math.floor(date / k) * k);
    }, (date, step)=>{
        date.setTime(+date + step * k);
    }, (start, end)=>{
        return (end - start) / k;
    });
};
const $904cfdfe660e697c$export$9a27fac83d67afd3 = $904cfdfe660e697c$export$edc5e5cb87280477.range;

});

parcelRegister("8vb39", function(module, exports) {

$parcel$export(module.exports, "timeSunday", () => $6309ca3cb2286854$export$22ee6205b762968c);
$parcel$export(module.exports, "timeMonday", () => $6309ca3cb2286854$export$e79bbe0177cf1b01);
$parcel$export(module.exports, "timeThursday", () => $6309ca3cb2286854$export$608689422d5cf9f4);
$parcel$export(module.exports, "utcSunday", () => $6309ca3cb2286854$export$4898b06303a92011);
$parcel$export(module.exports, "utcMonday", () => $6309ca3cb2286854$export$9cfc53b9cfafd080);
$parcel$export(module.exports, "utcThursday", () => $6309ca3cb2286854$export$1db08111baec2f53);

var $ecWlt = parcelRequire("ecWlt");

var $fUrRw = parcelRequire("fUrRw");
function $6309ca3cb2286854$var$timeWeekday(i) {
    return (0, $ecWlt.timeInterval)((date)=>{
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setDate(date.getDate() + step * 7);
    }, (start, end)=>{
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $fUrRw.durationMinute)) / (0, $fUrRw.durationWeek);
    });
}
const $6309ca3cb2286854$export$22ee6205b762968c = $6309ca3cb2286854$var$timeWeekday(0);
const $6309ca3cb2286854$export$e79bbe0177cf1b01 = $6309ca3cb2286854$var$timeWeekday(1);
const $6309ca3cb2286854$export$57c0658c29f77708 = $6309ca3cb2286854$var$timeWeekday(2);
const $6309ca3cb2286854$export$3fbeef226c256e43 = $6309ca3cb2286854$var$timeWeekday(3);
const $6309ca3cb2286854$export$608689422d5cf9f4 = $6309ca3cb2286854$var$timeWeekday(4);
const $6309ca3cb2286854$export$548e5227aa183dca = $6309ca3cb2286854$var$timeWeekday(5);
const $6309ca3cb2286854$export$c56a3ad248908e19 = $6309ca3cb2286854$var$timeWeekday(6);
const $6309ca3cb2286854$export$eac514c8a8674eba = $6309ca3cb2286854$export$22ee6205b762968c.range;
const $6309ca3cb2286854$export$f7219b1481948356 = $6309ca3cb2286854$export$e79bbe0177cf1b01.range;
const $6309ca3cb2286854$export$77e22b12c5bed05b = $6309ca3cb2286854$export$57c0658c29f77708.range;
const $6309ca3cb2286854$export$b85d407a471809e8 = $6309ca3cb2286854$export$3fbeef226c256e43.range;
const $6309ca3cb2286854$export$c1bc1c49254c8855 = $6309ca3cb2286854$export$608689422d5cf9f4.range;
const $6309ca3cb2286854$export$3691a1557fff46f1 = $6309ca3cb2286854$export$548e5227aa183dca.range;
const $6309ca3cb2286854$export$b755452d02cba8d2 = $6309ca3cb2286854$export$c56a3ad248908e19.range;
function $6309ca3cb2286854$var$utcWeekday(i) {
    return (0, $ecWlt.timeInterval)((date)=>{
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, (start, end)=>{
        return (end - start) / (0, $fUrRw.durationWeek);
    });
}
const $6309ca3cb2286854$export$4898b06303a92011 = $6309ca3cb2286854$var$utcWeekday(0);
const $6309ca3cb2286854$export$9cfc53b9cfafd080 = $6309ca3cb2286854$var$utcWeekday(1);
const $6309ca3cb2286854$export$2a6d545f77eceb15 = $6309ca3cb2286854$var$utcWeekday(2);
const $6309ca3cb2286854$export$a5c25d8ed64433c4 = $6309ca3cb2286854$var$utcWeekday(3);
const $6309ca3cb2286854$export$1db08111baec2f53 = $6309ca3cb2286854$var$utcWeekday(4);
const $6309ca3cb2286854$export$29265e34dd5921f7 = $6309ca3cb2286854$var$utcWeekday(5);
const $6309ca3cb2286854$export$85b74dad05049604 = $6309ca3cb2286854$var$utcWeekday(6);
const $6309ca3cb2286854$export$6f3e1c2b0f7d7880 = $6309ca3cb2286854$export$4898b06303a92011.range;
const $6309ca3cb2286854$export$1d2d8b858bb366f9 = $6309ca3cb2286854$export$9cfc53b9cfafd080.range;
const $6309ca3cb2286854$export$1d5f6785fc7f30f8 = $6309ca3cb2286854$export$2a6d545f77eceb15.range;
const $6309ca3cb2286854$export$7a75faf0e37ef4af = $6309ca3cb2286854$export$a5c25d8ed64433c4.range;
const $6309ca3cb2286854$export$417eb959611b2f2f = $6309ca3cb2286854$export$1db08111baec2f53.range;
const $6309ca3cb2286854$export$59d308db7af08c64 = $6309ca3cb2286854$export$29265e34dd5921f7.range;
const $6309ca3cb2286854$export$a124108a0a7f34c8 = $6309ca3cb2286854$export$85b74dad05049604.range;

});

parcelRegister("idw3k", function(module, exports) {

$parcel$export(module.exports, "timeYear", () => $d4324de4c61acb39$export$cd17cfe45df0c046);
$parcel$export(module.exports, "utcYear", () => $d4324de4c61acb39$export$d5c3802e389714c4);

var $ecWlt = parcelRequire("ecWlt");
const $d4324de4c61acb39$export$cd17cfe45df0c046 = (0, $ecWlt.timeInterval)((date)=>{
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setFullYear(date.getFullYear() + step);
}, (start, end)=>{
    return end.getFullYear() - start.getFullYear();
}, (date)=>{
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$d4324de4c61acb39$export$cd17cfe45df0c046.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $ecWlt.timeInterval)((date)=>{
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setFullYear(date.getFullYear() + step * k);
    });
};
const $d4324de4c61acb39$export$69a4e90dd2cc3bd1 = $d4324de4c61acb39$export$cd17cfe45df0c046.range;
const $d4324de4c61acb39$export$d5c3802e389714c4 = (0, $ecWlt.timeInterval)((date)=>{
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, (start, end)=>{
    return end.getUTCFullYear() - start.getUTCFullYear();
}, (date)=>{
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$d4324de4c61acb39$export$d5c3802e389714c4.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $ecWlt.timeInterval)((date)=>{
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
const $d4324de4c61acb39$export$3e24d311e17f5802 = $d4324de4c61acb39$export$d5c3802e389714c4.range;

});


parcelRegister("duk0X", function(module, exports) {

$parcel$export(module.exports, "timeFormat", () => $9d1d9a25801dc2bc$export$94f4d87fad5dcf9a);
$parcel$export(module.exports, "timeParse", () => $9d1d9a25801dc2bc$export$32b9cd16e1b8c8d2);
$parcel$export(module.exports, "utcFormat", () => $9d1d9a25801dc2bc$export$1a08fe38f63ebbbb);
$parcel$export(module.exports, "utcParse", () => $9d1d9a25801dc2bc$export$3edae9cf8e233729);

var $7X48q = parcelRequire("7X48q");
var $9d1d9a25801dc2bc$var$locale;
var $9d1d9a25801dc2bc$export$94f4d87fad5dcf9a;
var $9d1d9a25801dc2bc$export$32b9cd16e1b8c8d2;
var $9d1d9a25801dc2bc$export$1a08fe38f63ebbbb;
var $9d1d9a25801dc2bc$export$3edae9cf8e233729;
$9d1d9a25801dc2bc$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $9d1d9a25801dc2bc$export$2e2bcd8739ae039(definition) {
    $9d1d9a25801dc2bc$var$locale = (0, $7X48q.default)(definition);
    $9d1d9a25801dc2bc$export$94f4d87fad5dcf9a = $9d1d9a25801dc2bc$var$locale.format;
    $9d1d9a25801dc2bc$export$32b9cd16e1b8c8d2 = $9d1d9a25801dc2bc$var$locale.parse;
    $9d1d9a25801dc2bc$export$1a08fe38f63ebbbb = $9d1d9a25801dc2bc$var$locale.utcFormat;
    $9d1d9a25801dc2bc$export$3edae9cf8e233729 = $9d1d9a25801dc2bc$var$locale.utcParse;
    return $9d1d9a25801dc2bc$var$locale;
}

});
parcelRegister("7X48q", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ca140376c7a3a5b$export$2e2bcd8739ae039);

var $cRW5v = parcelRequire("cRW5v");
var $8vb39 = parcelRequire("8vb39");
var $idw3k = parcelRequire("idw3k");
function $5ca140376c7a3a5b$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $5ca140376c7a3a5b$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $5ca140376c7a3a5b$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $5ca140376c7a3a5b$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $5ca140376c7a3a5b$var$formatRe(locale_periods), periodLookup = $5ca140376c7a3a5b$var$formatLookup(locale_periods), weekdayRe = $5ca140376c7a3a5b$var$formatRe(locale_weekdays), weekdayLookup = $5ca140376c7a3a5b$var$formatLookup(locale_weekdays), shortWeekdayRe = $5ca140376c7a3a5b$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $5ca140376c7a3a5b$var$formatLookup(locale_shortWeekdays), monthRe = $5ca140376c7a3a5b$var$formatRe(locale_months), monthLookup = $5ca140376c7a3a5b$var$formatLookup(locale_months), shortMonthRe = $5ca140376c7a3a5b$var$formatRe(locale_shortMonths), shortMonthLookup = $5ca140376c7a3a5b$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $5ca140376c7a3a5b$var$formatDayOfMonth,
        "e": $5ca140376c7a3a5b$var$formatDayOfMonth,
        "f": $5ca140376c7a3a5b$var$formatMicroseconds,
        "g": $5ca140376c7a3a5b$var$formatYearISO,
        "G": $5ca140376c7a3a5b$var$formatFullYearISO,
        "H": $5ca140376c7a3a5b$var$formatHour24,
        "I": $5ca140376c7a3a5b$var$formatHour12,
        "j": $5ca140376c7a3a5b$var$formatDayOfYear,
        "L": $5ca140376c7a3a5b$var$formatMilliseconds,
        "m": $5ca140376c7a3a5b$var$formatMonthNumber,
        "M": $5ca140376c7a3a5b$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $5ca140376c7a3a5b$var$formatUnixTimestamp,
        "s": $5ca140376c7a3a5b$var$formatUnixTimestampSeconds,
        "S": $5ca140376c7a3a5b$var$formatSeconds,
        "u": $5ca140376c7a3a5b$var$formatWeekdayNumberMonday,
        "U": $5ca140376c7a3a5b$var$formatWeekNumberSunday,
        "V": $5ca140376c7a3a5b$var$formatWeekNumberISO,
        "w": $5ca140376c7a3a5b$var$formatWeekdayNumberSunday,
        "W": $5ca140376c7a3a5b$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $5ca140376c7a3a5b$var$formatYear,
        "Y": $5ca140376c7a3a5b$var$formatFullYear,
        "Z": $5ca140376c7a3a5b$var$formatZone,
        "%": $5ca140376c7a3a5b$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $5ca140376c7a3a5b$var$formatUTCDayOfMonth,
        "e": $5ca140376c7a3a5b$var$formatUTCDayOfMonth,
        "f": $5ca140376c7a3a5b$var$formatUTCMicroseconds,
        "g": $5ca140376c7a3a5b$var$formatUTCYearISO,
        "G": $5ca140376c7a3a5b$var$formatUTCFullYearISO,
        "H": $5ca140376c7a3a5b$var$formatUTCHour24,
        "I": $5ca140376c7a3a5b$var$formatUTCHour12,
        "j": $5ca140376c7a3a5b$var$formatUTCDayOfYear,
        "L": $5ca140376c7a3a5b$var$formatUTCMilliseconds,
        "m": $5ca140376c7a3a5b$var$formatUTCMonthNumber,
        "M": $5ca140376c7a3a5b$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $5ca140376c7a3a5b$var$formatUnixTimestamp,
        "s": $5ca140376c7a3a5b$var$formatUnixTimestampSeconds,
        "S": $5ca140376c7a3a5b$var$formatUTCSeconds,
        "u": $5ca140376c7a3a5b$var$formatUTCWeekdayNumberMonday,
        "U": $5ca140376c7a3a5b$var$formatUTCWeekNumberSunday,
        "V": $5ca140376c7a3a5b$var$formatUTCWeekNumberISO,
        "w": $5ca140376c7a3a5b$var$formatUTCWeekdayNumberSunday,
        "W": $5ca140376c7a3a5b$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $5ca140376c7a3a5b$var$formatUTCYear,
        "Y": $5ca140376c7a3a5b$var$formatUTCFullYear,
        "Z": $5ca140376c7a3a5b$var$formatUTCZone,
        "%": $5ca140376c7a3a5b$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $5ca140376c7a3a5b$var$parseDayOfMonth,
        "e": $5ca140376c7a3a5b$var$parseDayOfMonth,
        "f": $5ca140376c7a3a5b$var$parseMicroseconds,
        "g": $5ca140376c7a3a5b$var$parseYear,
        "G": $5ca140376c7a3a5b$var$parseFullYear,
        "H": $5ca140376c7a3a5b$var$parseHour24,
        "I": $5ca140376c7a3a5b$var$parseHour24,
        "j": $5ca140376c7a3a5b$var$parseDayOfYear,
        "L": $5ca140376c7a3a5b$var$parseMilliseconds,
        "m": $5ca140376c7a3a5b$var$parseMonthNumber,
        "M": $5ca140376c7a3a5b$var$parseMinutes,
        "p": parsePeriod,
        "q": $5ca140376c7a3a5b$var$parseQuarter,
        "Q": $5ca140376c7a3a5b$var$parseUnixTimestamp,
        "s": $5ca140376c7a3a5b$var$parseUnixTimestampSeconds,
        "S": $5ca140376c7a3a5b$var$parseSeconds,
        "u": $5ca140376c7a3a5b$var$parseWeekdayNumberMonday,
        "U": $5ca140376c7a3a5b$var$parseWeekNumberSunday,
        "V": $5ca140376c7a3a5b$var$parseWeekNumberISO,
        "w": $5ca140376c7a3a5b$var$parseWeekdayNumberSunday,
        "W": $5ca140376c7a3a5b$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $5ca140376c7a3a5b$var$parseYear,
        "Y": $5ca140376c7a3a5b$var$parseFullYear,
        "Z": $5ca140376c7a3a5b$var$parseZone,
        "%": $5ca140376c7a3a5b$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $5ca140376c7a3a5b$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $5ca140376c7a3a5b$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $5ca140376c7a3a5b$var$utcDate($5ca140376c7a3a5b$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $8vb39.utcMonday).ceil(week) : (0, $8vb39.utcMonday)(week);
                    week = (0, $cRW5v.utcDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $5ca140376c7a3a5b$var$localDate($5ca140376c7a3a5b$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $8vb39.timeMonday).ceil(week) : (0, $8vb39.timeMonday)(week);
                    week = (0, $cRW5v.timeDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $5ca140376c7a3a5b$var$utcDate($5ca140376c7a3a5b$var$newDate(d.y, 0, 1)).getUTCDay() : $5ca140376c7a3a5b$var$localDate($5ca140376c7a3a5b$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $5ca140376c7a3a5b$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $5ca140376c7a3a5b$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $5ca140376c7a3a5b$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $5ca140376c7a3a5b$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $5ca140376c7a3a5b$var$numberRe = /^\s*\d+/, $5ca140376c7a3a5b$var$percentRe = /^%/, $5ca140376c7a3a5b$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $5ca140376c7a3a5b$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $5ca140376c7a3a5b$var$requote(s) {
    return s.replace($5ca140376c7a3a5b$var$requoteRe, "\\$&");
}
function $5ca140376c7a3a5b$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($5ca140376c7a3a5b$var$requote).join("|") + ")", "i");
}
function $5ca140376c7a3a5b$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $5ca140376c7a3a5b$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseWeekNumberSunday(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseWeekNumberISO(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseWeekNumberMonday(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseFullYear(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseYear(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseQuarter(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseMonthNumber(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseDayOfMonth(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseDayOfYear(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseHour24(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseMinutes(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseSeconds(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseMilliseconds(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseMicroseconds(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseLiteralPercent(d, string, i) {
    var n = $5ca140376c7a3a5b$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $5ca140376c7a3a5b$var$parseUnixTimestamp(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$formatDayOfMonth(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getDate(), p, 2);
}
function $5ca140376c7a3a5b$var$formatHour24(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getHours(), p, 2);
}
function $5ca140376c7a3a5b$var$formatHour12(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $5ca140376c7a3a5b$var$formatDayOfYear(d, p) {
    return $5ca140376c7a3a5b$var$pad(1 + (0, $cRW5v.timeDay).count((0, $idw3k.timeYear)(d), d), p, 3);
}
function $5ca140376c7a3a5b$var$formatMilliseconds(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getMilliseconds(), p, 3);
}
function $5ca140376c7a3a5b$var$formatMicroseconds(d, p) {
    return $5ca140376c7a3a5b$var$formatMilliseconds(d, p) + "000";
}
function $5ca140376c7a3a5b$var$formatMonthNumber(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getMonth() + 1, p, 2);
}
function $5ca140376c7a3a5b$var$formatMinutes(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getMinutes(), p, 2);
}
function $5ca140376c7a3a5b$var$formatSeconds(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getSeconds(), p, 2);
}
function $5ca140376c7a3a5b$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $5ca140376c7a3a5b$var$formatWeekNumberSunday(d, p) {
    return $5ca140376c7a3a5b$var$pad((0, $8vb39.timeSunday).count((0, $idw3k.timeYear)(d) - 1, d), p, 2);
}
function $5ca140376c7a3a5b$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $8vb39.timeThursday)(d) : (0, $8vb39.timeThursday).ceil(d);
}
function $5ca140376c7a3a5b$var$formatWeekNumberISO(d, p) {
    d = $5ca140376c7a3a5b$var$dISO(d);
    return $5ca140376c7a3a5b$var$pad((0, $8vb39.timeThursday).count((0, $idw3k.timeYear)(d), d) + ((0, $idw3k.timeYear)(d).getDay() === 4), p, 2);
}
function $5ca140376c7a3a5b$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $5ca140376c7a3a5b$var$formatWeekNumberMonday(d, p) {
    return $5ca140376c7a3a5b$var$pad((0, $8vb39.timeMonday).count((0, $idw3k.timeYear)(d) - 1, d), p, 2);
}
function $5ca140376c7a3a5b$var$formatYear(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getFullYear() % 100, p, 2);
}
function $5ca140376c7a3a5b$var$formatYearISO(d, p) {
    d = $5ca140376c7a3a5b$var$dISO(d);
    return $5ca140376c7a3a5b$var$pad(d.getFullYear() % 100, p, 2);
}
function $5ca140376c7a3a5b$var$formatFullYear(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getFullYear() % 10000, p, 4);
}
function $5ca140376c7a3a5b$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $8vb39.timeThursday)(d) : (0, $8vb39.timeThursday).ceil(d);
    return $5ca140376c7a3a5b$var$pad(d.getFullYear() % 10000, p, 4);
}
function $5ca140376c7a3a5b$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $5ca140376c7a3a5b$var$pad(z / 60 | 0, "0", 2) + $5ca140376c7a3a5b$var$pad(z % 60, "0", 2);
}
function $5ca140376c7a3a5b$var$formatUTCDayOfMonth(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getUTCDate(), p, 2);
}
function $5ca140376c7a3a5b$var$formatUTCHour24(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getUTCHours(), p, 2);
}
function $5ca140376c7a3a5b$var$formatUTCHour12(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $5ca140376c7a3a5b$var$formatUTCDayOfYear(d, p) {
    return $5ca140376c7a3a5b$var$pad(1 + (0, $cRW5v.utcDay).count((0, $idw3k.utcYear)(d), d), p, 3);
}
function $5ca140376c7a3a5b$var$formatUTCMilliseconds(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $5ca140376c7a3a5b$var$formatUTCMicroseconds(d, p) {
    return $5ca140376c7a3a5b$var$formatUTCMilliseconds(d, p) + "000";
}
function $5ca140376c7a3a5b$var$formatUTCMonthNumber(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $5ca140376c7a3a5b$var$formatUTCMinutes(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getUTCMinutes(), p, 2);
}
function $5ca140376c7a3a5b$var$formatUTCSeconds(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getUTCSeconds(), p, 2);
}
function $5ca140376c7a3a5b$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $5ca140376c7a3a5b$var$formatUTCWeekNumberSunday(d, p) {
    return $5ca140376c7a3a5b$var$pad((0, $8vb39.utcSunday).count((0, $idw3k.utcYear)(d) - 1, d), p, 2);
}
function $5ca140376c7a3a5b$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $8vb39.utcThursday)(d) : (0, $8vb39.utcThursday).ceil(d);
}
function $5ca140376c7a3a5b$var$formatUTCWeekNumberISO(d, p) {
    d = $5ca140376c7a3a5b$var$UTCdISO(d);
    return $5ca140376c7a3a5b$var$pad((0, $8vb39.utcThursday).count((0, $idw3k.utcYear)(d), d) + ((0, $idw3k.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $5ca140376c7a3a5b$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $5ca140376c7a3a5b$var$formatUTCWeekNumberMonday(d, p) {
    return $5ca140376c7a3a5b$var$pad((0, $8vb39.utcMonday).count((0, $idw3k.utcYear)(d) - 1, d), p, 2);
}
function $5ca140376c7a3a5b$var$formatUTCYear(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $5ca140376c7a3a5b$var$formatUTCYearISO(d, p) {
    d = $5ca140376c7a3a5b$var$UTCdISO(d);
    return $5ca140376c7a3a5b$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $5ca140376c7a3a5b$var$formatUTCFullYear(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $5ca140376c7a3a5b$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $8vb39.utcThursday)(d) : (0, $8vb39.utcThursday).ceil(d);
    return $5ca140376c7a3a5b$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $5ca140376c7a3a5b$var$formatUTCZone() {
    return "+0000";
}
function $5ca140376c7a3a5b$var$formatLiteralPercent() {
    return "%";
}
function $5ca140376c7a3a5b$var$formatUnixTimestamp(d) {
    return +d;
}
function $5ca140376c7a3a5b$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});


parcelRegister("jhkFB", function(module, exports) {

$parcel$export(module.exports, "identity", () => $e08fa37ff0dcafa0$export$f0954fd7d5368655);
$parcel$export(module.exports, "copy", () => $e08fa37ff0dcafa0$export$784d13d8ee351f07);
$parcel$export(module.exports, "transformer", () => $e08fa37ff0dcafa0$export$6b468dcfb64c653c);
$parcel$export(module.exports, "default", () => $e08fa37ff0dcafa0$export$2e2bcd8739ae039);

var $babOZ = parcelRequire("babOZ");

var $6RkHc = parcelRequire("6RkHc");
var $3Rh7t = parcelRequire("3Rh7t");
var $8Masb = parcelRequire("8Masb");

var $8CHve = parcelRequire("8CHve");

var $bMlxp = parcelRequire("bMlxp");
var $e08fa37ff0dcafa0$var$unit = [
    0,
    1
];
function $e08fa37ff0dcafa0$export$f0954fd7d5368655(x) {
    return x;
}
function $e08fa37ff0dcafa0$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $8CHve.default)(isNaN(b) ? NaN : 0.5);
}
function $e08fa37ff0dcafa0$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $e08fa37ff0dcafa0$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $e08fa37ff0dcafa0$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $e08fa37ff0dcafa0$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $e08fa37ff0dcafa0$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $e08fa37ff0dcafa0$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $babOZ.default)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $e08fa37ff0dcafa0$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $e08fa37ff0dcafa0$export$6b468dcfb64c653c() {
    var domain = $e08fa37ff0dcafa0$var$unit, range = $e08fa37ff0dcafa0$var$unit, interpolate = (0, $6RkHc.default), transform, untransform, unknown, clamp = $e08fa37ff0dcafa0$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $e08fa37ff0dcafa0$export$f0954fd7d5368655) clamp = $e08fa37ff0dcafa0$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $e08fa37ff0dcafa0$var$polymap : $e08fa37ff0dcafa0$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $3Rh7t.default))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $bMlxp.default)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $8Masb.default), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $e08fa37ff0dcafa0$export$f0954fd7d5368655, rescale()) : clamp !== $e08fa37ff0dcafa0$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $e08fa37ff0dcafa0$export$2e2bcd8739ae039() {
    return $e08fa37ff0dcafa0$export$6b468dcfb64c653c()($e08fa37ff0dcafa0$export$f0954fd7d5368655, $e08fa37ff0dcafa0$export$f0954fd7d5368655);
}

});
parcelRegister("babOZ", function(module, exports) {

$parcel$export(module.exports, "bisectRight", () => $8209cc5de140cbf4$export$4d945ad3ad5751b0);
$parcel$export(module.exports, "bisectLeft", () => $8209cc5de140cbf4$export$df7d25c84ebd12a5);
$parcel$export(module.exports, "default", () => $8209cc5de140cbf4$export$2e2bcd8739ae039);

var $9eRkP = parcelRequire("9eRkP");

var $88EGG = parcelRequire("88EGG");

var $gcXrx = parcelRequire("gcXrx");
const $8209cc5de140cbf4$var$ascendingBisect = (0, $88EGG.default)((0, $9eRkP.default));
const $8209cc5de140cbf4$export$4d945ad3ad5751b0 = $8209cc5de140cbf4$var$ascendingBisect.right;
const $8209cc5de140cbf4$export$df7d25c84ebd12a5 = $8209cc5de140cbf4$var$ascendingBisect.left;
const $8209cc5de140cbf4$export$c1cb828b1117c77b = (0, $88EGG.default)((0, $gcXrx.default)).center;
var $8209cc5de140cbf4$export$2e2bcd8739ae039 = $8209cc5de140cbf4$export$4d945ad3ad5751b0;

});
parcelRegister("gcXrx", function(module, exports) {

$parcel$export(module.exports, "default", () => $bccbe082a14f438f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "numbers", () => $bccbe082a14f438f$export$1f6c9cc012ebacae);
function $bccbe082a14f438f$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $bccbe082a14f438f$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("6RkHc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fe7bf159d941aaa$export$2e2bcd8739ae039);

var $7UL8A = parcelRequire("7UL8A");

var $aG0QU = parcelRequire("aG0QU");

var $kTnyJ = parcelRequire("kTnyJ");

var $MJl9N = parcelRequire("MJl9N");

var $3Rh7t = parcelRequire("3Rh7t");

var $cNfx1 = parcelRequire("cNfx1");

var $aAMMD = parcelRequire("aAMMD");

var $28ku5 = parcelRequire("28ku5");

var $fwtCP = parcelRequire("fwtCP");
function $4fe7bf159d941aaa$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $28ku5.default)(b) : (t === "number" ? (0, $3Rh7t.default) : t === "string" ? (c = (0, $7UL8A.default)(b)) ? (b = c, $aG0QU.default) : (0, $aAMMD.default) : b instanceof (0, $7UL8A.default) ? (0, $aG0QU.default) : b instanceof Date ? (0, $MJl9N.default) : (0, $fwtCP.isNumberArray)(b) ? (0, $fwtCP.default) : Array.isArray(b) ? (0, $kTnyJ.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $cNfx1.default) : (0, $3Rh7t.default))(a, b);
}

});
parcelRegister("7UL8A", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $eeO9w = parcelRequire("eeO9w");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $eeO9w.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $eeO9w.default)(Rgb, rgb, (0, $eeO9w.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $eeO9w.default)(Hsl, hsl, (0, $eeO9w.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("eeO9w", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5d946be86aedd6a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $a5d946be86aedd6a$export$8b58be045bf06082);
function $a5d946be86aedd6a$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $a5d946be86aedd6a$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("aG0QU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c5e7ce60195f842$export$2e2bcd8739ae039);
$parcel$export(module.exports, "rgbBasis", () => $7c5e7ce60195f842$export$2c0e28f2e2852d3f);
$parcel$export(module.exports, "rgbBasisClosed", () => $7c5e7ce60195f842$export$53d5214f625ccd4c);

var $7UL8A = parcelRequire("7UL8A");

var $IzpFC = parcelRequire("IzpFC");

var $jde0I = parcelRequire("jde0I");

var $9fc6H = parcelRequire("9fc6H");
var $7c5e7ce60195f842$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $9fc6H.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $7UL8A.rgb)(start)).r, (end = (0, $7UL8A.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $9fc6H.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $7c5e7ce60195f842$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $7UL8A.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $7c5e7ce60195f842$export$2c0e28f2e2852d3f = $7c5e7ce60195f842$var$rgbSpline((0, $IzpFC.default));
var $7c5e7ce60195f842$export$53d5214f625ccd4c = $7c5e7ce60195f842$var$rgbSpline((0, $jde0I.default));

});
parcelRegister("IzpFC", function(module, exports) {

$parcel$export(module.exports, "basis", () => $085f9477972cbd8b$export$4e41033bfeec1a4c);
$parcel$export(module.exports, "default", () => $085f9477972cbd8b$export$2e2bcd8739ae039);
function $085f9477972cbd8b$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $085f9477972cbd8b$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $085f9477972cbd8b$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("jde0I", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfca19696d8e5441$export$2e2bcd8739ae039);

var $IzpFC = parcelRequire("IzpFC");
function $dfca19696d8e5441$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $IzpFC.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("9fc6H", function(module, exports) {

$parcel$export(module.exports, "hue", () => $6baee7f5715a9c6b$export$97d7b0c7ddb78dcf);
$parcel$export(module.exports, "gamma", () => $6baee7f5715a9c6b$export$a7ebe8cc6aaf8d37);
$parcel$export(module.exports, "default", () => $6baee7f5715a9c6b$export$2e2bcd8739ae039);

var $28ku5 = parcelRequire("28ku5");
function $6baee7f5715a9c6b$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $6baee7f5715a9c6b$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $6baee7f5715a9c6b$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $6baee7f5715a9c6b$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $28ku5.default)(isNaN(a) ? b : a);
}
function $6baee7f5715a9c6b$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $6baee7f5715a9c6b$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $6baee7f5715a9c6b$var$exponential(a, b, y) : (0, $28ku5.default)(isNaN(a) ? b : a);
    };
}
function $6baee7f5715a9c6b$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $6baee7f5715a9c6b$var$linear(a, d) : (0, $28ku5.default)(isNaN(a) ? b : a);
}

});
parcelRegister("28ku5", function(module, exports) {

$parcel$export(module.exports, "default", () => $18dc37dae666c7d2$export$2e2bcd8739ae039);
var $18dc37dae666c7d2$export$2e2bcd8739ae039 = (x)=>()=>x;

});



parcelRegister("kTnyJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f35b380b021f8b08$export$2e2bcd8739ae039);
$parcel$export(module.exports, "genericArray", () => $f35b380b021f8b08$export$15d09067c6a5ee49);

var $6RkHc = parcelRequire("6RkHc");

var $fwtCP = parcelRequire("fwtCP");
function $f35b380b021f8b08$export$2e2bcd8739ae039(a, b) {
    return ((0, $fwtCP.isNumberArray)(b) ? (0, $fwtCP.default) : $f35b380b021f8b08$export$15d09067c6a5ee49)(a, b);
}
function $f35b380b021f8b08$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $6RkHc.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("fwtCP", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4d0d32910153fd7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isNumberArray", () => $b4d0d32910153fd7$export$5cd576d1827d40c8);
function $b4d0d32910153fd7$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $b4d0d32910153fd7$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("MJl9N", function(module, exports) {

$parcel$export(module.exports, "default", () => $0927a76fd784b52f$export$2e2bcd8739ae039);
function $0927a76fd784b52f$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("3Rh7t", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf399f0ec029057$export$2e2bcd8739ae039);
function $2cf399f0ec029057$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("cNfx1", function(module, exports) {

$parcel$export(module.exports, "default", () => $95061be058f50ffd$export$2e2bcd8739ae039);

var $6RkHc = parcelRequire("6RkHc");
function $95061be058f50ffd$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $6RkHc.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("aAMMD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b631b92516e1d18$export$2e2bcd8739ae039);

var $3Rh7t = parcelRequire("3Rh7t");
var $7b631b92516e1d18$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $7b631b92516e1d18$var$reB = new RegExp($7b631b92516e1d18$var$reA.source, "g");
function $7b631b92516e1d18$var$zero(b) {
    return function() {
        return b;
    };
}
function $7b631b92516e1d18$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $7b631b92516e1d18$export$2e2bcd8739ae039(a, b) {
    var bi = $7b631b92516e1d18$var$reA.lastIndex = $7b631b92516e1d18$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $7b631b92516e1d18$var$reA.exec(a)) && (bm = $7b631b92516e1d18$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $3Rh7t.default)(am, bm)
            });
        }
        bi = $7b631b92516e1d18$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $7b631b92516e1d18$var$one(q[0].x) : $7b631b92516e1d18$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("8Masb", function(module, exports) {

$parcel$export(module.exports, "default", () => $663aea45c6d13a8b$export$2e2bcd8739ae039);
function $663aea45c6d13a8b$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("8CHve", function(module, exports) {

$parcel$export(module.exports, "default", () => $64739e0ff1e8934d$export$2e2bcd8739ae039);
function $64739e0ff1e8934d$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("bMlxp", function(module, exports) {

$parcel$export(module.exports, "default", () => $8934e2622cfc7145$export$2e2bcd8739ae039);
function $8934e2622cfc7145$export$2e2bcd8739ae039(x) {
    return +x;
}

});


parcelRegister("l4Hc4", function(module, exports) {

$parcel$export(module.exports, "initRange", () => $f57b7a0f29a58702$export$23c7bb9e6558da2a);
$parcel$export(module.exports, "initInterpolator", () => $f57b7a0f29a58702$export$7d6b419e59e83f3d);
function $f57b7a0f29a58702$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $f57b7a0f29a58702$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("8h2kZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6061b96d6d4d7b5e$export$2e2bcd8739ae039);
function $6061b96d6d4d7b5e$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("caWsP", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dd3c4ebebad7819$export$2e2bcd8739ae039);

var $7NDDt = parcelRequire("7NDDt");

var $aag8f = parcelRequire("aag8f");

var $8m6Xe = parcelRequire("8m6Xe");

var $c8Zjd = parcelRequire("c8Zjd");

var $1MYRX = parcelRequire("1MYRX");

var $adff9 = parcelRequire("adff9");

var $1MyI8 = parcelRequire("1MyI8");

var $ic1Fv = parcelRequire("ic1Fv");

var $7goQn = parcelRequire("7goQn");

var $c1r8l = parcelRequire("c1r8l");

var $dWXcN = parcelRequire("dWXcN");

var $4sSWK = parcelRequire("4sSWK");

var $iuIpV = parcelRequire("iuIpV");

var $jUCfg = parcelRequire("jUCfg");
var $8dd3c4ebebad7819$export$5f274da11658f617 = [
    // domain => nice => zero
    'domain',
    'nice',
    'zero',
    // interpolate before round
    'interpolate',
    'round',
    // set range then reverse
    'range',
    'reverse',
    // Order does not matter for these operators
    'align',
    'base',
    'clamp',
    'constant',
    'exponent',
    'padding',
    'unknown'
];
// Use Record to enforce that all keys in OperatorType must exist.
var $8dd3c4ebebad7819$var$operators = {
    domain: (0, $7NDDt.default),
    nice: (0, $7goQn.default),
    zero: (0, $jUCfg.default),
    interpolate: (0, $ic1Fv.default),
    round: (0, $4sSWK.default),
    align: (0, $8m6Xe.default),
    base: (0, $c8Zjd.default),
    clamp: (0, $1MYRX.default),
    constant: (0, $adff9.default),
    exponent: (0, $1MyI8.default),
    padding: (0, $c1r8l.default),
    range: (0, $aag8f.default),
    reverse: (0, $dWXcN.default),
    unknown: (0, $iuIpV.default)
};
function $8dd3c4ebebad7819$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, ops = new Array(_len), _key = 0; _key < _len; _key++)ops[_key] = arguments[_key];
    var selection = new Set(ops);
    var selectedOps = $8dd3c4ebebad7819$export$5f274da11658f617.filter(function(o) {
        return selection.has(o);
    });
    return function applyOperators(scale, config) {
        if (typeof config !== 'undefined') selectedOps.forEach(function(op) {
            $8dd3c4ebebad7819$var$operators[op](scale, config);
        });
        return scale;
    };
}

});
parcelRegister("7NDDt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5adbdad8d7dbd927$export$2e2bcd8739ae039);
function $5adbdad8d7dbd927$export$2e2bcd8739ae039(scale, config) {
    if (config.domain) {
        if ('nice' in scale || 'quantiles' in scale) // continuous input scales
        scale.domain(config.domain);
        else if ('padding' in scale) // point and band scales
        scale.domain(config.domain);
        else // ordinal and threshold scale
        scale.domain(config.domain);
    }
}

});

parcelRegister("aag8f", function(module, exports) {

$parcel$export(module.exports, "default", () => $76675a108d27a9d2$export$2e2bcd8739ae039);
function $76675a108d27a9d2$export$2e2bcd8739ae039(scale, config) {
    if (config.range) {
        if ('padding' in scale) // point and band scales
        scale.range(config.range);
        else // the rest
        scale.range(config.range);
    }
}

});

parcelRegister("8m6Xe", function(module, exports) {

$parcel$export(module.exports, "default", () => $6155c5c6f5439590$export$2e2bcd8739ae039);
function $6155c5c6f5439590$export$2e2bcd8739ae039(scale, config) {
    if ('align' in scale && 'align' in config && typeof config.align !== 'undefined') scale.align(config.align);
}

});

parcelRegister("c8Zjd", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d75ca1400c343c0$export$2e2bcd8739ae039);
function $8d75ca1400c343c0$export$2e2bcd8739ae039(scale, config) {
    if ('base' in scale && 'base' in config && typeof config.base !== 'undefined') scale.base(config.base);
}

});

parcelRegister("1MYRX", function(module, exports) {

$parcel$export(module.exports, "default", () => $14d97d80be7dc302$export$2e2bcd8739ae039);
function $14d97d80be7dc302$export$2e2bcd8739ae039(scale, config) {
    if ('clamp' in scale && 'clamp' in config && typeof config.clamp !== 'undefined') scale.clamp(config.clamp);
}

});

parcelRegister("adff9", function(module, exports) {

$parcel$export(module.exports, "default", () => $76f6f14eacc4e6ab$export$2e2bcd8739ae039);
function $76f6f14eacc4e6ab$export$2e2bcd8739ae039(scale, config) {
    if ('constant' in scale && 'constant' in config && typeof config.constant !== 'undefined') scale.constant(config.constant);
}

});

parcelRegister("1MyI8", function(module, exports) {

$parcel$export(module.exports, "default", () => $14c532f8d5c42e52$export$2e2bcd8739ae039);
function $14c532f8d5c42e52$export$2e2bcd8739ae039(scale, config) {
    if ('exponent' in scale && 'exponent' in config && typeof config.exponent !== 'undefined') scale.exponent(config.exponent);
}

});

parcelRegister("ic1Fv", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3eaa44c0ab3088c$export$2e2bcd8739ae039);

var $fVmmU = parcelRequire("fVmmU");
function $d3eaa44c0ab3088c$export$2e2bcd8739ae039(scale, config) {
    if ('interpolate' in config && 'interpolate' in scale && typeof config.interpolate !== 'undefined') {
        var interpolator = (0, $fVmmU.default)(config.interpolate);
        scale.interpolate(interpolator);
    }
}

});
parcelRegister("fVmmU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b97d87c86200b9cc$export$2e2bcd8739ae039);

var $bktzi = parcelRequire("bktzi");
var $45TwU = parcelRequire("45TwU");
var $9faDM = parcelRequire("9faDM");
var $fBRs6 = parcelRequire("fBRs6");
var $aG0QU = parcelRequire("aG0QU");
var $b97d87c86200b9cc$var$interpolatorMap = {
    lab: (0, $fBRs6.default),
    hcl: (0, $45TwU.default),
    'hcl-long': (0, $45TwU.hclLong),
    hsl: (0, $9faDM.default),
    'hsl-long': (0, $9faDM.hslLong),
    cubehelix: (0, $bktzi.default),
    'cubehelix-long': (0, $bktzi.cubehelixLong),
    rgb: (0, $aG0QU.default)
};
function $b97d87c86200b9cc$export$2e2bcd8739ae039(interpolate) {
    switch(interpolate){
        case 'lab':
        case 'hcl':
        case 'hcl-long':
        case 'hsl':
        case 'hsl-long':
        case 'cubehelix':
        case 'cubehelix-long':
        case 'rgb':
            return $b97d87c86200b9cc$var$interpolatorMap[interpolate];
        default:
    }
    var type = interpolate.type, gamma = interpolate.gamma;
    var interpolator = $b97d87c86200b9cc$var$interpolatorMap[type];
    return typeof gamma === 'undefined' ? interpolator : interpolator.gamma(gamma);
}

});
parcelRegister("bktzi", function(module, exports) {

$parcel$export(module.exports, "default", () => $83f87f9993df75d4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "cubehelixLong", () => $83f87f9993df75d4$export$934fa09ad474a1b4);

var $eKYlI = parcelRequire("eKYlI");

var $9fc6H = parcelRequire("9fc6H");
function $83f87f9993df75d4$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $eKYlI.default)(start)).h, (end = (0, $eKYlI.default)(end)).h), s = (0, $9fc6H.default)(start.s, end.s), l = (0, $9fc6H.default)(start.l, end.l), opacity = (0, $9fc6H.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $83f87f9993df75d4$export$2e2bcd8739ae039 = $83f87f9993df75d4$var$cubehelix((0, $9fc6H.hue));
var $83f87f9993df75d4$export$934fa09ad474a1b4 = $83f87f9993df75d4$var$cubehelix((0, $9fc6H.default));

});
parcelRegister("eKYlI", function(module, exports) {

$parcel$export(module.exports, "default", () => $abe42cac81644644$export$2e2bcd8739ae039);

var $eeO9w = parcelRequire("eeO9w");

var $7UL8A = parcelRequire("7UL8A");

var $fS7Ud = parcelRequire("fS7Ud");
var $abe42cac81644644$var$A = -0.14861, $abe42cac81644644$var$B = 1.78277, $abe42cac81644644$var$C = -0.29227, $abe42cac81644644$var$D = -0.90649, $abe42cac81644644$var$E = 1.97294, $abe42cac81644644$var$ED = $abe42cac81644644$var$E * $abe42cac81644644$var$D, $abe42cac81644644$var$EB = $abe42cac81644644$var$E * $abe42cac81644644$var$B, $abe42cac81644644$var$BC_DA = $abe42cac81644644$var$B * $abe42cac81644644$var$C - $abe42cac81644644$var$D * $abe42cac81644644$var$A;
function $abe42cac81644644$var$cubehelixConvert(o) {
    if (o instanceof $abe42cac81644644$export$57ed4bde61a1e2f2) return new $abe42cac81644644$export$57ed4bde61a1e2f2(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, $7UL8A.Rgb))) o = (0, $7UL8A.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($abe42cac81644644$var$BC_DA * b + $abe42cac81644644$var$ED * r - $abe42cac81644644$var$EB * g) / ($abe42cac81644644$var$BC_DA + $abe42cac81644644$var$ED - $abe42cac81644644$var$EB), bl = b - l, k = ($abe42cac81644644$var$E * (g - l) - $abe42cac81644644$var$C * bl) / $abe42cac81644644$var$D, s = Math.sqrt(k * k + bl * bl) / ($abe42cac81644644$var$E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, $fS7Ud.degrees) - 120 : NaN;
    return new $abe42cac81644644$export$57ed4bde61a1e2f2(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $abe42cac81644644$export$2e2bcd8739ae039(h, s, l, opacity) {
    return arguments.length === 1 ? $abe42cac81644644$var$cubehelixConvert(h) : new $abe42cac81644644$export$57ed4bde61a1e2f2(h, s, l, opacity == null ? 1 : opacity);
}
function $abe42cac81644644$export$57ed4bde61a1e2f2(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $eeO9w.default)($abe42cac81644644$export$57ed4bde61a1e2f2, $abe42cac81644644$export$2e2bcd8739ae039, (0, $eeO9w.extend)((0, $7UL8A.Color), {
    brighter (k) {
        k = k == null ? (0, $7UL8A.brighter) : Math.pow((0, $7UL8A.brighter), k);
        return new $abe42cac81644644$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? (0, $7UL8A.darker) : Math.pow((0, $7UL8A.darker), k);
        return new $abe42cac81644644$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, $fS7Ud.radians), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, $7UL8A.Rgb)(255 * (l + a * ($abe42cac81644644$var$A * cosh + $abe42cac81644644$var$B * sinh)), 255 * (l + a * ($abe42cac81644644$var$C * cosh + $abe42cac81644644$var$D * sinh)), 255 * (l + a * ($abe42cac81644644$var$E * cosh)), this.opacity);
    }
}));

});
parcelRegister("fS7Ud", function(module, exports) {

$parcel$export(module.exports, "radians", () => $b8e20817cb73101d$export$8449e153fbd325fc);
$parcel$export(module.exports, "degrees", () => $b8e20817cb73101d$export$41fc368e1a942b97);
const $b8e20817cb73101d$export$8449e153fbd325fc = Math.PI / 180;
const $b8e20817cb73101d$export$41fc368e1a942b97 = 180 / Math.PI;

});



parcelRegister("45TwU", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fb2b41fd8805549$export$2e2bcd8739ae039);
$parcel$export(module.exports, "hclLong", () => $2fb2b41fd8805549$export$5aaa50f7615f9b70);

var $40oml = parcelRequire("40oml");

var $9fc6H = parcelRequire("9fc6H");
function $2fb2b41fd8805549$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $40oml.hcl)(start)).h, (end = (0, $40oml.hcl)(end)).h), c = (0, $9fc6H.default)(start.c, end.c), l = (0, $9fc6H.default)(start.l, end.l), opacity = (0, $9fc6H.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $2fb2b41fd8805549$export$2e2bcd8739ae039 = $2fb2b41fd8805549$var$hcl((0, $9fc6H.hue));
var $2fb2b41fd8805549$export$5aaa50f7615f9b70 = $2fb2b41fd8805549$var$hcl((0, $9fc6H.default));

});
parcelRegister("40oml", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eaa0ec960060b67$export$2e2bcd8739ae039);
$parcel$export(module.exports, "hcl", () => $2eaa0ec960060b67$export$d0e870ba50062ff1);

var $eeO9w = parcelRequire("eeO9w");

var $7UL8A = parcelRequire("7UL8A");

var $fS7Ud = parcelRequire("fS7Ud");
// https://observablehq.com/@mbostock/lab-and-rgb
const $2eaa0ec960060b67$var$K = 18, $2eaa0ec960060b67$var$Xn = 0.96422, $2eaa0ec960060b67$var$Yn = 1, $2eaa0ec960060b67$var$Zn = 0.82521, $2eaa0ec960060b67$var$t0 = 4 / 29, $2eaa0ec960060b67$var$t1 = 6 / 29, $2eaa0ec960060b67$var$t2 = 3 * $2eaa0ec960060b67$var$t1 * $2eaa0ec960060b67$var$t1, $2eaa0ec960060b67$var$t3 = $2eaa0ec960060b67$var$t1 * $2eaa0ec960060b67$var$t1 * $2eaa0ec960060b67$var$t1;
function $2eaa0ec960060b67$var$labConvert(o) {
    if (o instanceof $2eaa0ec960060b67$export$f2722c70a60257f7) return new $2eaa0ec960060b67$export$f2722c70a60257f7(o.l, o.a, o.b, o.opacity);
    if (o instanceof $2eaa0ec960060b67$export$d9397e094a5fbb9a) return $2eaa0ec960060b67$var$hcl2lab(o);
    if (!(o instanceof (0, $7UL8A.Rgb))) o = (0, $7UL8A.rgbConvert)(o);
    var r = $2eaa0ec960060b67$var$rgb2lrgb(o.r), g = $2eaa0ec960060b67$var$rgb2lrgb(o.g), b = $2eaa0ec960060b67$var$rgb2lrgb(o.b), y = $2eaa0ec960060b67$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $2eaa0ec960060b67$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $2eaa0ec960060b67$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $2eaa0ec960060b67$var$Xn);
        z = $2eaa0ec960060b67$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $2eaa0ec960060b67$var$Zn);
    }
    return new $2eaa0ec960060b67$export$f2722c70a60257f7(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $2eaa0ec960060b67$export$3e2c219d3ab79d01(l, opacity) {
    return new $2eaa0ec960060b67$export$f2722c70a60257f7(l, 0, 0, opacity == null ? 1 : opacity);
}
function $2eaa0ec960060b67$export$2e2bcd8739ae039(l, a, b, opacity) {
    return arguments.length === 1 ? $2eaa0ec960060b67$var$labConvert(l) : new $2eaa0ec960060b67$export$f2722c70a60257f7(l, a, b, opacity == null ? 1 : opacity);
}
function $2eaa0ec960060b67$export$f2722c70a60257f7(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $eeO9w.default)($2eaa0ec960060b67$export$f2722c70a60257f7, $2eaa0ec960060b67$export$2e2bcd8739ae039, (0, $eeO9w.extend)((0, $7UL8A.Color), {
    brighter (k) {
        return new $2eaa0ec960060b67$export$f2722c70a60257f7(this.l + $2eaa0ec960060b67$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $2eaa0ec960060b67$export$f2722c70a60257f7(this.l - $2eaa0ec960060b67$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $2eaa0ec960060b67$var$Xn * $2eaa0ec960060b67$var$lab2xyz(x);
        y = $2eaa0ec960060b67$var$Yn * $2eaa0ec960060b67$var$lab2xyz(y);
        z = $2eaa0ec960060b67$var$Zn * $2eaa0ec960060b67$var$lab2xyz(z);
        return new (0, $7UL8A.Rgb)($2eaa0ec960060b67$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $2eaa0ec960060b67$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $2eaa0ec960060b67$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $2eaa0ec960060b67$var$xyz2lab(t) {
    return t > $2eaa0ec960060b67$var$t3 ? Math.pow(t, 1 / 3) : t / $2eaa0ec960060b67$var$t2 + $2eaa0ec960060b67$var$t0;
}
function $2eaa0ec960060b67$var$lab2xyz(t) {
    return t > $2eaa0ec960060b67$var$t1 ? t * t * t : $2eaa0ec960060b67$var$t2 * (t - $2eaa0ec960060b67$var$t0);
}
function $2eaa0ec960060b67$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $2eaa0ec960060b67$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $2eaa0ec960060b67$var$hclConvert(o) {
    if (o instanceof $2eaa0ec960060b67$export$d9397e094a5fbb9a) return new $2eaa0ec960060b67$export$d9397e094a5fbb9a(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $2eaa0ec960060b67$export$f2722c70a60257f7)) o = $2eaa0ec960060b67$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $2eaa0ec960060b67$export$d9397e094a5fbb9a(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * (0, $fS7Ud.degrees);
    return new $2eaa0ec960060b67$export$d9397e094a5fbb9a(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $2eaa0ec960060b67$export$5a21418738164530(l, c, h, opacity) {
    return arguments.length === 1 ? $2eaa0ec960060b67$var$hclConvert(l) : new $2eaa0ec960060b67$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $2eaa0ec960060b67$export$d0e870ba50062ff1(h, c, l, opacity) {
    return arguments.length === 1 ? $2eaa0ec960060b67$var$hclConvert(h) : new $2eaa0ec960060b67$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $2eaa0ec960060b67$export$d9397e094a5fbb9a(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $2eaa0ec960060b67$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $2eaa0ec960060b67$export$f2722c70a60257f7(o.l, 0, 0, o.opacity);
    var h = o.h * (0, $fS7Ud.radians);
    return new $2eaa0ec960060b67$export$f2722c70a60257f7(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $eeO9w.default)($2eaa0ec960060b67$export$d9397e094a5fbb9a, $2eaa0ec960060b67$export$d0e870ba50062ff1, (0, $eeO9w.extend)((0, $7UL8A.Color), {
    brighter (k) {
        return new $2eaa0ec960060b67$export$d9397e094a5fbb9a(this.h, this.c, this.l + $2eaa0ec960060b67$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $2eaa0ec960060b67$export$d9397e094a5fbb9a(this.h, this.c, this.l - $2eaa0ec960060b67$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $2eaa0ec960060b67$var$hcl2lab(this).rgb();
    }
}));

});


parcelRegister("9faDM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6badc4c070d16f58$export$2e2bcd8739ae039);
$parcel$export(module.exports, "hslLong", () => $6badc4c070d16f58$export$a2c535e270a59256);

var $7UL8A = parcelRequire("7UL8A");

var $9fc6H = parcelRequire("9fc6H");
function $6badc4c070d16f58$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $7UL8A.hsl)(start)).h, (end = (0, $7UL8A.hsl)(end)).h), s = (0, $9fc6H.default)(start.s, end.s), l = (0, $9fc6H.default)(start.l, end.l), opacity = (0, $9fc6H.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $6badc4c070d16f58$export$2e2bcd8739ae039 = $6badc4c070d16f58$var$hsl((0, $9fc6H.hue));
var $6badc4c070d16f58$export$a2c535e270a59256 = $6badc4c070d16f58$var$hsl((0, $9fc6H.default));

});

parcelRegister("fBRs6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5d3c63d13f1ba54$export$2e2bcd8739ae039);

var $40oml = parcelRequire("40oml");

var $9fc6H = parcelRequire("9fc6H");
function $b5d3c63d13f1ba54$export$2e2bcd8739ae039(start, end) {
    var l = (0, $9fc6H.default)((start = (0, $40oml.default)(start)).l, (end = (0, $40oml.default)(end)).l), a = (0, $9fc6H.default)(start.a, end.a), b = (0, $9fc6H.default)(start.b, end.b), opacity = (0, $9fc6H.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});



parcelRegister("7goQn", function(module, exports) {

$parcel$export(module.exports, "default", () => $549d4c81fda79cdb$export$2e2bcd8739ae039);
parcelRequire("dwFQU");
var $cRW5v = parcelRequire("cRW5v");
var $kSdfl = parcelRequire("kSdfl");
var $7yDT1 = parcelRequire("7yDT1");
var $2jkSd = parcelRequire("2jkSd");
var $dayZI = parcelRequire("dayZI");
var $8vb39 = parcelRequire("8vb39");
var $idw3k = parcelRequire("idw3k");

var $jjmqp = parcelRequire("jjmqp");
var $549d4c81fda79cdb$var$localTimeIntervals = {
    day: (0, $cRW5v.timeDay),
    hour: (0, $kSdfl.timeHour),
    minute: (0, $7yDT1.timeMinute),
    month: (0, $2jkSd.timeMonth),
    second: (0, $dayZI.second),
    week: (0, $8vb39.timeSunday),
    year: (0, $idw3k.timeYear)
};
var $549d4c81fda79cdb$var$utcIntervals = {
    day: (0, $cRW5v.utcDay),
    hour: (0, $kSdfl.utcHour),
    minute: (0, $7yDT1.utcMinute),
    month: (0, $2jkSd.utcMonth),
    second: (0, $dayZI.second),
    week: (0, $8vb39.utcSunday),
    year: (0, $idw3k.utcYear)
};
function $549d4c81fda79cdb$export$2e2bcd8739ae039(scale, config) {
    if ('nice' in config && typeof config.nice !== 'undefined' && 'nice' in scale) {
        var nice = config.nice;
        if (typeof nice === 'boolean') {
            if (nice) scale.nice();
        } else if (typeof nice === 'number') scale.nice(nice);
        else {
            var timeScale = scale;
            var isUtc = (0, $jjmqp.default)(timeScale);
            if (typeof nice === 'string') timeScale.nice(isUtc ? $549d4c81fda79cdb$var$utcIntervals[nice] : $549d4c81fda79cdb$var$localTimeIntervals[nice]);
            else {
                var interval = nice.interval, step = nice.step;
                var parsedInterval = (isUtc ? $549d4c81fda79cdb$var$utcIntervals[interval] : $549d4c81fda79cdb$var$localTimeIntervals[interval]).every(step);
                if (parsedInterval != null) timeScale.nice(parsedInterval);
            }
        }
    }
}

});
parcelRegister("dwFQU", function(module, exports) {
$parcel$export(module.exports, "timeDay", () => (parcelRequire("cRW5v")).timeDay);
$parcel$export(module.exports, "timeHour", () => (parcelRequire("kSdfl")).timeHour);
$parcel$export(module.exports, "timeMinute", () => (parcelRequire("7yDT1")).timeMinute);
$parcel$export(module.exports, "timeMonth", () => (parcelRequire("2jkSd")).timeMonth);
$parcel$export(module.exports, "timeSecond", () => (parcelRequire("dayZI")).second);
$parcel$export(module.exports, "timeWeek", () => (parcelRequire("8vb39")).timeSunday);
$parcel$export(module.exports, "timeYear", () => (parcelRequire("idw3k")).timeYear);
$parcel$export(module.exports, "utcDay", () => (parcelRequire("cRW5v")).utcDay);
$parcel$export(module.exports, "utcHour", () => (parcelRequire("kSdfl")).utcHour);
$parcel$export(module.exports, "utcMinute", () => (parcelRequire("7yDT1")).utcMinute);
$parcel$export(module.exports, "utcMonth", () => (parcelRequire("2jkSd")).utcMonth);
$parcel$export(module.exports, "utcSecond", () => (parcelRequire("dayZI")).second);
$parcel$export(module.exports, "utcWeek", () => (parcelRequire("8vb39")).utcSunday);
$parcel$export(module.exports, "utcYear", () => (parcelRequire("idw3k")).utcYear);
/**
 * `@visx/vendor/d3-time` (ESM)
 * See upstream license: https://github.com/d3/d3-time/blob/main/LICENSE
 *
 * This ESM package re-exports the underlying installed dependencies of 
 * `node_modules/d3-time`
 */ parcelRequire("gsGNk");

});
parcelRegister("gsGNk", function(module, exports) {

$parcel$export(module.exports, "utcMillisecond", () => (parcelRequire("co6MX")).millisecond);
$parcel$export(module.exports, "timeMillisecond", () => (parcelRequire("co6MX")).millisecond);
$parcel$export(module.exports, "utcSecond", () => (parcelRequire("dayZI")).second);
$parcel$export(module.exports, "timeSecond", () => (parcelRequire("dayZI")).second);
$parcel$export(module.exports, "timeMinute", () => (parcelRequire("7yDT1")).timeMinute);
$parcel$export(module.exports, "utcMinute", () => (parcelRequire("7yDT1")).utcMinute);
$parcel$export(module.exports, "timeHour", () => (parcelRequire("kSdfl")).timeHour);
$parcel$export(module.exports, "utcHour", () => (parcelRequire("kSdfl")).utcHour);
$parcel$export(module.exports, "timeDay", () => (parcelRequire("cRW5v")).timeDay);
$parcel$export(module.exports, "utcDay", () => (parcelRequire("cRW5v")).utcDay);
$parcel$export(module.exports, "timeWeek", () => (parcelRequire("8vb39")).timeSunday);
$parcel$export(module.exports, "utcWeek", () => (parcelRequire("8vb39")).utcSunday);
$parcel$export(module.exports, "timeMonth", () => (parcelRequire("2jkSd")).timeMonth);
$parcel$export(module.exports, "utcMonth", () => (parcelRequire("2jkSd")).utcMonth);
$parcel$export(module.exports, "timeYear", () => (parcelRequire("idw3k")).timeYear);
$parcel$export(module.exports, "utcYear", () => (parcelRequire("idw3k")).utcYear);


var $co6MX = parcelRequire("co6MX");

var $dayZI = parcelRequire("dayZI");

var $7yDT1 = parcelRequire("7yDT1");

var $kSdfl = parcelRequire("kSdfl");

var $cRW5v = parcelRequire("cRW5v");

var $8vb39 = parcelRequire("8vb39");

var $2jkSd = parcelRequire("2jkSd");

var $idw3k = parcelRequire("idw3k");

var $dCu2z = parcelRequire("dCu2z");

});



parcelRegister("c1r8l", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c0aa03447ba5a2e$export$2e2bcd8739ae039);
function $8c0aa03447ba5a2e$export$2e2bcd8739ae039(scale, config) {
    if ('padding' in scale && 'padding' in config && typeof config.padding !== 'undefined') scale.padding(config.padding);
    if ('paddingInner' in scale && 'paddingInner' in config && typeof config.paddingInner !== 'undefined') scale.paddingInner(config.paddingInner);
    if ('paddingOuter' in scale && 'paddingOuter' in config && typeof config.paddingOuter !== 'undefined') scale.paddingOuter(config.paddingOuter);
}

});

parcelRegister("dWXcN", function(module, exports) {

$parcel$export(module.exports, "default", () => $a27e9e1fda753c21$export$2e2bcd8739ae039);
function $a27e9e1fda753c21$export$2e2bcd8739ae039(scale, config) {
    if (config.reverse) {
        var reversedRange = scale.range().slice().reverse();
        if ('padding' in scale) // point and band scales
        scale.range(reversedRange);
        else // the rest
        scale.range(reversedRange);
    }
}

});

parcelRegister("4sSWK", function(module, exports) {

$parcel$export(module.exports, "default", () => $3404662c433becd8$export$2e2bcd8739ae039);

var $8Masb = parcelRequire("8Masb");
function $3404662c433becd8$export$2e2bcd8739ae039(scale, config) {
    if ('round' in config && typeof config.round !== 'undefined') {
        if (config.round && 'interpolate' in config && typeof config.interpolate !== 'undefined') console.warn("[visx/scale/applyRound] ignoring round: scale config contains round and interpolate. only applying interpolate. config:", config);
        else if ('round' in scale) // for point and band scales
        scale.round(config.round);
        else if ('interpolate' in scale && config.round) // for continuous output scales
        // setting config.round = true
        // is actually setting interpolator to interpolateRound
        // as these scales do not have scale.round() function
        scale.interpolate((0, $8Masb.default));
    }
}

});

parcelRegister("iuIpV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d76d7ba35e78d530$export$2e2bcd8739ae039);
function $d76d7ba35e78d530$export$2e2bcd8739ae039(scale, config) {
    if ('unknown' in scale && 'unknown' in config && typeof config.unknown !== 'undefined') scale.unknown(config.unknown);
}

});

parcelRegister("jUCfg", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7f0ea00b7703963$export$2e2bcd8739ae039);
function $e7f0ea00b7703963$export$2e2bcd8739ae039(scale, config) {
    if ('zero' in config && config.zero === true) {
        var domain = scale.domain();
        var a = domain[0], b = domain[1];
        var isDescending = b < a;
        var _ref = isDescending ? [
            b,
            a
        ] : [
            a,
            b
        ], min = _ref[0], max = _ref[1];
        var domainWithZero = [
            Math.min(0, min),
            Math.max(0, max)
        ];
        scale.domain(isDescending ? domainWithZero.reverse() : domainWithZero);
    }
}

});



const $22cf0ae7e72c2bef$export$b3026b3c8d26dc41 = 70;

parcelRegister("8LERT", function(module, exports) {

$parcel$export(module.exports, "default", () => $66226a162ab0f42c$export$2e2bcd8739ae039);

var $aDODq = parcelRequire("aDODq");
function $66226a162ab0f42c$export$2e2bcd8739ae039(_ref, horizontal) {
    let { x: x, y: y } = _ref;
    return new (0, $aDODq.default)(horizontal ? {
        x: x,
        y: y
    } : {
        x: y,
        y: x
    });
}

});
parcelRegister("aDODq", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bf4d2f2ef1d9d73$export$2e2bcd8739ae039);
class $7bf4d2f2ef1d9d73$export$2e2bcd8739ae039 {
    x = 0;
    y = 0;
    constructor(_ref){
        let { x: x = 0, y: y = 0 } = _ref;
        this.x = x;
        this.y = y;
    }
    value() {
        return {
            x: this.x,
            y: this.y
        };
    }
    toArray() {
        return [
            this.x,
            this.y
        ];
    }
}

});


parcelRegister("4ZQLi", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a35c94ede701419$export$2e2bcd8739ae039);
/**
 * Create a function that returns a tick position for the given tick value
 */ function $3a35c94ede701419$export$2e2bcd8739ae039(scale, align) {
    if (align === void 0) align = 'center';
    // Broaden type before using 'xxx' in s as typeguard.
    const s = scale;
    // For point or band scales,
    // have to add offset to make the tick at center or end.
    if (align !== 'start' && 'bandwidth' in s) {
        let offset = s.bandwidth();
        if (align === 'center') offset /= 2;
        if (s.round()) offset = Math.round(offset);
        return (d)=>{
            const scaledValue = s(d);
            return typeof scaledValue === 'number' ? scaledValue + offset : scaledValue;
        };
    }
    return scale;
}

});



parcelRegister("cXzUG", function(module, exports) {

$parcel$export(module.exports, "AxisLeftTick", () => $96f6da52418ad5a2$export$d9ad68803a03e71);
$parcel$export(module.exports, "AxisLeftLine", () => $96f6da52418ad5a2$export$25abdf51e62eb76e);
$parcel$export(module.exports, "AxisLeftText", () => $96f6da52418ad5a2$export$68f34be0235fe9c0);
$parcel$export(module.exports, "AxisLeft", () => $96f6da52418ad5a2$export$4b76feaa547cd202);
/* AxisLeft.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $bT1Sw = parcelRequire("bT1Sw");

var $eFK63 = parcelRequire("eFK63");

var $jxg43 = parcelRequire("jxg43");

var $42C9W = parcelRequire("42C9W");

var $f8uii = parcelRequire("f8uii");

var $da7Ww = parcelRequire("da7Ww");

var $l5ab7 = parcelRequire("l5ab7");

var $2vbO1 = parcelRequire("2vbO1");

var $kq3PX = parcelRequire("kq3PX");

var $2OMIu = parcelRequire("2OMIu");
const $96f6da52418ad5a2$export$ec95513e2647ff3 = {
    color: "var(--ds-text-subtlest, grey)",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    fontSize: 12
};
const $96f6da52418ad5a2$var$tickLength = 8;
const $96f6da52418ad5a2$var$orientation = (0, $jxg43.default).left;
const $96f6da52418ad5a2$export$d9ad68803a03e71 = (0, $bT1Sw.element)((0, $l5ab7.Tick));
const $96f6da52418ad5a2$export$25abdf51e62eb76e = (0, $bT1Sw.element)((_ref)=>{
    let { height: height, hide: hide } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $da7Ww.AxisLine), {
        hide: hide,
        style: {
            borderLeft: `2px solid ${(0, $da7Ww.axisLineStroke)}`,
            height: `${height}px`,
            position: 'absolute',
            transform: 'translateX(-1px)'
        }
    });
});
const $96f6da52418ad5a2$export$68f34be0235fe9c0 = (0, $bT1Sw.element)((_ref2)=>{
    let { width: width, formatter: formatter, truncate: truncate, singleline: singleline, children: children } = _ref2;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2vbO1.TickText), {
        style: {
            maxWidth: width
        },
        formatter: formatter,
        truncate: truncate,
        singleline: singleline,
        children: children
    });
});
function $96f6da52418ad5a2$var$AxisLeft(_ref3) {
    let { scale: scale, numTicks: numTicks, tickValues: tickValues, rangePadding: rangePadding, hideZero: hideZero, label: // TODO: Should label become it's own element?
    label, hide: hide } = _ref3;
    if (hide) return null;
    const { ticks: ticks } = (0, $kq3PX.useAxisTicks)({
        scale: scale,
        numTicks: numTicks,
        tickValues: tickValues,
        orientation: $96f6da52418ad5a2$var$orientation,
        rangePadding: rangePadding,
        hideZero: hideZero,
        tickLength: $96f6da52418ad5a2$var$tickLength
    });
    const TicksTextsComponent = ticks.map((_ref4)=>{
        let { value: value, index: index, from: from, to: to } = _ref4;
        const formatter = (0, $f8uii.default)(scale);
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            style: {
                // Ugh I hate you magic number
                top: `calc(${to.y}px - .6em)`,
                minWidth: 0,
                gridColumn: 1,
                gridRow: 1,
                position: 'relative',
                textAlign: 'right',
                ...$96f6da52418ad5a2$export$ec95513e2647ff3
            },
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($96f6da52418ad5a2$export$68f34be0235fe9c0, {
                formatter: formatter,
                width: 250,
                truncate: (0, $42C9W.default)(scale) === 'string',
                children: value
            })
        }, `axis-left-text-${index}-${value}-${from.toArray()}-${to.toArray()}`);
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                style: {
                    gridArea: 'plot',
                    display: 'flex'
                },
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($96f6da52418ad5a2$export$25abdf51e62eb76e, {
                    height: scale.range()[0]
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                "data-axis-type": "axis-left",
                className: (0, $bwpsq.default)([
                    "_nd5l1jbf _1e0c11p5 _yv0elpux _1tke1osq"
                ]),
                children: [
                    label ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        style: {
                            overflow: 'hidden',
                            maxHeight: '100%',
                            width: 'max-content',
                            textOverflow: 'ellipsis',
                            alignSelf: 'center',
                            writingMode: 'vertical-rl',
                            transform: 'rotate(-180deg)',
                            paddingLeft: '8px',
                            whiteSpace: 'nowrap',
                            ...(0, $eFK63.defaultTextHTMLProps)
                        },
                        children: label
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("div", {}),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            "_1e0c11p5 _1bsb1ris _wij21bp4 _yv0ehkll _2z05hkll _u5f31crf _lcxvglyw"
                        ]),
                        children: TicksTextsComponent
                    })
                ]
            })
        ]
    });
}
const $96f6da52418ad5a2$export$4b76feaa547cd202 = (0, $bT1Sw.element)($96f6da52418ad5a2$var$AxisLeft);

});

parcelRegister("lWVLr", function(module, exports) {

$parcel$export(module.exports, "LayoutContainer", () => $ffabd285ad88bd55$export$faad8b178f68f912);
$parcel$export(module.exports, "Layout", () => (parcelRequire("7Nxvv")).Layout);

var $7Nxvv = parcelRequire("7Nxvv");

var $2OMIu = parcelRequire("2OMIu");
function $ffabd285ad88bd55$export$faad8b178f68f912(_ref) {
    let { height: height, width: width, children: children, ...props } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7Nxvv.Layout), {
        showBorder: true,
        width: width,
        height: height,
        hasSubtitle: true,
        gridTemplate: (0, $7Nxvv.defaultGrid),
        ...props,
        children: children
    });
}

});
parcelRegister("7Nxvv", function(module, exports) {

$parcel$export(module.exports, "defaultGrid", () => $5ad719d8f2270c77$export$aed5b7d86c3777ab);
$parcel$export(module.exports, "Layout", () => $5ad719d8f2270c77$export$c84671f46d6a1ca);
/* layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $bT1Sw = parcelRequire("bT1Sw");

var $bSbfx = parcelRequire("bSbfx");

var $chU1I = parcelRequire("chU1I");

var $doqD0 = parcelRequire("doqD0");
var $l6fAT = parcelRequire("l6fAT");

var $2OMIu = parcelRequire("2OMIu");
const $5ad719d8f2270c77$export$aed5b7d86c3777ab = [
    'title',
    'subtitle',
    'legend',
    'plot'
];
function $5ad719d8f2270c77$var$Layout(_ref) {
    var _ref2, _ordering$plot;
    let { children: children, width: width, height: height, gridTemplate: gridTemplate, hasSubtitle: hasSubtitle, overflow: overflow = 'hidden', showBorder: showBorder = true } = _ref;
    const ordering = gridTemplate.reduce((acc, key, i)=>{
        acc[key] = i + 1;
        return acc;
    }, {});
    const chartOrder = (_ref2 = (_ordering$plot = ordering['plot']) !== null && _ordering$plot !== void 0 ? _ordering$plot : ordering['plot-legend']) !== null && _ref2 !== void 0 ? _ref2 : ordering['legend-plot'];
    const chartFlexDirection = ordering['plot'] || ordering['legend'] ? 'column' : 'row';
    const chartFlexReverse = ordering['legend'] > ordering['plot'] || ordering['plot-legend'] ? '-reverse' : '';
    const [fadeInOpacity, setFadeInOpacity] = (0, $5uXOq.useState)(0);
    (0, $5uXOq.useEffect)(()=>{
        let isMounted = true;
        const ref = window.requestAnimationFrame(()=>{
            // TODO: would be nice to fade in without triggering another render
            if (isMounted) setFadeInOpacity(1);
        });
        return ()=>{
            isMounted = false;
            window.cancelAnimationFrame(ref);
        };
    }, [
        setFadeInOpacity
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            "data-element": "layout",
            style: {
                width: width,
                height: height,
                backgroundColor: "var(--ds-surface, white)",
                border: showBorder ? `1px solid ${"var(--ds-border, lightgrey)"}` : '0px',
                padding: showBorder ? "var(--ds-space-200, 16px)" : 0,
                overflow: overflow
            },
            className: (0, $bwpsq.default)([
                "_1e0c1txw _kqswh2mm _4t3i1osq _2lx21bp4 _vchhusvi"
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                    style: {
                        order: ordering.title,
                        position: 'relative'
                    },
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bSbfx.Icon), {}),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l6fAT.Title), {})
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    style: {
                        order: ordering.subtitle
                    },
                    children: hasSubtitle && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $doqD0.Subtitle), {})
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    "data-element": "chart",
                    style: {
                        opacity: fadeInOpacity,
                        transition: 'opacity .3s ease-in-out',
                        order: chartOrder,
                        flexDirection: `${chartFlexDirection}${chartFlexReverse}`
                    },
                    className: (0, $bwpsq.default)([
                        "_1e0c1txw _1ul9idpf _1tkeidpf _16jlkb7n"
                    ]),
                    children: children
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $chU1I.ChartMenu), {})
            ]
        })
    });
}
const $5ad719d8f2270c77$export$c84671f46d6a1ca = (0, $bT1Sw.element)($5ad719d8f2270c77$var$Layout);

});
parcelRegister("bSbfx", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $8a4d76c7fe38e6da$export$f04a61298a47a40f);
/* icon.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $bT1Sw = parcelRequire("bT1Sw");

var $2OMIu = parcelRequire("2OMIu");
const $8a4d76c7fe38e6da$var$iconStyle = null;
function $8a4d76c7fe38e6da$var$Icon(_ref) {
    let { children: children } = _ref;
    if (!children) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _4t3i1tcg _syaz1oju"
        ]),
        children: children
    });
}
const $8a4d76c7fe38e6da$export$f04a61298a47a40f = (0, $bT1Sw.element)($8a4d76c7fe38e6da$var$Icon);

});

parcelRegister("chU1I", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $8f22884b61eb2a4d$export$d9b273488cd8ce6f);
$parcel$export(module.exports, "ChartMenu", () => $8f22884b61eb2a4d$export$597da2837c1a3c88);

var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $3oUqw = parcelRequire("3oUqw");

var $bT1Sw = parcelRequire("bT1Sw");
var $17PP9 = parcelRequire("17PP9");
parcelRequire("lWVLr");
var $7Nxvv = parcelRequire("7Nxvv");

var $3Anq0 = parcelRequire("3Anq0");

var $PfPCm = parcelRequire("PfPCm");

var $2OMIu = parcelRequire("2OMIu");
const $8f22884b61eb2a4d$export$d9b273488cd8ce6f = (0, $bT1Sw.element)((_ref)=>{
    let { children: children, hide: hide = false, toggleDataTable: toggleDataTable, toggleShowPatterns: toggleShowPatterns, showPatterns: showPatterns, disablePatternOption: disablePatternOption = false } = _ref;
    if (hide) return null;
    const { showBorder: showBorder } = (0, $17PP9.useElementProps)((0, $7Nxvv.Layout));
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            position: 'absolute',
            top: 0,
            right: 0,
            padding: showBorder ? "var(--ds-space-200, 16px)" : 0
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $BLPHT.default), {
            trigger: (_ref2)=>{
                let { triggerRef: triggerRef, ...props } = _ref2;
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    ...props,
                    appearance: "subtle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($3oUqw))),
                    label: "Chart Menu",
                    ref: triggerRef,
                    spacing: "compact"
                });
            },
            label: "Chart Menu",
            shouldRenderToParent: true,
            placement: "top-end",
            spacing: "compact",
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $aRoVz.default), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
                        onClick: toggleDataTable,
                        testId: (0, $3Anq0.a11yStrings).showDataTable,
                        children: (0, $3Anq0.a11yStrings).showDataTable
                    }, (0, $3Anq0.a11yStrings).showDataTable),
                    !disablePatternOption ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
                        onClick: toggleShowPatterns,
                        testId: (0, $3Anq0.a11yStrings).enablePatterns,
                        children: showPatterns ? (0, $3Anq0.a11yStrings).disablePatterns : (0, $3Anq0.a11yStrings).enablePatterns
                    }, (0, $3Anq0.a11yStrings).enablePatterns) : null,
                    children
                ]
            })
        })
    });
});
function $8f22884b61eb2a4d$export$597da2837c1a3c88(props) {
    const { toggleDataTable: toggleDataTable, toggleShowPatterns: toggleShowPatterns, showPatterns: showPatterns } = (0, $PfPCm.useMenuData)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($8f22884b61eb2a4d$export$d9b273488cd8ce6f, {
        ...props,
        toggleDataTable: toggleDataTable,
        toggleShowPatterns: toggleShowPatterns,
        showPatterns: showPatterns
    });
}

});
parcelRegister("3Anq0", function(module, exports) {

$parcel$export(module.exports, "a11yStrings", () => $29c6e64aba406dd9$export$1bab900455080d68);
const $29c6e64aba406dd9$export$1bab900455080d68 = {
    enablePatterns: 'Enable Patterns',
    disablePatterns: 'Disable Patterns',
    showDataTable: 'Show Data Table'
};

});

parcelRegister("PfPCm", function(module, exports) {

$parcel$export(module.exports, "useMenuData", () => $09a10b5983af36a5$export$bf0039e2171862f5);
$parcel$export(module.exports, "MenuProvider", () => $09a10b5983af36a5$export$62b22d151866115d);

var $5uXOq = parcelRequire("5uXOq");

var $2OMIu = parcelRequire("2OMIu");
function $09a10b5983af36a5$export$2ce5e940c4008526() {
    const [showDataTable, setShowDataTable] = (0, $5uXOq.useState)(false);
    const [showPatterns, setShowPatterns] = (0, $5uXOq.useState)(false);
    const toggleDataTable = (0, $5uXOq.useCallback)(()=>{
        setShowDataTable((prevShowDataTable)=>!prevShowDataTable);
    }, [
        setShowDataTable
    ]);
    const closeDataTable = (0, $5uXOq.useCallback)(()=>{
        setShowDataTable(false);
    }, [
        setShowDataTable
    ]);
    const toggleShowPatterns = (0, $5uXOq.useCallback)(()=>{
        setShowPatterns((prevShowPatterns)=>!prevShowPatterns);
    }, [
        setShowPatterns
    ]);
    return {
        showDataTable: showDataTable,
        closeDataTable: closeDataTable,
        toggleDataTable: toggleDataTable,
        showPatterns: showPatterns,
        toggleShowPatterns: toggleShowPatterns
    };
}
const $09a10b5983af36a5$export$c7e742effb1c51e2 = /*#__PURE__*/ (0, $5uXOq.createContext)({});
function $09a10b5983af36a5$export$bf0039e2171862f5() {
    return (0, $5uXOq.useContext)($09a10b5983af36a5$export$c7e742effb1c51e2);
}
const $09a10b5983af36a5$export$62b22d151866115d = (_ref)=>{
    let { children: children } = _ref;
    const { showDataTable: showDataTable, toggleDataTable: toggleDataTable, closeDataTable: closeDataTable, showPatterns: showPatterns, toggleShowPatterns: toggleShowPatterns } = $09a10b5983af36a5$export$2ce5e940c4008526();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($09a10b5983af36a5$export$c7e742effb1c51e2.Provider, {
        value: {
            showDataTable: showDataTable,
            showPatterns: showPatterns,
            closeDataTable: closeDataTable,
            toggleDataTable: toggleDataTable,
            toggleShowPatterns: toggleShowPatterns
        },
        children: children
    });
};

});


parcelRegister("doqD0", function(module, exports) {

$parcel$export(module.exports, "Subtitle", () => $9c022c0b2fd1f025$export$cf345ef34cd72655);
/* subtitle.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $bT1Sw = parcelRequire("bT1Sw");

var $2OMIu = parcelRequire("2OMIu");
const $9c022c0b2fd1f025$var$subTitleTextStyle = null;
function $9c022c0b2fd1f025$var$Subtitle(_ref) {
    let { children: children } = _ref;
    if (!children) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("h3", {
        className: (0, $bwpsq.default)([
            "_syaz1gjq _k48p1nn1 _ect41wi2 _1wyb1crf _zg8l4jg8 _vwz47vkz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdftgi _19bvidpf"
        ]),
        children: children
    });
}
const $9c022c0b2fd1f025$export$cf345ef34cd72655 = (0, $bT1Sw.element)($9c022c0b2fd1f025$var$Subtitle);

});



parcelRegister("e2CtX", function(module, exports) {

$parcel$export(module.exports, "DimensionsWrapper", () => $a38f1a5b7b4f9d3d$export$a263c0cd0abdd921);

var $5uXOq = parcelRequire("5uXOq");
const $a38f1a5b7b4f9d3d$var$INITIAL_DIMENSIONS = {
    plotHeight: 100,
    plotWidth: 100,
    margin: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }
};
function $a38f1a5b7b4f9d3d$export$a263c0cd0abdd921(_ref) {
    let { children: children } = _ref;
    const [, forceUpdate] = (0, $5uXOq.useState)({});
    const dimensions = (0, $5uXOq.useRef)($a38f1a5b7b4f9d3d$var$INITIAL_DIMENSIONS);
    const plotSvgRef = (0, $5uXOq.useRef)(null);
    // Update the dimensions and margin when the SVG element is resized.
    (0, $5uXOq.useEffect)(()=>{
        const resizeObserverSvg = new ResizeObserver((entries)=>{
            if (entries && entries[0]) {
                const { width: ws, height: hs } = entries[0].target.getBoundingClientRect();
                const newMargin = Object.assign({}, dimensions.current.margin);
                dimensions.current = {
                    margin: newMargin,
                    plotHeight: hs,
                    plotWidth: ws
                };
                forceUpdate({});
            }
        });
        // If parentDiv is available, observe it and its axis-left child (if exists).
        // If not, disconnect the observers.
        if (plotSvgRef.current) resizeObserverSvg.observe(plotSvgRef.current);
        return ()=>{
            resizeObserverSvg.disconnect();
        };
    }, []);
    return children({
        ...dimensions.current,
        plotSvgRef: plotSvgRef
    });
}

});

parcelRegister("erST8", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $a84e29f28dbcd30d$export$ef2184bd89960b14);

var $bT1Sw = parcelRequire("bT1Sw");

var $jfNuF = parcelRequire("jfNuF");

var $f6BRA = parcelRequire("f6BRA");

var $2OMIu = parcelRequire("2OMIu");
function $a84e29f28dbcd30d$var$Grid(_ref) {
    let { top: top, left: left, xScale: xScale, yScale: yScale, width: width, height: height, rowStrokeWidth: rowStrokeWidth, columnStrokeWidth: columnStrokeWidth, columnStroke: columnStroke, rowStroke: rowStroke, numTicksRows: numTicksRows, numTicksColumns: numTicksColumns, rowLineStyle: rowLineStyle, columnLineStyle: columnLineStyle, xOffset: xOffset, yOffset: yOffset, rowTickValues: rowTickValues, columnTickValues: columnTickValues, hide: hide = false } = _ref;
    if (hide) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        style: {
            top: top,
            left: left,
            gridArea: 'plot'
        },
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f6BRA.GridRows), {
                scale: yScale,
                width: width,
                stroke: rowStroke,
                strokeWidth: rowStrokeWidth,
                numTicks: numTicksRows,
                lineStyle: rowLineStyle,
                offset: yOffset,
                tickValues: rowTickValues
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jfNuF.GridColumns), {
                scale: xScale,
                height: height,
                stroke: columnStroke,
                strokeWidth: columnStrokeWidth,
                numTicks: numTicksColumns,
                lineStyle: columnLineStyle,
                offset: xOffset,
                tickValues: columnTickValues
            })
        ]
    });
}
const $a84e29f28dbcd30d$export$ef2184bd89960b14 = (0, $bT1Sw.element)($a84e29f28dbcd30d$var$Grid);

});
parcelRegister("jfNuF", function(module, exports) {

$parcel$export(module.exports, "GridColumns", () => $e045cf746f0b4756$export$22a67e3ff32a357a);

var $5uXOq = parcelRequire("5uXOq");

var $bT1Sw = parcelRequire("bT1Sw");

var $hqZma = parcelRequire("hqZma");

var $kq3PX = parcelRequire("kq3PX");

var $jxg43 = parcelRequire("jxg43");

var $aDODq = parcelRequire("aDODq");

var $cMo1a = parcelRequire("cMo1a");

var $8KrAm = parcelRequire("8KrAm");

var $2OMIu = parcelRequire("2OMIu");
function $e045cf746f0b4756$var$GridColumns(_ref) {
    let { top: top = 0, left: left = 0, scale: scale, height: height, stroke: stroke = "var(--ds-border, lightgrey)", strokeWidth: strokeWidth = 1, numTicks: numTicks, lineStyle: lineStyle = 'solid', offset: offset, tickValues: tickValues, hide: hide = false } = _ref;
    if (hide) return null;
    const { ticks: ticks } = (0, $kq3PX.useAxisTicks)({
        scale: scale,
        numTicks: numTicks,
        tickValues: tickValues,
        tickLength: 8,
        orientation: (0, $jxg43.default).bottom,
        rangePadding: undefined
    });
    const scaleOffset = (offset !== null && offset !== void 0 ? offset : 0) + (0, $8KrAm.default)(scale) / 2;
    const tickLines = ticks.map((_ref2)=>{
        var _coerceNumber;
        let { value: value, index: index } = _ref2;
        const x = ((_coerceNumber = (0, $cMo1a.default)(scale(value))) !== null && _coerceNumber !== void 0 ? _coerceNumber : 0) + scaleOffset;
        return {
            index: index,
            from: new (0, $aDODq.default)({
                x: x,
                y: 0
            }),
            to: new (0, $aDODq.default)({
                x: x,
                y: height
            })
        };
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            top: top,
            left: left,
            position: 'relative'
        },
        children: tickLines.map((_ref3)=>{
            let { from: from, to: to, index: index } = _ref3;
            return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hqZma.AxisBottomTick), {
                        from: from,
                        to: to
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        style: {
                            borderLeft: `${stroke} ${lineStyle} ${strokeWidth}px`,
                            height: `${to.y}px`,
                            position: 'absolute',
                            left: to.x
                        }
                    })
                ]
            }, `grid-columns-lines-${index}-${from.toArray()}-${to.toArray()}`);
        })
    });
}
const $e045cf746f0b4756$export$22a67e3ff32a357a = (0, $bT1Sw.element)($e045cf746f0b4756$var$GridColumns);

});
parcelRegister("8KrAm", function(module, exports) {

$parcel$export(module.exports, "default", () => $65e80487c092a9cc$export$2e2bcd8739ae039);
function $65e80487c092a9cc$export$2e2bcd8739ae039(scale) {
    return 'bandwidth' in scale ? scale.bandwidth() : 0;
}

});


parcelRegister("f6BRA", function(module, exports) {

$parcel$export(module.exports, "GridRows", () => $aff4c96cf8a8e597$export$f7ce055fe2ce64b1);

var $5uXOq = parcelRequire("5uXOq");

var $bT1Sw = parcelRequire("bT1Sw");

var $cXzUG = parcelRequire("cXzUG");

var $kq3PX = parcelRequire("kq3PX");

var $jxg43 = parcelRequire("jxg43");

var $aDODq = parcelRequire("aDODq");

var $cMo1a = parcelRequire("cMo1a");

var $8KrAm = parcelRequire("8KrAm");

var $2OMIu = parcelRequire("2OMIu");
function $aff4c96cf8a8e597$var$GridRows(_ref) {
    let { top: top = 0, left: left = 0, scale: scale, width: width, stroke: stroke = "var(--ds-border, lightgrey)", strokeWidth: strokeWidth = 1, numTicks: numTicks, lineStyle: lineStyle = 'solid', offset: offset, tickValues: tickValues, hide: hide = false } = _ref;
    if (hide) return null;
    const { ticks: ticks } = (0, $kq3PX.useAxisTicks)({
        scale: scale,
        numTicks: numTicks,
        tickValues: tickValues,
        tickLength: 8,
        orientation: (0, $jxg43.default).left,
        rangePadding: undefined
    });
    const scaleOffset = (offset !== null && offset !== void 0 ? offset : 0) + (0, $8KrAm.default)(scale) / 2;
    const tickLines = ticks.map((_ref2)=>{
        var _coerceNumber;
        let { value: value, index: index } = _ref2;
        const y = ((_coerceNumber = (0, $cMo1a.default)(scale(value))) !== null && _coerceNumber !== void 0 ? _coerceNumber : 0) + scaleOffset;
        return {
            index: index,
            from: new (0, $aDODq.default)({
                x: 0,
                y: y
            }),
            to: new (0, $aDODq.default)({
                x: width,
                y: y
            })
        };
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            top: top,
            left: left,
            position: 'relative'
        },
        children: tickLines.map((_ref3)=>{
            let { from: from, to: to, index: index } = _ref3;
            return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cXzUG.AxisLeftTick), {
                        from: from,
                        to: to
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        style: {
                            borderBottom: `${strokeWidth}px ${lineStyle} ${stroke}`,
                            width: `${to.x}px`,
                            position: 'absolute',
                            top: `calc(${to.y}px)`
                        }
                    })
                ]
            }, `grid-rows-lines-${index}-${from.toArray()}-${to.toArray()}`);
        })
    });
}
const $aff4c96cf8a8e597$export$f7ce055fe2ce64b1 = (0, $bT1Sw.element)($aff4c96cf8a8e597$var$GridRows);

});


parcelRegister("3B9ij", function(module, exports) {

$parcel$export(module.exports, "LegendLabel", () => $29ec097709f60bdd$export$f77025011665b85c);
$parcel$export(module.exports, "OrdinalLegend", () => $29ec097709f60bdd$export$7f71253a43a34ee6);
/* OrdinalLegend.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $iZnN2 = parcelRequire("iZnN2");

var $bT1Sw = parcelRequire("bT1Sw");
var $17PP9 = parcelRequire("17PP9");

var $7Nxvv = parcelRequire("7Nxvv");


var $gEnb9 = parcelRequire("gEnb9");

var $2OMIu = parcelRequire("2OMIu");
const $29ec097709f60bdd$export$83dfac8e05432e26 = {
    color: "var(--ds-text-subtlest, #626F86)",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    fontSize: '12px',
    margin: '8px 0px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
};
const $29ec097709f60bdd$var$LegendSymbol = (_ref)=>{
    let { color: color, shape: shape } = _ref;
    let symbol;
    switch(shape){
        case 'square':
            symbol = /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                fill: color,
                width: (0, $0bd291d77cbdd29d$export$1949567a35c96224),
                height: (0, $0bd291d77cbdd29d$export$1949567a35c96224),
                rx: 1,
                ry: 1
            });
            break;
        case 'line':
            symbol = /*#__PURE__*/ (0, $2OMIu.jsx)("line", {
                x1: 0,
                y1: (0, $0bd291d77cbdd29d$export$1949567a35c96224) / 2,
                x2: (0, $0bd291d77cbdd29d$export$1949567a35c96224),
                y2: (0, $0bd291d77cbdd29d$export$1949567a35c96224) / 2,
                stroke: color,
                strokeWidth: 2
            });
            break;
        case 'circle':
        default:
            symbol = /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                fill: color,
                width: (0, $0bd291d77cbdd29d$export$1949567a35c96224),
                height: (0, $0bd291d77cbdd29d$export$1949567a35c96224),
                rx: (0, $0bd291d77cbdd29d$export$1949567a35c96224) / 2,
                ry: (0, $0bd291d77cbdd29d$export$1949567a35c96224) / 2
            });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            width: (0, $0bd291d77cbdd29d$export$1949567a35c96224),
            height: (0, $0bd291d77cbdd29d$export$1949567a35c96224),
            children: symbol
        })
    });
};
const $29ec097709f60bdd$export$f77025011665b85c = (0, $bT1Sw.element)((_ref2)=>{
    let { labelAccessor: labelAccessor, datum: datum } = _ref2;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_syaz131l _ect41wi2 _1wyb1crf _19pkftgi _2hwxidpf _otyrftgi _18u0idpf _1bto1l2s _1reo15vq _18m915vq _o5721q9c"
        ]),
        children: labelAccessor(datum)
    });
});
const $29ec097709f60bdd$var$VerticalLegendMark = (_ref3)=>{
    let { color: color, labelAccessor: labelAccessor, shape: shape, opacity: opacity, datum: datum } = _ref3;
    const label = labelAccessor(datum);
    const { emitActiveSeriesKey: emitActiveSeriesKey } = (0, $iZnN2.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        style: {
            opacity: opacity
        },
        onPointerEnter: (e)=>emitActiveSeriesKey(e, label),
        onPointerLeave: (e)=>emitActiveSeriesKey(e, undefined),
        className: (0, $bwpsq.default)([
            "_1e0c1txw _zulpftgi _p12f1osq _4t3izwfg _1ul9idpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($29ec097709f60bdd$var$LegendSymbol, {
                color: color,
                shape: shape
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($29ec097709f60bdd$export$f77025011665b85c, {
                datum: datum,
                labelAccessor: labelAccessor
            })
        ]
    });
};
const $29ec097709f60bdd$var$HorizontalLegendMark = (_ref4)=>{
    let { color: color, labelAccessor: labelAccessor, shape: shape, opacity: opacity, datum: datum } = _ref4;
    const label = labelAccessor(datum);
    const { emitActiveSeriesKey: emitActiveSeriesKey } = (0, $iZnN2.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        style: {
            opacity: opacity
        },
        onPointerEnter: (e)=>emitActiveSeriesKey(e, label),
        onPointerLeave: (e)=>emitActiveSeriesKey(e, undefined),
        className: (0, $bwpsq.default)([
            "_1e0c116y _zulpftgi _4t3izwfg _1ul9idpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($29ec097709f60bdd$var$LegendSymbol, {
                color: color,
                shape: shape
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($29ec097709f60bdd$export$f77025011665b85c, {
                labelAccessor: labelAccessor,
                datum: datum
            })
        ]
    });
};
function $29ec097709f60bdd$var$VerticalLegend(_ref5) {
    let { data: data, colorAccessor: colorAccessor, colorScale: colorScale, labelAccessor: labelAccessor, shape: shape, justifyContent: justifyContent = 'center', maxRows: maxRows = 10 } = _ref5;
    const legendRef = (0, $5uXOq.useRef)(null);
    const [truncationIndex, setTruncationIndex] = (0, $5uXOq.useState)((0, $0bd291d77cbdd29d$export$7bf402e928540137));
    const flatData = (0, $gEnb9.useFlatData)({
        labelAccessor: labelAccessor,
        data: data
    });
    (0, $gEnb9.useTruncationIndexObserver)({
        legendRefCurrent: legendRef.current,
        setTruncationIndex: setTruncationIndex
    });
    const itemsToTruncate = flatData.length - (truncationIndex || 0);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: legendRef,
        style: {
            maxHeight: `${maxRows * (0, $0bd291d77cbdd29d$export$bc48d9a7fd313bb2) + 2}px`,
            justifyContent: justifyContent
        },
        className: (0, $bwpsq.default)([
            "_1e0c116y _1bah1h6o _1n261g80 _16jlidpf _1o9zidpf _i0dl1r5k _2lx21bp4 _ae4v1y6m _19pk1wug _2hwx1wug _otyr1wug _18u01wug _19bv1crf _4t3i1osq _1reo15vq _18m915vq _gy1p7vkz"
        ]),
        children: flatData.map((d, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                children: itemsToTruncate > 0 && truncationIndex - 1 <= i ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                        style: {
                            position: 'relative'
                        },
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)($29ec097709f60bdd$var$VerticalLegendMark, {
                                color: colorScale(colorAccessor(d)),
                                labelAccessor: labelAccessor,
                                shape: shape,
                                opacity: 0,
                                datum: d
                            }, labelAccessor(d)),
                            truncationIndex - 1 === i && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                style: {
                                    position: 'absolute',
                                    top: 0,
                                    left: 0
                                },
                                className: (0, $bwpsq.default)([
                                    "_syaz131l _ect41wi2 _1wyb1crf _19pkftgi _2hwxidpf _otyrftgi _18u0idpf _1bto1l2s _1reo15vq _18m915vq _o5721q9c"
                                ]),
                                children: ` ... ${itemsToTruncate + 1} more`
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)($29ec097709f60bdd$var$VerticalLegendMark, {
                    color: colorScale(colorAccessor(d)),
                    labelAccessor: labelAccessor,
                    shape: shape,
                    datum: d
                }, labelAccessor(d))
            }, `vertical-leged-entry${labelAccessor(d)}-${colorScale(colorAccessor(d))}-${i}`))
    });
}
function $29ec097709f60bdd$var$HorizontalLegend(_ref6) {
    let { data: data, colorAccessor: colorAccessor, colorScale: colorScale, labelAccessor: labelAccessor, shape: shape, justifyContent: justifyContent = 'flex-start', flexDirection: flexDirection = 'row', maxRows: maxRows = 5 } = _ref6;
    const legendRef = (0, $5uXOq.useRef)(null);
    const [truncationIndex, setTruncationIndex] = (0, $5uXOq.useState)((0, $0bd291d77cbdd29d$export$7bf402e928540137));
    const flatData = (0, $gEnb9.useFlatData)({
        labelAccessor: labelAccessor,
        data: data
    });
    (0, $gEnb9.useTruncationIndexObserver)({
        legendRefCurrent: legendRef.current,
        setTruncationIndex: setTruncationIndex
    });
    const itemsToTruncate = flatData.length - (truncationIndex || 0);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: legendRef,
        className: (0, $bwpsq.default)([
            "_1e0c116y _1n261g80 _16jlidpf _1o9zidpf _i0dl1wug _2lx21o5q _ae4v1y6m _1bsb1osq _1reo15vq _18m915vq _gy1p7vkz"
        ]),
        style: {
            maxHeight: `${maxRows * (0, $0bd291d77cbdd29d$export$bc48d9a7fd313bb2) + 2}px`,
            justifyContent: justifyContent,
            "--_j9pi5t": (0, $lD23V.default)(flexDirection)
        },
        children: flatData.map((d, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                children: itemsToTruncate > 0 && truncationIndex - 1 === i ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                        style: {
                            position: 'relative'
                        },
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)($29ec097709f60bdd$var$HorizontalLegendMark, {
                                color: colorScale(colorAccessor(d)),
                                labelAccessor: labelAccessor,
                                shape: shape,
                                opacity: 0,
                                datum: d
                            }, labelAccessor(d)),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                style: {
                                    position: 'absolute',
                                    top: 0,
                                    left: 0
                                },
                                className: (0, $bwpsq.default)([
                                    "_syaz131l _ect41wi2 _1wyb1crf _19pkftgi _2hwxidpf _otyrftgi _18u0idpf _1bto1l2s _1reo15vq _18m915vq _o5721q9c"
                                ]),
                                children: ` ... ${itemsToTruncate + 1} more`
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)($29ec097709f60bdd$var$HorizontalLegendMark, {
                    color: colorScale(colorAccessor(d)),
                    labelAccessor: labelAccessor,
                    shape: shape,
                    datum: d
                }, labelAccessor(d))
            }, `horizontal-leged-entry${labelAccessor(d)}-${colorScale(colorAccessor(d))}-${i}`))
    });
}
function $29ec097709f60bdd$export$734b3ee2d20431e7(_ref7) {
    var _layoutProps$gridTemp;
    let { data: data, colorAccessor: colorAccessor, colorScale: colorScale, labelAccessor: labelAccessor, shape: shape, maxRows: maxRows, justifyContent: justifyContent, flexDirection: flexDirection = 'row', hide: hide = false } = _ref7;
    const layoutProps = (0, $17PP9.useElementProps)((0, $7Nxvv.Layout));
    const sideBySide = !((_layoutProps$gridTemp = layoutProps.gridTemplate) !== null && _layoutProps$gridTemp !== void 0 && _layoutProps$gridTemp.includes('legend'));
    if (hide) return null;
    if (sideBySide) return /*#__PURE__*/ (0, $2OMIu.jsx)($29ec097709f60bdd$var$VerticalLegend, {
        data: data,
        colorAccessor: colorAccessor,
        colorScale: colorScale,
        labelAccessor: labelAccessor,
        shape: shape,
        maxRows: maxRows,
        justifyContent: justifyContent
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($29ec097709f60bdd$var$HorizontalLegend, {
        data: data,
        colorAccessor: colorAccessor,
        colorScale: colorScale,
        labelAccessor: labelAccessor,
        shape: shape,
        maxRows: maxRows,
        justifyContent: justifyContent,
        flexDirection: flexDirection
    });
}
const $29ec097709f60bdd$export$7f71253a43a34ee6 = (0, $bT1Sw.element)($29ec097709f60bdd$export$734b3ee2d20431e7);

});
parcelRegister("iZnN2", function(module, exports) {

$parcel$export(module.exports, "EVENT_TYPE", () => $dd3060ab55d6e4ba$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "SERIES_SOURCE", () => $dd3060ab55d6e4ba$export$8312cda563b4f1d7);
$parcel$export(module.exports, "default", () => $dd3060ab55d6e4ba$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lI55a = parcelRequire("lI55a");
const $dd3060ab55d6e4ba$export$76a2e4c433c23bb9 = 'pointermove';
const $dd3060ab55d6e4ba$export$8312cda563b4f1d7 = 'series-key-highlight';
function $dd3060ab55d6e4ba$export$2e2bcd8739ae039(eventType) {
    if (eventType === void 0) eventType = $dd3060ab55d6e4ba$export$76a2e4c433c23bb9;
    const emit = (0, $lI55a.default)();
    const emitActiveSeriesKey = (0, $5uXOq.useCallback)((event, label)=>emit === null || emit === void 0 ? void 0 : emit(eventType, event, $dd3060ab55d6e4ba$export$8312cda563b4f1d7, label), [
        emit
    ]);
    return {
        emitActiveSeriesKey: emitActiveSeriesKey
    };
}

});
parcelRegister("lI55a", function(module, exports) {

$parcel$export(module.exports, "default", () => $fce1a64b58ee40be$export$2e2bcd8739ae039);
// eslint-disable-next-line no-restricted-syntax

var $eIrko = parcelRequire("eIrko");

var $5uXOq = parcelRequire("5uXOq");

var $fsVNF = parcelRequire("fsVNF");
function $fce1a64b58ee40be$export$2e2bcd8739ae039(/** Type of event to subscribe to. */ eventType, /** Handler invoked on emission of EventType event.  */ handler, /** Optional valid sources for EventType subscription. */ allowedSources) {
    const emitter = (0, $5uXOq.useContext)((0, $fsVNF.default));
    const allowedSourcesRef = (0, $5uXOq.useRef)();
    allowedSourcesRef.current = allowedSources; // use ref so allowedSources[] can change without creating new handlers
    // wrap emitter.emit so we can enforce stricter type signature
    const emit = (0, $5uXOq.useCallback)((type, event, source, datum)=>{
        if (emitter) emitter.emit(type, {
            event: event,
            svgPoint: (0, $eIrko.default)(event),
            source: source,
            datum: datum
        });
    }, [
        emitter
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (emitter && eventType && handler) {
            // register handler, with source filtering as needed
            const handlerWithSourceFilter = (params)=>{
                var _allowedSourcesRef$cu;
                if (!allowedSourcesRef.current || params !== null && params !== void 0 && params.source && (_allowedSourcesRef$cu = allowedSourcesRef.current) !== null && _allowedSourcesRef$cu !== void 0 && _allowedSourcesRef$cu.includes(params.source)) handler(params);
            };
            emitter.on(eventType, handlerWithSourceFilter);
            return ()=>emitter === null || emitter === void 0 ? void 0 : emitter.off(eventType, handlerWithSourceFilter);
        }
        return undefined;
    }, [
        emitter,
        eventType,
        handler
    ]);
    return emitter ? emit : null;
}

});
parcelRegister("eIrko", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab6a5f852b569ad0$export$2e2bcd8739ae039);

var $9hsAU = parcelRequire("9hsAU");

var $koq5f = parcelRequire("koq5f");
function $ab6a5f852b569ad0$export$2e2bcd8739ae039(nodeOrEvent, maybeEvent) {
    // localPoint(node, event)
    if ((0, $koq5f.isElement)(nodeOrEvent) && maybeEvent) return (0, $9hsAU.default)(nodeOrEvent, maybeEvent);
    // localPoint(event)
    if ((0, $koq5f.isEvent)(nodeOrEvent)) {
        var event = nodeOrEvent;
        var node = event.target;
        if (node) return (0, $9hsAU.default)(node, event);
    }
    return null;
}

});
parcelRegister("9hsAU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c1be1cd7b69982c$export$2e2bcd8739ae039);

var $9c8sC = parcelRequire("9c8sC");

var $koq5f = parcelRequire("koq5f");

var $g6Ir5 = parcelRequire("g6Ir5");
function $6c1be1cd7b69982c$export$2e2bcd8739ae039(node, event) {
    if (!node || !event) return null;
    var coords = (0, $g6Ir5.default)(event);
    // find top-most SVG
    var svg = (0, $koq5f.isSVGElement)(node) ? node.ownerSVGElement : node;
    var screenCTM = (0, $koq5f.isSVGGraphicsElement)(svg) ? svg.getScreenCTM() : null;
    if ((0, $koq5f.isSVGSVGElement)(svg) && screenCTM) {
        var point = svg.createSVGPoint();
        point.x = coords.x;
        point.y = coords.y;
        point = point.matrixTransform(screenCTM.inverse());
        return new (0, $9c8sC.default)({
            x: point.x,
            y: point.y
        });
    }
    // fall back to bounding box
    var rect = node.getBoundingClientRect();
    return new (0, $9c8sC.default)({
        x: coords.x - rect.left - node.clientLeft,
        y: coords.y - rect.top - node.clientTop
    });
}

});
parcelRegister("9c8sC", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b1bcc229a165e03$export$2e2bcd8739ae039);
var $6b1bcc229a165e03$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Point(_ref) {
        var _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y;
        this.x = 0;
        this.y = 0;
        this.x = x;
        this.y = y;
    }
    var _proto = Point.prototype;
    _proto.value = function value() {
        return {
            x: this.x,
            y: this.y
        };
    };
    _proto.toArray = function toArray() {
        return [
            this.x,
            this.y
        ];
    };
    return Point;
}();

});

parcelRegister("koq5f", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $ed8a4839102faef6$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isSVGElement", () => $ed8a4839102faef6$export$17eda790a720ec57);
$parcel$export(module.exports, "isSVGSVGElement", () => $ed8a4839102faef6$export$66957ea77182581d);
$parcel$export(module.exports, "isSVGGraphicsElement", () => $ed8a4839102faef6$export$d320b9df0ffd0744);
$parcel$export(module.exports, "isTouchEvent", () => $ed8a4839102faef6$export$c4dfce035d43d1e0);
$parcel$export(module.exports, "isMouseEvent", () => $ed8a4839102faef6$export$764db16956f554f8);
$parcel$export(module.exports, "isEvent", () => $ed8a4839102faef6$export$9671ea99bd126ace);
function $ed8a4839102faef6$export$45a5e7f76e0caa8d(elem) {
    return !!elem && elem instanceof Element;
}
function $ed8a4839102faef6$export$17eda790a720ec57(elem) {
    return !!elem && (elem instanceof SVGElement || 'ownerSVGElement' in elem);
}
function $ed8a4839102faef6$export$66957ea77182581d(elem) {
    return !!elem && 'createSVGPoint' in elem;
}
function $ed8a4839102faef6$export$d320b9df0ffd0744(elem) {
    return !!elem && 'getScreenCTM' in elem;
}
function $ed8a4839102faef6$export$c4dfce035d43d1e0(event) {
    return !!event && 'changedTouches' in event;
}
function $ed8a4839102faef6$export$764db16956f554f8(event) {
    return !!event && 'clientX' in event;
}
function $ed8a4839102faef6$export$9671ea99bd126ace(event) {
    return !!event && (event instanceof Event || 'nativeEvent' in event && event.nativeEvent instanceof Event);
}

});

parcelRegister("g6Ir5", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb9facec00996761$export$2e2bcd8739ae039);

var $koq5f = parcelRequire("koq5f");
function $bb9facec00996761$var$_extends() {
    $bb9facec00996761$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bb9facec00996761$var$_extends.apply(this, arguments);
}
var $bb9facec00996761$var$DEFAULT_POINT = {
    x: 0,
    y: 0
};
function $bb9facec00996761$export$2e2bcd8739ae039(event) {
    if (!event) return $bb9facec00996761$var$_extends({}, $bb9facec00996761$var$DEFAULT_POINT);
    if ((0, $koq5f.isTouchEvent)(event)) return event.changedTouches.length > 0 ? {
        x: event.changedTouches[0].clientX,
        y: event.changedTouches[0].clientY
    } : $bb9facec00996761$var$_extends({}, $bb9facec00996761$var$DEFAULT_POINT);
    if ((0, $koq5f.isMouseEvent)(event)) return {
        x: event.clientX,
        y: event.clientY
    };
    // for focus events try to extract the center position of the target element
    var target = event == null ? void 0 : event.target;
    var boundingClientRect = target && 'getBoundingClientRect' in target ? target.getBoundingClientRect() : null;
    if (!boundingClientRect) return $bb9facec00996761$var$_extends({}, $bb9facec00996761$var$DEFAULT_POINT);
    return {
        x: boundingClientRect.x + boundingClientRect.width / 2,
        y: boundingClientRect.y + boundingClientRect.height / 2
    };
}

});



parcelRegister("fsVNF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4264e6f736a6013$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $b4264e6f736a6013$var$EventEmitterContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
var $b4264e6f736a6013$export$2e2bcd8739ae039 = $b4264e6f736a6013$var$EventEmitterContext;

});



const $0bd291d77cbdd29d$export$e64d201155cc8fe2 = 160;
const $0bd291d77cbdd29d$export$bc48d9a7fd313bb2 = 32;
const $0bd291d77cbdd29d$export$fece36e05d7a6c7b = 8;
const $0bd291d77cbdd29d$export$57cb39d4eda3140a = 16;
const $0bd291d77cbdd29d$export$1949567a35c96224 = 12;
const $0bd291d77cbdd29d$export$3a3ed70a2e553a67 = 2;
const $0bd291d77cbdd29d$export$7bf402e928540137 = 10000;

parcelRegister("gEnb9", function(module, exports) {

$parcel$export(module.exports, "useTruncationIndexObserver", () => $c1f25c9c571436f1$export$ec599d67f76e7af7);
$parcel$export(module.exports, "useFlatData", () => $c1f25c9c571436f1$export$f27cffe517b2d3a3);

var $5uXOq = parcelRequire("5uXOq");
const $c1f25c9c571436f1$export$178827bcd84b6d71 = (data, labelAccessor)=>{
    return data.reduce((flat, d)=>{
        const label = labelAccessor(d);
        if (flat[label]) return flat;
        const newFlatData = {
            ...flat
        };
        newFlatData[label] = d;
        return newFlatData;
    }, {});
};
const $c1f25c9c571436f1$export$5303528d1070ff6f = (value)=>{
    if (value === 'normal') return 8;
    else return parseFloat(value);
};
function $c1f25c9c571436f1$export$ec599d67f76e7af7(_ref) {
    let { legendRefCurrent: legendRefCurrent, setTruncationIndex: setTruncationIndex } = _ref;
    (0, $5uXOq.useEffect)(()=>{
        const observer = new ResizeObserver((entries)=>{
            let fit = 0;
            const content = [
                ...entries[0].target.children
            ];
            content.forEach((d)=>{
                // Look into isVisible function
                if (!$c1f25c9c571436f1$export$660f61eb7bd5242a(entries[0].target, d)) fit += 1;
            });
            setTruncationIndex(fit);
        });
        if (legendRefCurrent) observer.observe(legendRefCurrent);
        return ()=>{
            if (legendRefCurrent) observer.unobserve(legendRefCurrent);
        };
    }, [
        legendRefCurrent,
        setTruncationIndex
    ]);
}
const $c1f25c9c571436f1$export$660f61eb7bd5242a = (parent, child)=>{
    const box1coords = parent.getBoundingClientRect();
    const box2coords = child.getBoundingClientRect();
    if (box2coords.top + 2 < box1coords.top || box2coords.right - 2 > box1coords.right || box2coords.bottom - 2 > box1coords.bottom || box2coords.left + 2 < box1coords.left) return true;
    return false;
};
function $c1f25c9c571436f1$export$f27cffe517b2d3a3(_ref2) {
    let { labelAccessor: labelAccessor, data: data } = _ref2;
    return (0, $5uXOq.useMemo)(()=>Object.values(data.reduce((flat, d)=>{
            const label = labelAccessor(d);
            if (flat[label]) return flat;
            const newFlatData = {
                ...flat
            };
            newFlatData[label] = {
                ...d
            };
            return newFlatData;
        }, {})), [
        labelAccessor,
        data
    ]);
}

});


parcelRegister("iTGbP", function(module, exports) {

$parcel$export(module.exports, "PrivateBar", () => $dc1e1713f476a0f6$export$79dfc6df660f8241);
$parcel$export(module.exports, "Bar", () => $dc1e1713f476a0f6$export$bbc6c6369b38e3d1);
/* Bar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $bT1Sw = parcelRequire("bT1Sw");

var $2OMIu = parcelRequire("2OMIu");
function $dc1e1713f476a0f6$var$createPathFromRoundedRect(x, y, width, height, radius) {
    if (radius === void 0) radius = {};
    const xEnd = x + width;
    const yEnd = y + height;
    const { topLeft: topLeft = 0, topRight: topRight = 0, bottomLeft: bottomLeft = 0, bottomRight: bottomRight = 0 } = radius;
    return `M${x + (topLeft !== null && topLeft !== void 0 ? topLeft : 0)} ${y}
    L${xEnd - (topRight !== null && topRight !== void 0 ? topRight : 0)} ${y}
    A${topRight !== null && topRight !== void 0 ? topRight : 0} ${topRight !== null && topRight !== void 0 ? topRight : 0} 0 0 1 ${xEnd} ${y + (topRight !== null && topRight !== void 0 ? topRight : 0)}
    L${xEnd} ${yEnd - (bottomRight !== null && bottomRight !== void 0 ? bottomRight : 0)}
    A${bottomRight !== null && bottomRight !== void 0 ? bottomRight : 0} ${bottomRight !== null && bottomRight !== void 0 ? bottomRight : 0} 0 0 1 ${xEnd - (bottomRight !== null && bottomRight !== void 0 ? bottomRight : 0)} ${yEnd}
    L${x + (bottomLeft !== null && bottomLeft !== void 0 ? bottomLeft : 0)} ${yEnd}
    A${bottomLeft !== null && bottomLeft !== void 0 ? bottomLeft : 0} ${bottomLeft !== null && bottomLeft !== void 0 ? bottomLeft : 0} 0 0 1 ${x} ${yEnd - (bottomLeft !== null && bottomLeft !== void 0 ? bottomLeft : 0)}
    L${x} ${y + (topLeft !== null && topLeft !== void 0 ? topLeft : 0)}
    A${topLeft !== null && topLeft !== void 0 ? topLeft : 0} ${topLeft !== null && topLeft !== void 0 ? topLeft : 0} 0 0 1 ${x + (topLeft !== null && topLeft !== void 0 ? topLeft : 0)} ${y}
    Z`;
}
const $dc1e1713f476a0f6$var$barStyles = null;
function $dc1e1713f476a0f6$export$79dfc6df660f8241(_ref) {
    let { datum: datum, innerRef: innerRef, ariaLabel: ariaLabel, x: x, y: y, width: width, height: height, cornerRadius: cornerRadius, fill: fill, opacity: opacity } = _ref;
    const d = $dc1e1713f476a0f6$var$createPathFromRoundedRect(x, y, width, height, cornerRadius);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
        fill: fill,
        opacity: opacity,
        role: "img",
        "aria-label": ariaLabel,
        ref: innerRef,
        d: d,
        className: (0, $bwpsq.default)([
            "_v564g17y"
        ])
    });
}
const $dc1e1713f476a0f6$export$bbc6c6369b38e3d1 = (0, $bT1Sw.element)($dc1e1713f476a0f6$export$79dfc6df660f8241);

});

parcelRegister("cgmj2", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ORDINAL_COLORS", () => $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb);
$parcel$export(module.exports, "DEFAULT_ORDINAL_PATTERNS_DEFS", () => $8ed8482abbab76e7$export$3b4caf16b18628d7);
$parcel$export(module.exports, "useThemeFillStyles", () => $8ed8482abbab76e7$export$c533e33795ec3ca2);
$parcel$export(module.exports, "Theme", () => $8ed8482abbab76e7$export$14faa19a0f3bbeb2);

var $bT1Sw = parcelRequire("bT1Sw");

var $d9B5x = parcelRequire("d9B5x");
var $dTtIr = parcelRequire("dTtIr");
var $7jqLY = parcelRequire("7jqLY");
var $9VXb2 = parcelRequire("9VXb2");
var $ekGvZ = parcelRequire("ekGvZ");
var $e1sbT = parcelRequire("e1sbT");

var $2OMIu = parcelRequire("2OMIu");
const $8ed8482abbab76e7$export$f32b764d072ed1b7 = [
    "var(--ds-chart-categorical-1, #2898BD)",
    "var(--ds-chart-categorical-2, #5E4DB2)",
    "var(--ds-chart-categorical-3, #E56910)",
    "var(--ds-chart-categorical-4, #943D73)",
    "var(--ds-chart-categorical-5, #09326C)",
    "var(--ds-chart-categorical-6, #8F7EE7)",
    "var(--ds-chart-categorical-7, #50253F)",
    "var(--ds-chart-categorical-8, #A54800)"
];
const $8ed8482abbab76e7$export$5d11cb9bccf8f5db = [
    {
        key: 'danger',
        value: "var(--ds-chart-danger, #F15B50)"
    },
    {
        key: 'warning',
        value: "var(--ds-chart-warning, #B38600)"
    },
    {
        key: 'success',
        value: "var(--ds-chart-success, #22A06B)"
    },
    {
        key: 'discovery',
        value: "var(--ds-chart-discovery, #8F7EE7)"
    },
    {
        key: 'information',
        value: "var(--ds-chart-information, #388BFF)"
    },
    {
        key: 'neutral',
        value: "var(--ds-chart-neutral, #8590A2)"
    }
];
const $8ed8482abbab76e7$export$f29a3c9071a2ca9 = [
    "var(--ds-chart-red-bold, #2898BD)",
    "var(--ds-chart-orange-bold, #943D73)",
    "var(--ds-chart-yellow-bold, #E56910)",
    "var(--ds-chart-lime-bold, #5E4DB2)",
    "var(--ds-chart-green-bold, #09326C)",
    "var(--ds-chart-teal-bold, #09326C)",
    "var(--ds-chart-blue-bold, #8F7EE7)",
    "var(--ds-chart-purple-bold, #50253F)",
    "var(--ds-chart-magenta-bold, #A54800)",
    "var(--ds-chart-gray-bold, #A54800)",
    "var(--ds-chart-red-boldest, #2898BD)",
    "var(--ds-chart-orange-boldest, #943D73)",
    "var(--ds-chart-yellow-boldest, #E56910)",
    "var(--ds-chart-lime-boldest, #5E4DB2)",
    "var(--ds-chart-green-boldest, #09326C)",
    "var(--ds-chart-teal-boldest, #09326C)",
    "var(--ds-chart-blue-boldest, #8F7EE7)",
    "var(--ds-chart-purple-boldest, #50253F)",
    "var(--ds-chart-magenta-boldest, #A54800)",
    "var(--ds-chart-gray-boldest, #A54800)"
];
const $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb = [
    "var(--ds-chart-brand, #2898BD)",
    "var(--ds-chart-orange-bold, #943D73)",
    "var(--ds-chart-magenta-bold, #E56910)",
    "var(--ds-chart-lime-bold, #5E4DB2)",
    "var(--ds-chart-purple-bold, #09326C)",
    "var(--ds-chart-teal-bold, #8F7EE7)",
    "var(--ds-chart-green-bold, #50253F)",
    "var(--ds-chart-blue-boldest, #A54800)"
];
const $8ed8482abbab76e7$export$3b4caf16b18628d7 = [
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ekGvZ.default), {
        id: 'lines1',
        height: 5,
        width: 5,
        stroke: '#000000',
        background: $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb[0],
        strokeWidth: 1,
        orientation: [
            'diagonal'
        ]
    }),
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7jqLY.default), {
        id: 'crosshair1',
        width: 5,
        height: 5,
        stroke: '#000000',
        background: $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb[1],
        strokeWidth: 0.7,
        rotation: 45,
        gap: 7
    }),
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ekGvZ.default), {
        id: 'lines2',
        height: 5,
        width: 5,
        stroke: '#000000',
        background: $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb[2],
        strokeWidth: 1,
        orientation: [
            'diagonalRightToLeft'
        ]
    }),
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7jqLY.default), {
        id: 'crosshair2',
        width: 10,
        height: 10,
        stroke: '#000000',
        background: $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb[3],
        strokeWidth: 0.5,
        rotation: 45,
        gap: 7
    }),
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dTtIr.default), {
        id: "circles1",
        height: 8,
        width: 8,
        radius: 1,
        background: $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb[4],
        stroke: '#000000',
        strokeWidth: 0.4,
        complement: true,
        fill: 'none'
    }),
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e1sbT.default), {
        id: "waves1",
        height: 6,
        width: 6,
        stroke: '#000000',
        background: $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb[5],
        strokeWidth: 0.5
    }),
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9VXb2.default), {
        id: "hexagons1",
        height: 3,
        background: $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb[6],
        size: 3,
        gap: 2,
        strokeWidth: 0.5,
        stroke: "#000000"
    }),
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ekGvZ.default), {
        id: "lines3",
        height: 6,
        width: 5,
        stroke: '#000000',
        strokeDasharray: 3,
        background: $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb[7],
        orientation: [
            'horizontal'
        ]
    })
];
const $8ed8482abbab76e7$export$7b0a836186aa9014 = (0, $d9B5x.getPatternUrls)($8ed8482abbab76e7$export$3b4caf16b18628d7);
const $8ed8482abbab76e7$export$c533e33795ec3ca2 = (_ref)=>{
    let { fillStyles: customFillStyles, enableDefaultPatterns: enableDefaultPatterns } = _ref;
    const fillStyles = enableDefaultPatterns ? $8ed8482abbab76e7$export$7b0a836186aa9014 : customFillStyles;
    if (!fillStyles) return {
        range: [],
        domain: []
    };
    if (fillStyles.filter((d)=>typeof d !== 'string').length > 0) return {
        domain: fillStyles.map((d)=>typeof d === 'string' ? d : d.key),
        range: fillStyles.map((d)=>typeof d === 'string' ? d : d.value)
    };
    else return {
        range: fillStyles === null || fillStyles === void 0 ? void 0 : fillStyles.map((d)=>typeof d === 'string' ? d : d.value)
    };
};
const $8ed8482abbab76e7$export$14faa19a0f3bbeb2 = (0, $bT1Sw.element)((_ref2)=>{
    let { children: children } = _ref2;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
});
const $8ed8482abbab76e7$export$569885e57444f84a = {
    accessibleCategorical: $8ed8482abbab76e7$export$f32b764d072ed1b7,
    categorical: $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb,
    status: $8ed8482abbab76e7$export$5d11cb9bccf8f5db,
    categorical20: $8ed8482abbab76e7$export$f29a3c9071a2ca9,
    accessiblePatternDefs: $8ed8482abbab76e7$export$3b4caf16b18628d7
};

});
parcelRegister("d9B5x", function(module, exports) {

$parcel$export(module.exports, "getPatternUrls", () => $9938e29a28d7097f$export$c66920886885446e);
const $9938e29a28d7097f$export$c66920886885446e = (patterns)=>{
    if (!patterns) return [];
    return patterns.map((pattern)=>`url(#${pattern.props.id})`);
};

});

parcelRegister("dTtIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1d77660c0b91a6c$export$2e2bcd8739ae039);
// import cx from 'classnames';

var $12tJU = parcelRequire("12tJU");

var $2OMIu = parcelRequire("2OMIu");
function $a1d77660c0b91a6c$export$2e2bcd8739ae039(_ref) {
    var _corners;
    let { id: id, width: width, height: height, radius: radius = 2, fill: fill, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, background: background, complement: complement = false, className: className } = _ref;
    let corners;
    if (complement) corners = [
        [
            0,
            0
        ],
        [
            0,
            height
        ],
        [
            width,
            0
        ],
        [
            width,
            height
        ]
    ];
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $12tJU.default), {
        id: id,
        width: width,
        height: height,
        children: [
            !!background && /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: width,
                height: height,
                fill: background
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                // className={cx('visx-pattern-circle', className)}
                cx: width / 2,
                cy: height / 2,
                r: radius,
                fill: fill,
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeDasharray: strokeDasharray
            }),
            (_corners = corners) === null || _corners === void 0 ? void 0 : _corners.map((_ref2)=>{
                let [cornerX, cornerY] = _ref2;
                return /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                    // className={cx('visx-pattern-circle visx-pattern-circle-complement', className)}
                    cx: cornerX,
                    cy: cornerY,
                    r: radius,
                    fill: fill,
                    stroke: stroke,
                    strokeWidth: strokeWidth,
                    strokeDasharray: strokeDasharray
                }, `${id}-complement-${cornerX}-${cornerY}`);
            })
        ]
    });
}

});
parcelRegister("12tJU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c1d0bfb9e2e6ff6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
function $0c1d0bfb9e2e6ff6$export$2e2bcd8739ae039(_ref) {
    let { id: id, width: width, height: height, children: children } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("pattern", {
            id: id,
            width: width,
            height: height,
            patternUnits: "userSpaceOnUse",
            children: children
        })
    });
}

});


parcelRegister("7jqLY", function(module, exports) {

$parcel$export(module.exports, "default", () => $552f134aa047ca1f$export$2e2bcd8739ae039);

var $12tJU = parcelRequire("12tJU");

var $2OMIu = parcelRequire("2OMIu");
function $552f134aa047ca1f$export$2e2bcd8739ae039(_ref) {
    let { id: id, width: width, height: height, stroke: stroke = 'black', strokeWidth: strokeWidth = 1, strokeDasharray: strokeDasharray, background: background, className: className, rotation: rotation = 0, gap: gap = 10 } = _ref;
    const halfGap = gap / 2;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $12tJU.default), {
        id: id,
        width: gap,
        height: gap,
        children: [
            !!background && /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: gap,
                height: gap,
                fill: background
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                transform: `rotate(${rotation}, ${gap / 2}, ${gap / 2})`,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("line", {
                        // Horizontal line
                        x1: halfGap - width / 2,
                        y1: halfGap,
                        x2: halfGap + width / 2,
                        y2: halfGap,
                        stroke: stroke,
                        strokeWidth: strokeWidth,
                        strokeDasharray: strokeDasharray
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("line", {
                        // Vertical line
                        x1: halfGap,
                        y1: halfGap - height / 2,
                        x2: halfGap,
                        y2: halfGap + height / 2,
                        stroke: stroke,
                        strokeWidth: strokeWidth,
                        strokeDasharray: strokeDasharray
                    })
                ]
            })
        ]
    });
}

});

parcelRegister("9VXb2", function(module, exports) {

$parcel$export(module.exports, "default", () => $73b7573cb69bdfa6$export$2e2bcd8739ae039);

var $j92zy = parcelRequire("j92zy");

var $2OMIu = parcelRequire("2OMIu");
function $73b7573cb69bdfa6$export$2e2bcd8739ae039(_ref) {
    let { id: id, height: height, fill: fill, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, shapeRendering: shapeRendering, background: background, className: className, size: size = 3, gap: gap = 0 } = _ref;
    const hexWidth = size * Math.sqrt(3) + gap;
    const hexHeight = size * 2 + gap;
    const path = `
        M ${size * Math.sqrt(3) / 2 + gap / 2},${gap / 2}
        L ${size * Math.sqrt(3) + gap / 2},${size / 2 + gap / 2}
        L ${size * Math.sqrt(3) + gap / 2},${size * 1.5 + gap / 2}
        L ${size * Math.sqrt(3) / 2 + gap / 2},${size * 2 + gap / 2}
        L ${gap / 2},${size * 1.5 + gap / 2}
        L ${gap / 2},${size / 2 + gap / 2}
        Z
    `;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j92zy.default), {
        path: path,
        id: id,
        width: hexWidth,
        height: hexHeight,
        fill: fill,
        stroke: stroke,
        strokeWidth: strokeWidth,
        strokeDasharray: strokeDasharray,
        shapeRendering: shapeRendering,
        background: background
    });
}

});
parcelRegister("j92zy", function(module, exports) {

$parcel$export(module.exports, "default", () => $df00da6821c1721f$export$2e2bcd8739ae039);
// import cx from 'classnames';

var $12tJU = parcelRequire("12tJU");

var $2OMIu = parcelRequire("2OMIu");
function $df00da6821c1721f$export$2e2bcd8739ae039(_ref) {
    let { id: id, width: width, height: height, path: path, fill: fill = 'transparent', stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, strokeLinecap: strokeLinecap = 'square', shapeRendering: shapeRendering = 'auto', background: background, className: className } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $12tJU.default), {
        id: id,
        width: width,
        height: height,
        children: [
            !!background && /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: width,
                height: height,
                fill: background
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                // className={cx('visx-pattern-path', className)}
                d: path,
                fill: fill,
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeDasharray: strokeDasharray,
                strokeLinecap: strokeLinecap,
                shapeRendering: shapeRendering
            })
        ]
    });
}

});


parcelRegister("ekGvZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6f3e98601748030$export$2e2bcd8739ae039);
// import cx from 'classnames';

var $1GwA3 = parcelRequire("1GwA3");

var $12tJU = parcelRequire("12tJU");

var $2OMIu = parcelRequire("2OMIu");
function $a6f3e98601748030$export$777054cdc3eb6ab2(_ref) {
    let { height: height, orientation: orientation } = _ref;
    switch(orientation){
        case (0, $1GwA3.PatternOrientation).horizontal:
            return `M 0,${height / 2} l ${height},0`;
        case (0, $1GwA3.PatternOrientation).diagonal:
            return `M 0,${height} l ${height},${-height} M ${-height / 4},${height / 4} l ${height / 2},${-height / 2}
             M ${3 / 4 * height},${5 / 4 * height} l ${height / 2},${-height / 2}`;
        case (0, $1GwA3.PatternOrientation).diagonalRightToLeft:
            return `M 0,0 l ${height},${height}
        M ${-height / 4},${3 / 4 * height} l ${height / 2},${height / 2}
        M ${3 / 4 * height},${-height / 4} l ${height / 2},${height / 2}`;
        case (0, $1GwA3.PatternOrientation).vertical:
        default:
            return `M ${height / 2}, 0 l 0, ${height}`;
    }
}
function $a6f3e98601748030$export$2e2bcd8739ae039(_ref2) {
    let { id: id, width: width, height: height, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, strokeLinecap: strokeLinecap = 'square', shapeRendering: shapeRendering = 'auto', orientation: orientation = [
        'vertical'
    ], background: background, className: className } = _ref2;
    const orientations = Array.isArray(orientation) ? orientation : [
        orientation
    ];
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $12tJU.default), {
        id: id,
        width: width,
        height: height,
        children: [
            !!background && /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                // className={cx('visx-pattern-line-background')}
                width: width,
                height: height,
                fill: background
            }),
            orientations.map((o, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    // className={cx('visx-pattern-line', className)}
                    d: $a6f3e98601748030$export$777054cdc3eb6ab2({
                        orientation: o,
                        height: height
                    }),
                    stroke: stroke,
                    strokeWidth: strokeWidth,
                    strokeDasharray: strokeDasharray,
                    strokeLinecap: strokeLinecap,
                    shapeRendering: shapeRendering
                }, `visx-${id}-line-${o}-${i}`))
        ]
    });
}

});
parcelRegister("1GwA3", function(module, exports) {

$parcel$export(module.exports, "PatternOrientation", () => $13a2fc7b62d049a2$export$c37d4d4692ef0c91);
const $13a2fc7b62d049a2$export$c37d4d4692ef0c91 = {
    horizontal: 'horizontal',
    vertical: 'vertical',
    diagonal: 'diagonal',
    diagonalRightToLeft: 'diagonalRightToLeft'
};

});


parcelRegister("e1sbT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a35706caca164049$export$2e2bcd8739ae039);
// import cx from 'classnames';

var $j92zy = parcelRequire("j92zy");

var $2OMIu = parcelRequire("2OMIu");
function $a35706caca164049$export$2e2bcd8739ae039(_ref) {
    let { id: id, width: width, height: height, fill: fill, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, strokeLinecap: strokeLinecap, shapeRendering: shapeRendering, background: background, className: className } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j92zy.default), {
        path: `M 0 ${height / 2} c ${height / 8} ${-height / 4} , ${height * 3 / 8} ${-height / 4} , ${height / 2} 0
             c ${height / 8} ${height / 4} , ${height * 3 / 8} ${height / 4} , ${height / 2} 0 M ${-height / 2} ${height / 2}
             c ${height / 8} ${height / 4} , ${height * 3 / 8} ${height / 4} , ${height / 2} 0 M ${height} ${height / 2}
             c ${height / 8} ${-height / 4} , ${height * 3 / 8} ${-height / 4} , ${height / 2} 0`,
        id: id,
        width: width,
        height: height,
        fill: fill,
        stroke: stroke,
        strokeWidth: strokeWidth,
        strokeDasharray: strokeDasharray,
        strokeLinecap: strokeLinecap,
        shapeRendering: shapeRendering,
        background: background
    });
}

});


parcelRegister("1Tf3y", function(module, exports) {

$parcel$export(module.exports, "TooltipHeader", () => $16069b6018acac22$export$fd7ac08b5fcaeea);
/* TooltipHeader.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $bT1Sw = parcelRequire("bT1Sw");

var $2OMIu = parcelRequire("2OMIu");
const $16069b6018acac22$var$headerCss = null;
function $16069b6018acac22$var$TooltipHeader(_ref) {
    let { children: children, hide: hide, datum: datum } = _ref;
    if (hide) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1wpz1fhb _syaz1glm _1wyb1skh _ect41wi2 _k48p1nn1 _slp31hna"
        ]),
        children: children
    });
}
const $16069b6018acac22$export$fd7ac08b5fcaeea = (0, $bT1Sw.element)($16069b6018acac22$var$TooltipHeader);

});

parcelRegister("lA40p", function(module, exports) {

$parcel$export(module.exports, "TooltipRow", () => $fb601131272529e7$export$4cf463b4a9fc631a);
/* TooltipRow.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $bT1Sw = parcelRequire("bT1Sw");

var $2OMIu = parcelRequire("2OMIu");
const $fb601131272529e7$var$outerDivCss = null;
const $fb601131272529e7$var$innerDivCss = null;
const $fb601131272529e7$var$colorItemCss = null;
const $fb601131272529e7$var$labelItemCss = null;
const $fb601131272529e7$var$valueItemCss = null;
function $fb601131272529e7$var$TooltipRow(_ref) {
    let { color: color, label: label, value: value, datum: datum } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1wpz1fhb _1bah1yb4 _4cvr1h6o _1e0c116y"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            className: (0, $bwpsq.default)([
                "_u5f3ftgi _1bah1y6m _4cvr1h6o _zulpftgi _1e0c1txw"
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        "_1bah1y6m _4cvr1h6o _zulpftgi _1e0c1txw"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
                        style: {
                            width: 12,
                            height: 12,
                            borderRadius: 2
                        },
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "100%",
                            height: "100%",
                            fill: color
                        })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        "_ect41wi2 _syaz13nv _1wybdlk8 _k48p1nn1 _slp31hna"
                    ]),
                    children: label
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        "_ect41wi2 _syaz13nv _1wybdlk8 _k48p1nn1 _vwz41q5e _slp31hna"
                    ]),
                    children: value
                })
            ]
        })
    });
}
const $fb601131272529e7$export$4cf463b4a9fc631a = (0, $bT1Sw.element)($fb601131272529e7$var$TooltipRow);

});

parcelRegister("02ifK", function(module, exports) {

$parcel$export(module.exports, "default", () => $006e58b2f5bf66cd$export$2e2bcd8739ae039);

var $gu0md = parcelRequire("gu0md");

var $5uXOq = parcelRequire("5uXOq");

var $fsVNF = parcelRequire("fsVNF");

var $2OMIu = parcelRequire("2OMIu");
function $006e58b2f5bf66cd$export$2e2bcd8739ae039(_ref) {
    let { children: children } = _ref;
    const emitter = (0, $5uXOq.useMemo)(()=>(0, $gu0md.default)(), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fsVNF.default).Provider, {
        value: emitter,
        children: children
    });
}

});
parcelRegister("gu0md", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfffb9a55931417f$export$2e2bcd8739ae039);
function $bfffb9a55931417f$export$2e2bcd8739ae039(n) {
    return {
        all: n = n || new Map,
        on: function(t, e) {
            var i = n.get(t);
            i ? i.push(e) : n.set(t, [
                e
            ]);
        },
        off: function(t, e) {
            var i = n.get(t);
            i && (e ? i.splice(i.indexOf(e) >>> 0, 1) : n.set(t, []));
        },
        emit: function(t, e) {
            var i = n.get(t);
            i && i.slice().map(function(n) {
                n(e);
            }), (i = n.get("*")) && i.slice().map(function(n) {
                n(t, e);
            });
        }
    };
}

});


parcelRegister("e0UVN", function(module, exports) {

$parcel$export(module.exports, "default", () => $a33d3a1e9d33e815$export$2e2bcd8739ae039);

var $2qM0c = parcelRequire("2qM0c");

var $5uXOq = parcelRequire("5uXOq");

var $f76Li = parcelRequire("f76Li");

var $lrseF = parcelRequire("lrseF");

var $2OMIu = parcelRequire("2OMIu");
function $a33d3a1e9d33e815$var$isValidNumber(_) {
    return _ != null && typeof _ === 'number' && !Number.isNaN(_) && Number.isFinite(_);
}
function $a33d3a1e9d33e815$export$2e2bcd8739ae039(_ref) {
    let { hideTooltipDebounceMs: hideTooltipDebounceMs = 200, children: children } = _ref;
    const { tooltipOpen: tooltipOpen, tooltipLeft: tooltipLeft, tooltipTop: tooltipTop, tooltipData: tooltipData, updateTooltip: updateTooltip, hideTooltip: privateHideTooltip } = (0, $f76Li.default)(undefined);
    const debouncedHideTooltip = (0, $5uXOq.useRef)(null);
    function cancelDeboundedHideTooltip() {
        if (debouncedHideTooltip.current) {
            debouncedHideTooltip.current.cancel();
            debouncedHideTooltip.current = null;
        }
    }
    (0, $5uXOq.useEffect)(()=>cancelDeboundedHideTooltip, []);
    const showTooltip = (0, $5uXOq.useRef)((_ref2)=>{
        let { svgPoint: svgPoint, index: index, datum: datum, distanceX: distanceX, distanceY: distanceY, nearestSeriesData: nearestSeriesData, event: event } = _ref2;
        // cancel any hideTooltip calls so it won't hide after invoking the logic below
        cancelDeboundedHideTooltip();
        const cleanDistanceX = $a33d3a1e9d33e815$var$isValidNumber(distanceX) ? distanceX : Infinity;
        const cleanDistanceY = $a33d3a1e9d33e815$var$isValidNumber(distanceY) ? distanceY : Infinity;
        const distance = Math.sqrt(cleanDistanceX ** 2 + cleanDistanceY ** 2);
        // Event is valid up here. Hasn't been nullified yet.
        // We can call event.persist() but storing in a variable seems more elegant.
        const tooltipLeft = event && 'clientX' in event ? event === null || event === void 0 ? void 0 : event.clientX : svgPoint === null || svgPoint === void 0 ? void 0 : svgPoint.x;
        const tooltipTop = event && 'clientY' in event ? event === null || event === void 0 ? void 0 : event.clientY : svgPoint === null || svgPoint === void 0 ? void 0 : svgPoint.y;
        updateTooltip((_ref3)=>{
            let { tooltipData: tooltipData } = _ref3;
            // const currNearestDatumDistance =
            //     currData?.nearestDatum && isValidNumber(currData.nearestDatum.distance)
            //         ? currData.nearestDatum.distance
            //         : Infinity;
            return {
                tooltipOpen: true,
                tooltipLeft: tooltipLeft,
                tooltipTop: tooltipTop,
                tooltipData: {
                    // nearestDatum:
                    //     (currData?.nearestDatum?.key ?? '') !== key &&
                    //     currNearestDatumDistance < distance
                    //         ? currData?.nearestDatum
                    //         : {key, index, datum, distance},
                    nearestDatum: {
                        index: index,
                        datum: datum,
                        distance: distance
                    },
                    nearestSeriesData: nearestSeriesData
                }
            };
        });
    });
    const hideTooltip = (0, $5uXOq.useCallback)(()=>{
        debouncedHideTooltip.current = (0, (/*@__PURE__*/$parcel$interopDefault($2qM0c)))(privateHideTooltip, hideTooltipDebounceMs);
        debouncedHideTooltip.current();
    }, [
        privateHideTooltip,
        hideTooltipDebounceMs
    ]);
    const value = (0, $5uXOq.useMemo)(()=>({
            tooltipOpen: tooltipOpen,
            tooltipLeft: tooltipLeft,
            tooltipTop: tooltipTop,
            tooltipData: tooltipData,
            updateTooltip: updateTooltip,
            showTooltip: showTooltip.current,
            hideTooltip: hideTooltip
        }), [
        hideTooltip,
        tooltipData,
        tooltipLeft,
        tooltipOpen,
        tooltipTop,
        updateTooltip
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lrseF.default).Provider, {
        value: value,
        children: children
    });
}

});
parcelRegister("2qM0c", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $1c533eb56f421364$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $1c533eb56f421364$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $1c533eb56f421364$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $1c533eb56f421364$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $1c533eb56f421364$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $1c533eb56f421364$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $1c533eb56f421364$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $1c533eb56f421364$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $1c533eb56f421364$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $1c533eb56f421364$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1c533eb56f421364$var$root = $1c533eb56f421364$var$freeGlobal || $1c533eb56f421364$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $1c533eb56f421364$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1c533eb56f421364$var$objectToString = $1c533eb56f421364$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $1c533eb56f421364$var$nativeMax = Math.max, $1c533eb56f421364$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $1c533eb56f421364$var$now = function() {
    return $1c533eb56f421364$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $1c533eb56f421364$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($1c533eb56f421364$var$FUNC_ERROR_TEXT);
    wait = $1c533eb56f421364$var$toNumber(wait) || 0;
    if ($1c533eb56f421364$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $1c533eb56f421364$var$nativeMax($1c533eb56f421364$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $1c533eb56f421364$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $1c533eb56f421364$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($1c533eb56f421364$var$now());
    }
    function debounced() {
        var time = $1c533eb56f421364$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $1c533eb56f421364$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $1c533eb56f421364$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $1c533eb56f421364$var$isSymbol(value) {
    return typeof value == 'symbol' || $1c533eb56f421364$var$isObjectLike(value) && $1c533eb56f421364$var$objectToString.call(value) == $1c533eb56f421364$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $1c533eb56f421364$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($1c533eb56f421364$var$isSymbol(value)) return $1c533eb56f421364$var$NAN;
    if ($1c533eb56f421364$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $1c533eb56f421364$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($1c533eb56f421364$var$reTrim, '');
    var isBinary = $1c533eb56f421364$var$reIsBinary.test(value);
    return isBinary || $1c533eb56f421364$var$reIsOctal.test(value) ? $1c533eb56f421364$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $1c533eb56f421364$var$reIsBadHex.test(value) ? $1c533eb56f421364$var$NAN : +value;
}
module.exports = $1c533eb56f421364$var$debounce;

});

parcelRegister("f76Li", function(module, exports) {

$parcel$export(module.exports, "default", () => $b00cc13b202009ca$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $b00cc13b202009ca$export$2e2bcd8739ae039(/** Optional initial TooltipState. */ initialTooltipState) {
    const [tooltipState, setTooltipState] = (0, $5uXOq.useState)({
        tooltipOpen: false,
        ...initialTooltipState
    });
    const showTooltip = (0, $5uXOq.useCallback)((showArgs)=>setTooltipState(typeof showArgs === 'function' ? (_ref)=>{
            let { tooltipOpen: tooltipOpen, ...show } = _ref;
            return {
                ...showArgs(show),
                tooltipOpen: true
            };
        } : {
            tooltipOpen: true,
            tooltipLeft: showArgs.tooltipLeft,
            tooltipTop: showArgs.tooltipTop,
            tooltipData: showArgs.tooltipData
        }), [
        setTooltipState
    ]);
    const hideTooltip = (0, $5uXOq.useCallback)(()=>setTooltipState({
            tooltipOpen: false,
            tooltipLeft: undefined,
            tooltipTop: undefined,
            tooltipData: undefined
        }), [
        setTooltipState
    ]);
    return {
        tooltipOpen: tooltipState.tooltipOpen,
        tooltipLeft: tooltipState.tooltipLeft,
        tooltipTop: tooltipState.tooltipTop,
        tooltipData: tooltipState.tooltipData,
        updateTooltip: setTooltipState,
        showTooltip: showTooltip,
        hideTooltip: hideTooltip
    };
}

});

parcelRegister("lrseF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9c205926e36fc90$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $5uXOq = parcelRequire("5uXOq");
const $f9c205926e36fc90$var$TooltipContext = /*#__PURE__*/ (0, $5uXOq.createContext)({});
var $f9c205926e36fc90$export$2e2bcd8739ae039 = $f9c205926e36fc90$var$TooltipContext;

});


parcelRegister("2pOyr", function(module, exports) {

$parcel$export(module.exports, "MultiSeriesTooltip", () => $1c2521aa24f64dee$export$a2bd9600d7197e69);

var $bT1Sw = parcelRequire("bT1Sw");

var $1Tf3y = parcelRequire("1Tf3y");

var $lA40p = parcelRequire("lA40p");

var $5RaE1 = parcelRequire("5RaE1");

var $ltC0t = parcelRequire("ltC0t");

var $2OMIu = parcelRequire("2OMIu");
function $1c2521aa24f64dee$var$MultiSeriesTooltip(_ref) {
    var _tooltipData$nearestD, _window, _window2, _tooltipData$nearestS;
    let { tooltipData: tooltipData, tooltipLeft: tooltipLeft, tooltipTop: tooltipTop, xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, colorScale: colorScale, valueFormatter: valueFormatter = (0, $ltC0t.default).formatNumberAbbreviated } = _ref;
    const datum = tooltipData === null || tooltipData === void 0 ? void 0 : (_tooltipData$nearestD = tooltipData.nearestDatum) === null || _tooltipData$nearestD === void 0 ? void 0 : _tooltipData$nearestD.datum;
    // TODO: SSR check
    const scrollX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
    const scrollY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
    const portalLeft = (tooltipLeft || 0) + scrollX;
    const portalTop = (tooltipTop || 0) + scrollY;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: datum && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5RaE1.default), {
            left: portalLeft,
            top: portalTop,
            tooltipPortalElement: document.body,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Tf3y.TooltipHeader), {
                    datum: datum,
                    children: xAccessor(datum) instanceof Date ? (0, $ltC0t.default).multiTimeFormat(xAccessor(datum)) : String(xAccessor(datum))
                }),
                tooltipData === null || tooltipData === void 0 ? void 0 : (_tooltipData$nearestS = tooltipData.nearestSeriesData) === null || _tooltipData$nearestS === void 0 ? void 0 : _tooltipData$nearestS.map((d, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $lA40p.TooltipRow), {
                        datum: d,
                        color: colorScale(colorAccessor(d)),
                        label: colorAccessor(d),
                        value: String(valueFormatter(yAccessor(d)))
                    }, String(xAccessor(d)) + i))
            ]
        })
    });
}
const $1c2521aa24f64dee$export$a2bd9600d7197e69 = (0, $bT1Sw.element)($1c2521aa24f64dee$var$MultiSeriesTooltip);

});
parcelRegister("5RaE1", function(module, exports) {

$parcel$export(module.exports, "default", () => $443a28c41fa47583$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $clgDn = parcelRequire("clgDn");

var $2OMIu = parcelRequire("2OMIu");
const $443a28c41fa47583$var$DEFAULT_TRANSLATE = 'translate(0%, -100%)';
function $443a28c41fa47583$var$TooltipWithBounds(_ref) {
    let { children: children, left: initialLeft = 0, offsetLeft: offsetLeft = 2, offsetTop: offsetTop = -2, style: style = (0, $clgDn.defaultStyles), top: initialTop = 0, unstyled: unstyled = false, ...otherProps } = _ref;
    const elementRef = (0, $5uXOq.useRef)(null);
    const [transformStyle, setTransformStyle] = (0, $5uXOq.useState)($443a28c41fa47583$var$DEFAULT_TRANSLATE);
    (0, $5uXOq.useEffect)(()=>{
        var _elementRef$current;
        const rect = (_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.getBoundingClientRect();
        if (rect) {
            const outOfViewTop = Math.min(0, initialTop - rect.height);
            const outOfViewRight = Math.max(0, initialLeft + rect.width - window.innerWidth);
            const translateX = outOfViewRight > 0 ? -rect.width : 0;
            const translateY = outOfViewTop < 0 ? 0 : -rect.height;
            setTransformStyle(`translate(${translateX}px, ${translateY}px )`);
        }
    }, [
        initialTop,
        initialLeft,
        elementRef
    ]); // Dependency on adjusted state
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clgDn.default), {
        ref: elementRef,
        style: {
            top: initialTop + offsetTop,
            left: initialLeft + offsetLeft,
            transform: transformStyle,
            transition: 'transform 0.3s',
            ...!unstyled && style
        },
        ...otherProps,
        children: children
    });
}
var $443a28c41fa47583$export$2e2bcd8739ae039 = $443a28c41fa47583$var$TooltipWithBounds;

});
parcelRegister("clgDn", function(module, exports) {

$parcel$export(module.exports, "defaultStyles", () => $8fc459612f6eae76$export$214b055320e0bf32);
$parcel$export(module.exports, "default", () => $8fc459612f6eae76$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $2OMIu = parcelRequire("2OMIu");
const $8fc459612f6eae76$export$214b055320e0bf32 = {
    position: 'absolute',
    backgroundColor: "var(--ds-surface-overlay, white)",
    padding: '.3rem .5rem',
    borderRadius: '3px',
    fontSize: '14px',
    boxShadow: `0px 8px 12px ${"var(--ds-shadow-overflow-perimeter, grey)"}`,
    lineHeight: '1em',
    pointerEvents: 'none',
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 12,
    paddingBottom: 12,
    overflow: 'hidden',
    border: `1px ${"var(--ds-border, grey)"} solid`,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: 4,
    zIndex: 999,
    display: 'flex'
};
const $8fc459612f6eae76$var$Tooltip = /*#__PURE__*/ (0, $5uXOq.forwardRef)((_ref, ref)=>{
    let { className: className, top: top, left: left, tooltipPortalElement: tooltipPortalElement, offsetLeft: offsetLeft = 0, offsetTop: offsetTop = 0, style: style = $8fc459612f6eae76$export$214b055320e0bf32, children: children, unstyled: unstyled = false, applyPositionStyle: applyPositionStyle = false } = _ref;
    const elem = /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        className: className,
        style: {
            top: top == null || offsetTop == null ? top : top + offsetTop,
            left: left == null || offsetLeft == null ? left : left + offsetLeft,
            ...applyPositionStyle && {
                position: 'absolute'
            },
            ...!unstyled && style
        },
        children: children
    });
    // Render via portal
    if (tooltipPortalElement) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $7nsd3.createPortal)(elem, tooltipPortalElement)
    });
    return elem;
});
$8fc459612f6eae76$var$Tooltip.displayName = 'Tooltip';
var $8fc459612f6eae76$export$2e2bcd8739ae039 = $8fc459612f6eae76$var$Tooltip;

});



parcelRegister("arL7j", function(module, exports) {

$parcel$export(module.exports, "BarGroupMarkLabels", () => $79b0f96bd5a8555c$export$d00262aaa41e206c);

var $bT1Sw = parcelRequire("bT1Sw");

var $8WT90 = parcelRequire("8WT90");

var $dnJJh = parcelRequire("dnJJh");

var $2OMIu = parcelRequire("2OMIu");
const $79b0f96bd5a8555c$export$d00262aaa41e206c = (0, $bT1Sw.element)(function BarGroupMarkLabels(_ref) {
    let { barGroups: barGroups, hide: hide } = _ref;
    if (hide) return null;
    return barGroups.map((barGroup)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dnJJh.default), {
            left: barGroup.x0,
            children: barGroup.bars.map((bar)=>{
                if (!bar.width || !bar.height) return null;
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8WT90.ValueLabel), {
                        x: bar.x + bar.width / 2,
                        y: bar.y + bar.height / 2,
                        color: bar.color,
                        children: bar.yValue.toString()
                    }, `bar-stack-label-${barGroup.index}-${bar.index}`)
                });
            })
        }, `bar-group-labels-${barGroup.index}-${barGroup.x0}`));
});

});
parcelRegister("8WT90", function(module, exports) {

$parcel$export(module.exports, "ValueLabel", () => $683e8406f9035644$export$d0e17caf98739ceb);
/* label.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $bT1Sw = parcelRequire("bT1Sw");

var $cwHYm = parcelRequire("cwHYm");

var $ltC0t = parcelRequire("ltC0t");

var $jQ5Qu = parcelRequire("jQ5Qu");

var $2OMIu = parcelRequire("2OMIu");
const $683e8406f9035644$var$labelTextStyles = null;
function $683e8406f9035644$var$ValueLabel(_ref) {
    let { x: x, y: y, color: color, formatter: formatter = (0, $ltC0t.default).formatNumberAbbreviated, children: children } = _ref;
    if (!children) return null;
    if (typeof children === 'number' || typeof children === 'string') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwHYm.default), {
        x: x,
        y: y,
        style: {
            fill: (0, $jQ5Qu.getMaxContrast)(color)
        },
        verticalAnchor: "middle",
        alignmentBaseline: "central",
        className: (0, $bwpsq.default)([
            "_1fjgnkob _ect41wi2 _1wyb1crf"
        ]),
        children: formatter(children)
    });
    return children;
}
const $683e8406f9035644$export$d0e17caf98739ceb = (0, $bT1Sw.element)($683e8406f9035644$var$ValueLabel);

});
parcelRegister("cwHYm", function(module, exports) {

$parcel$export(module.exports, "default", () => $91ea953eed024a92$export$2e2bcd8739ae039);

var $3bDjY = parcelRequire("3bDjY");

var $ikfTR = parcelRequire("ikfTR");

var $2OMIu = parcelRequire("2OMIu");
const $91ea953eed024a92$var$SVG_STYLE = {
    overflow: 'visible'
};
function $91ea953eed024a92$export$2e2bcd8739ae039(props) {
    const { dx: dx = 0, dy: dy = 0, textAnchor: textAnchor = 'start', innerRef: innerRef, innerTextRef: innerTextRef, verticalAnchor: verticalAnchor, alignmentBaseline: alignmentBaseline, angle: angle, lineHeight: lineHeight = '1em', scaleToFit: // eslint-disable-next-line @typescript-eslint/no-unused-vars
    scaleToFit = false, capHeight: capHeight, truncate: truncate, singleline: singleline, children: children, ...textProps } = props;
    const { x: x = 0, fontSize: fontSize } = textProps;
    const { wordsByLines: wordsByLines, startDy: startDy, transform: transform, truncated: truncated } = (0, $ikfTR.default)(props);
    /*
   * NOTE: We may need to change this <g> tag back to a <svg> tag at some point
   *
   * https://github.com/airbnb/visx/issues/971
   *
   * The core developer says the following "This is intentional as it simplifies positioning, rotation, and scaling."
   *
   * We measure the axis labels using the element ref. This works fine in some browsers but firefox
   * adds default sizes to svgs. Whereas chrome will respect empty width/height as null value.
   *
   * We currently don't do very fancy things with this text component so ok to switch to <g> for now.
   *
   * I did have to move the dx/dy translates from x/y attributes to a css transform since they
   * use em to center the text.
   */ const textComponent = /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
        ref: innerRef,
        fontSize: fontSize,
        style: {
            ...$91ea953eed024a92$var$SVG_STYLE,
            transform: `translate(calc(${dx}), calc(${dy}))`
        },
        children: wordsByLines.length > 0 ? /*#__PURE__*/ (0, $2OMIu.jsx)("text", {
            ref: innerTextRef,
            transform: transform,
            ...textProps,
            textAnchor: textAnchor,
            children: wordsByLines.map((line, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)("tspan", {
                    alignmentBaseline: alignmentBaseline,
                    x: x,
                    dy: index === 0 ? startDy : lineHeight,
                    children: line.words.join(' ')
                }, index))
        }) : null
    });
    if (truncated) {
        var _props$children;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            tag: "g",
            content: (_props$children = props.children) === null || _props$children === void 0 ? void 0 : _props$children.toString(),
            position: "bottom",
            children: textComponent
        });
    }
    return textComponent;
}

});
parcelRegister("ikfTR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5766daa0bc60be3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6xQMF = parcelRequire("6xQMF");

var $lMXX0 = parcelRequire("lMXX0");
function $d5766daa0bc60be3$var$isNumber(val) {
    return typeof val === 'number';
}
function $d5766daa0bc60be3$var$isXOrYInValid(xOrY) {
    return(// number that is not NaN or Infinity
    typeof xOrY === 'number' && Number.isFinite(xOrY) || // for percentage
    typeof xOrY === 'string');
}
function $d5766daa0bc60be3$export$2e2bcd8739ae039(props) {
    const { verticalAnchor: verticalAnchor = 'start', scaleToFit: scaleToFit = false, angle: angle, width: width, lineHeight: lineHeight = '1em', capHeight: capHeight = '0em', children: // Magic number from d3
    // capHeight = '0.71em',
    children, truncate: truncate, style: style, singleline: singleline, ...textProps } = props;
    const { x: x = 0, y: y = 0 } = textProps;
    const isXOrYNotValid = !$d5766daa0bc60be3$var$isXOrYInValid(x) || !$d5766daa0bc60be3$var$isXOrYInValid(y);
    const { wordsWithWidth: wordsWithWidth, spaceWidth: spaceWidth } = (0, $5uXOq.useMemo)(()=>{
        const words = children == null ? [] : children.toString().split(/(?:(?!\u00A0+)\s+)/);
        return {
            wordsWithWidth: words.map((word)=>({
                    word: word,
                    wordWidth: (0, $lMXX0.default)(word, style) || 0
                })),
            spaceWidth: (0, $lMXX0.default)('\u00A0', style) || 0
        };
    }, [
        children,
        style
    ]);
    const { wordsByLines: wordsByLines, truncated: truncated } = (0, $5uXOq.useMemo)(()=>{
        let isTruncated = false;
        if (isXOrYNotValid) return {
            wordsByLines: [],
            truncated: isTruncated
        };
        // Only perform calculations if using features that require them (multiline, scaleToFit)
        if (width || scaleToFit) {
            const words = wordsWithWidth.reduce((result, _ref)=>{
                let { word: word, wordWidth: wordWidth } = _ref;
                const currentLine = result[result.length - 1];
                if (currentLine && (width == null || scaleToFit || truncate || singleline || (currentLine.width || 0) + wordWidth + spaceWidth < width)) {
                    currentLine.words.push(word);
                    currentLine.width = currentLine.width || 0;
                    currentLine.width += wordWidth + spaceWidth;
                } else {
                    // Add first word to line or word is too long to scaleToFit on existing line
                    const newLine = {
                        words: [
                            word
                        ],
                        width: wordWidth
                    };
                    result.push(newLine);
                }
                return result;
            }, []);
            // Word can be added to an existing line
            if (truncate && width) {
                const ellipsesWidth = (0, $lMXX0.default)('...', style) || 0;
                const joinedWords = words[0].words.join('\u00A0');
                const joinedSubstring = joinedWords.substring(0, (width - ellipsesWidth) / (words[0].width || 0) * joinedWords.length);
                if (joinedSubstring !== joinedWords) {
                    isTruncated = true;
                    words[0].words = [
                        joinedSubstring + '...'
                    ];
                }
            }
            return {
                wordsByLines: words,
                truncated: isTruncated
            };
        }
        return {
            wordsByLines: [
                {
                    words: children == null ? [] : children.toString().split(/(?:(?!\u00A0+)\s+)/)
                }
            ],
            truncated: isTruncated
        };
    }, [
        isXOrYNotValid,
        width,
        scaleToFit,
        children,
        wordsWithWidth,
        spaceWidth
    ]);
    const startDy = (0, $5uXOq.useMemo)(()=>{
        const startDyStr = isXOrYNotValid ? '' : verticalAnchor === 'start' ? (0, (/*@__PURE__*/$parcel$interopDefault($6xQMF)))(`calc(${capHeight})`) : verticalAnchor === 'middle' ? (0, (/*@__PURE__*/$parcel$interopDefault($6xQMF)))(`calc(${(wordsByLines.length - 1) / 2} * -${lineHeight} + (${capHeight} / 2))`) : (0, (/*@__PURE__*/$parcel$interopDefault($6xQMF)))(`calc(${wordsByLines.length - 1} * -${lineHeight})`);
        return startDyStr;
    }, [
        isXOrYNotValid,
        verticalAnchor,
        capHeight,
        wordsByLines.length,
        lineHeight
    ]);
    const transform = (0, $5uXOq.useMemo)(()=>{
        const transforms = [];
        if (isXOrYNotValid) return '';
        if ($d5766daa0bc60be3$var$isNumber(x) && $d5766daa0bc60be3$var$isNumber(y) && $d5766daa0bc60be3$var$isNumber(width) && scaleToFit && wordsByLines.length > 0) {
            const lineWidth = wordsByLines[0].width || 1;
            const sx = scaleToFit === 'shrink-only' ? Math.min(width / lineWidth, 1) : width / lineWidth;
            const sy = sx;
            const originX = x - sx * x;
            const originY = y - sy * y;
            transforms.push(`matrix(${sx}, 0, 0, ${sy}, ${originX}, ${originY})`);
        }
        if (angle) transforms.push(`rotate(${angle}, ${x}, ${y})`);
        return transforms.length > 0 ? transforms.join(' ') : '';
    }, [
        isXOrYNotValid,
        x,
        y,
        width,
        scaleToFit,
        wordsByLines,
        angle
    ]);
    return {
        wordsByLines: wordsByLines,
        startDy: startDy,
        transform: transform,
        truncated: truncated
    };
}

});
parcelRegister("6xQMF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $66zZI = parcelRequire("66zZI");
var $4c3ec4f1f2153be8$var$_postcssValueParser2 = $4c3ec4f1f2153be8$var$_interopRequireDefault($66zZI);

var $dR6OW = parcelRequire("dR6OW");

var $8nBRK = parcelRequire("8nBRK");
var $4c3ec4f1f2153be8$var$_reducer2 = $4c3ec4f1f2153be8$var$_interopRequireDefault($8nBRK);

var $hYnJW = parcelRequire("hYnJW");
var $4c3ec4f1f2153be8$var$_stringifier2 = $4c3ec4f1f2153be8$var$_interopRequireDefault($hYnJW);
function $4c3ec4f1f2153be8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// eslint-disable-line
var $4c3ec4f1f2153be8$var$MATCH_CALC = /((?:\-[a-z]+\-)?calc)/;
module.exports.default = function(value) {
    var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
    return (0, $4c3ec4f1f2153be8$var$_postcssValueParser2.default)(value).walk(function(node) {
        // skip anything which isn't a calc() function
        if (node.type !== 'function' || !$4c3ec4f1f2153be8$var$MATCH_CALC.test(node.value)) return;
        // stringify calc expression and produce an AST
        var contents = $4c3ec4f1f2153be8$var$_postcssValueParser2.default.stringify(node.nodes);
        // skip constant() and env()
        if (contents.indexOf('constant') >= 0 || contents.indexOf('env') >= 0) return;
        var ast = $dR6OW.parser.parse(contents);
        // reduce AST to its simplest form, that is, either to a single value
        // or a simplified calc expression
        var reducedAst = (0, $4c3ec4f1f2153be8$var$_reducer2.default)(ast, precision);
        // stringify AST and write it back
        node.type = 'word';
        node.value = (0, $4c3ec4f1f2153be8$var$_stringifier2.default)(node.value, reducedAst, precision);
    }, true).toString();
};
module.exports = module.exports['default'];

});
parcelRegister("66zZI", function(module, exports) {

var $c05wQ = parcelRequire("c05wQ");

var $lLT70 = parcelRequire("lLT70");

var $56MFS = parcelRequire("56MFS");
function $471f39605d327d11$var$ValueParser(value) {
    if (this instanceof $471f39605d327d11$var$ValueParser) {
        this.nodes = $c05wQ(value);
        return this;
    }
    return new $471f39605d327d11$var$ValueParser(value);
}
$471f39605d327d11$var$ValueParser.prototype.toString = function() {
    return Array.isArray(this.nodes) ? $56MFS(this.nodes) : "";
};
$471f39605d327d11$var$ValueParser.prototype.walk = function(cb, bubble) {
    $lLT70(this.nodes, cb, bubble);
    return this;
};

$471f39605d327d11$var$ValueParser.unit = (parcelRequire("6U91R"));
$471f39605d327d11$var$ValueParser.walk = $lLT70;
$471f39605d327d11$var$ValueParser.stringify = $56MFS;
module.exports = $471f39605d327d11$var$ValueParser;

});
parcelRegister("c05wQ", function(module, exports) {
var $8bc9c60852c1cb63$var$openParentheses = "(".charCodeAt(0);
var $8bc9c60852c1cb63$var$closeParentheses = ")".charCodeAt(0);
var $8bc9c60852c1cb63$var$singleQuote = "'".charCodeAt(0);
var $8bc9c60852c1cb63$var$doubleQuote = '"'.charCodeAt(0);
var $8bc9c60852c1cb63$var$backslash = "\\".charCodeAt(0);
var $8bc9c60852c1cb63$var$slash = "/".charCodeAt(0);
var $8bc9c60852c1cb63$var$comma = ",".charCodeAt(0);
var $8bc9c60852c1cb63$var$colon = ":".charCodeAt(0);
var $8bc9c60852c1cb63$var$star = "*".charCodeAt(0);
module.exports = function(input) {
    var tokens = [];
    var value = input;
    var next, quote, prev, token, escape, escapePos, whitespacePos;
    var pos = 0;
    var code = value.charCodeAt(pos);
    var max = value.length;
    var stack = [
        {
            nodes: tokens
        }
    ];
    var balanced = 0;
    var parent;
    var name = "";
    var before = "";
    var after = "";
    while(pos < max){
        // Whitespaces
        if (code <= 32) {
            next = pos;
            do {
                next += 1;
                code = value.charCodeAt(next);
            }while (code <= 32);
            token = value.slice(pos, next);
            prev = tokens[tokens.length - 1];
            if (code === $8bc9c60852c1cb63$var$closeParentheses && balanced) after = token;
            else if (prev && prev.type === "div") prev.after = token;
            else if (code === $8bc9c60852c1cb63$var$comma || code === $8bc9c60852c1cb63$var$colon || code === $8bc9c60852c1cb63$var$slash && value.charCodeAt(next + 1) !== $8bc9c60852c1cb63$var$star) before = token;
            else tokens.push({
                type: "space",
                sourceIndex: pos,
                value: token
            });
            pos = next;
        // Quotes
        } else if (code === $8bc9c60852c1cb63$var$singleQuote || code === $8bc9c60852c1cb63$var$doubleQuote) {
            next = pos;
            quote = code === $8bc9c60852c1cb63$var$singleQuote ? "'" : '"';
            token = {
                type: "string",
                sourceIndex: pos,
                quote: quote
            };
            do {
                escape = false;
                next = value.indexOf(quote, next + 1);
                if (~next) {
                    escapePos = next;
                    while(value.charCodeAt(escapePos - 1) === $8bc9c60852c1cb63$var$backslash){
                        escapePos -= 1;
                        escape = !escape;
                    }
                } else {
                    value += quote;
                    next = value.length - 1;
                    token.unclosed = true;
                }
            }while (escape);
            token.value = value.slice(pos + 1, next);
            tokens.push(token);
            pos = next + 1;
            code = value.charCodeAt(pos);
        // Comments
        } else if (code === $8bc9c60852c1cb63$var$slash && value.charCodeAt(pos + 1) === $8bc9c60852c1cb63$var$star) {
            token = {
                type: "comment",
                sourceIndex: pos
            };
            next = value.indexOf("*/", pos);
            if (next === -1) {
                token.unclosed = true;
                next = value.length;
            }
            token.value = value.slice(pos + 2, next);
            tokens.push(token);
            pos = next + 2;
            code = value.charCodeAt(pos);
        // Dividers
        } else if (code === $8bc9c60852c1cb63$var$slash || code === $8bc9c60852c1cb63$var$comma || code === $8bc9c60852c1cb63$var$colon) {
            token = value[pos];
            tokens.push({
                type: "div",
                sourceIndex: pos - before.length,
                value: token,
                before: before,
                after: ""
            });
            before = "";
            pos += 1;
            code = value.charCodeAt(pos);
        // Open parentheses
        } else if ($8bc9c60852c1cb63$var$openParentheses === code) {
            // Whitespaces after open parentheses
            next = pos;
            do {
                next += 1;
                code = value.charCodeAt(next);
            }while (code <= 32);
            token = {
                type: "function",
                sourceIndex: pos - name.length,
                value: name,
                before: value.slice(pos + 1, next)
            };
            pos = next;
            if (name === "url" && code !== $8bc9c60852c1cb63$var$singleQuote && code !== $8bc9c60852c1cb63$var$doubleQuote) {
                next -= 1;
                do {
                    escape = false;
                    next = value.indexOf(")", next + 1);
                    if (~next) {
                        escapePos = next;
                        while(value.charCodeAt(escapePos - 1) === $8bc9c60852c1cb63$var$backslash){
                            escapePos -= 1;
                            escape = !escape;
                        }
                    } else {
                        value += ")";
                        next = value.length - 1;
                        token.unclosed = true;
                    }
                }while (escape);
                // Whitespaces before closed
                whitespacePos = next;
                do {
                    whitespacePos -= 1;
                    code = value.charCodeAt(whitespacePos);
                }while (code <= 32);
                if (pos !== whitespacePos + 1) token.nodes = [
                    {
                        type: "word",
                        sourceIndex: pos,
                        value: value.slice(pos, whitespacePos + 1)
                    }
                ];
                else token.nodes = [];
                if (token.unclosed && whitespacePos + 1 !== next) {
                    token.after = "";
                    token.nodes.push({
                        type: "space",
                        sourceIndex: whitespacePos + 1,
                        value: value.slice(whitespacePos + 1, next)
                    });
                } else token.after = value.slice(whitespacePos + 1, next);
                pos = next + 1;
                code = value.charCodeAt(pos);
                tokens.push(token);
            } else {
                balanced += 1;
                token.after = "";
                tokens.push(token);
                stack.push(token);
                tokens = token.nodes = [];
                parent = token;
            }
            name = "";
        // Close parentheses
        } else if ($8bc9c60852c1cb63$var$closeParentheses === code && balanced) {
            pos += 1;
            code = value.charCodeAt(pos);
            parent.after = after;
            after = "";
            balanced -= 1;
            stack.pop();
            parent = stack[balanced];
            tokens = parent.nodes;
        // Words
        } else {
            next = pos;
            do {
                if (code === $8bc9c60852c1cb63$var$backslash) next += 1;
                next += 1;
                code = value.charCodeAt(next);
            }while (next < max && !(code <= 32 || code === $8bc9c60852c1cb63$var$singleQuote || code === $8bc9c60852c1cb63$var$doubleQuote || code === $8bc9c60852c1cb63$var$comma || code === $8bc9c60852c1cb63$var$colon || code === $8bc9c60852c1cb63$var$slash || code === $8bc9c60852c1cb63$var$openParentheses || code === $8bc9c60852c1cb63$var$closeParentheses && balanced));
            token = value.slice(pos, next);
            if ($8bc9c60852c1cb63$var$openParentheses === code) name = token;
            else tokens.push({
                type: "word",
                sourceIndex: pos,
                value: token
            });
            pos = next;
        }
    }
    for(pos = stack.length - 1; pos; pos -= 1)stack[pos].unclosed = true;
    return stack[0].nodes;
};

});

parcelRegister("lLT70", function(module, exports) {
module.exports = function walk(nodes, cb, bubble) {
    var i, max, node, result;
    for(i = 0, max = nodes.length; i < max; i += 1){
        node = nodes[i];
        if (!bubble) result = cb(node, i, nodes);
        if (result !== false && node.type === "function" && Array.isArray(node.nodes)) walk(node.nodes, cb, bubble);
        if (bubble) cb(node, i, nodes);
    }
};

});

parcelRegister("56MFS", function(module, exports) {
function $3b834504a4ab1d04$var$stringifyNode(node, custom) {
    var type = node.type;
    var value = node.value;
    var buf;
    var customResult;
    if (custom && (customResult = custom(node)) !== undefined) return customResult;
    else if (type === "word" || type === "space") return value;
    else if (type === "string") {
        buf = node.quote || "";
        return buf + value + (node.unclosed ? "" : buf);
    } else if (type === "comment") return "/*" + value + (node.unclosed ? "" : "*/");
    else if (type === "div") return (node.before || "") + value + (node.after || "");
    else if (Array.isArray(node.nodes)) {
        buf = $3b834504a4ab1d04$var$stringify(node.nodes);
        if (type !== "function") return buf;
        return value + "(" + (node.before || "") + buf + (node.after || "") + (node.unclosed ? "" : ")");
    }
    return value;
}
function $3b834504a4ab1d04$var$stringify(nodes, custom) {
    var result, i;
    if (Array.isArray(nodes)) {
        result = "";
        for(i = nodes.length - 1; ~i; i -= 1)result = $3b834504a4ab1d04$var$stringifyNode(nodes[i], custom) + result;
        return result;
    }
    return $3b834504a4ab1d04$var$stringifyNode(nodes, custom);
}
module.exports = $3b834504a4ab1d04$var$stringify;

});

parcelRegister("6U91R", function(module, exports) {
var $506ef9fdb9238895$var$minus = "-".charCodeAt(0);
var $506ef9fdb9238895$var$plus = "+".charCodeAt(0);
var $506ef9fdb9238895$var$dot = ".".charCodeAt(0);
var $506ef9fdb9238895$var$exp = "e".charCodeAt(0);
var $506ef9fdb9238895$var$EXP = "E".charCodeAt(0);
module.exports = function(value) {
    var pos = 0;
    var length = value.length;
    var dotted = false;
    var sciPos = -1;
    var containsNumber = false;
    var code;
    while(pos < length){
        code = value.charCodeAt(pos);
        if (code >= 48 && code <= 57) containsNumber = true;
        else if (code === $506ef9fdb9238895$var$exp || code === $506ef9fdb9238895$var$EXP) {
            if (sciPos > -1) break;
            sciPos = pos;
        } else if (code === $506ef9fdb9238895$var$dot) {
            if (dotted) break;
            dotted = true;
        } else if (code === $506ef9fdb9238895$var$plus || code === $506ef9fdb9238895$var$minus) {
            if (pos !== 0) break;
        } else break;
        pos += 1;
    }
    if (sciPos + 1 === pos) pos--;
    return containsNumber ? {
        number: value.slice(0, pos),
        unit: value.slice(pos)
    } : false;
};

});


parcelRegister("dR6OW", function(module, exports) {

$parcel$export(module.exports, "parser", () => $a165840c76c6afe6$export$8f49e4af10703ce3, (v) => $a165840c76c6afe6$export$8f49e4af10703ce3 = v);
/* parser generated by jison 0.6.1-215 */ /*
 * Returns a Parser object of the following structure:
 *
 *  Parser: {
 *    yy: {}     The so-called "shared state" or rather the *source* of it;
 *               the real "shared state" `yy` passed around to
 *               the rule actions, etc. is a derivative/copy of this one,
 *               not a direct reference!
 *  }
 *
 *  Parser.prototype: {
 *    yy: {},
 *    EOF: 1,
 *    TERROR: 2,
 *
 *    trace: function(errorMessage, ...),
 *
 *    JisonParserError: function(msg, hash),
 *
 *    quoteName: function(name),
 *               Helper function which can be overridden by user code later on: put suitable
 *               quotes around literal IDs in a description string.
 *
 *    originalQuoteName: function(name),
 *               The basic quoteName handler provided by JISON.
 *               `cleanupAfterParse()` will clean up and reset `quoteName()` to reference this function
 *               at the end of the `parse()`.
 *
 *    describeSymbol: function(symbol),
 *               Return a more-or-less human-readable description of the given symbol, when
 *               available, or the symbol itself, serving as its own 'description' for lack
 *               of something better to serve up.
 *
 *               Return NULL when the symbol is unknown to the parser.
 *
 *    symbols_: {associative list: name ==> number},
 *    terminals_: {associative list: number ==> name},
 *    nonterminals: {associative list: rule-name ==> {associative list: number ==> rule-alt}},
 *    terminal_descriptions_: (if there are any) {associative list: number ==> description},
 *    productions_: [...],
 *
 *    performAction: function parser__performAction(yytext, yyleng, yylineno, yyloc, yystate, yysp, yyvstack, yylstack, yystack, yysstack),
 *
 *               The function parameters and `this` have the following value/meaning:
 *               - `this`    : reference to the `yyval` internal object, which has members (`$` and `_$`)
 *                             to store/reference the rule value `$$` and location info `@$`.
 *
 *                 One important thing to note about `this` a.k.a. `yyval`: every *reduce* action gets
 *                 to see the same object via the `this` reference, i.e. if you wish to carry custom
 *                 data from one reduce action through to the next within a single parse run, then you
 *                 may get nasty and use `yyval` a.k.a. `this` for storing you own semi-permanent data.
 *
 *                 `this.yy` is a direct reference to the `yy` shared state object.
 *
 *                 `%parse-param`-specified additional `parse()` arguments have been added to this `yy`
 *                 object at `parse()` start and are therefore available to the action code via the
 *                 same named `yy.xxxx` attributes (where `xxxx` represents a identifier name from
 *                 the %parse-param` list.
 *
 *               - `yytext`  : reference to the lexer value which belongs to the last lexer token used
 *                             to match this rule. This is *not* the look-ahead token, but the last token
 *                             that's actually part of this rule.
 *
 *                 Formulated another way, `yytext` is the value of the token immediately preceeding
 *                 the current look-ahead token.
 *                 Caveats apply for rules which don't require look-ahead, such as epsilon rules.
 *
 *               - `yyleng`  : ditto as `yytext`, only now for the lexer.yyleng value.
 *
 *               - `yylineno`: ditto as `yytext`, only now for the lexer.yylineno value.
 *
 *               - `yyloc`   : ditto as `yytext`, only now for the lexer.yylloc lexer token location info.
 *
 *                               WARNING: since jison 0.4.18-186 this entry may be NULL/UNDEFINED instead
 *                               of an empty object when no suitable location info can be provided.
 *
 *               - `yystate` : the current parser state number, used internally for dispatching and
 *                               executing the action code chunk matching the rule currently being reduced.
 *
 *               - `yysp`    : the current state stack position (a.k.a. 'stack pointer')
 *
 *                 This one comes in handy when you are going to do advanced things to the parser
 *                 stacks, all of which are accessible from your action code (see the next entries below).
 *
 *                 Also note that you can access this and other stack index values using the new double-hash
 *                 syntax, i.e. `##$ === ##0 === yysp`, while `##1` is the stack index for all things
 *                 related to the first rule term, just like you have `$1`, `@1` and `#1`.
 *                 This is made available to write very advanced grammar action rules, e.g. when you want
 *                 to investigate the parse state stack in your action code, which would, for example,
 *                 be relevant when you wish to implement error diagnostics and reporting schemes similar
 *                 to the work described here:
 *
 *                 + Pottier, F., 2016. Reachability and error diagnosis in LR(1) automata.
 *                   In Journées Francophones des Languages Applicatifs.
 *
 *                 + Jeffery, C.L., 2003. Generating LR syntax error messages from examples.
 *                   ACM Transactions on Programming Languages and Systems (TOPLAS), 25(5), pp.631–640.
 *
 *               - `yyrulelength`: the current rule's term count, i.e. the number of entries occupied on the stack.
 *
 *                 This one comes in handy when you are going to do advanced things to the parser
 *                 stacks, all of which are accessible from your action code (see the next entries below).
 *
 *               - `yyvstack`: reference to the parser value stack. Also accessed via the `$1` etc.
 *                             constructs.
 *
 *               - `yylstack`: reference to the parser token location stack. Also accessed via
 *                             the `@1` etc. constructs.
 *
 *                             WARNING: since jison 0.4.18-186 this array MAY contain slots which are
 *                             UNDEFINED rather than an empty (location) object, when the lexer/parser
 *                             action code did not provide a suitable location info object when such a
 *                             slot was filled!
 *
 *               - `yystack` : reference to the parser token id stack. Also accessed via the
 *                             `#1` etc. constructs.
 *
 *                 Note: this is a bit of a **white lie** as we can statically decode any `#n` reference to
 *                 its numeric token id value, hence that code wouldn't need the `yystack` but *you* might
 *                 want access this array for your own purposes, such as error analysis as mentioned above!
 *
 *                 Note that this stack stores the current stack of *tokens*, that is the sequence of
 *                 already parsed=reduced *nonterminals* (tokens representing rules) and *terminals*
 *                 (lexer tokens *shifted* onto the stack until the rule they belong to is found and
 *                 *reduced*.
 *
 *               - `yysstack`: reference to the parser state stack. This one carries the internal parser
 *                             *states* such as the one in `yystate`, which are used to represent
 *                             the parser state machine in the *parse table*. *Very* *internal* stuff,
 *                             what can I say? If you access this one, you're clearly doing wicked things
 *
 *               - `...`     : the extra arguments you specified in the `%parse-param` statement in your
 *                             grammar definition file.
 *
 *    table: [...],
 *               State transition table
 *               ----------------------
 *
 *               index levels are:
 *               - `state`  --> hash table
 *               - `symbol` --> action (number or array)
 *
 *                 If the `action` is an array, these are the elements' meaning:
 *                 - index [0]: 1 = shift, 2 = reduce, 3 = accept
 *                 - index [1]: GOTO `state`
 *
 *                 If the `action` is a number, it is the GOTO `state`
 *
 *    defaultActions: {...},
 *
 *    parseError: function(str, hash, ExceptionClass),
 *    yyError: function(str, ...),
 *    yyRecovering: function(),
 *    yyErrOk: function(),
 *    yyClearIn: function(),
 *
 *    constructParseErrorInfo: function(error_message, exception_object, expected_token_set, is_recoverable),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               Produces a new errorInfo 'hash object' which can be passed into `parseError()`.
 *               See it's use in this parser kernel in many places; example usage:
 *
 *                   var infoObj = parser.constructParseErrorInfo('fail!', null,
 *                                     parser.collect_expected_token_set(state), true);
 *                   var retVal = parser.parseError(infoObj.errStr, infoObj, parser.JisonParserError);
 *
 *    originalParseError: function(str, hash, ExceptionClass),
 *               The basic `parseError` handler provided by JISON.
 *               `cleanupAfterParse()` will clean up and reset `parseError()` to reference this function
 *               at the end of the `parse()`.
 *
 *    options: { ... parser %options ... },
 *
 *    parse: function(input[, args...]),
 *               Parse the given `input` and return the parsed value (or `true` when none was provided by
 *               the root action, in which case the parser is acting as a *matcher*).
 *               You MAY use the additional `args...` parameters as per `%parse-param` spec of this grammar:
 *               these extra `args...` are added verbatim to the `yy` object reference as member variables.
 *
 *               WARNING:
 *               Parser's additional `args...` parameters (via `%parse-param`) MAY conflict with
 *               any attributes already added to `yy` by the jison run-time;
 *               when such a collision is detected an exception is thrown to prevent the generated run-time
 *               from silently accepting this confusing and potentially hazardous situation!
 *
 *               The lexer MAY add its own set of additional parameters (via the `%parse-param` line in
 *               the lexer section of the grammar spec): these will be inserted in the `yy` shared state
 *               object and any collision with those will be reported by the lexer via a thrown exception.
 *
 *    cleanupAfterParse: function(resultValue, invoke_post_methods, do_not_nuke_errorinfos),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               This helper API is invoked at the end of the `parse()` call, unless an exception was thrown
 *               and `%options no-try-catch` has been defined for this grammar: in that case this helper MAY
 *               be invoked by calling user code to ensure the `post_parse` callbacks are invoked and
 *               the internal parser gets properly garbage collected under these particular circumstances.
 *
 *    yyMergeLocationInfo: function(first_index, last_index, first_yylloc, last_yylloc, dont_look_back),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               This helper API can be invoked to calculate a spanning `yylloc` location info object.
 *
 *               Note: %epsilon rules MAY specify no `first_index` and `first_yylloc`, in which case
 *               this function will attempt to obtain a suitable location marker by inspecting the location stack
 *               backwards.
 *
 *               For more info see the documentation comment further below, immediately above this function's
 *               implementation.
 *
 *    lexer: {
 *        yy: {...},           A reference to the so-called "shared state" `yy` once
 *                             received via a call to the `.setInput(input, yy)` lexer API.
 *        EOF: 1,
 *        ERROR: 2,
 *        JisonLexerError: function(msg, hash),
 *        parseError: function(str, hash, ExceptionClass),
 *        setInput: function(input, [yy]),
 *        input: function(),
 *        unput: function(str),
 *        more: function(),
 *        reject: function(),
 *        less: function(n),
 *        pastInput: function(n),
 *        upcomingInput: function(n),
 *        showPosition: function(),
 *        test_match: function(regex_match_array, rule_index, ...),
 *        next: function(...),
 *        lex: function(...),
 *        begin: function(condition),
 *        pushState: function(condition),
 *        popState: function(),
 *        topState: function(),
 *        _currentRules: function(),
 *        stateStackSize: function(),
 *        cleanupAfterLex: function()
 *
 *        options: { ... lexer %options ... },
 *
 *        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START, ...),
 *        rules: [...],
 *        conditions: {associative list: name ==> set},
 *    }
 *  }
 *
 *
 *  token location info (@$, _$, etc.): {
 *    first_line: n,
 *    last_line: n,
 *    first_column: n,
 *    last_column: n,
 *    range: [start_number, end_number]
 *               (where the numbers are indexes into the input string, zero-based)
 *  }
 *
 * ---
 *
 * The `parseError` function receives a 'hash' object with these members for lexer and
 * parser errors:
 *
 *  {
 *    text:        (matched text)
 *    token:       (the produced terminal token, if any)
 *    token_id:    (the produced terminal token numeric ID, if any)
 *    line:        (yylineno)
 *    loc:         (yylloc)
 *  }
 *
 * parser (grammar) errors will also provide these additional members:
 *
 *  {
 *    expected:    (array describing the set of expected tokens;
 *                  may be UNDEFINED when we cannot easily produce such a set)
 *    state:       (integer (or array when the table includes grammar collisions);
 *                  represents the current internal state of the parser kernel.
 *                  can, for example, be used to pass to the `collect_expected_token_set()`
 *                  API to obtain the expected token set)
 *    action:      (integer; represents the current internal action which will be executed)
 *    new_state:   (integer; represents the next/planned internal state, once the current
 *                  action has executed)
 *    recoverable: (boolean: TRUE when the parser MAY have an error recovery rule
 *                  available for this particular error)
 *    state_stack: (array: the current parser LALR/LR internal state stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    value_stack: (array: the current parser LALR/LR internal `$$` value stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    location_stack: (array: the current parser LALR/LR internal location stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    yy:          (object: the current parser internal "shared state" `yy`
 *                  as is also available in the rule actions; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    lexer:       (reference to the current lexer instance used by the parser)
 *    parser:      (reference to the current parser instance)
 *  }
 *
 * while `this` will reference the current parser instance.
 *
 * When `parseError` is invoked by the lexer, `this` will still reference the related *parser*
 * instance, while these additional `hash` fields will also be provided:
 *
 *  {
 *    lexer:       (reference to the current lexer instance which reported the error)
 *  }
 *
 * When `parseError` is invoked by the parser due to a **JavaScript exception** being fired
 * from either the parser or lexer, `this` will still reference the related *parser*
 * instance, while these additional `hash` fields will also be provided:
 *
 *  {
 *    exception:   (reference to the exception thrown)
 *  }
 *
 * Please do note that in the latter situation, the `expected` field will be omitted as
 * this type of failure is assumed not to be due to *parse errors* but rather due to user
 * action code in either parser or lexer failing unexpectedly.
 *
 * ---
 *
 * You can specify parser options by setting / modifying the `.yy` object of your Parser instance.
 * These options are available:
 *
 * ### options which are global for all parser instances
 *
 *  Parser.pre_parse: function(yy)
 *                 optional: you can specify a pre_parse() function in the chunk following
 *                 the grammar, i.e. after the last `%%`.
 *  Parser.post_parse: function(yy, retval, parseInfo) { return retval; }
 *                 optional: you can specify a post_parse() function in the chunk following
 *                 the grammar, i.e. after the last `%%`. When it does not return any value,
 *                 the parser will return the original `retval`.
 *
 * ### options which can be set up per parser instance
 *
 *  yy: {
 *      pre_parse:  function(yy)
 *                 optional: is invoked before the parse cycle starts (and before the first
 *                 invocation of `lex()`) but immediately after the invocation of
 *                 `parser.pre_parse()`).
 *      post_parse: function(yy, retval, parseInfo) { return retval; }
 *                 optional: is invoked when the parse terminates due to success ('accept')
 *                 or failure (even when exceptions are thrown).
 *                 `retval` contains the return value to be produced by `Parser.parse()`;
 *                 this function can override the return value by returning another.
 *                 When it does not return any value, the parser will return the original
 *                 `retval`.
 *                 This function is invoked immediately before `parser.post_parse()`.
 *
 *      parseError: function(str, hash, ExceptionClass)
 *                 optional: overrides the default `parseError` function.
 *      quoteName: function(name),
 *                 optional: overrides the default `quoteName` function.
 *  }
 *
 *  parser.lexer.options: {
 *      pre_lex:  function()
 *                 optional: is invoked before the lexer is invoked to produce another token.
 *                 `this` refers to the Lexer object.
 *      post_lex: function(token) { return token; }
 *                 optional: is invoked when the lexer has produced a token `token`;
 *                 this function can override the returned token value by returning another.
 *                 When it does not return any (truthy) value, the lexer will return
 *                 the original `token`.
 *                 `this` refers to the Lexer object.
 *
 *      ranges: boolean
 *                 optional: `true` ==> token location info will include a .range[] member.
 *      flex: boolean
 *                 optional: `true` ==> flex-like lexing behaviour where the rules are tested
 *                 exhaustively to find the longest match.
 *      backtrack_lexer: boolean
 *                 optional: `true` ==> lexer regexes are tested in order and for invoked;
 *                 the lexer terminates the scan when a token is returned by the action code.
 *      xregexp: boolean
 *                 optional: `true` ==> lexer rule regexes are "extended regex format" requiring the
 *                 `XRegExp` library. When this `%option` has not been specified at compile time, all lexer
 *                 rule regexes have been written as standard JavaScript RegExp expressions.
 *  }
 */ var $a165840c76c6afe6$export$8f49e4af10703ce3;
var $a165840c76c6afe6$export$7acfa6ed01010e37;
var $a165840c76c6afe6$export$98e6a39c04603d36;
var $a165840c76c6afe6$var$parser = function() {
    // See also:
    // http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript/#35881508
    // but we keep the prototype.constructor and prototype.name assignment lines too for compatibility
    // with userland code which might access the derived class in a 'classic' way.
    function JisonParserError(msg, hash) {
        Object.defineProperty(this, 'name', {
            enumerable: false,
            writable: false,
            value: 'JisonParserError'
        });
        if (msg == null) msg = '???';
        Object.defineProperty(this, 'message', {
            enumerable: false,
            writable: true,
            value: msg
        });
        this.hash = hash;
        var stacktrace;
        if (hash && hash.exception instanceof Error) {
            var ex2 = hash.exception;
            this.message = ex2.message || msg;
            stacktrace = ex2.stack;
        }
        if (!stacktrace) {
            if (Error.hasOwnProperty('captureStackTrace')) Error.captureStackTrace(this, this.constructor);
            else stacktrace = new Error(msg).stack;
        }
        if (stacktrace) Object.defineProperty(this, 'stack', {
            enumerable: false,
            writable: false,
            value: stacktrace
        });
    }
    if (typeof Object.setPrototypeOf === 'function') Object.setPrototypeOf(JisonParserError.prototype, Error.prototype);
    else JisonParserError.prototype = Object.create(Error.prototype);
    JisonParserError.prototype.constructor = JisonParserError;
    JisonParserError.prototype.name = 'JisonParserError';
    // helper: reconstruct the productions[] table
    function bp(s) {
        var rv = [];
        var p = s.pop;
        var r = s.rule;
        for(var i = 0, l = p.length; i < l; i++)rv.push([
            p[i],
            r[i]
        ]);
        return rv;
    }
    // helper: reconstruct the defaultActions[] table
    function bda(s) {
        var rv = {};
        var d = s.idx;
        var g = s.goto;
        for(var i = 0, l = d.length; i < l; i++){
            var j = d[i];
            rv[j] = g[i];
        }
        return rv;
    }
    // helper: reconstruct the 'goto' table
    function bt(s) {
        var rv = [];
        var d = s.len;
        var y = s.symbol;
        var t = s.type;
        var a = s.state;
        var m = s.mode;
        var g = s.goto;
        for(var i = 0, l = d.length; i < l; i++){
            var n = d[i];
            var q = {};
            for(var j = 0; j < n; j++){
                var z = y.shift();
                switch(t.shift()){
                    case 2:
                        q[z] = [
                            m.shift(),
                            g.shift()
                        ];
                        break;
                    case 0:
                        q[z] = a.shift();
                        break;
                    default:
                        // type === 1: accept
                        q[z] = [
                            3
                        ];
                }
            }
            rv.push(q);
        }
        return rv;
    }
    // helper: runlength encoding with increment step: code, length: step (default step = 0)
    // `this` references an array
    function s(c, l, a) {
        a = a || 0;
        for(var i = 0; i < l; i++){
            this.push(c);
            c += a;
        }
    }
    // helper: duplicate sequence from *relative* offset and length.
    // `this` references an array
    function c(i, l) {
        i = this.length - i;
        for(l += i; i < l; i++)this.push(this[i]);
    }
    // helper: unpack an array using helpers and data, all passed in an array argument 'a'.
    function u(a) {
        var rv = [];
        for(var i = 0, l = a.length; i < l; i++){
            var e = a[i];
            // Is this entry a helper function?
            if (typeof e === 'function') {
                i++;
                e.apply(rv, a[i]);
            } else rv.push(e);
        }
        return rv;
    }
    var parser = {
        // Code Generator Information Report
        // ---------------------------------
        //
        // Options:
        //
        //   default action mode: ............. ["classic","merge"]
        //   test-compile action mode: ........ "parser:*,lexer:*"
        //   try..catch: ...................... true
        //   default resolve on conflict: ..... true
        //   on-demand look-ahead: ............ false
        //   error recovery token skip maximum: 3
        //   yyerror in parse actions is: ..... NOT recoverable,
        //   yyerror in lexer actions and other non-fatal lexer are:
        //   .................................. NOT recoverable,
        //   debug grammar/output: ............ false
        //   has partial LR conflict upgrade:   true
        //   rudimentary token-stack support:   false
        //   parser table compression mode: ... 2
        //   export debug tables: ............. false
        //   export *all* tables: ............. false
        //   module type: ..................... commonjs
        //   parser engine type: .............. lalr
        //   output main() in the module: ..... true
        //   has user-specified main(): ....... false
        //   has user-specified require()/import modules for main():
        //   .................................. false
        //   number of expected conflicts: .... 0
        //
        //
        // Parser Analysis flags:
        //
        //   no significant actions (parser is a language matcher only):
        //   .................................. false
        //   uses yyleng: ..................... false
        //   uses yylineno: ................... false
        //   uses yytext: ..................... false
        //   uses yylloc: ..................... false
        //   uses ParseError API: ............. false
        //   uses YYERROR: .................... false
        //   uses YYRECOVERING: ............... false
        //   uses YYERROK: .................... false
        //   uses YYCLEARIN: .................. false
        //   tracks rule values: .............. true
        //   assigns rule values: ............. true
        //   uses location tracking: .......... false
        //   assigns location: ................ false
        //   uses yystack: .................... false
        //   uses yysstack: ................... false
        //   uses yysp: ....................... true
        //   uses yyrulelength: ............... false
        //   uses yyMergeLocationInfo API: .... false
        //   has error recovery: .............. false
        //   has error reporting: ............. false
        //
        // --------- END OF REPORT -----------
        trace: function no_op_trace() {},
        JisonParserError: JisonParserError,
        yy: {},
        options: {
            type: "lalr",
            hasPartialLrUpgradeOnConflict: true,
            errorRecoveryTokenDiscardCount: 3
        },
        symbols_: {
            "$accept": 0,
            "$end": 1,
            "ADD": 3,
            "ANGLE": 16,
            "CHS": 22,
            "COMMA": 14,
            "CSS_CPROP": 13,
            "CSS_VAR": 12,
            "DIV": 6,
            "EMS": 20,
            "EOF": 1,
            "EXS": 21,
            "FREQ": 18,
            "LENGTH": 15,
            "LPAREN": 7,
            "MUL": 5,
            "NESTED_CALC": 9,
            "NUMBER": 11,
            "PERCENTAGE": 28,
            "PREFIX": 10,
            "REMS": 23,
            "RES": 19,
            "RPAREN": 8,
            "SUB": 4,
            "TIME": 17,
            "VHS": 24,
            "VMAXS": 27,
            "VMINS": 26,
            "VWS": 25,
            "css_value": 33,
            "css_variable": 32,
            "error": 2,
            "expression": 29,
            "math_expression": 30,
            "value": 31
        },
        terminals_: {
            1: "EOF",
            2: "error",
            3: "ADD",
            4: "SUB",
            5: "MUL",
            6: "DIV",
            7: "LPAREN",
            8: "RPAREN",
            9: "NESTED_CALC",
            10: "PREFIX",
            11: "NUMBER",
            12: "CSS_VAR",
            13: "CSS_CPROP",
            14: "COMMA",
            15: "LENGTH",
            16: "ANGLE",
            17: "TIME",
            18: "FREQ",
            19: "RES",
            20: "EMS",
            21: "EXS",
            22: "CHS",
            23: "REMS",
            24: "VHS",
            25: "VWS",
            26: "VMINS",
            27: "VMAXS",
            28: "PERCENTAGE"
        },
        TERROR: 2,
        EOF: 1,
        // internals: defined here so the object *structure* doesn't get modified by parse() et al,
        // thus helping JIT compilers like Chrome V8.
        originalQuoteName: null,
        originalParseError: null,
        cleanupAfterParse: null,
        constructParseErrorInfo: null,
        yyMergeLocationInfo: null,
        __reentrant_call_depth: 0,
        __error_infos: [],
        __error_recovery_infos: [],
        // APIs which will be set up depending on user action code analysis:
        //yyRecovering: 0,
        //yyErrOk: 0,
        //yyClearIn: 0,
        // Helper APIs
        // -----------
        // Helper function which can be overridden by user code later on: put suitable quotes around
        // literal IDs in a description string.
        quoteName: function parser_quoteName(id_str) {
            return '"' + id_str + '"';
        },
        // Return the name of the given symbol (terminal or non-terminal) as a string, when available.
        //
        // Return NULL when the symbol is unknown to the parser.
        getSymbolName: function parser_getSymbolName(symbol) {
            if (this.terminals_[symbol]) return this.terminals_[symbol];
            // Otherwise... this might refer to a RULE token i.e. a non-terminal: see if we can dig that one up.
            //
            // An example of this may be where a rule's action code contains a call like this:
            //
            //      parser.getSymbolName(#$)
            //
            // to obtain a human-readable name of the current grammar rule.
            var s = this.symbols_;
            for(var key in s){
                if (s[key] === symbol) return key;
            }
            return null;
        },
        // Return a more-or-less human-readable description of the given symbol, when available,
        // or the symbol itself, serving as its own 'description' for lack of something better to serve up.
        //
        // Return NULL when the symbol is unknown to the parser.
        describeSymbol: function parser_describeSymbol(symbol) {
            if (symbol !== this.EOF && this.terminal_descriptions_ && this.terminal_descriptions_[symbol]) return this.terminal_descriptions_[symbol];
            else if (symbol === this.EOF) return 'end of input';
            var id = this.getSymbolName(symbol);
            if (id) return this.quoteName(id);
            return null;
        },
        // Produce a (more or less) human-readable list of expected tokens at the point of failure.
        //
        // The produced list may contain token or token set descriptions instead of the tokens
        // themselves to help turning this output into something that easier to read by humans
        // unless `do_not_describe` parameter is set, in which case a list of the raw, *numeric*,
        // expected terminals and nonterminals is produced.
        //
        // The returned list (array) will not contain any duplicate entries.
        collect_expected_token_set: function parser_collect_expected_token_set(state, do_not_describe) {
            var TERROR = this.TERROR;
            var tokenset = [];
            var check = {};
            // Has this (error?) state been outfitted with a custom expectations description text for human consumption?
            // If so, use that one instead of the less palatable token set.
            if (!do_not_describe && this.state_descriptions_ && this.state_descriptions_[state]) return [
                this.state_descriptions_[state]
            ];
            for(var p in this.table[state]){
                p = +p;
                if (p !== TERROR) {
                    var d = do_not_describe ? p : this.describeSymbol(p);
                    if (d && !check[d]) {
                        tokenset.push(d);
                        check[d] = true; // Mark this token description as already mentioned to prevent outputting duplicate entries.
                    }
                }
            }
            return tokenset;
        },
        productions_: bp({
            pop: u([
                29,
                s,
                [
                    30,
                    10
                ],
                31,
                31,
                32,
                32,
                s,
                [
                    33,
                    15
                ]
            ]),
            rule: u([
                2,
                s,
                [
                    3,
                    5
                ],
                4,
                7,
                s,
                [
                    1,
                    4
                ],
                2,
                4,
                6,
                s,
                [
                    1,
                    14
                ],
                2
            ])
        }),
        performAction: function parser__PerformAction(yystate /* action[1] */ , yysp, yyvstack) {
            /* this == yyval */ // the JS engine itself can go and remove these statements when `yy` turns out to be unused in any action code!
            var yy = this.yy;
            var yyparser = yy.parser;
            var yylexer = yy.lexer;
            switch(yystate){
                case 0:
                    /*! Production::    $accept : expression $end */ // default action (generated by JISON mode classic/merge :: 1,VT,VA,-,-,-,-,-,-):
                    this.$ = yyvstack[yysp - 1];
                    break;
                case 1:
                    /*! Production::    expression : math_expression EOF */ // default action (generated by JISON mode classic/merge :: 2,VT,VA,-,-,-,-,-,-):
                    this.$ = yyvstack[yysp - 1];
                    // END of default action (generated by JISON mode classic/merge :: 2,VT,VA,-,-,-,-,-,-)
                    return yyvstack[yysp - 1];
                case 2:
                /*! Production::    math_expression : math_expression ADD math_expression */ case 3:
                /*! Production::    math_expression : math_expression SUB math_expression */ case 4:
                /*! Production::    math_expression : math_expression MUL math_expression */ case 5:
                    /*! Production::    math_expression : math_expression DIV math_expression */ this.$ = {
                        type: 'MathExpression',
                        operator: yyvstack[yysp - 1],
                        left: yyvstack[yysp - 2],
                        right: yyvstack[yysp]
                    };
                    break;
                case 6:
                    /*! Production::    math_expression : LPAREN math_expression RPAREN */ this.$ = yyvstack[yysp - 1];
                    break;
                case 7:
                    /*! Production::    math_expression : NESTED_CALC LPAREN math_expression RPAREN */ this.$ = {
                        type: 'Calc',
                        value: yyvstack[yysp - 1]
                    };
                    break;
                case 8:
                    /*! Production::    math_expression : SUB PREFIX SUB NESTED_CALC LPAREN math_expression RPAREN */ this.$ = {
                        type: 'Calc',
                        value: yyvstack[yysp - 1],
                        prefix: yyvstack[yysp - 5]
                    };
                    break;
                case 9:
                /*! Production::    math_expression : css_variable */ case 10:
                /*! Production::    math_expression : css_value */ case 11:
                    /*! Production::    math_expression : value */ this.$ = yyvstack[yysp];
                    break;
                case 12:
                    /*! Production::    value : NUMBER */ this.$ = {
                        type: 'Value',
                        value: parseFloat(yyvstack[yysp])
                    };
                    break;
                case 13:
                    /*! Production::    value : SUB NUMBER */ this.$ = {
                        type: 'Value',
                        value: parseFloat(yyvstack[yysp]) * -1
                    };
                    break;
                case 14:
                    /*! Production::    css_variable : CSS_VAR LPAREN CSS_CPROP RPAREN */ this.$ = {
                        type: 'CssVariable',
                        value: yyvstack[yysp - 1]
                    };
                    break;
                case 15:
                    /*! Production::    css_variable : CSS_VAR LPAREN CSS_CPROP COMMA math_expression RPAREN */ this.$ = {
                        type: 'CssVariable',
                        value: yyvstack[yysp - 3],
                        fallback: yyvstack[yysp - 1]
                    };
                    break;
                case 16:
                    /*! Production::    css_value : LENGTH */ this.$ = {
                        type: 'LengthValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 17:
                    /*! Production::    css_value : ANGLE */ this.$ = {
                        type: 'AngleValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 18:
                    /*! Production::    css_value : TIME */ this.$ = {
                        type: 'TimeValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 19:
                    /*! Production::    css_value : FREQ */ this.$ = {
                        type: 'FrequencyValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 20:
                    /*! Production::    css_value : RES */ this.$ = {
                        type: 'ResolutionValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 21:
                    /*! Production::    css_value : EMS */ this.$ = {
                        type: 'EmValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'em'
                    };
                    break;
                case 22:
                    /*! Production::    css_value : EXS */ this.$ = {
                        type: 'ExValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'ex'
                    };
                    break;
                case 23:
                    /*! Production::    css_value : CHS */ this.$ = {
                        type: 'ChValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'ch'
                    };
                    break;
                case 24:
                    /*! Production::    css_value : REMS */ this.$ = {
                        type: 'RemValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'rem'
                    };
                    break;
                case 25:
                    /*! Production::    css_value : VHS */ this.$ = {
                        type: 'VhValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'vh'
                    };
                    break;
                case 26:
                    /*! Production::    css_value : VWS */ this.$ = {
                        type: 'VwValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'vw'
                    };
                    break;
                case 27:
                    /*! Production::    css_value : VMINS */ this.$ = {
                        type: 'VminValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'vmin'
                    };
                    break;
                case 28:
                    /*! Production::    css_value : VMAXS */ this.$ = {
                        type: 'VmaxValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'vmax'
                    };
                    break;
                case 29:
                    /*! Production::    css_value : PERCENTAGE */ this.$ = {
                        type: 'PercentageValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: '%'
                    };
                    break;
                case 30:
                    /*! Production::    css_value : SUB css_value */ var prev = yyvstack[yysp];
                    prev.value *= -1;
                    this.$ = prev;
                    break;
            }
        },
        table: bt({
            len: u([
                24,
                1,
                5,
                23,
                1,
                18,
                s,
                [
                    0,
                    3
                ],
                1,
                s,
                [
                    0,
                    16
                ],
                s,
                [
                    23,
                    4
                ],
                c,
                [
                    28,
                    3
                ],
                0,
                0,
                16,
                1,
                6,
                6,
                s,
                [
                    0,
                    3
                ],
                5,
                1,
                2,
                c,
                [
                    37,
                    3
                ],
                c,
                [
                    20,
                    3
                ],
                5,
                0,
                0
            ]),
            symbol: u([
                4,
                7,
                9,
                11,
                12,
                s,
                [
                    15,
                    19,
                    1
                ],
                1,
                1,
                s,
                [
                    3,
                    4,
                    1
                ],
                c,
                [
                    30,
                    19
                ],
                c,
                [
                    29,
                    4
                ],
                7,
                4,
                10,
                11,
                c,
                [
                    22,
                    14
                ],
                c,
                [
                    19,
                    3
                ],
                c,
                [
                    43,
                    22
                ],
                c,
                [
                    23,
                    69
                ],
                c,
                [
                    139,
                    4
                ],
                8,
                c,
                [
                    51,
                    24
                ],
                4,
                c,
                [
                    138,
                    15
                ],
                13,
                c,
                [
                    186,
                    5
                ],
                8,
                c,
                [
                    6,
                    6
                ],
                c,
                [
                    5,
                    5
                ],
                9,
                8,
                14,
                c,
                [
                    159,
                    47
                ],
                c,
                [
                    60,
                    10
                ]
            ]),
            type: u([
                s,
                [
                    2,
                    19
                ],
                s,
                [
                    0,
                    5
                ],
                1,
                s,
                [
                    2,
                    24
                ],
                s,
                [
                    0,
                    4
                ],
                c,
                [
                    22,
                    19
                ],
                c,
                [
                    43,
                    42
                ],
                c,
                [
                    23,
                    70
                ],
                c,
                [
                    28,
                    25
                ],
                c,
                [
                    45,
                    25
                ],
                c,
                [
                    113,
                    54
                ]
            ]),
            state: u([
                1,
                2,
                8,
                6,
                7,
                30,
                c,
                [
                    4,
                    3
                ],
                33,
                37,
                c,
                [
                    5,
                    3
                ],
                38,
                c,
                [
                    4,
                    3
                ],
                39,
                c,
                [
                    4,
                    3
                ],
                40,
                c,
                [
                    4,
                    3
                ],
                42,
                c,
                [
                    21,
                    4
                ],
                50,
                c,
                [
                    5,
                    3
                ],
                51,
                c,
                [
                    4,
                    3
                ]
            ]),
            mode: u([
                s,
                [
                    1,
                    179
                ],
                s,
                [
                    2,
                    3
                ],
                c,
                [
                    5,
                    5
                ],
                c,
                [
                    6,
                    4
                ],
                s,
                [
                    1,
                    57
                ]
            ]),
            goto: u([
                5,
                3,
                4,
                24,
                s,
                [
                    9,
                    15,
                    1
                ],
                s,
                [
                    25,
                    5,
                    1
                ],
                c,
                [
                    24,
                    19
                ],
                31,
                35,
                32,
                34,
                c,
                [
                    18,
                    14
                ],
                36,
                c,
                [
                    38,
                    19
                ],
                c,
                [
                    19,
                    57
                ],
                c,
                [
                    118,
                    4
                ],
                41,
                c,
                [
                    24,
                    19
                ],
                43,
                35,
                c,
                [
                    16,
                    14
                ],
                44,
                s,
                [
                    2,
                    3
                ],
                28,
                29,
                2,
                s,
                [
                    3,
                    3
                ],
                28,
                29,
                3,
                c,
                [
                    53,
                    4
                ],
                s,
                [
                    45,
                    5,
                    1
                ],
                c,
                [
                    100,
                    42
                ],
                52,
                c,
                [
                    5,
                    4
                ],
                53
            ])
        }),
        defaultActions: bda({
            idx: u([
                6,
                7,
                8,
                s,
                [
                    10,
                    16,
                    1
                ],
                33,
                34,
                39,
                40,
                41,
                45,
                47,
                52,
                53
            ]),
            goto: u([
                9,
                10,
                11,
                s,
                [
                    16,
                    14,
                    1
                ],
                12,
                1,
                30,
                13,
                s,
                [
                    4,
                    4,
                    1
                ],
                14,
                15,
                8
            ])
        }),
        parseError: function parseError(str, hash, ExceptionClass) {
            if (hash.recoverable) {
                if (typeof this.trace === 'function') this.trace(str);
                hash.destroy(); // destroy... well, *almost*!
            } else {
                if (typeof this.trace === 'function') this.trace(str);
                if (!ExceptionClass) ExceptionClass = this.JisonParserError;
                throw new ExceptionClass(str, hash);
            }
        },
        parse: function parse(input) {
            var self = this;
            var stack = new Array(128); // token stack: stores token which leads to state at the same index (column storage)
            var sstack = new Array(128); // state stack: stores states (column storage)
            var vstack = new Array(128); // semantic value stack
            var table = this.table;
            var sp = 0; // 'stack pointer': index into the stacks
            var symbol = 0;
            var TERROR = this.TERROR;
            var EOF = this.EOF;
            var ERROR_RECOVERY_TOKEN_DISCARD_COUNT = this.options.errorRecoveryTokenDiscardCount | 0 || 3;
            var NO_ACTION = [
                0,
                54 /* === table.length :: ensures that anyone using this new state will fail dramatically! */ 
            ];
            var lexer;
            if (this.__lexer__) lexer = this.__lexer__;
            else lexer = this.__lexer__ = Object.create(this.lexer);
            var sharedState_yy = {
                parseError: undefined,
                quoteName: undefined,
                lexer: undefined,
                parser: undefined,
                pre_parse: undefined,
                post_parse: undefined,
                pre_lex: undefined,
                post_lex: undefined // WARNING: must be written this way for the code expanders to work correctly in both ES5 and ES6 modes!
            };
            var ASSERT;
            if (typeof assert !== 'function') ASSERT = function JisonAssert(cond, msg) {
                if (!cond) throw new Error('assertion failed: ' + (msg || '***'));
            };
            else ASSERT = assert;
            this.yyGetSharedState = function yyGetSharedState() {
                return sharedState_yy;
            };
            function shallow_copy_noclobber(dst, src) {
                for(var k in src)if (typeof dst[k] === 'undefined' && Object.prototype.hasOwnProperty.call(src, k)) dst[k] = src[k];
            }
            // copy state
            shallow_copy_noclobber(sharedState_yy, this.yy);
            sharedState_yy.lexer = lexer;
            sharedState_yy.parser = this;
            // Does the shared state override the default `parseError` that already comes with this instance?
            if (typeof sharedState_yy.parseError === 'function') this.parseError = function parseErrorAlt(str, hash, ExceptionClass) {
                if (!ExceptionClass) ExceptionClass = this.JisonParserError;
                return sharedState_yy.parseError.call(this, str, hash, ExceptionClass);
            };
            else this.parseError = this.originalParseError;
            // Does the shared state override the default `quoteName` that already comes with this instance?
            if (typeof sharedState_yy.quoteName === 'function') this.quoteName = function quoteNameAlt(id_str) {
                return sharedState_yy.quoteName.call(this, id_str);
            };
            else this.quoteName = this.originalQuoteName;
            // set up the cleanup function; make it an API so that external code can re-use this one in case of
            // calamities or when the `%options no-try-catch` option has been specified for the grammar, in which
            // case this parse() API method doesn't come with a `finally { ... }` block any more!
            //
            // NOTE: as this API uses parse() as a closure, it MUST be set again on every parse() invocation,
            //       or else your `sharedState`, etc. references will be *wrong*!
            this.cleanupAfterParse = function parser_cleanupAfterParse(resultValue, invoke_post_methods, do_not_nuke_errorinfos) {
                var rv;
                if (invoke_post_methods) {
                    var hash;
                    if (sharedState_yy.post_parse || this.post_parse) // create an error hash info instance: we re-use this API in a **non-error situation**
                    // as this one delivers all parser internals ready for access by userland code.
                    hash = this.constructParseErrorInfo(null, null, null, false);
                    if (sharedState_yy.post_parse) {
                        rv = sharedState_yy.post_parse.call(this, sharedState_yy, resultValue, hash);
                        if (typeof rv !== 'undefined') resultValue = rv;
                    }
                    if (this.post_parse) {
                        rv = this.post_parse.call(this, sharedState_yy, resultValue, hash);
                        if (typeof rv !== 'undefined') resultValue = rv;
                    }
                    // cleanup:
                    if (hash && hash.destroy) hash.destroy();
                }
                if (this.__reentrant_call_depth > 1) return resultValue; // do not (yet) kill the sharedState when this is a reentrant run.
                // clean up the lingering lexer structures as well:
                if (lexer.cleanupAfterLex) lexer.cleanupAfterLex(do_not_nuke_errorinfos);
                // prevent lingering circular references from causing memory leaks:
                if (sharedState_yy) {
                    sharedState_yy.lexer = undefined;
                    sharedState_yy.parser = undefined;
                    if (lexer.yy === sharedState_yy) lexer.yy = undefined;
                }
                sharedState_yy = undefined;
                this.parseError = this.originalParseError;
                this.quoteName = this.originalQuoteName;
                // nuke the vstack[] array at least as that one will still reference obsoleted user values.
                // To be safe, we nuke the other internal stack columns as well...
                stack.length = 0; // fastest way to nuke an array without overly bothering the GC
                sstack.length = 0;
                vstack.length = 0;
                sp = 0;
                // nuke the error hash info instances created during this run.
                // Userland code must COPY any data/references
                // in the error hash instance(s) it is more permanently interested in.
                if (!do_not_nuke_errorinfos) {
                    for(var i = this.__error_infos.length - 1; i >= 0; i--){
                        var el = this.__error_infos[i];
                        if (el && typeof el.destroy === 'function') el.destroy();
                    }
                    this.__error_infos.length = 0;
                }
                return resultValue;
            };
            // NOTE: as this API uses parse() as a closure, it MUST be set again on every parse() invocation,
            //       or else your `lexer`, `sharedState`, etc. references will be *wrong*!
            this.constructParseErrorInfo = function parser_constructParseErrorInfo(msg, ex, expected, recoverable) {
                var pei = {
                    errStr: msg,
                    exception: ex,
                    text: lexer.match,
                    value: lexer.yytext,
                    token: this.describeSymbol(symbol) || symbol,
                    token_id: symbol,
                    line: lexer.yylineno,
                    expected: expected,
                    recoverable: recoverable,
                    state: state,
                    action: action,
                    new_state: newState,
                    symbol_stack: stack,
                    state_stack: sstack,
                    value_stack: vstack,
                    stack_pointer: sp,
                    yy: sharedState_yy,
                    lexer: lexer,
                    parser: this,
                    // and make sure the error info doesn't stay due to potential
                    // ref cycle via userland code manipulations.
                    // These would otherwise all be memory leak opportunities!
                    //
                    // Note that only array and object references are nuked as those
                    // constitute the set of elements which can produce a cyclic ref.
                    // The rest of the members is kept intact as they are harmless.
                    destroy: function destructParseErrorInfo() {
                        // remove cyclic references added to error info:
                        // info.yy = null;
                        // info.lexer = null;
                        // info.value = null;
                        // info.value_stack = null;
                        // ...
                        var rec = !!this.recoverable;
                        for(var key in this)if (this.hasOwnProperty(key) && typeof key === 'object') this[key] = undefined;
                        this.recoverable = rec;
                    }
                };
                // track this instance so we can `destroy()` it once we deem it superfluous and ready for garbage collection!
                this.__error_infos.push(pei);
                return pei;
            };
            function getNonTerminalFromCode(symbol) {
                var tokenName = self.getSymbolName(symbol);
                if (!tokenName) tokenName = symbol;
                return tokenName;
            }
            function stdLex() {
                var token = lexer.lex();
                // if token isn't its numeric value, convert
                if (typeof token !== 'number') token = self.symbols_[token] || token;
                return token || EOF;
            }
            function fastLex() {
                var token = lexer.fastLex();
                // if token isn't its numeric value, convert
                if (typeof token !== 'number') token = self.symbols_[token] || token;
                return token || EOF;
            }
            var lex = stdLex;
            var state, action, r, t;
            var yyval = {
                $: true,
                _$: undefined,
                yy: sharedState_yy
            };
            var p;
            var yyrulelen;
            var this_production;
            var newState;
            var retval = false;
            try {
                this.__reentrant_call_depth++;
                lexer.setInput(input, sharedState_yy);
                // NOTE: we *assume* no lexer pre/post handlers are set up *after* 
                // this initial `setInput()` call: hence we can now check and decide
                // whether we'll go with the standard, slower, lex() API or the
                // `fast_lex()` one:
                if (typeof lexer.canIUse === 'function') {
                    var lexerInfo = lexer.canIUse();
                    if (lexerInfo.fastLex && typeof fastLex === 'function') lex = fastLex;
                }
                vstack[sp] = null;
                sstack[sp] = 0;
                stack[sp] = 0;
                ++sp;
                if (this.pre_parse) this.pre_parse.call(this, sharedState_yy);
                if (sharedState_yy.pre_parse) sharedState_yy.pre_parse.call(this, sharedState_yy);
                newState = sstack[sp - 1];
                for(;;){
                    // retrieve state number from top of stack
                    state = newState; // sstack[sp - 1];
                    // use default actions if available
                    if (this.defaultActions[state]) {
                        action = 2;
                        newState = this.defaultActions[state];
                    } else {
                        // The single `==` condition below covers both these `===` comparisons in a single
                        // operation:
                        //
                        //     if (symbol === null || typeof symbol === 'undefined') ...
                        if (!symbol) symbol = lex();
                        // read action for current state and first input
                        t = table[state] && table[state][symbol] || NO_ACTION;
                        newState = t[1];
                        action = t[0];
                        // handle parse error
                        if (!action) {
                            var errStr;
                            var errSymbolDescr = this.describeSymbol(symbol) || symbol;
                            var expected = this.collect_expected_token_set(state);
                            // Report error
                            if (typeof lexer.yylineno === 'number') errStr = 'Parse error on line ' + (lexer.yylineno + 1) + ': ';
                            else errStr = 'Parse error: ';
                            if (typeof lexer.showPosition === 'function') errStr += '\n' + lexer.showPosition(69, 10) + '\n';
                            if (expected.length) errStr += 'Expecting ' + expected.join(', ') + ', got unexpected ' + errSymbolDescr;
                            else errStr += 'Unexpected ' + errSymbolDescr;
                            // we cannot recover from the error!
                            p = this.constructParseErrorInfo(errStr, null, expected, false);
                            r = this.parseError(p.errStr, p, this.JisonParserError);
                            if (typeof r !== 'undefined') retval = r;
                            break;
                        }
                    }
                    switch(action){
                        // catch misc. parse failures:
                        default:
                            // this shouldn't happen, unless resolve defaults are off
                            if (action instanceof Array) {
                                p = this.constructParseErrorInfo('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol, null, null, false);
                                r = this.parseError(p.errStr, p, this.JisonParserError);
                                if (typeof r !== 'undefined') retval = r;
                                break;
                            }
                            // Another case of better safe than sorry: in case state transitions come out of another error recovery process
                            // or a buggy LUT (LookUp Table):
                            p = this.constructParseErrorInfo('Parsing halted. No viable error recovery approach available due to internal system failure.', null, null, false);
                            r = this.parseError(p.errStr, p, this.JisonParserError);
                            if (typeof r !== 'undefined') retval = r;
                            break;
                        // shift:
                        case 1:
                            stack[sp] = symbol;
                            vstack[sp] = lexer.yytext;
                            sstack[sp] = newState; // push state
                            ++sp;
                            symbol = 0;
                            continue;
                        // reduce:
                        case 2:
                            this_production = this.productions_[newState - 1]; // `this.productions_[]` is zero-based indexed while states start from 1 upwards...
                            yyrulelen = this_production[1];
                            r = this.performAction.call(yyval, newState, sp - 1, vstack);
                            if (typeof r !== 'undefined') {
                                retval = r;
                                break;
                            }
                            // pop off stack
                            sp -= yyrulelen;
                            // don't overwrite the `symbol` variable: use a local var to speed things up:
                            var ntsymbol = this_production[0]; // push nonterminal (reduce)
                            stack[sp] = ntsymbol;
                            vstack[sp] = yyval.$;
                            // goto new state = table[STATE][NONTERMINAL]
                            newState = table[sstack[sp - 1]][ntsymbol];
                            sstack[sp] = newState;
                            ++sp;
                            continue;
                        // accept:
                        case 3:
                            if (sp !== -2) {
                                retval = true;
                                // Return the `$accept` rule's `$$` result, if available.
                                //
                                // Also note that JISON always adds this top-most `$accept` rule (with implicit,
                                // default, action):
                                //
                                //     $accept: <startSymbol> $end
                                //                  %{ $$ = $1; @$ = @1; %}
                                //
                                // which, combined with the parse kernel's `$accept` state behaviour coded below,
                                // will produce the `$$` value output of the <startSymbol> rule as the parse result,
                                // IFF that result is *not* `undefined`. (See also the parser kernel code.)
                                //
                                // In code:
                                //
                                //                  %{
                                //                      @$ = @1;            // if location tracking support is included
                                //                      if (typeof $1 !== 'undefined')
                                //                          return $1;
                                //                      else
                                //                          return true;           // the default parse result if the rule actions don't produce anything
                                //                  %}
                                sp--;
                                if (typeof vstack[sp] !== 'undefined') retval = vstack[sp];
                            }
                            break;
                    }
                    break;
                }
            } catch (ex) {
                // report exceptions through the parseError callback too, but keep the exception intact
                // if it is a known parser or lexer error which has been thrown by parseError() already:
                if (ex instanceof this.JisonParserError) throw ex;
                else if (lexer && typeof lexer.JisonLexerError === 'function' && ex instanceof lexer.JisonLexerError) throw ex;
                p = this.constructParseErrorInfo('Parsing aborted due to exception.', ex, null, false);
                retval = false;
                r = this.parseError(p.errStr, p, this.JisonParserError);
                if (typeof r !== 'undefined') retval = r;
            } finally{
                retval = this.cleanupAfterParse(retval, true, true);
                this.__reentrant_call_depth--;
            } // /finally
            return retval;
        }
    };
    parser.originalParseError = parser.parseError;
    parser.originalQuoteName = parser.quoteName;
    /* lexer generated by jison-lex 0.6.1-215 */ /*
 * Returns a Lexer object of the following structure:
 *
 *  Lexer: {
 *    yy: {}     The so-called "shared state" or rather the *source* of it;
 *               the real "shared state" `yy` passed around to
 *               the rule actions, etc. is a direct reference!
 *
 *               This "shared context" object was passed to the lexer by way of 
 *               the `lexer.setInput(str, yy)` API before you may use it.
 *
 *               This "shared context" object is passed to the lexer action code in `performAction()`
 *               so userland code in the lexer actions may communicate with the outside world 
 *               and/or other lexer rules' actions in more or less complex ways.
 *
 *  }
 *
 *  Lexer.prototype: {
 *    EOF: 1,
 *    ERROR: 2,
 *
 *    yy:        The overall "shared context" object reference.
 *
 *    JisonLexerError: function(msg, hash),
 *
 *    performAction: function lexer__performAction(yy, yyrulenumber, YY_START),
 *
 *               The function parameters and `this` have the following value/meaning:
 *               - `this`    : reference to the `lexer` instance. 
 *                               `yy_` is an alias for `this` lexer instance reference used internally.
 *
 *               - `yy`      : a reference to the `yy` "shared state" object which was passed to the lexer
 *                             by way of the `lexer.setInput(str, yy)` API before.
 *
 *                             Note:
 *                             The extra arguments you specified in the `%parse-param` statement in your
 *                             **parser** grammar definition file are passed to the lexer via this object
 *                             reference as member variables.
 *
 *               - `yyrulenumber`   : index of the matched lexer rule (regex), used internally.
 *
 *               - `YY_START`: the current lexer "start condition" state.
 *
 *    parseError: function(str, hash, ExceptionClass),
 *
 *    constructLexErrorInfo: function(error_message, is_recoverable),
 *               Helper function.
 *               Produces a new errorInfo 'hash object' which can be passed into `parseError()`.
 *               See it's use in this lexer kernel in many places; example usage:
 *
 *                   var infoObj = lexer.constructParseErrorInfo('fail!', true);
 *                   var retVal = lexer.parseError(infoObj.errStr, infoObj, lexer.JisonLexerError);
 *
 *    options: { ... lexer %options ... },
 *
 *    lex: function(),
 *               Produce one token of lexed input, which was passed in earlier via the `lexer.setInput()` API.
 *               You MAY use the additional `args...` parameters as per `%parse-param` spec of the **lexer** grammar:
 *               these extra `args...` are added verbatim to the `yy` object reference as member variables.
 *
 *               WARNING:
 *               Lexer's additional `args...` parameters (via lexer's `%parse-param`) MAY conflict with
 *               any attributes already added to `yy` by the **parser** or the jison run-time; 
 *               when such a collision is detected an exception is thrown to prevent the generated run-time 
 *               from silently accepting this confusing and potentially hazardous situation! 
 *
 *    cleanupAfterLex: function(do_not_nuke_errorinfos),
 *               Helper function.
 *
 *               This helper API is invoked when the **parse process** has completed: it is the responsibility
 *               of the **parser** (or the calling userland code) to invoke this method once cleanup is desired. 
 *
 *               This helper may be invoked by user code to ensure the internal lexer gets properly garbage collected.
 *
 *    setInput: function(input, [yy]),
 *
 *
 *    input: function(),
 *
 *
 *    unput: function(str),
 *
 *
 *    more: function(),
 *
 *
 *    reject: function(),
 *
 *
 *    less: function(n),
 *
 *
 *    pastInput: function(n),
 *
 *
 *    upcomingInput: function(n),
 *
 *
 *    showPosition: function(),
 *
 *
 *    test_match: function(regex_match_array, rule_index),
 *
 *
 *    next: function(),
 *
 *
 *    begin: function(condition),
 *
 *
 *    pushState: function(condition),
 *
 *
 *    popState: function(),
 *
 *
 *    topState: function(),
 *
 *
 *    _currentRules: function(),
 *
 *
 *    stateStackSize: function(),
 *
 *
 *    performAction: function(yy, yy_, yyrulenumber, YY_START),
 *
 *
 *    rules: [...],
 *
 *
 *    conditions: {associative list: name ==> set},
 *  }
 *
 *
 *  token location info (`yylloc`): {
 *    first_line: n,
 *    last_line: n,
 *    first_column: n,
 *    last_column: n,
 *    range: [start_number, end_number]
 *               (where the numbers are indexes into the input string, zero-based)
 *  }
 *
 * ---
 *
 * The `parseError` function receives a 'hash' object with these members for lexer errors:
 *
 *  {
 *    text:        (matched text)
 *    token:       (the produced terminal token, if any)
 *    token_id:    (the produced terminal token numeric ID, if any)
 *    line:        (yylineno)
 *    loc:         (yylloc)
 *    recoverable: (boolean: TRUE when the parser MAY have an error recovery rule
 *                  available for this particular error)
 *    yy:          (object: the current parser internal "shared state" `yy`
 *                  as is also available in the rule actions; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    lexer:       (reference to the current lexer instance used by the parser)
 *  }
 *
 * while `this` will reference the current lexer instance.
 *
 * When `parseError` is invoked by the lexer, the default implementation will
 * attempt to invoke `yy.parser.parseError()`; when this callback is not provided
 * it will try to invoke `yy.parseError()` instead. When that callback is also not
 * provided, a `JisonLexerError` exception will be thrown containing the error
 * message and `hash`, as constructed by the `constructLexErrorInfo()` API.
 *
 * Note that the lexer's `JisonLexerError` error class is passed via the
 * `ExceptionClass` argument, which is invoked to construct the exception
 * instance to be thrown, so technically `parseError` will throw the object
 * produced by the `new ExceptionClass(str, hash)` JavaScript expression.
 *
 * ---
 *
 * You can specify lexer options by setting / modifying the `.options` object of your Lexer instance.
 * These options are available:
 *
 * (Options are permanent.)
 *  
 *  yy: {
 *      parseError: function(str, hash, ExceptionClass)
 *                 optional: overrides the default `parseError` function.
 *  }
 *
 *  lexer.options: {
 *      pre_lex:  function()
 *                 optional: is invoked before the lexer is invoked to produce another token.
 *                 `this` refers to the Lexer object.
 *      post_lex: function(token) { return token; }
 *                 optional: is invoked when the lexer has produced a token `token`;
 *                 this function can override the returned token value by returning another.
 *                 When it does not return any (truthy) value, the lexer will return
 *                 the original `token`.
 *                 `this` refers to the Lexer object.
 *
 * WARNING: the next set of options are not meant to be changed. They echo the abilities of
 * the lexer as per when it was compiled!
 *
 *      ranges: boolean
 *                 optional: `true` ==> token location info will include a .range[] member.
 *      flex: boolean
 *                 optional: `true` ==> flex-like lexing behaviour where the rules are tested
 *                 exhaustively to find the longest match.
 *      backtrack_lexer: boolean
 *                 optional: `true` ==> lexer regexes are tested in order and for invoked;
 *                 the lexer terminates the scan when a token is returned by the action code.
 *      xregexp: boolean
 *                 optional: `true` ==> lexer rule regexes are "extended regex format" requiring the
 *                 `XRegExp` library. When this %option has not been specified at compile time, all lexer
 *                 rule regexes have been written as standard JavaScript RegExp expressions.
 *  }
 */ var lexer = function() {
        /**
   * See also:
   * http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript/#35881508
   * but we keep the prototype.constructor and prototype.name assignment lines too for compatibility
   * with userland code which might access the derived class in a 'classic' way.
   *
   * @public
   * @constructor
   * @nocollapse
   */ function JisonLexerError(msg, hash) {
            Object.defineProperty(this, 'name', {
                enumerable: false,
                writable: false,
                value: 'JisonLexerError'
            });
            if (msg == null) msg = '???';
            Object.defineProperty(this, 'message', {
                enumerable: false,
                writable: true,
                value: msg
            });
            this.hash = hash;
            var stacktrace;
            if (hash && hash.exception instanceof Error) {
                var ex2 = hash.exception;
                this.message = ex2.message || msg;
                stacktrace = ex2.stack;
            }
            if (!stacktrace) {
                if (Error.hasOwnProperty('captureStackTrace')) // V8
                Error.captureStackTrace(this, this.constructor);
                else stacktrace = new Error(msg).stack;
            }
            if (stacktrace) Object.defineProperty(this, 'stack', {
                enumerable: false,
                writable: false,
                value: stacktrace
            });
        }
        if (typeof Object.setPrototypeOf === 'function') Object.setPrototypeOf(JisonLexerError.prototype, Error.prototype);
        else JisonLexerError.prototype = Object.create(Error.prototype);
        JisonLexerError.prototype.constructor = JisonLexerError;
        JisonLexerError.prototype.name = 'JisonLexerError';
        var lexer = {
            // Code Generator Information Report
            // ---------------------------------
            //
            // Options:
            //
            //   backtracking: .................... false
            //   location.ranges: ................. false
            //   location line+column tracking: ... true
            //
            //
            // Forwarded Parser Analysis flags:
            //
            //   uses yyleng: ..................... false
            //   uses yylineno: ................... false
            //   uses yytext: ..................... false
            //   uses yylloc: ..................... false
            //   uses lexer values: ............... true / true
            //   location tracking: ............... false
            //   location assignment: ............. false
            //
            //
            // Lexer Analysis flags:
            //
            //   uses yyleng: ..................... ???
            //   uses yylineno: ................... ???
            //   uses yytext: ..................... ???
            //   uses yylloc: ..................... ???
            //   uses ParseError API: ............. ???
            //   uses yyerror: .................... ???
            //   uses location tracking & editing:  ???
            //   uses more() API: ................. ???
            //   uses unput() API: ................ ???
            //   uses reject() API: ............... ???
            //   uses less() API: ................. ???
            //   uses display APIs pastInput(), upcomingInput(), showPosition():
            //        ............................. ???
            //   uses describeYYLLOC() API: ....... ???
            //
            // --------- END OF REPORT -----------
            EOF: 1,
            ERROR: 2,
            // JisonLexerError: JisonLexerError,        /// <-- injected by the code generator
            // options: {},                             /// <-- injected by the code generator
            // yy: ...,                                 /// <-- injected by setInput()
            __currentRuleSet__: null,
            __error_infos: [],
            __decompressed: false,
            done: false,
            _backtrack: false,
            _input: '',
            _more: false,
            _signaled_error_token: false,
            conditionStack: [],
            match: '',
            matched: '',
            matches: false,
            yytext: '',
            offset: 0,
            yyleng: 0,
            yylineno: 0,
            yylloc: null,
            /**
     * INTERNAL USE: construct a suitable error info hash object instance for `parseError`.
     * 
     * @public
     * @this {RegExpLexer}
     */ constructLexErrorInfo: function lexer_constructLexErrorInfo(msg, recoverable, show_input_position) {
                msg = '' + msg;
                // heuristic to determine if the error message already contains a (partial) source code dump
                // as produced by either `showPosition()` or `prettyPrintRange()`:
                if (show_input_position == undefined) show_input_position = !(msg.indexOf('\n') > 0 && msg.indexOf('^') > 0);
                if (this.yylloc && show_input_position) {
                    if (typeof this.prettyPrintRange === 'function') {
                        var pretty_src = this.prettyPrintRange(this.yylloc);
                        if (!/\n\s*$/.test(msg)) msg += '\n';
                        msg += '\n  Erroneous area:\n' + this.prettyPrintRange(this.yylloc);
                    } else if (typeof this.showPosition === 'function') {
                        var pos_str = this.showPosition();
                        if (pos_str) {
                            if (msg.length && msg[msg.length - 1] !== '\n' && pos_str[0] !== '\n') msg += '\n' + pos_str;
                            else msg += pos_str;
                        }
                    }
                }
                /** @constructor */ var pei = {
                    errStr: msg,
                    recoverable: !!recoverable,
                    text: this.match,
                    token: null,
                    line: this.yylineno,
                    loc: this.yylloc,
                    yy: this.yy,
                    lexer: this,
                    /**
         * and make sure the error info doesn't stay due to potential
         * ref cycle via userland code manipulations.
         * These would otherwise all be memory leak opportunities!
         * 
         * Note that only array and object references are nuked as those
         * constitute the set of elements which can produce a cyclic ref.
         * The rest of the members is kept intact as they are harmless.
         * 
         * @public
         * @this {LexErrorInfo}
         */ destroy: function destructLexErrorInfo() {
                        // remove cyclic references added to error info:
                        // info.yy = null;
                        // info.lexer = null;
                        // ...
                        var rec = !!this.recoverable;
                        for(var key in this)if (this.hasOwnProperty(key) && typeof key === 'object') this[key] = undefined;
                        this.recoverable = rec;
                    }
                };
                // track this instance so we can `destroy()` it once we deem it superfluous and ready for garbage collection!
                this.__error_infos.push(pei);
                return pei;
            },
            /**
     * handler which is invoked when a lexer error occurs.
     * 
     * @public
     * @this {RegExpLexer}
     */ parseError: function lexer_parseError(str, hash, ExceptionClass) {
                if (!ExceptionClass) ExceptionClass = this.JisonLexerError;
                if (this.yy) {
                    if (this.yy.parser && typeof this.yy.parser.parseError === 'function') return this.yy.parser.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
                    else if (typeof this.yy.parseError === 'function') return this.yy.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
                }
                throw new ExceptionClass(str, hash);
            },
            /**
     * method which implements `yyerror(str, ...args)` functionality for use inside lexer actions.
     * 
     * @public
     * @this {RegExpLexer}
     */ yyerror: function yyError(str /*, ...args */ ) {
                var lineno_msg = '';
                if (this.yylloc) lineno_msg = ' on line ' + (this.yylineno + 1);
                var p = this.constructLexErrorInfo('Lexical error' + lineno_msg + ': ' + str, this.options.lexerErrorsAreRecoverable);
                // Add any extra args to the hash under the name `extra_error_attributes`:
                var args = Array.prototype.slice.call(arguments, 1);
                if (args.length) p.extra_error_attributes = args;
                return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
            },
            /**
     * final cleanup function for when we have completed lexing the input;
     * make it an API so that external code can use this one once userland
     * code has decided it's time to destroy any lingering lexer error
     * hash object instances and the like: this function helps to clean
     * up these constructs, which *may* carry cyclic references which would
     * otherwise prevent the instances from being properly and timely
     * garbage-collected, i.e. this function helps prevent memory leaks!
     * 
     * @public
     * @this {RegExpLexer}
     */ cleanupAfterLex: function lexer_cleanupAfterLex(do_not_nuke_errorinfos) {
                // prevent lingering circular references from causing memory leaks:
                this.setInput('', {});
                // nuke the error hash info instances created during this run.
                // Userland code must COPY any data/references
                // in the error hash instance(s) it is more permanently interested in.
                if (!do_not_nuke_errorinfos) {
                    for(var i = this.__error_infos.length - 1; i >= 0; i--){
                        var el = this.__error_infos[i];
                        if (el && typeof el.destroy === 'function') el.destroy();
                    }
                    this.__error_infos.length = 0;
                }
                return this;
            },
            /**
     * clear the lexer token context; intended for internal use only
     * 
     * @public
     * @this {RegExpLexer}
     */ clear: function lexer_clear() {
                this.yytext = '';
                this.yyleng = 0;
                this.match = '';
                // - DO NOT reset `this.matched`
                this.matches = false;
                this._more = false;
                this._backtrack = false;
                var col = this.yylloc ? this.yylloc.last_column : 0;
                this.yylloc = {
                    first_line: this.yylineno + 1,
                    first_column: col,
                    last_line: this.yylineno + 1,
                    last_column: col,
                    range: [
                        this.offset,
                        this.offset
                    ]
                };
            },
            /**
     * resets the lexer, sets new input
     * 
     * @public
     * @this {RegExpLexer}
     */ setInput: function lexer_setInput(input, yy) {
                this.yy = yy || this.yy || {};
                // also check if we've fully initialized the lexer instance,
                // including expansion work to be done to go from a loaded
                // lexer to a usable lexer:
                if (!this.__decompressed) {
                    // step 1: decompress the regex list:
                    var rules = this.rules;
                    for(var i = 0, len = rules.length; i < len; i++){
                        var rule_re = rules[i];
                        // compression: is the RE an xref to another RE slot in the rules[] table?
                        if (typeof rule_re === 'number') rules[i] = rules[rule_re];
                    }
                    // step 2: unfold the conditions[] set to make these ready for use:
                    var conditions = this.conditions;
                    for(var k in conditions){
                        var spec = conditions[k];
                        var rule_ids = spec.rules;
                        var len = rule_ids.length;
                        var rule_regexes = new Array(len + 1); // slot 0 is unused; we use a 1-based index approach here to keep the hottest code in `lexer_next()` fast and simple! 
                        var rule_new_ids = new Array(len + 1);
                        for(var i = 0; i < len; i++){
                            var idx = rule_ids[i];
                            var rule_re = rules[idx];
                            rule_regexes[i + 1] = rule_re;
                            rule_new_ids[i + 1] = idx;
                        }
                        spec.rules = rule_new_ids;
                        spec.__rule_regexes = rule_regexes;
                        spec.__rule_count = len;
                    }
                    this.__decompressed = true;
                }
                this._input = input || '';
                this.clear();
                this._signaled_error_token = false;
                this.done = false;
                this.yylineno = 0;
                this.matched = '';
                this.conditionStack = [
                    'INITIAL'
                ];
                this.__currentRuleSet__ = null;
                this.yylloc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0,
                    range: [
                        0,
                        0
                    ]
                };
                this.offset = 0;
                return this;
            },
            /**
     * edit the remaining input via user-specified callback.
     * This can be used to forward-adjust the input-to-parse, 
     * e.g. inserting macro expansions and alike in the
     * input which has yet to be lexed.
     * The behaviour of this API contrasts the `unput()` et al
     * APIs as those act on the *consumed* input, while this
     * one allows one to manipulate the future, without impacting
     * the current `yyloc` cursor location or any history. 
     * 
     * Use this API to help implement C-preprocessor-like
     * `#include` statements, etc.
     * 
     * The provided callback must be synchronous and is
     * expected to return the edited input (string).
     *
     * The `cpsArg` argument value is passed to the callback
     * as-is.
     *
     * `callback` interface: 
     * `function callback(input, cpsArg)`
     * 
     * - `input` will carry the remaining-input-to-lex string
     *   from the lexer.
     * - `cpsArg` is `cpsArg` passed into this API.
     * 
     * The `this` reference for the callback will be set to
     * reference this lexer instance so that userland code
     * in the callback can easily and quickly access any lexer
     * API. 
     *
     * When the callback returns a non-string-type falsey value,
     * we assume the callback did not edit the input and we
     * will using the input as-is.
     *
     * When the callback returns a non-string-type value, it
     * is converted to a string for lexing via the `"" + retval`
     * operation. (See also why: http://2ality.com/2012/03/converting-to-string.html 
     * -- that way any returned object's `toValue()` and `toString()`
     * methods will be invoked in a proper/desirable order.)
     * 
     * @public
     * @this {RegExpLexer}
     */ editRemainingInput: function lexer_editRemainingInput(callback, cpsArg) {
                var rv = callback.call(this, this._input, cpsArg);
                if (typeof rv !== 'string') {
                    if (rv) this._input = '' + rv;
                } else this._input = rv;
                return this;
            },
            /**
     * consumes and returns one char from the input
     * 
     * @public
     * @this {RegExpLexer}
     */ input: function lexer_input() {
                if (!this._input) //this.done = true;    -- don't set `done` as we want the lex()/next() API to be able to produce one custom EOF token match after this anyhow. (lexer can match special <<EOF>> tokens and perform user action code for a <<EOF>> match, but only does so *once*)
                return null;
                var ch = this._input[0];
                this.yytext += ch;
                this.yyleng++;
                this.offset++;
                this.match += ch;
                this.matched += ch;
                // Count the linenumber up when we hit the LF (or a stand-alone CR).
                // On CRLF, the linenumber is incremented when you fetch the CR or the CRLF combo
                // and we advance immediately past the LF as well, returning both together as if
                // it was all a single 'character' only.
                var slice_len = 1;
                var lines = false;
                if (ch === '\n') lines = true;
                else if (ch === '\r') {
                    lines = true;
                    var ch2 = this._input[1];
                    if (ch2 === '\n') {
                        slice_len++;
                        ch += ch2;
                        this.yytext += ch2;
                        this.yyleng++;
                        this.offset++;
                        this.match += ch2;
                        this.matched += ch2;
                        this.yylloc.range[1]++;
                    }
                }
                if (lines) {
                    this.yylineno++;
                    this.yylloc.last_line++;
                    this.yylloc.last_column = 0;
                } else this.yylloc.last_column++;
                this.yylloc.range[1]++;
                this._input = this._input.slice(slice_len);
                return ch;
            },
            /**
     * unshifts one char (or an entire string) into the input
     * 
     * @public
     * @this {RegExpLexer}
     */ unput: function lexer_unput(ch) {
                var len = ch.length;
                var lines = ch.split(/(?:\r\n?|\n)/g);
                this._input = ch + this._input;
                this.yytext = this.yytext.substr(0, this.yytext.length - len);
                this.yyleng = this.yytext.length;
                this.offset -= len;
                this.match = this.match.substr(0, this.match.length - len);
                this.matched = this.matched.substr(0, this.matched.length - len);
                if (lines.length > 1) {
                    this.yylineno -= lines.length - 1;
                    this.yylloc.last_line = this.yylineno + 1;
                    // Get last entirely matched line into the `pre_lines[]` array's
                    // last index slot; we don't mind when other previously 
                    // matched lines end up in the array too. 
                    var pre = this.match;
                    var pre_lines = pre.split(/(?:\r\n?|\n)/g);
                    if (pre_lines.length === 1) {
                        pre = this.matched;
                        pre_lines = pre.split(/(?:\r\n?|\n)/g);
                    }
                    this.yylloc.last_column = pre_lines[pre_lines.length - 1].length;
                } else this.yylloc.last_column -= len;
                this.yylloc.range[1] = this.yylloc.range[0] + this.yyleng;
                this.done = false;
                return this;
            },
            /**
     * cache matched text and append it on next action
     * 
     * @public
     * @this {RegExpLexer}
     */ more: function lexer_more() {
                this._more = true;
                return this;
            },
            /**
     * signal the lexer that this rule fails to match the input, so the
     * next matching rule (regex) should be tested instead.
     * 
     * @public
     * @this {RegExpLexer}
     */ reject: function lexer_reject() {
                if (this.options.backtrack_lexer) this._backtrack = true;
                else {
                    // when the `parseError()` call returns, we MUST ensure that the error is registered.
                    // We accomplish this by signaling an 'error' token to be produced for the current
                    // `.lex()` run.
                    var lineno_msg = '';
                    if (this.yylloc) lineno_msg = ' on line ' + (this.yylineno + 1);
                    var p = this.constructLexErrorInfo('Lexical error' + lineno_msg + ': You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).', false);
                    this._signaled_error_token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                }
                return this;
            },
            /**
     * retain first n characters of the match
     * 
     * @public
     * @this {RegExpLexer}
     */ less: function lexer_less(n) {
                return this.unput(this.match.slice(n));
            },
            /**
     * return (part of the) already matched input, i.e. for error
     * messages.
     * 
     * Limit the returned string length to `maxSize` (default: 20).
     * 
     * Limit the returned string to the `maxLines` number of lines of
     * input (default: 1).
     * 
     * Negative limit values equal *unlimited*.
     * 
     * @public
     * @this {RegExpLexer}
     */ pastInput: function lexer_pastInput(maxSize, maxLines) {
                var past = this.matched.substring(0, this.matched.length - this.match.length);
                if (maxSize < 0) maxSize = past.length;
                else if (!maxSize) maxSize = 20;
                if (maxLines < 0) maxLines = past.length; // can't ever have more input lines than this! 
                else if (!maxLines) maxLines = 1;
                // `substr` anticipation: treat \r\n as a single character and take a little
                // more than necessary so that we can still properly check against maxSize
                // after we've transformed and limited the newLines in here:
                past = past.substr(-maxSize * 2 - 2);
                // now that we have a significantly reduced string to process, transform the newlines
                // and chop them, then limit them:
                var a = past.replace(/\r\n|\r/g, '\n').split('\n');
                a = a.slice(-maxLines);
                past = a.join('\n');
                // When, after limiting to maxLines, we still have too much to return,
                // do add an ellipsis prefix...
                if (past.length > maxSize) past = '...' + past.substr(-maxSize);
                return past;
            },
            /**
     * return (part of the) upcoming input, i.e. for error messages.
     * 
     * Limit the returned string length to `maxSize` (default: 20).
     * 
     * Limit the returned string to the `maxLines` number of lines of input (default: 1).
     * 
     * Negative limit values equal *unlimited*.
     *
     * > ### NOTE ###
     * >
     * > *"upcoming input"* is defined as the whole of the both
     * > the *currently lexed* input, together with any remaining input
     * > following that. *"currently lexed"* input is the input 
     * > already recognized by the lexer but not yet returned with
     * > the lexer token. This happens when you are invoking this API
     * > from inside any lexer rule action code block. 
     * >
     * 
     * @public
     * @this {RegExpLexer}
     */ upcomingInput: function lexer_upcomingInput(maxSize, maxLines) {
                var next = this.match;
                if (maxSize < 0) maxSize = next.length + this._input.length;
                else if (!maxSize) maxSize = 20;
                if (maxLines < 0) maxLines = maxSize; // can't ever have more input lines than this! 
                else if (!maxLines) maxLines = 1;
                // `substring` anticipation: treat \r\n as a single character and take a little
                // more than necessary so that we can still properly check against maxSize
                // after we've transformed and limited the newLines in here:
                if (next.length < maxSize * 2 + 2) next += this._input.substring(0, maxSize * 2 + 2); // substring is faster on Chrome/V8 
                // now that we have a significantly reduced string to process, transform the newlines
                // and chop them, then limit them:
                var a = next.replace(/\r\n|\r/g, '\n').split('\n');
                a = a.slice(0, maxLines);
                next = a.join('\n');
                // When, after limiting to maxLines, we still have too much to return,
                // do add an ellipsis postfix...
                if (next.length > maxSize) next = next.substring(0, maxSize) + '...';
                return next;
            },
            /**
     * return a string which displays the character position where the
     * lexing error occurred, i.e. for error messages
     * 
     * @public
     * @this {RegExpLexer}
     */ showPosition: function lexer_showPosition(maxPrefix, maxPostfix) {
                var pre = this.pastInput(maxPrefix).replace(/\s/g, ' ');
                var c = new Array(pre.length + 1).join('-');
                return pre + this.upcomingInput(maxPostfix).replace(/\s/g, ' ') + '\n' + c + '^';
            },
            /**
     * return an YYLLOC info object derived off the given context (actual, preceding, following, current).
     * Use this method when the given `actual` location is not guaranteed to exist (i.e. when
     * it MAY be NULL) and you MUST have a valid location info object anyway:
     * then we take the given context of the `preceding` and `following` locations, IFF those are available,
     * and reconstruct the `actual` location info from those.
     * If this fails, the heuristic is to take the `current` location, IFF available.
     * If this fails as well, we assume the sought location is at/around the current lexer position
     * and then produce that one as a response. DO NOTE that these heuristic/derived location info
     * values MAY be inaccurate!
     *
     * NOTE: `deriveLocationInfo()` ALWAYS produces a location info object *copy* of `actual`, not just
     * a *reference* hence all input location objects can be assumed to be 'constant' (function has no side-effects).
     * 
     * @public
     * @this {RegExpLexer}
     */ deriveLocationInfo: function lexer_deriveYYLLOC(actual, preceding, following, current) {
                var loc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0,
                    range: [
                        0,
                        0
                    ]
                };
                if (actual) {
                    loc.first_line = actual.first_line | 0;
                    loc.last_line = actual.last_line | 0;
                    loc.first_column = actual.first_column | 0;
                    loc.last_column = actual.last_column | 0;
                    if (actual.range) {
                        loc.range[0] = actual.range[0] | 0;
                        loc.range[1] = actual.range[1] | 0;
                    }
                }
                if (loc.first_line <= 0 || loc.last_line < loc.first_line) {
                    // plan B: heuristic using preceding and following:
                    if (loc.first_line <= 0 && preceding) {
                        loc.first_line = preceding.last_line | 0;
                        loc.first_column = preceding.last_column | 0;
                        if (preceding.range) loc.range[0] = actual.range[1] | 0;
                    }
                    if ((loc.last_line <= 0 || loc.last_line < loc.first_line) && following) {
                        loc.last_line = following.first_line | 0;
                        loc.last_column = following.first_column | 0;
                        if (following.range) loc.range[1] = actual.range[0] | 0;
                    }
                    // plan C?: see if the 'current' location is useful/sane too:
                    if (loc.first_line <= 0 && current && (loc.last_line <= 0 || current.last_line <= loc.last_line)) {
                        loc.first_line = current.first_line | 0;
                        loc.first_column = current.first_column | 0;
                        if (current.range) loc.range[0] = current.range[0] | 0;
                    }
                    if (loc.last_line <= 0 && current && (loc.first_line <= 0 || current.first_line >= loc.first_line)) {
                        loc.last_line = current.last_line | 0;
                        loc.last_column = current.last_column | 0;
                        if (current.range) loc.range[1] = current.range[1] | 0;
                    }
                }
                // sanitize: fix last_line BEFORE we fix first_line as we use the 'raw' value of the latter
                // or plan D heuristics to produce a 'sensible' last_line value:
                if (loc.last_line <= 0) {
                    if (loc.first_line <= 0) {
                        loc.first_line = this.yylloc.first_line;
                        loc.last_line = this.yylloc.last_line;
                        loc.first_column = this.yylloc.first_column;
                        loc.last_column = this.yylloc.last_column;
                        loc.range[0] = this.yylloc.range[0];
                        loc.range[1] = this.yylloc.range[1];
                    } else {
                        loc.last_line = this.yylloc.last_line;
                        loc.last_column = this.yylloc.last_column;
                        loc.range[1] = this.yylloc.range[1];
                    }
                }
                if (loc.first_line <= 0) {
                    loc.first_line = loc.last_line;
                    loc.first_column = 0; // loc.last_column; 
                    loc.range[1] = loc.range[0];
                }
                if (loc.first_column < 0) loc.first_column = 0;
                if (loc.last_column < 0) loc.last_column = loc.first_column > 0 ? loc.first_column : 80;
                return loc;
            },
            /**
     * return a string which displays the lines & columns of input which are referenced 
     * by the given location info range, plus a few lines of context.
     * 
     * This function pretty-prints the indicated section of the input, with line numbers 
     * and everything!
     * 
     * This function is very useful to provide highly readable error reports, while
     * the location range may be specified in various flexible ways:
     * 
     * - `loc` is the location info object which references the area which should be
     *   displayed and 'marked up': these lines & columns of text are marked up by `^`
     *   characters below each character in the entire input range.
     * 
     * - `context_loc` is the *optional* location info object which instructs this
     *   pretty-printer how much *leading* context should be displayed alongside
     *   the area referenced by `loc`. This can help provide context for the displayed
     *   error, etc.
     * 
     *   When this location info is not provided, a default context of 3 lines is
     *   used.
     * 
     * - `context_loc2` is another *optional* location info object, which serves
     *   a similar purpose to `context_loc`: it specifies the amount of *trailing*
     *   context lines to display in the pretty-print output.
     * 
     *   When this location info is not provided, a default context of 1 line only is
     *   used.
     * 
     * Special Notes:
     * 
     * - when the `loc`-indicated range is very large (about 5 lines or more), then
     *   only the first and last few lines of this block are printed while a
     *   `...continued...` message will be printed between them.
     * 
     *   This serves the purpose of not printing a huge amount of text when the `loc`
     *   range happens to be huge: this way a manageable & readable output results
     *   for arbitrary large ranges.
     * 
     * - this function can display lines of input which whave not yet been lexed.
     *   `prettyPrintRange()` can access the entire input!
     * 
     * @public
     * @this {RegExpLexer}
     */ prettyPrintRange: function lexer_prettyPrintRange(loc, context_loc, context_loc2) {
                loc = this.deriveLocationInfo(loc, context_loc, context_loc2);
                const CONTEXT = 3;
                const CONTEXT_TAIL = 1;
                const MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT = 2;
                var input = this.matched + this._input;
                var lines = input.split('\n');
                var l0 = Math.max(1, context_loc ? context_loc.first_line : loc.first_line - CONTEXT);
                var l1 = Math.max(1, context_loc2 ? context_loc2.last_line : loc.last_line + CONTEXT_TAIL);
                var lineno_display_width = 1 + Math.log10(l1 | 1) | 0;
                var ws_prefix = new Array(lineno_display_width).join(' ');
                var nonempty_line_indexes = [];
                var rv = lines.slice(l0 - 1, l1 + 1).map(function injectLineNumber(line, index) {
                    var lno = index + l0;
                    var lno_pfx = (ws_prefix + lno).substr(-lineno_display_width);
                    var rv = lno_pfx + ': ' + line;
                    var errpfx = new Array(lineno_display_width + 1).join('^');
                    var offset = 3;
                    var len = 0;
                    if (lno === loc.first_line) {
                        offset += loc.first_column;
                        len = Math.max(2, (lno === loc.last_line ? loc.last_column : line.length) - loc.first_column + 1);
                    } else if (lno === loc.last_line) len = Math.max(2, loc.last_column + 1);
                    else if (lno > loc.first_line && lno < loc.last_line) len = Math.max(2, line.length + 1);
                    if (len) {
                        var lead = new Array(offset).join('.');
                        var mark = new Array(len).join('^');
                        rv += '\n' + errpfx + lead + mark;
                        if (line.trim().length > 0) nonempty_line_indexes.push(index);
                    }
                    rv = rv.replace(/\t/g, ' ');
                    return rv;
                });
                // now make sure we don't print an overly large amount of error area: limit it 
                // to the top and bottom line count:
                if (nonempty_line_indexes.length > 2 * MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT) {
                    var clip_start = nonempty_line_indexes[MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT - 1] + 1;
                    var clip_end = nonempty_line_indexes[nonempty_line_indexes.length - MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT] - 1;
                    var intermediate_line = new Array(lineno_display_width + 1).join(' ') + '  (...continued...)';
                    intermediate_line += '\n' + new Array(lineno_display_width + 1).join('-') + '  (---------------)';
                    rv.splice(clip_start, clip_end - clip_start + 1, intermediate_line);
                }
                return rv.join('\n');
            },
            /**
     * helper function, used to produce a human readable description as a string, given
     * the input `yylloc` location object.
     * 
     * Set `display_range_too` to TRUE to include the string character index position(s)
     * in the description if the `yylloc.range` is available.
     * 
     * @public
     * @this {RegExpLexer}
     */ describeYYLLOC: function lexer_describe_yylloc(yylloc, display_range_too) {
                var l1 = yylloc.first_line;
                var l2 = yylloc.last_line;
                var c1 = yylloc.first_column;
                var c2 = yylloc.last_column;
                var dl = l2 - l1;
                var dc = c2 - c1;
                var rv;
                if (dl === 0) {
                    rv = 'line ' + l1 + ', ';
                    if (dc <= 1) rv += 'column ' + c1;
                    else rv += 'columns ' + c1 + ' .. ' + c2;
                } else rv = 'lines ' + l1 + '(column ' + c1 + ') .. ' + l2 + '(column ' + c2 + ')';
                if (yylloc.range && display_range_too) {
                    var r1 = yylloc.range[0];
                    var r2 = yylloc.range[1] - 1;
                    if (r2 <= r1) rv += ' {String Offset: ' + r1 + '}';
                    else rv += ' {String Offset range: ' + r1 + ' .. ' + r2 + '}';
                }
                return rv;
            },
            /**
     * test the lexed token: return FALSE when not a match, otherwise return token.
     * 
     * `match` is supposed to be an array coming out of a regex match, i.e. `match[0]`
     * contains the actually matched text string.
     * 
     * Also move the input cursor forward and update the match collectors:
     * 
     * - `yytext`
     * - `yyleng`
     * - `match`
     * - `matches`
     * - `yylloc`
     * - `offset`
     * 
     * @public
     * @this {RegExpLexer}
     */ test_match: function lexer_test_match(match, indexed_rule) {
                var token, lines, backup, match_str, match_str_len;
                if (this.options.backtrack_lexer) // save context
                backup = {
                    yylineno: this.yylineno,
                    yylloc: {
                        first_line: this.yylloc.first_line,
                        last_line: this.yylloc.last_line,
                        first_column: this.yylloc.first_column,
                        last_column: this.yylloc.last_column,
                        range: this.yylloc.range.slice(0)
                    },
                    yytext: this.yytext,
                    match: this.match,
                    matches: this.matches,
                    matched: this.matched,
                    yyleng: this.yyleng,
                    offset: this.offset,
                    _more: this._more,
                    _input: this._input,
                    //_signaled_error_token: this._signaled_error_token,
                    yy: this.yy,
                    conditionStack: this.conditionStack.slice(0),
                    done: this.done
                };
                match_str = match[0];
                match_str_len = match_str.length;
                // if (match_str.indexOf('\n') !== -1 || match_str.indexOf('\r') !== -1) {
                lines = match_str.split(/(?:\r\n?|\n)/g);
                if (lines.length > 1) {
                    this.yylineno += lines.length - 1;
                    this.yylloc.last_line = this.yylineno + 1;
                    this.yylloc.last_column = lines[lines.length - 1].length;
                } else this.yylloc.last_column += match_str_len;
                // }
                this.yytext += match_str;
                this.match += match_str;
                this.matched += match_str;
                this.matches = match;
                this.yyleng = this.yytext.length;
                this.yylloc.range[1] += match_str_len;
                // previous lex rules MAY have invoked the `more()` API rather than producing a token:
                // those rules will already have moved this `offset` forward matching their match lengths,
                // hence we must only add our own match length now:
                this.offset += match_str_len;
                this._more = false;
                this._backtrack = false;
                this._input = this._input.slice(match_str_len);
                // calling this method:
                //
                //   function lexer__performAction(yy, yyrulenumber, YY_START) {...}
                token = this.performAction.call(this, this.yy, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
                // otherwise, when the action codes are all simple return token statements:
                //token = this.simpleCaseActionClusters[indexed_rule];
                if (this.done && this._input) this.done = false;
                if (token) return token;
                else if (this._backtrack) {
                    // recover context
                    for(var k in backup)this[k] = backup[k];
                    this.__currentRuleSet__ = null;
                    return false; // rule action called reject() implying the next rule should be tested instead. 
                } else if (this._signaled_error_token) {
                    // produce one 'error' token as `.parseError()` in `reject()`
                    // did not guarantee a failure signal by throwing an exception!
                    token = this._signaled_error_token;
                    this._signaled_error_token = false;
                    return token;
                }
                return false;
            },
            /**
     * return next match in input
     * 
     * @public
     * @this {RegExpLexer}
     */ next: function lexer_next() {
                if (this.done) {
                    this.clear();
                    return this.EOF;
                }
                if (!this._input) this.done = true;
                var token, match, tempMatch, index;
                if (!this._more) this.clear();
                var spec = this.__currentRuleSet__;
                if (!spec) {
                    // Update the ruleset cache as we apparently encountered a state change or just started lexing.
                    // The cache is set up for fast lookup -- we assume a lexer will switch states much less often than it will
                    // invoke the `lex()` token-producing API and related APIs, hence caching the set for direct access helps
                    // speed up those activities a tiny bit.
                    spec = this.__currentRuleSet__ = this._currentRules();
                    // Check whether a *sane* condition has been pushed before: this makes the lexer robust against
                    // user-programmer bugs such as https://github.com/zaach/jison-lex/issues/19
                    if (!spec || !spec.rules) {
                        var lineno_msg = '';
                        if (this.options.trackPosition) lineno_msg = ' on line ' + (this.yylineno + 1);
                        var p = this.constructLexErrorInfo('Internal lexer engine error' + lineno_msg + ': The lex grammar programmer pushed a non-existing condition name "' + this.topState() + '"; this is a fatal error and should be reported to the application programmer team!', false);
                        // produce one 'error' token until this situation has been resolved, most probably by parse termination!
                        return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                    }
                }
                var rule_ids = spec.rules;
                var regexes = spec.__rule_regexes;
                var len = spec.__rule_count;
                // Note: the arrays are 1-based, while `len` itself is a valid index,
                // hence the non-standard less-or-equal check in the next loop condition!
                for(var i = 1; i <= len; i++){
                    tempMatch = this._input.match(regexes[i]);
                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                        match = tempMatch;
                        index = i;
                        if (this.options.backtrack_lexer) {
                            token = this.test_match(tempMatch, rule_ids[i]);
                            if (token !== false) return token;
                            else if (this._backtrack) {
                                match = undefined;
                                continue; // rule action called reject() implying a rule MISmatch. 
                            } else // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                            return false;
                        } else if (!this.options.flex) break;
                    }
                }
                if (match) {
                    token = this.test_match(match, rule_ids[index]);
                    if (token !== false) return token;
                    // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                    return false;
                }
                if (!this._input) {
                    this.done = true;
                    this.clear();
                    return this.EOF;
                } else {
                    var lineno_msg = '';
                    if (this.options.trackPosition) lineno_msg = ' on line ' + (this.yylineno + 1);
                    var p = this.constructLexErrorInfo('Lexical error' + lineno_msg + ': Unrecognized text.', this.options.lexerErrorsAreRecoverable);
                    var pendingInput = this._input;
                    var activeCondition = this.topState();
                    var conditionStackDepth = this.conditionStack.length;
                    token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                    if (token === this.ERROR) // we can try to recover from a lexer error that `parseError()` did not 'recover' for us
                    // by moving forward at least one character at a time IFF the (user-specified?) `parseError()`
                    // has not consumed/modified any pending input or changed state in the error handler:
                    {
                        if (!this.matches && // and make sure the input has been modified/consumed ...
                        pendingInput === this._input && // ...or the lexer state has been modified significantly enough
                        // to merit a non-consuming error handling action right now.
                        activeCondition === this.topState() && conditionStackDepth === this.conditionStack.length) this.input();
                    }
                    return token;
                }
            },
            /**
     * return next match that has a token
     * 
     * @public
     * @this {RegExpLexer}
     */ lex: function lexer_lex() {
                var r;
                // allow the PRE/POST handlers set/modify the return token for maximum flexibility of the generated lexer:
                if (typeof this.pre_lex === 'function') r = this.pre_lex.call(this, 0);
                if (typeof this.options.pre_lex === 'function') // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.options.pre_lex.call(this, r) || r;
                if (this.yy && typeof this.yy.pre_lex === 'function') // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.yy.pre_lex.call(this, r) || r;
                while(!r)r = this.next();
                if (this.yy && typeof this.yy.post_lex === 'function') // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.yy.post_lex.call(this, r) || r;
                if (typeof this.options.post_lex === 'function') // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.options.post_lex.call(this, r) || r;
                if (typeof this.post_lex === 'function') // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.post_lex.call(this, r) || r;
                return r;
            },
            /**
     * return next match that has a token. Identical to the `lex()` API but does not invoke any of the 
     * `pre_lex()` nor any of the `post_lex()` callbacks.
     * 
     * @public
     * @this {RegExpLexer}
     */ fastLex: function lexer_fastLex() {
                var r;
                while(!r)r = this.next();
                return r;
            },
            /**
     * return info about the lexer state that can help a parser or other lexer API user to use the
     * most efficient means available. This API is provided to aid run-time performance for larger
     * systems which employ this lexer.
     * 
     * @public
     * @this {RegExpLexer}
     */ canIUse: function lexer_canIUse() {
                var rv = {
                    fastLex: !(typeof this.pre_lex === 'function' || typeof this.options.pre_lex === 'function' || this.yy && typeof this.yy.pre_lex === 'function' || this.yy && typeof this.yy.post_lex === 'function' || typeof this.options.post_lex === 'function' || typeof this.post_lex === 'function') && typeof this.fastLex === 'function'
                };
                return rv;
            },
            /**
     * backwards compatible alias for `pushState()`;
     * the latter is symmetrical with `popState()` and we advise to use
     * those APIs in any modern lexer code, rather than `begin()`.
     * 
     * @public
     * @this {RegExpLexer}
     */ begin: function lexer_begin(condition) {
                return this.pushState(condition);
            },
            /**
     * activates a new lexer condition state (pushes the new lexer
     * condition state onto the condition stack)
     * 
     * @public
     * @this {RegExpLexer}
     */ pushState: function lexer_pushState(condition) {
                this.conditionStack.push(condition);
                this.__currentRuleSet__ = null;
                return this;
            },
            /**
     * pop the previously active lexer condition state off the condition
     * stack
     * 
     * @public
     * @this {RegExpLexer}
     */ popState: function lexer_popState() {
                var n = this.conditionStack.length - 1;
                if (n > 0) {
                    this.__currentRuleSet__ = null;
                    return this.conditionStack.pop();
                } else return this.conditionStack[0];
            },
            /**
     * return the currently active lexer condition state; when an index
     * argument is provided it produces the N-th previous condition state,
     * if available
     * 
     * @public
     * @this {RegExpLexer}
     */ topState: function lexer_topState(n) {
                n = this.conditionStack.length - 1 - Math.abs(n || 0);
                if (n >= 0) return this.conditionStack[n];
                else return 'INITIAL';
            },
            /**
     * (internal) determine the lexer rule set which is active for the
     * currently active lexer condition state
     * 
     * @public
     * @this {RegExpLexer}
     */ _currentRules: function lexer__currentRules() {
                if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) return this.conditions[this.conditionStack[this.conditionStack.length - 1]];
                else return this.conditions['INITIAL'];
            },
            /**
     * return the number of states currently on the stack
     * 
     * @public
     * @this {RegExpLexer}
     */ stateStackSize: function lexer_stateStackSize() {
                return this.conditionStack.length;
            },
            options: {
                trackPosition: true
            },
            JisonLexerError: JisonLexerError,
            performAction: function lexer__performAction(yy, yyrulenumber, YY_START) {
                var yy_ = this;
                var YYSTATE = YY_START;
                switch(yyrulenumber){
                    case 1:
                        break;
                    default:
                        return this.simpleCaseActionClusters[yyrulenumber];
                }
            },
            simpleCaseActionClusters: {
                /*! Conditions:: INITIAL */ /*! Rule::       (--[0-9a-z-A-Z-]*) */ 0: 13,
                /*! Conditions:: INITIAL */ /*! Rule::       \* */ 2: 5,
                /*! Conditions:: INITIAL */ /*! Rule::       \/ */ 3: 6,
                /*! Conditions:: INITIAL */ /*! Rule::       \+ */ 4: 3,
                /*! Conditions:: INITIAL */ /*! Rule::       - */ 5: 4,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)px\b */ 6: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)cm\b */ 7: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)mm\b */ 8: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)in\b */ 9: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)pt\b */ 10: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)pc\b */ 11: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)deg\b */ 12: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)grad\b */ 13: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)rad\b */ 14: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)turn\b */ 15: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)s\b */ 16: 17,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ms\b */ 17: 17,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)Hz\b */ 18: 18,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)kHz\b */ 19: 18,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dpi\b */ 20: 19,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dpcm\b */ 21: 19,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dppx\b */ 22: 19,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)em\b */ 23: 20,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ex\b */ 24: 21,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ch\b */ 25: 22,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)rem\b */ 26: 23,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vw\b */ 27: 25,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vh\b */ 28: 24,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vmin\b */ 29: 26,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vmax\b */ 30: 27,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)% */ 31: 28,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)\b */ 32: 11,
                /*! Conditions:: INITIAL */ /*! Rule::       (calc) */ 33: 9,
                /*! Conditions:: INITIAL */ /*! Rule::       (var) */ 34: 12,
                /*! Conditions:: INITIAL */ /*! Rule::       ([a-z]+) */ 35: 10,
                /*! Conditions:: INITIAL */ /*! Rule::       \( */ 36: 7,
                /*! Conditions:: INITIAL */ /*! Rule::       \) */ 37: 8,
                /*! Conditions:: INITIAL */ /*! Rule::       , */ 38: 14,
                /*! Conditions:: INITIAL */ /*! Rule::       $ */ 39: 1
            },
            rules: [
                /*  0: */ /^(?:(--[\d\-A-Za-z]*))/,
                /*  1: */ /^(?:\s+)/,
                /*  2: */ /^(?:\*)/,
                /*  3: */ /^(?:\/)/,
                /*  4: */ /^(?:\+)/,
                /*  5: */ /^(?:-)/,
                /*  6: */ /^(?:(\d+(\.\d*)?|\.\d+)px\b)/,
                /*  7: */ /^(?:(\d+(\.\d*)?|\.\d+)cm\b)/,
                /*  8: */ /^(?:(\d+(\.\d*)?|\.\d+)mm\b)/,
                /*  9: */ /^(?:(\d+(\.\d*)?|\.\d+)in\b)/,
                /* 10: */ /^(?:(\d+(\.\d*)?|\.\d+)pt\b)/,
                /* 11: */ /^(?:(\d+(\.\d*)?|\.\d+)pc\b)/,
                /* 12: */ /^(?:(\d+(\.\d*)?|\.\d+)deg\b)/,
                /* 13: */ /^(?:(\d+(\.\d*)?|\.\d+)grad\b)/,
                /* 14: */ /^(?:(\d+(\.\d*)?|\.\d+)rad\b)/,
                /* 15: */ /^(?:(\d+(\.\d*)?|\.\d+)turn\b)/,
                /* 16: */ /^(?:(\d+(\.\d*)?|\.\d+)s\b)/,
                /* 17: */ /^(?:(\d+(\.\d*)?|\.\d+)ms\b)/,
                /* 18: */ /^(?:(\d+(\.\d*)?|\.\d+)Hz\b)/,
                /* 19: */ /^(?:(\d+(\.\d*)?|\.\d+)kHz\b)/,
                /* 20: */ /^(?:(\d+(\.\d*)?|\.\d+)dpi\b)/,
                /* 21: */ /^(?:(\d+(\.\d*)?|\.\d+)dpcm\b)/,
                /* 22: */ /^(?:(\d+(\.\d*)?|\.\d+)dppx\b)/,
                /* 23: */ /^(?:(\d+(\.\d*)?|\.\d+)em\b)/,
                /* 24: */ /^(?:(\d+(\.\d*)?|\.\d+)ex\b)/,
                /* 25: */ /^(?:(\d+(\.\d*)?|\.\d+)ch\b)/,
                /* 26: */ /^(?:(\d+(\.\d*)?|\.\d+)rem\b)/,
                /* 27: */ /^(?:(\d+(\.\d*)?|\.\d+)vw\b)/,
                /* 28: */ /^(?:(\d+(\.\d*)?|\.\d+)vh\b)/,
                /* 29: */ /^(?:(\d+(\.\d*)?|\.\d+)vmin\b)/,
                /* 30: */ /^(?:(\d+(\.\d*)?|\.\d+)vmax\b)/,
                /* 31: */ /^(?:(\d+(\.\d*)?|\.\d+)%)/,
                /* 32: */ /^(?:(\d+(\.\d*)?|\.\d+)\b)/,
                /* 33: */ /^(?:(calc))/,
                /* 34: */ /^(?:(var))/,
                /* 35: */ /^(?:([a-z]+))/,
                /* 36: */ /^(?:\()/,
                /* 37: */ /^(?:\))/,
                /* 38: */ /^(?:,)/,
                /* 39: */ /^(?:$)/
            ],
            conditions: {
                'INITIAL': {
                    rules: [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18,
                        19,
                        20,
                        21,
                        22,
                        23,
                        24,
                        25,
                        26,
                        27,
                        28,
                        29,
                        30,
                        31,
                        32,
                        33,
                        34,
                        35,
                        36,
                        37,
                        38,
                        39
                    ],
                    inclusive: true
                }
            }
        };
        return lexer;
    }();
    parser.lexer = lexer;
    function Parser() {
        this.yy = {};
    }
    Parser.prototype = parser;
    parser.Parser = Parser;
    return new Parser();
}();
$a165840c76c6afe6$export$8f49e4af10703ce3 = $a165840c76c6afe6$var$parser;
$a165840c76c6afe6$export$7acfa6ed01010e37 = $a165840c76c6afe6$var$parser.Parser;
$a165840c76c6afe6$export$98e6a39c04603d36 = function() {
    return $a165840c76c6afe6$var$parser.parse.apply($a165840c76c6afe6$var$parser, arguments);
};

});

parcelRegister("8nBRK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.flip = $619dd81247578d79$var$flip;

var $bJf2Y = parcelRequire("bJf2Y");
var $619dd81247578d79$var$_convert2 = $619dd81247578d79$var$_interopRequireDefault($bJf2Y);
function $619dd81247578d79$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $619dd81247578d79$var$reduce(node, precision) {
    if (node.type === "MathExpression") return $619dd81247578d79$var$reduceMathExpression(node, precision);
    if (node.type === "Calc") return $619dd81247578d79$var$reduce(node.value, precision);
    return node;
}
function $619dd81247578d79$var$isEqual(left, right) {
    return left.type === right.type && left.value === right.value;
}
function $619dd81247578d79$var$isValueType(type) {
    switch(type){
        case 'LengthValue':
        case 'AngleValue':
        case 'TimeValue':
        case 'FrequencyValue':
        case 'ResolutionValue':
        case 'EmValue':
        case 'ExValue':
        case 'ChValue':
        case 'RemValue':
        case 'VhValue':
        case 'VwValue':
        case 'VminValue':
        case 'VmaxValue':
        case 'PercentageValue':
        case 'Value':
            return true;
    }
    return false;
}
function $619dd81247578d79$var$convertMathExpression(node, precision) {
    var nodes = (0, $619dd81247578d79$var$_convert2.default)(node.left, node.right, precision);
    var left = $619dd81247578d79$var$reduce(nodes.left, precision);
    var right = $619dd81247578d79$var$reduce(nodes.right, precision);
    if (left.type === "MathExpression" && right.type === "MathExpression") {
        if (left.operator === '/' && right.operator === '*' || left.operator === '-' && right.operator === '+' || left.operator === '*' && right.operator === '/' || left.operator === '+' && right.operator === '-') {
            if ($619dd81247578d79$var$isEqual(left.right, right.right)) nodes = (0, $619dd81247578d79$var$_convert2.default)(left.left, right.left, precision);
            else if ($619dd81247578d79$var$isEqual(left.right, right.left)) nodes = (0, $619dd81247578d79$var$_convert2.default)(left.left, right.right, precision);
            left = $619dd81247578d79$var$reduce(nodes.left, precision);
            right = $619dd81247578d79$var$reduce(nodes.right, precision);
        }
    }
    node.left = left;
    node.right = right;
    return node;
}
function $619dd81247578d79$var$flip(operator) {
    return operator === '+' ? '-' : '+';
}
function $619dd81247578d79$var$flipValue(node) {
    if ($619dd81247578d79$var$isValueType(node.type)) node.value = -node.value;
    else if (node.type == 'MathExpression') {
        node.left = $619dd81247578d79$var$flipValue(node.left);
        node.right = $619dd81247578d79$var$flipValue(node.right);
    }
    return node;
}
function $619dd81247578d79$var$reduceAddSubExpression(node, precision) {
    var _node = node, left = _node.left, right = _node.right, op = _node.operator;
    if (left.type === 'CssVariable' || right.type === 'CssVariable') return node;
    // something + 0 => something
    // something - 0 => something
    if (right.value === 0) return left;
    // 0 + something => something
    if (left.value === 0 && op === "+") return right;
    // 0 - something => -something
    if (left.value === 0 && op === "-") return $619dd81247578d79$var$flipValue(right);
    // value + value
    // value - value
    if (left.type === right.type && $619dd81247578d79$var$isValueType(left.type)) {
        node = Object.assign({}, left);
        if (op === "+") node.value = left.value + right.value;
        else node.value = left.value - right.value;
    }
    // value <op> (expr)
    if ($619dd81247578d79$var$isValueType(left.type) && (right.operator === '+' || right.operator === '-') && right.type === 'MathExpression') {
        // value + (value + something) => (value + value) + something
        // value + (value - something) => (value + value) - something
        // value - (value + something) => (value - value) - something
        // value - (value - something) => (value - value) + something
        if (left.type === right.left.type) {
            node = Object.assign({}, node);
            node.left = $619dd81247578d79$var$reduce({
                type: 'MathExpression',
                operator: op,
                left: left,
                right: right.left
            }, precision);
            node.right = right.right;
            node.operator = op === '-' ? $619dd81247578d79$var$flip(right.operator) : right.operator;
            return $619dd81247578d79$var$reduce(node, precision);
        } else if (left.type === right.right.type) {
            node = Object.assign({}, node);
            node.left = $619dd81247578d79$var$reduce({
                type: 'MathExpression',
                operator: op === '-' ? $619dd81247578d79$var$flip(right.operator) : right.operator,
                left: left,
                right: right.right
            }, precision);
            node.right = right.left;
            return $619dd81247578d79$var$reduce(node, precision);
        }
    }
    // (expr) <op> value
    if (left.type === 'MathExpression' && (left.operator === '+' || left.operator === '-') && $619dd81247578d79$var$isValueType(right.type)) {
        // (value + something) + value => (value + value) + something
        // (value - something) + value => (value + value) - something
        // (value + something) - value => (value - value) + something
        // (value - something) - value => (value - value) - something
        if (right.type === left.left.type) {
            node = Object.assign({}, left);
            node.left = $619dd81247578d79$var$reduce({
                type: 'MathExpression',
                operator: op,
                left: left.left,
                right: right
            }, precision);
            return $619dd81247578d79$var$reduce(node, precision);
        } else if (right.type === left.right.type) {
            node = Object.assign({}, left);
            if (left.operator === '-') {
                node.right = $619dd81247578d79$var$reduce({
                    type: 'MathExpression',
                    operator: op === '-' ? '+' : '-',
                    left: right,
                    right: left.right
                }, precision);
                node.operator = op === '-' ? '-' : '+';
            } else node.right = $619dd81247578d79$var$reduce({
                type: 'MathExpression',
                operator: op,
                left: left.right,
                right: right
            }, precision);
            if (node.right.value < 0) {
                node.right.value *= -1;
                node.operator = node.operator === '-' ? '+' : '-';
            }
            return $619dd81247578d79$var$reduce(node, precision);
        }
    }
    return node;
}
function $619dd81247578d79$var$reduceDivisionExpression(node, precision) {
    if (!$619dd81247578d79$var$isValueType(node.right.type)) return node;
    if (node.right.type !== 'Value') throw new Error("Cannot divide by \"" + node.right.unit + "\", number expected");
    if (node.right.value === 0) throw new Error('Cannot divide by zero');
    // (expr) / value
    if (node.left.type === 'MathExpression') {
        if ($619dd81247578d79$var$isValueType(node.left.left.type) && $619dd81247578d79$var$isValueType(node.left.right.type)) {
            node.left.left.value /= node.right.value;
            node.left.right.value /= node.right.value;
            return $619dd81247578d79$var$reduce(node.left, precision);
        }
        return node;
    } else if ($619dd81247578d79$var$isValueType(node.left.type)) {
        node.left.value /= node.right.value;
        return node.left;
    }
    return node;
}
function $619dd81247578d79$var$reduceMultiplicationExpression(node) {
    // (expr) * value
    if (node.left.type === 'MathExpression' && node.right.type === 'Value') {
        if ($619dd81247578d79$var$isValueType(node.left.left.type) && $619dd81247578d79$var$isValueType(node.left.right.type)) {
            node.left.left.value *= node.right.value;
            node.left.right.value *= node.right.value;
            return node.left;
        }
    } else if ($619dd81247578d79$var$isValueType(node.left.type) && node.right.type === 'Value') {
        node.left.value *= node.right.value;
        return node.left;
    } else if (node.left.type === 'Value' && node.right.type === 'MathExpression') {
        if ($619dd81247578d79$var$isValueType(node.right.left.type) && $619dd81247578d79$var$isValueType(node.right.right.type)) {
            node.right.left.value *= node.left.value;
            node.right.right.value *= node.left.value;
            return node.right;
        }
    } else if (node.left.type === 'Value' && $619dd81247578d79$var$isValueType(node.right.type)) {
        node.right.value *= node.left.value;
        return node.right;
    }
    return node;
}
function $619dd81247578d79$var$reduceMathExpression(node, precision) {
    node = $619dd81247578d79$var$convertMathExpression(node, precision);
    switch(node.operator){
        case "+":
        case "-":
            return $619dd81247578d79$var$reduceAddSubExpression(node, precision);
        case "/":
            return $619dd81247578d79$var$reduceDivisionExpression(node, precision);
        case "*":
            return $619dd81247578d79$var$reduceMultiplicationExpression(node);
    }
    return node;
}
module.exports.default = $619dd81247578d79$var$reduce;

});
parcelRegister("bJf2Y", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e3WAX = parcelRequire("e3WAX");
var $889f91b7777ca440$var$_cssUnitConverter2 = $889f91b7777ca440$var$_interopRequireDefault($e3WAX);
function $889f91b7777ca440$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $889f91b7777ca440$var$convertNodes(left, right, precision) {
    switch(left.type){
        case 'LengthValue':
        case 'AngleValue':
        case 'TimeValue':
        case 'FrequencyValue':
        case 'ResolutionValue':
            return $889f91b7777ca440$var$convertAbsoluteLength(left, right, precision);
        default:
            return {
                left: left,
                right: right
            };
    }
}
function $889f91b7777ca440$var$convertAbsoluteLength(left, right, precision) {
    if (right.type === left.type) right = {
        type: left.type,
        value: (0, $889f91b7777ca440$var$_cssUnitConverter2.default)(right.value, right.unit, left.unit, precision),
        unit: left.unit
    };
    return {
        left: left,
        right: right
    };
}
module.exports.default = $889f91b7777ca440$var$convertNodes;
module.exports = module.exports['default'];

});
parcelRegister("e3WAX", function(module, exports) {
var $a3cecc42eafd4fde$var$conversions = {
    // length
    'px': {
        'px': 1,
        'cm': 96.0 / 2.54,
        'mm': 96.0 / 25.4,
        'in': 96,
        'pt': 96.0 / 72.0,
        'pc': 16
    },
    'cm': {
        'px': 2.54 / 96.0,
        'cm': 1,
        'mm': 0.1,
        'in': 2.54,
        'pt': 2.54 / 72.0,
        'pc': 2.54 / 6.0
    },
    'mm': {
        'px': 25.4 / 96.0,
        'cm': 10,
        'mm': 1,
        'in': 25.4,
        'pt': 25.4 / 72.0,
        'pc': 25.4 / 6.0
    },
    'in': {
        'px': 1.0 / 96.0,
        'cm': 1.0 / 2.54,
        'mm': 1.0 / 25.4,
        'in': 1,
        'pt': 1.0 / 72.0,
        'pc': 1.0 / 6.0
    },
    'pt': {
        'px': 0.75,
        'cm': 72.0 / 2.54,
        'mm': 72.0 / 25.4,
        'in': 72,
        'pt': 1,
        'pc': 12
    },
    'pc': {
        'px': 0.0625,
        'cm': 6.0 / 2.54,
        'mm': 6.0 / 25.4,
        'in': 6,
        'pt': 6.0 / 72.0,
        'pc': 1
    },
    // angle
    'deg': {
        'deg': 1,
        'grad': 0.9,
        'rad': 180 / Math.PI,
        'turn': 360
    },
    'grad': {
        'deg': 400 / 360,
        'grad': 1,
        'rad': 200 / Math.PI,
        'turn': 400
    },
    'rad': {
        'deg': Math.PI / 180,
        'grad': Math.PI / 200,
        'rad': 1,
        'turn': Math.PI * 2
    },
    'turn': {
        'deg': 1 / 360,
        'grad': 1 / 400,
        'rad': 0.5 / Math.PI,
        'turn': 1
    },
    // time
    's': {
        's': 1,
        'ms': 0.001
    },
    'ms': {
        's': 1000,
        'ms': 1
    },
    // frequency
    'Hz': {
        'Hz': 1,
        'kHz': 1000
    },
    'kHz': {
        'Hz': 0.001,
        'kHz': 1
    },
    // resolution
    'dpi': {
        'dpi': 1,
        'dpcm': 1.0 / 2.54,
        'dppx': 1 / 96
    },
    'dpcm': {
        'dpi': 2.54,
        'dpcm': 1,
        'dppx': 2.54 / 96.0
    },
    'dppx': {
        'dpi': 96,
        'dpcm': 96.0 / 2.54,
        'dppx': 1
    }
};
module.exports = function(value, sourceUnit, targetUnit, precision) {
    if (!$a3cecc42eafd4fde$var$conversions.hasOwnProperty(targetUnit)) throw new Error("Cannot convert to " + targetUnit);
    if (!$a3cecc42eafd4fde$var$conversions[targetUnit].hasOwnProperty(sourceUnit)) throw new Error("Cannot convert from " + sourceUnit + " to " + targetUnit);
    precision = Math.pow(10, parseInt(precision) || 5);
    return Math.round($a3cecc42eafd4fde$var$conversions[targetUnit][sourceUnit] * value * precision) / precision;
};

});



parcelRegister("hYnJW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(calc, node, precision) {
    var str = $d15a748316f7199c$var$stringify(node, precision);
    if (node.type === "MathExpression") // if calc expression couldn't be resolved to a single value, re-wrap it as
    // a calc()
    str = calc + "(" + str + ")";
    return str;
};

var $8nBRK = parcelRequire("8nBRK");
var $d15a748316f7199c$var$order = {
    "*": 0,
    "/": 0,
    "+": 1,
    "-": 1
};
function $d15a748316f7199c$var$round(value, prec) {
    if (prec !== false) {
        var precision = Math.pow(10, prec);
        return Math.round(value * precision) / precision;
    }
    return value;
}
function $d15a748316f7199c$var$stringify(node, prec) {
    switch(node.type){
        case "MathExpression":
            var left = node.left, right = node.right, op = node.operator;
            var str = "";
            if (left.type === 'MathExpression' && $d15a748316f7199c$var$order[op] < $d15a748316f7199c$var$order[left.operator]) str += "(" + $d15a748316f7199c$var$stringify(left, prec) + ")";
            else str += $d15a748316f7199c$var$stringify(left, prec);
            str += " " + node.operator + " ";
            if (right.type === 'MathExpression' && $d15a748316f7199c$var$order[op] < $d15a748316f7199c$var$order[right.operator]) str += "(" + $d15a748316f7199c$var$stringify(right, prec) + ")";
            else if (right.type === 'MathExpression' && op === "-" && [
                "+",
                "-"
            ].includes(right.operator)) {
                // fix #52 : a-(b+c) = a-b-c
                right.operator = (0, $8nBRK.flip)(right.operator);
                str += $d15a748316f7199c$var$stringify(right, prec);
            } else str += $d15a748316f7199c$var$stringify(right, prec);
            return str;
        case "Value":
            return $d15a748316f7199c$var$round(node.value, prec);
        case 'CssVariable':
            if (node.fallback) return "var(" + node.value + ", " + $d15a748316f7199c$var$stringify(node.fallback, prec, true) + ")";
            return "var(" + node.value + ")";
        case 'Calc':
            if (node.prefix) return "-" + node.prefix + "-calc(" + $d15a748316f7199c$var$stringify(node.value, prec) + ")";
            return "calc(" + $d15a748316f7199c$var$stringify(node.value, prec) + ")";
        default:
            return $d15a748316f7199c$var$round(node.value, prec) + node.unit;
    }
}
module.exports = module.exports["default"];

});


parcelRegister("lMXX0", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdcc959e1e17280b$export$2e2bcd8739ae039);
// import memoize from 'lodash/memoize';
const $fdcc959e1e17280b$var$MEASUREMENT_ELEMENT_ID = '__react_svg_text_measurement_id';
function $fdcc959e1e17280b$export$2e2bcd8739ae039(str, style) {
    try {
        // Calculate length of each word to be used to determine number of words per line
        let textEl = document.getElementById($fdcc959e1e17280b$var$MEASUREMENT_ELEMENT_ID);
        if (!textEl) {
            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('aria-hidden', 'true');
            svg.style.width = '0';
            svg.style.height = '0';
            svg.style.position = 'absolute';
            svg.style.top = '-100%';
            svg.style.left = '-100%';
            textEl = document.createElementNS('http://www.w3.org/2000/svg', 'text');
            textEl.setAttribute('id', $fdcc959e1e17280b$var$MEASUREMENT_ELEMENT_ID);
            svg.appendChild(textEl);
            document.body.appendChild(svg);
        }
        Object.assign(textEl.style, style);
        textEl.textContent = str;
        return textEl.getComputedTextLength();
    } catch (e) {
        return null;
    }
} // TODO: Implement without lodash
 // export default memoize(getStringWidth, (str, style) => `${str}_${JSON.stringify(style)}`);

});



parcelRegister("jQ5Qu", function(module, exports) {

$parcel$export(module.exports, "getMaxContrast", () => $e7176877f098873f$export$499db937e3cd4eb2);

var $kTHGn = parcelRequire("kTHGn");

var $7UL8A = parcelRequire("7UL8A");
function $e7176877f098873f$var$getLuminance(_ref) {
    let { r: r, g: g, b: b } = _ref;
    const a = [
        r,
        g,
        b
    ].map((v)=>{
        v /= 255;
        return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}
function $e7176877f098873f$var$getContrast(color1, color2) {
    const lum1 = $e7176877f098873f$var$getLuminance(color1) + 0.05;
    const lum2 = $e7176877f098873f$var$getLuminance(color2) + 0.05;
    return Math.max(lum1, lum2) / Math.min(lum1, lum2);
}
function $e7176877f098873f$var$getTokenAndFallback(cssVar) {
    // Extract the number from the CSS variable name
    const numberMatch = cssVar.match(/\d+/);
    const number = numberMatch ? numberMatch[0] : '';
    // Extract all terms following '--ds-' and before the number
    const termsMatch = cssVar.match(/--ds-(.+)-\d+/);
    const terms = termsMatch ? termsMatch[1].split('-') : [];
    // Extract the hexadecimal color from the CSS variable
    const hexColorMatch = cssVar.match(/#[0-9a-fA-F]{6}/);
    const hexColor = hexColorMatch ? hexColorMatch[0] : '';
    // Create the desired format by joining all extracted terms
    const token = `color.${terms.join('.') + '.' + number}`;
    return {
        token: token,
        fallback: hexColor
    };
}
function $e7176877f098873f$export$499db937e3cd4eb2(arcColor) {
    const isPattern = arcColor.includes('url');
    const { token: token, fallback: fallback } = $e7176877f098873f$var$getTokenAndFallback(arcColor);
    const colorHex = (0, $kTHGn.default)(token, fallback);
    const color = (0, $7UL8A.rgb)(arcColor.startsWith('var(') ? colorHex : arcColor);
    if (isPattern) return 'black';
    if (!color) return '';
    const blackContrast = $e7176877f098873f$var$getContrast(color, (0, $7UL8A.rgb)('black'));
    const whiteContrast = $e7176877f098873f$var$getContrast(color, (0, $7UL8A.rgb)('white'));
    if (whiteContrast >= 4.5) return 'white';
    if (blackContrast >= 4.5) return 'black';
    return 'white';
}

});


parcelRegister("dnJJh", function(module, exports) {

$parcel$export(module.exports, "default", () => $9be0e5401983ef4c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
function $9be0e5401983ef4c$export$2e2bcd8739ae039(_ref) {
    let { top: top = 0, left: left = 0, transform: transform, children: children, innerRef: innerRef, ...restProps } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
        ref: innerRef,
        transform: transform || `translate(${left}, ${top})`,
        ...restProps,
        children: children
    });
}

});


parcelRegister("dwg9t", function(module, exports) {

$parcel$export(module.exports, "BarGroupMarks", () => $9d7acaf02478f739$export$fe396ea701d4567e);

var $bT1Sw = parcelRequire("bT1Sw");

var $iTGbP = parcelRequire("iTGbP");

var $dnJJh = parcelRequire("dnJJh");

var $dluWU = parcelRequire("dluWU");

var $2OMIu = parcelRequire("2OMIu");
const $9d7acaf02478f739$export$fe396ea701d4567e = (0, $bT1Sw.element)(function BarGroupMarks(_ref) {
    let { barGroups: barGroups, roundedCorners: roundedCorners = false } = _ref;
    return barGroups.map((barGroup)=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dnJJh.default), {
            left: barGroup.x0,
            children: barGroup.bars.map((bar)=>{
                const cornerRadius = roundedCorners && bar.height > 2 * (0, $dluWU.CORNER_RADIUS_VALUE).SMALL && bar.width > 2 * (0, $dluWU.CORNER_RADIUS_VALUE).SMALL ? (0, $dluWU.CORNER_RADIUS_VALUE).SMALL : (0, $dluWU.CORNER_RADIUS_VALUE).NONE;
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iTGbP.Bar), {
                    ariaLabel: `${bar.label}, x: ${bar.xValue}, y: ${bar.yValue}`,
                    x: bar.x,
                    y: bar.y,
                    datum: bar.datum,
                    width: bar.width,
                    height: bar.height,
                    fill: bar.color,
                    cornerRadius: {
                        topLeft: cornerRadius,
                        topRight: cornerRadius
                    }
                }, `bar-group-bar-${barGroup.index}-${bar.index}-${bar.xValue}-${bar.key}`);
            })
        }, `bar-group-marks-${barGroup.index}-${barGroup.x0}`);
    });
});

});
parcelRegister("dluWU", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_MARGIN", () => $9b753e5f48cfde8e$export$6475e56bfff61883);
$parcel$export(module.exports, "STACK_GAP", () => $9b753e5f48cfde8e$export$56b61e27223adae9);
$parcel$export(module.exports, "CORNER_RADIUS_VALUE", () => $9b753e5f48cfde8e$export$a15d94c34ecbca08);
const $9b753e5f48cfde8e$export$6475e56bfff61883 = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
};
const $9b753e5f48cfde8e$export$601d4a48e295711b = 150;
const $9b753e5f48cfde8e$export$56b61e27223adae9 = 1;
const $9b753e5f48cfde8e$export$4d00931646175b35 = 2;
const $9b753e5f48cfde8e$export$a15d94c34ecbca08 = {
    SMALL: 2,
    MEDIUM: 4,
    LARGE: 8,
    NONE: 0
};

});


parcelRegister("ggVTz", function(module, exports) {

$parcel$export(module.exports, "useMaximumYValue", () => $bd8b0cc46655e91a$export$b6f0cda1573da4a7);
$parcel$export(module.exports, "calculateXScaleDomain", () => $bd8b0cc46655e91a$export$25d8e7ab8cac3e31);
$parcel$export(module.exports, "calculateYDomain", () => $bd8b0cc46655e91a$export$d2ffead7cf0bfe5c);
$parcel$export(module.exports, "BarScalesElement", () => $bd8b0cc46655e91a$export$399ec5971eff5385);

var $hjll3 = parcelRequire("hjll3");

var $5uXOq = parcelRequire("5uXOq");

var $bT1Sw = parcelRequire("bT1Sw");
var $17PP9 = parcelRequire("17PP9");
parcelRequire("8WCE9");
var $i3RkB = parcelRequire("i3RkB");
var $8WCE9 = parcelRequire("8WCE9");
var $5pfgu = parcelRequire("5pfgu");
var $juXo4 = parcelRequire("juXo4");

var $6jSGb = parcelRequire("6jSGb");

var $cgmj2 = parcelRequire("cgmj2");
function $bd8b0cc46655e91a$export$b6f0cda1573da4a7(data, x, y, stacked) {
    const total = (0, $5uXOq.useMemo)(()=>{
        if (!stacked) return (0, $hjll3.max)(data, y) || 1;
        const grouped = (0, $hjll3.group)(data, x);
        const totals = [];
        grouped.forEach((colorGroup)=>{
            totals.push((0, $hjll3.sum)(colorGroup.map(y)));
        });
        return (0, $hjll3.max)(totals) || 1;
    }, [
        data,
        x,
        y,
        stacked
    ]);
    return total;
}
function $bd8b0cc46655e91a$export$25d8e7ab8cac3e31(_ref) {
    let { xData: xData, timeUnit: timeUnit, range: range, padding: padding } = _ref;
    if (timeUnit) {
        // @ts-expect-error unknown error expected
        const timeExtent = (0, $hjll3.extent)(xData);
        let timeInterval = (0, $hjll3.timeYear);
        switch(timeUnit){
            case 'days':
                timeInterval = (0, $hjll3.timeDay);
                break;
            case 'months':
                timeInterval = (0, $hjll3.timeMonth);
                break;
            case 'weeks':
                timeInterval = (0, $hjll3.timeWeek);
                break;
            default:
                break;
        }
        const timeDomain = timeInterval.range(timeExtent[0], timeInterval.offset(timeExtent[1], 1), 1);
        return (0, $8WCE9.scaleBandTime)({
            range: range,
            padding: padding,
            domain: timeDomain
        });
    } else // @ts-expect-error unknown error expected
    return (0, $i3RkB.default)({
        domain: [
            ...new Set(xData)
        ],
        range: range,
        padding: padding
    });
}
function $bd8b0cc46655e91a$export$d2ffead7cf0bfe5c(_ref2) {
    let { totalYValue: totalYValue, yDomain: yDomain, normalize: normalize } = _ref2;
    const domainOutput = normalize ? [
        0,
        1
    ] : [
        0,
        totalYValue
    ];
    if (yDomain && yDomain[0] != null) domainOutput[0] = yDomain[0];
    if (yDomain && yDomain[1] != null) domainOutput[1] = yDomain[1];
    return domainOutput;
}
const $bd8b0cc46655e91a$export$399ec5971eff5385 = (0, $bT1Sw.element)((props)=>{
    const { data: data, x: x, y: y, color: color, width: width, height: height, yDomain: yDomain, timeUnit: timeUnit } = props;
    const { fillStyles: fillStyles, enableDefaultPatterns: enableDefaultPatterns, useThemeFillStyles: useThemeFillStyles } = (0, $17PP9.useElementProps)((0, $cgmj2.Theme));
    const totalYValue = $bd8b0cc46655e91a$export$b6f0cda1573da4a7(data || [], x, y, false);
    const value = (0, $5uXOq.useMemo)(()=>{
        const xScaleRange = [
            0,
            width
        ];
        const xScalePadding = 0.25;
        const xScale = $bd8b0cc46655e91a$export$25d8e7ab8cac3e31({
            xData: data.map(x),
            timeUnit: timeUnit,
            range: xScaleRange,
            padding: xScalePadding
        });
        const groupScale = (0, $i3RkB.default)({
            domain: [
                ...new Set(data.map(color))
            ],
            range: [
                0,
                (0, $6jSGb.default)(xScale)
            ],
            padding: 0.1
        });
        const yScale = (0, $5pfgu.default)({
            domain: $bd8b0cc46655e91a$export$d2ffead7cf0bfe5c({
                totalYValue: totalYValue,
                yDomain: yDomain
            }),
            range: [
                height,
                0
            ]
        });
        const { domain: domain, range: range } = useThemeFillStyles({
            fillStyles: fillStyles,
            enableDefaultPatterns: enableDefaultPatterns
        });
        const colorScale = (0, $juXo4.default)({
            domain: domain ? domain : data.map(color),
            range: range
        });
        // This needs to go somewhere else. And should probably use the x data.
        const seriesData = (0, $hjll3.group)(data, x);
        return {
            xScale: xScale,
            yScale: yScale,
            colorScale: colorScale,
            groupScale: groupScale,
            seriesData: seriesData
        };
    }, [
        data,
        width,
        height,
        totalYValue,
        x,
        yDomain,
        timeUnit,
        fillStyles,
        enableDefaultPatterns
    ]);
    return props.children(value);
});

});
parcelRegister("8WCE9", function(module, exports) {

$parcel$export(module.exports, "scaleBandTime", () => $6831b7e75dd8af74$export$3664991d076c12bd);
$parcel$export(module.exports, "scaleBand", () => (parcelRequire("i3RkB")).default);
// only export what we use
// eslint-disable-next-line no-restricted-syntax

var $cMo1a = parcelRequire("cMo1a");
var $eOdM1 = parcelRequire("eOdM1");
var $elPt5 = parcelRequire("elPt5");
var $i3RkB = parcelRequire("i3RkB");
var $5pfgu = parcelRequire("5pfgu");
var $38Bo0 = parcelRequire("38Bo0");
var $juXo4 = parcelRequire("juXo4");
var $lLx1Y = parcelRequire("lLx1Y");
var $2YVVm = parcelRequire("2YVVm");
// Creating a combination scale that adds a timeUnit function
// I may want to adjust how we are doing this.
function $6831b7e75dd8af74$export$3664991d076c12bd(config) {
    const scale = (0, $i3RkB.default)(config);
    scale.timeUnit = function() {
        return config === null || config === void 0 ? void 0 : config.timeUnit;
    };
    return scale;
}

});
parcelRegister("i3RkB", function(module, exports) {

$parcel$export(module.exports, "default", () => $d261e04fb6b55f5b$export$2e2bcd8739ae039);

var $gMRSL = parcelRequire("gMRSL");

var $caWsP = parcelRequire("caWsP");
var $d261e04fb6b55f5b$export$933021962cd38dc1 = (0, $caWsP.default)('domain', 'range', 'reverse', 'align', 'padding', 'round');
function $d261e04fb6b55f5b$export$2e2bcd8739ae039(config) {
    return $d261e04fb6b55f5b$export$933021962cd38dc1((0, $gMRSL.default)(), config);
}

});
parcelRegister("gMRSL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c38aecf3af0f59a7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "point", () => $c38aecf3af0f59a7$export$105684a3041cb6f3);

var $7urYO = parcelRequire("7urYO");

var $l4Hc4 = parcelRequire("l4Hc4");

var $8idDz = parcelRequire("8idDz");
function $c38aecf3af0f59a7$export$2e2bcd8739ae039() {
    var scale = (0, $8idDz.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $7urYO.default)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $c38aecf3af0f59a7$export$2e2bcd8739ae039(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, $l4Hc4.initRange).apply(rescale(), arguments);
}
function $c38aecf3af0f59a7$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $c38aecf3af0f59a7$var$pointish(copy());
    };
    return scale;
}
function $c38aecf3af0f59a7$export$105684a3041cb6f3() {
    return $c38aecf3af0f59a7$var$pointish($c38aecf3af0f59a7$export$2e2bcd8739ae039.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("7urYO", function(module, exports) {

$parcel$export(module.exports, "default", () => $574109f1d23a3200$export$2e2bcd8739ae039);
function $574109f1d23a3200$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("8idDz", function(module, exports) {

$parcel$export(module.exports, "implicit", () => $609a953a3e88158e$export$e4f898ab14d9d460);
$parcel$export(module.exports, "default", () => $609a953a3e88158e$export$2e2bcd8739ae039);

var $ifNm6 = parcelRequire("ifNm6");

var $l4Hc4 = parcelRequire("l4Hc4");
const $609a953a3e88158e$export$e4f898ab14d9d460 = Symbol("implicit");
function $609a953a3e88158e$export$2e2bcd8739ae039() {
    var index = new (0, $ifNm6.InternMap)(), domain = [], range = [], unknown = $609a953a3e88158e$export$e4f898ab14d9d460;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $609a953a3e88158e$export$e4f898ab14d9d460) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new (0, $ifNm6.InternMap)();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $609a953a3e88158e$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $l4Hc4.initRange).apply(scale, arguments);
    return scale;
}

});
parcelRegister("ifNm6", function(module, exports) {

$parcel$export(module.exports, "InternMap", () => $d49fe9b4e774f532$export$dcc6fb7d82b5bc7b);
$parcel$export(module.exports, "InternSet", () => $d49fe9b4e774f532$export$55278c3294239828);
class $d49fe9b4e774f532$export$dcc6fb7d82b5bc7b extends Map {
    constructor(entries, key = $d49fe9b4e774f532$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($d49fe9b4e774f532$var$intern_get(this, key));
    }
    has(key) {
        return super.has($d49fe9b4e774f532$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($d49fe9b4e774f532$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($d49fe9b4e774f532$var$intern_delete(this, key));
    }
}
class $d49fe9b4e774f532$export$55278c3294239828 extends Set {
    constructor(values, key = $d49fe9b4e774f532$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($d49fe9b4e774f532$var$intern_get(this, value));
    }
    add(value) {
        return super.add($d49fe9b4e774f532$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($d49fe9b4e774f532$var$intern_delete(this, value));
    }
}
function $d49fe9b4e774f532$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $d49fe9b4e774f532$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $d49fe9b4e774f532$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $d49fe9b4e774f532$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});




parcelRegister("5pfgu", function(module, exports) {

$parcel$export(module.exports, "default", () => $3efb20df079e2ed4$export$2e2bcd8739ae039);

var $gcmOU = parcelRequire("gcmOU");

var $caWsP = parcelRequire("caWsP");
var $3efb20df079e2ed4$export$7ce4d19a8c2ea22f = (0, $caWsP.default)('domain', 'range', 'reverse', 'clamp', 'interpolate', 'nice', 'round', 'zero');
function $3efb20df079e2ed4$export$2e2bcd8739ae039(config) {
    return $3efb20df079e2ed4$export$7ce4d19a8c2ea22f((0, $gcmOU.default)(), config);
}

});
parcelRegister("gcmOU", function(module, exports) {

$parcel$export(module.exports, "linearish", () => $bcaf77e9c6cf2e73$export$16a5d4b4a61a274d);
$parcel$export(module.exports, "default", () => $bcaf77e9c6cf2e73$export$2e2bcd8739ae039);

var $80JJl = parcelRequire("80JJl");

var $jhkFB = parcelRequire("jhkFB");

var $l4Hc4 = parcelRequire("l4Hc4");

var $e86SE = parcelRequire("e86SE");
function $bcaf77e9c6cf2e73$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $80JJl.default)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $e86SE.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $80JJl.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $bcaf77e9c6cf2e73$export$2e2bcd8739ae039() {
    var scale = (0, $jhkFB.default)();
    scale.copy = function() {
        return (0, $jhkFB.copy)(scale, $bcaf77e9c6cf2e73$export$2e2bcd8739ae039());
    };
    (0, $l4Hc4.initRange).apply(scale, arguments);
    return $bcaf77e9c6cf2e73$export$16a5d4b4a61a274d(scale);
}

});
parcelRegister("e86SE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a497265f873a5cba$export$2e2bcd8739ae039);

var $80JJl = parcelRequire("80JJl");

var $lIJDz = parcelRequire("lIJDz");
var $d52Pl = parcelRequire("d52Pl");
var $jGaQB = parcelRequire("jGaQB");
var $eP35l = parcelRequire("eP35l");
var $3n7r8 = parcelRequire("3n7r8");
function $a497265f873a5cba$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $80JJl.tickStep)(start, stop, count), precision;
    specifier = (0, $d52Pl.default)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $eP35l.default)(step, value))) specifier.precision = precision;
            return (0, $lIJDz.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $3n7r8.default)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $jGaQB.default)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $lIJDz.format)(specifier);
}

});
parcelRegister("lIJDz", function(module, exports) {

$parcel$export(module.exports, "format", () => $fd011b9e7fff9861$export$d9468344d3651243);
$parcel$export(module.exports, "formatPrefix", () => $fd011b9e7fff9861$export$8d85692a469dde6f);

var $9lU0X = parcelRequire("9lU0X");
var $fd011b9e7fff9861$var$locale;
var $fd011b9e7fff9861$export$d9468344d3651243;
var $fd011b9e7fff9861$export$8d85692a469dde6f;
$fd011b9e7fff9861$export$2e2bcd8739ae039({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $fd011b9e7fff9861$export$2e2bcd8739ae039(definition) {
    $fd011b9e7fff9861$var$locale = (0, $9lU0X.default)(definition);
    $fd011b9e7fff9861$export$d9468344d3651243 = $fd011b9e7fff9861$var$locale.format;
    $fd011b9e7fff9861$export$8d85692a469dde6f = $fd011b9e7fff9861$var$locale.formatPrefix;
    return $fd011b9e7fff9861$var$locale;
}

});
parcelRegister("9lU0X", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cf18683e7066ef8$export$2e2bcd8739ae039);

var $4PYTL = parcelRequire("4PYTL");

var $lumKq = parcelRequire("lumKq");

var $69LQu = parcelRequire("69LQu");

var $d52Pl = parcelRequire("d52Pl");

var $hFRdc = parcelRequire("hFRdc");

var $61KNZ = parcelRequire("61KNZ");

var $6be9G = parcelRequire("6be9G");

var $koqnZ = parcelRequire("koqnZ");
var $6cf18683e7066ef8$var$map = Array.prototype.map, $6cf18683e7066ef8$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $6cf18683e7066ef8$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $koqnZ.default) : (0, $lumKq.default)($6cf18683e7066ef8$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $koqnZ.default) : (0, $69LQu.default)($6cf18683e7066ef8$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $d52Pl.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $61KNZ.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $61KNZ.default)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $hFRdc.default)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $6cf18683e7066ef8$var$prefixes[8 + (0, $6be9G.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $d52Pl.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $4PYTL.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $6cf18683e7066ef8$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("4PYTL", function(module, exports) {

$parcel$export(module.exports, "default", () => $385b29fac2777bcf$export$2e2bcd8739ae039);

var $dTsA8 = parcelRequire("dTsA8");
function $385b29fac2777bcf$export$2e2bcd8739ae039(x) {
    return x = (0, $dTsA8.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("dTsA8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1d6952536ec19e2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "formatDecimalParts", () => $a1d6952536ec19e2$export$8f8e23dd27dc19f5);
function $a1d6952536ec19e2$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $a1d6952536ec19e2$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("lumKq", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa4e0b8ad8ee75a1$export$2e2bcd8739ae039);
function $fa4e0b8ad8ee75a1$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("69LQu", function(module, exports) {

$parcel$export(module.exports, "default", () => $47b8b274d7519d09$export$2e2bcd8739ae039);
function $47b8b274d7519d09$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("d52Pl", function(module, exports) {

$parcel$export(module.exports, "default", () => $985def61c5e3febe$export$2e2bcd8739ae039);
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $985def61c5e3febe$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $985def61c5e3febe$export$2e2bcd8739ae039(specifier) {
    if (!(match = $985def61c5e3febe$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $985def61c5e3febe$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$985def61c5e3febe$export$2e2bcd8739ae039.prototype = $985def61c5e3febe$export$963aac351db36ed4.prototype; // instanceof
function $985def61c5e3febe$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$985def61c5e3febe$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("hFRdc", function(module, exports) {

$parcel$export(module.exports, "default", () => $cddf8aca24d838af$export$2e2bcd8739ae039);
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $cddf8aca24d838af$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("61KNZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $463724a038112234$export$2e2bcd8739ae039);

var $dTsA8 = parcelRequire("dTsA8");

var $6be9G = parcelRequire("6be9G");

var $91t1p = parcelRequire("91t1p");
var $463724a038112234$export$2e2bcd8739ae039 = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, $dTsA8.default),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $91t1p.default)(x * 100, p),
    "r": (0, $91t1p.default),
    "s": (0, $6be9G.default),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};

});
parcelRegister("6be9G", function(module, exports) {

$parcel$export(module.exports, "prefixExponent", () => $47fec017c029c8e0$export$6863724d9a42263);
$parcel$export(module.exports, "default", () => $47fec017c029c8e0$export$2e2bcd8739ae039);

var $dTsA8 = parcelRequire("dTsA8");
var $47fec017c029c8e0$export$6863724d9a42263;
function $47fec017c029c8e0$export$2e2bcd8739ae039(x, p) {
    var d = (0, $dTsA8.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($47fec017c029c8e0$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $dTsA8.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("91t1p", function(module, exports) {

$parcel$export(module.exports, "default", () => $691ab825243f2afd$export$2e2bcd8739ae039);

var $dTsA8 = parcelRequire("dTsA8");
function $691ab825243f2afd$export$2e2bcd8739ae039(x, p) {
    var d = (0, $dTsA8.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("koqnZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed8a843c78cf60aa$export$2e2bcd8739ae039);
function $ed8a843c78cf60aa$export$2e2bcd8739ae039(x) {
    return x;
}

});



parcelRegister("jGaQB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e53a5aa57132374c$export$2e2bcd8739ae039);

var $4PYTL = parcelRequire("4PYTL");
function $e53a5aa57132374c$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $4PYTL.default)(Math.abs(step)));
}

});

parcelRegister("eP35l", function(module, exports) {

$parcel$export(module.exports, "default", () => $aca838c0481a7c13$export$2e2bcd8739ae039);

var $4PYTL = parcelRequire("4PYTL");
function $aca838c0481a7c13$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $4PYTL.default)(value) / 3))) * 3 - (0, $4PYTL.default)(Math.abs(step)));
}

});

parcelRegister("3n7r8", function(module, exports) {

$parcel$export(module.exports, "default", () => $274949d87d20acb5$export$2e2bcd8739ae039);

var $4PYTL = parcelRequire("4PYTL");
function $274949d87d20acb5$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $4PYTL.default)(max) - (0, $4PYTL.default)(step)) + 1;
}

});




parcelRegister("38Bo0", function(module, exports) {

$parcel$export(module.exports, "default", () => $248f1e8d28412739$export$2e2bcd8739ae039);

var $iB1I6 = parcelRequire("iB1I6");

var $caWsP = parcelRequire("caWsP");
var $248f1e8d28412739$export$8cc7d5fc9fe1e0a3 = (0, $caWsP.default)('domain', 'range', 'reverse', 'base', 'clamp', 'interpolate', 'nice', 'round');
function $248f1e8d28412739$export$2e2bcd8739ae039(config) {
    return $248f1e8d28412739$export$8cc7d5fc9fe1e0a3((0, $iB1I6.default)(), config);
}

});
parcelRegister("iB1I6", function(module, exports) {

$parcel$export(module.exports, "loggish", () => $d89d02543259a0b5$export$860836db074028f0);
$parcel$export(module.exports, "default", () => $d89d02543259a0b5$export$2e2bcd8739ae039);

var $80JJl = parcelRequire("80JJl");

var $lIJDz = parcelRequire("lIJDz");
var $d52Pl = parcelRequire("d52Pl");

var $8h2kZ = parcelRequire("8h2kZ");

var $jhkFB = parcelRequire("jhkFB");

var $l4Hc4 = parcelRequire("l4Hc4");
function $d89d02543259a0b5$var$transformLog(x) {
    return Math.log(x);
}
function $d89d02543259a0b5$var$transformExp(x) {
    return Math.exp(x);
}
function $d89d02543259a0b5$var$transformLogn(x) {
    return -Math.log(-x);
}
function $d89d02543259a0b5$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $d89d02543259a0b5$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $d89d02543259a0b5$var$powp(base) {
    return base === 10 ? $d89d02543259a0b5$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $d89d02543259a0b5$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $d89d02543259a0b5$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $d89d02543259a0b5$export$860836db074028f0(transform) {
    const scale = transform($d89d02543259a0b5$var$transformLog, $d89d02543259a0b5$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $d89d02543259a0b5$var$logp(base), pows = $d89d02543259a0b5$var$powp(base);
        if (domain()[0] < 0) {
            logs = $d89d02543259a0b5$var$reflect(logs), pows = $d89d02543259a0b5$var$reflect(pows);
            transform($d89d02543259a0b5$var$transformLogn, $d89d02543259a0b5$var$transformExpn);
        } else transform($d89d02543259a0b5$var$transformLog, $d89d02543259a0b5$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $80JJl.default)(u, v, n);
        } else z = (0, $80JJl.default)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $d52Pl.default)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $lIJDz.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $8h2kZ.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $d89d02543259a0b5$export$2e2bcd8739ae039() {
    const scale = $d89d02543259a0b5$export$860836db074028f0((0, $jhkFB.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $jhkFB.copy)(scale, $d89d02543259a0b5$export$2e2bcd8739ae039()).base(scale.base());
    (0, $l4Hc4.initRange).apply(scale, arguments);
    return scale;
}

});


parcelRegister("juXo4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e31ee2bae0007f48$export$2e2bcd8739ae039);

var $8idDz = parcelRequire("8idDz");

var $caWsP = parcelRequire("caWsP");
var $e31ee2bae0007f48$export$6c7fd0f60d1828d8 = (0, $caWsP.default)('domain', 'range', 'reverse', 'unknown');
function $e31ee2bae0007f48$export$2e2bcd8739ae039(config) {
    return $e31ee2bae0007f48$export$6c7fd0f60d1828d8((0, $8idDz.default)(), config);
}

});

parcelRegister("lLx1Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd879c046e084e2b$export$2e2bcd8739ae039);

var $gMRSL = parcelRequire("gMRSL");

var $caWsP = parcelRequire("caWsP");
var $fd879c046e084e2b$export$1c86c961a04b7858 = (0, $caWsP.default)('domain', 'range', 'reverse', 'align', 'padding', 'round');
function $fd879c046e084e2b$export$2e2bcd8739ae039(config) {
    return $fd879c046e084e2b$export$1c86c961a04b7858((0, $gMRSL.point)(), config);
}

});


parcelRegister("6jSGb", function(module, exports) {

$parcel$export(module.exports, "default", () => $499eeea25e19f1a9$export$2e2bcd8739ae039);
function $499eeea25e19f1a9$export$2e2bcd8739ae039(scale) {
    if ('bandwidth' in scale) return scale.bandwidth();
    const range = scale.range();
    const domain = scale.domain();
    return Math.abs(range[range.length - 1] - range[0]) / domain.length;
}

});


parcelRegister("cKYPp", function(module, exports) {

$parcel$export(module.exports, "BarTooltipOverlayElement", () => $9498f71ba797135a$export$5ba4961e00f9d36);
$parcel$export(module.exports, "BarTooltipOverlayEmitterElement", () => $9498f71ba797135a$export$7224ce4821955367);
$parcel$export(module.exports, "BarTooltipOverlayEmitter", () => $9498f71ba797135a$export$e3d7d80d1df1466);
$parcel$export(module.exports, "BarTooltipOverlay", () => $9498f71ba797135a$export$a6d588001e949ed2);

var $5uXOq = parcelRequire("5uXOq");

var $bT1Sw = parcelRequire("bT1Sw");

var $iTGbP = parcelRequire("iTGbP");

var $6jSGb = parcelRequire("6jSGb");


var $lrseF = parcelRequire("lrseF");

var $13b02 = parcelRequire("13b02");

var $3xZ2d = parcelRequire("3xZ2d");

var $aEZ4R = parcelRequire("aEZ4R");

var $2OMIu = parcelRequire("2OMIu");
const $9498f71ba797135a$export$5ba4961e00f9d36 = (0, $bT1Sw.element)((props)=>{
    var _tooltipData$nearestD, _tooltipData$nearestD2, _tooltipData$nearestD3;
    const { tooltipOpen: tooltipOpen, tooltipData: tooltipData, showTooltip: showTooltip, hideTooltip: hideTooltip, width: width, height: height, xScale: xScale, yScale: yScale, horizontal: horizontal, xAccessor: xAccessor, yAccessor: yAccessor, margin: margin, seriesData: seriesData, data: data, hide: hide } = props;
    if (hide) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: tooltipOpen && (tooltipData === null || tooltipData === void 0 ? void 0 : (_tooltipData$nearestD = tooltipData.nearestDatum) === null || _tooltipData$nearestD === void 0 ? void 0 : _tooltipData$nearestD.datum) && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: !horizontal ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iTGbP.PrivateBar), {
                x: (xScale(xAccessor(tooltipData === null || tooltipData === void 0 ? void 0 : (_tooltipData$nearestD2 = tooltipData.nearestDatum) === null || _tooltipData$nearestD2 === void 0 ? void 0 : _tooltipData$nearestD2.datum)) || 0) - 5,
                y: 0,
                opacity: 0.5,
                fill: "var(--ds-interaction-hovered, #00000029)",
                width: (0, $6jSGb.default)(xScale) + 10,
                height: height
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iTGbP.PrivateBar), {
                y: (yScale(xAccessor(tooltipData === null || tooltipData === void 0 ? void 0 : (_tooltipData$nearestD3 = tooltipData.nearestDatum) === null || _tooltipData$nearestD3 === void 0 ? void 0 : _tooltipData$nearestD3.datum)) || 0) - 5,
                x: 0,
                opacity: 0.5,
                fill: "var(--ds-interaction-hovered, #00000029)",
                height: (0, $6jSGb.default)(yScale) + 10,
                width: width
            })
        })
    });
});
const $9498f71ba797135a$export$7224ce4821955367 = (0, $bT1Sw.element)((props)=>{
    const { width: width, height: height, xScale: xScale, yScale: yScale, horizontal: horizontal, xAccessor: xAccessor, yAccessor: yAccessor, margin: margin, seriesData: seriesData, showTooltip: showTooltip, hideTooltip: hideTooltip, onClick: onClick, data: data, hide: hide } = props;
    if (hide) return null;
    const eventEmitters = (0, $13b02.default)({
        source: (0, $0277c50b98747247$export$69b1818e3c4e83f9)
    });
    (0, $3xZ2d.default)({
        dataKey: 'nearest',
        onPointerMove: (d)=>showTooltip(d),
        onPointerOut: ()=>hideTooltip(),
        onPointerDown: (d)=>onClick && onClick(d),
        allowedSources: [
            (0, $0277c50b98747247$export$69b1818e3c4e83f9)
        ],
        horizontal: horizontal,
        width: width,
        margin: margin,
        height: height,
        data: data,
        xScale: xScale,
        yScale: yScale,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        seriesData: seriesData
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
            style: {
                cursor: onClick ? 'pointer' : 'default'
            },
            width: width,
            height: height,
            fill: "transparent",
            ...eventEmitters
        })
    });
});
function $9498f71ba797135a$export$e3d7d80d1df1466() {
    const { width: width, height: height, margin: margin, xScale: xScale, yScale: yScale, xAccessor: xAccessor, yAccessor: yAccessor, seriesData: seriesData, data: data } = (0, $aEZ4R.useBarData)();
    const { showTooltip: showTooltip, hideTooltip: hideTooltip } = (0, $5uXOq.useContext)((0, $lrseF.default));
    return /*#__PURE__*/ (0, $2OMIu.jsx)($9498f71ba797135a$export$7224ce4821955367, {
        showTooltip: showTooltip,
        hideTooltip: hideTooltip,
        width: width,
        height: height,
        xScale: xScale,
        yScale: yScale,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        data: data,
        seriesData: seriesData,
        margin: margin
    });
}
function $9498f71ba797135a$export$a6d588001e949ed2() {
    const { width: width, height: height, margin: margin, xScale: xScale, yScale: yScale, xAccessor: xAccessor, yAccessor: yAccessor, seriesData: seriesData, data: data } = (0, $aEZ4R.useBarData)();
    const { showTooltip: showTooltip, tooltipData: tooltipData, tooltipOpen: tooltipOpen, hideTooltip: hideTooltip } = (0, $5uXOq.useContext)((0, $lrseF.default));
    return /*#__PURE__*/ (0, $2OMIu.jsx)($9498f71ba797135a$export$5ba4961e00f9d36, {
        tooltipOpen: tooltipOpen,
        showTooltip: showTooltip,
        hideTooltip: hideTooltip,
        tooltipData: tooltipData,
        width: width,
        height: height,
        xScale: xScale,
        yScale: yScale,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        data: data,
        seriesData: seriesData,
        margin: margin
    });
}

});
const $0277c50b98747247$export$69b1818e3c4e83f9 = '__XY_EVENT_SOURCE__';

parcelRegister("13b02", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c3e9a8e4cb9b40b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lI55a = parcelRequire("lI55a");
function $0c3e9a8e4cb9b40b$export$2e2bcd8739ae039(_ref) {
    let { source: source, onPointerOut: onPointerOut = true, onPointerMove: onPointerMove = true, onPointerUp: onPointerUp = true, onPointerDown: onPointerDown = true, onFocus: onFocus = false, onBlur: onBlur = false } = _ref;
    const emit = (0, $lI55a.default)();
    const emitPointerMove = (0, $5uXOq.useCallback)((event, datum)=>emit === null || emit === void 0 ? void 0 : emit('pointermove', event, source, datum), [
        emit,
        source
    ]);
    const emitPointerOut = (0, $5uXOq.useCallback)((event)=>emit === null || emit === void 0 ? void 0 : emit('pointerout', event, source), [
        emit,
        source
    ]);
    const emitPointerUp = (0, $5uXOq.useCallback)((event)=>emit === null || emit === void 0 ? void 0 : emit('pointerup', event, source), [
        emit,
        source
    ]);
    const emitPointerDown = (0, $5uXOq.useCallback)((event, datum)=>emit === null || emit === void 0 ? void 0 : emit('pointerdown', event, source, datum), [
        emit,
        source
    ]);
    const emitFocus = (0, $5uXOq.useCallback)((event)=>emit === null || emit === void 0 ? void 0 : emit('focus', event, source), [
        emit,
        source
    ]);
    const emitBlur = (0, $5uXOq.useCallback)((event)=>emit === null || emit === void 0 ? void 0 : emit('blur', event, source), [
        emit,
        source
    ]);
    return {
        onPointerMove: onPointerMove ? emitPointerMove : undefined,
        onFocus: onFocus ? emitFocus : undefined,
        onBlur: onBlur ? emitBlur : undefined,
        onPointerOut: onPointerOut ? emitPointerOut : undefined,
        onPointerUp: onPointerUp ? emitPointerUp : undefined,
        onPointerDown: onPointerDown ? emitPointerDown : undefined
    };
}

});

parcelRegister("3xZ2d", function(module, exports) {

$parcel$export(module.exports, "default", () => $2953cc62a817af6a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5yRts = parcelRequire("5yRts");

var $4grX0 = parcelRequire("4grX0");

var $lI55a = parcelRequire("lI55a");
const $2953cc62a817af6a$export$76917c244f8b44cb = '__POINTER_EVENTS_ALL';
const $2953cc62a817af6a$export$ee16f91d64c2973e = '__POINTER_EVENTS_NEAREST';
function $2953cc62a817af6a$export$1d0a87a519049f8c(event) {
    return !!event && ('clientX' in event || 'changedTouches' in event);
}
function $2953cc62a817af6a$export$9829d00ac5f2232d(event) {
    return !!event && !$2953cc62a817af6a$export$1d0a87a519049f8c(event);
}
function $2953cc62a817af6a$export$2e2bcd8739ae039(_ref) {
    let { findNearestDatum: findNearestDatumProps, onBlur: onBlur, onFocus: onFocus, onPointerMove: onPointerMove, onPointerOut: onPointerOut, onPointerUp: onPointerUp, onPointerDown: onPointerDown, allowedSources: allowedSources, width: width, height: height, margin: margin, data: data, xScale: xScale, yScale: yScale, xAccessor: xAccessor, yAccessor: yAccessor, seriesData: seriesData, horizontal: horizontal } = _ref;
    // this logic is shared by pointerup, pointermove, and focus handlers
    const getHandlerParams = (0, $5uXOq.useCallback)((params)=>{
        const { svgPoint: svgPoint, event: event } = params || {};
        // nearest Datum across all dataKeys, if relevant
        // let nearestDatumPointerParams: EventHandlerParams<Datum> | null = null;
        // let nearestDatumDistance = Infinity;
        if (params && event && svgPoint && width && height) {
            const findNearestFunction = !horizontal ? (0, $5yRts.default) : (0, $4grX0.default);
            const nearestDatum = findNearestFunction({
                height: height,
                data: data,
                point: {
                    x: svgPoint.x - margin.left,
                    y: svgPoint.y - margin.top
                },
                width: width,
                xAccessor: !horizontal ? xAccessor : yAccessor,
                xScale: xScale,
                yAccessor: !horizontal ? yAccessor : xAccessor,
                yScale: yScale
            });
            if (nearestDatum) {
                const access = xAccessor;
                // TODO: get all of the data nearest
                const pointerParams = [
                    {
                        svgPoint: svgPoint,
                        event: event,
                        ...nearestDatum,
                        nearestSeriesData: seriesData.get(access(nearestDatum === null || nearestDatum === void 0 ? void 0 : nearestDatum.datum))
                    }
                ];
                // dataKey === POINTER_EVENTS_NEAREST
                // console.log(pointerParams);
                //     ? [nearestDatumPointerParams]
                // : dataKey === POINTER_EVENTS_ALL || Array.isArray(dataKey)
                //   ? Object.values(pointerParamsByKey)
                //   : [pointerParamsByKey[dataKey]];
                return pointerParams.filter((param)=>param);
            } else {
                const pointerParams = [
                    {
                        svgPoint: svgPoint,
                        event: event,
                        datum: null
                    }
                ];
                return pointerParams.filter((param)=>param);
            }
        }
        return [];
    }, [
        data,
        xScale,
        yScale,
        width,
        height,
        (0, $5yRts.default)
    ]);
    const handlePointerMove = (0, $5uXOq.useCallback)((params)=>{
        if (onPointerMove) getHandlerParams(params).forEach((p)=>onPointerMove(p));
    }, [
        getHandlerParams,
        onPointerMove
    ]);
    const handlePointerUp = (0, $5uXOq.useCallback)((params)=>{
        if (onPointerUp) getHandlerParams(params).forEach((p)=>onPointerUp(p));
    }, [
        getHandlerParams,
        onPointerUp
    ]);
    const handlePointerDown = (0, $5uXOq.useCallback)((params)=>{
        if (onPointerDown) getHandlerParams(params).forEach((p)=>onPointerDown(p));
    }, [
        getHandlerParams,
        onPointerDown
    ]);
    const handleFocus = (0, $5uXOq.useCallback)((params)=>{
        if (onFocus) getHandlerParams(params).forEach((p)=>onFocus(p));
    }, [
        getHandlerParams,
        onFocus
    ]);
    const handlePointerOut = (0, $5uXOq.useCallback)((params)=>{
        const event = params === null || params === void 0 ? void 0 : params.event;
        if (event && $2953cc62a817af6a$export$1d0a87a519049f8c(event) && onPointerOut) onPointerOut(event);
    }, [
        onPointerOut
    ]);
    const handleBlur = (0, $5uXOq.useCallback)((params)=>{
        const event = params === null || params === void 0 ? void 0 : params.event;
        if (event && $2953cc62a817af6a$export$9829d00ac5f2232d(event) && onBlur) onBlur(event);
    }, [
        onBlur
    ]);
    (0, $lI55a.default)('pointermove', onPointerMove ? handlePointerMove : undefined, allowedSources);
    (0, $lI55a.default)('pointerout', onPointerOut ? handlePointerOut : undefined, allowedSources);
    (0, $lI55a.default)('pointerup', onPointerUp ? handlePointerUp : undefined, allowedSources);
    (0, $lI55a.default)('pointerdown', onPointerDown ? handlePointerDown : undefined, allowedSources);
    (0, $lI55a.default)('focus', onFocus ? handleFocus : undefined, allowedSources);
    (0, $lI55a.default)('blur', onBlur ? handleBlur : undefined, allowedSources);
}

});
parcelRegister("5yRts", function(module, exports) {

$parcel$export(module.exports, "default", () => $40c99b8ee82fea7e$export$2e2bcd8739ae039);

var $8EmVK = parcelRequire("8EmVK");
function $40c99b8ee82fea7e$export$2e2bcd8739ae039(_ref) {
    let { xScale: scale, xAccessor: accessor, yScale: yScale, yAccessor: yAccessor, point: point, data: data } = _ref;
    if (!point) return null;
    const nearestDatum = (0, $8EmVK.default)({
        scale: scale,
        accessor: accessor,
        scaledValue: point.x,
        data: data
    });
    return nearestDatum ? {
        datum: nearestDatum.datum,
        index: nearestDatum.index,
        distanceX: nearestDatum.distance,
        distanceY: Math.abs(Number(yScale(yAccessor(nearestDatum.datum))) - point.y)
    } : null;
}

});
parcelRegister("8EmVK", function(module, exports) {

$parcel$export(module.exports, "default", () => $64c3d8a41a163589$export$2e2bcd8739ae039);

var $hjll3 = parcelRequire("hjll3");
function $64c3d8a41a163589$export$2e2bcd8739ae039(_ref) {
    let { scale: scale, accessor: accessor, scaledValue: scaledValue, data: data } = _ref;
    const coercedScale = scale; // broaden type before type guards below
    let nearestDatum;
    let nearestDatumIndex;
    // if scale has .invert(), convert svg coord to nearest data value
    if ('invert' in coercedScale && typeof coercedScale.invert === 'function') {
        const bisect = (0, $hjll3.bisector)(accessor).left;
        // find closest data value, then map that to closest datum
        const dataValue = Number(coercedScale.invert(scaledValue));
        const index = bisect(data, dataValue);
        // take the two datum nearest this index, and compute which is closer
        const nearestDatum0 = data[index - 1];
        const nearestDatum1 = data[index];
        nearestDatum = !nearestDatum0 || Math.abs(dataValue - accessor(nearestDatum0)) > Math.abs(dataValue - accessor(nearestDatum1)) ? nearestDatum1 : nearestDatum0;
        nearestDatumIndex = nearestDatum === nearestDatum0 ? index - 1 : index;
    } else if ('step' in coercedScale && typeof coercedScale.step !== 'undefined') {
        // band scales don't have an invert function but they do have discrete domains
        // so we manually invert
        const domain = scale.domain();
        const range = scale.range().map(Number);
        // Remove the padding for the points
        // https://github.com/airbnb/visx/issues/1602
        // Need to consider
        const sortedRange = [
            ...range
        ].sort((a, b)=>a - b); // bisectLeft assumes sort
        const sortedDomain = range[0] < range[1] ? domain : domain.reverse();
        let domainValue = 0;
        if ('paddingInner' in scale) {
            // BandScale
            // Get the outer padding.
            const paddingOuter = scale(sortedDomain[0]) || 0;
            // Get each band size
            const eachBand = coercedScale.step();
            // Find the index
            const index = Math.floor((scaledValue - paddingOuter) / eachBand);
            // Get domain value
            domainValue = sortedDomain[Math.max(0, Math.min(index, sortedDomain.length - 1))];
        } else {
            // PointScale
            // Create ranges that take into account the padding of the first and last
            // elements. Basically if there is 0 padding then the first element
            // should go into the negative by 1/2 the step amount.
            const rangePoints = (0, $hjll3.range)(sortedRange[0] - coercedScale.step() * (0.5 - coercedScale.padding()), sortedRange[1] + coercedScale.step() * (0.5 - coercedScale.padding()), coercedScale.step());
            domainValue = sortedDomain[(0, $hjll3.bisectLeft)(rangePoints, scaledValue) - 1];
        }
        const index = data.findIndex((d)=>String(accessor(d)) === String(domainValue));
        nearestDatum = data[index];
        nearestDatumIndex = index;
    } else {
        console.warn('[visx/xychart/findNearestDatum] encountered incompatible scale type, bailing');
        return null;
    }
    if (nearestDatum == null || nearestDatumIndex == null) return null;
    const distance = Math.abs(Number(coercedScale(accessor(nearestDatum))) - scaledValue);
    return {
        datum: nearestDatum,
        index: nearestDatumIndex,
        distance: distance
    };
}

});


parcelRegister("4grX0", function(module, exports) {

$parcel$export(module.exports, "default", () => $31ae567ddf80c493$export$2e2bcd8739ae039);

var $8EmVK = parcelRequire("8EmVK");
function $31ae567ddf80c493$export$2e2bcd8739ae039(_ref) {
    let { yScale: scale, yAccessor: accessor, xScale: xScale, xAccessor: xAccessor, point: point, data: data } = _ref;
    if (!point) return null;
    const nearestDatum = (0, $8EmVK.default)({
        scale: scale,
        accessor: accessor,
        scaledValue: point.y,
        data: data
    });
    return nearestDatum ? {
        datum: nearestDatum.datum,
        index: nearestDatum.index,
        distanceY: nearestDatum.distance,
        distanceX: Math.abs(Number(xScale(xAccessor(nearestDatum.datum))) - point.x)
    } : null;
}

});


parcelRegister("aEZ4R", function(module, exports) {

$parcel$export(module.exports, "BarDataProvider", () => $7c2d04805347e364$export$b2c9e5e1e06afcc9);
$parcel$export(module.exports, "useBarData", () => $7c2d04805347e364$export$315829aab2a8c649);

var $5uXOq = parcelRequire("5uXOq");

var $PfPCm = parcelRequire("PfPCm");

var $cgmj2 = parcelRequire("cgmj2");

var $ggVTz = parcelRequire("ggVTz");

var $2OMIu = parcelRequire("2OMIu");
const $7c2d04805347e364$var$DataContext = /*#__PURE__*/ (0, $5uXOq.createContext)({});
function $7c2d04805347e364$export$b2c9e5e1e06afcc9(_ref) {
    let { children: children, ...props } = _ref;
    const { showPatterns: showPatterns } = (0, $PfPCm.useMenuData)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgmj2.Theme), {
        fillStyles: (0, $cgmj2.DEFAULT_ORDINAL_COLORS),
        enableDefaultPatterns: showPatterns,
        useThemeFillStyles: (0, $cgmj2.useThemeFillStyles),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ggVTz.BarScalesElement), {
            ...props,
            children: (scales)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($7c2d04805347e364$var$DataContext.Provider, {
                        value: {
                            ...props,
                            ...scales
                        },
                        children: children
                    })
                })
        })
    });
}
function $7c2d04805347e364$export$315829aab2a8c649() {
    return (0, $5uXOq.useContext)($7c2d04805347e364$var$DataContext);
}

});


parcelRegister("fAwZ6", function(module, exports) {

$parcel$export(module.exports, "PureBarChart", () => $b593cdda4009ff24$export$1870517ff3080193);

var $5uXOq = parcelRequire("5uXOq");

var $cMmlP = parcelRequire("cMmlP");

var $hi6Wp = parcelRequire("hi6Wp");

var $dnJJh = parcelRequire("dnJJh");

var $8j5jo = parcelRequire("8j5jo");

var $dluWU = parcelRequire("dluWU");

var $4zOFu = parcelRequire("4zOFu");

var $7RF0L = parcelRequire("7RF0L");

var $5jWQu = parcelRequire("5jWQu");

var $h3rAq = parcelRequire("h3rAq");

var $F3H4n = parcelRequire("F3H4n");

var $dcOT3 = parcelRequire("dcOT3");

var $4HTJ0 = parcelRequire("4HTJ0");

var $cKYPp = parcelRequire("cKYPp");

var $aEZ4R = parcelRequire("aEZ4R");

var $2OMIu = parcelRequire("2OMIu");
function $b593cdda4009ff24$var$defaultColorAccessor() {
    return (_)=>'';
}
function $b593cdda4009ff24$var$useAccessors(_ref) {
    let { xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor } = _ref;
    // GENERATE ENCODINGS
    const [x, y, color] = (0, $5uXOq.useMemo)(()=>{
        const [x] = (0, $8j5jo.useSafeAccessors)(xAccessor);
        const [y] = (0, $8j5jo.useSafeAccessors)(yAccessor);
        const [color] = (0, $8j5jo.useSafeAccessors)(colorAccessor);
        return [
            x,
            y,
            color
        ];
    }, [
        xAccessor,
        yAccessor,
        colorAccessor
    ]);
    return {
        x: x,
        y: y,
        color: color
    };
}
function $b593cdda4009ff24$export$1870517ff3080193(_ref2) {
    let { data: data, width: width, height: height, xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, margin: margin = (0, $dluWU.DEFAULT_MARGIN), svgRef: svgRef } = _ref2;
    // TODO: move this to container so the dimentions returned are already correct
    const [plotHeight, plotWidth] = (0, $5uXOq.useMemo)(()=>[
            Math.max(0, height - margin.top - margin.bottom),
            Math.max(0, width - margin.left - margin.right)
        ], [
        height,
        margin,
        width
    ]);
    const { x: x, y: y, color: color } = $b593cdda4009ff24$var$useAccessors({
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        colorAccessor: colorAccessor || $b593cdda4009ff24$var$defaultColorAccessor()
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $aEZ4R.BarDataProvider), {
        data: data,
        width: plotWidth,
        height: plotHeight,
        x: x,
        y: y,
        xAccessor: x,
        yAccessor: y,
        color: color,
        colorAccessor: color,
        margin: margin,
        children: [
            colorAccessor && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $F3H4n.BarLegend), {}),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cMmlP.default), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4zOFu.BarAxes), {}),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h3rAq.BarGrid), {}),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hi6Wp.default), {
                        innerRef: svgRef,
                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dnJJh.default), {
                            top: margin.top,
                            left: margin.left,
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dcOT3.BarPatterns), {}),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7RF0L.BarMarkSlot), {}),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cKYPp.BarTooltipOverlay), {}),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cKYPp.BarTooltipOverlayEmitter), {})
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4HTJ0.BarTooltip), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5jWQu.DataTable), {})
        ]
    });
}

});
parcelRegister("cMmlP", function(module, exports) {

$parcel$export(module.exports, "default", () => $94db4e2c58c24248$export$2e2bcd8739ae039);
/* CartesianGrid.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $2OMIu = parcelRequire("2OMIu");
function $94db4e2c58c24248$export$2e2bcd8739ae039(_ref) {
    let { children: children } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _16jlkb7n _1tkeidpf _1ul9idpf"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                "_1e0c11p5 _yv0ey09t _2z051qft _zulp1nty _1lmcpu6d _1ul9idpf _1tkeidpf _1bsb1osq _4t3i1osq"
            ]),
            children: children
        })
    });
}

});

parcelRegister("hi6Wp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c96980735a92a865$export$2e2bcd8739ae039);
/* Plot.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $bT1Sw = parcelRequire("bT1Sw");

var $2OMIu = parcelRequire("2OMIu");
var $c96980735a92a865$export$2e2bcd8739ae039 = (0, $bT1Sw.element)(function Plot(_ref) {
    let { top: top = 0, left: left = 0, width: width = '100%', height: height = '100%', transform: transform, children: children, innerRef: innerRef, ...restProps } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            ref: innerRef,
            width: width,
            height: height,
            transform: transform || `translate(${left}, ${top})`,
            ...restProps,
            className: (0, $bwpsq.default)([
                "_nd5lah6b _16jlkb7n _1ul9idpf _1tkeidpf _1reoewfl _18m9ewfl _1pbyidpf"
            ]),
            children: children
        })
    });
});

});

parcelRegister("8j5jo", function(module, exports) {

$parcel$export(module.exports, "useSafeAccessors", () => $60c437dea181ada7$export$1ff31c13ab3c61e1);
$parcel$export(module.exports, "getFirstItem", () => $60c437dea181ada7$export$fbdeaa6a76694f71);
$parcel$export(module.exports, "getSecondItem", () => $60c437dea181ada7$export$18f9732b2021233c);
function $60c437dea181ada7$export$227cf200245550ef(accessor) {
    if (typeof accessor === 'string') {
        function s(d) {
            try {
                return d[accessor];
            } catch  {
                return 0;
            }
        }
        return s;
    } else if (typeof accessor === 'number') {
        function s1(d) {
            try {
                return d[accessor];
            } catch  {
                return 0;
            }
        }
        return s1;
    }
    function s2(d) {
        try {
            return accessor instanceof Function ? accessor(d) : 0;
        } catch  {
            return 0;
        }
    }
    return s2;
}
function $60c437dea181ada7$export$1ff31c13ab3c61e1() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return args.map((d)=>$60c437dea181ada7$export$227cf200245550ef(d));
}
function $60c437dea181ada7$export$3a667a3b7e4d6701(l) {
    return typeof (l === null || l === void 0 ? void 0 : l.x) === 'number' ? l === null || l === void 0 ? void 0 : l.x : 0;
}
function $60c437dea181ada7$export$337238c011325465(l) {
    return typeof (l === null || l === void 0 ? void 0 : l.y) === 'number' ? l === null || l === void 0 ? void 0 : l.y : 0;
}
function $60c437dea181ada7$export$dd2b6e807fb37ba3(l) {
    return l === null || l === void 0 ? void 0 : l.source;
}
function $60c437dea181ada7$export$c22522a4dfa48e9c(l) {
    return l === null || l === void 0 ? void 0 : l.target;
}
function $60c437dea181ada7$export$fbdeaa6a76694f71(d) {
    return d === null || d === void 0 ? void 0 : d[0];
}
function $60c437dea181ada7$export$18f9732b2021233c(d) {
    return d === null || d === void 0 ? void 0 : d[1];
}

});

parcelRegister("4zOFu", function(module, exports) {

$parcel$export(module.exports, "BarAxes", () => $3551bbeee5340be1$export$2212d638e9c7f00f);

var $hqZma = parcelRequire("hqZma");

var $cXzUG = parcelRequire("cXzUG");

var $aEZ4R = parcelRequire("aEZ4R");

var $2OMIu = parcelRequire("2OMIu");
function $3551bbeee5340be1$export$2212d638e9c7f00f() {
    const { xScale: xScale, yScale: yScale, height: height, width: width } = (0, $aEZ4R.useBarData)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hqZma.AxisBottom), {
                scale: xScale,
                top: height,
                left: width
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cXzUG.AxisLeft), {
                scale: yScale
            })
        ]
    });
}

});

parcelRegister("7RF0L", function(module, exports) {

$parcel$export(module.exports, "BarGroup", () => $5b9d4ba7b0c88f2a$export$54ef77743fe39325);
$parcel$export(module.exports, "BarMarkSlot", () => $5b9d4ba7b0c88f2a$export$a8a51762e68574d8);

var $bT1Sw = parcelRequire("bT1Sw");

var $dnJJh = parcelRequire("dnJJh");

var $aEZ4R = parcelRequire("aEZ4R");

var $arL7j = parcelRequire("arL7j");

var $dwg9t = parcelRequire("dwg9t");

var $cp7lx = parcelRequire("cp7lx");

var $2OMIu = parcelRequire("2OMIu");
const $5b9d4ba7b0c88f2a$export$54ef77743fe39325 = (0, $bT1Sw.element)(function BarGroup(_ref) {
    let { data: data, top: top, left: left, xScale: xScale, yScale: yScale, colorScale: colorScale, groupScale: groupScale, colorAccessor: colorAccessor, groupAccessor: groupAccessor, valueAccessor: valueAccessor, xAccessor: xAccessor } = _ref;
    const barGroups = (0, $cp7lx.getBarGroups)(data, groupScale, xScale, yScale, colorScale, groupAccessor, valueAccessor, colorAccessor, xAccessor);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dnJJh.default), {
        top: top,
        left: left,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dwg9t.BarGroupMarks), {
                barGroups: barGroups,
                roundedCorners: true
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $arL7j.BarGroupMarkLabels), {
                barGroups: barGroups,
                hide: true
            })
        ]
    });
});
function $5b9d4ba7b0c88f2a$export$a8a51762e68574d8() {
    const { data: data, xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, colorScale: colorScale, groupScale: groupScale, xScale: xScale, yScale: yScale } = (0, $aEZ4R.useBarData)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($5b9d4ba7b0c88f2a$export$54ef77743fe39325, {
        data: data,
        groupScale: groupScale,
        xScale: xScale,
        yScale: yScale,
        colorScale: colorScale,
        xAccessor: xAccessor,
        valueAccessor: yAccessor,
        colorAccessor: colorAccessor,
        groupAccessor: colorAccessor
    });
}

});
parcelRegister("cp7lx", function(module, exports) {

$parcel$export(module.exports, "getBarGroups", () => $907d84b07dc8893a$export$b0379c1526b79abe);

var $hjll3 = parcelRequire("hjll3");
function $907d84b07dc8893a$var$getScaleBandwidth(scale) {
    return 'bandwidth' in scale ? scale.bandwidth() : 0;
}
function $907d84b07dc8893a$export$b0379c1526b79abe(data, groupScale, xScale, yScale, colorScale, groupAccessor, valueAccessor, colorAccessor, xAccessor) {
    const barWidth = $907d84b07dc8893a$var$getScaleBandwidth(groupScale);
    const groups = (0, $hjll3.group)(data, groupAccessor);
    const barGroups = Array.from(groups).map((_ref, i)=>{
        let [key, entries] = _ref;
        return {
            index: i,
            x0: groupScale(key),
            bars: entries.map((d, j)=>{
                var _yScale;
                return {
                    index: j,
                    key: key,
                    datum: d,
                    width: barWidth,
                    xValue: xAccessor(d) || 0,
                    yValue: valueAccessor(d) || 0,
                    x: xScale(xAccessor(d)) || 0,
                    y: yScale(valueAccessor(d)) || 0,
                    label: colorAccessor(d) || '',
                    color: colorScale(colorAccessor(d)),
                    height: yScale.range()[0] - ((_yScale = yScale(valueAccessor(d))) !== null && _yScale !== void 0 ? _yScale : yScale.range()[0])
                };
            })
        };
    });
    return barGroups;
}

});


parcelRegister("5jWQu", function(module, exports) {

$parcel$export(module.exports, "DataTable", () => $3dfc5f9b9010c7cb$export$df30df7ec97b32b5);

var $5uXOq = parcelRequire("5uXOq");

var $PfPCm = parcelRequire("PfPCm");

var $aEZ4R = parcelRequire("aEZ4R");

var $2OMIu = parcelRequire("2OMIu");

const $3dfc5f9b9010c7cb$var$LazyDataTableModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>Promise.resolve((parcelRequire("lOXm0"))).then((module)=>({
            default: module.DataTableModal
        })));
function $3dfc5f9b9010c7cb$export$df30df7ec97b32b5() {
    const { showDataTable: showDataTable, closeDataTable: closeDataTable } = (0, $PfPCm.useMenuData)();
    const { data: data } = (0, $aEZ4R.useBarData)();
    return showDataTable ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            style: {
                visibility: 'hidden'
            }
        }),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($3dfc5f9b9010c7cb$var$LazyDataTableModal, {
            data: data,
            closeModal: closeDataTable
        })
    }) : null;
}

});

parcelRegister("h3rAq", function(module, exports) {

$parcel$export(module.exports, "BarGrid", () => $c6a81d93c24dd46f$export$fb11aa615404ad71);

var $erST8 = parcelRequire("erST8");

var $aEZ4R = parcelRequire("aEZ4R");

var $2OMIu = parcelRequire("2OMIu");
function $c6a81d93c24dd46f$export$fb11aa615404ad71() {
    const { xScale: xScale, yScale: yScale, height: height, width: width } = (0, $aEZ4R.useBarData)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $erST8.Grid), {
        rowLineStyle: "solid",
        columnLineStyle: "hidden",
        xScale: xScale,
        yScale: yScale,
        width: width,
        height: height
    });
}

});

parcelRegister("F3H4n", function(module, exports) {

$parcel$export(module.exports, "BarLegend", () => $07b6b1efa859beb0$export$9a281618489c171);

var $3B9ij = parcelRequire("3B9ij");

var $aEZ4R = parcelRequire("aEZ4R");

var $2OMIu = parcelRequire("2OMIu");
function $07b6b1efa859beb0$export$9a281618489c171() {
    const { data: data, colorAccessor: colorAccessor, colorScale: colorScale } = (0, $aEZ4R.useBarData)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3B9ij.OrdinalLegend), {
        shape: "square",
        data: data,
        colorScale: colorScale,
        colorAccessor: colorAccessor,
        labelAccessor: colorAccessor
    });
}

});

parcelRegister("dcOT3", function(module, exports) {

$parcel$export(module.exports, "BarPatterns", () => $99d3de702876114d$export$73f9b7830d32a61e);

var $epG85 = parcelRequire("epG85");

var $17PP9 = parcelRequire("17PP9");

var $PfPCm = parcelRequire("PfPCm");

var $cgmj2 = parcelRequire("cgmj2");

var $2OMIu = parcelRequire("2OMIu");
const $99d3de702876114d$export$73f9b7830d32a61e = ()=>{
    const { patternDefs: patternDefs } = (0, $17PP9.useElementProps)((0, $epG85.default).elements.Theme);
    const { showPatterns: showPatterns } = (0, $PfPCm.useMenuData)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: showPatterns ? (0, $cgmj2.DEFAULT_ORDINAL_PATTERNS_DEFS) : patternDefs
    });
};

});

parcelRegister("4HTJ0", function(module, exports) {

$parcel$export(module.exports, "BarTooltip", () => $36d66762af5c6a24$export$f509e97905f1d31f);

var $5uXOq = parcelRequire("5uXOq");

var $lrseF = parcelRequire("lrseF");

var $2pOyr = parcelRequire("2pOyr");

var $aEZ4R = parcelRequire("aEZ4R");

var $2OMIu = parcelRequire("2OMIu");
function $36d66762af5c6a24$export$f509e97905f1d31f() {
    const { xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, colorScale: colorScale } = (0, $aEZ4R.useBarData)();
    const { tooltipData: tooltipData, tooltipLeft: tooltipLeft, tooltipTop: tooltipTop } = (0, $5uXOq.useContext)((0, $lrseF.default));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2pOyr.MultiSeriesTooltip), {
        tooltipData: tooltipData,
        tooltipLeft: tooltipLeft,
        tooltipTop: tooltipTop,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        colorAccessor: colorAccessor,
        colorScale: colorScale
    });
}

});



parcelRegister("eqDul", function(module, exports) {

$parcel$export(module.exports, "BarStackHorizontal", () => $a8121ff57f946b14$export$2d5bf908777c40fd);

var $bT1Sw = parcelRequire("bT1Sw");
var $17PP9 = parcelRequire("17PP9");

var $dnJJh = parcelRequire("dnJJh");

var $8j5jo = parcelRequire("8j5jo");

var $7RF0L = parcelRequire("7RF0L");

var $hKzok = parcelRequire("hKzok");

var $5Yue6 = parcelRequire("5Yue6");

var $svh8v = parcelRequire("svh8v");

var $j6Ghb = parcelRequire("j6Ghb");

var $2OMIu = parcelRequire("2OMIu");
function $a8121ff57f946b14$var$BarStackHorizontal(props) {
    const { data: data, top: top, left: left, x0: x0 = (0, $8j5jo.getFirstItem), x1: x1 = (0, $8j5jo.getSecondItem), xScale: xScale, yScale: yScale, colorScale: colorScale, xAccessor: xAccessor, colorAccessor: colorAccessor, valueAccessor: valueAccessor, order: order, offset: offset } = (0, $17PP9.useElementProps)((0, $7RF0L.BarGroup), {
        mergeWith: props
    });
    const scaleProps = (0, $17PP9.useElementProps)((0, $svh8v.BarStackHorizontalScalesElement));
    const barStacks = (0, $j6Ghb.getHorizontalBarStacks)(data, order, scaleProps.normalize ? 'expand' : offset, xAccessor, colorAccessor, valueAccessor, xScale, yScale, colorScale, x0, x1);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dnJJh.default), {
        top: top,
        left: left,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5Yue6.BarStackHorizontalMarks), {
                barStacks: barStacks,
                roundedCorners: true
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hKzok.BarStackHorizontalLabels), {
                barStacks: barStacks,
                hide: true
            })
        ]
    });
}
const $a8121ff57f946b14$export$2d5bf908777c40fd = (0, $bT1Sw.element)($a8121ff57f946b14$var$BarStackHorizontal, {
    as: (0, $7RF0L.BarGroup)
});

});
parcelRegister("hKzok", function(module, exports) {

$parcel$export(module.exports, "BarStackHorizontalLabels", () => $cec22f8f3895a18c$export$8420bc814add736c);

var $bT1Sw = parcelRequire("bT1Sw");

var $8WT90 = parcelRequire("8WT90");

var $dnJJh = parcelRequire("dnJJh");

var $2OMIu = parcelRequire("2OMIu");
const $cec22f8f3895a18c$export$8420bc814add736c = (0, $bT1Sw.element)(function BarStackHorizontalLabels(_ref) {
    let { barStacks: barStacks, hide: hide } = _ref;
    if (hide) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dnJJh.default), {
        children: barStacks.map((barStack)=>barStack.bars.map((bar)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $8WT90.ValueLabel), {
                    x: bar.x + bar.width / 2,
                    y: bar.y + bar.height / 2,
                    color: bar.color,
                    children: bar.xValue.toString()
                }, `bar-stack-label-${barStack.index}-${bar.index}`)))
    });
});

});

parcelRegister("5Yue6", function(module, exports) {

$parcel$export(module.exports, "BarStackHorizontalMarks", () => $459a00b49c1cf703$export$47fb35cb4deec2c6);

var $bT1Sw = parcelRequire("bT1Sw");

var $iTGbP = parcelRequire("iTGbP");

var $dnJJh = parcelRequire("dnJJh");

var $dluWU = parcelRequire("dluWU");

var $2OMIu = parcelRequire("2OMIu");
const $459a00b49c1cf703$export$47fb35cb4deec2c6 = (0, $bT1Sw.element)(function BarStackHorizontalMarks(_ref) {
    let { barStacks: barStacks, roundedCorners: roundedCorners = true, stackGap: stackGap = true, baseRoundedCorners: baseRoundedCorners } = _ref;
    const gap = stackGap ? (0, $dluWU.STACK_GAP) : 0;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dnJJh.default), {
        children: barStacks.map((barStack, i)=>{
            return barStack.bars.map((bar, j)=>{
                const cornerRadius = bar.rounded && bar.height > 2 * (0, $dluWU.CORNER_RADIUS_VALUE).SMALL && bar.width > 2 * (0, $dluWU.CORNER_RADIUS_VALUE).SMALL ? (0, $dluWU.CORNER_RADIUS_VALUE).SMALL : (0, $dluWU.CORNER_RADIUS_VALUE).NONE;
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iTGbP.Bar), {
                    ariaLabel: `${bar.label}, x: ${bar.xValue}, y: ${bar.yValue}`,
                    x: bar.width - gap > 0 ? bar.x + gap : bar.x,
                    y: bar.y,
                    height: bar.height,
                    datum: bar.datum,
                    width: bar.width - gap > 0 ? bar.width - gap : bar.width,
                    fill: bar.color,
                    cornerRadius: {
                        ...(bar.x !== 0 || barStack.bars.length === 1) && roundedCorners ? {
                            topRight: cornerRadius,
                            bottomRight: cornerRadius
                        } : {},
                        ...bar.x === 0 && baseRoundedCorners ? {
                            topLeft: cornerRadius,
                            bottomLeft: cornerRadius
                        } : {}
                    }
                }, `bar-stack-${i}-${j}-${bar.label}-${bar.yValue}`);
            });
        })
    });
});

});

parcelRegister("svh8v", function(module, exports) {

$parcel$export(module.exports, "BarStackHorizontalScalesElement", () => $055ae047f0407afd$export$e34766ab787cd8ac);

var $hjll3 = parcelRequire("hjll3");

var $5uXOq = parcelRequire("5uXOq");

var $bT1Sw = parcelRequire("bT1Sw");
var $17PP9 = parcelRequire("17PP9");

var $5pfgu = parcelRequire("5pfgu");
var $juXo4 = parcelRequire("juXo4");

var $cgmj2 = parcelRequire("cgmj2");

var $ggVTz = parcelRequire("ggVTz");
/** Public props */ function $055ae047f0407afd$var$BarStackHorizontalScalesElement(props) {
    const { data: data, x: x, y: y, color: color, width: width, height: height, yDomain: yDomain, timeUnit: timeUnit, normalize: normalize, children: children } = (0, $17PP9.useElementProps)((0, $ggVTz.BarScalesElement), {
        mergeWith: props
    });
    const { fillStyles: fillStyles, enableDefaultPatterns: enableDefaultPatterns, useThemeFillStyles: useThemeFillStyles } = (0, $17PP9.useElementProps)((0, $cgmj2.Theme));
    const totalYValue = (0, $ggVTz.useMaximumYValue)(data || [], x, y, true);
    const value = (0, $5uXOq.useMemo)(()=>{
        const xScaleRange = [
            height,
            0
        ];
        const xScalePadding = 0.25;
        const xScale = (0, $ggVTz.calculateXScaleDomain)({
            xData: data.map(x),
            timeUnit: timeUnit,
            range: xScaleRange,
            padding: xScalePadding
        });
        const yScale = (0, $5pfgu.default)({
            domain: (0, $ggVTz.calculateYDomain)({
                totalYValue: totalYValue,
                yDomain: yDomain,
                normalize: normalize
            }),
            range: [
                0,
                width
            ]
        });
        const { domain: domain, range: range } = useThemeFillStyles({
            fillStyles: fillStyles,
            enableDefaultPatterns: enableDefaultPatterns
        });
        const colorScale = (0, $juXo4.default)({
            domain: domain ? domain : data.map(color),
            range: range
        });
        const seriesData = (0, $hjll3.group)(data, x);
        return {
            xScale: yScale,
            yScale: xScale,
            colorScale: colorScale,
            seriesData: seriesData
        };
    }, [
        data,
        width,
        height,
        totalYValue,
        x,
        yDomain,
        timeUnit,
        fillStyles,
        enableDefaultPatterns
    ]);
    return children(value);
}
const $055ae047f0407afd$export$e34766ab787cd8ac = (0, $bT1Sw.element)($055ae047f0407afd$var$BarStackHorizontalScalesElement, {
    as: (0, $ggVTz.BarScalesElement)
});

});

parcelRegister("j6Ghb", function(module, exports) {

$parcel$export(module.exports, "getHorizontalBarStacks", () => $de8f5f08526a5f80$export$7ddaf0c6d616b50f);

var $hjll3 = parcelRequire("hjll3");

var $6jSGb = parcelRequire("6jSGb");

var $jnT5G = parcelRequire("jnT5G");

var $7ars3 = parcelRequire("7ars3");
function $de8f5f08526a5f80$export$7ddaf0c6d616b50f(data, order, offset, xAccessor, colorAccessor, valueAccessor, xScale, yScale, colorScale, x0, x1) {
    const keyUnion = (0, $hjll3.union)(data.map((d)=>colorAccessor(d)));
    // Keys cannot be duplicate here.
    const indexData = (0, $hjll3.index)(data, (d)=>xAccessor(d), (d)=>colorAccessor(d));
    // TODO: Fix these data definitions
    const stack = (0, $hjll3.stack)().keys(keyUnion).value((_ref, key)=>{
        let [, group] = _ref;
        return valueAccessor(group.get(key));
    });
    if (order) stack.order((0, $7ars3.default)(order));
    if (offset) stack.offset((0, $jnT5G.default)(offset));
    const stacks = stack(indexData);
    const barHeight = (0, $6jSGb.default)(yScale);
    const barStacks = stacks.reduce((stack, categoryStack)=>{
        categoryStack.forEach((bar)=>{
            const key = bar.data[0];
            const barWidth = (xScale(x1(bar)) || 0) - (xScale(x0(bar)) || 0);
            const barX = xScale(x0(bar));
            const barY = 'bandwidth' in xScale ? yScale(bar.data[0]) : Math.max(yScale(bar.data[0]) || 0);
            if (!stack.hasOwnProperty(key)) stack[key] = {
                key: key,
                bars: []
            };
            if (barWidth !== 0) stack[key].bars.forEach((bar)=>{
                bar.rounded = false;
            });
            stack[key].bars.push({
                bar: bar,
                key: categoryStack.key,
                datum: bar.data[1].get(categoryStack.key),
                height: barHeight,
                width: barWidth,
                yValue: bar.data[0],
                xValue: x1(bar) - x0(bar),
                label: categoryStack.key,
                x: barX || 0,
                y: barY || 0,
                color: colorScale(categoryStack.key),
                rounded: barWidth !== 0
            });
            if (stack[key].bars.length > 0) stack[key].bars[0].rounded = true;
        });
        return stack;
    }, {});
    return Object.values(barStacks);
}

});
parcelRegister("jnT5G", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1cae62defdc6054$export$2e2bcd8739ae039);

var $hjll3 = parcelRequire("hjll3");
const $e1cae62defdc6054$export$b29440972ed4e3cc = {
    expand: (0, $hjll3.stackOffsetExpand),
    diverging: (0, $hjll3.stackOffsetDiverging),
    none: (0, $hjll3.stackOffsetNone),
    silhouette: (0, $hjll3.stackOffsetSilhouette),
    wiggle: (0, $hjll3.stackOffsetWiggle)
};
const $e1cae62defdc6054$export$f80b76cb2a25b919 = Object.keys($e1cae62defdc6054$export$b29440972ed4e3cc);
function $e1cae62defdc6054$export$2e2bcd8739ae039(offset) {
    return offset && $e1cae62defdc6054$export$b29440972ed4e3cc[offset] || $e1cae62defdc6054$export$b29440972ed4e3cc.none;
}

});

parcelRegister("7ars3", function(module, exports) {

$parcel$export(module.exports, "default", () => $537ec2d9368eb996$export$2e2bcd8739ae039);

var $hjll3 = parcelRequire("hjll3");
const $537ec2d9368eb996$export$f142d556a99f483c = {
    ascending: (0, $hjll3.stackOrderAscending),
    descending: (0, $hjll3.stackOrderDescending),
    insideout: (0, $hjll3.stackOrderInsideOut),
    none: (0, $hjll3.stackOrderNone),
    reverse: (0, $hjll3.stackOrderReverse)
};
const $537ec2d9368eb996$export$82f7741b5fe7f581 = Object.keys($537ec2d9368eb996$export$f142d556a99f483c);
function $537ec2d9368eb996$export$2e2bcd8739ae039(order) {
    return order && $537ec2d9368eb996$export$f142d556a99f483c[order] || $537ec2d9368eb996$export$f142d556a99f483c.none;
}

});




parcelRegister("153fj", function(module, exports) {

$parcel$export(module.exports, "useSectionAnalytics", () => $f836f36e20851550$export$97a66dbbb82ca183);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $f836f36e20851550$export$97a66dbbb82ca183 = (sectionId, boundaryId)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireSectionAnalytics = (0, $5uXOq.useCallback)((target, attributes)=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'item clicked', 'summarySection', {
            ...attributes,
            sectionId: sectionId,
            boundaryId: boundaryId,
            target: target
        }), [
        sectionId,
        boundaryId,
        createAnalyticsEvent
    ]);
    const fireOverviewCardAnalytics = (0, $5uXOq.useCallback)((target, attributes)=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'summaryOverviewCard', {
            ...attributes,
            sectionId: sectionId,
            boundaryId: boundaryId,
            target: target
        }), [
        sectionId,
        boundaryId,
        createAnalyticsEvent
    ]);
    return {
        fireSectionAnalytics: fireSectionAnalytics,
        fireOverviewCardAnalytics: fireOverviewCardAnalytics
    };
};

});

parcelRegister("4BeU4", function(module, exports) {

$parcel$export(module.exports, "ChartWithHeaderContainer", () => $5c5b0db8de97b4ad$export$355d25f97152818f);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $5c5b0db8de97b4ad$export$355d25f97152818f = ({ header: header, chart: chart })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $5c5b0db8de97b4ad$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, header), chart);
};
const $5c5b0db8de97b4ad$var$containerStyles = (0, $8CUq3.xcss)({
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.200'
});

});

parcelRegister("hKvdY", function(module, exports) {

$parcel$export(module.exports, "EmptyState", () => $dde18b702b6a886a$export$fddf379e22a74b00);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");
const $dde18b702b6a886a$export$fddf379e22a74b00 = ({ icon: icon, headingText: headingText, descriptionText: descriptionText, actionButton: actionButton })=>{
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _2lx21bp4 _4t3i1osq"
        ])
    }, icon, /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            "_p12f1kdj _y3gn1h6o"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $l1N8i.default), {
        size: "small",
        as: "h2"
    }, headingText), /*#__PURE__*/ $5uXOq.createElement((0, $cgL5K.default), null, descriptionText)), actionButton && /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $dde18b702b6a886a$var$actionButtonContainerStyles
    }, actionButton));
};
const $dde18b702b6a886a$var$containerStyles = null;
const $dde18b702b6a886a$var$textContainerStyles = null;
const $dde18b702b6a886a$var$actionButtonContainerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.300'
});

});

parcelRegister("1mhpE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f02741c1f14dc07$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8f02741c1f14dc07$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "contextual-summary.project-summary.epic-progress.title",
        "defaultMessage": "{hierarchyName} progress"
    },
    description: {
        "id": "contextual-summary.project-summary.epic-progress.description",
        "defaultMessage": "See how your epics are progressing at a glance. <link>View all epics</link>"
    },
    emptyDescription: {
        "id": "contextual-summary.project-summary.epic-progress.empty-description",
        "defaultMessage": "Use epics to track larger initiatives in your project. <link>What is an epic?</link>"
    },
    defaultHierarchyName: {
        "id": "contextual-summary.project-summary.epic-progress.default-hierarchy-name",
        "defaultMessage": "Epic"
    },
    doneLabel: {
        "id": "contextual-summary.project-summary.epic-progress.done-label",
        "defaultMessage": "Done"
    },
    inProgressLabel: {
        "id": "contextual-summary.project-summary.epic-progress.in-progress-label",
        "defaultMessage": "In progress"
    },
    toDoLabel: {
        "id": "contextual-summary.project-summary.epic-progress.to-do-label",
        "defaultMessage": "To do"
    }
});

});


parcelRegister("eCxQU", function(module, exports) {

$parcel$export(module.exports, "OverviewCount", () => $0e9b79543ce622c0$export$2a9564a2b64c3ef1);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $3fesp = parcelRequire("3fesp");

var $34OIV = parcelRequire("34OIV");

var $4sHph = parcelRequire("4sHph");

var $gbB8m = parcelRequire("gbB8m");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");


var $ousew = parcelRequire("ousew");

var $hDzhb = parcelRequire("hDzhb");

var $79GHn = parcelRequire("79GHn");

var $beAwS = parcelRequire("beAwS");

var $153fj = parcelRequire("153fj");

var $l3nh3 = parcelRequire("l3nh3");
const $0e9b79543ce622c0$var$ICON_CONFIG_FOR_TYPE = {
    done: [
        (0, (/*@__PURE__*/$parcel$interopDefault($34OIV))),
        "var(--ds-icon-accent-lime, #6A9A23)",
        (0, $8CUq3.xcss)({
            backgroundColor: 'color.background.accent.lime.subtlest'
        })
    ],
    updated: [
        (0, (/*@__PURE__*/$parcel$interopDefault($4sHph))),
        "var(--ds-icon-subtle, #626F86)",
        (0, $8CUq3.xcss)({
            backgroundColor: 'elevation.surface.sunken'
        })
    ],
    created: [
        (0, (/*@__PURE__*/$parcel$interopDefault($gbB8m))),
        "var(--ds-icon-subtle, #626F86)",
        (0, $8CUq3.xcss)({
            backgroundColor: 'elevation.surface.sunken'
        })
    ],
    due: [
        (0, (/*@__PURE__*/$parcel$interopDefault($3fesp))),
        "var(--ds-icon-accent-red, #C9372C)",
        (0, $8CUq3.xcss)({
            backgroundColor: 'color.background.accent.red.subtlest'
        })
    ]
};
const $0e9b79543ce622c0$var$ICON_CONFIG_FOR_EMPTY = [
    "var(--ds-icon-subtle, #626F86)",
    (0, $8CUq3.xcss)({
        backgroundColor: 'elevation.surface.sunken'
    })
];
const $0e9b79543ce622c0$var$REDIRECT_URL_OPTIONS_FOR_TYPE = {
    done: {
        filter: (0, $cd053842fd66588d$export$d5aac1de7fafa2b0)
    },
    updated: {
        filter: (0, $cd053842fd66588d$export$b10a33c38cc20983)
    },
    created: {
        filter: (0, $cd053842fd66588d$export$48eb4b4c930c6378)
    },
    due: {
        filter: (0, $cd053842fd66588d$export$2573f5b8014b4068)
    }
};
const $0e9b79543ce622c0$var$HEADING_MESSAGE_ID_FOR_TYPE = {
    done: 'doneTitle',
    updated: 'updatedTitle',
    created: 'createdTitle',
    due: 'dueTitle'
};
const $0e9b79543ce622c0$export$2a9564a2b64c3ef1 = ({ data: { count: count, type: type } })=>{
    const [IconComponent, ...iconConfigsForType] = $0e9b79543ce622c0$var$ICON_CONFIG_FOR_TYPE[type];
    const [iconColor, iconTileStyles] = count > 0 ? iconConfigsForType : $0e9b79543ce622c0$var$ICON_CONFIG_FOR_EMPTY;
    const { fireOverviewCardAnalytics: fireOverviewCardAnalytics } = (0, $153fj.useSectionAnalytics)((0, $beAwS.SectionIds).OverviewCard, (0, $beAwS.overviewCountBoundaryIds)[type]);
    const onLinkClick = (0, $5uXOq.useCallback)(()=>{
        fireOverviewCardAnalytics('viewWithFilter');
    }, [
        fireOverviewCardAnalytics
    ]);
    const { linksResolver: linksResolver, linksTarget: linksTarget } = (0, $79GHn.useSummaryFeatures)();
    const onClickHref = linksResolver($0e9b79543ce622c0$var$REDIRECT_URL_OPTIONS_FOR_TYPE[type]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
        href: onClickHref,
        target: linksTarget,
        onClick: onLinkClick,
        className: (0, $bwpsq.default)([
            "_9oik18uv _1bnxglyw _jf4cnqa1"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "row",
        gap: "space.100",
        xcss: $0e9b79543ce622c0$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        justifyContent: "center",
        alignItems: "center" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        ,
        xcss: [
            $0e9b79543ce622c0$var$iconContainerStyles,
            iconTileStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconComponent, {
        spacing: "spacious",
        label: "",
        color: iconColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        xcss: $0e9b79543ce622c0$var$contentContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $l3nh3.default)[$0e9b79543ce622c0$var$HEADING_MESSAGE_ID_FOR_TYPE[type]],
        values: {
            count: count,
            header: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
                    size: "small"
                }, chunks),
            copy: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                    size: "UNSAFE_small",
                    color: "color.text.subtlest"
                }, chunks)
        }
    })))));
};
const $0e9b79543ce622c0$var$linkStyles = null;
const $0e9b79543ce622c0$var$containerStyles = (0, $8CUq3.xcss)({
    margin: 'space.negative.050',
    padding: 'space.150',
    height: '64px'
});
const $0e9b79543ce622c0$var$contentContainerStyles = (0, $8CUq3.xcss)({
    height: '100%'
});
const $0e9b79543ce622c0$var$iconContainerStyles = (0, $8CUq3.xcss)({
    height: '40px',
    width: '40px',
    borderRadius: '4px'
});

});
parcelRegister("3fesp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c3c6678ca49b47a08391fd96c442f9a0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25cdfcb8bb836404$var$_react = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $25cdfcb8bb836404$var$_baseNew = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $25cdfcb8bb836404$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25cdfcb8bb836404$var$CalendarIcon = (props)=>/*#__PURE__*/ $25cdfcb8bb836404$var$_react.default.createElement($25cdfcb8bb836404$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
    }, props));
$25cdfcb8bb836404$var$CalendarIcon.displayName = 'CalendarIcon';
var $25cdfcb8bb836404$var$_default = module.exports.default = $25cdfcb8bb836404$var$CalendarIcon;

});

parcelRegister("34OIV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7ca7f2b04f3f535d72e31b1e4399daa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23d917767cf5e6f4$var$_react = $23d917767cf5e6f4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $23d917767cf5e6f4$var$_baseNew = $23d917767cf5e6f4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $23d917767cf5e6f4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: completed items, productivity emoji category. Completed task issue status in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23d917767cf5e6f4$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $23d917767cf5e6f4$var$_react.default.createElement($23d917767cf5e6f4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.25 8 2.5 3 5-6M8 .75a7.25 7.25 0 1 0 0 14.5A7.25 7.25 0 0 0 8 .75Z"/>`
    }, props));
$23d917767cf5e6f4$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $23d917767cf5e6f4$var$_default = module.exports.default = $23d917767cf5e6f4$var$CheckCircleIcon;

});

parcelRegister("4sHph", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e6c8da1dd8413d2d96451bd5cd861f8f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33fb72a3c99ed86f$var$_react = $33fb72a3c99ed86f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $33fb72a3c99ed86f$var$_baseNew = $33fb72a3c99ed86f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $33fb72a3c99ed86f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "EditBulk".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing multiple objects in bulk.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $33fb72a3c99ed86f$var$EditBulkIcon = (props)=>/*#__PURE__*/ $33fb72a3c99ed86f$var$_react.default.createElement($33fb72a3c99ed86f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m14 6 .866-.866a1.25 1.25 0 0 0 0-1.768l-.232-.232a1.25 1.25 0 0 0-1.768 0L12 4m2 2-3.982 3.982a1.25 1.25 0 0 1-.64.342l-2.128.426.426-2.129a1.25 1.25 0 0 1 .342-.639L12 4m2 2-2-2M1.75 1.75h2.5v2.5h-2.5zm0 5h2.5v2.5h-2.5zm0 5h2.5v2.5h-2.5z"/>`
    }, props));
$33fb72a3c99ed86f$var$EditBulkIcon.displayName = 'EditBulkIcon';
var $33fb72a3c99ed86f$var$_default = module.exports.default = $33fb72a3c99ed86f$var$EditBulkIcon;

});

parcelRegister("gbB8m", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1a90c87915d29e8cf3a331f01bd4b8e7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc8a7a716415a47e$var$_react = $bc8a7a716415a47e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bc8a7a716415a47e$var$_baseNew = $bc8a7a716415a47e$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $bc8a7a716415a47e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Tasks".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multiple tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bc8a7a716415a47e$var$TasksIcon = (props)=>/*#__PURE__*/ $bc8a7a716415a47e$var$_react.default.createElement($bc8a7a716415a47e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 6.875 6 9.25l4-4.75m-7 7.75h8c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v8c0 .69.56 1.25 1.25 1.25Z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
    }, props));
$bc8a7a716415a47e$var$TasksIcon.displayName = 'TasksIcon';
var $bc8a7a716415a47e$var$_default = module.exports.default = $bc8a7a716415a47e$var$TasksIcon;

});

parcelRegister("l3nh3", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ae796e9f94b0b63$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8ae796e9f94b0b63$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    doneTitle: {
        "id": "contextual-summary.project-summary.overview-count.done-title",
        "defaultMessage": "<header>{count} completed</header> <copy>in the last 7 days</copy>"
    },
    updatedTitle: {
        "id": "contextual-summary.project-summary.overview-count.updated-title",
        "defaultMessage": "<header>{count} updated</header> <copy>in the last 7 days</copy>"
    },
    createdTitle: {
        "id": "contextual-summary.project-summary.overview-count.created-title",
        "defaultMessage": "<header>{count} created</header> <copy>in the last 7 days</copy>"
    },
    dueTitle: {
        "id": "contextual-summary.project-summary.overview-count.due-title",
        "defaultMessage": "<header>{count} due</header> <copy>in the next 7 days</copy>"
    }
});

});


parcelRegister("5Up4t", function(module, exports) {

$parcel$export(module.exports, "PriorityBreakdown", () => $a6b8772ff925eebc$export$a8747a4a9d1fd7ab);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $cgL5K = parcelRequire("cgL5K");

var $54x4x = parcelRequire("54x4x");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $hDzhb = parcelRequire("hDzhb");
var $lVJAU = parcelRequire("lVJAU");

var $epG85 = parcelRequire("epG85");

var $bT1Sw = parcelRequire("bT1Sw");
var $17PP9 = parcelRequire("17PP9");

var $153fj = parcelRequire("153fj");

var $6hxaf = parcelRequire("6hxaf");

var $4BeU4 = parcelRequire("4BeU4");

var $79GHn = parcelRequire("79GHn");

var $6QFTz = parcelRequire("6QFTz");

var $beAwS = parcelRequire("beAwS");

var $7Ow6B = parcelRequire("7Ow6B");

var $82dvD = parcelRequire("82dvD");
const $a6b8772ff925eebc$var$SUPPORT_DOC_URL = 'https://support.atlassian.com/jira-cloud-administration/docs/configure-priorities-for-projects/';
const $a6b8772ff925eebc$var$CustomTooltipHeader = (0, $bT1Sw.element)(({ onRender: onRender })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { children: children, datum: datum } = (0, $17PP9.useElementProps)((0, $epG85.default).elements.TooltipHeader);
    onRender();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $epG85.default).elements.TooltipHeader, null, datum.jqlTerm ? children : formatMessage((0, $82dvD.default).noPriorityLabel));
}, {
    as: (0, $epG85.default).elements.TooltipHeader
});
const $a6b8772ff925eebc$export$a8747a4a9d1fd7ab = ({ data: { issuesByPriority: issuesByPriority }, colorScheme: colorScheme })=>{
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { linksResolver: linksResolver, linksTarget: linksTarget } = (0, $79GHn.useSummaryFeatures)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { addUFOCustomHoverData: addUFOCustomHoverData, UFOConditionalCustomHoverData: UFOConditionalCustomHoverData } = (0, $7Ow6B.useUFOCustomHoverData)();
    const totalIssueCount = issuesByPriority.reduce((acc, { count: count })=>acc + count, 0);
    const { fireSectionAnalytics: fireSectionAnalytics } = (0, $153fj.useSectionAnalytics)((0, $beAwS.SectionIds).PriorityBreakdown, (0, $beAwS.BoundaryIds).PriorityBreakdown);
    const filteredList = (0, $5uXOq.useCallback)((jqlTerm)=>linksResolver({
            filter: `priority = ${jqlTerm ? `'${(0, $6QFTz.escapeFilterChars)(jqlTerm)}'` : 'EMPTY'}`,
            hideDone: true
        }), [
        linksResolver
    ]);
    const onTooltipClick = (0, $5uXOq.useCallback)(({ event: event, datum: { jqlTerm: jqlTerm, count: count } })=>{
        // this only gets emitted on a PointerEvent
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const buttonNumber = event?.button;
        if (buttonNumber === 2) // ignore right clicks
        return;
        fireSectionAnalytics('viewWithFilter', {
            count: count,
            boundaryId: (0, $beAwS.BoundaryIds).EpicProgress
        });
        const onClickHref = filteredList(jqlTerm);
        if (buttonNumber === 1) // middle button should open in new tab
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(onClickHref, '_blank');
        else if (linksTarget === '_self') push(onClickHref);
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(onClickHref, linksTarget);
    }, [
        push,
        filteredList,
        fireSectionAnalytics,
        linksTarget
    ]);
    const onLinkClick = (0, $5uXOq.useCallback)(()=>{
        fireSectionAnalytics('view');
    }, [
        fireSectionAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4BeU4.ChartWithHeaderContainer), {
        header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            size: "small",
            as: "h2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $82dvD.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, totalIssueCount === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $82dvD.default).emptyDescription,
            values: {
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
                        href: $a6b8772ff925eebc$var$SUPPORT_DOC_URL,
                        target: "_blank",
                        onClick: onLinkClick
                    }, chunks)
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $82dvD.default).description,
            values: {
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
                        href: linksResolver({
                            sortBy: 'priority',
                            isDescending: true,
                            hideDone: true
                        }),
                        target: linksTarget,
                        onClick: onLinkClick
                    }, chunks),
                totalIssueCount: totalIssueCount
            }
        }))),
        chart: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6hxaf.BarChart), {
            data: issuesByPriority.map((item)=>({
                    name: item.priority.name,
                    count: item.count,
                    jqlTerm: item.priority.jqlTerm
                })),
            axisBottomTextTransformer: (children)=>{
                const { jqlTerm: jqlTerm, iconUrl: iconUrl } = issuesByPriority.find(({ priority: { name: name } })=>children === name)?.priority || {};
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
                    href: filteredList(jqlTerm),
                    target: linksTarget,
                    className: (0, $bwpsq.default)([
                        "_lcxv1h90 _9oik18uv _1bnxglyw _jf4cnqa1"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                    className: (0, $bwpsq.default)([
                        "_zulp1b66 _1e0c1txw _4cvr1h6o _1bah1h6o"
                    ])
                }, iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
                    alt: "",
                    src: iconUrl,
                    className: (0, $bwpsq.default)([
                        "_1bsb7vkz _4t3i7vkz"
                    ])
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($54x4x))), {
                    label: "",
                    size: "small",
                    primaryColor: "var(--ds-text-subtle, #7A869A)"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
                    className: (0, $bwpsq.default)([
                        "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _syaz1aqp"
                    ])
                }, children ?? formatMessage((0, $82dvD.default).noPriorityLabel))));
            },
            onTooltipClick: onTooltipClick,
            colorScheme: colorScheme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a6b8772ff925eebc$var$CustomTooltipHeader, {
            onRender: addUFOCustomHoverData
        }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(UFOConditionalCustomHoverData, null));
};
const $a6b8772ff925eebc$var$axixBottomTextLinkStyles = null;
const $a6b8772ff925eebc$var$axisBottomTextContainerStyles = null;
const $a6b8772ff925eebc$var$iconStyles = null;
const $a6b8772ff925eebc$var$axisBottomTextStyles = null;

});
parcelRegister("54x4x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3b16faec96c05702$var$_react = $3b16faec96c05702$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $3b16faec96c05702$var$_minus = $3b16faec96c05702$var$_interopRequireDefault((parcelRequire("cGbU6")));
function $3b16faec96c05702$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3b16faec96c05702$var$EditorHorizontalRuleIcon = (props)=>/*#__PURE__*/ $3b16faec96c05702$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><rect width="14" height="2" x="5" y="11" fill="currentcolor" fill-rule="evenodd" rx="1"/></svg>`
    }, props, {
        newIcon: $3b16faec96c05702$var$_minus.default
    }));
$3b16faec96c05702$var$EditorHorizontalRuleIcon.displayName = 'EditorHorizontalRuleIcon';
var $3b16faec96c05702$var$_default = module.exports.default = $3b16faec96c05702$var$EditorHorizontalRuleIcon;

});
parcelRegister("cGbU6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::48c52178b35236f9f44af0434faa4acf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $93b2a42556cf480d$var$_react = $93b2a42556cf480d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $93b2a42556cf480d$var$_baseNew = $93b2a42556cf480d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $93b2a42556cf480d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Minus".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: horizontal rule in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $93b2a42556cf480d$var$MinusIcon = (props)=>/*#__PURE__*/ $93b2a42556cf480d$var$_react.default.createElement($93b2a42556cf480d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M2 8h12"/>`
    }, props));
$93b2a42556cf480d$var$MinusIcon.displayName = 'MinusIcon';
var $93b2a42556cf480d$var$_default = module.exports.default = $93b2a42556cf480d$var$MinusIcon;

});


parcelRegister("6hxaf", function(module, exports) {

$parcel$export(module.exports, "BarChart", () => $c588540de7a5bb35$export$94aefc399ef206a9);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");


var $epG85 = parcelRequire("epG85");

var $bT1Sw = parcelRequire("bT1Sw");
var $17PP9 = parcelRequire("17PP9");

var $beAwS = parcelRequire("beAwS");
const $c588540de7a5bb35$var$TextContainer = ({ width: width, transform: transform, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        style: {
            width: width,
            transform: transform
        }
    }, children);
const $c588540de7a5bb35$var$CustomAxisBottomText = (0, $bT1Sw.element)(({ transformer: transformer })=>{
    const { children: children, width: width, transform: transform } = (0, $17PP9.useElementProps)((0, $epG85.default).elements.AxisBottomText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c588540de7a5bb35$var$TextContainer, {
        width: width,
        transform: transform
    }, transformer(children));
}, {
    as: (0, $epG85.default).elements.AxisBottomText
});
const $c588540de7a5bb35$var$CustomLayout = (0, $bT1Sw.element)(()=>{
    const { children: children } = (0, $17PP9.useElementProps)((0, $epG85.default).elements.Layout);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        "data-element": "layout",
        xcss: $c588540de7a5bb35$var$barLayoutStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        "data-element": "chart",
        xcss: $c588540de7a5bb35$var$barChartStyles
    }, children));
}, {
    as: (0, $epG85.default).elements.Layout
});
const $c588540de7a5bb35$export$94aefc399ef206a9 = ({ data: data, axisBottomTextTransformer: xAxisLabelTransformer = (children)=>children, onTooltipClick: onTooltipClick, children: children, colorScheme: colorScheme = (0, $beAwS.ColorSchemes).DEFAULT })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $epG85.default), {
        data: data,
        xAccessor: (d)=>d.name,
        yAccessor: (d)=>d.count
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $epG85.default).elements.Theme, {
        fillStyles: colorScheme === (0, $beAwS.ColorSchemes).BLUE ? [
            "var(--ds-chart-brand, #1D7AFC)"
        ] : [
            `var(--ds-chart-neutral, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $epG85.default).elements.TooltipEmitter, {
        onClick: onTooltipClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c588540de7a5bb35$var$CustomAxisBottomText, {
        transformer: xAxisLabelTransformer
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c588540de7a5bb35$var$CustomLayout, null), children);
};
const $c588540de7a5bb35$var$barLayoutStyles = (0, $8CUq3.xcss)({
    flexGrow: '1'
});
const $c588540de7a5bb35$var$barChartStyles = (0, $8CUq3.xcss)({
    height: '100%',
    display: 'flex'
});

});

parcelRegister("7Ow6B", function(module, exports) {

$parcel$export(module.exports, "UFOCustomHoverData", () => $5db9f54f32e9226c$export$e9176ef5da258674);
$parcel$export(module.exports, "useUFOCustomHoverData", () => $5db9f54f32e9226c$export$182b9f28bc2d7c0f);

var $5uXOq = parcelRequire("5uXOq");

var $99gkn = parcelRequire("99gkn");
const $5db9f54f32e9226c$export$e9176ef5da258674 = ({ hasHoverEvent: hasHoverEvent })=>{
    const data = (0, $5uXOq.useMemo)(()=>({
            hasHoverEvent: hasHoverEvent
        }), [
        hasHoverEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99gkn.default), {
        data: data
    });
};
const $5db9f54f32e9226c$export$182b9f28bc2d7c0f = ()=>{
    const [renderCustomData, setRenderCustomData] = (0, $5uXOq.useState)(false);
    const addUFOCustomHoverData = (0, $5uXOq.useCallback)(()=>{
        if (!renderCustomData) setRenderCustomData(true);
    }, [
        renderCustomData
    ]);
    const UFOConditionalCustomHoverData = ()=>renderCustomData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5db9f54f32e9226c$export$e9176ef5da258674, {
            hasHoverEvent: true
        }) : null;
    return {
        addUFOCustomHoverData: addUFOCustomHoverData,
        UFOConditionalCustomHoverData: UFOConditionalCustomHoverData
    };
};

});

parcelRegister("82dvD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0679c1249166aeec$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0679c1249166aeec$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "contextual-summary.project-summary.priority-breakdown.title",
        "defaultMessage": "Priority breakdown"
    },
    description: {
        "id": "contextual-summary.project-summary.priority-breakdown.description",
        "defaultMessage": "Get a holistic view of how work is being prioritized. <link>See what your team's been focusing on</link>"
    },
    emptyDescription: {
        "id": "contextual-summary.project-summary.priority-breakdown.empty-description",
        "defaultMessage": "Get a holistic view of how work is being prioritized. <link>How to manage priorities for projects</link>"
    },
    noPriorityLabel: {
        "id": "contextual-summary.project-summary.priority-breakdown.no-priority-label",
        "defaultMessage": "None"
    }
});

});


parcelRegister("ey00g", function(module, exports) {

$parcel$export(module.exports, "RecentActivity", () => $f61706fe2fafdd9e$export$8d9137fcb112aeab);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $f9ece = parcelRequire("f9ece");

var $9JptI = parcelRequire("9JptI");

var $iMVUf = parcelRequire("iMVUf");

var $l1N8i = parcelRequire("l1N8i");

var $cgL5K = parcelRequire("cgL5K");

var $l8Afc = parcelRequire("l8Afc");

var $koVbs = parcelRequire("koVbs");

var $153fj = parcelRequire("153fj");

var $4BeU4 = parcelRequire("4BeU4");

var $hKvdY = parcelRequire("hKvdY");

var $dXXko = parcelRequire("dXXko");

var $beAwS = parcelRequire("beAwS");

var $4RDEy = parcelRequire("4RDEy");

var $d0Qeg = parcelRequire("d0Qeg");
const $f61706fe2fafdd9e$var$emptyIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
    width: "96",
    height: "96",
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    d: "M79.8599 43.4902H31.1499V67.2902H79.8599V43.4902Z",
    fill: "#1868DB"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    d: "M64.72 28.71H16.01V52.51H64.72V28.71Z",
    fill: "#DDDEE1"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    d: "M64.7199 43.4902H31.1499V52.5102H64.7199V43.4902Z",
    fill: "#09326C"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M76.8299 52.09L66.3399 62.58L60.9199 57.01L63.2599 54.74L66.3799 57.94L74.5299 49.79L76.8399 52.1L76.8299 52.09Z",
    fill: "white"
}));
const $f61706fe2fafdd9e$export$8d9137fcb112aeab = ({ data: data, loadingNext: loadingNext, hasNextPage: hasNextPage, fetchNext: fetchNext })=>{
    const { formatDate: formatDate, formatMessage: formatMessage } = (0, $koVbs.default)();
    const { fireSectionAnalytics: fireSectionAnalytics } = (0, $153fj.useSectionAnalytics)((0, $beAwS.SectionIds).RecentActivity, (0, $beAwS.BoundaryIds).RecentActivity);
    const { onScroll: onScroll } = (0, $l8Afc.useScrollToEnd)({
        onScrollToEnd: fetchNext,
        isDisabled: loadingNext || !hasNextPage,
        options: {
            onEndReachedThreshold: 150
        }
    });
    const itemsByDate = (0, $5uXOq.useMemo)(()=>data.reduce((groups, item)=>{
            const publishedDate = new Date(item.published);
            const key = (0, $f9ece.default)(publishedDate, 'UTC', 'yyyy-MM-dd');
            const lastGroup = groups[groups.length - 1];
            if (lastGroup?.key === key) lastGroup.items.push(item);
            else {
                let label;
                if ((0, $9JptI.default)(publishedDate)) label = formatMessage((0, $d0Qeg.default).todayLabel);
                else if ((0, $iMVUf.default)(publishedDate)) label = formatMessage((0, $d0Qeg.default).yesterdayLabel);
                else label = formatDate(key, {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });
                groups.push({
                    key: key,
                    label: label,
                    items: [
                        item
                    ]
                });
            }
            return groups;
        }, []), [
        data,
        formatDate,
        formatMessage
    ]);
    const onActivityItemClick = (0, $5uXOq.useCallback)((target)=>{
        fireSectionAnalytics(target, {
            boundaryId: (0, $beAwS.BoundaryIds).RecentActivity
        });
    }, [
        fireSectionAnalytics
    ]);
    if (!itemsByDate?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKvdY.EmptyState), {
        icon: $f61706fe2fafdd9e$var$emptyIcon,
        headingText: formatMessage((0, $d0Qeg.default).title),
        descriptionText: formatMessage((0, $d0Qeg.default).description)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4BeU4.ChartWithHeaderContainer), {
        header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            size: "small",
            as: "h2"
        }, formatMessage((0, $d0Qeg.default).chartHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $d0Qeg.default).chartDescription))),
        chart: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            onScroll: onScroll,
            className: (0, $bwpsq.default)([
                "_18m91wug _16jlkb7n _2hwxxmi2 _u5f3utpp"
            ])
        }, itemsByDate.map(({ key: key, label: label, items: items })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                key: key
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("h6", {
                className: (0, $bwpsq.default)([
                    "_1p1dglyw"
                ])
            }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", {
                className: (0, $bwpsq.default)([
                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2mzuglyw _19pkidpf _otyru2gc"
                ])
            }, items.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4RDEy.ActivityItem), {
                    key: item.id,
                    item: item,
                    onClick: onActivityItemClick
                }))))), loadingNext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dXXko.ScrollingLoader), null))
    });
};
const $f61706fe2fafdd9e$var$containerStyles = null;
const $f61706fe2fafdd9e$var$headerStyles = null;
const $f61706fe2fafdd9e$var$listStyles = null;

});
parcelRegister("l8Afc", function(module, exports) {

$parcel$export(module.exports, "useScrollToEnd", () => $ebddd9e1f1864b8e$export$296d94f94d195283);

var $5uXOq = parcelRequire("5uXOq");

var $34ck9 = parcelRequire("34ck9");
const $ebddd9e1f1864b8e$var$DEFAULT_ON_END_REACHED_THRESHOLD = 300;
const $ebddd9e1f1864b8e$var$DEFAULT_THROTTLE_TIME = 16;
const $ebddd9e1f1864b8e$export$296d94f94d195283 = ({ onScrollToEnd: onScrollToEnd, isDisabled: isDisabled, options: options })=>{
    const onEndReachedThreshold = options?.onEndReachedThreshold ?? $ebddd9e1f1864b8e$var$DEFAULT_ON_END_REACHED_THRESHOLD;
    const throttleTime = options?.throttleTime ?? $ebddd9e1f1864b8e$var$DEFAULT_THROTTLE_TIME;
    const calculateEndReached = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(({ clientHeight: clientHeight, scrollTop: scrollTop, scrollHeight: scrollHeight })=>{
            const distanceFromEnd = scrollHeight - scrollTop - clientHeight;
            if (distanceFromEnd < onEndReachedThreshold && isDisabled !== true) onScrollToEnd();
        }, throttleTime), [
        onScrollToEnd,
        throttleTime,
        isDisabled,
        onEndReachedThreshold
    ]);
    const onScroll = (0, $5uXOq.useCallback)((event)=>{
        const { clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop } = event.currentTarget;
        calculateEndReached({
            clientHeight: clientHeight,
            scrollHeight: scrollHeight,
            scrollTop: scrollTop
        });
    }, [
        calculateEndReached
    ]);
    return {
        onScroll: onScroll
    };
};

});

parcelRegister("dXXko", function(module, exports) {

$parcel$export(module.exports, "ScrollingLoader", () => $00d329a9810b4f03$export$41db4f72a8f7f250);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");
const $00d329a9810b4f03$export$41db4f72a8f7f250 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $00d329a9810b4f03$var$spinnerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), null));
};
const $00d329a9810b4f03$var$spinnerWrapperStyles = (0, $8CUq3.xcss)({
    display: 'grid',
    justifyContent: 'center',
    margin: 'space.150'
});

});

parcelRegister("4RDEy", function(module, exports) {

$parcel$export(module.exports, "ActivityItem", () => $0f3611b5a433bd35$export$6d45a429e25bf06f);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $h9fHt = parcelRequire("h9fHt");

var $1p96B = parcelRequire("1p96B");

var $DVljb = parcelRequire("DVljb");
const $0f3611b5a433bd35$export$6d45a429e25bf06f = ({ item: item, onClick: onClick })=>{
    const locale = (0, $DVljb.useLocale)();
    const linksTarget = '_blank';
    const title = (0, $5uXOq.useMemo)(()=>(0, $h9fHt.transformTitle)(item, onClick, linksTarget), [
        item,
        onClick
    ]);
    const content = (0, $5uXOq.useMemo)(()=>(0, $h9fHt.transformContent)(item), [
        item
    ]);
    const relativePublishedTime = (0, $5uXOq.useMemo)(()=>(0, $1p96B.formatDistanceWithLocale)(new Date(item.published), new Date(), locale, true), [
        item,
        locale
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0f3611b5a433bd35$var$wrapperStyles,
        as: "li"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        src: item.author.avatarUrl,
        name: item.author.name,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_18u0u2gc _59381r81 _yha2agmp _1nmzvv82 _rfqo1r81 _1bgk14l6 _1t0pvv82"
        ])
    }, title, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text.subtle",
        as: "p"
    }, relativePublishedTime))), content);
};
const $0f3611b5a433bd35$var$wrapperStyles = (0, $8CUq3.xcss)({
    position: 'relative',
    margin: 'space.0',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    paddingLeft: 'space.0',
    paddingRight: 'space.0'
});
const $0f3611b5a433bd35$var$titleContainerStyles = null;

});
parcelRegister("h9fHt", function(module, exports) {

$parcel$export(module.exports, "transformTitle", () => $14b9b87d9c9d853d$export$b7844e8a25b12dea);
$parcel$export(module.exports, "transformContent", () => $14b9b87d9c9d853d$export$b7cb80c25ebba28e);
/* utils.tsx generated by @compiled/babel-plugin v0.36.0 */ /* eslint-disable no-bitwise */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jWlFw = parcelRequire("jWlFw");
const $14b9b87d9c9d853d$export$b7844e8a25b12dea = (item, onClick, linkTarget)=>{
    const parser = new DOMParser();
    const { body: body } = parser.parseFromString(item.title, 'text/html');
    if (body == null) return null;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
    let node = walker.firstChild();
    const result = [];
    let key = 0;
    do {
        if (node == null) continue;
        if (node.nodeType === Node.ELEMENT_NODE && node.nodeName === 'A') {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const href = node.getAttribute('href') || '';
            if (href.startsWith('/browse/')) result.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jWlFw.default), {
                key: key++,
                target: linkTarget,
                href: href,
                onClick: ()=>onClick('issue')
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($14b9b87d9c9d853d$var$TypeIcon, {
                src: item.iconUrl,
                alt: ""
            }), node.textContent));
            else result.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jWlFw.default), {
                key: key++,
                target: linkTarget,
                href: href,
                onClick: ()=>onClick('user')
            }, node.textContent));
        } else result.push(node.textContent);
    // eslint-disable-next-line no-cond-assign
    }while (node = walker.nextSibling());
    return result;
};
function* $14b9b87d9c9d853d$var$infinite() {
    let index = 0;
    while(true)yield index++;
}
const $14b9b87d9c9d853d$var$mapSiblingNodes = (walker, keyGen)=>{
    const mappedNodes = [];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    let currentNode = walker.currentNode;
    while(currentNode){
        const { nodeType: nodeType } = currentNode;
        if (nodeType === Node.TEXT_NODE) mappedNodes.push(currentNode.textContent);
        else if (nodeType === Node.ELEMENT_NODE) {
            const nodeName = currentNode.nodeName.toLowerCase();
            if (nodeName in $14b9b87d9c9d853d$var$NODE_MAPPER_MAP) {
                const result = $14b9b87d9c9d853d$var$NODE_MAPPER_MAP[nodeName](walker, keyGen);
                if (result != null) mappedNodes.push(result);
            }
        }
        currentNode = walker.nextSibling();
    }
    if (mappedNodes.length === 0) return null;
    return mappedNodes;
};
const $14b9b87d9c9d853d$var$mapChildrenNodes = (walker, keyGen)=>{
    const firstChild = walker.firstChild();
    if (firstChild) {
        const result = $14b9b87d9c9d853d$var$mapSiblingNodes(walker, keyGen);
        walker.parentNode();
        return result;
    }
    return null;
};
const $14b9b87d9c9d853d$var$identity = (walker, keyGen)=>{
    const children = $14b9b87d9c9d853d$var$mapChildrenNodes(walker, keyGen);
    return /*#__PURE__*/ (0, $5uXOq.createElement)(walker.currentNode.nodeName.toLowerCase(), {
        key: keyGen.next().value
    }, children);
};
const $14b9b87d9c9d853d$var$isNodeEmpty = (children)=>children.length === 1 && typeof children[0] === 'string' && children[0].trim().length === 0;
const $14b9b87d9c9d853d$var$NODE_MAPPER_MAP = {
    a: (walker, keyGen)=>{
        const children = $14b9b87d9c9d853d$var$mapChildrenNodes(walker, keyGen);
        if (children == null || children.length === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($14b9b87d9c9d853d$var$StyledAnchor, {
            key: keyGen.next().value,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            href: walker.currentNode.getAttribute('href'),
            target: "_blank"
        }, children);
    },
    b: $14b9b87d9c9d853d$var$identity,
    blockquote: (walker, keyGen)=>{
        const children = $14b9b87d9c9d853d$var$mapChildrenNodes(walker, keyGen);
        if (children == null || children.length === 0 || $14b9b87d9c9d853d$var$isNodeEmpty(children)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("blockquote", {
            key: keyGen.next().value
        }, children);
    },
    br: $14b9b87d9c9d853d$var$identity,
    div: (walker, keyGen)=>{
        const children = $14b9b87d9c9d853d$var$mapChildrenNodes(walker, keyGen);
        if (children == null || children.length === 0) return null;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (walker.currentNode.classList.contains('user-content')) {
            // if there is only a text node as child and it's blank space, skip it (stupid stream...)
            if ($14b9b87d9c9d853d$var$isNodeEmpty(children)) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("blockquote", {
                key: keyGen.next().value
            }, children);
        }
        return children;
    },
    em: $14b9b87d9c9d853d$var$identity,
    font: $14b9b87d9c9d853d$var$mapChildrenNodes,
    h1: $14b9b87d9c9d853d$var$identity,
    h2: $14b9b87d9c9d853d$var$identity,
    h3: $14b9b87d9c9d853d$var$identity,
    h4: $14b9b87d9c9d853d$var$identity,
    h5: $14b9b87d9c9d853d$var$identity,
    h6: $14b9b87d9c9d853d$var$identity,
    hr: $14b9b87d9c9d853d$var$identity,
    img: (walker, keyGen)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
            key: keyGen.next().value,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            src: walker.currentNode.getAttribute('src'),
            alt: ""
        }),
    li: $14b9b87d9c9d853d$var$identity,
    ol: $14b9b87d9c9d853d$var$identity,
    p: $14b9b87d9c9d853d$var$identity,
    pre: $14b9b87d9c9d853d$var$identity,
    span: $14b9b87d9c9d853d$var$mapChildrenNodes,
    sub: $14b9b87d9c9d853d$var$identity,
    sup: $14b9b87d9c9d853d$var$identity,
    table: $14b9b87d9c9d853d$var$identity,
    tbody: $14b9b87d9c9d853d$var$identity,
    td: $14b9b87d9c9d853d$var$identity,
    th: $14b9b87d9c9d853d$var$identity,
    thead: $14b9b87d9c9d853d$var$identity,
    tr: $14b9b87d9c9d853d$var$identity,
    ul: $14b9b87d9c9d853d$var$identity
};
const $14b9b87d9c9d853d$export$b7cb80c25ebba28e = (item)=>{
    if (item.content == null) return null;
    const parser = new DOMParser();
    const { body: body } = parser.parseFromString(item.content, 'text/html');
    if (body == null) return null;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
    const keyGen = $14b9b87d9c9d853d$var$infinite();
    const children = $14b9b87d9c9d853d$var$mapChildrenNodes(walker, keyGen);
    if (children == null || children.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($14b9b87d9c9d853d$var$Content, {
        "data-testid": "business-summary.ui.summary-view.activity-feed.activity-item.content"
    }, children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $14b9b87d9c9d853d$var$Content = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s81hqg _1nmz1hna _yc8jglyw _17q5zu5n _1uukyh40 _chq7muej _6qesidpf _12ogidpf _102oidpf _3fjiidpf _1kvxidpf _pezqidpf _1ysjidpf _1yf6idpf _17d4idpf _5jhz13xq _gxop13xq _d1n81wth _2uss1pyq _1qqaudwz _1hnyglyw _1jhyglyw _6n1uidpf _1uzxidpf _11ucidpf _lnp5idpf _1vt11bs6 _18iqiti9 _xh9ft94y _98utnqa1 _1ellmuej _wec71bs6 _9cgvqk37 _1jicqbzx _kq6x1jtm _16n31odn _rtys1osq _19l3uuw1 _mezj1wug _bna71wug _b4pmglyw _dzke18iy _1owe18iy _93rbt94y _cquzt94y _knywnqa1 _1wxlnqa1 _jq3amuej _d15amuej _178i155y _1d9ptcjq",
            __cmplp.className
        ])
    });
});
const $14b9b87d9c9d853d$var$TypeIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i7vkz _1bsb7vkz _2hwxv77o _s7n4nkob _1e0c116y _n3tdv77o",
            __cmplp.className
        ])
    });
});
const $14b9b87d9c9d853d$var$StyledAnchor = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4bfu18uv _1hms8stv _ajmmnqa1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jWlFw", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e73352e33b68a93$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hDzhb = parcelRequire("hDzhb");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7e73352e33b68a93$var$AccessibleLink = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $hDzhb.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4bfu18uv _1hms8stv _ajmmnqa1",
            __cmplp.className
        ])
    });
});
var $7e73352e33b68a93$export$2e2bcd8739ae039 = $7e73352e33b68a93$var$AccessibleLink;

});



parcelRegister("d0Qeg", function(module, exports) {

$parcel$export(module.exports, "default", () => $e75d7ffbaa7ffe20$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e75d7ffbaa7ffe20$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    chartHeading: {
        "id": "contextual-summary.project-summary.priority-breakdown.chart-heading",
        "defaultMessage": "Recent activity"
    },
    chartDescription: {
        "id": "contextual-summary.project-summary.priority-breakdown.chart-description",
        "defaultMessage": "Stay up to date with what's happening across the project."
    },
    title: {
        "id": "contextual-summary.project-summary.priority-breakdown.title",
        "defaultMessage": "No activity yet"
    },
    description: {
        "id": "contextual-summary.project-summary.priority-breakdown.description",
        "defaultMessage": "Create a few issues and invite some teammates to your project to see your project activity."
    },
    todayLabel: {
        "id": "contextual-summary.project-summary.priority-breakdown.today-label",
        "defaultMessage": "Today"
    },
    yesterdayLabel: {
        "id": "contextual-summary.project-summary.priority-breakdown.yesterday-label",
        "defaultMessage": "Yesterday"
    }
});

});


parcelRegister("mVdzu", function(module, exports) {

$parcel$export(module.exports, "StatusOverview", () => $49a05254947e5636$export$57292f98ea0281e3);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $cgL5K = parcelRequire("cgL5K");


var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $hDzhb = parcelRequire("hDzhb");
var $lVJAU = parcelRequire("lVJAU");

var $5Jz1t = parcelRequire("5Jz1t");
var $7mHaJ = parcelRequire("7mHaJ");
var $iZnN2 = parcelRequire("iZnN2");

var $bT1Sw = parcelRequire("bT1Sw");
var $17PP9 = parcelRequire("17PP9");

var $153fj = parcelRequire("153fj");

var $4BeU4 = parcelRequire("4BeU4");

var $incVD = parcelRequire("incVD");

var $79GHn = parcelRequire("79GHn");

var $6QFTz = parcelRequire("6QFTz");

var $beAwS = parcelRequire("beAwS");

var $7Ow6B = parcelRequire("7Ow6B");

var $bzu1k = parcelRequire("bzu1k");
const $49a05254947e5636$var$CustomDonutLabel = (0, $bT1Sw.element)(()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { activeSeriesKey: activeSeriesKey } = (0, $7mHaJ.default)();
    const metricLabel = activeSeriesKey ?? formatMessage((0, $bzu1k.default).chartLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Jz1t.default).elements.MetricLabel, {
        label: metricLabel
    });
}, {
    as: (0, $5Jz1t.default).elements.MetricLabel
});
const $49a05254947e5636$var$CustomDonutValue = (0, $bT1Sw.element)(()=>{
    const { activeSeriesKey: activeSeriesKey } = (0, $7mHaJ.default)();
    const { valueAccessor: valueAccessor, data: data } = (0, $17PP9.useElementProps)((0, $5Jz1t.default).elements.Metric);
    const { totalValue: totalValue } = (0, $17PP9.useElementProps)((0, $5Jz1t.default).elements.MetricValue);
    const activeSeriesValue = data.filter((datum)=>datum?.label === activeSeriesKey)[0]; // this accounts for the fact that if the total value is 0, the percentage will be 0 and not return NaN
    const value = activeSeriesKey && totalValue ? Math.round(valueAccessor(activeSeriesValue) / totalValue * 100) : totalValue;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Jz1t.default).elements.MetricValue, {
        totalValue: value,
        formatter: (d)=>activeSeriesKey ? `${d}%` : d
    });
}, {
    as: (0, $5Jz1t.default).elements.MetricValue
});
const $49a05254947e5636$var$CustomMark = (0, $bT1Sw.element)(({ onHover: onHover })=>{
    const { onPointerMove: onPointerMove } = (0, $17PP9.useElementProps)((0, $5Jz1t.default).elements.Mark);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Jz1t.default).elements.Mark, {
        onPointerMove: (e)=>{
            onHover();
            onPointerMove && onPointerMove(e);
        }
    });
}, {
    as: (0, $5Jz1t.default).elements.Mark
});
const $49a05254947e5636$var$generateUrlOptions = (key, label)=>{
    return {
        filter: `status = '${(0, $6QFTz.escapeFilterChars)(label)}'${key === 'done' ? ' AND statusCategoryChangedDate >= -2w' : ''}`
    };
};
const $49a05254947e5636$var$CustomDonutLegend = (0, $bT1Sw.element)(({ order: order, onHover: onHover })=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const { data: data, colorAccessor: colorAccessor, colorScale: colorScale } = (0, $17PP9.useElementProps)((0, $5Jz1t.default).elements.Legend);
    const { linksResolver: linksResolver, linksTarget: linksTarget } = (0, $79GHn.useSummaryFeatures)(); // `data` is typed as unknown in the viz library
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const typedData = data;
    const { fireSectionAnalytics: fireSectionAnalytics } = (0, $153fj.useSectionAnalytics)((0, $beAwS.SectionIds).StatusOverview, (0, $beAwS.BoundaryIds).StatusOverview); // CSS cannot be used to determine if the container is overflowing so we need to use JS
    // to determine this and center the content if it is not overflowing and vice versa
    (0, $5uXOq.useEffect)(()=>{
        const container = containerRef.current;
        if (!container) return;
        if (container.scrollHeight > container.clientHeight) container.style.justifyContent = 'flex-start';
        else container.style.justifyContent = 'center';
    }, [
        containerRef
    ]);
    const { emitActiveSeriesKey: emitActiveSeriesKey } = (0, $iZnN2.default)();
    const onLegendItemClick = ()=>{
        fireSectionAnalytics('viewWithFilter');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", {
        ref: containerRef,
        className: (0, $bwpsq.default)([
            "_18m91wug _i0dlhwvj _1e0c1txw _2lx21bp4 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
        ])
    }, typedData.sort((a, b)=>order.indexOf(a.label) - order.indexOf(b.label)).map((d)=>{
        const symbolSize = 12;
        const color = colorScale(colorAccessor(d));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
            key: d.label,
            onPointerEnter: (e)=>{
                // emitActiveSeriesKey is typed in viz library to take in HTMLDivElement as the type of the event target
                // but the event target is actually a HTMLLIElement in this case and works fine so we need to cast it
                // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
                emitActiveSeriesKey(e, d.label);
                onHover();
            },
            onPointerLeave: (e)=>emitActiveSeriesKey(e, undefined),
            className: (0, $bwpsq.default)([
                "_1e0c1txw _19pkidpf"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
            href: linksResolver($49a05254947e5636$var$generateUrlOptions(d.key, d.jqlTerm)),
            target: linksTarget,
            onClick: onLegendItemClick,
            className: (0, $bwpsq.default)([
                "_zulpu2gc _1e0c1txw _9oik18uv _1bnxglyw _jf4cnqa1 _30l31gjq"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
            width: symbolSize,
            height: symbolSize
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
            fill: color,
            width: symbolSize,
            height: symbolSize,
            rx: 1,
            ry: 1
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            className: (0, $bwpsq.default)([
                "_11c8qk37 _19pkftgi _2hwxidpf _otyrftgi _18u0idpf _syaz1gjq _9oik18uv _1bnxglyw _jf4cnqa1 _30l31gjq"
            ])
        }, d.label, " (", d.value, ")")));
    }));
}, {
    as: (0, $5Jz1t.default).elements.Legend
});
const $49a05254947e5636$var$legendsContainerStyles = null;
const $49a05254947e5636$var$singleLegendContainerStyles = null;
const $49a05254947e5636$var$legendLinkStyles = null;
const $49a05254947e5636$var$symbolStyles = null;
const $49a05254947e5636$var$labelStyles = null;
const $49a05254947e5636$export$57292f98ea0281e3 = ({ data: { issuesByStatus: issuesByStatus } })=>{
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { linksResolver: linksResolver, linksTarget: linksTarget } = (0, $79GHn.useSummaryFeatures)();
    const { fireSectionAnalytics: fireSectionAnalytics } = (0, $153fj.useSectionAnalytics)((0, $beAwS.SectionIds).StatusOverview, (0, $beAwS.BoundaryIds).StatusOverview);
    const { addUFOCustomHoverData: addUFOCustomHoverData, UFOConditionalCustomHoverData: UFOConditionalCustomHoverData } = (0, $7Ow6B.useUFOCustomHoverData)();
    const onFireSectionAnalytics = (0, $5uXOq.useCallback)((target)=>{
        fireSectionAnalytics(target);
    }, [
        fireSectionAnalytics
    ]);
    const onTooltipClick = (0, $5uXOq.useCallback)((params)=>{
        if (!params) return;
        const { event: event, datum: datum } = params; // this only gets emitted on a PointerEvent
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const buttonNumber = event.button;
        if (buttonNumber === 2 || !datum) // ignore right clicks and datum should always be there but this is for type safety
        return;
        onFireSectionAnalytics('viewWithFilter');
        const onClickHref = linksResolver($49a05254947e5636$var$generateUrlOptions(datum.key, datum.jqlTerm));
        if (buttonNumber === 1) // middle button should open in new tab
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(onClickHref, '_blank');
        else if (linksTarget === '_self') push(onClickHref);
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(onClickHref, linksTarget);
    }, [
        push,
        linksResolver,
        onFireSectionAnalytics,
        linksTarget
    ]);
    const issuesByStatusTotal = (0, $5uXOq.useMemo)(()=>issuesByStatus.reduce((acc, item)=>acc + item.count, 0), [
        issuesByStatus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4BeU4.ChartWithHeaderContainer), {
        header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            size: "small",
            as: "h2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bzu1k.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, issuesByStatusTotal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $bzu1k.default).description,
            values: {
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
                        href: linksResolver({
                            sortBy: 'status',
                            filter: (0, $cd053842fd66588d$export$8cca17e1017ba894),
                            hideDone: false
                        }),
                        target: linksTarget,
                        onClick: ()=>onFireSectionAnalytics('view')
                    }, chunks)
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $bzu1k.default).emptyDescription,
            values: {
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
                        href: linksResolver({
                            openCreateIssueDialog: true
                        }),
                        target: linksTarget,
                        onClick: ()=>onFireSectionAnalytics('view')
                    }, chunks)
            }
        }))),
        chart: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $incVD.DonutChart), {
            data: issuesByStatus.map((item)=>({
                    label: item.status.name,
                    value: item.count,
                    key: item.status.category.key,
                    jqlTerm: item.status.jqlTerm || ''
                }))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($49a05254947e5636$var$CustomDonutLabel, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($49a05254947e5636$var$CustomDonutValue, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($49a05254947e5636$var$CustomDonutLegend, {
            order: issuesByStatus.map(({ status: { name: name } })=>name),
            onHover: addUFOCustomHoverData
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($49a05254947e5636$var$CustomMark, {
            onHover: addUFOCustomHoverData
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Jz1t.default).elements.TooltipOverlay, {
            onClick: onTooltipClick
        }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(UFOConditionalCustomHoverData, null));
};

});
parcelRegister("5Jz1t", function(module, exports) {

$parcel$export(module.exports, "default", () => $42cc5280bee6c2fb$export$2e2bcd8739ae039);

var $17PP9 = parcelRequire("17PP9");

var $lOXm0 = parcelRequire("lOXm0");
parcelRequire("lWVLr");
var $7Nxvv = parcelRequire("7Nxvv");
var $lWVLr = parcelRequire("lWVLr");

var $e2CtX = parcelRequire("e2CtX");

var $3B9ij = parcelRequire("3B9ij");

var $3B9ij = parcelRequire("3B9ij");

var $chU1I = parcelRequire("chU1I");
var $PfPCm = parcelRequire("PfPCm");

var $9B41u = parcelRequire("9B41u");

var $cgmj2 = parcelRequire("cgmj2");

var $doqD0 = parcelRequire("doqD0");
var $l6fAT = parcelRequire("l6fAT");

var $02ifK = parcelRequire("02ifK");

var $e0UVN = parcelRequire("e0UVN");

var $cJVnx = parcelRequire("cJVnx");

var $icMSp = parcelRequire("icMSp");

var $fW813 = parcelRequire("fW813");

var $7VaXw = parcelRequire("7VaXw");

var $gh0O8 = parcelRequire("gh0O8");

var $7ylRf = parcelRequire("7ylRf");

var $5qUsS = parcelRequire("5qUsS");

var $2OMIu = parcelRequire("2OMIu");
function $42cc5280bee6c2fb$export$2e2bcd8739ae039(_ref) {
    let { width: width, height: height, data: data, children: children, ...restProps } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $17PP9.ElementsProvider), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e0UVN.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $PfPCm.MenuProvider), {
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $02ifK.default), {
                    children: [
                        children,
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lWVLr.LayoutContainer), {
                            width: width,
                            height: height,
                            data: data,
                            gridTemplate: [
                                'title',
                                'subtitle',
                                'plot',
                                'legend'
                            ],
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e2CtX.DimensionsWrapper), {
                                children: (_ref2)=>{
                                    let { margin: margin, plotHeight: plotHeight, plotWidth: plotWidth, plotSvgRef: plotSvgRef } = _ref2;
                                    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5qUsS.PureDonutChart), {
                                        svgRef: plotSvgRef,
                                        height: plotHeight,
                                        width: plotWidth,
                                        margin: margin,
                                        data: data,
                                        ...restProps
                                    });
                                }
                            })
                        })
                    ]
                })
            })
        })
    });
}
$42cc5280bee6c2fb$export$2e2bcd8739ae039.elements = {
    Legend: (0, $3B9ij.OrdinalLegend).Component,
    LegendLabel: (0, $3B9ij.LegendLabel).Component,
    Layout: (0, $7Nxvv.Layout).Component,
    Title: (0, $l6fAT.Title).Component,
    SubTitle: (0, $doqD0.Subtitle).Component,
    Mark: (0, $9B41u.Arc).Component,
    Marks: (0, $7VaXw.DonutMarks).Component,
    MarkLabels: (0, $fW813.DonutMarkLabels).Component,
    Metric: (0, $icMSp.DonutMetric).Component,
    MetricLabel: (0, $icMSp.DonutMetricLabel).Component,
    MetricValue: (0, $icMSp.DonutMetricValue).Component,
    TooltipOverlay: (0, $7ylRf.DonutTooltipOverlay).Component,
    Tooltip: (0, $cJVnx.SingleSeriesTooltip).Component,
    Scales: (0, $gh0O8.DonutScalesElement).Component,
    Theme: (0, $cgmj2.Theme).Component,
    Menu: (0, $chU1I.Menu).Component,
    DataTable: (0, $lOXm0.DataTable).Component
};

});
parcelRegister("9B41u", function(module, exports) {

$parcel$export(module.exports, "Arc", () => $6fcab0a7f00403bb$export$6ef80ffb606dd232);
/* Arc.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $hjll3 = parcelRequire("hjll3");

var $bT1Sw = parcelRequire("bT1Sw");

var $2OMIu = parcelRequire("2OMIu");
function $6fcab0a7f00403bb$export$596321273a76f453(func, value) {
    if (typeof value === 'number') func(value);
    else func(value);
}
const $6fcab0a7f00403bb$var$arcStyles = null;
function $6fcab0a7f00403bb$export$ff1ef9a5c671f043(_temp) {
    let { innerRadius: innerRadius, outerRadius: outerRadius, cornerRadius: cornerRadius, startAngle: startAngle, endAngle: endAngle, padAngle: padAngle, padRadius: padRadius } = _temp === void 0 ? {} : _temp;
    const path = (0, $hjll3.arc)();
    if (innerRadius != null) $6fcab0a7f00403bb$export$596321273a76f453(path.innerRadius, innerRadius);
    if (outerRadius != null) $6fcab0a7f00403bb$export$596321273a76f453(path.outerRadius, outerRadius);
    if (cornerRadius != null) $6fcab0a7f00403bb$export$596321273a76f453(path.cornerRadius, cornerRadius);
    if (startAngle != null) $6fcab0a7f00403bb$export$596321273a76f453(path.startAngle, startAngle);
    if (endAngle != null) $6fcab0a7f00403bb$export$596321273a76f453(path.endAngle, endAngle);
    if (padAngle != null) $6fcab0a7f00403bb$export$596321273a76f453(path.padAngle, padAngle);
    if (padRadius != null) $6fcab0a7f00403bb$export$596321273a76f453(path.padRadius, padRadius);
    return path;
}
function $6fcab0a7f00403bb$var$Arc(_ref) {
    let { innerRadius: innerRadius, outerRadius: outerRadius, cornerRadius: cornerRadius, startAngle: startAngle, endAngle: endAngle, padAngle: padAngle, padRadius: padRadius, datum: datum, opacity: opacity, children: children, innerRef: innerRef, ariaLabel: ariaLabel, fill: fill, stroke: stroke, ...rest } = _ref;
    const path = $6fcab0a7f00403bb$export$ff1ef9a5c671f043({
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: cornerRadius,
        startAngle: startAngle,
        endAngle: endAngle,
        padAngle: padAngle,
        padRadius: padRadius
    });
    if (children) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children({
            path: path
        })
    });
    if (!datum && (startAngle == null || endAngle == null || innerRadius == null || outerRadius == null)) {
        console.warn('[@visx/shape/Arc]: expected data because one of startAngle, endAngle, innerRadius, outerRadius is undefined. Bailing.');
        return null;
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
        ref: innerRef,
        d: path(datum) || '',
        role: "img",
        "aria-label": ariaLabel,
        opacity: opacity,
        fill: fill,
        stroke: stroke,
        ...rest,
        className: (0, $bwpsq.default)([
            "_v564g17y"
        ])
    });
}
const $6fcab0a7f00403bb$export$6ef80ffb606dd232 = (0, $bT1Sw.element)($6fcab0a7f00403bb$var$Arc);

});

parcelRegister("cJVnx", function(module, exports) {

$parcel$export(module.exports, "SingleSeriesTooltip", () => $94663239ddfeaa0f$export$417a3bee9df17219);

var $bT1Sw = parcelRequire("bT1Sw");

var $lA40p = parcelRequire("lA40p");

var $5RaE1 = parcelRequire("5RaE1");

var $ltC0t = parcelRequire("ltC0t");

var $2OMIu = parcelRequire("2OMIu");
function $94663239ddfeaa0f$var$SingleSeriesTooltip(_ref) {
    var _tooltipData$nearestD, _window, _window2;
    let { tooltipData: tooltipData, tooltipLeft: tooltipLeft, tooltipTop: tooltipTop, colorAccessor: colorAccessor, labelAccessor: labelAccessor, valueAccessor: valueAccessor, colorScale: colorScale, valueFormatter: valueFormatter = (0, $ltC0t.default).formatNumberAbbreviated } = _ref;
    const datum = tooltipData === null || tooltipData === void 0 ? void 0 : (_tooltipData$nearestD = tooltipData.nearestDatum) === null || _tooltipData$nearestD === void 0 ? void 0 : _tooltipData$nearestD.datum;
    // TODO: SSR check
    const scrollX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
    const scrollY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
    const portalLeft = (tooltipLeft || 0) + scrollX;
    const portalTop = (tooltipTop || 0) + scrollY;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: datum && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5RaE1.default), {
            left: portalLeft,
            top: portalTop,
            tooltipPortalElement: document.body,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lA40p.TooltipRow), {
                datum: datum,
                color: colorScale(colorAccessor(datum)),
                label: labelAccessor(datum),
                value: String(valueFormatter(valueAccessor(datum)))
            }, String(labelAccessor(datum)))
        })
    });
}
const $94663239ddfeaa0f$export$417a3bee9df17219 = (0, $bT1Sw.element)($94663239ddfeaa0f$var$SingleSeriesTooltip);

});

parcelRegister("icMSp", function(module, exports) {

$parcel$export(module.exports, "DonutMetricValue", () => $d40f42d4b5d2ab8e$export$a919e8af430790ff);
$parcel$export(module.exports, "DonutMetricLabel", () => $d40f42d4b5d2ab8e$export$1378bacd15e58eae);
$parcel$export(module.exports, "DonutMetric", () => $d40f42d4b5d2ab8e$export$263bc5dd8230a1d9);
/* donut-label.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $bT1Sw = parcelRequire("bT1Sw");

var $dnJJh = parcelRequire("dnJJh");

var $cwHYm = parcelRequire("cwHYm");

var $ltC0t = parcelRequire("ltC0t");

var $2OMIu = parcelRequire("2OMIu");
const $d40f42d4b5d2ab8e$export$9c69e622944f45dc = null;
const $d40f42d4b5d2ab8e$export$25396b46317eb664 = null;
const $d40f42d4b5d2ab8e$export$a919e8af430790ff = (0, $bT1Sw.element)((_ref)=>{
    let { totalValue: totalValue, width: width, formatter: formatter } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwHYm.default), {
        width: width,
        truncate: true,
        className: (0, $bwpsq.default)([
            "_lswu1fxt _1fjgnkob _ect41wi2 _1wyb1pa9"
        ]),
        children: formatter(totalValue)
    }, `donut-value-${totalValue}`);
});
const $d40f42d4b5d2ab8e$export$1378bacd15e58eae = (0, $bT1Sw.element)((_ref2)=>{
    let { width: width, label: label, totalValue: totalValue } = _ref2;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwHYm.default), {
        y: 24,
        width: width,
        truncate: true,
        className: (0, $bwpsq.default)([
            "_lswu131l _1fjgnkob _ect41wi2 _1wyb7vkz"
        ]),
        children: label
    }, `donut-value-text-${label}`);
});
const $d40f42d4b5d2ab8e$export$263bc5dd8230a1d9 = (0, $bT1Sw.element)(function DonutLabel(_ref3) {
    let { data: data, hide: hide, valueAccessor: valueAccessor, innerRadius: innerRadius } = _ref3;
    if (hide) return null;
    if (innerRadius < 30) return null;
    const centerTextValue = data.reduce((total, d)=>total + valueAccessor(d), 0);
    /* Approximating truncation width, for text to fit in the biggest square inside the inner circle. */ const width = innerRadius * Math.SQRT2;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dnJJh.default), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($d40f42d4b5d2ab8e$export$a919e8af430790ff, {
                width: width,
                totalValue: centerTextValue,
                formatter: (0, $ltC0t.default).formatNumberAbbreviated
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($d40f42d4b5d2ab8e$export$1378bacd15e58eae, {
                width: width,
                label: 'Total value',
                totalValue: centerTextValue
            })
        ]
    });
});

});

parcelRegister("fW813", function(module, exports) {

$parcel$export(module.exports, "DonutMarkLabels", () => $b9a27d9e32b62f69$export$1d7ea9ddbe30b32);

var $hjll3 = parcelRequire("hjll3");

var $bT1Sw = parcelRequire("bT1Sw");

var $8WT90 = parcelRequire("8WT90");

var $2OMIu = parcelRequire("2OMIu");
const $b9a27d9e32b62f69$export$1d7ea9ddbe30b32 = (0, $bT1Sw.element)(function DonutMarkLabels(_ref) {
    let { arcs: arcs, hide: hide } = _ref;
    if (hide) return null;
    const arcPath = (0, $hjll3.arc)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: arcs.map((arc)=>{
            const arcCentroid = arcPath.centroid({
                innerRadius: arc.innerRadius,
                outerRadius: arc.outerRadius,
                startAngle: arc.startAngle,
                endAngle: arc.endAngle
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8WT90.ValueLabel), {
                x: arcCentroid[0],
                y: arcCentroid[1],
                color: arc.fill,
                children: arc.value
            }, `stack-label-${arc.key}`);
        })
    });
});

});

parcelRegister("7VaXw", function(module, exports) {

$parcel$export(module.exports, "DonutMarks", () => $5c465b8064c4564c$export$a717cf1f0d95f89e);

var $5uXOq = parcelRequire("5uXOq");

var $bT1Sw = parcelRequire("bT1Sw");

var $9B41u = parcelRequire("9B41u");

var $lrseF = parcelRequire("lrseF");

var $2OMIu = parcelRequire("2OMIu");
const $5c465b8064c4564c$export$a717cf1f0d95f89e = (0, $bT1Sw.element)(function DonutMarks(_ref) {
    let { arcs: arcs, labelAccessor: labelAccessor } = _ref;
    const { tooltipData: tooltipData } = (0, $5uXOq.useContext)((0, $lrseF.default));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: arcs.map((arc, i)=>{
            var _tooltipData$nearestD;
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9B41u.Arc), {
                ariaLabel: arc.ariaLabel,
                datum: arc.data,
                innerRadius: arc.innerRadius,
                outerRadius: labelAccessor(tooltipData === null || tooltipData === void 0 ? void 0 : (_tooltipData$nearestD = tooltipData.nearestDatum) === null || _tooltipData$nearestD === void 0 ? void 0 : _tooltipData$nearestD.datum) === labelAccessor(arc.data) ? arc.outerRadius + arc.outerRadius * 0.05 : arc.outerRadius,
                startAngle: arc.startAngle,
                endAngle: arc.endAngle,
                padAngle: arc.padAngle,
                fill: arc.fill
            }, `Stack-${arc.key}-${i}`);
        })
    });
});

});

parcelRegister("gh0O8", function(module, exports) {

$parcel$export(module.exports, "DonutScalesElement", () => $bd8edc46ae741ba5$export$2fe94717b0d39350);

var $5uXOq = parcelRequire("5uXOq");

var $5Jz1t = parcelRequire("5Jz1t");

var $bT1Sw = parcelRequire("bT1Sw");
var $17PP9 = parcelRequire("17PP9");

var $juXo4 = parcelRequire("juXo4");
const $bd8edc46ae741ba5$export$2fe94717b0d39350 = (0, $bT1Sw.element)((_ref)=>{
    let { data: data, colorAccessor: colorAccessor, valueAccessor: valueAccessor, sort: sort = 'asc', children: children } = _ref;
    const { fillStyles: fillStyles, enableDefaultPatterns: enableDefaultPatterns, useThemeFillStyles: useThemeFillStyles } = (0, $17PP9.useElementProps)((0, $5Jz1t.default).elements.Theme);
    const value = (0, $5uXOq.useMemo)(()=>{
        const sortedData = data.sort((a, b)=>{
            if (valueAccessor(a) > valueAccessor(b)) return sort === 'asc' ? 1 : -1;
            if (valueAccessor(a) < valueAccessor(b)) return sort === 'asc' ? -1 : 1;
            return 0;
        });
        const { domain: domain, range: range } = useThemeFillStyles({
            fillStyles: fillStyles,
            enableDefaultPatterns: enableDefaultPatterns
        });
        const colorScale = (0, $juXo4.default)({
            domain: domain ? domain : data.map(colorAccessor),
            range: range
        });
        return {
            colorScale: colorScale,
            data: sortedData
        };
    }, [
        data,
        colorAccessor,
        valueAccessor,
        fillStyles,
        enableDefaultPatterns
    ]);
    return children(value);
});

});

parcelRegister("7ylRf", function(module, exports) {

$parcel$export(module.exports, "DonutTooltipOverlay", () => $57fca9dde521523f$export$b33ac6556176a316);

var $5uXOq = parcelRequire("5uXOq");

var $bT1Sw = parcelRequire("bT1Sw");

var $9B41u = parcelRequire("9B41u");


var $lrseF = parcelRequire("lrseF");

var $lI55a = parcelRequire("lI55a");

var $13b02 = parcelRequire("13b02");

var $2OMIu = parcelRequire("2OMIu");
const $57fca9dde521523f$export$b33ac6556176a316 = (0, $bT1Sw.element)(function DonutTooltipOverlay(_ref) {
    let { arcs: arcs, onClick: onClick } = _ref;
    const { showTooltip: showTooltip, hideTooltip: hideTooltip } = (0, $5uXOq.useContext)((0, $lrseF.default));
    const handleMouseMove = (0, $5uXOq.useCallback)((e)=>{
        showTooltip({
            ...e,
            datum: e === null || e === void 0 ? void 0 : e.datum
        });
    }, []);
    const handleMouseOut = (0, $5uXOq.useCallback)(()=>{
        hideTooltip();
    }, []);
    (0, $lI55a.default)('pointermove', handleMouseMove, [
        (0, $0277c50b98747247$export$69b1818e3c4e83f9)
    ]);
    (0, $lI55a.default)('pointerdown', onClick, [
        (0, $0277c50b98747247$export$69b1818e3c4e83f9)
    ]);
    (0, $lI55a.default)('pointerout', handleMouseOut, [
        (0, $0277c50b98747247$export$69b1818e3c4e83f9)
    ]);
    const { onPointerMove: onPointerMove, onPointerOut: onPointerOut, onPointerDown: onPointerDown } = (0, $13b02.default)({
        source: (0, $0277c50b98747247$export$69b1818e3c4e83f9)
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
        style: {
            cursor: onClick ? 'pointer' : 'default'
        },
        children: arcs.map((arc)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $9B41u.Arc), {
                onPointerMove: (e)=>onPointerMove && onPointerMove(e, arc.data),
                onPointerOut: onPointerOut,
                onPointerDown: (e)=>onPointerDown && onPointerDown(e, arc.data),
                ariaLabel: arc.ariaLabel,
                outerRadius: arc.outerRadius,
                innerRadius: arc.innerRadius,
                startAngle: arc.startAngle,
                endAngle: arc.endAngle,
                padAngle: arc.padAngle,
                fill: 'transparent'
            }, `DonutStack-${arc.key}`))
    });
});

});

parcelRegister("5qUsS", function(module, exports) {

$parcel$export(module.exports, "PureDonutChart", () => $3f4b2e3204f609fa$export$d983777419d59151);

var $5uXOq = parcelRequire("5uXOq");

var $17PP9 = parcelRequire("17PP9");

var $7Nxvv = parcelRequire("7Nxvv");

var $hi6Wp = parcelRequire("hi6Wp");

var $dnJJh = parcelRequire("dnJJh");

var $8j5jo = parcelRequire("8j5jo");

var $dluWU = parcelRequire("dluWU");

var $clSQO = parcelRequire("clSQO");

var $6Vofk = parcelRequire("6Vofk");

var $3gW2x = parcelRequire("3gW2x");

var $4olfF = parcelRequire("4olfF");

var $2m8Rk = parcelRequire("2m8Rk");

var $7Bgcg = parcelRequire("7Bgcg");

var $2OMIu = parcelRequire("2OMIu");
function $3f4b2e3204f609fa$var$useAccessors(_ref) {
    let { valueAccessor: valueAccessor, labelAccessor: labelAccessor, colorAccessor: colorAccessor } = _ref;
    const [value, label, color] = (0, $5uXOq.useMemo)(()=>{
        const [v] = (0, $8j5jo.useSafeAccessors)(valueAccessor);
        const [l] = (0, $8j5jo.useSafeAccessors)(labelAccessor);
        const [c] = (0, $8j5jo.useSafeAccessors)(colorAccessor);
        return [
            v,
            l,
            c
        ];
    }, [
        valueAccessor,
        labelAccessor,
        colorAccessor
    ]);
    return {
        value: value,
        label: label,
        color: color
    };
}
function $3f4b2e3204f609fa$export$d983777419d59151(_ref2) {
    let { data: data, width: width, height: height, innerRadius: userInnerRadius, outerRadius: userOuterRadius, margin: margin = (0, $dluWU.DEFAULT_MARGIN), valueAccessor: valueAccessor, colorAccessor: colorAccessor, labelAccessor: labelAccessor, svgRef: svgRef } = _ref2;
    const layoutProps = (0, $17PP9.useElementProps)((0, $7Nxvv.Layout));
    const { value: value, label: label, color: color } = $3f4b2e3204f609fa$var$useAccessors({
        valueAccessor: valueAccessor,
        labelAccessor: labelAccessor,
        colorAccessor: colorAccessor
    });
    // TODO: FIX THIS SO WE KNOW WHEN TO SHIFT PIE CHART OVER.
    // const layoutProps = useElementProps(Layout);
    // const sideBySide = !layoutProps.gridTemplate?.includes('legend');
    const plotHeight = Math.max(0, height - (margin.top + margin.bottom));
    const plotWidth = Math.max(0, width - (margin.left + margin.right));
    const outerRadius = userOuterRadius || Math.min(plotHeight || 0, plotWidth || 0) / 2;
    const innerRadius = userInnerRadius !== undefined ? userInnerRadius : outerRadius / 1.3;
    /* When height is not provided, the chart's height will be set to match its width */ const calculateHeight = layoutProps.height == null && layoutProps.width != null;
    const fixedHeight = calculateHeight ? `${plotWidth}px` : '100%';
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7Bgcg.DonutDataProvider), {
        data: data,
        width: plotWidth,
        height: plotHeight,
        valueAccessor: value,
        labelAccessor: label,
        colorAccessor: color,
        margin: margin,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6Vofk.DonutLegend), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hi6Wp.default), {
                innerRef: svgRef,
                height: fixedHeight,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dnJJh.default), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3gW2x.DonutPatterns), {}),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4olfF.DonutStackSlot), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clSQO.DataTable), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2m8Rk.DonutTooltip), {})
        ]
    });
}

});
parcelRegister("clSQO", function(module, exports) {

$parcel$export(module.exports, "DataTable", () => $8fe1fe71f6393802$export$df30df7ec97b32b5);

var $5uXOq = parcelRequire("5uXOq");

var $PfPCm = parcelRequire("PfPCm");

var $7Bgcg = parcelRequire("7Bgcg");

var $2OMIu = parcelRequire("2OMIu");

const $8fe1fe71f6393802$var$LazyDataTableModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>Promise.resolve((parcelRequire("lOXm0"))).then((module)=>({
            default: module.DataTableModal
        })));
function $8fe1fe71f6393802$export$df30df7ec97b32b5() {
    const { showDataTable: showDataTable, closeDataTable: closeDataTable } = (0, $PfPCm.useMenuData)();
    const { data: data } = (0, $7Bgcg.useDonutData)();
    return showDataTable ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            style: {
                visibility: 'hidden'
            }
        }),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($8fe1fe71f6393802$var$LazyDataTableModal, {
            data: data,
            closeModal: closeDataTable
        })
    }) : null;
}

});
parcelRegister("7Bgcg", function(module, exports) {

$parcel$export(module.exports, "DonutDataProvider", () => $58888d79b8af69a8$export$201ee326cc161324);
$parcel$export(module.exports, "useDonutData", () => $58888d79b8af69a8$export$570f964a43ebb08);

var $5uXOq = parcelRequire("5uXOq");

var $PfPCm = parcelRequire("PfPCm");

var $cgmj2 = parcelRequire("cgmj2");

var $gh0O8 = parcelRequire("gh0O8");

var $2OMIu = parcelRequire("2OMIu");
const $58888d79b8af69a8$var$DataContext = /*#__PURE__*/ (0, $5uXOq.createContext)({});
function $58888d79b8af69a8$export$201ee326cc161324(_ref) {
    let { children: children, ...props } = _ref;
    const { showPatterns: showPatterns } = (0, $PfPCm.useMenuData)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgmj2.Theme), {
        fillStyles: (0, $cgmj2.DEFAULT_ORDINAL_COLORS),
        enableDefaultPatterns: showPatterns,
        useThemeFillStyles: (0, $cgmj2.useThemeFillStyles),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gh0O8.DonutScalesElement), {
            ...props,
            children: (scales)=>/*#__PURE__*/ (0, $2OMIu.jsx)($58888d79b8af69a8$var$DataContext.Provider, {
                    value: {
                        ...props,
                        ...scales
                    },
                    children: children
                })
        })
    });
}
function $58888d79b8af69a8$export$570f964a43ebb08() {
    return (0, $5uXOq.useContext)($58888d79b8af69a8$var$DataContext);
}

});


parcelRegister("6Vofk", function(module, exports) {

$parcel$export(module.exports, "DonutLegend", () => $50aadfc39a04d881$export$bd81b761982512ab);

var $3B9ij = parcelRequire("3B9ij");

var $7Bgcg = parcelRequire("7Bgcg");

var $2OMIu = parcelRequire("2OMIu");
function $50aadfc39a04d881$export$bd81b761982512ab() {
    const { data: data, colorAccessor: colorAccessor, labelAccessor: labelAccessor, colorScale: colorScale } = (0, $7Bgcg.useDonutData)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3B9ij.OrdinalLegend), {
        shape: "circle",
        data: data,
        colorScale: colorScale,
        colorAccessor: colorAccessor,
        labelAccessor: labelAccessor,
        justifyContent: 'center'
    });
}

});

parcelRegister("3gW2x", function(module, exports) {

$parcel$export(module.exports, "DonutPatterns", () => $261fe340cc68c4a5$export$bbefc336dd56edb0);

var $5Jz1t = parcelRequire("5Jz1t");

var $17PP9 = parcelRequire("17PP9");

var $PfPCm = parcelRequire("PfPCm");

var $cgmj2 = parcelRequire("cgmj2");

var $2OMIu = parcelRequire("2OMIu");
const $261fe340cc68c4a5$export$bbefc336dd56edb0 = ()=>{
    const { patternDefs: patternDefs } = (0, $17PP9.useElementProps)((0, $5Jz1t.default).elements.Theme);
    const { showPatterns: showPatterns } = (0, $PfPCm.useMenuData)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: showPatterns ? (0, $cgmj2.DEFAULT_ORDINAL_PATTERNS_DEFS) : patternDefs
    });
};

});

parcelRegister("4olfF", function(module, exports) {

$parcel$export(module.exports, "DonutStackSlot", () => $3329e3780b06037d$export$24ce8a819edcba7b);

var $bT1Sw = parcelRequire("bT1Sw");
var $17PP9 = parcelRequire("17PP9");

var $7Nxvv = parcelRequire("7Nxvv");

var $dnJJh = parcelRequire("dnJJh");

var $7Bgcg = parcelRequire("7Bgcg");

var $icMSp = parcelRequire("icMSp");

var $fW813 = parcelRequire("fW813");

var $7VaXw = parcelRequire("7VaXw");

var $7ylRf = parcelRequire("7ylRf");

var $ehGnx = parcelRequire("ehGnx");

var $2OMIu = parcelRequire("2OMIu");
const $3329e3780b06037d$export$8874d6b2a9285ec0 = (0, $bT1Sw.element)(function DonutStack(_ref) {
    let { data: data, valueAccessor: valueAccessor, labelAccessor: labelAccessor, colorAccessor: colorAccessor, colorScale: colorScale, innerRadius: innerRadius, outerRadius: outerRadius, transform: transform } = _ref;
    const arcs = (0, $ehGnx.default)(data, valueAccessor, labelAccessor, colorAccessor, colorScale, innerRadius, outerRadius);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dnJJh.default), {
        transform: transform,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7VaXw.DonutMarks), {
                arcs: arcs,
                labelAccessor: labelAccessor
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fW813.DonutMarkLabels), {
                arcs: arcs,
                hide: true
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $icMSp.DonutMetric), {
                data: data,
                valueAccessor: valueAccessor,
                innerRadius: innerRadius,
                hide: false
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7ylRf.DonutTooltipOverlay), {
                arcs: arcs
            })
        ]
    });
});
function $3329e3780b06037d$export$24ce8a819edcba7b() {
    const { data: data, valueAccessor: valueAccessor, labelAccessor: labelAccessor, colorAccessor: colorAccessor, colorScale: colorScale, innerRadius: innerRadius, outerRadius: outerRadius, width: width, height: height } = (0, $7Bgcg.useDonutData)();
    const layoutProps = (0, $17PP9.useElementProps)((0, $7Nxvv.Layout));
    // DISABLE
    // const sideBySide = !layoutProps.gridTemplate?.includes('legend');
    const sideBySide = false;
    const transform = `translate(${sideBySide ? width - outerRadius : width / 2},${height / 2})`;
    return /*#__PURE__*/ (0, $2OMIu.jsx)($3329e3780b06037d$export$8874d6b2a9285ec0, {
        data: data,
        valueAccessor: valueAccessor,
        labelAccessor: labelAccessor,
        colorAccessor: colorAccessor,
        colorScale: colorScale,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        transform: transform
    });
}

});
parcelRegister("ehGnx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a66386c07f68d10d$export$2e2bcd8739ae039);

var $hjll3 = parcelRequire("hjll3");
function $a66386c07f68d10d$var$getStackArcs(data, valueAccessor, labelAccessor, colorAccessor, colorScale, innerRadius, outerRadius) {
    const pie = (0, $hjll3.pie)().value(valueAccessor).sort(null);
    const arcs = pie(data);
    const stackArcs = arcs.map((arc)=>({
            key: labelAccessor(arc.data),
            ariaLabel: `${labelAccessor(arc.data)}, ${valueAccessor(arc.data)}`,
            innerRadius: innerRadius !== undefined && innerRadius < 1 ? 1 : innerRadius,
            outerRadius: outerRadius,
            startAngle: arc.startAngle,
            endAngle: arc.endAngle,
            padAngle: 0.01,
            fill: colorScale(colorAccessor(arc.data)),
            value: valueAccessor(arc.data),
            data: arc.data
        }));
    return stackArcs;
}
var $a66386c07f68d10d$export$2e2bcd8739ae039 = $a66386c07f68d10d$var$getStackArcs;

});


parcelRegister("2m8Rk", function(module, exports) {

$parcel$export(module.exports, "DonutTooltip", () => $1b7482129cb1a7e8$export$9aab0b7a42ef8058);

var $5uXOq = parcelRequire("5uXOq");

var $lrseF = parcelRequire("lrseF");

var $cJVnx = parcelRequire("cJVnx");

var $7Bgcg = parcelRequire("7Bgcg");

var $2OMIu = parcelRequire("2OMIu");
function $1b7482129cb1a7e8$export$9aab0b7a42ef8058() {
    const { colorAccessor: colorAccessor, colorScale: colorScale, valueAccessor: valueAccessor, labelAccessor: labelAccessor } = (0, $7Bgcg.useDonutData)();
    const { tooltipData: tooltipData, tooltipLeft: tooltipLeft, tooltipTop: tooltipTop } = (0, $5uXOq.useContext)((0, $lrseF.default));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cJVnx.SingleSeriesTooltip), {
        tooltipData: tooltipData,
        tooltipLeft: tooltipLeft,
        tooltipTop: tooltipTop,
        colorAccessor: colorAccessor,
        colorScale: colorScale,
        valueAccessor: valueAccessor,
        labelAccessor: labelAccessor
    });
}

});



parcelRegister("7mHaJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $55cc139414156a08$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iZnN2 = parcelRequire("iZnN2");

var $lI55a = parcelRequire("lI55a");
function $55cc139414156a08$export$2e2bcd8739ae039(eventType) {
    if (eventType === void 0) eventType = (0, $iZnN2.EVENT_TYPE);
    const [activeSeriesKey, setActiveSeriesKey] = (0, $5uXOq.useState)();
    const setActiveSeriesKeyPublic = (0, $5uXOq.useCallback)((newKey)=>{
        if (activeSeriesKey !== newKey) setActiveSeriesKey(newKey);
    }, [
        activeSeriesKey,
        setActiveSeriesKey
    ]);
    const isSeriesSelected = (0, $5uXOq.useCallback)((label)=>{
        if (activeSeriesKey === undefined) return true;
        if (activeSeriesKey === label) return true;
        return false;
    }, [
        activeSeriesKey
    ]);
    // We will likely move this to the consumer side.
    // If datum is blah trigger this.
    (0, $lI55a.default)(eventType, (d)=>setActiveSeriesKeyPublic(d === null || d === void 0 ? void 0 : d.datum), [
        (0, $iZnN2.SERIES_SOURCE)
    ]);
    return {
        activeSeriesKey: activeSeriesKey,
        setActiveSeriesKeyPublic: setActiveSeriesKeyPublic,
        isSeriesSelected: isSeriesSelected
    };
}

});

parcelRegister("incVD", function(module, exports) {

$parcel$export(module.exports, "DonutChart", () => $bfc6d0390e699fef$export$533707e2f61b59ec);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $5Jz1t = parcelRequire("5Jz1t");

var $bT1Sw = parcelRequire("bT1Sw");
var $17PP9 = parcelRequire("17PP9");
const $bfc6d0390e699fef$var$CustomLayout = (0, $bT1Sw.element)(()=>{
    const { children: children } = (0, $17PP9.useElementProps)((0, $5Jz1t.default).elements.Layout);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        "data-element": "layout",
        xcss: $bfc6d0390e699fef$var$donutLayoutStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        "data-element": "chart",
        xcss: $bfc6d0390e699fef$var$donutChartStyles
    }, children));
}, {
    as: (0, $5Jz1t.default).elements.Layout
});
const $bfc6d0390e699fef$export$533707e2f61b59ec = ({ children: children, data: data })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Jz1t.default), {
        data: data,
        labelAccessor: (d)=>d.label,
        valueAccessor: (d)=>d.value,
        colorAccessor: (d)=>d.label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bfc6d0390e699fef$var$CustomLayout, {
        gridTemplate: [
            'plot'
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Jz1t.default).elements.Legend, {
        shape: "square"
    }), children);
};
const $bfc6d0390e699fef$var$donutLayoutStyles = (0, $8CUq3.xcss)({
    flexGrow: '1',
    overflow: 'hidden',
    paddingTop: 'space.075',
    paddingBottom: 'space.075',
    marginRight: 'space.negative.150'
});
const $bfc6d0390e699fef$var$donutChartStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flexDirection: 'row-reverse',
    height: '100%'
});

});

parcelRegister("bzu1k", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bf7bf183b3a6b08$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4bf7bf183b3a6b08$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "contextual-summary.project-summary.status-overview.title",
        "defaultMessage": "Status overview"
    },
    description: {
        "id": "contextual-summary.project-summary.status-overview.description",
        "defaultMessage": "Get a snapshot of the status of your issues. <link>View all issues</link>"
    },
    emptyDescription: {
        "id": "contextual-summary.project-summary.status-overview.empty-description",
        "defaultMessage": "The status overview for this project will display here after you <link>create some issues</link>"
    },
    chartLabel: {
        "id": "contextual-summary.project-summary.status-overview.chart-label",
        "defaultMessage": "Total issues"
    }
});

});


parcelRegister("1qZBw", function(module, exports) {

$parcel$export(module.exports, "TeamWorkload", () => $6e68e1caa6c7b076$export$f46ecd749e707dc5);

var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $l1N8i = parcelRequire("l1N8i");

var $cgL5K = parcelRequire("cgL5K");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $hDzhb = parcelRequire("hDzhb");

var $153fj = parcelRequire("153fj");

var $4BeU4 = parcelRequire("4BeU4");

var $bnge3 = parcelRequire("bnge3");

var $79GHn = parcelRequire("79GHn");

var $beAwS = parcelRequire("beAwS");

var $1lENx = parcelRequire("1lENx");
const $6e68e1caa6c7b076$var$UserRow = ({ item: { user: user }, totalUnresolvedIssues: totalUnresolvedIssues, counterText: counterText, linksResolver: linksResolver, linksTarget: linksTarget, count: count, colorScheme: colorScheme })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { fireSectionAnalytics: fireSectionAnalytics } = (0, $153fj.useSectionAnalytics)((0, $beAwS.SectionIds).TeamWorkload, (0, $beAwS.BoundaryIds).TeamWorkload);
    const unassignedUser = {
        accountId: undefined,
        avatarUrl: undefined,
        displayName: formatMessage((0, $1lENx.default).unassigned)
    };
    const { accountId: accountId, avatarUrl: avatarUrl, displayName: displayName } = user || unassignedUser;
    const onClickHref = linksResolver({
        filter: `assignee = ${accountId ?? 'EMPTY'}`,
        hideDone: true
    });
    const onRowClick = ()=>{
        fireSectionAnalytics('viewWithFilter', {
            count: count,
            isUnassigned: !user
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bnge3.PercentageTableRow), {
        count: count,
        totalUnresolvedIssues: totalUnresolvedIssues,
        counterText: counterText,
        onClickHref: onClickHref,
        linksTarget: linksTarget,
        onClick: onRowClick,
        linkAriaLabel: displayName,
        colorScheme: colorScheme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        src: avatarUrl,
        name: displayName,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        maxLines: 1
    }, displayName));
};
const $6e68e1caa6c7b076$export$f46ecd749e707dc5 = (props)=>{
    const totalUnresolvedIssues = (0, $5uXOq.useMemo)(()=>props.data.reduce((acc, { count: count })=>acc + count, 0), [
        props.data
    ]);
    const tableProps = totalUnresolvedIssues ? props : {
        ...props,
        data: [
            {
                id: '',
                count: 0,
                user: null
            }
        ]
    };
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { fireSectionAnalytics: fireSectionAnalytics } = (0, $153fj.useSectionAnalytics)((0, $beAwS.SectionIds).TeamWorkload, (0, $beAwS.BoundaryIds).TeamWorkload);
    const { linksResolver: linksResolver, linksTarget: linksTarget } = (0, $79GHn.useSummaryFeatures)();
    const handleLinkClick = (0, $5uXOq.useCallback)(()=>{
        fireSectionAnalytics('view');
    }, [
        fireSectionAnalytics
    ]);
    const countSelector = (0, $5uXOq.useCallback)(({ count: count })=>count, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4BeU4.ChartWithHeaderContainer), {
        header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            size: "small",
            as: "h2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1lENx.default).title)), totalUnresolvedIssues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $1lENx.default).description,
            values: {
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
                        href: linksResolver({
                            sortBy: 'assignee',
                            hideDone: true
                        }),
                        target: linksTarget,
                        onClick: handleLinkClick
                    }, chunks)
            }
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $1lENx.default).emptyDescription,
            values: {
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
                        href: linksResolver({
                            openCreateIssueDialog: true
                        }),
                        target: linksTarget,
                        onClick: handleLinkClick
                    }, chunks)
            }
        }))),
        chart: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bnge3.SinglePercentageTable), {
            typeText: formatMessage((0, $1lENx.default).typeColumn),
            distributionText: formatMessage((0, $1lENx.default).distributionColumn),
            counterText: formatMessage((0, $1lENx.default).counter),
            RowComponent: $6e68e1caa6c7b076$var$UserRow,
            getKey: ({ user: user })=>user?.accountId ?? 'unassigned',
            metricType: (0, $beAwS.MetricTypes).DISTRIBUTION,
            countSelector: countSelector,
            ...tableProps
        })
    });
};

});
parcelRegister("bnge3", function(module, exports) {

$parcel$export(module.exports, "SinglePercentageTable", () => $d27dd9b9019310ba$export$5d2c0897053fcd61);
$parcel$export(module.exports, "PercentageTableRow", () => $d27dd9b9019310ba$export$615e18cd840e8019);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $l8Afc = parcelRequire("l8Afc");

var $hDzhb = parcelRequire("hDzhb");

var $79GHn = parcelRequire("79GHn");

var $dXXko = parcelRequire("dXXko");

var $7Ow6B = parcelRequire("7Ow6B");

var $beAwS = parcelRequire("beAwS");
const $d27dd9b9019310ba$var$BAR_HEIGHT = 24;
const $d27dd9b9019310ba$var$BAR_BORDER_RADIUS = 2;
const $d27dd9b9019310ba$export$5d2c0897053fcd61 = ({ data: data, typeText: typeText, distributionText: distributionText, counterText: counterText, fetchNext: fetchNext, loadingNext: loadingNext, hasNextPage: hasNextPage, metaData: { totalUnresolvedIssues: totalUnresolvedIssues = 0 }, RowComponent: RowComponent, getKey: getKey, metricType: metricType = (0, $beAwS.MetricTypes).DISTRIBUTION, countSelector: countSelector, colorScheme: colorScheme })=>{
    const { onScroll: onScroll } = (0, $l8Afc.useScrollToEnd)({
        onScrollToEnd: fetchNext,
        isDisabled: loadingNext || !hasNextPage,
        options: {
            onEndReachedThreshold: 150
        }
    });
    const { linksResolver: linksResolver, linksTarget: linksTarget } = (0, $79GHn.useSummaryFeatures)();
    const metric = (0, $5uXOq.useMemo)(()=>metricType === (0, $beAwS.MetricTypes).COUNT ? {
            metricType: (0, $beAwS.MetricTypes).COUNT,
            maxCount: data.reduce((acc, item)=>Math.max(acc, countSelector(item)), 0)
        } : {
            metricType: (0, $beAwS.MetricTypes).DISTRIBUTION,
            maxCount: undefined
        }, [
        metricType,
        data,
        countSelector
    ]);
    const rows = (0, $5uXOq.useMemo)(()=>data.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RowComponent, {
                key: getKey(item),
                count: countSelector(item),
                item: item,
                totalUnresolvedIssues: totalUnresolvedIssues,
                counterText: counterText,
                linksResolver: linksResolver,
                linksTarget: linksTarget,
                metric: metric,
                colorScheme: colorScheme
            })), [
        countSelector,
        counterText,
        data,
        linksTarget,
        totalUnresolvedIssues,
        getKey,
        linksResolver,
        RowComponent,
        metric,
        colorScheme
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        onScroll: onScroll,
        className: (0, $bwpsq.default)([
            "_18m91wug _2hwxxmi2 _u5f3utpp"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("table", {
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _otyr1b66"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("thead", {
        className: (0, $bwpsq.default)([
            "_n7zlidpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("th", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("h6", {
        className: (0, $bwpsq.default)([
            "_syaz1wmz _1p1dglyw"
        ])
    }, typeText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("th", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("h6", {
        className: (0, $bwpsq.default)([
            "_syaz1wmz _1p1dglyw"
        ])
    }, distributionText)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tbody", {
        className: (0, $bwpsq.default)([
            "_n7zlidpf"
        ])
    }, rows)), loadingNext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dXXko.ScrollingLoader), null));
};
const $d27dd9b9019310ba$export$615e18cd840e8019 = ({ children: children, count: count, totalUnresolvedIssues: totalUnresolvedIssues, counterText: counterText, onClickHref: onClickHref, linksTarget: linksTarget, onClick: onClick, linkAriaLabel: linkAriaLabel, metric: metric, colorScheme: colorScheme })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tr", {
        className: (0, $bwpsq.default)([
            "_irr3xwku"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("td", {
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1r5k _19bv1b66 _u5f3u2gc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o _18u01b66"
        ])
    }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("td", {
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
        href: onClickHref,
        target: linksTarget,
        onClick: onClick,
        "aria-label": linkAriaLabel,
        className: (0, $bwpsq.default)([
            "_nt751r31 _49pc1wug _1hvw1o36 _9oik18uv _1bnxglyw _jf4cnqa1"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d27dd9b9019310ba$var$PercentageBar, {
        totalUnresolvedIssues: totalUnresolvedIssues,
        count: count,
        counterText: counterText,
        metric: metric,
        colorScheme: colorScheme
    }))));
const $d27dd9b9019310ba$var$useMovingTooltip = (isTooltipVisible)=>{
    const updateTooltip = (0, $5uXOq.useRef)();
    const [mouseMoved, setMouseMoved] = (0, $5uXOq.useState)(false);
    const handleMouseMove = (0, $5uXOq.useCallback)(()=>{
        setMouseMoved((prev)=>!prev);
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (isTooltipVisible) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('mousemove', handleMouseMove);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('mousemove', handleMouseMove);
        };
    }, [
        isTooltipVisible,
        handleMouseMove
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (isTooltipVisible) updateTooltip.current?.();
    }, [
        mouseMoved,
        isTooltipVisible
    ]);
    return updateTooltip;
};
const $d27dd9b9019310ba$var$PercentageBar = ({ totalUnresolvedIssues: totalUnresolvedIssues, count: count, counterText: counterText, metric: metric, colorScheme: colorScheme = (0, $beAwS.ColorSchemes).DEFAULT })=>{
    const [isTooltipVisible, setIsTooltipVisible] = (0, $5uXOq.useState)(false);
    const { addUFOCustomHoverData: addUFOCustomHoverData, UFOConditionalCustomHoverData: UFOConditionalCustomHoverData } = (0, $7Ow6B.useUFOCustomHoverData)();
    let percentage = 0;
    let barText = '';
    let width = 0;
    if (metric?.metricType === (0, $beAwS.MetricTypes).COUNT) {
        barText = `${count}`;
        width = `${Math.round(count / metric.maxCount * 100)}%`;
    } else {
        percentage = Math.round(count / totalUnresolvedIssues * 100);
        barText = `${percentage}%`;
        width = percentage > 0 ? `${percentage}%` : 0;
    }
    const updateTooltip = $d27dd9b9019310ba$var$useMovingTooltip(isTooltipVisible);
    const showPercentage = totalUnresolvedIssues !== 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return `${metric?.metricType === (0, $beAwS.MetricTypes).COUNT ? '' : `${percentage}% `} (${count}/${totalUnresolvedIssues} ${counterText})`;
        },
        position: "mouse",
        mousePosition: "bottom-start",
        delay: 0,
        onShow: ()=>{
            setIsTooltipVisible(true);
            addUFOCustomHoverData();
        },
        onHide: ()=>setIsTooltipVisible(false)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            ...showPercentage ? tooltipProps : {},
            className: (0, $bwpsq.default)([
                "_1e0c1txw _4cvr1h6o _ca0qu2gc _u5f3idpf _n3tdu2gc _19bvidpf"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                "_16jlkb7n _1o9zkb7n _i0dl1wug _2rkoyh40 _1e0c1txw _4t3i1tcg _bfhk134c _kqswh2mm"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                width: width,
                borderRadius: percentage === 100 ? `${$d27dd9b9019310ba$var$BAR_BORDER_RADIUS}px` : undefined
            },
            className: (0, $bwpsq.default)([
                "_2rko15w8 _bfhkkdha _7cca15wb _1f38b0vp",
                colorScheme === (0, $beAwS.ColorSchemes).BLUE && "_bfhkybjp"
            ])
        }, showPercentage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", {
            className: (0, $bwpsq.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz15cr _kqswstnw _1ltv1crf _154i1ssb _t9ec1i34 _lcxvglyw _1pbykb7n",
                "_19wjglyw"
            ])
        }, "..."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", {
            className: (0, $bwpsq.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz15cr _kqswstnw _1ltv1crf _154i1ssb _t9ec1i34 _lcxvglyw _1pbykb7n",
                "_l0jaglyw"
            ])
        }, barText)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(UFOConditionalCustomHoverData, null));
};
const $d27dd9b9019310ba$var$tableContainerStyles = null;
const $d27dd9b9019310ba$var$tableStyles = null;
const $d27dd9b9019310ba$var$tableHeaderStyles = null;
const $d27dd9b9019310ba$var$columnTitleStyles = null;
const $d27dd9b9019310ba$var$tableBodyStyles = null;
const $d27dd9b9019310ba$var$tableRowStyles = null;
const $d27dd9b9019310ba$var$tableTypeColumnStyles = null;
const $d27dd9b9019310ba$var$tablePercentageColumnStyles = null;
const $d27dd9b9019310ba$var$percentageBarLinkStyles = null;
const $d27dd9b9019310ba$var$typeContainerStyles = null;
const $d27dd9b9019310ba$var$percentageContainerStyles = null;
const $d27dd9b9019310ba$var$percentageBarStyles = null;
const $d27dd9b9019310ba$var$percentageBarFillStyles = null;
const $d27dd9b9019310ba$var$percentageBarBlueFillStyles = null;
const $d27dd9b9019310ba$var$baseLabelTextStyles = null;
const $d27dd9b9019310ba$var$truncatedTextStyles = null;
const $d27dd9b9019310ba$var$percentageTextStyles = null;

});

parcelRegister("1lENx", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec0838152f713b3b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ec0838152f713b3b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "contextual-summary.project-summary.team-workload.title",
        "defaultMessage": "Team workload"
    },
    description: {
        "id": "contextual-summary.project-summary.team-workload.description",
        "defaultMessage": "Monitor the capacity of your team. <link>Reassign issues to get the right balance</link>"
    },
    emptyDescription: {
        "id": "contextual-summary.project-summary.team-workload.empty-description",
        "defaultMessage": "To monitor the capacity of your team, <link>create some issues</link>"
    },
    unassigned: {
        "id": "contextual-summary.project-summary.team-workload.unassigned",
        "defaultMessage": "Unassigned"
    },
    typeColumn: {
        "id": "contextual-summary.project-summary.team-workload.type-column",
        "defaultMessage": "Assignee"
    },
    distributionColumn: {
        "id": "contextual-summary.project-summary.team-workload.distribution-column",
        "defaultMessage": "Work distribution"
    },
    counter: {
        "id": "contextual-summary.project-summary.team-workload.counter",
        "defaultMessage": "issues"
    }
});

});


parcelRegister("3fZW3", function(module, exports) {

$parcel$export(module.exports, "TypesOfWork", () => $38fcb610bbbb1660$export$b6b71316a955a275);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $kTK0a = parcelRequire("kTK0a");

var $l1N8i = parcelRequire("l1N8i");

var $cgL5K = parcelRequire("cgL5K");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $hDzhb = parcelRequire("hDzhb");

var $153fj = parcelRequire("153fj");

var $4BeU4 = parcelRequire("4BeU4");

var $bnge3 = parcelRequire("bnge3");

var $79GHn = parcelRequire("79GHn");

var $beAwS = parcelRequire("beAwS");

var $dqyQW = parcelRequire("dqyQW");
const $38fcb610bbbb1660$var$IssueTypeRow = ({ item: { issueType: { id: id, name: name, iconUrl: iconUrl } }, totalUnresolvedIssues: totalUnresolvedIssues, counterText: counterText, linksResolver: linksResolver, linksTarget: linksTarget, metric: metric, count: count, colorScheme: colorScheme })=>{
    const { fireSectionAnalytics: fireSectionAnalytics } = (0, $153fj.useSectionAnalytics)((0, $beAwS.SectionIds).TypesOfWork, (0, $beAwS.BoundaryIds).TypesOfWork);
    const onRowClick = ()=>{
        fireSectionAnalytics('viewWithFilter', {
            count: count
        });
    };
    const onClickHref = linksResolver({
        filter: `type = '${id}'`,
        hideDone: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bnge3.PercentageTableRow), {
        count: count,
        totalUnresolvedIssues: totalUnresolvedIssues,
        counterText: counterText,
        onClickHref: onClickHref,
        linksTarget: linksTarget,
        onClick: onRowClick,
        linkAriaLabel: name,
        metric: metric,
        colorScheme: colorScheme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        alt: "",
        src: iconUrl,
        className: (0, $bwpsq.default)([
            "_1bsbpxbi _4t3ipxbi"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        maxLines: 1
    }, name));
};
const $38fcb610bbbb1660$export$b6b71316a955a275 = ({ metricType: metricType = (0, $beAwS.MetricTypes).DISTRIBUTION, ...props })=>{
    const selector = (0, $5uXOq.useCallback)((item)=>item.count, []);
    const typesOfWorkTotal = (0, $5uXOq.useMemo)(()=>props.data.reduce((acc, { count: count })=>acc + count, 0), [
        props.data
    ]);
    const { linksResolver: linksResolver, linksTarget: linksTarget } = (0, $79GHn.useSummaryFeatures)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { fireSectionAnalytics: fireSectionAnalytics } = (0, $153fj.useSectionAnalytics)((0, $beAwS.SectionIds).TypesOfWork, (0, $beAwS.BoundaryIds).TypesOfWork);
    const onLinkClick = (0, $5uXOq.useCallback)(()=>{
        fireSectionAnalytics('view');
    }, [
        fireSectionAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4BeU4.ChartWithHeaderContainer), {
        header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            size: "small",
            as: "h2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $dqyQW.default).title)), typesOfWorkTotal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $dqyQW.default).description,
            values: {
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
                        href: linksResolver({
                            sortBy: 'issueType',
                            hideDone: true
                        }),
                        target: linksTarget,
                        onClick: onLinkClick
                    }, chunks)
            }
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $dqyQW.default).emptyDescription,
            values: {
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
                        href: `${(0, $kTK0a.getATLContextUrl)('support')}/jira-cloud-administration/docs/what-are-issue-types/`,
                        target: "_blank"
                    }, chunks)
            }
        }))),
        chart: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bnge3.SinglePercentageTable), {
            typeText: formatMessage((0, $dqyQW.default).typeColumn),
            distributionText: formatMessage((0, $dqyQW.default).distributionColumn),
            counterText: formatMessage((0, $dqyQW.default).counter),
            RowComponent: $38fcb610bbbb1660$var$IssueTypeRow,
            getKey: ({ issueType: issueType })=>issueType.id,
            countSelector: selector,
            metricType: metricType,
            ...props
        })
    });
};
const $38fcb610bbbb1660$var$iconStyles = null;

});
parcelRegister("dqyQW", function(module, exports) {

$parcel$export(module.exports, "default", () => $394996a9107e5c49$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $394996a9107e5c49$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "contextual-summary.project-summary.types-of-work.title",
        "defaultMessage": "Types of work"
    },
    description: {
        "id": "contextual-summary.project-summary.types-of-work.description",
        "defaultMessage": "Get a breakdown of issues by their types. <link>View all items</link>"
    },
    emptyDescription: {
        "id": "contextual-summary.project-summary.types-of-work.empty-description",
        "defaultMessage": "Create some issues to view a breakdown of total work by issue type. <link>What are issue types?</link>"
    },
    typeColumn: {
        "id": "contextual-summary.project-summary.types-of-work.type-column",
        "defaultMessage": "Type"
    },
    distributionColumn: {
        "id": "contextual-summary.project-summary.types-of-work.distribution-column",
        "defaultMessage": "Distribution"
    },
    counter: {
        "id": "contextual-summary.project-summary.types-of-work.counter",
        "defaultMessage": "issues"
    }
});

});


parcelRegister("hgVrX", function(module, exports) {

$parcel$export(module.exports, "ActivityFeed", () => $3aec347f0019c690$export$38f53ea5fa94cff8);

var $5uXOq = parcelRequire("5uXOq");

var $f9ece = parcelRequire("f9ece");

var $9JptI = parcelRequire("9JptI");

var $iMVUf = parcelRequire("iMVUf");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $l1N8i = parcelRequire("l1N8i");

var $koVbs = parcelRequire("koVbs");

var $7CMCs = parcelRequire("7CMCs");

var $4BeU4 = parcelRequire("4BeU4");

var $hKvdY = parcelRequire("hKvdY");

var $1Sc6c = parcelRequire("1Sc6c");

var $bJXyx = parcelRequire("bJXyx");
const $3aec347f0019c690$var$emptyIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
    width: "96",
    height: "96",
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    d: "M79.8599 43.4902H31.1499V67.2902H79.8599V43.4902Z",
    fill: "#1868DB"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    d: "M64.72 28.71H16.01V52.51H64.72V28.71Z",
    fill: "#DDDEE1"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    d: "M64.7199 43.4902H31.1499V52.5102H64.7199V43.4902Z",
    fill: "#09326C"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M76.8299 52.09L66.3399 62.58L60.9199 57.01L63.2599 54.74L66.3799 57.94L74.5299 49.79L76.8399 52.1L76.8299 52.09Z",
    fill: "white"
}));
const $3aec347f0019c690$export$38f53ea5fa94cff8 = ({ data: activities })=>{
    const { formatDate: formatDate, formatMessage: formatMessage } = (0, $koVbs.default)();
    const itemsByDate = (0, $5uXOq.useMemo)(()=>activities.reduce((groups, item)=>{
            const publishedDate = new Date(item.created);
            const key = (0, $f9ece.default)(publishedDate, 'UTC', 'yyyy-MM-dd');
            const lastGroup = groups[groups.length - 1];
            if (lastGroup?.key === key) lastGroup.items.push(item);
            else {
                let label;
                if ((0, $9JptI.default)(publishedDate)) label = formatMessage((0, $bJXyx.default).todayLabel);
                else if ((0, $iMVUf.default)(publishedDate)) label = formatMessage((0, $bJXyx.default).yesterdayLabel);
                else label = formatDate(key, {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });
                groups.push({
                    key: key,
                    label: label,
                    items: [
                        item
                    ]
                });
            }
            return groups;
        }, []), [
        activities,
        formatDate,
        formatMessage
    ]);
    if (!activities.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKvdY.EmptyState), {
        icon: $3aec347f0019c690$var$emptyIcon,
        headingText: formatMessage((0, $bJXyx.default).emptyStateTitle),
        descriptionText: formatMessage((0, $bJXyx.default).emptyStateDescription)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4BeU4.ChartWithHeaderContainer), {
        header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            size: "small",
            as: "h2"
        }, formatMessage((0, $bJXyx.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $bJXyx.default).description))),
        chart: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $3aec347f0019c690$var$containerStyles
        }, itemsByDate.map(({ key: key, label: label, items: items })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                key: key
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
                size: "xxsmall",
                as: "h3"
            }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
                as: "ul",
                direction: "column",
                rowGap: "space.200",
                xcss: $3aec347f0019c690$var$activityListStyles
            }, items.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
                    key: item.created,
                    id: "activityFeedItem",
                    packageName: "jiraContextualSummary",
                    teamName: "helios-reports"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    as: "li"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Sc6c.ActivityItem), {
                    activity: item
                }))))))))
    });
};
const $3aec347f0019c690$var$containerStyles = (0, $8CUq3.xcss)({
    overflowY: 'auto',
    overflowX: 'hidden',
    flexGrow: '1',
    marginRight: 'space.negative.150',
    paddingRight: 'space.150'
});
const $3aec347f0019c690$var$activityListStyles = (0, $8CUq3.xcss)({
    listStyleType: 'none',
    padding: '0',
    marginTop: 'space.100',
    marginBottom: 'space.100',
    paddingRight: 'space.050'
});

});
parcelRegister("1Sc6c", function(module, exports) {

$parcel$export(module.exports, "ActivityItem", () => $d52109f0adab754d$export$6d45a429e25bf06f);
/* eslint-disable @typescript-eslint/consistent-type-assertions */ // TODO: reconsider use of type assertions and implement something safer with type guards or similar

var $5uXOq = parcelRequire("5uXOq");

var $8dpu4 = parcelRequire("8dpu4");

var $4Pfmb = parcelRequire("4Pfmb");

var $aGoax = parcelRequire("aGoax");

var $cSD1r = parcelRequire("cSD1r");

var $1XsfU = parcelRequire("1XsfU");

var $53TL6 = parcelRequire("53TL6");

var $7cFa2 = parcelRequire("7cFa2");
const $d52109f0adab754d$var$renderActivityComponent = (activity)=>{
    switch(activity.type){
        case 'ASSIGNEE_CHANGED':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8dpu4.AssigneeChanged), {
                activity: activity
            });
        case 'ATTACHMENT_ADDED':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Pfmb.AttachmentAdded), {
                activity: activity
            });
        case 'COMMENT_ADDED':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aGoax.CommentAdded), {
                activity: activity
            });
        case 'CREATED':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cSD1r.IssueCreated), {
                activity: activity
            });
        case 'PRIORITY_CHANGED':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1XsfU.PriorityChanged), {
                activity: activity
            });
        case 'SINGLE_FIELD_UPDATED':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $53TL6.SingleFieldUpdated), {
                activity: activity
            });
        case 'STATUS_CHANGED':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7cFa2.StatusChanged), {
                activity: activity
            });
        default:
            return null;
    }
};
const $d52109f0adab754d$export$6d45a429e25bf06f = ({ activity: activity })=>{
    return $d52109f0adab754d$var$renderActivityComponent(activity);
};

});
parcelRegister("8dpu4", function(module, exports) {

$parcel$export(module.exports, "AssigneeChanged", () => $5d63934a9377158c$export$9979c0cca8df82bd);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $kUujW = parcelRequire("kUujW");

var $i6Q86 = parcelRequire("i6Q86");

var $beAwS = parcelRequire("beAwS");

var $ckwn2 = parcelRequire("ckwn2");

var $153fj = parcelRequire("153fj");

var $kfrXe = parcelRequire("kfrXe");

var $29Z5g = parcelRequire("29Z5g");
const $5d63934a9377158c$export$9979c0cca8df82bd = ({ activity: { created: created, issueData: issueData, author: author, data: { toAssignee: toAssignee } } })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { fireSectionAnalytics: fireSectionAnalytics } = (0, $153fj.useSectionAnalytics)((0, $beAwS.SectionIds).RecentActivity, (0, $beAwS.BoundaryIds).RecentActivity);
    const onActivityItemClick = (0, $5uXOq.useCallback)((target)=>{
        fireSectionAnalytics(target, {
            boundaryId: (0, $beAwS.BoundaryIds).RecentActivity,
            activityType: (0, $beAwS.ActivityTypes).ASSIGNEE_CHANGED
        });
    }, [
        fireSectionAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        columnGap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i6Q86.UserAvatar), {
        author: author
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        rowGap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ckwn2.ActivityMessage), {
        author: author,
        issueData: issueData,
        onClick: onActivityItemClick
    }, ({ author: activityAuthor, issueLink: issueLink })=>toAssignee ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $5d63934a9377158c$var$inlineStyles
        }, formatMessage((0, $29Z5g.default).assigneeChangedContent, {
            author: activityAuthor,
            issueLink: issueLink,
            newAssignee: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kfrXe.UsernameDisplay), {
                user: toAssignee
            })
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $5d63934a9377158c$var$inlineStyles
        }, formatMessage((0, $29Z5g.default).assigneeRemovedContent, {
            author: activityAuthor,
            issueLink: issueLink
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kUujW.RelativeTime), {
        time: created
    }))));
};
const $5d63934a9377158c$var$inlineStyles = (0, $8CUq3.xcss)({
    display: 'inline'
});

});
parcelRegister("kUujW", function(module, exports) {

$parcel$export(module.exports, "RelativeTime", () => $1383bad69b90df4c$export$19a7b8b69be8b795);

var $5uXOq = parcelRequire("5uXOq");

var $cgL5K = parcelRequire("cgL5K");

var $DVljb = parcelRequire("DVljb");

var $1p96B = parcelRequire("1p96B");
const $1383bad69b90df4c$export$19a7b8b69be8b795 = ({ time: time })=>{
    const locale = (0, $DVljb.useLocale)();
    const timeDisplayString = (0, $5uXOq.useMemo)(()=>(0, $1p96B.formatDistanceWithLocale)(new Date(time), new Date(), locale, true), [
        time,
        locale
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text.subtle",
        as: "p"
    }, timeDisplayString);
};

});

parcelRegister("i6Q86", function(module, exports) {

$parcel$export(module.exports, "UserAvatar", () => $7ac572884e9c9dd4$export$6c0524ba53950d9f);

var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $koVbs = parcelRequire("koVbs");

var $fptvq = parcelRequire("fptvq");
const $7ac572884e9c9dd4$export$6c0524ba53950d9f = ({ author: author })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!author.profilePicture && author.displayName === 'Unknown') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        name: formatMessage((0, $fptvq.default).unknown),
        size: "small"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        src: author.profilePicture ?? undefined,
        name: author.displayName,
        size: "small"
    });
};

});
parcelRegister("fptvq", function(module, exports) {

$parcel$export(module.exports, "default", () => $e499b17d171f3819$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e499b17d171f3819$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    unknown: {
        "id": "contextual-summary.common.user-avatar.unknown",
        "defaultMessage": "Unknown"
    }
});

});


parcelRegister("ckwn2", function(module, exports) {

$parcel$export(module.exports, "ActivityMessage", () => $e7668935736ce3ca$export$64f87d9f80f55ab);

var $5uXOq = parcelRequire("5uXOq");

var $cgL5K = parcelRequire("cgL5K");

var $kVZJG = parcelRequire("kVZJG");

var $kfrXe = parcelRequire("kfrXe");
const $e7668935736ce3ca$export$64f87d9f80f55ab = ({ author: author, issueData: issueData, onClick: onClick, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, children({
        author: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kfrXe.UsernameDisplay), {
            user: author,
            onClick: ()=>{
                onClick('user');
            }
        }),
        issueLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kVZJG.Card), {
            url: issueData.url,
            appearance: "inline",
            platform: "web",
            onClick: ()=>onClick('issue')
        })
    }));
};

});
parcelRegister("kVZJG", function(module, exports) {

$parcel$export(module.exports, "Card", () => $fc8afc0c39cee453$export$60332b2344f7fe41);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");
var $i5FdW = parcelRequire("i5FdW");

var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $fzJZi = parcelRequire("fzJZi");

var $lpxJ1 = parcelRequire("lpxJ1");
class $fc8afc0c39cee453$var$PlainCard extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const content = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lpxJ1.CardWithURLRenderer), {
            ...this.props
        });
        return this.props.intl ? content : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
            locale: "en",
            children: content
        });
    }
}
const $fc8afc0c39cee453$export$60332b2344f7fe41 = (0, $994MI.default)((0, $fzJZi.context))((0, $cb25w.default)()((0, $8RXs9.default)($fc8afc0c39cee453$var$PlainCard, {
    enforceContext: false
})));

});
parcelRegister("fzJZi", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $3b4d25437cc28513$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $3b4d25437cc28513$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $3b4d25437cc28513$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $3b4d25437cc28513$export$c89e475f7f7174c2);
$parcel$export(module.exports, "SmartLinkEvents", () => $3b4d25437cc28513$export$b91e0203b928470c);
const $3b4d25437cc28513$export$85183a312807388d = 'media';
const $3b4d25437cc28513$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
var $3b4d25437cc28513$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
var $3b4d25437cc28513$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});
class $3b4d25437cc28513$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $3b4d25437cc28513$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $3b4d25437cc28513$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($3b4d25437cc28513$export$85183a312807388d);
};

});

parcelRegister("lpxJ1", function(module, exports) {

$parcel$export(module.exports, "CardWithURLRenderer", () => $422a0598dbbdc42a$export$e00a7788e30dc998);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $gKZoD = parcelRequire("gKZoD");

var $7Jxgt = parcelRequire("7Jxgt");

var $a1vqi = parcelRequire("a1vqi");

var $1VPdD = parcelRequire("1VPdD");

var $kxcRq = parcelRequire("kxcRq");

var $5igsJ = parcelRequire("5igsJ");

var $91tw3 = parcelRequire("91tw3");

var $5vDFA = parcelRequire("5vDFA");

var $i41Ob = parcelRequire("i41Ob");

const $422a0598dbbdc42a$export$a7690c318cd6a95e = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(0, $kxcRq.importWithRetry)(()=>(parcelRequire("5HNFf"))));
function $422a0598dbbdc42a$export$e00a7788e30dc998(props) {
    (0, $gKZoD.di)($422a0598dbbdc42a$export$a7690c318cd6a95e);
    const [id] = (0, $5uXOq.useState)(()=>props.id ? props.id : (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))());
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        // ComponentWillUnmount
        return ()=>{
            (0, $5vDFA.clearMarks)(id);
            (0, $5vDFA.clearMeasures)(id);
        };
    }, [
        id
    ]);
    const { url: url, appearance: appearance, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, onClick: onClick, container: container, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, inheritDimensions: inheritDimensions, platform: platform, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, children: children, ui: ui, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, placeholder: placeholder, fallbackComponent: fallbackComponent, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline } = props;
    const isFlexibleUi = (0, $91tw3.isFlexibleUiCard)(children);
    const analyticsContext = (0, $5igsJ.useSmartLinkAnalyticsContext)({
        display: isFlexibleUi ? 'flexible' : appearance,
        id: id,
        url: url ?? ''
    });
    const errorHandler = (0, $5uXOq.useCallback)((error, info)=>{
        const { componentStack: componentStack } = info;
        const errorInfo = {
            componentStack: componentStack
        };
        // NB: APIErrors are thrown in response to Object Resolver Service. We do not
        // fire an event for these, as they do not cover failed UI render events.
        // The rest of the errors caught here are unexpected, and correlate
        // to the reliability of the smart-card front-end components.
        // Likewise, chunk loading errors are not caused by a failure of smart-card rendering.
        if (error.name === 'ChunkLoadError') fireEvent('operational.smartLink.chunkLoadFailed', {
            ...analyticsContext?.attributes,
            display: appearance,
            error: error,
            errorInfo: errorInfo,
            definitionId: null
        });
        else if (error.name !== 'APIError') {
            (0, $1VPdD.startUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $1VPdD.failUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $1VPdD.failUfoExperience)('smart-link-authenticated', id || 'NULL');
            fireEvent('ui.smartLink.renderFailed', {
                ...analyticsContext?.attributes,
                display: isFlexibleUi ? 'flexible' : appearance,
                id: id ?? null,
                error: error,
                errorInfo: errorInfo
            });
        }
        onError && onError({
            status: 'errored',
            url: url ?? '',
            err: error
        });
    }, [
        analyticsContext?.attributes,
        appearance,
        fireEvent,
        id,
        isFlexibleUi,
        onError,
        url
    ]);
    if (!url) throw new Error('@atlaskit/smart-card: url property is missing.');
    const defaultFallBackComponent = ()=>null;
    const FallbackComponent = fallbackComponent ?? defaultFallBackComponent;
    const ErrorFallback = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)(FallbackComponent, {});
    const cardWithUrlProps = {
        id: id,
        url: url,
        appearance: appearance,
        onClick: onClick,
        isSelected: isSelected,
        isHovered: isHovered,
        frameStyle: frameStyle,
        container: container,
        onResolve: onResolve,
        onError: onError,
        testId: testId,
        actionOptions: actionOptions,
        inheritDimensions: inheritDimensions,
        platform: platform,
        embedIframeRef: embedIframeRef,
        embedIframeUrlType: embedIframeUrlType,
        inlinePreloaderStyle: inlinePreloaderStyle,
        ui: ui,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        placeholder: placeholder,
        removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
        resolvingPlaceholder: resolvingPlaceholder,
        truncateInline: truncateInline
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
        FallbackComponent: ErrorFallback,
        onError: errorHandler,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
            fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i41Ob.LoadingCardLink), {
                ...cardWithUrlProps
            }),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($422a0598dbbdc42a$export$a7690c318cd6a95e, {
                ...cardWithUrlProps,
                children: children
            })
        })
    });
}

});
parcelRegister("a1vqi", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $91130a451fd4887d$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::1f3587129789e7883af37adad3817cd2>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");


var $1PQcU = parcelRequire("1PQcU");
const $91130a451fd4887d$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireEvent = (0, $5uXOq.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $1PQcU.default)(...params));
        event.fire((0, $37b399a913bad22b$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
const $37b399a913bad22b$export$3f072f06b90c3985 = 'media';

parcelRegister("1PQcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $539e70e97f68df84$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::eb8cd1263459fb798341024dc0c461ea>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ const $539e70e97f68df84$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $539e70e97f68df84$export$2e2bcd8739ae039 = $539e70e97f68df84$var$createEventPayload;

});


parcelRegister("1VPdD", function(module, exports) {

$parcel$export(module.exports, "startUfoExperience", () => $2308e6f5aae12b86$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $2308e6f5aae12b86$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $2308e6f5aae12b86$export$8dda83bafca11b77);
$parcel$export(module.exports, "addMetadataToExperience", () => $2308e6f5aae12b86$export$4084c0df4a03a6af);

var $cBycP = parcelRequire("cBycP");
var $7Zbvr = parcelRequire("7Zbvr");
const $2308e6f5aae12b86$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult
};
const $2308e6f5aae12b86$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $7Zbvr.ExperienceTypes).Load,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).PageSegmentLoad
};
const $2308e6f5aae12b86$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult
};
const $2308e6f5aae12b86$var$ufoExperiences = {
    'smart-link-rendered': new (0, $cBycP.ConcurrentExperience)('smart-link-rendered', $2308e6f5aae12b86$var$renderExperience),
    'smart-link-authenticated': new (0, $cBycP.ConcurrentExperience)('smart-link-authenticated', $2308e6f5aae12b86$var$inlineExperience),
    'smart-link-action-invocation': new (0, $cBycP.ConcurrentExperience)('smart-link-action-invocation', $2308e6f5aae12b86$var$inlineExperience),
    'smart-link-ai-summary': new (0, $cBycP.ConcurrentExperience)('smart-link-ai-summary', $2308e6f5aae12b86$var$aiExperience)
};
const $2308e6f5aae12b86$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $2308e6f5aae12b86$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $2308e6f5aae12b86$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $2308e6f5aae12b86$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};

});

parcelRegister("kxcRq", function(module, exports) {

$parcel$export(module.exports, "isSpecialEvent", () => $c53851cced73411d$export$efca2c4705678489);
$parcel$export(module.exports, "getIconForFileType", () => $c53851cced73411d$export$4d685c85ebc7a1e3);
$parcel$export(module.exports, "getLazyIcons", () => $c53851cced73411d$export$92d31eb5326761b6);
$parcel$export(module.exports, "getIframeSandboxAttribute", () => $c53851cced73411d$export$9b7e6a102056a387);
$parcel$export(module.exports, "handleOnClick", () => $c53851cced73411d$export$ffccab2ae3d093ef);
$parcel$export(module.exports, "isIntersectionObserverSupported", () => $c53851cced73411d$export$6c837641a9ab03cb);
$parcel$export(module.exports, "importWithRetry", () => $c53851cced73411d$export$aacbf48ace518c5a);
$parcel$export(module.exports, "downloadUrl", () => $c53851cced73411d$export$8a96edb1c96563f4);
$parcel$export(module.exports, "openUrl", () => $c53851cced73411d$export$a238cfe4a10e6279);
$parcel$export(module.exports, "getPreviewUrlWithTheme", () => $c53851cced73411d$export$4470f298c61a79da);
$parcel$export(module.exports, "isIconSizeLarge", () => $c53851cced73411d$export$d2b8fb9e780e17e7);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $VSDnB = parcelRequire("VSDnB");

var $imVhc = parcelRequire("imVhc");

var $8dVIb = parcelRequire("8dVIb");

var $liAf6 = parcelRequire("liAf6");
const $c53851cced73411d$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ($c53851cced73411d$export$e6c5ffa684aac4d7() || $c53851cced73411d$export$d8de0cd37d316fdf(evt) || $c53851cced73411d$export$5b1771037ab7c451(evt));
const $c53851cced73411d$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;
const $c53851cced73411d$export$d8de0cd37d316fdf = (event)=>{
    return (0, $VSDnB.fg)('platform-smart-card-shift-key') ? event.metaKey || event.ctrlKey || event.shiftKey : event.metaKey || event.ctrlKey;
};
const $c53851cced73411d$export$5b1771037ab7c451 = (event)=>event.button === 1;
const $c53851cced73411d$export$4d685c85ebc7a1e3 = (fileMimeType)=>{
    if (!fileMimeType) return;
    let icon = (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? $c53851cced73411d$var$getTypeToIconMap(fileMimeType.toLowerCase()) : $c53851cced73411d$var$typeToIcon[fileMimeType.toLowerCase()];
    if (!icon) return;
    const [label, importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    }); // because we're using dynamic loading here, TS will not be able to infer the type
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
        label: label,
        testId: "document-file-format-icon"
    });
};
const $c53851cced73411d$export$371bef29a3733127 = (fileMimeType)=>{
    let icon = (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? $c53851cced73411d$var$getTypeToIconMap(fileMimeType.toLowerCase()) : $c53851cced73411d$var$typeToIcon[fileMimeType.toLowerCase()];
    if (!icon) return;
    const [label] = icon;
    return label;
};


















































const $c53851cced73411d$var$typeToIcon = {
    'text/plain': [
        'Document',
        ()=>Promise.resolve((parcelRequire("duwKf")))
    ],
    'application/vnd.oasis.opendocument.text': [
        'Document',
        ()=>Promise.resolve((parcelRequire("duwKf")))
    ],
    'application/vnd.apple.pages': [
        'Document',
        ()=>Promise.resolve((parcelRequire("duwKf")))
    ],
    'application/vnd.google-apps.document': [
        'Google Doc',
        ()=>(parcelRequire("6q8Pr"))
    ],
    'application/msword': [
        'Word document',
        ()=>(parcelRequire("e3PhT"))
    ],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
        'Word document',
        ()=>(parcelRequire("e3PhT"))
    ],
    'application/pdf': [
        'PDF document',
        ()=>(parcelRequire("55TA3"))
    ],
    'application/vnd.oasis.opendocument.spreadsheet': [
        'Spreadsheet',
        ()=>(parcelRequire("lb4t9"))
    ],
    'application/vnd.apple.numbers': [
        'Spreadsheet',
        ()=>(parcelRequire("lb4t9"))
    ],
    'application/vnd.google-apps.spreadsheet': [
        'Google Sheet',
        ()=>(parcelRequire("bwXIZ"))
    ],
    'application/vnd.ms-excel': [
        'Excel spreadsheet',
        ()=>(parcelRequire("8vv4H"))
    ],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
        'Excel spreadsheet',
        ()=>(parcelRequire("8vv4H"))
    ],
    'application/vnd.oasis.opendocument.presentation': [
        'Presentation',
        ()=>(parcelRequire("2t9Hh"))
    ],
    'application/vnd.apple.keynote': [
        'Presentation',
        ()=>(parcelRequire("2t9Hh"))
    ],
    'application/vnd.google-apps.presentation': [
        'Google Slide',
        ()=>(parcelRequire("6SoQO"))
    ],
    'application/vnd.ms-powerpoint': [
        'PowerPoint presentation',
        ()=>(parcelRequire("TZHl8"))
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': [
        'PowerPoint presentation',
        ()=>(parcelRequire("TZHl8"))
    ],
    'application/vnd.google-apps.form': [
        'Google Form',
        ()=>(parcelRequire("3VL73"))
    ],
    'image/png': [
        'Image',
        ()=>(parcelRequire("ifmtc"))
    ],
    'image/jpeg': [
        'Image',
        ()=>(parcelRequire("ifmtc"))
    ],
    'image/bmp': [
        'Image',
        ()=>(parcelRequire("ifmtc"))
    ],
    'image/webp': [
        'Image',
        ()=>(parcelRequire("ifmtc"))
    ],
    'image/svg+xml': [
        'Image',
        ()=>(parcelRequire("ifmtc"))
    ],
    'image/gif': [
        'GIF',
        ()=>(parcelRequire("eogSM"))
    ],
    'audio/midi': [
        'Audio',
        ()=>(parcelRequire("5nV2R"))
    ],
    'audio/mpeg': [
        'Audio',
        ()=>(parcelRequire("5nV2R"))
    ],
    'audio/webm': [
        'Audio',
        ()=>(parcelRequire("5nV2R"))
    ],
    'audio/ogg': [
        'Audio',
        ()=>(parcelRequire("5nV2R"))
    ],
    'audio/wav': [
        'Audio',
        ()=>(parcelRequire("5nV2R"))
    ],
    'video/mp4': [
        'Video',
        ()=>(parcelRequire("6Y2WT"))
    ],
    'video/quicktime': [
        'Video',
        ()=>(parcelRequire("6Y2WT"))
    ],
    'video/mov': [
        'Video',
        ()=>(parcelRequire("6Y2WT"))
    ],
    'video/webm': [
        'Video',
        ()=>(parcelRequire("6Y2WT"))
    ],
    'video/ogg': [
        'Video',
        ()=>(parcelRequire("6Y2WT"))
    ],
    'video/x-ms-wmv': [
        'Video',
        ()=>(parcelRequire("6Y2WT"))
    ],
    'video/x-msvideo': [
        'Video',
        ()=>(parcelRequire("6Y2WT"))
    ],
    'application/zip': [
        'Archive',
        ()=>(parcelRequire("4m4MY"))
    ],
    'application/x-tar': [
        'Archive',
        ()=>(parcelRequire("4m4MY"))
    ],
    'application/x-gtar': [
        'Archive',
        ()=>(parcelRequire("4m4MY"))
    ],
    'application/x-7z-compressed': [
        'Archive',
        ()=>(parcelRequire("4m4MY"))
    ],
    'application/x-apple-diskimage': [
        'Archive',
        ()=>(parcelRequire("4m4MY"))
    ],
    'application/vnd.rar': [
        'Archive',
        ()=>(parcelRequire("4m4MY"))
    ],
    'application/dmg': [
        'Executable',
        ()=>(parcelRequire("gmDdF"))
    ],
    'text/css': [
        'Source Code',
        ()=>(parcelRequire("coOzc"))
    ],
    'text/html': [
        'Source Code',
        ()=>(parcelRequire("coOzc"))
    ],
    'application/javascript': [
        'Source Code',
        ()=>(parcelRequire("coOzc"))
    ],
    'application/octet-stream': [
        'Binary file',
        ()=>(parcelRequire("ldQLy"))
    ],
    'application/invision.prototype': [
        'Prototype',
        ()=>(parcelRequire("ldQLy"))
    ],
    // TODO: Figure a way to detect those
    'application/sketch': [
        'Sketch',
        ()=>(parcelRequire("4WgJk"))
    ],
    folder: [
        'Folder',
        ()=>(parcelRequire("fjtI4"))
    ]
};
























































































const $c53851cced73411d$export$92d31eb5326761b6 = ()=>{
    return {
        [(0, $8dVIb.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("94rku")))
        },
        [(0, $8dVIb.IconType).Blog]: {
            default: ()=>Promise.resolve((parcelRequire("dVpJZ")))
        },
        [(0, $8dVIb.IconType).Audio]: {
            default: ()=>(parcelRequire("6ftoN"))
        },
        [(0, $8dVIb.IconType).Code]: {
            default: ()=>(parcelRequire("a0Blm"))
        },
        [(0, $8dVIb.IconType).File]: {
            default: ()=>(parcelRequire("gp1iV"))
        },
        [(0, $8dVIb.IconType).Folder]: {
            default: ()=>(parcelRequire("jJcF3"))
        },
        [(0, $8dVIb.IconType).Generic]: {
            default: ()=>(parcelRequire("gp1iV"))
        },
        [(0, $8dVIb.IconType).Image]: {
            default: ()=>(parcelRequire("eT6gz"))
        },
        [(0, $8dVIb.IconType).Presentation]: {
            default: ()=>(parcelRequire("fHKiX"))
        },
        [(0, $8dVIb.IconType).Spreadsheet]: {
            default: ()=>(parcelRequire("9ulvP"))
        },
        [(0, $8dVIb.IconType).Video]: {
            default: ()=>(parcelRequire("3K7kY"))
        },
        [(0, $8dVIb.IconType).Project]: {
            default: ()=>(parcelRequire("1mt5h"))
        },
        [(0, $8dVIb.IconType).Template]: {
            default: ()=>(parcelRequire("vxJ9s"))
        },
        [(0, $8dVIb.IconType).Forbidden]: {
            default: ()=>(parcelRequire("23MsP"))
        },
        [(0, $8dVIb.IconType).Default]: {
            default: ()=>Promise.resolve((parcelRequire("jOyH3")))
        },
        [(0, $8dVIb.IconType).Archive]: {
            default: ()=>(parcelRequire("4m4MY")),
            large: ()=>(parcelRequire("6jkTx"))
        },
        [(0, $8dVIb.IconType).Executable]: {
            default: ()=>(parcelRequire("gmDdF")),
            large: ()=>(parcelRequire("kWjiJ"))
        },
        [(0, $8dVIb.IconType).GIF]: {
            default: ()=>(parcelRequire("eogSM")),
            large: ()=>(parcelRequire("03kpR"))
        },
        [(0, $8dVIb.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("6q8Pr")),
            large: ()=>(parcelRequire("3rJ38"))
        },
        [(0, $8dVIb.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("3VL73")),
            large: ()=>(parcelRequire("jiAjo"))
        },
        [(0, $8dVIb.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("bwXIZ")),
            large: ()=>(parcelRequire("3hQB1"))
        },
        [(0, $8dVIb.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("6SoQO")),
            large: ()=>(parcelRequire("70xas"))
        },
        [(0, $8dVIb.IconType).MSExcel]: {
            default: ()=>(parcelRequire("8vv4H")),
            large: ()=>(parcelRequire("7P2U4"))
        },
        [(0, $8dVIb.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("TZHl8")),
            large: ()=>(parcelRequire("9Eo4X"))
        },
        [(0, $8dVIb.IconType).MSWord]: {
            default: ()=>(parcelRequire("e3PhT")),
            large: ()=>(parcelRequire("gBnqE"))
        },
        [(0, $8dVIb.IconType).PDF]: {
            default: ()=>(parcelRequire("55TA3")),
            large: ()=>(parcelRequire("eWGoe"))
        },
        [(0, $8dVIb.IconType).Sketch]: {
            default: ()=>(parcelRequire("4WgJk")),
            large: ()=>(parcelRequire("fu8cn"))
        },
        // Bitbucket icons
        [(0, $8dVIb.IconType).Branch]: {
            default: ()=>(parcelRequire("cAU6j")),
            large: ()=>(parcelRequire("4rggH"))
        },
        [(0, $8dVIb.IconType).Commit]: {
            default: ()=>(parcelRequire("bn2CC")),
            large: ()=>(parcelRequire("2nXLN"))
        },
        [(0, $8dVIb.IconType).PullRequest]: {
            default: ()=>(parcelRequire("cIR4U")),
            large: ()=>(parcelRequire("d4Msz"))
        },
        [(0, $8dVIb.IconType).Repo]: {
            default: ()=>(parcelRequire("bbgWK")),
            large: ()=>(parcelRequire("4Z42j"))
        },
        // Jira icons
        [(0, $8dVIb.IconType).Bug]: {
            default: ()=>(parcelRequire("jNgVH")),
            large: ()=>(parcelRequire("9LCHw"))
        },
        [(0, $8dVIb.IconType).Change]: {
            default: ()=>(parcelRequire("hhL96")),
            large: ()=>(parcelRequire("tyrb0"))
        },
        [(0, $8dVIb.IconType).Epic]: {
            default: ()=>(parcelRequire("9q15g")),
            large: ()=>(parcelRequire("fwsJh"))
        },
        [(0, $8dVIb.IconType).Incident]: {
            default: ()=>(parcelRequire("14Fhu")),
            large: ()=>(parcelRequire("2EQdA"))
        },
        [(0, $8dVIb.IconType).Problem]: {
            default: ()=>(parcelRequire("3Qygt")),
            large: ()=>(parcelRequire("7GCAt"))
        },
        [(0, $8dVIb.IconType).ServiceRequest]: {
            default: ()=>(parcelRequire("7J5Ma")),
            large: ()=>(parcelRequire("akYbd"))
        },
        [(0, $8dVIb.IconType).Story]: {
            default: ()=>(parcelRequire("iErKi")),
            large: ()=>(parcelRequire("fuaYA"))
        },
        [(0, $8dVIb.IconType).SubTask]: {
            default: ()=>(parcelRequire("kBegL")),
            large: ()=>(parcelRequire("5sJWF"))
        },
        [(0, $8dVIb.IconType).Task]: {
            default: ()=>(parcelRequire("dqT3O")),
            large: ()=>(parcelRequire("gQ4Nj"))
        },
        // Confluence icons
        [(0, $8dVIb.IconType).LiveDocument]: {
            default: ()=>(parcelRequire("dSN1f")).then(({ default: LiveDocumentIcon })=>({
                        default: LiveDocumentIcon
                    }))
        },
        // Provider icons
        [(0, $8dVIb.IconType).Confluence]: {
            default: ()=>Promise.resolve((parcelRequire("7anl7"))).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                        default: ConfluenceIcon
                    }))
        },
        [(0, $8dVIb.IconType).Jira]: {
            default: ()=>Promise.resolve((parcelRequire("29YN9"))).then(({ JiraIcon: JiraIcon })=>({
                        default: JiraIcon
                    }))
        },
        // Badge icons
        [(0, $8dVIb.IconType).Attachment]: {
            default: ()=>(parcelRequire("fkmri"))
        },
        [(0, $8dVIb.IconType).CheckItem]: {
            default: ()=>(parcelRequire("eU0GA"))
        },
        [(0, $8dVIb.IconType).Comment]: {
            default: ()=>(parcelRequire("jAQ3K"))
        },
        [(0, $8dVIb.IconType).View]: {
            default: ()=>(parcelRequire("8YU6y"))
        },
        [(0, $8dVIb.IconType).React]: {
            default: ()=>(parcelRequire("7nuvV"))
        },
        [(0, $8dVIb.IconType).Vote]: {
            default: ()=>(parcelRequire("hFsYk"))
        },
        [(0, $8dVIb.IconType).PriorityBlocker]: {
            default: ()=>(parcelRequire("gMDFI"))
        },
        [(0, $8dVIb.IconType).PriorityCritical]: {
            default: ()=>(parcelRequire("4fkVg"))
        },
        [(0, $8dVIb.IconType).PriorityHigh]: {
            default: ()=>(parcelRequire("fgN6p"))
        },
        [(0, $8dVIb.IconType).PriorityHighest]: {
            default: ()=>(parcelRequire("cV2N9"))
        },
        [(0, $8dVIb.IconType).PriorityLow]: {
            default: ()=>(parcelRequire("eVavM"))
        },
        [(0, $8dVIb.IconType).PriorityLowest]: {
            default: ()=>(parcelRequire("56RVo"))
        },
        [(0, $8dVIb.IconType).PriorityMajor]: {
            default: ()=>(parcelRequire("ktXnL"))
        },
        [(0, $8dVIb.IconType).PriorityMedium]: {
            default: ()=>(parcelRequire("9mM5H"))
        },
        [(0, $8dVIb.IconType).PriorityMinor]: {
            default: ()=>(parcelRequire("1O0Re"))
        },
        [(0, $8dVIb.IconType).PriorityTrivial]: {
            default: ()=>(parcelRequire("lGGho"))
        },
        [(0, $8dVIb.IconType).PriorityUndefined]: {
            default: ()=>(parcelRequire("2LtoJ"))
        },
        [(0, $8dVIb.IconType).ProgrammingLanguage]: {
            default: ()=>(parcelRequire("lE2nX"))
        },
        [(0, $8dVIb.IconType).Subscriber]: {
            default: ()=>Promise.resolve((parcelRequire("4hqZ5")))
        },
        [(0, $8dVIb.IconType).SubTasksProgress]: {
            default: ()=>(parcelRequire("dWKdk"))
        }
    };
};
const $c53851cced73411d$var$getTypeToIconMap = (fileFormat)=>{
    const iconDescriptor = (0, $liAf6.default)(fileFormat);
    if (!iconDescriptor?.icon || !iconDescriptor.label) return null;
    const lazyIcons = $c53851cced73411d$export$92d31eb5326761b6();
    return [
        iconDescriptor.label,
        lazyIcons[iconDescriptor.icon]?.default
    ];
};
const $c53851cced73411d$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};
const $c53851cced73411d$export$ffccab2ae3d093ef = (handler)=>(e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler();
    };
const $c53851cced73411d$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';
const $c53851cced73411d$export$e772c8ff12451969 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
const $c53851cced73411d$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
    try {
        return await importFn();
    } catch (error) {
        if (error.name === 'ChunkLoadError' && retries > 0) {
            await $c53851cced73411d$export$e772c8ff12451969(interval);
            return $c53851cced73411d$export$aacbf48ace518c5a(importFn, retries - 1, interval);
        } else throw error;
    }
};
const $c53851cced73411d$export$8a96edb1c96563f4 = async (url)=>{
    if (!url) return;
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    link.download = url;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $c53851cced73411d$export$a238cfe4a10e6279 = async (url)=>{
    if (!url) return;
    window.open(url, '_blank', 'noopener=yes');
};
const $c53851cced73411d$export$4470f298c61a79da = (previewUrl, themeState)=>{
    try {
        const url = new URL(previewUrl);
        url.searchParams.append('themeState', (0, $imVhc.themeObjectToString)(themeState));
        return url.href;
    } catch  {
        return previewUrl;
    }
};
const $c53851cced73411d$export$d2b8fb9e780e17e7 = (size)=>size && [
        (0, $8dVIb.SmartLinkSize).Large,
        (0, $8dVIb.SmartLinkSize).XLarge
    ].includes(size);

});
parcelRegister("8dVIb", function(module, exports) {

$parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", () => $ad6fd5c2f706e309$export$5c881701926acbef);
$parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", () => $ad6fd5c2f706e309$export$93d67ab022d9f8d2);
$parcel$export(module.exports, "CONTENT_URL_AI", () => $ad6fd5c2f706e309$export$70d24f0465ae60f8);
$parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", () => $ad6fd5c2f706e309$export$a3ed5c4e9d9599b7);
$parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", () => $ad6fd5c2f706e309$export$73b198e73554a323);
$parcel$export(module.exports, "SmartLinkAlignment", () => $ad6fd5c2f706e309$export$8910bf86027fe6be);
$parcel$export(module.exports, "SmartLinkDirection", () => $ad6fd5c2f706e309$export$60831686b0574c86);
$parcel$export(module.exports, "SmartLinkPosition", () => $ad6fd5c2f706e309$export$d58e6377644d1dcf);
$parcel$export(module.exports, "SmartLinkSize", () => $ad6fd5c2f706e309$export$51f13ced115cbdae);
$parcel$export(module.exports, "SmartLinkStatus", () => $ad6fd5c2f706e309$export$61cff06be26816f);
$parcel$export(module.exports, "SmartLinkTheme", () => $ad6fd5c2f706e309$export$aed0f1e801ad691f);
$parcel$export(module.exports, "SmartLinkInternalTheme", () => $ad6fd5c2f706e309$export$9aafec380d7005da);
$parcel$export(module.exports, "SmartLinkWidth", () => $ad6fd5c2f706e309$export$19c60054ee783de6);
$parcel$export(module.exports, "ElementName", () => $ad6fd5c2f706e309$export$d65b168331104a46);
$parcel$export(module.exports, "ActionName", () => $ad6fd5c2f706e309$export$9c95d6e1614bad84);
$parcel$export(module.exports, "InternalActionName", () => $ad6fd5c2f706e309$export$4871a84b35cf8eb9);
$parcel$export(module.exports, "IconType", () => $ad6fd5c2f706e309$export$13ff1290a9e22e77);
$parcel$export(module.exports, "MediaType", () => $ad6fd5c2f706e309$export$483c11740a902fcd);
$parcel$export(module.exports, "MediaPlacement", () => $ad6fd5c2f706e309$export$f9f4737e25ab90fa);
$parcel$export(module.exports, "CardDisplay", () => $ad6fd5c2f706e309$export$6ca4ef8b3dc2c804);
const $ad6fd5c2f706e309$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $ad6fd5c2f706e309$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $ad6fd5c2f706e309$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $ad6fd5c2f706e309$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $ad6fd5c2f706e309$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $ad6fd5c2f706e309$export$8910bf86027fe6be = /*#__PURE__*/ function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
    return SmartLinkAlignment;
}({});
var $ad6fd5c2f706e309$export$60831686b0574c86 = /*#__PURE__*/ function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
    return SmartLinkDirection;
}({});
var $ad6fd5c2f706e309$export$d58e6377644d1dcf = /*#__PURE__*/ function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
    return SmartLinkPosition;
}({});
var $ad6fd5c2f706e309$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $ad6fd5c2f706e309$export$61cff06be26816f = /*#__PURE__*/ function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
    return SmartLinkStatus;
}({});
var $ad6fd5c2f706e309$export$aed0f1e801ad691f = /*#__PURE__*/ function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
    return SmartLinkTheme;
}({});
var $ad6fd5c2f706e309$export$9aafec380d7005da = /*#__PURE__*/ function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
    return SmartLinkInternalTheme;
}({});
var $ad6fd5c2f706e309$export$19c60054ee783de6 = /*#__PURE__*/ function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
    return SmartLinkWidth;
}({});
var $ad6fd5c2f706e309$export$d65b168331104a46 = /*#__PURE__*/ function(ElementName) {
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["Title"] = "Title";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
    return ElementName;
}({});
var $ad6fd5c2f706e309$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
    return ActionName;
}({});
var $ad6fd5c2f706e309$export$4871a84b35cf8eb9 = /*#__PURE__*/ function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    return InternalActionName;
}({});
var $ad6fd5c2f706e309$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Confluence
    IconType["LiveDocument"] = "Confluence:LiveDocument";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
    return IconType;
}({});
var $ad6fd5c2f706e309$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "image";
    return MediaType;
}({});
var $ad6fd5c2f706e309$export$f9f4737e25ab90fa = /*#__PURE__*/ function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
    return MediaPlacement;
}({});
var $ad6fd5c2f706e309$export$6ca4ef8b3dc2c804 = /*#__PURE__*/ function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    return CardDisplay;
}({});

});

parcelRegister("liAf6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d67e22f2f57cb4a6$export$2e2bcd8739ae039);

var $8dVIb = parcelRequire("8dVIb");
const $d67e22f2f57cb4a6$var$extractFileFormatIcon = (fileFormat)=>{
    switch(fileFormat){
        // Generic documents
        case 'folder':
            return {
                icon: (0, $8dVIb.IconType).Folder,
                label: 'Folder'
            };
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return {
                icon: (0, $8dVIb.IconType).Document,
                label: 'Document'
            };
        case 'application/pdf':
            return {
                icon: (0, $8dVIb.IconType).PDF,
                label: 'PDF document'
            };
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return {
                icon: (0, $8dVIb.IconType).Presentation,
                label: 'Presentation'
            };
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return {
                icon: (0, $8dVIb.IconType).Spreadsheet,
                label: 'Spreadsheet'
            };
        // Google Drive
        case 'application/vnd.google-apps.document':
            return {
                icon: (0, $8dVIb.IconType).GoogleDocs,
                label: 'Google Docs'
            };
        case 'application/vnd.google-apps.form':
            return {
                icon: (0, $8dVIb.IconType).GoogleForms,
                label: 'Google Form'
            };
        case 'application/vnd.google-apps.spreadsheet':
            return {
                icon: (0, $8dVIb.IconType).GoogleSheets,
                label: 'Google Sheets'
            };
        case 'application/vnd.google-apps.presentation':
            return {
                icon: (0, $8dVIb.IconType).GoogleSlides,
                label: 'Google Slides'
            };
        // Microsoft
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return {
                icon: (0, $8dVIb.IconType).MSExcel,
                label: 'Excel spreadsheet'
            };
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return {
                icon: (0, $8dVIb.IconType).MSPowerpoint,
                label: 'PowerPoint presentation'
            };
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return {
                icon: (0, $8dVIb.IconType).MSWord,
                label: 'Word document'
            };
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return {
                icon: (0, $8dVIb.IconType).Image,
                label: 'Image'
            };
        case 'image/gif':
            return {
                icon: (0, $8dVIb.IconType).GIF,
                label: 'GIF'
            };
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return {
                icon: (0, $8dVIb.IconType).Audio,
                label: 'Audio'
            };
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return {
                icon: (0, $8dVIb.IconType).Video,
                label: 'Video'
            };
        // Others
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return {
                icon: (0, $8dVIb.IconType).Code,
                label: 'Source Code'
            };
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return {
                icon: (0, $8dVIb.IconType).Archive,
                label: 'Archive'
            };
        case 'application/dmg':
            return {
                icon: (0, $8dVIb.IconType).Executable,
                label: 'Executable'
            };
        case 'application/sketch':
            return {
                icon: (0, $8dVIb.IconType).Sketch,
                label: 'Sketch'
            };
        case 'application/octet-stream':
            return {
                icon: (0, $8dVIb.IconType).Generic,
                label: 'Binary file'
            };
        case 'application/invision.prototype':
            return {
                icon: (0, $8dVIb.IconType).Generic,
                label: 'Prototype'
            };
        default:
            return undefined;
    }
};
var $d67e22f2f57cb4a6$export$2e2bcd8739ae039 = $d67e22f2f57cb4a6$var$extractFileFormatIcon;

});

parcelRegister("duwKf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9d277a30a5a98acd$var$_react = $9d277a30a5a98acd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $9d277a30a5a98acd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9d277a30a5a98acd$var$Document16Icon = (props)=>/*#__PURE__*/ $9d277a30a5a98acd$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$9d277a30a5a98acd$var$Document16Icon.displayName = 'Document16Icon';
var $9d277a30a5a98acd$var$_default = module.exports.default = $9d277a30a5a98acd$var$Document16Icon;

});

parcelRegister("6q8Pr", function(module, exports) {

let $4acc04fa6828837e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4acc04fa6828837e$var$load("7EgS6").then(()=>parcelRequire('3KifV'));

});

parcelRegister("e3PhT", function(module, exports) {

let $a3c92121ff44871f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a3c92121ff44871f$var$load("erQ4S").then(()=>parcelRequire('im5Hg'));

});

parcelRegister("55TA3", function(module, exports) {

let $3b5888855c97ba42$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3b5888855c97ba42$var$load("d767x").then(()=>parcelRequire('5m93C'));

});

parcelRegister("lb4t9", function(module, exports) {

let $f6ae178ddd88f3b4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f6ae178ddd88f3b4$var$load("lQ9xE").then(()=>parcelRequire('2Bgv8'));

});

parcelRegister("bwXIZ", function(module, exports) {

let $865102f672a4212f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $865102f672a4212f$var$load("izomc").then(()=>parcelRequire('iByEQ'));

});

parcelRegister("8vv4H", function(module, exports) {

let $631952ccff1c149a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $631952ccff1c149a$var$load("5I4RC").then(()=>parcelRequire('eABwY'));

});

parcelRegister("2t9Hh", function(module, exports) {

let $1cc5cfd630a69c27$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1cc5cfd630a69c27$var$load("iV5W6").then(()=>parcelRequire('h7zk4'));

});

parcelRegister("6SoQO", function(module, exports) {

let $501b100cfa76ff8e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $501b100cfa76ff8e$var$load("jepjM").then(()=>parcelRequire('F35X1'));

});

parcelRegister("TZHl8", function(module, exports) {

let $0a84ff1cb84378c5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0a84ff1cb84378c5$var$load("3YI2r").then(()=>parcelRequire('kKp2J'));

});

parcelRegister("3VL73", function(module, exports) {

let $2dcb3d9afd9c957a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2dcb3d9afd9c957a$var$load("cwkUf").then(()=>parcelRequire('j8IiS'));

});

parcelRegister("ifmtc", function(module, exports) {

let $d48b0ecc93ef9e55$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d48b0ecc93ef9e55$var$load("hVGrh").then(()=>parcelRequire('daL8e'));

});

parcelRegister("eogSM", function(module, exports) {

let $a7a0671937c9e1f3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a7a0671937c9e1f3$var$load("aAton").then(()=>parcelRequire('96Idm'));

});

parcelRegister("5nV2R", function(module, exports) {

let $3ebb59b9b44ae7f7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3ebb59b9b44ae7f7$var$load("iDnD4").then(()=>parcelRequire('dOkKo'));

});

parcelRegister("6Y2WT", function(module, exports) {

let $512aa2425db43ab6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $512aa2425db43ab6$var$load("dhQt8").then(()=>parcelRequire('lDRqn'));

});

parcelRegister("4m4MY", function(module, exports) {

let $32bcee7caa856311$var$load = (parcelRequire("28QjX"))(4);
module.exports = $32bcee7caa856311$var$load("7QDLp").then(()=>parcelRequire('8njZH'));

});

parcelRegister("gmDdF", function(module, exports) {

let $be9d1f90638c1db6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $be9d1f90638c1db6$var$load("b2yZA").then(()=>parcelRequire('lp0fk'));

});

parcelRegister("coOzc", function(module, exports) {

let $906ef36933b15f5b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $906ef36933b15f5b$var$load("5khw4").then(()=>parcelRequire('6cEsd'));

});

parcelRegister("ldQLy", function(module, exports) {

let $f733be138af3b35d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f733be138af3b35d$var$load("c1Yqk").then(()=>parcelRequire('7BHMh'));

});

parcelRegister("4WgJk", function(module, exports) {

let $39898e76c9d3a3c2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $39898e76c9d3a3c2$var$load("a5lMy").then(()=>parcelRequire('lE6mu'));

});

parcelRegister("fjtI4", function(module, exports) {

let $b25fad1f7947bb8b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b25fad1f7947bb8b$var$load("gaqBx").then(()=>parcelRequire('bBHpS'));

});

parcelRegister("94rku", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $56fb369bc3845a35$export$2e2bcd8739ae039);

var $duwKf = parcelRequire("duwKf");

var $kdfZa = parcelRequire("kdfZa");

var $50H21 = parcelRequire("50H21");
const $56fb369bc3845a35$var$PageIconWithColor = (0, $50H21.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($kdfZa))), 'blueBold', (0, (/*@__PURE__*/$parcel$interopDefault($duwKf))));
$56fb369bc3845a35$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $56fb369bc3845a35$export$2e2bcd8739ae039 = $56fb369bc3845a35$var$PageIconWithColor;

});
parcelRegister("50H21", function(module, exports) {

$parcel$export(module.exports, "renderIconPerSize", () => $399bb260cc38f0bb$export$28dd5ad82647c000);
$parcel$export(module.exports, "renderIconTile", () => $399bb260cc38f0bb$export$87c3646d0e299cfe);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $8dVIb = parcelRequire("8dVIb");

var $kxcRq = parcelRequire("kxcRq");
const $399bb260cc38f0bb$export$3acc3fb10995f020 = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return '24';
        default:
            return '16';
    }
};
const $399bb260cc38f0bb$export$28dd5ad82647c000 = (IconSmall, IconLarge)=>{
    return ({ size: size, ...props })=>{
        if ((0, $kxcRq.isIconSizeLarge)(size)) return /*#__PURE__*/ (0, $2OMIu.jsx)(IconLarge, {
            ...props
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)(IconSmall, {
            ...props
        });
    };
};
const $399bb260cc38f0bb$export$87c3646d0e299cfe = (Icon, appearance, LegacyIcon)=>{
    return ({ size: size, ...props })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
            appearance: appearance,
            icon: Icon,
            size: $399bb260cc38f0bb$export$3acc3fb10995f020(size),
            ...props,
            LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)(LegacyIcon, {
                ...props
            })
        });
    };
};

});
parcelRegister("cwmS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a921419639fe8f6f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");
function $a921419639fe8f6f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a921419639fe8f6f$var$sizeMap = {
    '16': {
        name: "157xhr7",
        styles: "width:16px;height:16px"
    },
    '24': {
        name: "rrel8y",
        styles: "width:24px;height:24px"
    },
    '32': {
        name: "68x97p",
        styles: "width:32px;height:32px"
    },
    '40': {
        name: "1mfsro6",
        styles: "width:40px;height:40px"
    },
    '48': {
        name: "18jhpep",
        styles: "width:48px;height:48px"
    }
};
const $a921419639fe8f6f$var$appearanceMap = {
    grayBold: {
        name: "algye9",
        styles: "background-color:var(--ds-background-accent-gray-bolder, #626F86);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    limeBold: {
        name: "a86nvv",
        styles: "background-color:var(--ds-background-accent-lime-bolder, #5B7F24);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    greenBold: {
        name: "13e2qqr",
        styles: "background-color:var(--ds-background-accent-green-bolder, #1F845A);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    blueBold: {
        name: "jpsdma",
        styles: "background-color:var(--ds-background-accent-blue-bolder, #0C66E4);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    redBold: {
        name: "1bg8y7a",
        styles: "background-color:var(--ds-background-accent-red-bolder, #C9372C);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    purpleBold: {
        name: "19bo3lb",
        styles: "background-color:var(--ds-background-accent-purple-bolder, #6E5DC6);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    magentaBold: {
        name: "1l16rgo",
        styles: "background-color:var(--ds-background-accent-magenta-bolder, #AE4787);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    tealBold: {
        name: "7kw5zl",
        styles: "background-color:var(--ds-background-accent-teal-bolder, #227D9B);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    orangeBold: {
        name: "h77eay",
        styles: "background-color:var(--ds-background-accent-orange-bolder, #C25100);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    yellowBold: {
        name: "sbe4w3",
        styles: "background-color:var(--ds-background-accent-yellow-bolder, #946F00);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    gray: {
        name: "yxgei8",
        styles: "background-color:var(--ds-background-accent-gray-subtler, #DCDFE4);color:var(--ds-icon-accent-gray, #758195)"
    },
    lime: {
        name: "o9c6oh",
        styles: "background-color:var(--ds-background-accent-lime-subtler, #D3F1A7);color:var(--ds-icon-accent-lime, #6A9A23)"
    },
    orange: {
        name: "szqzk5",
        styles: "background-color:var(--ds-background-accent-orange-subtler, #FEDEC8);color:var(--ds-icon-accent-orange, #E56910)"
    },
    magenta: {
        name: "o6ptuw",
        styles: "background-color:var(--ds-background-accent-magenta-subtler, #FDD0EC);color:var(--ds-icon-accent-magenta, #CD519D)"
    },
    green: {
        name: "157dg7e",
        styles: "background-color:var(--ds-background-accent-green-subtler, #BAF3DB);color:var(--ds-icon-accent-green, #22A06B)"
    },
    blue: {
        name: "x3nujl",
        styles: "background-color:var(--ds-background-accent-blue-subtler, #CCE0FF);color:var(--ds-icon-accent-blue, #1D7AFC)"
    },
    red: {
        name: "zqoyws",
        styles: "background-color:var(--ds-background-accent-red-subtler, #FFD5D2);color:var(--ds-icon-accent-red, #C9372C)"
    },
    purple: {
        name: "fitjkd",
        styles: "background-color:var(--ds-background-accent-purple-subtler, #DFD8FD);color:var(--ds-icon-accent-purple, #8270DB)"
    },
    teal: {
        name: "b3m1ww",
        styles: "background-color:var(--ds-background-accent-teal-subtler, #C6EDFB);color:var(--ds-icon-accent-teal, #2898BD)"
    },
    yellow: {
        name: "1j18jub",
        styles: "background-color:var(--ds-background-accent-yellow-subtler, #F8E6A0);color:var(--ds-icon-accent-yellow, #B38600)"
    }
};
const $a921419639fe8f6f$var$shapeMap = {
    square: {
        name: "vwdoqr",
        styles: "border-radius:var(--ds-border-radius-100, 4px)"
    },
    circle: {
        name: "i2ucdk",
        styles: "border-radius:var(--ds-border-radius-circle, 32032px)"
    }
};
const $a921419639fe8f6f$var$iconTileStyles = {
    name: "1ot07ws",
    styles: "display:inline-flex;box-sizing:border-box;align-items:center;justify-content:center;font-size:0"
};
function $a921419639fe8f6f$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', LEGACY_fallbackComponent: LEGACY_fallbackComponent, testId: testId } = props;
    const ExpandedIcon = Icon;
    if (LEGACY_fallbackComponent && !(0, $VSDnB.fg)('platform-visual-refresh-icons')) return LEGACY_fallbackComponent;
    else return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        "data-testid": testId,
        css: [
            $a921419639fe8f6f$var$iconTileStyles,
            $a921419639fe8f6f$var$appearanceMap[appearance],
            $a921419639fe8f6f$var$sizeMap[size],
            $a921419639fe8f6f$var$shapeMap[shape]
        ]
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(ExpandedIcon, {
        color: "currentColor",
        label: label,
        spacing: "spacious",
        shouldScale: true
    }));
}

});



parcelRegister("dVpJZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5e665de7fe478f98$export$2e2bcd8739ae039);

var $iRZQl = parcelRequire("iRZQl");

var $7oCpB = parcelRequire("7oCpB");

var $50H21 = parcelRequire("50H21");
const $5e665de7fe478f98$var$BlogIconWithColor = (0, $50H21.renderIconPerSize)((0, $iRZQl.default), (0, $7oCpB.default));
$5e665de7fe478f98$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $5e665de7fe478f98$export$2e2bcd8739ae039 = $5e665de7fe478f98$var$BlogIconWithColor;

});
parcelRegister("iRZQl", function(module, exports) {

$parcel$export(module.exports, "default", () => $24299d4e22463111$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::845767e81b63ae055da0ba81295847f0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2UiHO = parcelRequire("2UiHO");

var $VSDnB = parcelRequire("VSDnB");

var $hZgcq = parcelRequire("hZgcq");
/**
 * __16px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $24299d4e22463111$var$Blog16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2UiHO))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZgcq.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZgcq.default), {
        label: label,
        testId: testId
    });
};
$24299d4e22463111$var$Blog16Icon.displayName = 'Blog16Icon';
var $24299d4e22463111$export$2e2bcd8739ae039 = $24299d4e22463111$var$Blog16Icon;

});
parcelRegister("2UiHO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b40f413d9c2b5f3f2478820c1b2dc6e9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $21df524c58bafc58$var$_react = $21df524c58bafc58$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $21df524c58bafc58$var$_baseNew = $21df524c58bafc58$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $21df524c58bafc58$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "QuotationMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $21df524c58bafc58$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $21df524c58bafc58$var$_react.default.createElement($21df524c58bafc58$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M3 13.25A3.25 3.25 0 0 0 6.25 10V8.25m0 0V4c0-.69-.56-1.25-1.25-1.25H2C1.31 2.75.75 3.31.75 4v3c0 .69.56 1.25 1.25 1.25zm9 0V4c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v3c0 .69.56 1.25 1.25 1.25zm0 0V10A3.25 3.25 0 0 1 12 13.25"/>`
    }, props));
$21df524c58bafc58$var$QuotationMarkIcon.displayName = 'QuotationMarkIcon';
var $21df524c58bafc58$var$_default = module.exports.default = $21df524c58bafc58$var$QuotationMarkIcon;

});

parcelRegister("hZgcq", function(module, exports) {

$parcel$export(module.exports, "default", () => $47749dc4aba4294e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::387cb99b24103ef6908201cae0580f7c>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $47749dc4aba4294e$var$Blog16Icon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M6.972 6.128a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325m7 0a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$47749dc4aba4294e$var$Blog16Icon.displayName = 'Blog16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$47749dc4aba4294e$export$2e2bcd8739ae039 = $47749dc4aba4294e$var$Blog16Icon;

});


parcelRegister("7oCpB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8806751d7f7ea905$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bba35c7457f1c82d9d31626969c259a0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2UiHO = parcelRequire("2UiHO");

var $VSDnB = parcelRequire("VSDnB");

var $asoCt = parcelRequire("asoCt");
/**
 * __24px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $8806751d7f7ea905$var$Blog24Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2UiHO))),
        appearance: "blueBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $asoCt.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $asoCt.default), {
        label: label,
        testId: testId
    });
};
$8806751d7f7ea905$var$Blog24Icon.displayName = 'Blog24Icon';
var $8806751d7f7ea905$export$2e2bcd8739ae039 = $8806751d7f7ea905$var$Blog24Icon;

});
parcelRegister("asoCt", function(module, exports) {

$parcel$export(module.exports, "default", () => $158d85a5273c8dbb$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7682b4d34bd2a783038ec83f3b47a94>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $158d85a5273c8dbb$var$Blog24Icon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M10.998 9.035a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.013-5.52 3.516-8.18m8.895 0a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.012-5.52 3.516-8.18M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`,
        ...props,
        size: "medium"
    });
$158d85a5273c8dbb$var$Blog24Icon.displayName = 'Blog24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$158d85a5273c8dbb$export$2e2bcd8739ae039 = $158d85a5273c8dbb$var$Blog24Icon;

});



parcelRegister("6ftoN", function(module, exports) {

let $48caf2cb3a2b031c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $48caf2cb3a2b031c$var$load("4AlWm").then(()=>parcelRequire('aQnRv'));

});

parcelRegister("a0Blm", function(module, exports) {

let $7496df20f241cc20$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7496df20f241cc20$var$load("1oL5z").then(()=>parcelRequire('3WUNe'));

});

parcelRegister("gp1iV", function(module, exports) {

let $bf0ffe1d32436e05$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bf0ffe1d32436e05$var$load("dBvdI").then(()=>parcelRequire('3vtQf'));

});

parcelRegister("jJcF3", function(module, exports) {

let $e5cc0a8e109344ba$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e5cc0a8e109344ba$var$load("h2MrD"),
    $e5cc0a8e109344ba$var$load("bYT2S"),
    $e5cc0a8e109344ba$var$load("947Ze")
]).then(()=>parcelRequire('ikced'));

});

parcelRegister("eT6gz", function(module, exports) {

let $ad6b101988e539b4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ad6b101988e539b4$var$load("9Rmva").then(()=>parcelRequire('aRGuz'));

});

parcelRegister("fHKiX", function(module, exports) {

let $b6eeca4f456dab34$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b6eeca4f456dab34$var$load("4iYn6").then(()=>parcelRequire('gVXQp'));

});

parcelRegister("9ulvP", function(module, exports) {

let $6e879a4e86077e94$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6e879a4e86077e94$var$load("7tpZr").then(()=>parcelRequire('9bx9i'));

});

parcelRegister("3K7kY", function(module, exports) {

let $2b9b5c0158d75df8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2b9b5c0158d75df8$var$load("4OyEJ").then(()=>parcelRequire('T5PvZ'));

});

parcelRegister("1mt5h", function(module, exports) {

let $0fde680a0a439b5c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0fde680a0a439b5c$var$load("h2MrD"),
    $0fde680a0a439b5c$var$load("bYT2S"),
    $0fde680a0a439b5c$var$load("7aEUQ")
]).then(()=>parcelRequire('ckyDP'));

});

parcelRegister("vxJ9s", function(module, exports) {

let $05ed0ee4e8760d18$var$load = (parcelRequire("28QjX"))(4);
module.exports = $05ed0ee4e8760d18$var$load("a98CY").then(()=>parcelRequire('5mR3i'));

});

parcelRegister("23MsP", function(module, exports) {

let $180174885bfd768b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $180174885bfd768b$var$load("b4dsH").then(()=>parcelRequire('a8hd9'));

});

parcelRegister("jOyH3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ba5c183c8a258f8be0ef328c0a8b726>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6cd993777d46e1b$var$_react = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e6cd993777d46e1b$var$_link = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("1f9bV")));

var $e6cd993777d46e1b$var$_link2 = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("458iJ")));
function $e6cd993777d46e1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6cd993777d46e1b$var$LinkIcon = (props)=>/*#__PURE__*/ $e6cd993777d46e1b$var$_react.default.createElement($e6cd993777d46e1b$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $e6cd993777d46e1b$var$_link2.default
    }, props));
$e6cd993777d46e1b$var$LinkIcon.Name = 'LinkIconMigration';
var $e6cd993777d46e1b$var$_default = module.exports.default = $e6cd993777d46e1b$var$LinkIcon;

});
parcelRegister("1f9bV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9a87d743bb5f5b238079f9e871192b6e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e7e525cdad15340$var$_react = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0e7e525cdad15340$var$_baseNew = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0e7e525cdad15340$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e7e525cdad15340$var$LinkIcon = (props)=>/*#__PURE__*/ $0e7e525cdad15340$var$_react.default.createElement($0e7e525cdad15340$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m5.25 10.75 5.5-5.5M5 6.5 2.75 8.75a3.182 3.182 0 0 0 4.5 4.5L9.5 11m-3-6 2.25-2.25a3.182 3.182 0 0 1 4.5 4.5L11 9.5"/>`
    }, props));
$0e7e525cdad15340$var$LinkIcon.displayName = 'LinkIcon';
var $0e7e525cdad15340$var$_default = module.exports.default = $0e7e525cdad15340$var$LinkIcon;

});

parcelRegister("458iJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f8e117d74b4de46$var$_react = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $2f8e117d74b4de46$var$_link = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("1f9bV")));
function $2f8e117d74b4de46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2f8e117d74b4de46$var$LinkIcon = (props)=>/*#__PURE__*/ $2f8e117d74b4de46$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $2f8e117d74b4de46$var$_link.default
    }));
$2f8e117d74b4de46$var$LinkIcon.displayName = 'LinkIcon';
var $2f8e117d74b4de46$var$_default = module.exports.default = $2f8e117d74b4de46$var$LinkIcon;

});


parcelRegister("6jkTx", function(module, exports) {

let $4984b9ac5dd985b2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4984b9ac5dd985b2$var$load("9HbdP").then(()=>parcelRequire('9CRO6'));

});

parcelRegister("kWjiJ", function(module, exports) {

let $f3e832343a860d40$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f3e832343a860d40$var$load("dhNrp").then(()=>parcelRequire('dGYEZ'));

});

parcelRegister("03kpR", function(module, exports) {

let $00a01e23806922fc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $00a01e23806922fc$var$load("kqcH1").then(()=>parcelRequire('RiK2l'));

});

parcelRegister("3rJ38", function(module, exports) {

let $2826d69fb4be605d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2826d69fb4be605d$var$load("lJtIM").then(()=>parcelRequire('iBOon'));

});

parcelRegister("jiAjo", function(module, exports) {

let $e0cbdd8613b70fc8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e0cbdd8613b70fc8$var$load("5dt09").then(()=>parcelRequire('jdlqN'));

});

parcelRegister("3hQB1", function(module, exports) {

let $264bc21b80cc2a91$var$load = (parcelRequire("28QjX"))(4);
module.exports = $264bc21b80cc2a91$var$load("3WmO0").then(()=>parcelRequire('c70Lr'));

});

parcelRegister("70xas", function(module, exports) {

let $51a242e0c91d3734$var$load = (parcelRequire("28QjX"))(4);
module.exports = $51a242e0c91d3734$var$load("iSSEO").then(()=>parcelRequire('2osAJ'));

});

parcelRegister("7P2U4", function(module, exports) {

let $5b1f8c62c8f11a51$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5b1f8c62c8f11a51$var$load("9ykhE").then(()=>parcelRequire('7zjHG'));

});

parcelRegister("9Eo4X", function(module, exports) {

let $706a870b80e487e0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $706a870b80e487e0$var$load("ejGmj").then(()=>parcelRequire('cHwqN'));

});

parcelRegister("gBnqE", function(module, exports) {

let $c16246890c5b74cb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c16246890c5b74cb$var$load("5zjWD").then(()=>parcelRequire('2sfBf'));

});

parcelRegister("eWGoe", function(module, exports) {

let $ae175d383ef4ff8e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ae175d383ef4ff8e$var$load("fGPpk").then(()=>parcelRequire('2tm8x'));

});

parcelRegister("fu8cn", function(module, exports) {

let $b460046dacf40544$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b460046dacf40544$var$load("4Ckra").then(()=>parcelRequire('iABw2'));

});

parcelRegister("cAU6j", function(module, exports) {

let $92b45d4aa046f329$var$load = (parcelRequire("28QjX"))(4);
module.exports = $92b45d4aa046f329$var$load("evpxF").then(()=>parcelRequire('4sBeG'));

});

parcelRegister("4rggH", function(module, exports) {

let $33b64d92455eac54$var$load = (parcelRequire("28QjX"))(4);
module.exports = $33b64d92455eac54$var$load("g985s").then(()=>parcelRequire('l04jD'));

});

parcelRegister("bn2CC", function(module, exports) {

let $8473e052ffb4388d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8473e052ffb4388d$var$load("kAF19").then(()=>parcelRequire('bPjbr'));

});

parcelRegister("2nXLN", function(module, exports) {

let $1bcc17d3fb7fe2fd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1bcc17d3fb7fe2fd$var$load("16ic3").then(()=>parcelRequire('52A0r'));

});

parcelRegister("cIR4U", function(module, exports) {

let $9432c454ef92166f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9432c454ef92166f$var$load("7R5g7").then(()=>parcelRequire('6qWjs'));

});

parcelRegister("d4Msz", function(module, exports) {

let $98513d3325793783$var$load = (parcelRequire("28QjX"))(4);
module.exports = $98513d3325793783$var$load("gvHhR").then(()=>parcelRequire('c9Fqq'));

});

parcelRegister("bbgWK", function(module, exports) {

let $823dde017897a8a8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $823dde017897a8a8$var$load("6TtDJ").then(()=>parcelRequire('ezu4w'));

});

parcelRegister("4Z42j", function(module, exports) {

let $3a0ffd720a4a477e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3a0ffd720a4a477e$var$load("1NHTB").then(()=>parcelRequire('6OpPE'));

});

parcelRegister("jNgVH", function(module, exports) {

let $e68fb9c58ac59414$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e68fb9c58ac59414$var$load("kgx4U").then(()=>parcelRequire('iAkpb'));

});

parcelRegister("9LCHw", function(module, exports) {

let $71c6860eabfcf304$var$load = (parcelRequire("28QjX"))(4);
module.exports = $71c6860eabfcf304$var$load("9PpGe").then(()=>parcelRequire('41M8N'));

});

parcelRegister("hhL96", function(module, exports) {

let $c958985d73c1112b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c958985d73c1112b$var$load("eSwNo").then(()=>parcelRequire('jnURg'));

});

parcelRegister("tyrb0", function(module, exports) {

let $058d6c15a4a2e74c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $058d6c15a4a2e74c$var$load("bSBaJ").then(()=>parcelRequire('4MX1d'));

});

parcelRegister("9q15g", function(module, exports) {

let $6db76207028d4cfd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6db76207028d4cfd$var$load("cUQWc").then(()=>parcelRequire('gAdQO'));

});

parcelRegister("fwsJh", function(module, exports) {

let $b4d021375f2ba907$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b4d021375f2ba907$var$load("3w7tM").then(()=>parcelRequire('eHc1t'));

});

parcelRegister("14Fhu", function(module, exports) {

let $0c862fbc2ccb568d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0c862fbc2ccb568d$var$load("j373d").then(()=>parcelRequire('6ClRv'));

});

parcelRegister("2EQdA", function(module, exports) {

let $1ef7d29d585441a3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1ef7d29d585441a3$var$load("hdkrH").then(()=>parcelRequire('529Ow'));

});

parcelRegister("3Qygt", function(module, exports) {

let $2cd0ceaab7b162da$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2cd0ceaab7b162da$var$load("9HJjr").then(()=>parcelRequire('1ni2E'));

});

parcelRegister("7GCAt", function(module, exports) {

let $598a634b3bebd565$var$load = (parcelRequire("28QjX"))(4);
module.exports = $598a634b3bebd565$var$load("fcEu0").then(()=>parcelRequire('gaBfD'));

});

parcelRegister("7J5Ma", function(module, exports) {

let $5a013757451c6962$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5a013757451c6962$var$load("jXTSM").then(()=>parcelRequire('kQSMP'));

});

parcelRegister("akYbd", function(module, exports) {

let $786a741696fc3955$var$load = (parcelRequire("28QjX"))(4);
module.exports = $786a741696fc3955$var$load("2nFSk").then(()=>parcelRequire('36Q2c'));

});

parcelRegister("iErKi", function(module, exports) {

let $d9417c2310d04e80$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d9417c2310d04e80$var$load("hU82q").then(()=>parcelRequire('kvhCa'));

});

parcelRegister("fuaYA", function(module, exports) {

let $b4622c006adc733a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b4622c006adc733a$var$load("cVndS").then(()=>parcelRequire('21nCU'));

});

parcelRegister("kBegL", function(module, exports) {

let $eff254ee4c0946e8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eff254ee4c0946e8$var$load("3YoR7").then(()=>parcelRequire('dvo9I'));

});

parcelRegister("5sJWF", function(module, exports) {

let $3fa33507f5ae198f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3fa33507f5ae198f$var$load("hYBCI").then(()=>parcelRequire('93zHH'));

});

parcelRegister("dqT3O", function(module, exports) {

let $9c7869f611584426$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9c7869f611584426$var$load("3dBSm").then(()=>parcelRequire('ercGv'));

});

parcelRegister("gQ4Nj", function(module, exports) {

let $c42538c02c4bc2c7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c42538c02c4bc2c7$var$load("bG6hF").then(()=>parcelRequire('eFWxr'));

});

parcelRegister("dSN1f", function(module, exports) {

let $a1b657b272cd165b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a1b657b272cd165b$var$load("8shkA").then(()=>parcelRequire('2OgES'));

});

parcelRegister("7anl7", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", () => $1c9c2365ff37a453$export$68f3db7f6af48bcb);
/* eslint-disable max-len */ 
var $5uXOq = parcelRequire("5uXOq");

var $hxoiH = parcelRequire("hxoiH");

var $lEsIP = parcelRequire("lEsIP");

var $6PPEt = parcelRequire("6PPEt");

var $iVs6J = parcelRequire("iVs6J");
const $1c9c2365ff37a453$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $6PPEt.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>
    </svg>`;
};
const $1c9c2365ff37a453$export$68f3db7f6af48bcb = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, $lEsIP.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lEsIP.defaultLogoParams).iconColor, textColor: textColor = (0, $lEsIP.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iVs6J.default), {
        appearance: appearance,
        label: label,
        svg: $1c9c2365ff37a453$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("fkmri", function(module, exports) {

let $b28a214429ff684e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b28a214429ff684e$var$load("4JCpI").then(()=>parcelRequire('eZ9Cp'));

});

parcelRegister("eU0GA", function(module, exports) {

let $ad96d3dfca5d31e6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ad96d3dfca5d31e6$var$load("cEm5a").then(()=>parcelRequire('f5h6d'));

});

parcelRegister("jAQ3K", function(module, exports) {

let $e439c306ecaf2b13$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e439c306ecaf2b13$var$load("jfejx").then(()=>parcelRequire('729P0'));

});

parcelRegister("8YU6y", function(module, exports) {

let $689f728ade92de82$var$load = (parcelRequire("28QjX"))(4);
module.exports = $689f728ade92de82$var$load("4GgiA").then(()=>parcelRequire('6N55R'));

});

parcelRegister("7nuvV", function(module, exports) {

let $55f259d0aa4b0aae$var$load = (parcelRequire("28QjX"))(4);
module.exports = $55f259d0aa4b0aae$var$load("5xN5V").then(()=>parcelRequire('3xPiH'));

});

parcelRegister("hFsYk", function(module, exports) {

let $cdccbd4229e64354$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cdccbd4229e64354$var$load("fRQeP").then(()=>parcelRequire('9j532'));

});

parcelRegister("gMDFI", function(module, exports) {

let $c37fe70f109b78ee$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c37fe70f109b78ee$var$load("2JrEQ").then(()=>parcelRequire('jJL9z'));

});

parcelRegister("4fkVg", function(module, exports) {

let $3178caf18816bb57$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3178caf18816bb57$var$load("czPXX").then(()=>parcelRequire('3pKEh'));

});

parcelRegister("fgN6p", function(module, exports) {

let $b1de7052f50bfcad$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b1de7052f50bfcad$var$load("bW2Ht").then(()=>parcelRequire('k7gBp'));

});

parcelRegister("cV2N9", function(module, exports) {

let $967cf94be8e9a9d5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $967cf94be8e9a9d5$var$load("jlDVs").then(()=>parcelRequire('Le10t'));

});

parcelRegister("eVavM", function(module, exports) {

let $adce8af64095102c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $adce8af64095102c$var$load("9n8Rc").then(()=>parcelRequire('kc1MS'));

});

parcelRegister("56RVo", function(module, exports) {

let $3b87579a8c1c9c89$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3b87579a8c1c9c89$var$load("a0ALI").then(()=>parcelRequire('hfn9j'));

});

parcelRegister("ktXnL", function(module, exports) {

let $ee94942a5dcf51e4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ee94942a5dcf51e4$var$load("kFjg9").then(()=>parcelRequire('4zl0K'));

});

parcelRegister("9mM5H", function(module, exports) {

let $6d1b79007a44e718$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6d1b79007a44e718$var$load("50gXn").then(()=>parcelRequire('cfbO3'));

});

parcelRegister("1O0Re", function(module, exports) {

let $150b203f6494e0b7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $150b203f6494e0b7$var$load("1Bya1").then(()=>parcelRequire('jyFo7'));

});

parcelRegister("lGGho", function(module, exports) {

let $fc9e510f6e16a672$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fc9e510f6e16a672$var$load("6xK7c").then(()=>parcelRequire('eJNZM'));

});

parcelRegister("2LtoJ", function(module, exports) {

let $2036c66122d65aa9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2036c66122d65aa9$var$load("h2MrD"),
    $2036c66122d65aa9$var$load("bYT2S"),
    $2036c66122d65aa9$var$load("2ZGIQ")
]).then(()=>parcelRequire('2CRmv'));

});

parcelRegister("lE2nX", function(module, exports) {

let $fc1f2f1d241904fb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fc1f2f1d241904fb$var$load("kXqCi").then(()=>parcelRequire('2ciBJ'));

});

parcelRegister("dWKdk", function(module, exports) {

let $a2748a45fd722a7d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a2748a45fd722a7d$var$load("gPQs2").then(()=>parcelRequire('2lRM4'));

});


parcelRegister("5igsJ", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkAnalyticsContext", () => $31931ec4ffeaf53a$export$ac28ada90c4970b7);
$parcel$export(module.exports, "SmartLinkAnalyticsContext", () => $31931ec4ffeaf53a$export$eaff10f7ec59c455);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");

var $ffYTp = parcelRequire("ffYTp");

var $051X7 = parcelRequire("051X7");

var $cCcdH = parcelRequire("cCcdH");

var $hjhAz = parcelRequire("hjhAz");

var $fzJZi = parcelRequire("fzJZi");
const $31931ec4ffeaf53a$var$getExtendedResolvedAttributes = (linkDetails, details, linkStatus)=>({
        definitionId: details?.meta?.definitionId ?? null,
        resourceType: details?.meta?.resourceType ?? null,
        ...(0, $ffYTp.getResolvedAttributes)(linkDetails, details, linkStatus)
    });
const $31931ec4ffeaf53a$var$getSmartLinkAnalyticsContext = ({ display: display, id: id, response: response, source: source, status: status, url: url })=>{
    const resolvedAttributes = $31931ec4ffeaf53a$var$getExtendedResolvedAttributes({
        url: url
    }, response, status);
    return {
        source: source,
        attributes: {
            ...(0, $fzJZi.context),
            display: display,
            id: id,
            ...resolvedAttributes
        }
    };
};
const $31931ec4ffeaf53a$export$ac28ada90c4970b7 = ({ display: display, id: id, source: source, url: url })=>{
    const { store: store } = (0, $051X7.useSmartLinkContext)();
    const state = store ? (0, $cCcdH.getUrl)(store, url) : undefined;
    return (0, $5uXOq.useMemo)(()=>{
        return $31931ec4ffeaf53a$var$getSmartLinkAnalyticsContext({
            display: display,
            id: id,
            response: state?.details,
            source: source,
            status: state?.status,
            url: url
        });
    }, [
        display,
        id,
        source,
        state?.details,
        state?.status,
        url
    ]);
};
const $31931ec4ffeaf53a$export$eaff10f7ec59c455 = ({ children: children, display: display, id: id, source: source, url: url })=>{
    const { details: details, status: status } = (0, $hjhAz.useSmartCardState)(url);
    const data = $31931ec4ffeaf53a$var$getSmartLinkAnalyticsContext({
        display: display,
        id: id,
        response: details,
        source: source,
        status: status,
        url: url
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: data,
        children: children
    });
};

});
parcelRegister("ffYTp", function(module, exports) {

$parcel$export(module.exports, "getResolvedAttributes", () => $842bbc6d3f3b5d59$export$7243431f5325a7b);

var $fiKQs = parcelRequire("fiKQs");

var $iHcpV = parcelRequire("iHcpV");
const $842bbc6d3f3b5d59$export$7243431f5325a7b = (linkDetails, details, linkStatus)=>{
    const status = linkStatus ?? (details && (0, $fiKQs.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $iHcpV.getDisplayCategory)(status);
    return {
        status: status ?? null,
        statusDetails: details?.meta?.requestAccess?.accessType ?? null,
        displayCategory: displayCategory,
        extensionKey: details?.meta?.key ?? null,
        destinationTenantId: details?.meta?.tenantId ?? null,
        destinationActivationId: details?.meta?.activationId ?? null,
        destinationContainerId: details?.meta?.containerId ?? null,
        destinationCategory: details?.meta?.category ?? null,
        destinationProduct: details?.meta?.product ?? null,
        destinationSubproduct: details?.meta?.subproduct ?? null,
        destinationObjectId: details?.meta?.objectId ?? null,
        destinationObjectType: details?.meta?.resourceType ?? null,
        canBeDatasource: (details?.datasources || []).length > 0
    };
};

});
parcelRegister("iHcpV", function(module, exports) {

$parcel$export(module.exports, "getDisplayCategory", () => $1a9daeca9ad503b7$export$28ddbae335bd80b5);
const $1a9daeca9ad503b7$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};

});


parcelRegister("hjhAz", function(module, exports) {

$parcel$export(module.exports, "useSmartCardState", () => $7fb324870ee27912$export$b0444d00ba7313c6);

var $bDWQ3 = parcelRequire("bDWQ3");

var $051X7 = parcelRequire("051X7");
const $7fb324870ee27912$var$PENDING_STATE = {
    status: 'pending'
};
function $7fb324870ee27912$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $051X7.useSmartLinkContext)();
    const cardState = (0, $bDWQ3.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $7fb324870ee27912$var$PENDING_STATE;
}

});


parcelRegister("91tw3", function(module, exports) {

$parcel$export(module.exports, "isFlexibleUiCard", () => $f30ba994fabdf720$export$3c94e0f4719f5c2a);
$parcel$export(module.exports, "isFlexibleUiTitleBlock", () => $f30ba994fabdf720$export$df0092b19156b140);
$parcel$export(module.exports, "isFlexibleUiBlock", () => $f30ba994fabdf720$export$b56fc89cf6e7d1e9);
$parcel$export(module.exports, "isFlexibleUiElement", () => $f30ba994fabdf720$export$d7fc505bb0bd5756);
$parcel$export(module.exports, "isFlexibleUiPreviewBlock", () => $f30ba994fabdf720$export$c0547b4405cae584);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $66ZRy = parcelRequire("66ZRy");
var $buvhv = parcelRequire("buvhv");
var $hYQw7 = parcelRequire("hYQw7");
var $ietxm = parcelRequire("ietxm");

var $eqoQu = parcelRequire("eqoQu");
const $f30ba994fabdf720$export$3c94e0f4719f5c2a = (children)=>{
    if (children && (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children).some((child)=>$f30ba994fabdf720$export$df0092b19156b140(child))) return true;
    return false;
};
const $f30ba994fabdf720$export$b56fc89cf6e7d1e9 = (node)=>{
    if (!(0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && Object.values($66ZRy).some((type)=>type === node.type);
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if (typeof node.type !== 'string' && node.type?.name === 'StyleCacheProvider') {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!isChildrenValid) return;
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f30ba994fabdf720$export$b56fc89cf6e7d1e9(child);
        });
        return isChildrenValid;
    }
    if (Object.values($66ZRy).some((type)=>type === node.type)) return true;
    return false;
};
const $f30ba994fabdf720$export$d7fc505bb0bd5756 = (node)=>{
    if (!(0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && Object.values($eqoQu).some((type)=>type === node.type);
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if (Object.values($eqoQu).some((type)=>type === node.type)) return true;
    if (typeof node.type !== 'string' && node.type?.name === 'StyleCacheProvider' && node.props.children) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!isChildrenValid) return;
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f30ba994fabdf720$export$d7fc505bb0bd5756(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $f30ba994fabdf720$export$df0092b19156b140 = (node)=>{
    if (!(0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, $buvhv.default);
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if (node.type === (0, $buvhv.default)) return true;
    if (typeof node.type !== 'string' && node.type?.name === 'StyleCacheProvider' && node.props.children) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!isChildrenValid) return;
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f30ba994fabdf720$export$df0092b19156b140(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $f30ba994fabdf720$export$c0547b4405cae584 = (node)=>{
    if (!(0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, $hYQw7.default);
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if (node.type === (0, $hYQw7.default)) return true;
    if (typeof node.type !== 'string' && node.type?.name === 'StyleCacheProvider' && node.props.children) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!isChildrenValid) return;
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f30ba994fabdf720$export$c0547b4405cae584(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $f30ba994fabdf720$export$43edae7b55c79927 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, $ietxm.default);

});
parcelRegister("66ZRy", function(module, exports) {

$parcel$export(module.exports, "FooterBlock", () => (parcelRequire("ietxm")).default);
$parcel$export(module.exports, "MetadataBlock", () => (parcelRequire("gg6Qm")).default);
$parcel$export(module.exports, "PreviewBlock", () => (parcelRequire("hYQw7")).default);
$parcel$export(module.exports, "SnippetBlock", () => (parcelRequire("1JaZ4")).default);
$parcel$export(module.exports, "TitleBlock", () => (parcelRequire("buvhv")).default);
$parcel$export(module.exports, "CustomBlock", () => (parcelRequire("dghu0")).default);
$parcel$export(module.exports, "InternalFooterBlock", () => (parcelRequire("5HrTg")).default);
$parcel$export(module.exports, "AISummaryBlock", () => (parcelRequire("1qDIM")).default);
$parcel$export(module.exports, "AIFooterBlock", () => (parcelRequire("85ffk")).default);
$parcel$export(module.exports, "ActionBlock", () => (parcelRequire("fh9qw")).default);

var $ietxm = parcelRequire("ietxm");

var $gg6Qm = parcelRequire("gg6Qm");

var $hYQw7 = parcelRequire("hYQw7");

var $1JaZ4 = parcelRequire("1JaZ4");

var $buvhv = parcelRequire("buvhv");

var $dghu0 = parcelRequire("dghu0");

var $5HrTg = parcelRequire("5HrTg");

var $1qDIM = parcelRequire("1qDIM");

var $85ffk = parcelRequire("85ffk");

var $fh9qw = parcelRequire("fh9qw");

});
parcelRegister("ietxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fcebb5ad9978d90$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $5HrTg = parcelRequire("5HrTg");
/**
 * Represents a FooterBlock, designed to contain elements and actions that should appear
 * at the bottom of a link card.
 * @public
 * @param {FooterBlockProps} FooterBlockProps
 * @see Block
 */ const $3fcebb5ad9978d90$var$FooterBlock = ({ status: status, testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
    if (status !== (0, $8dVIb.SmartLinkStatus).Resolved && !alwaysShow) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5HrTg.default), {
        ...props,
        testId: testId
    });
};
var $3fcebb5ad9978d90$export$2e2bcd8739ae039 = $3fcebb5ad9978d90$var$FooterBlock;

});
parcelRegister("5HrTg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8eaafd3e75b73f4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $eqoQu = parcelRequire("eqoQu");

var $bubxq = parcelRequire("bubxq");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $akF1x = parcelRequire("akF1x");

var $dEOWY = parcelRequire("dEOWY");
const $b8eaafd3e75b73f4$var$actionGroupStyles = null;
const $b8eaafd3e75b73f4$var$FooterBlockResolvedView = (props)=>{
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $8dVIb.SmartLinkSize).Medium, hideProvider: hideProvider } = props;
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const hasActions = (0, $5uXOq.useMemo)(()=>(0, $akF1x.filterActionItems)(actions, context)?.length > 0, [
        actions,
        context
    ]);
    const onDropdownOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            !hideProvider && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.Provider), {
                testId: `${testId}-provider`
            }),
            actions && hasActions ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                testId: "smart-element-group-actions",
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                width: (0, $8dVIb.SmartLinkWidth).Flexible,
                className: (0, $bwpsq.default)([
                    size === (0, $8dVIb.SmartLinkSize).XLarge && "_c71lviql"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bubxq.default), {
                    onDropdownOpenChange: onDropdownOpenChange,
                    items: actions,
                    appearance: "default",
                    size: size
                })
            }) : null
        ]
    });
};
const $b8eaafd3e75b73f4$var$FooterBlockResolvedViewExported = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($b8eaafd3e75b73f4$var$FooterBlockResolvedView, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dEOWY.default), {
        ...props
    });
};
var $b8eaafd3e75b73f4$export$2e2bcd8739ae039 = $b8eaafd3e75b73f4$var$FooterBlockResolvedViewExported;

});
parcelRegister("Nh1XU", function(module, exports) {

$parcel$export(module.exports, "FlexibleUiContext", () => $79a38154bf117346$export$ca70b164b615de47);
$parcel$export(module.exports, "useFlexibleUiContext", () => $79a38154bf117346$export$61d7957a243df7aa);
$parcel$export(module.exports, "FlexibleUiOptionContext", () => $79a38154bf117346$export$f7433dbd6c50e26a);
$parcel$export(module.exports, "useFlexibleUiOptionContext", () => $79a38154bf117346$export$e6b5ad18b56e8f51);

var $5uXOq = parcelRequire("5uXOq");
const $79a38154bf117346$export$ca70b164b615de47 = (0, $5uXOq.createContext)(undefined);
const $79a38154bf117346$export$61d7957a243df7aa = ()=>(0, $5uXOq.useContext)($79a38154bf117346$export$ca70b164b615de47);
const $79a38154bf117346$export$f7433dbd6c50e26a = (0, $5uXOq.createContext)(undefined);
const $79a38154bf117346$export$e6b5ad18b56e8f51 = ()=>(0, $5uXOq.useContext)($79a38154bf117346$export$f7433dbd6c50e26a);

});

parcelRegister("eqoQu", function(module, exports) {

$parcel$export(module.exports, "AssignedTo", () => $ec376f2b71614cc0$export$d3af56c23f9e459b);
$parcel$export(module.exports, "AssignedToGroup", () => $ec376f2b71614cc0$export$fbd18f11bf3a3444);
$parcel$export(module.exports, "AttachmentCount", () => $ec376f2b71614cc0$export$3bc3c9693a40aa);
$parcel$export(module.exports, "AuthorGroup", () => $ec376f2b71614cc0$export$2ae2af4435dd6144);
$parcel$export(module.exports, "ChecklistProgress", () => $ec376f2b71614cc0$export$5742b38fd5cfe410);
$parcel$export(module.exports, "CollaboratorGroup", () => $ec376f2b71614cc0$export$a1e647014985ddb9);
$parcel$export(module.exports, "CommentCount", () => $ec376f2b71614cc0$export$f4c1466e6fdd07b);
$parcel$export(module.exports, "CreatedOn", () => $ec376f2b71614cc0$export$53ced9403d373871);
$parcel$export(module.exports, "CreatedBy", () => $ec376f2b71614cc0$export$db468caedefbb630);
$parcel$export(module.exports, "DueOn", () => $ec376f2b71614cc0$export$fea59459cfa1625b);
$parcel$export(module.exports, "LatestCommit", () => $ec376f2b71614cc0$export$2aa8c58ab6c8ae64);
$parcel$export(module.exports, "LinkIcon", () => $ec376f2b71614cc0$export$69387b41dfc808f7);
$parcel$export(module.exports, "Location", () => $ec376f2b71614cc0$export$18a2be9195644f38);
$parcel$export(module.exports, "ModifiedBy", () => $ec376f2b71614cc0$export$ebbbdcc68d717b7b);
$parcel$export(module.exports, "ModifiedOn", () => $ec376f2b71614cc0$export$a6db3f4240728b58);
$parcel$export(module.exports, "OwnedBy", () => $ec376f2b71614cc0$export$fa04b1f8d953704f);
$parcel$export(module.exports, "OwnedByGroup", () => $ec376f2b71614cc0$export$90e81c873cca1e90);
$parcel$export(module.exports, "Priority", () => $ec376f2b71614cc0$export$300334f671c43555);
$parcel$export(module.exports, "ProgrammingLanguage", () => $ec376f2b71614cc0$export$7904b5485bf997ea);
$parcel$export(module.exports, "Provider", () => $ec376f2b71614cc0$export$2881499e37b75b9a);
$parcel$export(module.exports, "ReactCount", () => $ec376f2b71614cc0$export$f69df2decd5f729e);
$parcel$export(module.exports, "ReadTime", () => $ec376f2b71614cc0$export$77dedcd16f070a20);
$parcel$export(module.exports, "SentOn", () => $ec376f2b71614cc0$export$897b145a1ed39fe5);
$parcel$export(module.exports, "SourceBranch", () => $ec376f2b71614cc0$export$387c3264a8f67d61);
$parcel$export(module.exports, "State", () => $ec376f2b71614cc0$export$7254cc27399e90bd);
$parcel$export(module.exports, "SubscriberCount", () => $ec376f2b71614cc0$export$cfafe90bba8a54db);
$parcel$export(module.exports, "SubTasksProgress", () => $ec376f2b71614cc0$export$d441f34e4c8dd9e7);
$parcel$export(module.exports, "StoryPoints", () => $ec376f2b71614cc0$export$634eef04d1a9a575);
$parcel$export(module.exports, "TargetBranch", () => $ec376f2b71614cc0$export$b5e4199e062b8f44);
$parcel$export(module.exports, "Title", () => $ec376f2b71614cc0$export$f99233281efd08a0);
$parcel$export(module.exports, "ViewCount", () => $ec376f2b71614cc0$export$ae2d8be089b6cfe0);
$parcel$export(module.exports, "VoteCount", () => $ec376f2b71614cc0$export$b080bef6ed7fa75a);
$parcel$export(module.exports, "Preview", () => (parcelRequire("kDhrr")).default);
$parcel$export(module.exports, "Snippet", () => (parcelRequire("kp8aU")).default);

var $8dVIb = parcelRequire("8dVIb");

var $eCsaJ = parcelRequire("eCsaJ");

var $kDhrr = parcelRequire("kDhrr");

var $kp8aU = parcelRequire("kp8aU");
const $ec376f2b71614cc0$export$d3af56c23f9e459b = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).AssignedTo);
const $ec376f2b71614cc0$export$fbd18f11bf3a3444 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).AssignedToGroup);
const $ec376f2b71614cc0$export$3bc3c9693a40aa = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).AttachmentCount);
const $ec376f2b71614cc0$export$2ae2af4435dd6144 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).AuthorGroup);
const $ec376f2b71614cc0$export$5742b38fd5cfe410 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ChecklistProgress);
const $ec376f2b71614cc0$export$a1e647014985ddb9 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).CollaboratorGroup);
const $ec376f2b71614cc0$export$f4c1466e6fdd07b = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).CommentCount);
const $ec376f2b71614cc0$export$53ced9403d373871 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).CreatedOn);
const $ec376f2b71614cc0$export$db468caedefbb630 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).CreatedBy);
const $ec376f2b71614cc0$export$fea59459cfa1625b = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).DueOn);
const $ec376f2b71614cc0$export$2aa8c58ab6c8ae64 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).LatestCommit);
const $ec376f2b71614cc0$export$69387b41dfc808f7 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).LinkIcon);
const $ec376f2b71614cc0$export$18a2be9195644f38 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).Location);
const $ec376f2b71614cc0$export$ebbbdcc68d717b7b = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ModifiedBy);
const $ec376f2b71614cc0$export$a6db3f4240728b58 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ModifiedOn);
const $ec376f2b71614cc0$export$fa04b1f8d953704f = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).OwnedBy);
const $ec376f2b71614cc0$export$90e81c873cca1e90 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).OwnedByGroup);
const $ec376f2b71614cc0$export$300334f671c43555 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).Priority);
const $ec376f2b71614cc0$export$7904b5485bf997ea = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ProgrammingLanguage);
const $ec376f2b71614cc0$export$2881499e37b75b9a = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).Provider);
const $ec376f2b71614cc0$export$f69df2decd5f729e = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ReactCount);
const $ec376f2b71614cc0$export$77dedcd16f070a20 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ReadTime);
const $ec376f2b71614cc0$export$897b145a1ed39fe5 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).SentOn);
const $ec376f2b71614cc0$export$387c3264a8f67d61 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).SourceBranch);
const $ec376f2b71614cc0$export$7254cc27399e90bd = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).State);
const $ec376f2b71614cc0$export$cfafe90bba8a54db = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).SubscriberCount);
const $ec376f2b71614cc0$export$d441f34e4c8dd9e7 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).SubTasksProgress);
const $ec376f2b71614cc0$export$634eef04d1a9a575 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).StoryPoints);
const $ec376f2b71614cc0$export$b5e4199e062b8f44 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).TargetBranch);
const $ec376f2b71614cc0$export$f99233281efd08a0 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).Title);
const $ec376f2b71614cc0$export$ae2d8be089b6cfe0 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ViewCount);
const $ec376f2b71614cc0$export$b080bef6ed7fa75a = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).VoteCount);

});
parcelRegister("eCsaJ", function(module, exports) {

$parcel$export(module.exports, "createElement", () => $3c92d860530d8c8b$export$c8a8987d4410bf2d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $9tslm = parcelRequire("9tslm");

var $4ZXUA = parcelRequire("4ZXUA");

var $7IZqM = parcelRequire("7IZqM");

var $bWpL0 = parcelRequire("bWpL0");

var $aWyvu = parcelRequire("aWyvu");

var $3dV67 = parcelRequire("3dV67");

var $cJxXG = parcelRequire("cJxXG");

var $77cM6 = parcelRequire("77cM6");

var $k39kU = parcelRequire("k39kU");
const $3c92d860530d8c8b$var$elementMappings = {
    [(0, $8dVIb.ElementName).AttachmentCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).Attachment
        }
    },
    [(0, $8dVIb.ElementName).AuthorGroup]: {
        component: (0, $4ZXUA.default)
    },
    [(0, $8dVIb.ElementName).ChecklistProgress]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).CheckItem
        }
    },
    [(0, $8dVIb.ElementName).CollaboratorGroup]: {
        component: (0, $4ZXUA.default)
    },
    [(0, $8dVIb.ElementName).CommentCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).Comment
        }
    },
    [(0, $8dVIb.ElementName).ViewCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).View
        }
    },
    [(0, $8dVIb.ElementName).ReactCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).React
        }
    },
    [(0, $8dVIb.ElementName).VoteCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).Vote
        }
    },
    [(0, $8dVIb.ElementName).CreatedBy]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).OwnedBy]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).AssignedTo]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).AssignedToGroup]: {
        component: (0, $4ZXUA.default)
    },
    [(0, $8dVIb.ElementName).OwnedByGroup]: {
        component: (0, $4ZXUA.default)
    },
    [(0, $8dVIb.ElementName).CreatedOn]: {
        component: (0, $bWpL0.default)
    },
    [(0, $8dVIb.ElementName).DueOn]: {
        component: (0, $cJxXG.default)
    },
    [(0, $8dVIb.ElementName).LatestCommit]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).Commit
        }
    },
    [(0, $8dVIb.ElementName).LinkIcon]: {
        component: (0, $aWyvu.default)
    },
    [(0, $8dVIb.ElementName).ModifiedBy]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).ModifiedOn]: {
        component: (0, $bWpL0.default)
    },
    [(0, $8dVIb.ElementName).Preview]: {
        component: (0, $77cM6.default)
    },
    [(0, $8dVIb.ElementName).Priority]: {
        component: (0, $7IZqM.default)
    },
    [(0, $8dVIb.ElementName).ProgrammingLanguage]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).ProgrammingLanguage
        }
    },
    [(0, $8dVIb.ElementName).Provider]: {
        component: (0, $7IZqM.default)
    },
    [(0, $8dVIb.ElementName).ReadTime]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).SentOn]: {
        component: (0, $bWpL0.default)
    },
    [(0, $8dVIb.ElementName).SourceBranch]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).State]: {
        component: (0, $cJxXG.default)
    },
    [(0, $8dVIb.ElementName).SubscriberCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).Subscriber
        }
    },
    [(0, $8dVIb.ElementName).SubTasksProgress]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).SubTasksProgress
        }
    },
    [(0, $8dVIb.ElementName).StoryPoints]: {
        component: (0, $9tslm.default)
    },
    [(0, $8dVIb.ElementName).TargetBranch]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).Title]: {
        component: (0, $3dV67.default)
    },
    [(0, $8dVIb.ElementName).Location]: {
        component: (0, $3dV67.default),
        props: {
            theme: (0, $8dVIb.SmartLinkInternalTheme).Grey
        }
    }
};
const $3c92d860530d8c8b$var$getContextKey = (name)=>{
    // Attempt to predict context prop name in advance to reduce the amount of
    // code run during runtime
    return name.length > 0 ? name.charAt(0).toLowerCase() + name.slice(1) : undefined;
};
const $3c92d860530d8c8b$var$getData = (elementName, contextKey, context)=>{
    if (!context) return undefined;
    const data = context[contextKey];
    switch(elementName){
        case (0, $8dVIb.ElementName).AssignedToGroup:
        case (0, $8dVIb.ElementName).AuthorGroup:
        case (0, $8dVIb.ElementName).CollaboratorGroup:
        case (0, $8dVIb.ElementName).OwnedByGroup:
            const AvatarGroupsWithFallback = [
                (0, $8dVIb.ElementName).AssignedToGroup
            ];
            const showFallbackAvatar = AvatarGroupsWithFallback.includes(elementName);
            return $3c92d860530d8c8b$var$toAvatarGroupProps(data, showFallbackAvatar);
        case (0, $8dVIb.ElementName).AttachmentCount:
        case (0, $8dVIb.ElementName).ChecklistProgress:
        case (0, $8dVIb.ElementName).CommentCount:
        case (0, $8dVIb.ElementName).ViewCount:
        case (0, $8dVIb.ElementName).ReactCount:
        case (0, $8dVIb.ElementName).VoteCount:
        case (0, $8dVIb.ElementName).ProgrammingLanguage:
        case (0, $8dVIb.ElementName).SubscriberCount:
        case (0, $8dVIb.ElementName).LatestCommit:
        case (0, $8dVIb.ElementName).SubTasksProgress:
            return $3c92d860530d8c8b$var$toBadgeProps(data);
        case (0, $8dVIb.ElementName).StoryPoints:
            return $3c92d860530d8c8b$var$toAtlaskitBadgeProps(data);
        case (0, $8dVIb.ElementName).CreatedBy:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).created_by, context.createdBy);
        case (0, $8dVIb.ElementName).AssignedTo:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).assigned_to, context.assignedTo);
        case (0, $8dVIb.ElementName).OwnedBy:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).owned_by, context.ownedBy);
        case (0, $8dVIb.ElementName).CreatedOn:
            return $3c92d860530d8c8b$var$toDateTimeProps('created', context.createdOn);
        case (0, $8dVIb.ElementName).DueOn:
            return $3c92d860530d8c8b$var$toDateLozengeProps(context.dueOn);
        case (0, $8dVIb.ElementName).ModifiedBy:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).modified_by, context.modifiedBy);
        case (0, $8dVIb.ElementName).ModifiedOn:
            return $3c92d860530d8c8b$var$toDateTimeProps('modified', context.modifiedOn);
        case (0, $8dVIb.ElementName).SentOn:
            return $3c92d860530d8c8b$var$toDateTimeProps('sent', context.sentOn);
        case (0, $8dVIb.ElementName).ReadTime:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).read_time, data);
        case (0, $8dVIb.ElementName).SourceBranch:
        case (0, $8dVIb.ElementName).TargetBranch:
            return $3c92d860530d8c8b$var$toTextProps(data);
        case (0, $8dVIb.ElementName).Title:
            return $3c92d860530d8c8b$var$toLinkProps(context.title, context.url);
        default:
            return typeof data === 'object' ? data : undefined;
    }
};
const $3c92d860530d8c8b$var$toAvatarGroupProps = (items, showFallbackAvatar)=>{
    return items ? {
        items: items
    } : showFallbackAvatar ? {
        items: []
    } : undefined;
};
const $3c92d860530d8c8b$var$toBadgeProps = (label)=>{
    return label ? {
        label: label
    } : undefined;
};
const $3c92d860530d8c8b$var$toAtlaskitBadgeProps = (value)=>{
    return value ? {
        value: value
    } : undefined;
};
const $3c92d860530d8c8b$var$toDateLozengeProps = (dateString)=>{
    if (dateString) {
        const text = Date.parse(dateString) ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7VHMR.FormattedDate), {
            value: new Date(dateString),
            year: "numeric",
            month: "short",
            day: "numeric",
            formatMatcher: "best fit"
        }) : dateString;
        return {
            text: text
        };
    }
};
const $3c92d860530d8c8b$var$toDateTimeProps = (type, dateString)=>{
    return dateString ? {
        date: new Date(dateString),
        type: type
    } : undefined;
};
const $3c92d860530d8c8b$var$toFormattedTextProps = (descriptor, context)=>{
    return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        }
    } : undefined;
};
const $3c92d860530d8c8b$var$toLinkProps = (text, url)=>{
    return text ? {
        text: text,
        url: url
    } : undefined;
};
const $3c92d860530d8c8b$var$toTextProps = (content)=>{
    return content ? {
        content: content
    } : undefined;
};
const $3c92d860530d8c8b$export$c8a8987d4410bf2d = (name)=>{
    const { component: BaseElement, props: props } = $3c92d860530d8c8b$var$elementMappings[name] || {};
    const contextKey = $3c92d860530d8c8b$var$getContextKey(name);
    if (!BaseElement) throw Error(`Element ${name} does not exist.`);
    return (overrides)=>{
        const context = (0, $5uXOq.useContext)((0, $Nh1XU.FlexibleUiContext));
        const data = $3c92d860530d8c8b$var$getData(name, contextKey, context);
        return data ? /*#__PURE__*/ (0, $2OMIu.jsx)(BaseElement, {
            ...props,
            ...data,
            ...overrides,
            name: name
        }) : null;
    };
};

});
parcelRegister("7zaVw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a298b78183f16654$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a298b78183f16654$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized: {
        id: 'fabric.linking.ai_summarized',
        defaultMessage: 'Summarized by Atlassian Intelligence',
        description: 'Shown with the content summarised by AI.'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarizing: {
        id: 'fabric.linking.ai_summarizing',
        defaultMessage: 'Atlassian Intelligence is working...',
        description: 'Shown when AI summary is summarising the link resource content.'
    },
    ai_summary_error_generic: {
        id: 'fabric.linking.ai_summary_error_generic',
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Indicates a beta phase of the feature.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: ''
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Link safety warning modal header'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'continue'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: ''
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Url has been copied to the clipboard'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Allow a user to delete a link'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: ''
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: 'Description on what Download does'
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Allow a user to download a file'
    },
    ai_summary_action: {
        id: 'fabric.linking.ai_summary_action',
        defaultMessage: 'Summarize with AI',
        description: 'Allow a user to summarize a link'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Allow a user to edit a link'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Click to follow a project.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Description on what Follow does'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Click to follow a project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Description on what Follow does'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Click to follow a project.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'go back'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Click to open link in Jira'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Click to open link in a new tab'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Description on what Preview does'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Click to close embed preview modal.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Indicated priority as blocker'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Indicated priority as critical'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Indicated priority as high'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Indicated priority as highest'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Indicated priority as low'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Indicated priority as lowest'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Indicated priority as major'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Indicated priority as medium'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Indicated priority as minor'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Indicated priority as trivial'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Indicated priority as unknown'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Estimated time to read this resource'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Link safety check warning message'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Description on what Unfollow does'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Click to unfollow a project.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'A generic error message to the user'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Recent links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls',
        defaultMessage: 'View recent links',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found In',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes Links To',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_header: {
        id: 'fabric.linking.related_links_modal_error_header',
        defaultMessage: 'Something went wrong',
        description: 'Title for related links error'
    },
    related_links_modal_error_message: {
        id: 'fabric.linking.related_links_modal_error_message',
        defaultMessage: 'We ran into an issue trying to load recent links. Check your connection or refresh to try again.',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_header: {
        id: 'fabric.linking.related_links_modal_unavailable_header',
        defaultMessage: 'No recent links',
        description: 'Title for related links being unavailable'
    },
    related_links_modal_unavailable_message: {
        id: 'fabric.linking.related_links_modal_unavailable_message',
        defaultMessage: "We didn't find any links to show here. We continuously review and add recent links for updated pages or other content types.",
        description: 'Informs the user that related links were not found but may be available in the future'
    },
    join_to_viewIssueTermRefresh: {
        id: 'fabric.linking.join_to_view-issue-term-refresh',
        defaultMessage: 'Join {context} to view this work item',
        description: 'Allows the user join the product or service immediately'
    },
    open_issue_in_jiraIssueTermRefresh: {
        id: 'fabric.linking.open_issue_in_jira-issue-term-refresh',
        defaultMessage: 'Open work item in Jira',
        description: 'Click to open link in Jira'
    },
    request_access_to_viewIssueTermRefresh: {
        id: 'fabric.linking.request_access_to_view-issue-term-refresh',
        defaultMessage: 'Request access to {context} to view this work item',
        description: 'Allows the user to request access to a product or service'
    },
    status_change_permission_errorIssueTermRefresh: {
        id: 'fabric.linking.status_change_permission_error-issue-term-refresh',
        defaultMessage: "You don\u2019t have permission to transition this work item. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    }
});

});

parcelRegister("9tslm", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf2a1e857857107e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $16T6Y = parcelRequire("16T6Y");

var $VSDnB = parcelRequire("VSDnB");

var $enZzq = parcelRequire("enZzq");
const $bf2a1e857857107e$var$badgeStyles = null;
/**
 * A base element that displays a visual indicator for a numeric value
 * @internal
 * @see StoryPoints
 * */ const $bf2a1e857857107e$var$AtlaskitBadgeNew = ({ value: value, name: name, className: className, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c116y",
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $16T6Y.default), {
            children: value
        })
    });
};
const $bf2a1e857857107e$var$AtlaskitBadge = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($bf2a1e857857107e$var$AtlaskitBadgeNew, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $enZzq.default), {
        ...props
    });
};
var $bf2a1e857857107e$export$2e2bcd8739ae039 = $bf2a1e857857107e$var$AtlaskitBadge;

});
parcelRegister("enZzq", function(module, exports) {

$parcel$export(module.exports, "default", () => $75cef1fb26f884a2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $16T6Y = parcelRequire("16T6Y");
function $75cef1fb26f884a2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $75cef1fb26f884a2$var$badgeStyles = {
    name: "qowjig",
    styles: "align-items:center;display:inline-flex"
};
/**
 * A base element that displays a visual indicator for a numeric value
 * @internal
 * @see StoryPoints
 * */ const $75cef1fb26f884a2$var$AtlaskitBadgeOld = ({ value: value, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $75cef1fb26f884a2$var$badgeStyles,
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $16T6Y.default), null, value));
};
var $75cef1fb26f884a2$export$2e2bcd8739ae039 = $75cef1fb26f884a2$var$AtlaskitBadgeOld;

});


parcelRegister("4ZXUA", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e655d051c837701$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $jnhNB = parcelRequire("jnhNB");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $fpDmE = parcelRequire("fpDmE");

var $dHPsx = parcelRequire("dHPsx");
const $1e655d051c837701$var$MAX_COUNT = 4;
const $1e655d051c837701$var$stylesMap = {
    xlarge: "_1e0c116y _1kvxcxkx _102oidpf",
    large: "_1e0c116y _1kvxcxkx _102oidpf",
    medium: "_1e0c116y _1kvxcxkx _102oidpf _6fu61k92 _1rrq1k92 _udwj1k92 _10pr1k92",
    small: "_1e0c116y _1kvxcxkx _102oidpf _6fu61k92 _1rrq1k92 _udwj1k92 _10pr1k92"
};
const $1e655d051c837701$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $8dVIb.ElementName).AssignedToGroup:
            return (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).assigned_to, personName);
        case (0, $8dVIb.ElementName).OwnedByGroup:
            return (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).owned_by, personName);
        case (0, $8dVIb.ElementName).AuthorGroup:
            return (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).created_by, personName);
        default:
            return personName;
    }
};
/**
 * A base element that displays a group of avatars.
 * @internal
 * @param {AvatarGroupProps} AvatarGroupProps - The props necessary for the AvatarGroup.
 * @see AuthorGroup
 * @see CollaboratorGroup
 */ const $1e655d051c837701$var$AvatarGroupNew = ({ items: items = [], maxCount: maxCount = $1e655d051c837701$var$MAX_COUNT, name: name, className: className, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $koVbs.default)();
    const data = (0, $5uXOq.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $8dVIb.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
        //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $1e655d051c837701$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $1e655d051c837701$var$stylesMap[size],
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jnhNB.default), {
            maxCount: maxCount,
            appearance: "stack",
            size: "small",
            data: data,
            testId: testId
        })
    });
};
const $1e655d051c837701$var$AvatarGroup = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($1e655d051c837701$var$AvatarGroupNew, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dHPsx.default), {
        ...props
    });
};
var $1e655d051c837701$export$2e2bcd8739ae039 = $1e655d051c837701$var$AvatarGroup;

});
parcelRegister("fpDmE", function(module, exports) {

$parcel$export(module.exports, "sizeToButtonSpacing", () => $3ebf94f205ad0182$export$9d642f65a919fb93);
$parcel$export(module.exports, "getFormattedMessage", () => $3ebf94f205ad0182$export$f1aa79f2218fb713);
$parcel$export(module.exports, "getFormattedMessageAsString", () => $3ebf94f205ad0182$export$66ecb50a9dd1768);
$parcel$export(module.exports, "getIconSizeStyles", () => $3ebf94f205ad0182$export$a5dfadfde90ee066);
$parcel$export(module.exports, "getIconWidthNew", () => $3ebf94f205ad0182$export$86b6226ea65a6ddf);
$parcel$export(module.exports, "getIconWidth", () => $3ebf94f205ad0182$export$fb10bc5609c6347e);
$parcel$export(module.exports, "importIcon", () => $3ebf94f205ad0182$export$6dc831e1a0a7a851);
$parcel$export(module.exports, "getLinkLineHeight", () => $3ebf94f205ad0182$export$1826e889cc97649);
$parcel$export(module.exports, "getLinkSizeStyles", () => $3ebf94f205ad0182$export$7c3a25542ae9da0e);
$parcel$export(module.exports, "getMaxLineHeight", () => $3ebf94f205ad0182$export$a681bd062fee88a5);
$parcel$export(module.exports, "getMaxLines", () => $3ebf94f205ad0182$export$c2293adf1794c09);
$parcel$export(module.exports, "getPrimitivesInlineSpaceBySize", () => $3ebf94f205ad0182$export$475c391af8171fec);
$parcel$export(module.exports, "getPrimitivesPaddingSpaceBySize", () => $3ebf94f205ad0182$export$1af10e3728e3a644);
$parcel$export(module.exports, "getTruncateStyles", () => $3ebf94f205ad0182$export$8847c5561c06da49);
$parcel$export(module.exports, "hasWhiteSpace", () => $3ebf94f205ad0182$export$619e376a425cb759);
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ousew = parcelRequire("ousew");

var $4qBtX = parcelRequire("4qBtX");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");
const $3ebf94f205ad0182$export$9d642f65a919fb93 = {
    [(0, $8dVIb.SmartLinkSize).Small]: 'none',
    [(0, $8dVIb.SmartLinkSize).Medium]: 'compact',
    [(0, $8dVIb.SmartLinkSize).Large]: 'compact',
    [(0, $8dVIb.SmartLinkSize).XLarge]: 'default'
};
const $3ebf94f205ad0182$export$f1aa79f2218fb713 = (message)=>{
    if (message) {
        const { descriptor: descriptor, values: values } = message;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...descriptor,
            values: values
        });
    }
};
const $3ebf94f205ad0182$export$66ecb50a9dd1768 = (intl, message, context)=>{
    const { formatMessage: formatMessage } = intl;
    return message ? formatMessage(message, {
        context: context
    }) : '';
};
/**
 * @deprecated remove on FF bandicoots-compiled-migration-smartcard clean up
 */ const $3ebf94f205ad0182$var$getIconDimensionStyles = (value)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minHeight: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minWidth: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: value
    });
const $3ebf94f205ad0182$export$a5dfadfde90ee066 = (width)=>{
    const sizeStyles = $3ebf94f205ad0182$var$getIconDimensionStyles(width);
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $f8Sb3.css)("flex:0 0 auto;", sizeStyles, " span,svg,img{", sizeStyles, ";}svg{padding:0;}");
};
const $3ebf94f205ad0182$export$ce56b6021549537 = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return '2rem';
        case (0, $8dVIb.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $8dVIb.SmartLinkSize).Medium:
            return '1rem';
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return '.75rem';
    }
};
const $3ebf94f205ad0182$export$86b6226ea65a6ddf = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $8dVIb.SmartLinkSize).Medium:
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return "var(--ds-space-200, 16px)";
    }
};
const $3ebf94f205ad0182$export$fb10bc5609c6347e = (size)=>{
    return (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? $3ebf94f205ad0182$export$86b6226ea65a6ddf(size) : $3ebf94f205ad0182$export$ce56b6021549537(size);
};
const $3ebf94f205ad0182$export$6dc831e1a0a7a851 = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $3ebf94f205ad0182$export$1826e889cc97649 = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return '1.5rem';
        case (0, $8dVIb.SmartLinkSize).Large:
        case (0, $8dVIb.SmartLinkSize).Medium:
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
const $3ebf94f205ad0182$export$7c3a25542ae9da0e = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return /*#__PURE__*/ (0, $f8Sb3.css)({
                font: "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                fontWeight: "var(--ds-font-weight-regular, 400)",
                lineHeight: $3ebf94f205ad0182$export$1826e889cc97649(size)
            });
        case (0, $8dVIb.SmartLinkSize).Large:
        case (0, $8dVIb.SmartLinkSize).Medium:
            return /*#__PURE__*/ (0, $f8Sb3.css)({
                font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                fontWeight: "var(--ds-font-weight-regular, 400)",
                lineHeight: $3ebf94f205ad0182$export$1826e889cc97649(size)
            });
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return /*#__PURE__*/ (0, $f8Sb3.css)({
                font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                fontWeight: "var(--ds-font-weight-regular, 400)",
                lineHeight: $3ebf94f205ad0182$export$1826e889cc97649(size)
            });
    }
};
const $3ebf94f205ad0182$export$a681bd062fee88a5 = (size)=>{
    // The maximum line height based on all elements in specific size.
    // These heights belongs to AvatarGroup.
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return 1.75;
        case (0, $8dVIb.SmartLinkSize).Medium:
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return 1.5;
    }
};
const $3ebf94f205ad0182$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
    if (value > max) return defaultValue;
    if (value < min) return min;
    return value;
};
const $3ebf94f205ad0182$export$475c391af8171fec = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return 'space.250';
        case (0, $8dVIb.SmartLinkSize).Large:
            return 'space.200';
        case (0, $8dVIb.SmartLinkSize).Medium:
            return 'space.100';
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return 'space.050';
    }
};
const $3ebf94f205ad0182$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return 'space.300';
        case (0, $8dVIb.SmartLinkSize).Large:
            return 'space.250';
        case (0, $8dVIb.SmartLinkSize).Medium:
            return 'space.200';
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return 'space.100';
    }
};
const $3ebf94f205ad0182$export$8847c5561c06da49 = (maxLines, lineHeight = '1rem', wordBreak = 'break-word')=>/*#__PURE__*/ (0, $f8Sb3.css)({
        display: '-webkit-box',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        wordBreak: wordBreak,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: 'vertical',
        '@supports not (-webkit-line-clamp: 1)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            maxHeight: `calc(${maxLines} * ${lineHeight})`
        }
    });
const $3ebf94f205ad0182$export$619e376a425cb759 = (str)=>{
    return str.search(/\s/) >= 0;
};

});

parcelRegister("dHPsx", function(module, exports) {

$parcel$export(module.exports, "default", () => $75ab4e9bd388d553$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $koVbs = parcelRequire("koVbs");

var $jnhNB = parcelRequire("jnhNB");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $fpDmE = parcelRequire("fpDmE");
function $75ab4e9bd388d553$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $75ab4e9bd388d553$var$MAX_COUNT = 4;
var $75ab4e9bd388d553$var$_ref = {
    name: "1brfzli",
    styles: "display:inline-flex;ul{margin-right:var(--ds-space-100, 0.5rem);margin-top:0;}"
};
const $75ab4e9bd388d553$var$getStyles = (size)=>{
    const styles = $75ab4e9bd388d553$var$_ref;
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            // Default AK small size
            return styles;
        case (0, $8dVIb.SmartLinkSize).Medium:
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
            return /*#__PURE__*/ (0, $f8Sb3.css)(styles, " li{span,svg{max-height:1.25rem;max-width:1.25rem;}}");
    }
};
const $75ab4e9bd388d553$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $8dVIb.ElementName).AssignedToGroup:
            return (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).assigned_to, personName);
        case (0, $8dVIb.ElementName).OwnedByGroup:
            return (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).owned_by, personName);
        case (0, $8dVIb.ElementName).AuthorGroup:
            return (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).created_by, personName);
        default:
            return personName;
    }
};
/**
 * A base element that displays a group of avatars.
 * @internal
 * @param {AvatarGroupProps} AvatarGroupProps - The props necessary for the AvatarGroup.
 * @see AuthorGroup
 * @see CollaboratorGroup
 */ const $75ab4e9bd388d553$var$AvatarGroupOld = ({ items: items = [], maxCount: maxCount = $75ab4e9bd388d553$var$MAX_COUNT, name: name, overrideCss: overrideCss, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $koVbs.default)();
    const data = (0, $5uXOq.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $8dVIb.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
        //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $75ab4e9bd388d553$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $75ab4e9bd388d553$var$getStyles(size),
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jnhNB.default), {
        maxCount: maxCount,
        appearance: "stack",
        size: "small",
        data: data,
        testId: testId
    }));
};
var $75ab4e9bd388d553$export$2e2bcd8739ae039 = $75ab4e9bd388d553$var$AvatarGroupOld;

});


parcelRegister("7IZqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $aab9f19acb0d3ec1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $9Hdrc = parcelRequire("9Hdrc");

var $l5Xsv = parcelRequire("l5Xsv");

var $fpDmE = parcelRequire("fpDmE");

var $1kJhy = parcelRequire("1kJhy");
const $aab9f19acb0d3ec1$var$badgeStyles = null;
const $aab9f19acb0d3ec1$var$iconStyles = null;
// ${getIconSizeStyles('1rem')}
const $aab9f19acb0d3ec1$var$labelStyles = null;
const $aab9f19acb0d3ec1$var$messageMapper = {
    [(0, $8dVIb.IconType).PriorityBlocker]: (0, $7zaVw.messages).priority_blocker,
    [(0, $8dVIb.IconType).PriorityCritical]: (0, $7zaVw.messages).priority_critical,
    [(0, $8dVIb.IconType).PriorityHigh]: (0, $7zaVw.messages).priority_high,
    [(0, $8dVIb.IconType).PriorityHighest]: (0, $7zaVw.messages).priority_highest,
    [(0, $8dVIb.IconType).PriorityLow]: (0, $7zaVw.messages).priority_low,
    [(0, $8dVIb.IconType).PriorityLowest]: (0, $7zaVw.messages).priority_lowest,
    [(0, $8dVIb.IconType).PriorityMajor]: (0, $7zaVw.messages).priority_major,
    [(0, $8dVIb.IconType).PriorityMedium]: (0, $7zaVw.messages).priority_medium,
    [(0, $8dVIb.IconType).PriorityMinor]: (0, $7zaVw.messages).priority_minor,
    [(0, $8dVIb.IconType).PriorityTrivial]: (0, $7zaVw.messages).priority_trivial,
    [(0, $8dVIb.IconType).PriorityUndefined]: (0, $7zaVw.messages).priority_undefined
};
const $aab9f19acb0d3ec1$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $aab9f19acb0d3ec1$var$messageMapper[icon];
        if (descriptor) return (0, $fpDmE.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $aab9f19acb0d3ec1$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Hdrc.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $aab9f19acb0d3ec1$var$renderImageIcon = (url, testId)=>{
    if (url) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l5Xsv.default), {
        testId: testId,
        url: url
    });
};
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BadgeProps} BadgeProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $aab9f19acb0d3ec1$var$BadgeNew = ({ hideIcon: hideIcon = false, icon: icon, label: label, name: name, className: className, testId: testId = 'smart-element-badge', url: url })=>{
    const formattedMessageOrLabel = $aab9f19acb0d3ec1$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $aab9f19acb0d3ec1$var$renderAtlaskitIcon(icon, testId) || $aab9f19acb0d3ec1$var$renderImageIcon(url, testId);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ]),
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    "_16jlidpf _1o9zidpf _i0dl1wug _syaz1oju _vwz4idpf _s7n4nkob _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v _1jtnidpf _13t3idpf _rm9uidpf _rtqbnkob _e4kmnkob _z239nkob"
                ]),
                children: badgeIcon
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                "data-testid": `${testId}-label`,
                className: (0, $bwpsq.default)([
                    "_11c8qk37 _syaz131l _19bv1xvx _s7n4nkob"
                ]),
                children: formattedMessageOrLabel
            })
        ]
    });
};
const $aab9f19acb0d3ec1$var$Badge = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($aab9f19acb0d3ec1$var$BadgeNew, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1kJhy.default), {
        ...props
    });
};
var $aab9f19acb0d3ec1$export$2e2bcd8739ae039 = $aab9f19acb0d3ec1$var$Badge;

});
parcelRegister("9Hdrc", function(module, exports) {

$parcel$export(module.exports, "default", () => $1647af7fe5459c6c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $duwKf = parcelRequire("duwKf");

var $iRZQl = parcelRequire("iRZQl");

var $7anl7 = parcelRequire("7anl7");
var $29YN9 = parcelRequire("29YN9");

var $VSDnB = parcelRequire("VSDnB");


var $dVpJZ = parcelRequire("dVpJZ");

var $94rku = parcelRequire("94rku");

var $8dVIb = parcelRequire("8dVIb");

var $kxcRq = parcelRequire("kxcRq");






























































// prettier-ignore
const $1647af7fe5459c6c$var$importIconMapperOld = {
    [(0, $8dVIb.IconType).Archive]: ()=>(parcelRequire("4m4MY")),
    [(0, $8dVIb.IconType).Audio]: ()=>(parcelRequire("5nV2R")),
    [(0, $8dVIb.IconType).Code]: ()=>(parcelRequire("coOzc")),
    [(0, $8dVIb.IconType).Executable]: ()=>(parcelRequire("gmDdF")),
    [(0, $8dVIb.IconType).File]: ()=>(parcelRequire("ldQLy")),
    [(0, $8dVIb.IconType).Folder]: ()=>(parcelRequire("fjtI4")),
    [(0, $8dVIb.IconType).Generic]: ()=>(parcelRequire("ldQLy")),
    [(0, $8dVIb.IconType).GIF]: ()=>(parcelRequire("eogSM")),
    [(0, $8dVIb.IconType).GoogleDocs]: ()=>(parcelRequire("6q8Pr")),
    [(0, $8dVIb.IconType).GoogleForms]: ()=>(parcelRequire("3VL73")),
    [(0, $8dVIb.IconType).GoogleSheets]: ()=>(parcelRequire("bwXIZ")),
    [(0, $8dVIb.IconType).GoogleSlides]: ()=>(parcelRequire("6SoQO")),
    [(0, $8dVIb.IconType).Image]: ()=>(parcelRequire("ifmtc")),
    [(0, $8dVIb.IconType).MSExcel]: ()=>(parcelRequire("8vv4H")),
    [(0, $8dVIb.IconType).MSPowerpoint]: ()=>(parcelRequire("TZHl8")),
    [(0, $8dVIb.IconType).MSWord]: ()=>(parcelRequire("e3PhT")),
    [(0, $8dVIb.IconType).PDF]: ()=>(parcelRequire("55TA3")),
    [(0, $8dVIb.IconType).Presentation]: ()=>(parcelRequire("2t9Hh")),
    [(0, $8dVIb.IconType).Sketch]: ()=>(parcelRequire("4WgJk")),
    [(0, $8dVIb.IconType).Spreadsheet]: ()=>(parcelRequire("lb4t9")),
    [(0, $8dVIb.IconType).Template]: ()=>(parcelRequire("60qz8")),
    [(0, $8dVIb.IconType).Video]: ()=>(parcelRequire("6Y2WT")),
    // Bitbucket icons
    [(0, $8dVIb.IconType).Branch]: ()=>(parcelRequire("cAU6j")),
    [(0, $8dVIb.IconType).Commit]: ()=>(parcelRequire("bn2CC")),
    [(0, $8dVIb.IconType).Project]: ()=>Promise.resolve((parcelRequire("kFO36"))),
    [(0, $8dVIb.IconType).PullRequest]: ()=>(parcelRequire("cIR4U")),
    [(0, $8dVIb.IconType).Repo]: ()=>(parcelRequire("bbgWK")),
    // Jira icons
    [(0, $8dVIb.IconType).Bug]: ()=>(parcelRequire("jNgVH")),
    [(0, $8dVIb.IconType).Change]: ()=>(parcelRequire("hhL96")),
    [(0, $8dVIb.IconType).Epic]: ()=>(parcelRequire("9q15g")),
    [(0, $8dVIb.IconType).Incident]: ()=>(parcelRequire("14Fhu")),
    [(0, $8dVIb.IconType).Problem]: ()=>(parcelRequire("3Qygt")),
    [(0, $8dVIb.IconType).ServiceRequest]: ()=>(parcelRequire("7J5Ma")),
    [(0, $8dVIb.IconType).Story]: ()=>(parcelRequire("iErKi")),
    [(0, $8dVIb.IconType).SubTask]: ()=>(parcelRequire("kBegL")),
    [(0, $8dVIb.IconType).Task]: ()=>(parcelRequire("dqT3O")),
    // Confluence icons
    [(0, $8dVIb.IconType).LiveDocument]: ()=>(parcelRequire("dSN1f")).then(({ default: LiveDocumentIcon })=>({
                default: LiveDocumentIcon
            })),
    // Provider icons
    [(0, $8dVIb.IconType).Confluence]: ()=>Promise.resolve((parcelRequire("7anl7"))).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                default: ConfluenceIcon
            })),
    [(0, $8dVIb.IconType).Jira]: ()=>Promise.resolve((parcelRequire("29YN9"))).then(({ JiraIcon: JiraIcon })=>({
                default: JiraIcon
            })),
    // Fallback icons
    [(0, $8dVIb.IconType).Default]: ()=>Promise.resolve((parcelRequire("458iJ"))),
    [(0, $8dVIb.IconType).Error]: ()=>Promise.resolve((parcelRequire("7nnPp"))),
    [(0, $8dVIb.IconType).Forbidden]: ()=>(parcelRequire("414ys")),
    // Badge
    [(0, $8dVIb.IconType).Attachment]: ()=>(parcelRequire("kbM6l")),
    [(0, $8dVIb.IconType).CheckItem]: ()=>(parcelRequire("iiba0")),
    [(0, $8dVIb.IconType).Comment]: ()=>(parcelRequire("etExZ")),
    [(0, $8dVIb.IconType).View]: ()=>(parcelRequire("hyIrG")),
    [(0, $8dVIb.IconType).React]: ()=>(parcelRequire("h8l0B")),
    [(0, $8dVIb.IconType).Vote]: ()=>(parcelRequire("4CGRY")),
    [(0, $8dVIb.IconType).PriorityBlocker]: ()=>(parcelRequire("gMDFI")),
    [(0, $8dVIb.IconType).PriorityCritical]: ()=>(parcelRequire("4fkVg")),
    [(0, $8dVIb.IconType).PriorityHigh]: ()=>(parcelRequire("fgN6p")),
    [(0, $8dVIb.IconType).PriorityHighest]: ()=>(parcelRequire("cV2N9")),
    [(0, $8dVIb.IconType).PriorityLow]: ()=>(parcelRequire("eVavM")),
    [(0, $8dVIb.IconType).PriorityLowest]: ()=>(parcelRequire("56RVo")),
    [(0, $8dVIb.IconType).PriorityMajor]: ()=>(parcelRequire("ktXnL")),
    [(0, $8dVIb.IconType).PriorityMedium]: ()=>(parcelRequire("9mM5H")),
    [(0, $8dVIb.IconType).PriorityMinor]: ()=>(parcelRequire("1O0Re")),
    [(0, $8dVIb.IconType).PriorityTrivial]: ()=>(parcelRequire("lGGho")),
    [(0, $8dVIb.IconType).PriorityUndefined]: ()=>Promise.resolve((parcelRequire("7QGmb"))),
    [(0, $8dVIb.IconType).ProgrammingLanguage]: ()=>(parcelRequire("7Hzmn")),
    [(0, $8dVIb.IconType).Subscriber]: ()=>Promise.resolve((parcelRequire("h8cgU"))),
    [(0, $8dVIb.IconType).SubTasksProgress]: ()=>(parcelRequire("jZ8wH"))
};
const $1647af7fe5459c6c$var$getIconImportFn = (icon, size)=>{
    if ((0, $VSDnB.fg)('platform-smart-card-icon-migration')) {
        const item = (0, $kxcRq.getLazyIcons)()[icon];
        if ((0, $kxcRq.isIconSizeLarge)(size) && item?.large) return item.large;
        return item?.default;
    }
    return $1647af7fe5459c6c$var$importIconMapperOld[icon];
};
const $1647af7fe5459c6c$var$importIcon = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $1647af7fe5459c6c$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId, size: size = (0, $8dVIb.SmartLinkSize).Medium })=>{
    const DocumentIcon = (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? (0, $94rku.default) : (0, (/*@__PURE__*/$parcel$interopDefault($duwKf)));
    const BlogIcon = (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? (0, $dVpJZ.default) : (0, $iRZQl.default);
    // Check for synchonously loaded icons first for SSR purposes
    switch(icon){
        case (0, $8dVIb.IconType).Document:
            return /*#__PURE__*/ (0, $2OMIu.jsx)(DocumentIcon, {
                label: label || 'document',
                testId: testId,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
                    size: size
                }
            });
        case (0, $8dVIb.IconType).Blog:
            return /*#__PURE__*/ (0, $2OMIu.jsx)(BlogIcon, {
                label: label || 'blog',
                testId: testId,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
                    size: size
                }
            });
    }
    const importFn = $1647af7fe5459c6c$var$getIconImportFn(icon, size);
    if (!importFn) return null;
    const ImportedIcon = $1647af7fe5459c6c$var$importIcon(importFn);
    switch(icon){
        case (0, $8dVIb.IconType).Confluence:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7anl7.ConfluenceIcon), {
                appearance: "brand",
                testId: testId,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
                    size: size === (0, $8dVIb.SmartLinkSize).Large ? 'small' : 'xsmall'
                }
            });
        case (0, $8dVIb.IconType).Jira:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $29YN9.JiraIcon), {
                appearance: "brand",
                testId: testId,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
                    size: size === (0, $8dVIb.SmartLinkSize).Large ? 'small' : 'xsmall'
                }
            });
        case (0, $8dVIb.IconType).Error:
        case (0, $8dVIb.IconType).Forbidden:
            return /*#__PURE__*/ (0, $2OMIu.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') ? {
                    size: size,
                    color: "var(--ds-icon-danger, #C9372C)"
                } : {
                    primaryColor: `var(--ds-icon-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`
                }
            });
        default:
            return /*#__PURE__*/ (0, $2OMIu.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
                    size: size
                }
            });
    }
};
var $1647af7fe5459c6c$export$2e2bcd8739ae039 = $1647af7fe5459c6c$var$AtlaskitIcon;

});
parcelRegister("60qz8", function(module, exports) {

let $45f7598832a79dac$var$load = (parcelRequire("28QjX"))(4);
module.exports = $45f7598832a79dac$var$load("dtoNN").then(()=>parcelRequire('53J27'));

});

parcelRegister("414ys", function(module, exports) {

let $2ecac9e0a8f149c4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2ecac9e0a8f149c4$var$load("j1srk").then(()=>parcelRequire('gs7PQ'));

});

parcelRegister("kbM6l", function(module, exports) {

let $eb2a25a65dcb50b4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eb2a25a65dcb50b4$var$load("gWXGh").then(()=>parcelRequire('j3Vfq'));

});

parcelRegister("iiba0", function(module, exports) {

let $d51290a7bc53dd95$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d51290a7bc53dd95$var$load("geqFV").then(()=>parcelRequire('imUQY'));

});

parcelRegister("etExZ", function(module, exports) {

let $a8a339f19c570aad$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a8a339f19c570aad$var$load("a5nLi").then(()=>parcelRequire('DBbS0'));

});

parcelRegister("hyIrG", function(module, exports) {

let $cc881699a67c12c9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cc881699a67c12c9$var$load("97YHa").then(()=>parcelRequire('bH0nF'));

});

parcelRegister("h8l0B", function(module, exports) {

let $c7937af0943f4fdc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c7937af0943f4fdc$var$load("cj5mx").then(()=>parcelRequire('kxkv9'));

});

parcelRegister("4CGRY", function(module, exports) {

let $35dbf7027bf16f47$var$load = (parcelRequire("28QjX"))(4);
module.exports = $35dbf7027bf16f47$var$load("7SKVs").then(()=>parcelRequire('kAObg'));

});

parcelRegister("7Hzmn", function(module, exports) {

let $59b7fa4a04481570$var$load = (parcelRequire("28QjX"))(4);
module.exports = $59b7fa4a04481570$var$load("iY2wN").then(()=>parcelRequire('c2JK5'));

});

parcelRegister("jZ8wH", function(module, exports) {

let $e8ca53f8b2e599bd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e8ca53f8b2e599bd$var$load("10dT8").then(()=>parcelRequire('gKopa'));

});


parcelRegister("l5Xsv", function(module, exports) {

$parcel$export(module.exports, "default", () => $951590e808a48e01$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bmnhy = parcelRequire("bmnhy");

var $VSDnB = parcelRequire("VSDnB");

var $gU02S = parcelRequire("gU02S");
const $951590e808a48e01$var$ImageIcon = ({ defaultIcon: defaultIcon, testId: testId, url: url, width: width, height: height, onError: onError, onLoad: onLoad })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bmnhy))), {
        src: url,
        ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') ? {
            loading: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeletonNew), {
                testId: `${testId}-loading`,
                width: width,
                height: height
            }),
            loaded: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
                src: url,
                "data-testid": `${testId}-image`,
                alt: "",
                style: {
                    width: width,
                    height: height
                }
            })
        } : {
            loading: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeletonOld), {
                testId: `${testId}-loading`
            }),
            // eslint-disable-next-line jsx-a11y/alt-text
            loaded: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
                src: url,
                "data-testid": `${testId}-image`
            })
        },
        errored: defaultIcon,
        onError: onError,
        onLoad: onLoad
    });
var $951590e808a48e01$export$2e2bcd8739ae039 = $951590e808a48e01$var$ImageIcon;

});
parcelRegister("bmnhy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8453cf1ee7ef4644$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5uXOq = parcelRequire("5uXOq");
var $8453cf1ee7ef4644$var$React = $8453cf1ee7ef4644$var$_interopRequireWildcard($5uXOq);
function $8453cf1ee7ef4644$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $8453cf1ee7ef4644$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8453cf1ee7ef4644$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8453cf1ee7ef4644$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $8453cf1ee7ef4644$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $8453cf1ee7ef4644$var$loaded() {
    return {
        isLoaded: true
    };
}
function $8453cf1ee7ef4644$var$errored() {
    return {
        isErrored: true
    };
}
function $8453cf1ee7ef4644$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $8453cf1ee7ef4644$var$ImageRenderer = function(_React$Component) {
    $8453cf1ee7ef4644$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $8453cf1ee7ef4644$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $8453cf1ee7ef4644$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($8453cf1ee7ef4644$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($8453cf1ee7ef4644$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $8453cf1ee7ef4644$var$_possibleConstructorReturn(_this, _ret);
    }
    $8453cf1ee7ef4644$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($8453cf1ee7ef4644$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($8453cf1ee7ef4644$var$hasPropsChanged(this.props, nextProps)) this.setState($8453cf1ee7ef4644$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($8453cf1ee7ef4644$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($8453cf1ee7ef4644$var$React.Component);
module.exports.default = $8453cf1ee7ef4644$var$ImageRenderer;

});

parcelRegister("gU02S", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeletonNew", () => $880176eb12ae8419$export$4c64943f69fac55);
$parcel$export(module.exports, "LoadingSkeletonOld", () => $880176eb12ae8419$export$c2c783ba34989c94);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $3dyog = parcelRequire("3dyog");
const $880176eb12ae8419$var$animationNameStyles = null;
const $880176eb12ae8419$var$loadingSkeletonStyle = null;
const $880176eb12ae8419$export$4c64943f69fac55 = ({ testId: testId, width: width, height: height })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        style: {
            width: width,
            height: height
        },
        className: (0, $bwpsq.default)([
            "_2rkoyh40 _uiztglyw _bfhk178v _1itk1bc0 _12vemgnk _1lrw6rms _1e0c1o8l _5sag9cwz _1o51q7pw _tip812c5 _j7hqqkar _1pglp3kn"
        ])
    });
};
const $880176eb12ae8419$export$c2c783ba34989c94 = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($880176eb12ae8419$export$4c64943f69fac55, {
        ...props,
        width: `${props.width}rem`,
        height: `${props.height}rem`
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3dyog.default), {
        ...props
    });
};

});
parcelRegister("3dyog", function(module, exports) {

$parcel$export(module.exports, "default", () => $d24ff00886e1b58d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
const $d24ff00886e1b58d$var$LoadingSkeletonOld = ({ testId: testId, width: width, height: height })=>{
    const animationNameStyles = (0, $f8Sb3.keyframes)({
        '0%': {
            backgroundPosition: '50% 0'
        },
        '100%': {
            backgroundPosition: '-50% 0'
        }
    });
    const styles = /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${width}rem`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${height}rem`,
        borderRadius: '2px',
        userSelect: 'none',
        background: "var(--ds-skeleton-subtle, #f6f7f8)",
        backgroundImage: `linear-gradient( to right, transparent 0%, ${"var(--ds-skeleton, #edeef1)"} 20%, transparent 40%, transparent 100% )`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '280% 100%',
        display: 'inline-block',
        animationDuration: '1s',
        animationFillMode: 'forwards',
        animationIterationCount: 'infinite',
        animationName: animationNameStyles,
        animationTimingFunction: 'linear'
    });
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- needs dynamic css
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: styles,
        "data-testid": testId
    });
};
var $d24ff00886e1b58d$export$2e2bcd8739ae039 = $d24ff00886e1b58d$var$LoadingSkeletonOld;

});



parcelRegister("1kJhy", function(module, exports) {

$parcel$export(module.exports, "default", () => $df5b3b8cae34beeb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $9Hdrc = parcelRequire("9Hdrc");

var $l5Xsv = parcelRequire("l5Xsv");

var $fpDmE = parcelRequire("fpDmE");
function $df5b3b8cae34beeb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $df5b3b8cae34beeb$var$badgeStyles = {
    name: "9qxyko",
    styles: "align-items:center;display:inline-flex;min-width:fit-content"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $df5b3b8cae34beeb$var$iconStyles = /*#__PURE__*/ (0, $f8Sb3.css)("color:var(--ds-icon-subtle, #626F86);line-height:0;vertical-align:middle;", (0, $fpDmE.getIconSizeStyles)('1rem'), " img,span,svg{line-height:0;vertical-align:middle;}");
const $df5b3b8cae34beeb$var$labelStyles = {
    name: "1nnoqpd",
    styles: "color:var(--ds-text-subtlest, #626F86);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-025, 0.125rem);vertical-align:middle"
};
const $df5b3b8cae34beeb$var$messageMapper = {
    [(0, $8dVIb.IconType).PriorityBlocker]: (0, $7zaVw.messages).priority_blocker,
    [(0, $8dVIb.IconType).PriorityCritical]: (0, $7zaVw.messages).priority_critical,
    [(0, $8dVIb.IconType).PriorityHigh]: (0, $7zaVw.messages).priority_high,
    [(0, $8dVIb.IconType).PriorityHighest]: (0, $7zaVw.messages).priority_highest,
    [(0, $8dVIb.IconType).PriorityLow]: (0, $7zaVw.messages).priority_low,
    [(0, $8dVIb.IconType).PriorityLowest]: (0, $7zaVw.messages).priority_lowest,
    [(0, $8dVIb.IconType).PriorityMajor]: (0, $7zaVw.messages).priority_major,
    [(0, $8dVIb.IconType).PriorityMedium]: (0, $7zaVw.messages).priority_medium,
    [(0, $8dVIb.IconType).PriorityMinor]: (0, $7zaVw.messages).priority_minor,
    [(0, $8dVIb.IconType).PriorityTrivial]: (0, $7zaVw.messages).priority_trivial,
    [(0, $8dVIb.IconType).PriorityUndefined]: (0, $7zaVw.messages).priority_undefined
};
const $df5b3b8cae34beeb$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $df5b3b8cae34beeb$var$messageMapper[icon];
        if (descriptor) return (0, $fpDmE.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $df5b3b8cae34beeb$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9Hdrc.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $df5b3b8cae34beeb$var$renderImageIcon = (url, testId)=>{
    if (url) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $l5Xsv.default), {
        testId: testId,
        url: url
    });
};
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BadgeProps} BadgeProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $df5b3b8cae34beeb$var$BadgeOld = ({ hideIcon: hideIcon = false, icon: icon, label: label, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-badge', url: url })=>{
    const formattedMessageOrLabel = $df5b3b8cae34beeb$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $df5b3b8cae34beeb$var$renderAtlaskitIcon(icon, testId) || $df5b3b8cae34beeb$var$renderImageIcon(url, testId);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $df5b3b8cae34beeb$var$badgeStyles,
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId
    }, !hideIcon && /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $df5b3b8cae34beeb$var$iconStyles
    }, badgeIcon), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $df5b3b8cae34beeb$var$labelStyles,
        "data-testid": `${testId}-label`
    }, formattedMessageOrLabel));
};
var $df5b3b8cae34beeb$export$2e2bcd8739ae039 = $df5b3b8cae34beeb$var$BadgeOld;

});


parcelRegister("bWpL0", function(module, exports) {

$parcel$export(module.exports, "default", () => $66a4f7878d6976fe$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $j7anB = parcelRequire("j7anB");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $VSDnB = parcelRequire("VSDnB");

var $7zaVw = parcelRequire("7zaVw");

var $ZlqLB = parcelRequire("ZlqLB");
const $66a4f7878d6976fe$var$styles = null;
const $66a4f7878d6976fe$var$typeToDescriptorMap = {
    created: {
        relative: (0, $7zaVw.messages).created_on_relative,
        absolute: (0, $7zaVw.messages).created_on_absolute
    },
    modified: {
        relative: (0, $7zaVw.messages).modified_on_relative,
        absolute: (0, $7zaVw.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $7zaVw.messages).sent_on_relative,
        absolute: (0, $7zaVw.messages).sent_on_absolute
    }
};
/**
 * A base element that displays an ISO Timestamp in text.
 * @internal
 * @param {DateTimeProps} DateTimeProps - The props necessary for the DateTime element.
 * @see CreatedOn
 * @see ModifiedOn
 * @see SentOn
 */ const $66a4f7878d6976fe$var$DateTimeNew = ({ date: date, name: name, className: className, type: type, testId: testId = 'smart-element-date-time', text: text })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $koVbs.default)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $j7anB.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_11c8qk37 _1reo15vq _18m915vq _syaz131l _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k1j6v",
            className
        ]),
        children: text ? `${text} ${context}` : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$66a4f7878d6976fe$var$typeToDescriptorMap[type][typeVariant],
            values: {
                context: context
            }
        })
    });
};
const $66a4f7878d6976fe$var$DateTime = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($66a4f7878d6976fe$var$DateTimeNew, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ZlqLB.default), {
        ...props
    });
};
var $66a4f7878d6976fe$export$2e2bcd8739ae039 = $66a4f7878d6976fe$var$DateTime;

});
parcelRegister("ZlqLB", function(module, exports) {

$parcel$export(module.exports, "default", () => $a687fe7433e69a06$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $j7anB = parcelRequire("j7anB");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $7zaVw = parcelRequire("7zaVw");

var $fpDmE = parcelRequire("fpDmE");
const $a687fe7433e69a06$var$styles = /*#__PURE__*/ (0, $f8Sb3.css)("color:var(--ds-text-subtlest, #626F86);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $fpDmE.getTruncateStyles)(1));
const $a687fe7433e69a06$var$typeToDescriptorMap = {
    created: {
        relative: (0, $7zaVw.messages).created_on_relative,
        absolute: (0, $7zaVw.messages).created_on_absolute
    },
    modified: {
        relative: (0, $7zaVw.messages).modified_on_relative,
        absolute: (0, $7zaVw.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $7zaVw.messages).sent_on_relative,
        absolute: (0, $7zaVw.messages).sent_on_absolute
    }
};
/**
 * A base element that displays an ISO Timestamp in text.
 * @internal
 * @param {DateTimeProps} DateTimeProps - The props necessary for the DateTime element.
 * @see CreatedOn
 * @see ModifiedOn
 * @see SentOn
 */ const $a687fe7433e69a06$var$DateTimeOld = ({ date: date, name: name, overrideCss: overrideCss, type: type, testId: testId = 'smart-element-date-time', text: text })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $koVbs.default)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $j7anB.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $a687fe7433e69a06$var$styles,
            overrideCss
        ],
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId
    }, text ? `${text} ${context}` : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), {
        ...$a687fe7433e69a06$var$typeToDescriptorMap[type][typeVariant],
        values: {
            context: context
        }
    }));
};
var $a687fe7433e69a06$export$2e2bcd8739ae039 = $a687fe7433e69a06$var$DateTimeOld;

});


parcelRegister("aWyvu", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6c193b1fc074556$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jOyH3 = parcelRequire("jOyH3");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $8dVIb = parcelRequire("8dVIb");

var $9Hdrc = parcelRequire("9Hdrc");

var $l5Xsv = parcelRequire("l5Xsv");

var $fpDmE = parcelRequire("fpDmE");

var $geoxn = parcelRequire("geoxn");
const $d6c193b1fc074556$var$styles = {
    iconWrapperStyle: "_1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $d6c193b1fc074556$var$positionStyleMap = {
    center: "_1wpz1h6o",
    top: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wpz1y6m"
};
const $d6c193b1fc074556$var$iconStylesMapOld = {
    xlarge: "_16jlidpf _1o9zidpf _i0dl1wug _4t3iviql _1tkeviql _c71lviql _1bsbviql _1ul9viql _p12fviql _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7viql _1xjxviql _1752viql _qci8viql _15izviql _erubviql _19l3viql _1pr2viql _1u5tviql _mezjviql _e2ooviql _w8l5viql _1rg2viql _q7cvviql _xwbjviql _rtysviql _b8nkviql _4x20viql",
    large: "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1k8s _1tke1k8s _c71l1k8s _1bsb1k8s _1ul91k8s _p12f1k8s _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71k8s _1xjx1k8s _17521k8s _qci81k8s _15iz1k8s _erub1k8s _19l31k8s _1pr21k8s _1u5t1k8s _mezj1k8s _e2oo1k8s _w8l51k8s _1rg21k8s _q7cv1k8s _xwbj1k8s _rtys1k8s _b8nk1k8s _4x201k8s",
    medium: "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v",
    small: "_16jlidpf _1o9zidpf _i0dl1wug _4t3ioqnp _1tkeoqnp _c71loqnp _1bsboqnp _1ul9oqnp _p12foqnp _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7oqnp _1xjxoqnp _1752oqnp _qci8oqnp _15izoqnp _eruboqnp _19l3oqnp _1pr2oqnp _1u5toqnp _mezjoqnp _e2oooqnp _w8l5oqnp _1rg2oqnp _q7cvoqnp _xwbjoqnp _rtysoqnp _b8nkoqnp _4x20oqnp"
};
const $d6c193b1fc074556$var$customRenderStyleMapOld = {
    xlarge: "_1reo15vq _18m915vq _1e0ccj1k _1nmz1hna _1yyjkb7n _vwz4viql _1wybviql _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102kviql",
    large: "_1reo15vq _18m915vq _1e0ccj1k _1nmz1hna _1yyjkb7n _vwz41k8s _1wyb1k8s _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102k1k8s",
    medium: "_1reo15vq _18m915vq _1e0ccj1k _1nmz1hna _1yyjkb7n _vwz41j6v _1wyb1j6v _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102k1j6v",
    small: "_1reo15vq _18m915vq _1e0ccj1k _1nmz1hna _1yyjkb7n _vwz4oqnp _1wyboqnp _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102koqnp"
};
const $d6c193b1fc074556$var$customRenderStyleMapNew = {
    xlarge: "_1reo15vq _18m915vq _11c81p5s _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102kz42d",
    large: "_1reo15vq _18m915vq _11c81p5s _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102kz42d",
    medium: "_1reo15vq _18m915vq _11c81bk4 _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102kptym",
    small: "_1reo15vq _18m915vq _11c81bk4 _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102kptym"
};
const $d6c193b1fc074556$var$renderAtlaskitIcon = (icon, testId, size = (0, $8dVIb.SmartLinkSize).Medium)=>{
    if (icon) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Hdrc.default), {
        icon: icon,
        testId: `${testId}-icon`,
        ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
            size: size
        }
    });
};
const $d6c193b1fc074556$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
        label: label,
        testId: `${testId}-default`,
        color: "currentColor"
    });
const $d6c193b1fc074556$var$renderImageIcon = (defaultIcon, url, testId, size = (0, $8dVIb.SmartLinkSize).Medium)=>{
    const width = size === (0, $8dVIb.SmartLinkSize).Large ? "var(--ds-space-300, 24px)" : "var(--ds-space-200, 16px)";
    if (url) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l5Xsv.default), {
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
            width: width,
            height: width
        }
    });
};
/**
 * A base element that displays an Icon or favicon.
 * @internal
 * @param {IconProps} IconProps - The props necessary for the Icon element.
 * @see LinkIcon
 */ const $d6c193b1fc074556$var$IconNew = ({ icon: icon, overrideIcon: overrideIcon, label: label = 'Link', name: name, position: position = (0, $8dVIb.SmartLinkPosition).Top, className: className, render: render, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url })=>{
    const element = (0, $5uXOq.useMemo)(()=>{
        const defaultIcon = $d6c193b1fc074556$var$renderDefaultIcon(label, testId);
        return overrideIcon || render?.() || $d6c193b1fc074556$var$renderImageIcon(defaultIcon, url, testId, (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? size : undefined) || $d6c193b1fc074556$var$renderAtlaskitIcon(icon, testId, (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? size : undefined) || defaultIcon;
    }, [
        overrideIcon,
        icon,
        label,
        render,
        testId,
        url,
        size
    ]);
    const width = (0, $fpDmE.getIconWidth)(size);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-smart-card-icon-migration') && $d6c193b1fc074556$var$iconStylesMapOld[size],
            !(0, $VSDnB.fg)('platform-smart-card-icon-migration') && $d6c193b1fc074556$var$positionStyleMap[position],
            render && !(0, $VSDnB.fg)('platform-smart-card-icon-migration') && $d6c193b1fc074556$var$customRenderStyleMapOld[size],
            render && (0, $VSDnB.fg)('platform-smart-card-icon-migration') && $d6c193b1fc074556$var$customRenderStyleMapNew[size],
            className
        ]),
        children: (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: $d6c193b1fc074556$var$styles.iconWrapperStyle,
            style: {
                width: width,
                height: width
            },
            children: element
        }) : element
    });
};
const $d6c193b1fc074556$var$Icon = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($d6c193b1fc074556$var$IconNew, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $geoxn.default), {
        ...props
    });
};
var $d6c193b1fc074556$export$2e2bcd8739ae039 = $d6c193b1fc074556$var$Icon;

});
parcelRegister("geoxn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c230573e4b66542a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $jOyH3 = parcelRequire("jOyH3");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $8dVIb = parcelRequire("8dVIb");

var $9Hdrc = parcelRequire("9Hdrc");

var $l5Xsv = parcelRequire("l5Xsv");

var $fpDmE = parcelRequire("fpDmE");
function $c230573e4b66542a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $c230573e4b66542a$var$_ref = {
    name: "1xpq7g4",
    styles: "align-self:flex-start;margin:0"
};
var $c230573e4b66542a$var$_ref2 = {
    name: "qbt5ty",
    styles: "align-self:center"
};
const $c230573e4b66542a$var$getPositionStyles = (position)=>{
    switch(position){
        case (0, $8dVIb.SmartLinkPosition).Center:
            return $c230573e4b66542a$var$_ref2;
        case (0, $8dVIb.SmartLinkPosition).Top:
        default:
            return $c230573e4b66542a$var$_ref;
    }
};
const $c230573e4b66542a$var$getIconStyles = (position, width)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $f8Sb3.css)($c230573e4b66542a$var$getPositionStyles(position), (0, $fpDmE.getIconSizeStyles)(width));
const $c230573e4b66542a$var$getCustomRenderStyles = (value)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $f8Sb3.css)((0, $fpDmE.getTruncateStyles)(1, value), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
        lineHeight: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: value,
        textAlign: 'center',
        textOverflow: 'clip',
        WebkitBoxOrient: 'unset',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        span: {
            margin: 0,
            padding: 0,
            verticalAlign: 'baseline'
        }
    });
const $c230573e4b66542a$var$renderAtlaskitIcon = (icon, testId, size = (0, $8dVIb.SmartLinkSize).Medium)=>{
    if (icon) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9Hdrc.default), {
        icon: icon,
        testId: `${testId}-icon`,
        ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
            size: size
        }
    });
};
const $c230573e4b66542a$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
        label: label,
        testId: `${testId}-default`,
        color: "currentColor"
    });
const $c230573e4b66542a$var$renderImageIcon = (defaultIcon, url, testId, size = (0, $8dVIb.SmartLinkSize).Medium)=>{
    const width = size === (0, $8dVIb.SmartLinkSize).Large ? "var(--ds-space-300, 24px)" : "var(--ds-space-200, 16px)";
    if (url) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $l5Xsv.default), {
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
            width: width,
            height: width
        }
    });
};
/**
 * A base element that displays an Icon or favicon.
 * @internal
 * @param {IconProps} IconProps - The props necessary for the Icon element.
 * @see LinkIcon
 */ const $c230573e4b66542a$var$IconOld = ({ icon: icon, overrideIcon: overrideIcon, label: label = 'Link', name: name, position: position = (0, $8dVIb.SmartLinkPosition).Top, overrideCss: overrideCss, render: render, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url })=>{
    const element = (0, $5uXOq.useMemo)(()=>{
        const defaultIcon = $c230573e4b66542a$var$renderDefaultIcon(label, testId);
        return overrideIcon || render?.() || $c230573e4b66542a$var$renderImageIcon(defaultIcon, url, testId, (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? size : undefined) || $c230573e4b66542a$var$renderAtlaskitIcon(icon, testId, (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? size : undefined) || defaultIcon;
    }, [
        overrideIcon,
        icon,
        label,
        render,
        testId,
        url,
        size
    ]);
    const width = (0, $fpDmE.getIconWidth)(size);
    const styles = $c230573e4b66542a$var$getIconStyles(position, width);
    const renderStyles = render ? $c230573e4b66542a$var$getCustomRenderStyles(width) : undefined;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- needs dynamic css
            !(0, $VSDnB.fg)('platform-smart-card-icon-migration') && styles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- needs dynamic css
            renderStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- needs dynamic css
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId
    }, (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
        xcss: $c230573e4b66542a$var$iconWrapperStyle,
        style: {
            width: width,
            height: width
        }
    }, element) : element);
};
const $c230573e4b66542a$var$iconWrapperStyle = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
var $c230573e4b66542a$export$2e2bcd8739ae039 = $c230573e4b66542a$var$IconOld;

});


parcelRegister("3dV67", function(module, exports) {

$parcel$export(module.exports, "default", () => $b60bb11df77d728a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $3bDjY = parcelRequire("3bDjY");

var $8dVIb = parcelRequire("8dVIb");

var $4URMI = parcelRequire("4URMI");

var $fpDmE = parcelRequire("fpDmE");

var $4xtGh = parcelRequire("4xtGh");
const $b60bb11df77d728a$var$DEFAULT_MAX_LINES = 2;
const $b60bb11df77d728a$var$MAXIMUM_MAX_LINES = 2;
const $b60bb11df77d728a$var$MINIMUM_MAX_LINES = 1;
const $b60bb11df77d728a$var$containerStyles = null;
const $b60bb11df77d728a$var$getMaxLines = (maxLines)=>{
    if (maxLines > $b60bb11df77d728a$var$MAXIMUM_MAX_LINES) return $b60bb11df77d728a$var$DEFAULT_MAX_LINES;
    if (maxLines < $b60bb11df77d728a$var$MINIMUM_MAX_LINES) return $b60bb11df77d728a$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $b60bb11df77d728a$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span",
        children: trigger
    });
const $b60bb11df77d728a$var$linkStyleSizeMap = {
    xlarge: "_11c8o0gd _k48pi7a9 _vwz41k8s",
    large: "_11c81oud _k48pi7a9 _vwz41j6v",
    medium: "_11c81oud _k48pi7a9 _vwz41j6v",
    small: "_11c8qk37 _k48pi7a9 _vwz41j6v"
};
const $b60bb11df77d728a$var$baseAnchorStyle = null;
const $b60bb11df77d728a$var$workBreakStyleMap = {
    true: "_1nmz1hna",
    false: "_1nmz9jpi"
};
const $b60bb11df77d728a$var$anchorConstantsStyles = null;
const $b60bb11df77d728a$var$anchorLineClampMap = {
    1: "_1yyjkb7n",
    2: "_1yyjcs5v"
};
const $b60bb11df77d728a$var$anchorLinkLineHeight1Map = {
    xlarge: "_102k1k8s",
    large: "_102k1j6v",
    medium: "_102k1j6v",
    small: "_102k1j6v"
};
const $b60bb11df77d728a$var$anchorLinkLineHeight2Map = {
    xlarge: "_102k1wto",
    large: "_102kviql",
    medium: "_102kviql",
    small: "_102kviql"
};
const $b60bb11df77d728a$var$themeStyleMap = {
    grey: "_fjv618uv _93u918uv _g2lk18uv _pnzf18uv _hlwq8stv _1e2m8stv _1l4b8stv _ue8d8stv _yni7nqa1 _1bianqa1 _93jhnqa1 _64n6nqa1 _1ray131l _dlb7131l _rnxt131l _1h4d131l _10ueqk37 _ye10131l",
    black: "_syaz1gjq _9oik18uv _1bnx8stv _jf4cnqa1 _30l31gjq _9h8h1fxt",
    link: "_syaz14q2 _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};
/**
 * A base element that represent an anchor.
 * @internal
 * @param {LinkProps} LinkProps - The props necessary for the Link element.
 * @see LinkIcon
 */ const $b60bb11df77d728a$var$LinkNew = ({ hideTooltip: hideTooltip, maxLines: maxLines = $b60bb11df77d728a$var$DEFAULT_MAX_LINES, name: name, className: className, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $8dVIb.SmartLinkTheme).Link, url: url, onClick: onClick, target: target = '_blank' })=>{
    const onMouseDown = (0, $4URMI.useMouseDownEvent)();
    const hasSpace = (0, $5uXOq.useMemo)(()=>text ? (0, $fpDmE.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onMouseDown: onMouseDown,
        href: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug",
            $b60bb11df77d728a$var$linkStyleSizeMap[size],
            $b60bb11df77d728a$var$anchorLineClampMap[$b60bb11df77d728a$var$getMaxLines(maxLines)],
            "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _sudp1e54",
            $b60bb11df77d728a$var$workBreakStyleMap[hasSpace ? 'true' : 'false'],
            $b60bb11df77d728a$var$getMaxLines(maxLines) === 1 && $b60bb11df77d728a$var$anchorLinkLineHeight1Map[size],
            $b60bb11df77d728a$var$getMaxLines(maxLines) === 2 && $b60bb11df77d728a$var$anchorLinkLineHeight2Map[size],
            $b60bb11df77d728a$var$themeStyleMap[theme],
            className
        ]),
        ...target !== '_self' && {
            target: target
        },
        children: text
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug"
        ]),
        children: hideTooltip || text === undefined ? anchor : $b60bb11df77d728a$var$withTooltip(anchor, text, testId)
    });
};
const $b60bb11df77d728a$var$Link = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($b60bb11df77d728a$var$LinkNew, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4xtGh.default), {
        ...props
    });
};
var $b60bb11df77d728a$export$2e2bcd8739ae039 = $b60bb11df77d728a$var$Link;

});
parcelRegister("4URMI", function(module, exports) {

$parcel$export(module.exports, "useLinkClicked", () => $0d5ea96be37e2b5d$export$5993d3ca6c85f774);
$parcel$export(module.exports, "useMouseDownEvent", () => $0d5ea96be37e2b5d$export$df67f318ded0283c);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $g2eZ6 = parcelRequire("g2eZ6");
var $0d5ea96be37e2b5d$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
const $0d5ea96be37e2b5d$export$5993d3ca6c85f774 = (/**
	 * Handler to
	 */ handler, /**
	 * Filter which mouse events should trigger the link clicked event
	 */ predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((...args)=>{
        const [event] = args;
        handler?.apply(null, args);
        if (!predicate || predicate?.(event)) (0, $g2eZ6.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $0d5ea96be37e2b5d$var$isNotLeftClick = (event)=>event.button !== 0;
const $0d5ea96be37e2b5d$export$df67f318ded0283c = (onMouseDown)=>{
    return $0d5ea96be37e2b5d$export$5993d3ca6c85f774(onMouseDown, $0d5ea96be37e2b5d$var$isNotLeftClick);
};

});
parcelRegister("g2eZ6", function(module, exports) {

$parcel$export(module.exports, "fireLinkClickedEvent", () => $473b45d487f9fd1b$export$7987de3055fbdcb0);
$parcel$export(module.exports, "withLinkClickedEvent", () => $473b45d487f9fd1b$export$263352d59c0c5966);

var $5uXOq = parcelRequire("5uXOq");

var $b6uPu = parcelRequire("b6uPu");

var $4URMI = parcelRequire("4URMI");

var $fzJZi = parcelRequire("fzJZi");
const $473b45d487f9fd1b$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $473b45d487f9fd1b$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $473b45d487f9fd1b$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $473b45d487f9fd1b$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $b6uPu.browser)();
    /**
	 * If the link/parent is content editable then left click won't have typical effect
	 */ if ($473b45d487f9fd1b$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $473b45d487f9fd1b$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $473b45d487f9fd1b$export$7fedc699766c16de = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $473b45d487f9fd1b$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $473b45d487f9fd1b$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $473b45d487f9fd1b$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    const linkClickedEventResult = $473b45d487f9fd1b$var$linkClickedEvent({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $473b45d487f9fd1b$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $473b45d487f9fd1b$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides?.attributes
            },
            nonPrivacySafeAttributes: {
                ...payload.nonPrivacySafeAttributes,
                ...overrides?.nonPrivacySafeAttributes
            }
        }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
    };
const $473b45d487f9fd1b$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $473b45d487f9fd1b$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $4URMI.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $4URMI.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$473b45d487f9fd1b$var$getDisplayName(WrappedComponent)})`;
    return Component;
}

});
parcelRegister("b6uPu", function(module, exports) {

$parcel$export(module.exports, "browser", () => $7f7209ce5c1e8d08$export$3f2684e5d7cb1006);
const $7f7209ce5c1e8d08$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $7f7209ce5c1e8d08$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $7f7209ce5c1e8d08$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $7f7209ce5c1e8d08$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $7f7209ce5c1e8d08$var$result.android = /Android \d/.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $7f7209ce5c1e8d08$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $7f7209ce5c1e8d08$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $7f7209ce5c1e8d08$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $7f7209ce5c1e8d08$export$3f2684e5d7cb1006() {
    return $7f7209ce5c1e8d08$var$result;
}

});



parcelRegister("4xtGh", function(module, exports) {

$parcel$export(module.exports, "default", () => $0435f90475b2676b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $3bDjY = parcelRequire("3bDjY");

var $8dVIb = parcelRequire("8dVIb");

var $4URMI = parcelRequire("4URMI");

var $fpDmE = parcelRequire("fpDmE");
function $0435f90475b2676b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0435f90475b2676b$var$DEFAULT_MAX_LINES = 2;
const $0435f90475b2676b$var$MAXIMUM_MAX_LINES = 2;
const $0435f90475b2676b$var$MINIMUM_MAX_LINES = 1;
const $0435f90475b2676b$var$containerStyles = {
    name: "mkkf9p",
    styles: "flex:1 1 auto"
};
var $0435f90475b2676b$var$_ref = {
    name: "16ucc2m",
    styles: "color:var(--ds-link, #0C66E4);:active{color:var(--ds-link-pressed, #0055CC);}:hover{color:var(--ds-link, #0C66E4);text-decoration:underline;}"
};
var $0435f90475b2676b$var$_ref2 = {
    name: "1glvof",
    styles: "color:var(--ds-text-subtle, #44546F);:active{color:var(--ds-text, #172B4D);}:hover{color:var(--ds-text-subtle, #44546F);text-decoration:underline;}"
};
var $0435f90475b2676b$var$_ref3 = {
    name: "izk992",
    styles: "a&{color:var(--ds-text-subtlest, #626F86);&:active, &:visited, &:focus, &:hover{color:var(--ds-text-subtlest, #626F86);text-decoration:underline;}font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);}"
};
const $0435f90475b2676b$var$getThemeStyles = (theme)=>{
    switch(theme){
        case (0, $8dVIb.SmartLinkInternalTheme).Grey:
            // We are being specifc with the CSS selectors to ensure that Confluence overrides
            // do not affect our internal Smart Card styles
            return $0435f90475b2676b$var$_ref3;
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        case (0, $8dVIb.SmartLinkTheme).Black:
            return $0435f90475b2676b$var$_ref2;
        case (0, $8dVIb.SmartLinkTheme).Link:
        default:
            return $0435f90475b2676b$var$_ref;
    }
};
const $0435f90475b2676b$var$getAnchorStyles = (size, theme, maxLines, hasSpace)=>{
    const sizeStyles = (0, $fpDmE.getLinkSizeStyles)(size);
    return /*#__PURE__*/ (0, $f8Sb3.css)("flex:1 1 auto;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    sizeStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $fpDmE.getTruncateStyles)(maxLines, (0, $fpDmE.getLinkLineHeight)(size), hasSpace ? 'break-word' : 'break-all'), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $0435f90475b2676b$var$getThemeStyles(theme));
};
const $0435f90475b2676b$var$getMaxLines = (maxLines)=>{
    if (maxLines > $0435f90475b2676b$var$MAXIMUM_MAX_LINES) return $0435f90475b2676b$var$DEFAULT_MAX_LINES;
    if (maxLines < $0435f90475b2676b$var$MINIMUM_MAX_LINES) return $0435f90475b2676b$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $0435f90475b2676b$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span"
    }, trigger);
/**
 * A base element that represent an anchor.
 * @internal
 * @param {LinkProps} LinkProps - The props necessary for the Link element.
 * @see LinkIcon
 */ const $0435f90475b2676b$var$LinkOld = ({ hideTooltip: hideTooltip, maxLines: maxLines = $0435f90475b2676b$var$DEFAULT_MAX_LINES, name: name, overrideCss: overrideCss, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $8dVIb.SmartLinkTheme).Link, url: url, onClick: onClick, target: target = '_blank' })=>{
    const onMouseDown = (0, $4URMI.useMouseDownEvent)();
    const hasSpace = (0, $5uXOq.useMemo)(()=>text ? (0, $fpDmE.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, $f8Sb3.jsx)("a", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $0435f90475b2676b$var$getAnchorStyles(size, theme, $0435f90475b2676b$var$getMaxLines(maxLines), hasSpace),
            overrideCss
        ],
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onMouseDown: onMouseDown,
        href: url,
        ...target !== '_self' && {
            target: target
        }
    }, text);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $0435f90475b2676b$var$containerStyles
    }, hideTooltip || text === undefined ? anchor : $0435f90475b2676b$var$withTooltip(anchor, text, testId));
};
var $0435f90475b2676b$export$2e2bcd8739ae039 = $0435f90475b2676b$var$LinkOld;

});


parcelRegister("cJxXG", function(module, exports) {

$parcel$export(module.exports, "default", () => $af9c30eaf441ad65$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lj8SI = parcelRequire("lj8SI");

var $VSDnB = parcelRequire("VSDnB");

var $Nh1XU = parcelRequire("Nh1XU");

var $a4DH1 = parcelRequire("a4DH1");

var $8jSB6 = parcelRequire("8jSB6");
const $af9c30eaf441ad65$var$styles = null;
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {LozengeProps} LozengeProps - The props necessary for the Lozenge element.
 * @see State
 */ const $af9c30eaf441ad65$var$LozengeNew = ({ action: action, appearance: appearance = 'default', name: name, className: className, style: style, text: text, testId: testId = 'smart-element-lozenge' })=>{
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a4DH1.default), {
        action: action,
        appearance: appearance,
        testId: testId,
        text: text,
        zIndex: ui?.zIndex
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lj8SI.default), {
        appearance: appearance,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        testId: `${testId}-lozenge`,
        children: text
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1e0c116y _vwz41kw7",
            className
        ]),
        children: lozenge
    });
};
const $af9c30eaf441ad65$var$Lozenge = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($af9c30eaf441ad65$var$LozengeNew, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8jSB6.default), {
        ...props
    });
};
var $af9c30eaf441ad65$export$2e2bcd8739ae039 = $af9c30eaf441ad65$var$Lozenge;

});
parcelRegister("a4DH1", function(module, exports) {

$parcel$export(module.exports, "default", () => $27ceba18caf6f022$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $BLPHT = parcelRequire("BLPHT");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $dlJZx = parcelRequire("dlJZx");

var $3q2sI = parcelRequire("3q2sI");

var $euMlu = parcelRequire("euMlu");

var $f22ja = parcelRequire("f22ja");

var $gDUps = parcelRequire("gDUps");

var $fzJZi = parcelRequire("fzJZi");

var $cLKee = parcelRequire("cLKee");

var $dMzTJ = parcelRequire("dMzTJ");

var $j6VJk = parcelRequire("j6VJk");

var $1s0lY = parcelRequire("1s0lY");

var $kf01E = parcelRequire("kf01E");

var $4Dg4o = parcelRequire("4Dg4o");
const $27ceba18caf6f022$var$validateItems = (items = [], text)=>{
    return items.filter((item)=>item.text !== text);
};
const $27ceba18caf6f022$var$LozengeAction = ({ action: action, appearance: appearance, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex })=>{
    const [selected, setSelected] = (0, $5uXOq.useState)({
        appearance: appearance,
        text: text
    });
    const [isLoaded, setIsLoaded] = (0, $5uXOq.useState)(false);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [items, setItems] = (0, $5uXOq.useState)();
    const [errorMessage, setErrorMessage] = (0, $5uXOq.useState)();
    const reload = (0, $f22ja.default)();
    const invoke = (0, $3q2sI.default)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        setSelected({
            text: text,
            appearance: appearance
        });
    }, [
        text,
        appearance
    ]);
    const { url: url, id: linkId, invokePreviewAction: invokePreviewAction } = action?.update?.details || {};
    const handleOpenChange = (0, $5uXOq.useCallback)(async (args)=>{
        setIsOpen(args.isOpen);
        if (args.isOpen) {
            fireEvent('ui.button.clicked.smartLinkStatusLozenge', {});
            fireEvent('track.smartLinkQuickAction.started', {
                smartLinkActionType: (0, $fzJZi.TrackQuickActionType).StatusUpdate
            });
            if (!isLoaded && action?.read) try {
                setIsLoading(true);
                const responseItems = await invoke(action.read, (0, $dlJZx.default));
                const validItems = typeof text === 'string' ? $27ceba18caf6f022$var$validateItems(responseItems, text) : responseItems;
                setItems(validItems);
                setIsLoaded(true);
                if (validItems?.length === 0) {
                    fireEvent('track.smartLinkQuickAction.failed', (0, $dMzTJ.permissionLoadErrorAnalyticsPayload));
                    setErrorMessage((0, $VSDnB.fg)('confluence-issue-terminology-refresh') ? (0, $1s0lY.LozengeActionErrorMessages).noDataIssueTermRefresh : (0, $1s0lY.LozengeActionErrorMessages).noData);
                    setIsLoaded(false);
                }
            } catch (err) {
                setErrorMessage((0, $1s0lY.LozengeActionErrorMessages).unknown);
                setIsLoaded(false);
                fireEvent('track.smartLinkQuickAction.failed', (0, $dMzTJ.unknownLoadErrorAnalyticsPayload));
            } finally{
                setIsLoading(false);
            }
        }
        if (!args.isOpen) setErrorMessage(undefined);
    }, [
        action.read,
        invoke,
        isLoaded,
        text,
        fireEvent
    ]);
    const trigger = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4Dg4o.default), {
            ...props,
            appearance: selected.appearance,
            isOpen: isOpen,
            testId: testId,
            text: selected.text
        }), [
        selected.appearance,
        selected.text,
        isOpen,
        testId
    ]);
    const handleItemClick = (0, $5uXOq.useCallback)(async (id, text, appearance)=>{
        try {
            fireEvent('ui.button.clicked.smartLinkStatusListItem', {});
            const updateAction = action?.update;
            if (updateAction && id) {
                setIsLoading(true);
                const request = (0, $gDUps.default)(updateAction, id);
                await invoke(request);
                setSelected({
                    appearance: appearance,
                    text: text
                });
                setIsLoading(false);
                setIsLoaded(false);
                setIsOpen(false);
                setItems([]);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: (0, $fzJZi.TrackQuickActionType).StatusUpdate
                });
                if (url) await reload(url, true, undefined, linkId);
            }
        } catch (err) {
            setIsLoading(false);
            if ((0, $euMlu.isInvokeCustomError)(err)) {
                setErrorMessage(err.message);
                fireEvent('track.smartLinkQuickAction.failed', (0, $dMzTJ.validationUpdateErrorAnalyticsPayload));
            } else {
                setErrorMessage((0, $1s0lY.LozengeActionErrorMessages).updateFailed);
                fireEvent('track.smartLinkQuickAction.failed', (0, $dMzTJ.unknownUpdateErrorAnalyticsPayload));
            }
        }
    }, [
        action?.update,
        invoke,
        linkId,
        reload,
        url,
        fireEvent
    ]);
    const dropdownItemGroup = (0, $5uXOq.useMemo)(()=>{
        if (errorMessage) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j6VJk.default), {
            errorMessage: errorMessage,
            testId: testId,
            url: url,
            invokePreviewAction: invokePreviewAction
        });
        if (items && items.length > 0) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kf01E.default), {
            testId: testId,
            items: items,
            onClick: handleItemClick
        });
    }, [
        errorMessage,
        handleItemClick,
        items,
        invokePreviewAction,
        testId,
        url
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $BLPHT.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        testId: testId,
        trigger: trigger,
        zIndex: zIndex,
        children: dropdownItemGroup
    });
};
var $27ceba18caf6f022$export$2e2bcd8739ae039 = (0, $cLKee.default)($27ceba18caf6f022$var$LozengeAction);

});
parcelRegister("dlJZx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eaacaffc693a3ec$export$2e2bcd8739ae039);
const $6eaacaffc693a3ec$var$extractLozengeActionItems = (response)=>{
    const items = response?.transitions?.map(({ appearance: appearance, id: id, name: name })=>({
            appearance: appearance ?? 'default',
            id: id,
            text: name
        })) ?? [];
    return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
var $6eaacaffc693a3ec$export$2e2bcd8739ae039 = $6eaacaffc693a3ec$var$extractLozengeActionItems;

});

parcelRegister("3q2sI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5a60e7c58b54588$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iiAnG = parcelRequire("iiAnG");

var $051X7 = parcelRequire("051X7");
const $f5a60e7c58b54588$var$useInvoke = ()=>{
    const { connections: connections } = (0, $051X7.useSmartLinkContext)();
    const clientExt = (0, $iiAnG.useSmartLinkClientExtension)(connections.client);
    return (0, $5uXOq.useCallback)(async (req, cb)=>{
        const response = await clientExt.invoke(req);
        return cb ? cb(response) : response;
    }, [
        clientExt
    ]);
};
var $f5a60e7c58b54588$export$2e2bcd8739ae039 = $f5a60e7c58b54588$var$useInvoke;

});
parcelRegister("iiAnG", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkClientExtension", () => $ffb669da1b6b71e8$export$303ede4eed148855);

var $5uXOq = parcelRequire("5uXOq");

var $dV0Jy = parcelRequire("dV0Jy");

var $T540Y = parcelRequire("T540Y");

var $3b94d = parcelRequire("3b94d");
const $ffb669da1b6b71e8$export$303ede4eed148855 = (cardClient)=>{
    const resolverUrl = (0, $3b94d.useResolverUrl)(cardClient);
    const invoke = (0, $5uXOq.useCallback)(async (data)=>{
        try {
            return await (0, $dV0Jy.request)('post', `${resolverUrl}/invoke`, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
        } catch (err) {
            // checking if the error is a Response type
            // since we already had a few HOTs caused by comparing with instanceOf',
            // we're verifying the type by the contents
            if (err && err.json && typeof err.json === 'function') {
                const errorBody = await err.json();
                if (errorBody) throw new (0, $T540Y.InvokeError)(errorBody?.error.message, errorBody?.error.status);
            }
            throw err;
        }
    }, [
        resolverUrl
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            invoke: invoke
        }), [
        invoke
    ]);
};

});
parcelRegister("T540Y", function(module, exports) {

$parcel$export(module.exports, "SmartLinkActionType", () => $171ae91e706973ef$export$6324b7946ad663e9);
$parcel$export(module.exports, "InvokeError", () => $171ae91e706973ef$export$d4d72202bff63658);
/**
 * The enum that describes Smart Link action types
 */ var $171ae91e706973ef$export$6324b7946ad663e9 = /*#__PURE__*/ function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
    return SmartLinkActionType;
}({});
class $171ae91e706973ef$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = errorCode;
    }
}

});

parcelRegister("3b94d", function(module, exports) {

$parcel$export(module.exports, "useResolverUrl", () => $eebf021c5f687360$export$d08617a365fbe694);

var $5uXOq = parcelRequire("5uXOq");

var $itO4f = parcelRequire("itO4f");
const $eebf021c5f687360$export$d08617a365fbe694 = (cardClient)=>(0, $5uXOq.useMemo)(()=>(0, $itO4f.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);

});



parcelRegister("euMlu", function(module, exports) {

$parcel$export(module.exports, "getInvokeFailureReason", () => $0ad6fedaface02c5$export$65b3f792dff0bd60);
$parcel$export(module.exports, "isInvokeCustomError", () => $0ad6fedaface02c5$export$1694272377fa07d8);

var $fzJZi = parcelRequire("fzJZi");
const $0ad6fedaface02c5$export$65b3f792dff0bd60 = (err)=>{
    if (!$0ad6fedaface02c5$export$1694272377fa07d8(err)) return (0, $fzJZi.TrackQuickActionFailureReason).UnknownError;
    switch(err?.errorCode){
        case 403:
            return (0, $fzJZi.TrackQuickActionFailureReason).PermissionError;
        default:
            return (0, $fzJZi.TrackQuickActionFailureReason).UnknownError;
    }
};
const $0ad6fedaface02c5$export$1694272377fa07d8 = (err)=>err?.message !== undefined && err?.errorCode !== undefined;

});

parcelRegister("f22ja", function(module, exports) {

$parcel$export(module.exports, "default", () => $f48b36e6e5cada34$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $051X7 = parcelRequire("051X7");

var $8dVIb = parcelRequire("8dVIb");

var $1VPdD = parcelRequire("1VPdD");

var $nb8r1 = parcelRequire("nb8r1");
const $f48b36e6e5cada34$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $051X7.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $nb8r1.default)();
    return (0, $5uXOq.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
        const { details: details } = getState()[url] || {
            status: (0, $8dVIb.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data);
        if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        else (0, $1VPdD.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $f48b36e6e5cada34$export$2e2bcd8739ae039 = $f48b36e6e5cada34$var$useResolve;

});
parcelRegister("nb8r1", function(module, exports) {

$parcel$export(module.exports, "default", () => $09545a48e55da9e9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $051X7 = parcelRequire("051X7");

var $2yPrN = parcelRequire("2yPrN");
var $kDZ6Z = parcelRequire("kDZ6Z");
var $fiKQs = parcelRequire("fiKQs");

var $8dVIb = parcelRequire("8dVIb");

var $aOsut = parcelRequire("aOsut");

const $09545a48e55da9e9$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $051X7.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $5uXOq.useCallback)((url, metadataStatus)=>{
        dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $5uXOq.useCallback)((url, error, response, isMetadataRequest)=>{
        const newState = {
            status: (0, $8dVIb.SmartLinkStatus).Pending,
            details: undefined
        };
        const { details: details } = getState()[url] || newState;
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RESOLVED), {
                url: url
            }, details));
            else {
                dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
        } else if (error.kind === 'auth') dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RESOLVED), {
            url: url
        }, (0, $aOsut.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $5uXOq.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
        //if a link resolves normally, metadata will also always be resolved
        setMetadataStatus(resourceUrl, 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $5uXOq.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $fiKQs.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $kDZ6Z.APIError)('fallback', hostname, (0, $cc6a74b99a201fc4$export$3e81ce851ffda0ad)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (!response || nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $kDZ6Z.APIError)('fatal', hostname, (0, $cc6a74b99a201fc4$export$45e7dda0d43d7f55)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $kDZ6Z.APIError)('error', hostname, (0, $cc6a74b99a201fc4$export$338f7d9ccca1975d)), response, isMetadataRequest);
            return;
        }
        /**
			 * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
			 * more info:
			 * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
			 * https://react-redux.js.org/api/batch
			 */ (0, $7nsd3.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $09545a48e55da9e9$export$2e2bcd8739ae039 = $09545a48e55da9e9$var$useResponse;

});
parcelRegister("aOsut", function(module, exports) {

$parcel$export(module.exports, "getEmptyJsonLd", () => $5dc57cbabb8840da$export$2796a804c6e44f63);
$parcel$export(module.exports, "getUnauthorizedJsonLd", () => $5dc57cbabb8840da$export$b9482e0f6d365cc7);
$parcel$export(module.exports, "getForbiddenJsonLd", () => $5dc57cbabb8840da$export$e32193033a594efb);
const $5dc57cbabb8840da$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $5dc57cbabb8840da$export$2796a804c6e44f63 = ()=>$5dc57cbabb8840da$var$emptyData;
const $5dc57cbabb8840da$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$5dc57cbabb8840da$var$emptyData
        }
    });
const $5dc57cbabb8840da$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$5dc57cbabb8840da$var$emptyData
        }
    });

});

const $cc6a74b99a201fc4$export$297c39c8b9bfca0 = 'resolving';
const $cc6a74b99a201fc4$export$b64a888338c24e0e = 'errored';
const $cc6a74b99a201fc4$export$677b6edfa0002c70 = 'fallback';
const $cc6a74b99a201fc4$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $cc6a74b99a201fc4$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $cc6a74b99a201fc4$export$338f7d9ccca1975d = 'Error resolving metadata.';



parcelRegister("gDUps", function(module, exports) {

$parcel$export(module.exports, "default", () => $66cd4b0a305f86bf$export$2e2bcd8739ae039);
const $66cd4b0a305f86bf$var$createStatusUpdateRequest = (request, id)=>({
        providerKey: request.providerKey,
        action: {
            ...request.action,
            payload: {
                newStatusId: id
            }
        }
    });
var $66cd4b0a305f86bf$export$2e2bcd8739ae039 = $66cd4b0a305f86bf$var$createStatusUpdateRequest;

});

parcelRegister("cLKee", function(module, exports) {

$parcel$export(module.exports, "default", () => $061d6f2e0c766414$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $lj8SI = parcelRequire("lj8SI");
const $061d6f2e0c766414$var$withErrorBoundary = (Component)=>(props)=>{
        const fallback = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $lj8SI.default), {
                appearance: props?.appearance,
                testId: `${props?.testId ?? 'smart-element-lozenge-action'}-fallback`,
                children: props?.text
            }), [
            props?.appearance,
            props?.testId,
            props?.text
        ]);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
            fallback: fallback,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                ...props
            })
        });
    };
var $061d6f2e0c766414$export$2e2bcd8739ae039 = $061d6f2e0c766414$var$withErrorBoundary;

});

parcelRegister("dMzTJ", function(module, exports) {

$parcel$export(module.exports, "unknownLoadErrorAnalyticsPayload", () => $bd6f9a689b54b40e$export$2a568ff99500df53);
$parcel$export(module.exports, "permissionLoadErrorAnalyticsPayload", () => $bd6f9a689b54b40e$export$2de2d0ccc17b915f);
$parcel$export(module.exports, "unknownUpdateErrorAnalyticsPayload", () => $bd6f9a689b54b40e$export$c1c05f9d51f7c467);
$parcel$export(module.exports, "validationUpdateErrorAnalyticsPayload", () => $bd6f9a689b54b40e$export$618660b8f2aa87e2);
const $bd6f9a689b54b40e$export$2a568ff99500df53 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'load'
};
const $bd6f9a689b54b40e$export$2de2d0ccc17b915f = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'PermissionError',
    step: 'load'
};
const $bd6f9a689b54b40e$export$c1c05f9d51f7c467 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'update'
};
const $bd6f9a689b54b40e$export$618660b8f2aa87e2 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'ValidationError',
    step: 'update'
};

});

parcelRegister("j6VJk", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee1a9d5bb42f1de9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $ousew = parcelRequire("ousew");

var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $dD7Zc = parcelRequire("dD7Zc");

var $VSDnB = parcelRequire("VSDnB");


var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $iPVbQ = parcelRequire("iPVbQ");

var $fpDmE = parcelRequire("fpDmE");

var $fI1Ph = parcelRequire("fI1Ph");
const $ee1a9d5bb42f1de9$var$MAX_LINE_NUMBER = 8;
const $ee1a9d5bb42f1de9$var$contentStyles = null;
const $ee1a9d5bb42f1de9$var$linkStyles = null;
const $ee1a9d5bb42f1de9$var$textStylesBase = null;
const $ee1a9d5bb42f1de9$var$dropdownItemGroupStyles = null;
const $ee1a9d5bb42f1de9$var$LozengeActionErrorNew = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $ee1a9d5bb42f1de9$var$MAX_LINE_NUMBER, invokePreviewAction: invokePreviewAction })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const invoke = (0, $iPVbQ.default)({});
    const isPreviewAvailable = invokePreviewAction !== undefined;
    const handlePreviewOpen = (0, $5uXOq.useCallback)(()=>{
        if (isPreviewAvailable) {
            fireEvent('ui.button.clicked.smartLinkStatusOpenPreview', {});
            if (invokePreviewAction) invoke(invokePreviewAction);
        }
    }, [
        isPreviewAvailable,
        invoke,
        invokePreviewAction,
        fireEvent
    ]);
    const dynamicCss = null;
    const content = (0, $5uXOq.useMemo)(()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                    className: (0, $bwpsq.default)([
                        "_zulpcxkx _11c81doa _1reo15vq _18m915vq _1e0c1txw _1ul9idpf _2lx2vrvc _19pkv77o _4cvr1y6m _pqme1oud _102e1oud _ngc01fxt _1t4p1fxt"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
                            testId: `${testId}-icon`,
                            LEGACY_size: "medium",
                            color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`,
                            LEGACY_secondaryColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
                            label: 'error',
                            spacing: "spacious"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            "data-testid": `${testId}-error-message`,
                            className: (0, $bwpsq.default)([
                                "_11c81doa _1reo15vq _18m915vq _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
                                "_1yyj1n6p _102k16q4"
                            ]),
                            style: {
                                "--_t4prqe": (0, $lD23V.default)(maxLineNumber)
                            },
                            children: typeof errorMessage === 'string' ? errorMessage : (0, $fpDmE.getFormattedMessage)(errorMessage)
                        })
                    ]
                }),
                isPreviewAvailable ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        "_zulpcxkx _1reo15vq _18m915vq _11c81oud _1e0c1txw _1ul9idpf _2lx2vrvc _4cvr1h6o _80omtlke _19pku2gc _18u0xy5q _otyrv77o"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                        target: "_blank",
                        "data-testid": `${testId}-open-embed`,
                        onClick: handlePreviewOpen,
                        children: (0, $VSDnB.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $7zaVw.messages).open_issue_in_jiraIssueTermRefresh
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $7zaVw.messages).open_issue_in_jira
                        })
                    })
                }) : null
            ]
        });
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        testId,
        dynamicCss
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": `${testId}-error-item-group`,
        className: (0, $bwpsq.default)([
            "_14hp1wdt _6pup1kw7 _1eo073ad"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aRoVz.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
                testId: `${testId}-error`,
                children: content
            })
        })
    });
};
const $ee1a9d5bb42f1de9$var$LozengeActionError = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($ee1a9d5bb42f1de9$var$LozengeActionErrorNew, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fI1Ph.default), {
        ...props
    });
};
var $ee1a9d5bb42f1de9$export$2e2bcd8739ae039 = $ee1a9d5bb42f1de9$var$LozengeActionError;

});
parcelRegister("iPVbQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a560b45251b869c0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $a1vqi = parcelRequire("a1vqi");

var $5vDFA = parcelRequire("5vDFA");

var $1VPdD = parcelRequire("1VPdD");
const $a560b45251b869c0$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $a560b45251b869c0$var$useInvokeClientAction = ({ fireEvent: fireEventProp })=>{
    const { fireEvent: defaultFireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const fireEvent = fireEventProp ?? defaultFireEvent;
    return (0, $5uXOq.useCallback)(async ({ actionSubjectId: actionSubjectId, actionType: actionType, actionFn: actionFn, definitionId: definitionId = null, extensionKey: extensionKey, display: display, id: id, resourceType: resourceType = null })=>{
        const experienceId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        $5vDFA.mark(markName, 'pending');
        try {
            // Begin UFO experience
            (0, $1VPdD.startUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            if (actionSubjectId !== undefined) fireEvent(`ui.button.clicked.${actionSubjectId}`, {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            // Invoke action
            const result = await actionFn();
            $5vDFA.mark(markName, 'resolved');
            (0, $1VPdD.succeedUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId);
            fireEvent('operational.smartLinkAction.resolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $5vDFA.getMeasure(markName, 'resolved')?.duration ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            return result;
        } catch (err) {
            $5vDFA.mark(markName, 'errored');
            (0, $1VPdD.failUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err?.message;
            fireEvent('operational.smartLinkAction.unresolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $5vDFA.getMeasure(markName, 'errored')?.duration ?? null,
                id: id ?? experienceId,
                reason: reason,
                resourceType: resourceType
            });
        }
    }, [
        fireEvent
    ]);
};
var $a560b45251b869c0$export$2e2bcd8739ae039 = $a560b45251b869c0$var$useInvokeClientAction;

});
parcelRegister("5vDFA", function(module, exports) {

$parcel$export(module.exports, "clearMarks", () => $483ef2a5b4b04745$export$1a717feb4df1a945);
$parcel$export(module.exports, "clearMeasures", () => $483ef2a5b4b04745$export$de42547d395c8271);
$parcel$export(module.exports, "getMeasure", () => $483ef2a5b4b04745$export$d6e97a903ae9a3aa);
$parcel$export(module.exports, "mark", () => $483ef2a5b4b04745$export$bf7f2fce5c1cf636);
$parcel$export(module.exports, "create", () => $483ef2a5b4b04745$export$185802fd694ee1f5);
const $483ef2a5b4b04745$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $483ef2a5b4b04745$var$hasPerformanceAPIAvailable = $483ef2a5b4b04745$var$isPerformanceAPIAvailable();
const $483ef2a5b4b04745$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $483ef2a5b4b04745$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $483ef2a5b4b04745$export$1a717feb4df1a945 = (id)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $483ef2a5b4b04745$export$de42547d395c8271 = (id)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $483ef2a5b4b04745$var$getMark = (id, status)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const name = $483ef2a5b4b04745$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $483ef2a5b4b04745$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const name = $483ef2a5b4b04745$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $483ef2a5b4b04745$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const name = $483ef2a5b4b04745$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $483ef2a5b4b04745$export$185802fd694ee1f5 = (id, status)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const name = $483ef2a5b4b04745$export$984df7f61dd7928f(id, status);
        const measure = $483ef2a5b4b04745$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $483ef2a5b4b04745$var$getMark(id, 'pending');
            const endMark = $483ef2a5b4b04745$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});


parcelRegister("fI1Ph", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b39c30f413189ec$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ousew = parcelRequire("ousew");

var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $dD7Zc = parcelRequire("dD7Zc");


var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $iPVbQ = parcelRequire("iPVbQ");

var $fpDmE = parcelRequire("fpDmE");

var $ljnlf = parcelRequire("ljnlf");
const $8b39c30f413189ec$var$MAX_LINE_NUMBER = 8;
const $8b39c30f413189ec$var$LozengeActionErrorOld = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $8b39c30f413189ec$var$MAX_LINE_NUMBER, invokePreviewAction: invokePreviewAction })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const invoke = (0, $iPVbQ.default)({});
    const isPreviewAvailable = invokePreviewAction !== undefined;
    const handlePreviewOpen = (0, $5uXOq.useCallback)(()=>{
        if (isPreviewAvailable) {
            fireEvent('ui.button.clicked.smartLinkStatusOpenPreview', {});
            if (invokePreviewAction) invoke(invokePreviewAction);
        }
    }, [
        isPreviewAvailable,
        invoke,
        invokePreviewAction,
        fireEvent
    ]);
    const content = (0, $5uXOq.useMemo)(()=>{
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: (0, $ljnlf.contentStyles)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
            testId: `${testId}-icon`,
            LEGACY_size: "medium",
            color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`,
            LEGACY_secondaryColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
            label: 'error',
            spacing: "spacious"
        }), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            css: (0, $ljnlf.textStyles)(maxLineNumber),
            "data-testid": `${testId}-error-message`
        }, typeof errorMessage === 'string' ? errorMessage : (0, $fpDmE.getFormattedMessage)(errorMessage))), isPreviewAvailable ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: (0, $ljnlf.linkStyles)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("a", {
            target: "_blank",
            "data-testid": `${testId}-open-embed`,
            onClick: handlePreviewOpen
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $7zaVw.messages).open_issue_in_jira))) : null);
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        maxLineNumber,
        testId
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: (0, $ljnlf.dropdownItemGroupStyles),
        "data-testid": `${testId}-error-item-group`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aRoVz.default), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6B7KL.default), {
        testId: `${testId}-error`
    }, content))));
};
var $8b39c30f413189ec$export$2e2bcd8739ae039 = $8b39c30f413189ec$var$LozengeActionErrorOld;

});
parcelRegister("ljnlf", function(module, exports) {

$parcel$export(module.exports, "dropdownItemGroupStyles", () => $83fdad0d8ffe5982$export$2c40d814aeff5db);
$parcel$export(module.exports, "contentStyles", () => $83fdad0d8ffe5982$export$a38ecc1ac2e6fba);
$parcel$export(module.exports, "linkStyles", () => $83fdad0d8ffe5982$export$4ea5976125a01ffa);
$parcel$export(module.exports, "textStyles", () => $83fdad0d8ffe5982$export$6a54c24d15b0f6ba);
/* eslint-disable @atlaskit/design-system/use-tokens-typography */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");


var $fpDmE = parcelRequire("fpDmE");
function $83fdad0d8ffe5982$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $83fdad0d8ffe5982$export$2c40d814aeff5db = {
    name: "a7m7l8",
    styles: "button{width:220px;&:hover{background-color:inherit;cursor:default;}}"
};
const $83fdad0d8ffe5982$var$sharedBlockStyles = {
    name: "gx0rja",
    styles: "display:flex;gap:var(--ds-space-100, 0.5rem);line-height:1rem;min-width:0;overflow:hidden;flex-direction:row;align-items:center"
};
const $83fdad0d8ffe5982$export$a38ecc1ac2e6fba = /*#__PURE__*/ (0, $f8Sb3.css)($83fdad0d8ffe5982$var$sharedBlockStyles, {
    marginTop: "var(--ds-space-025, 2px)",
    alignItems: 'flex-start',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> span, > div': {
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`
    }
});
const $83fdad0d8ffe5982$export$4ea5976125a01ffa = /*#__PURE__*/ (0, $f8Sb3.css)($83fdad0d8ffe5982$var$sharedBlockStyles, "cursor:pointer;font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-top:var(--ds-space-100, 8px);margin-left:var(--ds-space-400, 32px);margin-bottom:var(--ds-space-025, 2px);");
const $83fdad0d8ffe5982$export$6a54c24d15b0f6ba = (maxLines)=>/*#__PURE__*/ (0, $f8Sb3.css)("line-height:1rem;white-space:normal;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $fpDmE.getTruncateStyles)(maxLines));

});



parcelRegister("1s0lY", function(module, exports) {

$parcel$export(module.exports, "LozengeActionErrorMessages", () => $47c640bee30204cc$export$4f2e371a667ad688);

var $7zaVw = parcelRequire("7zaVw");
const $47c640bee30204cc$export$4f2e371a667ad688 = {
    noData: {
        descriptor: (0, $7zaVw.messages)['status_change_permission_error']
    },
    noDataIssueTermRefresh: {
        descriptor: (0, $7zaVw.messages)['status_change_permission_errorIssueTermRefresh']
    },
    unknown: {
        descriptor: (0, $7zaVw.messages)['status_change_load_error']
    },
    updateFailed: {
        descriptor: (0, $7zaVw.messages)['status_change_update_error']
    }
};

});

parcelRegister("kf01E", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a0af43cfe2e114d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aRoVz = parcelRequire("aRoVz");

var $VSDnB = parcelRequire("VSDnB");

var $hgsSZ = parcelRequire("hgsSZ");

var $aNsD1 = parcelRequire("aNsD1");
const $9a0af43cfe2e114d$var$dropdownItemGroupStyles = null;
const $9a0af43cfe2e114d$var$LozengeActionItemsGroupNew = ({ items: items, testId: testId, onClick: onClick })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": `${testId}-item-group`,
        className: (0, $bwpsq.default)([
            "_c71l1mjv _18m91wug _1pv01r31 _1m1b1r31 _qh55glyw _lt2aglyw _ph3k1o36 _1twe1o36 _1ll7166n _qprf166n _n6y8usvi _109gusvi _z29hu4to _wlxpu4to _1gfl12x7 _yhjmutpp _1gqn12x7 _11lvutpp _d4lf1f4h _14hp1wdt _6pup1kw7"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aRoVz.default), {
            children: items.map((item, idx)=>/*#__PURE__*/ (0, $5uXOq.createElement)((0, $hgsSZ.default), {
                    ...item,
                    key: idx,
                    onClick: onClick,
                    testId: `${testId}-item-${idx}`
                }))
        })
    });
const $9a0af43cfe2e114d$var$LozengeActionItemsGroup = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($9a0af43cfe2e114d$var$LozengeActionItemsGroupNew, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aNsD1.default), {
        ...props
    });
};
var $9a0af43cfe2e114d$export$2e2bcd8739ae039 = $9a0af43cfe2e114d$var$LozengeActionItemsGroup;

});
parcelRegister("hgsSZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $419e60cbfb62c454$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $lj8SI = parcelRequire("lj8SI");
const $419e60cbfb62c454$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        // Prevent dropdown to close on select item.
        // We want to show loading screen.
        e.stopPropagation();
        if (onClick) onClick(id, text, appearance);
    }, [
        appearance,
        id,
        onClick,
        text
    ]);
    const handleMouseEnter = (0, $5uXOq.useCallback)((e)=>{
        e.currentTarget?.firstElementChild?.focus();
    }, []);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        onMouseEnter: handleMouseEnter,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
            onClick: handleClick,
            testId: testId,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lj8SI.default), {
                appearance: appearance,
                children: text
            })
        })
    }));
};
var $419e60cbfb62c454$export$2e2bcd8739ae039 = $419e60cbfb62c454$var$LozengeActionItem;

});

parcelRegister("aNsD1", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8780db38fed84f1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $aRoVz = parcelRequire("aRoVz");

var $hgsSZ = parcelRequire("hgsSZ");

var $3UpeD = parcelRequire("3UpeD");
const $b8780db38fed84f1$var$LozengeActionItemsGroupOld = ({ items: items, testId: testId, onClick: onClick })=>// eslint-disable-next-line @atlaskit/design-system/prefer-primitives, @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: (0, $3UpeD.dropdownItemGroupStyles),
        "data-testid": `${testId}-item-group`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aRoVz.default), null, items.map((item, idx)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $hgsSZ.default), {
            ...item,
            key: idx,
            onClick: onClick,
            testId: `${testId}-item-${idx}`
        }))));
var $b8780db38fed84f1$export$2e2bcd8739ae039 = $b8780db38fed84f1$var$LozengeActionItemsGroupOld;

});
parcelRegister("3UpeD", function(module, exports) {

$parcel$export(module.exports, "triggerButtonStyles", () => $c3acfc8ed6aa38b4$export$ae858546f0bfd05c);
$parcel$export(module.exports, "triggerLozengeStyles", () => $c3acfc8ed6aa38b4$export$5717c7336384f3a6);
$parcel$export(module.exports, "dropdownItemGroupStyles", () => $c3acfc8ed6aa38b4$export$2c40d814aeff5db);
/* eslint-disable @atlaskit/design-system/use-tokens-typography */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $c3acfc8ed6aa38b4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c3acfc8ed6aa38b4$export$ae858546f0bfd05c = /*#__PURE__*/ (0, $f8Sb3.css)({
    all: 'unset',
    backgroundColor: 'transparent',
    color: 'unset',
    cursor: 'pointer',
    fontFamily: 'unset',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'unset',
    fontStyle: 'unset',
    fontWeight: 'unset',
    fontVariant: 'unset',
    lineHeight: 0,
    padding: 0,
    textTransform: 'unset',
    border: '2px solid transparent',
    margin: "var(--ds-space-025, 2px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&:focus-visible, &:focus-within, &[aria-expanded='true']": {
        outline: 'none',
        boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #388BFF)"}`,
        borderRadius: '5px'
    }
});
const $c3acfc8ed6aa38b4$export$5717c7336384f3a6 = {
    name: "1vr7vmn",
    styles: "align-items:center;display:flex"
};
const $c3acfc8ed6aa38b4$export$2c40d814aeff5db = /*#__PURE__*/ (0, $f8Sb3.css)({
    maxHeight: '300px',
    overflowY: 'auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    button: {
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
        minHeight: '28px',
        width: '220px',
        '&:hover': {
            backgroundColor: 'inherit'
        },
        '&:focus, &:focus-visible': {
            backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
            boxSizing: 'border-box',
            boxShadow: `inset 2px 0 0 ${"var(--ds-border-selected, #0C66E4)"}`,
            outline: 'none'
        }
    }
});

});



parcelRegister("4Dg4o", function(module, exports) {

$parcel$export(module.exports, "default", () => $afa61527cd4f792e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $c8Oei = parcelRequire("c8Oei");

var $lj8SI = parcelRequire("lj8SI");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $gqJFZ = parcelRequire("gqJFZ");
const $afa61527cd4f792e$var$styles = {
    chevronDown: "_18u012x7 _1e0c1txw"
};
const $afa61527cd4f792e$var$triggerLozengeStyles = null;
const $afa61527cd4f792e$var$triggerButtonStyles = null;
const $afa61527cd4f792e$var$LozengeActionTriggerNew = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const [isBold, setIsBold] = (0, $5uXOq.useState)(false);
    const onMouseEnter = (0, $5uXOq.useCallback)(()=>setIsBold(true), []);
    const onMouseLeave = (0, $5uXOq.useCallback)(()=>setIsBold(false), []);
    const lozenge = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $lj8SI.default), {
            appearance: appearance,
            isBold: isBold,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
                className: (0, $bwpsq.default)([
                    "_4cvr1h6o _1e0c1txw"
                ]),
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        children: text
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        as: "span",
                        xcss: $afa61527cd4f792e$var$styles.chevronDown,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
                            color: "currentColor",
                            label: "options",
                            LEGACY_size: "medium",
                            LEGACY_margin: "-4px -8px -4px -7px"
                        })
                    })
                ]
            })
        }), [
        appearance,
        isBold,
        text
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
        type: "button",
        ...props,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: triggerRef,
        className: (0, $bwpsq.default)([
            "_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vhn7od _1dqonqa1 _189eyh40 _1h6d3acm _bfhk18uv _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas14y2 _19h614y2 _1d3914y2 _1ejj1vm4 _1u6l1vm4 _6ssh1vm4"
        ]),
        children: lozenge
    });
};
const $afa61527cd4f792e$var$LozengeActionTrigger = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($afa61527cd4f792e$var$LozengeActionTriggerNew, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gqJFZ.default), {
        ...props
    });
};
var $afa61527cd4f792e$export$2e2bcd8739ae039 = $afa61527cd4f792e$var$LozengeActionTrigger;

});
parcelRegister("gqJFZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1dd9ec02fe2ecb0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $c8Oei = parcelRequire("c8Oei");

var $lj8SI = parcelRequire("lj8SI");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3UpeD = parcelRequire("3UpeD");
const $c1dd9ec02fe2ecb0$var$chevronDownStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.075',
    display: 'flex'
});
const $c1dd9ec02fe2ecb0$var$LozengeActionTriggerOld = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const [isBold, setIsBold] = (0, $5uXOq.useState)(false);
    const onMouseEnter = (0, $5uXOq.useCallback)(()=>setIsBold(true), []);
    const onMouseLeave = (0, $5uXOq.useCallback)(()=>setIsBold(false), []);
    const lozenge = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $lj8SI.default), {
            appearance: appearance,
            isBold: isBold
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            css: (0, $3UpeD.triggerLozengeStyles)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", null, text), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
            as: "span",
            xcss: $c1dd9ec02fe2ecb0$var$chevronDownStyles
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
            color: "currentColor",
            label: "options",
            LEGACY_size: "medium",
            LEGACY_margin: "-4px -8px -4px -7px"
        })))), [
        appearance,
        isBold,
        text
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        type: "button",
        ...props,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $3UpeD.triggerButtonStyles),
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: triggerRef
    }, lozenge);
};
var $c1dd9ec02fe2ecb0$export$2e2bcd8739ae039 = $c1dd9ec02fe2ecb0$var$LozengeActionTriggerOld;

});



parcelRegister("8jSB6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab09cc0f4f9f380e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $lj8SI = parcelRequire("lj8SI");

var $Nh1XU = parcelRequire("Nh1XU");

var $a4DH1 = parcelRequire("a4DH1");
function $ab09cc0f4f9f380e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ab09cc0f4f9f380e$var$styles = {
    name: "cvfhjc",
    styles: "display:inline-flex;line-height:inherit"
};
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {LozengeProps} LozengeProps - The props necessary for the Lozenge element.
 * @see State
 */ const $ab09cc0f4f9f380e$var$LozengeOld = ({ action: action, appearance: appearance = 'default', name: name, overrideCss: overrideCss, style: style, text: text, testId: testId = 'smart-element-lozenge' })=>{
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $a4DH1.default), {
        action: action,
        appearance: appearance,
        testId: testId,
        text: text,
        zIndex: ui?.zIndex
    }) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $lj8SI.default), {
        appearance: appearance,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        testId: `${testId}-lozenge`
    }, text);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $ab09cc0f4f9f380e$var$styles,
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId
    }, lozenge);
};
var $ab09cc0f4f9f380e$export$2e2bcd8739ae039 = $ab09cc0f4f9f380e$var$LozengeOld;

});


parcelRegister("77cM6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a723b9f793426daa$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $l5Xsv = parcelRequire("l5Xsv");

var $1cbPc = parcelRequire("1cbPc");
/**
 * Media: Image
 * [aspect-ratio: 16 / 9] The context box is fixed to aspect ratio of 16:9.
 * [object-fit: cover] The replaced content is sized to maintain
 * its aspect ratio while filling the element's entire content box.
 * If the object's aspect ratio does not match the aspect ratio of its box,
 * then the object will be clipped to fit.
 * [object-position] Center alignment of the selected replaced element's
 * contents within the element's box.
 */ const $a723b9f793426daa$var$styles = null;
/**
 * A base element that displays a Media.
 * @internal
 * @param {MediaProps} MediaProps - The props necessary for the Media element.
 * @see Preview
 */ const $a723b9f793426daa$var$MediaNew = ({ name: name, className: className, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    if (!type || !url) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1h1tcq2i _1e0c1txw _1bsb1osq _4t3i1ns9 _jqez1osq _1lg71osq _6slq1osq _x1m21osq _1chb1osq _1usb1osq _5c331osq _l9z01osq _6o691dfr _vr2g1dfr _173baqso _1niwaqso _t0h9stnw _1ulbstnw _byj21ooe _3hvr1ooe _1c0s1ssb _15j31ssb _1npy1ssb _19he1ssb _n3vc1wug _1qj91wug _4fdy1wug _18cv1wug _1aoq15vq _1iqz15vq _6fioj63w _l0jmidpf _12zuh2mm",
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l5Xsv.default), {
            testId: `${testId}-image`,
            url: url,
            onError: onError,
            onLoad: onLoad,
            defaultIcon: null
        })
    });
};
const $a723b9f793426daa$var$Media = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($a723b9f793426daa$var$MediaNew, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1cbPc.default), {
        ...props
    });
};
var $a723b9f793426daa$export$2e2bcd8739ae039 = $a723b9f793426daa$var$Media;

});
parcelRegister("1cbPc", function(module, exports) {

$parcel$export(module.exports, "default", () => $251e79e250945c39$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $l5Xsv = parcelRequire("l5Xsv");
function $251e79e250945c39$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Media: Image
 * [aspect-ratio: 16 / 9] The context box is fixed to aspect ratio of 16:9.
 * [object-fit: cover] The replaced content is sized to maintain
 * its aspect ratio while filling the element's entire content box.
 * If the object's aspect ratio does not match the aspect ratio of its box,
 * then the object will be clipped to fit.
 * [object-position] Center alignment of the selected replaced element's
 * contents within the element's box.
 */ const $251e79e250945c39$var$styles = {
    name: "a50hvv",
    styles: "aspect-ratio:16 / 9;display:flex;width:100%;height:fit-content;@supports not (aspect-ratio: auto){padding-top:56.25%;height:0;position:relative;overflow:hidden;}> img, > span{min-height:100%;min-width:100%;max-height:100%;max-width:100%;object-fit:cover;object-position:center center;@supports not (aspect-ratio: auto){position:absolute;transform:translate(-50%, -50%);left:50%;top:50%;width:auto;height:auto;}}"
};
/**
 * A base element that displays a Media.
 * @internal
 * @param {MediaProps} MediaProps - The props necessary for the Media element.
 * @see Preview
 */ const $251e79e250945c39$var$MediaOld = ({ name: name, overrideCss: overrideCss, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    if (!type || !url) return null;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $251e79e250945c39$var$styles,
            overrideCss
        ],
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $l5Xsv.default), {
        testId: `${testId}-image`,
        url: url,
        onError: onError,
        onLoad: onLoad,
        defaultIcon: null
    }));
};
var $251e79e250945c39$export$2e2bcd8739ae039 = $251e79e250945c39$var$MediaOld;

});


parcelRegister("k39kU", function(module, exports) {

$parcel$export(module.exports, "default", () => $af078338fe34f0f5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $VSDnB = parcelRequire("VSDnB");

var $fpDmE = parcelRequire("fpDmE");

var $8dVhN = parcelRequire("8dVhN");
const $af078338fe34f0f5$var$baseStyle = null;
/**
 * A base element that displays some Text.
 * @internal
 * @param {TextProps} TextProps - The props necessary for the Text element.
 * @see Title
 */ const $af078338fe34f0f5$var$TextNew = ({ content: content, maxLines: maxLines = 1, message: message, name: name, className: className, testId: testId = 'smart-element-text' })=>{
    if (!message && !content) return null;
    const dynamicCss = null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_11c8qk37 _1reo15vq _18m915vq _syaz131l _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
            "_1yyjr31u _102k1dud",
            className
        ]),
        style: {
            "--_1erfju8": (0, $lD23V.default)(maxLines)
        },
        children: (0, $fpDmE.getFormattedMessage)(message) || content
    });
};
const $af078338fe34f0f5$var$Text = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($af078338fe34f0f5$var$TextNew, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8dVhN.default), {
        ...props
    });
};
var $af078338fe34f0f5$export$2e2bcd8739ae039 = $af078338fe34f0f5$var$Text;

});
parcelRegister("8dVhN", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8b7388e8498db33$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $fpDmE = parcelRequire("fpDmE");
const $c8b7388e8498db33$var$getStyles = (maxLines)=>/*#__PURE__*/ (0, $f8Sb3.css)("color:var(--ds-text-subtlest, #626F86);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);white-space:normal;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $fpDmE.getTruncateStyles)(maxLines));
/**
 * A base element that displays some Text.
 * @internal
 * @param {TextProps} TextProps - The props necessary for the Text element.
 * @see Title
 */ const $c8b7388e8498db33$var$TextOld = ({ content: content, maxLines: maxLines = 1, message: message, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-text' })=>{
    if (!message && !content) return null;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $c8b7388e8498db33$var$getStyles(maxLines),
            overrideCss
        ],
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId
    }, (0, $fpDmE.getFormattedMessage)(message) || content);
};
var $c8b7388e8498db33$export$2e2bcd8739ae039 = $c8b7388e8498db33$var$TextOld;

});



parcelRegister("kDhrr", function(module, exports) {

$parcel$export(module.exports, "default", () => $5972a7cc25546c87$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $77cM6 = parcelRequire("77cM6");
const $5972a7cc25546c87$var$Preview = (props)=>{
    const { overrideUrl: overrideUrl, ...rest } = props ?? {};
    const context = (0, $5uXOq.useContext)((0, $Nh1XU.FlexibleUiContext));
    const data = overrideUrl ? {
        url: overrideUrl,
        type: (0, $8dVIb.MediaType).Image
    } : context?.preview;
    if (!data) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $77cM6.default), {
        ...rest,
        ...data
    });
};
var $5972a7cc25546c87$export$2e2bcd8739ae039 = $5972a7cc25546c87$var$Preview;

});

parcelRegister("kp8aU", function(module, exports) {

$parcel$export(module.exports, "default", () => $673e9555bded0d05$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $Nh1XU = parcelRequire("Nh1XU");

var $k39kU = parcelRequire("k39kU");

var $jDX3T = parcelRequire("jDX3T");
const $673e9555bded0d05$var$SNIPPET_DEFAULT_MAX_LINES = 3;
const $673e9555bded0d05$var$snippetBaseStyle = null;
const $673e9555bded0d05$var$SnippetElementNew = ({ content: overrideContent, maxLines: maxLines = $673e9555bded0d05$var$SNIPPET_DEFAULT_MAX_LINES, className: className, ...props } = {})=>{
    const context = (0, $5uXOq.useContext)((0, $Nh1XU.FlexibleUiContext));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k39kU.default), {
        content: overrideContent ?? context?.snippet,
        maxLines: maxLines,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_syaz1fxt _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        ...props
    });
};
const $673e9555bded0d05$var$SnippetElement = (props = {})=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($673e9555bded0d05$var$SnippetElementNew, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jDX3T.default), {
        ...props
    });
};
var $673e9555bded0d05$export$2e2bcd8739ae039 = $673e9555bded0d05$var$SnippetElement;

});
parcelRegister("jDX3T", function(module, exports) {

$parcel$export(module.exports, "default", () => $65dab0752ce7d537$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $Nh1XU = parcelRequire("Nh1XU");

var $k39kU = parcelRequire("k39kU");
const $65dab0752ce7d537$var$SNIPPET_DEFAULT_MAX_LINES = 3;
const $65dab0752ce7d537$var$getSnippetStyles = (overrideCss)=>/*#__PURE__*/ (0, $f8Sb3.css)("color:var(--ds-text, #172B4D);-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    overrideCss);
const $65dab0752ce7d537$var$SnippetElementOld = ({ content: overrideContent, maxLines: maxLines = $65dab0752ce7d537$var$SNIPPET_DEFAULT_MAX_LINES, overrideCss: overrideCss, ...props } = {})=>{
    const context = (0, $5uXOq.useContext)((0, $Nh1XU.FlexibleUiContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $k39kU.default), {
        content: overrideContent ?? context?.snippet,
        maxLines: maxLines,
        overrideCss: $65dab0752ce7d537$var$getSnippetStyles(overrideCss),
        ...props
    });
};
var $65dab0752ce7d537$export$2e2bcd8739ae039 = $65dab0752ce7d537$var$SnippetElementOld;

});



parcelRegister("bubxq", function(module, exports) {

$parcel$export(module.exports, "default", () => $66554651c27d9387$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");

var $gKZoD = parcelRequire("gKZoD");

var $ldJSL = parcelRequire("ldJSL");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");

var $bJeNF = parcelRequire("bJeNF");

var $VSDnB = parcelRequire("VSDnB");

var $3bDjY = parcelRequire("3bDjY");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $fpDmE = parcelRequire("fpDmE");

var $akF1x = parcelRequire("akF1x");

var $3Zm9O = parcelRequire("3Zm9O");

var $fFcX8 = parcelRequire("fFcX8");
const $66554651c27d9387$var$styles = null;
const $66554651c27d9387$var$renderActionItems = (items = [], size = (0, $8dVIb.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Zm9O.default), {
            item: item,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        }, idx));
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $66554651c27d9387$var$ActionGroupNew = ({ items: items = [], size: size = (0, $8dVIb.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange })=>{
    (0, $gKZoD.di)((0, $BLPHT.default));
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const renderableActionItems = (0, $5uXOq.useMemo)(()=>(0, $akF1x.filterActionItems)(items, context), [
        context,
        items
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const onOpenChange = (0, $5uXOq.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $5uXOq.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $5uXOq.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $66554651c27d9387$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum
    ]);
    const moreActionDropdown = (0, $5uXOq.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const spacing = (0, $fpDmE.sizeToButtonSpacing)[size];
            const moreIcon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                label: "more",
                color: "currentColor"
            });
            const formatMessage = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).more_actions
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $BLPHT.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                            ...props,
                            spacing: spacing,
                            testId: "action-group-more-button",
                            iconBefore: moreIcon,
                            ref: triggerRef
                        })
                    }),
                testId: "action-group-dropdown",
                zIndex: ui?.zIndex,
                children: $66554651c27d9387$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick)
            });
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui?.zIndex,
        visibleButtonsNum
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_1e0c116y _vwz41j6v _dzc21h6o _1ilq1i6y",
            "actions-button-group"
        ]),
        "data-action-open": isOpen,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ldJSL.default), {
            children: [
                actionButtons,
                moreActionDropdown
            ]
        })
    }) : null;
};
const $66554651c27d9387$var$ActionGroup = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($66554651c27d9387$var$ActionGroupNew, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fFcX8.default), {
        ...props
    });
};
var $66554651c27d9387$export$2e2bcd8739ae039 = $66554651c27d9387$var$ActionGroup;

});
parcelRegister("bJeNF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::384f31b6891d11603b1a7b84cc388cca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $889f60aca54b55ef$var$_react = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $889f60aca54b55ef$var$_showMoreHorizontal = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("8U6zd")));

var $889f60aca54b55ef$var$_more = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("3oUqw")));
function $889f60aca54b55ef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "MoreIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $889f60aca54b55ef$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $889f60aca54b55ef$var$_react.default.createElement($889f60aca54b55ef$var$_showMoreHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $889f60aca54b55ef$var$_more.default
    }, props));
$889f60aca54b55ef$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
var $889f60aca54b55ef$var$_default = module.exports.default = $889f60aca54b55ef$var$ShowMoreHorizontalIcon;

});

parcelRegister("akF1x", function(module, exports) {

$parcel$export(module.exports, "getGapSize", () => $8ba323b39584fd77$export$ff20be09ae01c52e);
$parcel$export(module.exports, "getBaseStyles", () => $8ba323b39584fd77$export$bff8031d86bb089);
$parcel$export(module.exports, "highlightRemoveStyles", () => $8ba323b39584fd77$export$1928241a6f267c0d);
$parcel$export(module.exports, "getActionGroupStyles", () => $8ba323b39584fd77$export$393b0054595c3748);
$parcel$export(module.exports, "filterActionItems", () => $8ba323b39584fd77$export$adbd04236f07a7d8);
$parcel$export(module.exports, "renderChildren", () => $8ba323b39584fd77$export$cd762ccf1a583d69);
$parcel$export(module.exports, "renderElementItems", () => $8ba323b39584fd77$export$9678d3ca18bd7526);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8dVIb = parcelRequire("8dVIb");

var $91tw3 = parcelRequire("91tw3");

var $eqoQu = parcelRequire("eqoQu");

var $bubxq = parcelRequire("bubxq");

var $1BfaB = parcelRequire("1BfaB");
function $8ba323b39584fd77$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8ba323b39584fd77$export$f942619ce67b1a41 = {
    [(0, $8dVIb.ElementName).AssignedTo]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).AssignedToGroup]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).AttachmentCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).AuthorGroup]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ChecklistProgress]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).CollaboratorGroup]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).CommentCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).CreatedBy]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).CreatedOn]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).DueOn]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).LatestCommit]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).LinkIcon]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Location]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ModifiedBy]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ModifiedOn]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).OwnedBy]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).OwnedByGroup]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Preview]: [
        'block'
    ],
    [(0, $8dVIb.ElementName).Priority]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ProgrammingLanguage]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Provider]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ReactCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ReadTime]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Snippet]: [
        'block'
    ],
    [(0, $8dVIb.ElementName).SourceBranch]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).SentOn]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).State]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).SubscriberCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).SubTasksProgress]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).StoryPoints]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).TargetBranch]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Title]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ViewCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).VoteCount]: [
        'inline'
    ]
};
var $8ba323b39584fd77$var$_ref2 = {
    name: "2rtvke",
    styles: "flex-direction:row;align-items:center"
};
var $8ba323b39584fd77$var$_ref3 = {
    name: "1ejri1g",
    styles: "flex-direction:column;align-items:flex-start"
};
const $8ba323b39584fd77$var$getDirectionStyles = (direction)=>{
    switch(direction){
        case (0, $8dVIb.SmartLinkDirection).Vertical:
            return $8ba323b39584fd77$var$_ref3;
        case (0, $8dVIb.SmartLinkDirection).Horizontal:
        default:
            return $8ba323b39584fd77$var$_ref2;
    }
};
const $8ba323b39584fd77$export$ff20be09ae01c52e = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return 1.25;
        case (0, $8dVIb.SmartLinkSize).Large:
            return 1;
        case (0, $8dVIb.SmartLinkSize).Medium:
            return 0.5;
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return 0.25;
    }
};
const $8ba323b39584fd77$export$bff8031d86bb089 = (direction, size)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        alignItems: 'center',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gap: `${$8ba323b39584fd77$export$ff20be09ae01c52e(size)}rem`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '1rem',
        minWidth: 0,
        overflow: 'hidden'
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $8ba323b39584fd77$var$getDirectionStyles(direction), "&:empty{display:none;}& > *{min-width:0;}& > [data-fit-to-content]{min-width:fit-content;}");
const $8ba323b39584fd77$export$1928241a6f267c0d = {
    name: "1klm9nt",
    styles: "outline:none!important;outline-color:inherit;color:inherit;-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none"
};
const $8ba323b39584fd77$var$isActionGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, $bubxq.default);
const $8ba323b39584fd77$var$isElementDisplayValid = (name, display)=>{
    return $8ba323b39584fd77$export$f942619ce67b1a41[name]?.includes(display) ?? false;
};
const $8ba323b39584fd77$export$f2c7ad0961800b16 = (children)=>{
    return Boolean(children.type() === null);
};
const $8ba323b39584fd77$var$isElementOrElementGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && ((0, $91tw3.isFlexibleUiElement)(node) || node.type === (0, $1BfaB.default));
var $8ba323b39584fd77$var$_ref = {
    name: "bceqwf",
    styles: "max-height:2rem"
};
const $8ba323b39584fd77$export$393b0054595c3748 = (size)=>{
    if (size === (0, $8dVIb.SmartLinkSize).XLarge) // The biggest height of the action button exceeds the max line-height
    // of the elements causing the action on the block with x-large size to
    // get cut at the bottom.
    return $8ba323b39584fd77$var$_ref;
};
const $8ba323b39584fd77$export$adbd04236f07a7d8 = (items = [], context)=>{
    return items.filter((item)=>{
        switch(item.name){
            case (0, $8dVIb.ActionName).DeleteAction:
            case (0, $8dVIb.ActionName).EditAction:
            case (0, $8dVIb.ActionName).CustomAction:
                // Named and custom actions that user defines.
                return Boolean((0, $8dVIb.ActionName)[item.name]);
            default:
                // Action that require data from the data context to render.
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
        }
    });
};
const $8ba323b39584fd77$export$cd762ccf1a583d69 = (children, size)=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (child)=>{
        if ($8ba323b39584fd77$var$isElementOrElementGroup(child) || $8ba323b39584fd77$var$isActionGroup(child)) {
            const node = child;
            const { size: childSize } = node.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(node, {
                size: childSize || size
            });
        }
        return child;
    });
const $8ba323b39584fd77$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
    const elements = items.reduce((acc, curr, idx)=>{
        const { name: name, ...props } = curr;
        const Element = $eqoQu[name];
        const typedProps = props;
        if (Element && $8ba323b39584fd77$var$isElementDisplayValid(name, display)) {
            const element = /*#__PURE__*/ (0, $2OMIu.jsx)(Element, {
                ...typedProps
            }, idx);
            if (!$8ba323b39584fd77$export$f2c7ad0961800b16(element)) return [
                ...acc,
                element
            ];
        }
        return acc;
    }, []);
    if (elements.length) return elements;
};

});
parcelRegister("1BfaB", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed56962f49dee3a8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $akF1x = parcelRequire("akF1x");

var $6HeLP = parcelRequire("6HeLP");
const $ed56962f49dee3a8$var$alignmentStyleMap = {
    right: "_1dthh9n0 _r291h9n0 _1bahesu3 _y3gnusic",
    left: "_1dthv2br _r291v2br _1bah1y6m _y3gn1e5h"
};
const $ed56962f49dee3a8$var$baseStyleBySize = {
    xlarge: "_zulp147b _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    large: "_zulp1e9d _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    medium: "_zulpcxkx _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    small: "_zulppdf9 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v"
};
const $ed56962f49dee3a8$var$baseStyleByDirection = {
    horizontal: "_2lx2vrvc _4cvr1h6o",
    vertical: "_2lx21bp4 _4cvr1y6m"
};
const $ed56962f49dee3a8$var$baseStyle = null;
const $ed56962f49dee3a8$var$widthStyle = {
    flexible: "_16jlkb7n _1o9z11wp _i0dlf1ug",
    'fit-to-content': ""
};
const $ed56962f49dee3a8$var$positionStyle = {
    top: "_1wpz1y6m",
    center: ""
};
const $ed56962f49dee3a8$var$horizontalStyleBase = null;
const $ed56962f49dee3a8$var$horizontalStyleByHeight = {
    xlarge: "_1e0ccj1k _102k1m1q",
    large: "_1e0ccj1k _102k1m1q",
    medium: "_1e0ccj1k _102k1k8s",
    small: "_1e0ccj1k _102k1k8s"
};
const $ed56962f49dee3a8$var$gapStylesLeft = {
    xlarge: "_7yhb147b _m6ukidpf",
    large: "_7yhb1e9d _m6ukidpf",
    medium: "_7yhbcxkx _m6ukidpf",
    small: "_7yhbpdf9 _m6ukidpf"
};
const $ed56962f49dee3a8$var$gapStylesRight = {
    xlarge: "_24rc147b _3dveidpf",
    large: "_24rc1e9d _3dveidpf",
    medium: "_24rccxkx _3dveidpf",
    small: "_24rcpdf9 _3dveidpf"
};
const $ed56962f49dee3a8$var$minWidthStyle = null;
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $ed56962f49dee3a8$var$ElementGroupNew = ({ align: align = (0, $8dVIb.SmartLinkAlignment).Left, children: children, direction: direction = (0, $8dVIb.SmartLinkDirection).Horizontal, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $8dVIb.SmartLinkWidth).FitToContent, position: position = (0, $8dVIb.SmartLinkPosition).Center, className: className })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-smart-element-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $ed56962f49dee3a8$var$baseStyleBySize[size],
            $ed56962f49dee3a8$var$baseStyleByDirection[direction],
            "_fiawglyw _1ouwidpf _f6ju1ns9",
            $ed56962f49dee3a8$var$alignmentStyleMap[align],
            "_1ul99by0",
            $ed56962f49dee3a8$var$widthStyle[width],
            direction === (0, $8dVIb.SmartLinkDirection).Horizontal && "_1reo15vq _18m915vq _1e0c1ule _s7n4nkob _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _1aaynkob _15tynkob _1iu61nu9 _166k1nu9 _1div1nu9 _bmfb1nu9",
            direction === (0, $8dVIb.SmartLinkDirection).Horizontal && $ed56962f49dee3a8$var$horizontalStyleByHeight[size],
            direction === (0, $8dVIb.SmartLinkDirection).Horizontal && align === (0, $8dVIb.SmartLinkAlignment).Left && $ed56962f49dee3a8$var$gapStylesLeft[size],
            direction === (0, $8dVIb.SmartLinkDirection).Horizontal && align === (0, $8dVIb.SmartLinkAlignment).Right && $ed56962f49dee3a8$var$gapStylesRight[size],
            $ed56962f49dee3a8$var$positionStyle[position],
            className
        ]),
        children: (0, $akF1x.renderChildren)(children, size)
    });
};
const $ed56962f49dee3a8$var$ElementGroup = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($ed56962f49dee3a8$var$ElementGroupNew, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6HeLP.default), {
        ...props
    });
};
var $ed56962f49dee3a8$export$2e2bcd8739ae039 = $ed56962f49dee3a8$var$ElementGroup;

});
parcelRegister("6HeLP", function(module, exports) {

$parcel$export(module.exports, "default", () => $71938689e0d5e5c1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $8dVIb = parcelRequire("8dVIb");

var $fpDmE = parcelRequire("fpDmE");

var $akF1x = parcelRequire("akF1x");
function $71938689e0d5e5c1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $71938689e0d5e5c1$var$_ref = {
    name: "3l7cjm",
    styles: "-webkit-box-align:start;-ms-flex-align:start;justify-content:flex-start;text-align:left"
};
var $71938689e0d5e5c1$var$_ref2 = {
    name: "1ofqdyp",
    styles: "-webkit-box-align:end;-ms-flex-align:end;justify-content:flex-end;text-align:right"
};
const $71938689e0d5e5c1$var$getAlignmentStyles = (align)=>{
    switch(align){
        case (0, $8dVIb.SmartLinkAlignment).Right:
            return $71938689e0d5e5c1$var$_ref2;
        case (0, $8dVIb.SmartLinkAlignment).Left:
        default:
            return $71938689e0d5e5c1$var$_ref;
    }
};
const $71938689e0d5e5c1$var$getGapStyles = (size, align)=>{
    const gap = (0, $akF1x.getGapSize)(size);
    if (align === (0, $8dVIb.SmartLinkAlignment).Right) return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> span': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginLeft: `${gap}rem`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> span:first-child': {
            marginLeft: 'initial'
        }
    });
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> span': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginRight: `${gap}rem`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:last-child': {
                marginRight: 'initial'
            }
        }
    });
};
const $71938689e0d5e5c1$var$getHorizontalDirectionStyles = (size, align)=>{
    const lineHeight = (0, $fpDmE.getMaxLineHeight)(size);
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $f8Sb3.css)("display:block;vertical-align:middle;", (0, $fpDmE.getTruncateStyles)(1, lineHeight + 'rem'), ">span,>div{vertical-align:middle;&[data-smart-element-date-time],&[data-smart-element-text]{display:inline;}}", $71938689e0d5e5c1$var$getGapStyles(size, align), ";");
};
const $71938689e0d5e5c1$export$91d118d179d992a4 = (direction, size, align, width, position)=>/*#__PURE__*/ (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $akF1x.getBaseStyles)(direction, size), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $71938689e0d5e5c1$var$getAlignmentStyles(align), "min-width:10%;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    width === (0, $8dVIb.SmartLinkWidth).Flexible ? `flex: 1 3;` : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    direction === (0, $8dVIb.SmartLinkDirection).Horizontal ? $71938689e0d5e5c1$var$getHorizontalDirectionStyles(size, align) : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    position === (0, $8dVIb.SmartLinkPosition).Top ? 'align-self: flex-start;' : '');
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $71938689e0d5e5c1$var$ElementGroup = ({ align: align = (0, $8dVIb.SmartLinkAlignment).Left, children: children, overrideCss: overrideCss, direction: direction = (0, $8dVIb.SmartLinkDirection).Horizontal, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $8dVIb.SmartLinkWidth).FitToContent, position: position = (0, $8dVIb.SmartLinkPosition).Center })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $71938689e0d5e5c1$export$91d118d179d992a4(direction, size, align, width, position),
            overrideCss
        ],
        "data-smart-element-group": true,
        "data-testid": testId
    }, (0, $akF1x.renderChildren)(children, size));
var $71938689e0d5e5c1$export$2e2bcd8739ae039 = $71938689e0d5e5c1$var$ElementGroup;

});



parcelRegister("3Zm9O", function(module, exports) {

$parcel$export(module.exports, "default", () => $70338cdeec0a99e7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jRHKj = parcelRequire("jRHKj");
const $70338cdeec0a99e7$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
    const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
    const handleOnClick = (0, $5uXOq.useCallback)(()=>{
        if (onActionItemClick) onActionItemClick();
        if (onClick) onClick();
    }, [
        onActionItemClick,
        onClick
    ]);
    const Action = name in $jRHKj ? $jRHKj[name] : undefined;
    if (!Action) return null;
    const actionProps = {
        ...props
    };
    if (hideContent && !asDropDownItems) actionProps.content = '';
    if (hideIcon) actionProps.icon = undefined;
    if (item?.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Action, {
        asDropDownItem: asDropDownItems,
        size: size,
        appearance: appearance,
        onClick: handleOnClick,
        isDisabled: isDisabled,
        ...actionProps
    });
};
var $70338cdeec0a99e7$export$2e2bcd8739ae039 = $70338cdeec0a99e7$var$ActionGroupItem;

});
parcelRegister("jRHKj", function(module, exports) {

$parcel$export(module.exports, "CustomAction", () => (parcelRequire("23vM5")).default);
$parcel$export(module.exports, "DeleteAction", () => (parcelRequire("96Kdz")).default);
$parcel$export(module.exports, "EditAction", () => (parcelRequire("fEhHT")).default);
$parcel$export(module.exports, "DownloadAction", () => (parcelRequire("g9G65")).default);
$parcel$export(module.exports, "FollowAction", () => (parcelRequire("b6Mes")).default);
$parcel$export(module.exports, "PreviewAction", () => (parcelRequire("9mTP8")).default);
$parcel$export(module.exports, "CopyLinkAction", () => (parcelRequire("jep3X")).default);
$parcel$export(module.exports, "AISummaryAction", () => (parcelRequire("ziZLe")).default);
$parcel$export(module.exports, "AutomationAction", () => (parcelRequire("5OUwn")).default);
$parcel$export(module.exports, "ViewRelatedLinksAction", () => (parcelRequire("faTeC")).default);

var $23vM5 = parcelRequire("23vM5");

var $96Kdz = parcelRequire("96Kdz");

var $fEhHT = parcelRequire("fEhHT");

var $g9G65 = parcelRequire("g9G65");

var $b6Mes = parcelRequire("b6Mes");

var $9mTP8 = parcelRequire("9mTP8");

var $jep3X = parcelRequire("jep3X");

var $ziZLe = parcelRequire("ziZLe");

var $5OUwn = parcelRequire("5OUwn");

var $faTeC = parcelRequire("faTeC");

});
parcelRegister("23vM5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bf7d27623ce3bf9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $f6kZQ = parcelRequire("f6kZQ");

var $kuVc8 = parcelRequire("kuVc8");

var $bhB72 = parcelRequire("bhB72");

var $1wpdl = parcelRequire("1wpdl");

var $5z2J4 = parcelRequire("5z2J4");
/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $1bf7d27623ce3bf9$var$ActionNew = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, style: style, asDropDownItem: asDropDownItem, className: className, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bhB72.default), {
        asStackItemIcon: isStackItem,
        isDisabled: isDisabled,
        icon: icon,
        size: size,
        testId: testId
    });
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1wpdl.default), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hideTooltip: hideTooltip
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kuVc8.default), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f6kZQ.default), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
        children: button
    }) : button;
};
const $1bf7d27623ce3bf9$var$Action = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($1bf7d27623ce3bf9$var$ActionNew, {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5z2J4.default), {
        ...props
    });
};
var $1bf7d27623ce3bf9$export$2e2bcd8739ae039 = $1bf7d27623ce3bf9$var$Action;

});
parcelRegister("f6kZQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3ee32ab04698fad$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $2rqOp = parcelRequire("2rqOp");

var $VSDnB = parcelRequire("VSDnB");

var $3bDjY = parcelRequire("3bDjY");

var $8dVIb = parcelRequire("8dVIb");

var $fpDmE = parcelRequire("fpDmE");

var $8SRO9 = parcelRequire("8SRO9");
const $b3ee32ab04698fad$var$IconOnlyLarge = null;
const $b3ee32ab04698fad$var$SizeSmall = null;
const $b3ee32ab04698fad$var$SizeSmallIconOnly = null;
const $b3ee32ab04698fad$var$SizeSmallNotIconOnly = null;
const $b3ee32ab04698fad$var$ActionButtonNew = ({ appearance: appearance, content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, className: className })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $5uXOq.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            size === (0, $8dVIb.SmartLinkSize).Large && iconOnly && "_1gflidpf _or3fidpf _1ddvidpf _1hhaidpf _yhjmidpf _1trnidpf _1fstidpf _1xceidpf _1gqnidpf _1qdmidpf _df2ridpf _j1twidpf _11lvidpf _192bidpf _vbn7idpf _wfu3idpf _1i3bidpf _13gwidpf _4wlcidpf _rehaidpf _mp2fidpf _ro8midpf _1l0qidpf _1bnaidpf _3kh9idpf _i2vxidpf _8pvjidpf _1e1oidpf _1vtwidpf _ijvwidpf _tpwpidpf _1ad8idpf",
            size === (0, $8dVIb.SmartLinkSize).Small && "_11c8qk37 _k48p1wq8",
            size === (0, $8dVIb.SmartLinkSize).Small && iconOnly && "_1gfl1xvx _or3f1xvx _1ddv1xvx _1hha1xvx _yhjm1xvx _1trn1xvx _1fst1xvx _1xce1xvx _1gqn1xvx _1qdm1xvx _df2r1xvx _j1tw1xvx _11lv1xvx _192b1xvx _vbn71xvx _wfu31xvx",
            size === (0, $8dVIb.SmartLinkSize).Small && !iconOnly && "_11lvpdf9 _192bpdf9 _vbn7pdf9 _wfu3pdf9 _yhjmpdf9 _1trnpdf9 _1fstpdf9 _1xcepdf9",
            className
        ]),
        "data-testid": `${testId}-button-wrapper`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2rqOp.default), {
                appearance: appearance,
                iconAfter: iconAfter,
                iconBefore: iconBefore,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: (0, $fpDmE.sizeToButtonSpacing)[size],
                testId: testId,
                href: href,
                "aria-label": ariaLabel,
                children: content
            })
        })
    });
};
const $b3ee32ab04698fad$var$ActionButton = (props)=>{
    return (0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard') ? /*#__PURE__*/ (0, $2OMIu.jsx)($b3ee32ab04698fad$var$ActionButtonNew, {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8SRO9.default), {
        ...props
    });
};
var $b3ee32ab04698fad$export$2e2bcd8739ae039 = $b3ee32ab04698fad$var$ActionButton;

});
parcelRegister("8SRO9", function(module, exports) {

$parcel$export(module.exports, "default", () => $60e42979d79aef9f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $2rqOp = parcelRequire("2rqOp");

var $3bDjY = parcelRequire("3bDjY");

var $8dVIb = parcelRequire("8dVIb");

var $fpDmE = parcelRequire("fpDmE");
function $60e42979d79aef9f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $60e42979d79aef9f$var$_ref = {
    name: "kaj2cp",
    styles: "button, button:hover, button:focus, button:active{padding:0;> span{margin:0;}}"
};
const $60e42979d79aef9f$var$getButtonStyle = (size, iconOnly)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).Large:
            return iconOnly ? $60e42979d79aef9f$var$_ref : '';
        case (0, $8dVIb.SmartLinkSize).Small:
            return /*#__PURE__*/ (0, $f8Sb3.css)({
                font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                fontWeight: "var(--ds-font-weight-medium, 500)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                'button, button:hover, button:focus, button:active': [
                    {
                        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                        lineHeight: 'inherit'
                    },
                    iconOnly ? `
            padding: 0.125rem;
          ` : `
            padding-left: 0.25rem;
            padding-right: 0.25rem;
          `
                ]
            });
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Medium:
        default:
            return '';
    }
};
const $60e42979d79aef9f$var$ActionButtonOld = ({ appearance: appearance, content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, overrideCss: overrideCss, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $5uXOq.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $60e42979d79aef9f$var$getButtonStyle(size, iconOnly),
            overrideCss
        ],
        "data-testid": `${testId}-button-wrapper`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        content: tooltipMessage,
        hideTooltipOnClick: true,
        testId: `${testId}-tooltip`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2rqOp.default), {
        appearance: appearance,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onButtonClick(onClick),
        spacing: (0, $fpDmE.sizeToButtonSpacing)[size],
        testId: testId,
        href: href,
        "aria-label": ariaLabel
    }, content)));
};
var $60e42979d79aef9f$export$2e2bcd8739ae039 = $60e42979d79aef9f$var$ActionButtonOld;

});


parcelRegister("kuVc8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e656bda53d041540$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $kxcRq = parcelRequire("kxcRq");
const $e656bda53d041540$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
        elemAfter: iconAfter,
        elemBefore: iconBefore,
        isDisabled: isLoading,
        onClick: (0, $kxcRq.handleOnClick)(onClick),
        testId: testId,
        children: content
    });
var $e656bda53d041540$export$2e2bcd8739ae039 = $e656bda53d041540$var$ActionDropdownItem;

});

parcelRegister("bhB72", function(module, exports) {

$parcel$export(module.exports, "default", () => $345d01659b23eb38$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $hpcQP = parcelRequire("hpcQP");
const $345d01659b23eb38$var$getIconWidth = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $8dVIb.SmartLinkSize).Medium:
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
const $345d01659b23eb38$var$iconSizeStyleMap = {
    '1.5rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1k8s _1tke1k8s _c71l1k8s _1bsb1k8s _1ul91k8s _p12f1k8s _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71k8s _1xjx1k8s _17521k8s _qci81k8s _15iz1k8s _erub1k8s _19l31k8s _1pr21k8s _1u5t1k8s _mezj1k8s _e2oo1k8s _w8l51k8s _1rg21k8s _q7cv1k8s _xwbj1k8s _rtys1k8s _b8nk1k8s _4x201k8s",
    '1rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v",
    '20px': "_16jlidpf _1o9zidpf _i0dl1wug _4t3igktf _1tkegktf _c71lgktf _1bsbgktf _1ul9gktf _p12fgktf _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7gktf _1xjxgktf _1752gktf _qci8gktf _15izgktf _erubgktf _19l3gktf _1pr2gktf _1u5tgktf _mezjgktf _e2oogktf _w8l5gktf _1rg2gktf _q7cvgktf _xwbjgktf _rtysgktf _b8nkgktf _4x20gktf"
};
const $345d01659b23eb38$var$stackItemIconStyles = null;
const $345d01659b23eb38$var$newStackItemIconStyles = null;
const $345d01659b23eb38$var$iconStyleMap = {
    true: "_syaz2oi6",
    false: "_syazwdcn"
};
const $345d01659b23eb38$var$ActionIconNew = ({ size: size, testId: testId, icon: icon, isDisabled: isDisabled, asStackItemIcon: asStackItemIcon })=>{
    if (!(0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $bwpsq.default)([
            $345d01659b23eb38$var$iconStyleMap[isDisabled ? 'true' : 'false'],
            asStackItemIcon && "_1e0c1o8l _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
            asStackItemIcon && $345d01659b23eb38$var$iconSizeStyleMap['20px'],
            !asStackItemIcon && $345d01659b23eb38$var$iconSizeStyleMap[$345d01659b23eb38$var$getIconWidth(size)]
        ]),
        children: icon
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $bwpsq.default)([
            $345d01659b23eb38$var$iconStyleMap[isDisabled ? 'true' : 'false'],
            "_1e0c1o8l"
        ]),
        children: icon
    });
};
const $345d01659b23eb38$var$ActionIcon = (props)=>{
    return (0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard') ? /*#__PURE__*/ (0, $2OMIu.jsx)($345d01659b23eb38$var$ActionIconNew, {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hpcQP.default), {
        ...props
    });
};
var $345d01659b23eb38$export$2e2bcd8739ae039 = $345d01659b23eb38$var$ActionIcon;

});
parcelRegister("hpcQP", function(module, exports) {

$parcel$export(module.exports, "default", () => $eab4e6fe8ea1cad3$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/use-tokens-typography */ /**
                                                                    * @jsxRuntime classic
                                                                    * @jsx jsx
                                                                    */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $fpDmE = parcelRequire("fpDmE");
function $eab4e6fe8ea1cad3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $eab4e6fe8ea1cad3$var$getIconWidth = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $8dVIb.SmartLinkSize).Medium:
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
const $eab4e6fe8ea1cad3$var$getIconStyles = (isDisabled)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: isDisabled ? "var(--ds-text-disabled, #6B778C)" : "var(--ds-icon, #44546F)"
    });
const $eab4e6fe8ea1cad3$var$stackItemIconSizeStyles = (0, $fpDmE.getIconSizeStyles)('20px');
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $eab4e6fe8ea1cad3$var$stackItemIconStyles = /*#__PURE__*/ (0, $f8Sb3.css)($eab4e6fe8ea1cad3$var$stackItemIconSizeStyles, "display:inline-block;line-height:0;padding:var(--ds-space-025, 2px);span,svg,img{line-height:0;}");
const $eab4e6fe8ea1cad3$var$newStackItemIconStyles = {
    name: "1pelf5a",
    styles: "display:inline-block;line-height:0"
};
const $eab4e6fe8ea1cad3$var$ActionIconOld = ({ size: size, testId: testId, icon: icon, isDisabled: isDisabled, asStackItemIcon: asStackItemIcon })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            $eab4e6fe8ea1cad3$var$getIconStyles(isDisabled),
            !(0, $VSDnB.fg)('platform-visual-refresh-icons') ? asStackItemIcon ? $eab4e6fe8ea1cad3$var$stackItemIconStyles : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $fpDmE.getIconSizeStyles)($eab4e6fe8ea1cad3$var$getIconWidth(size)) : $eab4e6fe8ea1cad3$var$newStackItemIconStyles
        ],
        "data-testid": `${testId}-icon`
    }, icon);
var $eab4e6fe8ea1cad3$export$2e2bcd8739ae039 = $eab4e6fe8ea1cad3$var$ActionIconOld;

});


parcelRegister("1wpdl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6ef8f3a6ac7d3ff$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $5PILj = parcelRequire("5PILj");
const $c6ef8f3a6ac7d3ff$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props })=>hideTooltip ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5PILj.default), {
        ...props,
        content: content
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: tooltipMessage || content,
        onHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5PILj.default), {
                ...props,
                content: content,
                tooltipProps: tooltipProps
            })
    });
var $c6ef8f3a6ac7d3ff$export$2e2bcd8739ae039 = $c6ef8f3a6ac7d3ff$var$ActionStackItem;

});
parcelRegister("5PILj", function(module, exports) {

$parcel$export(module.exports, "default", () => $222d00bebc6cbf68$export$2e2bcd8739ae039);
/* action-button.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $3Lty3 = parcelRequire("3Lty3");

var $eZJjh = parcelRequire("eZJjh");

var $fpDmE = parcelRequire("fpDmE");

var $bhB72 = parcelRequire("bhB72");

var $kltQN = parcelRequire("kltQN");
const $222d00bebc6cbf68$var$styles = {
    button: "_kkk2n7od _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _irr3166n _1di61dty",
    content: "_11c8qk37 _syaz1fxt"
};
const $222d00bebc6cbf68$var$ActionButtonNew = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, style: style })=>{
    const space = spaceOption ?? (0, $fpDmE.getPrimitivesInlineSpaceBySize)(size);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]);
    const icon = iconOption && isLoading ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bhB72.default), {
        asStackItemIcon: true,
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
            testId: `${testId}-loading`
        }),
        size: size
    }) : iconOption;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
        xcss: $222d00bebc6cbf68$var$styles.button,
        ...tooltipProps,
        onClick: onClick,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            alignBlock: "center",
            grow: "fill",
            space: space,
            children: [
                icon,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: $222d00bebc6cbf68$var$styles.content,
                    children: content
                })
            ]
        })
    });
};
const $222d00bebc6cbf68$var$ActionButton = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($222d00bebc6cbf68$var$ActionButtonNew, {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kltQN.default), {
        ...props
    });
};
var $222d00bebc6cbf68$export$2e2bcd8739ae039 = $222d00bebc6cbf68$var$ActionButton;

});
parcelRegister("kltQN", function(module, exports) {

$parcel$export(module.exports, "default", () => $22bccf96059b2be0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $fpDmE = parcelRequire("fpDmE");

var $bhB72 = parcelRequire("bhB72");
const $22bccf96059b2be0$var$buttonStyles = (0, $8CUq3.xcss)({
    all: 'unset',
    padding: 'space.050',
    width: '100%',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $22bccf96059b2be0$var$contentStyles = (0, $8CUq3.xcss)({
    color: 'color.text',
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $22bccf96059b2be0$var$ActionButtonOld = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, xcss: xcss })=>{
    const space = spaceOption ?? (0, $fpDmE.getPrimitivesInlineSpaceBySize)(size);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]);
    const icon = iconOption && isLoading ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bhB72.default), {
        asStackItemIcon: true,
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
            testId: `${testId}-loading`
        }),
        size: size
    }) : iconOption;
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5ILhZ.default), {
        xcss: [
            $22bccf96059b2be0$var$buttonStyles,
            xcss
        ],
        ...tooltipProps,
        onClick: onClick,
        testId: testId,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f5TWP.default), {
            alignBlock: "center",
            grow: "fill",
            space: space,
            children: [
                icon,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                    xcss: $22bccf96059b2be0$var$contentStyles,
                    children: content
                })
            ]
        })
    }));
};
var $22bccf96059b2be0$export$2e2bcd8739ae039 = $22bccf96059b2be0$var$ActionButtonOld;

});



parcelRegister("5z2J4", function(module, exports) {

$parcel$export(module.exports, "default", () => $50898b71f3262b17$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $8dVIb = parcelRequire("8dVIb");

var $f6kZQ = parcelRequire("f6kZQ");

var $kuVc8 = parcelRequire("kuVc8");

var $bhB72 = parcelRequire("bhB72");

var $1wpdl = parcelRequire("1wpdl");
/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $50898b71f3262b17$var$ActionOld = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, xcss: xcss, asDropDownItem: asDropDownItem, overrideCss: overrideCss, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bhB72.default), {
        asStackItemIcon: isStackItem,
        isDisabled: isDisabled,
        icon: icon,
        size: size,
        testId: testId
    });
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1wpdl.default), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hideTooltip: hideTooltip
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kuVc8.default), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f6kZQ.default), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        overrideCss: overrideCss,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, $f8Sb3.jsx)(Wrapper, null, button) : button;
};
var $50898b71f3262b17$export$2e2bcd8739ae039 = $50898b71f3262b17$var$ActionOld;

});


parcelRegister("96Kdz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddac835e19e975e0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $84THj = parcelRequire("84THj");

var $7zaVw = parcelRequire("7zaVw");

var $23vM5 = parcelRequire("23vM5");
const $ddac835e19e975e0$var$DeleteAction = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).delete
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Delete"
        }),
        testId: "smart-action-delete-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).delete
        }),
        ...props
    });
var $ddac835e19e975e0$export$2e2bcd8739ae039 = $ddac835e19e975e0$var$DeleteAction;

});

parcelRegister("fEhHT", function(module, exports) {

$parcel$export(module.exports, "default", () => $23e1c92ea69f35be$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $4ChK1 = parcelRequire("4ChK1");

var $7zaVw = parcelRequire("7zaVw");

var $23vM5 = parcelRequire("23vM5");
const $23e1c92ea69f35be$var$EditAction = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).edit
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ChK1))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Edit"
        }),
        testId: "smart-action-edit-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).edit
        }),
        ...props
    });
var $23e1c92ea69f35be$export$2e2bcd8739ae039 = $23e1c92ea69f35be$var$EditAction;

});
parcelRegister("4ChK1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c0bc716a0db7d939b06b255b25c2b388>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $35c87913ec905242$var$_react = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $35c87913ec905242$var$_edit = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("5nRKm")));

var $35c87913ec905242$var$_edit2 = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("gsEeL")));
function $35c87913ec905242$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $35c87913ec905242$var$EditIcon = (props)=>/*#__PURE__*/ $35c87913ec905242$var$_react.default.createElement($35c87913ec905242$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $35c87913ec905242$var$_edit2.default
    }, props));
$35c87913ec905242$var$EditIcon.Name = 'EditIconMigration';
var $35c87913ec905242$var$_default = module.exports.default = $35c87913ec905242$var$EditIcon;

});
parcelRegister("5nRKm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df0e46d6520ed0b12c088820aa4dca0e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3eb8cab3ab465b93$var$_react = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3eb8cab3ab465b93$var$_baseNew = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3eb8cab3ab465b93$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3eb8cab3ab465b93$var$EditIcon = (props)=>/*#__PURE__*/ $3eb8cab3ab465b93$var$_react.default.createElement($3eb8cab3ab465b93$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.751H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V10m-.75-5 1.116-1.116a1.25 1.25 0 0 0 0-1.768l-.732-.732a1.25 1.25 0 0 0-1.768 0L11 2.5M13.5 5 9.479 9.021c-.15.15-.336.26-.54.318l-3.189.911.911-3.189a1.25 1.25 0 0 1 .318-.54L11 2.5M13.5 5 11 2.5"/>`
    }, props));
$3eb8cab3ab465b93$var$EditIcon.displayName = 'EditIcon';
var $3eb8cab3ab465b93$var$_default = module.exports.default = $3eb8cab3ab465b93$var$EditIcon;

});

parcelRegister("gsEeL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbe7921991bc4cb$var$_react = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $bfbe7921991bc4cb$var$_edit = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5nRKm")));
function $bfbe7921991bc4cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bfbe7921991bc4cb$var$EditIcon = (props)=>/*#__PURE__*/ $bfbe7921991bc4cb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $bfbe7921991bc4cb$var$_edit.default
    }));
$bfbe7921991bc4cb$var$EditIcon.displayName = 'EditIcon';
var $bfbe7921991bc4cb$var$_default = module.exports.default = $bfbe7921991bc4cb$var$EditIcon;

});



parcelRegister("g9G65", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fb79986052b65c1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $d4dv2 = parcelRequire("d4dv2");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $iPVbQ = parcelRequire("iPVbQ");

var $23vM5 = parcelRequire("23vM5");
const $4fb79986052b65c1$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const invoke = (0, $iPVbQ.default)({});
    const data = context?.actions?.[(0, $8dVIb.ActionName).DownloadAction];
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const label = isStackItem ? (0, $7zaVw.messages).download_file : (0, $7zaVw.messages).download;
    const tooltipMessage = isStackItem ? (0, $7zaVw.messages).download_description : (0, $7zaVw.messages).download;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...label
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d4dv2))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Download"
        }),
        onClick: onClick,
        testId: "smart-action-download-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props
    }) : null;
};
var $4fb79986052b65c1$export$2e2bcd8739ae039 = $4fb79986052b65c1$var$DownloadAction;

});
parcelRegister("d4dv2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37f28b4661c3f10f3f040a6e37c48b91>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98361ed174bfbb2b$var$_react = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $98361ed174bfbb2b$var$_download = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("EOGIN")));

var $98361ed174bfbb2b$var$_download2 = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("5krT5")));
function $98361ed174bfbb2b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for DownloadIcon.
 * This component is DownloadIcon, with `UNSAFE_fallbackIcon` set to "DownloadIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $98361ed174bfbb2b$var$DownloadIcon = (props)=>/*#__PURE__*/ $98361ed174bfbb2b$var$_react.default.createElement($98361ed174bfbb2b$var$_download.default, Object.assign({
        LEGACY_fallbackIcon: $98361ed174bfbb2b$var$_download2.default
    }, props));
$98361ed174bfbb2b$var$DownloadIcon.Name = 'DownloadIconMigration';
var $98361ed174bfbb2b$var$_default = module.exports.default = $98361ed174bfbb2b$var$DownloadIcon;

});
parcelRegister("EOGIN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::234ef6d678f6eb4cd1fc902b5a2375a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $07ab0e2228a1635e$var$_react = $07ab0e2228a1635e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $07ab0e2228a1635e$var$_baseNew = $07ab0e2228a1635e$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $07ab0e2228a1635e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $07ab0e2228a1635e$var$DownloadIcon = (props)=>/*#__PURE__*/ $07ab0e2228a1635e$var$_react.default.createElement($07ab0e2228a1635e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 1v8.75m-4-3.5 4 4 4-4"/>`
    }, props));
$07ab0e2228a1635e$var$DownloadIcon.displayName = 'DownloadIcon';
var $07ab0e2228a1635e$var$_default = module.exports.default = $07ab0e2228a1635e$var$DownloadIcon;

});

parcelRegister("5krT5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e1473e49ea22b68$var$_react = $3e1473e49ea22b68$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $3e1473e49ea22b68$var$_download = $3e1473e49ea22b68$var$_interopRequireDefault((parcelRequire("EOGIN")));
function $3e1473e49ea22b68$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e1473e49ea22b68$var$DownloadIcon = (props)=>/*#__PURE__*/ $3e1473e49ea22b68$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
    }, props, {
        newIcon: $3e1473e49ea22b68$var$_download.default
    }));
$3e1473e49ea22b68$var$DownloadIcon.displayName = 'DownloadIcon';
var $3e1473e49ea22b68$var$_default = module.exports.default = $3e1473e49ea22b68$var$DownloadIcon;

});



parcelRegister("b6Mes", function(module, exports) {

$parcel$export(module.exports, "default", () => $879133cabfb6e190$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $fpDmE = parcelRequire("fpDmE");

var $3xnBw = parcelRequire("3xnBw");

var $itef5 = parcelRequire("itef5");


const $879133cabfb6e190$var$importIconMapper = {
    goal: ()=>(parcelRequire("82OF2")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })),
    projects: ()=>(parcelRequire("9yaZS")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            }))
};
const $879133cabfb6e190$var$getIcon = (stackIconType)=>{
    const importFn = $879133cabfb6e190$var$importIconMapper[stackIconType];
    if (!importFn) return null;
    return (0, $fpDmE.importIcon)(importFn);
};
const $879133cabfb6e190$var$FollowAction = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $8dVIb.ActionName).FollowAction];
    if (!context || !actionData) return null;
    const { value: value, isProject: isProject, ...data } = actionData;
    const isStackItem = props.as === 'stack-item';
    const message = value ? (0, $7zaVw.messages).follow : (0, $7zaVw.messages).unfollow;
    const projectMessage = value ? (0, $7zaVw.messages).follow_project : (0, $7zaVw.messages).unfollow_project;
    const goalMessage = value ? (0, $7zaVw.messages).follow_goal : (0, $7zaVw.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $7zaVw.messages).follow_project_description : (0, $7zaVw.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $7zaVw.messages).follow_goal_description : (0, $7zaVw.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const stackIconType = isProject ? 'projects' : 'goal';
    const ImportedIcon = $879133cabfb6e190$var$getIcon(stackIconType);
    const followIcon = /*#__PURE__*/ (0, $2OMIu.jsx)(ImportedIcon, {
        label: "Follow",
        testId: `smart-action-follow-action-${stackIconType}-icon`
    });
    const handleError = ()=>{
        const { onError: onErrorCallback } = props;
        const errorMessage = (0, $itef5.getFollowActionErrorMessage)(isProject, value);
        onErrorCallback?.({
            title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...errorMessage
            }),
            appearance: 'error'
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3xnBw.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...label
        }),
        icon: followIcon,
        testId: "smart-action-follow-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props,
        onError: handleError
    });
};
var $879133cabfb6e190$export$2e2bcd8739ae039 = $879133cabfb6e190$var$FollowAction;

});
parcelRegister("3xnBw", function(module, exports) {

$parcel$export(module.exports, "default", () => $35d557ed1ef6412d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $a1vqi = parcelRequire("a1vqi");

var $3q2sI = parcelRequire("3q2sI");

var $euMlu = parcelRequire("euMlu");

var $f22ja = parcelRequire("f22ja");

var $69hr0 = parcelRequire("69hr0");

var $23vM5 = parcelRequire("23vM5");
const $35d557ed1ef6412d$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const invoke = (0, $3q2sI.default)();
    const reload = (0, $f22ja.default)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const handleClick = (0, $5uXOq.useCallback)(async ()=>{
        if (action) {
            const smartLinkActionType = action.action?.actionType;
            try {
                setIsLoading(true);
                if (smartLinkActionType === 'FollowEntityAction' || smartLinkActionType === 'UnfollowEntityAction') fireEvent('ui.button.clicked.smartLinkFollowButton', {});
                else fireEvent(`ui.button.clicked.${smartLinkActionType}`, {});
                fireEvent('track.smartLinkQuickAction.started', {
                    smartLinkActionType: smartLinkActionType
                });
                const request = (0, $69hr0.default)(action);
                await invoke(request);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: smartLinkActionType
                });
                if (action.reload && action.reload.url) await reload(action.reload.url, true, undefined, action.reload.id);
                setIsLoading(false);
                if (onClick) onClick();
            } catch (err) {
                setIsLoading(false);
                fireEvent('track.smartLinkQuickAction.failed', {
                    smartLinkActionType: smartLinkActionType,
                    reason: (0, $euMlu.getInvokeFailureReason)(err)
                });
                onErrorCallback?.();
            }
        }
    }, [
        action,
        invoke,
        onClick,
        onErrorCallback,
        reload,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        ...props,
        isLoading: isLoading,
        onClick: handleClick
    });
};
var $35d557ed1ef6412d$export$2e2bcd8739ae039 = $35d557ed1ef6412d$var$ServerAction;

});
parcelRegister("69hr0", function(module, exports) {

$parcel$export(module.exports, "default", () => $22d791805237a266$export$2e2bcd8739ae039);
const $22d791805237a266$var$createInvokeRequest = (request, payload)=>({
        action: {
            ...request.action,
            payload: payload
        },
        providerKey: request.providerKey
    });
var $22d791805237a266$export$2e2bcd8739ae039 = $22d791805237a266$var$createInvokeRequest;

});


parcelRegister("itef5", function(module, exports) {

$parcel$export(module.exports, "getFollowActionErrorMessage", () => $d31a392ae92ce299$export$49248678d3914625);

var $7zaVw = parcelRequire("7zaVw");
const $d31a392ae92ce299$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
    if (isProject && isFollow) return (0, $7zaVw.messages).follow_project_error;
    if (isProject && !isFollow) return (0, $7zaVw.messages).unfollow_project_error;
    if (!isProject && isFollow) return (0, $7zaVw.messages).follow_goal_error;
    if (!isProject && !isFollow) return (0, $7zaVw.messages).unfollow_goal_error;
    return (0, $7zaVw.messages).generic_error_message;
};

});

parcelRegister("82OF2", function(module, exports) {

let $5db5ced4f0000848$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5db5ced4f0000848$var$load("h2MrD"),
    $5db5ced4f0000848$var$load("bYT2S"),
    $5db5ced4f0000848$var$load("ftS7u")
]).then(()=>parcelRequire('5UxRR'));

});

parcelRegister("9yaZS", function(module, exports) {

let $01cb5a17f25affbd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $01cb5a17f25affbd$var$load("h2MrD"),
    $01cb5a17f25affbd$var$load("bYT2S"),
    $01cb5a17f25affbd$var$load("3uQsu")
]).then(()=>parcelRequire('gsEJ1'));

});


parcelRegister("9mTP8", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ea9170f77974c10$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $5JpK2 = parcelRequire("5JpK2");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $iPVbQ = parcelRequire("iPVbQ");

var $23vM5 = parcelRequire("23vM5");
const $3ea9170f77974c10$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const invoke = (0, $iPVbQ.default)({});
    const data = context?.actions?.[(0, $8dVIb.ActionName).PreviewAction];
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const tooltipMessage = isStackItem ? (0, $7zaVw.messages).preview_description : (0, $7zaVw.messages).preview_improved;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).preview_improved
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5JpK2))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Open preview"
        }),
        onClick: onClick,
        testId: "smart-action-preview-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        hideTooltipOnMouseDown: true,
        ...data,
        ...props
    }) : null;
};
var $3ea9170f77974c10$export$2e2bcd8739ae039 = $3ea9170f77974c10$var$PreviewAction;

});
parcelRegister("5JpK2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a044223350e041031a35374685e9a4f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42c51f70ef43f1c0$var$_react = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $42c51f70ef43f1c0$var$_growDiagonal = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("l14Zy")));

var $42c51f70ef43f1c0$var$_actualSize = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("6LXPU")));
function $42c51f70ef43f1c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for GrowDiagonalIcon.
 * This component is GrowDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesActualSizeIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42c51f70ef43f1c0$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $42c51f70ef43f1c0$var$_react.default.createElement($42c51f70ef43f1c0$var$_growDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $42c51f70ef43f1c0$var$_actualSize.default
    }, props));
$42c51f70ef43f1c0$var$GrowDiagonalIcon.Name = 'GrowDiagonalIconMigration';
var $42c51f70ef43f1c0$var$_default = module.exports.default = $42c51f70ef43f1c0$var$GrowDiagonalIcon;

});


parcelRegister("jep3X", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1e0763b6a84021$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $jOyH3 = parcelRequire("jOyH3");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $iPVbQ = parcelRequire("iPVbQ");

var $23vM5 = parcelRequire("23vM5");
const $0d1e0763b6a84021$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const invoke = (0, $iPVbQ.default)({});
    const data = context?.actions?.[(0, $8dVIb.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)((0, $7zaVw.messages).copy_url_to_clipboard);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke({
                ...data.invokeAction,
                actionFn: async ()=>{
                    await data.invokeAction?.actionFn();
                    setTooltipMessage((0, $7zaVw.messages).copied_url_to_clipboard);
                }
            });
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).copy_url_to_clipboard
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
            color: "currentColor",
            label: "copy url",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        onClick: onClick,
        testId: "smart-action-copy-link-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $7zaVw.messages).copy_url_to_clipboard),
        ...data,
        ...props
    }) : null;
};
var $0d1e0763b6a84021$export$2e2bcd8739ae039 = $0d1e0763b6a84021$var$CopyLinkAction;

});

parcelRegister("ziZLe", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b53b1e1aa704061$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $dgRei = parcelRequire("dgRei");
const $8b53b1e1aa704061$var$AISummaryAction = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $8dVIb.InternalActionName).AISummaryAction];
    return actionData ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dgRei.AISummaryActionComponent), {
        ...actionData,
        ...props
    }) : null;
};
var $8b53b1e1aa704061$export$2e2bcd8739ae039 = $8b53b1e1aa704061$var$AISummaryAction;

});
parcelRegister("dgRei", function(module, exports) {

$parcel$export(module.exports, "AISummaryActionComponent", () => $a6e4dbdfe418b2c1$export$8eed96bc6d982595);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $1MeuC = parcelRequire("1MeuC");

var $8UCLX = parcelRequire("8UCLX");

var $jdA9V = parcelRequire("jdA9V");
const $a6e4dbdfe418b2c1$export$8eed96bc6d982595 = (props)=>{
    (0, $gKZoD.di)((0, $1MeuC.default));
    const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
    const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, $1MeuC.default)(url);
    (0, $5uXOq.useEffect)(()=>{
        onLoadingChange?.(status === 'loading');
    }, [
        onLoadingChange,
        status
    ]);
    return status === 'done' ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jdA9V.CopySummaryAction), {
        ...props,
        testId: testId,
        content: content
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8UCLX.AISummariseAction), {
        ...props,
        testId: testId,
        summariseUrl: summariseUrl,
        status: status
    });
};

});
parcelRegister("1MeuC", function(module, exports) {

$parcel$export(module.exports, "default", () => $27e30e18347ce2a0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hWyvy = parcelRequire("hWyvy");
var $8UXrm = parcelRequire("8UXrm");

var $a1vqi = parcelRequire("a1vqi");

var $1VPdD = parcelRequire("1VPdD");

var $hjhAz = parcelRequire("hjhAz");

var $kR87P = parcelRequire("kR87P");

var $anB5s = parcelRequire("anB5s");
const $27e30e18347ce2a0$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
const $27e30e18347ce2a0$var$useAISummaryAction = (url)=>{
    const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, $anB5s.useAISummaryConfig)();
    const cardState = (0, $hjhAz.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const data = cardState.details?.data;
    const ari = data && (0, $hWyvy.extractAri)(data);
    const dataUrl = data && (0, $8UXrm.extractLink)(data) || '';
    const onStart = (0, $5uXOq.useCallback)((id)=>{
        (0, $1VPdD.startUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
    }, []);
    const onSuccess = (0, $5uXOq.useCallback)((id)=>{
        fireEvent('operational.summary.success', {});
        (0, $1VPdD.succeedUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    const onError = (0, $5uXOq.useCallback)((id, reason)=>{
        /**
			 * Errors should only be counted to the SLO if they are not due to acceptable use violations
			 * HIPAA content detected or exceeding context length.
			 */ const isSloError = reason === undefined ? true : ![
            'ACCEPTABLE_USE_VIOLATIONS',
            'HIPAA_CONTENT_DETECTED',
            'EXCEEDING_CONTEXT_LENGTH_ERROR'
        ].includes(reason);
        fireEvent('operational.summary.failed', {
            reason: reason || null,
            isSloError: isSloError
        });
        (0, $1VPdD.failUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    return (0, $kR87P.useAISummary)({
        url: dataUrl,
        ari: ari,
        product: product,
        envKey: envKey,
        baseUrl: baseUrl,
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
var $27e30e18347ce2a0$export$2e2bcd8739ae039 = $27e30e18347ce2a0$var$useAISummaryAction;

});
parcelRegister("hWyvy", function(module, exports) {

$parcel$export(module.exports, "extractAri", () => $e72cc95d6d37b739$export$be18a6294fd426ec);
const $e72cc95d6d37b739$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
};

});

parcelRegister("8UXrm", function(module, exports) {

$parcel$export(module.exports, "extractLink", () => $c7ac01b191c63203$export$63f54cf4c5883620);

var $7OmtM = parcelRequire("7OmtM");
const $c7ac01b191c63203$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return (0, $7OmtM.extractUrlFromLinkJsonLd)(url);
    }
};

});

parcelRegister("kR87P", function(module, exports) {

$parcel$export(module.exports, "useAISummary", () => $c5395471ca862cc2$export$becd8f2eba1bbd96);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $VSDnB = parcelRequire("VSDnB");

var $SrCME = parcelRequire("SrCME");

var $561ku = parcelRequire("561ku");
const $c5395471ca862cc2$export$becd8f2eba1bbd96 = (props)=>{
    const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
    const [state, setState] = (0, $5uXOq.useState)((0, $561ku.AISummariesStore).get(url)?.state || {
        status: 'ready',
        content: ''
    });
    const { locale: locale } = (0, $VSDnB.fg)('send_locale_to_summarize_in_assistance-service') ? (0, $koVbs.default)() : {
        locale: undefined
    };
    (0, $5uXOq.useEffect)(()=>{
        //do not create a service for the empty URL string when the link data is not yet available,
        //or the service has already been created and cached.
        if (url && !(0, $561ku.AISummariesStore).get(url)) (0, $561ku.AISummariesStore).set(url, new (0, $SrCME.AISummaryService)({
            url: url,
            ari: ari,
            baseUrl: baseUrl,
            product: product,
            envKey: envKey,
            ...(0, $VSDnB.fg)('send_locale_to_summarize_in_assistance-service') && {
                locale: locale
            },
            onError: onError,
            onStart: onStart,
            onSuccess: onSuccess
        }));
        //returns function that calls unsubscribe method
        return (0, $561ku.AISummariesStore).get(url)?.subscribe(setState);
    }, [
        url,
        baseUrl,
        onError,
        onStart,
        onSuccess,
        product,
        ari,
        envKey,
        locale
    ]);
    const summariseUrl = ()=>{
        return (0, $561ku.AISummariesStore).get(url)?.summariseUrl();
    };
    return {
        summariseUrl: summariseUrl,
        state: state
    };
};

});
parcelRegister("SrCME", function(module, exports) {

$parcel$export(module.exports, "AISummaryService", () => $ad05438f1e08870b$export$73e4b807d5bd74b6);

var $7Jxgt = parcelRequire("7Jxgt");

var $itO4f = parcelRequire("itO4f");

var $VSDnB = parcelRequire("VSDnB");

var $9AA7J = parcelRequire("9AA7J");

var $c0Zwh = parcelRequire("c0Zwh");

var $ghXNq = parcelRequire("ghXNq");
class $ad05438f1e08870b$export$73e4b807d5bd74b6 {
    constructor(props){
        this.state = {
            content: '',
            status: 'ready'
        };
        this.subscribedStateSetters = new Set();
        this.getRequestUrl = (envKey, baseUrlOverride)=>{
            const path = 'assist/chat/v1/invoke_agent/stream';
            if (baseUrlOverride || envKey) {
                const baseUrl = baseUrlOverride || (0, $itO4f.getBaseUrl)(envKey);
                return (0, $ghXNq.addPath)(baseUrl, path);
            }
            return (0, $ghXNq.addPath)('/gateway/api/', path);
        };
        this.fetchStream = async ()=>{
            const payload = {
                recipient_agent_named_id: 'smartlink_summary_agent',
                agent_input_context: {
                    content_url: this.url,
                    content_ari: this.ari,
                    prompt_id: 'smart_links',
                    summary_output_mimetype: 'text/markdown',
                    ...(0, $VSDnB.fg)('send_locale_to_summarize_in_assistance-service') && {
                        locale: this.locale
                    }
                }
            };
            const options = {
                method: 'POST',
                headers: this.config.headers,
                body: JSON.stringify(payload),
                credentials: 'include'
            };
            const response = await fetch(this.config.requestUrl, options);
            if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
            else return (0, $9AA7J.readStream)(response);
        };
        this.config = {
            requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-experience-id': 'smart-link',
                'x-product': (0, $ghXNq.getXProductHeaderValue)(props.product)?.toLowerCase() || 'confluence'
            }
        };
        this.url = props.url;
        this.ari = props.ari;
        this.locale = props.locale;
        this.onStart = props.onStart;
        this.onSuccess = props.onSuccess;
        this.onError = props.onError;
    }
    async summariseUrl() {
        this.state = {
            status: 'loading',
            content: ''
        };
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
        try {
            this.onStart?.(id);
            const stream = await this.fetchStream();
            let bufferContent = '';
            for await (const chunk of stream){
                if (chunk.type === 'ANSWER_PART') {
                    bufferContent += chunk.message.content;
                    for (const subscriber of this.subscribedStateSetters)subscriber({
                        ...this.state,
                        content: bufferContent
                    });
                }
                //if AI Mate service returns cached summary we get the summary text in one piece as the last message
                if (chunk.type === 'FINAL_RESPONSE') bufferContent = chunk.message.message.content;
                if (chunk.type === 'ERROR') throw new (0, $c0Zwh.ChunkProcessingError)(chunk?.message?.message_template);
            }
            this.onSuccess?.(id);
            this.state = {
                status: 'done',
                content: bufferContent
            };
        } catch (err) {
            let message = err instanceof (0, $c0Zwh.ChunkProcessingError) ? err.message : 'UNEXPECTED';
            this.onError?.(id, message);
            this.state = {
                status: 'error',
                content: '',
                error: message
            };
        }
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        return this.state;
    }
    subscribe(stateSetter) {
        this.subscribedStateSetters.add(stateSetter);
        return ()=>{
            this.subscribedStateSetters.delete(stateSetter);
        };
    }
}

});
parcelRegister("9AA7J", function(module, exports) {

$parcel$export(module.exports, "readStream", () => $27dc203987154036$export$e45226161c660403);

var $ghXNq = parcelRequire("ghXNq");
async function* $27dc203987154036$export$e45226161c660403(response) {
    const reader = (0, $ghXNq.getBufferReader)(response);
    let doneStreaming = false;
    let chunkBuffer = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const processedChunks = `${chunkBuffer}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            chunkBuffer = '';
            for (let chunk of processedChunks)try {
                const jsonChunk = JSON.parse(chunk);
                if (jsonChunk.type === 'ERROR') reader.cancel();
                yield jsonChunk;
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                chunkBuffer = chunk;
            }
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else {
            reader.cancel();
            throw e;
        }
    }
    while (!doneStreaming);
    if (chunkBuffer) {
        const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
        throw error;
    }
}

});
parcelRegister("ghXNq", function(module, exports) {

$parcel$export(module.exports, "getBufferReader", () => $6c9c387ba5dd9d5b$export$f6383c3ea1307da9);
$parcel$export(module.exports, "addPath", () => $6c9c387ba5dd9d5b$export$4c25481b843feb0b);
$parcel$export(module.exports, "getXProductHeaderValue", () => $6c9c387ba5dd9d5b$export$ff2962de2b2c930f);
const $6c9c387ba5dd9d5b$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
const $6c9c387ba5dd9d5b$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */ const $6c9c387ba5dd9d5b$var$AiMateJiraXProduct = {
    JSM: 'JSM',
    JSW: 'JIRA-SOFTWARE',
    JWM: 'JIRA-CORE',
    JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */ const $6c9c387ba5dd9d5b$var$isJiraProduct = (product)=>{
    const JIRA_PRODUCTS = [
        'JPD',
        'JSM',
        'JSW',
        'JWM'
    ];
    return product !== undefined && JIRA_PRODUCTS.includes(product);
};
const $6c9c387ba5dd9d5b$export$ff2962de2b2c930f = (product)=>{
    if ($6c9c387ba5dd9d5b$var$isJiraProduct(product)) return $6c9c387ba5dd9d5b$var$AiMateJiraXProduct[product];
    return product;
};

});


parcelRegister("c0Zwh", function(module, exports) {

$parcel$export(module.exports, "ChunkProcessingError", () => $0e5f8d5a8019ed33$export$fcec967a4b7ebd84);
class $0e5f8d5a8019ed33$export$fcec967a4b7ebd84 extends Error {
    constructor(error){
        super(error);
    }
}
const $0e5f8d5a8019ed33$export$d8bd0967cb58683 = [
    'NETWORK_ERROR',
    'NO_ANSWER',
    'RATE_LIMIT',
    'NO_AGENT',
    'PLUGIN_ERRORED',
    'OPENAI_RATE_LIMIT_USER_ABUSE',
    'ACCEPTABLE_USE_VIOLATIONS',
    'AI_DISABLED',
    'UNEXPECTED',
    'HIPAA_CONTENT_DETECTED',
    'EXCEEDING_CONTEXT_LENGTH_ERROR'
];

});


parcelRegister("561ku", function(module, exports) {

$parcel$export(module.exports, "AISummariesStore", () => $cc472589618fd980$export$6979339b6d41707e);

var $iwKVT = parcelRequire("iwKVT");
const $cc472589618fd980$var$AI_SUMMARY_CACHE_SIZE = 100;
const $cc472589618fd980$export$6979339b6d41707e = new (0, $iwKVT.LRUMap)($cc472589618fd980$var$AI_SUMMARY_CACHE_SIZE);

});


parcelRegister("anB5s", function(module, exports) {

$parcel$export(module.exports, "useAISummaryConfig", () => $cd0a62b074a064ce$export$4480af2c00aa7ebe);

var $5uXOq = parcelRequire("5uXOq");

var $051X7 = parcelRequire("051X7");
const $cd0a62b074a064ce$export$4480af2c00aa7ebe = ()=>{
    const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $051X7.useSmartLinkContext)();
    return (0, $5uXOq.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        isAdminHubAIEnabled
    ]);
};

});


parcelRegister("8UCLX", function(module, exports) {

$parcel$export(module.exports, "AISummariseAction", () => $a2971ac1720627ee$export$75a19de44af58722);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $jps85 = parcelRequire("jps85");

var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $8z1HA = parcelRequire("8z1HA");

var $23vM5 = parcelRequire("23vM5");

var $blyr7 = parcelRequire("blyr7");
function $a2971ac1720627ee$export$75a19de44af58722({ url: url, onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const onCompleted = (0, $5uXOq.useCallback)((state)=>{
        if (state?.status === 'error') onErrorCallback?.((0, $blyr7.getErrorMessage)(state.error));
    }, [
        onErrorCallback
    ]);
    const handleActionClick = (0, $5uXOq.useCallback)(()=>{
        fireEvent('ui.button.clicked.aiSummary', {});
        fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        });
        summariseUrl()?.then(onCompleted, onCompleted);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        onCompleted,
        summariseUrl
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).ai_summary_action
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jps85))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Summarise with AI",
            LEGACY_fallbackIcon: (0, $8z1HA.default)
        }),
        onClick: handleActionClick,
        testId: `${testId}-summarise-action`,
        isLoading: status === 'loading',
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).ai_summary_action_description
        }),
        ...props
    });
}

});
parcelRegister("jps85", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d5c19b91ac54d446fcaff0cc7653cf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e2162c0618e136c6$var$_react = $e2162c0618e136c6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e2162c0618e136c6$var$_baseNew = $e2162c0618e136c6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e2162c0618e136c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence products or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e2162c0618e136c6$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $e2162c0618e136c6$var$_react.default.createElement($e2162c0618e136c6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m2 2 4 4m8 8-4-4m4-8-4 4m-8 8 4-4m2-9v3m0 8v3m7-7h-3M4 8H1"/>`
    }, props));
$e2162c0618e136c6$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $e2162c0618e136c6$var$_default = module.exports.default = $e2162c0618e136c6$var$AtlassianIntelligenceIcon;

});

parcelRegister("8z1HA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f8c2f1acb4b6b88$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dV6Te = parcelRequire("dV6Te");
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications
 */ const $7f8c2f1acb4b6b88$var$AiIcon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
                    fill: "var(--ds-icon, #44546F)"
                })
            ]
        })
    });
var $7f8c2f1acb4b6b88$export$2e2bcd8739ae039 = $7f8c2f1acb4b6b88$var$AiIcon;

});

parcelRegister("blyr7", function(module, exports) {

$parcel$export(module.exports, "getErrorMessage", () => $2b1346f84062e88d$export$82f46aa4e6535a45);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $cnaAy = parcelRequire("cnaAy");

var $RbANO = parcelRequire("RbANO");

var $1r4gF = parcelRequire("1r4gF");
const $2b1346f84062e88d$export$82f46aa4e6535a45 = (error)=>{
    const { message: message, url: url } = (0, $cnaAy.getAISummaryErrorMessage)(error);
    return {
        appearance: 'error',
        title: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $RbANO.default), {
                    reason: error
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...message,
                    values: {
                        a: (chunks)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1r4gF.default), {
                                href: url,
                                children: chunks
                            })
                    }
                })
            ]
        })
    };
};

});
parcelRegister("cnaAy", function(module, exports) {

$parcel$export(module.exports, "getIsAISummaryEnabled", () => $3339f41fc1b0dac1$export$d439c74cb206ff29);
$parcel$export(module.exports, "getAISummaryErrorMessage", () => $3339f41fc1b0dac1$export$cd2e891d7f87074d);

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");
const $3339f41fc1b0dac1$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>Boolean(isAdminHubAIEnabled && response?.meta?.supportedFeature?.includes('AISummary'));
const $3339f41fc1b0dac1$export$cd2e891d7f87074d = (error)=>{
    switch(error){
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                message: (0, $7zaVw.messages).ai_summary_error_acceptable_use_violation,
                url: (0, $8dVIb.CONTENT_URL_ACCEPTABLE_USE_POLICY)
            };
        case 'HIPAA_CONTENT_DETECTED':
            return {
                message: (0, $7zaVw.messages).ai_summary_error_hipaa_content_detected
            };
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return {
                message: (0, $7zaVw.messages).ai_summary_error_exceeding_context_length_error
            };
        default:
            return {
                message: (0, $7zaVw.messages).ai_summary_error_generic,
                url: (0, $8dVIb.CONTENT_URL_AI_TROUBLESHOOTING)
            };
    }
};

});

parcelRegister("RbANO", function(module, exports) {

$parcel$export(module.exports, "default", () => $402c39c7523f0dd1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $a1vqi = parcelRequire("a1vqi");
const $402c39c7523f0dd1$var$AIEventErrorViewed = ({ reason: reason })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        fireEvent('ui.error.viewed.aiSummary', {
            reason: reason
        });
    }, [
        fireEvent,
        reason
    ]);
    return null;
};
var $402c39c7523f0dd1$export$2e2bcd8739ae039 = $402c39c7523f0dd1$var$AIEventErrorViewed;

});

parcelRegister("1r4gF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff8f369a3b340dfb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");
const $ff8f369a3b340dfb$var$AILearnMoreAnchor = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        href: (0, $8dVIb.CONTENT_URL_AI),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props,
        children: children
    });
var $ff8f369a3b340dfb$export$2e2bcd8739ae039 = $ff8f369a3b340dfb$var$AILearnMoreAnchor;

});



parcelRegister("jdA9V", function(module, exports) {

$parcel$export(module.exports, "CopySummaryAction", () => $2e1357a85e616794$export$cfa1d3eed9a61059);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $3Fq5M = parcelRequire("3Fq5M");

var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $23vM5 = parcelRequire("23vM5");
function $2e1357a85e616794$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, testId: testId, content: content, ...props }) {
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)((0, $7zaVw.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $5uXOq.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(content ?? '');
        setTooltipMessage((0, $7zaVw.messages).copied_summary_action_description);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        content
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).copy_summary_action
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Fq5M))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Copy Summary"
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $7zaVw.messages).copy_summary_action_description),
        ...props
    });
}

});



parcelRegister("5OUwn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fd2a7343c5a2622$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $4ldhu = parcelRequire("4ldhu");

var $VSDnB = parcelRequire("VSDnB");

var $dS3PR = parcelRequire("dS3PR");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $7HAq8 = parcelRequire("7HAq8");

var $23vM5 = parcelRequire("23vM5");

var $lejnl = parcelRequire("lejnl");

var $e5vwM = parcelRequire("e5vwM");

var $3Lbo8 = parcelRequire("3Lbo8");

const $9fd2a7343c5a2622$var$AutomationModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("EjrMr")));
const $9fd2a7343c5a2622$var$AutomationActionNew = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const modal = (0, $7HAq8.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const automationActionData = context?.actions?.[(0, $8dVIb.ActionName).AutomationAction];
    const automationActionOnClick = (0, $5uXOq.useCallback)((automationActionData)=>{
        const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
        fireEvent('ui.button.clicked.automationAction', {});
        const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $3Lbo8.getModalContent)(product, resourceType) || {};
        const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...modalTitle
        }) : undefined;
        const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...modalDescription,
            values: {
                name: objectName,
                b: (chunks)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                        as: "strong",
                        children: chunks
                    }),
                br: /*#__PURE__*/ (0, $2OMIu.jsx)("br", {})
            }
        }) : undefined;
        modal.open(/*#__PURE__*/ (0, $2OMIu.jsx)($9fd2a7343c5a2622$var$AutomationModal, {
            baseAutomationUrl: baseAutomationUrl,
            objectAri: objectAri,
            siteAri: siteAri,
            canManageAutomation: canManageAutomation,
            analyticsSource: analyticsSource,
            modalTitle: automationModalTitle,
            modalDescription: automationModalDescription,
            onClose: ()=>modal.close()
        }));
        onClickCallback?.();
    }, [
        modal,
        onClickCallback,
        fireEvent
    ]);
    if (!automationActionData) return null;
    const automationActionTitle = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $7zaVw.messages).automation_action_title
    });
    const automationActionTooltip = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $7zaVw.messages).automation_action_tooltip
    });
    const automationActionIconLabel = formatMessage((0, $7zaVw.messages).automation_action_icon_label);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
            content: automationActionTitle,
            icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ldhu))), {
                spacing: "spacious",
                LEGACY_fallbackIcon: (0, $e5vwM.default),
                color: "currentColor",
                label: automationActionIconLabel
            }),
            testId: "smart-action-automation-action",
            tooltipMessage: automationActionTooltip,
            ...props,
            onClick: ()=>automationActionOnClick(automationActionData)
        })
    });
};
const $9fd2a7343c5a2622$var$AutomationAction = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($9fd2a7343c5a2622$var$AutomationActionNew, {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lejnl.default), {
        ...props
    });
};
var $9fd2a7343c5a2622$export$2e2bcd8739ae039 = $9fd2a7343c5a2622$var$AutomationAction;

});
parcelRegister("4ldhu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f63c4f2736d56f4b2fa41b3195f28f63>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32936cf628dec798$var$_react = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $32936cf628dec798$var$_baseNew = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $32936cf628dec798$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $32936cf628dec798$var$AutomationIcon = (props)=>/*#__PURE__*/ $32936cf628dec798$var$_react.default.createElement($32936cf628dec798$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6 15.25-.723-.2a.75.75 0 0 0 1.253.73zM13.25 8l.53.53a.75.75 0 0 0-.53-1.28zM10 .75l.723.2A.75.75 0 0 0 9.47.22zM2.75 8l-.53-.53a.75.75 0 0 0 .53 1.28zm3.78 7.78 7.25-7.25-1.06-1.06-7.25 7.25zm6.72-8.53H8v1.5h5.25zm-4.527.95 2-7.25-1.446-.4-2 7.25zM9.47.22 2.22 7.47l1.06 1.06 7.25-7.25zM2.75 8.75H8v-1.5H2.75zm4.527-.95-2 7.25 1.446.4 2-7.25z"/>`
    }, props));
$32936cf628dec798$var$AutomationIcon.displayName = 'AutomationIcon';
var $32936cf628dec798$var$_default = module.exports.default = $32936cf628dec798$var$AutomationIcon;

});

parcelRegister("7HAq8", function(module, exports) {

$parcel$export(module.exports, "SmartLinkModalProvider", () => $bc735e1cde43eb76$export$bb4eb02a83e1a0f8);
$parcel$export(module.exports, "useSmartLinkModal", () => $bc735e1cde43eb76$export$1fd7f5f21a6d6cb8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $lnPiq = parcelRequire("lnPiq");
const $bc735e1cde43eb76$var$FALLBACK_API = {
    open: ()=>{},
    close: ()=>{}
};
const $bc735e1cde43eb76$export$f4c0a0f23ba57f8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($bc735e1cde43eb76$var$FALLBACK_API);
const $bc735e1cde43eb76$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
    const [element, setElement] = (0, $5uXOq.useState)(null);
    const api = (0, $5uXOq.useMemo)(()=>({
            open: (modal)=>setElement(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lnPiq.StopPropagation), {
                        children: modal
                    })
                })),
            close: ()=>setElement(null)
        }), []);
    const fallbackRender = (0, $5uXOq.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
        resetErrorBoundary();
        return null;
    }, []);
    const onReset = (0, $5uXOq.useCallback)(()=>setElement(null), []);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($bc735e1cde43eb76$export$f4c0a0f23ba57f8c.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
                fallbackRender: fallbackRender,
                onReset: onReset,
                children: element
            })
        ]
    });
};
const $bc735e1cde43eb76$export$1fd7f5f21a6d6cb8 = ()=>(0, $5uXOq.useContext)($bc735e1cde43eb76$export$f4c0a0f23ba57f8c);

});
parcelRegister("lnPiq", function(module, exports) {

$parcel$export(module.exports, "StopPropagation", () => $a203465a8c9e0684$export$3e100bc08448f36c);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $2bDs4 = parcelRequire("2bDs4");
const $a203465a8c9e0684$var$styles = null;
const $a203465a8c9e0684$var$StopPropagationNew = ({ children: children })=>{
    const onClick = (0, $5uXOq.useCallback)((e)=>{
        // Prevent click event inside modal from bubble up
        e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        onClick: onClick,
        className: (0, $bwpsq.default)([
            "_c71lidpf _p12fidpf _kqswstnw"
        ]),
        children: children
    });
};
const $a203465a8c9e0684$export$3e100bc08448f36c = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($a203465a8c9e0684$var$StopPropagationNew, {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2bDs4.StopPropagationOld), {
        ...props
    });
};

});
parcelRegister("2bDs4", function(module, exports) {

$parcel$export(module.exports, "StopPropagationOld", () => $4cf488bb4bcc00de$export$5a70aec425a16ece);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");
function $4cf488bb4bcc00de$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4cf488bb4bcc00de$var$styles = {
    name: "g32yti",
    styles: "max-height:0;max-width:0;position:absolute"
};
const $4cf488bb4bcc00de$export$5a70aec425a16ece = ({ children: children })=>{
    const onClick = (0, $5uXOq.useCallback)((e)=>{
        // Prevent click event inside modal from bubble up
        e.stopPropagation();
    }, []);
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $4cf488bb4bcc00de$var$styles,
        onClick: onClick
    }, children));
};

});



parcelRegister("lejnl", function(module, exports) {

$parcel$export(module.exports, "default", () => $831a7b2b65090877$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $4ldhu = parcelRequire("4ldhu");

var $cgL5K = parcelRequire("cgL5K");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $7HAq8 = parcelRequire("7HAq8");

var $23vM5 = parcelRequire("23vM5");

var $e5vwM = parcelRequire("e5vwM");

var $3Lbo8 = parcelRequire("3Lbo8");

const $831a7b2b65090877$var$AutomationModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("EjrMr")));
const $831a7b2b65090877$var$AutomationActionOld = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const modal = (0, $7HAq8.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const automationActionData = context?.actions?.[(0, $8dVIb.ActionName).AutomationAction];
    const automationActionOnClick = (0, $5uXOq.useCallback)((automationActionData)=>{
        const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
        fireEvent('ui.button.clicked.automationAction', {});
        const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $3Lbo8.getModalContent)(product, resourceType) || {};
        const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...modalTitle
        }) : undefined;
        const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...modalDescription,
            values: {
                name: objectName,
                b: (chunks)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                        as: "strong",
                        children: chunks
                    }),
                br: /*#__PURE__*/ (0, $2OMIu.jsx)("br", {})
            }
        }) : undefined;
        modal.open(/*#__PURE__*/ (0, $2OMIu.jsx)($831a7b2b65090877$var$AutomationModal, {
            baseAutomationUrl: baseAutomationUrl,
            objectAri: objectAri,
            siteAri: siteAri,
            canManageAutomation: canManageAutomation,
            analyticsSource: analyticsSource,
            modalTitle: automationModalTitle,
            modalDescription: automationModalDescription,
            onClose: ()=>modal.close()
        }));
        onClickCallback?.();
    }, [
        modal,
        onClickCallback,
        fireEvent
    ]);
    if (!automationActionData) return null;
    const automationActionTitle = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $7zaVw.messages).automation_action_title
    });
    const automationActionTooltip = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $7zaVw.messages).automation_action_tooltip
    });
    const automationActionIconLabel = formatMessage((0, $7zaVw.messages).automation_action_icon_label);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
            content: automationActionTitle,
            icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ldhu))), {
                spacing: "spacious",
                LEGACY_fallbackIcon: (0, $e5vwM.default),
                color: "currentColor",
                label: automationActionIconLabel
            }),
            testId: "smart-action-automation-action",
            tooltipMessage: automationActionTooltip,
            ...props,
            onClick: ()=>automationActionOnClick(automationActionData)
        })
    });
};
var $831a7b2b65090877$export$2e2bcd8739ae039 = $831a7b2b65090877$var$AutomationActionOld;

});
parcelRegister("e5vwM", function(module, exports) {

$parcel$export(module.exports, "default", () => $23884530c116b98b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $23884530c116b98b$var$AutomationManualTriggersGlyph = ({ label: label })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        "aria-label": label,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M14 5L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M14 5L7 12H17L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $23884530c116b98b$export$2e2bcd8739ae039 = $23884530c116b98b$var$AutomationManualTriggersGlyph;

});

parcelRegister("3Lbo8", function(module, exports) {

$parcel$export(module.exports, "getModalContent", () => $6b74a4060fa13021$export$93e707b363eaf5c8);

var $7zaVw = parcelRequire("7zaVw");
const $6b74a4060fa13021$export$93e707b363eaf5c8 = (product, resourceType)=>{
    const modalContentMap = {
        confluence: {
            page: {
                modalTitle: (0, $7zaVw.messages).automation_action_confluence_page_modal_title,
                modalDescription: (0, $7zaVw.messages).automation_action_confluence_page_modal_description
            }
        }
    };
    return modalContentMap?.[product]?.[resourceType];
};

});

parcelRegister("EjrMr", function(module, exports) {

let $0792d252ffbcd5aa$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0792d252ffbcd5aa$var$load("hPzOn"),
    $0792d252ffbcd5aa$var$load("h2MrD"),
    $0792d252ffbcd5aa$var$load("bYT2S"),
    $0792d252ffbcd5aa$var$load("lchYl")
]).then(()=>parcelRequire('1Rjyb'));

});



parcelRegister("faTeC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b95acafe5e8a7ba5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $7HAq8 = parcelRequire("7HAq8");

var $23vM5 = parcelRequire("23vM5");

var $k98Kd = parcelRequire("k98Kd");

const $b95acafe5e8a7ba5$var$RelatedLinksModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("19m52")));
const $b95acafe5e8a7ba5$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
    const modal = (0, $7HAq8.useSmartLinkModal)();
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.ViewRelatedLinksAction;
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const ari = actionData?.ari;
        if (ari) modal.open(/*#__PURE__*/ (0, $2OMIu.jsx)($b95acafe5e8a7ba5$var$RelatedLinksModal, {
            ari: ari,
            showModal: true,
            onClose: ()=>modal.close()
        }));
        fireEvent('ui.button.clicked.relatedLinks', {});
        onClickCallback?.();
    }, [
        actionData?.ari,
        fireEvent,
        modal,
        onClickCallback
    ]);
    return actionData ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).related_links_view_related_urls
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k98Kd.default), {}),
        onClick: onClick,
        testId: "smart-action-view-related-links-action",
        ariaLabel: "View most recent pages or content types coming from or found on this link",
        ...props
    }) : null;
};
var $b95acafe5e8a7ba5$export$2e2bcd8739ae039 = $b95acafe5e8a7ba5$var$ViewRelatedLinksAction;

});
parcelRegister("k98Kd", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c9aac1bc71ae3e1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ehOs2 = parcelRequire("ehOs2");

var $VSDnB = parcelRequire("VSDnB");

var $cfYWA = parcelRequire("cfYWA");
const $7c9aac1bc71ae3e1$var$rotateSvg = null;
/**
 * ChildIssuesIcon but 180 degrees rotated
 */ const $7c9aac1bc71ae3e1$var$RelatedLinksActionIconNew = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_t9ec1sub _1e0c1o8l"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ehOs2))), {
            color: "currentColor",
            spacing: "spacious",
            label: "View recent links..."
        })
    });
const $7c9aac1bc71ae3e1$var$RelatedLinksActionIcon = ()=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($7c9aac1bc71ae3e1$var$RelatedLinksActionIconNew, {});
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cfYWA.default), {});
};
var $7c9aac1bc71ae3e1$export$2e2bcd8739ae039 = $7c9aac1bc71ae3e1$var$RelatedLinksActionIcon;

});
parcelRegister("ehOs2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7df931fb69dd4b6219148758c48ee3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a669c9c7dda1a2bd$var$_react = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a669c9c7dda1a2bd$var$_childIssues = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("a5U1O")));

var $a669c9c7dda1a2bd$var$_childIssues2 = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("hxodJ")));
function $a669c9c7dda1a2bd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChildIssuesIcon.
 * This component is ChildIssuesIcon, with `UNSAFE_fallbackIcon` set to "ChildIssuesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for child issues in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a669c9c7dda1a2bd$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $a669c9c7dda1a2bd$var$_react.default.createElement($a669c9c7dda1a2bd$var$_childIssues.default, Object.assign({
        LEGACY_fallbackIcon: $a669c9c7dda1a2bd$var$_childIssues2.default
    }, props));
$a669c9c7dda1a2bd$var$ChildIssuesIcon.Name = 'ChildIssuesIconMigration';
var $a669c9c7dda1a2bd$var$_default = module.exports.default = $a669c9c7dda1a2bd$var$ChildIssuesIcon;

});
parcelRegister("a5U1O", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a61c40139d910e35e43ae72e1295acfa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7595d510a7cf11ee$var$_react = $7595d510a7cf11ee$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7595d510a7cf11ee$var$_baseNew = $7595d510a7cf11ee$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $7595d510a7cf11ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChildIssues".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for child issues in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7595d510a7cf11ee$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $7595d510a7cf11ee$var$_react.default.createElement($7595d510a7cf11ee$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.75 12.25v1.5a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5zm0 0H3c-.69 0-1.25-.56-1.25-1.25V5.25m0-4.25v4.25m6 0v1.5a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5zm0 0h-6"/>`
    }, props));
$7595d510a7cf11ee$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $7595d510a7cf11ee$var$_default = module.exports.default = $7595d510a7cf11ee$var$ChildIssuesIcon;

});

parcelRegister("hxodJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc484e6d94653edf$var$_react = $cc484e6d94653edf$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $cc484e6d94653edf$var$_childIssues = $cc484e6d94653edf$var$_interopRequireDefault((parcelRequire("a5U1O")));
function $cc484e6d94653edf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cc484e6d94653edf$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $cc484e6d94653edf$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"/><path d="M7 11h10a1 1 0 0 1 1 1v1H6v-1a1 1 0 0 1 1-1"/><path fill-rule="nonzero" d="M5 18v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2m10 2v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2M10 5v1h4V5zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"/></g></svg>`
    }, props, {
        newIcon: $cc484e6d94653edf$var$_childIssues.default
    }));
$cc484e6d94653edf$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $cc484e6d94653edf$var$_default = module.exports.default = $cc484e6d94653edf$var$ChildIssuesIcon;

});


parcelRegister("cfYWA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3775a8c9b9ec23c2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $ehOs2 = parcelRequire("ehOs2");
function $3775a8c9b9ec23c2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3775a8c9b9ec23c2$var$rotateSvg = {
    name: "9v7l5f",
    styles: "transform:rotate(180deg);display:inline-block"
};
/**
 * ChildIssuesIcon but 180 degrees rotated
 */ const $3775a8c9b9ec23c2$var$RelatedLinksActionIconOld = ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $3775a8c9b9ec23c2$var$rotateSvg
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ehOs2))), {
        color: "currentColor",
        spacing: "spacious",
        label: "View recent links..."
    }));
var $3775a8c9b9ec23c2$export$2e2bcd8739ae039 = $3775a8c9b9ec23c2$var$RelatedLinksActionIconOld;

});


parcelRegister("19m52", function(module, exports) {

let $0d67c25d523d11e2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0d67c25d523d11e2$var$load("dXU8n").then(()=>parcelRequire('14MtF'));

});




parcelRegister("fFcX8", function(module, exports) {

$parcel$export(module.exports, "default", () => $f23c7150d4c586bb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ousew = parcelRequire("ousew");

var $gKZoD = parcelRequire("gKZoD");

var $ldJSL = parcelRequire("ldJSL");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");

var $bJeNF = parcelRequire("bJeNF");

var $3bDjY = parcelRequire("3bDjY");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $fpDmE = parcelRequire("fpDmE");

var $akF1x = parcelRequire("akF1x");

var $3Zm9O = parcelRequire("3Zm9O");
function $f23c7150d4c586bb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f23c7150d4c586bb$var$styles = {
    name: "inf63k",
    styles: "display:inline-flex;line-height:1rem;> div{align-items:center;button:focus-visible{outline-offset:var(--ds-space-negative-025, -2px);}}"
};
const $f23c7150d4c586bb$var$renderActionItems = (items = [], size = (0, $8dVIb.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3Zm9O.default), {
            item: item,
            key: idx,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        }));
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $f23c7150d4c586bb$var$ActionGroupOld = ({ items: items = [], size: size = (0, $8dVIb.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange })=>{
    (0, $gKZoD.di)((0, $BLPHT.default));
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const renderableActionItems = (0, $5uXOq.useMemo)(()=>(0, $akF1x.filterActionItems)(items, context), [
        context,
        items
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const onOpenChange = (0, $5uXOq.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $5uXOq.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $5uXOq.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $f23c7150d4c586bb$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum
    ]);
    const moreActionDropdown = (0, $5uXOq.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const spacing = (0, $fpDmE.sizeToButtonSpacing)[size];
            const moreIcon = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                label: "more",
                color: "currentColor"
            });
            const formatMessage = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $7zaVw.messages).more_actions);
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $BLPHT.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span"
                    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fVnbM.default), {
                        ...props,
                        spacing: spacing,
                        testId: "action-group-more-button",
                        iconBefore: moreIcon,
                        ref: triggerRef
                    })),
                testId: "action-group-dropdown",
                zIndex: ui?.zIndex
            }, $f23c7150d4c586bb$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick));
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui?.zIndex,
        visibleButtonsNum
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $f23c7150d4c586bb$var$styles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "actions-button-group",
        "data-action-open": isOpen
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ldJSL.default), null, actionButtons, moreActionDropdown)) : null;
};
var $f23c7150d4c586bb$export$2e2bcd8739ae039 = $f23c7150d4c586bb$var$ActionGroupOld;

});


parcelRegister("dghu0", function(module, exports) {

$parcel$export(module.exports, "default", () => $96a6d91fb5d77548$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $akF1x = parcelRequire("akF1x");

var $3YqTr = parcelRequire("3YqTr");
const $96a6d91fb5d77548$var$BaseBlockStyles = null;
const $96a6d91fb5d77548$var$highlightRemoveStyles = null;
const $96a6d91fb5d77548$var$gapsStyles = {
    xlarge: "_zulp1k92 _1ljq1k92",
    large: "_zulp1j6v _1ljq1j6v",
    medium: "_zulp1kwk _1ljq1kwk",
    small: "_zulp6mu8 _1ljq6mu8"
};
const $96a6d91fb5d77548$var$directionStyles = {
    vertical: "_2lx21bp4 _4cvr1y6m",
    horizontal: "_2lx2vrvc _4cvr1h6o"
};
/**
 * A block represents a collection of elements and actions that are arranged
 * in a row. All elements and actions should be contained within a Block.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $96a6d91fb5d77548$var$BlockNew = ({ children: children, direction: direction = (0, $8dVIb.SmartLinkDirection).Horizontal, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-block', className: className, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd, style: style })=>{
    (0, $5uXOq.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _4cvr1h6o _vwz41j6v _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1ouwidpf _f6ju1ns9 _1uzp1mp2 _ytq1bjq5 _a7e8uxlv",
            "_12ji1snc _1qu2agmp _12y310yn _12ji1kw7 _syaz1kw7 _18ql1j28 _1ifmglyw _181uglyw _1rkwglyw _te17glyw _uiztglyw",
            $96a6d91fb5d77548$var$directionStyles[direction],
            $96a6d91fb5d77548$var$gapsStyles[size],
            className
        ]),
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        children: (0, $akF1x.renderChildren)(children, size)
    });
};
const $96a6d91fb5d77548$var$Block = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($96a6d91fb5d77548$var$BlockNew, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3YqTr.default), {
        ...props
    });
};
var $96a6d91fb5d77548$export$2e2bcd8739ae039 = $96a6d91fb5d77548$var$Block;

});
parcelRegister("3YqTr", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dbed1cfa38332fb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8dVIb = parcelRequire("8dVIb");

var $akF1x = parcelRequire("akF1x");
const $4dbed1cfa38332fb$var$getBlockStyles = (direction, size)=>/*#__PURE__*/ (0, $f8Sb3.css)((0, $akF1x.getBaseStyles)(direction, size), " ", (0, $akF1x.highlightRemoveStyles), " justify-content:flex-start;[data-separator]+[data-separator]:before{content:'\u2022';margin-right:", (0, $akF1x.getGapSize)(size), "rem;}[data-smart-element='", (0, $8dVIb.ElementName).SourceBranch, "']+[data-smart-element='", (0, $8dVIb.ElementName).TargetBranch, "']:before{content:'\u2192';}[data-smart-element='", (0, $8dVIb.ElementName).TargetBranch, "']+[data-smart-element='", (0, $8dVIb.ElementName).SourceBranch, "']:before{content:'\u2190';}");
/**
 * A block represents a collection of elements and actions that are arranged
 * in a row. All elements and actions should be contained within a Block.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $4dbed1cfa38332fb$var$Block = ({ children: children, direction: direction = (0, $8dVIb.SmartLinkDirection).Horizontal, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-block', overrideCss: overrideCss, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd })=>{
    (0, $5uXOq.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $4dbed1cfa38332fb$var$getBlockStyles(direction, size),
            overrideCss
        ],
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef
    }, (0, $akF1x.renderChildren)(children, size));
};
var $4dbed1cfa38332fb$export$2e2bcd8739ae039 = $4dbed1cfa38332fb$var$Block;

});


parcelRegister("dEOWY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3d7291a62484db7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $eqoQu = parcelRequire("eqoQu");

var $bubxq = parcelRequire("bubxq");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $akF1x = parcelRequire("akF1x");
const $e3d7291a62484db7$var$FooterBlockResolvedViewOld = (props)=>{
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $8dVIb.SmartLinkSize).Medium, hideProvider: hideProvider } = props;
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const hasActions = (0, $5uXOq.useMemo)(()=>(0, $akF1x.filterActionItems)(actions, context)?.length > 0, [
        actions,
        context
    ]);
    const onDropdownOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            !hideProvider && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.Provider), {
                testId: `${testId}-provider`
            }),
            actions && hasActions ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                testId: "smart-element-group-actions",
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                overrideCss: (0, $akF1x.getActionGroupStyles)(size),
                width: (0, $8dVIb.SmartLinkWidth).Flexible,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bubxq.default), {
                    onDropdownOpenChange: onDropdownOpenChange,
                    items: actions,
                    appearance: "default"
                })
            }) : null
        ]
    });
};
var $e3d7291a62484db7$export$2e2bcd8739ae039 = $e3d7291a62484db7$var$FooterBlockResolvedViewOld;

});



parcelRegister("gg6Qm", function(module, exports) {

$parcel$export(module.exports, "default", () => $61dcf60a0013442f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $akF1x = parcelRequire("akF1x");

var $3M28Q = parcelRequire("3M28Q");
const $61dcf60a0013442f$var$DEFAULT_MAX_LINES = 2;
const $61dcf60a0013442f$var$MAXIMUM_MAX_LINES = 2;
const $61dcf60a0013442f$var$MINIMUM_MAX_LINES = 1;
const $61dcf60a0013442f$var$truncateStyles = {
    '1': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54",
    '2': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjcs5v _sudp1e54"
};
const $61dcf60a0013442f$var$sizeStyles = {
    xlarge: "_vwz41m1q _102k1k7u",
    large: "_vwz41m1q _102k1k7u",
    medium: "_vwz41k8s _102k1wto",
    small: "_vwz41k8s _102k1wto"
};
const $61dcf60a0013442f$var$getMaxLines = (maxLines)=>{
    if (maxLines > $61dcf60a0013442f$var$MAXIMUM_MAX_LINES) return $61dcf60a0013442f$var$DEFAULT_MAX_LINES;
    if (maxLines < $61dcf60a0013442f$var$MINIMUM_MAX_LINES) return $61dcf60a0013442f$var$MINIMUM_MAX_LINES;
    return maxLines;
};
/**
 * Represents a MetadataBlock, designed to contain groups of metadata in the form of elements.
 * Accepts an array of elements to be shown either primary (left hand side) or secondary (right hand side).
 * @public
 * @param {MetadataBlockProps} MetadataBlockProps
 * @see Block
 */ const $61dcf60a0013442f$var$MetadataBlock = ({ maxLines: maxLines = $61dcf60a0013442f$var$DEFAULT_MAX_LINES, status: status = (0, $8dVIb.SmartLinkStatus).Fallback, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    if (primary.length === 0 && secondary.length === 0 || status !== (0, $8dVIb.SmartLinkStatus).Resolved) return null;
    const primaryElements = (0, $akF1x.renderElementItems)(primary);
    const secondaryElements = (0, $akF1x.renderElementItems)(secondary);
    const { size: size = (0, $8dVIb.SmartLinkSize).Medium } = blockProps;
    const maxLinesTotal = $61dcf60a0013442f$var$getMaxLines(maxLines);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        children: [
            primaryElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                align: (0, $8dVIb.SmartLinkAlignment).Left,
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                width: (0, $8dVIb.SmartLinkWidth).Flexible,
                size: size,
                className: (0, $bwpsq.default)([
                    $61dcf60a0013442f$var$truncateStyles[maxLinesTotal],
                    $61dcf60a0013442f$var$sizeStyles[size]
                ]),
                children: primaryElements
            }),
            secondaryElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                width: (0, $8dVIb.SmartLinkWidth).Flexible,
                size: size,
                className: (0, $bwpsq.default)([
                    $61dcf60a0013442f$var$truncateStyles[maxLinesTotal],
                    $61dcf60a0013442f$var$sizeStyles[size]
                ]),
                children: secondaryElements
            })
        ]
    });
};
const $61dcf60a0013442f$var$MetadataBlockExported = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($61dcf60a0013442f$var$MetadataBlock, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3M28Q.default), {
        ...props
    });
};
var $61dcf60a0013442f$export$2e2bcd8739ae039 = $61dcf60a0013442f$var$MetadataBlockExported;

});
parcelRegister("3M28Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7c294272d295a9c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8dVIb = parcelRequire("8dVIb");

var $fpDmE = parcelRequire("fpDmE");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $akF1x = parcelRequire("akF1x");
const $c7c294272d295a9c$var$DEFAULT_MAX_LINES = 2;
const $c7c294272d295a9c$var$MAXIMUM_MAX_LINES = 2;
const $c7c294272d295a9c$var$MINIMUM_MAX_LINES = 1;
const $c7c294272d295a9c$var$getElementGroupStyles = (size, maxLines)=>{
    // MetadataBlock allows metadata elements to be displayed in
    // multiple lines, with maximum of 2 lines.
    // We need the height of the line to be equal on both left and right
    // sides so they line up nicely.
    const lineHeight = (0, $fpDmE.getMaxLineHeight)(size);
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
        lineHeight: `${lineHeight}rem`
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $fpDmE.getTruncateStyles)(maxLines, lineHeight + 'rem'));
};
const $c7c294272d295a9c$var$getMaxLines = (maxLines)=>{
    if (maxLines > $c7c294272d295a9c$var$MAXIMUM_MAX_LINES) return $c7c294272d295a9c$var$DEFAULT_MAX_LINES;
    if (maxLines < $c7c294272d295a9c$var$MINIMUM_MAX_LINES) return $c7c294272d295a9c$var$MINIMUM_MAX_LINES;
    return maxLines;
};
/**
 * Represents a MetadataBlock, designed to contain groups of metadata in the form of elements.
 * Accepts an array of elements to be shown either primary (left hand side) or secondary (right hand side).
 * @public
 * @param {MetadataBlockProps} MetadataBlockProps
 * @see Block
 */ const $c7c294272d295a9c$var$MetadataBlockOld = ({ maxLines: maxLines = $c7c294272d295a9c$var$DEFAULT_MAX_LINES, status: status = (0, $8dVIb.SmartLinkStatus).Fallback, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    if (primary.length === 0 && secondary.length === 0 || status !== (0, $8dVIb.SmartLinkStatus).Resolved) return null;
    const primaryElements = (0, $akF1x.renderElementItems)(primary);
    const secondaryElements = (0, $akF1x.renderElementItems)(secondary);
    const { size: size = (0, $8dVIb.SmartLinkSize).Medium } = blockProps;
    const elementGroupStyles = $c7c294272d295a9c$var$getElementGroupStyles(size, $c7c294272d295a9c$var$getMaxLines(maxLines));
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        children: [
            primaryElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                align: (0, $8dVIb.SmartLinkAlignment).Left,
                overrideCss: elementGroupStyles,
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                width: (0, $8dVIb.SmartLinkWidth).Flexible,
                children: primaryElements
            }),
            secondaryElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                overrideCss: elementGroupStyles,
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                width: (0, $8dVIb.SmartLinkWidth).Flexible,
                children: secondaryElements
            })
        ]
    });
};
var $c7c294272d295a9c$export$2e2bcd8739ae039 = $c7c294272d295a9c$var$MetadataBlockOld;

});


parcelRegister("hYQw7", function(module, exports) {

$parcel$export(module.exports, "default", () => $61b44b31e2da1312$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $lee4B = parcelRequire("lee4B");

var $cElbi = parcelRequire("cElbi");
/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */ const $61b44b31e2da1312$var$PreviewBlock = ({ status: // eslint-disable-next-line @typescript-eslint/no-unused-vars
status = (0, $8dVIb.SmartLinkStatus).Fallback, testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cElbi.default), {
        ...blockProps,
        testId: testId,
        overrideUrl: overrideUrl
    });
};
const $61b44b31e2da1312$var$Exported = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($61b44b31e2da1312$var$PreviewBlock, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lee4B.default), {
        ...props
    });
};
var $61b44b31e2da1312$export$2e2bcd8739ae039 = $61b44b31e2da1312$var$Exported;

});
parcelRegister("lee4B", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b73d97a5b5ddede$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $8dVIb = parcelRequire("8dVIb");

var $8cCud = parcelRequire("8cCud");
/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */ const $1b73d97a5b5ddede$var$PreviewBlock = ({ status: // eslint-disable-next-line @typescript-eslint/no-unused-vars
status = (0, $8dVIb.SmartLinkStatus).Fallback, testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8cCud.default), {
        ...blockProps,
        testId: testId,
        overrideUrl: overrideUrl
    });
};
var $1b73d97a5b5ddede$export$2e2bcd8739ae039 = $1b73d97a5b5ddede$var$PreviewBlock;

});
parcelRegister("8cCud", function(module, exports) {

$parcel$export(module.exports, "default", () => $85cff883015122f8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8dVIb = parcelRequire("8dVIb");

var $kDhrr = parcelRequire("kDhrr");

var $dghu0 = parcelRequire("dghu0");
function $85cff883015122f8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Due to its placement on the left/right and ignoreContainerPadding prop
 * rely on its parent container styling, css variables are declared in
 * <Container /> to preset the base values for the preview block styling.
 *
 * `--container-padding` is the padding of the Container. This value is based
 *   on size and hidePadding.
 * `--container-gap-left` and `--container-gap-right` are the gap or padding of
 *   the Container depending on whether the container has other preview blocks
 *   with left/right positioning.
 * `--preview-block-width` is the size of the preview image in relation to
 *   the Container width when the placement is left/right.
 * @param placement
 * @param ignoreContainerPadding
 */ var $85cff883015122f8$var$_ref = {
    name: "ooh6hm",
    styles: "margin-left:calc(var(--container-gap-left) * -1);margin-right:calc(var(--container-gap-right) * -1);&:first-of-type{margin-top:calc(var(--container-padding) * -1);}&:last-of-type{margin-bottom:calc(var(--container-padding) * -1);}"
};
const $85cff883015122f8$var$getPreviewBlockStyles = (placement, ignoreContainerPadding)=>{
    if (placement === (0, $8dVIb.MediaPlacement).Left || placement === (0, $8dVIb.MediaPlacement).Right) {
        const containerPadding = ignoreContainerPadding ? '0rem' : 'var(--container-padding)';
        // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
        return /*#__PURE__*/ (0, $f8Sb3.css)("position:absolute;top:", containerPadding, ";bottom:", containerPadding, ";width:calc(var(--preview-block-width) - ", containerPadding, ");", placement === (0, $8dVIb.MediaPlacement).Left ? `left: ${containerPadding};` : '', " ", placement === (0, $8dVIb.MediaPlacement).Right ? `right: ${containerPadding};` : '', " [data-smart-element-media='image']{aspect-ratio:unset;padding-top:unset;width:100%;height:100%;object-fit:cover;}");
    }
    if (ignoreContainerPadding) return $85cff883015122f8$var$_ref;
};
/**
 * Represents a resolved PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlock} PreviewBlock
 * @see Block
 */ const $85cff883015122f8$var$PreviewBlockResolvedViewOld = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, overrideCss: overrideCss, placement: placement, testId: testId, overrideUrl: overrideUrl, ...blockProps })=>{
    const [styles, setStyles] = (0, $5uXOq.useState)(overrideCss);
    const updateStyles = (0, $5uXOq.useCallback)(()=>{
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        setStyles(/*#__PURE__*/ (0, $f8Sb3.css)($85cff883015122f8$var$getPreviewBlockStyles(placement, ignoreContainerPadding), overrideCss));
    }, [
        ignoreContainerPadding,
        overrideCss,
        placement
    ]);
    (0, $5uXOq.useEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        overrideCss,
        placement,
        updateStyles
    ]);
    const handleOnLoad = (0, $5uXOq.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $5uXOq.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dghu0.default), {
        ...blockProps,
        overrideCss: styles,
        testId: `${testId}-resolved-view`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kDhrr.default), {
        onError: handleOnError,
        onLoad: handleOnLoad,
        overrideUrl: overrideUrl
    }));
};
var $85cff883015122f8$export$2e2bcd8739ae039 = $85cff883015122f8$var$PreviewBlockResolvedViewOld;

});


parcelRegister("cElbi", function(module, exports) {

$parcel$export(module.exports, "default", () => $64981f7edc74268b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $kDhrr = parcelRequire("kDhrr");

var $dghu0 = parcelRequire("dghu0");

var $8cCud = parcelRequire("8cCud");
const $64981f7edc74268b$var$previewBlockStyleCommon = null;
const $64981f7edc74268b$var$ignoreContainerPaddingStyle = null;
/**
 * Represents a resolved PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlock} PreviewBlock
 * @see Block
 */ const $64981f7edc74268b$var$PreviewBlockResolvedViewNew = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, placement: placement, testId: testId, overrideUrl: overrideUrl, style: style, className: className, ...blockProps })=>{
    // const [styles, setStyles] = useState<SerializedStyles | undefined>(overrideCss);
    const [dynamicStyles, setDynamicStyles] = (0, $5uXOq.useState)(style ?? {});
    const updateStyles = (0, $5uXOq.useCallback)(()=>{
        if (placement === (0, $8dVIb.MediaPlacement).Left || placement === (0, $8dVIb.MediaPlacement).Right) {
            const containerPadding = ignoreContainerPadding ? '0rem' : 'var(--container-padding)';
            const newStyle = {
                ...style,
                position: 'absolute',
                top: containerPadding,
                bottom: containerPadding,
                width: `calc(var(--preview-block-width) - ${containerPadding})`,
                ...placement === (0, $8dVIb.MediaPlacement).Left ? {
                    left: containerPadding
                } : {},
                ...placement === (0, $8dVIb.MediaPlacement).Right ? {
                    right: containerPadding
                } : {}
            };
            setDynamicStyles(newStyle);
        } else if (ignoreContainerPadding) setDynamicStyles({
            ...style
        });
    }, [
        ignoreContainerPadding,
        placement,
        style
    ]);
    (0, $5uXOq.useEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        placement,
        updateStyles,
        className
    ]);
    const handleOnLoad = (0, $5uXOq.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $5uXOq.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            placement && "_1t26n7od _ze72n7od _10aa1osq _rjuj1osq _mr051dfr",
            !placement && ignoreContainerPadding && "_18u01ivi _2hwxc10g _e0oi1ya9 _dmhj1ya9",
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kDhrr.default), {
            onError: handleOnError,
            onLoad: handleOnLoad,
            overrideUrl: overrideUrl
        })
    });
};
const $64981f7edc74268b$var$PreviewBlockResolvedView = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($64981f7edc74268b$var$PreviewBlockResolvedViewNew, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8cCud.default), {
        ...props
    });
};
var $64981f7edc74268b$export$2e2bcd8739ae039 = $64981f7edc74268b$var$PreviewBlockResolvedView;

});


parcelRegister("1JaZ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c880264dd5ccb40b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $kp8aU = parcelRequire("kp8aU");

var $fpDmE = parcelRequire("fpDmE");

var $dghu0 = parcelRequire("dghu0");
const $c880264dd5ccb40b$var$DEFAULT_MAX_LINES = 3;
const $c880264dd5ccb40b$var$MAXIMUM_MAX_LINES = 6;
const $c880264dd5ccb40b$var$MINIMUM_MAX_LINES = 1;
/**
 * Represents a SnippetBlock, which is used to display longer form text content, like descriptions.
 * @public
 * @param {SnippetBlockProps} SnippetBlockProps
 * @see Block
 */ const $c880264dd5ccb40b$var$SnippetBlock = ({ maxLines: maxLines = $c880264dd5ccb40b$var$DEFAULT_MAX_LINES, status: status = (0, $8dVIb.SmartLinkStatus).Fallback, testId: testId = 'smart-block-snippet', text: text, ...blockProps })=>{
    if (status !== (0, $8dVIb.SmartLinkStatus).Resolved && !text) return null;
    const snippetMaxLines = (0, $fpDmE.getMaxLines)(maxLines, $c880264dd5ccb40b$var$DEFAULT_MAX_LINES, $c880264dd5ccb40b$var$MAXIMUM_MAX_LINES, $c880264dd5ccb40b$var$MINIMUM_MAX_LINES);
    const statusTestId = !text ? 'resolved' : 'non-resolved';
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-${statusTestId}-view`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kp8aU.default), {
            maxLines: snippetMaxLines,
            content: text
        })
    });
};
var $c880264dd5ccb40b$export$2e2bcd8739ae039 = $c880264dd5ccb40b$var$SnippetBlock;

});

parcelRegister("buvhv", function(module, exports) {

$parcel$export(module.exports, "default", () => $93b66054384f48ec$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $4URMI = parcelRequire("4URMI");

var $eqoQu = parcelRequire("eqoQu");

var $bubxq = parcelRequire("bubxq");

var $fkxMX = parcelRequire("fkxMX");

var $bXy5i = parcelRequire("bXy5i");

var $jHa2h = parcelRequire("jHa2h");

var $lVptR = parcelRequire("lVptR");
const $93b66054384f48ec$var$actionStyles = null;
const $93b66054384f48ec$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $8dVIb.SmartLinkStatus).Pending:
        case (0, $8dVIb.SmartLinkStatus).Resolving:
            return 0, $jHa2h.default;
        case (0, $8dVIb.SmartLinkStatus).Resolved:
            return 0, $bXy5i.default;
        case (0, $8dVIb.SmartLinkStatus).Unauthorized:
        case (0, $8dVIb.SmartLinkStatus).Forbidden:
        case (0, $8dVIb.SmartLinkStatus).NotFound:
        case (0, $8dVIb.SmartLinkStatus).Errored:
        case (0, $8dVIb.SmartLinkStatus).Fallback:
        default:
            return 0, $fkxMX.default;
    }
};
/**
 * Represents a TitleBlock, which is the foundation of Flexible UI.
 * This contains an icon, the link, and any associated metadata and actions in one block.
 * The TitleBlock will also render differently given the state of the smart link.
 * This can be found in the corresponding Resolving, Resolved and Errored views.
 * @public
 * @param {TitleBlockProps} TitleBlockProps
 * @see Block
 * @see TitleBlockResolvingViewNew
 * @see TitleBlockResolvedViewNew
 * @see TitleBlockErroredViewNew
 */ const $93b66054384f48ec$var$TitleBlockNew = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, onClick: onClick, status: status = (0, $8dVIb.SmartLinkStatus).Fallback, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, theme: theme, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, className: className, ...props })=>{
    if (hideRetry && props.retry) delete props.retry;
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $5uXOq.useState)(false);
    const onDropdownOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bubxq.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $4URMI.useMouseDownEvent)();
    const title = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.Title), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: anchorTarget,
        theme: theme,
        ...overrideText
    });
    const Component = $93b66054384f48ec$var$getTitleBlockViewComponent(status);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        ...props,
        actionGroup: actionGroup,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            showActionOnHover && !actionDropdownOpen && "_1bfhidpf _wn5xkb7n _h157kb7n",
            className
        ]),
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        icon: icon,
        size: props.size,
        theme: theme
    });
};
const $93b66054384f48ec$var$TitleBlock = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($93b66054384f48ec$var$TitleBlockNew, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lVptR.default), {
        ...props
    });
};
var $93b66054384f48ec$export$2e2bcd8739ae039 = $93b66054384f48ec$var$TitleBlock;

});
parcelRegister("fkxMX", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcbea6814ca213c7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $8dVIb = parcelRequire("8dVIb");

var $eqoQu = parcelRequire("eqoQu");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $4itqr = parcelRequire("4itqr");
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $dcbea6814ca213c7$var$TitleBlockErroredViewNew = ({ actionGroup: actionGroup, retry: retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, ...blockProps })=>{
    const { descriptor: descriptor, onClick: onClick, values: values } = retry || {};
    const hasAction = onClick !== undefined;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-errored-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.LinkIcon), {
                overrideIcon: icon,
                position: position
            }),
            title,
            descriptor && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    onClick: onClick,
                    testId: `${testId}-errored-view-message`,
                    tabIndex: hasAction ? 0 : -1,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...descriptor,
                        values: values
                    })
                })
            }),
            actionGroup
        ]
    });
};
const $dcbea6814ca213c7$var$TitleBlockErroredView = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($dcbea6814ca213c7$var$TitleBlockErroredViewNew, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4itqr.default), {
        ...props
    });
};
var $dcbea6814ca213c7$export$2e2bcd8739ae039 = $dcbea6814ca213c7$var$TitleBlockErroredView;

});
parcelRegister("4itqr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccd5bf7c2b7a739e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $ousew = parcelRequire("ousew");

var $dC5iT = parcelRequire("dC5iT");

var $8dVIb = parcelRequire("8dVIb");

var $eqoQu = parcelRequire("eqoQu");

var $fpDmE = parcelRequire("fpDmE");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");
function $ccd5bf7c2b7a739e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ccd5bf7c2b7a739e$var$actionStyles = {
    name: "r982j0",
    styles: "cursor:pointer;:hover{color:var(--ds-text-subtle, #8993A4);text-decoration:underline;}"
};
const $ccd5bf7c2b7a739e$var$actionHoverStyles = {
    name: "y4wzay",
    styles: "position:relative;z-index:1;&:focus{outline-offset:var(--ds-space-negative-025, -2px);}"
};
/**
 * This function does not work in the component below as it needs to be xcss.
 * The component instead uses inherited styles
 */ const $ccd5bf7c2b7a739e$var$getMessageStyles = (size, hasAction)=>{
    const sizeStyles = (0, $fpDmE.getLinkSizeStyles)(size);
    return /*#__PURE__*/ (0, $f8Sb3.css)("flex:1 1 auto;justify-content:flex-end;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    hasAction ? $ccd5bf7c2b7a739e$var$actionStyles : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    sizeStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $fpDmE.getTruncateStyles)(1, (0, $fpDmE.getLinkLineHeight)(size)), {
        color: "var(--ds-text-disabled, #6B778C)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':focus': {
            outline: `${"var(--ds-border-focused, #388BFF)"} solid 2px`
        }
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    hasAction ? $ccd5bf7c2b7a739e$var$actionHoverStyles : '');
};
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $ccd5bf7c2b7a739e$var$TitleBlockErroredViewOld = ({ actionGroup: actionGroup, retry: retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, ...blockProps })=>{
    const { descriptor: descriptor, onClick: onClick, values: values } = retry || {};
    const { size: size = (0, $8dVIb.SmartLinkSize).Medium } = blockProps;
    const hasAction = onClick !== undefined;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-errored-view`
    }, !hideIcon && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eqoQu.LinkIcon), {
        overrideIcon: icon,
        position: position
    }), title, descriptor && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1BfaB.default), {
        direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
        align: (0, $8dVIb.SmartLinkAlignment).Right
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        xcss: $ccd5bf7c2b7a739e$var$getMessageStyles(size, hasAction),
        onClick: onClick,
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : -1
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), {
        ...descriptor,
        values: values
    }))), actionGroup);
};
var $ccd5bf7c2b7a739e$export$2e2bcd8739ae039 = $ccd5bf7c2b7a739e$var$TitleBlockErroredViewOld;

});


parcelRegister("bXy5i", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2967317da51f9f7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $eqoQu = parcelRequire("eqoQu");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $akF1x = parcelRequire("akF1x");

var $jSZrF = parcelRequire("jSZrF");
const $e2967317da51f9f7$var$style = null;
/**
 * This renders a fully resolved TitleBlock.
 * This should render when a Smart Link returns a valid response.
 * @see TitleBlock
 */ const $e2967317da51f9f7$var$TitleBlockResolvedViewNew = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size } = blockProps;
    const metadataElements = (0, $akF1x.renderElementItems)(metadata);
    const subtitleElements = (0, $akF1x.renderElementItems)(subtitle);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.LinkIcon), {
                overrideIcon: icon,
                position: position,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
                    size: size
                }
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1BfaB.default), {
                direction: (0, $8dVIb.SmartLinkDirection).Vertical,
                width: (0, $8dVIb.SmartLinkWidth).Flexible,
                size: blockProps.size,
                className: (0, $bwpsq.default)([
                    "_zulppdf9"
                ]),
                children: [
                    title,
                    subtitleElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                        direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                        children: subtitleElements
                    })
                ]
            }),
            metadataElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                position: metadataPosition ?? (0, $8dVIb.SmartLinkPosition).Center,
                size: blockProps.size,
                children: metadataElements
            }),
            actionGroup
        ]
    });
};
const $e2967317da51f9f7$var$TitleBlockResolvedView = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($e2967317da51f9f7$var$TitleBlockResolvedViewNew, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jSZrF.default), {
        ...props
    });
};
var $e2967317da51f9f7$export$2e2bcd8739ae039 = $e2967317da51f9f7$var$TitleBlockResolvedView;

});
parcelRegister("jSZrF", function(module, exports) {

$parcel$export(module.exports, "default", () => $db35b34f2fc5f736$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $eqoQu = parcelRequire("eqoQu");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $akF1x = parcelRequire("akF1x");
function $db35b34f2fc5f736$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * This renders a fully resolved TitleBlock.
 * This should render when a Smart Link returns a valid response.
 * @see TitleBlock
 */ var $db35b34f2fc5f736$var$_ref = {
    name: "v43pxc",
    styles: "gap:var(--ds-space-050, 0.25rem)"
};
const $db35b34f2fc5f736$var$TitleBlockResolvedViewOld = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, ...blockProps })=>{
    const metadataElements = (0, $akF1x.renderElementItems)(metadata);
    const subtitleElements = (0, $akF1x.renderElementItems)(subtitle);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.LinkIcon), {
                overrideIcon: icon,
                position: position
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1BfaB.default), {
                direction: (0, $8dVIb.SmartLinkDirection).Vertical,
                width: (0, $8dVIb.SmartLinkWidth).Flexible,
                overrideCss: $db35b34f2fc5f736$var$_ref,
                children: [
                    title,
                    subtitleElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                        direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                        children: subtitleElements
                    })
                ]
            }),
            metadataElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                position: metadataPosition ?? (0, $8dVIb.SmartLinkPosition).Center,
                children: metadataElements
            }),
            actionGroup
        ]
    });
};
var $db35b34f2fc5f736$export$2e2bcd8739ae039 = $db35b34f2fc5f736$var$TitleBlockResolvedViewOld;

});


parcelRegister("jHa2h", function(module, exports) {

$parcel$export(module.exports, "default", () => $045d1b1e49cae759$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $gU02S = parcelRequire("gU02S");

var $fpDmE = parcelRequire("fpDmE");

var $dghu0 = parcelRequire("dghu0");

var $iZ5Ns = parcelRequire("iZ5Ns");
const $045d1b1e49cae759$var$iconStyle = {
    xlarge: "_16jlidpf _1o9zidpf _i0dl1wug _4t3iviql _1tkeviql _c71lviql _1bsbviql _1ul9viql _p12fviql _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7viql _1xjxviql _1752viql _qci8viql _15izviql _erubviql _19l3viql _1pr2viql _1u5tviql _mezjviql _e2ooviql _w8l5viql _1rg2viql _q7cvviql _xwbjviql _rtysviql _b8nkviql _4x20viql",
    large: "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1k8s _1tke1k8s _c71l1k8s _1bsb1k8s _1ul91k8s _p12f1k8s _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71k8s _1xjx1k8s _17521k8s _qci81k8s _15iz1k8s _erub1k8s _19l31k8s _1pr21k8s _1u5t1k8s _mezj1k8s _e2oo1k8s _w8l51k8s _1rg21k8s _q7cv1k8s _xwbj1k8s _rtys1k8s _b8nk1k8s _4x201k8s",
    medium: "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v",
    small: "_16jlidpf _1o9zidpf _i0dl1wug _4t3ioqnp _1tkeoqnp _c71loqnp _1bsboqnp _1ul9oqnp _p12foqnp _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7oqnp _1xjxoqnp _1752oqnp _qci8oqnp _15izoqnp _eruboqnp _19l3oqnp _1pr2oqnp _1u5toqnp _mezjoqnp _e2oooqnp _w8l5oqnp _1rg2oqnp _q7cvoqnp _xwbjoqnp _rtysoqnp _b8nkoqnp _4x20oqnp"
};
/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $045d1b1e49cae759$var$TitleBlockResolvingViewNew = ({ actionGroup: actionGroup, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $8dVIb.SmartLinkSize).Medium } = blockProps;
    if ((0, $VSDnB.fg)('platform-smart-card-icon-migration')) {
        const iconWidth = (0, $fpDmE.getIconWidthNew)(size);
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
            ...blockProps,
            testId: `${testId}-resolving-view`,
            children: [
                !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    style: {
                        width: iconWidth,
                        height: iconWidth
                    },
                    "data-testid": `${testId}-icon`,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeletonNew), {
                        width: iconWidth,
                        height: iconWidth,
                        testId: `${testId}-icon-loading`
                    })
                }),
                title,
                actionGroup
            ]
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                "data-testid": `${testId}-icon`,
                className: (0, $bwpsq.default)([
                    $045d1b1e49cae759$var$iconStyle[size]
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeletonOld), {
                    testId: `${testId}-icon-loading`
                })
            }),
            title,
            actionGroup
        ]
    });
};
const $045d1b1e49cae759$var$TitleBlockResolvingView = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($045d1b1e49cae759$var$TitleBlockResolvingViewNew, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iZ5Ns.default), {
        ...props
    });
};
var $045d1b1e49cae759$export$2e2bcd8739ae039 = $045d1b1e49cae759$var$TitleBlockResolvingView;

});
parcelRegister("iZ5Ns", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6684130218aacb9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $8dVIb = parcelRequire("8dVIb");

var $gU02S = parcelRequire("gU02S");

var $fpDmE = parcelRequire("fpDmE");

var $dghu0 = parcelRequire("dghu0");
/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $a6684130218aacb9$var$TitleBlockResolvingViewOld = ({ actionGroup: actionGroup, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $8dVIb.SmartLinkSize).Medium } = blockProps;
    const iconWidth = (0, $fpDmE.getIconWidth)(size);
    const iconStyles = (0, $fpDmE.getIconSizeStyles)(iconWidth);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`
    }, !hideIcon && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: iconStyles,
        "data-testid": `${testId}-icon`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gU02S.LoadingSkeletonOld), {
        testId: `${testId}-icon-loading`
    })), title, actionGroup);
};
var $a6684130218aacb9$export$2e2bcd8739ae039 = $a6684130218aacb9$var$TitleBlockResolvingViewOld;

});


parcelRegister("lVptR", function(module, exports) {

$parcel$export(module.exports, "default", () => $653ae9094f090b52$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8dVIb = parcelRequire("8dVIb");

var $4URMI = parcelRequire("4URMI");

var $eqoQu = parcelRequire("eqoQu");

var $bubxq = parcelRequire("bubxq");

var $fkxMX = parcelRequire("fkxMX");

var $bXy5i = parcelRequire("bXy5i");

var $jHa2h = parcelRequire("jHa2h");
function $653ae9094f090b52$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $653ae9094f090b52$var$_ref = {
    name: "11eaz",
    styles: ".actions-button-group{opacity:0;}&:hover .actions-button-group, .actions-button-group:focus-within{opacity:1;}"
};
const $653ae9094f090b52$var$getActionStyles = (showOnHover, isOpen)=>{
    if (showOnHover && !isOpen) return $653ae9094f090b52$var$_ref;
};
const $653ae9094f090b52$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $8dVIb.SmartLinkStatus).Pending:
        case (0, $8dVIb.SmartLinkStatus).Resolving:
            return 0, $jHa2h.default;
        case (0, $8dVIb.SmartLinkStatus).Resolved:
            return 0, $bXy5i.default;
        case (0, $8dVIb.SmartLinkStatus).Unauthorized:
        case (0, $8dVIb.SmartLinkStatus).Forbidden:
        case (0, $8dVIb.SmartLinkStatus).NotFound:
        case (0, $8dVIb.SmartLinkStatus).Errored:
        case (0, $8dVIb.SmartLinkStatus).Fallback:
        default:
            return 0, $fkxMX.default;
    }
};
/**
 * Represents a TitleBlock, which is the foundation of Flexible UI.
 * This contains an icon, the link, and any associated metadata and actions in one block.
 * The TitleBlock will also render differently given the state of the smart link.
 * This can be found in the corresponding Resolving, Resolved and Errored views.
 * @public
 * @param {TitleBlockProps} TitleBlockProps
 * @see Block
 * @see TitleBlockResolvingView
 * @see TitleBlockResolvedView
 * @see TitleBlockErroredView
 */ const $653ae9094f090b52$var$TitleBlock = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, onClick: onClick, overrideCss: overrideCss, status: status = (0, $8dVIb.SmartLinkStatus).Fallback, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, theme: theme, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, ...props })=>{
    if (hideRetry && props.retry) delete props.retry;
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $5uXOq.useState)(false);
    const onDropdownOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bubxq.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const actionStyles = $653ae9094f090b52$var$getActionStyles(showActionOnHover, actionDropdownOpen);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const combinedCss = /*#__PURE__*/ (0, $f8Sb3.css)(actionStyles, overrideCss);
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $4URMI.useMouseDownEvent)();
    const title = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.Title), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: anchorTarget,
        theme: theme,
        ...overrideText
    });
    const Component = $653ae9094f090b52$var$getTitleBlockViewComponent(status);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        ...props,
        actionGroup: actionGroup,
        overrideCss: combinedCss,
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        icon: icon
    });
};
var $653ae9094f090b52$export$2e2bcd8739ae039 = $653ae9094f090b52$var$TitleBlock;

});


parcelRegister("1qDIM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dff75b4d7cc06d3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $4tgi5 = parcelRequire("4tgi5");
/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */ const $5dff75b4d7cc06d3$var$AISummaryBlock = ({ status: status, testId: testId = 'smart-ai-summary-block', ...props })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $8dVIb.InternalActionName).AISummaryAction];
    if (status !== (0, $8dVIb.SmartLinkStatus).Resolved) return null;
    if (!actionData?.url) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4tgi5.default), {
        ...props,
        testId: testId,
        url: actionData.url
    });
};
var $5dff75b4d7cc06d3$export$2e2bcd8739ae039 = $5dff75b4d7cc06d3$var$AISummaryBlock;

});
parcelRegister("4tgi5", function(module, exports) {

$parcel$export(module.exports, "default", () => $413bb2fab5c71807$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gKZoD = parcelRequire("gKZoD");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $1MeuC = parcelRequire("1MeuC");

var $bHeMs = parcelRequire("bHeMs");

var $aBTst = parcelRequire("aBTst");

var $dghu0 = parcelRequire("dghu0");

var $adeuB = parcelRequire("adeuB");

var $1n0HW = parcelRequire("1n0HW");
const $413bb2fab5c71807$var$styles = null;
const $413bb2fab5c71807$var$AISummaryBlockResolvedViewNew = (props)=>{
    (0, $gKZoD.di)((0, $1MeuC.default), (0, $bHeMs.default));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $1MeuC.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $5uXOq.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: placeholder
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...props,
        direction: (0, $8dVIb.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        /**
   * Enabled for feature discovery to allow box shadow to overflow
   * Cleanup: https://product-fabric.atlassian.net/browse/EDM-8681
   */ className: (0, $bwpsq.default)([
            "_1reoewfl _18m9ewfl"
        ]),
        children: [
            status === 'done' && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $adeuB.default), {
                fromCache: isSummarisedOnMountRef.current
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aBTst.default), {
                minHeight: minHeight,
                show: showAISummary,
                showTransition: !isSummarisedOnMountRef.current,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bHeMs.default), {
                    testId: `${testId}-ai-summary`,
                    minHeight: minHeight,
                    content: content
                })
            })
        ]
    });
};
const $413bb2fab5c71807$var$AISummaryBlockResolvedView = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($413bb2fab5c71807$var$AISummaryBlockResolvedViewNew, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1n0HW.default), {
        ...props
    });
};
var $413bb2fab5c71807$export$2e2bcd8739ae039 = $413bb2fab5c71807$var$AISummaryBlockResolvedView;

});
parcelRegister("bHeMs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea67ef8b17402f34$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $flpap = parcelRequire("flpap");

var $VSDnB = parcelRequire("VSDnB");

var $htIU2 = parcelRequire("htIU2");

var $aRS1S = parcelRequire("aRS1S");
const $ea67ef8b17402f34$var$AISummaryCSSStyles = null;
/**
 * A component to render a response from AI in markdown text.
 * @internal
 * @param {AISummaryProps} AISummaryProps
 */ const $ea67ef8b17402f34$var$AISummaryNew = ({ content: content = '', className: className, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $flpap.default), {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_11c8qk37 _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        children: content,
        options: {
            forceWrapper: true,
            overrides: {
                ul: (0, $aRS1S.default)
            }
        },
        style: {
            minHeight: minHeight
        }
    });
};
const $ea67ef8b17402f34$var$AISummary = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($ea67ef8b17402f34$var$AISummaryNew, {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $htIU2.default), {
        ...props
    });
};
var $ea67ef8b17402f34$export$2e2bcd8739ae039 = $ea67ef8b17402f34$var$AISummary;

});
parcelRegister("flpap", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2bc56c6c0b4e02e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $b2bc56c6c0b4e02e$var$t() {
    return $b2bc56c6c0b4e02e$var$t = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }, $b2bc56c6c0b4e02e$var$t.apply(this, arguments);
}
const $b2bc56c6c0b4e02e$var$n = [
    "children",
    "options"
], $b2bc56c6c0b4e02e$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
};
var $b2bc56c6c0b4e02e$var$i;
!function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($b2bc56c6c0b4e02e$var$i || ($b2bc56c6c0b4e02e$var$i = {}));
const $b2bc56c6c0b4e02e$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, t)=>(e[t.toLowerCase()] = t, e), {
    class: "className",
    for: "htmlFor"
}), $b2bc56c6c0b4e02e$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $b2bc56c6c0b4e02e$var$o = [
    "style",
    "script"
], $b2bc56c6c0b4e02e$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $b2bc56c6c0b4e02e$var$s = /mailto:/i, $b2bc56c6c0b4e02e$var$d = /\n{2,}$/, $b2bc56c6c0b4e02e$var$p = /^(\s*>[\s\S]*?)(?=\n{2,})/, $b2bc56c6c0b4e02e$var$u = /^ *> ?/gm, $b2bc56c6c0b4e02e$var$f = /^ {2,}\n/, $b2bc56c6c0b4e02e$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $b2bc56c6c0b4e02e$var$m = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $b2bc56c6c0b4e02e$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $b2bc56c6c0b4e02e$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $b2bc56c6c0b4e02e$var$k = /^(?:\n *)*\n/, $b2bc56c6c0b4e02e$var$x = /\r\n?/g, $b2bc56c6c0b4e02e$var$b = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $b2bc56c6c0b4e02e$var$v = /^\[\^([^\]]+)]/, $b2bc56c6c0b4e02e$var$S = /\f/g, $b2bc56c6c0b4e02e$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $b2bc56c6c0b4e02e$var$C = /^\s*?\[(x|\s)\]/, $b2bc56c6c0b4e02e$var$$ = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $b2bc56c6c0b4e02e$var$w = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $b2bc56c6c0b4e02e$var$z = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $b2bc56c6c0b4e02e$var$L = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $b2bc56c6c0b4e02e$var$A = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $b2bc56c6c0b4e02e$var$T = /^<!--[\s\S]*?(?:-->)/, $b2bc56c6c0b4e02e$var$O = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $b2bc56c6c0b4e02e$var$B = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $b2bc56c6c0b4e02e$var$M = /^\{.*\}$/, $b2bc56c6c0b4e02e$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $b2bc56c6c0b4e02e$var$I = /^<([^ >]+@[^ >]+)>/, $b2bc56c6c0b4e02e$var$U = /^<([^ >]+:\/[^ >]+)>/, $b2bc56c6c0b4e02e$var$D = /-([a-z])?/gi, $b2bc56c6c0b4e02e$var$j = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $b2bc56c6c0b4e02e$var$N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $b2bc56c6c0b4e02e$var$H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $b2bc56c6c0b4e02e$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $b2bc56c6c0b4e02e$var$P = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $b2bc56c6c0b4e02e$var$_ = /\t/g, $b2bc56c6c0b4e02e$var$G = /(^ *\||\| *$)/g, $b2bc56c6c0b4e02e$var$W = /^ *:-+: *$/, $b2bc56c6c0b4e02e$var$Z = /^ *:-+ *$/, $b2bc56c6c0b4e02e$var$q = /^ *-+: *$/, $b2bc56c6c0b4e02e$var$Q = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $b2bc56c6c0b4e02e$var$V = new RegExp(`^([*_])\\1${$b2bc56c6c0b4e02e$var$Q}\\1\\1(?!\\1)`), $b2bc56c6c0b4e02e$var$X = new RegExp(`^([*_])${$b2bc56c6c0b4e02e$var$Q}\\1(?!\\1|\\w)`), $b2bc56c6c0b4e02e$var$J = new RegExp(`^==${$b2bc56c6c0b4e02e$var$Q}==`), $b2bc56c6c0b4e02e$var$K = new RegExp(`^~~${$b2bc56c6c0b4e02e$var$Q}~~`), $b2bc56c6c0b4e02e$var$Y = /^\\([^0-9A-Za-z\s])/, $b2bc56c6c0b4e02e$var$ee = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $b2bc56c6c0b4e02e$var$te = /^\n+/, $b2bc56c6c0b4e02e$var$ne = /^([ \t]*)/, $b2bc56c6c0b4e02e$var$re = /\\([^\\])/g, $b2bc56c6c0b4e02e$var$ie = / *\n+$/, $b2bc56c6c0b4e02e$var$le = /(?:^|\n)( *)$/, $b2bc56c6c0b4e02e$var$ae = "(?:\\d+\\.)", $b2bc56c6c0b4e02e$var$oe = "(?:[*+-])";
function $b2bc56c6c0b4e02e$var$ce(e) {
    return "( *)(" + (1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe) + ") +";
}
const $b2bc56c6c0b4e02e$var$se = $b2bc56c6c0b4e02e$var$ce(1), $b2bc56c6c0b4e02e$var$de = $b2bc56c6c0b4e02e$var$ce(2);
function $b2bc56c6c0b4e02e$var$pe(e) {
    return new RegExp("^" + (1 === e ? $b2bc56c6c0b4e02e$var$se : $b2bc56c6c0b4e02e$var$de));
}
const $b2bc56c6c0b4e02e$var$ue = $b2bc56c6c0b4e02e$var$pe(1), $b2bc56c6c0b4e02e$var$fe = $b2bc56c6c0b4e02e$var$pe(2);
function $b2bc56c6c0b4e02e$var$he(e) {
    return new RegExp("^" + (1 === e ? $b2bc56c6c0b4e02e$var$se : $b2bc56c6c0b4e02e$var$de) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $b2bc56c6c0b4e02e$var$me = $b2bc56c6c0b4e02e$var$he(1), $b2bc56c6c0b4e02e$var$ge = $b2bc56c6c0b4e02e$var$he(2);
function $b2bc56c6c0b4e02e$var$ye(e) {
    const t = 1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe;
    return new RegExp("^( *)(" + t + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + t + " (?!" + t + " ))\\n*|\\s*\\n*$)");
}
const $b2bc56c6c0b4e02e$var$ke = $b2bc56c6c0b4e02e$var$ye(1), $b2bc56c6c0b4e02e$var$xe = $b2bc56c6c0b4e02e$var$ye(2);
function $b2bc56c6c0b4e02e$var$be(e, t) {
    const n = 1 === t, i = n ? $b2bc56c6c0b4e02e$var$ke : $b2bc56c6c0b4e02e$var$xe, l = n ? $b2bc56c6c0b4e02e$var$me : $b2bc56c6c0b4e02e$var$ge, a = n ? $b2bc56c6c0b4e02e$var$ue : $b2bc56c6c0b4e02e$var$fe;
    return {
        match (e, t) {
            const n = $b2bc56c6c0b4e02e$var$le.exec(t.prevCapture);
            return n && (t.list || !t.inline && !t.simple) ? i.exec(e = n[1] + e) : null;
        },
        order: 1,
        parse (e, t, r) {
            const i = n ? +e[2] : void 0, o = e[0].replace($b2bc56c6c0b4e02e$var$d, "\n").match(l);
            let c = !1;
            return {
                items: o.map(function(e, n) {
                    const i = a.exec(e)[0].length, l = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(l, "").replace(a, ""), d = n === o.length - 1, p = -1 !== s.indexOf("\n\n") || d && c;
                    c = p;
                    const u = r.inline, f = r.list;
                    let h;
                    r.list = !0, p ? (r.inline = !1, h = s.replace($b2bc56c6c0b4e02e$var$ie, "\n\n")) : (r.inline = !0, h = s.replace($b2bc56c6c0b4e02e$var$ie, ""));
                    const m = t(h, r);
                    return r.inline = u, r.list = f, m;
                }),
                ordered: n,
                start: i
            };
        },
        render: (t, n, i)=>e(t.ordered ? "ol" : "ul", {
                key: i.key,
                start: t.type === $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.orderedList ? t.start : void 0
            }, t.items.map(function(t, r) {
                return e("li", {
                    key: r
                }, n(t, i));
            }))
    };
}
const $b2bc56c6c0b4e02e$var$ve = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $b2bc56c6c0b4e02e$var$Se = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $b2bc56c6c0b4e02e$var$Ee = [
    $b2bc56c6c0b4e02e$var$p,
    $b2bc56c6c0b4e02e$var$m,
    $b2bc56c6c0b4e02e$var$g,
    $b2bc56c6c0b4e02e$var$$,
    $b2bc56c6c0b4e02e$var$z,
    $b2bc56c6c0b4e02e$var$w,
    $b2bc56c6c0b4e02e$var$T,
    $b2bc56c6c0b4e02e$var$j,
    $b2bc56c6c0b4e02e$var$me,
    $b2bc56c6c0b4e02e$var$ke,
    $b2bc56c6c0b4e02e$var$ge,
    $b2bc56c6c0b4e02e$var$xe
], $b2bc56c6c0b4e02e$var$Ce = [
    ...$b2bc56c6c0b4e02e$var$Ee,
    /^[^\n]+(?:  \n|\n{2,})/,
    $b2bc56c6c0b4e02e$var$L,
    $b2bc56c6c0b4e02e$var$B
];
function $b2bc56c6c0b4e02e$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $b2bc56c6c0b4e02e$var$we(e) {
    return $b2bc56c6c0b4e02e$var$q.test(e) ? "right" : $b2bc56c6c0b4e02e$var$W.test(e) ? "center" : $b2bc56c6c0b4e02e$var$Z.test(e) ? "left" : null;
}
function $b2bc56c6c0b4e02e$var$ze(e, t, n, i) {
    const l = n.inTable;
    n.inTable = !0;
    let a = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((e, l)=>("|" === l.trim() ? e.push(i ? {
            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator
        } : {
            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text,
            text: l
        }) : "" !== l && e.push.apply(e, t(l, n)), e), []);
    n.inTable = l;
    let o = [
        []
    ];
    return a.forEach(function(e, t) {
        e.type === $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator ? 0 !== t && t !== a.length - 1 && o.push([]) : (e.type !== $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text || null != a[t + 1] && a[t + 1].type !== $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator || (e.text = e.text.trimEnd()), o[o.length - 1].push(e));
    }), o;
}
function $b2bc56c6c0b4e02e$var$Le(e, t, n) {
    n.inline = !0;
    const i = e[2] ? e[2].replace($b2bc56c6c0b4e02e$var$G, "").split("|").map($b2bc56c6c0b4e02e$var$we) : [], l = e[3] ? function(e, t, n) {
        return e.trim().split("\n").map(function(e) {
            return $b2bc56c6c0b4e02e$var$ze(e, t, n, !0);
        });
    }(e[3], t, n) : [], a = $b2bc56c6c0b4e02e$var$ze(e[1], t, n, !!l.length);
    return n.inline = !1, l.length ? {
        align: i,
        cells: l,
        header: a,
        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.table
    } : {
        children: a,
        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.paragraph
    };
}
function $b2bc56c6c0b4e02e$var$Ae(e, t) {
    return null == e.align[t] ? {} : {
        textAlign: e.align[t]
    };
}
function $b2bc56c6c0b4e02e$var$Te(e) {
    return function(t, n) {
        return n.inline ? e.exec(t) : null;
    };
}
function $b2bc56c6c0b4e02e$var$Oe(e) {
    return function(t, n) {
        return n.inline || n.simple ? e.exec(t) : null;
    };
}
function $b2bc56c6c0b4e02e$var$Be(e) {
    return function(t, n) {
        return n.inline || n.simple ? null : e.exec(t);
    };
}
function $b2bc56c6c0b4e02e$var$Me(e) {
    return function(t) {
        return e.exec(t);
    };
}
function $b2bc56c6c0b4e02e$var$Re(e, t) {
    if (t.inline || t.simple) return null;
    let n = "";
    e.split("\n").every((e)=>!$b2bc56c6c0b4e02e$var$Ee.some((t)=>t.test(e)) && (n += e + "\n", e.trim()));
    const r = n.trimEnd();
    return "" == r ? null : [
        n,
        r
    ];
}
function $b2bc56c6c0b4e02e$export$3e2338ea76b578c9(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $b2bc56c6c0b4e02e$var$Ue(e) {
    return e.replace($b2bc56c6c0b4e02e$var$re, "$1");
}
function $b2bc56c6c0b4e02e$var$De(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !0, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $b2bc56c6c0b4e02e$var$je(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !1, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $b2bc56c6c0b4e02e$var$Ne(e, t, n) {
    const r = n.inline || !1;
    n.inline = !1;
    const i = e(t, n);
    return n.inline = r, i;
}
const $b2bc56c6c0b4e02e$var$He = (e, t, n)=>({
        children: $b2bc56c6c0b4e02e$var$De(t, e[1], n)
    });
function $b2bc56c6c0b4e02e$var$Fe() {
    return {};
}
function $b2bc56c6c0b4e02e$var$Pe() {
    return null;
}
function $b2bc56c6c0b4e02e$var$_e(...e) {
    return e.filter(Boolean).join(" ");
}
function $b2bc56c6c0b4e02e$var$Ge(e, t, n) {
    let r = e;
    const i = t.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || n;
}
function $b2bc56c6c0b4e02e$export$69f434acfbdb0b32(n = "", i = {}) {
    function d(e, n, ...r) {
        const l = $b2bc56c6c0b4e02e$var$Ge(i.overrides, `${e}.props`, {});
        return i.createElement(function(e, t) {
            const n = $b2bc56c6c0b4e02e$var$Ge(t, e);
            return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $b2bc56c6c0b4e02e$var$Ge(t, `${e}.component`, e) : e;
        }(e, i.overrides), $b2bc56c6c0b4e02e$var$t({}, n, l, {
            className: $b2bc56c6c0b4e02e$var$_e(null == n ? void 0 : n.className, l.className) || void 0
        }), ...r);
    }
    function G(t) {
        t = t.replace($b2bc56c6c0b4e02e$var$E, "");
        let n = !1;
        i.forceInline ? n = !0 : i.forceBlock || (n = !1 === $b2bc56c6c0b4e02e$var$P.test(t));
        const r = ie(re(n ? t : `${t.trimEnd().replace($b2bc56c6c0b4e02e$var$te, "")}\n\n`, {
            inline: n
        }));
        for(; "string" == typeof r[r.length - 1] && !r[r.length - 1].trim();)r.pop();
        if (null === i.wrapper) return r;
        const l = i.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || i.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? d("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $5uXOq.createElement(l, {
            key: "outer"
        }, a);
    }
    function W(t, n) {
        const r = n.match($b2bc56c6c0b4e02e$var$c);
        return r ? r.reduce(function(n, r, a) {
            const o = r.indexOf("=");
            if (-1 !== o) {
                const c = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($b2bc56c6c0b4e02e$var$O) && (e = e.replace($b2bc56c6c0b4e02e$var$D, function(e, t) {
                        return t.toUpperCase();
                    })), e;
                })(r.slice(0, o)).trim(), s = function(e) {
                    const t = e[0];
                    return ('"' === t || "'" === t) && e.length >= 2 && e[e.length - 1] === t ? e.slice(1, -1) : e;
                }(r.slice(o + 1).trim()), d = $b2bc56c6c0b4e02e$var$l[c] || c, p = n[d] = function(e, t, n, r) {
                    return "style" === t ? n.split(/;\s?/).reduce(function(e, t) {
                        const n = t.slice(0, t.indexOf(":"));
                        return e[n.trim().replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t.slice(n.length + 1).trim(), e;
                    }, {}) : "href" === t || "src" === t ? r(n, e, t) : (n.match($b2bc56c6c0b4e02e$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(t, c, s, i.sanitizer);
                "string" == typeof p && ($b2bc56c6c0b4e02e$var$L.test(p) || $b2bc56c6c0b4e02e$var$B.test(p)) && (n[d] = $5uXOq.cloneElement(G(p.trim()), {
                    key: a
                }));
            } else "style" !== r && (n[$b2bc56c6c0b4e02e$var$l[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    i.overrides = i.overrides || {}, i.sanitizer = i.sanitizer || $b2bc56c6c0b4e02e$export$3e2338ea76b578c9, i.slugify = i.slugify || $b2bc56c6c0b4e02e$export$c383cdd2a518017a, i.namedCodesToUnicode = i.namedCodesToUnicode ? $b2bc56c6c0b4e02e$var$t({}, $b2bc56c6c0b4e02e$var$a, i.namedCodesToUnicode) : $b2bc56c6c0b4e02e$var$a, i.createElement = i.createElement || $5uXOq.createElement;
    const Z = [], q = {}, Q = {
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.blockQuote]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$p),
            order: 1,
            parse: (e, t, n)=>({
                    children: t(e[0].replace($b2bc56c6c0b4e02e$var$u, ""), n)
                }),
            render: (e, t, n)=>d("blockquote", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.breakLine]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$f),
            order: 1,
            parse: $b2bc56c6c0b4e02e$var$Fe,
            render: (e, t, n)=>d("br", {
                    key: n.key
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.breakThematic]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$h),
            order: 1,
            parse: $b2bc56c6c0b4e02e$var$Fe,
            render: (e, t, n)=>d("hr", {
                    key: n.key
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeBlock]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, n, r)=>d("pre", {
                    key: r.key
                }, d("code", $b2bc56c6c0b4e02e$var$t({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeFenced]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: W("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeBlock
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeInline]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, t, n)=>d("code", {
                    key: n.key
                }, e.text)
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.footnote]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$b),
            order: 0,
            parse: (e)=>(Z.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $b2bc56c6c0b4e02e$var$Pe
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.footnoteReference]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$v),
            order: 1,
            parse: (e)=>({
                    target: `#${i.slugify(e[1], $b2bc56c6c0b4e02e$export$c383cdd2a518017a)}`,
                    text: e[1]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href")
                }, d("sup", {
                    key: n.key
                }, e.text))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.gfmTask]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$C),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, t, n)=>d("input", {
                    checked: e.completed,
                    key: n.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.heading]: {
            match: $b2bc56c6c0b4e02e$var$Be(i.enforceAtxHeadings ? $b2bc56c6c0b4e02e$var$w : $b2bc56c6c0b4e02e$var$$),
            order: 1,
            parse: (e, t, n)=>({
                    children: $b2bc56c6c0b4e02e$var$De(t, e[2], n),
                    id: i.slugify(e[2], $b2bc56c6c0b4e02e$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            render: (e, t, n)=>d(`h${e.level}`, {
                    id: e.id,
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.headingSetext]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$z),
            order: 0,
            parse: (e, t, n)=>({
                    children: $b2bc56c6c0b4e02e$var$De(t, e[1], n),
                    level: "=" === e[2] ? 1 : 2,
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.heading
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlBlock]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$L),
            order: 1,
            parse (e, t, n) {
                const [, r] = e[3].match($b2bc56c6c0b4e02e$var$ne), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), a = (c = l, $b2bc56c6c0b4e02e$var$Ce.some((e)=>e.test(c)) ? $b2bc56c6c0b4e02e$var$Ne : $b2bc56c6c0b4e02e$var$De);
                var c;
                const s = e[1].toLowerCase(), d = -1 !== $b2bc56c6c0b4e02e$var$o.indexOf(s), p = (d ? s : e[1]).trim(), u = {
                    attrs: W(p, e[2]),
                    noInnerParse: d,
                    tag: p
                };
                return n.inAnchor = n.inAnchor || "a" === s, d ? u.text = e[3] : u.children = a(t, l, n), n.inAnchor = !1, u;
            },
            render: (e, n, r)=>d(e.tag, $b2bc56c6c0b4e02e$var$t({
                    key: r.key
                }, e.attrs), e.text || (e.children ? n(e.children, r) : ""))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlSelfClosing]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$B),
            order: 1,
            parse (e) {
                const t = e[1].trim();
                return {
                    attrs: W(t, e[2] || ""),
                    tag: t
                };
            },
            render: (e, n, r)=>d(e.tag, $b2bc56c6c0b4e02e$var$t({}, e.attrs, {
                    key: r.key
                }))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlComment]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$T),
            order: 1,
            parse: ()=>({}),
            render: $b2bc56c6c0b4e02e$var$Pe
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.image]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$Se),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $b2bc56c6c0b4e02e$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("img", {
                    key: n.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: i.sanitizer(e.target, "img", "src")
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$ve),
            order: 3,
            parse: (e, t, n)=>({
                    children: $b2bc56c6c0b4e02e$var$je(t, e[1], n),
                    target: $b2bc56c6c0b4e02e$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href"),
                    title: e.title
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkAngleBraceStyleDetector]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$U),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkBareUrlDetector]: {
            match: (e, t)=>t.inAnchor || i.disableAutoLink ? null : $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$R)(e, t),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkMailtoDetector]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$I),
            order: 0,
            parse (e) {
                let t = e[1], n = e[1];
                return $b2bc56c6c0b4e02e$var$s.test(n) || (n = "mailto:" + n), {
                    children: [
                        {
                            text: t.replace("mailto:", ""),
                            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: n,
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                };
            }
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.orderedList]: $b2bc56c6c0b4e02e$var$be(d, 1),
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.unorderedList]: $b2bc56c6c0b4e02e$var$be(d, 2),
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.newlineCoalescer]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$k),
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$Fe,
            render: ()=>"\n"
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.paragraph]: {
            match: $b2bc56c6c0b4e02e$var$Re,
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$He,
            render: (e, t, n)=>d("p", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.ref]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$N),
            order: 0,
            parse: (e)=>(q[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $b2bc56c6c0b4e02e$var$Pe
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.refImage]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$H),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("img", {
                    key: n.key,
                    alt: e.alt,
                    src: i.sanitizer(q[e.ref].target, "img", "src"),
                    title: q[e.ref].title
                }) : null
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.refLink]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$F),
            order: 0,
            parse: (e, t, n)=>({
                    children: t(e[1], n),
                    fallbackChildren: e[0],
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("a", {
                    key: n.key,
                    href: i.sanitizer(q[e.ref].target, "a", "href"),
                    title: q[e.ref].title
                }, t(e.children, n)) : d("span", {
                    key: n.key
                }, e.fallbackChildren)
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.table]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$j),
            order: 1,
            parse: $b2bc56c6c0b4e02e$var$Le,
            render (e, t, n) {
                const r = e;
                return d("table", {
                    key: n.key
                }, d("thead", null, d("tr", null, r.header.map(function(e, i) {
                    return d("th", {
                        key: i,
                        style: $b2bc56c6c0b4e02e$var$Ae(r, i)
                    }, t(e, n));
                }))), d("tbody", null, r.cells.map(function(e, i) {
                    return d("tr", {
                        key: i
                    }, e.map(function(e, i) {
                        return d("td", {
                            key: i,
                            style: $b2bc56c6c0b4e02e$var$Ae(r, i)
                        }, t(e, n));
                    }));
                })));
            }
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$ee),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($b2bc56c6c0b4e02e$var$A, (e, t)=>i.namedCodesToUnicode[t] ? i.namedCodesToUnicode[t] : e)
                }),
            render: (e)=>e.text
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textBolded]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$V),
            order: 2,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("strong", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textEmphasized]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$X),
            order: 3,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("em", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textEscaped]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$Y),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textMarked]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$J),
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$He,
            render: (e, t, n)=>d("mark", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textStrikethroughed]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$K),
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$He,
            render: (e, t, n)=>d("del", {
                    key: n.key
                }, t(e.children, n))
        }
    };
    !0 === i.disableParsingRawHTML && (delete Q[$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlBlock], delete Q[$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlSelfClosing]);
    const re = function(e) {
        let t = Object.keys(e);
        function n(r, i) {
            let l = [];
            for(i.prevCapture = i.prevCapture || ""; r;){
                let a = 0;
                for(; a < t.length;){
                    const o = t[a], c = e[o], s = c.match(r, i);
                    if (s) {
                        const e = s[0];
                        i.prevCapture += e, r = r.substring(e.length);
                        const t = c.parse(s, n, i);
                        null == t.type && (t.type = o), l.push(t);
                        break;
                    }
                    a++;
                }
            }
            return i.prevCapture = "", l;
        }
        return t.sort(function(t, n) {
            let r = e[t].order, i = e[n].order;
            return r !== i ? r - i : t < n ? -1 : 1;
        }), function(e, t) {
            return n(function(e) {
                return e.replace($b2bc56c6c0b4e02e$var$x, "\n").replace($b2bc56c6c0b4e02e$var$S, "").replace($b2bc56c6c0b4e02e$var$_, "    ");
            }(e), t);
        };
    }(Q), ie = (le = function(e, t) {
        return function(n, r, i) {
            const l = e[n.type].render;
            return t ? t(()=>l(n, r, i), n, r, i) : l(n, r, i);
        };
    }(Q, i.renderRule), function e(t, n = {}) {
        if (Array.isArray(t)) {
            const r = n.key, i = [];
            let l = !1;
            for(let r = 0; r < t.length; r++){
                n.key = r;
                const a = e(t[r], n), o = "string" == typeof a;
                o && l ? i[i.length - 1] += a : null !== a && i.push(a), l = o;
            }
            return n.key = r, i;
        }
        return le(t, e, n);
    });
    var le;
    const ae = G(n);
    return Z.length ? d("div", null, ae, d("footer", {
        key: "footer"
    }, Z.map(function(e) {
        return d("div", {
            id: i.slugify(e.identifier, $b2bc56c6c0b4e02e$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, ie(re(e.footnote, {
            inline: !0
        })));
    }))) : ae;
}
var $b2bc56c6c0b4e02e$export$2e2bcd8739ae039 = (t)=>{
    let { children: r = "", options: i } = t, l = function(e, t) {
        if (null == e) return {};
        var n, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)t.indexOf(n = l[r]) >= 0 || (i[n] = e[n]);
        return i;
    }(t, $b2bc56c6c0b4e02e$var$n);
    return $5uXOq.cloneElement($b2bc56c6c0b4e02e$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("htIU2", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c927d4d6eeab946$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $flpap = parcelRequire("flpap");

var $aRS1S = parcelRequire("aRS1S");
function $4c927d4d6eeab946$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4c927d4d6eeab946$var$AISummaryCSSStyles = {
    name: "gujpb9",
    styles: "font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);word-wrap:break-word;word-break:break-word;white-space:normal;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text"
};
/**
 * A component to render a response from AI in markdown text.
 * @internal
 * @param {AISummaryProps} AISummaryProps
 */ const $4c927d4d6eeab946$var$AISummaryOld = ({ content: content = '', overrideCss: overrideCss, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $flpap.default), {
        "data-testid": testId,
        css: [
            $4c927d4d6eeab946$var$AISummaryCSSStyles,
            overrideCss
        ],
        children: content,
        options: {
            forceWrapper: true,
            overrides: {
                ul: (0, $aRS1S.default)
            }
        },
        style: {
            minHeight: minHeight
        }
    });
};
var $4c927d4d6eeab946$export$2e2bcd8739ae039 = $4c927d4d6eeab946$var$AISummaryOld;

});
parcelRegister("aRS1S", function(module, exports) {

$parcel$export(module.exports, "default", () => $270fc2c4bbd80c91$export$2e2bcd8739ae039);
/* ulist.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $3hwkO = parcelRequire("3hwkO");
const $270fc2c4bbd80c91$var$listStyles = null;
const $270fc2c4bbd80c91$var$UListNew = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
        ...props,
        className: (0, $bwpsq.default)([
            "_19bvv47k _bozgv47k"
        ]),
        children: children
    });
const $270fc2c4bbd80c91$var$UList = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($270fc2c4bbd80c91$var$UListNew, {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3hwkO.default), {
        ...props
    });
};
var $270fc2c4bbd80c91$export$2e2bcd8739ae039 = $270fc2c4bbd80c91$var$UList;

});
parcelRegister("3hwkO", function(module, exports) {

$parcel$export(module.exports, "default", () => $af187f77d375adf3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");
function $af187f77d375adf3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $af187f77d375adf3$var$listStyles = {
    name: "k4jzwf",
    styles: "padding-left:var(--ds-space-250, 20px);padding-inline-start:var(--ds-space-250, 20px)"
};
const $af187f77d375adf3$var$UListOld = ({ children: children, ...props })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("ul", {
        css: $af187f77d375adf3$var$listStyles,
        ...props
    }, children);
var $af187f77d375adf3$export$2e2bcd8739ae039 = $af187f77d375adf3$var$UListOld;

});




parcelRegister("aBTst", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8d8f80d50d9d1e4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $a8d8f80d50d9d1e4$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
    const [height, setHeight] = (0, $5uXOq.useState)(0);
    const ref = (0, $5uXOq.useRef)(null);
    const transition = isFadeIn ? 'height, opacity' : 'height';
    (0, $5uXOq.useEffect)(()=>{
        if (show && ref.current) // set the height of the error message container explicitly to the height
        // of its contents (including anything hidden due to overflow) so that we
        // can animate the height of the container
        setHeight(ref.current.scrollHeight);
        else setHeight(0);
    }, [
        children,
        show
    ]);
    return show ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        style: {
            height: height,
            minHeight: minHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // a fit for purpose state variable to control when the 'visible' styles should be appled
            opacity: height > 0 ? 1 : 0,
            // we only want to transition opacity and height when the error message is initially shown
            // not if its to be shown on mount
            transitionProperty: showTransition ? transition : 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            transitionDuration: '0.3s'
        },
        ref: ref,
        children: children
    }) : null;
};
var $a8d8f80d50d9d1e4$export$2e2bcd8739ae039 = $a8d8f80d50d9d1e4$export$6118ed0013927eb2;

});

parcelRegister("adeuB", function(module, exports) {

$parcel$export(module.exports, "default", () => $749bb6d43c83bff0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $a1vqi = parcelRequire("a1vqi");
const $749bb6d43c83bff0$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        fireEvent('ui.summary.viewed', {
            fromCache: fromCache
        });
        if (fromCache) fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 1,
            userGeneratedAI: 0
        });
    }, [
        fireEvent,
        fromCache
    ]);
    return null;
};
var $749bb6d43c83bff0$export$2e2bcd8739ae039 = $749bb6d43c83bff0$var$AIEventSummaryViewed;

});

parcelRegister("1n0HW", function(module, exports) {

$parcel$export(module.exports, "default", () => $612fabb86adb8229$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $gKZoD = parcelRequire("gKZoD");

var $8dVIb = parcelRequire("8dVIb");

var $1MeuC = parcelRequire("1MeuC");

var $bHeMs = parcelRequire("bHeMs");

var $aBTst = parcelRequire("aBTst");

var $dghu0 = parcelRequire("dghu0");

var $adeuB = parcelRequire("adeuB");
const $612fabb86adb8229$var$AISummaryBlockResolvedViewOld = (props)=>{
    (0, $gKZoD.di)((0, $1MeuC.default), (0, $bHeMs.default));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $1MeuC.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $5uXOq.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: placeholder
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...props,
        direction: (0, $8dVIb.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        /**
   * Enabled for feature discovery to allow box shadow to overflow
   * Cleanup: https://product-fabric.atlassian.net/browse/EDM-8681
   */ overrideCss: (0, $f8Sb3.css)("overflow:visible;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        props.overrideCss),
        children: [
            status === 'done' && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $adeuB.default), {
                fromCache: isSummarisedOnMountRef.current
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aBTst.default), {
                minHeight: minHeight,
                show: showAISummary,
                showTransition: !isSummarisedOnMountRef.current,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bHeMs.default), {
                    testId: `${testId}-ai-summary`,
                    minHeight: minHeight,
                    content: content
                })
            })
        ]
    });
};
var $612fabb86adb8229$export$2e2bcd8739ae039 = $612fabb86adb8229$var$AISummaryBlockResolvedViewOld;

});



parcelRegister("85ffk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5cb2203e6787402$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $obtkX = parcelRequire("obtkX");
/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */ const $d5cb2203e6787402$var$AIFooterBlock = ({ status: status, testId: testId = 'smart-ai-footer-block', ...props })=>{
    if (status !== (0, $8dVIb.SmartLinkStatus).Resolved) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $obtkX.default), {
        ...props,
        testId: testId
    });
};
var $d5cb2203e6787402$export$2e2bcd8739ae039 = $d5cb2203e6787402$var$AIFooterBlock;

});
parcelRegister("obtkX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6b56bbc6d143050$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $eqoQu = parcelRequire("eqoQu");

var $dghu0 = parcelRequire("dghu0");

var $kBKwT = parcelRequire("kBKwT");
const $f6b56bbc6d143050$var$AIFooterBlockResolvedView = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $8dVIb.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.Provider), {
                testId: `${testId}-provider`
            }),
            actionData ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kBKwT.AIFooterMetadata), {
                ...actionData,
                testId: `${testId}-ai-metadata`
            }) : null
        ]
    });
};
var $f6b56bbc6d143050$export$2e2bcd8739ae039 = $f6b56bbc6d143050$var$AIFooterBlockResolvedView;

});
parcelRegister("kBKwT", function(module, exports) {

$parcel$export(module.exports, "AIFooterMetadata", () => $84dc366e320e5880$export$175228cc2c92b3b6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $gKZoD = parcelRequire("gKZoD");

var $jps85 = parcelRequire("jps85");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $3bDjY = parcelRequire("3bDjY");

var $7zaVw = parcelRequire("7zaVw");

var $1MeuC = parcelRequire("1MeuC");

var $8z1HA = parcelRequire("8z1HA");

var $c8Sqt = parcelRequire("c8Sqt");

var $geWDu = parcelRequire("geWDu");
const $84dc366e320e5880$var$AIFooterMetadataNew = ({ testId: testId, url: url })=>{
    (0, $gKZoD.di)((0, $1MeuC.default));
    const { state: { status: status } } = (0, $1MeuC.default)(url);
    if (status !== 'done') return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $7zaVw.messages).ai_summarized_info_short
                }),
                position: "bottom",
                children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        ...tooltipProps,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c8Sqt.InfoIcon), {
                            label: "Information",
                            LEGACY_size: "small",
                            color: "var(--ds-icon-subtle, #626F86)"
                        })
                    })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jps85))), {
                label: "AI",
                LEGACY_size: "small",
                LEGACY_fallbackIcon: (0, $8z1HA.default),
                color: "var(--ds-icon-subtle, #626F86)"
            })
        ]
    });
};
const $84dc366e320e5880$export$175228cc2c92b3b6 = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($84dc366e320e5880$var$AIFooterMetadataNew, {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $geWDu.AIFooterMetadataOld), {
        ...props
    });
};

});
parcelRegister("c8Sqt", function(module, exports) {

$parcel$export(module.exports, "InfoIcon", () => $a035773c38c242b5$export$2957fc44b3d2481);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $2Yv61 = parcelRequire("2Yv61");

var $lqBg9 = parcelRequire("lqBg9");
const $a035773c38c242b5$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Yv61))), {
        color: props.color || 'currentColor',
        LEGACY_fallbackIcon: (0, $lqBg9.default),
        ...props
    });

});
parcelRegister("lqBg9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f1ed3211c768fe6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $4f1ed3211c768fe6$var$InfoIconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7.25 7L7.25 12H8.75L8.75 7H7.25Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8Z",
        fill: "currentColor"
    }));
/**
 * __InfoIcon__
 */ const $4f1ed3211c768fe6$var$InfoIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $4f1ed3211c768fe6$var$InfoIconGlyph
    });
var $4f1ed3211c768fe6$export$2e2bcd8739ae039 = $4f1ed3211c768fe6$var$InfoIcon;

});


parcelRegister("geWDu", function(module, exports) {

$parcel$export(module.exports, "AIFooterMetadataOld", () => $ae03d9230f6a4687$export$7cff2d86c454af23);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $gKZoD = parcelRequire("gKZoD");

var $jps85 = parcelRequire("jps85");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");

var $3bDjY = parcelRequire("3bDjY");

var $7zaVw = parcelRequire("7zaVw");

var $1MeuC = parcelRequire("1MeuC");

var $8z1HA = parcelRequire("8z1HA");

var $c8Sqt = parcelRequire("c8Sqt");
const $ae03d9230f6a4687$export$7cff2d86c454af23 = ({ testId: testId, url: url })=>{
    (0, $gKZoD.di)((0, $1MeuC.default));
    const { state: { status: status } } = (0, $1MeuC.default)(url);
    if (status !== 'done') return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f5TWP.default), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $7zaVw.messages).ai_summarized_info_short
                }),
                position: "bottom",
                children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                        ...tooltipProps,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c8Sqt.InfoIcon), {
                            label: "Information",
                            LEGACY_size: "small",
                            color: "var(--ds-icon-subtle, #626F86)"
                        })
                    })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jps85))), {
                label: "AI",
                LEGACY_size: "small",
                LEGACY_fallbackIcon: (0, $8z1HA.default),
                color: "var(--ds-icon-subtle, #626F86)"
            })
        ]
    });
};

});




parcelRegister("fh9qw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b695424587865b74$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gKZoD = parcelRequire("gKZoD");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $jRHKj = parcelRequire("jRHKj");

var $s2ak7 = parcelRequire("s2ak7");

var $6GeXu = parcelRequire("6GeXu");
const $b695424587865b74$var$ignoreContainerPaddingStyles = null;
const $b695424587865b74$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $b695424587865b74$var$sort = (a, b)=>{
    let idxA = $b695424587865b74$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $b695424587865b74$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $b695424587865b74$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $b695424587865b74$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
};
const $b695424587865b74$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $8dVIb.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $8dVIb.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $b695424587865b74$var$ActionBlockNew = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, testId: testId = 'smart-block-action' })=>{
    (0, $gKZoD.di)((0, $s2ak7.ActionFooter));
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    const [message, setMessage] = (0, $5uXOq.useState)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const onLoadingChange = (0, $5uXOq.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !ui?.hidePadding ? $b695424587865b74$export$1af10e3728e3a644(ui?.size || (0, $8dVIb.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $5uXOq.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback?.(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $5uXOq.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $5uXOq.useMemo)(()=>{
        if (!context?.actions) return;
        const arr = Object.keys(context.actions);
        arr.sort($b695424587865b74$var$sort);
        return arr.map((name)=>{
            const Action = name in $jRHKj ? $jRHKj[name] : undefined;
            return Action ? /*#__PURE__*/ (0, $2OMIu.jsx)(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: size,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/no-unsafe-design-token-usage
                style: padding && {
                    paddingInline: padding
                },
                hideTooltip: isLoading
            }, name) : null;
        });
    }, [
        context?.actions,
        onClick,
        onError,
        padding,
        size,
        spaceInline,
        isLoading,
        onLoadingChange
    ]);
    return actions ? /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        ref: blockRef,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb1osq _18u01ivi _2hwxc10g"
        ]),
        children: [
            actions,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $s2ak7.ActionFooter), {
                message: message,
                testId: testId
            })
        ]
    }) : null;
};
const $b695424587865b74$var$ActionBlock = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($b695424587865b74$var$ActionBlockNew, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6GeXu.default), {
        ...props
    });
};
var $b695424587865b74$export$2e2bcd8739ae039 = $b695424587865b74$var$ActionBlock;

});
parcelRegister("s2ak7", function(module, exports) {

$parcel$export(module.exports, "ActionFooter", () => $e384e6334b5a98a7$export$2d2b754ac238f9aa);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $059q9 = parcelRequire("059q9");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $aBTst = parcelRequire("aBTst");

var $3wDVQ = parcelRequire("3wDVQ");
const $e384e6334b5a98a7$var$containerStyles = null;
const $e384e6334b5a98a7$var$errorStyles = null;
const $e384e6334b5a98a7$var$styles = {
    errorContentStyles: "_bozgv77o",
    titleStyles: "_11c8qk37 _syaz1gjq"
};
const $e384e6334b5a98a7$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($059q9))), {
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "compact",
                label: "Error",
                LEGACY_size: "small",
                testId: "action-error-icon",
                LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`
            });
        default:
            return null;
    }
};
const $e384e6334b5a98a7$var$ActionFooterNew = ({ message: message, testId: testId })=>{
    if (!message) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testId": `${testId}-footer`,
        className: (0, $bwpsq.default)([
            "_kkk2n7od _2rkoglpi _1yt412x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _vwz4gktf _1bsb1osq _fiawglyw",
            message.appearance === 'error' && "_bfhk1gly"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aBTst.default), {
            isFadeIn: true,
            show: true,
            showTransition: true,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                alignBlock: "start",
                grow: "fill",
                space: "space.075",
                xcss: $e384e6334b5a98a7$var$styles.errorContentStyles,
                children: [
                    message.icon || $e384e6334b5a98a7$var$getIcon(message.appearance),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        xcss: $e384e6334b5a98a7$var$styles.titleStyles,
                        children: message.title
                    })
                ]
            })
        })
    });
};
const $e384e6334b5a98a7$export$2d2b754ac238f9aa = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($e384e6334b5a98a7$var$ActionFooterNew, {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3wDVQ.ActionFooterOld), {
        ...props
    });
};

});
parcelRegister("3wDVQ", function(module, exports) {

$parcel$export(module.exports, "ActionFooterOld", () => $5cb9f532c874d949$export$2613a37bf0f6de97);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $059q9 = parcelRequire("059q9");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $aBTst = parcelRequire("aBTst");
const $5cb9f532c874d949$var$containerStyles = (0, $8CUq3.xcss)({
    all: 'unset',
    borderRadius: 'border.radius',
    margin: 'space.100',
    marginBottom: 'space.0',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px',
    padding: 'space.075',
    paddingInline: 'space.100',
    width: '100%',
    ':empty': {
        display: 'none'
    }
});
const $5cb9f532c874d949$var$errorStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.danger'
});
const $5cb9f532c874d949$var$errorContentStyles = (0, $8CUq3.xcss)({
    paddingInlineStart: 'space.025'
});
const $5cb9f532c874d949$var$titleStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtle',
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $5cb9f532c874d949$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($059q9))), {
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "compact",
                label: "Error",
                LEGACY_size: "small",
                testId: "action-error-icon",
                LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`
            });
        default:
            return null;
    }
};
const $5cb9f532c874d949$export$2613a37bf0f6de97 = ({ message: message, testId: testId })=>{
    if (!message) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        testId: `${testId}-footer`,
        xcss: [
            $5cb9f532c874d949$var$containerStyles,
            message.appearance === 'error' && $5cb9f532c874d949$var$errorStyles
        ],
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aBTst.default), {
            isFadeIn: true,
            show: true,
            showTransition: true,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f5TWP.default), {
                alignBlock: "start",
                grow: "fill",
                space: "space.075",
                xcss: $5cb9f532c874d949$var$errorContentStyles,
                children: [
                    message.icon || $5cb9f532c874d949$var$getIcon(message.appearance),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                        xcss: $5cb9f532c874d949$var$titleStyles,
                        children: message.title
                    })
                ]
            })
        })
    });
};

});


parcelRegister("6GeXu", function(module, exports) {

$parcel$export(module.exports, "default", () => $d655c3cc6a66bae1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $gKZoD = parcelRequire("gKZoD");

var $8CUq3 = parcelRequire("8CUq3");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $jRHKj = parcelRequire("jRHKj");

var $fpDmE = parcelRequire("fpDmE");

var $s2ak7 = parcelRequire("s2ak7");
function $d655c3cc6a66bae1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d655c3cc6a66bae1$var$ignoreContainerPaddingStyles = {
    name: "19m4cma",
    styles: "display:flex;flex-direction:column;box-sizing:border-box;flex-grow:1;width:100%;margin-left:calc(var(--container-gap-left) * -1);margin-right:calc(var(--container-gap-right) * -1)"
};
const $d655c3cc6a66bae1$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $d655c3cc6a66bae1$var$sort = (a, b)=>{
    let idxA = $d655c3cc6a66bae1$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $d655c3cc6a66bae1$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $d655c3cc6a66bae1$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $d655c3cc6a66bae1$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
};
const $d655c3cc6a66bae1$var$ActionBlockOld = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, testId: testId = 'smart-block-action' })=>{
    (0, $gKZoD.di)((0, $s2ak7.ActionFooter));
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    const [message, setMessage] = (0, $5uXOq.useState)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const onLoadingChange = (0, $5uXOq.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !ui?.hidePadding ? (0, $fpDmE.getPrimitivesPaddingSpaceBySize)(ui?.size || (0, $8dVIb.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $5uXOq.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback?.(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $5uXOq.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $5uXOq.useMemo)(()=>{
        if (!context?.actions) return;
        const arr = Object.keys(context.actions);
        arr.sort($d655c3cc6a66bae1$var$sort);
        return arr.map((name)=>{
            const Action = name in $jRHKj ? $jRHKj[name] : undefined;
            return Action ? /*#__PURE__*/ (0, $f8Sb3.jsx)(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                key: name,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: size,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                xcss: (0, $8CUq3.xcss)({
                    paddingInline: padding
                }),
                hideTooltip: isLoading
            }) : null;
        });
    }, [
        context?.actions,
        onClick,
        onError,
        padding,
        size,
        spaceInline,
        isLoading,
        onLoadingChange
    ]);
    return actions ? /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $d655c3cc6a66bae1$var$ignoreContainerPaddingStyles,
        ref: blockRef,
        "data-testid": testId
    }, actions, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $s2ak7.ActionFooter), {
        message: message,
        paddingInline: padding,
        testId: testId
    })) : null;
};
var $d655c3cc6a66bae1$export$2e2bcd8739ae039 = $d655c3cc6a66bae1$var$ActionBlockOld;

});




parcelRegister("i41Ob", function(module, exports) {

$parcel$export(module.exports, "LoadingCardLink", () => $b4c0875f37c33ad9$export$1ca0544321134ad6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bMldO = parcelRequire("bMldO");

const $b4c0875f37c33ad9$export$1ca0544321134ad6 = ({ isSelected: isSelected, url: url, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMldO.CardLinkView), {
        testId: 'lazy-render-placeholder',
        "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
        isSelected: isSelected,
        link: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $b18b5009ce608fe8$export$4b2b7d155f69aed4),
        placeholder: placeholder
    }, 'lazy-render-key');
};

});
parcelRegister("bMldO", function(module, exports) {

$parcel$export(module.exports, "CardLinkView", () => $d0b446175f31475d$export$ce508304ed2dd145);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kkxZO = parcelRequire("kkxZO");
class $d0b446175f31475d$export$ce508304ed2dd145 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kkxZO.Frame), {
            withoutBackground: true,
            ...this.props,
            children: this.props.placeholder || this.props.link
        });
    }
}

});
parcelRegister("kkxZO", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $2ed7f4f9fecd197d$export$b89a827e9254211a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $4URMI = parcelRequire("4URMI");

var $8RHvB = parcelRequire("8RHvB");

var $7WNJh = parcelRequire("7WNJh");
const $2ed7f4f9fecd197d$export$b89a827e9254211a = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { isSelected: isSelected, children: children, onClick: onClick, link: link, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered, truncateInline: truncateInline } = props;
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, $5uXOq.useCallback)((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleMouseDown = (0, $4URMI.useMouseDownEvent)();
    const isInteractive = Boolean(onClick);
    const isAnchor = Boolean(link || onClick);
    // Depending on whenever Frame was given onClick or link itself we display span or anchor elements
    const Wrapper = (0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard') ? isAnchor ? (0, $8RHvB.WrapperAnchor) : (0, $8RHvB.WrapperSpan) : isAnchor ? (0, $7WNJh.WrapperAnchor) : (0, $7WNJh.WrapperSpan);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
        href: link,
        withoutBackground: withoutBackground,
        isSelected: isSelected,
        isInteractive: isInteractive,
        tabIndex: isInteractive ? 0 : undefined,
        "aria-label": isAnchor ? link ?? 'Link' : undefined,
        role: isInteractive ? 'button' : undefined,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onKeyPress: handleKeyPress,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        isHovered: isHovered,
        truncateInline: truncateInline,
        children: children
    });
});

});
parcelRegister("8RHvB", function(module, exports) {

$parcel$export(module.exports, "WrapperSpan", () => $7f29852863f1f016$export$8b5c95e985c4ec9a);
$parcel$export(module.exports, "WrapperAnchor", () => $7f29852863f1f016$export$6e4bde711df5c2ab);
/* styled.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $7f29852863f1f016$var$lineHeight = 22;
const $7f29852863f1f016$export$8b5c95e985c4ec9a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ref: ref,
        ...props,
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_11c81doa _1yt4x7n9 _2rkoiti9 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28" : "_1yt4x7n9 _2rkoiti9 _v56415x0 _vwz4qslr _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28",
            truncateInline && (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _17bix7n9 _nr8z1o8l",
            truncateInline && !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _vwz4183y _1e0c1abx _1yyjkb7n _sudp1e54 _17bix7n9 _nr8z1o8l _102kqslr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19ith6cr _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6dmr28",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw7h6cr _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv"
        ]),
        children: props.children
    });
});
const $7f29852863f1f016$export$6e4bde711df5c2ab = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        href: href,
        ref: ref,
        ...props,
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_11c81doa _1yt4x7n9 _2rkoiti9 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28" : "_1yt4x7n9 _2rkoiti9 _v56415x0 _vwz4qslr _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28",
            truncateInline && (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _17bix7n9 _nr8z1o8l",
            truncateInline && !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _vwz4183y _1e0c1abx _1yyjkb7n _sudp1e54 _17bix7n9 _nr8z1o8l _102kqslr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19ith6cr _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6dmr28",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw7h6cr _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv",
            isInteractive && "_nt751r31 _49pcglyw _1hvw1o36 _1372tlke _7ehicw00 _1j5pglyw _1di629zg"
        ]),
        children: props.children
    });
});
const $7f29852863f1f016$var$baseWrapperStylesNew = null;
const $7f29852863f1f016$var$baseWrapperStylesOld = null;
// if the parent instruct the wrapper to be interactive, and the wrapper is in focus, apply selectedStyles
const $7f29852863f1f016$var$interactiveStyles = null;
const $7f29852863f1f016$var$hoveredStyles = null;
const $7f29852863f1f016$var$hoveredWithBackgroundStyles = null;
const $7f29852863f1f016$var$withoutBackgroundStyles = null;
const $7f29852863f1f016$var$withBackgroundStyles = null;
const $7f29852863f1f016$var$truncateStylesNew = null;
const $7f29852863f1f016$var$truncateStylesOld = null;
const $7f29852863f1f016$var$notSelectedStyle = null;
const $7f29852863f1f016$var$selectedStyles = null;

});

parcelRegister("7WNJh", function(module, exports) {

$parcel$export(module.exports, "WrapperAnchor", () => $65f1736df4b88c9b$export$6e4bde711df5c2ab);
$parcel$export(module.exports, "WrapperSpan", () => $65f1736df4b88c9b$export$8b5c95e985c4ec9a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $bWGt6 = parcelRequire("bWGt6");
const $65f1736df4b88c9b$var$lineHeight = 22;
const $65f1736df4b88c9b$var$selectedStyles = {
    cursor: 'pointer',
    boxShadow: `0 0 0 2px ${`var(--ds-border-selected, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`,
    outline: 'none',
    userSelect: 'none',
    '&, :hover, :focus, :active': {
        textDecoration: 'none'
    },
    '&:hover': {
        border: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`}`
    }
};
const $65f1736df4b88c9b$var$isInteractive = ({ isInteractive: isInteractive })=>{
    if (isInteractive) return {
        ':active': {
            backgroundColor: `var(--ds-background-selected, ${0, $829f609a65d26a98$export$226de0355ed012f8})`
        },
        ':focus': $65f1736df4b88c9b$var$selectedStyles
    };
    return undefined;
};
const $65f1736df4b88c9b$var$isSelected = ({ isSelected: isSelected })=>{
    if (isSelected) return $65f1736df4b88c9b$var$selectedStyles;
    else return {
        userSelect: 'text'
    };
};
const $65f1736df4b88c9b$var$hoveredStyles = {
    borderColor: `var(--ds-border-accent-blue, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`
};
const $65f1736df4b88c9b$var$activeHoveredFocusedStyles = (props)=>{
    if (props.withoutBackground) return undefined;
    return {
        textDecoration: 'none'
    };
};
const $65f1736df4b88c9b$var$hoveredWihBorderStyles = (props)=>({
        ...$65f1736df4b88c9b$var$hoveredStyles,
        ...$65f1736df4b88c9b$var$activeHoveredFocusedStyles(props)
    });
/*
  Inline smart cards should have the following layout:
  ------------------------------------
  | icon | title | action OR lozenge |
  ------------------------------------
  The aim is to ensure (1) all children are
  in line with each other, (2) are vertically
  centered.
*/ // NB: `padding` consistent with @mentions.
// NB: `display: inline` required for `box-decoration-break` to work.
// NB: `box-decoration-break` required for retaining properties (border-radius) on wrap.
const $65f1736df4b88c9b$var$baseWrapperStyles = (props)=>({
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: `${$65f1736df4b88c9b$var$lineHeight}px`,
        padding: `${"var(--ds-space-025, 2px)"} 0px`,
        ...props.withoutBackground ? {
            paddingLeft: 0,
            marginLeft: "var(--ds-space-negative-025, -2px)"
        } : undefined,
        display: 'inline',
        boxDecorationBreak: 'clone',
        borderRadius: "var(--ds-border-radius-100, 4px)",
        color: `var(--ds-link, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`,
        ...props.withoutBackground ? undefined : {
            backgroundColor: "var(--ds-surface-raised, white)"
        },
        ...$65f1736df4b88c9b$var$isSelected(props),
        ...props.withoutBackground ? undefined : {
            border: `1px solid ${`var(--ds-border, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`}`
        },
        '&:hover': $65f1736df4b88c9b$var$hoveredStyles,
        '&, :hover, :focus, :active': $65f1736df4b88c9b$var$activeHoveredFocusedStyles(props),
        transition: '0.1s all ease-in-out',
        MozUserSelect: 'none',
        // -moz-user-select
        ...props.isHovered ? $65f1736df4b88c9b$var$hoveredWihBorderStyles(props) : undefined
    });
const $65f1736df4b88c9b$var$truncateStyles = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-all',
    // The height of a truncated card is 1px higher than that of a non-truncated card, so we subtract 1px from the line height.
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: `${$65f1736df4b88c9b$var$lineHeight - 1}px`,
    display: '-webkit-inline-box',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
    // We need to remove the padding because display: -webkit-inline-box will cause any padding to be
    // added to the total height, causing truncated cards to have greater height than non-truncated cards which use display: inline.
    padding: 0,
    '@supports not (-webkit-line-clamp: 1)': {
        display: 'inline-block',
        maxHeight: `${$65f1736df4b88c9b$var$lineHeight}px`,
        // If the browser does not support webkit, we don't need to remove the padding
        padding: `${"var(--ds-space-025, 2px)"} 0px`
    }
};
const $65f1736df4b88c9b$var$isTruncated = ({ truncateInline: truncateInline })=>{
    if (truncateInline) return $65f1736df4b88c9b$var$truncateStyles;
    return undefined;
};
const $65f1736df4b88c9b$export$6e4bde711df5c2ab = /*#__PURE__*/ (0, $bWGt6.default)("a", {
    target: "ewuc7q31"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$65f1736df4b88c9b$var$baseWrapperStyles(props),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$65f1736df4b88c9b$var$isInteractive(props),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$65f1736df4b88c9b$var$isTruncated(props)
    }));
$65f1736df4b88c9b$export$6e4bde711df5c2ab.displayName = 'WrapperAnchor';
const $65f1736df4b88c9b$export$8b5c95e985c4ec9a = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ewuc7q30"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$65f1736df4b88c9b$var$baseWrapperStyles(props),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$65f1736df4b88c9b$var$isTruncated(props)
    }));
$65f1736df4b88c9b$export$8b5c95e985c4ec9a.displayName = 'WrapperSpan';

});



const $b18b5009ce608fe8$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';


parcelRegister("5HNFf", function(module, exports) {

let $42777e3129bc7bce$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $42777e3129bc7bce$var$load("h2MrD"),
    $42777e3129bc7bce$var$load("bYT2S"),
    $42777e3129bc7bce$var$load("ij5kv")
]).then(()=>parcelRequire('6Of57'));

});



parcelRegister("kfrXe", function(module, exports) {

$parcel$export(module.exports, "UsernameDisplay", () => $698109a783cde8de$export$89592377716faa3d);

var $5uXOq = parcelRequire("5uXOq");

var $hDzhb = parcelRequire("hDzhb");

var $bD2Hf = parcelRequire("bD2Hf");

var $79GHn = parcelRequire("79GHn");
const $698109a783cde8de$export$89592377716faa3d = ({ user: user, onClick: onClick })=>{
    const { linksTarget: linksTarget } = (0, $79GHn.useSummaryFeatures)();
    if (user.displayName === 'Unknown') return user.displayName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
        href: (0, $bD2Hf.buildAccountUrl)(user.accountId),
        target: linksTarget,
        onClick: ()=>{
            onClick?.();
        }
    }, user.displayName);
};

});
parcelRegister("bD2Hf", function(module, exports) {

$parcel$export(module.exports, "buildAccountUrl", () => $c1a253701bf8ceca$export$7d9ab302d9df6891);
const $c1a253701bf8ceca$export$7d9ab302d9df6891 = (accountId)=>`/secure/ViewProfile.jspa?accountId=${accountId}`;

});



parcelRegister("29Z5g", function(module, exports) {

$parcel$export(module.exports, "default", () => $aad353da16394b26$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $aad353da16394b26$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    assigneeChangedContent: {
        "id": "contextual-summary.gadgets.activity-feed.activity-items.attachment-added.assignee-changed-content",
        "defaultMessage": "{author} changed the Assignee to {newAssignee} on {issueLink}"
    },
    assigneeRemovedContent: {
        "id": "contextual-summary.gadgets.activity-feed.activity-items.attachment-added.assignee-removed-content",
        "defaultMessage": "{author} removed the Assignee of {issueLink}"
    }
});

});


parcelRegister("4Pfmb", function(module, exports) {

$parcel$export(module.exports, "AttachmentAdded", () => $4a333256584c2e8d$export$db33ea4cb1ff5d9d);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");

var $koVbs = parcelRequire("koVbs");

var $kUujW = parcelRequire("kUujW");

var $i6Q86 = parcelRequire("i6Q86");

var $beAwS = parcelRequire("beAwS");

var $ckwn2 = parcelRequire("ckwn2");

var $153fj = parcelRequire("153fj");

var $6c07p = parcelRequire("6c07p");
const $4a333256584c2e8d$export$db33ea4cb1ff5d9d = ({ activity: { created: created, issueData: issueData, author: author } })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { fireSectionAnalytics: fireSectionAnalytics } = (0, $153fj.useSectionAnalytics)((0, $beAwS.SectionIds).RecentActivity, (0, $beAwS.BoundaryIds).RecentActivity);
    const onActivityItemClick = (0, $5uXOq.useCallback)((target)=>{
        fireSectionAnalytics(target, {
            boundaryId: (0, $beAwS.BoundaryIds).RecentActivity,
            activityType: (0, $beAwS.ActivityTypes).ATTACHMENT_ADDED
        });
    }, [
        fireSectionAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        columnGap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i6Q86.UserAvatar), {
        author: author
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        rowGap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ckwn2.ActivityMessage), {
        author: author,
        issueData: issueData,
        onClick: onActivityItemClick
    }, ({ author: activityAuthor, issueLink: issueLink })=>formatMessage((0, $6c07p.default).attachmentContent, {
            author: activityAuthor,
            issueLink: issueLink
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kUujW.RelativeTime), {
        time: created
    }))));
};

});
parcelRegister("6c07p", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa9919921d550f1f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fa9919921d550f1f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    attachmentContent: {
        "id": "contextual-summary.gadgets.activity-feed.activity-items.attachment-added.attachment-content",
        "defaultMessage": "{author} attached a file to {issueLink}"
    }
});

});


parcelRegister("aGoax", function(module, exports) {

$parcel$export(module.exports, "CommentAdded", () => $a6c9d4567b8dc400$export$6a401696fa20bf9c);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $kOFhM = parcelRequire("kOFhM");

var $f5oqj = parcelRequire("f5oqj");

var $koVbs = parcelRequire("koVbs");

var $h17zy = parcelRequire("h17zy");

var $4IoOR = parcelRequire("4IoOR");

var $6a30R = parcelRequire("6a30R");

var $kUujW = parcelRequire("kUujW");

var $i6Q86 = parcelRequire("i6Q86");

var $beAwS = parcelRequire("beAwS");

var $ckwn2 = parcelRequire("ckwn2");

var $153fj = parcelRequire("153fj");

var $kZkXS = parcelRequire("kZkXS");
const $a6c9d4567b8dc400$export$6a401696fa20bf9c = ({ activity: { created: created, issueData: issueData, author: author, data: { comment: comment } } })=>{
    const [isCommentExpanded, setIsCommentExpanded] = (0, $5uXOq.useState)(false);
    const emojiProvider = (0, $h17zy.useEmojiProvider)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { fireSectionAnalytics: fireSectionAnalytics } = (0, $153fj.useSectionAnalytics)((0, $beAwS.SectionIds).RecentActivity, (0, $beAwS.BoundaryIds).RecentActivity);
    const adf = (0, $4IoOR.convertWikiToAdf)(comment);
    const onActivityItemClick = (0, $5uXOq.useCallback)((target)=>{
        fireSectionAnalytics(target, {
            boundaryId: (0, $beAwS.BoundaryIds).RecentActivity,
            activityType: (0, $beAwS.ActivityTypes).COMMENT_ADDED
        });
    }, [
        fireSectionAnalytics
    ]);
    const onCommentLinkClick = (0, $5uXOq.useCallback)((event, url)=>{
        (0, $6a30R.onLinkClick)(event, url);
        fireSectionAnalytics('link', {
            boundaryId: (0, $beAwS.BoundaryIds).RecentActivity,
            activityType: (0, $beAwS.ActivityTypes).COMMENT_ADDED
        });
    }, [
        fireSectionAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        columnGap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i6Q86.UserAvatar), {
        author: author
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        rowGap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ckwn2.ActivityMessage), {
        author: author,
        issueData: issueData,
        onClick: onActivityItemClick
    }, ({ author: activityAuthor, issueLink: issueLink })=>formatMessage((0, $kZkXS.default).commentAddedContent, {
            author: activityAuthor,
            issueLink: issueLink
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kUujW.RelativeTime), {
        time: created
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        role: "button",
        "aria-expanded": isCommentExpanded,
        tabIndex: 0,
        onClick: ()=>{
            setIsCommentExpanded((prev)=>!prev);
        },
        onKeyDown: (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                setIsCommentExpanded((prev)=>!prev);
            }
        },
        xcss: $a6c9d4567b8dc400$var$commentWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5oqj.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        document: adf,
        schema: (0, $kOFhM.defaultSchema),
        truncated: !isCommentExpanded,
        dataProviders: emojiProvider,
        eventHandlers: {
            smartCard: {
                onClick: onCommentLinkClick
            },
            link: {
                onClick: onCommentLinkClick
            }
        },
        smartLinks: (0, $6a30R.smartLinksDefault)
    })))));
};
const $a6c9d4567b8dc400$var$commentWrapperStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100',
    padding: 'space.100',
    border: '1px solid',
    borderColor: 'color.border',
    borderRadius: 'border.radius',
    cursor: 'pointer',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':focus': {
        outline: '1px solid',
        outlineColor: 'color.border.focused'
    }
});

});
parcelRegister("kOFhM", function(module, exports) {

$parcel$export(module.exports, "defaultSchemaConfig", () => $f27880a8173018db$export$e4e3ac1fa64862db);
$parcel$export(module.exports, "getSchemaBasedOnStage", () => $f27880a8173018db$export$fd147e7d448dea03);
$parcel$export(module.exports, "defaultSchema", () => $f27880a8173018db$export$1db618b7b2275ea1);

var $8QpSo = parcelRequire("8QpSo");

var $aXBFx = parcelRequire("aXBFx");
var $7kC9H = parcelRequire("7kC9H");
var $47jug = parcelRequire("47jug");
var $gZoER = parcelRequire("gZoER");
var $2FIVU = parcelRequire("2FIVU");
var $bFtEE = parcelRequire("bFtEE");
var $9UDEr = parcelRequire("9UDEr");

var $kBho7 = parcelRequire("kBho7");
const $f27880a8173018db$var$getDefaultSchemaConfig = ()=>{
    const defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            // https://product-fabric.atlassian.net/browse/ED-10214,
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
const $f27880a8173018db$export$e4e3ac1fa64862db = $f27880a8173018db$var$getDefaultSchemaConfig();
const $f27880a8173018db$export$fd147e7d448dea03 = (0, $8QpSo.default)((stage = 'final')=>{
    const defaultSchemaConfig = $f27880a8173018db$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $gZoER.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $47jug.multiBodiedExtension),
        extensionFrame: (0, $47jug.extensionFrame),
        expand: (0, $7kC9H.expandWithNestedExpand),
        blockquote: (0, $aXBFx.blockquoteWithNestedCodeblockOrMedia),
        listItem: (0, $2FIVU.listItemWithDecisionStage0),
        panel: (0, $bFtEE.panelWithBlockquoteStage0)(true),
        table: (0, $9UDEr.tableWithNestedTable),
        tableRow: (0, $9UDEr.tableRowWithNestedTable),
        tableCell: (0, $9UDEr.tableCellWithNestedTable),
        tableHeader: (0, $9UDEr.tableHeaderWithNestedTable)
    };
    return (0, $kBho7.createSchema)(defaultSchemaConfig);
});
const $f27880a8173018db$export$1db618b7b2275ea1 = $f27880a8173018db$export$fd147e7d448dea03();

});
parcelRegister("aXBFx", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $7faca2534e4894a0$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteWithNestedCodeblockOrMedia", () => $7faca2534e4894a0$export$c4d50234112df933);
$parcel$export(module.exports, "blockquoteWithList", () => $7faca2534e4894a0$export$9b4686c4b9672643);

var $gthjq = parcelRequire("gthjq");
/**
 * @name blockquote_node
 */ const $7faca2534e4894a0$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
};
const $7faca2534e4894a0$export$67dc04e652a298ca = (0, $gthjq.blockquoteLegacy)($7faca2534e4894a0$var$nodeSpecOptions);
const $7faca2534e4894a0$export$c4d50234112df933 = (0, $gthjq.blockquote)($7faca2534e4894a0$var$nodeSpecOptions);
const $7faca2534e4894a0$export$9b4686c4b9672643 = (0, $gthjq.blockquoteWithoutNestedCodeblockOrMedia)({
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
});

});
parcelRegister("gthjq", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $bfdcc8a4590754dc$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $bfdcc8a4590754dc$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteLegacy", () => $bfdcc8a4590754dc$export$199922e5af8e9a6);
$parcel$export(module.exports, "blockquoteWithoutNestedCodeblockOrMedia", () => $bfdcc8a4590754dc$export$a91509d1c739c16f);
$parcel$export(module.exports, "bodiedExtension", () => $bfdcc8a4590754dc$export$27903d543b563e39);
$parcel$export(module.exports, "bulletList", () => $bfdcc8a4590754dc$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $bfdcc8a4590754dc$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "codeBlock", () => $bfdcc8a4590754dc$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "confluenceJiraIssue", () => $bfdcc8a4590754dc$export$daf889beb5092f95);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $bfdcc8a4590754dc$export$e6e4878f43c27cab);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $bfdcc8a4590754dc$export$3e6d667072febc87);
$parcel$export(module.exports, "date", () => $bfdcc8a4590754dc$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $bfdcc8a4590754dc$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $bfdcc8a4590754dc$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $bfdcc8a4590754dc$export$2a111da947c407d2);
$parcel$export(module.exports, "embedCard", () => $bfdcc8a4590754dc$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $bfdcc8a4590754dc$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $bfdcc8a4590754dc$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expandWithoutNestedExpand", () => $bfdcc8a4590754dc$export$63c0f3992661097b);
$parcel$export(module.exports, "extension", () => $bfdcc8a4590754dc$export$1b45514b112dd749);
$parcel$export(module.exports, "extensionFrameStage0", () => $bfdcc8a4590754dc$export$b555be60c7703afb);
$parcel$export(module.exports, "hardBreak", () => $bfdcc8a4590754dc$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $bfdcc8a4590754dc$export$46e4a324ac90507f);
$parcel$export(module.exports, "image", () => $bfdcc8a4590754dc$export$5c452ff88e35e47d);
$parcel$export(module.exports, "inlineCard", () => $bfdcc8a4590754dc$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtensionWithMarks", () => $bfdcc8a4590754dc$export$b3b1e36c2105006d);
$parcel$export(module.exports, "layoutColumn", () => $bfdcc8a4590754dc$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $bfdcc8a4590754dc$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionFull", () => $bfdcc8a4590754dc$export$cdae19acb0a520fd);
$parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", () => $bfdcc8a4590754dc$export$206007566ca0aca5);
$parcel$export(module.exports, "listItem", () => $bfdcc8a4590754dc$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithNestedDecisionStage0", () => $bfdcc8a4590754dc$export$df876f0305235056);
$parcel$export(module.exports, "media", () => $bfdcc8a4590754dc$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $bfdcc8a4590754dc$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $bfdcc8a4590754dc$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $bfdcc8a4590754dc$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleCaption", () => $bfdcc8a4590754dc$export$8d067f22dc2d1254);
$parcel$export(module.exports, "mediaSingleFull", () => $bfdcc8a4590754dc$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleWidthType", () => $bfdcc8a4590754dc$export$4bd9a38995f6bf50);
$parcel$export(module.exports, "mention", () => $bfdcc8a4590754dc$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtensionStage0", () => $bfdcc8a4590754dc$export$750e45819f66d9d0);
$parcel$export(module.exports, "nestedExpand", () => $bfdcc8a4590754dc$export$63cadbf5f4296627);
$parcel$export(module.exports, "orderedList", () => $bfdcc8a4590754dc$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $bfdcc8a4590754dc$export$21f42ab9b6679f44);
$parcel$export(module.exports, "panelWithNestedBlockquoteStage0", () => $bfdcc8a4590754dc$export$a1cf9918ad22c7e9);
$parcel$export(module.exports, "paragraph", () => $bfdcc8a4590754dc$export$9c206ddddb32a9b);
$parcel$export(module.exports, "placeholder", () => $bfdcc8a4590754dc$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $bfdcc8a4590754dc$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $bfdcc8a4590754dc$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "table", () => $bfdcc8a4590754dc$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithNestedTable", () => $bfdcc8a4590754dc$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableCell", () => $bfdcc8a4590754dc$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $bfdcc8a4590754dc$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeader", () => $bfdcc8a4590754dc$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $bfdcc8a4590754dc$export$2a5a518232fa1a97);
$parcel$export(module.exports, "tableRow", () => $bfdcc8a4590754dc$export$ce666bf02318c957);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $bfdcc8a4590754dc$export$7d657479499397);
$parcel$export(module.exports, "taskItem", () => $bfdcc8a4590754dc$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $bfdcc8a4590754dc$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $bfdcc8a4590754dc$export$6f093cfa640b7166);
$parcel$export(module.exports, "unsupportedBlock", () => $bfdcc8a4590754dc$export$44b79b0979d0f0f7);
$parcel$export(module.exports, "unsupportedInline", () => $bfdcc8a4590754dc$export$310ebe0d80122e9b);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $f0ccE = parcelRequire("f0ccE");
const $bfdcc8a4590754dc$export$c4c2f833baaebdb8 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $bfdcc8a4590754dc$export$67dc04e652a298ca = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
const $bfdcc8a4590754dc$export$199922e5af8e9a6 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
const $bfdcc8a4590754dc$export$a91509d1c739c16f = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
const $bfdcc8a4590754dc$export$27903d543b563e39 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$e7320d153c538837 = (0, $f0ccE.createPMNodeSpecFactory)({
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$a140c94e5ea26bee = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: false
});
const $bfdcc8a4590754dc$export$8e3c2dfdc4f0453d = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    selectable: false,
    isolating: true
});
const $bfdcc8a4590754dc$export$7bb0d5c671655cc4 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $bfdcc8a4590754dc$export$e4f1c66d84049f8b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $bfdcc8a4590754dc$export$daf889beb5092f95 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
const $bfdcc8a4590754dc$export$e6e4878f43c27cab = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $bfdcc8a4590754dc$export$3e6d667072febc87 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $bfdcc8a4590754dc$export$324d90190a8b822a = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$47988d68fe575725 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$6959e16eeff859b4 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
const $bfdcc8a4590754dc$export$62d45a65fb43d95e = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$2a111da947c407d2 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(block | codeBlock | layoutSection | blockRootOnly | expand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment breakout'
});
const $bfdcc8a4590754dc$export$be4283d9a1cb1ff6 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$a19185d1233fc4b2 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$f5574b5d45fc2112 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$9f77e0932fb78f72 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$7e3788972005cc72 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$63c0f3992661097b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$1b45514b112dd749 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$a8baf338431a691 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$b555be60c7703afb = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$371da9dd35aba193 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: '\n'
        }
    },
    selectable: false,
    linebreakReplacement: true
});
const $bfdcc8a4590754dc$export$46e4a324ac90507f = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$1b0c1557b234fa00 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$85461f751c457cc2 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$2b380a0f7e250af1 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$5c452ff88e35e47d = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
const $bfdcc8a4590754dc$export$cbf8224b64e0d942 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $bfdcc8a4590754dc$export$2f4e72b9459914ad = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $bfdcc8a4590754dc$export$16b353b2649bd8d9 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$b3b1e36c2105006d = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$ab76e7c03cd6f650 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(block | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment',
    attrs: {
        width: {
            default: undefined
        }
    },
    selectable: false,
    isolating: true
});
const $bfdcc8a4590754dc$export$b3b6a70a7fa4a5be = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
const $bfdcc8a4590754dc$export$cdae19acb0a520fd = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
const $bfdcc8a4590754dc$export$206007566ca0aca5 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        columnRuleStyle: {
            default: null
        }
    },
    isolating: true
});
const $bfdcc8a4590754dc$export$76c7e83ecc9cdf05 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$df876f0305235056 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | decisionList) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | decisionList)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$987d49ffe1b0900f = (0, $f0ccE.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$2855e964765eac9 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
const $bfdcc8a4590754dc$export$38bab695e3f720f1 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$969fe3781ca15058 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
const $bfdcc8a4590754dc$export$8d067f22dc2d1254 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$7e767666f2ce108a = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$4bd9a38995f6bf50 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$db83999c14438df4 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$46f790bd65f760d0 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$750e45819f66d9d0 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
const $bfdcc8a4590754dc$export$63cadbf5f4296627 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$f03786aa6312d1e4 = (0, $f0ccE.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$a5dc81035676e7a = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$21f42ab9b6679f44 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$a1cf9918ad22c7e9 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | blockquote)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$9c206ddddb32a9b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$4f98472e6dc14293 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$ea332b61641b0588 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$a1f41dc4901771f8 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$c7187bbd1a7a9244 = (0, $f0ccE.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$fbeb3a3956e8a3c7 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block'
});
const $bfdcc8a4590754dc$export$471f7ae5c4103ae1 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$b6ce52be8d7a261 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$9852986a3ec5f6a0 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $bfdcc8a4590754dc$export$ce086a560a1d05f5 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $bfdcc8a4590754dc$export$e1e720e5f4603e6a = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $bfdcc8a4590754dc$export$abf39ca178940ff3 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $bfdcc8a4590754dc$export$48884d2a5190dc73 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $bfdcc8a4590754dc$export$2a5a518232fa1a97 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $bfdcc8a4590754dc$export$ce666bf02318c957 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    tableRole: 'row'
});
const $bfdcc8a4590754dc$export$7d657479499397 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    tableRole: 'row'
});
const $bfdcc8a4590754dc$export$6d8b0ef52e2e6390 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$375b6afcc5f4d291 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(taskItem | unsupportedBlock)+ (taskItem | taskList | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$6f093cfa640b7166 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline'
});
const $bfdcc8a4590754dc$export$5ea06bc686c59dc2 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline'
});
const $bfdcc8a4590754dc$export$93256a4c17b33a82 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline'
});
const $bfdcc8a4590754dc$export$a12828d0f14a2762 = (0, $f0ccE.createPMNodeSpecFactory)({});
const $bfdcc8a4590754dc$export$44b79b0979d0f0f7 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$310ebe0d80122e9b = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("f0ccE", function(module, exports) {

$parcel$export(module.exports, "createPMNodeSpecFactory", () => $aec0525c0df12bb9$export$bf0a80f00e2b8ff6);
$parcel$export(module.exports, "createPMMarkSpecFactory", () => $aec0525c0df12bb9$export$cf5823ed4e9f4c6f);
/**
 * Factory method to attach custom parseDOM and/or toDOM for nodeSpec
 *
 * @example
 * createPMNodeSpecFactory<SomeNode>(node)({parseDOM: {}, toDOM: (node) => {} });
 *
 * @param nodeSpec - NodeSpec without toDom and parseDom
 * @returns A function for a node which allows the consumer to define toDom and parseDom
 */ const $aec0525c0df12bb9$export$bf0a80f00e2b8ff6 = (nodeSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        return {
            ...nodeSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };
const $aec0525c0df12bb9$export$cf5823ed4e9f4c6f = (markSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        return {
            ...markSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };

});



parcelRegister("7kC9H", function(module, exports) {

$parcel$export(module.exports, "expand", () => $5567ff8f3f52f7a8$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expandWithNestedExpand", () => $5567ff8f3f52f7a8$export$7b80cba28d10b2c1);
$parcel$export(module.exports, "toJSON", () => $5567ff8f3f52f7a8$export$54fd2c36b5cc6731);

var $gthjq = parcelRequire("gthjq");
/**
 * @name expand_node
 */ /**
 * @name expand_with_no_mark_node
 */ /**
 * @name expand_root_only_node
 */ function $5567ff8f3f52f7a8$var$getExpandAttrs(domNode) {
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $5567ff8f3f52f7a8$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $5567ff8f3f52f7a8$export$9f77e0932fb78f72 = (0, $gthjq.expandWithoutNestedExpand)($5567ff8f3f52f7a8$var$nodeSpecOptions);
const $5567ff8f3f52f7a8$export$7b80cba28d10b2c1 = (0, $gthjq.expand)($5567ff8f3f52f7a8$var$nodeSpecOptions);
const $5567ff8f3f52f7a8$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>!key.startsWith('__')).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("47jug", function(module, exports) {

$parcel$export(module.exports, "extensionFrame", () => $2ff6ee9baaedd4b6$export$4fdcae991fd743e7);
$parcel$export(module.exports, "multiBodiedExtension", () => $2ff6ee9baaedd4b6$export$c3c04d555a8b9013);

var $CWpyq = parcelRequire("CWpyq");

var $gthjq = parcelRequire("gthjq");
const $2ff6ee9baaedd4b6$export$4fdcae991fd743e7 = (0, $gthjq.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-extension-frame': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $2ff6ee9baaedd4b6$export$c3c04d555a8b9013 = (0, $gthjq.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: (domNode)=>(0, $CWpyq.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});
parcelRegister("CWpyq", function(module, exports) {

$parcel$export(module.exports, "getExtensionAttrs", () => $0750dbf71b86cced$export$1765e2758fc47004);
const $0750dbf71b86cced$export$d5f21755dc782a4a = (name)=>{
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};
const $0750dbf71b86cced$export$1765e2758fc47004 = (dom, isInline = false)=>{
    const extensionType = dom.getAttribute('data-extension-type');
    const extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    const attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        const rawLayout = dom.getAttribute('data-layout');
        attrs.layout = $0750dbf71b86cced$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};

});


parcelRegister("gZoER", function(module, exports) {

$parcel$export(module.exports, "layoutSection", () => $c5e57867b1f8b9c7$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => $c5e57867b1f8b9c7$export$4f9d8f623ff17117);

var $gthjq = parcelRequire("gthjq");
const $c5e57867b1f8b9c7$export$b3b6a70a7fa4a5be = (0, $gthjq.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $c5e57867b1f8b9c7$export$cdae19acb0a520fd = (0, $gthjq.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $c5e57867b1f8b9c7$export$4f9d8f623ff17117 = (0, $gthjq.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: (dom)=>{
                const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM (node) {
        const { columnRuleStyle: columnRuleStyle } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("2FIVU", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $1f2243de0d109562$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithTask", () => $1f2243de0d109562$export$58dca2f0678302a4);
$parcel$export(module.exports, "listItemWithDecisionStage0", () => $1f2243de0d109562$export$b2cd54d5ce935ddb);

var $gthjq = parcelRequire("gthjq");
const $1f2243de0d109562$export$76c7e83ecc9cdf05 = (0, $gthjq.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $1f2243de0d109562$export$58dca2f0678302a4 = $1f2243de0d109562$export$76c7e83ecc9cdf05;
const $1f2243de0d109562$export$b2cd54d5ce935ddb = (0, $gthjq.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});

});

parcelRegister("bFtEE", function(module, exports) {

$parcel$export(module.exports, "PanelType", () => $87ea86de426496d8$export$969277cf61e5a7aa);
$parcel$export(module.exports, "extendedPanel", () => $87ea86de426496d8$export$ce20b13564211141);
$parcel$export(module.exports, "panelWithBlockquoteStage0", () => $87ea86de426496d8$export$1f8c55a804c909c7);

var $gthjq = parcelRequire("gthjq");
let $87ea86de426496d8$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
/**
 * @name panel_node
 */ const $87ea86de426496d8$var$getDomAttrs = (nodeAttrs)=>{
    const attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor
    };
    return attrs;
};
const $87ea86de426496d8$var$getParseDOMAttrs = (allowCustomPanel, dom)=>{
    let parseDOMAttrs = {
        panelType: dom.getAttribute('data-panel-type')
    };
    if (allowCustomPanel) parseDOMAttrs = {
        ...parseDOMAttrs,
        panelIcon: dom.getAttribute('data-panel-icon'),
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        panelColor: dom.getAttribute('data-panel-color')
    };
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $87ea86de426496d8$export$969277cf61e5a7aa.CUSTOM ? $87ea86de426496d8$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
const $87ea86de426496d8$export$ce20b13564211141 = (allowCustomPanel)=>{
    const panelNodeSpec = (0, $gthjq.panel)({
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>$87ea86de426496d8$var$getParseDOMAttrs(allowCustomPanel, dom)
            }
        ],
        toDOM (node) {
            const attrs = $87ea86de426496d8$var$getDomAttrs(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });
    return panelNodeSpec;
};
const $87ea86de426496d8$export$1f8c55a804c909c7 = (allowCustomPanel)=>{
    const panelNodeSpec = (0, $gthjq.panelWithNestedBlockquoteStage0)({
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>$87ea86de426496d8$var$getParseDOMAttrs(allowCustomPanel, dom)
            }
        ],
        toDOM (node) {
            const attrs = $87ea86de426496d8$var$getDomAttrs(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });
    return panelNodeSpec;
};

});

parcelRegister("9UDEr", function(module, exports) {

$parcel$export(module.exports, "tablePrefixSelector", () => $737819f27951a815$export$9cfceb893b24742a);
$parcel$export(module.exports, "tableCellSelector", () => $737819f27951a815$export$69cb4c3f80383763);
$parcel$export(module.exports, "tableHeaderSelector", () => $737819f27951a815$export$7b07d37d879c957f);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => $737819f27951a815$export$8dd42a84cd52da07);
$parcel$export(module.exports, "tableCellContentDomSelector", () => $737819f27951a815$export$5e26a5c19f0865d8);
$parcel$export(module.exports, "getCellAttrs", () => $737819f27951a815$export$43977bde391e007);
$parcel$export(module.exports, "getCellDomAttrs", () => $737819f27951a815$export$363c8dda799bfe9c);
$parcel$export(module.exports, "tableBackgroundColorNames", () => $737819f27951a815$export$8cc2833b5b349a1e);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => $737819f27951a815$export$219b7f492ad209f8);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => $737819f27951a815$export$95e9c925fbf01d1c);
$parcel$export(module.exports, "table", () => $737819f27951a815$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithCustomWidth", () => $737819f27951a815$export$90e634fbace1f0c4);
$parcel$export(module.exports, "tableStage0", () => $737819f27951a815$export$3862de5c8c9098cf);
$parcel$export(module.exports, "tableToJSON", () => $737819f27951a815$export$1f92a2f429e06fa8);
$parcel$export(module.exports, "tableRow", () => $737819f27951a815$export$ce666bf02318c957);
$parcel$export(module.exports, "tableCell", () => $737819f27951a815$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "toJSONTableCell", () => $737819f27951a815$export$2ac34c099660f1a8);
$parcel$export(module.exports, "tableHeader", () => $737819f27951a815$export$48884d2a5190dc73);
$parcel$export(module.exports, "toJSONTableHeader", () => $737819f27951a815$export$2af48797a1010bb1);
$parcel$export(module.exports, "tableWithNestedTable", () => $737819f27951a815$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $737819f27951a815$export$7d657479499397);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $737819f27951a815$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $737819f27951a815$export$2a5a518232fa1a97);

var $daes7 = parcelRequire("daes7");

var $51H8P = parcelRequire("51H8P");

var $9IGaJ = parcelRequire("9IGaJ");

var $87j2U = parcelRequire("87j2U");

var $gthjq = parcelRequire("gthjq");
const $737819f27951a815$export$9cfceb893b24742a = 'pm-table';
const $737819f27951a815$export$69cb4c3f80383763 = `${$737819f27951a815$export$9cfceb893b24742a}-cell-content-wrap`;
const $737819f27951a815$export$7b07d37d879c957f = `${$737819f27951a815$export$9cfceb893b24742a}-header-content-wrap`;
const $737819f27951a815$export$8dd42a84cd52da07 = `${$737819f27951a815$export$9cfceb893b24742a}-cell-nodeview-wrapper`;
const $737819f27951a815$export$5e26a5c19f0865d8 = `${$737819f27951a815$export$9cfceb893b24742a}-cell-nodeview-content-dom`;
const $737819f27951a815$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $51H8P.N20).toLocaleLowerCase();
const $737819f27951a815$export$43977bde391e007 = (dom, defaultValues = {})=>{
    const widthAttr = dom.getAttribute('data-colwidth');
    const width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(',').map((str)=>Number(str)) : null;
    const colspan = Number(dom.getAttribute('colspan') || 1);
    let { backgroundColor: backgroundColor } = dom.style;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ const dataCellBackground = dom.getAttribute('data-cell-background');
    const dataCellBackgroundHexCode = dataCellBackground && (0, $51H8P.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $51H8P.isRgb)(backgroundColor)) {
        const result = (0, $51H8P.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    const backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    return {
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode
    };
};
// these are for test only
let $737819f27951a815$var$testGlobalTheme;
const $737819f27951a815$export$fd7e0dd2b74807f7 = (theme)=>{
    $737819f27951a815$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
const $737819f27951a815$var$getGlobalTheme = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($737819f27951a815$var$testGlobalTheme) return {
        colorMode: $737819f27951a815$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $737819f27951a815$var$cssVariablePattern = /^var\(--.*\)$/;
const $737819f27951a815$export$363c8dda799bfe9c = (node)=>{
    const attrs = {};
    const nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        const { background: background } = node.attrs;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        const ignored = nodeType === 'tableHeader' && background === $737819f27951a815$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $737819f27951a815$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            const color = (0, $51H8P.isRgb)(background) && (0, $51H8P.rgbToHex)(background) ? (0, $51H8P.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ const tokenColor = (0, $daes7.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = `background-color: ${tokenColor};`;
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $737819f27951a815$var$cssVariablePattern.test(color)) attrs.style = `background-color: ${color};`;
            else // if we have a custom color, we need to check if we are in dark mode
            if ($737819f27951a815$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = `background-color: ${(0, $87j2U.getDarkModeLCHColor)(color)};`;
            else // if we are in light mode, we can just set the color
            attrs.style = `background-color: ${background};`;
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            attrs.colorname = $737819f27951a815$export$219b7f492ad209f8.get(color);
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $737819f27951a815$export$7b07d37d879c957f;
    else attrs.class = $737819f27951a815$export$69cb4c3f80383763;
    return attrs;
};
const $737819f27951a815$export$219b7f492ad209f8 = new Map();
const $737819f27951a815$export$95e9c925fbf01d1c = (0, $51H8P.hexToRgba)((0, $51H8P.N800), 0.12) || (0, $51H8P.N0);
const $737819f27951a815$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $51H8P.N0),
        'White'
    ],
    [
        (0, $51H8P.B50),
        'Light blue'
    ],
    [
        (0, $51H8P.T50),
        'Light teal'
    ],
    [
        (0, $51H8P.G50),
        'Light green'
    ],
    [
        (0, $51H8P.Y50),
        'Light yellow'
    ],
    [
        (0, $51H8P.R50),
        'Light red'
    ],
    [
        (0, $51H8P.P50),
        'Light purple'
    ],
    [
        (0, $51H8P.N20),
        'Light gray'
    ],
    [
        (0, $51H8P.B75),
        'Blue'
    ],
    [
        (0, $51H8P.T75),
        'Teal'
    ],
    [
        (0, $51H8P.G75),
        'Green'
    ],
    [
        (0, $51H8P.Y75),
        'Yellow'
    ],
    [
        (0, $51H8P.R75),
        'Red'
    ],
    [
        (0, $51H8P.P75),
        'Purple'
    ],
    [
        (0, $51H8P.N60),
        'Gray'
    ],
    [
        (0, $51H8P.B100),
        'Dark blue'
    ],
    [
        (0, $51H8P.T100),
        'Dark teal'
    ],
    [
        (0, $51H8P.G200),
        'Dark green'
    ],
    [
        (0, $51H8P.Y200),
        'Dark yellow'
    ],
    [
        (0, $51H8P.R100),
        'Dark red'
    ],
    [
        (0, $51H8P.P100),
        'Dark purple'
    ]
].forEach(([colorValue, colorName])=>{
    $737819f27951a815$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $737819f27951a815$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
/**
 * @name table_node
 */ /**
 * @name table_row_node
 */ /**
 * @name table_cell_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name table_cell_node
 */ /**
 * @name table_header_node
 */ // table nodes with nested tables support
const $737819f27951a815$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'table',
            getAttrs: (node)=>{
                var _dom$parentElement;
                const dom = node;
                const breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                    layout: // copying from editor
                    dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                    __autoSize: dom.getAttribute('data-autosize') === 'true',
                    localId: dom.getAttribute('data-table-local-id') || (0, $9IGaJ.uuid).generate(),
                    width: Number(dom.getAttribute('data-table-width')) || null,
                    displayMode: dom.getAttribute('data-table-display-mode') || null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-number-column': node.attrs.isNumberColumnEnabled,
            'data-layout': node.attrs.layout,
            'data-autosize': node.attrs.__autoSize,
            'data-table-local-id': node.attrs.localId,
            'data-table-width': node.attrs.width,
            'data-table-display-mode': node.attrs.displayMode
        };
        return [
            'table',
            attrs,
            [
                'tbody',
                0
            ]
        ];
    }
};
// TODO: Fix any, potential issue. ED-5048
const $737819f27951a815$var$createTableSpec = ()=>(0, $gthjq.table)($737819f27951a815$var$tableNodeSpecOptions);
const $737819f27951a815$export$9852986a3ec5f6a0 = $737819f27951a815$var$createTableSpec();
const $737819f27951a815$export$90e634fbace1f0c4 = $737819f27951a815$var$createTableSpec();
const $737819f27951a815$export$3862de5c8c9098cf = $737819f27951a815$var$createTableSpec();
const $737819f27951a815$var$shouldIncludeAttribute = (key, value)=>!key.startsWith('__') && (key !== 'localId' || !!value);
const $737819f27951a815$export$1f92a2f429e06fa8 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>$737819f27951a815$var$shouldIncludeAttribute(key, node.attrs[key])).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
const $737819f27951a815$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM () {
        return [
            'tr',
            0
        ];
    }
};
const $737819f27951a815$export$ce666bf02318c957 = (0, $gthjq.tableRow)($737819f27951a815$var$tableRowNodeSpecOptions);
const $737819f27951a815$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    }
};
const $737819f27951a815$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            getAttrs: (dom)=>$737819f27951a815$export$43977bde391e007(dom)
        }
    ],
    toDOM: (node)=>[
            'td',
            $737819f27951a815$export$363c8dda799bfe9c(node),
            0
        ]
};
const $737819f27951a815$export$e1e720e5f4603e6a = (0, $gthjq.tableCell)($737819f27951a815$var$tableCellNodeSpecOptions);
const $737819f27951a815$export$2ac34c099660f1a8 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($737819f27951a815$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
const $737819f27951a815$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>$737819f27951a815$export$43977bde391e007(dom, {
                    background: $737819f27951a815$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $737819f27951a815$export$363c8dda799bfe9c(node),
            0
        ]
};
const $737819f27951a815$export$48884d2a5190dc73 = (0, $gthjq.tableHeader)($737819f27951a815$var$tableHeaderNodeSpecOptions);
const $737819f27951a815$export$2af48797a1010bb1 = $737819f27951a815$export$2ac34c099660f1a8;
const $737819f27951a815$export$ce086a560a1d05f5 = (0, $gthjq.tableWithNestedTable)($737819f27951a815$var$tableNodeSpecOptions);
const $737819f27951a815$export$7d657479499397 = (0, $gthjq.tableRowWithNestedTable)($737819f27951a815$var$tableRowNodeSpecOptions);
const $737819f27951a815$export$abf39ca178940ff3 = (0, $gthjq.tableCellWithNestedTable)($737819f27951a815$var$tableCellNodeSpecOptions);
const $737819f27951a815$export$2a5a518232fa1a97 = (0, $gthjq.tableHeaderWithNestedTable)($737819f27951a815$var$tableHeaderNodeSpecOptions);

});
parcelRegister("daes7", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $99576b847e5fbb17$export$bad3c41dd33cb4bc);
$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $99576b847e5fbb17$export$9c2f408d391feb93);
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $99576b847e5fbb17$export$8b58ff1b36bb75e0);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $99576b847e5fbb17$export$a270511a0e7fd61a);
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $99576b847e5fbb17$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $99576b847e5fbb17$export$aa000893c5e2b9c2[hexColor.toUpperCase()] : undefined;
}
const $99576b847e5fbb17$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $99576b847e5fbb17$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $99576b847e5fbb17$export$57fa5089caad992[hexColor.toUpperCase()] : undefined;
}
const $99576b847e5fbb17$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $99576b847e5fbb17$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    return hexColor ? $99576b847e5fbb17$export$12a518ff137dd389[hexColor.toUpperCase()] : undefined;
}
const $99576b847e5fbb17$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)'
};
function $99576b847e5fbb17$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    const tokenData = hexColor ? $99576b847e5fbb17$export$2462741d70e6a62f[hexColor.toUpperCase()] : undefined;
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $99576b847e5fbb17$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: ()=>'#DEEBFF',
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: ()=>'#B3D4FF',
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: ()=>'#4C9AFF',
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: ()=>'#E6FCFF',
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: ()=>'#B3F5FF',
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: ()=>'#79E2F2',
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: ()=>'#E3FCEF',
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: ()=>'#ABF5D1',
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: ()=>'#57D9A3',
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: ()=>'#FFFAE6',
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: ()=>'#FFF0B3',
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: ()=>'#FFC400',
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: ()=>'#FFEBE6',
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: ()=>'#FFBDAD',
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: ()=>'#FF8F73',
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: ()=>'#EAE6FF',
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: ()=>'#C0B6F2',
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: ()=>'#998DD9',
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: ()=>'#FFFFFF',
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: ()=>'#F4F5F7',
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: ()=>'#B3BAC5',
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    }
};

});

parcelRegister("51H8P", function(module, exports) {

$parcel$export(module.exports, "R50", () => $3a8e82bcbd673dd1$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $3a8e82bcbd673dd1$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $3a8e82bcbd673dd1$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R300", () => $3a8e82bcbd673dd1$export$4a7404f376229999);
$parcel$export(module.exports, "R400", () => $3a8e82bcbd673dd1$export$2010d0fb4295b346);
$parcel$export(module.exports, "R500", () => $3a8e82bcbd673dd1$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $3a8e82bcbd673dd1$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $3a8e82bcbd673dd1$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y200", () => $3a8e82bcbd673dd1$export$5aae31392d72caaa);
$parcel$export(module.exports, "Y400", () => $3a8e82bcbd673dd1$export$59619663aa6500fb);
$parcel$export(module.exports, "G50", () => $3a8e82bcbd673dd1$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $3a8e82bcbd673dd1$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G200", () => $3a8e82bcbd673dd1$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $3a8e82bcbd673dd1$export$940e1f69e873f202);
$parcel$export(module.exports, "G400", () => $3a8e82bcbd673dd1$export$a49394138f7b8e85);
$parcel$export(module.exports, "G500", () => $3a8e82bcbd673dd1$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $3a8e82bcbd673dd1$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $3a8e82bcbd673dd1$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $3a8e82bcbd673dd1$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B400", () => $3a8e82bcbd673dd1$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $3a8e82bcbd673dd1$export$a6ee3d71bc067634);
$parcel$export(module.exports, "L200", () => $3a8e82bcbd673dd1$export$f72948ef771f6f15);
$parcel$export(module.exports, "N0", () => $3a8e82bcbd673dd1$export$29a4f05edc054374);
$parcel$export(module.exports, "N20", () => $3a8e82bcbd673dd1$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $3a8e82bcbd673dd1$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N40", () => $3a8e82bcbd673dd1$export$1ce2d1575d444ceb);
$parcel$export(module.exports, "N50", () => $3a8e82bcbd673dd1$export$8754fc7e6d8b3000);
$parcel$export(module.exports, "N60", () => $3a8e82bcbd673dd1$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "N80", () => $3a8e82bcbd673dd1$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "N200", () => $3a8e82bcbd673dd1$export$f563ee71e9ee74cd);
$parcel$export(module.exports, "N300", () => $3a8e82bcbd673dd1$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "Neutral300", () => $3a8e82bcbd673dd1$export$1ae1cebe22dcedb4);
$parcel$export(module.exports, "N300A", () => $3a8e82bcbd673dd1$export$13609db0e6812ab8);
$parcel$export(module.exports, "N500", () => $3a8e82bcbd673dd1$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N600", () => $3a8e82bcbd673dd1$export$7090862dc3038a9f);
$parcel$export(module.exports, "N800", () => $3a8e82bcbd673dd1$export$7d61b15e0da132af);
$parcel$export(module.exports, "N1000", () => $3a8e82bcbd673dd1$export$f78789c8b01753cd);
$parcel$export(module.exports, "M200", () => $3a8e82bcbd673dd1$export$a19f0c33186f7767);
$parcel$export(module.exports, "O200", () => $3a8e82bcbd673dd1$export$51716a84e62e022c);
$parcel$export(module.exports, "P50", () => $3a8e82bcbd673dd1$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $3a8e82bcbd673dd1$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $3a8e82bcbd673dd1$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $3a8e82bcbd673dd1$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $3a8e82bcbd673dd1$export$b48405b95304b5a1);
$parcel$export(module.exports, "P500", () => $3a8e82bcbd673dd1$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $3a8e82bcbd673dd1$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $3a8e82bcbd673dd1$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $3a8e82bcbd673dd1$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $3a8e82bcbd673dd1$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $3a8e82bcbd673dd1$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T500", () => $3a8e82bcbd673dd1$export$6036577f95c3877e);
$parcel$export(module.exports, "normalizeHexColor", () => $3a8e82bcbd673dd1$export$b61655071712e690);
$parcel$export(module.exports, "isHex", () => $3a8e82bcbd673dd1$export$8a9b6341a7c96bc);
$parcel$export(module.exports, "isRgb", () => $3a8e82bcbd673dd1$export$e698776ec826343);
$parcel$export(module.exports, "rgbToHex", () => $3a8e82bcbd673dd1$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgb", () => $3a8e82bcbd673dd1$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToRgba", () => $3a8e82bcbd673dd1$export$9665a07d9187b414);

var $3nnJa = parcelRequire("3nnJa");
const $3a8e82bcbd673dd1$export$4b84fd0e2c617bd = '#FFEBE6';
const $3a8e82bcbd673dd1$export$b34b069eff244586 = '#FFBDAD';
const $3a8e82bcbd673dd1$export$be802dd0d8b57f35 = '#FF8F73';
const $3a8e82bcbd673dd1$export$4a7404f376229999 = '#FF5630';
const $3a8e82bcbd673dd1$export$2010d0fb4295b346 = '#DE350B';
const $3a8e82bcbd673dd1$export$2837b5a1a71d5c02 = '#BF2600';
const $3a8e82bcbd673dd1$export$8d9596b529bbb9cf = '#FFFAE6';
const $3a8e82bcbd673dd1$export$41060a744ab0b7ae = '#FFF0B3';
const $3a8e82bcbd673dd1$export$5aae31392d72caaa = '#FFC400';
const $3a8e82bcbd673dd1$export$59619663aa6500fb = '#FF991F';
const $3a8e82bcbd673dd1$export$874739ea9e379ab6 = '#FF8B00';
const $3a8e82bcbd673dd1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $3a8e82bcbd673dd1$export$69a3bf21b9686c2b = '#ABF5D1';
const $3a8e82bcbd673dd1$export$747d86715d4175de = '#57D9A3';
const $3a8e82bcbd673dd1$export$940e1f69e873f202 = '#36B37E';
const $3a8e82bcbd673dd1$export$a49394138f7b8e85 = '#00875A';
const $3a8e82bcbd673dd1$export$6fa04827ac68a4fb = '#006644';
const $3a8e82bcbd673dd1$export$226de0355ed012f8 = '#DEEBFF';
const $3a8e82bcbd673dd1$export$8c13c2ee36917869 = '#B3D4FF';
const $3a8e82bcbd673dd1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $3a8e82bcbd673dd1$export$b3de0ae08da2ce64 = '#0052CC';
const $3a8e82bcbd673dd1$export$a6ee3d71bc067634 = '#0747A6';
const $3a8e82bcbd673dd1$export$f72948ef771f6f15 = '#D3F1A7';
const $3a8e82bcbd673dd1$export$29a4f05edc054374 = '#FFFFFF';
const $3a8e82bcbd673dd1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $3a8e82bcbd673dd1$export$3e51e8f1440314ba = '#EBECF0';
const $3a8e82bcbd673dd1$export$1ce2d1575d444ceb = '#DFE1E6';
const $3a8e82bcbd673dd1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $3a8e82bcbd673dd1$export$c2e91cbeada39b8b = '#B3BAC5';
const $3a8e82bcbd673dd1$export$eaa8c8a70ac22806 = '#97A0AF';
const $3a8e82bcbd673dd1$export$7c87d337fb91a97d = '#8993A4';
const $3a8e82bcbd673dd1$export$f563ee71e9ee74cd = '#6B778C';
const $3a8e82bcbd673dd1$export$e2ef2124cf4024b1 = '#5E6C84';
const $3a8e82bcbd673dd1$export$1ae1cebe22dcedb4 = '#DCDFE4';
const $3a8e82bcbd673dd1$export$13609db0e6812ab8 = '#091E4224';
const $3a8e82bcbd673dd1$export$c39c0fe0f26207ae = '#42526E';
const $3a8e82bcbd673dd1$export$7090862dc3038a9f = '#758195';
const $3a8e82bcbd673dd1$export$7d61b15e0da132af = '#172B4D';
const $3a8e82bcbd673dd1$export$f78789c8b01753cd = '#172B4D';
const $3a8e82bcbd673dd1$export$a19f0c33186f7767 = '#FDD0EC';
const $3a8e82bcbd673dd1$export$51716a84e62e022c = '#FEDEC8';
const $3a8e82bcbd673dd1$export$363e4475840015bb = '#EAE6FF';
const $3a8e82bcbd673dd1$export$4b0a4417ed59760f = '#C0B6F2';
const $3a8e82bcbd673dd1$export$6011520a64d9a187 = '#998DD9';
const $3a8e82bcbd673dd1$export$a7175d4e9206bc80 = '#DFD8FD';
const $3a8e82bcbd673dd1$export$b48405b95304b5a1 = '#6554C0';
const $3a8e82bcbd673dd1$export$c71e4279dd54a18d = '#5243AA';
const $3a8e82bcbd673dd1$export$147899de772240ec = '#403294';
const $3a8e82bcbd673dd1$export$2cf711fe14c66f06 = '#E6FCFF';
const $3a8e82bcbd673dd1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $3a8e82bcbd673dd1$export$776c9c497ef08533 = '#79E2F2';
const $3a8e82bcbd673dd1$export$69cb3ca10c1e330e = '#C6EDFB';
const $3a8e82bcbd673dd1$export$9dc1ef0f3f48059b = '#00B8D9';
const $3a8e82bcbd673dd1$export$6036577f95c3877e = '#008DA6';
function $3a8e82bcbd673dd1$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
    } else if ($3a8e82bcbd673dd1$export$e698776ec826343(color)) return $3a8e82bcbd673dd1$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if ($3nnJa.default && $3nnJa.default[color]) color = $3nnJa.default[color];
        else if ($3nnJa && $3nnJa[color]) color = $3nnJa[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $3a8e82bcbd673dd1$export$5a544e13ad4e1fa5(color) {
    if (!$3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color)) return null;
    let colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    const rgb = Number(`0x${colorBits.join('')}`);
    // eslint-disable-next-line no-bitwise
    return `rgb(${rgb >> 16 & 255},${rgb >> 8 & 255},${rgb & 255})`;
}
function $3a8e82bcbd673dd1$export$9665a07d9187b414(rawColor, alpha) {
    const color = $3a8e82bcbd673dd1$export$b61655071712e690(rawColor);
    if (!color) return null;
    const hex2rgb = (color)=>color.match(/[a-z0-9]{2}/gi).map((hex)=>parseInt(hex, 16));
    return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
}
function $3a8e82bcbd673dd1$export$34d09c4a771c46ef(value) {
    const matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        const [red, green, blue] = matches.map(Number);
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) // eslint-disable-line no-bitwise
        ;
    }
    return null;
}
function $3a8e82bcbd673dd1$export$e698776ec826343(color) {
    return /rgba?\(/.test(color);
}
function $3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}

});
parcelRegister("3nnJa", function(module, exports) {
module.exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");

});


parcelRegister("9IGaJ", function(module, exports) {

$parcel$export(module.exports, "generateUuid", () => $7138efa2a0163ee8$export$1c3aefb711c3a4cc);
$parcel$export(module.exports, "uuid", () => $7138efa2a0163ee8$export$31b40729666a4ae0);
/* eslint-disable no-bitwise */ const $7138efa2a0163ee8$export$1c3aefb711c3a4cc = ()=>'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
/* eslint-enable no-bitwise */ let $7138efa2a0163ee8$var$staticValue = false;
const $7138efa2a0163ee8$export$31b40729666a4ae0 = {
    setStatic (value) {
        $7138efa2a0163ee8$var$staticValue = value;
    },
    generate () {
        return $7138efa2a0163ee8$var$staticValue || $7138efa2a0163ee8$export$1c3aefb711c3a4cc();
    }
};

});

parcelRegister("87j2U", function(module, exports) {

$parcel$export(module.exports, "getDarkModeLCHColor", () => $5e8dc04ff4ab4f7d$export$a5065c3b8aacaf99);
// https://en.wikipedia.org/wiki/HCL_color_space
// https://en.wikipedia.org/wiki/CIE_1931_color_space#CIE_xy_chromaticity_diagram_and_the_CIE_xyY_color_space
// https://en.wikipedia.org/wiki/CIELAB_color_space
const $5e8dc04ff4ab4f7d$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $5e8dc04ff4ab4f7d$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
const $5e8dc04ff4ab4f7d$var$rgbFromHex = (input)=>{
    const fullHex = $5e8dc04ff4ab4f7d$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $5e8dc04ff4ab4f7d$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $5e8dc04ff4ab4f7d$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $5e8dc04ff4ab4f7d$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $5e8dc04ff4ab4f7d$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $5e8dc04ff4ab4f7d$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $5e8dc04ff4ab4f7d$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $5e8dc04ff4ab4f7d$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $5e8dc04ff4ab4f7d$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $5e8dc04ff4ab4f7d$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $5e8dc04ff4ab4f7d$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $5e8dc04ff4ab4f7d$var$rgbToLch = (rgb)=>$5e8dc04ff4ab4f7d$var$labToLch($5e8dc04ff4ab4f7d$var$xyzToLab($5e8dc04ff4ab4f7d$var$rgbToXyz(rgb)));
const $5e8dc04ff4ab4f7d$var$lchToRgb = (lch)=>$5e8dc04ff4ab4f7d$var$xyzToRgb($5e8dc04ff4ab4f7d$var$labToXyz($5e8dc04ff4ab4f7d$var$lchToLab(lch)));
const $5e8dc04ff4ab4f7d$export$313b8a8fcb34c3b8 = (color, newPercent)=>{
    const rgb = $5e8dc04ff4ab4f7d$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $5e8dc04ff4ab4f7d$var$rgbToLch(rgb);
    lch.l = $5e8dc04ff4ab4f7d$var$clamp(newPercent, 0, 100);
    return $5e8dc04ff4ab4f7d$var$rgbToHex($5e8dc04ff4ab4f7d$var$lchToRgb(lch));
};
const $5e8dc04ff4ab4f7d$var$getLightness = (color)=>{
    const rgb = $5e8dc04ff4ab4f7d$var$rgbFromHex(color);
    if (rgb === null) return 0;
    const lch = $5e8dc04ff4ab4f7d$var$rgbToLch(rgb);
    return lch.l;
};
const $5e8dc04ff4ab4f7d$export$a5065c3b8aacaf99 = (currentBackgroundColor)=>{
    const lightness = $5e8dc04ff4ab4f7d$var$getLightness(currentBackgroundColor);
    const newLightness = Math.abs(100 - lightness);
    return $5e8dc04ff4ab4f7d$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};

});


parcelRegister("kBho7", function(module, exports) {

$parcel$export(module.exports, "createSchema", () => $eff4c0443be4d23b$export$5f4ce795563f4211);

var $kCV8T = parcelRequire("kCV8T");


var $7P7H6 = parcelRequire("7P7H6");

var $aeGrH = parcelRequire("aeGrH");
var $88i6h = parcelRequire("88i6h");
var $8jJss = parcelRequire("8jJss");
var $14Vqw = parcelRequire("14Vqw");
var $zceQE = parcelRequire("zceQE");
var $lcXoV = parcelRequire("lcXoV");
var $71k4W = parcelRequire("71k4W");
var $cUwVZ = parcelRequire("cUwVZ");
var $l3Tmi = parcelRequire("l3Tmi");
var $29Vii = parcelRequire("29Vii");
var $fK6mK = parcelRequire("fK6mK");
var $8XeG6 = parcelRequire("8XeG6");
var $aUhe2 = parcelRequire("aUhe2");
var $hhtT8 = parcelRequire("hhtT8");
var $4NwJJ = parcelRequire("4NwJJ");
var $c9aa1 = parcelRequire("c9aa1");
var $dtyqo = parcelRequire("dtyqo");
var $8EAPB = parcelRequire("8EAPB");
var $jxVez = parcelRequire("jxVez");
var $lVmBd = parcelRequire("lVmBd");

var $21PS7 = parcelRequire("21PS7");
var $aXBFx = parcelRequire("aXBFx");
var $5AxYU = parcelRequire("5AxYU");
var $kjhhp = parcelRequire("kjhhp");
var $5JeV5 = parcelRequire("5JeV5");
var $8vlrc = parcelRequire("8vlrc");
var $6bbHe = parcelRequire("6bbHe");
var $5y0tR = parcelRequire("5y0tR");
var $bd7A9 = parcelRequire("bd7A9");
var $b2VmY = parcelRequire("b2VmY");
var $Khvpb = parcelRequire("Khvpb");
var $8gSD8 = parcelRequire("8gSD8");
var $xjCuM = parcelRequire("xjCuM");
var $kshOv = parcelRequire("kshOv");
var $7DoMR = parcelRequire("7DoMR");
var $7kC9H = parcelRequire("7kC9H");
var $bFtEE = parcelRequire("bFtEE");
var $hhN5g = parcelRequire("hhN5g");
var $47jug = parcelRequire("47jug");
var $jnMM2 = parcelRequire("jnMM2");
var $lRTZM = parcelRequire("lRTZM");
var $7lRBh = parcelRequire("7lRBh");
var $cCBEe = parcelRequire("cCBEe");
var $5BOuQ = parcelRequire("5BOuQ");
var $4EbxI = parcelRequire("4EbxI");
var $gZoER = parcelRequire("gZoER");
var $2FIVU = parcelRequire("2FIVU");
var $7agO8 = parcelRequire("7agO8");
var $92lix = parcelRequire("92lix");
var $7Xgp3 = parcelRequire("7Xgp3");
var $bIGZ7 = parcelRequire("bIGZ7");
var $g7Cky = parcelRequire("g7Cky");
var $dx5eC = parcelRequire("dx5eC");
var $dwptW = parcelRequire("dwptW");
var $abme3 = parcelRequire("abme3");
var $dgJoa = parcelRequire("dgJoa");
var $M4hHz = parcelRequire("M4hHz");
var $18bvk = parcelRequire("18bvk");
var $9UDEr = parcelRequire("9UDEr");
var $iThOL = parcelRequire("iThOL");
var $43mJF = parcelRequire("43mJF");
var $3DR6L = parcelRequire("3DR6L");
var $9X587 = parcelRequire("9X587");
var $d1d6m = parcelRequire("d1d6m");
var $6kr5W = parcelRequire("6kr5W");
function $eff4c0443be4d23b$var$addItems(builtInItems, config, customSpecs = {}) {
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ const items = builtInItems.reduce((items, { name: name, spec: spec })=>{
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce((items, name)=>{
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $eff4c0443be4d23b$var$groupDeclaration(name) {
    return {
        name: `__${name}GroupDeclaration`,
        spec: {
            group: name
        }
    };
}
const $eff4c0443be4d23b$var$markGroupDeclarations = [
    $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$9b982809044276a6)),
    $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$4498a6080fed604c)),
    $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$f8e8a5f34f6ea725)),
    $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$b395009ca7f092c7))
];
const $eff4c0443be4d23b$var$markGroupDeclarationsNames = $eff4c0443be4d23b$var$markGroupDeclarations.map((groupMark)=>groupMark.name);
const $eff4c0443be4d23b$var$nodesInOrder = [
    {
        name: 'doc',
        spec: (0, $xjCuM.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $abme3.paragraph)
    },
    {
        name: 'text',
        spec: (0, $3DR6L.text)
    },
    {
        name: 'bulletList',
        spec: (0, $kjhhp.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $dwptW.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $2FIVU.listItemWithTask)
    },
    {
        name: 'heading',
        spec: (0, $lRTZM.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $aXBFx.blockquoteWithNestedCodeblockOrMedia)
    },
    {
        name: 'codeBlock',
        spec: (0, $8vlrc.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $bFtEE.extendedPanel)(true)
    },
    {
        name: 'rule',
        spec: (0, $M4hHz.rule)
    },
    {
        name: 'image',
        spec: (0, $7lRBh.image)
    },
    {
        name: 'mention',
        spec: (0, $g7Cky.mention)
    },
    {
        name: 'caption',
        spec: (0, $5JeV5.caption)
    },
    {
        name: 'media',
        spec: (0, $7agO8.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $92lix.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $bIGZ7.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $7Xgp3.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $dgJoa.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $gZoER.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $4EbxI.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $jnMM2.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $7DoMR.emoji)
    },
    {
        name: 'table',
        spec: (0, $9UDEr.table)
    },
    {
        name: 'tableCell',
        spec: (0, $9UDEr.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $9UDEr.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $9UDEr.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $6bbHe.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $bd7A9.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $5y0tR.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $8gSD8.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $Khvpb.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $43mJF.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $iThOL.taskItem)
    },
    {
        name: 'date',
        spec: (0, $b2VmY.date)
    },
    {
        name: 'status',
        spec: (0, $18bvk.status)
    },
    {
        name: 'expand',
        spec: (0, $7kC9H.expandWithNestedExpand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $dx5eC.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $hhN5g.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $5BOuQ.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $5AxYU.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $47jug.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $47jug.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $cCBEe.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $21PS7.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $kshOv.embedCard)
    },
    {
        name: 'unknownBlock',
        spec: (0, $9X587.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $d1d6m.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $6kr5W.unsupportedInline)
    }
];
const $eff4c0443be4d23b$var$marksInOrder = [
    {
        name: 'link',
        spec: (0, $8XeG6.link)
    },
    {
        name: 'em',
        spec: (0, $l3Tmi.em)
    },
    {
        name: 'strong',
        spec: (0, $hhtT8.strong)
    },
    {
        name: 'textColor',
        spec: (0, $c9aa1.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $8jJss.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $aUhe2.strike)
    },
    {
        name: 'subsup',
        spec: (0, $4NwJJ.subsup)
    },
    {
        name: 'underline',
        spec: (0, $8EAPB.underline)
    },
    {
        name: 'code',
        spec: (0, $lcXoV.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $dtyqo.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $aeGrH.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $88i6h.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $71k4W.confluenceInlineComment)
    },
    ...$eff4c0443be4d23b$var$markGroupDeclarations,
    {
        name: 'breakout',
        spec: (0, $zceQE.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $cUwVZ.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $29Vii.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $fK6mK.indentation)
    },
    {
        name: 'border',
        spec: (0, $14Vqw.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $jxVez.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $lVmBd.unsupportedNodeAttribute)
    }
];
function $eff4c0443be4d23b$export$2d0c32a809131488() {
    const nodes = $eff4c0443be4d23b$var$nodesInOrder.reduce((acc, { name: name, spec: spec })=>{
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    const marks = $eff4c0443be4d23b$var$marksInOrder.reduce((acc, { name: name, spec: spec })=>{
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    return {
        nodes: nodes,
        marks: marks
    };
}
function $eff4c0443be4d23b$export$5f4ce795563f4211(config) {
    const { customNodeSpecs: customNodeSpecs, customMarkSpecs: customMarkSpecs } = config;
    const nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    const marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($eff4c0443be4d23b$var$markGroupDeclarationsNames);
    let nodes = $eff4c0443be4d23b$var$addItems($eff4c0443be4d23b$var$nodesInOrder, nodesConfig, customNodeSpecs);
    const marks = $eff4c0443be4d23b$var$addItems($eff4c0443be4d23b$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = (0, $7P7H6.sanitizeNodes)(nodes, marks);
    return new (0, $kCV8T.Schema)({
        nodes: nodes,
        marks: marks
    });
}
const $eff4c0443be4d23b$export$c77b6d30da5276a1 = true;

});
parcelRegister("kCV8T", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $f043ae92c0a873f0$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $f043ae92c0a873f0$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $f043ae92c0a873f0$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $f043ae92c0a873f0$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "ResolvedPos", () => $f043ae92c0a873f0$export$b2a42f82e59e4b19);
$parcel$export(module.exports, "NodeRange", () => $f043ae92c0a873f0$export$7bc461ceb770fb16);
$parcel$export(module.exports, "Node", () => $f043ae92c0a873f0$export$85c928794f8d04d4);
$parcel$export(module.exports, "MarkType", () => $f043ae92c0a873f0$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $f043ae92c0a873f0$export$19342e026b58ebb7);
$parcel$export(module.exports, "DOMParser", () => $f043ae92c0a873f0$export$1059c6e7d2ce5669);
$parcel$export(module.exports, "DOMSerializer", () => $f043ae92c0a873f0$export$3476b78f8f5a8b72);

var $dHeNB = parcelRequire("dHeNB");
function $f043ae92c0a873f0$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $f043ae92c0a873f0$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $f043ae92c0a873f0$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $f043ae92c0a873f0$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $f043ae92c0a873f0$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    @internal
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $f043ae92c0a873f0$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $f043ae92c0a873f0$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $f043ae92c0a873f0$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $f043ae92c0a873f0$var$retIndex(0, pos);
        if (pos == this.size) return $f043ae92c0a873f0$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $f043ae92c0a873f0$var$retIndex(i + 1, end);
                return $f043ae92c0a873f0$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        if (nodes instanceof $f043ae92c0a873f0$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $f043ae92c0a873f0$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $f043ae92c0a873f0$export$ffb0004e005737fa.empty = new $f043ae92c0a873f0$export$ffb0004e005737fa([], 0);
const $f043ae92c0a873f0$var$found = {
    index: 0,
    offset: 0
};
function $f043ae92c0a873f0$var$retIndex(index, offset) {
    $f043ae92c0a873f0$var$found.index = index;
    $f043ae92c0a873f0$var$found.offset = offset;
    return $f043ae92c0a873f0$var$found;
}
function $f043ae92c0a873f0$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$f043ae92c0a873f0$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$f043ae92c0a873f0$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $f043ae92c0a873f0$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $f043ae92c0a873f0$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        if (marks instanceof $f043ae92c0a873f0$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $f043ae92c0a873f0$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $f043ae92c0a873f0$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $f043ae92c0a873f0$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $f043ae92c0a873f0$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty = new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$export$ffb0004e005737fa.empty, 0, 0);
function $f043ae92c0a873f0$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($f043ae92c0a873f0$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $f043ae92c0a873f0$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $f043ae92c0a873f0$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $f043ae92c0a873f0$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Inconsistent open depths");
    return $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, 0);
}
function $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $f043ae92c0a873f0$var$close(node, $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $f043ae92c0a873f0$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $f043ae92c0a873f0$var$prepareSliceForReplace(slice, $from);
        return $f043ae92c0a873f0$var$close(node, $f043ae92c0a873f0$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $f043ae92c0a873f0$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $f043ae92c0a873f0$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $f043ae92c0a873f0$var$checkJoin(node, $after.node(depth));
    return node;
}
function $f043ae92c0a873f0$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $f043ae92c0a873f0$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $f043ae92c0a873f0$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$f043ae92c0a873f0$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $f043ae92c0a873f0$var$addNode($end.nodeBefore, target);
}
function $f043ae92c0a873f0$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $f043ae92c0a873f0$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $f043ae92c0a873f0$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $f043ae92c0a873f0$var$joinable($end, $to, depth + 1);
    let content = [];
    $f043ae92c0a873f0$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $f043ae92c0a873f0$var$checkJoin(openStart, openEnd);
        $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openStart, $f043ae92c0a873f0$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openStart, $f043ae92c0a873f0$var$replaceTwoWay($from, $start, depth + 1)), content);
        $f043ae92c0a873f0$var$addRange($start, $end, depth, content);
        if (openEnd) $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openEnd, $f043ae92c0a873f0$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $f043ae92c0a873f0$var$addRange($to, null, depth, content);
    return new $f043ae92c0a873f0$export$ffb0004e005737fa(content);
}
function $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $f043ae92c0a873f0$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $f043ae92c0a873f0$var$joinable($from, $to, depth + 1);
        $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(type, $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $f043ae92c0a873f0$var$addRange($to, null, depth, content);
    return new $f043ae92c0a873f0$export$ffb0004e005737fa(content);
}
function $f043ae92c0a873f0$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($f043ae92c0a873f0$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $f043ae92c0a873f0$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $f043ae92c0a873f0$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $f043ae92c0a873f0$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $f043ae92c0a873f0$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $f043ae92c0a873f0$var$resolveCache.set(doc, cache = new $f043ae92c0a873f0$var$ResolveCache);
        let result = cache.elts[cache.i] = $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $f043ae92c0a873f0$var$resolveCacheSize;
        return result;
    }
}
class $f043ae92c0a873f0$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $f043ae92c0a873f0$var$resolveCacheSize = 12, $f043ae92c0a873f0$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $f043ae92c0a873f0$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $f043ae92c0a873f0$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $f043ae92c0a873f0$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $f043ae92c0a873f0$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $f043ae92c0a873f0$var$emptyAttrs) && $f043ae92c0a873f0$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $f043ae92c0a873f0$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $f043ae92c0a873f0$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $f043ae92c0a873f0$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $f043ae92c0a873f0$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $f043ae92c0a873f0$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$f043ae92c0a873f0$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $f043ae92c0a873f0$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$f043ae92c0a873f0$export$85c928794f8d04d4.prototype.text = undefined;
class $f043ae92c0a873f0$var$TextNode extends $f043ae92c0a873f0$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $f043ae92c0a873f0$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $f043ae92c0a873f0$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $f043ae92c0a873f0$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $f043ae92c0a873f0$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $f043ae92c0a873f0$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $f043ae92c0a873f0$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $f043ae92c0a873f0$export$364ed450558d7ec4.empty;
        let expr = $f043ae92c0a873f0$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $f043ae92c0a873f0$var$dfa($f043ae92c0a873f0$var$nfa(expr));
        $f043ae92c0a873f0$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $f043ae92c0a873f0$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $f043ae92c0a873f0$export$364ed450558d7ec4.empty = new $f043ae92c0a873f0$export$364ed450558d7ec4(true);
class $f043ae92c0a873f0$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $f043ae92c0a873f0$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($f043ae92c0a873f0$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $f043ae92c0a873f0$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($f043ae92c0a873f0$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $f043ae92c0a873f0$var$parseExprSubscript(stream) {
    let expr = $f043ae92c0a873f0$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $f043ae92c0a873f0$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $f043ae92c0a873f0$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $f043ae92c0a873f0$var$parseExprRange(stream, expr) {
    let min = $f043ae92c0a873f0$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $f043ae92c0a873f0$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $f043ae92c0a873f0$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.groups.indexOf(name) > -1) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $f043ae92c0a873f0$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $f043ae92c0a873f0$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $f043ae92c0a873f0$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
/**
Construct an NFA from an expression as returned by the parser. The
NFA is represented as an array of states, which are themselves
arrays of edges, which are `{term, to}` objects. The first state is
the entry state and the last node is the success state.

Note that unlike typical NFAs, the edge ordering in this one is
significant, in that it is used to contruct filler content when
necessary.
*/ function $f043ae92c0a873f0$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $f043ae92c0a873f0$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $f043ae92c0a873f0$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($f043ae92c0a873f0$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $f043ae92c0a873f0$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($f043ae92c0a873f0$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $f043ae92c0a873f0$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $f043ae92c0a873f0$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($f043ae92c0a873f0$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $f043ae92c0a873f0$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $f043ae92c0a873f0$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $f043ae92c0a873f0$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $f043ae92c0a873f0$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $f043ae92c0a873f0$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $f043ae92c0a873f0$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $f043ae92c0a873f0$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $f043ae92c0a873f0$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $f043ae92c0a873f0$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $f043ae92c0a873f0$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $f043ae92c0a873f0$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $f043ae92c0a873f0$export$ffb0004e005737fa.from(content), $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, attrs, content.append(after), $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $f043ae92c0a873f0$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $f043ae92c0a873f0$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $f043ae92c0a873f0$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $f043ae92c0a873f0$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $f043ae92c0a873f0$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $f043ae92c0a873f0$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $f043ae92c0a873f0$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $f043ae92c0a873f0$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $f043ae92c0a873f0$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $f043ae92c0a873f0$export$c9d15bcfc6d42044(this, $f043ae92c0a873f0$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $f043ae92c0a873f0$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $f043ae92c0a873f0$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $f043ae92c0a873f0$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $dHeNB.default).from(spec.nodes), instanceSpec.marks = (0, $dHeNB.default).from(spec.marks || {}), this.nodes = $f043ae92c0a873f0$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $f043ae92c0a873f0$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $f043ae92c0a873f0$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $f043ae92c0a873f0$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $f043ae92c0a873f0$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $f043ae92c0a873f0$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $f043ae92c0a873f0$var$TextNode(type, type.defaultAttrs, text, $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $f043ae92c0a873f0$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $f043ae92c0a873f0$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $f043ae92c0a873f0$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $f043ae92c0a873f0$var$isTagRule(rule) {
    return rule.tag != null;
}
function $f043ae92c0a873f0$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $f043ae92c0a873f0$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($f043ae92c0a873f0$var$isTagRule(rule)) this.tags.push(rule);
            else if ($f043ae92c0a873f0$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $f043ae92c0a873f0$var$ParseContext(this, options, false);
        context.addAll(dom, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $f043ae92c0a873f0$var$ParseContext(this, options, true);
        context.addAll(dom, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($f043ae92c0a873f0$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $f043ae92c0a873f0$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $f043ae92c0a873f0$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $f043ae92c0a873f0$export$1059c6e7d2ce5669(schema, $f043ae92c0a873f0$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $f043ae92c0a873f0$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $f043ae92c0a873f0$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $f043ae92c0a873f0$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $f043ae92c0a873f0$var$OPT_PRESERVE_WS = 1, $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL = 2, $f043ae92c0a873f0$var$OPT_OPEN_LEFT = 4;
function $f043ae92c0a873f0$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS | $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL : base & ~$f043ae92c0a873f0$var$OPT_OPEN_LEFT;
}
class $f043ae92c0a873f0$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $f043ae92c0a873f0$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$f043ae92c0a873f0$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $f043ae92c0a873f0$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        let topNode = options.topNode, topContext;
        let topOptions = $f043ae92c0a873f0$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $f043ae92c0a873f0$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $f043ae92c0a873f0$var$NodeContext(topNode.type, topNode.attrs, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $f043ae92c0a873f0$var$NodeContext(null, null, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $f043ae92c0a873f0$var$NodeContext(parser.schema.topNodeType, null, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top;
        if (top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!(top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS)) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (!(top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL)) value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($f043ae92c0a873f0$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $f043ae92c0a873f0$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        if (rule ? rule.ignore : $f043ae92c0a873f0$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, top = this.top, oldNeedsBlock = this.needsBlock;
            if ($f043ae92c0a873f0$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                return;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $f043ae92c0a873f0$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $f043ae92c0a873f0$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $f043ae92c0a873f0$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $f043ae92c0a873f0$var$OPT_OPEN_LEFT;
        let applyMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $f043ae92c0a873f0$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $f043ae92c0a873f0$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(this.isOpen || this.options.topOpen);
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--)if (this.nodes[i] == to) {
            this.open = i;
            return true;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && next.groups.indexOf(part) == -1) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $f043ae92c0a873f0$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $f043ae92c0a873f0$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $f043ae92c0a873f0$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $f043ae92c0a873f0$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $f043ae92c0a873f0$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $f043ae92c0a873f0$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $f043ae92c0a873f0$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $f043ae92c0a873f0$var$renderSpec($f043ae92c0a873f0$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $f043ae92c0a873f0$var$renderSpec($f043ae92c0a873f0$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $f043ae92c0a873f0$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $f043ae92c0a873f0$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $f043ae92c0a873f0$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $f043ae92c0a873f0$var$gatherToDOM(schema.marks);
    }
}
function $f043ae92c0a873f0$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $f043ae92c0a873f0$var$doc(options) {
    return options.document || window.document;
}
const $f043ae92c0a873f0$var$suspiciousAttributeCache = new WeakMap();
function $f043ae92c0a873f0$var$suspiciousAttributes(attrs) {
    let value = $f043ae92c0a873f0$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $f043ae92c0a873f0$var$suspiciousAttributeCache.set(attrs, value = $f043ae92c0a873f0$var$suspiciousAttributesInner(attrs));
    return value;
}
function $f043ae92c0a873f0$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $f043ae92c0a873f0$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $f043ae92c0a873f0$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $f043ae92c0a873f0$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});
parcelRegister("dHeNB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f8ac547b0b2e1f8$export$2e2bcd8739ae039);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $9f8ac547b0b2e1f8$var$OrderedMap(content) {
    this.content = content;
}
$9f8ac547b0b2e1f8$var$OrderedMap.prototype = {
    constructor: $9f8ac547b0b2e1f8$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $9f8ac547b0b2e1f8$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $9f8ac547b0b2e1f8$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $9f8ac547b0b2e1f8$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$9f8ac547b0b2e1f8$var$OrderedMap.from = function(value) {
    if (value instanceof $9f8ac547b0b2e1f8$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
};
var $9f8ac547b0b2e1f8$export$2e2bcd8739ae039 = $9f8ac547b0b2e1f8$var$OrderedMap;

});


// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
const $72fd39d34ca5bb7c$export$4498a6080fed604c = 'fontStyle';
const $72fd39d34ca5bb7c$export$f8e8a5f34f6ea725 = 'searchQuery';
const $72fd39d34ca5bb7c$export$b395009ca7f092c7 = 'link';
const $72fd39d34ca5bb7c$export$9b982809044276a6 = 'color';
const $72fd39d34ca5bb7c$export$470d0905851e47a1 = 'alignment';
const $72fd39d34ca5bb7c$export$bacb7f4b06a06b22 = 'indentation';

parcelRegister("7P7H6", function(module, exports) {

$parcel$export(module.exports, "sanitizeNodes", () => $5b2343b4eb27461c$export$daf54fed04c8fb77);
function $5b2343b4eb27461c$export$daf54fed04c8fb77(nodes, supportedMarks) {
    const nodeNames = Object.keys(nodes);
    nodeNames.forEach((nodeKey)=>{
        const nodeSpec = {
            ...nodes[nodeKey]
        };
        if (nodeSpec.marks && nodeSpec.marks !== '_') nodeSpec.marks = nodeSpec.marks.split(' ').filter((mark)=>!!supportedMarks[mark]).join(' ');
        if (nodeSpec.content) nodeSpec.content = $5b2343b4eb27461c$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $5b2343b4eb27461c$var$sanitizeNodeSpecContent(nodes, rawContent) {
    const content = rawContent.replace(/\W/g, ' ');
    const contentKeys = content.split(' ');
    const unsupportedContentKeys = contentKeys.filter((contentKey)=>!$5b2343b4eb27461c$var$isContentSupported(nodes, contentKey));
    return unsupportedContentKeys.reduce((newContent, nodeName)=>$5b2343b4eb27461c$var$sanitizedContent(newContent, nodeName), rawContent);
}
function $5b2343b4eb27461c$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match(/\w/)) return '';
    const pattern = `(${invalidContent}((\\s)*\\|)+)|((\\|(\\s)*)+${invalidContent}(\\+|\\*)?)|(${invalidContent}$)|(${invalidContent}(\\+|\\*))`;
    return content.replace(new RegExp(pattern, 'g'), '').replace('  ', ' ').trim();
}
function $5b2343b4eb27461c$var$isContentSupported(nodes, contentKey) {
    const nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(const supportedKey in nodes){
        const nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}

});

parcelRegister("aeGrH", function(module, exports) {

$parcel$export(module.exports, "alignmentPositionMap", () => $773c2309706a915e$export$be9cf49015769bbd);
$parcel$export(module.exports, "alignment", () => $773c2309706a915e$export$8e53000a4ec837);

var $2fTAU = parcelRequire("2fTAU");
const $773c2309706a915e$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
const $773c2309706a915e$export$8e53000a4ec837 = (0, $2fTAU.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: (dom)=>{
                const align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: `fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-${mark.attrs.align}`,
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});

});
parcelRegister("2fTAU", function(module, exports) {

$parcel$export(module.exports, "alignment", () => $1a481b607696d815$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $1a481b607696d815$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $1a481b607696d815$export$8c5a050822fd698c);
$parcel$export(module.exports, "border", () => $1a481b607696d815$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $1a481b607696d815$export$89015c65f1c75e3f);
$parcel$export(module.exports, "code", () => $1a481b607696d815$export$6565f9f03506010b);
$parcel$export(module.exports, "confluenceInlineComment", () => $1a481b607696d815$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $1a481b607696d815$export$3024f02c495408d6);
$parcel$export(module.exports, "em", () => $1a481b607696d815$export$c63c6f932822f543);
$parcel$export(module.exports, "fragment", () => $1a481b607696d815$export$f00aeb236b6f05af);
$parcel$export(module.exports, "indentation", () => $1a481b607696d815$export$480c699bd4ec0d86);
$parcel$export(module.exports, "link", () => $1a481b607696d815$export$9c30223ca0a664fb);
$parcel$export(module.exports, "strike", () => $1a481b607696d815$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $1a481b607696d815$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $1a481b607696d815$export$b3401ee80eb31041);
$parcel$export(module.exports, "textColor", () => $1a481b607696d815$export$32f78bffcd82ff28);
$parcel$export(module.exports, "typeAheadQuery", () => $1a481b607696d815$export$20af3dabbb5538df);
$parcel$export(module.exports, "underline", () => $1a481b607696d815$export$425327af25286e5e);
$parcel$export(module.exports, "unsupportedMark", () => $1a481b607696d815$export$30d78d5eb6719bb8);
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $1a481b607696d815$export$a316dc07ff5182a2);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $f0ccE = parcelRequire("f0ccE");
const $1a481b607696d815$export$8e53000a4ec837 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
const $1a481b607696d815$export$8512c9afa7b24c3b = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
const $1a481b607696d815$export$8c5a050822fd698c = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    excludes: 'color',
    group: 'color'
});
const $1a481b607696d815$export$1edee58a52776cd9 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
const $1a481b607696d815$export$89015c65f1c75e3f = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
const $1a481b607696d815$export$6565f9f03506010b = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
const $1a481b607696d815$export$f3b72f8fc4684ecd = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
const $1a481b607696d815$export$3024f02c495408d6 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
const $1a481b607696d815$export$c63c6f932822f543 = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$f00aeb236b6f05af = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
const $1a481b607696d815$export$480c699bd4ec0d86 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
const $1a481b607696d815$export$9c30223ca0a664fb = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
const $1a481b607696d815$export$4899a95d70ec5056 = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$59ae2c325a998f89 = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$b3401ee80eb31041 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$32f78bffcd82ff28 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
const $1a481b607696d815$export$20af3dabbb5538df = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
const $1a481b607696d815$export$425327af25286e5e = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$30d78d5eb6719bb8 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
const $1a481b607696d815$export$a316dc07ff5182a2 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});


parcelRegister("88i6h", function(module, exports) {

$parcel$export(module.exports, "AnnotationTypes", () => $5ebd1c6c912098fc$export$94aa2fc69ad33d19);
$parcel$export(module.exports, "AnnotationMarkStates", () => $5ebd1c6c912098fc$export$4bab14797673da9f);
$parcel$export(module.exports, "buildDataAttributes", () => $5ebd1c6c912098fc$export$93a98caa8bc6cb07);
$parcel$export(module.exports, "annotation", () => $5ebd1c6c912098fc$export$8512c9afa7b24c3b);

var $2fTAU = parcelRequire("2fTAU");
let $5ebd1c6c912098fc$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
let $5ebd1c6c912098fc$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $5ebd1c6c912098fc$export$93a98caa8bc6cb07({ id: id, annotationType: annotationType, state: state }) {
    const data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return {
        ...data,
        'data-mark-annotation-state': state
    };
    return data;
}
const $5ebd1c6c912098fc$export$8512c9afa7b24c3b = (0, $2fTAU.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        /*
      Data attributes on the DOM node are a temporary means of
      incrementally switching over to the Annotation mark. Once renderer
      provides native support for inline comments the data attributes on the
      DOM nodes will be removed.
    */ return [
            'span',
            {
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation',
                ...$5ebd1c6c912098fc$export$93a98caa8bc6cb07({
                    id: node.attrs.id,
                    annotationType: node.attrs.annotationType
                })
            },
            0
        ];
    }
});

});

parcelRegister("8jJss", function(module, exports) {

$parcel$export(module.exports, "backgroundColor", () => $60e35c16db44f137$export$8c5a050822fd698c);

var $2fTAU = parcelRequire("2fTAU");

var $daes7 = parcelRequire("daes7");

var $51H8P = parcelRequire("51H8P");

var $c9aa1 = parcelRequire("c9aa1");

var $87j2U = parcelRequire("87j2U");
/**
 * @name backgroundColor_mark
 */ const $60e35c16db44f137$var$colorArrayPalette = [
    [
        (0, $51H8P.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $51H8P.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $51H8P.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $51H8P.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $51H8P.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $51H8P.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
const $60e35c16db44f137$export$14ec3f21a268e497 = new Map();
$60e35c16db44f137$var$colorArrayPalette.forEach(([color, label])=>$60e35c16db44f137$export$14ec3f21a268e497.set(color.toLowerCase(), label));
const $60e35c16db44f137$export$8c5a050822fd698c = (0, $2fTAU.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $51H8P.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $60e35c16db44f137$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $60e35c16db44f137$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $daes7.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $c9aa1.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $87j2U.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-background-custom-color']: mark.attrs.color
            }
        ];
    }
});

});
parcelRegister("c9aa1", function(module, exports) {

$parcel$export(module.exports, "colorPalette", () => $8d7e34fd69d04bb8$export$569885e57444f84a);
$parcel$export(module.exports, "getGlobalTheme", () => $8d7e34fd69d04bb8$export$813ecdf77207a053);
$parcel$export(module.exports, "textColor", () => $8d7e34fd69d04bb8$export$32f78bffcd82ff28);

var $2fTAU = parcelRequire("2fTAU");

var $daes7 = parcelRequire("daes7");

var $51H8P = parcelRequire("51H8P");

var $87j2U = parcelRequire("87j2U");
/**
 * @name textColor_mark
 */ // used for extended palette in text color picker
const $8d7e34fd69d04bb8$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $51H8P.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $51H8P.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $51H8P.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $51H8P.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $51H8P.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $51H8P.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $51H8P.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $51H8P.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $51H8P.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $51H8P.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $51H8P.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $51H8P.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $51H8P.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $51H8P.N0),
        'White'
    ],
    [
        (0, $51H8P.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $51H8P.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $51H8P.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $51H8P.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $51H8P.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $51H8P.P50),
        'Light purple'
    ] // Lavender secret
];
const $8d7e34fd69d04bb8$export$569885e57444f84a = new Map();
const $8d7e34fd69d04bb8$export$81e5ed9e84fe2e28 = $8d7e34fd69d04bb8$export$569885e57444f84a;
$8d7e34fd69d04bb8$var$colorArrayPalette.forEach(([color, label])=>$8d7e34fd69d04bb8$export$569885e57444f84a.set(color.toLowerCase(), label));
// these are for test only
let $8d7e34fd69d04bb8$var$testGlobalTheme;
const $8d7e34fd69d04bb8$export$fd7e0dd2b74807f7 = (theme)=>{
    $8d7e34fd69d04bb8$var$testGlobalTheme = theme;
};
const $8d7e34fd69d04bb8$export$813ecdf77207a053 = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($8d7e34fd69d04bb8$var$testGlobalTheme) return {
        colorMode: $8d7e34fd69d04bb8$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $8d7e34fd69d04bb8$export$32f78bffcd82ff28 = (0, $2fTAU.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $51H8P.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $8d7e34fd69d04bb8$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $8d7e34fd69d04bb8$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $daes7.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($8d7e34fd69d04bb8$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $87j2U.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-text-custom-color']: mark.attrs.color
            }
        ];
    }
});

});


parcelRegister("14Vqw", function(module, exports) {

$parcel$export(module.exports, "borderColorPalette", () => $0c92b5eb9dbe9377$export$e4e044c989c86ca7);
$parcel$export(module.exports, "border", () => $0c92b5eb9dbe9377$export$1edee58a52776cd9);

var $2fTAU = parcelRequire("2fTAU");

var $daes7 = parcelRequire("daes7");

var $51H8P = parcelRequire("51H8P");
/**
 * @name border_mark
 * @description This mark adds decoration to an element, and any element decorated with it will also have a border style.
 */ const $0c92b5eb9dbe9377$var$borderColorArrayPalette = [
    [
        (0, $51H8P.N300A),
        'Subtle gray'
    ],
    [
        (0, $51H8P.N600),
        'Gray'
    ],
    [
        (0, $51H8P.N1000),
        'Bold gray'
    ]
];
const $0c92b5eb9dbe9377$export$e4e044c989c86ca7 = new Map();
$0c92b5eb9dbe9377$var$borderColorArrayPalette.forEach(([color, label])=>$0c92b5eb9dbe9377$export$e4e044c989c86ca7.set(color.toLowerCase(), label));
const $0c92b5eb9dbe9377$export$1edee58a52776cd9 = (0, $2fTAU.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: (domNode)=>{
                var _dom$getAttribute, _dom$getAttribute2;
                const dom = domNode;
                const color = ((_dom$getAttribute = dom.getAttribute('data-color')) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : '').toLowerCase();
                const size = +((_dom$getAttribute2 = dom.getAttribute('data-size')) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $0c92b5eb9dbe9377$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM (mark, isInline) {
        const wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        const paletteColorValue = (0, $daes7.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: `--custom-palette-color: ${paletteColorValue}`
            }
        ];
    }
});

});

parcelRegister("zceQE", function(module, exports) {

$parcel$export(module.exports, "breakout", () => $069cc34ec2ef025e$export$89015c65f1c75e3f);

var $2fTAU = parcelRequire("2fTAU");
const $069cc34ec2ef025e$var$allowedTypes = [
    'wide',
    'full-width'
];
const $069cc34ec2ef025e$export$89015c65f1c75e3f = (0, $2fTAU.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs (dom) {
                const mode = dom.getAttribute('data-mode');
                const width = dom.getAttribute('data-width');
                return {
                    mode: $069cc34ec2ef025e$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM (mark) {
        var _mark$attrs;
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode,
                'data-width': (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
            },
            0
        ];
    }
});

});

parcelRegister("lcXoV", function(module, exports) {

$parcel$export(module.exports, "code", () => $f708cbc93f02b120$export$6565f9f03506010b);

var $2fTAU = parcelRequire("2fTAU");
const $f708cbc93f02b120$export$6565f9f03506010b = (0, $2fTAU.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM () {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});

});

parcelRegister("71k4W", function(module, exports) {

$parcel$export(module.exports, "confluenceInlineComment", () => $51c833981031ae17$export$f3b72f8fc4684ecd);

var $2fTAU = parcelRequire("2fTAU");
const $51c833981031ae17$export$f3b72f8fc4684ecd = (0, $2fTAU.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});

});

parcelRegister("cUwVZ", function(module, exports) {

$parcel$export(module.exports, "dataConsumer", () => $966443126bdc8969$export$3024f02c495408d6);
$parcel$export(module.exports, "toJSON", () => $966443126bdc8969$export$54fd2c36b5cc6731);

var $2fTAU = parcelRequire("2fTAU");

var $6VXbJ = parcelRequire("6VXbJ");
/**
 * This annotation is purely for reference, & does _nothing_ given annotating
 * `minLength` on an array of strings is not supported with our schema+spec
 * generator.
 *
 * We're keeping it to signal that data consumer `sources` shouldn't be empty
 * strings
 *
 * // @minLength 1
 */ /**
 * @name dataConsumer_mark
 * @description This mark is used for metadata surrounding a node consuming data
 * from a given source node
 */ const $966443126bdc8969$var$parseDataConsumer = (maybeValue)=>{
    const sources = (0, $6VXbJ.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch  {
        return false;
    }
};
const $966443126bdc8969$export$3024f02c495408d6 = (0, $2fTAU.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: (maybeValue)=>$966443126bdc8969$var$parseDataConsumer(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
const $966443126bdc8969$export$54fd2c36b5cc6731 = (mark)=>{
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter((key)=>key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null).reduce((acc, key)=>{
            return {
                ...acc,
                [key]: mark.attrs[key]
            };
        }, {})
    };
};

});
parcelRegister("6VXbJ", function(module, exports) {

$parcel$export(module.exports, "isDOMElement", () => $50c5fa8010b73128$export$c296e2d4365c37a5);
const $50c5fa8010b73128$export$c296e2d4365c37a5 = (maybeNode)=>maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;

});


parcelRegister("l3Tmi", function(module, exports) {

$parcel$export(module.exports, "em", () => $f554d1dac524ac83$export$c63c6f932822f543);

var $2fTAU = parcelRequire("2fTAU");
/**
 * @name em_mark
 */ const $f554d1dac524ac83$var$emDOM = [
    'em'
];
const $f554d1dac524ac83$export$c63c6f932822f543 = (0, $2fTAU.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM () {
        return $f554d1dac524ac83$var$emDOM;
    }
});

});

parcelRegister("29Vii", function(module, exports) {

$parcel$export(module.exports, "fragment", () => $1928dd6d160b68a9$export$f00aeb236b6f05af);
$parcel$export(module.exports, "toJSON", () => $1928dd6d160b68a9$export$54fd2c36b5cc6731);

var $2fTAU = parcelRequire("2fTAU");

var $6VXbJ = parcelRequire("6VXbJ");
/**
 * @name fragment_mark
 * @description Indicates that the elements decorated with this mark belong to a "fragment" entity, which represents a collection of ADF nodes.
 * This entity can be referred to later by its `localId` attribute.
 */ const $1928dd6d160b68a9$var$parseFragment = (maybeValue)=>{
    var _maybeValue$getAttrib;
    if (!(0, $6VXbJ.isDOMElement)(maybeValue)) return false;
    const name = (_maybeValue$getAttrib = maybeValue.getAttribute('data-name')) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
    const localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
const $1928dd6d160b68a9$export$f00aeb236b6f05af = (0, $2fTAU.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: (maybeValue)=>$1928dd6d160b68a9$var$parseFragment(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
const $1928dd6d160b68a9$export$54fd2c36b5cc6731 = (mark)=>{
    return {
        type: mark.type.name,
        attrs: {
            localId: mark.attrs.localId,
            ...mark.attrs.name ? {
                name: mark.attrs.name
            } : {}
        }
    };
};

});

parcelRegister("fK6mK", function(module, exports) {

$parcel$export(module.exports, "indentation", () => $b760170dcfe13435$export$480c699bd4ec0d86);

var $2fTAU = parcelRequire("2fTAU");
const $b760170dcfe13435$export$480c699bd4ec0d86 = (0, $2fTAU.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs (dom) {
                const level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});

});

parcelRegister("8XeG6", function(module, exports) {

$parcel$export(module.exports, "link", () => $684f383282dda449$export$9c30223ca0a664fb);
$parcel$export(module.exports, "toJSON", () => $684f383282dda449$export$54fd2c36b5cc6731);

var $2fTAU = parcelRequire("2fTAU");

var $iZOJ9 = parcelRequire("iZOJ9");
const $684f383282dda449$export$b5f67017585d1431 = (attribute)=>(domNode)=>{
        const dom = domNode;
        const href = dom.getAttribute(attribute) || '';
        const attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $iZOJ9.isSafeUrl)(href)) return false;
        if ((0, $iZOJ9.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $iZOJ9.normalizeUrl)(href);
        return attrs;
    };
const $684f383282dda449$export$9c30223ca0a664fb = (0, $2fTAU.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: $684f383282dda449$export$b5f67017585d1431('data-block-link'),
            contentElement: (node)=>{
                const clone = node.cloneNode(true);
                clone.removeAttribute('data-block-link');
                clone.setAttribute('data-skip-paste', 'true');
                const wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: $684f383282dda449$export$b5f67017585d1431('href')
        }
    ],
    toDOM (node, isInline) {
        const attrs = Object.keys(node.attrs).reduce((attrs, key)=>{
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $iZOJ9.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            {
                ...attrs,
                ['data-block-link']: 'true',
                class: 'blockLink'
            },
            0
        ];
    }
});
const $684f383282dda449$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
const $684f383282dda449$export$54fd2c36b5cc6731 = (mark)=>({
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce((attrs, key)=>{
            if ($684f383282dda449$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    });

});
parcelRegister("iZOJ9", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $dd4545da25e52dce$export$c9f92f5469372e0f);
$parcel$export(module.exports, "linkify", () => $dd4545da25e52dce$export$8ccbde94d5c7f8e7);
$parcel$export(module.exports, "linkifyMatch", () => $dd4545da25e52dce$export$6f7d7761b97f967);
$parcel$export(module.exports, "getLinkMatch", () => $dd4545da25e52dce$export$ce9ae45aed3e4ec);
$parcel$export(module.exports, "normalizeUrl", () => $dd4545da25e52dce$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "isRootRelative", () => $dd4545da25e52dce$export$23579274a7a24f7b);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $i6xkD = parcelRequire("i6xkD");
const $dd4545da25e52dce$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
const $dd4545da25e52dce$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $dd4545da25e52dce$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
const $dd4545da25e52dce$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($i6xkD)))();
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
const $dd4545da25e52dce$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('tel:', $dd4545da25e52dce$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('file:', $dd4545da25e52dce$var$urlWithoutSpacesValidator);
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
const $dd4545da25e52dce$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $dd4545da25e52dce$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$dd4545da25e52dce$var$tlds.push($dd4545da25e52dce$var$tlds2Char);
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.tlds($dd4545da25e52dce$var$tlds, false);
const $dd4545da25e52dce$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $dd4545da25e52dce$export$6f7d7761b97f967 = (text)=>{
    if (!$dd4545da25e52dce$export$746d02eae03c72e1.test(text)) return [];
    const matches = [];
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($dd4545da25e52dce$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($dd4545da25e52dce$export$746d02eae03c72e1);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $dd4545da25e52dce$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    let match = $dd4545da25e52dce$export$6f7d7761b97f967(str);
    if (!match.length) match = $dd4545da25e52dce$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $dd4545da25e52dce$export$6535eb414fa2c8b6(url) {
    const match = $dd4545da25e52dce$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $dd4545da25e52dce$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}

});
parcelRegister("i6xkD", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $d2e2a485107d561a$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $d2e2a485107d561a$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $d2e2a485107d561a$var$isString(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object String]';
}
function $d2e2a485107d561a$var$isObject(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object Object]';
}
function $d2e2a485107d561a$var$isRegExp(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object RegExp]';
}
function $d2e2a485107d561a$var$isFunction(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object Function]';
}
function $d2e2a485107d561a$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $d2e2a485107d561a$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $d2e2a485107d561a$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $d2e2a485107d561a$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $d2e2a485107d561a$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $d2e2a485107d561a$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $d2e2a485107d561a$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $d2e2a485107d561a$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $d2e2a485107d561a$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $d2e2a485107d561a$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $d2e2a485107d561a$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("9mKTr"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($d2e2a485107d561a$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($d2e2a485107d561a$var$isObject(val)) {
            if ($d2e2a485107d561a$var$isRegExp(val.validate)) compiled.validate = $d2e2a485107d561a$var$createValidator(val.validate);
            else if ($d2e2a485107d561a$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($d2e2a485107d561a$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $d2e2a485107d561a$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($d2e2a485107d561a$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $d2e2a485107d561a$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($d2e2a485107d561a$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|' + '(' + self.re.host_fuzzy_test.source + ')|' + '@', 'i');
    //
    // Cleanup
    //
    $d2e2a485107d561a$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $d2e2a485107d561a$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $d2e2a485107d561a$var$createMatch(self, shift) {
    var match = new $d2e2a485107d561a$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $d2e2a485107d561a$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $d2e2a485107d561a$var$LinkifyIt)) return new $d2e2a485107d561a$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($d2e2a485107d561a$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $d2e2a485107d561a$var$assign({}, $d2e2a485107d561a$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $d2e2a485107d561a$var$assign({}, $d2e2a485107d561a$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $d2e2a485107d561a$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $d2e2a485107d561a$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $d2e2a485107d561a$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $d2e2a485107d561a$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($d2e2a485107d561a$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($d2e2a485107d561a$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $d2e2a485107d561a$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $d2e2a485107d561a$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $d2e2a485107d561a$var$LinkifyIt;

});
parcelRegister("9mKTr", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("b9ep3")).source;
    re.src_Cc = (parcelRequire("23ErL")).source;
    re.src_Z = (parcelRequire("oRY4m")).source;
    re.src_P = (parcelRequire("9bBmm")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,3}[a-zA-Z0-9%/]|' + // github has ... in commit range links. Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    re.src_email_name = '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + // don't allow `--` in domain names, because:
    // - that can conflict with markdown &mdash; / &ndash;
    // - nobody use those anyway
    '(?:' + re.src_pseudo_letter + '(?:-(?!-)|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});
parcelRegister("b9ep3", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("23ErL", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("oRY4m", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;

});

parcelRegister("9bBmm", function(module, exports) {
module.exports = /[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E49\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});





parcelRegister("aUhe2", function(module, exports) {

$parcel$export(module.exports, "strike", () => $7f0c7ef7d4ef76e7$export$4899a95d70ec5056);

var $2fTAU = parcelRequire("2fTAU");
const $7f0c7ef7d4ef76e7$export$4899a95d70ec5056 = (0, $2fTAU.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'line-through' && null
        }
    ],
    toDOM () {
        return [
            's'
        ];
    }
});

});

parcelRegister("hhtT8", function(module, exports) {

$parcel$export(module.exports, "strong", () => $c94b3560d4129743$export$59ae2c325a998f89);

var $2fTAU = parcelRequire("2fTAU");
/**
 * @name strong_mark
 */ const $c94b3560d4129743$var$strongDOM = [
    'strong'
];
const $c94b3560d4129743$export$59ae2c325a998f89 = (0, $2fTAU.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs (node) {
                const element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs (node) {
                const element = node;
                const { fontWeight: fontWeight } = element.style;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || /^(bold(er)?|[5-9]\d{2,})$/.test(fontWeight)) && null;
            }
        }
    ],
    toDOM () {
        return $c94b3560d4129743$var$strongDOM;
    }
});

});

parcelRegister("4NwJJ", function(module, exports) {

$parcel$export(module.exports, "subsup", () => $37e521d9accf6615$export$b3401ee80eb31041);

var $2fTAU = parcelRequire("2fTAU");
/**
 * @name subsup_mark
 */ function $37e521d9accf6615$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
const $37e521d9accf6615$export$b3401ee80eb31041 = (0, $2fTAU.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: (node)=>$37e521d9accf6615$var$getAttrFromVerticalAlign(node)
        },
        {
            style: 'vertical-align=sub',
            getAttrs: (node)=>$37e521d9accf6615$var$getAttrFromVerticalAlign(node)
        }
    ],
    toDOM (mark) {
        return [
            mark.attrs.type
        ];
    }
});

});

parcelRegister("dtyqo", function(module, exports) {

$parcel$export(module.exports, "typeAheadQuery", () => $9cf8afcff83743a0$export$20af3dabbb5538df);

var $2fTAU = parcelRequire("2fTAU");

var $51H8P = parcelRequire("51H8P");
const $9cf8afcff83743a0$export$20af3dabbb5538df = (0, $2fTAU.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: `color: ${(0, $51H8P.B400)}`
            }
        ];
    }
});

});

parcelRegister("8EAPB", function(module, exports) {

$parcel$export(module.exports, "underline", () => $64cea1116bb0e8f8$export$425327af25286e5e);

var $2fTAU = parcelRequire("2fTAU");
const $64cea1116bb0e8f8$export$425327af25286e5e = (0, $2fTAU.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'underline' && null
        }
    ],
    toDOM () {
        return [
            'u'
        ];
    }
});

});

parcelRegister("jxVez", function(module, exports) {

$parcel$export(module.exports, "unsupportedMark", () => $e3ad7edb6364f3b2$export$30d78d5eb6719bb8);

var $2fTAU = parcelRequire("2fTAU");
const $e3ad7edb6364f3b2$export$30d78d5eb6719bb8 = (0, $2fTAU.unsupportedMark)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("lVmBd", function(module, exports) {

$parcel$export(module.exports, "unsupportedNodeAttribute", () => $ff60739479aa7be3$export$a316dc07ff5182a2);

var $2fTAU = parcelRequire("2fTAU");
const $ff60739479aa7be3$export$a316dc07ff5182a2 = (0, $2fTAU.unsupportedNodeAttribute)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("21PS7", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $17a3e9738ed289c7$export$c4c2f833baaebdb8);

var $gthjq = parcelRequire("gthjq");
/**
 * @name blockCard_node
 */ const $17a3e9738ed289c7$var$getCommonAttributesFromDom = (dom)=>{
    const anchor = dom;
    const data = anchor.getAttribute('data-card-data');
    const datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute('data-layout') || undefined : undefined,
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
const $17a3e9738ed289c7$export$c4c2f833baaebdb8 = (0, $gthjq.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$17a3e9738ed289c7$var$getCommonAttributesFromDom(dom)
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$17a3e9738ed289c7$var$getCommonAttributesFromDom(dom)
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
        ];
    }
});

});

parcelRegister("5AxYU", function(module, exports) {

$parcel$export(module.exports, "bodiedExtension", () => $411aac89e34c8741$export$27903d543b563e39);

var $CWpyq = parcelRequire("CWpyq");

var $gthjq = parcelRequire("gthjq");
const $411aac89e34c8741$export$27903d543b563e39 = (0, $gthjq.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            getAttrs: (domNode)=>(0, $CWpyq.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("kjhhp", function(module, exports) {

$parcel$export(module.exports, "bulletListSelector", () => $ec92fc66e86ee824$export$5f25a39efab3b58b);
$parcel$export(module.exports, "bulletList", () => $ec92fc66e86ee824$export$a140c94e5ea26bee);

var $gthjq = parcelRequire("gthjq");
const $ec92fc66e86ee824$export$5f25a39efab3b58b = '.ak-ul';
const $ec92fc66e86ee824$export$a140c94e5ea26bee = (0, $gthjq.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM () {
        const attrs = {
            class: $ec92fc66e86ee824$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});

});

parcelRegister("5JeV5", function(module, exports) {

$parcel$export(module.exports, "caption", () => $42bcba7b958fdfd3$export$8e3c2dfdc4f0453d);

var $gthjq = parcelRequire("gthjq");
const $42bcba7b958fdfd3$export$8e3c2dfdc4f0453d = (0, $gthjq.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});

});

parcelRegister("8vlrc", function(module, exports) {

$parcel$export(module.exports, "codeBlock", () => $6311d90c8f0b12c7$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "toJSON", () => $6311d90c8f0b12c7$export$54fd2c36b5cc6731);

var $kCV8T = parcelRequire("kCV8T");

var $gthjq = parcelRequire("gthjq");
/**
 * @name codeBlock_with_no_marks_node
 */ /**
 * @name codeBlock_node
 */ const $6311d90c8f0b12c7$var$getLanguageFromEditorStyle = (dom)=>{
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
const $6311d90c8f0b12c7$var$getLanguageFromBitbucketStyle = (dom)=>{
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $6311d90c8f0b12c7$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
const $6311d90c8f0b12c7$var$getLanguageFromCode = (dom)=>{
    const firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
const $6311d90c8f0b12c7$var$extractLanguageFromClass = (className)=>{
    const languageRegex = /(?:^|\s)language-([^\s]+)/;
    const result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
const $6311d90c8f0b12c7$var$removeLastNewLine = (dom)=>{
    const parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) dom.textContent = dom.textContent.replace(/\n$/, '');
    return dom;
};
function $6311d90c8f0b12c7$var$parseCodeFromHtml(node) {
    let code = '';
    node.childNodes.forEach((child)=>{
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            const tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $6311d90c8f0b12c7$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
const $6311d90c8f0b12c7$export$7bb0d5c671655cc4 = (0, $gthjq.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                let dom = domNode;
                const language = $6311d90c8f0b12c7$var$getLanguageFromBitbucketStyle(dom.parentElement) || $6311d90c8f0b12c7$var$getLanguageFromEditorStyle(dom.parentElement) || $6311d90c8f0b12c7$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                dom = $6311d90c8f0b12c7$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $6311d90c8f0b12c7$var$parseCodeFromHtml(domNode);
                return code ? (0, $kCV8T.Fragment).from(schema.text(code)) : (0, $kCV8T.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {};
            }
        }
    ],
    toDOM (node) {
        return [
            'pre',
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
const $6311d90c8f0b12c7$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((memo, key)=>{
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    });

});

parcelRegister("6bbHe", function(module, exports) {

$parcel$export(module.exports, "confluenceJiraIssue", () => $47fcd7cf328a46ad$export$daf889beb5092f95);

var $gthjq = parcelRequire("gthjq");
const $47fcd7cf328a46ad$var$name = 'confluenceJiraIssue';
const $47fcd7cf328a46ad$export$daf889beb5092f95 = (0, $gthjq.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: `span[data-node-type="${$47fcd7cf328a46ad$var$name}"]`,
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': $47fcd7cf328a46ad$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});

});

parcelRegister("5y0tR", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $40a0802970c8dfd0$export$e6e4878f43c27cab);

var $gthjq = parcelRequire("gthjq");
const $40a0802970c8dfd0$var$name = 'confluenceUnsupportedBlock';
const $40a0802970c8dfd0$export$e6e4878f43c27cab = (0, $gthjq.confluenceUnsupportedBlock)({
    toDOM (node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        const attrs = {
            'data-node-type': $40a0802970c8dfd0$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$40a0802970c8dfd0$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("bd7A9", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedInline", () => $8296ca40a4ed2ee7$export$3e6d667072febc87);

var $gthjq = parcelRequire("gthjq");
const $8296ca40a4ed2ee7$var$name = 'confluenceUnsupportedInline';
const $8296ca40a4ed2ee7$export$3e6d667072febc87 = (0, $gthjq.confluenceUnsupportedInline)({
    toDOM (node) {
        const attrs = {
            'data-node-type': $8296ca40a4ed2ee7$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$8296ca40a4ed2ee7$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("b2VmY", function(module, exports) {

$parcel$export(module.exports, "date", () => $80ac620012a63cc1$export$324d90190a8b822a);

var $gthjq = parcelRequire("gthjq");
const $80ac620012a63cc1$export$324d90190a8b822a = (0, $gthjq.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    timestamp: dom.getAttribute('data-timestamp')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("Khvpb", function(module, exports) {

$parcel$export(module.exports, "decisionItem", () => $08b1e03a19cbdc24$export$6959e16eeff859b4);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
const $08b1e03a19cbdc24$export$6959e16eeff859b4 = (0, $gthjq.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $9IGaJ.uuid).generate(),
                    state: dom.getAttribute('data-decision-state')
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});

});

parcelRegister("8gSD8", function(module, exports) {

$parcel$export(module.exports, "decisionListSelector", () => $605a31c9af2a8977$export$a5393ce68c2ff601);
$parcel$export(module.exports, "decisionList", () => $605a31c9af2a8977$export$62d45a65fb43d95e);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
/**
 * @name decisionList_node
 */ const $605a31c9af2a8977$var$name = 'decisionList';
const $605a31c9af2a8977$export$a5393ce68c2ff601 = `[data-node-type="${$605a31c9af2a8977$var$name}"]`;
const $605a31c9af2a8977$export$62d45a65fb43d95e = (0, $gthjq.decisionList)({
    parseDOM: [
        {
            tag: `ol${$605a31c9af2a8977$export$a5393ce68c2ff601}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $9IGaJ.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $605a31c9af2a8977$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("xjCuM", function(module, exports) {

$parcel$export(module.exports, "doc", () => $06424d48e92613a9$export$2a111da947c407d2);

var $gthjq = parcelRequire("gthjq");
const $06424d48e92613a9$export$2a111da947c407d2 = (0, $gthjq.doc)({});

});

parcelRegister("kshOv", function(module, exports) {

$parcel$export(module.exports, "embedCard", () => $ee443d93678dbe0b$export$be4283d9a1cb1ff6);

var $gthjq = parcelRequire("gthjq");
const $ee443d93678dbe0b$export$be4283d9a1cb1ff6 = (0, $gthjq.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    url: dom.getAttribute('data-card-url'),
                    layout: dom.getAttribute('data-layout') || 'center',
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(dom.getAttribute('data-card-original-height')) || null
                })
        }
    ],
    toDOM (node) {
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("7DoMR", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $58ef6723e99e5604$export$a19185d1233fc4b2);

var $4pzsz = parcelRequire("4pzsz");

var $gthjq = parcelRequire("gthjq");
const $58ef6723e99e5604$export$a19185d1233fc4b2 = (0, $gthjq.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: (dom)=>(0, $4pzsz.acNameToEmoji)(dom.getAttribute('data-emoticon-name'))
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: (dom)=>(0, $4pzsz.acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'))
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM (node) {
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});
parcelRegister("4pzsz", function(module, exports) {

$parcel$export(module.exports, "acNameToEmoji", () => $336500cbd1ca0f10$export$f61e93bda2a8b420);
$parcel$export(module.exports, "acShortcutToEmoji", () => $336500cbd1ca0f10$export$441f8b58f5790a68);
$parcel$export(module.exports, "getEmojiAcName", () => $336500cbd1ca0f10$export$880a2465992fbbe);
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
const $336500cbd1ca0f10$var$DEFAULT_EMOJI_ID = '2b50';
// Default ac:name for emoticons as a fallback is `blue-star`
const $336500cbd1ca0f10$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
// ac:hipchat-emoticon prefix when converting to Emoji ID
const $336500cbd1ca0f10$var$HC_EMOTICON_PREFIX = 'atlassian-';
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ const $336500cbd1ca0f10$var$acNameToEmojiMap = {
    smile: [
        '1f642',
        ':slight_smile:',
        '\uD83D\uDE42'
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        '\uD83D\uDE41'
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        '\uD83D\uDE1B'
    ],
    laugh: [
        '1f600',
        ':grinning:',
        '\uD83D\uDE00'
    ],
    wink: [
        '1f609',
        ':wink:',
        '\uD83D\uDE09'
    ],
    information: [
        '2139',
        ':information_source:',
        '\u2139'
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        '\u2705'
    ],
    cross: [
        '274c',
        ':x:',
        '\u274C'
    ],
    warning: [
        '26a0',
        ':warning:',
        '\u26A0'
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        '\u2795'
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        '\u2796'
    ],
    question: [
        '2753',
        ':question:',
        '\u003F'
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        '\uD83D\uDC4D'
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        '\uD83D\uDC4E'
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        '\uD83D\uDCA1'
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        '\uD83D\uDC9B'
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        '\uD83D\uDEAB'
    ],
    'red-star': [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        '\uD83D\uDC9A'
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        '\uD83D\uDC99'
    ],
    heart: [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        '\uD83D\uDC94'
    ]
};
function $336500cbd1ca0f10$export$f61e93bda2a8b420(acName) {
    const emojiData = $336500cbd1ca0f10$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $336500cbd1ca0f10$var$DEFAULT_EMOJI_ID,
        shortName: `:${acName}:`,
        text: ''
    };
}
function $336500cbd1ca0f10$export$bc94e44ec0e7bd82(emojiId) {
    const filterEmojis = (acName)=>$336500cbd1ca0f10$var$acNameToEmojiMap[acName] ? $336500cbd1ca0f10$var$acNameToEmojiMap[acName][0] === emojiId : false;
    return Object.keys($336500cbd1ca0f10$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $336500cbd1ca0f10$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: `${$336500cbd1ca0f10$var$HC_EMOTICON_PREFIX}${hipchatEmoticonShortName}`,
        shortName: `:${hipchatEmoticonShortName}:`,
        text: ''
    };
}
function $336500cbd1ca0f10$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
}
function $336500cbd1ca0f10$export$880a2465992fbbe({ id: id, shortName: shortName }) {
    if ($336500cbd1ca0f10$var$DEFAULT_EMOJI_ID === id) {
        const possibleName = $336500cbd1ca0f10$var$getAcNameFromShortName(shortName);
        if (possibleName in $336500cbd1ca0f10$var$acNameToEmojiMap) return possibleName;
    }
    return $336500cbd1ca0f10$export$bc94e44ec0e7bd82(id) || $336500cbd1ca0f10$var$DEFAULT_EMOJI_ACNAME;
}

});


parcelRegister("hhN5g", function(module, exports) {

$parcel$export(module.exports, "extension", () => $c95a1940f4fa6aee$export$1b45514b112dd749);

var $CWpyq = parcelRequire("CWpyq");

var $gthjq = parcelRequire("gthjq");
const $c95a1940f4fa6aee$export$1b45514b112dd749 = (0, $gthjq.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            getAttrs: (domNode)=>(0, $CWpyq.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("jnMM2", function(module, exports) {

$parcel$export(module.exports, "hardBreak", () => $e1c5ffc4cc369fdc$export$371da9dd35aba193);

var $gthjq = parcelRequire("gthjq");
const $e1c5ffc4cc369fdc$export$371da9dd35aba193 = (0, $gthjq.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM () {
        return [
            'br'
        ];
    }
});

});

parcelRegister("lRTZM", function(module, exports) {

$parcel$export(module.exports, "heading", () => $feb9fbb7aabe0cc7$export$46e4a324ac90507f);

var $gthjq = parcelRequire("gthjq");
/**
 * @name heading_node
 */ /**
 * @name heading_with_no_marks_node
 */ // Check `paragraph` node for why we are doing things like this
/**
 * @name heading_with_alignment_node
 */ /**
 * @name heading_with_indentation_node
 */ const $feb9fbb7aabe0cc7$var$getAttrs = (level)=>(domNode)=>{
        var _heading$attrs, _heading$attrs$localI;
        return {
            level: level,
            localId: domNode.getAttribute('data-local-id') || ((_heading$attrs = $feb9fbb7aabe0cc7$export$46e4a324ac90507f.attrs) === null || _heading$attrs === void 0 ? void 0 : (_heading$attrs$localI = _heading$attrs.localId) === null || _heading$attrs$localI === void 0 ? void 0 : _heading$attrs$localI.default)
        };
    };
const $feb9fbb7aabe0cc7$export$46e4a324ac90507f = (0, $gthjq.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(6)
        }
    ],
    toDOM (node) {
        const { level: level, localId: localId } = node.attrs;
        const name = 'h' + level;
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("7lRBh", function(module, exports) {

$parcel$export(module.exports, "image", () => $55a4127c569d3934$export$5c452ff88e35e47d);

var $gthjq = parcelRequire("gthjq");
const $55a4127c569d3934$export$5c452ff88e35e47d = (0, $gthjq.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs (domNode) {
                const dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM (node) {
        return [
            'img',
            node.attrs
        ];
    }
});

});

parcelRegister("cCBEe", function(module, exports) {

$parcel$export(module.exports, "inlineCard", () => $93063cb7956d3766$export$cbf8224b64e0d942);

var $gthjq = parcelRequire("gthjq");
const $93063cb7956d3766$export$cbf8224b64e0d942 = (0, $gthjq.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});

});

parcelRegister("5BOuQ", function(module, exports) {

$parcel$export(module.exports, "inlineExtension", () => $4157940155363fee$export$16b353b2649bd8d9);

var $CWpyq = parcelRequire("CWpyq");

var $gthjq = parcelRequire("gthjq");
const $4157940155363fee$export$16b353b2649bd8d9 = (0, $gthjq.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            getAttrs: (domNode)=>(0, $CWpyq.getExtensionAttrs)(domNode, true)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("4EbxI", function(module, exports) {

$parcel$export(module.exports, "layoutColumn", () => $3623d9fd8951cfd2$export$ab76e7c03cd6f650);

var $gthjq = parcelRequire("gthjq");
const $3623d9fd8951cfd2$export$ab76e7c03cd6f650 = (0, $gthjq.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-layout-column': 'true'
        };
        const { width: width } = node.attrs;
        if (width) {
            attrs['style'] = `flex-basis: ${width}%`;
            attrs['data-column-width'] = `${width}`;
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        const contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});

});

parcelRegister("7agO8", function(module, exports) {

$parcel$export(module.exports, "createMediaSpec", () => $5376813d9b4ea07d$export$35bdbf5bc8caa677);
$parcel$export(module.exports, "copyPrivateAttributes", () => $5376813d9b4ea07d$export$111130fa8968d741);
$parcel$export(module.exports, "media", () => $5376813d9b4ea07d$export$987d49ffe1b0900f);
$parcel$export(module.exports, "toJSON", () => $5376813d9b4ea07d$export$54fd2c36b5cc6731);

var $51H8P = parcelRequire("51H8P");

var $gthjq = parcelRequire("gthjq");
const $5376813d9b4ea07d$export$bb3fe706be61f640 = (0, $gthjq.media)({}).attrs;
const $5376813d9b4ea07d$export$35bdbf5bc8caa677 = (attributes, inline = false)=>{
    const domNodeType = inline ? 'span' : 'div';
    const nodeName = inline ? 'mediaInline' : 'media';
    const parseDOM = [
        {
            tag: `${domNodeType}[data-node-type="${nodeName}"]`,
            getAttrs: (dom)=>{
                const attrs = {};
                if (attributes) Object.keys(attributes).forEach((k)=>{
                    const key = $5376813d9b4ea07d$export$f84fdfb973c05bd8(k).replace(/^__/, '');
                    const value = dom.getAttribute(`data-${key}`) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                const width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                const height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    const toDOM = (node)=>{
        const attrs = {
            'data-id': node.attrs.id,
            'data-node-type': `${nodeName}`,
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: `display: inline-block; border-radius: 3px; background: ${(0, $51H8P.N30)}; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
        };
        $5376813d9b4ea07d$export$111130fa8968d741(node.attrs, attrs, (key)=>`data-${$5376813d9b4ea07d$export$f84fdfb973c05bd8(key.slice(2))}`);
        return [
            `${domNodeType}`,
            attrs
        ];
    };
    if (inline) return (0, $gthjq.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $gthjq.media)({
        parseDOM: [
            ...parseDOM,
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: (dom)=>{
                    return {
                        type: 'external',
                        url: dom.getAttribute('src') || '',
                        alt: dom.getAttribute('alt') || ''
                    };
                }
            }
        ],
        toDOM: toDOM
    });
};
const $5376813d9b4ea07d$export$987d49ffe1b0900f = $5376813d9b4ea07d$export$35bdbf5bc8caa677($5376813d9b4ea07d$export$bb3fe706be61f640, false);
const $5376813d9b4ea07d$export$f84fdfb973c05bd8 = (str)=>str.replace(/([^A-Z]+)([A-Z])/g, (_, x, y)=>`${x}-${y.toLowerCase()}`);
const $5376813d9b4ea07d$export$111130fa8968d741 = (from, to, map)=>{
    if ($5376813d9b4ea07d$export$987d49ffe1b0900f.attrs) Object.keys($5376813d9b4ea07d$export$987d49ffe1b0900f.attrs).forEach((key)=>{
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ const $5376813d9b4ea07d$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt'
];
const $5376813d9b4ea07d$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt'
];
const $5376813d9b4ea07d$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter((key)=>!(key[0] === '_' && key[1] === '_')).reduce((obj, key)=>{
            if (node.attrs.type === 'external' && $5376813d9b4ea07d$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($5376813d9b4ea07d$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});

parcelRegister("92lix", function(module, exports) {

$parcel$export(module.exports, "mediaGroup", () => $6944d24b2c8b0dd9$export$2855e964765eac9);

var $gthjq = parcelRequire("gthjq");
const $6944d24b2c8b0dd9$export$2855e964765eac9 = (0, $gthjq.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM () {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});

});

parcelRegister("7Xgp3", function(module, exports) {

$parcel$export(module.exports, "mediaInline", () => $5caac46433adf3f0$export$38bab695e3f720f1);

var $7agO8 = parcelRequire("7agO8");

var $gthjq = parcelRequire("gthjq");
const $5caac46433adf3f0$export$38bab695e3f720f1 = (0, $7agO8.createMediaSpec)((0, $gthjq.mediaInline)({}).attrs, true);

});

parcelRegister("bIGZ7", function(module, exports) {

$parcel$export(module.exports, "mediaSingleSpec", () => $888525ada96954d1$export$5a1e124099b60c6b);
$parcel$export(module.exports, "mediaSingle", () => $888525ada96954d1$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleWithCaption", () => $888525ada96954d1$export$d35e6c006d4abdfb);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => $888525ada96954d1$export$9c58e19811ce4cf5);
$parcel$export(module.exports, "mediaSingleFull", () => $888525ada96954d1$export$7e767666f2ce108a);
$parcel$export(module.exports, "toJSON", () => $888525ada96954d1$export$54fd2c36b5cc6731);

var $ITAJ1 = parcelRequire("ITAJ1");

var $6VXbJ = parcelRequire("6VXbJ");

var $gthjq = parcelRequire("gthjq");
const $888525ada96954d1$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: 'center'
    }
};
const $888525ada96954d1$export$5a1e124099b60c6b = ({ withCaption: withCaption = false, withExtendedWidthTypes: withExtendedWidthTypes = false })=>{
    const getAttrs = (dom)=>{
        if (!(0, $6VXbJ.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        const layout = dom.getAttribute('data-layout') || 'center';
        const width = Number(dom.getAttribute('data-width')) || null;
        const widthType = dom.getAttribute('data-width-type');
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $ITAJ1.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    const getAttrsFromNode = (node)=>{
        const { layout: layout, width: width } = node.attrs;
        const attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            const { widthType: widthType } = node.attrs;
            return {
                ...attrs,
                'data-width-type': widthType || (0, $ITAJ1.WidthType).PERCENTAGE
            };
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $gthjq.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $gthjq.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $gthjq.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $gthjq.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
const $888525ada96954d1$export$969fe3781ca15058 = $888525ada96954d1$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
const $888525ada96954d1$export$d35e6c006d4abdfb = $888525ada96954d1$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
const $888525ada96954d1$export$9c58e19811ce4cf5 = $888525ada96954d1$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
const $888525ada96954d1$export$7e767666f2ce108a = $888525ada96954d1$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
const $888525ada96954d1$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});
parcelRegister("ITAJ1", function(module, exports) {

$parcel$export(module.exports, "WidthType", () => $086f3b754fef02e1$export$4d41558722ac7eed);
/**
 * @description The widthType attribute is used to support fixed with media single
 */ let $086f3b754fef02e1$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});


parcelRegister("g7Cky", function(module, exports) {

$parcel$export(module.exports, "mention", () => $bbcb0873d657d42d$export$db83999c14438df4);
$parcel$export(module.exports, "toJSON", () => $bbcb0873d657d42d$export$54fd2c36b5cc6731);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
let $bbcb0873d657d42d$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
const $bbcb0873d657d42d$export$db83999c14438df4 = (0, $gthjq.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-mention-id') || $bbcb0873d657d42d$export$db83999c14438df4.attrs.id.default,
                    text: dom.textContent || $bbcb0873d657d42d$export$db83999c14438df4.attrs.text.default,
                    accessLevel: dom.getAttribute('data-access-level') || $bbcb0873d657d42d$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $9IGaJ.uuid).generate()
                };
                const userType = dom.getAttribute('data-user-type');
                if ($bbcb0873d657d42d$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { id: id, accessLevel: accessLevel, text: text, userType: userType, localId: localId } = node.attrs;
        const attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $bbcb0873d657d42d$var$isOptional = (key)=>{
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
const $bbcb0873d657d42d$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($bbcb0873d657d42d$var$isOptional(key) && !node.attrs[key]) return obj;
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("dx5eC", function(module, exports) {

$parcel$export(module.exports, "nestedExpand", () => $9da26af350402964$export$63cadbf5f4296627);

var $gthjq = parcelRequire("gthjq");
/**
 * @name nestedExpand_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name nestedExpand_node
 */ /**
 * @name nestedExpand_with_no_marks_node
 */ function $9da26af350402964$var$getExpandAttrs(domNode) {
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $9da26af350402964$export$63cadbf5f4296627 = (0, $gthjq.nestedExpand)({
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: $9da26af350402964$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: $9da26af350402964$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("dwptW", function(module, exports) {

$parcel$export(module.exports, "orderedListSelector", () => $9d8207b1e6c47527$export$4e7125c7ff595be5);
$parcel$export(module.exports, "orderedList", () => $9d8207b1e6c47527$export$a5dc81035676e7a);
$parcel$export(module.exports, "orderedListWithOrder", () => $9d8207b1e6c47527$export$b9ab759e8298198f);

var $gthjq = parcelRequire("gthjq");
const $9d8207b1e6c47527$export$4e7125c7ff595be5 = '.ak-ol';
const $9d8207b1e6c47527$export$a5dc81035676e7a = (0, $gthjq.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM () {
        const attrs = {
            class: $9d8207b1e6c47527$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
const $9d8207b1e6c47527$var$resolveStart = (start)=>{
    const num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $9d8207b1e6c47527$export$b9ab759e8298198f = (0, $gthjq.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    const start = $9d8207b1e6c47527$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const start = $9d8207b1e6c47527$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $9d8207b1e6c47527$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("abme3", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $769c2c0b195d79f6$export$9c206ddddb32a9b);

var $gthjq = parcelRequire("gthjq");
const $769c2c0b195d79f6$export$9c206ddddb32a9b = (0, $gthjq.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: (domNode)=>{
                var _paragraph$attrs, _paragraph$attrs$loca;
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $769c2c0b195d79f6$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const name = 'p';
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("dgJoa", function(module, exports) {

$parcel$export(module.exports, "placeholder", () => $9a8ffa3be19d5bd0$export$c7187bbd1a7a9244);

var $gthjq = parcelRequire("gthjq");
const $9a8ffa3be19d5bd0$export$c7187bbd1a7a9244 = (0, $gthjq.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: dom.getAttribute('data-placeholder') || $9a8ffa3be19d5bd0$export$c7187bbd1a7a9244.attrs.text.default
                })
        }
    ],
    toDOM (node) {
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("M4hHz", function(module, exports) {

$parcel$export(module.exports, "rule", () => $0907ce9fea0294ca$export$fbeb3a3956e8a3c7);

var $gthjq = parcelRequire("gthjq");
/**
 * @name rule_node
 */ const $0907ce9fea0294ca$var$hrDOM = [
    'hr'
];
const $0907ce9fea0294ca$export$fbeb3a3956e8a3c7 = (0, $gthjq.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM () {
        return $0907ce9fea0294ca$var$hrDOM;
    }
});

});

parcelRegister("18bvk", function(module, exports) {

$parcel$export(module.exports, "status", () => $0d2f764e7fea7c00$export$471f7ae5c4103ae1);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
const $0d2f764e7fea7c00$export$471f7ae5c4103ae1 = (0, $gthjq.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    text: dom.textContent.replace(/\n/, '').trim(),
                    color: dom.getAttribute('data-color'),
                    localId: (0, $9IGaJ.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM (node) {
        const { text: text, color: color, localId: localId, style: style } = node.attrs;
        const attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("iThOL", function(module, exports) {

$parcel$export(module.exports, "taskItem", () => $dc0b2f4f47f16dc0$export$6d8b0ef52e2e6390);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
const $dc0b2f4f47f16dc0$export$6d8b0ef52e2e6390 = (0, $gthjq.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $9IGaJ.uuid).generate(),
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("43mJF", function(module, exports) {

$parcel$export(module.exports, "taskListSelector", () => $2f3914100d01687b$export$c0ec71adb7a18fb2);
$parcel$export(module.exports, "taskList", () => $2f3914100d01687b$export$375b6afcc5f4d291);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
/**
 * @name taskList_node
 */ const $2f3914100d01687b$var$name = 'actionList';
const $2f3914100d01687b$export$c0ec71adb7a18fb2 = `[data-node-type="${$2f3914100d01687b$var$name}"]`;
const $2f3914100d01687b$export$375b6afcc5f4d291 = (0, $gthjq.taskList)({
    parseDOM: [
        {
            tag: `div${$2f3914100d01687b$export$c0ec71adb7a18fb2}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $9IGaJ.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $2f3914100d01687b$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("3DR6L", function(module, exports) {

$parcel$export(module.exports, "text", () => $2a6e35cab1a01b8e$export$6f093cfa640b7166);

var $gthjq = parcelRequire("gthjq");
const $2a6e35cab1a01b8e$export$6f093cfa640b7166 = (0, $gthjq.text)({
    toDebugString: ()=>'text_node'
});

});

parcelRegister("9X587", function(module, exports) {

$parcel$export(module.exports, "default", () => $01deabc8204e5493$export$2e2bcd8739ae039);
const $01deabc8204e5493$var$name = 'unknownBlock';
var $01deabc8204e5493$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM () {
        return [
            'div',
            {
                'data-node-type': $01deabc8204e5493$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$01deabc8204e5493$var$name}"]`
        }
    ]
};

});

parcelRegister("d1d6m", function(module, exports) {

$parcel$export(module.exports, "unsupportedBlock", () => $97a5880db351ce36$export$44b79b0979d0f0f7);

var $gthjq = parcelRequire("gthjq");
const $97a5880db351ce36$export$44b79b0979d0f0f7 = (0, $gthjq.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("6kr5W", function(module, exports) {

$parcel$export(module.exports, "unsupportedInline", () => $49b9a0cbcfdcc3a0$export$310ebe0d80122e9b);

var $gthjq = parcelRequire("gthjq");
const $49b9a0cbcfdcc3a0$export$310ebe0d80122e9b = (0, $gthjq.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});

});



parcelRegister("f5oqj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3de1eca32602d427$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $kOFhM = parcelRequire("kOFhM");

var $dGzaM = parcelRequire("dGzaM");
var $9S8fM = parcelRequire("9S8fM");

var $9Iju4 = parcelRequire("9Iju4");
var $fIJEx = parcelRequire("fIJEx");
var $iiXGq = parcelRequire("iiXGq");
var $4ceoy = parcelRequire("4ceoy");
var $2DpUZ = parcelRequire("2DpUZ");

var $gmhCD = parcelRequire("gmhCD");

var $f8Sb3 = parcelRequire("f8Sb3");

var $gE8f9 = parcelRequire("gE8f9");

var $iN9lO = parcelRequire("iN9lO");

var $ap7h6 = parcelRequire("ap7h6");

var $kFiBa = parcelRequire("kFiBa");

var $4NUlu = parcelRequire("4NUlu");
var $fc6h8 = parcelRequire("fc6h8");

var $VSDnB = parcelRequire("VSDnB");

var $dWAZk = parcelRequire("dWAZk");

var $1PVpv = parcelRequire("1PVpv");

var $gkwXh = parcelRequire("gkwXh");

var $4zXba = parcelRequire("4zXba");

var $iHYdz = parcelRequire("iHYdz");

var $8QpSo = parcelRequire("8QpSo");

var $bXrHm = parcelRequire("bXrHm");

var $9gOVJ = parcelRequire("9gOVJ");
var $12yAL = parcelRequire("12yAL");

var $TM1uy = parcelRequire("TM1uy");

var $knXBU = parcelRequire("knXBU");

var $1urn6 = parcelRequire("1urn6");

var $3kKuL = parcelRequire("3kKuL");

var $dyURG = parcelRequire("dyURG");

var $K5Jsy = parcelRequire("K5Jsy");

var $fCNtA = parcelRequire("fCNtA");

var $4BsEy = parcelRequire("4BsEy");

var $1pTqN = parcelRequire("1pTqN");

var $4YrGg = parcelRequire("4YrGg");

var $8Eu7T = parcelRequire("8Eu7T");

var $jUVor = parcelRequire("jUVor");

var $TPpI8 = parcelRequire("TPpI8");

var $kgV4b = parcelRequire("kgV4b");

var $OxITw = parcelRequire("OxITw");

var $3lRy2 = parcelRequire("3lRy2");
function $3de1eca32602d427$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3de1eca32602d427$export$47b2879ca9bbf67a = 2000;
const $3de1eca32602d427$export$1b622068be977101 = 3000;
const $3de1eca32602d427$var$packageName = "platform-pkg";
const $3de1eca32602d427$var$packageVersion = "0.0.0-use.local";
const $3de1eca32602d427$var$setAsQueryContainerStyles = {
    name: "isqlwl",
    styles: "container-name:ak-renderer-wrapper;container-type:inline-size;contain:layout style inline-size"
};
class $3de1eca32602d427$export$5161b00bb85c4267 extends (0, $5uXOq.PureComponent) {
    constructor(props){
        super(props), /**
   * This is used in measuring the Renderer Mount time and is then
   * deleted once that measurement occurs.
   */ this.renderedMeasurementDistortedDurationMonitor = (0, $ap7h6.getDistortedDurationMonitor)(), this.createRendererContext = (0, $8QpSo.default)((featureFlags, isTopLevelRenderer)=>{
            const normalizedFeatureFlags = (0, $4zXba.normalizeFeatureFlags)(featureFlags);
            return {
                featureFlags: normalizedFeatureFlags,
                // The context is uninitialized at the top level. In nested levels it's all false
                isTopLevelRenderer: isTopLevelRenderer === undefined
            };
        }), this.fireAnalyticsEvent = (event)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) {
                const channel = (0, $dWAZk.FabricChannel).editor;
                createAnalyticsEvent(event).fire(channel);
            }
        }, this.getSchema = (0, $8QpSo.default)((schema, adfStage)=>{
            if (schema) return schema;
            return (0, $kOFhM.getSchemaBasedOnStage)(adfStage);
        }), this.onMouseDownEditView = ()=>{
            // When the user is deselecting text on the screen by clicking, if they are clicking outside
            // the current selection, by the time the onclick handler is called the window.getSelection()
            // value will already be cleared.
            // The mousedown callback is called before the selection is cleared.
            const windowSelection = window.getSelection();
            this.mouseDownSelection = windowSelection !== null ? windowSelection.toString() : undefined;
        }, this.handleMouseTripleClickInTables = (event)=>{
            if ((0, $gE8f9.browser).ios || (0, $gE8f9.browser).android) return;
            const badBrowser = (0, $gE8f9.browser).chrome || (0, $gE8f9.browser).safari;
            const tripleClick = event.detail >= 3;
            if (!(badBrowser && tripleClick)) return;
            const selection = window.getSelection();
            if (!selection) return;
            const { type: type, anchorNode: anchorNode, focusNode: focusNode } = selection;
            const rangeSelection = Boolean(type === 'Range' && anchorNode && focusNode);
            if (!rangeSelection) return;
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const target = event.target;
            const tableCell = target.closest('td,th');
            const clickedInCell = Boolean(tableCell);
            if (!clickedInCell) return;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const anchorInCell = tableCell.contains(anchorNode);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const focusInCell = tableCell.contains(focusNode);
            const selectionStartsOrEndsOutsideClickedCell = !(anchorInCell && focusInCell);
            if (!selectionStartsOrEndsOutsideClickedCell) return;
            // If selection starts or ends in a different cell than the clicked cell,
            // we select the node inside the clicked cell (or if both are in a different
            // cell, we select the cell's contents instead). We want to select the nearest
            // parent block, so that a whole line of text/content is selected (rather than
            // selecting a span that would select one specific chunk of text).
            const elementToSelect = anchorInCell ? // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            anchorNode.parentElement?.closest('div,p') : focusInCell ? // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            focusNode.parentElement?.closest('div,p') : tableCell;
            if (elementToSelect) selection.selectAllChildren(elementToSelect);
        };
        this.providerFactory = props.dataProviders || new (0, $dGzaM.default)();
        this.serializer = new (0, $9gOVJ.default)(this.deriveSerializerProps(props));
        this.editorRef = props.innerRef || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef();
        this.id = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
        (0, $iN9lO.startMeasure)(`Renderer Render Time: ${this.id}`);
    }
    anchorLinkAnalytics() {
        const hash = window.location.hash && decodeURIComponent(window.location.hash.slice(1));
        const { disableHeadingIDs: disableHeadingIDs } = this.props;
        if (!disableHeadingIDs && hash && this.editorRef && this.editorRef.current instanceof HTMLElement) {
            const anchorLinkElement = document.getElementById(hash);
            // We are not use this.editorRef.querySelector here, instead we have this.editorRef.contains
            // because querySelector might fail if there are special characters in hash, and CSS.escape is still experimental.
            if (anchorLinkElement && this.editorRef.current.contains(anchorLinkElement)) this.fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).VIEWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANCHOR_LINK,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB,
                    mode: (0, $knXBU.MODE).RENDERER
                },
                eventType: (0, $gkwXh.EVENT_TYPE).UI
            });
        }
    }
    componentDidMount() {
        this.fireAnalyticsEvent({
            action: (0, $gkwXh.ACTION).STARTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB
            },
            eventType: (0, $gkwXh.EVENT_TYPE).UI
        });
        this.rafID = requestAnimationFrame(()=>{
            (0, $iN9lO.stopMeasure)(`Renderer Render Time: ${this.id}`, (duration)=>{
                const { analyticsEventSeverityTracking: analyticsEventSeverityTracking } = this.props;
                const forceSeverityTracking = typeof analyticsEventSeverityTracking === 'undefined' && (0, $fc6h8.shouldForceTracking)();
                const severity = !!forceSeverityTracking || analyticsEventSeverityTracking?.enabled ? (0, $4NUlu.getAnalyticsEventSeverity)(duration, analyticsEventSeverityTracking?.severityNormalThreshold ?? $3de1eca32602d427$export$47b2879ca9bbf67a, analyticsEventSeverityTracking?.severityDegradedThreshold ?? $3de1eca32602d427$export$1b622068be977101) : undefined;
                // ED-16320: Check for explicit disable so that by default
                // it will still be enabled as it currently is. Then we can
                // progressively opt out synthetic tenants.
                const isTTRTrackingExplicitlyDisabled = this.props?.analyticsEventSeverityTracking?.enabled === false;
                if (!isTTRTrackingExplicitlyDisabled) this.fireAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).RENDERED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
                    attributes: {
                        platform: (0, $knXBU.PLATFORM).WEB,
                        duration: duration,
                        distortedDuration: // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        this.renderedMeasurementDistortedDurationMonitor.distortedDuration,
                        ttfb: (0, $kFiBa.getResponseEndTime)(),
                        nodes: (0, $kgV4b.countNodes)(this.props.document),
                        severity: severity
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.renderedMeasurementDistortedDurationMonitor.cleanup();
                delete this.renderedMeasurementDistortedDurationMonitor;
            });
            this.anchorLinkAnalytics();
        });
    }
    // Ignored via go/ees005
    // eslint-disable-next-line react/no-unsafe
    UNSAFE_componentWillReceiveProps(nextProps) {
        const nextMedia = nextProps.media || {};
        const media = this.props.media || {};
        if (nextProps.portal !== this.props.portal || nextProps.appearance !== this.props.appearance || nextProps.stickyHeaders !== this.props.stickyHeaders || nextProps.disableActions !== this.props.disableActions || nextProps.allowCustomPanels !== this.props.allowCustomPanels || nextProps.extensionHandlers !== this.props.extensionHandlers || nextProps.allowHeadingAnchorLinks !== this.props.allowHeadingAnchorLinks || nextMedia.allowLinking !== media.allowLinking) this.serializer = new (0, $9gOVJ.default)(this.deriveSerializerProps(nextProps));
    }
    deriveSerializerProps(props) {
        // if just passed a boolean, change shape into object to simplify type
        const stickyHeaders = props.stickyHeaders ? props.stickyHeaders === true ? {} : props.stickyHeaders : undefined;
        const { annotationProvider: annotationProvider } = props;
        const allowAnnotationsDraftMode = Boolean(annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.allowDraftMode);
        const { featureFlags: featureFlags } = this.createRendererContext(props.featureFlags, props.isTopLevelRenderer);
        return {
            startPos: props.startPos,
            providers: this.providerFactory,
            eventHandlers: props.eventHandlers,
            extensionHandlers: props.extensionHandlers,
            portal: props.portal,
            objectContext: {
                adDoc: props.document,
                schema: props.schema,
                ...props.rendererContext
            },
            appearance: props.appearance,
            disableHeadingIDs: props.disableHeadingIDs,
            disableActions: props.disableActions,
            allowHeadingAnchorLinks: props.allowHeadingAnchorLinks,
            allowColumnSorting: props.allowColumnSorting,
            fireAnalyticsEvent: this.fireAnalyticsEvent,
            shouldOpenMediaViewer: props.shouldOpenMediaViewer,
            allowAltTextOnImages: props.allowAltTextOnImages,
            stickyHeaders: stickyHeaders,
            allowMediaLinking: props.media && props.media.allowLinking,
            surroundTextNodesWithTextWrapper: allowAnnotationsDraftMode,
            media: props.media,
            emojiResourceConfig: props.emojiResourceConfig,
            smartLinks: props.smartLinks,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowAnnotations: props.allowAnnotations,
            allowSelectAllTrap: props.allowSelectAllTrap,
            allowPlaceholderText: props.allowPlaceholderText,
            nodeComponents: props.nodeComponents,
            // does not currently support SSR, should not be enabled in environments where Renderer is SSR-ed
            allowWindowedCodeBlock: featureFlags?.allowWindowedCodeBlock,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            textHighlighter: props.UNSTABLE_textHighlighter,
            allowTableAlignment: props.UNSTABLE_allowTableAlignment,
            allowTableResizing: props.UNSTABLE_allowTableResizing
        };
    }
    render() {
        const { document: adfDocument, onComplete: onComplete, onError: onError, appearance: appearance, allowAnnotations: allowAnnotations, adfStage: adfStage, truncated: truncated, maxHeight: maxHeight, fadeOutHeight: fadeOutHeight, enableSsrInlineScripts: enableSsrInlineScripts, noOpSSRInlineScript: noOpSSRInlineScript, allowHeadingAnchorLinks: allowHeadingAnchorLinks, allowPlaceholderText: allowPlaceholderText, allowColumnSorting: allowColumnSorting, allowCopyToClipboard: allowCopyToClipboard, allowWrapCodeBlock: allowWrapCodeBlock, allowCustomPanels: allowCustomPanels, media: media, skipValidation: skipValidation } = this.props;
        const rendererContext = this.createRendererContext(this.props.featureFlags, this.props.isTopLevelRenderer);
        const allowNestedHeaderLinks = (0, $3kKuL.isNestedHeaderLinksEnabled)(allowHeadingAnchorLinks);
        /**
     * Handle clicks inside renderer. If the click isn't on media, in the media picker, or on a
     * link, call the onUnhandledClick eventHandler (which in Jira for example, may switch the
     * renderer out for the editor).
     * @param event Click event anywhere inside renderer
     */ const handleWrapperOnClick = (event)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const targetElement = event.target;
            // ED-14862: When a user triple clicks to select a line of content inside a
            // a table cell, but the browser incorrectly moves the selection start or end into
            // a different table cell, we manually set the selection back to within the original
            // table cell the user intended to target
            this.handleMouseTripleClickInTables(event);
            if (!this.props.eventHandlers?.onUnhandledClick) return;
            if (!(targetElement instanceof window.Element)) return;
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const rendererWrapper = event.currentTarget;
            // Check if the click was on an interactive element
            const isInteractiveElementInTree = (0, $K5Jsy.findInTree)(targetElement, rendererWrapper, (0, $TPpI8.isInteractiveElement));
            if (isInteractiveElementInTree) return;
            // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
            // This logic originated in jira-frontend:
            // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
            // The selection is required to be checked in `onMouseDown` and here. If not here, a new
            // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
            // return an empty selection, which will erroneously fire onUnhandledClick.
            const windowSelection = window.getSelection();
            const selection = windowSelection !== null ? windowSelection.toString() : undefined;
            const hasSelection = selection && selection.length !== 0;
            const hasSelectionMouseDown = this.mouseDownSelection && this.mouseDownSelection.length !== 0;
            const allowEditBasedOnSelection = !hasSelection && !hasSelectionMouseDown;
            if (allowEditBasedOnSelection) this.props.eventHandlers.onUnhandledClick(event);
        };
        try {
            const schema = this.getSchema(this.props.schema, this.props.adfStage);
            const { result: result, stat: stat, pmDoc: pmDoc } = (0, $12yAL.renderDocument)(adfDocument, this.serializer, schema, adfStage, this.props.useSpecBasedValidator, this.id, this.fireAnalyticsEvent, this.props.unsupportedContentLevelsTracking, this.props.appearance, this.props.includeNodesCountInStats, skipValidation);
            if (onComplete) onComplete(stat);
            const rendererOutput = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dyURG.RendererContextProvider), {
                value: rendererContext
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1pTqN.ActiveHeaderIdProvider), {
                value: (0, $3kKuL.getActiveHeadingId)(allowHeadingAnchorLinks)
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $TM1uy.default).Provider, {
                value: {
                    fireAnalyticsEvent: (event)=>this.fireAnalyticsEvent(event)
                }
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4BsEy.Provider), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9S8fM.ProviderFactoryProvider), {
                value: this.providerFactory
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererWrapper, {
                allowAnnotations: allowAnnotations,
                appearance: appearance,
                allowNestedHeaderLinks: allowNestedHeaderLinks,
                allowColumnSorting: allowColumnSorting,
                allowCopyToClipboard: allowCopyToClipboard,
                allowWrapCodeBlock: allowWrapCodeBlock,
                allowCustomPanels: allowCustomPanels,
                allowPlaceholderText: allowPlaceholderText,
                useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
                addTelepointer: this.props.addTelepointer,
                innerRef: this.editorRef,
                onClick: handleWrapperOnClick,
                onMouseDown: this.onMouseDownEditView,
                ssr: media?.ssr,
                isInsideOfInlineExtension: this.props.isInsideOfInlineExtension,
                isTopLevelRenderer: rendererContext.isTopLevelRenderer
            }, enableSsrInlineScripts || noOpSSRInlineScript ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUVor.BreakoutSSRInlineScript), {
                noOpSSRInlineScript: Boolean(noOpSSRInlineScript)
            }) : null, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererActionsInternalUpdater, {
                doc: pmDoc,
                schema: schema,
                onAnalyticsEvent: this.fireAnalyticsEvent
            }, result)))))));
            const rendererResult = truncated ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3lRy2.TruncatedWrapper), {
                height: maxHeight,
                fadeHeight: fadeOutHeight
            }, rendererOutput) : rendererOutput;
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, rendererResult);
        } catch (e) {
            if (onError) onError(e);
            return /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererWrapper, {
                allowAnnotations: allowAnnotations,
                appearance: appearance,
                allowCopyToClipboard: allowCopyToClipboard,
                allowWrapCodeBlock: allowWrapCodeBlock,
                allowPlaceholderText: allowPlaceholderText,
                allowColumnSorting: allowColumnSorting,
                allowNestedHeaderLinks: allowNestedHeaderLinks,
                useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
                addTelepointer: this.props.addTelepointer,
                onClick: handleWrapperOnClick,
                isTopLevelRenderer: rendererContext.isTopLevelRenderer
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iiXGq.default), null));
        }
    }
    componentWillUnmount() {
        const { dataProviders: dataProviders } = this.props;
        if (this.rafID) window.cancelAnimationFrame(this.rafID);
        // if this is the ProviderFactory which was created in constructor
        // it's safe to destroy it on Renderer unmount
        if (!dataProviders) this.providerFactory.destroy();
    }
}
const $3de1eca32602d427$var$handleMouseTripleClickInTables = (event)=>{
    if ((0, $gE8f9.browser).ios || (0, $gE8f9.browser).android) return;
    const badBrowser = (0, $gE8f9.browser).chrome || (0, $gE8f9.browser).safari;
    const tripleClick = event.detail >= 3;
    if (!(badBrowser && tripleClick)) return;
    const selection = window.getSelection();
    if (!selection) return;
    const { type: type, anchorNode: anchorNode, focusNode: focusNode } = selection;
    const rangeSelection = Boolean(type === 'Range' && anchorNode && focusNode);
    if (!rangeSelection) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const tableCell = target.closest('td,th');
    const clickedInCell = Boolean(tableCell);
    if (!clickedInCell) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const anchorInCell = tableCell.contains(anchorNode);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const focusInCell = tableCell.contains(focusNode);
    const selectionStartsOrEndsOutsideClickedCell = !(anchorInCell && focusInCell);
    if (!selectionStartsOrEndsOutsideClickedCell) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const elementToSelect = anchorInCell ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    anchorNode.parentElement?.closest('div,p') : focusInCell ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    focusNode.parentElement?.closest('div,p') : tableCell;
    if (elementToSelect) selection.selectAllChildren(elementToSelect);
};
/**
 * Handle clicks inside renderer. If the click isn't on media, in the media picker, or on a
 * link, call the onUnhandledClick eventHandler (which in Jira for example, may switch the
 * renderer out for the editor).
 * @param event Click event anywhere inside renderer
 */ const $3de1eca32602d427$var$handleWrapperOnClick = (event, props, mouseDownSelection)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const targetElement = event.target;
    $3de1eca32602d427$var$handleMouseTripleClickInTables(event);
    // ED-14862: When a user triple clicks to select a line of content inside a
    // a table cell, but the browser incorrectly moves the selection start or end into
    // a different table cell, we manually set the selection back to within the original
    // table cell the user intended to target
    if (!props.eventHandlers?.onUnhandledClick) return;
    if (!(targetElement instanceof window.Element)) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const rendererWrapper = event.currentTarget;
    const isInteractiveElementInTree = (0, $K5Jsy.findInTree)(targetElement, rendererWrapper, (0, $TPpI8.isInteractiveElement));
    if (isInteractiveElementInTree) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const windowSelection = window.getSelection();
    const selection = windowSelection !== null ? windowSelection.toString() : undefined;
    const hasSelection = selection && selection.length !== 0;
    const hasSelectionMouseDown = mouseDownSelection.current && mouseDownSelection.current.length !== 0;
    const allowEditBasedOnSelection = !hasSelection && !hasSelectionMouseDown;
    if (allowEditBasedOnSelection) props.eventHandlers.onUnhandledClick(event);
};
const $3de1eca32602d427$var$RendererFunctionalComponent = (props)=>{
    const mouseDownSelection = (0, $5uXOq.useRef)(undefined);
    const providerFactory = (0, $5uXOq.useMemo)(()=>props.dataProviders || new (0, $dGzaM.default)(), [
        props.dataProviders
    ]);
    const createRendererContext = (0, $5uXOq.useMemo)(()=>(featureFlags, isTopLevelRenderer)=>{
            const normalizedFeatureFlags = (0, $4zXba.normalizeFeatureFlags)(featureFlags);
            return {
                featureFlags: normalizedFeatureFlags,
                isTopLevelRenderer: isTopLevelRenderer === undefined
            };
        }, []);
    const fireAnalyticsEvent = (0, $5uXOq.useCallback)((event)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = props;
        if (createAnalyticsEvent) {
            const channel = (0, $dWAZk.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        props
    ]);
    const deriveSerializerProps = (0, $5uXOq.useCallback)((props)=>{
        const stickyHeaders = props.stickyHeaders ? props.stickyHeaders === true ? {} : props.stickyHeaders : undefined;
        const { annotationProvider: annotationProvider } = props;
        const allowAnnotationsDraftMode = Boolean(annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.allowDraftMode);
        const { featureFlags: featureFlags } = createRendererContext(props.featureFlags, props.isTopLevelRenderer);
        return {
            startPos: props.startPos,
            providers: providerFactory,
            eventHandlers: props.eventHandlers,
            extensionHandlers: props.extensionHandlers,
            portal: props.portal,
            objectContext: {
                adDoc: props.document,
                schema: props.schema,
                ...props.rendererContext
            },
            appearance: props.appearance,
            disableHeadingIDs: props.disableHeadingIDs,
            disableActions: props.disableActions,
            allowHeadingAnchorLinks: props.allowHeadingAnchorLinks,
            allowColumnSorting: props.allowColumnSorting,
            fireAnalyticsEvent: fireAnalyticsEvent,
            shouldOpenMediaViewer: props.shouldOpenMediaViewer,
            allowAltTextOnImages: props.allowAltTextOnImages,
            stickyHeaders: stickyHeaders,
            allowMediaLinking: props.media && props.media.allowLinking,
            surroundTextNodesWithTextWrapper: allowAnnotationsDraftMode,
            media: props.media,
            emojiResourceConfig: props.emojiResourceConfig,
            smartLinks: props.smartLinks,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowAnnotations: props.allowAnnotations,
            allowSelectAllTrap: props.allowSelectAllTrap,
            allowPlaceholderText: props.allowPlaceholderText,
            nodeComponents: props.nodeComponents,
            allowWindowedCodeBlock: featureFlags?.allowWindowedCodeBlock,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            textHighlighter: props.UNSTABLE_textHighlighter,
            allowTableAlignment: props.UNSTABLE_allowTableAlignment,
            allowTableResizing: props.UNSTABLE_allowTableResizing
        };
    }, [
        createRendererContext,
        providerFactory,
        fireAnalyticsEvent
    ]);
    const serializer = (0, $5uXOq.useMemo)(()=>new (0, $9gOVJ.default)(deriveSerializerProps({
            ...props,
            startPos: props.startPos ?? 0
        })), [
        deriveSerializerProps,
        props
    ]);
    const localRef = (0, $5uXOq.useRef)(null);
    const editorRef = props.innerRef || localRef;
    const id = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))(), []);
    const renderedMeasurementDistortedDurationMonitor = (0, $5uXOq.useMemo)(()=>(0, $ap7h6.getDistortedDurationMonitor)(), []);
    // we are doing this to ensure it runs as
    // early as possible in the React lifecycle
    // to avoid any other side effects
    const measureStarted = (0, $5uXOq.useRef)(false);
    const startAnalyticsMeasure = ()=>{
        (0, $iN9lO.startMeasure)(`Renderer Render Time: ${id}`);
    };
    if (!measureStarted.current) {
        startAnalyticsMeasure();
        measureStarted.current = true;
    }
    const anchorLinkAnalytics = (0, $5uXOq.useCallback)(()=>{
        const hash = window.location.hash && decodeURIComponent(window.location.hash.slice(1));
        const disableHeadingIDs = props.disableHeadingIDs;
        if (!disableHeadingIDs && hash && editorRef && editorRef.current instanceof HTMLElement) {
            const anchorLinkElement = document.getElementById(hash);
            if (anchorLinkElement && editorRef.current.contains(anchorLinkElement)) fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).VIEWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANCHOR_LINK,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB,
                    mode: (0, $knXBU.MODE).RENDERER
                },
                eventType: (0, $gkwXh.EVENT_TYPE).UI
            });
        }
    }, [
        props.disableHeadingIDs,
        editorRef,
        fireAnalyticsEvent
    ]);
    const getSchema = (0, $5uXOq.useMemo)(()=>{
        return (schema, adfStage)=>{
            if (schema) return schema;
            return (0, $kOFhM.getSchemaBasedOnStage)(adfStage);
        };
    }, []);
    const onMouseDownEditView = ()=>{
        const windowSelection = window.getSelection();
        mouseDownSelection.current = windowSelection !== null ? windowSelection.toString() : undefined;
    };
    const { dataProviders: dataProviders, analyticsEventSeverityTracking: analyticsEventSeverityTracking } = props;
    (0, $5uXOq.useEffect)(()=>{
        let rafID;
        const handleAnalytics = ()=>{
            fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).STARTED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB
                },
                eventType: (0, $gkwXh.EVENT_TYPE).UI
            });
            rafID = requestAnimationFrame(()=>{
                (0, $iN9lO.stopMeasure)(`Renderer Render Time: ${id}`, (duration)=>{
                    const forceSeverityTracking = typeof analyticsEventSeverityTracking === 'undefined' && (0, $fc6h8.shouldForceTracking)();
                    const severity = !!forceSeverityTracking || analyticsEventSeverityTracking?.enabled ? (0, $4NUlu.getAnalyticsEventSeverity)(duration, analyticsEventSeverityTracking?.severityNormalThreshold ?? $3de1eca32602d427$export$47b2879ca9bbf67a, analyticsEventSeverityTracking?.severityDegradedThreshold ?? $3de1eca32602d427$export$1b622068be977101) : undefined;
                    const isTTRTrackingExplicitlyDisabled = analyticsEventSeverityTracking?.enabled === false;
                    if (!isTTRTrackingExplicitlyDisabled) fireAnalyticsEvent({
                        action: (0, $gkwXh.ACTION).RENDERED,
                        actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
                        attributes: {
                            platform: (0, $knXBU.PLATFORM).WEB,
                            duration: duration,
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            distortedDuration: renderedMeasurementDistortedDurationMonitor.distortedDuration,
                            ttfb: (0, $kFiBa.getResponseEndTime)(),
                            nodes: (0, $kgV4b.countNodes)(props.document),
                            severity: severity
                        },
                        eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
                    });
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    renderedMeasurementDistortedDurationMonitor.cleanup();
                });
                anchorLinkAnalytics();
            });
        };
        handleAnalytics();
        return ()=>{
            if (rafID) window.cancelAnimationFrame(rafID);
            if (dataProviders) providerFactory.destroy();
        };
    // we are going to ignore this because I'm doing this on purpose
    // having a dependency array means we run stopMeasure twice per render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    try {
        const schema = getSchema(props.schema, props.adfStage);
        const { result: result, stat: stat, pmDoc: pmDoc } = (0, $12yAL.renderDocument)(props.document, serializer, schema, props.adfStage, props.useSpecBasedValidator, id, fireAnalyticsEvent, props.unsupportedContentLevelsTracking, props.appearance, props.includeNodesCountInStats, props.skipValidation);
        if (props.onComplete) props.onComplete(stat);
        const rendererOutput = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dyURG.RendererContextProvider), {
            value: createRendererContext(props.featureFlags, props.isTopLevelRenderer)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1pTqN.ActiveHeaderIdProvider), {
            value: (0, $3kKuL.getActiveHeadingId)(props.allowHeadingAnchorLinks)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $TM1uy.default).Provider, {
            value: {
                fireAnalyticsEvent: (event)=>fireAnalyticsEvent(event)
            }
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4BsEy.Provider), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9S8fM.ProviderFactoryProvider), {
            value: providerFactory
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            allowNestedHeaderLinks: (0, $3kKuL.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            allowColumnSorting: props.allowColumnSorting,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowPlaceholderText: props.allowPlaceholderText,
            useBlockRenderForCodeBlock: createRendererContext(props.featureFlags, props.isTopLevelRenderer).featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            innerRef: editorRef,
            onClick: (event)=>$3de1eca32602d427$var$handleWrapperOnClick(event, props, mouseDownSelection),
            onMouseDown: onMouseDownEditView,
            ssr: props.media?.ssr,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isTopLevelRenderer: createRendererContext(props.featureFlags, props.isTopLevelRenderer).isTopLevelRenderer
        }, props.enableSsrInlineScripts || props.noOpSSRInlineScript ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUVor.BreakoutSSRInlineScript), {
            noOpSSRInlineScript: Boolean(props.noOpSSRInlineScript)
        }) : null, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererActionsInternalUpdater, {
            doc: pmDoc,
            schema: schema,
            onAnalyticsEvent: fireAnalyticsEvent
        }, result)))))));
        const rendererResult = props.truncated ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3lRy2.TruncatedWrapper), {
            height: props.maxHeight,
            fadeHeight: props.fadeOutHeight
        }, rendererOutput) : rendererOutput;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, rendererResult);
    } catch (e) {
        if (props.onError) props.onError(e);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowPlaceholderText: props.allowPlaceholderText,
            allowColumnSorting: props.allowColumnSorting,
            allowNestedHeaderLinks: (0, $3kKuL.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            useBlockRenderForCodeBlock: createRendererContext(props.featureFlags, props.isTopLevelRenderer).featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            onClick: (event)=>$3de1eca32602d427$var$handleWrapperOnClick(event, props, mouseDownSelection),
            isTopLevelRenderer: createRendererContext(props.featureFlags, props.isTopLevelRenderer).isTopLevelRenderer
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iiXGq.default), null));
    }
};
function $3de1eca32602d427$export$88530751e3977073(props) {
    const { startPos: startPos } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $4YrGg.AnnotationsPositionContext));
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $dyURG.useRendererContext)();
    return (0, $VSDnB.fg)('platform_editor_react18_renderer') ? /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererFunctionalComponent, {
        ...props,
        startPos: startPos,
        isTopLevelRenderer: isTopLevelRenderer
    }) : // eslint-disable-next-line react/jsx-pascal-case
    /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$export$5161b00bb85c4267, {
        ...props,
        startPos: startPos,
        isTopLevelRenderer: isTopLevelRenderer
    });
}
const $3de1eca32602d427$export$af81ffb59b6ef0dd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1PVpv.FabricEditorAnalyticsContext), {
        data: {
            appearance: (0, $4NUlu.getAnalyticsAppearance)(props.appearance),
            packageName: $3de1eca32602d427$var$packageName,
            packageVersion: $3de1eca32602d427$var$packageVersion,
            componentName: 'renderer',
            editorSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))()
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2DpUZ.WithCreateAnalyticsEvent), {
        render: (createAnalyticsEvent)=>{
            // `IntlErrorBoundary` only captures Internationalisation errors, leaving others for `ErrorBoundary`.
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8Eu7T.ErrorBoundary), {
                component: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
                rethrowError: true,
                fallbackComponent: null,
                createAnalyticsEvent: createAnalyticsEvent
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fIJEx.IntlErrorBoundary), null, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$export$88530751e3977073, {
                ...props,
                createAnalyticsEvent: createAnalyticsEvent
            })));
        }
    })));
const $3de1eca32602d427$var$RendererWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const { allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks, innerRef: innerRef, appearance: appearance, children: children, onClick: onClick, onMouseDown: onMouseDown, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, addTelepointer: addTelepointer, ssr: ssr, isInsideOfInlineExtension: isInsideOfInlineExtension, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer } = props;
    const createTelepointer = ()=>{
        const telepointer = document.createElement('span');
        telepointer.textContent = '\u200b';
        telepointer.id = (0, $OxITw.TELEPOINTER_ID);
        return telepointer;
    };
    const initialUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(true);
    (0, $5uXOq.useEffect)(()=>{
        // We must check if window is defined, if it isn't we are in a SSR environment
        // and we don't want to add the telepointer
        if (typeof window !== 'undefined' && addTelepointer && innerRef?.current) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const renderer = innerRef.current.querySelector('.ak-renderer-document');
            if (initialUpdate.current) {
                const lastChild = renderer.lastChild;
                lastChild && lastChild.appendChild(createTelepointer());
            }
            const mutateTelepointer = (mutations)=>{
                mutations.forEach((mutation)=>{
                    if (initialUpdate.current) {
                        const oldTelepointer = renderer.querySelector(`#${(0, $OxITw.TELEPOINTER_ID)}`);
                        if (oldTelepointer) oldTelepointer.remove();
                        const lastChild = renderer.lastChild;
                        lastChild && lastChild.appendChild(createTelepointer());
                        initialUpdate.current = false;
                    }
                    if (mutation.type === 'characterData') {
                        const parentNode = mutation.target.parentElement;
                        if (parentNode) {
                            const oldTelepointer = renderer.querySelector(`#${(0, $OxITw.TELEPOINTER_ID)}`);
                            if (oldTelepointer) oldTelepointer.remove();
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            parentNode.appendChild(createTelepointer());
                        }
                    }
                });
            };
            const observer = new MutationObserver(mutateTelepointer);
            observer.observe(innerRef.current, {
                characterData: true,
                attributes: false,
                childList: true,
                subtree: true
            });
            return ()=>observer.disconnect();
        }
    }, [
        innerRef,
        addTelepointer
    ]);
    const renderer = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthProvider), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `ak-renderer-wrapper is-${appearance}`,
        "data-appearance": appearance,
        shouldCheckExistingValue: isInsideOfInlineExtension
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9Iju4.BaseTheme), {
        baseFontSize: appearance && appearance !== 'comment' ? (0, $iHYdz.akEditorFullPageDefaultFontSize) : undefined
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1urn6.EditorMediaClientProvider), {
        ssr: ssr
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $OxITw.rendererStyles)({
            appearance: appearance,
            allowNestedHeaderLinks: allowNestedHeaderLinks,
            allowColumnSorting: !!allowColumnSorting,
            useBlockRenderForCodeBlock: useBlockRenderForCodeBlock,
            allowAnnotations: props.allowAnnotations,
            allowTableResizing: allowTableResizing
        })
    }, children))));
    // We can only make the wrapper div query container when we have a known width.
    // This is also required for SSR to work correctly. As WidthProvider/WithConsumer will not have the correct width during SSR.
    //
    // We are setting this wrapper div as query container conditionally.
    // Only apply container-type = inline-size when having a known width in full-page/full-width/comment mode.
    // Otherwise when appearance is unspecified the renderer size is decided by the content.
    // In this case we can't set the container-type = inline-size as it will collapse width to 0.
    return (appearance === 'full-page' || appearance === 'full-width' || appearance === 'comment') && // In case of having excerpt-include on page there are multiple renderers nested.
    // Make sure only the root renderer is set to be query container.
    isTopLevelRenderer && (0, $VSDnB.fg)('platform-fix-table-ssr-resizing') ? /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $3de1eca32602d427$var$setAsQueryContainerStyles
    }, renderer) : renderer;
});
const $3de1eca32602d427$var$RootRendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(null);
function $3de1eca32602d427$var$RendererActionsInternalUpdater({ children: children, doc: doc, schema: schema, onAnalyticsEvent: onAnalyticsEvent }) {
    const rootRendererContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($3de1eca32602d427$var$RootRendererContext);
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const rendererRef = (0, $5uXOq.useRef)(null);
    // This doc is used by the renderer actions when applying comments to the document.
    // (via hand crafted steps based on non prosemirror based position calculations)
    // It is set to the root renderer's doc as otherwise the resulting document will
    // be incorrect (nested renderers use a fake document which represents a subset
    // of the actual document).
    let _doc;
    if ((0, $gmhCD.editorExperiment)('comment_on_bodied_extensions', true) && rootRendererContextValue) // If rootRendererContextValue is set -- we are inside a nested renderer
    // and should always use the doc from the root renderer
    _doc = rootRendererContextValue.doc;
    else // If rootRendererContextValue is not set -- we are in the root renderer
    // and set the doc to the current doc.
    _doc = doc;
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (_doc) actions._privateRegisterRenderer(rendererRef, _doc, schema, onAnalyticsEvent);
        else actions._privateUnregisterRenderer();
        return ()=>actions._privateUnregisterRenderer();
    }, [
        actions,
        schema,
        _doc,
        onAnalyticsEvent
    ]);
    if ((0, $gmhCD.editorExperiment)('comment_on_bodied_extensions', true)) return /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RootRendererContext.Provider, {
        value: {
            doc: _doc
        }
    }, children);
    return children;
}
// Usage notes:
// Used by Confluence for nested renderers
// For the View page renderer - see RendererWithAnalytics
const $3de1eca32602d427$var$RendererWithAnnotationSelection = (props)=>{
    const { allowAnnotations: allowAnnotations, document: adfDocument } = props;
    const localRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const innerRef = props.innerRef || localRef;
    if (!allowAnnotations) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fCNtA.RendererActionsContext), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4YrGg.AnnotationsWrapper), {
        rendererRef: innerRef,
        adfDocument: adfDocument,
        annotationProvider: props.annotationProvider,
        isNestedRender: true
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props,
        featureFlags: props.featureFlags
    })));
};
var // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/* @deprecated using this version of the renderer causes the RendererActions to inaccessible from any consumers */ $3de1eca32602d427$export$2e2bcd8739ae039 = $3de1eca32602d427$var$RendererWithAnnotationSelection;

});
parcelRegister("dGzaM", function(module, exports) {

$parcel$export(module.exports, "default", () => $586c606cb83743fd$export$2e2bcd8739ae039);
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $586c606cb83743fd$var$isUndefined(x) {
    return x === undefined;
}
class $586c606cb83743fd$export$2e2bcd8739ae039 {
    static create(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    providers) {
        const providerFactory = new $586c606cb83743fd$export$2e2bcd8739ae039();
        const keys = Object.keys(providers);
        keys.forEach((name)=>{
            providerFactory.setProvider(name, providers[name]);
        });
        return providerFactory;
    }
    destroy() {
        this.providers.clear();
        this.subscribers.clear();
    }
    isEmpty() {
        return !this.providers.size && !this.subscribers.size;
    }
    setProvider(name, provider) {
        // Do not trigger notifyUpdate if provider is the same.
        if (this.providers.get(name) === provider) return;
        if (!$586c606cb83743fd$var$isUndefined(provider)) this.providers.set(name, provider);
        else this.providers.delete(name);
        this.notifyUpdated(name, provider);
    }
    removeProvider(name) {
        this.providers.delete(name);
        this.notifyUpdated(name);
    }
    subscribe(name, handler) {
        const handlers = this.subscribers.get(name) || [];
        handlers.push(handler);
        this.subscribers.set(name, handlers);
        const provider = this.providers.get(name);
        if (provider) handler(name, provider);
        return provider;
    }
    unsubscribe(name, handler) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        const index = handlers.indexOf(handler);
        if (index !== -1) handlers.splice(index, 1);
        if (handlers.length === 0) this.subscribers.delete(name);
        else this.subscribers.set(name, handlers);
    }
    unsubscribeAll(name) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        this.subscribers.delete(name);
    }
    hasProvider(name) {
        return this.providers.has(name);
    }
    notifyUpdated(name, provider) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        handlers.forEach((handler)=>{
            handler(name, provider);
        });
    }
    constructor(){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.providers = new Map();
        this.subscribers = new Map();
    }
}

});

parcelRegister("9S8fM", function(module, exports) {

$parcel$export(module.exports, "ProviderFactoryProvider", () => $d1ee541d73df1fcd$export$617c134b25cc4265);
$parcel$export(module.exports, "useProvider", () => $d1ee541d73df1fcd$export$693cdb10cec23617);

var $5uXOq = parcelRequire("5uXOq");

var $dGzaM = parcelRequire("dGzaM");
const $d1ee541d73df1fcd$var$ProviderFactoryContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(new (0, $dGzaM.default)());
const $d1ee541d73df1fcd$export$617c134b25cc4265 = $d1ee541d73df1fcd$var$ProviderFactoryContext.Provider;
const $d1ee541d73df1fcd$export$a3af4b6980aa23b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($d1ee541d73df1fcd$var$ProviderFactoryContext);
const $d1ee541d73df1fcd$export$693cdb10cec23617 = (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState();
    const providerFactory = $d1ee541d73df1fcd$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        const providerHandler = (_, provider)=>{
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};

});

parcelRegister("9Iju4", function(module, exports) {

$parcel$export(module.exports, "mapBreakpointToLayoutMaxWidth", () => $b0fd15d81ba0fb5a$export$b5ccf4d25d2c5af1);
$parcel$export(module.exports, "BaseTheme", () => $b0fd15d81ba0fb5a$export$a1a213d350ca51ca);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $g0wej = parcelRequire("g0wej");

var $iHYdz = parcelRequire("iHYdz");

var $4ceoy = parcelRequire("4ceoy");
function $b0fd15d81ba0fb5a$export$b5ccf4d25d2c5af1(breakpoint) {
    switch(breakpoint){
        case 'M':
        case 'L':
            return 760;
        default:
            return 680;
    }
}
function $b0fd15d81ba0fb5a$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $5uXOq.useMemo)(()=>({
            baseFontSize: baseFontSize || 14,
            layoutMaxWidth: (0, $iHYdz.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g0wej.a), {
        theme: memoizedTheme,
        children: children
    });
}
function $b0fd15d81ba0fb5a$export$a1a213d350ca51ca({ children: children, baseFontSize: baseFontSize }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ceoy.WidthConsumer), {
        children: ({ breakpoint: breakpoint })=>/*#__PURE__*/ (0, $2OMIu.jsx)($b0fd15d81ba0fb5a$export$3de34996b814f0f0, {
                breakpoint: breakpoint,
                baseFontSize: baseFontSize,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: children
                })
            })
    });
}

});
parcelRegister("iHYdz", function(module, exports) {

$parcel$export(module.exports, "akEditorFullPageDefaultFontSize", () => $01f0a5ace820da37$export$fe6b0b821a0e9067);
$parcel$export(module.exports, "akEditorCodeFontFamily", () => $01f0a5ace820da37$export$9a7c520c39e1f0aa);
$parcel$export(module.exports, "akEditorSubtleAccent", () => $01f0a5ace820da37$export$1d762aef048d30f9);
$parcel$export(module.exports, "akEditorBlockquoteBorderColor", () => $01f0a5ace820da37$export$a7a75e50ae62d0a8);
$parcel$export(module.exports, "akEditorDeleteBackground", () => $01f0a5ace820da37$export$ef95eb6ef0fd0a4a);
$parcel$export(module.exports, "akEditorDeleteBackgroundWithOpacity", () => $01f0a5ace820da37$export$8f7d2d784079e274);
$parcel$export(module.exports, "akEditorDeleteBorder", () => $01f0a5ace820da37$export$3c108a6bc41bb5f2);
$parcel$export(module.exports, "akEditorDeleteIconColor", () => $01f0a5ace820da37$export$bf3aaa2106c119fd);
$parcel$export(module.exports, "akEditorCustomIconSize", () => $01f0a5ace820da37$export$d2715266dd4a1fd1);
$parcel$export(module.exports, "akEditorSelectedBorderColor", () => $01f0a5ace820da37$export$cf524c1b49838a49);
$parcel$export(module.exports, "akEditorSelectedBorderSize", () => $01f0a5ace820da37$export$8dac549e32469ac4);
$parcel$export(module.exports, "akEditorSelectedBorderBoldSize", () => $01f0a5ace820da37$export$befaaae517e3d864);
$parcel$export(module.exports, "akEditorSelectedBorder", () => $01f0a5ace820da37$export$6e1e1996c4e8cc51);
$parcel$export(module.exports, "akEditorSelectedBoxShadow", () => $01f0a5ace820da37$export$b6a59ac3a19b6343);
$parcel$export(module.exports, "akEditorSelectedBoldBoxShadow", () => $01f0a5ace820da37$export$37e178ca41c198ca);
$parcel$export(module.exports, "akEditorUnitZIndex", () => $01f0a5ace820da37$export$f35cc48f3398ab79);
$parcel$export(module.exports, "akEditorShadowZIndex", () => $01f0a5ace820da37$export$b46cda584c619451);
$parcel$export(module.exports, "akEditorStickyHeaderZIndex", () => $01f0a5ace820da37$export$6bed85de54b5de42);
$parcel$export(module.exports, "akEditorSmallZIndex", () => $01f0a5ace820da37$export$321ddd2f049dd12);
$parcel$export(module.exports, "akEditorGridLineZIndex", () => $01f0a5ace820da37$export$daeac9b8422ac3c2);
$parcel$export(module.exports, "akEditorMenuZIndex", () => $01f0a5ace820da37$export$501d46e11ed5bf73);
$parcel$export(module.exports, "akEditorFloatingPanelZIndex", () => $01f0a5ace820da37$export$6817b4b6a5ef78f1);
$parcel$export(module.exports, "akEditorFloatingDialogZIndex", () => $01f0a5ace820da37$export$93768eb72dec48ce);
$parcel$export(module.exports, "akEditorTableCellOnStickyHeaderZIndex", () => $01f0a5ace820da37$export$c0aec4e0896849a0);
$parcel$export(module.exports, "akEditorFloatingOverlapPanelZIndex", () => $01f0a5ace820da37$export$5886f057e4f21fe4);
$parcel$export(module.exports, "akEditorTableToolbarSize", () => $01f0a5ace820da37$export$6e85faa46d537a3f);
$parcel$export(module.exports, "akEditorTableBorder", () => $01f0a5ace820da37$export$36ba77fba4a62d5f);
$parcel$export(module.exports, "akEditorTableToolbar", () => $01f0a5ace820da37$export$640eef769748f78f);
$parcel$export(module.exports, "akEditorTableHeaderCellBackground", () => $01f0a5ace820da37$export$4c6f61fb4b9ae93);
$parcel$export(module.exports, "akEditorTableBorderSelected", () => $01f0a5ace820da37$export$f7bbcec54ff5bc47);
$parcel$export(module.exports, "akEditorFullPageMaxWidth", () => $01f0a5ace820da37$export$fad19f16d3f953a3);
$parcel$export(module.exports, "akEditorDefaultLayoutWidth", () => $01f0a5ace820da37$export$9db045950eedb49f);
$parcel$export(module.exports, "akEditorWideLayoutWidth", () => $01f0a5ace820da37$export$74c442132af16a);
$parcel$export(module.exports, "akEditorFullWidthLayoutWidth", () => $01f0a5ace820da37$export$f580e3d28d0986de);
$parcel$export(module.exports, "akEditorTableNumberColumnWidth", () => $01f0a5ace820da37$export$37df10057d36a0e5);
$parcel$export(module.exports, "akEditorBreakoutPadding", () => $01f0a5ace820da37$export$437293c5e9fc2703);
$parcel$export(module.exports, "akEditorGutterPadding", () => $01f0a5ace820da37$export$6e0f4d52efd3d2d);
$parcel$export(module.exports, "akEditorGutterPaddingDynamic", () => $01f0a5ace820da37$export$f222e0c7a2dc5324);
$parcel$export(module.exports, "akEditorMobileBreakoutPoint", () => $01f0a5ace820da37$export$efe8561bbd3f74d2);
$parcel$export(module.exports, "akEditorTableCellMinWidth", () => $01f0a5ace820da37$export$e4d39a9e8607c1d3);
$parcel$export(module.exports, "akEditorTableLegacyCellMinWidth", () => $01f0a5ace820da37$export$43946f2400ab6f1f);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPaddingWide", () => $01f0a5ace820da37$export$558438ae7fd4b8ce);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPadding", () => $01f0a5ace820da37$export$6beb98d32d4ca149);
$parcel$export(module.exports, "akEditorSwoopCubicBezier", () => $01f0a5ace820da37$export$3b24948cd5dbb087);
$parcel$export(module.exports, "gridMediumMaxWidth", () => $01f0a5ace820da37$export$5edb4f38c3eacb1a);
$parcel$export(module.exports, "breakoutWideScaleRatio", () => $01f0a5ace820da37$export$e60820063058ed59);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidthSmallViewport", () => $01f0a5ace820da37$export$60da500206e2ceec);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidth", () => $01f0a5ace820da37$export$c0e6648ae1bb2fac);
$parcel$export(module.exports, "akRichMediaResizeZIndex", () => $01f0a5ace820da37$export$fb15fade89f67217);
$parcel$export(module.exports, "akLayoutGutterOffset", () => $01f0a5ace820da37$export$847030921e9d5a40);
$parcel$export(module.exports, "akEditorLineHeight", () => $01f0a5ace820da37$export$40eb41ab799f0329);
$parcel$export(module.exports, "akEditorToolbarKeylineHeight", () => $01f0a5ace820da37$export$d29cb2c31fcbb7c5);
$parcel$export(module.exports, "akEditorContextPanelWidth", () => $01f0a5ace820da37$export$688a6dc01e760755);
$parcel$export(module.exports, "akEditorTableCellBlanketSelected", () => $01f0a5ace820da37$export$e736f2caf3b39eb3);
$parcel$export(module.exports, "akEditorTableCellBlanketDeleted", () => $01f0a5ace820da37$export$de3cef07cda55645);
$parcel$export(module.exports, "akEditorWrappedNodeZIndex", () => $01f0a5ace820da37$export$e88f6c898960b391);
$parcel$export(module.exports, "blockNodesVerticalMargin", () => $01f0a5ace820da37$export$1d0d506416d457f1);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_WIDTH", () => $01f0a5ace820da37$export$e683ef42725d1713);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_HEIGHT", () => $01f0a5ace820da37$export$226c784ba04bd04b);
$parcel$export(module.exports, "MAX_BROWSER_SCROLLBAR_HEIGHT", () => $01f0a5ace820da37$export$214ff00e5618d86c);
$parcel$export(module.exports, "FULL_PAGE_EDITOR_TOOLBAR_HEIGHT", () => $01f0a5ace820da37$export$d7726a000ae2d7c);
$parcel$export(module.exports, "akEditorSelectedNodeClassName", () => $01f0a5ace820da37$export$a02a3f1515c2e21a);
$parcel$export(module.exports, "editorFontSize", () => $01f0a5ace820da37$export$58a725ff69bda73a);
$parcel$export(module.exports, "relativeFontSizeToBase16", () => $01f0a5ace820da37$export$59733a9f61449b25);
$parcel$export(module.exports, "akEditorMobileMaxWidth", () => $01f0a5ace820da37$export$9369fd010fa0ddd6);
$parcel$export(module.exports, "participantColors", () => $01f0a5ace820da37$export$42608c013398a830);

var $VSDnB = parcelRequire("VSDnB");
const $01f0a5ace820da37$export$fe6b0b821a0e9067 = 16;
const $01f0a5ace820da37$export$9a7c520c39e1f0aa = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $01f0a5ace820da37$export$1d762aef048d30f9 = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
const $01f0a5ace820da37$export$a7a75e50ae62d0a8 = "var(--ds-border, #091E4224)";
const $01f0a5ace820da37$export$b9864494c2608629 = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $01f0a5ace820da37$export$f0e953d95429ca1 = '12px';
const $01f0a5ace820da37$export$a309dbdeca0adb1a = '2px 4px';
const $01f0a5ace820da37$export$ef95eb6ef0fd0a4a = "var(--ds-background-danger, #FFECEB)";
const $01f0a5ace820da37$export$8f7d2d784079e274 = 'rgba(255, 189, 173, 0.5)'; // R75 with 50% opacity
const $01f0a5ace820da37$export$3c108a6bc41bb5f2 = "var(--ds-border-danger, #E2483D)";
const $01f0a5ace820da37$export$bf3aaa2106c119fd = "var(--ds-icon-danger, #C9372C)";
const $01f0a5ace820da37$export$d2715266dd4a1fd1 = 20;
const $01f0a5ace820da37$export$cf524c1b49838a49 = "var(--ds-border-selected, #0C66E4)";
const $01f0a5ace820da37$export$8dac549e32469ac4 = 1;
const $01f0a5ace820da37$export$befaaae517e3d864 = 2;
const $01f0a5ace820da37$export$6e1e1996c4e8cc51 = `${$01f0a5ace820da37$export$8dac549e32469ac4}px solid ${"var(--ds-border-selected, #0C66E4)"}`;
const $01f0a5ace820da37$export$b6a59ac3a19b6343 = `0 0 0 ${$01f0a5ace820da37$export$8dac549e32469ac4}px ${"var(--ds-border-selected, #0C66E4)"}`;
const $01f0a5ace820da37$export$37e178ca41c198ca = `0 0 0 ${$01f0a5ace820da37$export$befaaae517e3d864}px ${"var(--ds-border-selected, #0C66E4)"}`;
const $01f0a5ace820da37$export$4a007c22e25e31f6 = 0.3;
const $01f0a5ace820da37$export$f35cc48f3398ab79 = 1;
const $01f0a5ace820da37$export$b46cda584c619451 = 2;
const $01f0a5ace820da37$export$6bed85de54b5de42 = 11; // filmstrip uses 10 for its shadow
const $01f0a5ace820da37$export$321ddd2f049dd12 = $01f0a5ace820da37$export$6bed85de54b5de42 + 1;
const $01f0a5ace820da37$export$daeac9b8422ac3c2 = 2;
const $01f0a5ace820da37$export$501d46e11ed5bf73 = 500;
const $01f0a5ace820da37$export$6817b4b6a5ef78f1 = 400;
const $01f0a5ace820da37$export$93768eb72dec48ce = $01f0a5ace820da37$export$501d46e11ed5bf73 + 10;
const $01f0a5ace820da37$export$c0aec4e0896849a0 = $01f0a5ace820da37$export$93768eb72dec48ce - 5;
const $01f0a5ace820da37$export$5886f057e4f21fe4 = $01f0a5ace820da37$export$6817b4b6a5ef78f1 + 5;
const $01f0a5ace820da37$export$6e85faa46d537a3f = 11;
const $01f0a5ace820da37$export$36ba77fba4a62d5f = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
const $01f0a5ace820da37$export$640eef769748f78f = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $01f0a5ace820da37$export$4c6f61fb4b9ae93 = '#F1F2F4';
const $01f0a5ace820da37$export$95e9a0285b97474d = '#2C333A';
const $01f0a5ace820da37$export$f7bbcec54ff5bc47 = "var(--ds-border-focused, #388BFF)";
const $01f0a5ace820da37$export$76b5e653883e5290 = '3px';
const $01f0a5ace820da37$export$6d85fe8177a50c0c = 0.5;
const $01f0a5ace820da37$export$fad19f16d3f953a3 = 680;
const $01f0a5ace820da37$export$9db045950eedb49f = 760;
const $01f0a5ace820da37$export$74c442132af16a = 960; // This value is used for tables with breakouts and is used to calculate `breakoutWidthPx`
const $01f0a5ace820da37$export$f580e3d28d0986de = 1800;
const $01f0a5ace820da37$export$9d5488b5afad62bf = 1792;
const $01f0a5ace820da37$export$37df10057d36a0e5 = 42;
const $01f0a5ace820da37$export$437293c5e9fc2703 = 96;
const $01f0a5ace820da37$export$6e0f4d52efd3d2d = 32;
const $01f0a5ace820da37$export$f222e0c7a2dc5324 = ()=>(0, $VSDnB.fg)('platform_editor_core_increase_full_page_guttering') ? 52 : 32;
const $01f0a5ace820da37$export$efe8561bbd3f74d2 = 720;
const $01f0a5ace820da37$export$e4d39a9e8607c1d3 = 48;
const $01f0a5ace820da37$export$43946f2400ab6f1f = 128;
const $01f0a5ace820da37$export$558438ae7fd4b8ce = 12;
const $01f0a5ace820da37$export$6beb98d32d4ca149 = 4;
const $01f0a5ace820da37$export$3b24948cd5dbb087 = `cubic-bezier(0.15, 1, 0.3, 1)`;
const $01f0a5ace820da37$export$5edb4f38c3eacb1a = 1024;
const $01f0a5ace820da37$export$e60820063058ed59 = 1.33;
const $01f0a5ace820da37$export$60da500206e2ceec = 905; // from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
const $01f0a5ace820da37$export$c0e6648ae1bb2fac = 1011; // = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
const $01f0a5ace820da37$export$fb15fade89f67217 = $01f0a5ace820da37$export$f35cc48f3398ab79 * 99;
const $01f0a5ace820da37$export$847030921e9d5a40 = 12;
const $01f0a5ace820da37$export$40eb41ab799f0329 = 1.714;
const $01f0a5ace820da37$export$e271312fc7124aec = '1px';
const $01f0a5ace820da37$export$d29cb2c31fcbb7c5 = 2;
const $01f0a5ace820da37$export$688a6dc01e760755 = 320;
const $01f0a5ace820da37$export$e736f2caf3b39eb3 = 'rgba(179, 212, 255, 0.3)';
const $01f0a5ace820da37$export$de3cef07cda55645 = 'rgba(255, 235, 230, 0.3)';
const $01f0a5ace820da37$export$e88f6c898960b391 = $01f0a5ace820da37$export$f35cc48f3398ab79 * 2; //prevent paragraph nodes from rendering above wrapped nodes
const $01f0a5ace820da37$export$e5c605f2b2a12b00 = {
    SMALL: 550,
    MEDIUM: 760
};
const $01f0a5ace820da37$export$1d0d506416d457f1 = '0.75rem';
const $01f0a5ace820da37$export$e683ef42725d1713 = 680;
const $01f0a5ace820da37$export$226c784ba04bd04b = 480;
const $01f0a5ace820da37$export$214ff00e5618d86c = 20;
const $01f0a5ace820da37$export$c82675fa56f2eefd = '56px';
const $01f0a5ace820da37$var$DEFAULT_FONT_SIZE = 14;
const $01f0a5ace820da37$export$d7726a000ae2d7c = ()=>(0, $VSDnB.fg)('live_pages_content_jump_mitigation') ? '2.188rem' : "var(--ds-space-500, 40px)";
const $01f0a5ace820da37$export$a02a3f1515c2e21a = 'ak-editor-selected-node';
const $01f0a5ace820da37$export$58a725ff69bda73a = ({ theme: theme })=>theme && theme.baseFontSize ? theme.baseFontSize : $01f0a5ace820da37$var$DEFAULT_FONT_SIZE;
const $01f0a5ace820da37$export$945a9e125632354d = (multiplier)=>({ theme: theme })=>$01f0a5ace820da37$export$58a725ff69bda73a({
            theme: theme
        }) * multiplier;
const $01f0a5ace820da37$export$59733a9f61449b25 = (px)=>{
    if (typeof px === 'string') px = parseInt(px);
    if (isNaN(px)) throw new Error(`Invalid font size: '${px}'`);
    return `${px / 16}rem`;
};
const $01f0a5ace820da37$export$96b72b7f243fa693 = {
    laptopHiDPI: {
        width: 1440,
        height: 900
    },
    laptopMDPI: {
        width: 1280,
        height: 800
    },
    tabletL: {
        width: 1024,
        height: 1366
    },
    tabletS: {
        width: 768,
        height: 1024
    },
    mobileM: {
        width: 414,
        height: 736
    },
    mobileS: {
        width: 375,
        height: 667
    },
    mobileXS: {
        width: 320,
        height: 568
    }
};
const $01f0a5ace820da37$export$9369fd010fa0ddd6 = 0;
const $01f0a5ace820da37$export$846a716e9e69a8df = [
    [
        'White',
        '#000000'
    ],
    [
        'Light blue',
        '#0C294F'
    ],
    [
        'Light teal',
        '#0C343B'
    ],
    [
        'Light green',
        '#052E21'
    ],
    [
        'Light yellow',
        '#484123'
    ],
    [
        'Light red',
        '#441C13'
    ],
    [
        'Light purple',
        '#282249'
    ],
    [
        'Light gray',
        '#202328'
    ],
    [
        'Blue',
        '#0B3165'
    ],
    [
        'Teal',
        '#044853'
    ],
    [
        'Green',
        '#053927'
    ],
    [
        'Yellow',
        '#6F5C25'
    ],
    [
        'Red',
        '#582013'
    ],
    [
        'Purple',
        '#3E327B'
    ],
    [
        'Gray',
        '#475262'
    ],
    [
        'Dark blue',
        '#003884'
    ],
    [
        'Dark teal',
        '#055866'
    ],
    [
        'Dark green',
        '#044932'
    ],
    [
        'Dark yellow',
        '#82641C'
    ],
    [
        'Dark red',
        '#6B2A19'
    ],
    [
        'Dark purple',
        '#4D38B2'
    ]
].map(([colorName, colorValue])=>$01f0a5ace820da37$export$5f2dade43b841301(colorName, colorValue)).join('\n');
function $01f0a5ace820da37$export$5f2dade43b841301(colorName, colorValue) {
    return `
  &[colorname="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
  }
  `;
}
const $01f0a5ace820da37$export$312e1e71424c4aa1 = [
    "var(--ds-icon-accent-red, #C9372C)",
    "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    "var(--ds-icon-accent-magenta, #CD519D)",
    "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "var(--ds-icon-accent-orange, #E56910)",
    "var(--ds-background-accent-orange-bolder-hovered, #A54800)",
    "var(--ds-icon-accent-green, #22A06B)",
    "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    "var(--ds-icon-accent-blue, #1D7AFC)",
    "var(--ds-background-accent-blue-bolder-hovered, #0055CC)",
    "var(--ds-icon-accent-teal, #2898BD)",
    "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    "var(--ds-icon-accent-lime, #6A9A23)",
    "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    "var(--ds-icon-accent-purple, #8270DB)",
    "var(--ds-background-accent-purple-bolder-hovered, #5E4DB2)",
    "var(--ds-icon-accent-gray, #758195)",
    "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
    "var(--ds-icon-accent-yellow, #B38600)",
    "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    "var(--ds-background-accent-yellow-bolder-pressed, #533F04)"
];
const $01f0a5ace820da37$export$42608c013398a830 = [
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-blue-bolder, #0C66E4)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-purple-bolder, #6E5DC6)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-teal-bolder, #227D9B)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-lime-bolder, #5B7F24)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-gray-bolder, #626F86)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)"
    }
];

});

parcelRegister("4ceoy", function(module, exports) {

$parcel$export(module.exports, "getBreakpoint", () => $a2904bcfe480568e$export$1eb095b00b926404);
$parcel$export(module.exports, "createWidthContext", () => $a2904bcfe480568e$export$31a4966bffb9ac98);
$parcel$export(module.exports, "WidthContext", () => $a2904bcfe480568e$export$27e39f636459b9f);
$parcel$export(module.exports, "WidthConsumer", () => $a2904bcfe480568e$export$5d8538aa831b6ebb);
$parcel$export(module.exports, "WidthProvider", () => $a2904bcfe480568e$export$7921e18173e8c666);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8QpSo = parcelRequire("8QpSo");

var $7nRxN = parcelRequire("7nRxN");

var $gJlZe = parcelRequire("gJlZe");

var $1v3g5 = parcelRequire("1v3g5");
function $a2904bcfe480568e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a2904bcfe480568e$var$styles = {
    name: "pw7jst",
    styles: "position:relative;width:100%"
};
const $a2904bcfe480568e$var$SCROLLBAR_WIDTH = 30;
function $a2904bcfe480568e$export$1eb095b00b926404(width = 0) {
    const MAX_S = 1266;
    const MAX_M = 2146;
    if (width >= MAX_S && width < MAX_M) return 'M';
    else if (width >= MAX_M) return 'L';
    return 'S';
}
function $a2904bcfe480568e$export$31a4966bffb9ac98(width = 0) {
    return {
        width: width,
        breakpoint: $a2904bcfe480568e$export$1eb095b00b926404(width)
    };
}
const $a2904bcfe480568e$export$27e39f636459b9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($a2904bcfe480568e$export$31a4966bffb9ac98());
const { Provider: $a2904bcfe480568e$var$Provider, Consumer: $a2904bcfe480568e$export$5d8538aa831b6ebb } = $a2904bcfe480568e$export$27e39f636459b9f;
const $a2904bcfe480568e$export$df154c49e93b2ac2 = (0, $8QpSo.default)(()=>{
    return (0, $1v3g5.isSSR)() ? 0 : document.body?.offsetWidth ?? 0;
});
const $a2904bcfe480568e$export$7921e18173e8c666 = ({ className: className, shouldCheckExistingValue: shouldCheckExistingValue, children: children })=>{
    const existingContextValue = (0, $5uXOq.useContext)($a2904bcfe480568e$export$27e39f636459b9f);
    const [width, setWidth] = (0, $5uXOq.useState)($a2904bcfe480568e$export$df154c49e93b2ac2);
    const widthRef = (0, $5uXOq.useRef)(width);
    const isMountedRef = (0, $5uXOq.useRef)(true);
    const providerValue = (0, $5uXOq.useMemo)(()=>$a2904bcfe480568e$export$31a4966bffb9ac98(width), [
        width
    ]);
    const updateWidth = (0, $5uXOq.useMemo)(()=>{
        return (0, $7nRxN.default)((nextWidth)=>{
            const currentWidth = widthRef.current || 0;
            // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
            if (Math.abs(currentWidth - nextWidth) < $a2904bcfe480568e$var$SCROLLBAR_WIDTH) return;
            // Avoid React memory leak by checking if the component is still mounted
            if (!isMountedRef.current) return;
            setWidth(nextWidth);
        });
    }, []);
    const skipWidthDetection = shouldCheckExistingValue && existingContextValue.width > 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useLayoutEffect(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $a2904bcfe480568e$var$styles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, !skipWidthDetection && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gJlZe.WidthObserver), {
        setWidth: updateWidth,
        offscreen: true
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)($a2904bcfe480568e$var$Provider, {
        value: providerValue
    }, children)), skipWidthDetection && children);
};

});
parcelRegister("1v3g5", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $161da1f5bf80dbfb$export$48d7c418edadb60c);

var $6cAn5 = parcelRequire("6cAn5");
function $161da1f5bf80dbfb$export$48d7c418edadb60c() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        typeof $6cAn5 !== 'undefined' && undefined);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}

});



parcelRegister("fIJEx", function(module, exports) {

$parcel$export(module.exports, "IntlErrorBoundary", () => $f1eccfecc1c43fb5$export$7df0749115d18d19);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
const $f1eccfecc1c43fb5$export$c7ef921528e1d279 = '<IntlProvider> needs to exist in the component ancestry';
const $f1eccfecc1c43fb5$var$isMissingIntlProviderInAncestryError = (err)=>err?.toString()?.includes('<IntlProvider> needs to exist in the component ancestry');
class $f1eccfecc1c43fb5$export$7df0749115d18d19 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch(error, errorInfo) {
        // if missing IntlProvider in ancestry, we setup a fallback IntlProvider ourselves
        if ($f1eccfecc1c43fb5$var$isMissingIntlProviderInAncestryError(error)) this.setState({
            missingIntlProviderInAncestry: true
        });
        else // else we re-propagate the non-react-intl-next error
        throw error;
    }
    render() {
        if (this.state.missingIntlProviderInAncestry) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
            locale: "en",
            children: this.props.children
        });
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            missingIntlProviderInAncestry: false
        };
    }
}

});

parcelRegister("iiXGq", function(module, exports) {

$parcel$export(module.exports, "default", () => $94120525d10931b9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $iHYdz = parcelRequire("iHYdz");

var $eJS47 = parcelRequire("eJS47");

var $3bDjY = parcelRequire("3bDjY");

var $gkwXh = parcelRequire("gkwXh");

var $7R1zM = parcelRequire("7R1zM");

var $d54NZ = parcelRequire("d54NZ");

var $9tFGn = parcelRequire("9tFGn");
const $94120525d10931b9$var$blockNodeStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    background: "var(--ds-background-disabled, #091E4208)",
    border: `1px dashed ${"var(--ds-border-disabled, #091E420F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $iHYdz.relativeFontSizeToBase16)(14),
    margin: `${"var(--ds-space-100, 8px)"} 0`,
    minHeight: '24px',
    padding: "var(--ds-space-150, 12px)",
    textAlign: 'center',
    verticalAlign: 'text-bottom',
    minWidth: '120px',
    alignItems: 'center',
    justifyContent: 'center'
});
const $94120525d10931b9$var$UnsupportedBlockNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $9tFGn.getUnsupportedContent)((0, $7R1zM.unsupportedContentMessages).unsupportedBlockContent, (0, $7R1zM.unsupportedContentMessages).unsupportedBlockContent.defaultMessage + ':', node, intl);
    const tooltipContent = intl.formatMessage((0, $7R1zM.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $5uXOq.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $5uXOq.useCallback)(()=>dispatchAnalyticsEvent && (0, $d54NZ.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).ON_UNSUPPORTED_BLOCK, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $94120525d10931b9$var$blockNodeStyle,
        className: "unsupported"
    }, message, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJS47))), {
        label: "?",
        size: "small"
    })))));
};
var $94120525d10931b9$export$2e2bcd8739ae039 = (0, $8RXs9.default)($94120525d10931b9$var$UnsupportedBlockNode);

});
parcelRegister("gkwXh", function(module, exports) {

$parcel$export(module.exports, "EVENT_TYPE", () => $97c56ca7515fdb59$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $97c56ca7515fdb59$export$9523889e0a5da4ba);
$parcel$export(module.exports, "INPUT_METHOD", () => $97c56ca7515fdb59$export$85f107b1fcc9d96f);
$parcel$export(module.exports, "INSERT_MEDIA_VIA", () => $97c56ca7515fdb59$export$9b31fa32ae3f8051);
$parcel$export(module.exports, "TRIGGER_METHOD", () => $97c56ca7515fdb59$export$81a8b7dba1aa8f75);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $97c56ca7515fdb59$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $97c56ca7515fdb59$export$9957974f8b4d8f74);
$parcel$export(module.exports, "CONTENT_COMPONENT", () => $97c56ca7515fdb59$export$9f0b2adf3cfd71b7);
var $97c56ca7515fdb59$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $97c56ca7515fdb59$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["ACTIONED"] = "actioned";
    ACTION["ACTIVATED"] = "activated";
    ACTION["ADDED"] = "added";
    ACTION["API_ERROR"] = "apiError";
    ACTION["API_RECEIVED"] = "apiReceived";
    ACTION["API_PURGED"] = "apiPurged";
    ACTION["BROWSER_FREEZE"] = "browserFreeze";
    ACTION["CANCELLED"] = "cancelled";
    ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
    ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
    ACTION["CHANGED_ICON"] = "changedIcon";
    ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
    ACTION["CHANGED_LAYOUT"] = "changedLayout";
    ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
    ACTION["CHANGED_TYPE"] = "changedType";
    ACTION["CHANGED_URL"] = "changedUrl";
    ACTION["CLEARED"] = "cleared";
    ACTION["CLICK"] = "click";
    ACTION["CLICKED"] = "clicked";
    ACTION["CLOSED"] = "closed";
    ACTION["COMMITTED"] = "committed";
    /** used in @atlassian/editor-referentiality */ ACTION["CONNECTED_NODES"] = "connectedNodes";
    ACTION["CONVERTED"] = "converted";
    ACTION["COPIED"] = "copied";
    ACTION["CUT"] = "cut";
    ACTION["DEACTIVATED"] = "deactivated";
    ACTION["DECREMENTED"] = "decremented";
    ACTION["DELETED"] = "deleted";
    ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
    ACTION["DISMISSED"] = "dismissed";
    ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
    ACTION["DISPATCHED_VALID_TRANSACTION"] = "dispatchedValidTransaction";
    ACTION["DOUBLE_CLICKED"] = "doubleClicked";
    ACTION["DRAGGED"] = "dragged";
    ACTION["EDITED"] = "edited";
    ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
    ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
    ACTION["EDITOR_MOUNTED"] = "mounted";
    ACTION["EDITOR_TTI"] = "tti";
    ACTION["EDITOR_CONTENT_RETRIEVAL_PERFORMED"] = "contentRetrievalPerformed";
    ACTION["RE_RENDERED"] = "reRendered";
    ACTION["ENDED"] = "ended";
    ACTION["ENTERED"] = "entered";
    ACTION["ERROR"] = "error";
    ACTION["ERRORED"] = "errored";
    ACTION["EXPOSED"] = "exposed";
    ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
    ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
    ACTION["FIND_PERFORMED"] = "findPerformed";
    ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
    ACTION["FORMATTED"] = "formatted";
    ACTION["HELP_OPENED"] = "helpOpened";
    ACTION["HIGHLIGHTED"] = "highlighted";
    ACTION["INCREMENTED"] = "incremented";
    ACTION["INDENTED"] = "indented";
    ACTION["INITIALISED"] = "initialised";
    ACTION["INITIATED"] = "initiated";
    /** used in @atlassian/editor-referentiality */ ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
    ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
    ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
    ACTION["INPUT_PERF_SAMPLING_SINGLE_KEYPRESS"] = "inputPerfSamplingSingleKeypress";
    ACTION["INPUT_PERF_SAMPLING_SINGLE_KEYPRESS_AVG"] = "inputPerfSamplingSingleKeypressAvg";
    ACTION["INPUT_PERF_SAMPLING_RENDERED"] = "inputPerfSamplingRendered";
    ACTION["INPUT_PERF_SAMPLING_RENDERED_AVG"] = "inputPerfSamplingRenderedAvg";
    ACTION["INSERTED"] = "inserted";
    ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
    ACTION["INVOKED"] = "invoked";
    /** used in @atlassian/editor-referentiality */ ACTION["GOT_CONNECTIONS"] = "gotConnections";
    ACTION["LANGUAGE_SELECTED"] = "languageSelected";
    ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
    ACTION["MATCHED"] = "matched";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
    ACTION["OPENED"] = "opened";
    ACTION["OUTDENTED"] = "outdented";
    ACTION["PASTED"] = "pasted";
    ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
    ACTION["PASTED_TIMED"] = "pastedTimed";
    ACTION["PRESSED"] = "pressed";
    ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
    ACTION["REACT_NODEVIEW_RENDERED"] = "reactNodeViewRendered";
    ACTION["REPLACED_ALL"] = "replacedAll";
    ACTION["REPLACED_ONE"] = "replacedOne";
    ACTION["RESOLVED"] = "resolved";
    ACTION["REQUEST_TO_EDIT"] = "requestToEdit";
    ACTION["SELECTED"] = "selected";
    ACTION["SHOWN"] = "shown";
    ACTION["SLOW_INPUT"] = "slowInput";
    ACTION["STARTED"] = "started";
    ACTION["STOPPED"] = "stopped";
    ACTION["SUBMITTED"] = "submitted";
    ACTION["SUBSTITUTED"] = "autoSubstituted";
    ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
    ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
    ACTION["SYNCHRONY_ERROR"] = "synchronyError";
    ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
    ACTION["TOGGLED"] = "toggled";
    ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
    ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
    ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
    ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["TRANSACTION_DISPATCHED"] = "transactionDispatched";
    ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
    ACTION["TYPING_FINISHED"] = "typingFinished";
    ACTION["TYPING_STARTED"] = "typingStarted";
    ACTION["UNHANDLED_ERROR_CAUGHT"] = "unhandledErrorCaught";
    ACTION["UNLINK"] = "unlinked";
    ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
    ACTION["UPDATED"] = "updated";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_SOURCE"] = "updatedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_TARGET"] = "updatedTarget";
    ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["WITH_PLUGIN_STATE_CALLED"] = "withPluginStateCalled";
    ACTION["RENDERED"] = "rendered";
    ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
    /**
	 * @private
	 * @deprecated
	 *
	 * This is no longer used and can be removed at a later date
	 */ ACTION["ON_CHANGE_CALLBACK"] = "onChangeCalled";
    ACTION["NESTED_TABLE_TRANSFORMED"] = "nestedTableTransformed";
    ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
    ACTION["REMOVE_ICON"] = "removedIcon";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
    ACTION["RENDERER_TTI"] = "tti";
    ACTION["CRASHED"] = "unhandledErrorCaughtV2";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["STEPS_TRACKED"] = "stepsTracked";
    ACTION["STEPS_FILTERED"] = "stepsFiltered";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
    ACTION["RECORD_VIDEO"] = "recordVideo";
    ACTION["INSERT_VIDEO"] = "insertVideo";
    ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
    ACTION["ADD_CHILD"] = "addChild";
    ACTION["CHANGE_ACTIVE"] = "changeActive";
    ACTION["REMOVE_CHILD"] = "removeChild";
    ACTION["UPDATE_PARAMETERS"] = "updateParameters";
    ACTION["GET_CHILDERN"] = "getChildern";
    ACTION["MOVED"] = "moved";
    ACTION["UPLOAD_COMMENCED"] = "uploadCommenced";
    ACTION["UPLOAD_SUCCEEDED"] = "uploadSucceeded";
    ACTION["UPLOAD_FAILED"] = "uploadFailed";
    ACTION["TOGGLE_CODE_BLOCK_WRAP"] = "toggleCodeBlockWrap";
    ACTION["RESIZED"] = "resized";
    ACTION["BLOCKS_DRAG_INIT"] = "blocksDragInit";
    ACTION["SINGLE_COL_LAYOUT_DETECTED"] = "singleColumLayoutDetected";
    return ACTION;
}({});
var $97c56ca7515fdb59$export$85f107b1fcc9d96f = /*#__PURE__*/ function(INPUT_METHOD) {
    INPUT_METHOD["ASCII"] = "ascii";
    INPUT_METHOD["AUTO"] = "auto";
    INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
    INPUT_METHOD["BUTTON"] = "button";
    INPUT_METHOD["BLUR"] = "blur";
    INPUT_METHOD["CARD"] = "card";
    INPUT_METHOD["CLIPBOARD"] = "clipboard";
    INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
    INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
    INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
    INPUT_METHOD["DRAG"] = "drag";
    INPUT_METHOD["EXTERNAL"] = "external";
    INPUT_METHOD["EXTENSION_API"] = "extensionApi";
    INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
    INPUT_METHOD["FORMATTING"] = "autoformatting";
    INPUT_METHOD["INSERT_MENU"] = "insertMenu";
    INPUT_METHOD["INSERT_MENU_RIGHT_RAIL"] = "insertMenuRightRail";
    INPUT_METHOD["KEYBOARD"] = "keyboard";
    INPUT_METHOD["MEDIA_PICKER"] = "mediaPicker";
    INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
    INPUT_METHOD["MANUAL"] = "manual";
    INPUT_METHOD["PICKER"] = "picker";
    INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
    INPUT_METHOD["PREFILL"] = "prefill";
    INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
    INPUT_METHOD["SHORTCUT"] = "shortcut";
    INPUT_METHOD["TOOLBAR"] = "toolbar";
    INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
    INPUT_METHOD["DATASOURCE"] = "datasource_config";
    INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
    INPUT_METHOD["MOUSE"] = "mouse";
    INPUT_METHOD["BROWSER"] = "browser";
    INPUT_METHOD["DOUBLE_CLICK"] = "doubleClick";
    return INPUT_METHOD;
}({});
var $97c56ca7515fdb59$export$9b31fa32ae3f8051 = /*#__PURE__*/ function(INSERT_MEDIA_VIA) {
    INSERT_MEDIA_VIA["LOCAL_UPLOAD"] = "localUpload";
    INSERT_MEDIA_VIA["EXTERNAL_URL"] = "externalUrl";
    INSERT_MEDIA_VIA["EXTERNAL_UPLOAD"] = "externalUpload";
    return INSERT_MEDIA_VIA;
}({});
var $97c56ca7515fdb59$export$81a8b7dba1aa8f75 = /*#__PURE__*/ function(TRIGGER_METHOD) {
    TRIGGER_METHOD["BUTTON"] = "button";
    TRIGGER_METHOD["KEYBOARD"] = "keyboard";
    TRIGGER_METHOD["SHORTCUT"] = "shortcut";
    TRIGGER_METHOD["TOOLBAR"] = "toolbar";
    return TRIGGER_METHOD;
}({});
var $97c56ca7515fdb59$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["AI_INTERACTION"] = "aiInteraction";
    ACTION_SUBJECT["AI_RESULT"] = "aiResult";
    ACTION_SUBJECT["AI_FEEDBACK"] = "aiFeedback";
    ACTION_SUBJECT["COLLAB"] = "collab";
    ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
    ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
    ACTION_SUBJECT["DATE"] = "date";
    ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
    ACTION_SUBJECT["DOCUMENT"] = "document";
    ACTION_SUBJECT["EDITOR"] = "editor";
    ACTION_SUBJECT["ACTIVITY_SESSION"] = "activitySession";
    ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
    ACTION_SUBJECT["EMBEDS"] = "embeds";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["EXTENSION"] = "extension";
    ACTION_SUBJECT["FEATURE"] = "feature";
    ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
    ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
    ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
    ACTION_SUBJECT["HELP"] = "help";
    ACTION_SUBJECT["INVITE_ITEM"] = "inviteItem";
    ACTION_SUBJECT["LAYOUT"] = "layout";
    ACTION_SUBJECT["LIST"] = "list";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["MENTION"] = "mention";
    ACTION_SUBJECT["MENTION_TYPEAHEAD"] = "mentionTypeahead";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["PANEL"] = "panel";
    ACTION_SUBJECT["PICKER"] = "picker";
    ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
    ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
    ACTION_SUBJECT["REQUEST_TO_EDIT_POP_UP"] = "requestToEditPopUp";
    ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT["SELECTION"] = "selection";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
    ACTION_SUBJECT["TEAM_MENTION_TYPEAHEAD"] = "teamMentionTypeahead";
    ACTION_SUBJECT["TEXT"] = "text";
    ACTION_SUBJECT["TOOLBAR"] = "toolbar";
    ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
    ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
    ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
    ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["TOOLTIP"] = "tooltip";
    ACTION_SUBJECT["LOOM"] = "loom";
    ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT["BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT["DROP_TARGET"] = "dropTarget";
    ACTION_SUBJECT["DRAG"] = "drag";
    ACTION_SUBJECT["ELEMENT"] = "element";
    ACTION_SUBJECT["INLINE_DIALOG"] = "inlineDialog";
    ACTION_SUBJECT["ENGAGEMENT_PLATFORM"] = "engagementPlatform";
    ACTION_SUBJECT["MEDIA_VIEWER"] = "mediaViewer";
    ACTION_SUBJECT["DECORATION"] = "decoration";
    ACTION_SUBJECT["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT["AI_DEFINITIONS"] = "aiDefinitions";
    return ACTION_SUBJECT;
}({});
var $97c56ca7515fdb59$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["ACTION"] = "action";
    ACTION_SUBJECT_ID["ACTIVITY"] = "activity";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_DEFINE_BUTTON"] = "aiDefinitionsDefineButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_AUTO_HIGHLIGHT"] = "aiDefinitionsAutoHighlight";
    ACTION_SUBJECT_ID["AI_PANELS_BODIED_EXTENSION"] = "aiPanelsBodiedExtension";
    ACTION_SUBJECT_ID["AI_PROMPT_LINK_PICKER_BUTTON"] = "aiPromptLinkPickerButton";
    ACTION_SUBJECT_ID["AI_PROMPT_MENTION_BUTTON"] = "aiPromptMentionButton";
    ACTION_SUBJECT_ID["AI_PROACTIVE_FEEDBACK_DIALOG"] = "aiProactiveFeedbackDialog";
    ACTION_SUBJECT_ID["ALL"] = "all";
    ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
    ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
    ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
    ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["BORDER"] = "border";
    ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
    ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
    ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
    ACTION_SUBJECT_ID["CANCEL"] = "cancel";
    ACTION_SUBJECT_ID["CAPTION"] = "caption";
    ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
    ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
    ACTION_SUBJECT_ID["CELL"] = "cell";
    ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    ACTION_SUBJECT_ID["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT_ID["COPY_LINK_TO_ANCHOR"] = "copyLinkToAnchor";
    ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
    ACTION_SUBJECT_ID["DATE"] = "date";
    ACTION_SUBJECT_ID["DATE_DAY"] = "day";
    ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
    ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
    ACTION_SUBJECT_ID["DECISION"] = "decision";
    ACTION_SUBJECT_ID["DIVIDER"] = "divider";
    ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
    ACTION_SUBJECT_ID["EDIT_DATASOURCE"] = "editDatasource";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT_ID["ELEMENT_DRAG_HANDLE"] = "elementDragHandle";
    ACTION_SUBJECT_ID["ELEMENT_DROP_TARGET"] = "elementDropTarget";
    ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
    ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    ACTION_SUBJECT_ID["EXPAND"] = "expand";
    ACTION_SUBJECT_ID["EXPERIENCE_APPLICATION"] = "experienceApplication";
    ACTION_SUBJECT_ID["EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
    ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
    ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
    ACTION_SUBJECT_ID["FORMAT_BACKGROUND_COLOR"] = "backgroundColor";
    ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
    ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
    ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
    ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
    ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
    ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
    ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
    ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
    ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
    ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
    ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
    ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
    ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
    ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
    ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
    ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
    ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["LAYOUT"] = "layout";
    ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
    ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
    ACTION_SUBJECT_ID["MEDIA"] = "media";
    ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
    ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
    ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["MENTION"] = "mention";
    ACTION_SUBJECT_ID["MENTION_PROVIDER"] = "mentionProvider";
    ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["NODE"] = "node";
    ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
    ACTION_SUBJECT_ID["PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
    ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
    ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
    ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
    ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
    ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
    ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
    ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
    ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
    ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
    ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
    ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
    ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
    ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
    ACTION_SUBJECT_ID["PICKER_MEDIA"] = "mediaPicker";
    ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
    ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
    ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
    ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
    ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
    ACTION_SUBJECT_ID["PROACTIVE_SUGGESTION"] = "proactiveSuggestion";
    ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
    ACTION_SUBJECT_ID["PUNC"] = "punctuation";
    ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
    ACTION_SUBJECT_ID["RANGE"] = "range";
    ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
    ACTION_SUBJECT_ID["RESIZED"] = "resized";
    ACTION_SUBJECT_ID["RESPONSE_FEEDBACK_BUTTON"] = "responseFeedbackButton";
    ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
    ACTION_SUBJECT_ID["SAVE"] = "save";
    ACTION_SUBJECT_ID["SECTION"] = "section";
    ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT_ID["SMART_LINK_TOOLBAR"] = "smartLinkToolbar";
    ACTION_SUBJECT_ID["STATUS"] = "status";
    ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
    ACTION_SUBJECT_ID["TABLE"] = "table";
    ACTION_SUBJECT_ID["TEXT"] = "text";
    ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
    ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
    ACTION_SUBJECT_ID["UNLINK"] = "unlink";
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
    ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
    ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
    ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
    ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
    ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT_ID["UPLOAD_MEDIA"] = "uploadMedia";
    return ACTION_SUBJECT_ID;
}({});
var $97c56ca7515fdb59$export$75ef928acd21e35b = /*#__PURE__*/ function(FLOATING_CONTROLS_TITLE) {
    FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
    FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
    FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
    FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
    FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
    FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
    FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
    return FLOATING_CONTROLS_TITLE;
}({});
var $97c56ca7515fdb59$export$9f0b2adf3cfd71b7 = /*#__PURE__*/ function(CONTENT_COMPONENT) {
    CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
    CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
    CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
    return CONTENT_COMPONENT;
}({});

});

parcelRegister("7R1zM", function(module, exports) {

$parcel$export(module.exports, "unsupportedContentMessages", () => $757d518931aaa671$export$32ec96484dd3ba39);

var $7VHMR = parcelRequire("7VHMR");
const $757d518931aaa671$export$32ec96484dd3ba39 = (0, $7VHMR.defineMessages)({
    unsupportedInlineContent: {
        id: 'fabric.editor.unsupportedInlineContent',
        defaultMessage: 'Unsupported content',
        description: 'Unsupported content'
    },
    unsupportedBlockContent: {
        id: 'fabric.editor.unsupportedBlockContent',
        defaultMessage: 'This editor does not support displaying this content',
        description: 'This editor does not support displaying this content'
    },
    unsupportedContentTooltip: {
        id: 'fabric.editor.unsupportedContentTooltip',
        defaultMessage: 'Content is not available in this editor, this will be preserved when you edit and save',
        description: 'Content is not available in this editor, this will be preserved when you edit and save'
    }
});

});

parcelRegister("d54NZ", function(module, exports) {

$parcel$export(module.exports, "findAndTrackUnsupportedContentNodes", () => $850930d0b79c2a61$export$d343369b8f25914);
$parcel$export(module.exports, "fireUnsupportedEvent", () => $850930d0b79c2a61$export$e1051b410945e4d4);
$parcel$export(module.exports, "trackUnsupportedContentTooltipDisplayedFor", () => $850930d0b79c2a61$export$3a34598135e7219b);

var $gkwXh = parcelRequire("gkwXh");
const $850930d0b79c2a61$var$whitelistedAttributes = [
    'align',
    'annotationType',
    'extensionKey',
    'extensionType',
    'layout',
    'type',
    'localId',
    'mode',
    'language',
    'timestamp',
    'state',
    'originalWidth',
    'originalHeight',
    'height',
    'width',
    'shortName',
    'level',
    'userType',
    'order',
    'panelType',
    'color',
    'style',
    'isNumberColumnEnabled',
    'colspan',
    'rowspan',
    'colwidth',
    'background'
];
function $850930d0b79c2a61$var$concatAncestorHierarchy(node, ancestoryHierarchy) {
    const { name: name } = node.type;
    // Space concatenator used to reduce analytics payload size
    return ancestoryHierarchy ? `${ancestoryHierarchy} ${name}` : name;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $850930d0b79c2a61$var$sanitizeMarks = (marks = [])=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedMarks = [];
    marks.forEach((mark)=>{
        if (mark.attrs) {
            const attrs = $850930d0b79c2a61$var$sanitizeAttributes(mark.attrs);
            sanitizedMarks.push({
                ...mark,
                attrs: attrs
            });
        } else sanitizedMarks.push({
            ...mark
        });
    });
    return sanitizedMarks;
};
const $850930d0b79c2a61$var$sanitizeAttributes = (attrs = {})=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedAttrs = Object.assign({}, attrs);
    Object.keys(attrs).filter((key)=>!$850930d0b79c2a61$var$whitelistedAttributes.includes(key)).forEach((key)=>{
        sanitizedAttrs[key] !== null ? sanitizedAttrs[key] = '' : sanitizedAttrs[key] = 'null';
    });
    return sanitizedAttrs;
};
const $850930d0b79c2a61$var$trackUnsupportedContentTooltipActionFor = (action, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    dispatchAnalyticsEvent({
        action: action,
        actionSubjectId: unsupportedContentType,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).TOOLTIP,
        eventType: (0, $gkwXh.EVENT_TYPE).UI,
        attributes: {
            unsupportedNodeType: originalNodeType
        }
    });
};
const $850930d0b79c2a61$export$d343369b8f25914 = (node, schema, dispatchAnalyticsEvent, ancestorHierarchy = '')=>{
    const { type: nodeType, marks: nodeMarks } = node;
    const { unsupportedMark: unsupportedMark, unsupportedNodeAttribute: unsupportedNodeAttribute } = schema.marks;
    const { unsupportedInline: unsupportedInline, unsupportedBlock: unsupportedBlock } = schema.nodes;
    const parentType = ancestorHierarchy.split(' ').pop() || '';
    if (nodeMarks.length) nodeMarks.forEach((mark)=>{
        if (mark.type === unsupportedMark) {
            const { originalValue: originalValue } = mark.attrs || {};
            const { type: type } = originalValue || {};
            const unsupportedNode = {
                type: type || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: originalValue.attrs || {}
            };
            $850930d0b79c2a61$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_MARK, unsupportedNode);
        } else if (mark.type === unsupportedNodeAttribute) {
            const { unsupported: unsupported } = mark.attrs || {};
            const unsupportedNodeAttribute = {
                type: nodeType.name || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: unsupported || {}
            };
            $850930d0b79c2a61$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_NODE_ATTRIBUTE, unsupportedNodeAttribute);
        }
    });
    if (nodeType === unsupportedInline || nodeType === unsupportedBlock) {
        const { originalValue: originalValue } = node.attrs || {};
        const { marks: marks } = originalValue || [];
        const { attrs: attrs } = originalValue || {};
        const { type: type } = originalValue || {};
        const unsupportedNode = {
            type: type || '',
            ancestry: ancestorHierarchy,
            parentType: parentType,
            marks: marks || [],
            attrs: attrs || {}
        };
        const actionSubjectId = nodeType === unsupportedInline ? (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_INLINE : (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_BLOCK;
        $850930d0b79c2a61$export$e1051b410945e4d4(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode);
    } else // Recursive check for nested content
    node.content.forEach((childNode)=>$850930d0b79c2a61$export$d343369b8f25914(childNode, schema, dispatchAnalyticsEvent, $850930d0b79c2a61$var$concatAncestorHierarchy(node, ancestorHierarchy)));
};
const $850930d0b79c2a61$export$e1051b410945e4d4 = (dispatchAnalyticsEvent, actionSubjectId, unsupportedNode, errorCode)=>{
    const sanitizedAttrs = $850930d0b79c2a61$var$sanitizeAttributes(unsupportedNode.attrs);
    const sanitizedMarks = $850930d0b79c2a61$var$sanitizeMarks(unsupportedNode.marks);
    const sanitizedUnsupportedNode = {
        type: unsupportedNode.type,
        ancestry: unsupportedNode.ancestry,
        parentType: unsupportedNode.parentType,
        attrs: sanitizedAttrs,
        marks: sanitizedMarks
    };
    const payload = {
        action: (0, $gkwXh.ACTION).UNSUPPORTED_CONTENT_ENCOUNTERED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        attributes: {
            unsupportedNode: sanitizedUnsupportedNode,
            ...!!errorCode && {
                errorCode: errorCode
            }
        },
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK
    };
    dispatchAnalyticsEvent(payload);
};
const $850930d0b79c2a61$export$3a34598135e7219b = (dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    $850930d0b79c2a61$var$trackUnsupportedContentTooltipActionFor((0, $gkwXh.ACTION).UNSUPPORTED_TOOLTIP_VIEWED, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType);
};

});

parcelRegister("9tFGn", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedContent", () => $3ba5e7dd155390b9$export$d4ded51d0f0bd2df);
function $3ba5e7dd155390b9$export$d4ded51d0f0bd2df(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
message, prefix, node, intl) {
    const defaultLocale = 'en';
    let canTranslateToLocale = true;
    const locale = intl ? intl.locale : defaultLocale;
    let finalMessage = message.defaultMessage;
    if (node && locale.startsWith(defaultLocale)) {
        const { originalValue: originalValue } = node.attrs;
        if (originalValue.text || originalValue.attrs && originalValue.attrs.text) {
            finalMessage = originalValue.text ? originalValue.text : originalValue.attrs.text;
            canTranslateToLocale = false;
        } else if (originalValue.type) {
            finalMessage = `${prefix} ${originalValue.type}`;
            canTranslateToLocale = false;
        }
    }
    if (intl && canTranslateToLocale) return intl.formatMessage(message);
    return finalMessage;
}

});


parcelRegister("2DpUZ", function(module, exports) {

$parcel$export(module.exports, "WithCreateAnalyticsEvent", () => $10143a74d71d9da7$export$9ac3d19711324187);

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");
const $10143a74d71d9da7$export$9ac3d19711324187 = (0, $cb25w.default)()(class WithCreateAnalyticsEvent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { render: render, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        return render(createAnalyticsEvent);
    }
});

});

parcelRegister("gmhCD", function(module, exports) {

$parcel$export(module.exports, "editorExperiment", () => $a90e6fd79e0e0cb2$export$9b7cf3b74f250027);
$parcel$export(module.exports, "unstable_editorExperimentParam", () => $a90e6fd79e0e0cb2$export$92316ae898e357eb);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $iEN9D = parcelRequire("iEN9D");

var $hdkTE = parcelRequire("hdkTE");

var $a0Psj = parcelRequire("a0Psj");
function $a90e6fd79e0e0cb2$export$9b7cf3b74f250027(experimentName, expectedExperimentValue, options = {
    exposure: false
}) {
    const experimentConfig = (0, $hdkTE.editorExperimentsConfig)[experimentName];
    if ((0, $a0Psj._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $a0Psj._overrides)[experimentName] === expectedExperimentValue;
    if (!(0, $a0Psj._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return experimentConfig.defaultValue === expectedExperimentValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig.productKeys?.[0, $a0Psj._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return (0, $hdkTE.editorExperimentsConfig)[experimentName].defaultValue === expectedExperimentValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $iEN9D.default).getExperimentValue(// @ts-ignore
    experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
        typeGuard: experimentConfig.typeGuard,
        fireExperimentExposure: options.exposure
    });
    return expectedExperimentValue === experimentValue;
}
function $a90e6fd79e0e0cb2$export$92316ae898e357eb(experimentName, paramName, options) {
    if ((0, $a0Psj._paramOverrides)[experimentName]?.[paramName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $a0Psj._paramOverrides)[experimentName][paramName];
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $iEN9D.default).getExperimentValue(experimentName, paramName, options.defaultValue, {
        typeGuard: options.typeGuard,
        fireExperimentExposure: options.exposure ?? false
    });
    return experimentValue;
}

});
parcelRegister("hdkTE", function(module, exports) {

$parcel$export(module.exports, "editorExperimentsConfig", () => $7a273b3c03491c92$export$6cbb856f286b07ef);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $9qwvi = parcelRequire("9qwvi");
const $7a273b3c03491c92$export$6cbb856f286b07ef = {
    // Added 2024-08-08
    'example-boolean': {
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        // Note -- you need to set the type to boolean for the default value
        defaultValue: false
    },
    // Added 2024-08-08
    'example-multivariate': {
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        typeGuard: (0, $9qwvi.oneOf)([
            'one',
            'two',
            'three'
        ]),
        // Note -- you need to specify the type of the default value as the union of all possible values
        // This is used to provide type safety on consumption
        defaultValue: 'one'
    },
    // Added 2024-08-08
    'test-new-experiments-package': {
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Add 2024-08-14
    'basic-text-transformations': {
        productKeys: {
            confluence: 'platform_editor_basic_text_transformations'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-08-28
    'element-level-templates': {
        productKeys: {
            confluence: 'platform_editor_element_level_templates'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-08-29
    'add-media-from-url': {
        productKeys: {
            confluence: 'platform_editor_add_media_from_url'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-08-30
    'nested-dnd': {
        productKeys: {
            confluence: 'platform_editor_element_drag_and_drop_nested'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-08-29
    'insert-menu-in-right-rail': {
        productKeys: {
            confluence: 'platform_editor_insert_menu_in_right_rail'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-09-05
    support_table_in_comment: {
        productKeys: {
            confluence: 'platform_editor_support_table_in_comment_exp'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-09-07
    platform_editor_exp_lazy_node_views: {
        productKeys: {
            confluence: 'platform_editor_exp_lazy_node_views'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: {
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-09-18
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_nest_media_and_codeblock_in_quotes/setup
    'nest-media-and-codeblock-in-quote': {
        productKeys: {
            confluence: 'platform_editor_nest_media_and_codeblock_in_quotes'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-09-18
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_nest_nested_expand_in_expand/setup
    'nested-expand-in-expand': {
        productKeys: {
            confluence: 'platform_editor_nest_nested_expand_in_expand'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-09-23
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/editor_ai_-_multi_prompts/setup
    'editor_ai_-_multi_prompts': {
        productKeys: {
            confluence: 'editor_ai_-_multi_prompts'
        },
        param: 'cohort',
        typeGuard: (0, $9qwvi.oneOf)([
            'control',
            'test'
        ]),
        defaultValue: 'control'
    },
    // Added 2024-10-01
    comment_on_bodied_extensions: {
        productKeys: {
            confluence: 'platform_editor_comment_on_bodied_extensions'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: {
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-10-08
    support_table_in_comment_jira: {
        productKeys: {
            jira: 'platform_editor_support_table_in_comment_jira'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-10-25
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_comment_on_inline_node_spotlight/setup
    comment_on_inline_node_spotlight: {
        productKeys: {
            confluence: 'platform_editor_comment_on_inline_node_spotlight'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    'platform_editor_ai-prompts-placeholder': {
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        typeGuard: (0, $9qwvi.oneOf)([
            'control',
            'test'
        ]),
        defaultValue: 'control'
    },
    // added 2024-11-06
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_nested_tables/setup
    'nested-tables-in-tables': {
        productKeys: {
            confluence: 'platform_editor_nested_tables'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-11-06
    platform_editor_ai_change_tone_floating_toolbar: {
        productKeys: {
            confluence: 'platform_editor_ai_change_tone_floating_toolbar'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-11-13
    issue_view_action_items: {
        productKeys: {
            jira: 'issue_view_action_items'
        },
        param: 'isActionItemsEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-11-18
    contextual_formatting_toolbar: {
        productKeys: {
            confluence: 'platform_editor_contextual_formatting_toolbar_exp'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-11-19
    platform_editor_ai_1p_smart_link_unfurl_in_prompt: {
        productKeys: {
            confluence: 'platform_editor_ai_1p_smart_link_unfurl_in_prompt'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: {
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2025-01-15
    platform_editor_ai_advanced_prompts: {
        productKeys: {
            confluence: 'platform_editor_ai_advanced_prompts'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    expand_selection_range_to_include_inline_node: {
        productKeys: {
            confluence: 'expand_selection_range_to_include_inline_node'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-12-05
    platform_editor_blockquote_in_text_formatting_menu: {
        productKeys: {
            confluence: 'platform_editor_blockquote_in_text_formatting_menu'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2025-01-09
    platform_editor_advanced_code_blocks: {
        productKeys: {
            confluence: 'platform_editor_advanced_code_blocks'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2025-01-13
    platform_editor_element_drag_and_drop_multiselect: {
        productKeys: {
            confluence: 'platform_editor_element_drag_and_drop_multiselect'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2025-01-16
    live_pages_graceful_edit: {
        productKeys: {
            confluence: 'live_pages_graceful_edit'
        },
        param: 'cohort',
        typeGuard: (0, $9qwvi.oneOf)([
            'control',
            'text-click-delayed',
            'text-click-no-delay',
            'initially-hide-toolbar'
        ]),
        defaultValue: 'control'
    },
    // Added 2025-01-20
    platform_editor_contextual_formatting_toolbar_v2: {
        productKeys: {
            confluence: 'platform_editor_contextual_formatting_toolbar_v2'
        },
        param: 'cohort',
        typeGuard: (0, $9qwvi.oneOf)([
            'control',
            'variant1',
            'variant2'
        ]),
        defaultValue: 'control'
    },
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: {
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2025-01-22
    platform_editor_ai_jira_content_read_url: {
        productKeys: {
            jira: 'platform_editor_ai_jira_content_read_url'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    }
};

});
parcelRegister("9qwvi", function(module, exports) {

$parcel$export(module.exports, "isBoolean", () => $41035ee8947774ef$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "oneOf", () => $41035ee8947774ef$export$a9a18ae5ba42aeab);
function $41035ee8947774ef$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $41035ee8947774ef$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
	 * This is used by test utils to get the variants when running describe.each
	 */ if ($41035ee8947774ef$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}
const $41035ee8947774ef$var$IS_TESTING_ENV = false;

});


parcelRegister("a0Psj", function(module, exports) {

$parcel$export(module.exports, "_overrides", () => $ae2371e90434836c$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_paramOverrides", () => $ae2371e90434836c$export$4e849416bb5c5b52);
$parcel$export(module.exports, "_product", () => $ae2371e90434836c$export$cf7305fc65acbf0d);
$parcel$export(module.exports, "setupEditorExperiments", () => $ae2371e90434836c$export$1c2b6dbf79eb3560);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $hdkTE = parcelRequire("hdkTE");
let $ae2371e90434836c$export$e5d73bf4f8e2ae96 = {};
let $ae2371e90434836c$export$4e849416bb5c5b52 = {};
let $ae2371e90434836c$export$cf7305fc65acbf0d;
function $ae2371e90434836c$export$1c2b6dbf79eb3560(product, /**
	 * Overrides are used to set the group of an experiment for testing purposes.
	 * This is useful when you want to test a specific experiment group.
	 */ groupOverrides, /**
	 * Param overrides are used to set the experiment parameters for testing purposes.
	 * This is useful when you want to tweak the experiment parameters for testing.
	 */ paramOverrides) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        // @ts-ignore
        groupOverrides = Object.entries(groupOverrides).reduce((acc, [key, value])=>{
            const config = (0, $hdkTE.editorExperimentsConfig)[key];
            if (config) acc = {
                ...acc,
                [key]: config.typeGuard(value) ? value : config.defaultValue
            };
            return acc;
        }, {});
        $ae2371e90434836c$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    $ae2371e90434836c$export$cf7305fc65acbf0d = product;
    if (paramOverrides) $ae2371e90434836c$export$4e849416bb5c5b52 = paramOverrides;
}

});


parcelRegister("gE8f9", function(module, exports) {

$parcel$export(module.exports, "browser", () => $6911d91f679e4e6c$export$3f2684e5d7cb1006);
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6911d91f679e4e6c$export$3f2684e5d7cb1006 = {
    mac: false,
    windows: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    gecko_version: 0,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    safari_version: 0,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const ieEdge = /(?:Edge|Edg)\/(\d+)/.exec(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.mac = /Mac/.test(navigator.platform);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.windows = // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    navigator.userAgentData?.platform === 'Windows' || // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /Windows|Win\d+/i.test(navigator.userAgent);
    const ie = $6911d91f679e4e6c$export$3f2684e5d7cb1006.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.ie_version = ieUpTo10 ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.gecko_version = parseInt((navigator.userAgent.match(/Firefox\/(\d+)/) || [])[1], 10);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.android = /Android \d/.test(navigator.userAgent);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.ios = // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.safari_version = parseInt(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    (navigator.userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}

});

parcelRegister("iN9lO", function(module, exports) {

$parcel$export(module.exports, "startMeasure", () => $420059dd531814dc$export$b62aa2130c86b59b);
$parcel$export(module.exports, "stopMeasure", () => $420059dd531814dc$export$37c25be427bec097);
$parcel$export(module.exports, "clearMeasure", () => $420059dd531814dc$export$6f766653554dac02);

var $b7gJe = parcelRequire("b7gJe");
const $420059dd531814dc$var$measureMap = new Map();
function $420059dd531814dc$export$b62aa2130c86b59b(measureName) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::start`);
    $420059dd531814dc$var$measureMap.set(measureName, performance.now());
}
function $420059dd531814dc$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $420059dd531814dc$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $420059dd531814dc$export$6f766653554dac02(measureName);
    }
}
function $420059dd531814dc$export$6f766653554dac02(measureName) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    $420059dd531814dc$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}
function $420059dd531814dc$export$b0a51f9f0047ea32(measureName) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return false;
    return $420059dd531814dc$var$measureMap.get(measureName) !== undefined;
}

});
parcelRegister("b7gJe", function(module, exports) {

$parcel$export(module.exports, "isPerformanceAPIAvailable", () => $da51e67df7144cd5$export$b5717a625dd4a3eb);
$parcel$export(module.exports, "isPerformanceObserverAvailable", () => $da51e67df7144cd5$export$48995af1e77d8643);
let $da51e67df7144cd5$var$hasRequiredPerformanceAPIs;
function $da51e67df7144cd5$export$b5717a625dd4a3eb() {
    if ($da51e67df7144cd5$var$hasRequiredPerformanceAPIs === undefined) $da51e67df7144cd5$var$hasRequiredPerformanceAPIs = typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType',
        'now'
    ].every((api)=>!!performance[api]);
    return $da51e67df7144cd5$var$hasRequiredPerformanceAPIs;
}
function $da51e67df7144cd5$export$48995af1e77d8643() {
    return !!(typeof window !== 'undefined' && 'PerformanceObserver' in window);
}
function $da51e67df7144cd5$export$4370ec0f52022f66() {
    return $da51e67df7144cd5$export$48995af1e77d8643() && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('longtask');
}

});


parcelRegister("ap7h6", function(module, exports) {

$parcel$export(module.exports, "getDistortedDurationMonitor", () => $3e05ce213e57560b$export$70f7d127254a90c);
$parcel$export(module.exports, "measureRender", () => $3e05ce213e57560b$export$267ed650a5d21ae6);

var $b7gJe = parcelRequire("b7gJe");
const $3e05ce213e57560b$export$70f7d127254a90c = ()=>{
    if (typeof document === 'undefined') return {
        distortedDuration: false,
        cleanup () {}
    };
    // If an editor is rendered when the document is not visible -- the callback passed to
    // requestAnimationFrame will not fire until the document becomes visible again.
    //
    // For the purposes of using performance measurement -- this behaviour means the events
    // which have been fired in the background are not useful -- and lead to other events
    // being hard to draw conclusions from.
    //
    // To mitigate this -- we detect this state -- and fire a separate callback when the
    // measurement has occurred when the render was in the background
    let distortedDuration = document.visibilityState !== 'visible';
    function handleVisibilityChange() {
        if (document.visibilityState !== 'visible') distortedDuration = true;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return {
        distortedDuration: distortedDuration,
        /**
		 * Cleans up the document visibility event listener
		 */ cleanup () {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        }
    };
};
function $3e05ce213e57560b$export$267ed650a5d21ae6(/**
	 * Unique name for the measurement
	 *
	 * Important: if multiple measureRender events are fired at the same time
	 * with the same measure name -- the result will not be correct.
	 */ measureName, /**
	 * Call back fired when the measurement completes.
	 *
	 * Note: when this function is called when the Document.visibilityState is not
	 * visible -- the duration is likely to be misleading/inaccurate. This is due
	 * to the measurements use of the `requestAnimationFrame` api which only fires
	 * when the Document.visibilityState is visible.
	 */ onMeasureComplete) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    const startMark = `[START]: ${measureName}`;
    const endMark = `[END]: ${measureName}`;
    const startTime = performance.now();
    performance.mark(startMark);
    const distortedDurationMonitor = $3e05ce213e57560b$export$70f7d127254a90c();
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            performance.mark(endMark);
            distortedDurationMonitor.cleanup();
            const duration = performance.now() - startTime;
            try {
                performance.measure(measureName, startMark, endMark);
                const entry = performance.getEntriesByName(measureName).pop();
                if (!entry) onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
                else onMeasureComplete({
                    duration: entry.duration,
                    startTime: entry.startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            } catch (e) {
                onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            }
            performance.clearMeasures(measureName);
            performance.clearMarks(startMark);
            performance.clearMarks(endMark);
        });
    });
}

});

parcelRegister("kFiBa", function(module, exports) {

$parcel$export(module.exports, "getResponseEndTime", () => $9d05c46136d117ff$export$92d097a1155bbe27);

var $b7gJe = parcelRequire("b7gJe");
function $9d05c46136d117ff$export$92d097a1155bbe27() {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav) return nav.responseEnd;
    return;
}

});

parcelRegister("4NUlu", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsAppearance", () => $d9ce436f8d702318$export$be87849653b93e6b);
$parcel$export(module.exports, "getAnalyticsEditorAppearance", () => $d9ce436f8d702318$export$31ae53e002edded0);
$parcel$export(module.exports, "getAnalyticsEventSeverity", () => $d9ce436f8d702318$export$f8edd689e8b20f3a);
$parcel$export(module.exports, "analyticsEventKey", () => $d9ce436f8d702318$export$288273ee3e3b6132);

var $d93fQ = parcelRequire("d93fQ");
const $d9ce436f8d702318$export$be87849653b93e6b = (appearance)=>{
    switch(appearance){
        case 'full-page':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).FIXED_WIDTH;
        case 'full-width':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).FULL_WIDTH;
        case 'comment':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).COMMENT;
        case 'chromeless':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).CHROMELESS;
        case 'mobile':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).MOBILE;
    }
};
const $d9ce436f8d702318$export$31ae53e002edded0 = (editorAppearance)=>editorAppearance ? `editor_${$d9ce436f8d702318$export$be87849653b93e6b(editorAppearance)}` : '_unknown';
const $d9ce436f8d702318$export$f8edd689e8b20f3a = (duration, normalThreshold, degradedThreshold)=>{
    if (duration > normalThreshold && duration <= degradedThreshold) return "degraded";
    if (duration > degradedThreshold) return "blocking";
    return "normal";
};
var $d9ce436f8d702318$export$6a6bef12562cd865 = /*#__PURE__*/ function(SEVERITY) {
    SEVERITY["NORMAL"] = "normal";
    SEVERITY["DEGRADED"] = "degraded";
    SEVERITY["BLOCKING"] = "blocking";
    return SEVERITY;
}({});
const $d9ce436f8d702318$export$288273ee3e3b6132 = 'EDITOR_ANALYTICS_EVENT';

});

parcelRegister("fc6h8", function(module, exports) {

$parcel$export(module.exports, "shouldForceTracking", () => $d5e5ded83470406e$export$5b59d3e9e22dbdc6);
// START: temporary code https://product-fabric.atlassian.net/browse/ED-10260
const $d5e5ded83470406e$export$5b59d3e9e22dbdc6 = ()=>{
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { FRONTEND_VERSION: FRONTEND_VERSION = '' } = window.__buildInfo || {};
        return window.location.hostname === 'product-fabric.atlassian.net' && FRONTEND_VERSION.includes('branch-deploy');
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
        return false;
    }
}; // END:  temporary code  https://product-fabric.atlassian.net/browse/ED-10260

});

parcelRegister("4zXba", function(module, exports) {

$parcel$export(module.exports, "normalizeFeatureFlags", () => $e819a2725d93345d$export$f1485fc4974593c0);
$parcel$export(module.exports, "getEnabledFeatureFlagKeys", () => $e819a2725d93345d$export$6d018dd0f6cbebcb);

var $e4eHl = parcelRequire("e4eHl");

var $3T6Xo = parcelRequire("3T6Xo");
const $e819a2725d93345d$var$EMPTY = {};
function $e819a2725d93345d$var$isObjectFlagKey(key, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value, objectFlagKeys) {
    return Boolean(typeof value === 'string' && objectFlagKeys?.includes(key));
}
function $e819a2725d93345d$var$isValidJSONObject(value) {
    try {
        const result = JSON.parse(value);
        if (typeof result === 'object' && result !== null) return true;
        return false;
    } catch (err) {
        return false;
    }
}
function $e819a2725d93345d$export$f1485fc4974593c0(rawFeatureFlags, options) {
    if (!rawFeatureFlags) return $e819a2725d93345d$var$EMPTY;
    return Object.entries(rawFeatureFlags).filter((e)=>{
        if (typeof e[1] === 'boolean') return true;
        if ($e819a2725d93345d$var$isObjectFlagKey((0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(e[0]), e[1], options?.objectFlagKeys) && $e819a2725d93345d$var$isValidJSONObject(e[1])) return true;
        return false;
    }).filter(([key])=>(0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(key) === key).map(([key, value])=>[
            (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(key),
            value
        ]).reduce((flags, [key, value])=>{
        if ($e819a2725d93345d$var$isObjectFlagKey(key, value, options?.objectFlagKeys)) flags[key] = JSON.parse(value);
        if (typeof value === 'boolean') flags[key] = value;
        return flags;
    }, {});
}
function $e819a2725d93345d$export$6d018dd0f6cbebcb(featureFlags) {
    return Object.keys(featureFlags).filter((key)=>featureFlags[key] === true);
}

});

parcelRegister("9gOVJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a549b54270369c2c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kCV8T = parcelRequire("kCV8T");

var $gmhCD = parcelRequire("gmhCD");

var $3kKuL = parcelRequire("3kKuL");
parcelRequire("gJX6d");
var $5KNWO = parcelRequire("5KNWO");
var $gJX6d = parcelRequire("gJX6d");

var $5BLIh = parcelRequire("5BLIh");

var $cKKwC = parcelRequire("cKKwC");
var $GDkvY = parcelRequire("GDkvY");

var $eQNWQ = parcelRequire("eQNWQ");

var $5or39 = parcelRequire("5or39");

var $K5Jsy = parcelRequire("K5Jsy");

var $9dTMW = parcelRequire("9dTMW");

var $VSDnB = parcelRequire("VSDnB");

var $bzwTW = parcelRequire("bzwTW");

var $bVGKe = parcelRequire("bVGKe");

var $h5tvG = parcelRequire("h5tvG");

var $3VpWO = parcelRequire("3VpWO");
function $a549b54270369c2c$var$mergeMarks(marksAndNodes) {
    return marksAndNodes.reduce((acc, markOrNode)=>{
        const prev = acc.length && acc[acc.length - 1] || null;
        if (markOrNode.type instanceof (0, $kCV8T.MarkType) && prev && prev.type instanceof (0, $kCV8T.MarkType) && Array.isArray(prev.content) && (0, $eQNWQ.isSameMark)(prev, markOrNode)) prev.content = $a549b54270369c2c$var$mergeMarks(prev.content.concat(markOrNode.content));
        else acc.push(markOrNode);
        return acc;
    }, []);
}
class $a549b54270369c2c$export$2e2bcd8739ae039 {
    constructor(init){
        this.headingIds = [];
        /**
	 * The reason we have this extra array here is because we need to generate the same unique
	 * heading id for 2 different nodes: headers and expands (check the implementation of
	 * `getUniqueHeadingId` for more info).
	 *
	 * We will eventually need to refactor the current approach to generate unique ids
	 * for headers under this ticket -> https://product-fabric.atlassian.net/browse/ED-9668
	 */ this.expandHeadingIds = [];
        this.allowCopyToClipboard = false;
        this.allowWrapCodeBlock = false;
        this.allowPlaceholderText = true;
        this.allowCustomPanels = false;
        this.surroundTextNodesWithTextWrapper = false;
        this.allowAnnotations = false;
        this.serializeFragmentChild = (node, { index: index, parentInfo: parentInfo })=>{
            const pos = this.startPos;
            const currentPath = parentInfo && parentInfo.path || [];
            const parentIsIncompleteTask = node.type.name === 'taskItem' && node.attrs.state !== 'DONE';
            const nodeKey = `${node.type.name}__${this.startPos}`;
            const serializedContent = this.serializeFragment(node.content, this.getNodeProps(node, parentInfo), (0, $gJX6d.toReact)(node, {
                allowSelectAllTrap: this.allowSelectAllTrap,
                allowWindowedCodeBlock: this.allowWindowedCodeBlock
            }, this.nodeComponents), nodeKey, {
                parentIsIncompleteTask: parentIsIncompleteTask,
                path: [
                    ...currentPath,
                    node
                ],
                pos: this.startPos
            });
            this.startPos = pos + node.nodeSize;
            const marks = node.marks ? [
                ...node.marks
            ] : [];
            const isMedia = node.type.name === 'media';
            const shouldSkipBorderMark = (mark)=>currentPath.some((n)=>n.type?.name !== 'mediaSingle') && isMedia && mark.type.name === 'border';
            const shouldSkipLinkMark = (mark)=>this.allowMediaLinking !== true && isMedia && mark.type.name === 'link';
            return marks.reduceRight((content, mark)=>{
                if (shouldSkipLinkMark(mark) || shouldSkipBorderMark(mark)) return content;
                return this.renderMark((0, $GDkvY.toReact)(mark), this.withMediaMarkProps(node, mark, this.getMarkProps(mark, [], node)), `${mark.type.name}-${index}`, content);
            }, serializedContent);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.withMediaMarkProps = (node, mark, defaultProps)=>{
            if (mark.type.name === 'link' && node.type.name === 'media') return {
                ...defaultProps,
                isMediaLink: true
            };
            if (node.type.name === 'mediaInline' && mark.type.name === 'annotation') return {
                ...defaultProps,
                isMediaInline: true
            };
            return defaultProps;
        };
        this.getUnsupportedContentProps = (node)=>{
            return {
                node: node,
                dispatchAnalyticsEvent: this.fireAnalyticsEvent
            };
        };
        this.getAnnotationMarkProps = (mark, marksParentPath)=>{
            const annotationParentIds = (marksParentPath || []).reduce((acc, parent)=>{
                if ((0, $cKKwC.isAnnotationMark)(parent)) return [
                    ...acc,
                    parent.attrs.id
                ];
                return acc;
            }, []);
            return {
                id: mark.attrs.id,
                annotationType: mark.attrs.annotationType,
                annotationParentIds: annotationParentIds,
                allowAnnotations: this.allowAnnotations,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
        };
        this.getMarkProps = (mark, marksParentPath, node)=>{
            if ((0, $cKKwC.isAnnotationMark)(mark)) return this.getAnnotationMarkProps(mark, marksParentPath);
            const { key: key, ...otherAttrs } = mark.attrs;
            const extraProps = {
                isInline: node?.isInline
            };
            // currently the only mark which has custom props is the code mark
            const markSpecificProps = (0, $bVGKe.isCodeMark)(mark) ? {
                // The appearance being mobile indicates we are in an renderer being
                // rendered by mobile bridge in a web view.
                // The tooltip is likely to have unexpected behaviour there, with being cut
                // off, so we disable it. This is also to keep the behaviour consistent with
                // the rendering in the mobile Native Renderer.
                codeBidiWarningTooltipEnabled: false
            } : {};
            const props = {
                eventHandlers: this.eventHandlers,
                fireAnalyticsEvent: this.fireAnalyticsEvent,
                markKey: key,
                ...otherAttrs,
                ...extraProps,
                ...markSpecificProps,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
            return props;
        };
        if ((0, $gmhCD.editorExperiment)('comment_on_bodied_extensions', true)) {
            this.initStartPos = init.startPos || 1;
            this.startPos = init.startPos || 1;
        } else {
            this.initStartPos = 1;
            this.startPos = 1;
        }
        this.providers = init.providers;
        this.eventHandlers = init.eventHandlers;
        this.extensionHandlers = init.extensionHandlers;
        this.portal = init.portal;
        this.rendererContext = init.objectContext;
        this.appearance = init.appearance;
        this.disableHeadingIDs = init.disableHeadingIDs;
        this.disableActions = init.disableActions;
        this.allowHeadingAnchorLinks = init.allowHeadingAnchorLinks;
        this.allowCopyToClipboard = init.allowCopyToClipboard;
        this.allowWrapCodeBlock = init.allowWrapCodeBlock;
        this.allowPlaceholderText = init.allowPlaceholderText;
        this.allowCustomPanels = init.allowCustomPanels;
        this.allowColumnSorting = init.allowColumnSorting;
        this.fireAnalyticsEvent = init.fireAnalyticsEvent;
        this.shouldOpenMediaViewer = init.shouldOpenMediaViewer;
        this.allowAltTextOnImages = init.allowAltTextOnImages;
        this.stickyHeaders = init.stickyHeaders;
        this.allowMediaLinking = init.allowMediaLinking;
        this.allowAnnotations = Boolean(init.allowAnnotations);
        this.surroundTextNodesWithTextWrapper = Boolean(init.surroundTextNodesWithTextWrapper);
        this.media = init.media;
        this.emojiResourceConfig = init.emojiResourceConfig;
        this.smartLinks = init.smartLinks;
        this.allowSelectAllTrap = init.allowSelectAllTrap;
        this.nodeComponents = init.nodeComponents;
        this.allowWindowedCodeBlock = init.allowWindowedCodeBlock;
        this.isInsideOfInlineExtension = init.isInsideOfInlineExtension;
        this.textHighlighter = init.textHighlighter;
        this.allowTableAlignment = init.allowTableAlignment;
        this.allowTableResizing = init.allowTableResizing;
    }
    resetState() {
        this.headingIds = [];
        this.expandHeadingIds = [];
        this.startPos = this.initStartPos;
    }
    getNodeProps(node, parentInfo) {
        const path = parentInfo ? parentInfo.path : undefined;
        switch(node.type.name){
            case 'date':
                return this.getDateProps(node, parentInfo, path);
            case 'hardBreak':
                return this.getHardBreakProps(node, path);
            case 'heading':
                return this.getHeadingProps(node, path);
            case 'media':
                return this.getMediaProps(node, path);
            case 'emoji':
                return this.getEmojiProps(node);
            case 'mediaGroup':
                return this.getMediaGroupProps(node);
            case 'mediaInline':
                return this.getMediaInlineProps(node);
            case 'mediaSingle':
                return this.getMediaSingleProps(node, path);
            case 'table':
                return this.getTableProps(node, path);
            case 'tableHeader':
            case 'tableRow':
                return this.getTableChildrenProps(node);
            case 'taskItem':
                return this.getTaskItemProps(node, path);
            case 'embedCard':
                return this.getEmbedCardProps(node, path);
            case 'blockCard':
                return this.getBlockCardProps(node, path);
            case 'expand':
                return this.getExpandProps(node, path);
            case 'unsupportedBlock':
            case 'unsupportedInline':
                return this.getUnsupportedContentProps(node);
            case 'codeBlock':
                return this.getCodeBlockProps(node);
            case 'panel':
                return this.getPanelProps(node);
            default:
                return this.getProps(node, path);
        }
    }
    serializeFragment(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props = {}, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    target = this.allowSelectAllTrap ? (0, $5KNWO.DocWithSelectAllTrap) : (0, $5KNWO.default), key = 'root-0', parentInfo) {
        // This makes sure that we reset internal state on re-render.
        if (key === 'root-0') this.resetState();
        return this.renderNode(target, props, key, $a549b54270369c2c$export$2e2bcd8739ae039.getChildNodes(fragment).map((node, index)=>{
            if ((0, $gJX6d.isTextWrapper)(node)) return this.serializeTextWrapper(node.content, {
                index: index,
                parentInfo: parentInfo
            });
            return this.serializeFragmentChild(node, {
                index: index,
                parentInfo: parentInfo
            });
        }));
    }
    serializeTextWrapper(content, { index: index, parentInfo: parentInfo }) {
        const currentPath = parentInfo && parentInfo.path || [];
        const nodePosition = parentInfo && parentInfo.pos || 1;
        return $a549b54270369c2c$export$2e2bcd8739ae039.buildMarkStructure(content).map((mark, index)=>{
            return this.serializeMark({
                mark: mark,
                parentNode: {
                    path: currentPath,
                    pos: nodePosition
                },
                parentMark: {
                    path: [
                        mark
                    ]
                }
            });
        });
    }
    serializeMark({ mark: mark, parentNode: parentNode, parentMark: parentMark }) {
        if (!(0, $gJX6d.isTextNode)(mark)) {
            const serializeContent = (childMark, index)=>this.serializeMark({
                    mark: childMark,
                    parentNode: parentNode,
                    parentMark: {
                        path: [
                            ...parentMark.path,
                            childMark
                        ]
                    }
                });
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const content = (mark.content || []).map(serializeContent);
            const markKey = `${mark.type.name}-component__${this.startPos}__${parentMark.path.length}`;
            return this.renderMark((0, $GDkvY.toReact)(mark), this.getMarkProps(mark, parentMark.path), markKey, content);
        }
        const startPos = this.startPos;
        const endPos = startPos + mark.nodeSize;
        this.startPos = endPos;
        const textKey = `text-wrapper_${this.startPos}`;
        if (this.surroundTextNodesWithTextWrapper) {
            const parentDepth = Math.max(parentNode.path.length - 1, 0);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5BLIh.default), {
                key: textKey,
                startPos: startPos + parentDepth,
                endPos: endPos + parentDepth,
                textHighlighter: this.textHighlighter,
                marks: mark.marks
            }, mark.text);
        }
        const segments = (0, $h5tvG.segmentText)(mark.text, this.textHighlighter);
        return (0, $3VpWO.renderTextSegments)(segments, this.textHighlighter, mark.marks, startPos);
    }
    renderNode(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    NodeComponent, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NodeComponent, {
            key: key,
            ...props
        }, content));
    }
    renderMark(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    MarkComponent, props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MarkComponent, {
            key: key,
            ...props
        }, content));
    }
    getTableChildrenProps(node) {
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting
        };
    }
    getTableProps(node, path = []) {
        // TODO: https://product-fabric.atlassian.net/browse/CEMS-1048
        const stickyHeaders = !(0, $bzwTW.insideBreakoutLayout)(path) ? this.stickyHeaders : undefined;
        const isInsideOfBlockNode = (0, $bzwTW.insideBlockNode)(path, node.type.schema);
        const isInsideMultiBodiedExtension = (0, $bzwTW.insideMultiBodiedExtension)(path, node.type.schema);
        const isInsideOfTable = (0, $bzwTW.insideTable)(path, node.type.schema);
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting,
            columnWidths: // When allowTableResizing is enabled, the number of columns is required to render
            // the same scaling logic as editor. Some tables can have unequal rows, so the entire
            // table needs to be scanned.
            this.allowTableResizing && (0, $VSDnB.fg)('platform_editor_table_col_calculation_fix') ? (0, $5or39.getColumnWidths)(node) : (0, $5or39.calcTableColumnWidths)(node),
            tableNode: node,
            stickyHeaders: stickyHeaders,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfTable: isInsideOfTable,
            isInsideMultiBodiedExtension: isInsideMultiBodiedExtension,
            allowTableAlignment: this.allowTableAlignment,
            allowTableResizing: this.allowTableResizing
        };
    }
    getDateProps(node, parentInfo, path = []) {
        return {
            timestamp: node.attrs && node.attrs.timestamp,
            parentIsIncompleteTask: parentInfo && parentInfo.parentIsIncompleteTask,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': this.startPos + path.length
            }
        };
    }
    getMediaSingleProps(node, path = []) {
        const { marks: { link: link } } = node.type.schema;
        const isInsideOfBlockNode = (0, $bzwTW.insideBlockNode)(path, node.type.schema);
        const isLinkMark = (mark)=>mark.type === link;
        const childHasLink = node.firstChild && node.firstChild.marks.filter((m)=>isLinkMark(m) || this.allowMediaLinking === true).length;
        return {
            ...this.getProps(node, path),
            isInsideOfBlockNode: isInsideOfBlockNode,
            childHasLink: childHasLink,
            allowCaptions: this.media && this.media.allowCaptions,
            featureFlags: this.media && this.media.featureFlags
        };
    }
    getMediaProps(node, path = []) {
        const { marks: { annotation: annotation, link: link, border: border } } = node.type.schema;
        const isChildOfMediaSingle = path.some((n)=>n.type?.name === 'mediaSingle');
        const isAnnotationMark = (mark)=>mark.type === annotation;
        const isLinkMark = (mark)=>mark.type === link;
        const isBorderMark = (mark)=>isChildOfMediaSingle && mark.type === border;
        return {
            ...this.getProps(node, path),
            marks: node.marks.filter((m)=>!isLinkMark(m) || this.allowMediaLinking === true),
            isLinkMark: isLinkMark,
            isBorderMark: isBorderMark,
            isAnnotationMark: isAnnotationMark,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            ssr: this.media?.ssr,
            // surroundTextNodesWithTextWrapper checks inlineComment.allowDraftMode
            allowAnnotationsDraftMode: this.surroundTextNodesWithTextWrapper
        };
    }
    getEmojiProps(node) {
        return {
            ...this.getProps(node),
            resourceConfig: this.emojiResourceConfig
        };
    }
    getEmbedCardProps(node, path = []) {
        const isInsideOfBlockNode = (0, $bzwTW.insideBlockNode)(path, node.type.schema);
        return {
            ...this.getProps(node),
            isInsideOfBlockNode: isInsideOfBlockNode
        };
    }
    getBlockCardProps(node, path = []) {
        return {
            ...this.getProps(node),
            isNodeNested: path.length > 0
        };
    }
    getMediaGroupProps(node) {
        return {
            ...this.getProps(node),
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            enableDownloadButton: this.media?.enableDownloadButton,
            ssr: this.media?.ssr
        };
    }
    getMediaInlineProps(node) {
        return {
            ...this.getProps(node),
            ssr: this.media?.ssr
        };
    }
    getTaskItemProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            disabled: this.disableActions
        };
    }
    getHardBreakProps(node, path = []) {
        let forceNewLine = false;
        const parentNode = path.length > 0 ? path[path.length - 1] : null;
        if (parentNode && parentNode.lastChild === node) forceNewLine = true;
        return {
            ...this.getProps(node),
            forceNewLine: forceNewLine
        };
    }
    getCodeBlockProps(node) {
        // The appearance being mobile indicates we are in an renderer being
        // rendered by mobile bridge in a web view.
        // The tooltip is likely to have unexpected behaviour there, with being cut
        // off, so we disable it. This is also to keep the behaviour consistent with
        // the rendering in the mobile Native Renderer.
        const codeBidiWarningTooltipEnabled = false;
        return {
            ...this.getProps(node),
            text: node.textContent,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        };
    }
    getPanelProps(node) {
        return {
            ...this.getProps(node),
            allowCustomPanels: this.allowCustomPanels
        };
    }
    getProps(node, path = []) {
        const startPos = this.startPos + path.length;
        return {
            text: node.text,
            providers: this.providers,
            eventHandlers: this.eventHandlers,
            extensionHandlers: this.extensionHandlers,
            portal: this.portal,
            rendererContext: this.rendererContext,
            serializer: this,
            content: node.content ? node.content.toJSON() : undefined,
            allowHeadingAnchorLinks: this.allowHeadingAnchorLinks,
            allowCopyToClipboard: this.allowCopyToClipboard,
            allowWrapCodeBlock: this.allowWrapCodeBlock,
            allowPlaceholderText: this.allowPlaceholderText,
            rendererAppearance: this.appearance,
            fireAnalyticsEvent: this.fireAnalyticsEvent,
            nodeType: node.type.name,
            marks: node.marks,
            smartLinks: this.smartLinks,
            isInsideOfInlineExtension: this.isInsideOfInlineExtension,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': startPos
            },
            startPos: startPos,
            path: path,
            ...node.attrs
        };
    }
    headingAnchorSupported(path = []) {
        const isImmediateParent = (path, nodeName)=>{
            return path.length > 0 && path[path.length - 1].type.name === nodeName;
        };
        return (0, $3kKuL.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks) || path.length === 0 || isImmediateParent(path, 'layoutColumn');
    }
    getHeadingProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            content: node.content ? node.content.toJSON() : undefined,
            headingId: this.getHeadingId(node, this.headingIds),
            showAnchorLink: this.appearance !== 'comment' && this.allowHeadingAnchorLinks && !this.disableHeadingIDs && this.headingAnchorSupported(path)
        };
    }
    getExpandProps(node, path = []) {
        if (!(0, $3kKuL.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks)) return this.getProps(node);
        const nestedHeaderIds = (0, $9dTMW.findChildrenByType)(node, node.type.schema.nodes.heading).map(({ node: node })=>this.getHeadingId(node, this.expandHeadingIds));
        return {
            ...this.getProps(node),
            nestedHeaderIds: nestedHeaderIds
        };
    }
    // The return value of this function is NOT url encoded,
    // In HTML5 standard, id can contain any characters, encoding is no necessary.
    // Plus we trying to avoid double encoding, therefore we leave the value as is.
    // Remember to use encodeURIComponent when generating url from the id value.
    getHeadingId(node, headingIds) {
        if (this.disableHeadingIDs || !node.content.size) return;
        // We are not use node.textContent here, because we would like to handle cases where
        // headings only contain inline blocks like emoji, status and date.
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const nodeContent = node.content.toJSON()// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((acc, node)=>acc.concat((0, $K5Jsy.getText)(node) || ''), '').trim()// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/\s/g, '-');
        if (!nodeContent) return;
        return this.getUniqueHeadingId(nodeContent, headingIds);
    }
    getUniqueHeadingId(baseId, headingIds, counter = 0) {
        if (counter === 0 && headingIds.indexOf(baseId) === -1) {
            headingIds.push(baseId);
            return baseId;
        } else if (counter !== 0) {
            const headingId = `${baseId}.${counter}`;
            if (headingIds.indexOf(headingId) === -1) {
                headingIds.push(headingId);
                return headingId;
            }
        }
        return this.getUniqueHeadingId(baseId, headingIds, ++counter);
    }
    static getChildNodes(fragment) {
        const children = [];
        fragment.forEach((node)=>{
            children.push(node);
        });
        return (0, $gJX6d.mergeTextNodes)(children);
    }
    static getMarks(node) {
        if (!node.marks || node.marks.length === 0) return [];
        return (0, $eQNWQ.getMarksByOrder)(node.marks);
    }
    static buildMarkStructure(content) {
        return $a549b54270369c2c$var$mergeMarks(content.map((node)=>{
            const nodeMarks = this.getMarks(node);
            if (nodeMarks.length === 0) return node;
            return nodeMarks.reverse().reduce((acc, mark)=>{
                const { eq: eq } = mark;
                return {
                    ...mark,
                    eq: eq,
                    content: [
                        acc
                    ]
                };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }, node);
        }));
    }
    // TODO: ED-9004 Remove unused ReactSerializer.fromSchema in renderer
    // https://sourcegraph-frontend.internal.shared-prod.us-west-2.kitt-inf.net/search?q=ReactSerializer.fromSchema&patternType=literal
    static fromSchema(_, init) {
        return new $a549b54270369c2c$export$2e2bcd8739ae039(init);
    }
}

});
parcelRegister("3kKuL", function(module, exports) {

$parcel$export(module.exports, "isNestedHeaderLinksEnabled", () => $e845fca6b21fd822$export$7aa7587d1ce9583c);
$parcel$export(module.exports, "getActiveHeadingId", () => $e845fca6b21fd822$export$acb253d79d72af92);
function $e845fca6b21fd822$export$7aa7587d1ce9583c(allowHeadingAnchorLinks) {
    // If it's a boolean or undefined, then we don't support nesting.
    if (!allowHeadingAnchorLinks || typeof allowHeadingAnchorLinks === 'boolean') return false;
    const { allowNestedHeaderLinks: allowNestedHeaderLinks } = allowHeadingAnchorLinks;
    // Explicit cast to a boolean to cover scenario where it's undefined.
    return !!allowNestedHeaderLinks;
}
function $e845fca6b21fd822$export$acb253d79d72af92(allowHeadingAnchorLinks) {
    if (!$e845fca6b21fd822$export$7aa7587d1ce9583c(allowHeadingAnchorLinks)) return undefined;
    return allowHeadingAnchorLinks.activeHeadingId;
}

});

parcelRegister("gJX6d", function(module, exports) {

$parcel$export(module.exports, "InlineCard", () => $2b5167c1d6aa176d$export$aff6291803939b05);
$parcel$export(module.exports, "nodeToReact", () => $2b5167c1d6aa176d$export$3931063f6a5f290e);
$parcel$export(module.exports, "toReact", () => $2b5167c1d6aa176d$export$d4334b129116aad7);
$parcel$export(module.exports, "mergeTextNodes", () => $2b5167c1d6aa176d$export$8045509d14b5046f);
$parcel$export(module.exports, "isTextWrapper", () => $2b5167c1d6aa176d$export$d4ebd3557ee7fac1);
$parcel$export(module.exports, "isTextNode", () => $2b5167c1d6aa176d$export$ccbedd67ef6e9417);
$parcel$export(module.exports, "Doc", () => (parcelRequire("5KNWO")).default);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => (parcelRequire("5KNWO")).DocWithSelectAllTrap);
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $4qBtX = parcelRequire("4qBtX");

var $atrOQ = parcelRequire("atrOQ");

var $4dtZR = parcelRequire("4dtZR");

var $bQeYo = parcelRequire("bQeYo");

var $cOnYv = parcelRequire("cOnYv");

var $cWRvh = parcelRequire("cWRvh");

var $5KNWO = parcelRequire("5KNWO");

var $i8Zwf = parcelRequire("i8Zwf");

var $lKIDi = parcelRequire("lKIDi");

var $7AttJ = parcelRequire("7AttJ");

var $112O7 = parcelRequire("112O7");

var $ieJGA = parcelRequire("ieJGA");

var $3RqVz = parcelRequire("3RqVz");

var $qjsNK = parcelRequire("qjsNK");

var $jHa9U = parcelRequire("jHa9U");

var $6svWT = parcelRequire("6svWT");

var $9FXQX = parcelRequire("9FXQX");

var $hqBb9 = parcelRequire("hqBb9");

var $ixoQV = parcelRequire("ixoQV");

var $dkc63 = parcelRequire("dkc63");

var $cWojJ = parcelRequire("cWojJ");

var $i4Lgj = parcelRequire("i4Lgj");

var $gfMkN = parcelRequire("gfMkN");

var $iiXGq = parcelRequire("iiXGq");
var $9kpKZ = parcelRequire("9kpKZ");

const $2b5167c1d6aa176d$export$a22ee8f907eecb5f = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("b7uH5")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$6c415d1fdae3dfdb = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("4nigH")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$771a55a10b0a40ae = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("jjsQN")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$27c4189b8be1bf93 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("0K8mZ")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$b458dfa720128865 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("k7Zs2")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$b6f73a2b0b0de599 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("aNesC")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$6341f9a885713487 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("57OMq")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$96e9906d6d93a972 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("bfPot")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$56cc48506ff790a = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("7mtWi")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$2ddb90ad54e5f587 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("cyYfQ")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$6789d7ecdc77631b = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("bat28")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$aff6291803939b05 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("iyg8s")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$d18ccd25c0d2c6b0 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("gQJy5")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$7fc53215244aec38 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("7UIjK")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$d7858be3df00d59 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("lmZTQ")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$462ea7c2a1c4cb1f = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("4kfHt")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$888d74bc001c3a5d = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("hPQIC")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$e891316fea657d90 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("3ceee")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$49bd1dfb0ad29c40 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("bbv0R")).then((mod)=>mod.default),
    loading: ()=>null
});
const $2b5167c1d6aa176d$export$3931063f6a5f290e = {
    blockquote: (0, $atrOQ.default),
    bulletList: (0, $cWRvh.default),
    blockCard: $2b5167c1d6aa176d$export$d18ccd25c0d2c6b0,
    caption: (0, $jHa9U.default),
    date: $2b5167c1d6aa176d$export$6341f9a885713487,
    decisionItem: $2b5167c1d6aa176d$export$b6f73a2b0b0de599,
    decisionList: $2b5167c1d6aa176d$export$b458dfa720128865,
    doc: (0, $5KNWO.default),
    emoji: $2b5167c1d6aa176d$export$56cc48506ff790a,
    extension: (0, $i8Zwf.default),
    bodiedExtension: (0, $4dtZR.default),
    multiBodiedExtension: (0, $bQeYo.default),
    extensionFrame: (0, $cOnYv.default),
    hardBreak: (0, $lKIDi.default),
    heading: (0, $7AttJ.default),
    inlineCard: $2b5167c1d6aa176d$export$aff6291803939b05,
    inlineExtension: (0, $112O7.default),
    layoutSection: (0, $ieJGA.default),
    layoutColumn: (0, $3RqVz.default),
    listItem: (0, $qjsNK.default),
    media: $2b5167c1d6aa176d$export$7fc53215244aec38,
    mediaGroup: $2b5167c1d6aa176d$export$d7858be3df00d59,
    mediaInline: $2b5167c1d6aa176d$export$462ea7c2a1c4cb1f,
    mediaSingle: $2b5167c1d6aa176d$export$888d74bc001c3a5d,
    mention: $2b5167c1d6aa176d$export$e891316fea657d90,
    orderedList: (0, $6svWT.default),
    panel: $2b5167c1d6aa176d$export$2ddb90ad54e5f587,
    paragraph: (0, $9FXQX.default),
    placeholder: (0, $hqBb9.default),
    rule: (0, $ixoQV.default),
    status: $2b5167c1d6aa176d$export$96e9906d6d93a972,
    taskItem: $2b5167c1d6aa176d$export$27c4189b8be1bf93,
    taskList: $2b5167c1d6aa176d$export$771a55a10b0a40ae,
    table: (0, $dkc63.default),
    tableCell: (0, $cWojJ.TableCell),
    tableHeader: (0, $cWojJ.TableHeader),
    tableRow: (0, $i4Lgj.default),
    unknownBlock: (0, $gfMkN.default),
    unsupportedBlock: (0, $iiXGq.default),
    unsupportedInline: (0, $9kpKZ.default),
    expand: $2b5167c1d6aa176d$export$49bd1dfb0ad29c40,
    nestedExpand: $2b5167c1d6aa176d$export$49bd1dfb0ad29c40,
    embedCard: $2b5167c1d6aa176d$export$6789d7ecdc77631b
};
const $2b5167c1d6aa176d$export$d4334b129116aad7 = (node, flags, nodeComponents)=>{
    if (node.type.name === 'doc' && flags?.allowSelectAllTrap === true) return 0, $5KNWO.DocWithSelectAllTrap;
    if (node.type.name === 'codeBlock') {
        if (flags?.allowWindowedCodeBlock === true) return $2b5167c1d6aa176d$export$a22ee8f907eecb5f;
        return $2b5167c1d6aa176d$export$6c415d1fdae3dfdb;
    }
    // Allowing custom components to override those provided in nodeToReact
    const nodes = {
        ...$2b5167c1d6aa176d$export$3931063f6a5f290e,
        ...nodeComponents
    };
    return nodes[node.type.name];
};
const $2b5167c1d6aa176d$export$8045509d14b5046f = (nodes)=>{
    return nodes.reduce((acc, current)=>{
        if (!$2b5167c1d6aa176d$export$1879817ac5c922b7(current.type.name)) {
            acc.push(current);
            return acc;
        }
        // Append node to previous node, if it was a text wrapper
        if (acc.length > 0 && $2b5167c1d6aa176d$export$d4ebd3557ee7fac1(acc[acc.length - 1])) {
            const textWrapper = acc[acc.length - 1];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            textWrapper.content.push(current);
            textWrapper.nodeSize += current.nodeSize;
        } else acc.push({
            type: {
                name: 'textWrapper'
            },
            content: [
                current
            ],
            nodeSize: current.nodeSize
        });
        return acc;
    }, []);
};
const $2b5167c1d6aa176d$export$1879817ac5c922b7 = (type)=>{
    return type === 'text';
};
const $2b5167c1d6aa176d$export$d4ebd3557ee7fac1 = (node)=>{
    return node.type.name === 'textWrapper';
};
function $2b5167c1d6aa176d$export$ccbedd67ef6e9417(node) {
    return node.type.name === 'text';
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $2b5167c1d6aa176d$var$whitespaceRegex = /^\s*$/;
const $2b5167c1d6aa176d$export$dd0c7365db1f79a5 = (doc)=>{
    if (doc.childCount !== 1) return false;
    const parentNodes = [];
    doc.forEach((child)=>parentNodes.push(child));
    const node = parentNodes[0];
    return node.type.name === 'paragraph' && $2b5167c1d6aa176d$var$isEmojiBlock(node.content);
};
const $2b5167c1d6aa176d$var$isEmojiBlock = (pnode)=>{
    const content = [];
    // Optimisation for long documents - worst case block will be space-emoji-space
    if (pnode.childCount > 7) return false;
    pnode.forEach((child)=>content.push(child));
    let emojiCount = 0;
    for(let i = 0; i < content.length; ++i){
        const node = content[i];
        switch(node.type.name){
            case 'text':
                if (node.text && !node.text.match($2b5167c1d6aa176d$var$whitespaceRegex)) return false;
                continue;
            case 'emoji':
                if (++emojiCount > 3) return false;
                continue;
            default:
                // Only text and emoji nodes are allowed
                return false;
        }
    }
    return emojiCount > 0;
};

});
parcelRegister("atrOQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d51d57a125840f5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $8d51d57a125840f5$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("blockquote", null, props.children);
}

});

parcelRegister("4dtZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9e9d2beaec6b895$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $i8Zwf = parcelRequire("i8Zwf");

var $8Eu7T = parcelRequire("8Eu7T");

var $fAZXL = parcelRequire("fAZXL");

var $cWCI0 = parcelRequire("cWCI0");

var $gkwXh = parcelRequire("gkwXh");

var $4YrGg = parcelRequire("4YrGg");
const $b9e9d2beaec6b895$var$BodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [], extensionKey: extensionKey, extensionType: extensionType } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children)// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Eu7T.ErrorBoundary), {
        component: (0, $cWCI0.ACTION_SUBJECT).RENDERER,
        componentId: (0, $gkwXh.ACTION_SUBJECT_ID).EXTENSION_BODIED,
        createAnalyticsEvent: createAnalyticsEvent,
        additionalInfo: `${extensionType}: ${extensionKey} `
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YrGg.AnnotationsPositionContext).Provider, {
        value: {
            startPos: props.startPos + 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fAZXL.default), {
        ...props,
        type: "bodiedExtension"
    }, ({ result: result })=>{
        try {
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
            return (0, $i8Zwf.renderExtension)(result, layout, {
                isTopLevel: path.length < 1
            }, removeOverflow);
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return (0, $i8Zwf.renderExtension)(children, layout, {
            isTopLevel: path.length < 1
        }, removeOverflow);
    })));
};
var $b9e9d2beaec6b895$export$2e2bcd8739ae039 = $b9e9d2beaec6b895$var$BodiedExtension;

});
parcelRegister("i8Zwf", function(module, exports) {

$parcel$export(module.exports, "renderExtension", () => $1a97cbb70a611ae8$export$b7482bdc8aff85e4);
$parcel$export(module.exports, "default", () => $1a97cbb70a611ae8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fAZXL = parcelRequire("fAZXL");

var $ajc8Z = parcelRequire("ajc8Z");
var $4ceoy = parcelRequire("4ceoy");

var $eOOFp = parcelRequire("eOOFp");

var $l8Gxi = parcelRequire("l8Gxi");
const $1a97cbb70a611ae8$export$b7482bdc8aff85e4 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
content, layout, options = {}, removeOverflow)=>{
    const overflowContainerClass = !removeOverflow ? (0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    // by default, we assume the extension is at top level, (direct child of doc node)
    const { isTopLevel: isTopLevel = true } = options || {};
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $l8Gxi.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4ceoy.WidthConsumer), null, ({ width: width })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            ref: options.handleRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $l8Gxi.RendererCssClassName).EXTENSION} ${options.shadowClassNames} ${centerAlignClass}`,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                width: isTopLevel ? (0, $eOOFp.calcBreakoutWidth)(layout, width) : '100%'
            },
            "data-layout": layout
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: overflowContainerClass
        }, content)));
};
const $1a97cbb70a611ae8$var$Extension = (props)=>{
    const { text: text, layout: layout = 'default', handleRef: handleRef, shadowClassNames: shadowClassNames, path: path = [] } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fAZXL.default), {
        ...props,
        type: "extension"
    }, ({ result: result })=>{
        try {
            // Return the result directly if it's a valid JSX.Element
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(result)) return $1a97cbb70a611ae8$export$b7482bdc8aff85e4(result, layout, {
                isTopLevel: path.length < 1,
                handleRef: handleRef,
                shadowClassNames: shadowClassNames
            });
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return $1a97cbb70a611ae8$export$b7482bdc8aff85e4(text || 'extension', layout, {
            isTopLevel: path.length < 1,
            handleRef: handleRef,
            shadowClassNames: shadowClassNames
        });
    });
};
var $1a97cbb70a611ae8$export$2e2bcd8739ae039 = (0, $ajc8Z.default)($1a97cbb70a611ae8$var$Extension, {
    overflowSelector: `.${(0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
});

});
parcelRegister("fAZXL", function(module, exports) {

$parcel$export(module.exports, "default", () => $45cce7a6859f4709$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $gnH2s = parcelRequire("gnH2s");

var $9Egzu = parcelRequire("9Egzu");

var $2vGdQ = parcelRequire("2vGdQ");
const $45cce7a6859f4709$var$inlineExtensionStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-block',
    maxWidth: '100%',
    verticalAlign: 'middle',
    // es-lint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: `1px 1px ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& .rich-media-item': {
        maxWidth: '100%'
    }
});
function $45cce7a6859f4709$export$2e2bcd8739ae039(props) {
    const { extensionHandlers: extensionHandlers, rendererContext: rendererContext, extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, content: content, text: text, type: type, localId: localId, marks: marks, actions: actions, children: children } = props;
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>(0, $8QpSo.default)((0, $gnH2s.getNodeRenderer)), []);
    const [extensionProvider, setExtensionProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(null);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleProvider = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((name, providerPromise)=>{
        providerPromise && providerPromise.then((provider)=>{
            if (isMounted.current) setExtensionProvider(provider);
        });
    }, []);
    const renderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((extensionProvider)=>{
        const fragmentLocalId = marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
        const node = {
            type: type,
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content || text,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        let result = null;
        try {
            if (extensionHandlers && extensionHandlers[extensionType]) {
                const render = (0, $2vGdQ.getExtensionRenderer)(extensionHandlers[extensionType]);
                result = render(node, rendererContext.adDoc);
            }
            if (!result && extensionProvider) {
                const NodeRenderer = localGetNodeRenderer(extensionProvider, extensionType, extensionKey);
                if (node.type === 'multiBodiedExtension') result = /*#__PURE__*/ (0, $f8Sb3.jsx)(NodeRenderer, {
                    node: node,
                    actions: actions
                });
                else if (node.type === 'inlineExtension') result = /*#__PURE__*/ (0, $f8Sb3.jsx)($45cce7a6859f4709$var$InlineNodeRendererWrapper, null, /*#__PURE__*/ (0, $f8Sb3.jsx)(NodeRenderer, {
                    node: node
                }));
                else result = /*#__PURE__*/ (0, $f8Sb3.jsx)(NodeRenderer, {
                    node: node
                });
            }
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        return children({
            result: result
        });
    }, [
        actions,
        children,
        content,
        extensionHandlers,
        extensionKey,
        extensionType,
        localGetNodeRenderer,
        localId,
        marks,
        parameters,
        rendererContext?.adDoc,
        text,
        type
    ]);
    const setupAndRenderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((providers)=>{
        if (!extensionProvider && providers.extensionProvider) handleProvider('extensionProvider', providers.extensionProvider);
        return renderExtensionNode(extensionProvider);
    }, [
        extensionProvider,
        handleProvider,
        renderExtensionNode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    if (!props.providers) return setupAndRenderExtensionNode({});
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9Egzu.WithProviders), {
        providers: [
            'extensionProvider'
        ],
        providerFactory: props.providers,
        renderNode: setupAndRenderExtensionNode
    });
}
const $45cce7a6859f4709$var$InlineNodeRendererWrapper = ({ children: children })=>{
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        className: "inline-extension-renderer",
        css: $45cce7a6859f4709$var$inlineExtensionStyle
    }, children));
};

});
parcelRegister("gnH2s", function(module, exports) {

$parcel$export(module.exports, "getExtensionModuleNode", () => $36d4284a17bc60a0$export$82dd45c2db936caf);
$parcel$export(module.exports, "getExtensionModuleNodePrivateProps", () => $36d4284a17bc60a0$export$426f8efd8690d8aa);
$parcel$export(module.exports, "getNodeRenderer", () => $36d4284a17bc60a0$export$67a7d49db68d30a0);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $izxHQ = parcelRequire("izxHQ");
async function $36d4284a17bc60a0$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $izxHQ.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = await extensionProvider.getExtension(extensionType, extKey);
    if (!manifest) throw new Error(`Extension with key "${extKey}" and type "${extensionType}" not found!`);
    if (!manifest.modules.nodes) throw new Error(`Couldn't find any node for extension type "${extensionType}" and key "${extensionKey}"!`);
    const node = manifest.modules.nodes[nodeKey];
    if (!node) throw new Error(`Node with key "${extensionKey}" not found on manifest for extension type "${extensionType}" and key "${extensionKey}"!`);
    return node;
}
async function $36d4284a17bc60a0$export$426f8efd8690d8aa(extensionProvider, extensionType, extensionKey) {
    const moduleNode = await $36d4284a17bc60a0$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey);
    return Object.keys(moduleNode).filter((key)=>key.startsWith('__')).reduce((acc, key)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        acc[key] = moduleNode[key];
        return acc;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }, {});
}
function $36d4284a17bc60a0$var$ExtensionLoading(props) {
    if (props.error || props.timedOut) {
        // eslint-disable-next-line no-console
        console.error('Error rendering extension', props.error);
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            children: "Error loading the extension!"
        });
    } else return null;
}
function $36d4284a17bc60a0$export$67a7d49db68d30a0(extensionProvider, extensionType, extensionKey) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>{
            return $36d4284a17bc60a0$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey).then((node)=>(0, $izxHQ.resolveImport)(node.render()));
        },
        loading: $36d4284a17bc60a0$var$ExtensionLoading
    });
}

});
parcelRegister("izxHQ", function(module, exports) {

$parcel$export(module.exports, "getExtensionKeyAndNodeKey", () => $23c4e3f9598df846$export$8a49818572e1d105);
$parcel$export(module.exports, "buildAction", () => $23c4e3f9598df846$export$bb33bcdd9a10a608);
$parcel$export(module.exports, "resolveImport", () => $23c4e3f9598df846$export$d69c9b451c47653b);
const $23c4e3f9598df846$export$a7d04c836550045a = 'com.atlassian.ecosystem';
const $23c4e3f9598df846$export$8a49818572e1d105 = (extensionKey, extensionType)=>{
    // Forge macro extensionKey has a user generated string, so splitting on
    // a colon is unstable for their particular use case. They only have one
    // node in the relevant manifest so we can hardcode nodeKey to 'default'.
    if (extensionType === $23c4e3f9598df846$export$a7d04c836550045a) return [
        extensionKey,
        'default'
    ];
    const [extKey, nodeKey = 'default'] = extensionKey.split(':');
    return [
        extKey,
        nodeKey
    ];
};
const $23c4e3f9598df846$export$5f3eb042babacbbd = (extensionKey, nodeKey)=>{
    if (!nodeKey || nodeKey === 'default') return extensionKey;
    return `${extensionKey}:${nodeKey}`;
};
function $23c4e3f9598df846$export$bb33bcdd9a10a608(action, manifest) {
    if (typeof action === 'function') return action;
    if (action.type === 'node' && manifest.modules.nodes) return $23c4e3f9598df846$export$33863d887d6f4bfd(action, manifest);
}
const $23c4e3f9598df846$export$d69c9b451c47653b = async (importPromise)=>{
    const importedModule = await importPromise;
    return importedModule && importedModule.__esModule ? importedModule.default : importedModule;
};
function $23c4e3f9598df846$export$33863d887d6f4bfd(action, manifest) {
    if (!manifest.modules.nodes) return;
    const node = manifest.modules.nodes[action.key];
    const extensionKey = $23c4e3f9598df846$export$5f3eb042babacbbd(manifest.key, action.key);
    const extension = {
        type: node.type,
        attrs: {
            extensionType: manifest.type,
            extensionKey: extensionKey,
            parameters: action.parameters
        }
    };
    if (node.type === 'bodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    };
    else if (node.type === 'multiBodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'extensionFrame',
                content: [
                    {
                        type: 'paragraph',
                        content: []
                    }
                ]
            }
        ]
    };
    return extension;
}

});


parcelRegister("9Egzu", function(module, exports) {

$parcel$export(module.exports, "WithProviders", () => $76144329c6f313cf$export$d498ee8be33e096f);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
class $76144329c6f313cf$export$d498ee8be33e096f extends (0, $5uXOq.PureComponent) {
    static{
        this.displayName = 'WithProviders';
    }
    constructor(props){
        super(props), this.mounted = false, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProviderIfMounted = (name, provider)=>{
            if (!this.mounted) return;
            this.handleProvider(name, provider);
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProvider = (name, provider)=>{
            this.setState(({ providers: providers })=>{
                return {
                    providers: {
                        ...providers,
                        [name]: provider
                    }
                };
            });
        };
        this.mounted = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const providers = {};
        this.props.providers.forEach((name)=>{
            if ((0, $VSDnB.fg)('platform_editor_react18_phase2_v2')) {
                const providerPromise = props.providerFactory.subscribe(name, this.handleProviderIfMounted);
                providers[name] = providerPromise;
            } else providers[name] = undefined;
        });
        this.state = {
            providers: providers
        };
    }
    componentDidMount() {
        this.mounted = true;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line react/no-unsafe
    UNSAFE_componentWillMount() {
        if (!(0, $VSDnB.fg)('platform_editor_react18_phase2_v2')) {
            const { providers: providers, providerFactory: providerFactory } = this.props;
            providers.forEach((name)=>{
                providerFactory.subscribe(name, this.handleProvider);
            });
        }
    }
    componentWillUnmount() {
        const { providers: providers, providerFactory: providerFactory } = this.props;
        providers.forEach((name)=>{
            providerFactory.unsubscribe(name, this.handleProvider);
        });
    }
    render() {
        const { state: state, props: props } = this;
        const { renderNode: renderNode } = props;
        return renderNode(state.providers);
    }
}

});

parcelRegister("2vGdQ", function(module, exports) {

$parcel$export(module.exports, "getExtensionRenderer", () => $f7ce50c6d2d400b7$export$9214452ef07eda7);
function $f7ce50c6d2d400b7$export$9214452ef07eda7(extensionHandler) {
    if (typeof extensionHandler === 'object') return extensionHandler.render;
    else return extensionHandler;
}

});


parcelRegister("ajc8Z", function(module, exports) {

$parcel$export(module.exports, "shadowClassNames", () => $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5);
$parcel$export(module.exports, "default", () => $0d6cb6e0383d0ba0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bbl9Y = parcelRequire("bbl9Y");
const $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5 = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow'
};
function $0d6cb6e0383d0ba0$export$2e2bcd8739ae039(Component, options) {
    return class OverflowShadow extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        componentWillUnmount() {
            if (options.useShadowObserver) return this.shadowObserver && this.shadowObserver.dispose();
            if (this.overflowContainer) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowContainer.removeEventListener('scroll', this.handleScroll);
            this.updateShadows();
        }
        componentDidUpdate() {
            if (!options.useShadowObserver) this.updateShadows();
        }
        initShadowObserver() {
            if (this.shadowObserver || !this.overflowContainer) return;
            this.shadowObserver = new (0, $bbl9Y.ShadowObserver)({
                scrollContainer: this.overflowContainer,
                onUpdateShadows: (shadowStates)=>{
                    this.setState((prevState)=>{
                        const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = shadowStates;
                        if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== prevState.showRightShadow) return {
                            showLeftShadow: showLeftShadow,
                            showRightShadow: showRightShadow
                        };
                        return null;
                    });
                }
            });
        }
        render() {
            const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = this.state;
            const classNames = [
                showRightShadow && $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5.RIGHT_SHADOW,
                showLeftShadow && $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5.LEFT_SHADOW,
                options.useShadowObserver && (0, $bbl9Y.shadowObserverClassNames).SHADOW_CONTAINER
            ].filter(Boolean).join(' ');
            return(// Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                handleRef: this.handleContainer,
                shadowClassNames: classNames,
                ...this.props
            }));
        }
        constructor(...args){
            super(...args), this.overflowContainerWidth = 0, this.state = {
                showLeftShadow: false,
                showRightShadow: false
            }, this.handleScroll = (event)=>{
                if (!this.overflowContainer || event.target !== this.overflowContainer || options.useShadowObserver) return;
                this.updateShadows();
            }, this.updateShadows = ()=>{
                if (options.useShadowObserver) return;
                this.setState((prevState)=>{
                    if (!this.overflowContainer) return;
                    const diff = this.calcOverflowDiff();
                    const showRightShadow = diff > 0 && diff > this.overflowContainer.scrollLeft;
                    const showLeftShadow = this.showLeftShadow(this.overflowContainer);
                    if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== this.state.showRightShadow) return {
                        showLeftShadow: showLeftShadow,
                        showRightShadow: showRightShadow
                    };
                    return null;
                });
            }, this.showLeftShadow = (overflowContainer)=>{
                return !!overflowContainer && overflowContainer.scrollLeft > 0;
            }, this.calcOverflowDiff = ()=>{
                if (!this.overflowContainer) return 0;
                this.diff = this.calcScrollableWidth();
                return this.diff - this.overflowContainer.offsetWidth;
            }, this.calcScrollableWidth = ()=>{
                if (!this.scrollable && this.overflowContainer) return this.overflowContainer.scrollWidth;
                if (!this.scrollable) return 0;
                let width = 0;
                for(let i = 0; i < this.scrollable.length; i++){
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const scrollableElement = this.scrollable[i];
                    width += scrollableElement.scrollWidth;
                }
                return width;
            }, this.handleContainer = (container)=>{
                if (!container || this.container) return;
                this.container = container;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                this.overflowContainer = container.querySelector(options.overflowSelector);
                if (!this.overflowContainer) this.overflowContainer = container;
                if (options.useShadowObserver) {
                    this.initShadowObserver();
                    return;
                }
                this.updateShadows();
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.overflowContainer.addEventListener('scroll', this.handleScroll);
            };
        }
    };
}

});
parcelRegister("bbl9Y", function(module, exports) {

$parcel$export(module.exports, "shadowObserverClassNames", () => $cd027df5593f4e8b$export$1cbe0bb16052178d);
$parcel$export(module.exports, "ShadowObserver", () => $cd027df5593f4e8b$export$51a5b28e4fb2dba2);
var $cd027df5593f4e8b$export$ebeea2fe2e93862e = /*#__PURE__*/ function(ShadowKeys) {
    ShadowKeys["SHOW_LEFT_SHADOW"] = "showLeftShadow";
    ShadowKeys["SHOW_RIGHT_SHADOW"] = "showRightShadow";
    return ShadowKeys;
}({});
const $cd027df5593f4e8b$export$1cbe0bb16052178d = {
    SENTINEL_LEFT: 'sentinel-left',
    SENTINEL_RIGHT: 'sentinel-right',
    SHADOW_CONTAINER: 'with-shadow-observer'
};
const $cd027df5593f4e8b$var$requestIdleCallback = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.requestIdleCallback ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn) : window.requestAnimationFrame(fn);
};
const $cd027df5593f4e8b$var$cancelIdleCallback = (id)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.cancelIdleCallback ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.cancelIdleCallback(id) : window.cancelAnimationFrame(id);
};
class $cd027df5593f4e8b$export$51a5b28e4fb2dba2 {
    constructor({ scrollContainer: scrollContainer, onUpdateShadows: onUpdateShadows }){
        this.sentinels = {};
        this.shadowStates = {
            ["showLeftShadow"]: false,
            ["showRightShadow"]: false
        };
        this.init = ()=>{
            if (!this.scrollContainer || this.intersectionObserver) return;
            this.sentinels.right = document.createElement('div');
            this.sentinels.right.classList.add($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_RIGHT);
            this.scrollContainer.appendChild(this.sentinels.right);
            this.sentinels.left = document.createElement('div');
            this.sentinels.left.classList.add($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_LEFT);
            this.scrollContainer.prepend(this.sentinels.left);
            this.intersectionObserver = new IntersectionObserver((entries, _)=>{
                entries.forEach(this.onIntersect);
            }, {
                root: this.scrollContainer,
                rootMargin: '1px'
            });
            this.intersectionObserver.observe(this.sentinels.left);
            this.intersectionObserver.observe(this.sentinels.right);
        };
        this.onIntersect = (entry)=>{
            this.requestCallbackId = $cd027df5593f4e8b$var$requestIdleCallback(()=>{
                if (entry.target.classList.contains($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_LEFT)) this.shadowStates["showLeftShadow"] = !entry.isIntersecting;
                if (entry.target.classList.contains($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_RIGHT)) this.shadowStates["showRightShadow"] = !entry.isIntersecting;
                this.onUpdateShadows(this.shadowStates);
            });
        };
        this.scrollContainer = scrollContainer;
        this.onUpdateShadows = onUpdateShadows;
        this.init();
    }
    dispose() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            this.intersectionObserver = undefined;
            this.requestCallbackId && $cd027df5593f4e8b$var$cancelIdleCallback(this.requestCallbackId);
        }
    }
}

});


parcelRegister("eOOFp", function(module, exports) {

$parcel$export(module.exports, "breakoutConsts", () => $081c5ce54850cd88$export$ead1fecec2ecf57c);
$parcel$export(module.exports, "absoluteBreakoutWidth", () => $081c5ce54850cd88$export$b34ea040d1533a3);
$parcel$export(module.exports, "calcWideWidth", () => $081c5ce54850cd88$export$86325001fe8f3adc);
$parcel$export(module.exports, "calcBreakoutWidth", () => $081c5ce54850cd88$export$5f4502874a28dfce);
$parcel$export(module.exports, "calcBreakoutWithCustomWidth", () => $081c5ce54850cd88$export$ccc0a02edddeed39);
$parcel$export(module.exports, "calculateBreakoutStyles", () => $081c5ce54850cd88$export$c377853ecdd53e5b);
$parcel$export(module.exports, "getNextBreakoutMode", () => $081c5ce54850cd88$export$7eb758567e6644fd);
$parcel$export(module.exports, "getTitle", () => $081c5ce54850cd88$export$70d1bf7729efff40);

var $iHYdz = parcelRequire("iHYdz");

var $8DYpW = parcelRequire("8DYpW");

var $9Iju4 = parcelRequire("9Iju4");

var $4ceoy = parcelRequire("4ceoy");

var $eQcNy = parcelRequire("eQcNy");
/**
 * Variables required to construct a context for breakout ssr inline script.
 *
 * TODO: Clean this up after: https://product-fabric.atlassian.net/browse/ED-8942
 *
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $081c5ce54850cd88$export$ead1fecec2ecf57c = {
    padding: (0, $iHYdz.akEditorBreakoutPadding),
    defaultLayoutWidth: (0, $iHYdz.akEditorDefaultLayoutWidth),
    wideScaleRatio: (0, $iHYdz.breakoutWideScaleRatio),
    fullWidthLayoutWidth: (0, $iHYdz.akEditorFullWidthLayoutWidth),
    wideLayoutWidth: (0, $iHYdz.akEditorWideLayoutWidth),
    mapBreakpointToLayoutMaxWidth: $9Iju4.mapBreakpointToLayoutMaxWidth,
    getBreakpoint: $4ceoy.getBreakpoint,
    /**
	 * This function can return percentage value or px value depending upon the inputs
	 */ calcBreakoutWidth: (layout, containerWidth, padding)=>{
        const effectiveFullWidth = containerWidth - (padding ?? $081c5ce54850cd88$export$ead1fecec2ecf57c.padding);
        switch(layout){
            case 'full-width':
                return `${Math.min(effectiveFullWidth, $081c5ce54850cd88$export$ead1fecec2ecf57c.fullWidthLayoutWidth)}px`;
            case 'wide':
                if (effectiveFullWidth <= 0) return '100%';
                const wideWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcWideWidth(containerWidth, undefined, undefined, padding);
                if (wideWidth.endsWith('%')) return `${Math.min(effectiveFullWidth, $081c5ce54850cd88$export$ead1fecec2ecf57c.fullWidthLayoutWidth)}px`;
                return wideWidth;
            default:
                return '100%';
        }
    },
    calcBreakoutWithCustomWidth: (mode, width, editorContainerWidth)=>{
        if (width !== null && width > 0) {
            const effectiveFullWidth = editorContainerWidth - $081c5ce54850cd88$export$ead1fecec2ecf57c.padding;
            // if below 0 then expect we're rendering in SSR
            return `${Math.min(width, effectiveFullWidth)}px`;
        }
        return $081c5ce54850cd88$export$ead1fecec2ecf57c.calcBreakoutWidth(mode, editorContainerWidth);
    },
    calcLineLength: ()=>$081c5ce54850cd88$export$ead1fecec2ecf57c.defaultLayoutWidth,
    calcWideWidth: (containerWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.defaultLayoutWidth, maxWidth = Infinity, fallback = '100%', padding)=>{
        const effectiveFullWidth = containerWidth - (padding ?? $081c5ce54850cd88$export$ead1fecec2ecf57c.padding);
        const layoutMaxWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($081c5ce54850cd88$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
        const wideWidth = Math.min(Math.ceil(layoutMaxWidth * $081c5ce54850cd88$export$ead1fecec2ecf57c.wideScaleRatio), effectiveFullWidth);
        return layoutMaxWidth > wideWidth ? fallback : `${Math.min(maxWidth, wideWidth)}px`;
    }
};
const $081c5ce54850cd88$export$b34ea040d1533a3 = (layout, containerWidth)=>{
    const breakoutWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcBreakoutWidth(layout, containerWidth);
    // If it's percent, map to max layout size
    if (breakoutWidth.endsWith('%')) switch(layout){
        case 'full-width':
            return 0, $iHYdz.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $iHYdz.akEditorWideLayoutWidth;
        default:
            return $081c5ce54850cd88$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($081c5ce54850cd88$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
    }
    return parseInt(breakoutWidth, 10);
};
const $081c5ce54850cd88$export$86325001fe8f3adc = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcWideWidth;
const $081c5ce54850cd88$export$5f4502874a28dfce = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcBreakoutWidth;
const $081c5ce54850cd88$export$ccc0a02edddeed39 = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcBreakoutWithCustomWidth;
function $081c5ce54850cd88$export$c377853ecdd53e5b({ mode: mode, widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth }) {
    const breakoutWidth = $081c5ce54850cd88$export$5f4502874a28dfce(mode, widthStateWidth);
    const breakoutWidthPx = (0, $eQcNy.parsePx)(breakoutWidth);
    if (!widthStateLineLength) // lineLength is not normally undefined when this is run for,
    // consumers but can be in SSR, initial render or test (jsdom)
    // environments.
    //
    // this approach doesn't work well with position: fixed, so
    // it breaks things like sticky headers.
    //
    // It can also cause bluriness for some child content (such as iframes)
    return {
        type: 'line-length-unknown',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        display: 'flex',
        justifyContent: 'center',
        transform: 'none',
        transition: `min-width 0.5s ${0, $iHYdz.akEditorSwoopCubicBezier}`
    };
    // NOTE
    // At time of writing -- when toggling between full-width and
    // full-page appearance modes. There is a slight delay before
    // the widthState is updated.
    // During this period -- the marginLeftPx will be incorrect.
    // const marginLeftPx = -(breakoutWidthPx - widthStateLineLength) / 2;
    return {
        type: 'line-length-known',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        transition: `min-width 0.5s ${0, $iHYdz.akEditorSwoopCubicBezier}`,
        transform: `translateX(-50%)`,
        marginLeft: `50%`
    };
}
function $081c5ce54850cd88$export$586300c53bd298dd(mode, widthStateWidth, padding) {
    return (0, $eQcNy.parsePx)($081c5ce54850cd88$export$5f4502874a28dfce(mode, widthStateWidth, padding));
}
const $081c5ce54850cd88$export$7eb758567e6644fd = (currentMode)=>{
    if (currentMode === 'full-width') return 'center';
    else if (currentMode === 'wide') return 'full-width';
    return 'wide';
};
const $081c5ce54850cd88$export$70d1bf7729efff40 = (layout)=>{
    switch(layout){
        case 'full-width':
            return (0, $8DYpW.default).layoutFixedWidth;
        case 'wide':
            return (0, $8DYpW.default).layoutFullWidth;
        default:
            return (0, $8DYpW.default).layoutWide;
    }
};

});
parcelRegister("8DYpW", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb832a3bfaa1d66d$export$2e2bcd8739ae039);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $7VHMR = parcelRequire("7VHMR");





var $l9HLU = parcelRequire("l9HLU");

var $8cp3a = parcelRequire("8cp3a");

var $9NKqk = parcelRequire("9NKqk");

var $fJyLQ = parcelRequire("fJyLQ");

var $gSYO9 = parcelRequire("gSYO9");

var $jDuvE = parcelRequire("jDuvE");


var $lQKNV = parcelRequire("lQKNV");

var $2i4K4 = parcelRequire("2i4K4");

var $eX53M = parcelRequire("eX53M");

var $80CM7 = parcelRequire("80CM7");

var $kXnoC = parcelRequire("kXnoC");

var $eDTMN = parcelRequire("eDTMN");

var $2V0EL = parcelRequire("2V0EL");

var $kFJBG = parcelRequire("kFJBG");

var $7S9ZN = parcelRequire("7S9ZN");

var $6OcHr = parcelRequire("6OcHr");

var $dbepQ = parcelRequire("dbepQ");

var $kANLZ = parcelRequire("kANLZ");

var $kmmxF = parcelRequire("kmmxF");

var $80TXs = parcelRequire("80TXs");

var $9QBHe = parcelRequire("9QBHe");

var $kAM3u = parcelRequire("kAM3u");

var $6lWmZ = parcelRequire("6lWmZ");

var $ixwvf = parcelRequire("ixwvf");

var $fJm1A = parcelRequire("fJm1A");

var $ecAvy = parcelRequire("ecAvy");

var $7ywdr = parcelRequire("7ywdr");

var $1ElKj = parcelRequire("1ElKj");



var $3AEXe = parcelRequire("3AEXe");
var $eb832a3bfaa1d66d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    layoutFixedWidth: {
        id: 'fabric.editor.layoutFixedWidth',
        defaultMessage: 'Back to center',
        description: 'Display your element (image, table, extension, etc) as standard width'
    },
    layoutWide: {
        id: 'fabric.editor.layoutWide',
        defaultMessage: 'Go wide',
        description: 'Display your element (image, table, extension, etc) wider than normal'
    },
    layoutFullWidth: {
        id: 'fabric.editor.layoutFullWidth',
        defaultMessage: 'Go full width',
        description: 'Display your element (image, table, extension, etc) as full width'
    },
    alignImageRight: {
        id: 'fabric.editor.alignImageRight',
        defaultMessage: 'Align right',
        description: 'Aligns image to the right'
    },
    alignImageCenter: {
        id: 'fabric.editor.alignImageCenter',
        defaultMessage: 'Align center',
        description: 'Aligns image to the center'
    },
    alignImageLeft: {
        id: 'fabric.editor.alignImageLeft',
        defaultMessage: 'Align left',
        description: 'Aligns image to the left'
    },
    remove: {
        id: 'fabric.editor.remove',
        defaultMessage: 'Remove',
        description: 'Delete the element (image, panel, table, etc.) from your document'
    },
    removeEmoji: {
        id: 'fabric.editor.removeEmoji',
        defaultMessage: 'Remove emoji',
        description: 'Remove the emoji panel icon from custom panel'
    },
    visit: {
        id: 'fabric.editor.visit',
        defaultMessage: 'Open link in a new window',
        description: 'Open the link in a new window'
    },
    inviteToEditButtonTitle: {
        id: 'fabric.editor.editMode.inviteToEditButton.title',
        defaultMessage: 'Invite to edit',
        description: 'Invite another user to edit the current document'
    },
    saveButton: {
        id: 'fabric.editor.saveButton',
        defaultMessage: 'Save',
        description: 'Submit and save a comment or document'
    },
    cancelButton: {
        id: 'fabric.editor.cancelButton',
        defaultMessage: 'Cancel',
        description: 'Discard the current comment or document'
    },
    taskList: {
        id: 'fabric.editor.tooltip.taskList',
        defaultMessage: 'an action item',
        description: 'an action item in the Editor'
    },
    bulletList: {
        id: 'fabric.editor.tooltip.bulletList',
        defaultMessage: 'a list',
        description: 'a list item in the Editor'
    },
    nestedExpand: {
        id: 'fabric.editor.tooltip.nestedExpand',
        defaultMessage: 'a nested expand',
        description: 'expand node which is nested'
    },
    decisionList: {
        id: 'fabric.editor.tooltip.decisionList',
        defaultMessage: 'a decision list',
        description: 'a list of decisions'
    },
    defaultBlockNode: {
        id: 'fabric.editor.tooltip.defaultBlockNode',
        defaultMessage: 'a block node',
        description: 'a block node element'
    },
    panel: {
        id: 'fabric.editor.tooltip.blockPanel',
        defaultMessage: 'a panel',
        description: 'Panel node in the Editor'
    },
    blockquote: {
        id: 'fabric.editor.blockquote',
        defaultMessage: 'a quote',
        description: 'a quote node'
    },
    timeUpdated: {
        id: 'fabric.editor.time.updated',
        defaultMessage: 'Updated',
        description: 'Time last updated'
    },
    timeViewed: {
        id: 'fabric.editor.time.viewed',
        defaultMessage: 'Viewed',
        description: 'Time last viewed'
    },
    timeAgo: {
        id: 'fabric.editor.time.ago',
        defaultMessage: 'ago',
        description: 'Some time ago'
    },
    copyToClipboard: {
        id: 'fabric.editor.copyToClipboard',
        defaultMessage: 'Copy',
        description: 'Copy the whole content of the element to your clipboard'
    },
    copiedToClipboard: {
        id: 'fabric.editor.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the whole content of the element to clipboard'
    }
});

});
parcelRegister("l9HLU", function(module, exports) {

$parcel$export(module.exports, "alignmentMessages", () => $c0194801a7a2c28d$export$5229ffea355cfdf6);

var $7VHMR = parcelRequire("7VHMR");
const $c0194801a7a2c28d$export$5229ffea355cfdf6 = (0, $7VHMR.defineMessages)({
    alignment: {
        id: 'fabric.editor.alignment',
        defaultMessage: 'Text alignment',
        description: 'Opens drop down menu of options to configure text alignment'
    },
    alignLeft: {
        id: 'fabric.editor.alignLeft',
        defaultMessage: 'Align left',
        description: 'label stating that text is aligned left'
    },
    alignCenter: {
        id: 'fabric.editor.alignCenter',
        defaultMessage: 'Align center',
        description: 'label stating that text is aligned center'
    },
    alignRight: {
        id: 'fabric.editor.alignRight',
        defaultMessage: 'Align right',
        description: 'label stating that text is aligned right'
    }
});

});

parcelRegister("8cp3a", function(module, exports) {

$parcel$export(module.exports, "annotationMessages", () => $0f161f19f888f3d2$export$ff612ca71703201d);

var $7VHMR = parcelRequire("7VHMR");
const $0f161f19f888f3d2$export$ff612ca71703201d = (0, $7VHMR.defineMessages)({
    createComment: {
        id: 'fabric.editor.createComment',
        defaultMessage: 'Comment',
        description: 'Create/add an inline comment based on the users selection'
    },
    // TODO: Remove this message when the editor_inline_comments_on_inline_nodes FF is removed
    createCommentInvalid: {
        id: 'fabric.editor.createCommentInvalid',
        defaultMessage: 'You can only comment on text and headings',
        description: 'Error message to communicate to the user they can only do the current action in certain contexts'
    },
    createCommentDisabled: {
        id: 'fabric.editor.createCommentDisabled',
        defaultMessage: 'You can only comment on text, headings, emojis, dates, mentions, links, and statuses.',
        description: 'Error message to communicate to the user they can only do the current action in certain contexts'
    },
    toolbar: {
        id: 'fabric.editor.annotationToolbar',
        defaultMessage: 'Annotation toolbar',
        description: 'A label for a toolbar (UI element) that creates annotations/comments in the document'
    },
    createCommentOnInlineNodeSpotlightBody: {
        id: 'fabric.editor.createCommentOnInlineNodeSpotlight.body',
        defaultMessage: 'You can now leave comments on inline elements like links, dates, statuses and mentions.',
        description: 'The body content of the spotlight message that appears when the user can leave comments on inline nodes'
    },
    createCommentOnInlineNodeSpotlightAction: {
        id: 'fabric.editor.createCommentOnInlineNodeSpotlight.action',
        defaultMessage: 'Got it',
        description: 'The content of the action button that closes the spotlight'
    }
});

});

parcelRegister("9NKqk", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f845f8650b83fa4e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f845f8650b83fa4e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    normal: {
        id: 'fabric.editor.normal',
        defaultMessage: 'Normal text',
        description: 'This is the default text style'
    },
    heading1: {
        id: 'fabric.editor.heading1',
        defaultMessage: 'Heading 1',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading1Description: {
        id: 'fabric.editor.heading1Description',
        defaultMessage: 'Use this for a top level heading',
        description: 'Description of the main heading, heading 1'
    },
    heading2: {
        id: 'fabric.editor.heading2',
        defaultMessage: 'Heading 2',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading2Description: {
        id: 'fabric.editor.heading2Description',
        defaultMessage: 'Use this for key sections',
        description: 'Description of a subtitle heading or secondary heading'
    },
    heading3: {
        id: 'fabric.editor.heading3',
        defaultMessage: 'Heading 3',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading3Description: {
        id: 'fabric.editor.heading3Description',
        defaultMessage: 'Use this for sub sections and group headings',
        description: ''
    },
    heading4: {
        id: 'fabric.editor.heading4',
        defaultMessage: 'Heading 4',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading4Description: {
        id: 'fabric.editor.heading4Description',
        defaultMessage: 'Use this for deep headings',
        description: ''
    },
    heading5: {
        id: 'fabric.editor.heading5',
        defaultMessage: 'Heading 5',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading5Description: {
        id: 'fabric.editor.heading5Description',
        defaultMessage: 'Use this for grouping list items',
        description: ''
    },
    heading6: {
        id: 'fabric.editor.heading6',
        defaultMessage: 'Heading 6',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading6Description: {
        id: 'fabric.editor.heading6Description',
        defaultMessage: 'Use this for low level headings',
        description: ''
    },
    blockquote: {
        id: 'fabric.editor.blockquote2',
        defaultMessage: 'Quote',
        description: 'Quote some text'
    },
    blockquoteDescription: {
        id: 'fabric.editor.blockquote.description',
        defaultMessage: 'Insert a quote or citation',
        description: 'Quote some text'
    },
    codeblock: {
        id: 'fabric.editor.codeblock',
        defaultMessage: 'Code snippet',
        description: 'Insert a snippet/segment of code (code block)'
    },
    codeblockDescription: {
        id: 'fabric.editor.codeblock.description',
        defaultMessage: 'Display code with syntax highlighting',
        description: 'Insert a snippet/segment of code (code block)'
    },
    infoPanel: {
        id: 'fabric.editor.infoPanel',
        defaultMessage: 'Info panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
    },
    infoPanelDescription: {
        id: 'fabric.editor.infoPanel.description',
        defaultMessage: 'Highlight information in a colored panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
    },
    notePanel: {
        id: 'fabric.editor.notePanel',
        defaultMessage: 'Note panel',
        description: 'Visually distinguishes your text by adding a note panel'
    },
    notePanelDescription: {
        id: 'fabric.editor.notePanel.description',
        defaultMessage: 'Add a note in a colored panel',
        description: 'Visually distinguishes your text by adding a note panel'
    },
    successPanel: {
        id: 'fabric.editor.successPanel',
        defaultMessage: 'Success panel',
        description: 'Visually distinguishes your text by adding a success panel'
    },
    successPanelDescription: {
        id: 'fabric.editor.successPanel.description',
        defaultMessage: 'Add tips in a colored panel',
        description: 'Visually distinguishes your text by adding a success panel'
    },
    warningPanel: {
        id: 'fabric.editor.warningPanel',
        defaultMessage: 'Warning panel',
        description: 'Visually distinguishes your text by adding a warning panel'
    },
    warningPanelDescription: {
        id: 'fabric.editor.warningPanel.description',
        defaultMessage: 'Add a note of caution in a colored panel',
        description: 'Visually distinguishes your text by adding a warning panel'
    },
    errorPanel: {
        id: 'fabric.editor.errorPanel',
        defaultMessage: 'Error panel',
        description: 'Visually distinguishes your text by adding a error panel'
    },
    errorPanelDescription: {
        id: 'fabric.editor.errorPanel.description',
        defaultMessage: 'Call out errors in a colored panel',
        description: 'Visually distinguishes your text by adding a error panel'
    },
    customPanel: {
        id: 'fabric.editor.customPanel',
        defaultMessage: 'Custom panel',
        description: 'Visually distinguishes your panel by adding a emoji icon and background color'
    },
    customPanelDescription: {
        id: 'fabric.editor.customPanel.description',
        defaultMessage: 'Add a note with an emoji and colored background',
        description: 'Visually distinguishes your panel by adding a emoji icon and background color '
    },
    panel: {
        id: 'fabric.editor.panel',
        defaultMessage: 'Panel',
        description: 'Visually distinguishes your text by adding a panel'
    },
    other: {
        id: 'fabric.editor.other',
        defaultMessage: 'Others...',
        description: 'Other text formatting'
    }
});

});

parcelRegister("fJyLQ", function(module, exports) {

$parcel$export(module.exports, "codeBidiWarningMessages", () => $bc1b61e25b99393f$export$42bb270d1224182);

var $7VHMR = parcelRequire("7VHMR");
const $bc1b61e25b99393f$export$42bb270d1224182 = (0, $7VHMR.defineMessages)({
    /**
	 * Message taken from
	 * https://hello.atlassian.net/wiki/spaces/~tswan/pages/1366555782/PSHELP-2943+Investigate+Trojan+Source+Attack+Vulnerability+design
	 */ label: {
        id: 'fabric.editor.codeBidiWarningLabel',
        defaultMessage: 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.',
        description: 'Tooltip message to present to users when a bidirectional character is encountered in code.'
    }
});

});

parcelRegister("gSYO9", function(module, exports) {

$parcel$export(module.exports, "linkMessages", () => $6ccabeb0d4490fe2$export$4ce3884394d6d9);

var $7VHMR = parcelRequire("7VHMR");
const $6ccabeb0d4490fe2$export$4ce3884394d6d9 = (0, $7VHMR.defineMessages)({
    openLink: {
        id: 'fabric.editor.openLink',
        defaultMessage: 'Open link in a new tab',
        description: 'Opens the link in a new tab'
    }
});

});

parcelRegister("jDuvE", function(module, exports) {

$parcel$export(module.exports, "linkToolbarMessages", () => $8ffd20c106600435$export$2d7676d841c8ae9);

var $7VHMR = parcelRequire("7VHMR");
const $8ffd20c106600435$export$2d7676d841c8ae9 = (0, $7VHMR.defineMessages)({
    addLink: {
        id: 'fabric.editor.mediaAddLink',
        defaultMessage: 'Add link',
        description: 'Add link'
    },
    unableToOpenLink: {
        id: 'fabric.editor.unableToOpenLink',
        defaultMessage: 'Unable to open this link',
        description: 'Unable to open this link'
    },
    unlink: {
        id: 'fabric.editor.unlink',
        defaultMessage: 'Unlink',
        description: 'Removes the hyperlink but keeps your text.'
    },
    editDatasourceStandalone: {
        id: 'fabric.editor.editDatasourceStandalone',
        defaultMessage: 'Edit',
        description: 'A standalone edit button to edit the datasource via a config modal'
    },
    editDatasourceStandaloneTooltip: {
        id: 'fabric.editor.editDatasourceStandaloneTooltip',
        defaultMessage: 'Edit search query',
        description: 'A standalone edit button tooltip to hint at editing the datasource via a config modal'
    },
    editLink: {
        id: 'fabric.editor.editLink',
        defaultMessage: 'Edit link',
        description: 'Edit the link, update display text'
    },
    placeholder: {
        id: 'fabric.editor.hyperlinkToolbarPlaceholder',
        defaultMessage: 'Paste or search for link',
        description: 'Paste or search for link'
    },
    linkPlaceholder: {
        id: 'fabric.editor.linkPlaceholder',
        defaultMessage: 'Paste link',
        description: 'Create a new link by pasting a URL.'
    },
    linkAddress: {
        id: 'fabric.editor.linkAddress',
        defaultMessage: 'Link address',
        description: 'Insert the address of the link'
    },
    invalidLink: {
        id: 'fabric.editor.invalidLink',
        defaultMessage: 'Please enter a valid link.',
        description: 'Please enter a valid link.'
    },
    emptyLink: {
        id: 'fabric.editor.emptyLink',
        defaultMessage: 'Please enter a link.',
        description: 'Please enter a link.'
    },
    settingsLink: {
        id: 'fabric.editor.settingsLinks',
        defaultMessage: 'Go to Link Preferences',
        description: 'Go to Link Preferences'
    },
    editDatasource: {
        id: 'fabric.editor.edit.datasource',
        defaultMessage: 'Edit search query',
        description: 'Datasource toolbar edit button'
    },
    searchInput: {
        id: 'fabric.editor.edit.searchInput',
        defaultMessage: 'Add a link',
        description: 'Label for the search media input'
    }
});

});

parcelRegister("lQKNV", function(module, exports) {

$parcel$export(module.exports, "codeBlockButtonMessages", () => $20d0fb06aaa96548$export$74e304339778e94d);

var $7VHMR = parcelRequire("7VHMR");
const $20d0fb06aaa96548$export$74e304339778e94d = (0, $7VHMR.defineMessages)({
    copyCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copyToClipboard',
        defaultMessage: 'Copy as text',
        description: 'Copy the content of the code block as text to your clipboard'
    },
    copiedCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the content of the code block as text to clipboard'
    },
    wrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.wrapCodeBlock',
        defaultMessage: 'Turn on wrap',
        description: 'Wrap the content of the code block'
    },
    unwrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.unwrapCodeBlock',
        defaultMessage: 'Turn off wrap',
        description: 'Wrap the content of the code block'
    },
    selectLanguage: {
        id: 'fabric.editor.selectLanguage',
        defaultMessage: 'Select language',
        description: 'Code blocks display software code. A prompt to select the software language the code is written in.'
    }
});

});

parcelRegister("2i4K4", function(module, exports) {

$parcel$export(module.exports, "toolbarInsertBlockMessages", () => $4423ee10317a70cf$export$70c8a7203d95247);

var $7VHMR = parcelRequire("7VHMR");
const $4423ee10317a70cf$export$70c8a7203d95247 = (0, $7VHMR.defineMessages)({
    action: {
        id: 'fabric.editor.action',
        defaultMessage: 'Action item',
        description: "Also known as a \u201Ctask\u201D, \u201Cto do item\u201D, or a checklist"
    },
    actionDescription: {
        id: 'fabric.editor.action.description',
        defaultMessage: 'Create and assign action items',
        description: ''
    },
    closeInsertRightRail: {
        id: 'fabric.editor.insertRightRail.close',
        defaultMessage: 'Close',
        description: 'Close button label'
    },
    link: {
        id: 'fabric.editor.link',
        defaultMessage: 'Link',
        description: 'Insert a hyperlink'
    },
    linkDescription: {
        id: 'fabric.editor.link.description',
        defaultMessage: 'Insert a link',
        description: 'Insert a hyperlink'
    },
    mediaFiles: {
        id: 'fabric.editor.mediaFiles',
        defaultMessage: 'Image, video, or file',
        description: 'Insert one or more files, videos or images'
    },
    addMediaFiles: {
        id: 'fabric.editor.addMediaFiles',
        defaultMessage: 'Add image, video, or file',
        description: 'Insert one or more files, videos or images'
    },
    insertRightRailTitle: {
        id: 'fabric.editor.insertRightRail.title',
        defaultMessage: 'Insert',
        description: 'Insert a node into the document'
    },
    mediaFilesDescription: {
        id: 'fabric.editor.mediaFiles.description',
        defaultMessage: 'Add images and other files to your page',
        description: 'Insert one or more files or images'
    },
    image: {
        id: 'fabric.editor.image',
        defaultMessage: 'Image',
        description: 'Insert an image.'
    },
    mention: {
        id: 'fabric.editor.mention',
        defaultMessage: 'Mention',
        description: 'Reference another person in your document'
    },
    mentionDescription: {
        id: 'fabric.editor.mention.description',
        defaultMessage: 'Mention someone to send them a notification',
        description: 'Reference another person in your document'
    },
    emoji: {
        id: 'fabric.editor.emoji',
        defaultMessage: 'Emoji',
        description: 'Insert an emoticon or smiley :-)'
    },
    emojiDescription: {
        id: 'fabric.editor.emoji.description',
        defaultMessage: "Use emojis to express ideas \uD83C\uDF89 and emotions \uD83D\uDE04",
        description: 'Insert an emoticon or smiley :-)'
    },
    table: {
        id: 'fabric.editor.table',
        defaultMessage: 'Table',
        description: 'Inserts a table in the document'
    },
    tableDescription: {
        id: 'fabric.editor.table.description',
        defaultMessage: 'Insert a table',
        description: 'Inserts a table in the document'
    },
    tableSelector: {
        id: 'fabric.editor.tableSelector',
        defaultMessage: 'Table size',
        description: 'Opens a table selector that lets you insert a table of custom size'
    },
    tableSelectorDescription: {
        id: 'fabric.editor.tableSelector.description',
        defaultMessage: 'Add a table using popup to select a custom size',
        description: 'Opens a table selector that lets you insert a table of a custom size'
    },
    tableSizeSelectorButton: {
        id: 'fabric.editor.tableSizeSelectorButton',
        defaultMessage: '{numberOfColumns} by {numberOfRows}',
        description: 'Creates a table of custom size'
    },
    tableSizeSelectorPopup: {
        id: 'fabric.editor.tableSizeSelectorPopup',
        defaultMessage: 'Table size selector',
        description: 'Table selector popup to create table of custom size'
    },
    expand: {
        id: 'fabric.editor.expand',
        defaultMessage: 'Expand',
        description: 'Inserts an expand in the document'
    },
    expandDescription: {
        id: 'fabric.editor.expand.description',
        defaultMessage: 'Insert an expand',
        description: 'Inserts an expand in the document'
    },
    decision: {
        id: 'fabric.editor.decision',
        defaultMessage: 'Decision',
        description: "Capture a decision you\u2019ve made"
    },
    decisionDescription: {
        id: 'fabric.editor.decision.description',
        defaultMessage: "Capture decisions so they\u2019re easy to track",
        description: "Capture a decision you\u2019ve made"
    },
    feedbackDialog: {
        id: 'fabric.editor.feedbackDialog',
        defaultMessage: 'Give feedback',
        description: 'Open the feedback dialog from editor'
    },
    feedbackDialogDescription: {
        id: 'fabric.editor.feedbackDialog.description',
        defaultMessage: 'Tell us about your experience using the new editor',
        description: 'Description for feedback option under quick insert dropdown'
    },
    horizontalRule: {
        id: 'fabric.editor.horizontalRule',
        defaultMessage: 'Divider',
        description: 'A horizontal rule or divider'
    },
    horizontalRuleDescription: {
        id: 'fabric.editor.horizontalRule.description',
        defaultMessage: 'Separate content with a horizontal line',
        description: 'A horizontal rule or divider'
    },
    date: {
        id: 'fabric.editor.date',
        defaultMessage: 'Date',
        description: 'Opens a date picker that lets you select a date'
    },
    dateDescription: {
        id: 'fabric.editor.date.description',
        defaultMessage: 'Add a date using a calendar',
        description: 'Opens a date picker that lets you select a date'
    },
    placeholderText: {
        id: 'fabric.editor.placeholderText',
        defaultMessage: 'Placeholder text',
        description: 'Inserts a text placeholder into the page'
    },
    placeholderTextDescription: {
        id: 'fabric.editor.placeholderText.description',
        defaultMessage: 'Insert a text placeholder into the page',
        description: 'Inserts a text placeholder into the page'
    },
    columns: {
        id: 'fabric.editor.columns',
        defaultMessage: 'Layouts',
        description: 'Create a multi column section or layout'
    },
    columnsDescription: {
        id: 'fabric.editor.columns.description',
        defaultMessage: 'Structure your page using sections',
        description: 'Create a multi column section or layout'
    },
    columnsDescriptionAdvancedLayout: {
        id: 'fabric.editor.columns.advanced.layout.description',
        defaultMessage: 'Insert {numberOfColumns} equal {numberOfColumns, plural, one {column} other {columns}}',
        description: 'Create a multi column section or layout'
    },
    status: {
        id: 'fabric.editor.status',
        defaultMessage: 'Status',
        description: 'Inserts an item representing the status of an activity to task.'
    },
    statusDescription: {
        id: 'fabric.editor.status.description',
        defaultMessage: 'Add a custom status label',
        description: 'Inserts an item representing the status of an activity to task.'
    },
    viewMore: {
        id: 'fabric.editor.viewMore',
        defaultMessage: 'View more',
        description: ''
    },
    insertMenu: {
        id: 'fabric.editor.insertMenu',
        defaultMessage: 'Insert elements',
        description: 'Opens a menu of additional items that can be inserted into your document.'
    },
    help: {
        id: 'fabric.editor.help',
        defaultMessage: 'Help',
        description: 'Opens up the help dialog'
    },
    helpDescription: {
        id: 'fabric.editor.help.description',
        defaultMessage: 'Browse all the keyboard shortcuts and markdown options',
        description: 'Browse all the keyboard shortcuts and markdown options'
    },
    recordVideo: {
        id: 'fabric.editor.recordVideo',
        defaultMessage: 'Record a Loom video',
        description: 'Record a Loom video'
    },
    addLoomVideo: {
        id: 'fabric.editor.addLoomVideo',
        defaultMessage: 'Record a Loom video',
        description: 'Record a Loom video'
    },
    addLoomVideoComment: {
        id: 'fabric.editor.addLoomVideoComment',
        defaultMessage: 'Record a Loom video comment',
        description: 'Record a Loom video comment'
    },
    recordVideoDescription: {
        id: 'fabric.editor.recordVideo.description',
        defaultMessage: 'Record and share your screen and thoughts',
        description: 'Record and share your screen and thoughts'
    },
    recordLoomShortTitle: {
        id: 'fabric.editor.recordLoomShortTitle',
        defaultMessage: 'Record',
        description: 'Record'
    },
    turnInto: {
        id: 'fabric.editor.turnInto',
        defaultMessage: 'Turn into',
        description: 'Turn selected texts into another element containing those texts'
    }
});

});

parcelRegister("eX53M", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $0e5cb7a66b16e8d0$export$81b075fd34c2f0bb);

var $7VHMR = parcelRequire("7VHMR");
const $0e5cb7a66b16e8d0$export$81b075fd34c2f0bb = (0, $7VHMR.defineMessages)({
    wrapLeft: {
        id: 'fabric.editor.wrapLeft',
        defaultMessage: 'Wrap left',
        description: 'Aligns your image to the left and wraps text around it.'
    },
    wrapRight: {
        id: 'fabric.editor.wrapRight',
        defaultMessage: 'Wrap right',
        description: 'Aligns your image to the right and wraps text around it.'
    },
    changeToMediaSingle: {
        id: 'fabric.editor.media_change_mediasingle',
        defaultMessage: 'Original size',
        description: 'In the context of a media inline image, it allows the user to convert it to media single'
    },
    changeToMediaInlineImage: {
        id: 'fabric.editor.media_change_mediainline_default',
        defaultMessage: 'Inline',
        description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image'
    },
    changeToMediaInlineImageCaptionWarning: {
        id: 'fabric.editor.media_change_mediainline_caption_warn',
        defaultMessage: 'Inline (caption will be removed)',
        description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image and warn user about caption being removed'
    }
});

});

parcelRegister("80CM7", function(module, exports) {

$parcel$export(module.exports, "messages", () => $402c787ddf19f01c$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $402c787ddf19f01c$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    url: {
        id: 'fabric.editor.url',
        defaultMessage: 'Display URL',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    block: {
        id: 'fabric.editor.displayBlock',
        defaultMessage: 'Display card',
        description: 'Display link as a card with a rich preview similar to in a Facebook feed with page title, description, and potentially an image.'
    },
    inline: {
        id: 'fabric.editor.displayInline',
        defaultMessage: 'Display inline',
        description: 'Display link with the title only.'
    },
    embed: {
        id: 'fabric.editor.displayEmbed',
        defaultMessage: 'Display embed',
        description: 'Display link as an embedded object'
    },
    link: {
        id: 'fabric.editor.displayLink',
        defaultMessage: 'Display as text',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    card: {
        id: 'fabric.editor.cardFloatingControls',
        defaultMessage: 'Card options',
        description: 'Options to change card type'
    },
    blockCardUnavailable: {
        id: 'fabric.editor.blockCardUnavailable',
        defaultMessage: 'The inline link is inside {node} and cannot have its view changed',
        description: 'Warning message to show the user that this node cannot change its view'
    },
    displayOptionUnavailableInParentNode: {
        id: 'fabric.editor.displayOptionUnavailableInParentNode',
        defaultMessage: "This display option isn't available inside {node}",
        description: 'Warning message to show the user that this node option is not available inside a parent node type'
    },
    urlTitle: {
        id: 'fabric.editor.urlTitle',
        defaultMessage: 'URL',
        description: 'Title for option to convert the card to become a regular text-based hyperlink.'
    },
    blockTitle: {
        id: 'fabric.editor.blockTitle',
        defaultMessage: 'Card',
        description: 'Title for option to display link in the card view.'
    },
    inlineTitle: {
        id: 'fabric.editor.inlineTitle',
        defaultMessage: 'Inline',
        description: 'Title for option to display link in the inline view.'
    },
    embedTitle: {
        id: 'fabric.editor.embedTitle',
        defaultMessage: 'Embed',
        description: 'Title for option to display link as an embedded object.'
    },
    urlDescription: {
        id: 'fabric.editor.urlDescription',
        defaultMessage: 'Display link as URL',
        description: 'Description for option to convert the card to become a regular text-based hyperlink.'
    },
    blockDescription: {
        id: 'fabric.editor.blockDescription',
        defaultMessage: 'Display more information about a link, including a summary and actions',
        description: 'Description for option to display link in the card view.'
    },
    inlineDescription: {
        id: 'fabric.editor.inlineDescription',
        defaultMessage: 'Display link as inline text',
        description: 'Description for option to display link in the inline view.'
    },
    embedDescription: {
        id: 'fabric.editor.ecombedDescription',
        defaultMessage: 'Display an interactive preview of a link',
        description: 'Description for option to display link as an embedded object.'
    },
    editDropdownExpandIconLabel: {
        id: 'fabric.editor.editDropdownExpandIconLabel',
        defaultMessage: 'Expand dropdown menu',
        description: 'Text of an icon to expand the dropdown'
    },
    editDropdownTriggerTitle: {
        id: 'fabric.editor.editDropdownTriggerTitle',
        defaultMessage: 'Edit',
        description: 'Text of a button to trigger opening an edit dropdown'
    },
    editDropdownEditLinkTitle: {
        id: 'fabric.editor.editDropdownEditLinkTitle',
        defaultMessage: 'Edit link',
        description: 'Edit dropdown edit link button text'
    },
    editDropdownEditDatasourceTitle: {
        id: 'fabric.editor.editDropdownEditDatasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Edit dropdown edit datasource button text'
    },
    datasourceTitle: {
        id: 'fabric.editor.datasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Tooltip of button to edit a card into a datasource'
    },
    datasourceAppearanceTitle: {
        id: 'fabric.editor.datasourceAppearanceTitle',
        defaultMessage: 'List',
        description: 'Tooltip of button to change to datasource appearance'
    },
    datasourceJiraIssue: {
        id: 'fabric.editor.datasource.jiraIssue',
        defaultMessage: 'Jira Issues',
        description: 'Insert a jira datasource table'
    },
    datasourceJiraIssueDescription: {
        id: 'fabric.editor.datasource.jiraIssue.description',
        defaultMessage: 'Insert Jira issues from Jira Cloud with enhanced search, filtering, and configuration.',
        description: 'Insert a jira datasource table'
    },
    datasourceAssetsObjectsGeneralAvailability: {
        id: 'fabric.editor.datasource.assetsObjectsGeneralAvailability',
        defaultMessage: 'Assets',
        description: 'Text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects.'
    },
    datasourceAssetsObjectsDescription: {
        id: 'fabric.editor.datasource.assetsObjects.description',
        defaultMessage: 'Insert objects from Assets in Jira Service Management with search and filtering',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects'
    },
    inlineOverlay: {
        id: 'fabric.editor.inlineOverlay',
        defaultMessage: 'Configure',
        description: 'An overlay shown when hover over inline smart link to inform user that they can click the link to edit the links appearance.'
    },
    inlineConfigureLink: {
        id: 'fabric.editor.inlineConfigureLink',
        defaultMessage: 'Configure link',
        description: 'An icon shown when hovering over inline smart link to inform user they can click the icon to configure the links appearance.'
    },
    inlineGoToLink: {
        id: 'fabric.editor.inlineGoToLink',
        defaultMessage: 'Go to link',
        description: 'An option in the configure link dropdown that informs the user they can click the option to open the link'
    },
    datasourceConfluenceSearch: {
        id: 'fabric.editor.datasource.confluenceSearch',
        defaultMessage: 'Insert Confluence list',
        description: 'Title shown for Confluence Search datasource on QuickInsert options'
    },
    datasourceConfluenceSearchDescription: {
        id: 'fabric.editor.datasource.confluenceSearch.description',
        defaultMessage: 'Insert list of search results from Confluence with enhanced search, filtering, and configuration.',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: Confluence Search objects'
    }
});

});

parcelRegister("kXnoC", function(module, exports) {

$parcel$export(module.exports, "messages", () => $19e3f2f865259995$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $19e3f2f865259995$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    toolbarLabel: {
        id: 'fabric.editor.toolbarLabel',
        defaultMessage: 'Editor',
        description: 'Label for the ARIA region landmark'
    },
    pageActionsLabel: {
        id: 'fabric.editor.pageActionsLabel',
        defaultMessage: 'Page actions',
        description: 'Label for the ARIA region landmark'
    },
    editableContentLabel: {
        id: 'fabric.editor.editableContentLabel',
        defaultMessage: 'Editable content',
        description: 'Label for the ARIA region landmark'
    }
});

});

parcelRegister("eDTMN", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $ec9866e02d0168cb$export$81b075fd34c2f0bb);

var $7VHMR = parcelRequire("7VHMR");
const $ec9866e02d0168cb$export$81b075fd34c2f0bb = (0, $7VHMR.defineMessages)({
    underline: {
        id: 'fabric.editor.underline',
        defaultMessage: 'Underline',
        description: 'Whether the text selection has underlined text'
    },
    strike: {
        id: 'fabric.editor.strike',
        defaultMessage: 'Strikethrough',
        description: 'Whether the text selection has crossed out text'
    },
    code: {
        id: 'fabric.editor.code',
        defaultMessage: 'Code',
        description: 'Whether the text selection has monospaced/code font'
    },
    codeOn: {
        id: 'fabric.editor.code.on',
        defaultMessage: '{textFormattingOff}, Code On',
        description: 'Reports that code formatting has been turned on'
    },
    subscript: {
        id: 'fabric.editor.subscript',
        defaultMessage: 'Subscript',
        description: 'Whether the text selection is written below the line in a slightly smaller size'
    },
    subscriptOffSuperscriptOn: {
        id: 'fabric.editor.subscript.off.superscript.on',
        defaultMessage: 'Subscript Off, Superscript On',
        description: 'Reports text formatting in case when subscript off and superscript on'
    },
    superscript: {
        id: 'fabric.editor.superscript',
        defaultMessage: 'Superscript',
        description: 'Whether the text selection is written above the line in a slightly smaller size'
    },
    superscriptOffSubscriptOn: {
        id: 'fabric.editor.superscript.off.subscript.on',
        defaultMessage: 'Superscript Off, Subscript On',
        description: 'Describe text formatting in case when Superscript Off and Subscript on'
    },
    clearFormatting: {
        id: 'fabric.editor.clearFormatting',
        defaultMessage: 'Clear formatting',
        description: 'Remove all rich text formatting from the selected text'
    },
    moreFormatting: {
        id: 'fabric.editor.moreFormatting',
        defaultMessage: 'More formatting',
        description: 'Clicking this will show a menu with additional formatting options'
    },
    textFormatting: {
        id: 'fabric.editor.textFormatting',
        defaultMessage: 'Text formatting',
        description: 'Aria label for the wrapper of text format buttons'
    },
    textFormat: {
        id: 'fabric.editor.textFormat',
        defaultMessage: 'Format text',
        description: 'Aria label for the wrapper of text format buttons'
    },
    bold: {
        id: 'fabric.editor.bold',
        defaultMessage: 'Bold',
        description: "This refers to bold or \u201Cstrong\u201D formatting, indicates that its contents have strong importance, seriousness, or urgency."
    },
    italic: {
        id: 'fabric.editor.italic',
        defaultMessage: 'Italic',
        description: 'This refers to italics or emphasized formatting.'
    },
    on: {
        id: 'fabric.editor.on',
        defaultMessage: '{formattingType} On',
        description: 'Reports that text formatting has been turned on'
    },
    off: {
        id: 'fabric.editor.off',
        defaultMessage: '{formattingType} Off',
        description: 'Reports that text formatting has been turned off'
    },
    textStyles: {
        id: 'fabric.editor.textStyles',
        defaultMessage: '{blockTypeName} Text styles',
        description: 'Menu label that provides access to various heading styles or normal text. For example: normal text styles, heading 1 text styles.'
    },
    textStylesTooltip: {
        id: 'fabric.editor.textStylesTooltip',
        defaultMessage: 'Text styles',
        description: 'Tooltip text for menu that provides access to various heading styles or normal text.'
    },
    textFormattingOff: {
        id: 'fabric.editor.text.formatting.off',
        defaultMessage: 'Text formatting Off',
        description: 'Reports that text formatting has been turned off'
    },
    navigateToEditorToolbar: {
        id: 'fabric.editor.navigate.toolbar.editor',
        defaultMessage: 'Navigate to editor toolbar',
        description: 'Navigate to the main editor toolbar.'
    },
    navigateToFloatingToolbar: {
        id: 'fabric.editor.navigate.toolbar.floating',
        defaultMessage: 'Navigate to floating toolbar',
        description: 'Navigate to a floating toolbar for relevant nodes (e.g. tables or panels).'
    }
});

});

parcelRegister("2V0EL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bcecf16097bd0035$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $bcecf16097bd0035$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    tableOptions: {
        id: 'fabric.editor.tableOptions',
        defaultMessage: 'Table options',
        description: 'Opens a menu with additional table options'
    },
    tableSizeIncreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeIncreaseScreenReaderInformation',
        defaultMessage: 'Table width increased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about increasing the table size by a certain number of pixels.'
    },
    tableSizeDecreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeDecreaseScreenReaderInformation',
        defaultMessage: 'Table width decreased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about decreasing the table size by a certain number of pixels.'
    },
    headerRow: {
        id: 'fabric.editor.headerRow',
        defaultMessage: 'Header row',
        description: 'Marks the first table row as a header row'
    },
    headerColumn: {
        id: 'fabric.editor.headerColumn',
        defaultMessage: 'Header column',
        description: 'Marks the first table column as a header row'
    },
    numberedColumn: {
        id: 'fabric.editor.numberedColumn',
        defaultMessage: 'Numbered column',
        description: 'Adds an auto-numbering column to your table'
    },
    collapseTable: {
        id: 'fabric.editor.collapseTable',
        defaultMessage: 'Collapse table',
        description: 'Wraps table in an expand'
    },
    resizeTable: {
        id: 'fabric.editor.tables.resizeTable',
        defaultMessage: 'Resize table',
        description: 'Tooltip displayed on custom table width resize hande'
    },
    insertColumn: {
        id: 'fabric.editor.insertColumn',
        defaultMessage: 'Insert column right',
        description: 'Inserts a new column to the right of selected column.'
    },
    addColumnLeft: {
        id: 'fabric.editor.addColumnLeft',
        defaultMessage: 'Add column left',
        description: 'Adds a new column to the left of selected column.'
    },
    addColumnRight: {
        id: 'fabric.editor.addColumnRight',
        defaultMessage: 'Add column right',
        description: 'Adds a new column to the right of selected column.'
    },
    insertColumnDrag: {
        id: 'fabric.editor.insertColumnDrag',
        defaultMessage: 'Insert column',
        description: 'Inserts a new column to the right of selected column.'
    },
    removeColumns: {
        id: 'fabric.editor.removeColumns',
        defaultMessage: 'Delete {0, plural, one {column} other {columns}}',
        description: 'Deletes a table column.'
    },
    insertRow: {
        id: 'fabric.editor.insertRow',
        defaultMessage: 'Insert row below',
        description: 'Inserts a new row below the selected row.'
    },
    addRowAbove: {
        id: 'fabric.editor.addRowAbove',
        defaultMessage: 'Add row above',
        description: 'Adds a new row above the selected row.'
    },
    addRowBelow: {
        id: 'fabric.editor.addRowBelow',
        defaultMessage: 'Add row below',
        description: 'Adds a new row below the selected row.'
    },
    moveColumnLeft: {
        id: 'fabric.editor.moveColumnLeft',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} left',
        description: 'Moves a column or columns to the left.'
    },
    moveColumnRight: {
        id: 'fabric.editor.moveColumnRight',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} right',
        description: 'Moves a column or columns to the right.'
    },
    moveRowUp: {
        id: 'fabric.editor.moveRowUp',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} up',
        description: 'Moves a row or selected rows up.'
    },
    moveRowDown: {
        id: 'fabric.editor.moveDownDown',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} down',
        description: 'Moves a row or selected rows down.'
    },
    insertRowDrag: {
        id: 'fabric.editor.insertRowDrag',
        defaultMessage: 'Insert row',
        description: 'Inserts a new row below the selected row.'
    },
    removeRows: {
        id: 'fabric.editor.removeRows',
        defaultMessage: 'Delete {0, plural, one {row} other {rows}}',
        description: 'Deletes a table row.'
    },
    rowNumbers: {
        id: 'fabrid.editor.rowNumbers',
        defaultMessage: 'Row numbers',
        desciption: 'Adds a number to each row except header row'
    },
    rowsAreInserted: {
        id: 'fabric.editor.rowsAreInserted',
        defaultMessage: '{count, plural, one {A row has been} other {{count} rows have been}} inserted',
        description: 'Assistive message following the insertion of row(s)'
    },
    rowsAreRemoved: {
        id: 'fabric.editor.rowsAreRemoved',
        defaultMessage: '{count, plural, one {The row has been} other {{count} rows have been}} removed',
        description: 'Assistive message following the removal of row(s)'
    },
    rowSelected: {
        id: 'fabric.editor.rowSelected',
        defaultMessage: 'Row {index} of {total} selected',
        description: 'Assistive message following the selection of a row'
    },
    rowMovedUp: {
        id: 'fabric.editor.rowMovedUp',
        defaultMessage: 'Row moved up to {index} of {total}',
        description: 'Assistive message following the upward movement of a row'
    },
    rowMovedDown: {
        id: 'fabric.editor.rowMovedDown',
        defaultMessage: 'Row moved down to {index} of {total}',
        description: 'Assistive message following the downward movement of a row'
    },
    columnsAreInserted: {
        id: 'fabric.editor.columnsAreInserted',
        defaultMessage: '{count, plural, one {A column has been} other {{count} columns have been}} inserted',
        description: 'Assistive message following the insertion of column(s)'
    },
    columnsAreRemoved: {
        id: 'fabric.editor.columnsAreRemoved',
        defaultMessage: '{count, plural, one {The column has been} other {{count} columns have been}} removed',
        description: 'Assistive message following the removal of column(s)'
    },
    columnSelected: {
        id: 'fabric.editor.columnSelected',
        defaultMessage: 'Column {index} of {total} selected',
        description: 'Assistive message following the selection of a column'
    },
    columnMovedLeft: {
        id: 'fabric.editor.columnMovedLeft',
        defaultMessage: 'Column moved left to {index} of {total}',
        description: 'Assistive message following the left movement of a column'
    },
    columnMovedRight: {
        id: 'fabric.editor.columnMovedRight',
        defaultMessage: 'Column moved right to {index} of {total}',
        description: 'Assistive message following the right movement of a column'
    },
    cellOptions: {
        id: 'fabric.editor.cellOptions',
        defaultMessage: 'Cell options',
        description: 'Opens a menu with options for the current table cell.'
    },
    confirmDeleteLinkedModalOKButton: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalOKButton',
        defaultMessage: 'Delete',
        description: 'Action button label for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessagePrefix: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix',
        defaultMessage: 'Deleting',
        description: 'prefix for confirmation dialog text'
    },
    confirmModalCheckboxLabel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCheckboxLabel',
        defaultMessage: 'Also delete connected elements',
        description: 'checkbox label text'
    },
    deleteElementTitle: {
        id: 'fabric.editor.extension.deleteElementTitle',
        defaultMessage: 'Delete element',
        description: 'Title text for confirm modal when deleting an extension linked to a data consumer.'
    },
    unnamedSource: {
        id: 'fabric.editor.extension.sourceNoTitledName',
        defaultMessage: 'this element',
        description: 'The current element without preset name been selected'
    },
    adjustColumns: {
        id: 'fabric.editor.tables.adjustColumn',
        defaultMessage: 'Adjust column',
        description: 'Tooltip displayed on table column resize handle'
    },
    cornerControl: {
        id: 'fabric.editor.cornerControl',
        defaultMessage: 'Highlight table',
        description: 'A button on the upper left corner of the table that shows up when the table is in focus. Clicking on it will select the entire table.'
    },
    cellBackground: {
        id: 'fabric.editor.cellBackground',
        defaultMessage: 'Cell background',
        description: 'Change the background color of a table cell.'
    },
    backgroundColor: {
        id: 'fabric.editor.backgroundColor',
        defaultMessage: 'Background color',
        description: 'Change the background color of a table cell.'
    },
    mergeCells: {
        id: 'fabric.editor.mergeCells',
        defaultMessage: 'Merge cells',
        description: 'Merge tables cells together.'
    },
    splitCell: {
        id: 'fabric.editor.splitCell',
        defaultMessage: 'Split cell',
        description: 'Split a merged table cell.'
    },
    clearCells: {
        id: 'fabric.editor.clearCells',
        defaultMessage: 'Clear {0, plural, one {cell} other {cells}}',
        description: 'Clears the contents of the selected cells (this does not delete the cells themselves).'
    },
    sortColumnASC: {
        id: 'fabric.editor.sortColumnASC',
        defaultMessage: "Sort column A \u2192 Z",
        description: 'Sort column in ascending order'
    },
    sortColumnDESC: {
        id: 'fabric.editor.sortColumnDESC',
        defaultMessage: "Sort column Z \u2192 A",
        description: 'Sort column in descending order'
    },
    sortColumnIncreasing: {
        id: 'fabric.editor.sortColumnIncreasing',
        defaultMessage: 'Sort increasing',
        description: 'Sort column in ascending order'
    },
    sortColumnDecreasing: {
        id: 'fabric.editor.sortColumnDecreasing',
        defaultMessage: 'Sort decreasing',
        description: 'Sort column in descending order'
    },
    canNotSortTable: {
        id: 'fabric.editor.canNotSortTable',
        defaultMessage: `\u{26A0}\u{FE0F} You can't sort a table with merged cells`,
        description: `Split your cells to enable this feature`
    },
    distributeColumns: {
        id: 'fabric.editor.distributeColumns',
        defaultMessage: `Distribute columns`,
        description: `Distribute widths between selected columns`
    },
    lockColumnWidths: {
        id: 'fabric.editor.lockColumns',
        defaultMessage: 'Fixed column widths',
        description: 'Toggle button to enable fixed column widths'
    },
    rowControl: {
        id: 'fabric.editor.rowControl',
        defaultMessage: 'Highlight row',
        description: 'A button on the left of each row that shows up when the table is in focus. Clicking on it will select the entire row.'
    },
    rowDragHandle: {
        id: 'fabric.editor.rowDragHandle',
        defaultMessage: 'Row options',
        description: 'The row drag handle to move the row within the table. Click to open a menu for more row options.'
    },
    columnDragHandle: {
        id: 'fabric.editor.columnDragHandle',
        defaultMessage: 'Column options',
        description: 'The column drag handle to move the column within the table. Click to open a menu for more column options.'
    },
    fullWidthLabel: {
        id: 'fabric.editor.tableFullWidthLabel',
        defaultMessage: 'Full-width',
        description: 'Trigger table width to full-width mode'
    },
    startedColumnResize: {
        id: 'fabric.editor.tables.startedColumnResize',
        defaultMessage: 'Started column resize',
        description: 'Screen Reader announces when the user engages the column resizer'
    },
    focusedOtherResize: {
        id: 'fabric.editor.tables.otherResize',
        defaultMessage: '{direction, select, left {Switched to the left column resize} right {Switched to the right column resize} other {}}',
        description: 'Screen Reader announces when the user switches to the left or right column resizer'
    },
    changedColumnWidth: {
        id: 'fabric.editor.tables.columnWidth',
        defaultMessage: '{width, plural, one {Column width was changed to {width} pixel} other {Column width was changed to {width} pixels}}',
        description: 'Screen Reader announces when the user modifies the column width'
    },
    columnResizeStop: {
        id: 'fabric.editor.tables.resizeStop',
        defaultMessage: 'Stopped resize',
        description: 'Screen Reader announces when the user discontinues the resizing operation'
    },
    columnResizeOverflow: {
        id: 'fabric.editor.tables.columnResizeOverflow',
        defaultMessage: 'You can only resize this column while the table has a scroll bar.',
        description: 'Screen Reader announces when the user attempts to resize the last column without the table being in overflow state'
    },
    columnResizeLast: {
        id: 'fabric.editor.tables.columnResizeLast',
        defaultMessage: 'You can only resize this column to the left.',
        description: 'Screen Reader announces when the user attempts to resize the last column when only the previous one is available for resizing'
    },
    tableAlignmentOptions: {
        id: 'fabric.editor.tableAlignmentOptions',
        defaultMessage: 'Alignment options',
        description: 'Opens a menu with additional table alignment options'
    },
    alignTableCenter: {
        id: 'fabric.editor.alignTableCenter',
        defaultMessage: 'Align center',
        description: 'Aligns table to the center'
    },
    alignTableLeft: {
        id: 'fabric.editor.alignTableLeft',
        defaultMessage: 'Align left',
        description: 'Aligns table to the left'
    }
});

});

parcelRegister("kFJBG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a872fd5a03f73724$export$defe85febe8b728c);
// Common Translations will live here

var $7VHMR = parcelRequire("7VHMR");
const $a872fd5a03f73724$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    unorderedList: {
        id: 'fabric.editor.unorderedList',
        defaultMessage: 'Bullet list',
        description: "A list with bullets. Also known as an \u201Cunordered\u201D list"
    },
    unorderedListDescription: {
        id: 'fabric.editor.unorderedList.description',
        defaultMessage: 'Create an unordered list',
        description: ''
    },
    orderedList: {
        id: 'fabric.editor.orderedList',
        defaultMessage: 'Numbered list',
        description: "A list with ordered items 1\u2026 2\u2026 3\u2026"
    },
    orderedListDescription: {
        id: 'fabric.editor.orderedList.description',
        defaultMessage: 'Create an ordered list',
        description: ''
    },
    lists: {
        id: 'fabric.editor.lists',
        defaultMessage: 'Lists',
        description: 'Menu shows ordered/bullet list and unordered/numbered lists'
    },
    listsFormat: {
        id: 'fabric.editor.listsFormat',
        defaultMessage: 'List formatting',
        description: 'Aria label for the wrapper of list buttons'
    }
});

});

parcelRegister("7S9ZN", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9078664297972b18$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9078664297972b18$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    undo: {
        id: 'fabric.editor.undo',
        defaultMessage: 'Undo',
        description: 'Undo the previously performed action.'
    },
    redo: {
        id: 'fabric.editor.redo',
        defaultMessage: 'Redo',
        description: 'Redo the previously undone action.'
    }
});

});

parcelRegister("6OcHr", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b883afcc2fb8665e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b883afcc2fb8665e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    placeholder: {
        id: 'fabric.editor.statusPlaceholder',
        defaultMessage: 'Set a status',
        description: 'Placeholder description for an empty (new) status item in the editor'
    },
    editText: {
        id: 'fabric.editor.editStatusText',
        defaultMessage: 'Edit Status',
        description: 'Title for the input that changes the status text'
    },
    editColor: {
        id: 'fabric.editor.editStatusColor',
        defaultMessage: 'Edit Status Color',
        description: 'Title for the color picker that changes the status color'
    }
});

});

parcelRegister("dbepQ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $19b9098ff265842b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $19b9098ff265842b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    editText: {
        id: 'fabric.editor.editDateText',
        defaultMessage: 'Edit Date',
        description: 'Title for the input that changes the date'
    },
    invalidDateError: {
        id: 'fabric.editor.invalidDateError',
        defaultMessage: 'Enter a valid date',
        description: 'Error message when the date typed in is invalid, requesting they inputs a new date'
    },
    onKeyUpDownText: {
        id: 'fabric.editor.upDown',
        defaultMessage: 'On the use of up and down arrow keys into the following input field, the date will update below',
        description: 'The text for the date input informs the user that using the arrow keys (up and down) will update the date picker below'
    }
});

});

parcelRegister("kANLZ", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $2ae4030e88533f57$export$81b075fd34c2f0bb);

var $7VHMR = parcelRequire("7VHMR");
const $2ae4030e88533f57$export$81b075fd34c2f0bb = (0, $7VHMR.defineMessages)({
    singleColumn: {
        id: 'fabric.editor.single',
        defaultMessage: 'Single column layout',
        description: 'Layout with one single column'
    },
    twoColumns: {
        id: 'fabric.editor.twoColumns',
        defaultMessage: 'Two columns layout',
        description: 'Layout with two columns of equal width'
    },
    twoColumnsAdvancedLayout: {
        id: 'fabric.editor.twoColumns',
        defaultMessage: '2 Column layout',
        description: 'Layout with two columns of equal width'
    },
    threeColumns: {
        id: 'fabric.editor.threeColumns',
        defaultMessage: 'Three columns layout',
        description: 'Layout with three columns of equal width'
    },
    threeColumnsAdvancedLayout: {
        id: 'fabric.editor.threeColumns',
        defaultMessage: '3 Column layout',
        description: 'Layout with three columns of equal width'
    },
    fourColumns: {
        id: 'fabric.editor.fourColumns',
        defaultMessage: '4 Column layout',
        description: 'Layout with four columns of equal width'
    },
    fiveColumns: {
        id: 'fabric.editor.fiveColumns',
        defaultMessage: '5 Column layout',
        description: 'Layout with five columns of equal width'
    },
    rightSidebar: {
        id: 'fabric.editor.rightSidebar',
        defaultMessage: 'Right sidebar layout',
        description: 'Layout with two columns, left column is 2/3 and right is 1/3 of page'
    },
    leftSidebar: {
        id: 'fabric.editor.leftSidebar',
        defaultMessage: 'Left sidebar layout',
        description: 'Layout with two columns, left column is 1/3 and right is 2/3 of page'
    },
    threeColumnsWithSidebars: {
        id: 'fabric.editor.threeColumnsWithSidebars',
        defaultMessage: 'Three columns with sidebars layout',
        description: 'Layout with 3 columns laid out as 25% - 50% - 25%'
    },
    threeColumnsWithLeftSidebars: {
        id: 'fabric.editor.threeColumnsWithLeftSidebars',
        defaultMessage: 'Three columns with left sidebar layout',
        description: 'Layout with 3 columns laid out as 25% - 25% - 50%'
    },
    threeColumnsWithRightSidebars: {
        id: 'fabric.editor.threeColumnsWithRightSidebars',
        defaultMessage: 'Three columns with right sidebar layout',
        description: 'Layout with 3 columns laid out as 50% - 25% - 25%'
    },
    floatingToolbarRadioGroupAriaLabel: {
        id: 'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel',
        defaultMessage: 'Layout options',
        description: "a floating toolbar radiogroup's aria label"
    },
    layoutPlaceholder: {
        id: 'fabric.editor.layout.placeholder',
        defaultMessage: 'Add content',
        description: 'Add placeholder text for empty layout'
    },
    columnOption: {
        id: 'fabric.editor.layout.columnOption',
        defaultMessage: '{count, plural, one { Column} other {{count} Columns}}',
        description: 'column option text for layout'
    },
    resizeLayout: {
        id: 'fabric.editor.layout.resizeLayout',
        defaultMessage: 'Resize layout',
        description: 'resize layout'
    }
});

});

parcelRegister("kmmxF", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e4735e0a5cdca6f9$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $e4735e0a5cdca6f9$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    indent: {
        id: 'fabric.editor.indent',
        defaultMessage: 'Indent',
        description: 'Indent a list item, paragraph or heading'
    },
    outdent: {
        id: 'fabric.editor.outdent',
        defaultMessage: 'Outdent',
        description: 'Outdent a list item, paragraph or heading'
    }
});

});

parcelRegister("80TXs", function(module, exports) {

$parcel$export(module.exports, "avatarGroupMessages", () => $cedd04a0024a64f8$export$8a0e7c3f8f5b8868);

var $7VHMR = parcelRequire("7VHMR");
const $cedd04a0024a64f8$export$8a0e7c3f8f5b8868 = (0, $7VHMR.defineMessages)({
    editors: {
        id: 'fabric.editor.editors',
        defaultMessage: 'Editors',
        description: 'classifying the people that are currently editing the document'
    }
});

});

parcelRegister("9QBHe", function(module, exports) {

$parcel$export(module.exports, "findReplaceMessages", () => $b943fdad34912591$export$b46a930e1a386b2e);

var $7VHMR = parcelRequire("7VHMR");
const $b943fdad34912591$export$b46a930e1a386b2e = (0, $7VHMR.defineMessages)({
    find: {
        id: 'fabric.editor.find',
        defaultMessage: 'Find',
        description: 'The word or phrase to search for on the document'
    },
    matchCase: {
        id: 'fabric.editor.matchCase',
        defaultMessage: 'Match case',
        description: 'Toggle whether should also match case when searching for text'
    },
    findNext: {
        id: 'fabric.editor.findNext',
        defaultMessage: 'Find next',
        description: 'Locate the next occurrence of the word or phrase that was searched for'
    },
    findPrevious: {
        id: 'fabric.editor.findPrevious',
        defaultMessage: 'Find previous',
        description: 'Locate the previous occurrence of the word or phrase that was searched for'
    },
    closeFindReplaceDialog: {
        id: 'fabric.editor.closeFindReplaceDialog',
        defaultMessage: 'Close',
        description: 'Cancel search and close the "Find and Replace" dialog'
    },
    noResultsFound: {
        id: 'fabric.editor.noResultsFound',
        defaultMessage: 'No results',
        description: 'No matches were found for the word or phrase that was searched for'
    },
    resultsCount: {
        id: 'fabric.editor.resultsCount',
        description: 'Text for selected search match position and total results count',
        defaultMessage: '{selectedMatchPosition} of {totalResultsCount}'
    },
    findReplaceToolbarButton: {
        id: 'fabric.editor.findReplaceToolbarButton',
        defaultMessage: 'Find and replace',
        description: '"Find" highlights all instances of a word or phrase on the document, and "Replace" changes one or all of those instances to something else'
    },
    replaceWith: {
        id: 'fabric.editor.replaceWith',
        defaultMessage: 'Replace with',
        description: 'The value that will replace the word or phrase that was searched for'
    },
    replace: {
        id: 'fabric.editor.replace',
        defaultMessage: 'Replace',
        description: 'Replace only the currently selected instance of the word or phrase'
    },
    replaceAll: {
        id: 'fabric.editor.replaceAll',
        defaultMessage: 'Replace all',
        description: 'Replace all instances of the word or phrase throughout the entire document'
    },
    replaceSuccess: {
        id: 'fabric.editor.replaceSuccess',
        defaultMessage: '{numberOfMatches, plural, one {# match replaced} other {# matches replaced}}',
        description: 'Text when replacement succesfully done'
    }
});

});

parcelRegister("kAM3u", function(module, exports) {

$parcel$export(module.exports, "textColorMessages", () => $147c4cd461faf1fe$export$effb4ee8b6f74abe);

var $7VHMR = parcelRequire("7VHMR");
const $147c4cd461faf1fe$export$effb4ee8b6f74abe = (0, $7VHMR.defineMessages)({
    textColor: {
        id: 'fabric.editor.textColor',
        defaultMessage: '{selectedColorName} Text color',
        description: 'Label of menu that provides access to various colors of text. For example: green Text color, dark blue Text color'
    },
    textColorTooltip: {
        id: 'fabric.editor.textColorTooltip',
        defaultMessage: 'Text color',
        description: 'Toolip of menu that provides access to various colors of text.'
    }
});

});

parcelRegister("6lWmZ", function(module, exports) {

$parcel$export(module.exports, "tasksAndDecisionsMessages", () => $65d46911a2519e83$export$273d864e9e6d0b1f);

var $7VHMR = parcelRequire("7VHMR");
const $65d46911a2519e83$export$273d864e9e6d0b1f = (0, $7VHMR.defineMessages)({
    taskPlaceholder: {
        id: 'fabric.editor.taskPlaceholder',
        defaultMessage: "Type your action, use '@' to assign to someone.",
        description: 'Placeholder description for an empty action/task in the editor'
    },
    decisionPlaceholder: {
        id: 'fabric.editor.decisionPlaceholder',
        defaultMessage: "Add a decision\u2026",
        description: 'Placeholder description for an empty decision in the editor'
    },
    editAccessTitle: {
        id: 'fabric.editor.editAccessTitle',
        defaultMessage: 'You need edit access',
        description: 'Title in the popup when we click on action item checkbox without edit permission'
    },
    requestToEditDescription: {
        id: 'fabric.editor.requestToEditDescription',
        defaultMessage: 'When you request access, the page owner will receive a notification.',
        description: 'Description in the popup when we click on action item checkbox without edit permission'
    },
    requestToEdit: {
        id: 'fabric.editor.requestToEdit',
        defaultMessage: 'Request to edit',
        description: 'Button in the popup when we click on action item checkbox without edit permission'
    },
    dismiss: {
        id: 'fabric.editor.requestToEditDismiss',
        defaultMessage: 'Dismiss',
        description: 'Button in the popup when we click on dismiss without edit permission'
    }
});

});

parcelRegister("ixwvf", function(module, exports) {

$parcel$export(module.exports, "placeholderTextMessages", () => $358e275c47040b0e$export$ee8ab8a034b5a8bd);

var $7VHMR = parcelRequire("7VHMR");
const $358e275c47040b0e$export$ee8ab8a034b5a8bd = (0, $7VHMR.defineMessages)({
    placeholderTextPlaceholder: {
        id: 'fabric.editor.placeholderTextPlaceholder',
        defaultMessage: 'Add placeholder text',
        description: ''
    }
});

});

parcelRegister("fJm1A", function(module, exports) {

$parcel$export(module.exports, "pasteOptionsToolbarMessages", () => $b0fedd2e9a93e39a$export$703e803e9cb0cea4);

var $7VHMR = parcelRequire("7VHMR");
const $b0fedd2e9a93e39a$export$703e803e9cb0cea4 = (0, $7VHMR.defineMessages)({
    pasteOptions: {
        id: 'fabric.editor.pasteOptions',
        defaultMessage: 'Paste options',
        description: 'Opens a menu with additional paste options'
    },
    plainText: {
        id: 'fabric.editor.plainText',
        defaultMessage: 'Use plain text',
        description: 'Converts pasted text into plain text'
    },
    markdown: {
        id: 'fabric.editor.useMarkdown',
        defaultMessage: 'Use Markdown',
        description: 'Converts pasted text into Markdown'
    },
    richText: {
        id: 'fabric.editor.richText',
        defaultMessage: 'Use rich text',
        description: 'Converts pasted text into Rich text'
    }
});

});

parcelRegister("ecAvy", function(module, exports) {

$parcel$export(module.exports, "panelMessages", () => $e955dc2d97d725ff$export$7bb18eb6f9170174);

var $7VHMR = parcelRequire("7VHMR");
const $e955dc2d97d725ff$export$7bb18eb6f9170174 = (0, $7VHMR.defineMessages)({
    info: {
        id: 'fabric.editor.info',
        defaultMessage: 'Info',
        description: 'Panels provide a way to highlight text. The info panel has a blue background.'
    },
    note: {
        id: 'fabric.editor.note',
        defaultMessage: 'Note',
        description: 'Panels provide a way to highlight text. The note panel has a purple background.'
    },
    success: {
        id: 'fabric.editor.success',
        defaultMessage: 'Success',
        description: 'Panels provide a way to highlight text. The success panel has a green background.'
    },
    warning: {
        id: 'fabric.editor.warning',
        defaultMessage: 'Warning',
        description: 'Panels provide a way to highlight text. The warning panel has a yellow background.'
    },
    error: {
        id: 'fabric.editor.error',
        defaultMessage: 'Error',
        description: 'Panels provide a way to highlight text. The error panel has a red background.'
    },
    emoji: {
        id: 'fabric.editor.panel.emoji',
        defaultMessage: 'Add emoji',
        description: 'Select the panel icon'
    },
    backgroundColor: {
        id: 'fabric.editor.panel.backgroundColor',
        defaultMessage: 'Background color',
        description: 'Select the panel background color.'
    },
    panelsGroup: {
        id: 'fabric.editor.panel.panelsGroup',
        defaultMessage: 'Panel Types',
        description: 'aria-label for group of panels the floating toolbar'
    }
});

});

parcelRegister("7ywdr", function(module, exports) {

$parcel$export(module.exports, "mentionMessages", () => $a3d6d16f96d339d5$export$33aafd5ccbbbd00a);

var $7VHMR = parcelRequire("7VHMR");
const $a3d6d16f96d339d5$export$33aafd5ccbbbd00a = (0, $7VHMR.defineMessages)({
    inviteItemTitle: {
        id: 'fabric.editor.inviteItem.title',
        defaultMessage: '{userRole, select, admin {Invite} trusted {Invite} other {Add}} teammate to {productName}',
        description: 'Title of the invite teammate item in typeahead plugin'
    },
    mentionsAddLabel: {
        id: 'fabric.editor.mentionsAddLabel',
        defaultMessage: 'add-icon',
        description: 'icon label to describe adding a new mention'
    },
    mentionsIconLabel: {
        id: 'fabric.editor.mentionsIconLabel',
        defaultMessage: 'Mention',
        description: 'icon label to describe the mention icon'
    },
    mentionsNodeLabel: {
        id: 'fabric.editor.mentionNode.label',
        defaultMessage: 'Tagged user',
        description: 'Label to indicate mention node to Screen reader users, that preceeds with user name ex: "Tagged user @XXX'
    },
    unknownLabel: {
        id: 'fabric.editor.unknown.label',
        defaultMessage: 'Unknown',
        description: 'Label to indicate unknown mention node'
    }
});

});

parcelRegister("1ElKj", function(module, exports) {

$parcel$export(module.exports, "helpDialogMessages", () => $691908dbd48d7aae$export$83c85447c71428ba);

var $7VHMR = parcelRequire("7VHMR");
const $691908dbd48d7aae$export$83c85447c71428ba = (0, $7VHMR.defineMessages)({
    editorHelp: {
        id: 'fabric.editor.editorHelp',
        defaultMessage: 'Editor help',
        description: 'Title of editor help dialog.'
    },
    helpDialogTips: {
        id: 'fabric.editor.helpDialogTips',
        defaultMessage: 'Press {keyMap} to quickly open this dialog at any time',
        description: 'Hint about how to open a dialog quickly using a shortcut.'
    },
    keyboardShortcuts: {
        id: 'fabric.editor.keyboardShortcuts',
        defaultMessage: 'Keyboard shortcuts',
        description: ''
    },
    markdown: {
        id: 'fabric.editor.markdown',
        defaultMessage: 'Markdown',
        description: 'It is a name of popular markup language.'
    },
    pastePlainText: {
        id: 'fabric.editor.pastePlainText',
        defaultMessage: 'Paste plain text',
        description: ''
    },
    CheckUncheckActionItem: {
        id: 'fabric.editor.checkUncheckActionItem',
        defaultMessage: 'Toggle action item',
        description: 'For Check/Uncheck Action item use shortcut'
    },
    InsertTableColumn: {
        id: 'fabric.editor.insertTableColumn',
        defaultMessage: 'Insert table column',
        description: 'For insert table column'
    },
    InsertTableRow: {
        id: 'fabric.editor.insertTableRow',
        defaultMessage: 'Insert table row',
        description: 'For insert table row'
    },
    altText: {
        id: 'fabric.editor.altText',
        defaultMessage: 'Alt text',
        description: 'Alternative text for image.'
    },
    selectTableRow: {
        id: 'fabric.editor.selectTableRow',
        defaultMessage: 'Select table row',
        description: 'Hint for selecting a table row using a shortcut'
    },
    selectTableColumn: {
        id: 'fabric.editor.selectTableColumn',
        defaultMessage: 'Select table column',
        description: 'Hint for selecting a table column using a shortcut'
    },
    selectColumnResize: {
        id: 'fabric.editor.selectColumnResize',
        defaultMessage: 'Select column resize',
        description: 'Hint for selecting a column resize a shortcut'
    },
    increaseSize: {
        id: 'fabric.editor.increaseSize',
        defaultMessage: 'Increase table or media size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to increase the width of the selected element. Optimal characters less than 21.'
    },
    decreaseSize: {
        id: 'fabric.editor.decreaseSize',
        defaultMessage: 'Decrease table or media size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to decrease the width of the selected element. Optimal characters less than 21.'
    },
    openCellOptions: {
        id: 'fabric.editor.openCellOptions',
        defaultMessage: 'Open cell options',
        description: 'Keyboard shortcut to open cell options.'
    },
    focusTableResizeHandle: {
        id: 'fabric.editor.focusTableResizeHandle',
        defaultMessage: 'Focus table resize handle',
        description: 'Focus table resize handle'
    },
    closeHelpDialog: {
        id: 'fabric.editor.closeHelpDialog',
        defaultMessage: 'Close help dialog',
        description: ''
    },
    // TODO: Move it inside quick insert plugin
    quickInsert: {
        id: 'fabric.editor.quickInsert',
        defaultMessage: 'Quick insert',
        description: 'Name of a feature, which let you insert items quickly.'
    },
    highlightColor: {
        id: 'fabric.editor.highlightColor',
        defaultMessage: 'Toggle highlight color palette',
        description: 'Keyboard shortcut to toggle highlight color palette.'
    }
});

});

parcelRegister("3AEXe", function(module, exports) {

$parcel$export(module.exports, "mediaInsertMessages", () => $a755ba82139b4a7d$export$7eb9dc59242bbc45);

var $7VHMR = parcelRequire("7VHMR");
const $a755ba82139b4a7d$export$7eb9dc59242bbc45 = (0, $7VHMR.defineMessages)({
    loadPreview: {
        id: 'fabric.editor.media.insert.loadPreview',
        defaultMessage: 'Load preview',
        description: 'Text on a button that loads a preview of a media file that has been linked to from a URL'
    },
    insert: {
        id: 'fabric.editor.media.insert.insert',
        defaultMessage: 'Insert',
        description: 'Text on the modal action button that inserts the linked media file into the editor document'
    },
    pasteLinkToUpload: {
        id: 'fabric.editor.media.insert.pasteLinkToUpload',
        defaultMessage: 'Paste link to upload',
        description: 'Placeholder text for the input field where a user can paste (as in copy-paste) a URL to upload a media file'
    },
    cancel: {
        id: 'fabric.editor.media.insert.cancel',
        defaultMessage: 'Cancel',
        description: 'Text on the modal action button that cancels the media file insertion and closes the modal'
    },
    fromUrlErrorMessage: {
        id: 'fabric.editor.media.insert.fromUrlErrorMessage',
        defaultMessage: "Unfortunately, we can\u2019t add this image link. Download the image, then drag and drop onto the page.",
        description: 'Error message displayed when a user tries to insert an image from a URL that cannot be loaded. This may be because the URL is invalid, there is a network error or any other reason the preview upload does not succeed. When this occurs the suggestion is to attempt downloading the linked file manually and using a local upload instead.'
    },
    fromUrlWarning: {
        id: 'fabric.editor.media.insert.fromUrlWarning',
        defaultMessage: 'This image might not be visible to others due to source restrictions. Consider uploading the file instead.',
        description: 'Warning message displayed when a user tries to insert an image from a URL that may not be visible to others due to source restrictions such as not having permissions/authentication to load the image. The suggestion is to upload the file instead.'
    },
    localFileNetworkErrorMessage: {
        id: 'fabric.editor.media.insert.localFileNetworkErrorMessage',
        defaultMessage: 'File upload error. Check file path or network.',
        description: 'Error message displayed when a network error occurs during file upload'
    },
    localFileErrorMessage: {
        id: 'fabric.editor.media.insert.localFileErrorMessage',
        defaultMessage: "This file couldn\u2019t be uploaded.",
        description: 'Generic catch-all error message displayed when file upload fails'
    },
    mediaAlt: {
        id: 'fabric.editor.media.insert.mediaAlt',
        defaultMessage: 'Preview for uploaded image or video file',
        description: 'Alt text describing a preview of an image uploaded.'
    },
    upload: {
        id: 'fabric.editor.media.insert.upload',
        defaultMessage: 'Upload',
        description: 'Text on a button that opens a file picker dialog to upload a media file'
    },
    linkTabTitle: {
        id: 'fabric.editor.media.insert.linkTabTitle',
        defaultMessage: 'Link',
        description: 'Title of the navigation tab that allows users to insert media from a URL or link'
    },
    fileTabTitle: {
        id: 'fabric.editor.media.insert.fileTabTitle',
        defaultMessage: 'File',
        description: 'Title of the navigation tab that allows users to upload local media files'
    },
    mediaPickerPopupAriaLabel: {
        id: 'fabric.editor.media.insert.mediaPickerPopupAriaLabel',
        defaultMessage: 'Media picker',
        description: 'Accessibility label for the media picker popup'
    },
    invalidUrlErrorMessage: {
        id: 'fabric.editor.media.insert.invalidUrlErrorMessage',
        defaultMessage: 'Invalid link',
        description: 'Error message displayed when a user tries to insert media from an invalid URL'
    }
});

});


parcelRegister("eQcNy", function(module, exports) {

$parcel$export(module.exports, "walkUpTreeUntil", () => $ab609be3c0cbf6e9$export$df14aaf7a527ab0c);
$parcel$export(module.exports, "unwrap", () => $ab609be3c0cbf6e9$export$debb760848ca95a);
$parcel$export(module.exports, "removeNestedEmptyEls", () => $ab609be3c0cbf6e9$export$5b66dc78851adb5e);
$parcel$export(module.exports, "containsClassName", () => $ab609be3c0cbf6e9$export$c8913a477cc44663);
$parcel$export(module.exports, "closest", () => $ab609be3c0cbf6e9$export$ff7f7c97cdce86e);
$parcel$export(module.exports, "closestElement", () => $ab609be3c0cbf6e9$export$d508bcfb7f019487);
$parcel$export(module.exports, "parsePx", () => $ab609be3c0cbf6e9$export$b0eef8cd00b29d5c);
$parcel$export(module.exports, "maphElem", () => $ab609be3c0cbf6e9$export$5b6ab01a6efa50e2);
/**
 * Walks a DOM tree up to the provided `stopElement`, or if falsy before.
 * @param element
 * @param stopElement
 */ function $ab609be3c0cbf6e9$export$df14aaf7a527ab0c(element, shouldStop) {
    let rootElement = element;
    while(rootElement && rootElement.parentElement && !shouldStop(rootElement))rootElement = rootElement.parentElement;
    return rootElement;
}
function $ab609be3c0cbf6e9$export$debb760848ca95a(parent, wrapped) {
    const docsFragment = document.createDocumentFragment();
    Array.from(wrapped.children).forEach((child)=>{
        docsFragment.appendChild(child);
    });
    parent.replaceChild(docsFragment, wrapped);
}
function $ab609be3c0cbf6e9$export$5b66dc78851adb5e(el) {
    while(el.parentElement && el.childElementCount === 0 && el.textContent === ''){
        const parentEl = el.parentElement;
        parentEl.removeChild(el);
        el = parentEl;
    }
}
const $ab609be3c0cbf6e9$export$c8913a477cc44663 = (node, className)=>{
    if (!node) return false;
    if (node.classList && node.classList.contains) return node.classList.contains(className);
    if (!node.className) return false;
    const classNames = typeof node.className.baseVal === 'string' ? node.className.baseVal : node.className;
    return classNames.split(' ').indexOf(className) !== -1;
};
function $ab609be3c0cbf6e9$export$ff7f7c97cdce86e(node, s) {
    if (!node) return null;
    let el = node;
    if (!document.documentElement || !document.documentElement.contains(el)) return null;
    if (el.closest) return el.closest(s);
    do {
        const matchfn = el.matches ? el.matches : el.msMatchesSelector;
        if (matchfn && matchfn.call(el, s)) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function $ab609be3c0cbf6e9$export$d508bcfb7f019487(node, s) {
    return $ab609be3c0cbf6e9$export$ff7f7c97cdce86e(node, s);
}
function $ab609be3c0cbf6e9$export$b0eef8cd00b29d5c(pxStr) {
    if (!pxStr.endsWith('px')) return undefined;
    const maybeNumber = parseInt(pxStr, 10);
    return !Number.isNaN(maybeNumber) ? maybeNumber : undefined;
}
function $ab609be3c0cbf6e9$export$b2d5d4f1aeebddf1(elem, callback) {
    const array = [];
    for(let i = 0; i < elem.childElementCount; i++)array.push(callback(elem.children[i], i, elem));
    return array;
}
function $ab609be3c0cbf6e9$export$5b6ab01a6efa50e2(elem, callback) {
    return $ab609be3c0cbf6e9$export$b2d5d4f1aeebddf1(elem, callback);
}

});


parcelRegister("l8Gxi", function(module, exports) {

$parcel$export(module.exports, "RendererCssClassName", () => $ca55565f908e8e5d$export$91f3bbbf974496e2);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $ca55565f908e8e5d$var$clPrefix = 'ak-renderer-';
const $ca55565f908e8e5d$export$91f3bbbf974496e2 = {
    DOCUMENT: `${$ca55565f908e8e5d$var$clPrefix}document`,
    EXTENSION: `${$ca55565f908e8e5d$var$clPrefix}extension`,
    EXTENSION_CENTER_ALIGN: `${$ca55565f908e8e5d$var$clPrefix}extension-center-align`,
    EXTENSION_OVERFLOW_CONTAINER: `${$ca55565f908e8e5d$var$clPrefix}extension-overflow-container`,
    NUMBER_COLUMN: `${$ca55565f908e8e5d$var$clPrefix}table-number-column`,
    SORTABLE_COLUMN_WRAPPER: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sortable-column__wrapper`,
    SORTABLE_COLUMN: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sortable-column`,
    SORTABLE_COLUMN_ICON_WRAPPER: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sorting-icon__wrapper`,
    SORTABLE_COLUMN_NO_ORDER: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sorting-icon__no-order`
};

});


parcelRegister("8Eu7T", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $19f8e43ef61748ed$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $dWAZk = parcelRequire("dWAZk");

var $1KzE6 = parcelRequire("1KzE6");

var $knXBU = parcelRequire("knXBU");

var $7Jxgt = parcelRequire("7Jxgt");
class $19f8e43ef61748ed$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    fireAnalyticsEvent(event) {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) {
            const channel = (0, $dWAZk.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        const additionalInfo = this.props.additionalInfo ?? '';
        this.fireAnalyticsEvent({
            action: (0, $gkwXh.ACTION).CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB,
                errorMessage: `${additionalInfo}${error?.message}`,
                componentStack: errorInfo?.componentStack || undefined,
                errorRethrown: Boolean(this.props.rethrowError)
            }
        });
        (0, $1KzE6.logException)(error, {
            location: 'renderer'
        });
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const pattern = /Failed to execute.*on 'Node'.*/;
        const matchesPattern = pattern.test(error.message);
        if (matchesPattern) {
            this.fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).CAUGHT_DOM_ERROR,
                actionSubject: this.props.component,
                actionSubjectId: this.props.componentId,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB,
                    errorMessage: `${additionalInfo}${error?.message}`
                }
            });
            this.setState(()=>({
                    domError: true
                }));
        }
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        }, ()=>{
            if (this.props.rethrowError) throw error;
        });
    }
    render() {
        if (this.state.domError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
            key: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))()
        }, this.props.children);
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            errorCaptured: false,
            domError: false
        };
    }
}

});
parcelRegister("1KzE6", function(module, exports) {

$parcel$export(module.exports, "logException", () => $8cb678cf4830ec10$export$f86b2a1a2ce291b3);

var $8eFcy = parcelRequire("8eFcy");
const $8cb678cf4830ec10$var$SENTRY_DSN = 'https://0b10c8e02fb44d8796c047b102c9bee8@o55978.ingest.sentry.io/4505129224110080';
const $8cb678cf4830ec10$var$packageName = 'editor-common'; // Sentry doesn't accept '/' in its releases https://docs.sentry.io/platforms/javascript/configuration/releases/
const $8cb678cf4830ec10$var$packageVersion = "0.0.0-use.local";
const $8cb678cf4830ec10$var$sanitiseSentryEvents = (data, _hint)=>{
    // Remove URL as it has UGC
    // TODO: Sanitise the URL instead of just removing it
    if (data.request) delete data.request.url;
    return data;
};


const $8cb678cf4830ec10$export$f86b2a1a2ce291b3 = async (error, tags)=>{
    try {
        const { BrowserClient: BrowserClient, defaultIntegrations: defaultIntegrations, getCurrentHub: getCurrentHub } = await (parcelRequire("8IyQ8"));
        const { ExtraErrorData: ExtraErrorData } = await (parcelRequire("eqokj"));
        const sentryOptions = {
            dsn: (0, $8eFcy.isFedRamp)() ? undefined : $8cb678cf4830ec10$var$SENTRY_DSN,
            release: `${$8cb678cf4830ec10$var$packageName}@${$8cb678cf4830ec10$var$packageVersion}`,
            environment: undefined ?? 'unknown',
            ignoreErrors: [
                // Network issues
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /^network error/i,
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /^network failure/i,
                'TypeError: Failed to fetch',
                // A benign error, see https://stackoverflow.com/a/50387233/2645305
                'ResizeObserver loop limit exceeded',
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /ResizeObserver loop completed with undelivered notifications/
            ],
            autoSessionTracking: false,
            integrations: (_integrations)=>[
                    // Remove the Breadcrumbs integration from the default as it's too likely to log UGC/PII
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/default/
                    ...defaultIntegrations.filter(({ name: name })=>name !== 'Breadcrumbs'),
                    // Extracts all non-native attributes from the error object and attaches them to the event as the extra data
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/plugin/?original_referrer=https%3A%2F%2Fduckduckgo.com%2F#extraerrordata
                    new ExtraErrorData()
                ],
            beforeSend: $8cb678cf4830ec10$var$sanitiseSentryEvents
        };
        // Use a client to avoid picking up the errors from parent applications
        const client = new BrowserClient(sentryOptions);
        const hub = getCurrentHub();
        hub.bindClient(client);
        hub.withScope((scope)=>{
            scope.setTags({
                // Jira environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-bundler': window.BUNDLER_VERSION,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-variant': window.BUILD_VARIANT,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-release': window.BUILD_KEY,
                // Confluence environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'confluence-frontend-version': window.__buildInfo?.FRONTEND_VERSION,
                ...tags
            });
            // Explicitly remove the breadcrumbs as it's too likely to log UGC/PII to side-step the hub integrations not being respected
            scope.clearBreadcrumbs();
            hub.captureException(error);
        });
        return client.close();
    } catch (_error) {
    // Error reporting failed, we don't want this to generate more errors
    }
};

});
parcelRegister("8eFcy", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", () => $1a8a754a294d51a4$export$64d6499adf9b2e51);
const $1a8a754a294d51a4$var$FEDRAMP_MODERATE = 'fedramp-moderate';
function $1a8a754a294d51a4$export$64d6499adf9b2e51() {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === $1a8a754a294d51a4$var$FEDRAMP_MODERATE;
    const matches = global.location?.hostname?.match(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});

parcelRegister("8IyQ8", function(module, exports) {

let $658d753eb7264f71$var$load = (parcelRequire("28QjX"))(4);
module.exports = $658d753eb7264f71$var$load("56SDo").then(()=>parcelRequire('hFoxV'));

});

parcelRegister("eqokj", function(module, exports) {

let $a8065d22b57a6f1c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a8065d22b57a6f1c$var$load("a12Xb").then(()=>parcelRequire('1dEW4'));

});


parcelRegister("knXBU", function(module, exports) {

$parcel$export(module.exports, "PLATFORM", () => $11894d4d5d86b4b1$export$88c4881e092abcaf);
$parcel$export(module.exports, "MODE", () => $11894d4d5d86b4b1$export$e48589d9e4824227);
var $11894d4d5d86b4b1$export$88c4881e092abcaf = /*#__PURE__*/ function(PLATFORM) {
    PLATFORM["NATIVE"] = "mobileNative";
    PLATFORM["HYBRID"] = "mobileHybrid";
    PLATFORM["WEB"] = "web";
    return PLATFORM;
}({});
var $11894d4d5d86b4b1$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $11894d4d5d86b4b1$var$RESOLVE_METHOD = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}($11894d4d5d86b4b1$var$RESOLVE_METHOD || {});

});


parcelRegister("cWCI0", function(module, exports) {

$parcel$export(module.exports, "EVENT_TYPE", () => $78ed418dcea0e38c$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $78ed418dcea0e38c$export$9523889e0a5da4ba);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $78ed418dcea0e38c$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $78ed418dcea0e38c$export$9957974f8b4d8f74);
var $78ed418dcea0e38c$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $78ed418dcea0e38c$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["STARTED"] = "started";
    ACTION["RENDERED"] = "rendered";
    ACTION["RENDERER_TTI"] = "tti";
    ACTION["CRASHED"] = "unhandledErrorCaught";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["CLICKED"] = "clicked";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["INSERTED"] = "inserted";
    ACTION["OPENED"] = "opened";
    ACTION["CLOSED"] = "closed";
    ACTION["DELETED"] = "deleted";
    ACTION["EDITED"] = "edited";
    ACTION["RESOLVED"] = "resolved";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    return ACTION;
}({});
var $78ed418dcea0e38c$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["MEDIA"] = "media";
    return ACTION_SUBJECT;
}({});
var $78ed418dcea0e38c$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    return ACTION_SUBJECT_ID;
}({});

});

parcelRegister("4YrGg", function(module, exports) {

$parcel$export(module.exports, "AnnotationsPositionContext", () => $5dd0541565473935$export$8c8c3e12db6c0591);
$parcel$export(module.exports, "AnnotationsWrapper", () => $5dd0541565473935$export$cef0157dd42cbb3f);

var $5uXOq = parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $eka68 = parcelRequire("eka68");

var $8Mz83 = parcelRequire("8Mz83");

var $iYAgE = parcelRequire("iYAgE");

var $joddd = parcelRequire("joddd");

var $1oOiu = parcelRequire("1oOiu");

var $2NMNM = parcelRequire("2NMNM");

var $2EsbE = parcelRequire("2EsbE");

var $kuusl = parcelRequire("kuusl");
const $5dd0541565473935$var$LoadAnnotations = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    (0, $joddd.useLoadAnnotations)({
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    });
    return null;
});
const $5dd0541565473935$export$8c8c3e12db6c0591 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    startPos: 1
});
const $5dd0541565473935$export$cef0157dd42cbb3f = (props)=>{
    const { children: children, annotationProvider: annotationProvider, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    const updateSubscriber = annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.updateSubscriber;
    const inlineCommentAnnotationsState = (0, $1oOiu.useAnnotationStateByTypeEvent)({
        type: (0, $88i6h.AnnotationTypes).INLINE_COMMENT,
        updateSubscriber: updateSubscriber || null
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iYAgE.ProvidersContext).Provider, {
        value: annotationProvider
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iYAgE.InlineCommentsStateContext).Provider, {
        value: inlineCommentAnnotationsState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2EsbE.AnnotationRangeProvider), {
        allowCommentsOnMedia: annotationProvider?.inlineComment?.allowCommentsOnMedia ?? false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kuusl.AnnotationHoverContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Mz83.AnnotationsContextWrapper), {
        createAnalyticsEvent: createAnalyticsEvent,
        rendererRef: rendererRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5dd0541565473935$var$LoadAnnotations, {
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eka68.AnnotationView), {
        isNestedRender: isNestedRender,
        createAnalyticsEvent: createAnalyticsEvent
    }), children)))));
};

});
parcelRegister("eka68", function(module, exports) {

$parcel$export(module.exports, "AnnotationView", () => $38b360e678e45e5a$export$41cd4a02859c2806);

var $5uXOq = parcelRequire("5uXOq");

var $iYAgE = parcelRequire("iYAgE");

var $1oOiu = parcelRequire("1oOiu");

var $fCNtA = parcelRequire("fCNtA");
const $38b360e678e45e5a$export$41cd4a02859c2806 = (props)=>{
    const providers = (0, $5uXOq.useContext)((0, $iYAgE.ProvidersContext));
    const actionContext = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const inlineCommentProvider = providers && providers.inlineComment;
    const updateSubscriber = inlineCommentProvider && inlineCommentProvider.updateSubscriber || null;
    const viewComponentProps = (0, $1oOiu.useAnnotationClickEvent)({
        updateSubscriber: updateSubscriber,
        createAnalyticsEvent: props.createAnalyticsEvent,
        isNestedRender: props.isNestedRender
    });
    const ViewComponent = inlineCommentProvider && inlineCommentProvider.viewComponent;
    const deleteAnnotation = (0, $5uXOq.useMemo)(()=>(annotationInfo)=>actionContext.deleteAnnotation(annotationInfo.id, annotationInfo.type), [
        actionContext
    ]);
    // For view mode, the finding of inline node types is a bit more complex,
    // that's why we will not provide it as a `inlineNodeTypes` props to the view component,
    // to speed up the rendering process.
    const getInlineNodeTypes = (0, $5uXOq.useCallback)((annotationId)=>actionContext.getInlineNodeTypes(annotationId), [
        actionContext
    ]);
    if (ViewComponent && viewComponentProps) {
        const { annotations: annotations, clickElementTarget: clickElementTarget } = viewComponentProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ViewComponent, {
            annotations: annotations,
            clickElementTarget: clickElementTarget,
            deleteAnnotation: deleteAnnotation,
            getInlineNodeTypes: getInlineNodeTypes
        });
    }
    return null;
};

});
parcelRegister("iYAgE", function(module, exports) {

$parcel$export(module.exports, "AnnotationsDraftContext", () => $1cf3b601714e6f28$export$365d1799d81a236d);
$parcel$export(module.exports, "ProvidersContext", () => $1cf3b601714e6f28$export$6a26b015ac619737);
$parcel$export(module.exports, "InlineCommentsStateContext", () => $1cf3b601714e6f28$export$aafe46a36ef535ba);
$parcel$export(module.exports, "AnnotationsDraftContextWrapper", () => $1cf3b601714e6f28$export$153126608e00390);

var $5uXOq = parcelRequire("5uXOq");
const $1cf3b601714e6f28$export$365d1799d81a236d = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $1cf3b601714e6f28$export$6a26b015ac619737 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $1cf3b601714e6f28$export$aafe46a36ef535ba = /*#__PURE__*/ (0, $5uXOq.createContext)({});
class $1cf3b601714e6f28$export$153126608e00390 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { children: children } = this.props;
        const { position: position } = this.state;
        const applyAnnotationDraftAt = this.applyAnnotationDraftAt;
        const clearAnnotationDraft = this.clearAnnotationDraft;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1cf3b601714e6f28$export$365d1799d81a236d.Provider, {
            value: position
        }, children({
            applyAnnotationDraftAt: applyAnnotationDraftAt,
            clearAnnotationDraft: clearAnnotationDraft
        }));
    }
    constructor(...args){
        super(...args), this.state = {
            position: null
        }, this.applyAnnotationDraftAt = (nextPosition)=>{
            const { setDraftRange: setDraftRange } = this.props;
            // Set the draft range to preserve it downstream
            setDraftRange();
            // We need to support a new draft being made while one exists and overwrite it
            // Set the document position for the newly created draft
            this.setState({
                position: nextPosition
            });
        }, this.clearAnnotationDraft = ()=>{
            const { clearDraftRange: clearDraftRange } = this.props;
            // Clear the draft range
            clearDraftRange();
            // Clear the draft position in the document
            this.setState({
                position: null
            });
        };
    }
}

});

parcelRegister("1oOiu", function(module, exports) {

$parcel$export(module.exports, "useAnnotationStateByTypeEvent", () => $477334c02b9da473$export$95f9f9045e92d283);
$parcel$export(module.exports, "useHasFocusEvent", () => $477334c02b9da473$export$48f5d7f6702be07c);
$parcel$export(module.exports, "useAnnotationClickEvent", () => $477334c02b9da473$export$26cf539704e444c1);

var $5uXOq = parcelRequire("5uXOq");

var $dEtqo = parcelRequire("dEtqo");

var $iEN9D = parcelRequire("iEN9D");

var $88i6h = parcelRequire("88i6h");

var $gkwXh = parcelRequire("gkwXh");

var $dWAZk = parcelRequire("dWAZk");
const $477334c02b9da473$export$95f9f9045e92d283 = ({ type: type, updateSubscriber: updateSubscriber })=>{
    const [states, setStates] = (0, $5uXOq.useState)({});
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            if (!payload) return;
            const nextStates = Object.values(payload).reduce((acc, curr)=>{
                if (curr.id && curr.annotationType === type) {
                    // Check for empty state to prevent additional renders
                    const isEmpty = curr.state === null || curr.state === undefined;
                    return {
                        ...acc,
                        [curr.id]: !isEmpty ? curr.state : states[curr.id]
                    };
                }
                return acc;
            }, {});
            setStates({
                ...states,
                ...nextStates
            });
        };
        updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
        return ()=>{
            updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
        };
    }, [
        states,
        type,
        updateSubscriber
    ]);
    return states;
};
const $477334c02b9da473$export$48f5d7f6702be07c = ({ id: id, updateSubscriber: updateSubscriber })=>{
    const [hasFocus, setHasFocus] = (0, $5uXOq.useState)(false);
    const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
    const isInlineCommentsKbAccessible = (0, $iEN9D.default).checkGate('inline_comments_keyboard_accessible_renderer');
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            setHasFocus(payload && payload.annotationId === id);
        };
        const callbackForHoveredAnnotation = (payload)=>{
            setIsHovered(payload && payload.annotationId === id);
        };
        const removeFocus = ()=>{
            setHasFocus(false);
            if (isInlineCommentsKbAccessible && document.activeElement instanceof HTMLElement) document.activeElement.blur();
        };
        const removeHoverEffect = ()=>{
            setIsHovered(false);
            if (isInlineCommentsKbAccessible && document.activeElement instanceof HTMLElement) document.activeElement.blur();
        };
        updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
        updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
        updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
        updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, removeHoverEffect);
        return ()=>{
            updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
            updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
            updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
            updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, removeHoverEffect);
        };
    }, [
        id,
        updateSubscriber,
        isInlineCommentsKbAccessible
    ]);
    return {
        hasFocus: hasFocus,
        isHovered: isHovered
    };
};
const $477334c02b9da473$export$26cf539704e444c1 = (props)=>{
    const [annotationClickEvent, setAnnotationClickEvent] = (0, $5uXOq.useState)(null);
    const { updateSubscriber: updateSubscriber, createAnalyticsEvent: createAnalyticsEvent, isNestedRender: isNestedRender } = props;
    const isInlineCommentsKbAccessible = (0, $iEN9D.default).checkGate('inline_comments_keyboard_accessible_renderer');
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!updateSubscriber || isNestedRender) return;
        const clickCb = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: eventTargetType, viewMethod: viewMethod })=>{
            const annotationsByType = annotationIds.filter((id)=>!!id).map((id)=>({
                    id: id,
                    type: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
                }));
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).VIEWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: annotationsByType.length || 0,
                    targetNodeType: eventTargetType,
                    method: viewMethod
                }
            }).fire((0, $dWAZk.FabricChannel).editor);
            setAnnotationClickEvent({
                annotations: annotationsByType,
                clickElementTarget: eventTarget
            });
        };
        const deselectCb = ()=>{
            setAnnotationClickEvent({
                annotations: [],
                clickElementTarget: undefined
            });
            if (isInlineCommentsKbAccessible && document.activeElement instanceof HTMLElement) document.activeElement.blur();
        };
        updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
        updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
        return ()=>{
            updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
            updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
        };
    }, [
        updateSubscriber,
        createAnalyticsEvent,
        isInlineCommentsKbAccessible,
        isNestedRender
    ]);
    return annotationClickEvent;
};

});
parcelRegister("dEtqo", function(module, exports) {

$parcel$export(module.exports, "AnnotationUpdateEvent", () => $916fd31c0363f129$export$c1c4b33b4e7b1c70);

var $6Oghe = parcelRequire("6Oghe");
var $916fd31c0363f129$export$c1c4b33b4e7b1c70 = /*#__PURE__*/ function(AnnotationUpdateEvent) {
    AnnotationUpdateEvent["SET_ANNOTATION_FOCUS"] = "SET_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["SET_ANNOTATION_HOVERED"] = "SET_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["SET_ANNOTATION_STATE"] = "SET_ANNOTATION_STATE";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_FOCUS"] = "REMOVE_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_HOVERED"] = "REMOVE_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["ON_ANNOTATION_CLICK"] = "ON_ANNOTATION_CLICK";
    AnnotationUpdateEvent["DESELECT_ANNOTATIONS"] = "DESELECT_ANNOTATIONS";
    return AnnotationUpdateEvent;
}({});
class $916fd31c0363f129$export$7cc60aa9ef845515 {
    emit(event, params) {
        if (typeof params === 'undefined') return this.emitter.emit(event);
        return this.emitter.emit(event, params);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    on(event, listener) {
        return this.emitter.on(event, listener);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    off(event, listener) {
        return this.emitter.removeListener(event, listener);
    }
    listeners(event) {
        return this.emitter.listeners(event);
    }
    constructor(){
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($6Oghe)))();
    }
}

});
parcelRegister("6Oghe", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $4f5409da028b4771$var$R = typeof Reflect === 'object' ? Reflect : null;
var $4f5409da028b4771$var$ReflectApply = $4f5409da028b4771$var$R && typeof $4f5409da028b4771$var$R.apply === 'function' ? $4f5409da028b4771$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $4f5409da028b4771$var$ReflectOwnKeys;
if ($4f5409da028b4771$var$R && typeof $4f5409da028b4771$var$R.ownKeys === 'function') $4f5409da028b4771$var$ReflectOwnKeys = $4f5409da028b4771$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $4f5409da028b4771$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $4f5409da028b4771$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $4f5409da028b4771$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $4f5409da028b4771$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $4f5409da028b4771$var$EventEmitter() {
    $4f5409da028b4771$var$EventEmitter.init.call(this);
}
module.exports = $4f5409da028b4771$var$EventEmitter;
module.exports.once = $4f5409da028b4771$var$once;
// Backwards-compat with node 0.10.x
$4f5409da028b4771$var$EventEmitter.EventEmitter = $4f5409da028b4771$var$EventEmitter;
$4f5409da028b4771$var$EventEmitter.prototype._events = undefined;
$4f5409da028b4771$var$EventEmitter.prototype._eventsCount = 0;
$4f5409da028b4771$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $4f5409da028b4771$var$defaultMaxListeners = 10;
function $4f5409da028b4771$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($4f5409da028b4771$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $4f5409da028b4771$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $4f5409da028b4771$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $4f5409da028b4771$var$defaultMaxListeners = arg;
    }
});
$4f5409da028b4771$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$4f5409da028b4771$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $4f5409da028b4771$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $4f5409da028b4771$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $4f5409da028b4771$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$4f5409da028b4771$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $4f5409da028b4771$var$_getMaxListeners(this);
};
$4f5409da028b4771$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $4f5409da028b4771$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $4f5409da028b4771$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$4f5409da028b4771$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $4f5409da028b4771$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $4f5409da028b4771$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $4f5409da028b4771$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $4f5409da028b4771$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$4f5409da028b4771$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $4f5409da028b4771$var$_addListener(this, type, listener, false);
};
$4f5409da028b4771$var$EventEmitter.prototype.on = $4f5409da028b4771$var$EventEmitter.prototype.addListener;
$4f5409da028b4771$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $4f5409da028b4771$var$_addListener(this, type, listener, true);
};
function $4f5409da028b4771$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $4f5409da028b4771$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $4f5409da028b4771$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$4f5409da028b4771$var$EventEmitter.prototype.once = function once(type, listener) {
    $4f5409da028b4771$var$checkListener(listener);
    this.on(type, $4f5409da028b4771$var$_onceWrap(this, type, listener));
    return this;
};
$4f5409da028b4771$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $4f5409da028b4771$var$checkListener(listener);
    this.prependListener(type, $4f5409da028b4771$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$4f5409da028b4771$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $4f5409da028b4771$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $4f5409da028b4771$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$4f5409da028b4771$var$EventEmitter.prototype.off = $4f5409da028b4771$var$EventEmitter.prototype.removeListener;
$4f5409da028b4771$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $4f5409da028b4771$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $4f5409da028b4771$var$unwrapListeners(evlistener) : $4f5409da028b4771$var$arrayClone(evlistener, evlistener.length);
}
$4f5409da028b4771$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $4f5409da028b4771$var$_listeners(this, type, true);
};
$4f5409da028b4771$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $4f5409da028b4771$var$_listeners(this, type, false);
};
$4f5409da028b4771$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $4f5409da028b4771$var$listenerCount.call(emitter, type);
};
$4f5409da028b4771$var$EventEmitter.prototype.listenerCount = $4f5409da028b4771$var$listenerCount;
function $4f5409da028b4771$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$4f5409da028b4771$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $4f5409da028b4771$var$ReflectOwnKeys(this._events) : [];
};
function $4f5409da028b4771$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $4f5409da028b4771$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $4f5409da028b4771$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $4f5409da028b4771$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $4f5409da028b4771$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $4f5409da028b4771$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});



parcelRegister("fCNtA", function(module, exports) {

$parcel$export(module.exports, "RendererContext", () => $7e61ed70df2336e9$export$1e9ea4edb6d1bfe6);
$parcel$export(module.exports, "RendererActionsContext", () => $7e61ed70df2336e9$export$66feffbad722f9d4);

var $5uXOq = parcelRequire("5uXOq");

var $6pY1y = parcelRequire("6pY1y");
const $7e61ed70df2336e9$export$1e9ea4edb6d1bfe6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(new (0, $6pY1y.default)());
function $7e61ed70df2336e9$export$66feffbad722f9d4({ children: children, context: context }) {
    const actions = (0, $5uXOq.useMemo)(()=>new (0, $6pY1y.default)(true), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e61ed70df2336e9$export$1e9ea4edb6d1bfe6.Provider, {
        value: context || actions
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(children));
}
const $7e61ed70df2336e9$export$d5fcf151601331bc = $7e61ed70df2336e9$export$1e9ea4edb6d1bfe6.Consumer;

});
parcelRegister("6pY1y", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e7850a7dc1aaf7e$export$2e2bcd8739ae039);

var $88i6h = parcelRequire("88i6h");

var $h03xs = parcelRequire("h03xs");

var $hYNZx = parcelRequire("hYNZx");

var $gZGBX = parcelRequire("gZGBX");

var $gkwXh = parcelRequire("gkwXh");

var $eS2Dn = parcelRequire("eS2Dn");

var $VSDnB = parcelRequire("VSDnB");

var $cMPbW = parcelRequire("cMPbW");

var $4apTl = parcelRequire("4apTl");

var $hAPWV = parcelRequire("hAPWV");
class $5e7850a7dc1aaf7e$export$2e2bcd8739ae039 {
    constructor(initFromContext = false){
        // This is our psuedo feature flag for now
        // This module can only be used when wrapped with
        // the <RendererContext> component for now.
        this.initFromContext = false;
        this.initFromContext = initFromContext;
        this.transformer = new (0, $hYNZx.JSONTransformer)();
    }
    //#region private
    _privateRegisterRenderer(ref, doc, schema, onAnalyticsEvent) {
        if (!this.initFromContext) return;
        else if (!this.ref) this.ref = ref;
        else if (this.ref !== ref) throw new Error("Renderer has already been registered! It's not allowed to re-register with another new Renderer instance.");
        this.doc = doc;
        this.schema = schema;
        this.onAnalyticsEvent = onAnalyticsEvent;
    }
    _privateUnregisterRenderer() {
        this.doc = undefined;
        this.ref = undefined;
        this.schema = undefined;
    }
    /**
	 * Validate whether we can create an annotation between two positions
	 */ _privateValidatePositionsForAnnotation(from, to) {
        if (!this.doc || !this.schema) return false;
        if ((0, $VSDnB.fg)('forbid_comments_on_empty_newlines')) {
            const currentSelection = (0, $gZGBX.TextSelection).create(this.doc, from, to);
            if ((0, $h03xs.isEmptyTextSelection)(currentSelection, this.schema)) return false;
        }
        return (0, $h03xs.canApplyAnnotationOnRange)({
            from: from,
            to: to
        }, this.doc, this.schema);
    }
    //#endregion
    deleteAnnotation(annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const mark = this.schema.marks.annotation.create({
            id: annotationId,
            annotationType: annotationType
        });
        let from;
        let to;
        let nodePos;
        let step;
        this.doc.descendants((node, pos)=>{
            const found = mark.isInSet(node.marks);
            if (found && node.type.name === 'media') nodePos = pos;
            if (found && !from) {
                // Set both here incase it only spans one node.
                from = pos;
                to = pos + node.nodeSize;
            } else if (found && from) // If the mark spans multiple nodes,
            // we'll keep setting the end until no longer found.
            to = pos + node.nodeSize;
            return true;
        });
        if (nodePos !== undefined) step = new (0, $eS2Dn.RemoveNodeMarkStep)(nodePos, mark);
        else {
            if (from === undefined || to === undefined) return false;
            step = new (0, $eS2Dn.RemoveMarkStep)(from, to, mark);
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (this.onAnalyticsEvent) {
            const payload = {
                action: (0, $gkwXh.ACTION).DELETED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    inlineNodeNames: step instanceof (0, $eS2Dn.RemoveMarkStep) ? (0, $4apTl.getRendererRangeInlineNodeNames)({
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        pos: {
                            from: from,
                            to: to
                        },
                        actions: this
                    }) : undefined
                }
            };
            this.onAnalyticsEvent(payload);
        }
        if (!failed && doc) return {
            step: step,
            doc: this.transformer.encode(doc)
        };
        return false;
    }
    annotate(range, annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const pos = (0, $cMPbW.getPosFromRange)(range);
        if (!pos) return false;
        const { from: from, to: to } = pos;
        const validPositions = this._privateValidatePositionsForAnnotation(from, to);
        if (!validPositions) return false;
        return this.applyAnnotation(pos, {
            annotationId: annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        });
    }
    isValidAnnotationRange(range) {
        if (!range) return false;
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
            if (this.isRendererWithinRange(range)) return false;
        }
        const pos = (0, $cMPbW.getPosFromRange)(range);
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    isRangeAnnotatable(range) {
        try {
            if (!range) return false;
            const { startContainer: startContainer, endContainer: endContainer } = range;
            if (startContainer.parentElement?.closest('.ak-renderer-extension') || endContainer.parentElement?.closest('.ak-renderer-extension')) return false;
            return this.isValidAnnotationRange(range);
        } catch  {
            // isValidAnnotationRange can fail when called inside nested renderers.
            // while isRendererWithinRange guards against this to some degree -- the classnames
            // are controlled by product -- and we don't have platform guarantees on them.
            //
            // Currently there is a mix of logic across the platform and confluence on determining
            // positions that are annotatable. This is a defensive check to ensure we don't throw an error
            // in cases where the range is not valid.
            return false;
        }
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
	 * This is replaced by `isRangeAnnotatable`.
	 *
	 * @deprecated
	 **/ isRendererWithinRange(range) {
        const { startContainer: startContainer, endContainer: endContainer } = range;
        if (startContainer.parentElement && startContainer.parentElement.closest('.ak-renderer-extension') || endContainer.parentElement && endContainer.parentElement.closest('.ak-renderer-extension')) return true;
        return false;
    }
    isValidAnnotationPosition(pos) {
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    /**
	 * Note: False indicates that the selection not able to be calculated.
	 */ getPositionFromRange(range) {
        if (!this.doc || !this.schema || !range) return false;
        return (0, $cMPbW.getPosFromRange)(range);
    }
    getAnnotationMarks() {
        const { schema: schema, doc: doc } = this;
        if (!schema || !doc) return [];
        const { marks: { annotation: annotationMarkType } } = schema;
        if (!annotationMarkType) return [];
        const marks = [];
        doc.descendants((node)=>{
            const annotationsMark = node.marks.filter((m)=>m.type === annotationMarkType);
            if (!annotationsMark || !annotationsMark.length) return true;
            marks.push(...annotationsMark);
            return false;
        });
        const uniqueMarks = new Map();
        marks.forEach((m)=>{
            uniqueMarks.set(m.attrs.id, m);
        });
        return Array.from(uniqueMarks.values());
    }
    getAnnotationsByPosition(range) {
        if (!this.doc || !this.schema) return [];
        const pos = (0, $cMPbW.getPosFromRange)(range);
        if (!pos || !this.doc) return [];
        return (0, $h03xs.getAnnotationIdsFromRange)(pos, this.doc, this.schema);
    }
    applyAnnotation(pos, annotation) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const { annotationId: annotationId, annotationType: annotationType } = annotation;
        let step;
        let targetNodeType;
        // As part of fix for RAP, `from` points to the position right before media node
        // hence, -1 is not needed
        const beforeNodePos = from;
        const possibleNode = this.doc.nodeAt(beforeNodePos);
        if (possibleNode?.type.name === 'media') {
            targetNodeType = 'media';
            step = new (0, $eS2Dn.AddNodeMarkStep)(beforeNodePos, this.schema.marks.annotation.create({
                id: annotationId,
                type: annotationType
            }));
        } else {
            const resolvedNode = this.doc.resolve(from).node();
            // annotation is technically on text, but the context is caption
            targetNodeType = resolvedNode.type.name === 'caption' ? 'caption' : 'text';
            step = (0, $cMPbW.createAnnotationStep)(from, to, {
                annotationId: annotationId,
                annotationType: annotationType,
                schema: this.schema
            });
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (failed || !doc) return false;
        const originalSelection = doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $hAPWV.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            step: step,
            doc: this.transformer.encode(doc),
            inlineNodeTypes: (0, $4apTl.getRendererRangeInlineNodeNames)({
                actions: this,
                pos: {
                    from: from,
                    to: to
                }
            }),
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos,
            targetNodeType: targetNodeType
        };
    }
    generateAnnotationIndexMatch(pos) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const originalSelection = this.doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $hAPWV.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos
        };
    }
    // TODO: Do not forget to remove `undefined` when the
    //       `editor_inline_comments_on_inline_nodes` is removed.
    getInlineNodeTypes(annotationId) {
        if (!this.doc || !this.schema) return [];
        return (0, $h03xs.getAnnotationInlineNodeTypes)({
            doc: this.doc,
            schema: this.schema
        }, annotationId);
    }
}

});
parcelRegister("h03xs", function(module, exports) {

$parcel$export(module.exports, "canApplyAnnotationOnRange", () => $ccb20202dc8fa865$export$77ddf8216f9eb904);
$parcel$export(module.exports, "getAnnotationIdsFromRange", () => $ccb20202dc8fa865$export$badbcc229c848aec);
$parcel$export(module.exports, "hasAnnotationMark", () => $ccb20202dc8fa865$export$5fe1412b20386053);
$parcel$export(module.exports, "containsAnyAnnotations", () => $ccb20202dc8fa865$export$1976770b876b2728);
$parcel$export(module.exports, "getRangeInlineNodeNames", () => $ccb20202dc8fa865$export$35054451202ed5d9);
$parcel$export(module.exports, "getAnnotationInlineNodeTypes", () => $ccb20202dc8fa865$export$8261bc1f662f3f6e);
$parcel$export(module.exports, "getAnnotationMarksForPos", () => $ccb20202dc8fa865$export$bb1945a828f2864b);
$parcel$export(module.exports, "isEmptyTextSelection", () => $ccb20202dc8fa865$export$2efbc6d84ea0fbec);

var $88i6h = parcelRequire("88i6h");

var $VSDnB = parcelRequire("VSDnB");
const $ccb20202dc8fa865$export$77ddf8216f9eb904 = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    if (isNaN(from + to) || to - from <= 0 || to < 0 || from < 0) return false;
    let foundInvalid = false;
    doc.nodesBetween(rangeSelection.from, rangeSelection.to, (node, _pos, parent)=>{
        // Special exception for hardBreak nodes
        if (schema.nodes.hardBreak === node.type) return false;
        // For block elements or text nodes, we want to check
        // if annotations are allowed inside this tree
        // or if we're leaf and not text
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
            const isAllowedInlineNode = [
                'emoji',
                'status',
                'date',
                'mention',
                'inlineCard'
            ].includes(node.type.name);
            if (node.isInline && !node.isText && !isAllowedInlineNode || node.isLeaf && !node.isText && !isAllowedInlineNode || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
                foundInvalid = true;
                return false;
            }
        } else if (node.isInline && !node.isText || node.isLeaf && !node.isText || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
            foundInvalid = true;
            return false;
        }
        return true;
    });
    return !foundInvalid;
};
const $ccb20202dc8fa865$export$badbcc229c848aec = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    const annotations = new Set();
    doc.nodesBetween(from, to, (node)=>{
        if (!node.marks) return true;
        node.marks.forEach((mark)=>{
            if (mark.type === schema.marks.annotation && mark.attrs) annotations.add(mark.attrs.id);
        });
        return true;
    });
    return Array.from(annotations);
};
function $ccb20202dc8fa865$export$5fe1412b20386053(node, state) {
    const { schema: { marks: { annotation: annotationMark } } } = state;
    return !!(annotationMark && node && node.marks.length && annotationMark.isInSet(node.marks));
}
function $ccb20202dc8fa865$export$1976770b876b2728(slice, state) {
    if (!slice.content.size) return false;
    let hasAnnotation = false;
    slice.content.forEach((node)=>{
        hasAnnotation = hasAnnotation || $ccb20202dc8fa865$export$5fe1412b20386053(node, state);
        // return early if annotation found already
        if (hasAnnotation) return true;
        // check annotations in descendants
        node.descendants((node)=>{
            if ($ccb20202dc8fa865$export$5fe1412b20386053(node, state)) {
                hasAnnotation = true;
                return false;
            }
            return true;
        });
    });
    return hasAnnotation;
}
function $ccb20202dc8fa865$export$35054451202ed5d9({ doc: doc, pos: pos }) {
    if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const nodeNames = new Set();
    try {
        doc.nodesBetween(pos.from, pos.to, (node)=>{
            if (node.isInline) nodeNames.add(node.type.name);
        });
        // We sort the list alphabetically to make human consumption of the list easier (in tools like the analytics extension)
        const sortedNames = [
            ...nodeNames
        ].sort();
        return sortedNames;
    } catch  {
        // Some callers have existing gaps where the positions are not valid,
        // and so when called in the current document can throw an error if out of range.
        //
        // This is a defensive check to ensure we don't throw an error in those cases.
        return undefined;
    }
}
function $ccb20202dc8fa865$export$8261bc1f662f3f6e(state, annotationId) {
    if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const mark = state.schema.marks.annotation.create({
        id: annotationId,
        annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
    });
    const inlineNodeNames = new Set();
    state.doc.descendants((node, pos)=>{
        if (mark.isInSet(node.marks)) inlineNodeNames.add(node.type.name);
        return true;
    });
    // This sorting is done to make human consumption easier (ie. in dev tools, test snapshots, analytics events, ...)
    return [
        ...inlineNodeNames
    ].sort();
}
function $ccb20202dc8fa865$export$bb1945a828f2864b(pos) {
    if (!(0, $VSDnB.fg)('editor_inline_comments_paste_insert_nodes')) return undefined;
    const annotationMarks = pos.marks().filter((mark)=>mark.type === pos.doc.type.schema.marks.annotation);
    return annotationMarks;
}
function $ccb20202dc8fa865$export$2efbc6d84ea0fbec(selection, schema) {
    const { text: text, paragraph: paragraph } = schema.nodes;
    let hasContent = false;
    selection.content().content.descendants((node)=>{
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for not a text or nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type !== text || !node.textContent) hasContent = true;
        return !hasContent;
    });
    return !hasContent;
}

});

parcelRegister("hYNZx", function(module, exports) {

$parcel$export(module.exports, "SchemaStage", () => $c960adc5c7547145$export$933e6445c497ffd5);
$parcel$export(module.exports, "JSONTransformer", () => $c960adc5c7547145$export$98cb1d9308d0944d);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $ajpes = parcelRequire("ajpes");

var $8vlrc = parcelRequire("8vlrc");
var $cUwVZ = parcelRequire("cUwVZ");
var $7kC9H = parcelRequire("7kC9H");
var $29Vii = parcelRequire("29Vii");
var $8XeG6 = parcelRequire("8XeG6");
var $bIGZ7 = parcelRequire("bIGZ7");
var $7agO8 = parcelRequire("7agO8");
var $g7Cky = parcelRequire("g7Cky");
var $9UDEr = parcelRequire("9UDEr");

var $kOFhM = parcelRequire("kOFhM");

var $fVI2q = parcelRequire("fVI2q");

var $0Cgjx = parcelRequire("0Cgjx");
var $c960adc5c7547145$export$933e6445c497ffd5 = /*#__PURE__*/ function(SchemaStage) {
    SchemaStage["FINAL"] = "final";
    SchemaStage["STAGE_0"] = "stage0";
    return SchemaStage;
}({});
const $c960adc5c7547145$var$isType = (type)=>(node)=>node.type.name === type;
const $c960adc5c7547145$var$isCodeBlock = $c960adc5c7547145$var$isType('codeBlock');
const $c960adc5c7547145$var$isMediaNode = $c960adc5c7547145$var$isType('media');
const $c960adc5c7547145$var$isMediaInline = $c960adc5c7547145$var$isType('mediaInline');
const $c960adc5c7547145$var$isMediaSingleNode = $c960adc5c7547145$var$isType('mediaSingle');
const $c960adc5c7547145$var$isMentionNode = $c960adc5c7547145$var$isType('mention');
const $c960adc5c7547145$var$isParagraph = $c960adc5c7547145$var$isType('paragraph');
const $c960adc5c7547145$var$isHeading = $c960adc5c7547145$var$isType('heading');
const $c960adc5c7547145$var$isTable = $c960adc5c7547145$var$isType('table');
const $c960adc5c7547145$var$isTableCell = $c960adc5c7547145$var$isType('tableCell');
const $c960adc5c7547145$var$isTableHeader = $c960adc5c7547145$var$isType('tableHeader');
const $c960adc5c7547145$var$isLinkMark = $c960adc5c7547145$var$isType('link');
const $c960adc5c7547145$var$isUnsupportedMark = $c960adc5c7547145$var$isType('unsupportedMark');
const $c960adc5c7547145$var$isUnsupportedNodeAttributeMark = $c960adc5c7547145$var$isType('unsupportedNodeAttribute');
const $c960adc5c7547145$var$isExpand = $c960adc5c7547145$var$isType('expand');
const $c960adc5c7547145$var$isNestedExpand = $c960adc5c7547145$var$isType('nestedExpand');
const $c960adc5c7547145$var$isUnsupportedNode = (node)=>$c960adc5c7547145$var$isType('unsupportedBlock')(node) || $c960adc5c7547145$var$isType('unsupportedInline')(node);
const $c960adc5c7547145$var$isDataConsumer = $c960adc5c7547145$var$isType('dataConsumer');
const $c960adc5c7547145$var$isFragmentMark = $c960adc5c7547145$var$isType('fragment');
const $c960adc5c7547145$var$isHardBreak = $c960adc5c7547145$var$isType('hardBreak');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c960adc5c7547145$var$filterNull = (subject)=>{
    let output = {
        ...subject
    };
    // eslint-disable-next-line guard-for-in
    for(const key in output){
        const current = output[key];
        if (current === null) {
            const { [key]: unusedKey, ...filteredObj } = output;
            output = filteredObj;
        } else if (typeof current === 'object' && !Array.isArray(current)) output[key] = $c960adc5c7547145$var$filterNull(current);
    }
    return output;
};
const $c960adc5c7547145$var$createDocFromContent = (content)=>{
    return {
        version: 1,
        type: 'doc',
        content: content || []
    };
};
const $c960adc5c7547145$var$emptyDoc = $c960adc5c7547145$var$createDocFromContent([
    {
        type: 'paragraph',
        content: []
    }
]);
const $c960adc5c7547145$var$toJSON = (node, mentionMap)=>{
    const obj = {
        type: node.type.name
    };
    if ($c960adc5c7547145$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($c960adc5c7547145$var$isMediaNode(node)) obj.attrs = (0, $7agO8.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isMediaSingleNode(node)) obj.attrs = (0, $bIGZ7.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isMediaInline(node)) obj.attrs = (0, $7agO8.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isMentionNode(node)) obj.attrs = (0, $g7Cky.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isCodeBlock(node)) obj.attrs = (0, $8vlrc.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isTable(node)) obj.attrs = (0, $9UDEr.tableToJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isTableCell(node)) obj.attrs = (0, $9UDEr.toJSONTableCell)(node).attrs;
    else if ($c960adc5c7547145$var$isTableHeader(node)) obj.attrs = (0, $9UDEr.toJSONTableHeader)(node).attrs;
    else if ($c960adc5c7547145$var$isExpand(node) || $c960adc5c7547145$var$isNestedExpand(node)) obj.attrs = (0, $7kC9H.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $c960adc5c7547145$var$filterNull(obj.attrs);
    if ($c960adc5c7547145$var$isMentionNode(node) && mentionMap) {
        // If the mentionMap exists and has a name defined then we should use it and prepend @ to the begining of it.
        const name = !!mentionMap?.[node.attrs.id] ? `@${mentionMap[node.attrs.id]}` : '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const text = obj.attrs?.text ?? '';
        obj.attrs = {
            ...obj.attrs,
            // If an explicit text value is set on the mention then that should take priority over the mentionMap value.
            text: !!text ? text : name
        };
    }
    // Remove the attrs property if it's empty, this is currently limited to paragraph nodes.
    if ($c960adc5c7547145$var$isParagraph(node) && obj.attrs && !Object.keys(obj.attrs).length) delete obj.attrs;
    // Hard break has optional attr.text which was added for PM <-> ADF compatibility.
    // No need to preserve it.
    if ($c960adc5c7547145$var$isHardBreak(node)) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach((child)=>{
        obj.content = obj.content || [];
        obj.content.push($c960adc5c7547145$var$toJSON(child, mentionMap));
    });
    if ($c960adc5c7547145$var$isParagraph(node) || $c960adc5c7547145$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        const parsedMarks = node.marks.map((mark)=>{
            if ($c960adc5c7547145$var$isUnsupportedMark(mark)) return $c960adc5c7547145$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($c960adc5c7547145$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($c960adc5c7547145$var$isLinkMark(mark)) return (0, $8XeG6.toJSON)(mark);
            else if ($c960adc5c7547145$var$isDataConsumer(mark)) {
                const serialised = (0, $cUwVZ.toJSON)(mark);
                return !serialised.attrs.sources || serialised.attrs.sources?.length === 0 ? null : serialised;
            } else if ($c960adc5c7547145$var$isFragmentMark(mark)) {
                const fragmentMark = (0, $29Vii.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter((maybeMark)=>maybeMark !== null);
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = parsedMarks?.length > 0 ? parsedMarks : undefined;
        const nodeAttributeMark = node.marks.find($c960adc5c7547145$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = {
            ...$c960adc5c7547145$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj)
        };
    }
    return obj;
};
const $c960adc5c7547145$var$canOverrideMark = (mark, existingMarks)=>{
    if (existingMarks.some((e)=>mark.attrs.originalValue.type === e.type.name)) return (0, $fVI2q.markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
const $c960adc5c7547145$var$getUnwrappedNodeAttributes = (node, mark, obj)=>{
    const nodeAttributes = node.type.spec.attrs;
    const attributes = {
        ...mark.attrs.unsupported,
        ...obj.attrs
    };
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        const attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return {
                ...attributes,
                [key]: mark.attrs.unsupported[key]
            };
        }
    }
    return attributes;
};
class $c960adc5c7547145$export$98cb1d9308d0944d {
    /**
	 * @param schema The current editor schema
	 * @param mentionMap An optional mapping of user IDs to mention names. This is used by the encoder to substitute empty
	 * mention node.attr.text values with mapped names.
	 */ constructor(schema = (0, $kOFhM.defaultSchema), mentionMap){
        this.schema = schema;
        this.mentionMap = mentionMap;
    }
    encode(node) {
        const content = [];
        node.content.forEach((child)=>{
            content.push((0, $0Cgjx.sanitizeNode)($c960adc5c7547145$var$toJSON(child, this.mentionMap)));
        });
        if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(content, $c960adc5c7547145$var$emptyDoc.content)) return $c960adc5c7547145$var$createDocFromContent([]);
        return $c960adc5c7547145$var$createDocFromContent(content);
    }
    internalParse(content, schema) {
        const doc = schema.nodeFromJSON(content);
        doc.check();
        return doc;
    }
    parse(content, stage) {
        if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
        const schema = !!stage ? (0, $kOFhM.getSchemaBasedOnStage)(stage) : this.schema;
        if (!content.content || content.content.length === 0) return this.internalParse($c960adc5c7547145$var$emptyDoc, schema);
        return this.internalParse(content, schema);
    }
    /**
	 * This method is used to encode a single node
	 */ encodeNode(node) {
        return (0, $0Cgjx.sanitizeNode)($c960adc5c7547145$var$toJSON(node, this.mentionMap));
    }
}

});
parcelRegister("fVI2q", function(module, exports) {

$parcel$export(module.exports, "markOverrideRuleFor", () => $7f7cf8cf5d94f891$export$28e4e3c024cce988);
const $7f7cf8cf5d94f891$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return true;
    }
};
const $7f7cf8cf5d94f891$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return false;
    }
};
const $7f7cf8cf5d94f891$export$28e4e3c024cce988 = (type)=>{
    switch(type){
        case 'link':
        case 'em':
        case 'strong':
        case 'strike':
        case 'subsup':
        case 'underline':
        case 'code':
        case 'textColor':
        case 'backgroundColor':
        case 'confluenceInlineComment':
        case 'breakout':
        case 'alignment':
        case 'indentation':
        case 'border':
            return $7f7cf8cf5d94f891$var$defaultAllowOverrideBehaviour;
        default:
            return $7f7cf8cf5d94f891$var$defaultDoNotAllowOverrideBehaviour;
    }
};

});

parcelRegister("0Cgjx", function(module, exports) {

$parcel$export(module.exports, "sanitizeNode", () => $45db1c8142107da9$export$48b382180baf8e88);

var $aSk3Q = parcelRequire("aSk3Q");

var $l1C1k = parcelRequire("l1C1k");

var $VSDnB = parcelRequire("VSDnB");

var $hRZSy = parcelRequire("hRZSy");
const $45db1c8142107da9$var$hasNestedTable = (tableCellNode)=>tableCellNode.content?.some((node)=>node?.type === 'table');
function $45db1c8142107da9$export$48b382180baf8e88(json) {
    const sanitizedJSON = (0, $l1C1k.traverse)(json, {
        text: (node)=>{
            if (!node || !Array.isArray(node.marks)) return node;
            return {
                ...node,
                marks: node.marks.filter((mark)=>mark.type !== 'typeAheadQuery')
            };
        },
        status: (node)=>{
            if (node.attrs && !!node.attrs.text) return (0, $hRZSy.removeNonAnnotationMarks)(node);
            return false; // empty status
        },
        caption: (node)=>{
            if (node.content) return node;
            return false; // empty caption
        },
        tableCell: (node)=>{
            if ($45db1c8142107da9$var$hasNestedTable(node) && (0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) return (0, $aSk3Q.transformNestedTableNodeOutgoingDocument)(node);
        },
        tableHeader: (node)=>{
            if ($45db1c8142107da9$var$hasNestedTable(node) && (0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) return (0, $aSk3Q.transformNestedTableNodeOutgoingDocument)(node);
        },
        emoji: (0, $hRZSy.removeNonAnnotationMarks),
        mention: (0, $hRZSy.removeNonAnnotationMarks),
        date: (0, $hRZSy.removeNonAnnotationMarks),
        hardBreak: (0, $hRZSy.removeMarks),
        inlineCard: (0, $hRZSy.removeNonAnnotationMarks)
    });
    return sanitizedJSON;
}

});
parcelRegister("aSk3Q", function(module, exports) {

$parcel$export(module.exports, "transformNestedTablesIncomingDocument", () => $2dd8f1bba9a54435$export$18544d0b5f43e4a1);
$parcel$export(module.exports, "transformNestedTableNodeOutgoingDocument", () => $2dd8f1bba9a54435$export$8a334a7d9fe120ec);

var $l1C1k = parcelRequire("l1C1k");

var $gxbjN = parcelRequire("gxbjN");

var $8YCkv = parcelRequire("8YCkv");
const $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_TYPE = 'com.atlassian.confluence.migration', $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_KEY = 'nested-table';
const $2dd8f1bba9a54435$export$f45e7335ec874bfe = (extensionNode)=>extensionNode.attrs?.extensionType === $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_TYPE && extensionNode.attrs?.extensionKey === $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_KEY;
const $2dd8f1bba9a54435$var$transformNestedTableExtension = (nestedTableExtension)=>{
    // No content - drop the extension node
    if (!nestedTableExtension.attrs?.parameters?.adf) return false;
    try {
        const adf = JSON.parse(nestedTableExtension.attrs?.parameters?.adf);
        if (!adf.content || adf.content.length === 0) return false;
        return adf.content[0];
    } catch (e) {
        throw new (0, $8YCkv.NodeNestingTransformError)('Failed to parse nested table content');
    }
};
function $2dd8f1bba9a54435$var$isInsideBodiedExtension(parent) {
    if (parent.node === undefined) return false;
    if (parent.node.type === 'bodiedExtension') return true;
    if (parent?.parent?.node) return $2dd8f1bba9a54435$var$isInsideBodiedExtension(parent.parent);
    return false;
}
const $2dd8f1bba9a54435$export$18544d0b5f43e4a1 = (adf, options = {})=>{
    let isTransformed = false;
    const transformedAdf = (0, $l1C1k.traverse)(adf, {
        extension: (node, parent)=>{
            if ($2dd8f1bba9a54435$export$f45e7335ec874bfe(node)) {
                // Bodied extensions in renderer use their own nested renderer to render the content.
                // This results in the document being validated/transformed twice, once with untransformed content and again with transformed content.
                // Since the untransformed content is valid ADF (table as extension in table) but the transformed content is not valid ADF, (table in table)
                // we need to skip transforming nested tables inside bodied extensions in renderer on the first pass or else it will fail validation and render an unsupported block.
                if (options.environment === 'renderer' && $2dd8f1bba9a54435$var$isInsideBodiedExtension(parent)) return undefined;
                isTransformed = true;
                return $2dd8f1bba9a54435$var$transformNestedTableExtension(node);
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};
const $2dd8f1bba9a54435$export$8a334a7d9fe120ec = (tableCellNode)=>{
    try {
        return {
            ...tableCellNode,
            content: tableCellNode.content?.map((childNode)=>{
                // wrap nested table in an extension node
                if (childNode?.type === 'table') return (0, $gxbjN.extension)({
                    extensionType: $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_TYPE,
                    extensionKey: $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_KEY,
                    parameters: {
                        adf: JSON.stringify({
                            type: 'doc',
                            version: 1,
                            content: [
                                childNode
                            ]
                        })
                    }
                });
                return childNode;
            })
        };
    } catch (e) {
        throw new (0, $8YCkv.NodeNestingTransformError)('Failed to encode nested table node');
    }
};

});
parcelRegister("l1C1k", function(module, exports) {

$parcel$export(module.exports, "traverse", () => $b903aab814d8ed47$export$df3f009e3d155b20);
function $b903aab814d8ed47$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $b903aab814d8ed47$export$df3f009e3d155b20(adf, visitors) {
    if (!$b903aab814d8ed47$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $b903aab814d8ed47$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $b903aab814d8ed47$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $b903aab814d8ed47$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});

parcelRegister("gxbjN", function(module, exports) {

$parcel$export(module.exports, "extension", () => $ec4576859225619a$export$1b45514b112dd749);
const $ec4576859225619a$export$1b45514b112dd749 = (attrs)=>({
        type: 'extension',
        attrs: attrs
    });

});

parcelRegister("8YCkv", function(module, exports) {

$parcel$export(module.exports, "NodeNestingTransformError", () => $b0271efedae2a0b7$export$3d8e8d2182f13924);
/** NodeNestingTransformError  */ class $b0271efedae2a0b7$export$3d8e8d2182f13924 extends Error {
    /**
	 * @param message - Error message - Do not use any UGC in this message
	 */ constructor(message){
        super(message);
        this.name = 'NodeNestingTransformError';
    }
}

});


parcelRegister("hRZSy", function(module, exports) {

$parcel$export(module.exports, "removeMarks", () => $7e7bed7752b3d3e8$export$9bf001d8ef76e497);
$parcel$export(module.exports, "removeNonAnnotationMarks", () => $7e7bed7752b3d3e8$export$8cae9126fc577085);
function $7e7bed7752b3d3e8$export$9bf001d8ef76e497(node) {
    const newNode = {
        ...node
    };
    delete newNode.marks;
    return newNode;
}
function $7e7bed7752b3d3e8$export$8cae9126fc577085(node) {
    const newNode = {
        ...node
    };
    if (node.marks) newNode.marks = node.marks.filter((mark)=>mark.type === 'annotation');
    return newNode;
}

});



parcelRegister("cMPbW", function(module, exports) {

$parcel$export(module.exports, "isRoot", () => $c9441534493a403f$export$e3140dc7d0c35e48);
$parcel$export(module.exports, "getPosFromRange", () => $c9441534493a403f$export$243cdddc5b21d8c1);
$parcel$export(module.exports, "createAnnotationStep", () => $c9441534493a403f$export$74899f7e5acb5cd3);

var $VSDnB = parcelRequire("VSDnB");

var $eS2Dn = parcelRequire("eS2Dn");
function $c9441534493a403f$var$getStartPos(element) {
    return parseInt(element.dataset.rendererStartPos || '-1', 10);
}
const $c9441534493a403f$var$getNodeType = (element)=>element.dataset.nodeType;
function $c9441534493a403f$var$isPositionPointer(element) {
    return $c9441534493a403f$var$getStartPos(element) > -1;
}
function $c9441534493a403f$var$findParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $c9441534493a403f$export$e3140dc7d0c35e48(parentElement)) return null;
    if ($c9441534493a403f$var$isPositionPointer(parentElement)) return parentElement;
    return $c9441534493a403f$var$findParent(parentElement);
}
function $c9441534493a403f$var$findMediaParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $c9441534493a403f$export$e3140dc7d0c35e48(parentElement)) return null;
    if (parentElement.dataset.nodeType === 'mediaSingle') return parentElement;
    return $c9441534493a403f$var$findMediaParent(parentElement);
}
function $c9441534493a403f$var$findParentBeforePointer(element) {
    const { parentElement: parentElement } = element;
    if ($c9441534493a403f$export$e3140dc7d0c35e48(parentElement) || !parentElement) return null;
    if ($c9441534493a403f$var$isPositionPointer(parentElement)) return element;
    return $c9441534493a403f$var$findParentBeforePointer(parentElement);
}
function $c9441534493a403f$var$isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function $c9441534493a403f$var$isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function $c9441534493a403f$var$isHighlightTextNode(node) {
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return !!node?.dataset?.highlighted;
}
function $c9441534493a403f$var$isNodeInlineMark(node) {
    return $c9441534493a403f$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
}
function $c9441534493a403f$var$isElementInlineMark(element) {
    return !!element && Boolean(element.dataset.rendererMark);
}
function $c9441534493a403f$var$isNodeInlineTextMark(node) {
    if (node === null) return false;
    const isInlineMark = $c9441534493a403f$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
    if (!isInlineMark) return false;
    /**
	 * This checks if the element has any descendents with the data-inline-card
	 * attribute set to 'true'. If it does, we should not consider it as an
	 * inline text mark.
	 **/ if ($c9441534493a403f$var$hasInlineNodeDescendant(node)) return false;
    return true;
}
/**
 * This checks all the descendents of a node and returns true if it reaches
 * a descendant with the data-inline-card attribute set to 'true'.
 */ function $c9441534493a403f$var$hasInlineNodeDescendant(node) {
    if ($c9441534493a403f$var$isElementNode(node)) {
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
            if (node.dataset.annotationInlineNode === 'true') return true;
        } else {
            if (node.dataset.inlineCard === 'true') return true;
        }
        return Array.from(node.childNodes).some($c9441534493a403f$var$hasInlineNodeDescendant);
    }
    return false;
}
function $c9441534493a403f$var$resolveNodePos(node) {
    let resolvedPos = 0;
    let prev = node.previousSibling;
    while(prev){
        if (prev && ($c9441534493a403f$var$isTextNode(prev) || $c9441534493a403f$var$isHighlightTextNode(prev))) resolvedPos += (prev.textContent || '').length;
        else if (prev) {
            if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
                if ($c9441534493a403f$var$isNodeInlineTextMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
                else resolvedPos += 1;
            } else if ($c9441534493a403f$var$isNodeInlineMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
            else resolvedPos += 1;
        }
        prev = prev.previousSibling;
    }
    return resolvedPos;
}
function $c9441534493a403f$export$e3140dc7d0c35e48(element) {
    return !!element && element.classList.contains('ak-renderer-document');
}
function $c9441534493a403f$export$5db587db55468da7(node, offset, findEnd = false) {
    // If the passed node doesn't exist, we should abort
    if (!node) return false;
    if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
        const startPosAncestor = node.parentElement?.closest('[data-renderer-start-pos');
        const potentialParent = (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? 'data-annotation-mark' : 'data-inline-card';
        if (startPosAncestor?.hasAttribute(potentialParent)) {
            if (findEnd) return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10) + 1;
            else return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10);
        }
    }
    /**
	 * If anchor node is an element (e.g. after a triple click) the anchorOffset
	 * is the number of child nodes preceding the anchor.
	 * https://developer.mozilla.org/en-US/docs/Web/API/Selection/anchorOffset
	 *
	 * For end pos we calculate the number of characters by stepping through
	 * each of the node's children.
	 */ if (node instanceof HTMLElement && $c9441534493a403f$var$isPositionPointer(node)) {
        if (findEnd) {
            let count = $c9441534493a403f$var$getStartPos(node);
            const children = node.childNodes;
            for(let i = 0; i < offset; i++)count += children[i]?.textContent?.length || 1;
            return count;
        }
        return $c9441534493a403f$var$getStartPos(node) + offset;
    }
    const parent = $c9441534493a403f$var$findParent(node);
    // Similar to above, if we cant find a parent position pointer
    // we should not proceed.
    if (!parent) return false;
    let resolvedPos = $c9441534493a403f$var$getStartPos(parent);
    let current = node;
    if (current.parentElement && current.parentElement !== parent) {
        // Find the parent element that is a direct child of the position pointer
        // the outer most element from our text position.
        const preParentPointer = $c9441534493a403f$var$findParentBeforePointer(current.parentElement);
        // If our range is inside an inline node
        // We need to move our pointers to parent element
        // since we don't want to count text inside inline nodes at all
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!($c9441534493a403f$var$isNodeInlineTextMark(preParentPointer) || $c9441534493a403f$var$isHighlightTextNode(preParentPointer))) {
                current = current.parentElement;
                offset = 0;
            }
        } else if (!($c9441534493a403f$var$isElementInlineMark(preParentPointer) || $c9441534493a403f$var$isHighlightTextNode(preParentPointer))) {
            current = current.parentElement;
            offset = 0;
        }
        resolvedPos += $c9441534493a403f$var$resolveNodePos(current);
        while(current && current.parentElement !== parent){
            current = current.parentNode;
            if (current) {
                const nodePos = $c9441534493a403f$var$resolveNodePos(current);
                resolvedPos += nodePos;
            }
        }
    } else resolvedPos += $c9441534493a403f$var$resolveNodePos(current);
    return resolvedPos + offset;
}
function $c9441534493a403f$export$243cdddc5b21d8c1(range) {
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
    const possibleMediaOrMediaSingleElement = $c9441534493a403f$var$findParent(startContainer);
    // Video hover targets return media single, not media, thus, the extra check in condition.
    const isMediaOrMediaSingle = possibleMediaOrMediaSingleElement && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /media|mediaSingle/.test($c9441534493a403f$var$getNodeType(possibleMediaOrMediaSingleElement) || '');
    if (isMediaOrMediaSingle) {
        let pos;
        const mediaSingleElement = $c9441534493a403f$var$getNodeType(possibleMediaOrMediaSingleElement) === 'mediaSingle' ? possibleMediaOrMediaSingleElement : $c9441534493a403f$var$findMediaParent(possibleMediaOrMediaSingleElement);
        if (mediaSingleElement) pos = $c9441534493a403f$var$getStartPos(mediaSingleElement);
        if (pos !== undefined) return {
            from: pos,
            to: pos
        };
    }
    const from = $c9441534493a403f$export$5db587db55468da7(startContainer, startOffset);
    const findEnd = true;
    const to = $c9441534493a403f$export$5db587db55468da7(endContainer, endOffset, findEnd);
    if (from === false || to === false) return false;
    return {
        from: from,
        to: to
    };
}
function $c9441534493a403f$export$74899f7e5acb5cd3(from, to, opts) {
    return new (0, $eS2Dn.AddMarkStep)(Math.min(from, to), Math.max(from, to), opts.schema.marks.annotation.create({
        id: opts.annotationId,
        annotationType: opts.annotationType
    }));
}

});

parcelRegister("4apTl", function(module, exports) {

$parcel$export(module.exports, "getRendererRangeInlineNodeNames", () => $3b0115c3167e4664$export$b0ea72d31617ccea);

var $h03xs = parcelRequire("h03xs");

var $VSDnB = parcelRequire("VSDnB");
function $3b0115c3167e4664$export$b0ea72d31617ccea({ actions: actions, pos: pos }) {
    if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const { doc: doc } = actions;
    if (!pos || !doc) return undefined;
    const inlineNodeNames = (0, $h03xs.getRangeInlineNodeNames)({
        doc: doc,
        pos: pos
    });
    return inlineNodeNames;
}

});

parcelRegister("hAPWV", function(module, exports) {

$parcel$export(module.exports, "getIndexMatch", () => $8b6d6fb20e026dde$export$fb7dab895a0d310e);
function $8b6d6fb20e026dde$export$fb7dab895a0d310e(doc, schema, selectedText, startIndex) {
    let textContent = '';
    let matchIndex = 0;
    let numMatches = 0;
    let blockNodePos;
    doc.descendants((node, pos)=>{
        const nodeType = node.type;
        const { media: media } = schema.nodes;
        // Mirrors Confluence backend and doesn't construct textContent if it doesn't allow annotations
        // Don't skip media node so that block node can be defined its startIndex in within [nodeStart, nodeEnd]
        if ((node.isText || !nodeType.allowsMarkType(schema.marks.annotation)) && nodeType !== media) // Note: `return true` as a parent disallowing annotations does not mean a child disallows annotations.
        // Eg: panel (invalid) > p (valid)
        return true;
        const nodeStart = pos;
        const nodeEnd = nodeStart + node.nodeSize;
        if (startIndex >= nodeStart && startIndex <= nodeEnd) {
            // if it's a node block, set position to pos to indicate to the backend
            // that it's an annotation on a block node
            if (nodeType === media) blockNodePos = pos;
            // If the start of the annotation selection is within the current node, we scan the document for previous occurrences
            // Find the index by counting all previous instances of the selectedText in the partial textContent
            // Need to scan from start, up to `startIndex` (which includes partial of the current node)
            textContent += doc.textBetween(nodeStart, startIndex - 1);
            matchIndex = $8b6d6fb20e026dde$export$3c2359e76fc742da(textContent, selectedText);
            // Complete appending of the node
            textContent += doc.textBetween(startIndex, nodeEnd);
        } else textContent += node.textContent;
        return true;
    });
    // Count total number of matches in final text
    numMatches = $8b6d6fb20e026dde$export$3c2359e76fc742da(textContent, selectedText);
    return {
        numMatches: numMatches,
        matchIndex: matchIndex,
        textContent: textContent,
        blockNodePos: blockNodePos
    };
}
function $8b6d6fb20e026dde$export$3c2359e76fc742da(searchString, query) {
    if (searchString === '' || query === '') return 0;
    // Escape characters that would trigger as syntax in a regex query before converting to the query
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const reg = new RegExp(query.replace(/(?=[.\\+*?[^\]$(){}\|])/g, '\\'), 'g');
    return (searchString.match(reg) || []).length;
}

});




parcelRegister("8Mz83", function(module, exports) {

$parcel$export(module.exports, "AnnotationsContextWrapper", () => $68c25c02b6872087$export$787af8a111ff3c03);

var $5uXOq = parcelRequire("5uXOq");

var $iYAgE = parcelRequire("iYAgE");

var $6MIvG = parcelRequire("6MIvG");

var $iatcV = parcelRequire("iatcV");

var $2EsbE = parcelRequire("2EsbE");
const $68c25c02b6872087$export$787af8a111ff3c03 = (props)=>{
    const providers = (0, $5uXOq.useContext)((0, $iYAgE.ProvidersContext));
    const { range: range, type: type } = (0, $2EsbE.useAnnotationRangeState)();
    const { setDraftRange: setDraftRange, clearDraftRange: clearDraftRange } = (0, $2EsbE.useAnnotationRangeDispatch)();
    const { rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent, children: children } = props;
    const inlineCommentProvider = providers && providers.inlineComment;
    const selectionComponent = inlineCommentProvider && inlineCommentProvider.selectionComponent;
    const hoverComponent = inlineCommentProvider && inlineCommentProvider.hoverComponent;
    // We want to set the draft to the range the user highlighted
    const setRangeForDraft = (0, $5uXOq.useCallback)(()=>{
        setDraftRange(range, type);
    }, [
        range,
        setDraftRange,
        type
    ]);
    const clearRangeForDraft = (0, $5uXOq.useCallback)(()=>{
        clearDraftRange(type);
    }, [
        type,
        clearDraftRange
    ]);
    const render = (0, $5uXOq.useCallback)(({ applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children, !!hoverComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6MIvG.RangeValidator), {
            createAnalyticsEvent: createAnalyticsEvent,
            rendererRef: rendererRef,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            component: hoverComponent,
            applyAnnotationDraftAt: applyAnnotationDraftAt,
            clearAnnotationDraft: clearAnnotationDraft
        }), !!selectionComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iatcV.SelectionRangeValidator), {
            createAnalyticsEvent: createAnalyticsEvent,
            rendererRef: rendererRef,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            selectionComponent: selectionComponent,
            applyAnnotationDraftAt: applyAnnotationDraftAt,
            clearAnnotationDraft: clearAnnotationDraft
        }));
    }, [
        hoverComponent,
        selectionComponent,
        children,
        rendererRef,
        createAnalyticsEvent
    ]);
    if (!selectionComponent && !hoverComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iYAgE.AnnotationsDraftContextWrapper), {
        setDraftRange: setRangeForDraft,
        clearDraftRange: clearRangeForDraft
    }, render);
};

});
parcelRegister("6MIvG", function(module, exports) {

$parcel$export(module.exports, "RangeValidator", () => $38d3fe2fadcf735b$export$6d8376a902cb8aa7);

var $5uXOq = parcelRequire("5uXOq");

var $7g31n = parcelRequire("7g31n");

var $fCNtA = parcelRequire("fCNtA");

var $2EsbE = parcelRequire("2EsbE");

var $kuusl = parcelRequire("kuusl");
const $38d3fe2fadcf735b$export$6d8376a902cb8aa7 = (props)=>{
    const { component: component, rendererRef: rendererRef, applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const { clearHoverRange: clearHoverRange } = (0, $2EsbE.useAnnotationRangeDispatch)();
    const { range: range, type: type } = (0, $2EsbE.useAnnotationRangeState)();
    const { isWithinRange: isWithinRange } = (0, $kuusl.useAnnotationHoverContext)();
    if (!range || type !== 'hover') return null;
    const documentPosition = actions.getPositionFromRange(range);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7g31n.Mounter), {
        isWithinRange: isWithinRange,
        range: range,
        wrapperDOM: rendererRef,
        component: component,
        onClose: clearHoverRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: true,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        applyAnnotationDraftAt: applyAnnotationDraftAt,
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        clearAnnotationDraft: clearAnnotationDraft,
        createAnalyticsEvent: createAnalyticsEvent
    });
};

});
parcelRegister("7g31n", function(module, exports) {

$parcel$export(module.exports, "Mounter", () => $3da53cae08f8e9e6$export$2109cd350bcf6eda);

var $5uXOq = parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $fVTp8 = parcelRequire("fVTp8");

var $dWAZk = parcelRequire("dWAZk");

var $gkwXh = parcelRequire("gkwXh");

var $fCNtA = parcelRequire("fCNtA");
const $3da53cae08f8e9e6$export$2109cd350bcf6eda = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const { component: Component, range: range, isWithinRange: isWithinRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, clearAnnotationDraft: clearAnnotationDraft, applyAnnotationDraftAt: applyAnnotationDraftAt, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const [draftDocumentPosition, setDraftDocumentPosition] = (0, $5uXOq.useState)();
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const onCreateCallback = (0, $5uXOq.useCallback)((annotationId)=>{
        if (!isAnnotationAllowed || !documentPosition || !applyAnnotation) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $gkwXh.ACTION).INSERTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {},
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK
        }).fire((0, $dWAZk.FabricChannel).editor);
        return applyAnnotation(draftDocumentPosition || documentPosition, annotation);
    }, [
        isAnnotationAllowed,
        documentPosition,
        applyAnnotation,
        draftDocumentPosition,
        createAnalyticsEvent
    ]);
    const createIndexCallback = (0, $5uXOq.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $5uXOq.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {},
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            }).fire((0, $dWAZk.FabricChannel).editor);
            return false;
        }
        setDraftDocumentPosition(documentPosition);
        applyAnnotationDraftAt(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = actions.getAnnotationsByPosition(range);
            createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).OPENED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length
                }
            }).fire((0, $dWAZk.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $fVTp8.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        const positionToAnnotate = draftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) return false;
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        applyAnnotationDraftAt,
        createAnalyticsEvent,
        applyAnnotation,
        draftDocumentPosition,
        actions,
        range
    ]);
    const removeDraftModeCallback = (0, $5uXOq.useCallback)(()=>{
        clearAnnotationDraft();
        setDraftDocumentPosition(null);
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearAnnotationDraft
    ]);
    const onCloseCallback = (0, $5uXOq.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $gkwXh.ACTION).CLOSED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            attributes: {}
        }).fire((0, $dWAZk.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
        range: range,
        isWithinRange: isWithinRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: onCloseCallback,
        onCreate: onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: applyDraftModeCallback,
        removeDraftMode: removeDraftModeCallback
    });
});

});
parcelRegister("fVTp8", function(module, exports) {

$parcel$export(module.exports, "dataAttributes", () => $c2a45e53becb69f1$export$15d6ddc168d35719);
$parcel$export(module.exports, "updateWindowSelectionAroundDraft", () => $c2a45e53becb69f1$export$e14699d956e87e73);
const $c2a45e53becb69f1$export$15d6ddc168d35719 = ({ from: from, to: to })=>{
    return {
        ['data-annotation-draft-mark']: true,
        ['data-draft-start-at']: from,
        ['data-draft-end-at']: to
    };
};
const $c2a45e53becb69f1$var$buildDataAttributesQuery = (pos)=>{
    const a = $c2a45e53becb69f1$export$15d6ddc168d35719(pos);
    return Object.entries(a).map(([k, v])=>`[${k}="${v}"]`).join('');
};
const $c2a45e53becb69f1$export$e14699d956e87e73 = (pos)=>{
    const sel = window.getSelection();
    if (!sel) return false;
    const draftNodes = document.querySelectorAll($c2a45e53becb69f1$var$buildDataAttributesQuery(pos));
    if (!draftNodes || draftNodes.length === 0) return false;
    sel.removeAllRanges();
    const range = document.createRange();
    range.setStart(draftNodes[0], 0);
    range.setEndAfter(draftNodes[draftNodes.length - 1]);
    sel.addRange(range);
    return true;
};

});


parcelRegister("2EsbE", function(module, exports) {

$parcel$export(module.exports, "AnnotationRangeProvider", () => $7c7af48337b91c7a$export$30384a6aedd19fee);
$parcel$export(module.exports, "useAnnotationRangeState", () => $7c7af48337b91c7a$export$e07ee6d6cc95d9a0);
$parcel$export(module.exports, "useAnnotationRangeDispatch", () => $7c7af48337b91c7a$export$708fc397e2b6f08d);

var $5uXOq = parcelRequire("5uXOq");
function $7c7af48337b91c7a$var$reducer(state, action) {
    switch(action.type){
        case 'clear':
            if (!!state.range || !!state.type) return {
                range: null,
                draftRange: null,
                type: null
            };
            return state;
        case 'clearSelection':
            if (state.type === 'selection') return {
                ...state,
                range: null,
                type: null
            };
            return state;
        case 'clearDraftSelection':
            if (state.type === 'selection') return {
                ...state,
                draftRange: null
            };
            return state;
        case 'clearDraftHover':
            if (state.type === 'hover') return {
                ...state,
                draftRange: null
            };
            return state;
        case 'clearHover':
            if (state.type === 'hover') return {
                range: null,
                draftRange: null,
                type: null
            };
            return state;
        case 'setSelection':
            if (state.range !== action.range || state.type !== 'selection') return {
                ...state,
                range: action.range,
                type: 'selection'
            };
            return state;
        case 'setHover':
            if (state.range !== action.range || state.type !== 'hover') return {
                ...state,
                range: action.range,
                type: 'hover'
            };
            return state;
        case 'setDraftSelection':
            if (state.draftRange !== action.draftRange || state.type !== 'selection') return {
                range: null,
                draftRange: action.draftRange,
                type: null
            };
            return state;
        case 'setDraftHover':
            if (state.draftRange !== action.draftRange || state.type !== 'hover') return {
                ...state,
                draftRange: action.draftRange
            };
            return state;
    }
}
const $7c7af48337b91c7a$var$AnnotationRangeStateContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    range: null,
    draftRange: null,
    type: null
});
const $7c7af48337b91c7a$var$AnnotationRangeDispatchContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    clearRange: ()=>{},
    clearSelectionRange: ()=>{},
    clearDraftRange: ()=>{},
    clearHoverRange: ()=>{},
    setRange: ()=>{},
    setDraftRange: ()=>{}
});
const $7c7af48337b91c7a$export$30384a6aedd19fee = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia })=>{
    const [{ range: range, draftRange: draftRange, type: type }, dispatch] = (0, $5uXOq.useReducer)($7c7af48337b91c7a$var$reducer, {
        range: null,
        draftRange: null,
        type: null
    });
    const clearRange = (0, $5uXOq.useCallback)(()=>dispatch({
            type: 'clear'
        }), []);
    const clearSelectionRange = (0, $5uXOq.useCallback)(()=>dispatch({
            type: 'clearSelection'
        }), []);
    const clearDraftRange = (0, $5uXOq.useCallback)((type)=>{
        if (type === 'hover') {
            dispatch({
                type: 'clearDraftHover'
            });
            return;
        }
        dispatch({
            type: 'clearDraftSelection'
        });
    }, []);
    const clearHoverRange = (0, $5uXOq.useCallback)(()=>dispatch({
            type: 'clearHover'
        }), []);
    const setRange = (0, $5uXOq.useCallback)((range)=>dispatch({
            type: 'setSelection',
            range: range
        }), []);
    const setDraftRange = (0, $5uXOq.useCallback)((range, type)=>{
        if (type === 'hover') {
            dispatch({
                type: 'setDraftHover',
                draftRange: range
            });
            return;
        }
        dispatch({
            type: 'setDraftSelection',
            draftRange: range
        });
    }, []);
    const setHoverTarget = (0, $5uXOq.useCallback)((target)=>{
        // the HoverComponent expects an element deeply nested inside media, these classes work with the current implementation
        const mediaNode = target.querySelector('.media-card-inline-player, .media-file-card-view');
        if (!mediaNode) return;
        const range = document.createRange();
        range.setStartBefore(mediaNode);
        range.setEndAfter(mediaNode);
        dispatch({
            type: 'setHover',
            range: range
        });
    }, []);
    const stateData = (0, $5uXOq.useMemo)(()=>({
            range: range,
            draftRange: draftRange,
            type: type
        }), [
        range,
        draftRange,
        type
    ]);
    const dispatchData = (0, $5uXOq.useMemo)(()=>({
            clearRange: clearRange,
            clearSelectionRange: clearSelectionRange,
            clearDraftRange: clearDraftRange,
            clearHoverRange: clearHoverRange,
            setRange: setRange,
            setDraftRange: setDraftRange,
            setHoverTarget: !!allowCommentsOnMedia ? setHoverTarget : undefined
        }), [
        allowCommentsOnMedia,
        clearRange,
        clearSelectionRange,
        clearDraftRange,
        clearHoverRange,
        setRange,
        setDraftRange,
        setHoverTarget
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c7af48337b91c7a$var$AnnotationRangeStateContext.Provider, {
        value: stateData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c7af48337b91c7a$var$AnnotationRangeDispatchContext.Provider, {
        value: dispatchData
    }, children));
};
const $7c7af48337b91c7a$export$e07ee6d6cc95d9a0 = ()=>{
    return (0, $5uXOq.useContext)($7c7af48337b91c7a$var$AnnotationRangeStateContext);
};
const $7c7af48337b91c7a$export$708fc397e2b6f08d = ()=>{
    return (0, $5uXOq.useContext)($7c7af48337b91c7a$var$AnnotationRangeDispatchContext);
};

});

parcelRegister("kuusl", function(module, exports) {

$parcel$export(module.exports, "AnnotationHoverContext", () => $b758d405b6d3becf$export$b3db0feb20552fc3);
$parcel$export(module.exports, "useAnnotationHoverContext", () => $b758d405b6d3becf$export$a02bfcbbbf920306);
$parcel$export(module.exports, "useAnnotationHoverDispatch", () => $b758d405b6d3becf$export$c288883964405c82);

var $5uXOq = parcelRequire("5uXOq");
const $b758d405b6d3becf$var$AnnotationHoverStateContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isWithinRange: false
});
const $b758d405b6d3becf$var$AnnotationHoverDispatchContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    cancelTimeout: ()=>{},
    initiateTimeout: ()=>{},
    setIsWithinRange: ()=>{}
});
const $b758d405b6d3becf$export$b3db0feb20552fc3 = ({ children: children })=>{
    const [isWithinRange, setIsWithinRange] = (0, $5uXOq.useState)(false);
    const timeoutHandler = (0, $5uXOq.useRef)();
    const cancelTimeout = (0, $5uXOq.useCallback)(()=>{
        if (timeoutHandler) clearTimeout(timeoutHandler.current);
    }, [
        timeoutHandler
    ]);
    const initiateTimeout = (0, $5uXOq.useCallback)(()=>{
        if (isWithinRange) timeoutHandler.current = setTimeout(()=>{
            setIsWithinRange(false);
        }, 500);
    }, [
        isWithinRange
    ]);
    const stateData = (0, $5uXOq.useMemo)(()=>({
            isWithinRange: isWithinRange
        }), [
        isWithinRange
    ]);
    const dispatchData = (0, $5uXOq.useMemo)(()=>({
            cancelTimeout: cancelTimeout,
            initiateTimeout: initiateTimeout,
            setIsWithinRange: setIsWithinRange
        }), [
        cancelTimeout,
        initiateTimeout,
        setIsWithinRange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b758d405b6d3becf$var$AnnotationHoverStateContext.Provider, {
        value: stateData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b758d405b6d3becf$var$AnnotationHoverDispatchContext.Provider, {
        value: dispatchData
    }, children));
};
const $b758d405b6d3becf$export$a02bfcbbbf920306 = ()=>{
    return (0, $5uXOq.useContext)($b758d405b6d3becf$var$AnnotationHoverStateContext);
};
const $b758d405b6d3becf$export$c288883964405c82 = ()=>{
    return (0, $5uXOq.useContext)($b758d405b6d3becf$var$AnnotationHoverDispatchContext);
};

});


parcelRegister("iatcV", function(module, exports) {

$parcel$export(module.exports, "SelectionRangeValidator", () => $d73a3647df6a8131$export$74435b85e23b84d9);

var $5uXOq = parcelRequire("5uXOq");

var $jWe7H = parcelRequire("jWe7H");

var $bZQ2Q = parcelRequire("bZQ2Q");

var $fCNtA = parcelRequire("fCNtA");
const $d73a3647df6a8131$export$74435b85e23b84d9 = (props)=>{
    const { selectionComponent: selectionComponent, rendererRef: rendererRef, applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const [range, draftRange, clearRange] = (0, $jWe7H.useUserSelectionRange)({
        rendererRef: rendererRef
    });
    if (!range && !draftRange) return null;
    const documentPosition = actions.getPositionFromRange(range);
    // This property is drilled down to consumers when a new range is selected to test it's validity
    let isAnnotationAllowedOnRange = false;
    try {
        isAnnotationAllowedOnRange = documentPosition && actions.isValidAnnotationPosition(documentPosition);
    } catch  {
        isAnnotationAllowedOnRange = false;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bZQ2Q.SelectionInlineCommentMounter), {
        range: range,
        draftRange: draftRange,
        wrapperDOM: rendererRef,
        component: selectionComponent,
        onClose: clearRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: isAnnotationAllowedOnRange,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        applyAnnotationDraftAt: applyAnnotationDraftAt,
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        clearAnnotationDraft: clearAnnotationDraft,
        createAnalyticsEvent: createAnalyticsEvent
    });
};

});
parcelRegister("jWe7H", function(module, exports) {

$parcel$export(module.exports, "useUserSelectionRange", () => $cd0f4805a1ba9aff$export$47201332e612f5a4);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $2EsbE = parcelRequire("2EsbE");

var $jqO24 = parcelRequire("jqO24");

var $cMPbW = parcelRequire("cMPbW");
const $cd0f4805a1ba9aff$export$47201332e612f5a4 = (props)=>{
    const { rendererRef: { current: rendererDOM } } = props;
    const selectionTimeoutRef = (0, $5uXOq.useRef)();
    const { clearRange: clearRange, setRange: setRange } = (0, $2EsbE.useAnnotationRangeDispatch)();
    const { range: range, draftRange: draftRange, type: type } = (0, $2EsbE.useAnnotationRangeState)();
    (0, $5uXOq.useEffect)(()=>{
        if (!document || !rendererDOM) return;
        const onSelectionChange = (event)=>{
            if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
            selectionTimeoutRef.current = setTimeout(()=>{
                const sel = document.getSelection();
                if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) return;
                const _range = sel.getRangeAt(0);
                if (rendererDOM && (0, $jqO24.isRangeInsideOfRendererContainer)(rendererDOM, _range)) {
                    if ((0, $VSDnB.fg)('platform_editor_allow_annotation_triple_click')) {
                        const { startContainer: startContainer, endContainer: endContainer, commonAncestorContainer: commonAncestorContainer } = _range;
                        const parentNode = startContainer.parentNode;
                        // ED-23493
                        // On triple-click in Chrome and Safari, the native Selection API's range has endContainer as a non-text node
                        // and commonAncestorContainer as root level div.ak-renderer-document when the node is followed by div or hr.
                        // Triple clicks are the only case that can cause the endContainer to be a non-text node
                        // Same check for highlight range logic in confluence/next/packages/comments-util/src/domUtils.ts Line 180
                        const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
                        // isAnnotationAllowedOnRange range validation is checking if the parent container is root element and disable the comment if it is.
                        // platform/packages/editor/renderer/src/steps/index.ts Line 180
                        // This workaround ensures the endContainer is set to a text node when endContainer is non-text and the parent container is the root element
                        if (isTripleClick && // Ignored via go/ees005
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        (0, $cMPbW.isRoot)(commonAncestorContainer) && parentNode?.nodeName === 'P' // ignore if the parent node is strong, em, etc.
                        ) {
                            const lastChild = parentNode?.lastChild && parentNode?.lastChild?.nodeType === Node.TEXT_NODE ? parentNode?.lastChild : parentNode?.lastChild?.childNodes[0];
                            _range.setEnd(lastChild, lastChild.length || 0);
                        }
                    }
                    setRange(_range.cloneRange());
                }
            }, 250);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('selectionchange', onSelectionChange);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('selectionchange', onSelectionChange);
            clearRange();
        };
    }, [
        rendererDOM,
        setRange,
        clearRange
    ]);
    return [
        type === 'selection' ? range : null,
        draftRange,
        clearRange
    ];
};

});
parcelRegister("jqO24", function(module, exports) {

$parcel$export(module.exports, "isRangeInsideOfRendererContainer", () => $8373eb69e5c4287b$export$90ee8f2d9317f430);
/** Exists in its own module to allow mocking in unit tests */ const $8373eb69e5c4287b$export$90ee8f2d9317f430 = (rendererDOM, range)=>{
    const sourceRange = document.createRange();
    sourceRange.selectNode(rendererDOM);
    const isSelectionStartsAfterRenderer = range.compareBoundaryPoints(Range.START_TO_START, sourceRange) === 1;
    const isSelectionStartsBeforeRenderer = range.compareBoundaryPoints(Range.START_TO_END, sourceRange) === 1;
    const isSelectionEndsAfterRenderer = range.compareBoundaryPoints(Range.END_TO_END, sourceRange) === 1;
    return isSelectionStartsAfterRenderer && isSelectionStartsBeforeRenderer && !isSelectionEndsAfterRenderer;
};

});


parcelRegister("bZQ2Q", function(module, exports) {

$parcel$export(module.exports, "SelectionInlineCommentMounter", () => $7e4c7bbc0d380e24$export$ca7741472ed8ba00);

var $5uXOq = parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $VSDnB = parcelRequire("VSDnB");

var $fVTp8 = parcelRequire("fVTp8");

var $dWAZk = parcelRequire("dWAZk");

var $gkwXh = parcelRequire("gkwXh");

var $4apTl = parcelRequire("4apTl");

var $fCNtA = parcelRequire("fCNtA");
const $7e4c7bbc0d380e24$export$ca7741472ed8ba00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const { component: Component, range: range, draftRange: draftRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, clearAnnotationDraft: clearAnnotationDraft, applyAnnotationDraftAt: applyAnnotationDraftAt, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const [draftDocumentPosition, setDraftDocumentPosition] = (0, $5uXOq.useState)();
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const inlineNodeTypes = (0, $5uXOq.useMemo)(()=>{
        if ((0, $VSDnB.fg)('annotations_defensive_node_name_calculations')) {
            if (!actions.isRangeAnnotatable(range)) return undefined;
            return (0, $4apTl.getRendererRangeInlineNodeNames)({
                pos: documentPosition,
                actions: actions
            });
        } else {
            if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
            if (actions.isValidAnnotationRange(range)) return (0, $4apTl.getRendererRangeInlineNodeNames)({
                pos: documentPosition,
                actions: actions
            });
            else return undefined;
        }
    }, [
        documentPosition,
        actions,
        range
    ]);
    const onCreateCallback = (0, $5uXOq.useCallback)((annotationId)=>{
        // We want to support creation on a documentPosition if the user is only using ranges
        // but we want to prioritize draft positions if they are being used by consumers
        const positionToAnnotate = draftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation) return false;
        // Evaluate position validity when the user commits the position to be annotated
        const isCreateAllowedOnPosition = actions.isValidAnnotationPosition(positionToAnnotate);
        if (!isCreateAllowedOnPosition) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $gkwXh.ACTION).INSERTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            },
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK
        }).fire((0, $dWAZk.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        actions,
        documentPosition,
        applyAnnotation,
        draftDocumentPosition,
        createAnalyticsEvent,
        inlineNodeTypes
    ]);
    const createIndexCallback = (0, $5uXOq.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $5uXOq.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    inlineNodeNames: inlineNodeTypes
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            }).fire((0, $dWAZk.FabricChannel).editor);
            return false;
        }
        setDraftDocumentPosition(documentPosition);
        applyAnnotationDraftAt(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = range ? actions.getAnnotationsByPosition(range) : [];
            createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).OPENED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length,
                    inlineNodeNames: inlineNodeTypes
                }
            }).fire((0, $dWAZk.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $fVTp8.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        const positionToAnnotate = draftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) return false;
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        applyAnnotationDraftAt,
        createAnalyticsEvent,
        applyAnnotation,
        draftDocumentPosition,
        actions,
        range,
        inlineNodeTypes
    ]);
    const removeDraftModeCallback = (0, $5uXOq.useCallback)(()=>{
        clearAnnotationDraft();
        setDraftDocumentPosition(null);
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearAnnotationDraft
    ]);
    const onCloseCallback = (0, $5uXOq.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $gkwXh.ACTION).CLOSED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            }
        }).fire((0, $dWAZk.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent,
        inlineNodeTypes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
        range: range,
        draftRange: draftRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: onCloseCallback,
        onCreate: onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: applyDraftModeCallback,
        removeDraftMode: removeDraftModeCallback,
        inlineNodeTypes: inlineNodeTypes
    });
});

});



parcelRegister("joddd", function(module, exports) {

$parcel$export(module.exports, "useLoadAnnotations", () => $9aa08f3110a2b008$export$39f7c1a861a0d41c);

var $5uXOq = parcelRequire("5uXOq");

var $dEtqo = parcelRequire("dEtqo");

var $VSDnB = parcelRequire("VSDnB");

var $iYAgE = parcelRequire("iYAgE");

var $fCNtA = parcelRequire("fCNtA");
const $9aa08f3110a2b008$export$39f7c1a861a0d41c = ({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const providers = (0, $5uXOq.useContext)((0, $iYAgE.ProvidersContext));
    (0, $5uXOq.useEffect)(()=>{
        if (!providers) return;
        const { inlineComment: { getState: inlineCommentGetState, updateSubscriber: updateSubscriberInlineComment } } = providers;
        const annotations = actions.getAnnotationMarks();
        // we don't want to request integrators for state with an empty list of ids.
        if (!annotations.length) {
            if (!isNestedRender && (0, $VSDnB.fg)('use_comments_data_annotation_updater')) // inlineCommentGetState handles empty lists gracefully. It has a side-effect of clearing state, which is why this call is needed
            inlineCommentGetState([], isNestedRender);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: 0
            });
            return;
        }
        const ids = annotations.map((mark)=>mark.attrs.id);
        const cb = (data)=>{
            if (!updateSubscriberInlineComment) return;
            const payload = data.reduce((acc, value)=>({
                    ...acc,
                    [value.id]: value
                }), {});
            updateSubscriberInlineComment.emit((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_STATE, payload);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: data.filter((data)=>data.state === 'active').length
            });
        };
        inlineCommentGetState(ids, isNestedRender).then(cb);
    }, [
        actions,
        providers,
        adfDocument,
        isNestedRender,
        onLoadComplete
    ]);
};

});



parcelRegister("bQeYo", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5dc6f3b113435da$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");


var $5uXOq = parcelRequire("5uXOq");

var $i8Zwf = parcelRequire("i8Zwf");

var $fAZXL = parcelRequire("fAZXL");

var $edXiX = parcelRequire("edXiX");
var $4ceoy = parcelRequire("4ceoy");

var $l8Gxi = parcelRequire("l8Gxi");

var $eOOFp = parcelRequire("eOOFp");
const $c5dc6f3b113435da$var$useMultiBodiedExtensionActions = ({ updateActiveChild: updateActiveChild, children: children })=>{
    const actions = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        return {
            changeActive (index) {
                return updateActiveChild(index);
            },
            addChild () {
                return false;
            },
            getChildrenCount () {
                return children ? children?.length : 0;
            },
            removeChild (index) {
                return false;
            },
            updateParameters (parameters) {
                return false;
            },
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getChildren () {
                return [];
            }
        };
    }, [
        updateActiveChild,
        children
    ]);
    return actions;
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $c5dc6f3b113435da$var$navigationCssExtended = /*#__PURE__*/ (0, $f8Sb3.css)((0, $edXiX.sharedMultiBodiedExtensionStyles).mbeNavigation, ";margin-left:0!important;margin-right:0!important;.mbe-add-tab-button,.mbe-remove-tab{display:none;}");
const $c5dc6f3b113435da$var$MultiBodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [] } = props;
    const [activeChildIndex, setActiveChildIndex] = (0, $5uXOq.useState)(0);
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children)// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    const overflowContainerClass = !removeOverflow ? (0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    const updateActiveChild = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((index)=>{
        if (typeof index !== 'number') {
            // TODO: Make sure we log this somewhere if this happens
            setActiveChildIndex(0);
            return false;
        }
        setActiveChildIndex(index);
        return true;
    }, [
        setActiveChildIndex
    ]);
    const actions = $c5dc6f3b113435da$var$useMultiBodiedExtensionActions({
        updateActiveChild: updateActiveChild,
        children: children
    });
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    const containerCssExtended = /*#__PURE__*/ (0, $f8Sb3.css)((0, $edXiX.sharedMultiBodiedExtensionStyles).mbeExtensionContainer, ";.ak-renderer-extension{margin-top:0!important;}[data-layout='full-width'],[data-layout='wide']{.multiBodiedExtension-navigation{border-right:3px solid ", `var(--ds-border, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`, "!important;}}.multiBodiedExtension--frames>[data-extension-frame='true']:nth-of-type(", activeChildIndex + 1, "){", (0, $edXiX.sharedMultiBodiedExtensionStyles).extensionFrameContent, " margin-left:0;margin-right:0;}");
    const isTopLevel = path.length < 1;
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $l8Gxi.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    function renderMbeContent(width) {
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $l8Gxi.RendererCssClassName).EXTENSION} ${centerAlignClass} ${overflowContainerClass}`,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                width: isTopLevel ? (0, $eOOFp.calcBreakoutWidth)(layout, width) : '100%'
            },
            "data-layout": layout
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("nav", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "multiBodiedExtension-navigation",
            css: $c5dc6f3b113435da$var$navigationCssExtended,
            "data-testid": "multiBodiedExtension-navigation"
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fAZXL.default), {
            ...props,
            actions: actions,
            type: "multiBodiedExtension"
        }, ({ result: result })=>{
            try {
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
                return (0, $i8Zwf.renderExtension)(result, layout, {
                    isTopLevel: path.length < 1
                });
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return (0, $i8Zwf.renderExtension)(children, layout, {
                isTopLevel: path.length < 1
            });
        })), /*#__PURE__*/ (0, $f8Sb3.jsx)("article", {
            "data-testid": "multiBodiedExtension--frames",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `multiBodiedExtension--frames`
        }, children));
    }
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("section", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "multiBodiedExtension--container",
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerCssExtended,
        "data-testid": "multiBodiedExtension--container",
        "data-active-child-index": activeChildIndex,
        "data-layout": layout
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthConsumer), null, ({ width: width })=>renderMbeContent(width)));
};
var $c5dc6f3b113435da$export$2e2bcd8739ae039 = $c5dc6f3b113435da$var$MultiBodiedExtension;

});
parcelRegister("edXiX", function(module, exports) {

$parcel$export(module.exports, "removeMarginsAndBorder", () => $a5dc814f02ba73ab$export$8df0393dc2d5d656);
$parcel$export(module.exports, "sharedMultiBodiedExtensionStyles", () => $a5dc814f02ba73ab$export$9c7196ca47f67390);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $a5dc814f02ba73ab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Wraps the navigation bar and extensionFrames
const $a5dc814f02ba73ab$var$mbeExtensionContainer = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    background: 'transparent !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'padding:': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        left: `${"var(--ds-space-100, 8px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        right: `${"var(--ds-space-100, 8px)"} !important`
    },
    paddingBottom: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-padding': {
        paddingBottom: 0
    },
    position: 'relative',
    verticalAlign: 'middle',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-handler-result': {
        marginLeft: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true'], .multiBodiedExtension--frames > [data-extension-frame='true']": {
        display: 'none',
        background: "var(--ds-surface, white)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-content-dom-wrapper, .multiBodiedExtension--frames': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[data-extension-frame='true'] > :not(style):first-child, [data-extension-frame='true'] > style:first-child + *": {
            marginTop: 0
        }
    }
});
const $a5dc814f02ba73ab$var$mbeNavigation = {
    name: "2ubief",
    styles: "border-top-left-radius:var(--ds-border-radius, 3px);border-top-right-radius:var(--ds-border-radius, 3px);user-select:none;-webkit-user-modify:read-only;border-bottom:none !important;background:var(--ds-surface, white);margin-left:var(--ds-space-100, 8px);margin-right:var(--ds-space-100, 8px);&.remove-margins{margin:var(--ds-space-negative-100, -8px);}&.remove-border{border:none;}"
};
const $a5dc814f02ba73ab$var$extensionFrameContent = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    padding: `${"var(--ds-space-100, 8px)"} !important`,
    display: 'block',
    minHeight: '100px',
    background: "var(--ds-surface, white)",
    borderBottomLeftRadius: "var(--ds-border-radius, 3px)",
    borderBottomRightRadius: "var(--ds-border-radius, 3px)",
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-100, 8px)",
    cursor: 'initial',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.pm-table-with-controls': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-150, 12px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingRight: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.bodiedExtensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-100, 8px)"} !important`
    }
});
const $a5dc814f02ba73ab$export$8df0393dc2d5d656 = {
    name: "c620zi",
    styles: "margin-left:0;margin-right:0;border:none"
};
const $a5dc814f02ba73ab$export$9c7196ca47f67390 = {
    mbeExtensionContainer: $a5dc814f02ba73ab$var$mbeExtensionContainer,
    mbeNavigation: $a5dc814f02ba73ab$var$mbeNavigation,
    extensionFrameContent: $a5dc814f02ba73ab$var$extensionFrameContent
};

});


parcelRegister("cOnYv", function(module, exports) {

$parcel$export(module.exports, "default", () => $adf8f8318644b4cb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $adf8f8318644b4cb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $adf8f8318644b4cb$var$containerCSS = {
    name: "ecvjkq",
    styles: "min-height:100px"
};
const $adf8f8318644b4cb$var$ExtensionFrame = (props)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $adf8f8318644b4cb$var$containerCSS,
        "data-extension-frame": "true",
        style: {
            flexBasis: `100%`
        }
    }, props.children);
};
var $adf8f8318644b4cb$export$2e2bcd8739ae039 = $adf8f8318644b4cb$var$ExtensionFrame;

});

parcelRegister("cWRvh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b4346c39a86c4f3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kjhhp = parcelRequire("kjhhp");

var $503mU = parcelRequire("503mU");
function $4b4346c39a86c4f3$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $kjhhp.bulletListSelector).substr(1),
        "data-indent-level": props.path ? (0, $503mU.getListIndentLevel)(props.path) : 1
    }, props.children);
}

});
parcelRegister("503mU", function(module, exports) {

$parcel$export(module.exports, "getListIndentLevel", () => $95f5719763d590de$export$75aa84e85754623e);
function $95f5719763d590de$export$75aa84e85754623e(path) {
    let count = 1;
    path.forEach((node)=>{
        if (node.type.name === 'bulletList' || node.type.name === 'orderedList') count++;
    });
    return count;
}

});


parcelRegister("5KNWO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e507ebac88967e63$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => $e507ebac88967e63$export$41121a410ca2f650);

var $5uXOq = parcelRequire("5uXOq");

var $l8Gxi = parcelRequire("l8Gxi");

var $bGnBY = parcelRequire("bGnBY");
function $e507ebac88967e63$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $l8Gxi.RendererCssClassName).DOCUMENT
    }, props.children);
}
function $e507ebac88967e63$export$41121a410ca2f650(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: (0, $bGnBY.useSelectAllTrap)(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $l8Gxi.RendererCssClassName).DOCUMENT
    }, props.children);
}

});
parcelRegister("bGnBY", function(module, exports) {

$parcel$export(module.exports, "useSelectAllTrap", () => $08249876083d1eac$export$98871b245ee25215);

var $gkwXh = parcelRequire("gkwXh");

var $5uXOq = parcelRequire("5uXOq");

var $TM1uy = parcelRequire("TM1uy");

var $lb6Ua = parcelRequire("lb6Ua");
const $08249876083d1eac$export$98871b245ee25215 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $TM1uy.default));
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const clicked = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(false);
    const caught = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const mac = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
    const onKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((e)=>{
        const el = ref.current;
        if (!el) return;
        const modKey = mac ? e.metaKey : e.ctrlKey;
        if (!modKey || e.code !== 'KeyA' || e.shiftKey) return;
        const elementSelection = (0, $lb6Ua.ElementSelection).fromWindow();
        const isInput = e.target?.matches?.('input');
        if (elementSelection.eq(caught.current) || isInput) {
            fireAnalyticsEvent({
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                action: (0, $gkwXh.ACTION).SELECT_ALL_ESCAPED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER
            });
            return;
        }
        if (elementSelection.inside(el) || elementSelection.type === 'None' && clicked.current) {
            fireAnalyticsEvent({
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                action: (0, $gkwXh.ACTION).SELECT_ALL_CAUGHT,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER
            });
            e.preventDefault();
            caught.current = elementSelection.select(el);
        }
    }, [
        mac,
        ref,
        fireAnalyticsEvent,
        clicked,
        caught
    ]);
    const onClick = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((e)=>{
        clicked.current = ref.current?.contains(e.target) ?? false;
    }, [
        ref,
        clicked
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('keydown', onKeyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('click', onClick);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('keydown', onKeyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('click', onClick);
        };
    }, [
        onKeyDown,
        onClick
    ]);
    return ref;
};

});
parcelRegister("TM1uy", function(module, exports) {

$parcel$export(module.exports, "default", () => $64e1e4f8cfab5159$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $64e1e4f8cfab5159$var$AnalyticsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    fireAnalyticsEvent: (_event)=>null
});
var $64e1e4f8cfab5159$export$2e2bcd8739ae039 = $64e1e4f8cfab5159$var$AnalyticsContext;

});

parcelRegister("lb6Ua", function(module, exports) {

$parcel$export(module.exports, "ElementSelection", () => $854590065f4073c9$export$6e6724d89f27411);
class $854590065f4073c9$export$6e6724d89f27411 {
    constructor(selection){
        this.type = selection ? selection.type : 'None';
        if (selection && this.type !== 'None') this.range = selection.getRangeAt(0);
    }
    eq(selection) {
        if (!selection) return false;
        if (this.range && selection.range) {
            const startMatches = this.range?.compareBoundaryPoints(Range.START_TO_START, selection.range) === 0;
            const endMatches = this.range?.compareBoundaryPoints(Range.END_TO_END, selection.range) === 0;
            return startMatches && endMatches;
        }
        return this.type === 'None' && selection.type === 'None';
    }
    inside(el) {
        return el.contains(this.range?.commonAncestorContainer ?? null);
    }
    select(el) {
        const range = document.createRange();
        range.selectNodeContents(el);
        const selection = window.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
        return $854590065f4073c9$export$6e6724d89f27411.fromWindow();
    }
    static fromWindow(win = window) {
        return new $854590065f4073c9$export$6e6724d89f27411(win.getSelection());
    }
}

});



parcelRegister("lKIDi", function(module, exports) {

$parcel$export(module.exports, "default", () => $98a311e98fd838fb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $98a311e98fd838fb$var$HardBreak = ({ forceNewLine: forceNewLine = false })=>{
    // To display an empty line using Shift+Enter, ProseMirror inserts a
    // double <br>. The second <br> is not part of the document, it's just
    // there to make browsers behave properly. The forceNewLine prop in this
    // component replicates this behaviour. If the last child node is a
    // hardBreak, it will also insert a double <br>.
    if (forceNewLine) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null);
};
var $98a311e98fd838fb$export$2e2bcd8739ae039 = $98a311e98fd838fb$var$HardBreak;

});

parcelRegister("7AttJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e20de8dc9c3ed0b1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jldZL = parcelRequire("jldZL");

var $VSDnB = parcelRequire("VSDnB");

var $3rouw = parcelRequire("3rouw");

var $gkwXh = parcelRequire("gkwXh");

var $TM1uy = parcelRequire("TM1uy");

var $jSk6P = parcelRequire("jSk6P");
const $e20de8dc9c3ed0b1$var$getCurrentUrlWithHash = (hash = '')=>{
    const url = new URL(window.location.href);
    url.search = ''; // clear any query params so that the page will correctly scroll to the anchor
    url.hash = encodeURIComponent(hash);
    return url.href;
};
function $e20de8dc9c3ed0b1$var$hasRightAlignmentMark(marks) {
    if (!marks || !marks.length) return false;
    return marks.some((mark)=>mark.type.name === 'alignment' && mark.attrs.align === 'end');
}
function $e20de8dc9c3ed0b1$var$WrappedHeadingAnchor({ enableNestedHeaderLinks: enableNestedHeaderLinks, level: level, headingId: headingId, hideFromScreenReader: hideFromScreenReader }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $TM1uy.default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3rouw.default), {
            enableNestedHeaderLinks: enableNestedHeaderLinks,
            level: level,
            onCopyText: ()=>{
                fireAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).CLICKED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).HEADING_ANCHOR_LINK,
                    eventType: (0, $gkwXh.EVENT_TYPE).UI
                });
                return (0, $jSk6P.copyTextToClipboard)($e20de8dc9c3ed0b1$var$getCurrentUrlWithHash(headingId));
            },
            hideFromScreenReader: hideFromScreenReader
        }));
}
function $e20de8dc9c3ed0b1$var$Heading(props) {
    const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible } = props;
    const HX = `h${props.level}`;
    const showAnchorLink = !!props.showAnchorLink;
    const isRightAligned = $e20de8dc9c3ed0b1$var$hasRightAlignmentMark(marks);
    const enableNestedHeaderLinks = allowHeadingAnchorLinks && allowHeadingAnchorLinks.allowNestedHeaderLinks;
    const headingIdToUse = invisible ? undefined : headingId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HX, {
        id: headingIdToUse,
        "data-renderer-start-pos": dataAttributes['data-renderer-start-pos']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, showAnchorLink && headingId && isRightAligned && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e20de8dc9c3ed0b1$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        headingId: headingId,
        hideFromScreenReader: (0, $VSDnB.fg)('platform_editor_accessible_heading_copy_link')
    }), props.children, showAnchorLink && headingId && !isRightAligned && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e20de8dc9c3ed0b1$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        headingId: headingId,
        hideFromScreenReader: (0, $VSDnB.fg)('platform_editor_accessible_heading_copy_link')
    }))), (0, $VSDnB.fg)('platform_editor_accessible_heading_copy_link') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), {
        testId: "visually-hidden-heading-anchor"
    }, showAnchorLink && headingId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e20de8dc9c3ed0b1$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        headingId: headingId
    })));
}
var $e20de8dc9c3ed0b1$export$2e2bcd8739ae039 = $e20de8dc9c3ed0b1$var$Heading;

});
parcelRegister("3rouw", function(module, exports) {

$parcel$export(module.exports, "HeadingAnchorWrapperClassName", () => $b36f5408031b5508$export$3c9cedc52604835d);
$parcel$export(module.exports, "default", () => $b36f5408031b5508$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $458iJ = parcelRequire("458iJ");

var $3bDjY = parcelRequire("3bDjY");

var $8RXs9 = parcelRequire("8RXs9");

var $1Bd5P = parcelRequire("1Bd5P");
const $b36f5408031b5508$export$3c9cedc52604835d = 'heading-anchor-wrapper';
const $b36f5408031b5508$var$CopyAnchorWrapperWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $b36f5408031b5508$export$3c9cedc52604835d,
        ref: ref
    }, children);
});
const $b36f5408031b5508$var$copyAnchorButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline',
    outline: 'none',
    backgroundColor: 'transparent',
    border: 'none',
    color: `var(--ds-icon, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
    cursor: 'pointer',
    right: 0
});
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $b36f5408031b5508$var$HeadingAnchor extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    componentDidMount() {
        this.resetMessage();
    }
    render() {
        const { tooltipMessage: tooltipMessage } = this.state;
        if (tooltipMessage) // We set the key to the message to ensure it remounts when the message
        // changes, so that it correctly repositions.
        // @see https://ecosystem.atlassian.net/projects/AK/queues/issue/AK-6548
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            tag: $b36f5408031b5508$var$CopyAnchorWrapperWithRef,
            content: tooltipMessage,
            position: "top",
            delay: 0,
            key: tooltipMessage
        }, this.renderAnchorButton());
        return this.renderAnchorButton();
    }
    constructor(...args){
        super(...args), this.state = {
            tooltipMessage: '',
            isClicked: false
        }, this.setTooltipState = (message, isClicked = false)=>{
            this.setState({
                // TODO: ED-14403 investigate why this does not translate
                tooltipMessage: this.props.intl.formatMessage(message),
                isClicked: isClicked
            });
        }, this.getCopyAriaLabel = ()=>{
            const { copyAriaLabel: copyAriaLabel } = (0, $1Bd5P.headingAnchorLinkMessages);
            return this.props.intl.formatMessage(copyAriaLabel);
        }, this.copyToClipboard = async (event)=>{
            const { copiedHeadingLinkToClipboard: copiedHeadingLinkToClipboard, failedToCopyHeadingLink: failedToCopyHeadingLink } = (0, $1Bd5P.headingAnchorLinkMessages);
            event.stopPropagation();
            try {
                await this.props.onCopyText();
                this.setTooltipState(copiedHeadingLinkToClipboard, true);
            } catch (e) {
                this.setTooltipState(failedToCopyHeadingLink);
            }
        }, this.resetMessage = ()=>{
            this.setTooltipState((0, $1Bd5P.headingAnchorLinkMessages).copyHeadingLinkToClipboard);
        }, this.renderAnchorButton = ()=>{
            const { hideFromScreenReader: hideFromScreenReader = false } = this.props;
            return /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
                "data-testid": "anchor-button",
                css: $b36f5408031b5508$var$copyAnchorButtonStyles,
                onMouseLeave: this.resetMessage,
                onClick: this.copyToClipboard,
                "aria-hidden": hideFromScreenReader,
                tabIndex: hideFromScreenReader ? undefined : -1,
                "aria-label": hideFromScreenReader ? undefined : this.state.tooltipMessage,
                type: "button"
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($458iJ))), {
                label: this.getCopyAriaLabel(),
                size: this.props.level > 3 ? 'small' : 'medium',
                primaryColor: this.state.isClicked ? `var(--ds-icon-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-icon-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
            }));
        };
    }
}
var $b36f5408031b5508$export$2e2bcd8739ae039 = (0, $8RXs9.default)($b36f5408031b5508$var$HeadingAnchor);

});
parcelRegister("1Bd5P", function(module, exports) {

$parcel$export(module.exports, "headingAnchorLinkMessages", () => $bb2bb569629ca076$export$74bada844422036d);
$parcel$export(module.exports, "tableCellMessages", () => $bb2bb569629ca076$export$c79ebc36348824d1);
$parcel$export(module.exports, "inlineCommentMessages", () => $bb2bb569629ca076$export$9f52c375a6ef34fc);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $7VHMR = parcelRequire("7VHMR");
const $bb2bb569629ca076$export$74bada844422036d = (0, $7VHMR.defineMessages)({
    copyHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copyAnchorLink',
        defaultMessage: 'Copy link to heading',
        description: 'Copy heading link to clipboard'
    },
    copiedHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copied',
        defaultMessage: 'Copied!',
        description: 'Copied heading link to clipboard'
    },
    failedToCopyHeadingLink: {
        id: 'fabric.editor.headingLink.failedToCopy',
        defaultMessage: 'Copy failed',
        description: 'failed to copy heading link to clipboard'
    },
    copyAriaLabel: {
        id: 'fabric.editor.headingLink.copyAriaLabel',
        defaultMessage: 'Copy',
        description: 'copy aria label for link icon'
    }
});
const $bb2bb569629ca076$export$c79ebc36348824d1 = (0, $7VHMR.defineMessages)({
    noneSortingLabel: {
        id: 'fabric.editor.headingLink.noneSortingLabel',
        defaultMessage: 'none',
        description: 'this table column is not sorted'
    },
    ascSortingLabel: {
        id: 'fabric.editor.headingLink.ascSortingLabel',
        defaultMessage: 'ascending',
        description: 'this table column is sorted in ascending order'
    },
    descSortingLabel: {
        id: 'fabric.editor.headingLink.descSortingLabel',
        defaultMessage: 'descending',
        description: 'this table column is sorted in descending order'
    }
});
const $bb2bb569629ca076$export$9f52c375a6ef34fc = (0, $7VHMR.defineMessages)({
    contentRendererInlineCommentMarkerStart: {
        id: 'fabric.editor.inlineComment.marker.start',
        defaultMessage: 'inline comment start',
        description: 'Starting marker to indicate that text is highlighted with an inline comment by a screen reader.'
    },
    contentRendererInlineCommentMarkerEnd: {
        id: 'fabric.editor.inlineComment.marker.end',
        defaultMessage: 'inline comment end',
        description: 'Ending marker to indicate that text was highlighted with an inline comment by a screen reader.'
    }
});

});


parcelRegister("jSk6P", function(module, exports) {

$parcel$export(module.exports, "copyTextToClipboard", () => $2ff51d830678d63e$export$f980440e1ab4537d);
const $2ff51d830678d63e$export$f980440e1ab4537d = (text)=>new Promise((resolve, reject)=>{
        const isApiSupported = !!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
        if (isApiSupported) navigator.clipboard.writeText(text).then(()=>resolve(), (e)=>reject(e));
        else reject('Clipboard API is not supported');
    });

});


parcelRegister("112O7", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4bc2ade6d275922$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fAZXL = parcelRequire("fAZXL");
const $a4bc2ade6d275922$var$InlineExtension = (props)=>{
    const { text: text } = props;
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fAZXL.default), {
        ...props,
        type: "inlineExtension"
    }, ({ result: result })=>{
        try {
            // Return the result directly if it's a valid JSX.Element
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(result)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, result);
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, text || 'inlineExtension');
    }));
};
var $a4bc2ade6d275922$export$2e2bcd8739ae039 = $a4bc2ade6d275922$var$InlineExtension;

});

parcelRegister("ieJGA", function(module, exports) {

$parcel$export(module.exports, "default", () => $57fd1bc0570bfa35$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gmhCD = parcelRequire("gmhCD");
function $57fd1bc0570bfa35$export$2e2bcd8739ae039(props) {
    return (0, $gmhCD.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: "layout-section-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-layout-section": true,
        "data-layout-columns": props?.content?.length
    }, props.children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-layout-section": true
    }, props.children);
}

});

parcelRegister("3RqVz", function(module, exports) {

$parcel$export(module.exports, "default", () => $93f45378df34617d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $iEGtv = parcelRequire("iEGtv");
var $4ceoy = parcelRequire("4ceoy");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $93f45378df34617d$var$layoutColumnClearMarginTopStyles = /*#__PURE__*/ (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $iEGtv.clearNextSiblingMarginTopStyle), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $iEGtv.clearNextSiblingBlockMarkMarginTopStyle));
function $93f45378df34617d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-layout-column": true,
        "data-column-width": props.width,
        style: {
            flexBasis: `${props.width}%`
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthProvider), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $93f45378df34617d$var$layoutColumnClearMarginTopStyles
    }), props.children));
}

});
parcelRegister("iEGtv", function(module, exports) {

$parcel$export(module.exports, "clearNextSiblingMarginTopStyle", () => $1f25160b5efdbc99$export$b15ec88fc1f2e843);
$parcel$export(module.exports, "clearNextSiblingBlockMarkMarginTopStyle", () => $1f25160b5efdbc99$export$eb3aaa9338936d44);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $1f25160b5efdbc99$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1f25160b5efdbc99$export$b15ec88fc1f2e843 = {
    name: "1f3w791",
    styles: "& + *{margin-top:0 !important;}"
};
const $1f25160b5efdbc99$var$textElements = [
    'p',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6'
];
const $1f25160b5efdbc99$var$nextSiblingBlockMarkContentSelectors = $1f25160b5efdbc99$var$textElements.map((elem)=>`+ .fabric-editor-block-mark > ${elem}`).join(',');
const $1f25160b5efdbc99$export$eb3aaa9338936d44 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`${$1f25160b5efdbc99$var$nextSiblingBlockMarkContentSelectors}`]: {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: '0 !important'
    }
});

});


parcelRegister("qjsNK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccd334ef870d278c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $ccd334ef870d278c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, props.children);
}

});

parcelRegister("jHa9U", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fce9f67e250185e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8hSwr = parcelRequire("8hSwr");
const $4fce9f67e250185e$var$RenderCaption = ({ children: children, dataAttributes: dataAttributes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8hSwr.default), {
        hasContent: true,
        dataAttributes: dataAttributes
    }, children);
};
var $4fce9f67e250185e$export$2e2bcd8739ae039 = $4fce9f67e250185e$var$RenderCaption;

});
parcelRegister("8hSwr", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bb2c70aa755b661$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $2AEnW = parcelRequire("2AEnW");
function $5bb2c70aa755b661$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5bb2c70aa755b661$var$captionWrapperStyle = {
    name: "1f0iwez",
    styles: "margin-top:var(--ds-space-100, 8px);text-align:center;position:relative;color:var(--ds-text-subtle, #44546F)"
};
const $5bb2c70aa755b661$var$placeholderStyle = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    position: 'absolute',
    top: 'space.0',
    width: '100%'
});
class $5bb2c70aa755b661$export$f7feb87190a94c76 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { selected: selected, hasContent: hasContent, children: children, dataAttributes: dataAttributes, intl: { formatMessage: formatMessage } } = this.props;
        const showPlaceholder = !selected && !hasContent;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            "data-media-caption": true,
            "data-testid": "media-caption",
            ...dataAttributes,
            css: $5bb2c70aa755b661$var$captionWrapperStyle
        }, showPlaceholder ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
            xcss: $5bb2c70aa755b661$var$placeholderStyle
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cgL5K.default), null, formatMessage((0, $2AEnW.messages).placeholder))) : null, children);
    }
}
var $5bb2c70aa755b661$export$2e2bcd8739ae039 = (0, $8RXs9.default)($5bb2c70aa755b661$export$f7feb87190a94c76);

});
parcelRegister("2AEnW", function(module, exports) {

$parcel$export(module.exports, "messages", () => $aa314c48a072d691$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $aa314c48a072d691$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    placeholder: {
        id: 'fabric.editor.captionPlaceholder',
        defaultMessage: 'Add a caption',
        description: 'Placeholder description for an empty (new) caption in the editor'
    }
});

});



parcelRegister("6svWT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6654d29b704d772$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dwptW = parcelRequire("dwptW");

var $jlYLw = parcelRequire("jlYLw");

var $uTDrM = parcelRequire("uTDrM");

var $503mU = parcelRequire("503mU");
function $e6654d29b704d772$export$2e2bcd8739ae039(props) {
    const extraProps = {};
    const itemCounterDigitsSize = (0, $uTDrM.getItemCounterDigitsSize)({
        order: props.order,
        itemsCount: props?.content?.length
    });
    if (itemCounterDigitsSize && itemCounterDigitsSize > 2) extraProps.style = (0, $jlYLw.getOrderedListInlineStyles)(itemCounterDigitsSize, 'object');
    if (props.order !== undefined) extraProps.start = (0, $uTDrM.resolveOrder)(props.order);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ol", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $dwptW.orderedListSelector).substr(1),
        "data-indent-level": props.path ? (0, $503mU.getListIndentLevel)(props.path) : 1,
        start: props.start,
        ...extraProps
    }, props.children);
}

});
parcelRegister("jlYLw", function(module, exports) {

$parcel$export(module.exports, "listItemCounterPadding", () => $6a64108c33d9274c$export$bafd6beec0797f87);
$parcel$export(module.exports, "getOrderedListInlineStyles", () => $6a64108c33d9274c$export$6d31fdb1d74cee3e);
$parcel$export(module.exports, "listsSharedStyles", () => $6a64108c33d9274c$export$ea95db02cc29c78f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $kjhhp = parcelRequire("kjhhp");
var $dwptW = parcelRequire("dwptW");

var $gE8f9 = parcelRequire("gE8f9");
const $6a64108c33d9274c$export$bafd6beec0797f87 = 24;
var $6a64108c33d9274c$var$CSS_VAR_NAMES = /*#__PURE__*/ function(CSS_VAR_NAMES) {
    CSS_VAR_NAMES["ITEM_COUNTER_PADDING"] = "--ed--list--item-counter--padding";
    return CSS_VAR_NAMES;
}($6a64108c33d9274c$var$CSS_VAR_NAMES || {});
const $6a64108c33d9274c$var$getItemCounterLeftPadding = (itemCounterDigitsSize)=>{
    // Previous padding-left was approximately 24px. We approximate that
    // same value using "ch" units (which represent the width of a "0" digit
    // character). We use "ch" so that this computed padding can now grow if
    //  the font-size ever enlarges.
    let paddingLeft = `2.385ch`;
    if (itemCounterDigitsSize >= 3) {
        // When there are 3 or more digits, we use a combination of "ch" units and
        // pixel values so that while the computed padding grows if font-size ever
        // enlarges, it doesn't over-scale with each digit (because of the fixed pixel
        // portion of the computed value). This way, very large item counters will not
        // become overly left-padded.
        const fixedBasePx = 2;
        paddingLeft = `calc(${itemCounterDigitsSize + 1}ch - ${fixedBasePx}px)`;
    }
    return paddingLeft;
};
const $6a64108c33d9274c$var$stringifyStyle = (style)=>Object.entries(style).reduce((str, [key, value])=>`${str}${key}:${value};`, ``);
function $6a64108c33d9274c$export$6d31fdb1d74cee3e(itemCounterDigitsSize, styleFormat) {
    const style = {
        ["--ed--list--item-counter--padding"]: $6a64108c33d9274c$var$getItemCounterLeftPadding(itemCounterDigitsSize)
    };
    if (styleFormat === 'string') return $6a64108c33d9274c$var$stringifyStyle(style);
    return style;
}
const $6a64108c33d9274c$export$ea95db02cc29c78f = /*#__PURE__*/ (0, $f8Sb3.css)("ul,ol{box-sizing:border-box;padding-left:var(", "--ed--list--item-counter--padding", ", ", $6a64108c33d9274c$export$bafd6beec0797f87, "px);li p:empty,li p>span:empty{", (0, $gE8f9.browser).gecko ? 'display: inline-block;' : '', ";}}", (0, $dwptW.orderedListSelector), ",", (0, $kjhhp.bulletListSelector), "{/*\n      Ensures list item content adheres to the list's margin instead\n      of filling the entire block row. This is important to allow\n      clicking interactive elements which are floated next to a list.\n\n      For some history and context on this block, see PRs related to tickets.:\n      @see ED-6551 - original issue.\n      @see ED-7015 - follow up issue.\n      @see ED-7447 - flow-root change.\n\n      We use 'display: table' (old clear fix / new block formatting context hack)\n      for older browsers and 'flow-root' for modern browsers.\n\n      @see https://css-tricks.com/display-flow-root/\n    */display:table;display:flow-root;}ul,ul ul ul ul{list-style-type:disc;}ul ul,ul ul ul ul ul{list-style-type:circle;}ul ul ul,ul ul ul ul ul ul{list-style-type:square;}ol,ol ol ol ol{list-style-type:decimal;}ol ol,ol ol ol ol ol{list-style-type:lower-alpha;}ol ol ol,ol ol ol ol ol ol{list-style-type:lower-roman;}ol[data-indent-level='1'],ol[data-indent-level='4']{list-style-type:decimal;}ol[data-indent-level='2'],ol[data-indent-level='5']{list-style-type:lower-alpha;}ol[data-indent-level='3'],ol[data-indent-level='6']{list-style-type:lower-roman;}ul[data-indent-level='1'],ul[data-indent-level='4']{list-style-type:disc;}ul[data-indent-level='2'],ul[data-indent-level='5']{list-style-type:circle;}ul[data-indent-level='3'],ul[data-indent-level='6']{list-style-type:square;}");

});

parcelRegister("uTDrM", function(module, exports) {

$parcel$export(module.exports, "resolveOrder", () => $ebe278356715a8a4$export$d445360e2a3c026b);
$parcel$export(module.exports, "getOrderFromOrderedListNode", () => $ebe278356715a8a4$export$cbefb5b89ef0719f);
$parcel$export(module.exports, "getItemCounterDigitsSize", () => $ebe278356715a8a4$export$320582fc14ba1e0f);
$parcel$export(module.exports, "isListNode", () => $ebe278356715a8a4$export$a7d7d2b9ba4d4dbb);
$parcel$export(module.exports, "isParagraphNode", () => $ebe278356715a8a4$export$35f600abfe6f0127);
$parcel$export(module.exports, "isListItemNode", () => $ebe278356715a8a4$export$2ddb0a75547407f6);
$parcel$export(module.exports, "isBulletList", () => $ebe278356715a8a4$export$35b2f400604e700);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/prosemirror-transformer/utils/list.ts
// If changes are made to this file, please make the same update in the linked file.
const $ebe278356715a8a4$export$8ef94ae42a3729bd = 1;
const $ebe278356715a8a4$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $ebe278356715a8a4$export$cbefb5b89ef0719f = (orderedListNode)=>{
    const order = orderedListNode?.attrs?.order;
    return $ebe278356715a8a4$export$d445360e2a3c026b(order) ?? $ebe278356715a8a4$export$8ef94ae42a3729bd;
};
const $ebe278356715a8a4$export$320582fc14ba1e0f = (options)=>{
    const order = $ebe278356715a8a4$export$d445360e2a3c026b(options.order) ?? $ebe278356715a8a4$export$8ef94ae42a3729bd;
    const itemsCount = typeof options.itemsCount === 'number' ? options.itemsCount : 0;
    const largestCounter = order + (itemsCount - 1);
    return String(largestCounter)?.split('.')?.[0]?.length;
};
function $ebe278356715a8a4$export$a7d7d2b9ba4d4dbb(node) {
    return Boolean(node && node.type && [
        'orderedList',
        'bulletList'
    ].includes(node.type.name));
}
function $ebe278356715a8a4$export$35f600abfe6f0127(node) {
    return Boolean(node && node.type && 'paragraph' === node.type.name);
}
function $ebe278356715a8a4$export$2ddb0a75547407f6(node) {
    return Boolean(node && node.type && 'listItem' === node.type.name);
}
function $ebe278356715a8a4$export$35b2f400604e700(node) {
    return Boolean(node && node.type && 'bulletList' === node.type.name);
}

});


parcelRegister("9FXQX", function(module, exports) {

$parcel$export(module.exports, "default", () => $26d2961aa3d14cef$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $EGPjg = parcelRequire("EGPjg");
function $26d2961aa3d14cef$export$2e2bcd8739ae039({ children: children, dataAttributes: dataAttributes }) {
    return(// ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", dataAttributes, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $EGPjg.default), null, children)));
}

});
parcelRegister("EGPjg", function(module, exports) {

$parcel$export(module.exports, "default", () => $372a7010ecff9ba7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $372a7010ecff9ba7$export$2e2bcd8739ae039(props) {
    const { children: children } = props;
    const childCount = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children).length;
    if (!childCount) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, "\xa0");
    return children;
}

});


parcelRegister("hqBb9", function(module, exports) {

$parcel$export(module.exports, "default", () => $add04eab04996fda$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $add04eab04996fda$export$2e2bcd8739ae039(props) {
    if (props.allowPlaceholderText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-placeholder": `${props.text}`
    }, props.text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null);
}

});

parcelRegister("ixoQV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1bb5022786e53a6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $e1bb5022786e53a6$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("hr", {
        role: "presentation"
    });
}

});

parcelRegister("dkc63", function(module, exports) {

$parcel$export(module.exports, "isTableResizingEnabled", () => $7478efdfea2a60bf$export$eec82c0a93aa66d9);
$parcel$export(module.exports, "isStickyScrollbarEnabled", () => $7478efdfea2a60bf$export$bdb2dadcb04aad50);
$parcel$export(module.exports, "default", () => $7478efdfea2a60bf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6gEe5 = parcelRequire("6gEe5");

var $ajc8Z = parcelRequire("ajc8Z");
var $4ceoy = parcelRequire("4ceoy");

var $VSDnB = parcelRequire("VSDnB");

var $5vnE9 = parcelRequire("5vnE9");
var $5or39 = parcelRequire("5or39");
var $5J0oM = parcelRequire("5J0oM");

var $9BYlQ = parcelRequire("9BYlQ");

var $iHYdz = parcelRequire("iHYdz");

var $fKLIs = parcelRequire("fKLIs");

var $gmhCD = parcelRequire("gmhCD");

var $OxITw = parcelRequire("OxITw");

var $cWojJ = parcelRequire("cWojJ");

var $4BsEy = parcelRequire("4BsEy");

var $2aXGN = parcelRequire("2aXGN");

var $a4mor = parcelRequire("a4mor");

var $kjIja = parcelRequire("kjIja");

var $eIscD = parcelRequire("eIscD");
const $7478efdfea2a60bf$export$eec82c0a93aa66d9 = (appearance)=>(0, $kjIja.isFullWidthOrFullPageAppearance)(appearance) || (0, $kjIja.isCommentAppearance)(appearance) && (0, $gmhCD.editorExperiment)('support_table_in_comment', true, {
        exposure: true
    });
const $7478efdfea2a60bf$export$bdb2dadcb04aad50 = (appearance)=>(0, $kjIja.isFullWidthOrFullPageAppearance)(appearance) && (0, $gmhCD.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
const $7478efdfea2a60bf$var$orderChildren = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $9BYlQ.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $5J0oM.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $5or39.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $7478efdfea2a60bf$var$hasRowspan = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $7478efdfea2a60bf$var$getRefTop = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $7478efdfea2a60bf$var$shouldHeaderStick = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $7478efdfea2a60bf$var$shouldHeaderPinBottom = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $7478efdfea2a60bf$var$addSortableColumn = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $7478efdfea2a60bf$var$isHeaderRowEnabled = (rows)=>{
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $cWojJ.TableHeader);
    return children.every((node)=>node.type === (0, $cWojJ.TableHeader));
};
const $7478efdfea2a60bf$var$tableCanBeSticky = (node, children)=>{
    return $7478efdfea2a60bf$var$isHeaderRowEnabled(children) && node && node.firstChild && !$7478efdfea2a60bf$var$hasRowspan(node.firstChild);
};
class $7478efdfea2a60bf$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            this.overflowParent = (0, $2aXGN.OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
        if (this.wrapperRef.current && $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $eIscD.TableStickyScrollbar)(this.wrapperRef.current);
    }
    componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) this.overflowParent = (0, $2aXGN.OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
        else if (!this.props.stickyHeaders && this.overflowParent) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
    }
    get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $6gEe5.tableMarginTop) - (0, $2aXGN.tableStickyPadding);
    }
    get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
        // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
        // AND the StickyHeaderConfig specifies a default scroll root id
        // AND the OverflowParent is the corresponding element
        // THEN we should add the OverflowParent offset top (RETURN TRUE)
        return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
    }
    get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                    const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                    return offsetTop + overflowParentOffsetTop;
                } else return offsetTop;
            default:
                return undefined;
        }
    }
    render() {
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, renderWidth: renderWidth, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $iHYdz.akEditorDefaultLayoutWidth);
        let left;
        let updatedLayout;
        // The tableWidth and left offset logic below must stay aligned with the `breakout-ssr.tsx` logic
        // Please consider changes below carefully to not negatively impact SSR
        // `renderWidth` cannot be depended on during SSR
        const isRenderWidthValid = !!renderWidth && renderWidth > 0;
        const renderWidthCSS = rendererAppearance === 'full-page' ? `100cqw - ${0, $OxITw.FullPagePadding}px * 2` : `100cqw`;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'full-width' && !tableNode?.attrs.width) return [
                isRenderWidthValid ? Math.min((0, $iHYdz.akEditorFullWidthLayoutWidth), renderWidth) : (0, $iHYdz.akEditorFullWidthLayoutWidth),
                `min(${(0, $iHYdz.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`
            ];
            else if (rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width) {
                const tableContainerWidth = (0, $fKLIs.getTableContainerWidth)(tableNode);
                return [
                    isRenderWidthValid ? renderWidth : tableContainerWidth,
                    renderWidthCSS
                ];
            } else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $fKLIs.getTableContainerWidth)(tableNode);
                return [
                    isRenderWidthValid ? Math.min(tableContainerWidth, renderWidth) : tableContainerWidth,
                    `min(${tableContainerWidth}px, ${renderWidthCSS})`
                ];
            }
        };
        const [tableWidth, tableWidthCSS] = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
        const fullWidthLineLength = isRenderWidthValid ? Math.min((0, $iHYdz.akEditorFullWidthLayoutWidth), renderWidth) : (0, $iHYdz.akEditorFullWidthLayoutWidth);
        const fullWidthLineLengthCSS = `min(${(0, $iHYdz.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const commentLineLength = isRenderWidthValid ? renderWidth : lineLengthFixedWidth;
        const isCommentAppearanceAndTableAlignmentEnabled = (0, $kjIja.isCommentAppearance)(rendererAppearance) && allowTableAlignment;
        const lineLength = (0, $kjIja.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLength : isCommentAppearanceAndTableAlignmentEnabled ? commentLineLength : lineLengthFixedWidth;
        const lineLengthCSS = (0, $kjIja.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
        const fixTableSSRResizing = (0, $VSDnB.fg)('platform-fix-table-ssr-resizing');
        const tableWidthNew = fixTableSSRResizing ? (0, $fKLIs.getTableContainerWidth)(tableNode) : tableWidth;
        const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $kjIja.isFullPageAppearance)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $kjIja.isFullWidthAppearance)(rendererAppearance) || isCommentAppearanceAndTableAlignmentEnabled);
        let leftCSS;
        if (shouldCalculateLeftForAlignment) {
            left = (tableWidth - lineLength) / 2;
            leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
        }
        if (fixTableSSRResizing) {
            if (!shouldCalculateLeftForAlignment && (0, $kjIja.isFullPageAppearance)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
            // When the screen is super wide we want table to break out.
            // However if screen is smaller than 760px. We want table align to left.
            leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
        } else if (!shouldCalculateLeftForAlignment && (0, $kjIja.isFullPageAppearance)(rendererAppearance) && tableWidthNew > lineLengthFixedWidth) left = lineLengthFixedWidth / 2 - tableWidth / 2;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !tableNode?.attrs.width && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode?.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
        // We can only use CSS to determine the width when we have a known width in container.
        // When appearance is full-page, full-width or comment we use CSS based width calculation.
        // Otherwise it's fixed table width (customized width) or inherit.
        if ((rendererAppearance === 'full-page' || rendererAppearance === 'full-width') && fixTableSSRResizing) finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
        // it is most likely a table created before "Support Table in Comments" FF was enabled
        // and we would see a bug ED-24795. A table created before "Support Table in Comments",
        // should inhirit the width of the renderer container.
        // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
        // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
        finalTableContainerWidth = tableNode?.attrs.width && tableNode?.attrs.width !== (0, $iHYdz.akEditorDefaultLayoutWidth) ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
        // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
        // instead of 760 that was set on tableNode when the table had been published.
        finalTableContainerWidth = (tableNode?.attrs.layout === 'align-start' || tableNode?.attrs.layout === 'center') && tableNode?.attrs.width ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
        let style;
        if (fixTableSSRResizing) style = {
            width: finalTableContainerWidth,
            left: leftCSS ? `calc(${leftCSS})` : undefined,
            marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
        };
        else style = {
            width: finalTableContainerWidth,
            left: left,
            marginLeft: shouldCalculateLeftForAlignment && left !== undefined ? -left : undefined
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
            "data-layout": updatedLayout,
            ref: this.props.handleRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style
        }, $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
            "data-testid": "sticky-scrollbar-sentinel-top"
        }), stickyHeaders && $7478efdfea2a60bf$var$tableCanBeSticky(tableNode, children) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2aXGN.StickyTable), {
            isNumberColumnEnabled: isNumberColumnEnabled,
            tableWidth: tableWidth,
            layout: layout,
            renderWidth: renderWidth,
            handleRef: this.props.handleRef,
            shadowClassNames: this.props.shadowClassNames,
            top: this.stickyTop,
            mode: stickyMode,
            innerRef: this.stickyWrapperRef,
            wrapperWidth: this.state.wrapperWidth,
            columnWidths: columnWidths,
            rowHeight: this.state.headerRowHeight,
            tableNode: tableNode,
            rendererAppearance: rendererAppearance,
            allowTableResizing: allowTableResizing
        }, [
            children && children[0]
        ]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER,
            ref: this.wrapperRef,
            onScroll: this.props.stickyHeaders && this.onWrapperScrolled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a4mor.Table), {
            innerRef: this.tableRef,
            columnWidths: columnWidths,
            layout: layout,
            isNumberColumnEnabled: isNumberColumnEnabled,
            renderWidth: renderWidth,
            tableNode: tableNode,
            rendererAppearance: rendererAppearance,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfTable: isInsideOfTable,
            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
            allowTableResizing: allowTableResizing
        }, this.grabFirstRowRef(children))), $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER,
            ref: this.stickyScrollbarRef,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: "var(--ds-space-250, 20px)",
                // MAX_BROWSER_SCROLLBAR_HEIGHT
                // Follow editor to hide by default so it does not show empty gap in SSR
                // https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: fixTableSSRResizing ? 'none' : 'block',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                width: '100%'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                width: this.tableRef.current?.clientWidth,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: '100%'
            }
        })), $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
            "data-testid": "sticky-scrollbar-sentinel-bottom"
        })));
    }
    constructor(...args){
        super(...args), this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        }, this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.stickyScrollbarRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.overflowParent = null, this.resizeObserver = null, this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        }, this.componentWillUnmount = ()=>{
            if (this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        }, this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        }, this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $2aXGN.tableStickyPadding);
            const tableTop = $7478efdfea2a60bf$var$getRefTop(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $7478efdfea2a60bf$var$shouldHeaderStick(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $7478efdfea2a60bf$var$shouldHeaderPinBottom(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        }, this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        }, this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        }, this.grabFirstRowRef = (children)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
class $7478efdfea2a60bf$export$91e0997fd3f75d56 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { children: children } = this.props;
        if (!children) return null;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children);
        const orderedChildren = (0, $5vnE9.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7478efdfea2a60bf$export$f2c3aea42b2a048f, this.props, orderedChildren);
    }
    constructor(...args){
        super(...args), this.state = {
            tableOrderStatus: undefined
        }, // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $7478efdfea2a60bf$var$isHeaderRowEnabled(childrenArray) && tableNode && !(0, $5or39.hasMergedCell)(tableNode)) return $7478efdfea2a60bf$var$addSortableColumn($7478efdfea2a60bf$var$orderChildren(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        }, this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $7478efdfea2a60bf$var$isHeaderRowEnabled(rows);
            return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                });
            });
        };
    }
}
const $7478efdfea2a60bf$var$TableWithShadows = (0, $ajc8Z.default)($7478efdfea2a60bf$export$91e0997fd3f75d56, {
    overflowSelector: `.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
const $7478efdfea2a60bf$var$TableWithWidth = (props)=>{
    // Remember, `width` will be 0 during SSR
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4ceoy.WidthConsumer), null, ({ width: width })=>{
        const renderWidth = props.rendererAppearance === 'full-page' ? width - (0, $OxITw.FullPagePadding) * 2 : width;
        const colWidthsSum = props.columnWidths?.reduce((total, val)=>total + val, 0) || 0;
        if (colWidthsSum || props.allowTableResizing) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7478efdfea2a60bf$var$TableWithShadows, {
            renderWidth: renderWidth,
            ...props
        });
        // there should not be a case when colWidthsSum is 0 and table is in overflow state - so no need to render shadows in this case
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7478efdfea2a60bf$export$91e0997fd3f75d56, {
            renderWidth: renderWidth,
            ...props
        });
    });
};
var $7478efdfea2a60bf$export$2e2bcd8739ae039 = (0, $4BsEy.withSmartCardStorage)($7478efdfea2a60bf$var$TableWithWidth);

});
parcelRegister("6gEe5", function(module, exports) {

$parcel$export(module.exports, "tableMarginTop", () => $356bd8bd1d42bb7c$export$808015ab1dd6897a);
$parcel$export(module.exports, "tableMarginTopWithControl", () => $356bd8bd1d42bb7c$export$910bf0d22c3d10f2);
$parcel$export(module.exports, "tableMarginSides", () => $356bd8bd1d42bb7c$export$a43e30915fab3ccf);
$parcel$export(module.exports, "tableCellMinWidth", () => $356bd8bd1d42bb7c$export$531f77930bf508de);
$parcel$export(module.exports, "tableNewColumnMinWidth", () => $356bd8bd1d42bb7c$export$c60fae4049791eae);
$parcel$export(module.exports, "tableCellBorderWidth", () => $356bd8bd1d42bb7c$export$72aad729077aa0fb);
$parcel$export(module.exports, "tableCellPadding", () => $356bd8bd1d42bb7c$export$e56b8ca552b280f6);
$parcel$export(module.exports, "TableSharedCssClassName", () => $356bd8bd1d42bb7c$export$c096bca5477eb7ad);
$parcel$export(module.exports, "tableSharedStyle", () => $356bd8bd1d42bb7c$export$c2bf8eea75aa9302);
$parcel$export(module.exports, "calcTableWidth", () => $356bd8bd1d42bb7c$export$d7ece4d8beb06815);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $9UDEr = parcelRequire("9UDEr");

var $iHYdz = parcelRequire("iHYdz");
var $eluMF = parcelRequire("eluMF");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $gE8f9 = parcelRequire("gE8f9");

var $cYeQP = parcelRequire("cYeQP");

var $hgR8Y = parcelRequire("hgR8Y");
function $356bd8bd1d42bb7c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $356bd8bd1d42bb7c$export$808015ab1dd6897a = 24;
const $356bd8bd1d42bb7c$export$afe1899c3eea9823 = 16;
const $356bd8bd1d42bb7c$export$910bf0d22c3d10f2 = 14;
const $356bd8bd1d42bb7c$export$a43e30915fab3ccf = 8;
const $356bd8bd1d42bb7c$export$531f77930bf508de = 48;
const $356bd8bd1d42bb7c$export$c60fae4049791eae = 140;
const $356bd8bd1d42bb7c$export$72aad729077aa0fb = 1;
const $356bd8bd1d42bb7c$export$e56b8ca552b280f6 = 8;
const $356bd8bd1d42bb7c$export$bba39e724bc39451 = 6;
const $356bd8bd1d42bb7c$export$c096bca5477eb7ad = {
    TABLE_CONTAINER: `${(0, $9UDEr.tablePrefixSelector)}-container`,
    TABLE_NODE_WRAPPER: `${(0, $9UDEr.tablePrefixSelector)}-wrapper`,
    TABLE_LEFT_SHADOW: `${(0, $9UDEr.tablePrefixSelector)}-with-left-shadow`,
    TABLE_RIGHT_SHADOW: `${(0, $9UDEr.tablePrefixSelector)}-with-right-shadow`,
    TABLE_STICKY_SHADOW: `${(0, $9UDEr.tablePrefixSelector)}-sticky-shadow`,
    TABLE_STICKY_WRAPPER: `${(0, $9UDEr.tablePrefixSelector)}-sticky-wrapper`,
    TABLE_STICKY_SCROLLBAR_CONTAINER: `${(0, $9UDEr.tablePrefixSelector)}-sticky-scrollbar-container`,
    TABLE_STICKY_SENTINEL_TOP: `${(0, $9UDEr.tablePrefixSelector)}-sticky-sentinel-top`,
    TABLE_STICKY_SENTINEL_BOTTOM: `${(0, $9UDEr.tablePrefixSelector)}-sticky-sentinel-bottom`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_TOP: `${(0, $9UDEr.tablePrefixSelector)}-sticky-scrollbar-sentinel-top`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM: `${(0, $9UDEr.tablePrefixSelector)}-sticky-scrollbar-sentinel-bottom`,
    TABLE_SHADOW_SENTINEL_LEFT: `${(0, $9UDEr.tablePrefixSelector)}-shadow-sentinel-left`,
    TABLE_SHADOW_SENTINEL_RIGHT: `${(0, $9UDEr.tablePrefixSelector)}-shadow-sentinel-right`,
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_NODEVIEW_CONTENT_DOM: (0, $9UDEr.tableCellContentDomSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_WRAPPER: (0, $9UDEr.tableCellSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_HEADER_CELL_WRAPPER: (0, $9UDEr.tableHeaderSelector),
    TABLE_ROW_CONTROLS_WRAPPER: `${(0, $9UDEr.tablePrefixSelector)}-row-controls-wrapper`,
    TABLE_COLUMN_CONTROLS_DECORATIONS: `${(0, $9UDEr.tablePrefixSelector)}-column-controls-decoration`,
    TABLE_RESIZER_CONTAINER: `${(0, $9UDEr.tablePrefixSelector)}-resizer-container`
};
/* first block node has 0 top margin */ var $356bd8bd1d42bb7c$var$_ref = {
    name: "qubt66",
    styles: ">:first-child:not(style),>style:first-child+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*,>style:first-child+.ProseMirror-gapcursor+span+*{margin-top:0;}"
};
var $356bd8bd1d42bb7c$var$_ref2 = {
    name: "1fct7qz",
    styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}"
};
const $356bd8bd1d42bb7c$var$firstNodeWithNotMarginTop = ()=>(0, $gmhCD.editorExperiment)('nested-dnd', true) ? $356bd8bd1d42bb7c$var$_ref2 : $356bd8bd1d42bb7c$var$_ref;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Appears safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing
const $356bd8bd1d42bb7c$export$c2bf8eea75aa9302 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)((0, $hgR8Y.tableCellBackgroundStyleOverride)(), " .", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, "{position:relative;margin:0 auto var(--ds-space-200, 16px);box-sizing:border-box;.decisionItemView-content-wrap:first-of-type>div{margin-top:0;}}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, $iHYdz.akEditorTableNumberColumnWidth) - 1, "px;clear:both;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, "{will-change:width,margin-left;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, " table{will-change:width;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table{margin:var(--ds-space-300, 24px) 0 0 0;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{margin:var(--ds-space-300, 24px) var(--ds-space-100, 8px) 0 0;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table,.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{border-collapse:collapse;border:", $356bd8bd1d42bb7c$export$72aad729077aa0fb, "px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`, ";table-layout:fixed;font-size:1em;width:100%;&[data-autosize='true']{table-layout:auto;}&{*{box-sizing:border-box;}hr{box-sizing:content-box;}tbody{border-bottom:none;}th td{background-color:var(--ds-background-neutral-subtle, white);}", (0, $VSDnB.fg)('platform_editor_renderer_table_header_styles') ? `> tbody > tr > th, > tbody > tr > td` : 'th, td', "{min-width:", $356bd8bd1d42bb7c$export$531f77930bf508de, "px;font-weight:var(--ds-font-weight-regular, 400);vertical-align:top;border:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`, ";border-right-width:0;border-bottom-width:0;padding:var(--ds-space-100, 8px);", (0, $gE8f9.browser).gecko || (0, $gE8f9.browser).ie || (0, $gE8f9.browser).mac && (0, $gE8f9.browser).chrome ? 'background-clip: padding-box;' : '', " ", $356bd8bd1d42bb7c$var$firstNodeWithNotMarginTop(), " th p:not(:first-of-type),td p:not(:first-of-type){margin-top:var(--ds-space-150, 12px);}}", (0, $VSDnB.fg)('platform_editor_nested_tables_renderer_styles') ? `// Ensures nested tables are compatible with parent table background color - uses specificity to ensure tables nested by extensions are not affected
			> tbody > tr > td {
				background-color: ${"var(--ds-surface, #FFFFFF)"};
			}` : '', " th{background-color:", `var(--ds-background-accent-gray-subtlest, ${(0, $iHYdz.akEditorTableToolbar)})`, ";text-align:left;&:not([style]):not(.danger){.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ":not(.danger){background-color:var(--ds-surface-raised, rgb(235, 237, 240));:not(.", (0, $iHYdz.akEditorSelectedNodeClassName), "){box-shadow:0px 0px 0px 1px var(--ds-border, transparent);}.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER, "{background-image:", (0, $eluMF.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-color:var(--ds-background-neutral, rgb(235, 237, 240));}.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, rgb(226, 229, 233));}>[data-ds--code--code-block]{background-image:", (0, $eluMF.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), "!important;background-color:var(--ds-background-neutral, rgb(235, 237, 240))!important;--ds--code--line-number-bg-color:var(--ds-background-neutral, rgb(226, 229, 233));}}}}}}");
const $356bd8bd1d42bb7c$export$d7ece4d8beb06815 = (layout, containerWidth, addControllerPadding = true)=>{
    switch(layout){
        case 'full-width':
            return containerWidth ? Math.min(containerWidth - (addControllerPadding ? (0, $iHYdz.akEditorBreakoutPadding) : 0), (0, $iHYdz.akEditorFullWidthLayoutWidth)) : (0, $iHYdz.akEditorFullWidthLayoutWidth);
        case 'wide':
            if (containerWidth) return Math.min(containerWidth - (addControllerPadding ? (0, $iHYdz.akEditorBreakoutPadding) : 0), (0, $iHYdz.akEditorWideLayoutWidth));
            return 0, $iHYdz.akEditorWideLayoutWidth;
        default:
            return 'inherit';
    }
};

});
parcelRegister("eluMF", function(module, exports) {

$parcel$export(module.exports, "overflowShadow", () => $b41fea6975363b1e$export$c5c1e4f4640336fb);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
const $b41fea6975363b1e$export$c5c1e4f4640336fb = ({ leftCoverWidth: leftCoverWidth, rightCoverWidth: rightCoverWidth })=>{
    const width = "var(--ds-space-100, 8px)";
    const leftCoverWidthResolved = leftCoverWidth || width;
    const rightCoverWidthResolved = rightCoverWidth || width;
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $f8Sb3.css)();
};

});

parcelRegister("cYeQP", function(module, exports) {

$parcel$export(module.exports, "CodeBlockSharedCssClassName", () => $dca73d3fed5e4b1b$export$42659c26f026f6ea);
$parcel$export(module.exports, "codeBlockSharedStyles", () => $dca73d3fed5e4b1b$export$a4fbe21dc6fae881);
$parcel$export(module.exports, "codeBlockInListSafariFix", () => $dca73d3fed5e4b1b$export$3aa5ee2f4c156533);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Should be safe to autofix, but ignoring for now */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
var $eluMF = parcelRequire("eluMF");
const $dca73d3fed5e4b1b$export$42659c26f026f6ea = {
    CODEBLOCK_CONTAINER: 'code-block',
    CODEBLOCK_START: 'code-block--start',
    CODEBLOCK_END: 'code-block--end',
    CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
    CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
    CODEBLOCK_CONTENT: 'code-content',
    DS_CODEBLOCK: '[data-ds--code--code-block]',
    CODEBLOCK_CONTENT_WRAPPED: 'code-content--wrapped',
    CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped'
};
const $dca73d3fed5e4b1b$export$a4fbe21dc6fae881 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPED, ">.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, ">.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{margin-right:var(--ds-space-100, 8px);code{display:block;word-break:break-word;white-space:pre-wrap;}}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, ">.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{display:flex;flex:1;code{flex-grow:1;white-space:pre;}}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTAINER, "{position:relative;background-color:var(--ds-surface-raised, #FFFFFF);border-radius:var(--ds-border-radius, 3px);margin:", (0, $iHYdz.blockNodesVerticalMargin), " 0 0 0;font-family:", (0, $iHYdz.akEditorCodeFontFamily), ";min-width:", (0, $iHYdz.akEditorTableCellMinWidth), "px;cursor:pointer;clear:both;--ds--code--bg-color:transparent;white-space:normal;.code-block-gutter-pseudo-element::before{content:attr(data-label);}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_START, "{position:absolute;visibility:hidden;height:1.5rem;top:0px;left:0px;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_END, "{position:absolute;visibility:hidden;height:1.5rem;bottom:0px;right:0px;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, "{position:relative;background-color:var(--ds-background-neutral, #091E420F);display:flex;border-radius:var(--ds-border-radius, 3px);width:100%;counter-reset:line;overflow-x:auto;background-image:", (0, $eluMF.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-repeat:no-repeat;background-attachment:local,local,local,local,scroll,scroll,scroll,scroll;background-size:var(--ds-space-300, 24px) 100%,var(--ds-space-300, 24px) 100%,var(--ds-space-100, 8px) 100%,var(--ds-space-100, 8px) 100%,var(--ds-space-100, 8px) 100%,1px 100%,var(--ds-space-100, 8px) 100%,1px 100%;background-position:0 0,0 0,100% 0,100% 0,100% 0,100% 0,0 0,0 0;overflow-y:hidden;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, #091E420F);position:relative;width:var(--lineNumberGutterWidth, 2rem);padding:var(--ds-space-100, 8px);flex-shrink:0;font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";box-sizing:content-box;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER, "::before{content:'1';visibility:hidden;font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";line-height:1.5rem;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{code{tab-size:4;cursor:text;color:var(--ds-text, #172B4D);border-radius:var(--ds-border-radius, 3px);margin:var(--ds-space-100, 8px);font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";line-height:1.5rem;}}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET, "{pointer-events:none;user-select:none;width:var(--lineNumberGutterWidth, 2rem);left:0;position:absolute;font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";padding:0px var(--ds-space-100, 8px);line-height:1.5rem;text-align:right;color:var(--ds-text-subtlest, #505F79);box-sizing:content-box;}}");
const $dca73d3fed5e4b1b$export$3aa5ee2f4c156533 = /*#__PURE__*/ (0, $f8Sb3.css)("::before{content:' ';line-height:", (0, $iHYdz.akEditorLineHeight), ";}>p:first-child,>.code-block:first-child,>.ProseMirror-gapcursor:first-child+.code-block{margin-top:-", (0, $iHYdz.akEditorLineHeight), "em!important;}");

});

parcelRegister("hgR8Y", function(module, exports) {

$parcel$export(module.exports, "tableCellBackgroundStyleOverride", () => $eaa2b3bf40c7fca9$export$677e93f0f5f9623a);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $9UDEr = parcelRequire("9UDEr");

var $hAs1r = parcelRequire("hAs1r");
// This is used in order to support usage of DS tokens. Table cell background-color
// is set inline in '@atlaskit/adf-schema' and the color value is stored in ADF so
// it is not possible to use tokens there without polluting ADF.
// As table cell backgrounds are set inline, this should not break mobile as
// hexToEditorBackgroundPaletteColor() outputs a css variable with fallback hex.
const $eaa2b3bf40c7fca9$var$mapBackgroundColors = ()=>{
    let cssString = '';
    (0, $9UDEr.tableBackgroundColorNames).forEach((value, key)=>{
        const paletteColorValue = (0, $hAs1r.hexToEditorBackgroundPaletteColor)(value);
        if (paletteColorValue) cssString += `
        td[colorname='${key}' i],
        th[colorname='${key}' i] {
          background-color: ${paletteColorValue} !important;
        }
      `;
    });
    return cssString;
};
const $eaa2b3bf40c7fca9$export$677e93f0f5f9623a = ()=>/*#__PURE__*/ (0, $f8Sb3.css)($eaa2b3bf40c7fca9$var$mapBackgroundColors());

});
parcelRegister("hAs1r", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBackgroundPaletteColor", () => $3966f91ec47ca318$export$5f6a44a42a4b38c2);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $3966f91ec47ca318$export$a270511a0e7fd61a);
// This import will be stripped on build

var $kTHGn = parcelRequire("kTHGn");
function $3966f91ec47ca318$export$5f6a44a42a4b38c2(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $3966f91ec47ca318$export$2462741d70e6a62f[hexColor.toUpperCase()];
    return tokenData ? tokenData.token : undefined;
}
function $3966f91ec47ca318$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $3966f91ec47ca318$export$2462741d70e6a62f[hexColor.toUpperCase()];
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $3966f91ec47ca318$export$2462741d70e6a62f = {
    // blue
    /** blue - light */ ['#DEEBFF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.blue.subtlest', fallback),
        token: "var(--ds-background-accent-blue-subtlest, #DEEBFF)"
    },
    // source for hex code was legacy token B50
    /** blue - medium */ ['#B3D4FF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.blue.subtler', fallback),
        token: "var(--ds-background-accent-blue-subtler, #B3D4FF)"
    },
    // source for hex code was legacy token B75
    /** blue - strong */ ['#4C9AFF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.blue.subtle', fallback),
        token: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
    },
    // source for hex code was legacy token B100
    // teal
    /** teal - light */ ['#E6FCFF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.teal.subtlest', fallback),
        token: "var(--ds-background-accent-teal-subtlest, #E6FCFF)" // source for hex code was legacy token T50,
    },
    /** teal - medium */ ['#B3F5FF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.teal.subtler', fallback),
        token: "var(--ds-background-accent-teal-subtler, #B3F5FF)" // source for hex code was legacy token T75,
    },
    /** teal - strong */ ['#79E2F2']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.teal.subtle', fallback),
        token: "var(--ds-background-accent-teal-subtle, #79E2F2)" // source for hex code was legacy token T100,
    },
    // green
    /** green - light */ ['#E3FCEF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.green.subtlest', fallback),
        token: "var(--ds-background-accent-green-subtlest, #E3FCEF)" // source for hex code was legacy token G50,
    },
    /** green - medium */ ['#ABF5D1']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.green.subtler', fallback),
        token: "var(--ds-background-accent-green-subtler, #ABF5D1)" // source for hex code was legacy token G75,
    },
    /** green - strong */ ['#57D9A3']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.green.subtle', fallback),
        token: "var(--ds-background-accent-green-subtle, #57D9A3)" // source for hex code was legacy token G200,
    },
    // yellowOrange
    /** yellowOrange - light */ ['#FFFAE6']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.yellow.subtlest', fallback),
        token: "var(--ds-background-accent-yellow-subtlest, #FFFAE6)" // source for hex code was legacy token Y50,
    },
    /** yellowOrange - medium */ ['#FFF0B3']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.yellow.subtler', fallback),
        token: "var(--ds-background-accent-yellow-subtler, #FFF0B3)" // source for hex code was legacy token Y75,
    },
    /** yellowOrange - strong */ ['#FFC400']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.orange.subtle', fallback),
        token: "var(--ds-background-accent-orange-subtle, #FFC400)" // source for hex code was legacy token Y200,
    },
    // red
    /** red - light */ ['#FFEBE6']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.red.subtlest', fallback),
        token: "var(--ds-background-accent-red-subtlest, #FFEBE6)" // source for hex code was legacy token R50,
    },
    /** red - medium */ ['#FFBDAD']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.red.subtler', fallback),
        token: "var(--ds-background-accent-red-subtler, #FFBDAD)" // source for hex code was legacy token R75,
    },
    /** red - strong */ ['#FF8F73']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.red.subtle', fallback),
        token: "var(--ds-background-accent-red-subtle, #FF8F73)" // source for hex code was legacy token R100,
    },
    // purple
    /** purple - light */ ['#EAE6FF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.purple.subtlest', fallback),
        token: "var(--ds-background-accent-purple-subtlest, #EAE6FF)" // source for hex code was legacy token P50,
    },
    /** purple - medium */ ['#C0B6F2']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.purple.subtler', fallback),
        token: "var(--ds-background-accent-purple-subtler, #C0B6F2)" // source for hex code was legacy token P75,
    },
    /** purple - strong */ ['#998DD9']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.purple.subtle', fallback),
        token: "var(--ds-background-accent-purple-subtle, #998DD9)" // source for hex code was legacy token P100,
    },
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('elevation.surface', fallback),
        token: "var(--ds-surface, #FFFFFF)" // source for hex code was legacy token N0,
    },
    /** whiteGray - medium */ ['#F4F5F7']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.gray.subtlest', fallback),
        token: "var(--ds-background-accent-gray-subtlest, #F4F5F7)" // source for hex code was legacy token N20,
    },
    /** whiteGray - strong */ ['#B3BAC5']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.gray.subtle', fallback),
        token: "var(--ds-background-accent-gray-subtle, #B3BAC5)" // source for hex code was legacy token N60,
    }
};

});



parcelRegister("5vnE9", function(module, exports) {

$parcel$export(module.exports, "compose", () => $8cb395a24b5942e2$export$f672e0b6f7222cd7);
/** Helper type for single arg function */ function $8cb395a24b5942e2$export$f672e0b6f7222cd7(func, ...funcs) {
    const allFuncs = [
        func,
        ...funcs
    ];
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function composed(raw) {
        return allFuncs.reduceRight((memo, func)=>func(memo), raw);
    };
}

});

parcelRegister("5or39", function(module, exports) {

$parcel$export(module.exports, "getColumnWidths", () => $a59f56ae192d20af$export$e54c9225ca52acc);
$parcel$export(module.exports, "calcTableColumnWidths", () => $a59f56ae192d20af$export$98951d3cdcfd364b);
$parcel$export(module.exports, "hasMergedCell", () => $a59f56ae192d20af$export$f9d610bfbb78949b);
$parcel$export(module.exports, "convertProsemirrorTableNodeToArrayOfRows", () => $a59f56ae192d20af$export$69fbfaf01f2fd534);
$parcel$export(module.exports, "isPositionNearTableRow", () => $a59f56ae192d20af$export$889a8e446452be16);

var $VSDnB = parcelRequire("VSDnB");
function $a59f56ae192d20af$export$e54c9225ca52acc(node) {
    let tableColumnWidths = [];
    node.forEach((row)=>{
        const currentTableWidth = [];
        row.forEach((cell)=>{
            const { colspan: colspan, colwidth: colwidth } = cell.attrs;
            // column has been resized, colWidth will be an array, can safely take values even if cell is merged
            if (Array.isArray(colwidth)) currentTableWidth.push(...colwidth);
            else if (colspan !== undefined && colspan > 1) currentTableWidth.push(...Array(colspan).fill(0));
            else currentTableWidth.push(0);
        });
        if (currentTableWidth.length > tableColumnWidths.length) tableColumnWidths = currentTableWidth;
    });
    return tableColumnWidths;
}
function $a59f56ae192d20af$export$98951d3cdcfd364b(node) {
    // TODO: replaced with getColumnWidths, which correctly scans entire table for column widths
    if ((0, $VSDnB.fg)('platform_editor_table_row_span_fix')) {
        const firstRow = node.firstChild;
        const tableColumnWidths = [];
        if (firstRow) firstRow.forEach((cell)=>{
            const { colspan: colspan, colwidth: colwidth } = cell.attrs;
            // column has been resized, colWidth will be an array, can safely take values even if cell is merged
            if (Array.isArray(colwidth)) tableColumnWidths.push(...colwidth);
            else if (colspan > 1) tableColumnWidths.push(...Array(colspan).fill(0));
            else tableColumnWidths.push(0);
        });
        return tableColumnWidths;
    }
    let tableColumnWidths = [];
    const firstRow = node.firstChild;
    if (firstRow) // Sanity validation, but it should always have a first row
    // Iterate for the cells in the first row
    firstRow.forEach((colNode)=>{
        const colwidth = colNode.attrs.colwidth || [
            0
        ];
        // If we have colwidth, we added it
        if (colwidth) tableColumnWidths = [
            ...tableColumnWidths,
            ...colwidth
        ];
    });
    return tableColumnWidths;
}
function $a59f56ae192d20af$export$f9d610bfbb78949b(tableNode) {
    let hasSpan = false;
    tableNode.descendants((node)=>{
        if (node.type.name === 'tableRow') return true;
        const { colspan: colspan, rowspan: rowspan } = node.attrs;
        if (colspan > 1 || rowspan > 1) hasSpan = true;
        return false;
    });
    return hasSpan;
}
function $a59f56ae192d20af$export$69fbfaf01f2fd534(tableNode) {
    const result = [];
    tableNode.forEach((rowNode)=>{
        if (rowNode.type.name === 'tableRow') {
            const row = [];
            rowNode.forEach((n)=>row.push(n));
            result.push(row);
        }
    });
    return result;
}
function $a59f56ae192d20af$export$889a8e446452be16(pos, schema, direction) {
    if (!schema.nodes.tableRow) return false;
    const doc = pos.doc;
    let resolved = pos;
    const sibling = direction === 'before' ? 'nodeBefore' : 'nodeAfter';
    while(resolved.depth > 0){
        const siblingType = resolved[sibling]?.type;
        if (siblingType === schema.nodes.tableRow) return true;
        resolved = doc.resolve(resolved[direction]());
    }
    return false;
}

});

parcelRegister("5J0oM", function(module, exports) {

$parcel$export(module.exports, "createCompareNodes", () => $c09b1d49576acabb$export$49215374a8bec29c);

var $9BYlQ = parcelRequire("9BYlQ");
var $c09b1d49576acabb$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType[ContentType["NUMBER"] = 0] = "NUMBER";
    ContentType[ContentType["TEXT"] = 5] = "TEXT";
    ContentType[ContentType["MENTION"] = 10] = "MENTION";
    ContentType[ContentType["DATE"] = 15] = "DATE";
    ContentType[ContentType["STATUS"] = 20] = "STATUS";
    ContentType[ContentType["LINK"] = 25] = "LINK";
    return ContentType;
}({});
function $c09b1d49576acabb$var$getLinkMark(node) {
    const [linkMark] = node.marks.filter((mark)=>mark.type.name === 'link');
    return linkMark || null;
}
function $c09b1d49576acabb$var$parseLocaleNumber(stringNumber, groupPattern, fractionPattern) {
    if (!stringNumber.trim().length) return null;
    const maybeANumber = Number.parseFloat(stringNumber.replace(groupPattern, '').replace(fractionPattern, '.'));
    if (Number.isNaN(maybeANumber)) return null;
    return maybeANumber;
}
function $c09b1d49576acabb$export$8ebf986086b1866f() {
    // Source: https://stackoverflow.com/questions/12004808/does-javascript-take-local-decimal-separators-into-account
    const locale = window.navigator.language;
    const thousandSeparator = Intl.NumberFormat(locale).format(11111).replace(/\p{Number}/gu, '');
    const decimalSeparator = Intl.NumberFormat(locale).format(1.1).replace(/\p{Number}/gu, '');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const numericPattern = new RegExp(`(\\d+(?:[${thousandSeparator}${decimalSeparator}]?\\d+)*)`, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const thousandSeparatorPattern = new RegExp('\\' + thousandSeparator, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const decimalSeparatorPattern = new RegExp('\\' + decimalSeparator);
    return (text)=>{
        if (!text.trim().length) return null;
        // This will break the text apart at the locations of the formatted numbers
        const result = text.split(numericPattern);
        // We then put the text back together but with all the formatted numbers converted back to plain numerals,
        // for example a sentence like "What is 1,000.01% of 10,000.01" would be normalized and sorted as
        // if it's saying "What is 1000.01% of 10000.01". This way the Intl.Collator can use the numeric setting to sort
        // numeral values within string correctly.
        const tokens = result.reduce((acc, stringNumber)=>{
            if (!stringNumber?.length) return acc;
            const maybeANumber = $c09b1d49576acabb$var$parseLocaleNumber(stringNumber, thousandSeparatorPattern, decimalSeparatorPattern);
            // NOTE: We know there can only be a single decimal separator. So we can assume that if the first found separator
            // is not at the same position as the last found one, then we can assume the locale used to format the number
            // is different to our locale. This will result in the value being treated as a string.
            if (maybeANumber !== null && stringNumber.indexOf(decimalSeparator) === stringNumber.lastIndexOf(decimalSeparator)) acc.push(maybeANumber);
            else acc.push(stringNumber);
            return acc;
        }, []);
        if (tokens.length === 1) return tokens[0];
        return tokens.join('');
    };
}
function $c09b1d49576acabb$export$7cc053f549ed70b8(textNode, normalizeTextParser) {
    // treat as a link if contain a link
    const linkMark = $c09b1d49576acabb$var$getLinkMark(textNode);
    if (linkMark) {
        const value = textNode.text || '';
        return {
            type: 25,
            value: value
        };
    }
    const text = textNode.text || '';
    const normalizedText = normalizeTextParser(text);
    if (typeof normalizedText === 'number') return {
        type: 0,
        value: normalizedText
    };
    return {
        type: 5,
        value: normalizedText ?? text
    };
}
function $c09b1d49576acabb$var$getMetaFromNode(node, options, normalizeTextParser) {
    if (!node) return null;
    const firstChild = node.firstChild;
    if (!firstChild) return null;
    switch(firstChild.type.name){
        // Text case
        /*
      Get Meta value from the first child if the cell is of type
        * Heading (Any cell where the text is set to a heading type)
        * Paragraph (Normal text)
     */ case 'heading':
        case 'paragraph':
            return $c09b1d49576acabb$var$getMetaFromNode(firstChild, options, normalizeTextParser);
        case 'inlineCard':
            {
                const attrs = firstChild.attrs;
                const maybeTitle = options.getInlineCardTextFromStore(attrs);
                if (maybeTitle) return {
                    type: 25,
                    value: maybeTitle
                };
                const url = attrs.url;
                return {
                    type: 25,
                    value: url ? url : ''
                };
            }
        case 'text':
            return $c09b1d49576acabb$export$7cc053f549ed70b8(firstChild, normalizeTextParser);
        case 'status':
            {
                const text = firstChild.attrs.text;
                return {
                    type: 20,
                    value: text
                };
            }
        case 'date':
            {
                const timestamp = Number.parseInt(firstChild.attrs.timestamp, 20);
                return {
                    type: 15,
                    value: timestamp
                };
            }
        case 'mention':
            {
                // TODO: Check what should be the fallback when mention does not have a text
                const text = firstChild.attrs.text || '';
                return {
                    type: 10,
                    value: text.toLowerCase()
                };
            }
        default:
            return null;
    }
}
function $c09b1d49576acabb$var$compareValue(valueA, valueB) {
    if (valueA === valueB) return 0;
    if (typeof valueA === 'string' && typeof valueB === 'string') return valueA.localeCompare(valueB, window.navigator.language, {
        caseFirst: 'upper',
        numeric: true
    });
    return valueA > valueB ? 1 : -1;
}
const $c09b1d49576acabb$export$49215374a8bec29c = (options, order = (0, $9BYlQ.SortOrder).ASC)=>{
    const normalizeTextParser = $c09b1d49576acabb$export$8ebf986086b1866f();
    return (nodeA, nodeB)=>{
        const metaNodeA = $c09b1d49576acabb$var$getMetaFromNode(nodeA, options, normalizeTextParser);
        const metaNodeB = $c09b1d49576acabb$var$getMetaFromNode(nodeB, options, normalizeTextParser);
        /*
      Donot switch the order (Asec or Desc) if either node is null.
      This will ensure that empty cells are always at the bottom during sorting.
    */ if (metaNodeA === null || metaNodeB === null) return $c09b1d49576acabb$var$compareMetaFromNode(metaNodeA, metaNodeB);
        return (order === (0, $9BYlQ.SortOrder).DESC ? -1 : 1) * $c09b1d49576acabb$var$compareMetaFromNode(metaNodeA, metaNodeB);
    };
};
function $c09b1d49576acabb$var$compareMetaFromNode(metaNodeA, metaNodeB) {
    if (metaNodeA === metaNodeB) return 0;
    if (metaNodeA === null || metaNodeB === null) return metaNodeB === null ? -1 : 1;
    if (metaNodeA.type !== metaNodeB.type) return metaNodeA.type > metaNodeB.type ? 1 : -1;
    return $c09b1d49576acabb$var$compareValue(metaNodeA.value, metaNodeB.value);
}

});
parcelRegister("9BYlQ", function(module, exports) {

$parcel$export(module.exports, "SortOrder", () => $42ab1316856d1585$export$7ae723045d45777a);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $dEtqo = parcelRequire("dEtqo");

var $kXC89 = parcelRequire("kXC89");
var $42ab1316856d1585$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    SortOrder["NO_ORDER"] = "no_order";
    return SortOrder;
}({});

});
parcelRegister("kXC89", function(module, exports) {

$parcel$export(module.exports, "ToolbarSize", () => $fa36a5395f686390$export$ed55211407a9423);
$parcel$export(module.exports, "ToolbarWidths", () => $fa36a5395f686390$export$423b5e8c92d477b9);
$parcel$export(module.exports, "ToolbarWidthsNext", () => $fa36a5395f686390$export$3f050002d3df641b);
$parcel$export(module.exports, "ToolbarWidthsFullPage", () => $fa36a5395f686390$export$63ca43752be70b90);
$parcel$export(module.exports, "ToolbarWidthsFullPageNext", () => $fa36a5395f686390$export$501a79d885598191);
var $fa36a5395f686390$export$ed55211407a9423 = /*#__PURE__*/ function(ToolbarSize) {
    ToolbarSize[ToolbarSize["XXL"] = 6] = "XXL";
    ToolbarSize[ToolbarSize["XL"] = 5] = "XL";
    ToolbarSize[ToolbarSize["L"] = 4] = "L";
    ToolbarSize[ToolbarSize["M"] = 3] = "M";
    ToolbarSize[ToolbarSize["S"] = 2] = "S";
    ToolbarSize[ToolbarSize["XXXS"] = 1] = "XXXS";
    return ToolbarSize;
}({});
var $fa36a5395f686390$export$423b5e8c92d477b9 = /*#__PURE__*/ function(ToolbarWidths) {
    ToolbarWidths[ToolbarWidths["XXL"] = 610] = "XXL";
    ToolbarWidths[ToolbarWidths["XL"] = 540] = "XL";
    ToolbarWidths[ToolbarWidths["L"] = 460] = "L";
    ToolbarWidths[ToolbarWidths["M"] = 450] = "M";
    ToolbarWidths[ToolbarWidths["S"] = 410] = "S";
    return ToolbarWidths;
}({});
var $fa36a5395f686390$export$3f050002d3df641b = /*#__PURE__*/ function(ToolbarWidthsNext) {
    ToolbarWidthsNext[ToolbarWidthsNext["XXL"] = 768] = "XXL";
    ToolbarWidthsNext[ToolbarWidthsNext["XL"] = 576] = "XL";
    ToolbarWidthsNext[ToolbarWidthsNext["L"] = 460] = "L";
    ToolbarWidthsNext[ToolbarWidthsNext["M"] = 450] = "M";
    ToolbarWidthsNext[ToolbarWidthsNext["S"] = 410] = "S";
    return ToolbarWidthsNext;
}({});
var $fa36a5395f686390$export$63ca43752be70b90 = /*#__PURE__*/ function(ToolbarWidthsFullPage) {
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XXL"] = 650] = "XXL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XL"] = 580] = "XL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["L"] = 540] = "L";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["M"] = 490] = "M";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["S"] = 410] = "S";
    return ToolbarWidthsFullPage;
}({});
var $fa36a5395f686390$export$501a79d885598191 = /*#__PURE__*/ function(ToolbarWidthsFullPageNext) {
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XXL"] = 1200] = "XXL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XL"] = 992] = "XL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["L"] = 768] = "L";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["M"] = 576] = "M";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["S"] = 410] = "S";
    return ToolbarWidthsFullPageNext;
}({});

});



parcelRegister("fKLIs", function(module, exports) {

$parcel$export(module.exports, "layoutToWidth", () => $78b5f00ff26d55fc$export$9b77d38feba5446);
$parcel$export(module.exports, "getParentNodeWidth", () => $78b5f00ff26d55fc$export$d76cc081ce1449a8);
$parcel$export(module.exports, "getTableContainerWidth", () => $78b5f00ff26d55fc$export$3930799be057b305);

var $9dTMW = parcelRequire("9dTMW");

var $iHYdz = parcelRequire("iHYdz");

var $bQr2R = parcelRequire("bQr2R");

var $ejmVg = parcelRequire("ejmVg");

var $eOOFp = parcelRequire("eOOFp");
const $78b5f00ff26d55fc$var$GRID_SIZE = 8;
const $78b5f00ff26d55fc$export$9b77d38feba5446 = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    default: (0, $iHYdz.akEditorDefaultLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    wide: (0, $iHYdz.akEditorWideLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    'full-width': (0, $iHYdz.akEditorFullWidthLayoutWidth)
};
const $78b5f00ff26d55fc$export$d76cc081ce1449a8 = (pos, state, containerWidth, isFullWidthModeEnabled)=>{
    if (!pos) return;
    const node = $78b5f00ff26d55fc$var$getNestedParentNode(pos, state);
    if (!node) return;
    let layout = node.attrs.layout || 'default';
    const { schema: schema } = state;
    const breakoutMark = schema.marks.breakout && schema.marks.breakout.isInSet(node.marks);
    if (breakoutMark && breakoutMark.attrs.mode) layout = breakoutMark.attrs.mode;
    let parentWidth = $78b5f00ff26d55fc$var$calcBreakoutNodeWidth(layout, containerWidth, isFullWidthModeEnabled);
    // TODO: ED-15663
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    const contextPanelPluginKey = {
        key: 'contextPanelPluginKey$',
        getState: (state)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return state['contextPanelPluginKey$'];
        }
    };
    if (node.type === schema.nodes.layoutSection) {
        parentWidth += (0, $iHYdz.akLayoutGutterOffset) * 2; // extra width that gets added to layout
        // Calculate width of parent layout column when
        // Parallel layout with viewport greater than 1024px
        // OR side panel of an extension is open and change the node width to smaller than containerWidth
        if (containerWidth.width > (0, $iHYdz.gridMediumMaxWidth) || contextPanelPluginKey.getState(state)?.contents.length > 0 && contextPanelPluginKey.getState(state)?.contents[0] !== undefined) {
            parentWidth -= ((0, $ejmVg.LAYOUT_SECTION_MARGIN) + 2) * (node.childCount - 1); // margin between sections
            const $pos = state.doc.resolve(pos);
            const column = (0, $9dTMW.findParentNodeOfTypeClosestToPos)($pos, [
                state.schema.nodes.layoutColumn
            ]);
            if (column && column.node && !isNaN(column.node.attrs.width)) // get exact width of parent layout column using node attrs
            parentWidth = Math.round(parentWidth * column.node.attrs.width * 0.01);
        }
    }
    // account for the padding of the parent node
    switch(node.type){
        case schema.nodes.layoutSection:
            parentWidth -= (0, $ejmVg.LAYOUT_COLUMN_PADDING) * 2;
            break;
        case schema.nodes.bodiedExtension:
            parentWidth -= (0, $bQr2R.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.extensionFrame:
            parentWidth -= (0, $bQr2R.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.expand:
            // padding
            parentWidth -= $78b5f00ff26d55fc$var$GRID_SIZE * 2;
            // gutter offset
            parentWidth += $78b5f00ff26d55fc$var$GRID_SIZE * 3;
            // padding right
            parentWidth -= $78b5f00ff26d55fc$var$GRID_SIZE;
            // padding left
            parentWidth -= $78b5f00ff26d55fc$var$GRID_SIZE * 4 - $78b5f00ff26d55fc$var$GRID_SIZE / 2;
            break;
    }
    parentWidth -= 2; // border
    return parentWidth;
};
const $78b5f00ff26d55fc$var$getNestedParentNode = (tablePos, state)=>{
    if (tablePos === undefined) return null;
    const $pos = state.doc.resolve(tablePos);
    const parent = (0, $9dTMW.findParentNodeOfTypeClosestToPos)($pos, [
        state.schema.nodes.bodiedExtension,
        state.schema.nodes.extensionFrame,
        state.schema.nodes.layoutSection,
        state.schema.nodes.expand
    ]);
    return parent ? parent.node : null;
};
const $78b5f00ff26d55fc$var$calcBreakoutNodeWidth = (layout, containerWidth, isFullWidthModeEnabled)=>{
    return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, (0, $iHYdz.akEditorFullWidthLayoutWidth)) : (0, $eOOFp.absoluteBreakoutWidth)(layout, containerWidth.width);
};
const $78b5f00ff26d55fc$export$3930799be057b305 = (node)=>{
    if (node?.attrs.width) return node.attrs.width;
    return $78b5f00ff26d55fc$export$9b77d38feba5446[node?.attrs.layout] || (0, $iHYdz.akEditorDefaultLayoutWidth);
};
const $78b5f00ff26d55fc$export$9724081a0d43786a = (node, offset)=>{
    const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
    if (isNumberColumnEnabled && offset > 0) return $78b5f00ff26d55fc$export$3930799be057b305(node) - offset;
    return $78b5f00ff26d55fc$export$3930799be057b305(node);
};

});
parcelRegister("9dTMW", function(module, exports) {

$parcel$export(module.exports, "removeParentNodeOfType", () => $6b709a593d983bd3$export$5dd18664fe8bcbde);
$parcel$export(module.exports, "findParentNodeOfType", () => $6b709a593d983bd3$export$1a3a74094b9968e);
$parcel$export(module.exports, "replaceParentNodeOfType", () => $6b709a593d983bd3$export$b72cc612b642c071);
$parcel$export(module.exports, "removeSelectedNode", () => $6b709a593d983bd3$export$7d6e4e6663186878);
$parcel$export(module.exports, "isNodeSelection", () => $6b709a593d983bd3$export$a8c1d2c13abf8822);
$parcel$export(module.exports, "replaceSelectedNode", () => $6b709a593d983bd3$export$39874bca494f9ba3);
$parcel$export(module.exports, "setTextSelection", () => $6b709a593d983bd3$export$1df6d14df6b0b758);
$parcel$export(module.exports, "safeInsert", () => $6b709a593d983bd3$export$5fe92db78385e37c);
$parcel$export(module.exports, "canInsert", () => $6b709a593d983bd3$export$b4d1262a40ad21d4);
$parcel$export(module.exports, "removeNodeBefore", () => $6b709a593d983bd3$export$ffb1550ab6c3d03c);
$parcel$export(module.exports, "findPositionOfNodeBefore", () => $6b709a593d983bd3$export$f8088819b1e2c2dc);
$parcel$export(module.exports, "findParentNode", () => $6b709a593d983bd3$export$dc159056ffdb4c76);
$parcel$export(module.exports, "findParentNodeClosestToPos", () => $6b709a593d983bd3$export$fe09644e3bc6166b);
$parcel$export(module.exports, "findDomRefAtPos", () => $6b709a593d983bd3$export$666ce65defe9ad6e);
$parcel$export(module.exports, "hasParentNode", () => $6b709a593d983bd3$export$178ecaf80f45fdb6);
$parcel$export(module.exports, "findParentNodeOfTypeClosestToPos", () => $6b709a593d983bd3$export$8bf0d019bde85d18);
$parcel$export(module.exports, "hasParentNodeOfType", () => $6b709a593d983bd3$export$14f438bb7227ce63);
$parcel$export(module.exports, "findParentDomRefOfType", () => $6b709a593d983bd3$export$faeafc1151740116);
$parcel$export(module.exports, "findSelectedNodeOfType", () => $6b709a593d983bd3$export$924aa2dd4d9a67fa);
$parcel$export(module.exports, "flatten", () => $6b709a593d983bd3$export$bffa455ba8c619a6);
$parcel$export(module.exports, "findChildren", () => $6b709a593d983bd3$export$f94ca194e830789c);
$parcel$export(module.exports, "findChildrenByType", () => $6b709a593d983bd3$export$96bb9476c7c69f39);
$parcel$export(module.exports, "contains", () => $6b709a593d983bd3$export$2344b14b097df817);
// src/selection.ts

var $gZGBX = parcelRequire("gZGBX");

var $kCV8T = parcelRequire("kCV8T");
var $6b709a593d983bd3$export$5dd18664fe8bcbde = (nodeType)=>(tr)=>{
        const parent = $6b709a593d983bd3$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $6b709a593d983bd3$var$removeNodeAtPos(parent.pos)(tr);
        return tr;
    };
var $6b709a593d983bd3$export$b72cc612b642c071 = (nodeType, content)=>(tr)=>{
        if (!Array.isArray(nodeType)) nodeType = [
            nodeType
        ];
        for(let i = 0, count = nodeType.length; i < count; i++){
            const parent = $6b709a593d983bd3$export$1a3a74094b9968e(nodeType[i])(tr.selection);
            if (parent) {
                const newTr = $6b709a593d983bd3$var$replaceNodeAtPos(parent.pos, content)(tr);
                if (newTr !== tr) return newTr;
            }
        }
        return tr;
    };
var $6b709a593d983bd3$export$7d6e4e6663186878 = (tr)=>{
    if ($6b709a593d983bd3$export$a8c1d2c13abf8822(tr.selection)) {
        const from = tr.selection.$from.pos;
        const to = tr.selection.$to.pos;
        return $6b709a593d983bd3$var$cloneTr(tr.delete(from, to));
    }
    return tr;
};
var $6b709a593d983bd3$export$39874bca494f9ba3 = (content)=>(tr)=>{
        if ($6b709a593d983bd3$export$a8c1d2c13abf8822(tr.selection)) {
            const { $from: $from, $to: $to } = tr.selection;
            if (content instanceof (0, $kCV8T.Fragment) && $from.parent.canReplace($from.index(), $from.indexAfter(), content) || content instanceof (0, $kCV8T.Node) && $from.parent.canReplaceWith($from.index(), $from.indexAfter(), content.type)) return $6b709a593d983bd3$var$cloneTr(tr.replaceWith($from.pos, $to.pos, content).setSelection(new (0, $gZGBX.NodeSelection)(tr.doc.resolve($from.pos))));
        }
        return tr;
    };
var $6b709a593d983bd3$export$1df6d14df6b0b758 = (position, dir = 1)=>(tr)=>{
        const nextSelection = (0, $gZGBX.Selection).findFrom(tr.doc.resolve(position), dir, true);
        if (nextSelection) return tr.setSelection(nextSelection);
        return tr;
    };
var $6b709a593d983bd3$var$isSelectableNode = (node)=>Boolean(node instanceof (0, $kCV8T.Node) && node.type && node.type.spec.selectable);
var $6b709a593d983bd3$var$shouldSelectNode = (node)=>$6b709a593d983bd3$var$isSelectableNode(node) && node.type.isLeaf;
var $6b709a593d983bd3$var$setSelection = (node, pos, tr)=>{
    if ($6b709a593d983bd3$var$shouldSelectNode(node)) return tr.setSelection(new (0, $gZGBX.NodeSelection)(tr.doc.resolve(pos)));
    return $6b709a593d983bd3$export$1df6d14df6b0b758(pos)(tr);
};
var $6b709a593d983bd3$export$5fe92db78385e37c = (content, position, tryToReplace)=>(tr)=>{
        const hasPosition = typeof position === "number";
        const { $from: $from } = tr.selection;
        const $insertPos = hasPosition ? tr.doc.resolve(position) : $6b709a593d983bd3$export$a8c1d2c13abf8822(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        const { parent: parent } = $insertPos;
        if ($6b709a593d983bd3$export$a8c1d2c13abf8822(tr.selection) && tryToReplace) {
            const oldTr = tr;
            tr = $6b709a593d983bd3$export$39874bca494f9ba3(content)(tr);
            if (oldTr !== tr) return tr;
        }
        if ($6b709a593d983bd3$var$isEmptyParagraph(parent)) {
            const oldTr = tr;
            tr = $6b709a593d983bd3$export$b72cc612b642c071(parent.type, content)(tr);
            if (oldTr !== tr) {
                const pos = $6b709a593d983bd3$var$isSelectableNode(content) ? // for selectable node, selection position would be the position of the replaced parent
                $insertPos.before($insertPos.depth) : $insertPos.pos;
                return $6b709a593d983bd3$var$setSelection(content, pos, tr);
            }
        }
        if ($6b709a593d983bd3$export$b4d1262a40ad21d4($insertPos, content)) {
            tr.insert($insertPos.pos, content);
            const pos = hasPosition ? $insertPos.pos : $6b709a593d983bd3$var$isSelectableNode(content) ? // for atom nodes selection position after insertion is the previous pos
            tr.selection.$anchor.pos - 1 : tr.selection.$anchor.pos;
            return $6b709a593d983bd3$var$cloneTr($6b709a593d983bd3$var$setSelection(content, pos, tr));
        }
        for(let i = $insertPos.depth; i > 0; i--){
            const pos = $insertPos.after(i);
            const $pos = tr.doc.resolve(pos);
            if ($6b709a593d983bd3$export$b4d1262a40ad21d4($pos, content)) {
                tr.insert(pos, content);
                return $6b709a593d983bd3$var$cloneTr($6b709a593d983bd3$var$setSelection(content, pos, tr));
            }
        }
        return tr;
    };
var $6b709a593d983bd3$export$36491a9ea218d882 = (nodeType, type, attrs, marks)=>(tr)=>{
        const parent = $6b709a593d983bd3$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $6b709a593d983bd3$var$cloneTr(tr.setNodeMarkup(parent.pos, type, Object.assign({}, parent.node.attrs, attrs), marks));
        return tr;
    };
var $6b709a593d983bd3$export$7f11cc48adfe3aed = (nodeType)=>(tr)=>{
        if (!$6b709a593d983bd3$export$a8c1d2c13abf8822(tr.selection)) {
            const parent = $6b709a593d983bd3$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $6b709a593d983bd3$var$cloneTr(tr.setSelection((0, $gZGBX.NodeSelection).create(tr.doc, parent.pos)));
        }
        return tr;
    };
var $6b709a593d983bd3$export$ffb1550ab6c3d03c = (tr)=>{
    const position = $6b709a593d983bd3$export$f8088819b1e2c2dc(tr.selection);
    if (typeof position === "number") return $6b709a593d983bd3$var$removeNodeAtPos(position)(tr);
    return tr;
};
// src/helpers.ts
var $6b709a593d983bd3$export$a8c1d2c13abf8822 = (selection)=>{
    return selection instanceof (0, $gZGBX.NodeSelection);
};
var $6b709a593d983bd3$var$equalNodeType = (nodeType, node)=>{
    return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
};
var $6b709a593d983bd3$var$cloneTr = (tr)=>{
    return Object.assign(Object.create(tr), tr).setTime(Date.now());
};
var $6b709a593d983bd3$var$replaceNodeAtPos = (position, content)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        const $pos = tr.doc.resolve(position);
        if (!node) return tr;
        if ($6b709a593d983bd3$var$canReplace($pos, content)) {
            tr = tr.replaceWith(position, position + node.nodeSize, content);
            const start = tr.selection.$from.pos - 1;
            tr = $6b709a593d983bd3$export$1df6d14df6b0b758(Math.max(start, 0), -1)(tr);
            tr = $6b709a593d983bd3$export$1df6d14df6b0b758(tr.selection.$from.start())(tr);
            return $6b709a593d983bd3$var$cloneTr(tr);
        }
        return tr;
    };
var $6b709a593d983bd3$var$canReplace = ($pos, content)=>{
    const node = $pos.node($pos.depth);
    return node && node.type.validContent(content instanceof (0, $kCV8T.Fragment) ? content : (0, $kCV8T.Fragment).from(content));
};
var $6b709a593d983bd3$var$removeNodeAtPos = (position)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        if (!node) return tr;
        return $6b709a593d983bd3$var$cloneTr(tr.delete(position, position + node.nodeSize));
    };
var $6b709a593d983bd3$export$b4d1262a40ad21d4 = ($pos, content)=>{
    const index = $pos.index();
    if (content instanceof (0, $kCV8T.Fragment)) return $pos.parent.canReplace(index, index, content);
    else if (content instanceof (0, $kCV8T.Node)) return $pos.parent.canReplaceWith(index, index, content.type);
    return false;
};
var $6b709a593d983bd3$var$isEmptyParagraph = (node)=>{
    return !node || node.type.name === "paragraph" && node.nodeSize === 2;
};
// src/selection.ts
var $6b709a593d983bd3$export$dc159056ffdb4c76 = (predicate)=>({ $from: $from, $to: $to }, validateSameParent = false)=>{
        if (validateSameParent && !$from.sameParent($to)) {
            let depth = Math.min($from.depth, $to.depth);
            while(depth >= 0){
                const fromNode = $from.node(depth);
                const toNode = $to.node(depth);
                if (toNode === fromNode) {
                    if (predicate(fromNode)) return {
                        // Return the resolved pos
                        pos: depth > 0 ? $from.before(depth) : 0,
                        start: $from.start(depth),
                        depth: depth,
                        node: fromNode
                    };
                }
                depth = depth - 1;
            }
            return;
        }
        return $6b709a593d983bd3$export$fe09644e3bc6166b($from, predicate);
    };
var $6b709a593d983bd3$export$fe09644e3bc6166b = ($pos, predicate)=>{
    for(let i = $pos.depth; i > 0; i--){
        const node = $pos.node(i);
        if (predicate(node)) return {
            pos: i > 0 ? $pos.before(i) : 0,
            start: $pos.start(i),
            depth: i,
            node: node
        };
    }
};
var $6b709a593d983bd3$export$8556d79fa8189214 = (predicate, domAtPos)=>(selection)=>{
        const parent = $6b709a593d983bd3$export$dc159056ffdb4c76(predicate)(selection);
        if (parent) return $6b709a593d983bd3$export$666ce65defe9ad6e(parent.pos, domAtPos);
    };
var $6b709a593d983bd3$export$178ecaf80f45fdb6 = (predicate)=>(selection)=>{
        return !!$6b709a593d983bd3$export$dc159056ffdb4c76(predicate)(selection);
    };
var $6b709a593d983bd3$export$1a3a74094b9968e = (nodeType)=>(selection)=>{
        return $6b709a593d983bd3$export$dc159056ffdb4c76((node)=>$6b709a593d983bd3$var$equalNodeType(nodeType, node))(selection);
    };
var $6b709a593d983bd3$export$8bf0d019bde85d18 = ($pos, nodeType)=>{
    return $6b709a593d983bd3$export$fe09644e3bc6166b($pos, (node)=>$6b709a593d983bd3$var$equalNodeType(nodeType, node));
};
var $6b709a593d983bd3$export$14f438bb7227ce63 = (nodeType)=>(selection)=>{
        return $6b709a593d983bd3$export$178ecaf80f45fdb6((node)=>$6b709a593d983bd3$var$equalNodeType(nodeType, node))(selection);
    };
var $6b709a593d983bd3$export$faeafc1151740116 = (nodeType, domAtPos)=>(selection)=>{
        return $6b709a593d983bd3$export$8556d79fa8189214((node)=>$6b709a593d983bd3$var$equalNodeType(nodeType, node), domAtPos)(selection);
    };
var $6b709a593d983bd3$export$924aa2dd4d9a67fa = (nodeType)=>(selection)=>{
        if ($6b709a593d983bd3$export$a8c1d2c13abf8822(selection)) {
            const { node: node, $from: $from } = selection;
            if ($6b709a593d983bd3$var$equalNodeType(nodeType, node)) return {
                node: node,
                start: $from.start(),
                pos: $from.pos,
                depth: $from.depth
            };
        }
    };
var $6b709a593d983bd3$export$f8088819b1e2c2dc = (selection)=>{
    const { nodeBefore: nodeBefore } = selection.$from;
    const maybeSelection = (0, $gZGBX.Selection).findFrom(selection.$from, -1);
    if (maybeSelection && nodeBefore) {
        const parent = $6b709a593d983bd3$export$1a3a74094b9968e(nodeBefore.type)(maybeSelection);
        if (parent) return parent.pos;
        return maybeSelection.$from.pos;
    }
};
var $6b709a593d983bd3$export$666ce65defe9ad6e = (position, domAtPos)=>{
    const dom = domAtPos(position);
    const node = dom.node.childNodes[dom.offset];
    if (dom.node.nodeType === Node.TEXT_NODE && dom.node.parentNode) return dom.node.parentNode;
    if (!node || node.nodeType === Node.TEXT_NODE) return dom.node;
    return node;
};
// src/node.ts
var $6b709a593d983bd3$export$bffa455ba8c619a6 = (node, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    const result = [];
    node.descendants((child, pos)=>{
        result.push({
            node: child,
            pos: pos
        });
        if (!descend) return false;
    });
    return result;
};
var $6b709a593d983bd3$export$f94ca194e830789c = (node, predicate, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    else if (!predicate) throw new Error('Invalid "predicate" parameter');
    return $6b709a593d983bd3$export$bffa455ba8c619a6(node, descend).filter((child)=>predicate(child.node));
};
var $6b709a593d983bd3$export$53418710fbc2d8cc = (node, descend = true)=>{
    return $6b709a593d983bd3$export$f94ca194e830789c(node, (child)=>child.isText, descend);
};
var $6b709a593d983bd3$export$ddc1620722e25671 = (node, descend = true)=>{
    return $6b709a593d983bd3$export$f94ca194e830789c(node, (child)=>child.isInline, descend);
};
var $6b709a593d983bd3$export$cae8d7f259e5bbe9 = (node, descend = true)=>{
    return $6b709a593d983bd3$export$f94ca194e830789c(node, (child)=>child.isBlock, descend);
};
var $6b709a593d983bd3$export$a836476a7f9de5b4 = (node, predicate, descend = true)=>{
    return $6b709a593d983bd3$export$f94ca194e830789c(node, (child)=>!!predicate(child.attrs), descend);
};
var $6b709a593d983bd3$export$96bb9476c7c69f39 = (node, nodeType, descend = true)=>{
    return $6b709a593d983bd3$export$f94ca194e830789c(node, (child)=>child.type === nodeType, descend);
};
var $6b709a593d983bd3$export$c01a9e7ec615e821 = (node, markType, descend = true)=>{
    return $6b709a593d983bd3$export$f94ca194e830789c(node, (child)=>Boolean(markType.isInSet(child.marks)), descend);
};
var $6b709a593d983bd3$export$2344b14b097df817 = (node, nodeType)=>{
    return !!$6b709a593d983bd3$export$96bb9476c7c69f39(node, nodeType).length;
};

});

parcelRegister("bQr2R", function(module, exports) {

$parcel$export(module.exports, "BODIED_EXT_PADDING", () => $6a203c68476205e6$export$5ac5087fe1217160);
$parcel$export(module.exports, "BODIED_EXT_MBE_MARGIN_TOP", () => $6a203c68476205e6$export$91624ec52c59c24c);
const $6a203c68476205e6$export$f5ecdce4c60ff98b = 8;
const $6a203c68476205e6$export$5ac5087fe1217160 = $6a203c68476205e6$export$f5ecdce4c60ff98b * 2;
const $6a203c68476205e6$export$91624ec52c59c24c = 12;

});

parcelRegister("ejmVg", function(module, exports) {

$parcel$export(module.exports, "LAYOUT_SECTION_MARGIN", () => $16b49a7404f3316f$export$cd04f19842abff0);
$parcel$export(module.exports, "LAYOUT_COLUMN_PADDING", () => $16b49a7404f3316f$export$a1bb91aa2d5fcce8);
const $16b49a7404f3316f$export$cd04f19842abff0 = 8;
const $16b49a7404f3316f$export$a1bb91aa2d5fcce8 = $16b49a7404f3316f$export$cd04f19842abff0 * 1.5;

});


parcelRegister("OxITw", function(module, exports) {

$parcel$export(module.exports, "FullPagePadding", () => $19a4579e32968c00$export$12fd658e5eef0d79);
$parcel$export(module.exports, "TELEPOINTER_ID", () => $19a4579e32968c00$export$74b525449cc7cbd1);
$parcel$export(module.exports, "rendererStyles", () => $19a4579e32968c00$export$1c4377249312209);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");


var $3RZIb = parcelRequire("3RZIb");

var $cSyk1 = parcelRequire("cSyk1");

var $9R9Rb = parcelRequire("9R9Rb");

var $1xqpZ = parcelRequire("1xqpZ");
var $cx4Bg = parcelRequire("cx4Bg");
var $kRRtM = parcelRequire("kRRtM");
var $cYeQP = parcelRequire("cYeQP");
var $7Acon = parcelRequire("7Acon");
var $719f3 = parcelRequire("719f3");
var $4E5wI = parcelRequire("4E5wI");
var $kZxLT = parcelRequire("kZxLT");
var $idytF = parcelRequire("idytF");
var $5fBxY = parcelRequire("5fBxY");
var $jlYLw = parcelRequire("jlYLw");
var $ceYEW = parcelRequire("ceYEW");
var $4jyW9 = parcelRequire("4jyW9");
var $bv4Ps = parcelRequire("bv4Ps");
var $aSoqv = parcelRequire("aSoqv");
var $iJOES = parcelRequire("iJOES");
var $6gEe5 = parcelRequire("6gEe5");
var $1bQ0V = parcelRequire("1bQ0V");
var $jRk4M = parcelRequire("jRk4M");
var $fwxzS = parcelRequire("fwxzS");

var $ajc8Z = parcelRequire("ajc8Z");
var $bbl9Y = parcelRequire("bbl9Y");

var $gE8f9 = parcelRequire("gE8f9");

var $iHYdz = parcelRequire("iHYdz");

var $l8Gxi = parcelRequire("l8Gxi");

var $3rouw = parcelRequire("3rouw");

var $2o2hu = parcelRequire("2o2hu");

var $dkc63 = parcelRequire("dkc63");


var $gmhCD = parcelRequire("gmhCD");
const $19a4579e32968c00$export$12fd658e5eef0d79 = 32;
const $19a4579e32968c00$var$tableShadowWidth = 32;
const $19a4579e32968c00$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';
const $19a4579e32968c00$var$telepointerStyles = (colorMode)=>{
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $f8Sb3.css)("#", $19a4579e32968c00$export$74b525449cc7cbd1, "{display:inline-block;position:relative;width:1.5px;height:25px;background:linear-gradient(\n\t\t\t\t45deg,\n\t\t\t\t", colorMode === 'dark' ? '#f5cd47' : '#f8e6a0', " -12.02%,\n\t\t\t\t", colorMode === 'dark' ? '#60c6d2' : '#8bdbe5', " 19.18%,\n\t\t\t\t", colorMode === 'dark' ? '#388bff' : '#0c66e4', " 71.87%\n\t\t\t);margin-left:var(--ds-space-025, 2px);&::after{content:'AI';position:absolute;display:block;top:0;left:0;font-size:10px;font-weight:var(--ds-font-weight-bold, 700);width:12.5px;height:13px;padding-top:1px;padding-left:1.5px;line-height:initial;border-radius:0px 2px 2px 0px;color:var(--ds-text-inverse, white);background:linear-gradient(\n\t\t\t\t\t45deg,\n\t\t\t\t\t", colorMode === 'dark' ? '#60c6d2' : '#8bdbe5', " -57%,\n\t\t\t\t\t", colorMode === 'dark' ? '#388bff' : '#0c66e4', " 71.87%\n\t\t\t\t);}}");
};
const $19a4579e32968c00$var$getLineHeight = (fontCode)=>(0, $3RZIb.headingSizes)[fontCode].lineHeight / (0, $3RZIb.headingSizes)[fontCode].size;
const $19a4579e32968c00$var$headingSizes = {
    h1: {
        lineHeight: $19a4579e32968c00$var$getLineHeight('h700')
    },
    h2: {
        lineHeight: $19a4579e32968c00$var$getLineHeight('h600')
    },
    h3: {
        lineHeight: $19a4579e32968c00$var$getLineHeight('h500')
    },
    h4: {
        lineHeight: $19a4579e32968c00$var$getLineHeight('h400')
    },
    h5: {
        lineHeight: $19a4579e32968c00$var$getLineHeight('h300')
    },
    h6: {
        lineHeight: $19a4579e32968c00$var$getLineHeight('h100')
    }
};
const $19a4579e32968c00$var$headingAnchorStyle = (headingTag)=>/*#__PURE__*/ // TODO Delete this comment after verifying space token -> previous value `margin-left: 6px`
    (0, $f8Sb3.css)(".", (0, $3rouw.HeadingAnchorWrapperClassName), "{position:absolute;height:", $19a4579e32968c00$var$headingSizes[headingTag].lineHeight, "em;margin-left:var(--ds-space-075, 6px);button{padding-left:0;padding-right:0;}}/**\n     * Applies hover effects to the heading anchor link button\n     * to fade in when the user rolls over the heading.\n     *\n     * The link is persistent on mobile, so we use feature detection\n     * to enable hover effects for systems that support it (desktop).\n     *\n     * @see https://caniuse.com/mdn-css_at-rules_media_hover\n     */@media (hover: hover) and (pointer: fine){.", (0, $3rouw.HeadingAnchorWrapperClassName), "{>button{opacity:0;transform:translate(-8px, 0px);transition:opacity 0.2s ease 0s,transform 0.2s ease 0s;}}&:hover{.", (0, $3rouw.HeadingAnchorWrapperClassName), ">button{opacity:1;transform:none!important;}}}.", (0, $3rouw.HeadingAnchorWrapperClassName), "{button:focus{opacity:1;transform:none!important;}}");
const $19a4579e32968c00$var$alignedHeadingAnchorStyle = ({ allowNestedHeaderLinks: allowNestedHeaderLinks })=>{
    if (!allowNestedHeaderLinks) return '';
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    return /*#__PURE__*/ (0, $f8Sb3.css)(".fabric-editor-block-mark[data-align]>{h1,h2,h3,h4,h5,h6{position:relative;}}.fabric-editor-block-mark:not([data-align='center'])[data-align]{.", (0, $3rouw.HeadingAnchorWrapperClassName), "{margin:0 var(--ds-space-075, 6px) 0 0;transform:translateX(calc(-100% - var(--ds-space-075, 6px)));}@media (hover: hover) and (pointer: fine){.", (0, $3rouw.HeadingAnchorWrapperClassName), ">button{transform:translate(8px, 0px);}}}");
};
const $19a4579e32968c00$var$tableSortableColumnStyle = ({ allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks })=>{
    if (!allowColumnSorting) return '';
    let headingsCss = '';
    if (allowNestedHeaderLinks) headingsCss = `
      /**
       * When the sort button is enabled we want the heading's copy link button
       * to reserve space so that it can prematurely wrap to avoid the button
       * being displayed underneath the sort button (hidden or obscured).
       *
       * The two buttons fight each other since the sort button is displayed
       * on hover of the <th /> and the copy link button is displayed on hover
       * of the heading.
       *
       * Note that this can break the WYSIWYG experience in the case where
       * a heading fills the width of the table cell and the only thing which
       * wraps is the copy link button. This is hopefully a rare fringe case.
       */
      .${0, $3rouw.HeadingAnchorWrapperClassName} {
        position: unset;
      }
      > {
        h1, h2, h3, h4, h5, h6 {
          margin-right: 30px;
        }
      }
    `;
    return /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_WRAPPER, "{padding:0;", (0, $VSDnB.fg)('platform_editor_nested_tables_renderer_styles') ? /*#__PURE__*/ (0, $f8Sb3.css)(">.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN, ">.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER, "{margin:0;.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:1;transition:opacity 0.2s ease-in-out;}}>.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN, ">.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER, "{.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:0;&:focus{opacity:1;}}}&:hover:not(\n\t\t\t\t\t\t\t\t:has(\n\t\t\t\t\t\t\t\t\t\t.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_WRAPPER, "\n\t\t\t\t\t\t\t\t\t\t\t.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN, ":hover\n\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t)>.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN, ">.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER, "{.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:1;}}") : /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER, "{margin:0;.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:1;transition:opacity 0.2s ease-in-out;}}.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER, "{.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:0;&:focus{opacity:1;}}}&:hover{.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER, "{.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:1;}}}"), ";.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN, "{width:100%;height:100%;padding:", (0, $6gEe5.tableCellPadding), "px;border-width:1.5px;border-style:solid;border-color:transparent;", headingsCss, ";>*:first-child{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*,>style:first-child+.ProseMirror-gapcursor+span+*{margin-top:0;}@supports selector(:focus-visible){&:focus{outline:unset;}&:focus-visible{border-color:", `var(--ds-border-focused, ${$829f609a65d26a98$export$e62e8919cca44969})`, ";}}}}");
};
const $19a4579e32968c00$var$fullPageStyles = ({ appearance: appearance }, { theme: theme })=>{
    if (appearance !== 'full-page') return '';
    return /*#__PURE__*/ (0, $f8Sb3.css)("max-width:", theme && theme.layoutMaxWidth ? `${theme.layoutMaxWidth}px` : 'none', ";margin:0 auto;padding:0 ", appearance === 'full-page' ? $19a4579e32968c00$export$12fd658e5eef0d79 : 0, "px;");
};
const $19a4579e32968c00$var$fullWidthStyles = ({ appearance: appearance })=>{
    if (appearance !== 'full-width') return '';
    return /*#__PURE__*/ (0, $f8Sb3.css)("max-width:", (0, $iHYdz.akEditorFullWidthLayoutWidth), "px;margin:0 auto;.fabric-editor-breakout-mark:not([data-has-width='true']),.ak-renderer-extension{width:100%!important;}", (0, $dkc63.isTableResizingEnabled)(appearance) ? '' : `
      .pm-table-container {
        width: 100% !important;
      }
    `, ";");
};
const $19a4579e32968c00$var$breakoutWidthStyle = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)("*:not([data-mark-type='fragment']) .", (0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER, "{width:100%!important;left:0!important;}[data-mark-type='fragment'] * .", (0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER, "{width:100%!important;left:0!important;}");
};
const $19a4579e32968c00$var$getShadowOverrides = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)("&.", (0, $ajc8Z.shadowClassNames).RIGHT_SHADOW, "::after,&.", (0, $ajc8Z.shadowClassNames).LEFT_SHADOW, "::before{width:", $19a4579e32968c00$var$tableShadowWidth, "px;background:linear-gradient(\n\t\t\t\t\tto left,\n\t\t\t\t\ttransparent 0,\n\t\t\t\t\t", `var(--ds-shadow-overflow-spread, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`, " 140%\n\t\t\t\t),linear-gradient(\n\t\t\t\t\tto right,\n\t\t\t\t\tvar(--ds-shadow-overflow-perimeter, transparent) 0px,\n\t\t\t\t\ttransparent 1px\n\t\t\t\t);}&.", (0, $ajc8Z.shadowClassNames).RIGHT_SHADOW, "::after{background:linear-gradient(\n\t\t\t\t\tto right,\n\t\t\t\t\ttransparent 0,\n\t\t\t\t\t", `var(--ds-shadow-overflow-spread, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`, " 140%\n\t\t\t\t),linear-gradient(\n\t\t\t\t\tto left,\n\t\t\t\t\tvar(--ds-shadow-overflow-perimeter, transparent) 0px,\n\t\t\t\t\ttransparent 1px\n\t\t\t\t);right:0px;}");
};
function $19a4579e32968c00$var$getAnnotationStyles({ allowAnnotations: allowAnnotations }) {
    if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return '';
    if ((0, $VSDnB.fg)('annotations_align_editor_and_renderer_styles')) return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& [data-annotation-draft-mark][data-annotation-inline-node]': {
            borderBottom: '2px solid transparent',
            cursor: 'pointer',
            padding: '1px 0 2px',
            background: `var(--ds-background-accent-yellow-subtler, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
            borderBottomColor: `var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`,
            boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, -1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& [data-annotation-draft-mark][data-annotation-inline-node][data-inline-card]': {
            padding: '5px 0 3px 0'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& [data-annotation-draft-mark][data-annotation-inline-node].date-lozenger-container': {
            paddingTop: "var(--ds-space-025, 2px)"
        }
    });
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark], & [data-annotation-draft-mark][data-annotation-inline-node]": {
            background: `var(--ds-background-accent-yellow-subtler, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
            borderBottom: `2px solid ${`var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`}`,
            boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, -1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
            cursor: 'pointer',
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"}`
        }
    });
}
const $19a4579e32968c00$var$tableRowHeight = 44;
const $19a4579e32968c00$var$stickyScrollbarStyles = `
	position: relative;
	flex-direction: column;

	> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER} {
	  width: 100%;
	  display: block;
	  visibility: hidden;
	  overflow-x: auto;
	  position: sticky;
	  bottom: ${"var(--ds-space-0, 0px)"};
	  z-index: 1;
	}

	> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
	> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
	   position: absolute;
	   width: 100%;
	   height: 1px;
	   margin-top: -1px;
	   // need this to avoid sentinel being focused via keyboard
	   // this still allows it to be detected by intersection observer
	   visibility: hidden;
	 }
	 > .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
	   top: ${$19a4579e32968c00$var$tableRowHeight * 3}px;
	 }
	 > .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM} {
	   bottom:  ${"var(--ds-space-250, 20px)"}; // MAX_BROWSER_SCROLLBAR_HEIGHT = 20;
	 }
  `;
const $19a4579e32968c00$export$1c4377249312209 = (wrapperProps)=>(theme)=>{
        const { colorMode: colorMode, typography: typography } = (0, $cSyk1.default)();
        // This is required to be compatible with styled-components prop structure.
        const themeProps = {
            theme: theme
        };
        const { useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, appearance: appearance } = wrapperProps;
        const isAdvancedLayoutsOn = (0, $gmhCD.editorExperiment)('advanced_layouts', true);
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/design-system/no-css-tagged-template-expression
        return /*#__PURE__*/ (0, $f8Sb3.css)("font-size:", (0, $iHYdz.editorFontSize)(themeProps), "px;line-height:1.5rem;color:", `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`, ";.", (0, $l8Gxi.RendererCssClassName).DOCUMENT, "::after{content:'';visibility:hidden;display:block;height:0;clear:both;}", $19a4579e32968c00$var$fullPageStyles(wrapperProps, themeProps), " ", $19a4579e32968c00$var$fullWidthStyles(wrapperProps), " .", (0, $l8Gxi.RendererCssClassName).DOCUMENT, "{", (0, $9R9Rb.mediaInlineImageStyles), ";}& h1{", $19a4579e32968c00$var$headingAnchorStyle('h1'), ";}& h2{", $19a4579e32968c00$var$headingAnchorStyle('h2'), ";}& h3{", $19a4579e32968c00$var$headingAnchorStyle('h3'), ";}& h4{", $19a4579e32968c00$var$headingAnchorStyle('h4'), ";}& h5{", $19a4579e32968c00$var$headingAnchorStyle('h5'), ";}& h6{", $19a4579e32968c00$var$headingAnchorStyle('h6'), ";}& span.akActionMark{color:", `var(--ds-link, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`, ";text-decoration:none;&:hover{color:", `var(--ds-link, ${$829f609a65d26a98$export$e62e8919cca44969})`, ";text-decoration:underline;}&:active{color:", `var(--ds-link-pressed, ${$829f609a65d26a98$export$a6ee3d71bc067634})`, ";}}& span.akActionMark{cursor:pointer;}& span[data-placeholder]{color:", `var(--ds-text-subtlest, ${$829f609a65d26a98$export$f563ee71e9ee74cd})`, ";}", $19a4579e32968c00$var$telepointerStyles(colorMode), " ", (0, $fwxzS.whitespaceSharedStyles), ";", (0, $kRRtM.blockquoteSharedStyles), ";", (0, $idytF.headingsSharedStyles)(typography), ";", (0, $bv4Ps.ruleSharedStyles)(), ";", (0, $4jyW9.paragraphSharedStyles)(typography), ";", (0, $jlYLw.listsSharedStyles), ";", (0, $5fBxY.indentationSharedStyles), ";", (0, $cx4Bg.blockMarksSharedStyles), ";", (0, $7Acon.codeMarkSharedStyles)(), ";", (0, $aSoqv.shadowSharedStyle), ";", (0, $4E5wI.dateSharedStyle), ";", (0, $jRk4M.textColorStyles), ";", (0, $1xqpZ.backgroundColorStyles)(), ";", (0, $1bQ0V.tasksAndDecisionsStyles), ";", (0, $iJOES.smartCardSharedStyles), " ", $19a4579e32968c00$var$getAnnotationStyles(wrapperProps), " ", (0, $kZxLT.getStatusSharedStyles)(), " & .UnknownBlock{font-family:var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";font-weight:var(--ds-font-weight-regular, 400);white-space:pre-wrap;word-wrap:break-word;}& span.date-node{background:", `var(--ds-background-neutral, ${$829f609a65d26a98$export$920c0d5c49070351})`, ";border-radius:var(--ds-border-radius-100, 3px);color:", `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`, ";padding:var(--ds-space-025, 2px) var(--ds-space-050, 4px);margin:0 1px;transition:background 0.3s;}& span.date-node-highlighted{background:", `var(--ds-background-danger, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`, ";color:", `var(--ds-text-danger, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`, ";}& .renderer-image{max-width:100%;display:block;margin:var(--ds-space-300, 24px) 0;}.", (0, $ceYEW.richMediaClassName), ".rich-media-wrapped+.", (0, $ceYEW.richMediaClassName), ":not(.rich-media-wrapped){clear:both;}& .code-block,& blockquote,& hr,&>div>div:not(.rich-media-wrapped),.", (0, $ceYEW.richMediaClassName), ".rich-media-wrapped+.rich-media-wrapped+*:not(.rich-media-wrapped),.", (0, $ceYEW.richMediaClassName), ".rich-media-wrapped+div:not(.rich-media-wrapped),.", (0, $ceYEW.richMediaClassName), ".image-align-start,.", (0, $ceYEW.richMediaClassName), ".image-center,.", (0, $ceYEW.richMediaClassName), ".image-align-end{clear:both;}& .rich-media-wrapped{&+h1,&+h2,&+h3,&+h4,&+h5,&+h6{margin-top:var(--ds-space-100, 8px);}}", $19a4579e32968c00$var$alignedHeadingAnchorStyle(wrapperProps), (0, $ceYEW.mediaSingleSharedStyle), " & div[class^='image-wrap-']+div[class^='image-wrap-']{margin-left:0;margin-right:0;}.", (0, $l8Gxi.RendererCssClassName).DOCUMENT, ">{", $19a4579e32968c00$var$breakoutWidthStyle(), " * .", (0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER, "{overflow-x:auto;}& .", (0, $l8Gxi.RendererCssClassName).EXTENSION, ":first-child{margin-top:0;}}.", (0, $l8Gxi.RendererCssClassName).DOCUMENT, "{.", (0, $l8Gxi.RendererCssClassName).EXTENSION, "{margin-top:", (0, $iHYdz.blockNodesVerticalMargin), ";}.", (0, $l8Gxi.RendererCssClassName).EXTENSION_CENTER_ALIGN, "{margin-left:50%;transform:translateX(-50%);}.", (0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER, "{overflow-x:auto;}.", (0, $bbl9Y.shadowObserverClassNames).SHADOW_CONTAINER, " .", (0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER, "{display:flex;}}", (0, $6gEe5.tableSharedStyle)(), " .", (0, $l8Gxi.RendererCssClassName).DOCUMENT, " .", (0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER, "{z-index:0;transition:all 0.1s linear;display:flex;&.", (0, $ajc8Z.shadowClassNames).RIGHT_SHADOW, "::after,&.", (0, $ajc8Z.shadowClassNames).LEFT_SHADOW, "::before{top:", (0, $6gEe5.tableMarginTop) - 1, "px;height:calc(100% - ", (0, $6gEe5.tableMarginTop), "px);z-index:", (0, $iHYdz.akEditorStickyHeaderZIndex), ";}", $19a4579e32968c00$var$getShadowOverrides(), " ", (0, $dkc63.isStickyScrollbarEnabled)(appearance) ? $19a4579e32968c00$var$stickyScrollbarStyles : '', " & .", (0, $bbl9Y.shadowObserverClassNames).SENTINEL_LEFT, ",& .", (0, $bbl9Y.shadowObserverClassNames).SENTINEL_RIGHT, "{height:calc(100% - ", (0, $6gEe5.tableMarginTop), "px);}", (0, $VSDnB.fg)('platform_editor_renderer_table_header_styles') ? `.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table` : 'table', "{height:1px;", $19a4579e32968c00$var$tableSortableColumnStyle(wrapperProps), ";margin-left:0;margin-right:0;}", (0, $VSDnB.fg)('platform_editor_renderer_table_header_styles') ? `.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table > tbody > tr:first-of-type ` : 'table tr:first-of-type', "{height:100%;td,th{position:relative;}}table[data-number-column='true']{.", (0, $l8Gxi.RendererCssClassName).NUMBER_COLUMN, "{background-color:", `var(--ds-background-neutral, ${(0, $iHYdz.akEditorTableToolbar)})`, ";border-right:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`, ";width:", (0, $iHYdz.akEditorTableNumberColumnWidth), "px;text-align:center;color:", `var(--ds-text-subtlest, ${$829f609a65d26a98$export$f563ee71e9ee74cd})`, ";font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";}.fixed .", (0, $l8Gxi.RendererCssClassName).NUMBER_COLUMN, "{border-right:0px none;}}}tr[data-header-row].fixed{position:fixed!important;display:flex;overflow:hidden;z-index:", (0, $iHYdz.akEditorStickyHeaderZIndex), ";border-right:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`, ";border-bottom:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`, ";transform:translateX(-1px);}.sticky>th{z-index:", (0, $iHYdz.akEditorStickyHeaderZIndex), ";position:sticky!important;top:0;}.sticky>td{position:sticky!important;top:0;}.sticky th,.sticky td{box-shadow:0px 1px ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`, ",0px -0.5px ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`, ",inset -1px 0px ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableToolbar)})`, ",0px -1px ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableToolbar)})`, ";}.fixed+tr{min-height:0px;}& .code-block{max-width:100%;display:block;position:relative;border-radius:var(--ds-border-radius-100, 3px);word-wrap:normal;}& .MediaGroup,& .code-block{margin-top:", (0, $iHYdz.blockNodesVerticalMargin), ";&:first-child{margin-top:0;}}", $19a4579e32968c00$var$useGridRenderForCodeBlock(useBlockRenderForCodeBlock), " ", (0, $2o2hu.getLightWeightCodeBlockStylesForRootRendererStyleSheet)(), " ", isAdvancedLayoutsOn ? (0, $719f3.columnLayoutResponsiveSharedStyle) : (0, $719f3.columnLayoutSharedStyle), ";", isAdvancedLayoutsOn && (0, $719f3.columnLayoutResponsiveRendererStyles), ";& [data-layout-section]{margin-top:var(--ds-space-250, 20px);&>div+div{margin-left:", isAdvancedLayoutsOn ? 0 : "var(--ds-space-400, 32px)", ";}@media screen and (max-width: ", (0, $iHYdz.gridMediumMaxWidth), "px){&>div+div{margin-left:0;}}& .MediaGroup,& .code-block{margin-top:", (0, $iHYdz.blockNodesVerticalMargin), ";&:first-child{margin-top:0;}}}& li{>.code-block{margin:", (0, $iHYdz.blockNodesVerticalMargin), " 0 0 0;}>.code-block:first-child{margin-top:0;}>div:last-of-type.code-block{margin-bottom:", (0, $iHYdz.blockNodesVerticalMargin), ";}}&:not([data-node-type='decisionList'])>li,&:not(.", (0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, ")>li{", (0, $gE8f9.browser).safari ? (0, $cYeQP.codeBlockInListSafariFix) : '', ";}");
    };
const $19a4579e32968c00$var$useGridRenderForCodeBlock = (codeBlockRenderAsBlock)=>{
    if (codeBlockRenderAsBlock) return '';
    return `& .code-block {
       /* -ms- properties are necessary until MS supports the latest version of the grid spec */
       /* stylelint-disable value-no-vendor-prefix, declaration-block-no-duplicate-properties */
       display: -ms-grid;
       display: grid;
       -ms-grid-columns: auto 1fr;
       /* stylelint-enable */

       grid-template-columns: minmax(0, 1fr);

       & > span {
         /* stylelint-disable value-no-vendor-prefix */
         -ms-grid-row: 1;
         -ms-grid-column: 2;
         /* stylelint-enable */
         grid-column: 1;
       }
     }`;
};

});
parcelRegister("9R9Rb", function(module, exports) {

$parcel$export(module.exports, "INLINE_IMAGE_WRAPPER_CLASS_NAME", () => $c55873fb36219b19$export$dd2e16f83ae6aa78);
$parcel$export(module.exports, "INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY", () => $c55873fb36219b19$export$7ab34e219ce6eef);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY", () => $c55873fb36219b19$export$263a8a844c370a89);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY", () => $c55873fb36219b19$export$b0d1f1e1fb3c4b46);
$parcel$export(module.exports, "mediaInlineImageStyles", () => $c55873fb36219b19$export$dee15762144889b7);
$parcel$export(module.exports, "wrapperStyle", () => $c55873fb36219b19$export$c4d4f06a25de97f);
$parcel$export(module.exports, "selectedStyle", () => $c55873fb36219b19$export$a7abb1b3dc25813f);
$parcel$export(module.exports, "borderStyle", () => $c55873fb36219b19$export$4d0a7f76ad443516);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $dR3f5 = parcelRequire("dR3f5");
const $c55873fb36219b19$export$dd2e16f83ae6aa78 = 'media-inline-image-wrapper';
const $c55873fb36219b19$export$7ab34e219ce6eef = '--editor-media-inline-image-aspect-ratio';
const $c55873fb36219b19$export$263a8a844c370a89 = '--editor-media-inline-image-border-size';
const $c55873fb36219b19$export$b0d1f1e1fb3c4b46 = '--editor-media-inline-image-border-color';
// We implemented such selectors to ensure specificity:
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Nested and dynamic css calls are violations, needs manual remediation
const $c55873fb36219b19$var$inlineImageHeight = (height, margin = 0)=>/*#__PURE__*/ (0, $f8Sb3.css)(">.mediaInlineView-content-wrap>.", $c55873fb36219b19$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap>.", $c55873fb36219b19$export$dd2e16f83ae6aa78, ",>.", $c55873fb36219b19$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .", $c55873fb36219b19$export$dd2e16f83ae6aa78, "{height:", height, "px;transform:translateY(", margin, "px);}");
const $c55873fb36219b19$export$dee15762144889b7 = /*#__PURE__*/ (0, $f8Sb3.css)(".", $c55873fb36219b19$export$dd2e16f83ae6aa78, "{height:", (0, $dR3f5.referenceHeights)['p'], "px;transform:translateY(-2px);}h1{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h1'], -3), ";}h2{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h2'], -3), ";}h3{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h3'], -2), ";}h4{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h4'], -2), ";}h5{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h5'], -2), ";}h6{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h6'], -2), ";}");
const $c55873fb36219b19$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-flex',
    cursor: 'pointer',
    justifyContent: 'center',
    alignItems: 'center',
    verticalAlign: 'middle',
    overflow: 'hidden',
    borderRadius: `${"var(--ds-border-radius, 3px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    aspectRatio: `var(${$c55873fb36219b19$export$7ab34e219ce6eef}, ${(0, $dR3f5.DEFAULT_INLINE_IMAGE_ASPECT_RATIO)})`,
    maxWidth: '100%'
});
const $c55873fb36219b19$export$a7abb1b3dc25813f = /*#__PURE__*/ (0, $f8Sb3.css)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`,
    outline: 'none'
});
const $c55873fb36219b19$export$4d0a7f76ad443516 = /*#__PURE__*/ (0, $f8Sb3.css)({
    borderColor: `var(${$c55873fb36219b19$export$b0d1f1e1fb3c4b46})`,
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `calc(var(${$c55873fb36219b19$export$263a8a844c370a89}, ${(0, $dR3f5.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 2px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderWidth: `calc(var(${$c55873fb36219b19$export$263a8a844c370a89}, ${(0, $dR3f5.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 1px)`,
    boxSizing: `border-box`
});

});
parcelRegister("dR3f5", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $c9848698b53f0c39$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $c9848698b53f0c39$export$da894f7669b4e67c);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_ASPECT_RATIO", () => $c9848698b53f0c39$export$286cf28b87ad4b4f);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_BORDER_SIZE", () => $c9848698b53f0c39$export$64fe09732fb8680);
$parcel$export(module.exports, "referenceHeights", () => $c9848698b53f0c39$export$c1317a9224e4d798);
const $c9848698b53f0c39$export$d722b7527b1834a8 = 250;
const $c9848698b53f0c39$export$da894f7669b4e67c = 200;
const $c9848698b53f0c39$export$286cf28b87ad4b4f = $c9848698b53f0c39$export$d722b7527b1834a8 / $c9848698b53f0c39$export$da894f7669b4e67c;
const $c9848698b53f0c39$export$64fe09732fb8680 = 0;
const $c9848698b53f0c39$export$c1317a9224e4d798 = {
    p: 22,
    h1: 36,
    h2: 31,
    h3: 25,
    h4: 23,
    h5: 20,
    h6: 18
};

});


parcelRegister("1xqpZ", function(module, exports) {

$parcel$export(module.exports, "backgroundColorStyles", () => $31831d84911fc513$export$e4cca17cf56e99d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $31831d84911fc513$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $31831d84911fc513$var$_ref = {
    name: "7ixjog",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:2px;padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}a .fabric-background-color-mark{background-color:unset;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};
const $31831d84911fc513$export$e4cca17cf56e99d = ()=>{
    return $31831d84911fc513$var$_ref;
};

});

parcelRegister("cx4Bg", function(module, exports) {

$parcel$export(module.exports, "blockMarksSharedStyles", () => $e319ea6be2c09fe0$export$33edc553df878c50);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Perfectly safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $e319ea6be2c09fe0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e319ea6be2c09fe0$export$33edc553df878c50 = {
    name: "1p01ut3",
    styles: "*:not(.fabric-editor-block-mark)>,*:not(.fabric-editor-block-mark)>div.fabric-editor-block-mark:first-of-type:not(.fabric-editor-indentation-mark):not(.fabric-editor-alignment),.fabric-editor-alignment:first-of-type:first-child,.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child{p,h1,h2,h3,h4,h5,h6,.heading-wrapper{:first-child:not(style),style:first-child+*{margin-top:0;}}}"
};

});

parcelRegister("kRRtM", function(module, exports) {

$parcel$export(module.exports, "blockquoteSharedStyles", () => $93fa07ea5b1e3295$export$1b5f3b43e6c4a8ee);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
const $93fa07ea5b1e3295$export$1b5f3b43e6c4a8ee = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: `2px solid ${`var(--ds-border, ${(0, $iHYdz.akEditorBlockquoteBorderColor)})`}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $iHYdz.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        }
    }
});

});

parcelRegister("7Acon", function(module, exports) {

$parcel$export(module.exports, "codeMarkSharedStyles", () => $4ae245bd686f7965$export$ea799c18f699972b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $1HkQx = parcelRequire("1HkQx");
const $4ae245bd686f7965$export$ea799c18f699972b = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.code': {
            '--ds--code--bg-color': "var(--ds-background-neutral, #091E420F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $1HkQx.getCodeStyles)()
        }
    });
};

});
parcelRegister("1HkQx", function(module, exports) {

$parcel$export(module.exports, "getCodeBlockStyles", () => $a9c1aabaca189fa1$export$b571c24d82780698);
$parcel$export(module.exports, "getCodeStyles", () => $a9c1aabaca189fa1$export$d5fcf1b7ff23707b);
$parcel$export(module.exports, "getCodeBlockTheme", () => $a9c1aabaca189fa1$export$57a2d4b573afd64a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lBXbx = parcelRequire("lBXbx");

var $8CJbG = parcelRequire("8CJbG");
const $a9c1aabaca189fa1$export$cb7aec0206b595d2 = (numLines)=>{
    if (!numLines) return '1ch';
    return `${numLines.toFixed(0).length}ch`;
};
const $a9c1aabaca189fa1$var$lineNumberStyle = (theme)=>({
        // width of the line number gutter
        minWidth: `calc(${theme.lineNumberWidth} + ${0, $lBXbx.LINE_NUMBER_GUTTER}px) !important`,
        // this needs to be important or it gets overwritten by inline styles
        fontStyle: 'normal !important',
        // this needs to be important or it gets overwritten by inline styles
        color: `${theme.lineNumberColor} !important`,
        flexShrink: 0,
        // needed to replicate existing design spec
        boxSizing: 'border-box',
        paddingRight: `${0, $lBXbx.SPACING}px !important`,
        paddingLeft: (0, $lBXbx.SPACING),
        marginRight: (0, $lBXbx.SPACING),
        textAlign: 'right',
        userSelect: 'none',
        // this is to fix SSR spacing issue
        display: 'block',
        // This is how we are preventing line numbers being copied to clipboard.
        // (`user-select: none;` was not sufficent).
        // https://product-fabric.atlassian.net/browse/DSP-2729
        '&::after': {
            content: `attr(data-ds--line-number)`
        }
    });
// order of these keys does matter as it will affect the css precedence
const $a9c1aabaca189fa1$var$syntaxKeywordColors = (theme)=>({
        '.token': {
            // this specifically stops prism css cascading.
            '&:not([class=token],[data-ds--code--row--highlight],[data-ds--code--row])': {
                all: 'unset'
            },
            // additional specificity required to match the all: unset
            '&.key,&.keyword': {
                color: theme.keywordColor,
                fontWeight: 'bolder'
            },
            '&.attr-name': {
                color: theme.attributeColor
            },
            '&.selector': {
                color: theme.selectorTagColor
            },
            '&.comment,&.block-comment': {
                color: theme.commentColor,
                fontFamily: theme.fontFamilyItalic,
                fontStyle: 'italic'
            },
            '&.function-name': {
                color: theme.sectionColor
            },
            '&.doctype': {
                color: theme.docTagColor
            },
            '&.substr': {
                color: theme.substringColor
            },
            '&.namespace': {
                color: theme.nameColor
            },
            '&.builtin': {
                color: theme.builtInColor
            },
            '&.entity': {
                color: theme.literalColor
            },
            '&.bullet': {
                color: theme.bulletColor
            },
            '&.code': {
                color: theme.codeColor
            },
            '&.regex': {
                color: theme.regexpColor
            },
            '&.symbol': {
                color: theme.symbolColor
            },
            '&.variable': {
                color: theme.variableColor
            },
            '&.url': {
                color: theme.linkColor
            },
            '&.selector-attr': {
                color: theme.selectorAttributeColor
            },
            '&.selector-pseudo': {
                color: theme.selectorPseudoColor
            },
            '&.type': {
                color: theme.typeColor
            },
            '&.quote': {
                color: theme.quoteColor
            },
            '&.tag': {
                color: theme.templateTagColor
            },
            '&.string': {
                color: theme.stringColor
            },
            '&.class-name': {
                color: theme.sectionColor
            },
            '&.title': {
                color: theme.titleColor
            },
            '&.section': {
                color: theme.sectionColor
            },
            '&.meta-keyword': {
                color: theme.metaKeywordColor
            },
            '&.meta': {
                color: theme.metaColor
            },
            '&.italic': {
                fontStyle: 'italic'
            },
            '&.bold': {
                fontWeight: 'bolder'
            },
            '&.function': {
                color: theme.functionColor
            },
            '&.number': {
                color: theme.numberColor
            },
            '&.attr-value': {
                color: theme.attributeColor
            },
            '&.prolog': {
                color: theme.prologColor
            },
            '&.cdata': {
                color: theme.cdataColor
            },
            '&.punctuation': {
                color: theme.punctuationColor
            },
            '&.property': {
                color: theme.propertyColor
            },
            '&.constant': {
                color: theme.constantColor
            },
            '&.deleted': {
                color: theme.deletedColor
            },
            '&.boolean': {
                color: theme.booleanColor
            },
            '&.char': {
                color: theme.charColor
            },
            '&.inserted': {
                color: theme.insertedColor
            },
            '&.operator': {
                color: theme.operatorColor
            },
            '&.atrule': {
                color: theme.atruleColor
            },
            '&.important': {
                color: theme.importantColor,
                fontWeight: "var(--ds-font-weight-bold, 700)"
            }
        }
    });
/**
 * Styles applied at the root element level, common across code/codeblock
 */ const $a9c1aabaca189fa1$var$getBaseCodeStyles = (theme)=>({
        fontSize: (0, $lBXbx.CODE_FONT_SIZE),
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: theme.fontFamily,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        backgroundColor: `var(${0, $lBXbx.VAR_CODE_BG_COLOR},${theme.backgroundColor})`,
        color: theme.textColor,
        borderStyle: 'none',
        borderRadius: "var(--ds-border-radius, 3px)"
    });
const $a9c1aabaca189fa1$export$b571c24d82780698 = (theme)=>(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)=>({
            // this is required to account for prismjs styles leaking into the codeblock
            'code[class*="language-"], pre[class*="language-"], code': {
                all: 'unset',
                padding: showLineNumbers ? `${0, $lBXbx.SPACING}px 0` : (0, $lBXbx.SPACING),
                tabSize: 4
            },
            display: 'flex',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $lBXbx.CODE_LINE_HEIGHT),
            overflowX: 'auto',
            whiteSpace: 'pre',
            direction: 'ltr',
            ...$a9c1aabaca189fa1$var$getBaseCodeStyles(theme),
            ...$a9c1aabaca189fa1$var$syntaxKeywordColors(theme),
            // this is to account for SSR spacing issue once loaded in browser
            '& .linenumber, .ds-sh-line-number': $a9c1aabaca189fa1$var$lineNumberStyle(theme),
            '& .linenumber': {
                display: 'inline-block !important',
                float: 'left'
            },
            // these styles are for line highlighting
            '& [data-ds--code--row]': {
                display: showLineNumbers ? 'flex' : 'block',
                paddingRight: `${0, $lBXbx.SPACING}px !important`,
                marginRight: `-${0, $lBXbx.SPACING}px`
            },
            '& [data-ds--code--row--highlight]': {
                background: `${theme.highlightedLineBgColor}`,
                // eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
                '&::before, &::after': {
                    clipPath: 'inset(100%)',
                    clip: 'rect(1px, 1px, 1px, 1px)',
                    height: '1px',
                    overflow: 'hidden',
                    position: 'absolute',
                    whiteSpace: 'nowrap',
                    width: '1px'
                },
                // The formatting here is an accessibility convention
                '&::before': {
                    content: `" [${highlightedStartText}] "`
                },
                '&::after': {
                    content: `" [${highlightedEndText}] "`
                }
            },
            '& [data-ds--code--row--highlight] .linenumber': {
                borderLeft: `${0, $lBXbx.HIGHLIGHT_BORDER_WIDTH} solid ${theme.highlightedLineBorderColor}`,
                paddingLeft: `${(0, $lBXbx.SPACING) / 2}px !important`,
                position: 'relative'
            },
            // fill in space caused by parent border top
            '& [data-ds--code--row--highlight] .linenumber::before': {
                content: '""',
                position: 'absolute',
                width: (0, $lBXbx.HIGHLIGHT_BORDER_WIDTH),
                top: '-1px',
                left: `-${0, $lBXbx.HIGHLIGHT_BORDER_WIDTH}`,
                borderTop: `1px solid ${theme.highlightedLineBorderColor}`
            },
            '[data-ds--code--row--highlight] + [data-ds--code--row]:not([data-ds--code--row--highlight]), [data-ds--code--row]:not([data-ds--code--row--highlight]) + [data-ds--code--row--highlight]': {
                borderTop: '1px dashed transparent'
            },
            '[data-ds--code--row--highlight]:last-child': {
                borderBottom: '1px dashed transparent'
            },
            '& code:first-of-type': {
                paddingRight: `0px !important`,
                backgroundImage: showLineNumbers ? `linear-gradient(to right, var(${0, $lBXbx.VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor}), var(${0, $lBXbx.VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor})
    calc(${theme.lineNumberWidth} + ${0, $lBXbx.LINE_NUMBER_GUTTER}px), transparent calc(${theme.lineNumberWidth} + ${0, $lBXbx.LINE_NUMBER_GUTTER}px), transparent)` : undefined
            },
            // we need to use last-of-type because when Code is SSR'd
            // 2 <code> elements are created and we don't want this style
            // applied to the first one
            '& code:last-of-type': {
                paddingRight: `${0, $lBXbx.SPACING}px !important`,
                flexBasis: 'auto',
                flexGrow: 1,
                // Needed for the highlight line to extend full-width
                flexShrink: shouldWrapLongLines ? 1 : 0,
                wordBreak: 'break-word'
            },
            // Prevents empty code blocks from vertically collapsing
            'code > span:only-child:empty:before, code > span:only-child > span:only-child:empty:before': {
                content: '" "'
            }
        });
const $a9c1aabaca189fa1$export$d5fcf1b7ff23707b = ()=>{
    const theme = (0, $8CJbG.getBaseTheme)();
    const baseStyles = $a9c1aabaca189fa1$var$getBaseCodeStyles(theme);
    return {
        ...baseStyles,
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    };
};
const $a9c1aabaca189fa1$export$57a2d4b573afd64a = (maxLines)=>{
    return {
        ...(0, $8CJbG.getBaseTheme)(),
        ...(0, $8CJbG.getColorPalette)(),
        lineNumberWidth: maxLines ? $a9c1aabaca189fa1$export$cb7aec0206b595d2(maxLines) : undefined
    };
};

});
parcelRegister("lBXbx", function(module, exports) {

$parcel$export(module.exports, "CODE_FONT_SIZE", () => $6ec31795911692d1$export$431ac46d758d98c8);
$parcel$export(module.exports, "CODE_LINE_HEIGHT", () => $6ec31795911692d1$export$8e3c04032121c606);
$parcel$export(module.exports, "HIGHLIGHT_BORDER_WIDTH", () => $6ec31795911692d1$export$c8b5dc30e9f2b86e);
$parcel$export(module.exports, "SPACING", () => $6ec31795911692d1$export$82ea42e772d49e5b);
$parcel$export(module.exports, "LINE_NUMBER_GUTTER", () => $6ec31795911692d1$export$eeeea0ff98e06fff);
$parcel$export(module.exports, "VAR_CODE_LINE_NUMBER_BG_COLOR", () => $6ec31795911692d1$export$254015fe817dcb9e);
$parcel$export(module.exports, "VAR_CODE_BG_COLOR", () => $6ec31795911692d1$export$1758fda69688282e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $k5uoT = parcelRequire("k5uoT");
const $6ec31795911692d1$export$431ac46d758d98c8 = 12;
const $6ec31795911692d1$export$8e3c04032121c606 = '20px';
const $6ec31795911692d1$export$c8b5dc30e9f2b86e = '4px';
const $6ec31795911692d1$export$82ea42e772d49e5b = (0, $k5uoT.gridSize)();
const $6ec31795911692d1$export$eeeea0ff98e06fff = $6ec31795911692d1$export$82ea42e772d49e5b * 2;
const $6ec31795911692d1$export$254015fe817dcb9e = '--ds--code--line-number-bg-color';
const $6ec31795911692d1$export$1758fda69688282e = '--ds--code--bg-color';
const $6ec31795911692d1$export$2cd00c745c539a1 = `data-ds--code--code-block`;

});

parcelRegister("8CJbG", function(module, exports) {

$parcel$export(module.exports, "getBaseTheme", () => $eac5fe855702cfc1$export$4464aa303b3e4fda);
$parcel$export(module.exports, "getColorPalette", () => $eac5fe855702cfc1$export$fe2a6478976e8b17);

var $8QpSo = parcelRequire("8QpSo");


var $kTHGn = parcelRequire("kTHGn");
// Hardcoded values have been used due to the current color palette not having any
// accessible color options for Teal and Yellow and +20A
const $eac5fe855702cfc1$var$T800 = '#067384';
const $eac5fe855702cfc1$var$Y1100 = '#7A5D1A';
const $eac5fe855702cfc1$export$4464aa303b3e4fda = ()=>({
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamilyItalic: `SFMono-MediumItalic, ${(0, $kTHGn.default)('font.family.code')}`,
        backgroundColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
        textColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        lineNumberColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        lineNumberBgColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$3e51e8f1440314ba})`
    });
const $eac5fe855702cfc1$export$fe2a6478976e8b17 = (0, $8QpSo.default)(()=>{
    return {
        highlightedLineBgColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$3e51e8f1440314ba})`,
        highlightedLineBorderColor: `var(--ds-border-focused, ${$829f609a65d26a98$export$215b7063051591f1})`,
        substringColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        keywordColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        attributeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        selectorTagColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        docTagColor: `var(--ds-text-accent-yellow, ${$eac5fe855702cfc1$var$Y1100})`,
        nameColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        builtInColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        literalColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        bulletColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        codeColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        regexpColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        symbolColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        variableColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        templateVariableColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        linkColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
        selectorAttributeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        selectorPseudoColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        typeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        stringColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        selectorIdColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        selectorClassColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        quoteColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        templateTagColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        titleColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
        sectionColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
        commentColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        metaKeywordColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        metaColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        functionColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        numberColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        prologColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        cdataColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        punctuationColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        propertyColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
        constantColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        booleanColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        charColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        insertedColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        deletedColor: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`,
        operatorColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        atruleColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        importantColor: `var(--ds-text-accent-yellow, ${$eac5fe855702cfc1$var$Y1100})`
    };
});
const $eac5fe855702cfc1$var$getTheme = ()=>({
        ...$eac5fe855702cfc1$export$4464aa303b3e4fda(),
        ...$eac5fe855702cfc1$export$fe2a6478976e8b17()
    });
var $eac5fe855702cfc1$export$2e2bcd8739ae039 = $eac5fe855702cfc1$var$getTheme;

});



parcelRegister("719f3", function(module, exports) {

$parcel$export(module.exports, "columnLayoutSharedStyle", () => $2e5d010f6440279f$export$6891a39948814a80);
$parcel$export(module.exports, "columnLayoutResponsiveSharedStyle", () => $2e5d010f6440279f$export$3afcac98e7ca927d);
$parcel$export(module.exports, "columnLayoutResponsiveRendererStyles", () => $2e5d010f6440279f$export$f2451ec7aca7656c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
function $2e5d010f6440279f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2e5d010f6440279f$export$6891a39948814a80 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '[data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${0, $iHYdz.gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});
const $2e5d010f6440279f$export$3afcac98e7ca927d = {
    name: "ee7qh9",
    styles: "[data-layout-section]{display:flex;flex-direction:row;gap:var(--ds-space-100, 8px);& > *{flex:1;min-width:0;}& > .unsupportedBlockView-content-wrap{min-width:initial;}}.layout-section-container{container-type:inline-size;container-name:layout-area;}"
};
const $2e5d010f6440279f$var$LAYOUT_BREAKPOINT_RENDERER = 629;
const $2e5d010f6440279f$export$f2451ec7aca7656c = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.layout-section-container': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            gap: "var(--ds-space-600, 48px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`@container layout-area (max-width:${$2e5d010f6440279f$var$LAYOUT_BREAKPOINT_RENDERER}px)`]: {
                flexDirection: 'column',
                gap: "var(--ds-space-400, 32px)"
            }
        }
    }
});

});

parcelRegister("4E5wI", function(module, exports) {

$parcel$export(module.exports, "DateSharedCssClassName", () => $174371b9df7208d5$export$99cdf122d0bb9f95);
$parcel$export(module.exports, "dateSharedStyle", () => $174371b9df7208d5$export$86f86bd772084bf4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
const $174371b9df7208d5$export$99cdf122d0bb9f95 = {
    DATE_WRAPPER: `date-lozenger-container`,
    DATE_CONTAINER: 'dateView-content-wrap'
};
const $174371b9df7208d5$export$86f86bd772084bf4 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$174371b9df7208d5$export$99cdf122d0bb9f95.DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    }
});

});

parcelRegister("kZxLT", function(module, exports) {

$parcel$export(module.exports, "StatusSharedCssClassName", () => $1b48498df0149da7$export$b18e58a1c082b710);
$parcel$export(module.exports, "getStatusSharedStyles", () => $1b48498df0149da7$export$1e03960666c96c29);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");
function $1b48498df0149da7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1b48498df0149da7$export$b18e58a1c082b710 = {
    STATUS_CONTAINER: 'statusView-content-wrap',
    STATUS_LOZENGE: 'status-lozenge-span'
};
var $1b48498df0149da7$var$_ref = {
    name: "0",
    styles: ""
};
const $1b48498df0149da7$export$1e03960666c96c29 = ()=>// eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $VSDnB.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$1b48498df0149da7$export$b18e58a1c082b710.STATUS_LOZENGE} > span `]: {
            border: `1px solid ${"var(--ds-border-inverse, #FFF)"}`
        }
    }) : $1b48498df0149da7$var$_ref;

});

parcelRegister("idytF", function(module, exports) {

$parcel$export(module.exports, "headingsSharedStyles", () => $152b62c033bbf99a$export$9272613b68afed4b);
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/use-tokens-space */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $04VvC = parcelRequire("04VvC");
const $152b62c033bbf99a$var$headingWithAlignmentStyles = ()=>// Override marginTop: 0 with default margin found in headingsSharedStyles for first heading in alignment block that is not the first child
    (0, $VSDnB.fg)('platform_editor_heading_margin_fix') ? {
        '.fabric-editor-block-mark.fabric-editor-alignment:not(:first-child)': {
            '> h1:first-child': {
                marginTop: '1.667em'
            },
            ' > h2:first-child': {
                marginTop: '1.8em'
            },
            '> h3:first-child': {
                marginTop: '2em'
            },
            '> h4:first-child': {
                marginTop: '1.357em'
            },
            '> h5:first-child': {
                marginTop: '1.667em'
            },
            '> h6:first-child': {
                marginTop: '1.455em'
            }
        },
        // Set marginTop: 0 if alignment block is next to a gap cursor or widget that is first child
        '.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment': {
            '> :is(h1, h2, h3, h4, h5, h6):first-child': {
                marginTop: '0'
            }
        }
    } : {};
const $152b62c033bbf99a$export$9272613b68afed4b = (typographyTheme)=>{
    if ((0, $VSDnB.fg)('platform_editor_typography_ugc')) return /*#__PURE__*/ (0, $f8Sb3.css)({
        '& h1': {
            font: (0, $04VvC.default)('editor.font.heading.h1', typographyTheme),
            marginBottom: 0,
            marginTop: '1.45833em',
            '& strong': {
                fontWeight: (0, $04VvC.default)('editor.font.weight.heading.h1.bold', typographyTheme)
            },
            '&::before': {}
        },
        '& h2': {
            font: (0, $04VvC.default)('editor.font.heading.h2', typographyTheme),
            marginTop: '1.4em',
            marginBottom: 0,
            '& strong': {
                fontWeight: (0, $04VvC.default)('editor.font.weight.heading.h1.bold', typographyTheme)
            }
        },
        '& h3': {
            font: (0, $04VvC.default)('editor.font.heading.h3', typographyTheme),
            marginTop: '1.31249em',
            marginBottom: 0,
            '& strong': {
                fontWeight: (0, $04VvC.default)('editor.font.weight.heading.h1.bold', typographyTheme)
            }
        },
        '& h4': {
            font: (0, $04VvC.default)('editor.font.heading.h4', typographyTheme),
            marginTop: '1.25em',
            '& strong': {
                fontWeight: (0, $04VvC.default)('editor.font.weight.heading.h1.bold', typographyTheme)
            }
        },
        '& h5': {
            font: (0, $04VvC.default)('editor.font.heading.h5', typographyTheme),
            marginTop: '1.45833em',
            textTransform: 'none',
            '& strong': {
                fontWeight: (0, $04VvC.default)('editor.font.weight.heading.h1.bold', typographyTheme)
            }
        },
        '& h6': {
            font: (0, $04VvC.default)('editor.font.heading.h6', typographyTheme),
            marginTop: '1.59091em',
            textTransform: 'none',
            '& strong': {
                fontWeight: (0, $04VvC.default)('editor.font.weight.heading.h1.bold', typographyTheme)
            }
        },
        ...$152b62c033bbf99a$var$headingWithAlignmentStyles()
    });
    else return /*#__PURE__*/ (0, $f8Sb3.css)({
        '& h1': {
            fontSize: `${24 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 28 / 24,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            letterSpacing: `-0.01em`,
            marginBottom: 0,
            marginTop: '1.667em'
        },
        '& h2': {
            fontSize: `${20 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 1.2,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            letterSpacing: `-0.008em`,
            marginTop: '1.8em',
            marginBottom: 0
        },
        '& h3': {
            fontSize: `${16 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 1.25,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            letterSpacing: `-0.006em`,
            marginTop: '2em',
            marginBottom: 0
        },
        '& h4': {
            fontSize: `${1}em`,
            fontStyle: 'inherit',
            lineHeight: 16 / 14,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            letterSpacing: `-0.003em`,
            marginTop: '1.357em'
        },
        '& h5': {
            fontSize: `${12 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 16 / 12,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            marginTop: '1.667em',
            textTransform: 'none'
        },
        '& h6': {
            fontSize: `${11 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 16 / 11,
            color: "var(--ds-text-subtlest, #626F86)",
            fontWeight: "var(--ds-font-weight-bold, 700)",
            marginTop: '1.455em',
            textTransform: 'none'
        },
        ...$152b62c033bbf99a$var$headingWithAlignmentStyles()
    });
};

});
parcelRegister("04VvC", function(module, exports) {

$parcel$export(module.exports, "default", () => $53f731000984869b$export$2e2bcd8739ae039);

var $kqZva = parcelRequire("kqZva");
function $53f731000984869b$var$editorUGCToken(path, typographyTheme) {
    let token;
    switch(typographyTheme){
        case 'typography-modernized':
            token = (0, $kqZva.editorUGCTokensModernized)[path];
            break;
        case 'typography-refreshed':
            token = (0, $kqZva.editorUGCTokensRefreshed)[path];
            break;
        default:
            token = (0, $kqZva.editorUGCTokens)[path];
            break;
    }
    return token;
}
var $53f731000984869b$export$2e2bcd8739ae039 = $53f731000984869b$var$editorUGCToken;

});
parcelRegister("kqZva", function(module, exports) {

$parcel$export(module.exports, "editorUGCTokens", () => $5558cddd9c1ce385$export$4a3637dc6e2ae29e);
$parcel$export(module.exports, "editorUGCTokensModernized", () => $5558cddd9c1ce385$export$95588e746468319e);
$parcel$export(module.exports, "editorUGCTokensRefreshed", () => $5558cddd9c1ce385$export$63adc0ebe3278d31);
const $5558cddd9c1ce385$export$4a3637dc6e2ae29e = {
    'editor.font.heading.h1': 'normal 500 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 500 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 700 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
const $5558cddd9c1ce385$export$95588e746468319e = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600  1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600  0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
const $5558cddd9c1ce385$export$63adc0ebe3278d31 = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};

});



parcelRegister("5fBxY", function(module, exports) {

$parcel$export(module.exports, "indentationSharedStyles", () => $586c09e19d6f6d26$export$6856b92f564d3de8);
/* eslint-disable @atlaskit/design-system/use-tokens-space */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $586c09e19d6f6d26$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $586c09e19d6f6d26$export$6856b92f564d3de8 = {
    name: "1bgz9nd",
    styles: ".fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}"
};

});

parcelRegister("ceYEW", function(module, exports) {

$parcel$export(module.exports, "richMediaClassName", () => $5c06afce66d8efef$export$cfe6da7d522d87bb);
$parcel$export(module.exports, "mediaSingleSharedStyle", () => $5c06afce66d8efef$export$d031611b96ba4cf0);
$parcel$export(module.exports, "mediaSingleSharedStyleNew", () => $5c06afce66d8efef$export$b51dea84d928a378);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
const $5c06afce66d8efef$export$cfe6da7d522d87bb = 'rich-media-item';
const $5c06afce66d8efef$var$wrappedMediaBreakoutPoint = 410;
const $5c06afce66d8efef$export$d031611b96ba4cf0 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$5c06afce66d8efef$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});
const $5c06afce66d8efef$export$b51dea84d928a378 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".mediaSingleView-content-wrap[layout^='wrap-']": {
        position: 'relative',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        zIndex: (0, $iHYdz.akEditorWrappedNodeZIndex)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$5c06afce66d8efef$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});

});

parcelRegister("4jyW9", function(module, exports) {

$parcel$export(module.exports, "paragraphSharedStyles", () => $0bce92e99beab9a0$export$2f49074d75b0e29f);
/* eslint-disable @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");

var $04VvC = parcelRequire("04VvC");
const $0bce92e99beab9a0$export$2f49074d75b0e29f = (typographyTheme)=>{
    return (0, $VSDnB.fg)('platform_editor_typography_ugc') ? /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            font: (0, $04VvC.default)('editor.font.body', typographyTheme),
            marginTop: (0, $iHYdz.blockNodesVerticalMargin),
            marginBottom: 0
        }
    }) : /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            fontSize: '1em',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            lineHeight: (0, $iHYdz.akEditorLineHeight),
            fontWeight: "var(--ds-font-weight-regular, 400)",
            marginTop: (0, $iHYdz.blockNodesVerticalMargin),
            marginBottom: 0,
            letterSpacing: '-0.005em'
        }
    });
};

});

parcelRegister("bv4Ps", function(module, exports) {

$parcel$export(module.exports, "ruleSharedStyles", () => $f15d364691bf541f$export$329434b3a2da905e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
const $f15d364691bf541f$export$329434b3a2da905e = ()=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& hr': {
            border: 'none',
            backgroundColor: "var(--ds-border, #091E4224)",
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            margin: `${(0, $iHYdz.akEditorLineHeight)}em 0`,
            height: '2px',
            borderRadius: '1px'
        }
    });

});

parcelRegister("aSoqv", function(module, exports) {

$parcel$export(module.exports, "shadowSharedStyle", () => $0235d3a2f78ffda6$export$985ce3da3286f9ed);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");

var $ajc8Z = parcelRequire("ajc8Z");

var $bbl9Y = parcelRequire("bbl9Y");
const $0235d3a2f78ffda6$var$shadowWidth = 8;
/**
 * TODO: This is close to working and removes a tone of JS from OverflowShadow component
 *
 *  background: linear-gradient(to right, white 30%, rgba(255, 255, 255, 0)),
 *         linear-gradient(to right, rgba(255, 255, 255, 0), white 70%) 100% 0,
 *        linear-gradient(to right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0)),
 *         linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.2)) 100% 0;
 *       background-repeat: no-repeat;
 *       background-color: white;
 *       background-size: 40px 100%, 40px 100%, 14px 100%, 14px 100%;
 *
 *      background-attachment: local, local, scroll, scroll;
 */ const $0235d3a2f78ffda6$export$985ce3da3286f9ed = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::before, .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::after, .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}::before, .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}::after`]: {
        display: 'none',
        position: 'absolute',
        pointerEvents: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $iHYdz.akEditorShadowZIndex),
        width: `${$0235d3a2f78ffda6$var$shadowWidth}px`,
        content: "''",
        height: 'calc(100%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}, .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}`]: {
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}::before`]: {
        background: `linear-gradient( to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        top: '0px',
        left: 0,
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::after`]: {
        background: `linear-gradient( to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        right: '0px',
        top: '0px',
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $bbl9Y.shadowObserverClassNames).SENTINEL_LEFT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $bbl9Y.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    }
});

});

parcelRegister("iJOES", function(module, exports) {

$parcel$export(module.exports, "SmartCardSharedCssClassName", () => $bc13534612fcd0a2$export$4ccd31bf665a88f6);
$parcel$export(module.exports, "smartCardSharedStyles", () => $bc13534612fcd0a2$export$83e107f0a431e184);

var $iHYdz = parcelRequire("iHYdz");
const $bc13534612fcd0a2$export$4ccd31bf665a88f6 = {
    INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
    BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
    EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
    DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
    LOADER_WRAPPER: 'loader-wrapper'
};
const $bc13534612fcd0a2$export$83e107f0a431e184 = `
  .${$bc13534612fcd0a2$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER} {
    display: block;
    margin: ${(0, $iHYdz.blockNodesVerticalMargin)} 0 0;
    max-width: ${760}px;
  }
`;

});

parcelRegister("1bQ0V", function(module, exports) {

$parcel$export(module.exports, "TaskDecisionSharedCssClassName", () => $2398d5ed497032ce$export$a7172b75d403a0e4);
$parcel$export(module.exports, "tasksAndDecisionsStyles", () => $2398d5ed497032ce$export$df437277fbc8b4f5);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
const $2398d5ed497032ce$export$a7172b75d403a0e4 = {
    DECISION_CONTAINER: 'decisionItemView-content-wrap',
    TASK_CONTAINER: 'taskItemView-content-wrap',
    TASK_ITEM: 'task-item'
};
const $2398d5ed497032ce$export$df437277fbc8b4f5 = /*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{.taskItemView-content-wrap,.", $2398d5ed497032ce$export$a7172b75d403a0e4.DECISION_CONTAINER, "{position:relative;min-width:", (0, $iHYdz.akEditorTableCellMinWidth), "px;}.", $2398d5ed497032ce$export$a7172b75d403a0e4.DECISION_CONTAINER, "{margin-top:0;}.", $2398d5ed497032ce$export$a7172b75d403a0e4.TASK_CONTAINER, "{span[contenteditable='false']{height:", (0, $iHYdz.akEditorLineHeight), "em;}}.", $2398d5ed497032ce$export$a7172b75d403a0e4.TASK_ITEM, "{line-height:", (0, $iHYdz.akEditorLineHeight), ";}}div[data-task-local-id]{span[contenteditable='false']{height:", (0, $iHYdz.akEditorLineHeight), "em;}span[contenteditable='false']+div{line-height:", (0, $iHYdz.akEditorLineHeight), "em;}}div[data-task-list-local-id]{margin:var(--ds-space-150, 12px) 0 0 0;}div[data-task-list-local-id]{div+div{margin-top:var(--ds-space-050, 4px);}}div[data-task-list-local-id] div[data-task-list-local-id]{margin-top:var(--ds-space-050, 4px);margin-left:var(--ds-space-300, 24px);}.ak-editor-panel__content{>div[data-task-list-local-id]:first-child{margin:0 0 0 0!important;}}");

});

parcelRegister("jRk4M", function(module, exports) {

$parcel$export(module.exports, "textColorStyles", () => $e9c9f96b9e0ca8df$export$a518ea5d00002b38);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $e9c9f96b9e0ca8df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e9c9f96b9e0ca8df$export$a518ea5d00002b38 = {
    name: "1nlqh0j",
    styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
};

});

parcelRegister("fwxzS", function(module, exports) {

$parcel$export(module.exports, "whitespaceSharedStyles", () => $308dad73f97ce24c$export$c9ce3bfa46d7acba);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $308dad73f97ce24c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $308dad73f97ce24c$export$c9ce3bfa46d7acba = {
    name: "1s8ykn2",
    styles: "word-wrap:break-word;white-space:pre-wrap"
};

});

parcelRegister("2o2hu", function(module, exports) {

$parcel$export(module.exports, "getLightWeightCodeBlockStylesForRootRendererStyleSheet", () => $67d1fb0f1c6fc210$export$3f1ff491ca7c4c4a);
$parcel$export(module.exports, "default", () => $67d1fb0f1c6fc210$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");

var $cYeQP = parcelRequire("cYeQP");

var $23OJc = parcelRequire("23OJc");

var $l8Gxi = parcelRequire("l8Gxi");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $67d1fb0f1c6fc210$var$lightWeightCodeBlockStyles = /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{cursor:text;}");
const $67d1fb0f1c6fc210$export$afbde0e7339bed51 = {
    CONTAINER: 'light-weight-code-block'
};
const $67d1fb0f1c6fc210$export$3f1ff491ca7c4c4a = ()=>{
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $l8Gxi.RendererCssClassName).DOCUMENT, ">.", $67d1fb0f1c6fc210$export$afbde0e7339bed51.CONTAINER, " .", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{margin-top:", (0, $iHYdz.blockNodesVerticalMargin), ";}");
};
const $67d1fb0f1c6fc210$var$LightWeightCodeBlock = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ text: text, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, className: className }, ref)=>{
    const textRows = (0, $5uXOq.useMemo)(()=>(text ?? '').split('\n'), [
        text
    ]);
    const { renderBidiWarnings: renderBidiWarnings } = (0, $23OJc.useBidiWarnings)({
        enableWarningTooltip: codeBidiWarningTooltipEnabled
    });
    const classNames = [
        $67d1fb0f1c6fc210$export$afbde0e7339bed51.CONTAINER,
        className
    ].join(' ');
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            (0, $cYeQP.codeBlockSharedStyles)(),
            $67d1fb0f1c6fc210$var$lightWeightCodeBlockStyles
        ]
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        className: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER
    }, textRows.map((_, index)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            key: index
        }))), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        className: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("code", null, renderBidiWarnings(text))))));
});
var $67d1fb0f1c6fc210$export$2e2bcd8739ae039 = $67d1fb0f1c6fc210$var$LightWeightCodeBlock;

});
parcelRegister("23OJc", function(module, exports) {

$parcel$export(module.exports, "useBidiWarnings", () => $807954ab13bca9b8$export$9fb9fe546a188c7b);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $lrHA4 = parcelRequire("lrHA4");

var $fJyLQ = parcelRequire("fJyLQ");

var $31cgS = parcelRequire("31cgS");
const $807954ab13bca9b8$export$9fb9fe546a188c7b = ({ enableWarningTooltip: enableWarningTooltip = true })=>{
    const intl = (0, $koVbs.default)();
    const warningLabel = intl.formatMessage((0, $fJyLQ.codeBidiWarningMessages).label);
    const renderBidiWarnings = (text)=>{
        return (0, $31cgS.default)(text, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lrHA4.default), {
                bidiCharacter: bidiCharacter,
                key: index,
                label: warningLabel,
                tooltipEnabled: enableWarningTooltip
            }));
    };
    return {
        renderBidiWarnings: renderBidiWarnings,
        warningLabel: warningLabel
    };
};

});
parcelRegister("lrHA4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e6443bd1dfeaac7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $abxiq = parcelRequire("abxiq");
function $2e6443bd1dfeaac7$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    if (tooltipEnabled) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label,
        tag: $2e6443bd1dfeaac7$var$CustomizedTagWithRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $abxiq.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, skipChildren ? null : bidiCharacter)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $abxiq.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, skipChildren ? null : bidiCharacter);
}
const $2e6443bd1dfeaac7$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        ...rest,
        ref: ref
    }, children);
});

});
parcelRegister("abxiq", function(module, exports) {

$parcel$export(module.exports, "Decorator", () => $59fdc1b7b0ae96c9$export$a592b67c93d52467);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $jldZL = parcelRequire("jldZL");
const $59fdc1b7b0ae96c9$var$decoration = /*#__PURE__*/ (0, $f8Sb3.css)({
    // Required as otherwise the following bidi characters cause the span
    // to not receive hover events.
    //
    // U+2066 LEFT-TO-RIGHT ISOLATE (when using pseudo element before)
    // U+202E RIGHT-TO-LEFT OVERRIDE' (when using pseudo element after)
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':before': {
        display: 'inline-flex',
        padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        background: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
        color: "var(--ds-text-warning, #7F5F01)",
        content: '"<"attr(data-bidi-character-code)">"',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        fontStyle: 'normal',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '18px',
        /**
     * Ensures the decoration receives pointer events when it occurs with
     * an ancestor that disables them.
     */ pointerEvents: 'auto'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover:before': {
        background: `var(--ds-background-warning-hovered, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
        color: "var(--ds-text-warning, #533F04)"
    }
});
function $59fdc1b7b0ae96c9$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $59fdc1b7b0ae96c9$var$decoration,
        "data-testid": testId,
        "data-bidi-character-code": bidiCharacterCode,
        // This is set to true so that the content is not read out by
        // screen readers as the content includes angle brackets for
        // visual decoration purposes.
        // We use a visually hidden `mark` element below for screen readers
        "aria-hidden": "true"
    }, children), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jldZL.default), {
        testId: testId && `${testId}--visually-hidden`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("mark", null, bidiCharacterCode)));
}
function $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("31cgS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e16562bd8c2aca9b$export$2e2bcd8739ae039);
const $e16562bd8c2aca9b$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $e16562bd8c2aca9b$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($e16562bd8c2aca9b$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});



const $75c933b3daaf1f19$export$bd4f24d8b1e86b23 = `ak-renderer-tableHeader-sorting-icon`;


parcelRegister("cWojJ", function(module, exports) {

$parcel$export(module.exports, "TableHeader", () => $decaf4f5703baa00$export$f850895b287ef28e);
$parcel$export(module.exports, "TableCell", () => $decaf4f5703baa00$export$1e4baea7053fc0e3);

var $5uXOq = parcelRequire("5uXOq");

var $87j2U = parcelRequire("87j2U");
var $9UDEr = parcelRequire("9UDEr");

var $hxoiH = parcelRequire("hxoiH");

var $9BYlQ = parcelRequire("9BYlQ");

var $hAs1r = parcelRequire("hAs1r");

var $hrpWq = parcelRequire("hrpWq");

var $knXBU = parcelRequire("knXBU");

var $gkwXh = parcelRequire("gkwXh");

var $l8Gxi = parcelRequire("l8Gxi");

var $koVbs = parcelRequire("koVbs");

var $1Bd5P = parcelRequire("1Bd5P");
const $decaf4f5703baa00$var$IgnoreSorting = [
    'LABEL',
    'INPUT'
];
const $decaf4f5703baa00$var$nextStatusOrder = (currentSortOrder)=>{
    switch(currentSortOrder){
        case (0, $9BYlQ.SortOrder).NO_ORDER:
            return (0, $9BYlQ.SortOrder).ASC;
        case (0, $9BYlQ.SortOrder).ASC:
            return (0, $9BYlQ.SortOrder).DESC;
        case (0, $9BYlQ.SortOrder).DESC:
            return (0, $9BYlQ.SortOrder).NO_ORDER;
    }
    return (0, $9BYlQ.SortOrder).NO_ORDER;
};
const $decaf4f5703baa00$var$getSortOrderLabel = (intl, currentSortOrder)=>{
    const { noneSortingLabel: noneSortingLabel, ascSortingLabel: ascSortingLabel, descSortingLabel: descSortingLabel } = (0, $1Bd5P.tableCellMessages);
    switch(currentSortOrder){
        case (0, $9BYlQ.SortOrder).NO_ORDER:
            return intl.formatMessage(noneSortingLabel);
        case (0, $9BYlQ.SortOrder).ASC:
            return intl.formatMessage(ascSortingLabel);
        case (0, $9BYlQ.SortOrder).DESC:
            return intl.formatMessage(descSortingLabel);
        default:
            return intl.formatMessage(noneSortingLabel);
    }
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $decaf4f5703baa00$var$getDataAttributes = (colwidth, background)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const attrs = {};
    if (colwidth) attrs['data-colwidth'] = colwidth.join(',');
    /**
   * Storing hex code in data-cell-background because
   *  we want to have DST token (css variable) or
   *  DST token value (value (hex code) of css variable) in
   *  inline style to correct render table cell background
   *  based on selected theme.
   * Currently we rely on background color hex code stored in
   *  inline style.
   * Because of that when we copy and paste table, we end up
   *  having DST token or DST token value in ADF instead of
   *  original hex code which we map to DST token.
   * So, introducing data-cell-background.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ if (background) attrs['data-cell-background'] = background;
    return attrs;
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $decaf4f5703baa00$var$cssVariablePattern = /^var\(--.*\)$/;
const $decaf4f5703baa00$var$getStyle = ({ background: background, colGroupWidth: colGroupWidth, offsetTop: offsetTop, colorMode: colorMode })=>{
    const style = {};
    if (background && // ignore setting inline styles if ds neutral token is detected
    !background.includes('--ds-background-neutral')) {
        /**
     * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
     * backgrounds persisted.
     *
     * This feature predates the introduction of dark mode.
     *
     * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-cell-background), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $hAs1r.hexToEditorBackgroundPaletteRawValue)(background);
        if (tokenColor) style.backgroundColor = tokenColor;
        else if (/**
     * There was previously a bug in dark mode where we would attempt to invert
     * a design token in `getDarkModeLCHColor` causing issues.
     * If it's a design token we should return it as is.
     */ $decaf4f5703baa00$var$cssVariablePattern.test(background)) style.backgroundColor = background;
        else // if we have a custom color, we need to check if we are in dark mode
        if (colorMode === 'dark') // if we are in dark mode, we need to invert the color
        style.backgroundColor = (0, $87j2U.getDarkModeLCHColor)(background);
        else // if we are in light mode, we can just set the color
        style.backgroundColor = background;
    }
    if (colGroupWidth) {
        style.width = colGroupWidth;
        style.minWidth = colGroupWidth;
    }
    if (offsetTop !== undefined) style.top = offsetTop;
    return style;
};
const $decaf4f5703baa00$var$getWithCellProps = (WrapperComponent)=>{
    return function WithCellProps(props) {
        const { colorMode: colorMode } = (0, $hxoiH.default)();
        const { children: children, className: className, onClick: onClick, colwidth: colwidth, colGroupWidth: colGroupWidth, rowspan: rowspan, colspan: colspan, background: background, offsetTop: offsetTop, ariaSort: ariaSort } = props;
        // This is used to set the background color of the cell
        // to a dark mode color in mobile dark mode
        const colorName = background ? (0, $9UDEr.tableBackgroundColorPalette).get(background) : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrapperComponent, {
            rowSpan: rowspan,
            colSpan: colspan,
            // Note: When content from a renderer is pasted into an editor
            // the background color is not taken from the inline style.
            // Instead it is taken from the data-cell-background attribute
            // (added via getDataAttributes below).
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $decaf4f5703baa00$var$getStyle({
                background: background,
                colGroupWidth: colGroupWidth,
                offsetTop: offsetTop,
                colorMode: colorMode
            }),
            colorname: colorName,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ...$decaf4f5703baa00$var$getDataAttributes(colwidth, background),
            "aria-sort": ariaSort
        }, children);
    };
};
const $decaf4f5703baa00$var$TH = $decaf4f5703baa00$var$getWithCellProps('th');
const $decaf4f5703baa00$export$cfca40ca5c56a38e = (WrapperComponent)=>{
    return function THWithSortableColumn(props) {
        const intl = (0, $koVbs.default)();
        const { allowColumnSorting: allowColumnSorting, onSorting: onSorting, children: children, sortOrdered: sortOrdered, isHeaderRow: isHeaderRow } = props;
        const sortOrderedClassName = sortOrdered === (0, $9BYlQ.SortOrder).NO_ORDER ? (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER : '';
        if (!allowColumnSorting || !isHeaderRow) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrapperComponent, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrapperComponent, {
            ...props,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_WRAPPER,
            ariaSort: $decaf4f5703baa00$var$getSortOrderLabel(intl, sortOrdered)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN
        }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("figure", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER} ${sortOrderedClassName}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hrpWq.default), {
            isSortingAllowed: !!onSorting,
            sortOrdered: sortOrdered,
            onClick: sort,
            onKeyDown: onKeyPress
        }))));
        function onKeyPress(event) {
            const keys = [
                ' ',
                'Enter',
                'Spacebar'
            ];
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const { tagName: tagName } = event.target;
            // trigger sorting if space or enter are clicked but not when in an input field (template variables)
            if (keys.includes(event.key) && !$decaf4f5703baa00$var$IgnoreSorting.includes(tagName)) {
                event.preventDefault();
                sort();
            }
        }
        function sort() {
            const { fireAnalyticsEvent: fireAnalyticsEvent, onSorting: onSorting, columnIndex: columnIndex, sortOrdered: sortOrdered } = props;
            if (onSorting && columnIndex != null) {
                const sortOrder = $decaf4f5703baa00$var$nextStatusOrder(sortOrdered);
                onSorting(columnIndex, sortOrder);
                fireAnalyticsEvent && fireAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).SORT_COLUMN,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                    attributes: {
                        platform: (0, $knXBU.PLATFORM).WEB,
                        mode: (0, $knXBU.MODE).RENDERER,
                        columnIndex: columnIndex,
                        sortOrder: sortOrder
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).TRACK
                });
            } else fireAnalyticsEvent && fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).SORT_COLUMN_NOT_ALLOWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB,
                    mode: (0, $knXBU.MODE).RENDERER
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            });
        }
    };
};
const $decaf4f5703baa00$export$f850895b287ef28e = $decaf4f5703baa00$export$cfca40ca5c56a38e($decaf4f5703baa00$var$TH);
const $decaf4f5703baa00$var$TD = $decaf4f5703baa00$var$getWithCellProps('td');
const $decaf4f5703baa00$export$1e4baea7053fc0e3 = $decaf4f5703baa00$var$TD;

});
parcelRegister("hrpWq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d33846969f29997f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $VSDnB = parcelRequire("VSDnB");

var $3bDjY = parcelRequire("3bDjY");

var $9BYlQ = parcelRequire("9BYlQ");


var $3hakN = parcelRequire("3hakN");
function $d33846969f29997f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d33846969f29997f$var$annotationRangeFixStyle = {
    name: "oldbq4",
    styles: "user-select:none"
};
var $d33846969f29997f$export$c3618f310f725028 = /*#__PURE__*/ function(StatusClassNames) {
    StatusClassNames["ASC"] = "sorting-icon-svg__asc";
    StatusClassNames["DESC"] = "sorting-icon-svg__desc";
    StatusClassNames["NO_ORDER"] = "sorting-icon-svg__no_order";
    StatusClassNames["SORTING_NOT_ALLOWED"] = "sorting-icon-svg__not-allowed";
    return StatusClassNames;
}({});
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $d33846969f29997f$var$buttonStyles = /*#__PURE__*/ (0, $f8Sb3.css)("position:absolute;display:flex;height:28px;width:28px;margin:var(--ds-space-075, 6px);right:0;top:0;border:2px solid var(--ds-border, #fff);border-radius:var(--ds-border-radius-100, 4px);background-color:var(--ds-surface-overlay, #FFFFFF);justify-content:center;align-items:center;cursor:pointer;&:hover{background-color:var(--ds-surface-overlay-hovered, #F1F2F4);}&:active{background-color:var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6));}&.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "__not-allowed{cursor:not-allowed;}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $d33846969f29997f$var$iconWrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)("width:8px;height:12px;transition:transform 0.3s cubic-bezier(0.15, 1, 0.3, 1);transform-origin:50% 50%;display:flex;justify-content:center;&.", "sorting-icon-svg__desc", "{transform:rotate(-180deg);}&.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "-inactive{opacity:0.7;}");
// The icon is created with CSS due to the following Firefox issue: https://product-fabric.atlassian.net/browse/ED-8001
// The TL;DR is that svg's in tables mess up how HTML is copied in Firefox. Using a styled div instead solves the problem.
// For this reason, svg's should be avoided in tables until this issue is fixed: https://bugzilla.mozilla.org/show_bug.cgi?id=1664350
const $d33846969f29997f$var$iconStyles = {
    name: "1uj2pwb",
    styles: "height:100%;width:2px;border-radius:50px;background:var(--ds-icon, #42526E);&::before, &::after{background:var(--ds-icon, #42526E);content:'';height:2px;width:6px;position:absolute;border-radius:50px;}&::before{transform:rotate(45deg) translate(3.4px, 8.5px);}&::after{transform:rotate(-45deg) translate(-6.3px, 5.7px);}"
};
const $d33846969f29997f$var$getIconClassName = (isSortingAllowed, sortOrdered)=>{
    const activated = sortOrdered !== (0, $9BYlQ.SortOrder).NO_ORDER;
    const activeStatusClass = `${(0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23)}-${activated ? 'active' : 'inactive'}`;
    if (!isSortingAllowed) return `${"sorting-icon-svg__not-allowed"} ${activeStatusClass}`;
    switch(sortOrdered){
        case (0, $9BYlQ.SortOrder).ASC:
            return `${"sorting-icon-svg__asc"} ${activeStatusClass}`;
        case (0, $9BYlQ.SortOrder).DESC:
            return `${"sorting-icon-svg__desc"} ${activeStatusClass}`;
        default:
            return `${"sorting-icon-svg__no_order"} ${activeStatusClass}`;
    }
};
const $d33846969f29997f$var$getTooltipTitle = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel } = (0, $3hakN.sortingIconMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $9BYlQ.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $9BYlQ.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $9BYlQ.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return '';
};
const $d33846969f29997f$var$getAriaLabel = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel, defaultLabel: defaultLabel } = (0, $3hakN.sortingAriaLabelMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $9BYlQ.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $9BYlQ.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $9BYlQ.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return intl.formatMessage(defaultLabel);
};
const $d33846969f29997f$var$SortingIcon = ({ isSortingAllowed: isSortingAllowed, sortOrdered: sortOrdered, intl: intl, onClick: onClick, onKeyDown: onKeyDown })=>{
    const buttonClassName = `${(0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23)} ${sortOrdered !== (0, $9BYlQ.SortOrder).NO_ORDER ? 'is-active' : ''}${isSortingAllowed ? '' : ` ${0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23}__not-allowed `}`;
    const content = $d33846969f29997f$var$getTooltipTitle(intl, isSortingAllowed, sortOrdered);
    const ariaLabel = $d33846969f29997f$var$getAriaLabel(intl, isSortingAllowed, sortOrdered);
    const handleClick = ()=>{
        if (isSortingAllowed) onClick();
    };
    const handleKeyDown = (event)=>{
        if (isSortingAllowed) onKeyDown(event);
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        delay: 0,
        content: content,
        position: "top"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $d33846969f29997f$var$buttonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: buttonClassName,
        role: "button",
        tabIndex: isSortingAllowed ? 0 : -1,
        "aria-label": ariaLabel,
        "aria-disabled": !isSortingAllowed,
        "aria-hidden": (0, $VSDnB.fg)('platform_renderer_table_sort_btn_aria_hidden') ? !isSortingAllowed : undefined,
        onClick: handleClick,
        onKeyDown: handleKeyDown
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $d33846969f29997f$var$iconWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $d33846969f29997f$var$getIconClassName(isSortingAllowed, sortOrdered)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $d33846969f29997f$var$iconStyles,
            (0, $VSDnB.fg)('platform_editor_allow_annotation_triple_click') && $d33846969f29997f$var$annotationRangeFixStyle
        ]
    }))));
};
var $d33846969f29997f$export$2e2bcd8739ae039 = (0, $8RXs9.default)($d33846969f29997f$var$SortingIcon);

});
parcelRegister("3hakN", function(module, exports) {

$parcel$export(module.exports, "sortingIconMessages", () => $c1f584a2cfc01515$export$458c50917513cd1a);
$parcel$export(module.exports, "sortingAriaLabelMessages", () => $c1f584a2cfc01515$export$f142573f51a67577);

var $7VHMR = parcelRequire("7VHMR");
const $c1f584a2cfc01515$export$458c50917513cd1a = (0, $7VHMR.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.headingLink.noOrderLabel',
        defaultMessage: 'Sort column A to Z',
        description: 'Sort the column in ascending order'
    },
    ascOrderLabel: {
        id: 'fabric.editor.headingLink.ascOrderLabel',
        defaultMessage: 'Sort column Z to A',
        description: 'Sort the column in descending order'
    },
    descOrderLabel: {
        id: 'fabric.editor.headingLink.descOrderLabel',
        defaultMessage: 'Clear sorting',
        description: 'clear the sorting from this column'
    },
    invalidLabel: {
        id: 'fabric.editor.headingLink.invalidLabel',
        defaultMessage: `\u{26A0}\u{FE0F}  You can't sort a table with merged cells`,
        description: 'this sort is invalid for merged cells'
    }
});
const $c1f584a2cfc01515$export$f142573f51a67577 = (0, $7VHMR.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.no',
        defaultMessage: 'No sort applied to the column',
        description: 'Aria-label for Sort column button when sorting was not applied or the sorting has been cleared'
    },
    ascOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.asc',
        defaultMessage: 'Ascending sort applied',
        description: 'Aria-label for Sort column button when ascending sorting was applied'
    },
    descOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.desc',
        defaultMessage: 'Descending sort applied',
        description: 'Aria-label for Sort column button when descending sorting was applied'
    },
    invalidLabel: {
        id: 'fabric.editor.tableHeader.sorting.invalid',
        defaultMessage: `You can't sort a table with merged cells`,
        description: 'Aria-label for Sort column button when sorting is not possible'
    },
    defaultLabel: {
        id: 'fabric.editor.tableHeader.sorting.default',
        defaultMessage: 'Sort the column',
        description: 'Default aria-label for Sort column button'
    }
});

});



parcelRegister("4BsEy", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $3b927b61a8274f19$export$2881499e37b75b9a);
$parcel$export(module.exports, "withSmartCardStorage", () => $3b927b61a8274f19$export$65e2d5a272a382b0);

var $5uXOq = parcelRequire("5uXOq");
const $3b927b61a8274f19$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(new Map());
const $3b927b61a8274f19$export$2881499e37b75b9a = function({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3b927b61a8274f19$export$841858b892ce1f4c.Provider, {
        value: new Map()
    }, children);
};
const $3b927b61a8274f19$export$65e2d5a272a382b0 = (WrappedComponent)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/prefer-stateless-function
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3b927b61a8274f19$export$841858b892ce1f4c.Consumer, null, (storage)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    ...this.props,
                    smartCardStorage: storage
                }));
        }
    };
};

});

parcelRegister("2aXGN", function(module, exports) {

$parcel$export(module.exports, "tableStickyPadding", () => $9b3e020198447653$export$3de6413b528017ca);
$parcel$export(module.exports, "StickyTable", () => $9b3e020198447653$export$fd9654fc359d55a3);
$parcel$export(module.exports, "OverflowParent", () => $9b3e020198447653$export$e97bc6692974bd0b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6gEe5 = parcelRequire("6gEe5");

var $iHYdz = parcelRequire("iHYdz");


var $a4mor = parcelRequire("a4mor");

var $6cOrl = parcelRequire("6cOrl");
function $9b3e020198447653$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9b3e020198447653$export$3de6413b528017ca = 8;
const $9b3e020198447653$var$modeSpecficStyles = {
    none: {
        name: "eivff4",
        styles: "display:none"
    },
    stick: {
        name: "duudsh",
        styles: "position:fixed"
    },
    'pin-bottom': {
        name: "a4hmbt",
        styles: "position:absolute"
    }
};
// TODO: Quality ticket: https://product-fabric.atlassian.net/browse/DSP-4123
const $9b3e020198447653$var$fixedTableDivStaticStyles = (top, width, allowTableResizing)=>{
    let stickyHeaderZIndex;
    if (allowTableResizing) stickyHeaderZIndex = 13;
    else stickyHeaderZIndex = (0, $iHYdz.akEditorStickyHeaderZIndex);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $f8Sb3.css)(typeof top === 'number' && `top: ${top}px;`, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${width}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: stickyHeaderZIndex,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}, & .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            marginTop: 0,
            marginBottom: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            tr: {
                background: "var(--ds-surface, white)"
            }
        },
        borderTop: `${$9b3e020198447653$export$3de6413b528017ca}px solid ${"var(--ds-surface, white)"}`,
        background: "var(--ds-surface-overlay, white)",
        boxShadow: `0 6px 4px -4px ${`var(--ds-shadow-overflow-perimeter, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "div[data-expanded='false'] &": {
            display: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.right-shadow::after, & .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.left-shadow::before`]: {
            top: '0px',
            height: '100%'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&.fixed-table-div-custom-table-resizing[mode='stick']": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            zIndex: stickyHeaderZIndex
        }
    });
};
const $9b3e020198447653$var$FixedTableDiv = (props)=>{
    const { top: top, wrapperWidth: wrapperWidth, mode: mode, allowTableResizing: allowTableResizing } = props;
    const fixedTableCss = [
        $9b3e020198447653$var$fixedTableDivStaticStyles(top, wrapperWidth, allowTableResizing),
        $9b3e020198447653$var$modeSpecficStyles?.[mode]
    ];
    const attrs = {
        mode: mode
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...attrs,
        "data-testid": "sticky-table-fixed",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: allowTableResizing ? 'fixed-table-div-custom-table-resizing' : '',
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: fixedTableCss
    }, props.children);
};
const $9b3e020198447653$export$fd9654fc359d55a3 = ({ top: top, left: left, mode: mode, shadowClassNames: shadowClassNames, innerRef: innerRef, wrapperWidth: wrapperWidth, tableWidth: tableWidth, isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, children: children, columnWidths: columnWidths, renderWidth: renderWidth, rowHeight: rowHeight, tableNode: tableNode, rendererAppearance: rendererAppearance, allowTableResizing: allowTableResizing })=>{
    let styles;
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ if (allowTableResizing) styles = /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'absolute'
    });
    else styles = /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: left && left < 0 ? left : undefined,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'relative'
    });
    /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: styles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($9b3e020198447653$var$FixedTableDiv, {
        top: mode === 'stick' ? top : undefined,
        mode: rowHeight > 300 ? 'none' : mode,
        wrapperWidth: wrapperWidth,
        allowTableResizing: allowTableResizing
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} is-sticky ${shadowClassNames || ''}`,
        "data-layout": layout,
        style: {
            width: tableWidth
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $a4mor.Table), {
        columnWidths: columnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance
    }, /**
               * @see https://product-fabric.atlassian.net/browse/ED-10235
               * We pass prop 'invisible' to our table's children nodes meaning
               * they exist inside of the 'invisible' duplicated table component that
               * enables sticky headers.
               */ (0, $6cOrl.recursivelyInjectProps)(children, {
        invisible: true
    })))))));
};
/**
 * Traverse DOM Tree upwards looking for table parents with "overflow: scroll".
 */ function $9b3e020198447653$var$findHorizontalOverflowScrollParent(table, defaultScrollRootId) {
    let parent = table;
    if (!parent) return null;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowY === 'scroll') return parent;
        if (!!defaultScrollRootId && parent.id === defaultScrollRootId) // If a defaultScrollRootId was specified and we reached the element with this id without finding a closer
        // scroll parent, use this element as the scroll parent
        return parent;
    }
    return null;
}
class $9b3e020198447653$export$e97bc6692974bd0b {
    constructor(ref){
        this.ref = ref;
        this.ref = ref;
    }
    static fromElement(el, defaultScrollRootId) {
        return new $9b3e020198447653$export$e97bc6692974bd0b($9b3e020198447653$var$findHorizontalOverflowScrollParent(el, defaultScrollRootId) || window);
    }
    get isElement() {
        return this.ref instanceof HTMLElement;
    }
    get id() {
        if (this.ref instanceof HTMLElement) return this.ref.id;
        return '';
    }
    get top() {
        if (this.ref instanceof HTMLElement) return this.ref.getBoundingClientRect().top;
        return 0;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    addEventListener(type, cb, ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.addEventListener(type, cb, ...args);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    removeEventListener(type, cb, ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.removeEventListener(type, cb, ...args);
    }
}

});
parcelRegister("a4mor", function(module, exports) {

$parcel$export(module.exports, "Table", () => $40c6d2c88bc98a0d$export$54ec01a60f47d33d);

var $5uXOq = parcelRequire("5uXOq");

var $3nHPA = parcelRequire("3nHPA");

var $fKLIs = parcelRequire("fKLIs");

var $iHYdz = parcelRequire("iHYdz");
const $40c6d2c88bc98a0d$export$54ec01a60f47d33d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ innerRef: innerRef, isNumberColumnEnabled: isNumberColumnEnabled, columnWidths: columnWidths, layout: layout, renderWidth: renderWidth, children: children, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableResizing: allowTableResizing })=>{
    let tableWidth = tableNode ? (0, $fKLIs.getTableContainerWidth)(tableNode) : (0, $iHYdz.akEditorDefaultLayoutWidth);
    if (rendererAppearance === 'comment' && allowTableResizing && tableNode && !tableNode.attrs?.width) tableWidth = 'inherit';
    if (rendererAppearance === 'comment' && !allowTableResizing) tableWidth = renderWidth;
    const tableLayout = tableNode?.attrs.layout;
    const tableDisplayMode = tableNode?.attrs.displayMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("table", {
        "data-testid": "renderer-table",
        "data-number-column": isNumberColumnEnabled,
        "data-table-width": tableWidth,
        "data-layout": tableLayout,
        "data-table-display-mode": tableDisplayMode,
        ref: innerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3nHPA.Colgroup), {
        columnWidths: columnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance,
        isInsideOfBlockNode: isInsideOfBlockNode,
        isInsideOfTable: isInsideOfTable,
        isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
        allowTableResizing: allowTableResizing
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tbody", null, children));
});

});
parcelRegister("3nHPA", function(module, exports) {

$parcel$export(module.exports, "Colgroup", () => $ae0cfecd7422435f$export$89efc2d0ceeaa030);

var $5uXOq = parcelRequire("5uXOq");

var $6gEe5 = parcelRequire("6gEe5");

var $iHYdz = parcelRequire("iHYdz");

var $gmhCD = parcelRequire("gmhCD");

var $fKLIs = parcelRequire("fKLIs");

var $VSDnB = parcelRequire("VSDnB");

var $9JDnL = parcelRequire("9JDnL");

var $dyURG = parcelRequire("dyURG");
// we allow scaling down column widths by no more than 30%
// this intends to reduce unwanted scrolling in the Renderer in these scenarios:
// User A creates a table with column widths → User B views it on a smaller screen
// User A creates a table with column widths → User A views it with reduced viewport space (eg. Confluence sidebar is open)
const $ae0cfecd7422435f$var$MAX_SCALING_PERCENT = 0.3;
const $ae0cfecd7422435f$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION = 0.4;
const $ae0cfecd7422435f$var$isTableColumnResized = (columnWidths)=>{
    const filteredWidths = columnWidths.filter((width)=>width !== 0);
    return !!filteredWidths.length;
};
const $ae0cfecd7422435f$var$fixColumnWidth = (columnWidth, _tableWidth, _layoutWidth, zeroWidthColumnsCount, scaleDownPercent)=>{
    if (columnWidth === 0) return columnWidth;
    // If the tables total width (including no zero widths col or cols without width) is less than the current layout
    // We scale up the columns to meet the minimum of the table layout.
    if (zeroWidthColumnsCount === 0 && scaleDownPercent) return Math.max(Math.floor((1 - scaleDownPercent) * columnWidth), (0, $6gEe5.tableCellMinWidth));
    return Math.max(// We need to take tableCellBorderWidth, to avoid unnecessary overflow.
    columnWidth - (0, $6gEe5.tableCellBorderWidth), zeroWidthColumnsCount ? (0, $iHYdz.akEditorTableLegacyCellMinWidth) : (0, $6gEe5.tableCellMinWidth));
};
const $ae0cfecd7422435f$var$calcScalePercent = ({ renderWidth: renderWidth, tableWidth: tableWidth, maxScale: maxScale, isNumberColumnEnabled: isNumberColumnEnabled })=>{
    const noNumColumnScalePercent = renderWidth / tableWidth;
    // when numbered column is enabled, we need to calculate the scale percent without the akEditorTableNumberColumnWidth
    // As numbered column width is not scaled down
    const numColumnScalePercent = (renderWidth - (0, $iHYdz.akEditorTableNumberColumnWidth)) / (tableWidth - (0, $iHYdz.akEditorTableNumberColumnWidth));
    const diffPercent = 1 - noNumColumnScalePercent;
    return diffPercent < maxScale ? isNumberColumnEnabled ? 1 - numColumnScalePercent : diffPercent : maxScale;
};
const $ae0cfecd7422435f$var$colWidthSum = (columnWidths)=>columnWidths.reduce((prev, curr)=>curr + prev, 0);
const $ae0cfecd7422435f$var$renderScaleDownColgroup = (props)=>{
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled, renderWidth: renderWidth, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, isTableScalingEnabled: isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer } = props;
    if (!columnWidths) return [];
    const tableColumnResized = $ae0cfecd7422435f$var$isTableColumnResized(columnWidths);
    const noOfColumns = columnWidths.length;
    let targetWidths;
    // This is a fix for ED-23259
    // Some extensions (for ex: Page Properties or Excerpt) do not renderer tables directly inside themselves. They use ReactRenderer.
    // So if we add a check like isInsideExtension (similar to exising isInsideBlockNode), it will fail, and to the only way to learn
    // if the table is rendered inside another node, is to check if the Renderer itself is nested.
    const isRendererNested = isTopLevelRenderer === false && (0, $VSDnB.fg)('platform_editor_nested_table_in_nested_parent_fix');
    // appearance == comment && allowTableResizing && !tableNode?.attrs.width, means it is a comment
    // appearance == comment && !allowTableResizing && !tableNode?.attrs.width, means it is a inline comment
    // When comment and inline comment table width inherits from the parent container, we want tableContainerWidth === renderWidth
    const tableContainerWidth = rendererAppearance === 'comment' && !tableNode?.attrs.width || isRendererNested ? renderWidth : (0, $fKLIs.getTableContainerWidth)(tableNode);
    if (allowTableResizing && !isInsideOfBlockNode && !((0, $VSDnB.fg)('platform_editor_nested_tables_renderer_colgroup') && isInsideOfTable) && !isinsideMultiBodiedExtension && !tableColumnResized) {
        // when no columns are resized, each column should have equal width, equals to tableWidth / noOfColumns
        const tableWidth = (isNumberColumnEnabled ? tableContainerWidth - (0, $iHYdz.akEditorTableNumberColumnWidth) : tableContainerWidth) - 1;
        const defaultColumnWidth = tableWidth / noOfColumns;
        targetWidths = new Array(noOfColumns).fill(defaultColumnWidth);
    } else if (!tableColumnResized) return null;
    const sumOfColumns = $ae0cfecd7422435f$var$colWidthSum(columnWidths);
    // tables in the wild may be smaller than table container width (col resizing bugs, created before custom widths etc.)
    // this causes issues with num column scaling as we add a new table column in renderer
    const isTableSmallerThanContainer = sumOfColumns < tableContainerWidth - 1;
    const forceScaleForNumColumn = isTableScalingEnabled && isNumberColumnEnabled && tableColumnResized;
    // when table resized and number column is enabled, we need to scale down the table in render
    if (forceScaleForNumColumn) {
        const scalePercentage = +((tableContainerWidth - (0, $iHYdz.akEditorTableNumberColumnWidth)) / tableContainerWidth);
        const targetMaxWidth = tableContainerWidth - (0, $iHYdz.akEditorTableNumberColumnWidth);
        let totalWidthAfterScale = 0;
        const newScaledTargetWidths = columnWidths.map((width)=>{
            // we need to scale each column UP, to ensure total width of table matches table container
            const patchedWidth = isTableSmallerThanContainer ? width / sumOfColumns * (tableContainerWidth - 1) : width;
            const newWidth = Math.floor(patchedWidth * scalePercentage);
            totalWidthAfterScale += newWidth;
            return newWidth;
        });
        const diff = targetMaxWidth - totalWidthAfterScale;
        targetWidths = newScaledTargetWidths;
        if (diff > 0 || diff < 0 && Math.abs(diff) < (0, $6gEe5.tableCellMinWidth)) {
            let updated = false;
            targetWidths = targetWidths.map((width)=>{
                if (!updated && width + diff > (0, $6gEe5.tableCellMinWidth)) {
                    updated = true;
                    width += diff;
                }
                return width;
            });
        }
    }
    targetWidths = targetWidths || columnWidths;
    // @see ED-6056
    const maxTableWidth = renderWidth < tableContainerWidth ? renderWidth : tableContainerWidth;
    let tableWidth = isNumberColumnEnabled ? (0, $iHYdz.akEditorTableNumberColumnWidth) : 0;
    let minTableWidth = tableWidth;
    let zeroWidthColumnsCount = 0;
    targetWidths.forEach((width)=>{
        if (width) tableWidth += Math.ceil(width);
        else zeroWidthColumnsCount += 1;
        minTableWidth += Math.ceil(width) || (0, $iHYdz.akEditorTableLegacyCellMinWidth);
    });
    let cellMinWidth = 0;
    let scaleDownPercent = 0;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
    const isTableWidthFixed = isTableScalingWithFixedColumnWidthsOptionEnabled && props.tableNode?.attrs.displayMode === 'fixed';
    const maxScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && rendererAppearance === 'comment' ? $ae0cfecd7422435f$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION : $ae0cfecd7422435f$var$MAX_SCALING_PERCENT;
    // fixes migration tables with zero-width columns
    if (zeroWidthColumnsCount > 0) {
        if (minTableWidth > maxTableWidth) {
            const minWidth = Math.ceil((maxTableWidth - tableWidth) / zeroWidthColumnsCount);
            cellMinWidth = minWidth < (0, $iHYdz.akEditorTableLegacyCellMinWidth) ? (0, $iHYdz.akEditorTableLegacyCellMinWidth) : minWidth;
        }
    } else if (renderWidth < tableWidth && !isTableWidthFixed) {
        const shouldTable100ScaleDown = rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width;
        scaleDownPercent = $ae0cfecd7422435f$var$calcScalePercent({
            renderWidth: renderWidth,
            tableWidth: tableWidth,
            maxScale: shouldTable100ScaleDown ? 1 : maxScalingPercent,
            isNumberColumnEnabled: isNumberColumnEnabled
        });
    }
    return targetWidths.map((colWidth)=>{
        const width = $ae0cfecd7422435f$var$fixColumnWidth(colWidth, minTableWidth, maxTableWidth, zeroWidthColumnsCount, scaleDownPercent) || cellMinWidth;
        const style = width ? {
            width: `${width}px`
        } : {};
        return style;
    });
};
const $ae0cfecd7422435f$export$89efc2d0ceeaa030 = (props)=>{
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $dyURG.useRendererContext)();
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled } = props;
    const flags = (0, $9JDnL.useFeatureFlags)();
    if (!columnWidths) return null;
    const colStyles = $ae0cfecd7422435f$var$renderScaleDownColgroup({
        ...props,
        isTopLevelRenderer: isTopLevelRenderer,
        isTableScalingEnabled: props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width' || props.rendererAppearance === 'comment' && (0, $gmhCD.editorExperiment)('support_table_in_comment', true, {
            exposure: true
        }) || props.rendererAppearance === 'comment' && (0, $gmhCD.editorExperiment)('support_table_in_comment_jira', true, {
            exposure: true
        }),
        isTableFixedColumnWidthsOptionEnabled: !!(flags && 'tableWithFixedColumnWidthsOption' in flags && flags.tableWithFixedColumnWidthsOption) && (props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width')
    });
    if (!colStyles) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("colgroup", null, isNumberColumnEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("col", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            width: (0, $iHYdz.akEditorTableNumberColumnWidth)
        },
        "data-test-id": 'num'
    }), colStyles.map((style, idx)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("col", {
            key: idx,
            style: style
        })));
};

});
parcelRegister("9JDnL", function(module, exports) {

$parcel$export(module.exports, "useFeatureFlags", () => $7cc75954bd6ebac0$export$90335b3ff08f335);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $dyURG = parcelRequire("dyURG");
const $7cc75954bd6ebac0$export$90335b3ff08f335 = ()=>(0, $dyURG.useRendererContext)()?.featureFlags;

});
parcelRegister("dyURG", function(module, exports) {

$parcel$export(module.exports, "useRendererContext", () => $6d8aa882825f4203$export$a906432540ed7ed8);
$parcel$export(module.exports, "RendererContextProvider", () => $6d8aa882825f4203$export$ca5df47902194781);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $5uXOq = parcelRequire("5uXOq");
const $6d8aa882825f4203$var$RendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
const $6d8aa882825f4203$export$a906432540ed7ed8 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($6d8aa882825f4203$var$RendererContext);
const $6d8aa882825f4203$export$ca5df47902194781 = $6d8aa882825f4203$var$RendererContext.Provider;

});




parcelRegister("6cOrl", function(module, exports) {

$parcel$export(module.exports, "recursivelyInjectProps", () => $7a2ba32d880ccda8$export$40e12ce8e0a76b0c);

var $5uXOq = parcelRequire("5uXOq");
function $7a2ba32d880ccda8$export$40e12ce8e0a76b0c(children, propsToInject) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children).map((child)=>{
        // Cannot add a prop to an invalid element, so just return the child
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) return child;
        // Recursive call if child has nested children
        if (child.props.children) child = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
            children: $7a2ba32d880ccda8$export$40e12ce8e0a76b0c(child.props.children, propsToInject)
        });
        // Add props to react child node
        return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, propsToInject);
    });
}

});


parcelRegister("kjIja", function(module, exports) {

$parcel$export(module.exports, "isFullWidthAppearance", () => $b5d34963b73650ed$export$c0112b8340d4924b);
$parcel$export(module.exports, "isFullPageAppearance", () => $b5d34963b73650ed$export$a64737a81cde10b4);
$parcel$export(module.exports, "isCommentAppearance", () => $b5d34963b73650ed$export$f77d2ff45b2c53ed);
$parcel$export(module.exports, "isFullWidthOrFullPageAppearance", () => $b5d34963b73650ed$export$33331a99fac775a1);
const $b5d34963b73650ed$export$c0112b8340d4924b = (appearance)=>appearance === 'full-width';
const $b5d34963b73650ed$export$a64737a81cde10b4 = (appearance)=>appearance === 'full-page';
const $b5d34963b73650ed$export$f77d2ff45b2c53ed = (appearance)=>appearance === 'comment';
const $b5d34963b73650ed$export$33331a99fac775a1 = (appearance)=>$b5d34963b73650ed$export$a64737a81cde10b4(appearance) || $b5d34963b73650ed$export$c0112b8340d4924b(appearance);

});

parcelRegister("eIscD", function(module, exports) {

$parcel$export(module.exports, "TableStickyScrollbar", () => $ea0307076d72d83e$export$8c072780619cfc83);

var $6gEe5 = parcelRequire("6gEe5");
class $ea0307076d72d83e$export$8c072780619cfc83 {
    constructor(wrapper){
        this.sentinels = {};
        this.handleScroll = (event)=>{
            if (!this.stickyScrollbarContainerElement || !this.wrapper || event.target !== this.stickyScrollbarContainerElement) return;
            this.wrapper.scrollLeft = this.stickyScrollbarContainerElement.scrollLeft;
        };
        this.wrapper = wrapper;
        this.init();
    }
    dispose() {
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.removeEventListener('scroll', this.handleScroll);
        this.deleteIntersectionObserver();
    }
    scrollLeft(left) {
        if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.scrollLeft = left;
    }
    init() {
        if (!this.wrapper) return;
        this.stickyScrollbarContainerElement = this.wrapper.parentElement?.querySelector(`.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.addEventListener('scroll', this.handleScroll, {
            passive: true
        });
        this.createIntersectionObserver();
    }
    createIntersectionObserver() {
        this.rendererScrollableElement = window.document;
        if (!this.rendererScrollableElement || !this.wrapper) return;
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            if (!this.stickyScrollbarContainerElement) return;
            entries.forEach((entry)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const target = entry.target;
                if (target.classList.contains((0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) this.sentinelBottomCallback(entry);
                if (target.classList.contains((0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) this.sentinelTopCallback(entry);
            });
        }, {
            root: this.rendererScrollableElement
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.sentinels.bottom = this.wrapper?.parentElement?.getElementsByClassName((0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)?.item(0);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.sentinels.top = this.wrapper?.parentElement?.getElementsByClassName((0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)?.item(0);
        [
            this.sentinels.bottom,
            this.sentinels.top
        ].forEach((el)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.intersectionObserver.observe(el));
    }
    deleteIntersectionObserver() {
        if (this.intersectionObserver) {
            if (this.sentinels.bottom) this.intersectionObserver.unobserve(this.sentinels.bottom);
            this.intersectionObserver.disconnect();
        }
    }
    sentinelBottomCallback(entry) {
        const sentinelIsAboveScrollArea = entry.boundingClientRect.top < (entry.rootBounds?.top || 0);
        this.bottomSentinelState = sentinelIsAboveScrollArea ? 'above' : entry.isIntersecting ? 'visible' : 'below';
        this.toggle();
    }
    sentinelTopCallback(entry) {
        const sentinelIsBelowScrollArea = (entry.rootBounds?.bottom || 0) < entry.boundingClientRect.top;
        this.topSentinelState = sentinelIsBelowScrollArea ? 'below' : entry.isIntersecting ? 'visible' : 'above';
        this.toggle();
    }
    toggle() {
        if ((this.topSentinelState === 'visible' || this.topSentinelState === 'above') && this.bottomSentinelState === 'below') this.show();
        else this.hide();
    }
    hide() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'hidden') this.stickyScrollbarContainerElement.style.visibility = 'hidden';
    }
    show() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'visible') this.stickyScrollbarContainerElement.style.visibility = 'visible';
    }
}

});


parcelRegister("i4Lgj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d6cf54c99dd1cb3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5vnE9 = parcelRequire("5vnE9");

var $9BYlQ = parcelRequire("9BYlQ");

var $l8Gxi = parcelRequire("l8Gxi");
class $6d6cf54c99dd1cb3$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { children: children, innerRef: innerRef } = this.props;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tr", {
            ref: innerRef
        }, this.props.isNumberColumnEnabled && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("td", {
            className: (0, $l8Gxi.RendererCssClassName).NUMBER_COLUMN
        }, this.props.index), (0, $5vnE9.compose)(this.addSortableColumn, this.addColGroupWidth)(childrenArray));
    }
    constructor(...args){
        super(...args), this.state = {
            colGroupWidths: []
        }, this.addSortableColumn = (childrenArray)=>{
            const { allowColumnSorting: allowColumnSorting, index: rowIndex } = this.props;
            if (allowColumnSorting) {
                const isHeaderRow = !rowIndex;
                childrenArray = childrenArray.map((child, index)=>{
                    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                        const { tableOrderStatus: tableOrderStatus } = this.props;
                        let sortOrdered = (0, $9BYlQ.SortOrder).NO_ORDER;
                        if (tableOrderStatus) sortOrdered = index === tableOrderStatus.columnIndex ? tableOrderStatus.order : (0, $9BYlQ.SortOrder).NO_ORDER;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                            columnIndex: index,
                            onSorting: this.props.onSorting,
                            sortOrdered: sortOrdered,
                            isHeaderRow: isHeaderRow
                        });
                    }
                });
            }
            return childrenArray;
        }, this.addColGroupWidth = (childrenArray)=>{
            if (this.state.colGroupWidths) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                    colGroupWidth: this.state.colGroupWidths[index]
                });
            });
            return childrenArray;
        };
    }
}

});

parcelRegister("gfMkN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5be854e6b8cbd84$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $d5be854e6b8cbd84$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: "UnknownBlock"
    }, props.children);
}

});

parcelRegister("9kpKZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b743bc5ccb58a13$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $iHYdz = parcelRequire("iHYdz");

var $eJS47 = parcelRequire("eJS47");

var $3bDjY = parcelRequire("3bDjY");

var $gkwXh = parcelRequire("gkwXh");

var $7R1zM = parcelRequire("7R1zM");

var $d54NZ = parcelRequire("d54NZ");

var $9tFGn = parcelRequire("9tFGn");
const $5b743bc5ccb58a13$var$inlineNodeStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    alignItems: 'center',
    background: "var(--ds-background-disabled, #091E4208)",
    border: `1px dashed ${"var(--ds-border-disabled, #091E420F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'inline-flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $iHYdz.relativeFontSizeToBase16)(14),
    margin: `0 ${"var(--ds-space-025, 2px)"}`,
    minHeight: '24px',
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    verticalAlign: 'middle',
    whiteSpace: 'nowrap'
});
const $5b743bc5ccb58a13$var$UnsupportedInlineNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $9tFGn.getUnsupportedContent)((0, $7R1zM.unsupportedContentMessages).unsupportedInlineContent, 'Unsupported', node, intl);
    const tooltipContent = intl.formatMessage((0, $7R1zM.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $5uXOq.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $5uXOq.useCallback)(()=>dispatchAnalyticsEvent && (0, $d54NZ.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).ON_UNSUPPORTED_INLINE, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $5b743bc5ccb58a13$var$inlineNodeStyle
    }, message, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJS47))), {
        label: "?",
        size: "small"
    }))));
};
var $5b743bc5ccb58a13$export$2e2bcd8739ae039 = (0, $8RXs9.default)($5b743bc5ccb58a13$var$UnsupportedInlineNode);

});

parcelRegister("b7uH5", function(module, exports) {

let $8188285c16b52cce$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8188285c16b52cce$var$load("jv5OL").then(()=>parcelRequire('fyj1u'));

});

parcelRegister("4nigH", function(module, exports) {

let $32f77b20371be65f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $32f77b20371be65f$var$load("27B3z").then(()=>parcelRequire('bO8HO'));

});

parcelRegister("jjsQN", function(module, exports) {

let $e0f62bc8730c7d05$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e0f62bc8730c7d05$var$load("wQW1L").then(()=>parcelRequire('iLXzZ'));

});

parcelRegister("0K8mZ", function(module, exports) {

let $0023c973e159b439$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0023c973e159b439$var$load("hY7zf").then(()=>parcelRequire('5Y7e4'));

});

parcelRegister("k7Zs2", function(module, exports) {

let $ea742102175705e3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ea742102175705e3$var$load("7lItE").then(()=>parcelRequire('h2Mqp'));

});

parcelRegister("aNesC", function(module, exports) {

let $7db9b28bd0545c2e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7db9b28bd0545c2e$var$load("6OdqE").then(()=>parcelRequire('sFJC1'));

});

parcelRegister("57OMq", function(module, exports) {

let $3bb4ff084aedf044$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3bb4ff084aedf044$var$load("8PYkX").then(()=>parcelRequire('4hMem'));

});

parcelRegister("bfPot", function(module, exports) {

let $8318f624fdf8cb8b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8318f624fdf8cb8b$var$load("aetML").then(()=>parcelRequire('c3ssB'));

});

parcelRegister("7mtWi", function(module, exports) {

let $55c1cfcbb6e43f4a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $55c1cfcbb6e43f4a$var$load("cM9em"),
    $55c1cfcbb6e43f4a$var$load("fr9NE"),
    $55c1cfcbb6e43f4a$var$load("h2MrD"),
    $55c1cfcbb6e43f4a$var$load("bYT2S"),
    $55c1cfcbb6e43f4a$var$load("9VCdz")
]).then(()=>parcelRequire('hibqv'));

});

parcelRegister("cyYfQ", function(module, exports) {

let $92576655004e1c2c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $92576655004e1c2c$var$load("cM9em"),
    $92576655004e1c2c$var$load("fr9NE"),
    $92576655004e1c2c$var$load("h2MrD"),
    $92576655004e1c2c$var$load("bYT2S"),
    $92576655004e1c2c$var$load("h0TDs")
]).then(()=>parcelRequire('1lkep'));

});

parcelRegister("bat28", function(module, exports) {

let $8217264db8cfcb2d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8217264db8cfcb2d$var$load("dsiAd"),
    $8217264db8cfcb2d$var$load("cM9em"),
    $8217264db8cfcb2d$var$load("fr9NE"),
    $8217264db8cfcb2d$var$load("h2MrD"),
    $8217264db8cfcb2d$var$load("bYT2S"),
    $8217264db8cfcb2d$var$load("hPzOn"),
    $8217264db8cfcb2d$var$load("hLGxH")
]).then(()=>parcelRequire('fz1ZD'));

});

parcelRegister("iyg8s", function(module, exports) {

let $d817eb1ae1141039$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d817eb1ae1141039$var$load("dsiAd"),
    $d817eb1ae1141039$var$load("cM9em"),
    $d817eb1ae1141039$var$load("fr9NE"),
    $d817eb1ae1141039$var$load("h2MrD"),
    $d817eb1ae1141039$var$load("bYT2S"),
    $d817eb1ae1141039$var$load("hPzOn"),
    $d817eb1ae1141039$var$load("13w3s")
]).then(()=>parcelRequire('lD0Zb'));

});

parcelRegister("gQJy5", function(module, exports) {

let $032a668b1beb7866$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $032a668b1beb7866$var$load("dsiAd"),
    $032a668b1beb7866$var$load("cM9em"),
    $032a668b1beb7866$var$load("fr9NE"),
    $032a668b1beb7866$var$load("h2MrD"),
    $032a668b1beb7866$var$load("bYT2S"),
    $032a668b1beb7866$var$load("hPzOn"),
    $032a668b1beb7866$var$load("YsZeU")
]).then(()=>parcelRequire('gQwn3'));

});

parcelRegister("7UIjK", function(module, exports) {

let $5c3023ed13e23afa$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5c3023ed13e23afa$var$load("cM9em"),
    $5c3023ed13e23afa$var$load("fr9NE"),
    $5c3023ed13e23afa$var$load("2Q2XH")
]).then(()=>parcelRequire('aPwmB'));

});

parcelRegister("lmZTQ", function(module, exports) {

let $f8ebab104a7491ec$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f8ebab104a7491ec$var$load("h2MrD"),
    $f8ebab104a7491ec$var$load("bYT2S"),
    $f8ebab104a7491ec$var$load("4B3Pp")
]).then(()=>parcelRequire('ebIkR'));

});

parcelRegister("4kfHt", function(module, exports) {

let $32653568d7020556$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $32653568d7020556$var$load("cM9em"),
    $32653568d7020556$var$load("fr9NE"),
    $32653568d7020556$var$load("c5BYw")
]).then(()=>parcelRequire('74PfD'));

});

parcelRegister("hPQIC", function(module, exports) {

let $cfc017ee8c8604ba$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cfc017ee8c8604ba$var$load("8QV79").then(()=>parcelRequire('9jt2S'));

});

parcelRegister("3ceee", function(module, exports) {

let $253d87993a37a182$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $253d87993a37a182$var$load("h2MrD"),
    $253d87993a37a182$var$load("bYT2S"),
    $253d87993a37a182$var$load("cM9em"),
    $253d87993a37a182$var$load("fr9NE"),
    $253d87993a37a182$var$load("iJ6aZ")
]).then(()=>parcelRequire('V5Yjo'));

});

parcelRegister("bbv0R", function(module, exports) {

let $8248c74ba6db9df5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8248c74ba6db9df5$var$load("h2MrD"),
    $8248c74ba6db9df5$var$load("bYT2S"),
    $8248c74ba6db9df5$var$load("jcqJ9")
]).then(()=>parcelRequire('hA9EZ'));

});


parcelRegister("5BLIh", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1269296b575a9fc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4dDLS = parcelRequire("4dDLS");
const $e1269296b575a9fc$var$TextWrapper = (props)=>{
    const { startPos: startPos, endPos: endPos } = props;
    const { children: children } = props;
    if (!children) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dDLS.TextWithAnnotationDraft), {
        startPos: startPos,
        endPos: endPos,
        textHighlighter: props.textHighlighter,
        marks: props.marks
    }, children);
};
var $e1269296b575a9fc$export$2e2bcd8739ae039 = $e1269296b575a9fc$var$TextWrapper;

});
parcelRegister("4dDLS", function(module, exports) {

$parcel$export(module.exports, "TextWithAnnotationDraft", () => $3c5c154ced085d7f$export$69a4e0ac39aaf9b7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dLpur = parcelRequire("dLpur");

var $iYAgE = parcelRequire("iYAgE");

var $i9Z2i = parcelRequire("i9Z2i");

var $b60W1 = parcelRequire("b60W1");

var $fVTp8 = parcelRequire("fVTp8");

var $5Lu5s = parcelRequire("5Lu5s");

var $h5tvG = parcelRequire("h5tvG");

var $3VpWO = parcelRequire("3VpWO");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $3c5c154ced085d7f$var$markStyles = ()=>/*#__PURE__*/ (0, $f8Sb3.css)("color:inherit;background-color:unset;-webkit-tap-highlight-color:transparent;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $5Lu5s.AnnotationSharedCSSByState)().common, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $5Lu5s.AnnotationSharedCSSByState)().focus);
const $3c5c154ced085d7f$export$8062d68eccdfa39c = ({ draftPosition: draftPosition, children: children })=>{
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $f8Sb3.jsx)("mark", {
        "data-renderer-mark": true,
        ...(0, $fVTp8.dataAttributes)(draftPosition),
        css: $3c5c154ced085d7f$var$markStyles
    }, children));
};
const $3c5c154ced085d7f$export$846ef6158669db08 = (annotationPosition, fragmentCount)=>{
    if (annotationPosition === (0, $dLpur.InsertDraftPosition).START) return 0;
    if (annotationPosition === (0, $dLpur.InsertDraftPosition).END) return fragmentCount - 1;
    if (annotationPosition === (0, $dLpur.InsertDraftPosition).INSIDE && fragmentCount === 3) return 1;
    return -1;
};
const $3c5c154ced085d7f$export$b756d37afc321d72 = ({ texts: texts, shouldApplyAnnotationAt: shouldApplyAnnotationAt, draftPosition: draftPosition, textHighlighter: textHighlighter, marks: marks })=>{
    const annotateIndex = $3c5c154ced085d7f$export$846ef6158669db08(shouldApplyAnnotationAt, texts.length);
    return texts.map((value, index)=>{
        const segments = (0, $h5tvG.segmentText)(value, textHighlighter);
        if (annotateIndex === index) return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $f8Sb3.jsx)($3c5c154ced085d7f$export$8062d68eccdfa39c, {
            key: index,
            draftPosition: draftPosition
        }, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from)));
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
            key: index
        }, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from)));
    });
};
const $3c5c154ced085d7f$export$69a4e0ac39aaf9b7 = ({ startPos: startPos, endPos: endPos, children: children, textHighlighter: textHighlighter, marks: marks })=>{
    const textPosition = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>({
            start: startPos,
            end: endPos
        }), [
        endPos,
        startPos
    ]);
    const nextDraftPosition = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $iYAgE.AnnotationsDraftContext));
    const shouldApplyAnnotationAt = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        if (!nextDraftPosition) return false;
        return (0, $b60W1.calcInsertDraftPositionOnText)(textPosition, nextDraftPosition);
    }, [
        nextDraftPosition,
        textPosition
    ]);
    const textString = (0, $i9Z2i.findTextString)(children);
    if (!textString) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, children);
    if (shouldApplyAnnotationAt === false || !nextDraftPosition) {
        const segments = (0, $h5tvG.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    if (shouldApplyAnnotationAt === (0, $dLpur.InsertDraftPosition).AROUND_TEXT) {
        const segments = (0, $h5tvG.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)($3c5c154ced085d7f$export$8062d68eccdfa39c, {
            key: 0,
            draftPosition: nextDraftPosition
        }, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    const offsets = (0, $i9Z2i.calcTextSplitOffset)(nextDraftPosition, textPosition, textString);
    const texts = (0, $i9Z2i.splitText)(textString, offsets);
    if (!texts) {
        const segments = (0, $h5tvG.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    const components = $3c5c154ced085d7f$export$b756d37afc321d72({
        texts: texts,
        shouldApplyAnnotationAt: shouldApplyAnnotationAt,
        draftPosition: nextDraftPosition,
        textHighlighter: textHighlighter,
        marks: marks
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, components);
};

});
parcelRegister("dLpur", function(module, exports) {

$parcel$export(module.exports, "InsertDraftPosition", () => $0808a380eaa6574c$export$c1bd4813440b4505);
var $0808a380eaa6574c$export$c1bd4813440b4505 = /*#__PURE__*/ function(InsertDraftPosition) {
    InsertDraftPosition["AROUND_TEXT"] = "AROUND_TEXT";
    InsertDraftPosition["START"] = "START";
    InsertDraftPosition["END"] = "END";
    InsertDraftPosition["INSIDE"] = "INSIDE";
    return InsertDraftPosition;
}({});

});

parcelRegister("i9Z2i", function(module, exports) {

$parcel$export(module.exports, "findTextString", () => $b2e5f988c70f5313$export$a9795c84b22a1f06);
$parcel$export(module.exports, "splitText", () => $b2e5f988c70f5313$export$2878cc467c8be8fe);
$parcel$export(module.exports, "calcTextSplitOffset", () => $b2e5f988c70f5313$export$1059bfc467f4f55d);

var $5uXOq = parcelRequire("5uXOq");
const $b2e5f988c70f5313$export$a9795c84b22a1f06 = (reactNode)=>{
    let result = null;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(reactNode);
    for (const childNode of children){
        if (result) break;
        else if (typeof childNode === 'string') result = childNode;
        else if ($b2e5f988c70f5313$var$isReactElement(childNode) && childNode.props.children) result = $b2e5f988c70f5313$export$a9795c84b22a1f06(childNode.props.children);
    }
    return result;
};
function $b2e5f988c70f5313$var$isReactElement(child) {
    return !!child.type;
}
const $b2e5f988c70f5313$export$2878cc467c8be8fe = (text, { startOffset: startOffset, endOffset: endOffset })=>{
    if (endOffset > text.length || endOffset - startOffset <= 0) return null;
    return [
        text.slice(0, startOffset),
        text.slice(startOffset, endOffset),
        text.slice(endOffset)
    ].filter(Boolean);
};
const $b2e5f988c70f5313$export$1059bfc467f4f55d = (position, textPosition, text)=>{
    const { start: start, end: end } = textPosition;
    const startOffset = Math.max(position.from - start, 0);
    const endOffset = Math.min(Math.abs(end - position.to - text.length), text.length);
    return {
        startOffset: startOffset,
        endOffset: endOffset
    };
};

});

parcelRegister("b60W1", function(module, exports) {

$parcel$export(module.exports, "calcInsertDraftPositionOnText", () => $cc6d6765c9b34830$export$b1baddbd5f289877);

var $dLpur = parcelRequire("dLpur");
const $cc6d6765c9b34830$export$b1baddbd5f289877 = ({ start: startTextPosition, end: endTextPosition }, position)=>{
    const isRangePositionAroundText = position.from <= startTextPosition && position.to >= endTextPosition;
    if (isRangePositionAroundText) return (0, $dLpur.InsertDraftPosition).AROUND_TEXT;
    const isRangePositionInsideText = position.from > startTextPosition && position.from < endTextPosition && position.to < endTextPosition && position.to > startTextPosition;
    if (isRangePositionInsideText) return (0, $dLpur.InsertDraftPosition).INSIDE;
    const isRangePositionStartingAtText = position.from >= startTextPosition && position.from <= endTextPosition && position.to >= endTextPosition;
    if (isRangePositionStartingAtText) return (0, $dLpur.InsertDraftPosition).END;
    const isRangePositionEndingAtText = position.from <= startTextPosition && position.to >= startTextPosition && position.to <= endTextPosition;
    if (isRangePositionEndingAtText) return (0, $dLpur.InsertDraftPosition).START;
    return false;
};

});

parcelRegister("5Lu5s", function(module, exports) {

$parcel$export(module.exports, "AnnotationSharedClassNames", () => $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c);
$parcel$export(module.exports, "BlockAnnotationSharedClassNames", () => $973d0f0bfe5e36b9$export$ac15f3ad21fefeac);
$parcel$export(module.exports, "AnnotationSharedCSSByState", () => $973d0f0bfe5e36b9$export$261ebe180da42726);
$parcel$export(module.exports, "annotationSharedStyles", () => $973d0f0bfe5e36b9$export$5f72fe1d39f8129b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");
function $973d0f0bfe5e36b9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $973d0f0bfe5e36b9$export$6d0ce11e3a04da25 = 'ak-editor-annotation';
const $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c = {
    focus: `${$973d0f0bfe5e36b9$export$6d0ce11e3a04da25}-focus`,
    blur: `${$973d0f0bfe5e36b9$export$6d0ce11e3a04da25}-blur`,
    draft: `${$973d0f0bfe5e36b9$export$6d0ce11e3a04da25}-draft`,
    hover: `${$973d0f0bfe5e36b9$export$6d0ce11e3a04da25}-hover`
};
const $973d0f0bfe5e36b9$export$3600479d19dfa7a9 = 'ak-editor-block-annotation';
const $973d0f0bfe5e36b9$export$ac15f3ad21fefeac = {
    focus: `${$973d0f0bfe5e36b9$export$3600479d19dfa7a9}-focus`,
    blur: `${$973d0f0bfe5e36b9$export$3600479d19dfa7a9}-blur`,
    draft: `${$973d0f0bfe5e36b9$export$3600479d19dfa7a9}-draft`
};
var $973d0f0bfe5e36b9$var$_ref = {
    name: "j33ko3",
    styles: "background:var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0);border-bottom-color:var(--ds-border-accent-yellow, #B38600);box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
};
var $973d0f0bfe5e36b9$var$_ref2 = {
    name: "kh65d",
    styles: "background:var(--ds-background-accent-yellow-subtlest, #FFF7D6);border-bottom-color:var(--ds-border-accent-yellow, #B38600)"
};
var $973d0f0bfe5e36b9$var$_ref3 = {
    name: "buc4yh",
    styles: "background:var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47);border-bottom-color:var(--ds-border-accent-yellow, #B38600);box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
};
const $973d0f0bfe5e36b9$export$261ebe180da42726 = ()=>{
    if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) // NOTE: These styles are shared between renderer and editor. Sometimes they
    // need different selectors and other times they apply the same attributes
    // in a different way. For example in renderer the focus styles are an
    // override, not a separate class. Be sure to check both usages of this
    // before modifying.
    return {
        common: {
            borderBottom: '2px solid transparent',
            cursor: 'pointer',
            padding: '1px 0 2px',
            '&:has(.card), &:has([data-inline-card])': (0, $VSDnB.fg)('annotations_align_editor_and_renderer_styles') ? {
                padding: '5px 0 3px 0'
            } : {
                paddingTop: '4px',
                border: 'none',
                boxShadow: `0 2px 0 0 ${"var(--ds-border-accent-yellow, #B38600)"}`
            },
            '&:has(.date-lozenger-container)': {
                paddingTop: '2px'
            }
        },
        focus: $973d0f0bfe5e36b9$var$_ref3,
        blur: $973d0f0bfe5e36b9$var$_ref2,
        hover: $973d0f0bfe5e36b9$var$_ref
    };
    else return {
        focus: /*#__PURE__*/ (0, $f8Sb3.css)({
            // Background is not coming through in confluence, suspecting to be caused by some specific combination of
            // emotion and token look up
            background: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            // TODO: https://product-fabric.atlassian.net/browse/DSP-4147
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)",
            cursor: 'pointer'
        }),
        blur: /*#__PURE__*/ (0, $f8Sb3.css)({
            background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            cursor: 'pointer'
        })
    };
};
const $973d0f0bfe5e36b9$export$5f72fe1d39f8129b = ()=>(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- `AnnotationSharedCSSByState()` is not safe in object syntax
    (0, $f8Sb3.css)(".ProseMirror{.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.blur, ",.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.focus, ",.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.draft, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().common, ";}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.focus, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().focus, ";}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.draft, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().focus, ";cursor:initial;}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.blur, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().blur, ";}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.hover, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().common, ";", $973d0f0bfe5e36b9$export$261ebe180da42726().hover, ";}}") : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- `AnnotationSharedCSSByState()` is not safe in object syntax
    (0, $f8Sb3.css)(".ProseMirror{.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.focus, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().focus, ";}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.draft, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().focus, ";cursor:initial;}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.blur, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().blur, ";}}");

});

parcelRegister("h5tvG", function(module, exports) {

$parcel$export(module.exports, "segmentText", () => $63dc04a72edc8a4d$export$93301b6f1ff0b0c3);
function $63dc04a72edc8a4d$export$93301b6f1ff0b0c3(text, highlighter) {
    if (!highlighter || !text) return [
        {
            type: 'plain',
            text: text ?? ''
        }
    ];
    const segments = [];
    let pos = 0;
    try {
        const markTextSegmentMatches = text.matchAll(highlighter.pattern);
        for (const markTextMatch of markTextSegmentMatches){
            if (markTextMatch.index !== 0) segments.push({
                type: 'plain',
                text: text.substring(pos, markTextMatch.index)
            });
            segments.push({
                type: 'match',
                text: markTextMatch[0],
                groups: markTextMatch.groups && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                Object.keys(markTextMatch.groups).filter((key)=>markTextMatch.groups[key])
            });
            pos = markTextMatch.index + markTextMatch[0].length;
        }
        if (pos < text.length) segments.push({
            type: 'plain',
            text: text.substring(pos)
        });
        return segments;
    } catch (_e) {}
    return [
        {
            type: 'plain',
            text: text
        }
    ];
}

});

parcelRegister("3VpWO", function(module, exports) {

$parcel$export(module.exports, "renderTextSegments", () => $eefbbe172cfc7a10$export$8a20fd0614851c5f);

var $5uXOq = parcelRequire("5uXOq");
function $eefbbe172cfc7a10$export$8a20fd0614851c5f(segments, textHighlighter, marksList, startPos) {
    const Component = textHighlighter?.component;
    const marks = new Set(marksList.map((m)=>m.type.name));
    function renderSegment(segment, idx = 0) {
        if (segment.type === 'plain' || !Component) return segment.text;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            "data-highlighted": true,
            "data-vc": "highlighted-text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
            match: segment.text,
            groups: segment.groups,
            marks: marks,
            key: `${segment.text}_${startPos}_${idx}`,
            startPos: startPos + idx
        }, segment.text));
    }
    if (segments.length === 1) return renderSegment(segments[0]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
        key: `text-wrapper_${startPos}`
    }, segments.map(renderSegment));
}

});



parcelRegister("cKKwC", function(module, exports) {

$parcel$export(module.exports, "isAnnotationMark", () => $d006a5118aec07b0$export$855795c145f03402);
$parcel$export(module.exports, "default", () => $d006a5118aec07b0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $5uoEK = parcelRequire("5uoEK");
const $d006a5118aec07b0$export$855795c145f03402 = (mark)=>{
    return mark && mark.type && mark.type.name === 'annotation';
};
const $d006a5118aec07b0$var$AnnotationComponent = ({ id: id, annotationType: annotationType, children: children, dataAttributes: dataAttributes, annotationParentIds: annotationParentIds = [], allowAnnotations: allowAnnotations, useBlockLevel: useBlockLevel, isMediaInline: isMediaInline })=>{
    const data = {
        ...dataAttributes,
        ...(0, $88i6h.buildDataAttributes)({
            id: id,
            annotationType: annotationType
        })
    };
    if (allowAnnotations) return isMediaInline ? // Inline comment on mediaInline is not supported as part of comments on media project,
    // hence skip any styling/event handling for annotations on mediaInline.
    // `id` is still needed so that comment view component can be correct positioned
    // when using comment navigation to access comments on mediaInline
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        id: id
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uoEK.MarkElement), {
        id: id,
        dataAttributes: data,
        annotationParentIds: annotationParentIds,
        annotationType: annotationType,
        useBlockLevel: useBlockLevel
    }, children);
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        id: id,
        ...data
    }, children));
};
var $d006a5118aec07b0$export$2e2bcd8739ae039 = $d006a5118aec07b0$var$AnnotationComponent;

});
parcelRegister("5uoEK", function(module, exports) {

$parcel$export(module.exports, "MarkElement", () => $97291021c9f24158$export$f3069f755c1eba0b);

var $5uXOq = parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $8u8ms = parcelRequire("8u8ms");

var $6Oe8V = parcelRequire("6Oe8V");

var $3N1TD = parcelRequire("3N1TD");

var $1oOiu = parcelRequire("1oOiu");

var $iYAgE = parcelRequire("iYAgE");

var $dEtqo = parcelRequire("dEtqo");
const $97291021c9f24158$export$f3069f755c1eba0b = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, useBlockLevel: useBlockLevel })=>{
    const updateSubscriber = (0, $3N1TD.useInlineCommentSubscriberContext)();
    const states = (0, $5uXOq.useContext)((0, $iYAgE.InlineCommentsStateContext));
    const { hasFocus: hasFocus, isHovered: isHovered } = (0, $1oOiu.useHasFocusEvent)({
        id: id,
        updateSubscriber: updateSubscriber
    });
    const dataAttributesMemorized = (0, $5uXOq.useMemo)(()=>dataAttributes, [
        dataAttributes
    ]);
    const onClick = (0, $5uXOq.useCallback)((props)=>{
        if (!updateSubscriber) return;
        if (useBlockLevel) return;
        const { eventTarget: eventTarget, annotationIds: annotationIds } = props;
        updateSubscriber.emit((0, $dEtqo.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: annotationIds,
            eventTarget: eventTarget
        });
    }, [
        updateSubscriber,
        useBlockLevel
    ]);
    const activeParentIds = (0, $6Oe8V.useInlineCommentsFilter)({
        annotationIds: annotationParentIds,
        filter: {
            state: (0, $88i6h.AnnotationMarkStates).ACTIVE
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8u8ms.MarkComponent), {
        id: id,
        dataAttributes: dataAttributesMemorized,
        annotationParentIds: activeParentIds,
        onClick: onClick,
        hasFocus: hasFocus,
        isHovered: isHovered,
        state: states[id],
        useBlockLevel: useBlockLevel
    }, children);
};

});
parcelRegister("8u8ms", function(module, exports) {

$parcel$export(module.exports, "MarkComponent", () => $c95b45af50ffb058$export$4f5a51511304fdd0);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $5Lu5s = parcelRequire("5Lu5s");

var $88i6h = parcelRequire("88i6h");

var $VSDnB = parcelRequire("VSDnB");

var $koVbs = parcelRequire("koVbs");

var $1Bd5P = parcelRequire("1Bd5P");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- `AnnotationSharedCSSByState` is not object-safe
const $c95b45af50ffb058$var$markStyles = ()=>/*#__PURE__*/ (0, $f8Sb3.css)("color:inherit;background-color:unset;-webkit-tap-highlight-color:transparent;&[data-mark-annotation-state='", (0, $88i6h.AnnotationMarkStates).ACTIVE, "']{", (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? (0, $5Lu5s.AnnotationSharedCSSByState)().common : '', " ", (0, $5Lu5s.AnnotationSharedCSSByState)().blur, " &:focus,&[data-has-focus='true']{", (0, $5Lu5s.AnnotationSharedCSSByState)().focus, ";}&[data-is-hovered='true']:not([data-has-focus='true']){", (0, $VSDnB.fg)('confluence-frontend-comments-panel') ? (0, $5Lu5s.AnnotationSharedCSSByState)().hover : '', ";}}");
const $c95b45af50ffb058$var$isMobile = ()=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
const $c95b45af50ffb058$var$accessibilityStyles = (startMarker, endMarker)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        '&::before, &::after': {
            clipPath: 'inset(100%)',
            clip: 'rect(1px, 1px, 1px, 1px)',
            height: '1px',
            overflow: 'hidden',
            position: 'absolute',
            whiteSpace: 'nowrap',
            width: '1px'
        },
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            content: `' [${startMarker}] '`
        },
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            content: `' [${endMarker}] '`
        }
    });
const $c95b45af50ffb058$export$4f5a51511304fdd0 = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, state: state, hasFocus: hasFocus, isHovered: isHovered, onClick: onClick, useBlockLevel: useBlockLevel })=>{
    const isInlineCommentsKbAccessible = (0, $VSDnB.fg)('inline_comments_keyboard_accessible_renderer');
    const intl = (0, $koVbs.default)();
    const annotationIds = (0, $5uXOq.useMemo)(()=>[
            ...new Set([
                ...annotationParentIds,
                id
            ])
        ], [
        id,
        annotationParentIds
    ]);
    const onMarkClick = (0, $5uXOq.useCallback)((event)=>{
        // prevent inline mark logic for media block marks
        if (event.currentTarget instanceof HTMLElement && event.currentTarget.getAttribute('data-block-mark')) return;
        // prevents multiple callback on overlapping annotations
        if (event.defaultPrevented || state !== (0, $88i6h.AnnotationMarkStates).ACTIVE) return;
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) // We only want to interfere with click events if the click is on some ui inside the renderer document
        // This is to prevent the click events from portaled content (such as link previews and mention profiles)
        {
            if (event.target instanceof HTMLElement && event.target.closest('.ak-renderer-document')) {
                if (event.target.closest('[data-mention-id]')) ;
                else {
                    // prevents from opening link URL inside webView in Safari
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        } else // prevents from opening link URL inside webView in Safari
        event.preventDefault();
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.target,
            annotationIds: annotationIds
        });
    }, [
        annotationIds,
        onClick,
        state
    ]);
    const onMarkEnter = (evt)=>{
        const focusedElementTag = document.activeElement?.tagName;
        if (focusedElementTag === 'MARK' && evt.key === 'Enter') onMarkClick(evt);
    };
    const overriddenData = !state ? dataAttributes : {
        ...dataAttributes,
        'data-mark-annotation-state': state,
        'data-has-focus': hasFocus,
        'data-is-hovered': isHovered
    };
    const desktopAccessibilityAttributes = isInlineCommentsKbAccessible ? $c95b45af50ffb058$var$isMobile() ? {} : {
        role: 'button',
        tabIndex: 0,
        onKeyDown: onMarkEnter,
        'aria-expanded': hasFocus
    } : {};
    const accessibility = state !== (0, $88i6h.AnnotationMarkStates).ACTIVE ? {
        'aria-disabled': true
    } : {
        'aria-details': annotationIds.join(', '),
        ...desktopAccessibilityAttributes
    };
    const getAccessibilityStyles = ()=>{
        if ($c95b45af50ffb058$var$isMobile()) return {};
        if (isInlineCommentsKbAccessible && state !== (0, $88i6h.AnnotationMarkStates).RESOLVED) {
            const startMarker = intl.formatMessage((0, $1Bd5P.inlineCommentMessages).contentRendererInlineCommentMarkerStart);
            const endMarker = intl.formatMessage((0, $1Bd5P.inlineCommentMessages).contentRendererInlineCommentMarkerEnd);
            return $c95b45af50ffb058$var$accessibilityStyles(startMarker, endMarker);
        } else return {};
    };
    return (0, $f8Sb3.jsx)(useBlockLevel ? 'div' : 'mark', {
        id: id,
        [(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? 'onClickCapture' : 'onClick']: onMarkClick,
        ...accessibility,
        ...overriddenData,
        ...!useBlockLevel && {
            css: [
                $c95b45af50ffb058$var$markStyles,
                getAccessibilityStyles()
            ]
        }
    }, children);
};

});

parcelRegister("6Oe8V", function(module, exports) {

$parcel$export(module.exports, "useInlineCommentsFilter", () => $588f60613625d184$export$8e7d47f9e38ad4f1);

var $5uXOq = parcelRequire("5uXOq");

var $iYAgE = parcelRequire("iYAgE");
const $588f60613625d184$export$8e7d47f9e38ad4f1 = ({ annotationIds: annotationIds, filter: { state: stateFilter } })=>{
    const states = (0, $5uXOq.useContext)((0, $iYAgE.InlineCommentsStateContext));
    return (0, $5uXOq.useMemo)(()=>{
        return annotationIds.reduce((acc, id)=>{
            if (states && states[id] === stateFilter) return [
                ...acc,
                id
            ];
            return acc;
        }, []);
    }, [
        annotationIds,
        states,
        stateFilter
    ]);
};

});

parcelRegister("3N1TD", function(module, exports) {

$parcel$export(module.exports, "useInlineCommentSubscriberContext", () => $861d152b5ce122b2$export$b46737175cffd396);

var $5uXOq = parcelRequire("5uXOq");

var $iYAgE = parcelRequire("iYAgE");
const $861d152b5ce122b2$export$b46737175cffd396 = ()=>{
    const providers = (0, $5uXOq.useContext)((0, $iYAgE.ProvidersContext));
    if (!providers) return null;
    const { inlineComment: { updateSubscriber: updateSubscriber } } = providers;
    return updateSubscriber || null;
};

});



parcelRegister("GDkvY", function(module, exports) {

$parcel$export(module.exports, "toReact", () => $d1627eb50b8d1823$export$d4334b129116aad7);
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $bVGKe = parcelRequire("bVGKe");

var $lqKi3 = parcelRequire("lqKi3");

var $kgK5w = parcelRequire("kgK5w");

var $f14yv = parcelRequire("f14yv");

var $eVxaj = parcelRequire("eVxaj");

var $gUlHA = parcelRequire("gUlHA");

var $c15YI = parcelRequire("c15YI");

var $koUAb = parcelRequire("koUAb");

var $eESZY = parcelRequire("eESZY");

var $95Yll = parcelRequire("95Yll");

var $lbdLJ = parcelRequire("lbdLJ");

var $9xZ5X = parcelRequire("9xZ5X");

var $g5EjF = parcelRequire("g5EjF");

var $acz8Q = parcelRequire("acz8Q");

var $8DQfy = parcelRequire("8DQfy");

var $g9yqu = parcelRequire("g9yqu");

var $cKKwC = parcelRequire("cKKwC");

var $itF0z = parcelRequire("itF0z");

var $6EeUE = parcelRequire("6EeUE");
const $d1627eb50b8d1823$export$c00d967a0f56fdb7 = {
    code: (0, $bVGKe.default),
    em: (0, $lqKi3.default),
    link: (0, $kgK5w.default),
    strike: (0, $f14yv.default),
    strong: (0, $eVxaj.default),
    subsup: (0, $gUlHA.default),
    textColor: (0, $c15YI.default),
    backgroundColor: (0, $koUAb.default),
    underline: (0, $eESZY.default),
    annotation: (0, $cKKwC.default),
    border: (0, $itF0z.default),
    // Stage0
    confluenceInlineComment: (0, $6EeUE.default),
    breakout: (0, $95Yll.default),
    alignment: (0, $lbdLJ.default),
    indentation: (0, $9xZ5X.default),
    unsupportedMark: (0, $g5EjF.default),
    unsupportedNodeAttribute: (0, $acz8Q.default),
    dataConsumer: (0, $8DQfy.default),
    fragment: (0, $g9yqu.default)
};
const $d1627eb50b8d1823$export$d4334b129116aad7 = (mark)=>{
    return $d1627eb50b8d1823$export$c00d967a0f56fdb7[mark.type.name];
};

});
parcelRegister("bVGKe", function(module, exports) {

$parcel$export(module.exports, "isCodeMark", () => $caa083dc61fd842d$export$86390c02c110ec2f);
$parcel$export(module.exports, "default", () => $caa083dc61fd842d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $O2UjQ = parcelRequire("O2UjQ");

var $fJyLQ = parcelRequire("fJyLQ");
const $caa083dc61fd842d$export$86390c02c110ec2f = (mark)=>{
    return mark && mark.type && mark.type.name === 'code';
};
function $caa083dc61fd842d$export$7cea6ffa7022e85f(props) {
    const codeBidiWarningLabel = props.intl.formatMessage((0, $fJyLQ.codeBidiWarningMessages).label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $O2UjQ.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "code",
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: props.codeBidiWarningTooltipEnabled,
        ...props.dataAttributes
    }, props.children);
}
var $caa083dc61fd842d$export$2e2bcd8739ae039 = (0, $8RXs9.default)($caa083dc61fd842d$export$7cea6ffa7022e85f);

});
parcelRegister("O2UjQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c9c981a54265bdd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $lrHA4 = parcelRequire("lrHA4");

var $31cgS = parcelRequire("31cgS");

var $lBXbx = parcelRequire("lBXbx");

var $1HkQx = parcelRequire("1HkQx");
const $4c9c981a54265bdd$var$styles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline',
    padding: '2px 0.5ch',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: `var(${(0, $lBXbx.VAR_CODE_BG_COLOR)}, ${"var(--ds-background-neutral, #091E420F)"})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    borderStyle: 'none',
    boxDecorationBreak: 'clone',
    color: "var(--ds-text, #172B4D)",
    font: "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'inherit',
    overflow: 'auto',
    overflowWrap: 'break-word',
    whiteSpace: 'pre-wrap'
});
/**
 * __Code__
 *
 * Code highlights short strings of code snippets inline with body text.
 *
 * - [Examples](https://atlassian.design/components/code/examples)
 * - [Code](https://atlassian.design/components/code/code)
 * - [Usage](https://atlassian.design/components/code/usage)
 */ const $4c9c981a54265bdd$var$Code = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Code({ testId: testId, ...props }, ref) {
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    const { children: children, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, ...otherProps } = props;
    const decoratedChildren = codeBidiWarnings ? /*#__PURE__*/ (0, $f8Sb3.jsx)($4c9c981a54265bdd$var$RenderCodeChildrenWithBidiWarnings, {
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    }, children) : children;
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("code", {
        ref: ref,
        "data-testid": testId,
        css: $4c9c981a54265bdd$var$styles,
        ...otherProps
    }, decoratedChildren));
}));
function $4c9c981a54265bdd$var$RenderCodeChildrenWithBidiWarnings({ children: children, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled }) {
    const replacedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (childNode)=>{
        if (typeof childNode === 'string') {
            const decorated = (0, $31cgS.default)(childNode, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $lrHA4.default), {
                    bidiCharacter: bidiCharacter,
                    key: index,
                    label: codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningTooltipEnabled
                }));
            return decorated;
        }
        if ($4c9c981a54265bdd$var$isReactElement(childNode) && childNode.props.children) {
            // eslint-disable-next-line @repo/internal/react/no-clone-element
            const newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(childNode, {
                children: /*#__PURE__*/ (0, $f8Sb3.jsx)($4c9c981a54265bdd$var$RenderCodeChildrenWithBidiWarnings, {
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
                }, childNode.props.children)
            });
            return newChildNode;
        }
        return childNode;
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, replacedChildren);
}
function $4c9c981a54265bdd$var$isReactElement(child) {
    return !!child.type;
}
$4c9c981a54265bdd$var$Code.displayName = 'Code';
var $4c9c981a54265bdd$export$2e2bcd8739ae039 = $4c9c981a54265bdd$var$Code;

});


parcelRegister("lqKi3", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd21faba719ebab1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $fd21faba719ebab1$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("em", props.dataAttributes, props.children);
}

});

parcelRegister("kgK5w", function(module, exports) {

$parcel$export(module.exports, "default", () => $9900830cb94354be$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $K5Jsy = parcelRequire("K5Jsy");

var $knXBU = parcelRequire("knXBU");

var $gkwXh = parcelRequire("gkwXh");

var $VSDnB = parcelRequire("VSDnB");

var $iHvAB = parcelRequire("iHvAB");

var $daJ0i = parcelRequire("daJ0i");
const $9900830cb94354be$var$anchorStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-link, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
    '&:hover': {
        color: `var(--ds-link, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
        textDecoration: 'underline'
    },
    '&:active': {
        color: `var(--ds-link-pressed, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
    }
});
function $9900830cb94354be$export$2e2bcd8739ae039(props) {
    const { href: href, target: target, eventHandlers: eventHandlers, fireAnalyticsEvent: fireAnalyticsEvent, isMediaLink: isMediaLink, dataAttributes: dataAttributes } = props;
    const anchorProps = {
        href: href,
        target: target,
        title: href
    };
    if (target === '_blank') anchorProps.rel = 'noreferrer noopener';
    const handler = (0, $K5Jsy.getEventHandler)(eventHandlers, 'link');
    if (isMediaLink) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, props.children);
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $daJ0i.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iHvAB.default), {
        css: $9900830cb94354be$var$anchorStyles,
        onClick: (e)=>{
            if (fireAnalyticsEvent) fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).VISITED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).LINK,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB,
                    mode: (0, $knXBU.MODE).RENDERER
                }
            });
            if (handler) handler(e, href);
        },
        ...anchorProps,
        ...dataAttributes,
        ...(0, $VSDnB.fg)('platform_editor_hyperlink_underline') && {
            isLinkComponent: true
        }
    }, props.children));
}

});
parcelRegister("K5Jsy", function(module, exports) {

$parcel$export(module.exports, "ADFEncoder", () => $75b48ee07210971a$export$bcf771b83128eae7);
$parcel$export(module.exports, "getText", () => $75b48ee07210971a$export$c72d34660a162238);
$parcel$export(module.exports, "getEventHandler", () => $75b48ee07210971a$export$eee20638634729b3);
$parcel$export(module.exports, "findInTree", () => $75b48ee07210971a$export$38b61ebf4950cd39);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $kOFhM = parcelRequire("kOFhM");

var $hYNZx = parcelRequire("hYNZx");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $75b48ee07210971a$var$createEncoder(parser, encoder) {
    return (value)=>encoder.encode(parser.parse(value));
}
class $75b48ee07210971a$export$bcf771b83128eae7 {
    constructor(createTransformerWithSchema){
        const transformer = createTransformerWithSchema((0, $kOFhM.defaultSchema));
        this.encode = $75b48ee07210971a$var$createEncoder(transformer, new (0, $hYNZx.JSONTransformer)());
    }
}
const $75b48ee07210971a$export$c72d34660a162238 = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : node.type.name}]`;
};
const $75b48ee07210971a$export$eee20638634729b3 = (eventHandlers, type, eventName = 'onClick')=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return eventHandlers && type && eventHandlers[type] && eventHandlers[type][eventName];
};
function $75b48ee07210971a$export$38b61ebf4950cd39(element, topElement, evaluate) {
    if (element === topElement) return false;
    if (evaluate(element)) return true;
    if (!element.parentElement) return false;
    return $75b48ee07210971a$export$38b61ebf4950cd39(element.parentElement, topElement, evaluate);
}

});

parcelRegister("iHvAB", function(module, exports) {

$parcel$export(module.exports, "default", () => $65e7a399613e0863$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $994MI = parcelRequire("994MI");

var $e4yMr = parcelRequire("e4yMr");

var $VSDnB = parcelRequire("VSDnB");

var $g2eZ6 = parcelRequire("g2eZ6");

var $66xOO = parcelRequire("66xOO");

var $hTTxJ = parcelRequire("hTTxJ");

var $cI2hq = parcelRequire("cI2hq");
const $65e7a399613e0863$var$PACKAGE_DATA = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: 'linkUrl'
};
const $65e7a399613e0863$var$Anchor = (0, $g2eZ6.withLinkClickedEvent)('a');
const $65e7a399613e0863$export$8c0773eab230d49e = (0, $g2eZ6.withLinkClickedEvent)((0, $e4yMr.default));
const $65e7a399613e0863$var$LinkUrl = ({ href: href, children: children, checkSafety: checkSafety = true, onClick: onClick, testId: testId = 'link-with-safety', isLinkComponent: isLinkComponent = false, ...props })=>{
    (0, $gKZoD.di)($65e7a399613e0863$export$8c0773eab230d49e, (0, $cI2hq.useLinkWarningModal));
    const { isLinkSafe: isLinkSafe, showSafetyWarningModal: showSafetyWarningModal, ...linkWarningModalProps } = (0, $cI2hq.useLinkWarningModal)();
    const Link = isLinkComponent && (0, $VSDnB.fg)('platform_editor_hyperlink_underline') ? $65e7a399613e0863$export$8c0773eab230d49e : $65e7a399613e0863$var$Anchor;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $66xOO.LinkAnalyticsContext), {
                url: href,
                display: "url",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(Link, {
                    "data-testid": testId,
                    href: href || '',
                    onClick: (e)=>{
                        if (!checkSafety) {
                            onClick && onClick(e);
                            return;
                        }
                        // Only call the onClick if the link is safe
                        if (isLinkSafe(e, href)) onClick && onClick(e);
                        else showSafetyWarningModal(e, href);
                    },
                    ...props,
                    children: children
                })
            }),
            checkSafety && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hTTxJ.default), {
                ...linkWarningModalProps
            })
        ]
    });
};
var $65e7a399613e0863$export$2e2bcd8739ae039 = (0, $994MI.default)($65e7a399613e0863$var$PACKAGE_DATA)($65e7a399613e0863$var$LinkUrl);

});
parcelRegister("66xOO", function(module, exports) {

$parcel$export(module.exports, "LinkAnalyticsContext", () => $a51765c35bf0b052$export$9458cdec663b9ff1);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");
const $a51765c35bf0b052$export$9458cdec663b9ff1 = ({ display: display, id: id, children: children, source: source })=>{
    const displayCategory = display === 'url' ? 'link' : undefined;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: {
            source: source,
            attributes: {
                displayCategory: displayCategory,
                display: display,
                id: id
            }
        },
        children: children
    });
};

});

parcelRegister("hTTxJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ef61591d3052acd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");
var $i5FdW = parcelRequire("i5FdW");

var $fVnbM = parcelRequire("fVnbM");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $VSDnB = parcelRequire("VSDnB");

var $7zaVw = parcelRequire("7zaVw");

var $a58QI = parcelRequire("a58QI");
const $6ef61591d3052acd$var$breakWordsCss = null;
const $6ef61591d3052acd$var$WarningModalNew = (props)=>{
    const { isOpen: isOpen, unsafeLinkText: unsafeLinkText, url: url, onClose: onClose, onContinue: onContinue, intl: intl } = props;
    const content = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i8Qvm.default), {
        children: isOpen && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1R1Ge.default), {
            onClose: onClose,
            testId: "link-with-safety-warning",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jgVsb.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gofOI.default), {
                        appearance: "warning",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $7zaVw.messages).check_this_link
                        })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7QSqG.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            "_o5726vc6 _1nmz9jpi"
                        ]),
                        children: url && unsafeLinkText && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $7zaVw.messages).link_safety_warning_message,
                            values: {
                                unsafeLinkText: unsafeLinkText,
                                a: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                                        href: url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: url
                                    })
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $juxqI.default), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                            appearance: "subtle",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $7zaVw.messages).go_back
                            })
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                            appearance: "warning",
                            onClick: onContinue,
                            autoFocus: true,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $7zaVw.messages).continue
                            })
                        })
                    ]
                })
            ]
        })
    });
    return intl ? content : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: "en",
        children: content
    });
};
const $6ef61591d3052acd$var$Component = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, $2OMIu.jsx)($6ef61591d3052acd$var$WarningModalNew, {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a58QI.default), {
        ...props
    });
};
var $6ef61591d3052acd$export$2e2bcd8739ae039 = (0, $8RXs9.default)($6ef61591d3052acd$var$Component, {
    enforceContext: false
});

});
parcelRegister("a58QI", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5e6a6bcd9645309$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $ousew = parcelRequire("ousew");
var $i5FdW = parcelRequire("i5FdW");

var $fVnbM = parcelRequire("fVnbM");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $7zaVw = parcelRequire("7zaVw");

var $5joKY = parcelRequire("5joKY");
const $e5e6a6bcd9645309$var$WarningModalOld = (props)=>{
    const { isOpen: isOpen, unsafeLinkText: unsafeLinkText, url: url, onClose: onClose, onContinue: onContinue, intl: intl } = props;
    const content = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $i8Qvm.default), null, isOpen && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1R1Ge.default), {
        onClose: onClose,
        testId: "link-with-safety-warning"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jgVsb.default), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gofOI.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $7zaVw.messages).check_this_link))), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7QSqG.default), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: (0, $5joKY.breakWordsCss)
    }, url && unsafeLinkText && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), {
        ...(0, $7zaVw.messages).link_safety_warning_message,
        values: {
            unsafeLinkText: unsafeLinkText,
            a: ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)("a", {
                    href: url,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, url)
        }
    }))), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $juxqI.default), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fVnbM.default), {
        appearance: "subtle",
        onClick: onClose
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $7zaVw.messages).go_back)), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fVnbM.default), {
        appearance: "warning",
        onClick: onContinue,
        autoFocus: true
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $7zaVw.messages).continue)))));
    return intl ? content : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $i5FdW.default), {
        locale: "en"
    }, content);
};
var $e5e6a6bcd9645309$export$2e2bcd8739ae039 = $e5e6a6bcd9645309$var$WarningModalOld;

});
parcelRegister("5joKY", function(module, exports) {

$parcel$export(module.exports, "breakWordsCss", () => $b66aa972276b3574$export$e4dda5b86d39ace5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $b66aa972276b3574$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b66aa972276b3574$export$e4dda5b86d39ace5 = {
    name: "1ujvzzx",
    styles: "white-space:pre-line;word-break:break-all"
};

});



parcelRegister("cI2hq", function(module, exports) {

$parcel$export(module.exports, "useLinkWarningModal", () => $afd5dc953340b04b$export$32b76c003683c2ec);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $57Lhk = parcelRequire("57Lhk");

var $fzJZi = parcelRequire("fzJZi");
const $afd5dc953340b04b$var$toUrl = (url, base)=>{
    try {
        return new URL(url, base);
    } catch  {
        return undefined;
    }
};
const $afd5dc953340b04b$export$32b76c003683c2ec = ()=>{
    const [unsafeLinkText, setUnsafeLinkText] = (0, $5uXOq.useState)(null);
    const [url, setUrl] = (0, $5uXOq.useState)(null);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const sendWarningModalViewedEvent = ()=>{
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'linkSafetyWarningModal',
            eventType: 'screen',
            name: 'linkSafetyWarningModal'
        }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
    };
    const sendContinueClickedEvent = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'linkSafetyWarningModalContinue',
            eventType: 'ui',
            screen: 'linkSafetyWarningModal'
        }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
    };
    /**
	 * It checks and warns if a link text is a URL and different from an actual link destination
	 */ const isLinkSafe = (event, href)=>{
        if (!href) return true;
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        const normalisedUrlFromLinkText = (0, $57Lhk.normalizeUrl)(linkText);
        if (!normalisedUrlFromLinkText) return true;
        const anchorLinkRegex = new RegExp(/^#/im);
        const isLinkTextAnchorLink = anchorLinkRegex.test(linkText);
        const isAnchorLink = anchorLinkRegex.test(href);
        if (isAnchorLink || isLinkTextAnchorLink) return true;
        const relativeLinkRegex = new RegExp(/^\//im);
        const isRelativeHrefLink = relativeLinkRegex.test(href);
        if (isRelativeHrefLink) return true;
        const hrefUrl = $afd5dc953340b04b$var$toUrl(href, window.location.origin);
        const linkTextUrl = $afd5dc953340b04b$var$toUrl(normalisedUrlFromLinkText, hrefUrl?.origin);
        if (!hrefUrl || !linkTextUrl) return true;
        const httpProtocols = [
            'http:',
            'https:'
        ];
        let areProtocolsEquivalent;
        if (httpProtocols.includes(linkTextUrl.protocol) && httpProtocols.includes(hrefUrl.protocol)) {
            const noUserNameAndPassword = !linkTextUrl.username && !linkTextUrl.password && !hrefUrl.username && !hrefUrl.password;
            areProtocolsEquivalent = noUserNameAndPassword;
        } else areProtocolsEquivalent = linkTextUrl.protocol === hrefUrl.protocol;
        const areEquivalentLinks = linkTextUrl.hostname === hrefUrl.hostname && linkTextUrl.pathname === hrefUrl.pathname && linkTextUrl.search === hrefUrl.search && linkTextUrl.username === hrefUrl.username && linkTextUrl.password === hrefUrl.password && areProtocolsEquivalent;
        if (!areEquivalentLinks) return false;
        return true;
    };
    const showSafetyWarningModal = (event, href)=>{
        event.preventDefault();
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        setUnsafeLinkText(linkText);
        href && setUrl(href);
        setIsOpen(true);
        sendWarningModalViewedEvent();
    };
    const onClose = ()=>{
        setIsOpen(false);
        setUnsafeLinkText(null);
        setUrl(null);
    };
    const onContinue = ()=>{
        onClose();
        sendContinueClickedEvent();
        url && window.open(url, '_blank', 'noopener noreferrer');
    };
    return {
        isLinkSafe: isLinkSafe,
        isOpen: isOpen,
        onClose: onClose,
        onContinue: onContinue,
        showSafetyWarningModal: showSafetyWarningModal,
        unsafeLinkText: unsafeLinkText,
        url: url
    };
};

});
parcelRegister("57Lhk", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $8f5c48f3a9939b0b$export$c9f92f5469372e0f);
$parcel$export(module.exports, "normalizeUrl", () => $8f5c48f3a9939b0b$export$6535eb414fa2c8b6);
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $e2gHg = parcelRequire("e2gHg");
const $8f5c48f3a9939b0b$var$linkify = (0, (/*@__PURE__*/$parcel$interopDefault($e2gHg)))();
$8f5c48f3a9939b0b$var$linkify.add('sourcetree:', 'http:');
$8f5c48f3a9939b0b$var$linkify.add('jamfselfservice:', 'http:');
$8f5c48f3a9939b0b$var$linkify.add('notes:', 'http:');
const $8f5c48f3a9939b0b$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $8f5c48f3a9939b0b$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$8f5c48f3a9939b0b$var$tlds.push($8f5c48f3a9939b0b$var$tlds2Char);
$8f5c48f3a9939b0b$var$linkify.tlds($8f5c48f3a9939b0b$var$tlds, false);
const $8f5c48f3a9939b0b$var$whitelistedURLPatterns = [
    /^https?:\/\/[^\s]*$/im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\/[^\s]*$/im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:[^\s]*$/im,
    /^facetime:[^\s]*$/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    /^sourcetree:/im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^foo:/im,
    /^#/im
];
const $8f5c48f3a9939b0b$var$normaliseLinkHref = (url)=>{
    const match = $8f5c48f3a9939b0b$var$getLinkMatch(url);
    return match && match.url || null;
};
const $8f5c48f3a9939b0b$var$getLinkMatch = (str)=>{
    if (!str) return null;
    let match = $8f5c48f3a9939b0b$var$linkifyMatch(str);
    if (!match.length) match = $8f5c48f3a9939b0b$var$linkify.match(str);
    return match && match.length > 0 && match[0].index === 0 && match[0].lastIndex === str.trim().length ? match[0] : null;
};
const $8f5c48f3a9939b0b$var$LINK_REGEXP = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $8f5c48f3a9939b0b$var$linkifyMatch = (text)=>{
    const matches = [];
    if (!$8f5c48f3a9939b0b$var$LINK_REGEXP.test(text)) return matches;
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($8f5c48f3a9939b0b$var$LINK_REGEXP) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($8f5c48f3a9939b0b$var$LINK_REGEXP);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
const $8f5c48f3a9939b0b$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    return $8f5c48f3a9939b0b$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
function $8f5c48f3a9939b0b$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    const urlWithoutNewlines = url.replace(/[\r\n]+/g, '');
    if ($8f5c48f3a9939b0b$export$c9f92f5469372e0f(urlWithoutNewlines)) return urlWithoutNewlines.trim();
    return $8f5c48f3a9939b0b$var$normaliseLinkHref(urlWithoutNewlines);
}

});
parcelRegister("e2gHg", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $a37e3434b26d3f31$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $a37e3434b26d3f31$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $a37e3434b26d3f31$var$isString(obj) {
    return $a37e3434b26d3f31$var$_class(obj) === '[object String]';
}
function $a37e3434b26d3f31$var$isObject(obj) {
    return $a37e3434b26d3f31$var$_class(obj) === '[object Object]';
}
function $a37e3434b26d3f31$var$isRegExp(obj) {
    return $a37e3434b26d3f31$var$_class(obj) === '[object RegExp]';
}
function $a37e3434b26d3f31$var$isFunction(obj) {
    return $a37e3434b26d3f31$var$_class(obj) === '[object Function]';
}
function $a37e3434b26d3f31$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $a37e3434b26d3f31$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $a37e3434b26d3f31$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $a37e3434b26d3f31$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $a37e3434b26d3f31$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $a37e3434b26d3f31$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $a37e3434b26d3f31$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $a37e3434b26d3f31$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $a37e3434b26d3f31$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $a37e3434b26d3f31$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $a37e3434b26d3f31$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("d5qnw"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($a37e3434b26d3f31$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($a37e3434b26d3f31$var$isObject(val)) {
            if ($a37e3434b26d3f31$var$isRegExp(val.validate)) compiled.validate = $a37e3434b26d3f31$var$createValidator(val.validate);
            else if ($a37e3434b26d3f31$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($a37e3434b26d3f31$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $a37e3434b26d3f31$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($a37e3434b26d3f31$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $a37e3434b26d3f31$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($a37e3434b26d3f31$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $a37e3434b26d3f31$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $a37e3434b26d3f31$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $a37e3434b26d3f31$var$createMatch(self, shift) {
    var match = new $a37e3434b26d3f31$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $a37e3434b26d3f31$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $a37e3434b26d3f31$var$LinkifyIt)) return new $a37e3434b26d3f31$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($a37e3434b26d3f31$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $a37e3434b26d3f31$var$assign({}, $a37e3434b26d3f31$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $a37e3434b26d3f31$var$assign({}, $a37e3434b26d3f31$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $a37e3434b26d3f31$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $a37e3434b26d3f31$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $a37e3434b26d3f31$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $a37e3434b26d3f31$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($a37e3434b26d3f31$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($a37e3434b26d3f31$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $a37e3434b26d3f31$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $a37e3434b26d3f31$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $a37e3434b26d3f31$var$LinkifyIt;

});
parcelRegister("d5qnw", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("b9ep3")).source;
    re.src_Cc = (parcelRequire("23ErL")).source;
    re.src_Z = (parcelRequire("oRY4m")).source;
    re.src_P = (parcelRequire("9bBmm")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + ').|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]).|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});






parcelRegister("f14yv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e31acef3336a9ea7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $e31acef3336a9ea7$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        ...props.dataAttributes,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            textDecoration: 'line-through'
        }
    }, props.children);
}

});

parcelRegister("eVxaj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3356ea5acdd73a43$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $3356ea5acdd73a43$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("strong", props.dataAttributes, props.children);
}

});

parcelRegister("gUlHA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c264e87eca3a3d05$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $c264e87eca3a3d05$var$isSub = (type)=>{
    return type === 'sub';
};
function $c264e87eca3a3d05$export$2e2bcd8739ae039(props) {
    if ($c264e87eca3a3d05$var$isSub(props.type)) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("sub", props.dataAttributes, props.children);
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("sup", props.dataAttributes, props.children);
}

});

parcelRegister("c15YI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8904856eee164f6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $87j2U = parcelRequire("87j2U");

var $lKA8N = parcelRequire("lKA8N");

var $hxoiH = parcelRequire("hxoiH");
function $c8904856eee164f6$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    // Note -- while there is no way to create custom colors using default tooling
    // the editor does supported ad hoc color values -- and there may be content
    // which has been migrated or created via apis which use such values.
    let paletteColorValue;
    /**
   * The Editor persists custom text colors when content has been migrated from the old editor, or created via
   * apis.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text colors copied from external editor sources. Where we load the background color from a
   * seperate attribute (data-text-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $lKA8N.hexToEditorTextPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = (0, $lKA8N.hexToEditorTextPaletteColor)(props.color) || props.color;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $87j2U.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $5uXOq.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        ...props.dataAttributes,
        "data-text-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-text-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, props.children);
}

});
parcelRegister("lKA8N", function(module, exports) {

$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $965e3166a7c18c5e$export$9c2f408d391feb93);
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching text palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToTextPaletteColor('#0747A6');
 * //     ^? const cssValue: string
 * <span style={{textColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $965e3166a7c18c5e$export$9c2f408d391feb93(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $965e3166a7c18c5e$export$57fa5089caad992[hexColor.toUpperCase()];
}
const $965e3166a7c18c5e$export$57fa5089caad992 = {
    // blue
    /** blue - light */ ['#B3D4FF']: "var(--ds-background-accent-blue-subtler, #B3D4FF)",
    // source for hex code was legacy token B75
    /** blue - medium */ ['#4C9AFF']: "var(--ds-icon-accent-blue, #4C9AFF)",
    // source for hex code was legacy token B100
    /** blue - strong */ ['#0747A6']: "var(--ds-text-accent-blue, #0747A6)",
    // source for hex code was legacy token B500
    // teal
    /** teal - light */ ['#B3F5FF']: "var(--ds-background-accent-teal-subtler, #B3F5FF)",
    // source for hex code was legacy token T75
    /** teal - medium */ ['#00B8D9']: "var(--ds-icon-accent-teal, #00B8D9)",
    // source for hex code was legacy token T300
    /** teal - strong */ ['#008DA6']: "var(--ds-text-accent-teal, #008DA6)",
    // source for hex code was legacy token T500
    // green
    /** green - light */ ['#ABF5D1']: "var(--ds-background-accent-green-subtler, #ABF5D1)",
    // source for hex code was legacy token G75
    /** green - medium */ ['#36B37E']: "var(--ds-icon-accent-green, #36B37E)",
    // source for hex code was legacy token G300
    /** green - strong */ ['#006644']: "var(--ds-text-accent-green, #006644)",
    // source for hex code was legacy token G500
    // yellowOrange
    /** yellowOrange - light */ ['#FFF0B3']: "var(--ds-background-accent-yellow-subtler, #FFF0B3)",
    // source for hex code was legacy token Y75
    /** yellowOrange - medium */ ['#FFC400']: "var(--ds-background-accent-orange-subtle, #FFC400)",
    // source for hex code was legacy token Y200
    /** yellowOrange - strong */ ['#FF991F']: "var(--ds-icon-accent-orange, #FF991F)",
    // source for hex code was legacy token Y400
    // red
    /** red - light */ ['#FFBDAD']: "var(--ds-background-accent-red-subtler, #FFBDAD)",
    // source for hex code was legacy token R75
    /** red - medium */ ['#FF5630']: "var(--ds-icon-accent-red, #FF5630)",
    // source for hex code was legacy token R300
    /** red - strong */ ['#BF2600']: "var(--ds-text-accent-red, #BF2600)",
    // source for hex code was legacy token R500
    // purple
    /** purple - light */ ['#EAE6FF']: "var(--ds-background-accent-purple-subtler, #EAE6FF)",
    // source for hex code was legacy token P50
    /** purple - medium */ ['#6554C0']: "var(--ds-icon-accent-purple, #6554C0)",
    // source for hex code was legacy token P300
    /** purple - strong */ ['#403294']: "var(--ds-text-accent-purple, #403294)",
    // source for hex code was legacy token P500
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: "var(--ds-text-inverse, #FFFFFF)",
    // source for hex code was legacy token N0
    /** whiteGray - medium */ ['#97A0AF']: "var(--ds-icon-accent-gray, #97A0AF)",
    // source for hex code was legacy token N80
    /** whiteGray - strong */ ['#172B4D']: "var(--ds-text, #172B4D)" // source for hex code was legacy token N800
};

});


parcelRegister("koUAb", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d139f843714a421$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $87j2U = parcelRequire("87j2U");

var $7dikW = parcelRequire("7dikW");

var $hxoiH = parcelRequire("hxoiH");
function $7d139f843714a421$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    let paletteColorValue;
    /**
   * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text background colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text background colors copied from external editor sources. Where we load the background color from a
   * separate attribute (data-background-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $7dikW.hexToEditorTextBackgroundPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = tokenColor;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $87j2U.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $5uXOq.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        ...props.dataAttributes,
        "data-background-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-background-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, props.children);
}

});
parcelRegister("7dikW", function(module, exports) {

$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $b5a4f7ad3e4ae03c$export$8b58ff1b36bb75e0);
// This import will be stripped on build
// Color tokens defined on https://hello.atlassian.net/wiki/spaces/EOU/pages/3587733210/Text+highlighting+-+designs#Colour-palette
// values are asserted to improve generated type declarations
const $b5a4f7ad3e4ae03c$export$12a518ff137dd389 = {
    /** Gray - light */ ['#DCDFE4']: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
    /** Teal - light */ ['#C6EDFB']: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    /** Lime - light */ ['#D3F1A7']: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    /** Orange - light */ ['#FEDEC8']: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    /** Magenta - light */ ['#FDD0EC']: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    /** Purple - light */ ['#DFD8FD']: "var(--ds-background-accent-purple-subtler, #DFD8FD)"
};
function $b5a4f7ad3e4ae03c$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-ignore
    return $b5a4f7ad3e4ae03c$export$12a518ff137dd389[hexColor.toUpperCase()];
}

});


parcelRegister("eESZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f8016b636a69d58$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $6f8016b636a69d58$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("u", props.dataAttributes, props.children);
}

});

parcelRegister("95Yll", function(module, exports) {

$parcel$export(module.exports, "default", () => $56f1f5242a99941b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $4ceoy = parcelRequire("4ceoy");

var $eOOFp = parcelRequire("eOOFp");

var $iHYdz = parcelRequire("iHYdz");

var $gmhCD = parcelRequire("gmhCD");
const $56f1f5242a99941b$var$wrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `${(0, $iHYdz.blockNodesVerticalMargin)} 0`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginLeft: '50%',
    transform: 'translateX(-50%)'
});
function $56f1f5242a99941b$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthConsumer), null, ({ width: width })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $56f1f5242a99941b$var$wrapperStyles,
            "data-mode": props.mode,
            ...(0, $gmhCD.editorExperiment)('advanced_layouts', true) && {
                'data-has-width': !!props.width,
                'data-width': props.width
            },
            style: {
                width: (0, $gmhCD.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $eOOFp.calcBreakoutWithCustomWidth)(props.mode, 'width' in props ? props.width : null, width) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $eOOFp.calcBreakoutWidth)(props.mode, width)
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "fabric-editor-breakout-mark fabric-editor-block-mark"
        }, props.children));
}

});

parcelRegister("lbdLJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1b7090399d1e727$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $aeGrH = parcelRequire("aeGrH");
const $d1b7090399d1e727$var$MarkWrapper = (props)=>{
    const styles = props['data-align'] ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $f8Sb3.css)("text-align:", (0, $aeGrH.alignmentPositionMap)[props['data-align']], ";") : '';
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: styles,
        ...props
    }, props.children);
};
function $d1b7090399d1e727$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($d1b7090399d1e727$var$MarkWrapper, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-alignment",
        "data-align": props.align
    }, props.children);
}

});

parcelRegister("9xZ5X", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ef073b46e3c6008$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $3ef073b46e3c6008$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-indentation-mark",
        "data-level": props.level
    }, props.children);
}

});

parcelRegister("g5EjF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1398622ac205fad$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $b1398622ac205fad$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", props.dataAttributes, props.children);
}

});

parcelRegister("acz8Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $04eeed03d14d0e78$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $04eeed03d14d0e78$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", props.dataAttributes, props.children);
}

});

parcelRegister("8DQfy", function(module, exports) {

$parcel$export(module.exports, "default", () => $009dff5e97619965$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $009dff5e97619965$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrapperElement, {
        "data-source": props.sources ? JSON.stringify(props.sources) : undefined,
        "data-mark-type": "dataConsumer",
        ...props.dataAttributes
    }, props.children);
}

});

parcelRegister("g9yqu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ac6eff929f5b91e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $8ac6eff929f5b91e$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrapperElement, {
        "data-localId": props.localId,
        "data-name": props.name,
        "data-mark-type": "fragment",
        ...props.dataAttributes
    }, props.children);
}

});

parcelRegister("itF0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f200b42408cc462$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $7f200b42408cc462$export$2e2bcd8739ae039(props) {
    const borderColor = props.color ?? '';
    const borderSize = props.size ?? 0;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        "data-color": borderColor,
        "data-size": borderSize,
        "data-mark-type": "border"
    }, props.children);
}

});

parcelRegister("6EeUE", function(module, exports) {

$parcel$export(module.exports, "default", () => $efbb661461ca3406$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
class $efbb661461ca3406$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        const { reference: reference, children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            "data-mark-type": "confluenceInlineComment",
            "data-reference": reference
        }, children);
    }
}

});


parcelRegister("eQNWQ", function(module, exports) {

$parcel$export(module.exports, "getMarksByOrder", () => $7bbfc2d34b0938dd$export$99a33ed044c278ae);
$parcel$export(module.exports, "isSameMark", () => $7bbfc2d34b0938dd$export$b1304404bdc42b7a);
$parcel$export(module.exports, "getValidDocument", () => $7bbfc2d34b0938dd$export$fb80336a7e408cb3);
$parcel$export(module.exports, "getValidNode", () => $7bbfc2d34b0938dd$export$81b20b6c83a56bd);

var $9IGaJ = parcelRequire("9IGaJ");
var $kc0v7 = parcelRequire("kc0v7");
var $iZOJ9 = parcelRequire("iZOJ9");
var $bFtEE = parcelRequire("bFtEE");

var $kOFhM = parcelRequire("kOFhM");

var $VSDnB = parcelRequire("VSDnB");
const $7bbfc2d34b0938dd$export$3b94ef2190b2d585 = {
    FINAL: 'final',
    STAGE_0: 'stage0'
};
const $7bbfc2d34b0938dd$export$62d5811a2955c1d8 = [
    'fragment',
    'link',
    'em',
    'strong',
    'textColor',
    'backgroundColor',
    'strike',
    'subsup',
    'underline',
    'code',
    'confluenceInlineComment',
    'annotation',
    'dataConsumer'
];
const $7bbfc2d34b0938dd$export$30f8aa4cc1f8c1cb = (type)=>{
    return type === 'sub' || type === 'sup';
};
const $7bbfc2d34b0938dd$export$99a33ed044c278ae = (marks)=>{
    return [
        ...marks
    ].sort((a, b)=>$7bbfc2d34b0938dd$export$62d5811a2955c1d8.indexOf(a.type.name) - $7bbfc2d34b0938dd$export$62d5811a2955c1d8.indexOf(b.type.name));
};
const $7bbfc2d34b0938dd$export$b1304404bdc42b7a = (mark, otherMark)=>{
    if (!mark || !otherMark) return false;
    return mark.eq(otherMark);
};
const $7bbfc2d34b0938dd$export$fb80336a7e408cb3 = (doc, schema = (0, $kOFhM.defaultSchema), adfStage = 'final')=>{
    const node = $7bbfc2d34b0938dd$export$81b20b6c83a56bd(doc, schema, adfStage);
    if (node.type === 'doc') {
        node.content = $7bbfc2d34b0938dd$var$wrapInlineNodes(node.content);
        return node;
    }
    return null;
};
const $7bbfc2d34b0938dd$var$wrapInlineNodes = (nodes = [])=>{
    return nodes.map((node)=>(0, $kc0v7.inlineNodes).has(node.type) ? {
            type: 'paragraph',
            content: [
                node
            ]
        } : node);
};
const $7bbfc2d34b0938dd$export$fafd4f799ee68da0 = (content, schema = (0, $kOFhM.defaultSchema), adfStage = 'final')=>{
    return content.map((node)=>$7bbfc2d34b0938dd$export$81b20b6c83a56bd(node, schema, adfStage));
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7bbfc2d34b0938dd$var$TEXT_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7bbfc2d34b0938dd$var$RELATIVE_LINK = /^\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7bbfc2d34b0938dd$var$ANCHOR_LINK = /^#/;
const $7bbfc2d34b0938dd$var$flattenUnknownBlockTree = (node, schema = (0, $kOFhM.defaultSchema), adfStage = 'final')=>{
    const output = [];
    let isPrevLeafNode = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    for(let i = 0; i < node.content.length; i++){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const childNode = node.content[i];
        const isLeafNode = !(childNode.content && childNode.content.length);
        if (i > 0) {
            if (isPrevLeafNode) output.push({
                type: 'text',
                text: ' '
            });
            else output.push({
                type: 'hardBreak'
            });
        }
        if (isLeafNode) output.push($7bbfc2d34b0938dd$export$81b20b6c83a56bd(childNode, schema, adfStage));
        else output.push(...$7bbfc2d34b0938dd$var$flattenUnknownBlockTree(childNode, schema, adfStage));
        isPrevLeafNode = isLeafNode;
    }
    return output;
};
const $7bbfc2d34b0938dd$export$b9908ef75cad1e0e = (node)=>{
    const { attrs: attrs = {}, content: content, text: text, type: type } = node;
    if (!content || !content.length) {
        const unknownInlineNode = {
            type: 'text',
            text: text || attrs.text || `[${type}]`
        };
        const { textUrl: textUrl } = attrs;
        if (textUrl && (0, $iZOJ9.isSafeUrl)(textUrl)) unknownInlineNode.marks = [
            {
                type: 'link',
                attrs: {
                    href: textUrl
                }
            }
        ];
        return unknownInlineNode;
    }
    /*
	 * Find leaf nodes and join them. If leaf nodes' parent node is the same node
	 * join with a blank space, otherwise they are children of different branches, i.e.
	 * we need to join them with a hardBreak node
	 */ return {
        type: 'unknownBlock',
        content: $7bbfc2d34b0938dd$var$flattenUnknownBlockTree(node)
    };
};
const $7bbfc2d34b0938dd$var$getValidMarks = (marks, adfStage = 'final')=>{
    if (marks && marks.length > 0) return marks.reduce((acc, mark)=>{
        const validMark = $7bbfc2d34b0938dd$export$87c6d4a6ebb7d9e9(mark, adfStage);
        if (validMark) acc.push(validMark);
        return acc;
    }, []);
    return marks;
};
const $7bbfc2d34b0938dd$export$81b20b6c83a56bd = (originalNode, schema = (0, $kOFhM.defaultSchema), adfStage = 'final')=>{
    const { attrs: attrs, marks: marks, text: text, type: type } = originalNode;
    let { content: content } = originalNode;
    const node = {
        attrs: attrs,
        marks: marks,
        text: text,
        type: type
    };
    if (content) node.content = content = $7bbfc2d34b0938dd$export$fafd4f799ee68da0(content, schema, adfStage);
    // If node type doesn't exist in schema, make it an unknown node
    if (!schema.nodes[type]) return $7bbfc2d34b0938dd$export$b9908ef75cad1e0e(node);
    if (type) switch(type){
        case 'doc':
            {
                const { version: version } = originalNode;
                if (version && content && content.length) return {
                    type: type,
                    content: content
                };
                break;
            }
        case 'codeBlock':
            if (content) content = content.reduce((acc, val)=>{
                if (val.type === 'text') acc.push({
                    type: val.type,
                    text: val.text
                });
                return acc;
            }, []);
            if (attrs && attrs.language) return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
            return {
                type: type,
                content: content,
                marks: marks
            };
        case 'date':
            if (attrs && attrs.timestamp) return {
                type: type,
                attrs: attrs,
                ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'status':
            if (attrs && attrs.text && attrs.color) return {
                type: type,
                attrs: attrs,
                ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'emoji':
            if (attrs && attrs.shortName) return {
                type: type,
                attrs: attrs,
                ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'inlineExtension':
        case 'extension':
            if (attrs && attrs.extensionType && attrs.extensionKey) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'inlineCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $iZOJ9.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iZOJ9.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs,
                ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'blockCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $iZOJ9.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iZOJ9.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'embedCard':
            if (attrs && (attrs.url && (0, $iZOJ9.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iZOJ9.isSafeUrl)(attrs.data.url)) && attrs.layout) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'bodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'multiBodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'extensionFrame':
            if (content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'hardBreak':
            return {
                type: type
            };
        case 'caption':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'mediaInline':
            {
                let mediaId = '';
                let mediaCollection = [];
                if (attrs) {
                    const { id: id, collection: collection } = attrs;
                    mediaId = id;
                    mediaCollection = collection;
                }
                if (mediaId && mediaCollection) return {
                    type: type,
                    attrs: attrs,
                    marks: marks
                };
                break;
            }
        case 'media':
            {
                let mediaId = '';
                let mediaType = '';
                let mediaCollection = [];
                let mediaUrl = '';
                if (attrs) {
                    const { id: id, collection: collection, type: type, url: url } = attrs;
                    mediaId = id;
                    mediaType = type;
                    mediaCollection = collection;
                    mediaUrl = url;
                }
                if (mediaType === 'external' && !!mediaUrl) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        url: mediaUrl,
                        width: attrs.width,
                        height: attrs.height
                    };
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                } else if (mediaId && mediaType) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        id: mediaId,
                        collection: mediaCollection
                    };
                    if (attrs.width) mediaAttrs.width = attrs.width;
                    if (attrs.height) mediaAttrs.height = attrs.height;
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                }
                break;
            }
        case 'mediaGroup':
            if (Array.isArray(content) && !content.some((e)=>e.type !== 'media')) return {
                type: type,
                content: content
            };
            break;
        case 'mediaSingle':
            {
                const containsJustMedia = Array.isArray(content) && content.length === 1 && content[0].type === 'media';
                const containsMediaAndCaption = Array.isArray(content) && content.length === 2 && content[0].type === 'media' && content[1].type === 'caption';
                if (containsJustMedia || containsMediaAndCaption) return {
                    type: type,
                    attrs: attrs,
                    content: content,
                    marks: $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage)
                };
                break;
            }
        case 'mention':
            {
                let mentionText = '';
                let mentionId;
                let mentionAccess;
                if (attrs) {
                    const { text: text, displayName: displayName, id: id, accessLevel: accessLevel } = attrs;
                    mentionText = text || displayName;
                    mentionId = id;
                    mentionAccess = accessLevel;
                }
                if (!mentionText) mentionText = text || '@unknown';
                if (mentionText && mentionId) {
                    const mentionNode = {
                        type: type,
                        attrs: {
                            id: mentionId,
                            text: mentionText,
                            accessLevel: ''
                        },
                        ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                            marks: marks
                        } : {}
                    };
                    if (mentionAccess) mentionNode.attrs.accessLevel = mentionAccess;
                    return mentionNode;
                }
                break;
            }
        case 'paragraph':
            if (adfStage === 'stage0') {
                const paragraphNode = {
                    type: type,
                    content: content || []
                };
                if (attrs && attrs.localId) paragraphNode.attrs = {
                    localId: attrs.localId
                };
                if (marks) paragraphNode.marks = [
                    ...marks
                ];
                return paragraphNode;
            }
            return marks ? {
                type: type,
                content: content || [],
                marks: marks
            } : {
                type: type,
                content: content || []
            };
        case 'rule':
            return {
                type: type
            };
        case 'text':
            {
                const { marks: marks } = node;
                if (text) return marks ? {
                    type: type,
                    text: text,
                    marks: $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage)
                } : {
                    type: type,
                    text: text
                };
                break;
            }
        case 'heading':
            if (attrs) {
                const { level: level } = attrs;
                const between = (x, a, b)=>x >= a && x <= b;
                if (level && between(level, 1, 6)) {
                    if (adfStage === 'stage0') {
                        const headingNode = {
                            type: type,
                            content: content,
                            attrs: {
                                level: level
                            }
                        };
                        if (attrs.localId) headingNode.attrs.localId = attrs.localId;
                        if (marks) headingNode.marks = [
                            ...marks
                        ];
                        return headingNode;
                    }
                    return marks ? {
                        type: type,
                        content: content,
                        marks: marks,
                        attrs: {
                            level: level
                        }
                    } : {
                        type: type,
                        content: content,
                        attrs: {
                            level: level
                        }
                    };
                }
            }
            break;
        case 'bulletList':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'orderedList':
            if (content) return {
                type: type,
                content: content,
                attrs: {
                    order: attrs && attrs.order
                }
            };
            break;
        case 'listItem':
            if (content) return {
                type: type,
                content: $7bbfc2d34b0938dd$var$wrapInlineNodes(content)
            };
            break;
        case 'blockquote':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'panel':
            if (attrs && content) {
                const { panelType: panelType } = attrs;
                if (Object.values((0, $bFtEE.PanelType)).includes(panelType)) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
            }
            break;
        case 'layoutSection':
            if (content) return {
                type: type,
                marks: marks,
                content: content
            };
            break;
        case 'layoutColumn':
            if (attrs && content) {
                if (attrs.width > 0 && attrs.width <= 100) return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'decisionList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9IGaJ.generateUuid)()
                }
            };
        case 'decisionItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9IGaJ.generateUuid)(),
                    state: attrs && attrs.state || 'DECIDED'
                }
            };
        case 'taskList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9IGaJ.generateUuid)()
                }
            };
        case 'taskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9IGaJ.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'table':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableRow')) {
                if (adfStage === 'stage0') return {
                    type: type,
                    content: content,
                    attrs: {
                        ...attrs,
                        localId: attrs?.localId || (0, $9IGaJ.generateUuid)(),
                        width: attrs?.width || null
                    }
                };
                return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'tableRow':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableCell' && e.type !== 'tableHeader')) return {
                type: type,
                content: content
            };
            break;
        case 'tableCell':
        case 'tableHeader':
            if (content) {
                const cellAttrs = {};
                if (attrs) {
                    if (attrs.colspan && attrs.colspan > 1) cellAttrs.colspan = attrs.colspan;
                    if (attrs.rowspan && attrs.rowspan > 1) cellAttrs.rowspan = attrs.rowspan;
                    if (attrs.background) cellAttrs.background = attrs.background;
                    if (attrs.colwidth && Array.isArray(attrs.colwidth)) cellAttrs.colwidth = attrs.colwidth;
                }
                return {
                    type: type,
                    content: $7bbfc2d34b0938dd$var$wrapInlineNodes(content),
                    attrs: attrs ? cellAttrs : undefined
                };
            }
            break;
        case 'image':
            if (attrs && attrs.src) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'placeholder':
            if (attrs && typeof attrs.text !== 'undefined') return {
                type: type,
                attrs: attrs
            };
            break;
        case 'expand':
        case 'nestedExpand':
            return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
    }
    return $7bbfc2d34b0938dd$export$b9908ef75cad1e0e(node);
};
const $7bbfc2d34b0938dd$export$87c6d4a6ebb7d9e9 = (mark, adfStage = 'final')=>{
    const { attrs: attrs, type: type } = mark;
    if (type) switch(type){
        case 'code':
            return {
                type: type
            };
        case 'em':
            return {
                type: type
            };
        case 'link':
            if (attrs) {
                const { href: href, url: url, __confluenceMetadata: __confluenceMetadata } = attrs;
                let linkHref = href || url;
                if (linkHref && linkHref.indexOf(':') === -1 && !$7bbfc2d34b0938dd$var$RELATIVE_LINK.test(linkHref) && !$7bbfc2d34b0938dd$var$ANCHOR_LINK.test(linkHref)) linkHref = `http://${linkHref}`;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const linkAttrs = {
                    href: linkHref
                };
                if (__confluenceMetadata) linkAttrs.__confluenceMetadata = __confluenceMetadata;
                if (linkHref && (0, $iZOJ9.isSafeUrl)(linkHref)) return {
                    type: type,
                    attrs: linkAttrs
                };
            }
            break;
        case 'strike':
            return {
                type: type
            };
        case 'strong':
            return {
                type: type
            };
        case 'subsup':
            if (attrs && attrs['type']) {
                const subSupType = attrs['type'];
                if ($7bbfc2d34b0938dd$export$30f8aa4cc1f8c1cb(subSupType)) return {
                    type: type,
                    attrs: {
                        type: subSupType
                    }
                };
            }
            break;
        case 'textColor':
            if (attrs && $7bbfc2d34b0938dd$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'underline':
            return {
                type: type
            };
        case 'annotation':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
        case 'backgroundColor':
            if (attrs && $7bbfc2d34b0938dd$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
    }
    if (adfStage === 'stage0') switch(type){
        case 'confluenceInlineComment':
            return {
                type: type,
                attrs: attrs
            };
        case 'dataConsumer':
            return {
                type: type,
                attrs: attrs
            };
        case 'fragment':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
    }
    return null;
};

});
parcelRegister("kc0v7", function(module, exports) {

$parcel$export(module.exports, "inlineNodes", () => $eb355120b38723aa$export$b1f729c6af6f2a6e);

var $ctVrM = parcelRequire("ctVrM");
const $eb355120b38723aa$var$typedNodes = $ctVrM;
const $eb355120b38723aa$export$b1f729c6af6f2a6e = new Set(Object.keys($eb355120b38723aa$var$typedNodes).filter((key)=>$eb355120b38723aa$var$typedNodes[key] && $eb355120b38723aa$var$typedNodes[key].group === 'inline'));

});
parcelRegister("ctVrM", function(module, exports) {

$parcel$export(module.exports, "expand", () => (parcelRequire("7kC9H")).expand);
$parcel$export(module.exports, "expandWithNestedExpand", () => (parcelRequire("7kC9H")).expandWithNestedExpand);
$parcel$export(module.exports, "expandToJSON", () => (parcelRequire("7kC9H")).toJSON);
$parcel$export(module.exports, "confluenceJiraIssue", () => (parcelRequire("6bbHe")).confluenceJiraIssue);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => (parcelRequire("5y0tR")).confluenceUnsupportedBlock);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => (parcelRequire("bd7A9")).confluenceUnsupportedInline);
$parcel$export(module.exports, "doc", () => (parcelRequire("xjCuM")).doc);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("aXBFx")).blockquote);
$parcel$export(module.exports, "blockquoteWithList", () => (parcelRequire("aXBFx")).blockquoteWithList);
$parcel$export(module.exports, "blockquoteWithNestedCodeblockOrMedia", () => (parcelRequire("aXBFx")).blockquoteWithNestedCodeblockOrMedia);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("kjhhp")).bulletList);
$parcel$export(module.exports, "bulletListSelector", () => (parcelRequire("kjhhp")).bulletListSelector);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("8vlrc")).codeBlock);
$parcel$export(module.exports, "codeBlockToJSON", () => (parcelRequire("8vlrc")).toJSON);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("jnMM2")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("lRTZM")).heading);
$parcel$export(module.exports, "rule", () => (parcelRequire("M4hHz")).rule);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("dwptW")).orderedList);
$parcel$export(module.exports, "orderedListSelector", () => (parcelRequire("dwptW")).orderedListSelector);
$parcel$export(module.exports, "orderedListWithOrder", () => (parcelRequire("dwptW")).orderedListWithOrder);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("abme3")).paragraph);
$parcel$export(module.exports, "emoji", () => (parcelRequire("7DoMR")).emoji);
$parcel$export(module.exports, "image", () => (parcelRequire("7lRBh")).image);
$parcel$export(module.exports, "mention", () => (parcelRequire("g7Cky")).mention);
$parcel$export(module.exports, "mentionToJSON", () => (parcelRequire("g7Cky")).toJSON);
$parcel$export(module.exports, "listItem", () => (parcelRequire("2FIVU")).listItem);
$parcel$export(module.exports, "listItemWithTask", () => (parcelRequire("2FIVU")).listItemWithTask);
$parcel$export(module.exports, "listItemWithDecisionStage0", () => (parcelRequire("2FIVU")).listItemWithDecisionStage0);
$parcel$export(module.exports, "extendedPanel", () => (parcelRequire("bFtEE")).extendedPanel);
$parcel$export(module.exports, "PanelType", () => (parcelRequire("bFtEE")).PanelType);
$parcel$export(module.exports, "panelWithBlockquoteStage0", () => (parcelRequire("bFtEE")).panelWithBlockquoteStage0);
$parcel$export(module.exports, "text", () => (parcelRequire("3DR6L")).text);
$parcel$export(module.exports, "unknownBlock", () => (parcelRequire("9X587")).default);
$parcel$export(module.exports, "caption", () => (parcelRequire("5JeV5")).caption);
$parcel$export(module.exports, "media", () => (parcelRequire("7agO8")).media);
$parcel$export(module.exports, "copyPrivateMediaAttributes", () => (parcelRequire("7agO8")).copyPrivateAttributes);
$parcel$export(module.exports, "mediaToJSON", () => (parcelRequire("7agO8")).toJSON);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("92lix")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("7Xgp3")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("bIGZ7")).mediaSingle);
$parcel$export(module.exports, "mediaSingleSpec", () => (parcelRequire("bIGZ7")).mediaSingleSpec);
$parcel$export(module.exports, "mediaSingleWithCaption", () => (parcelRequire("bIGZ7")).mediaSingleWithCaption);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => (parcelRequire("bIGZ7")).mediaSingleWithWidthType);
$parcel$export(module.exports, "mediaSingleFull", () => (parcelRequire("bIGZ7")).mediaSingleFull);
$parcel$export(module.exports, "mediaSingleToJSON", () => (parcelRequire("bIGZ7")).toJSON);
$parcel$export(module.exports, "table", () => (parcelRequire("9UDEr")).table);
$parcel$export(module.exports, "tableWithNestedTable", () => (parcelRequire("9UDEr")).tableWithNestedTable);
$parcel$export(module.exports, "tableRowWithNestedTable", () => (parcelRequire("9UDEr")).tableRowWithNestedTable);
$parcel$export(module.exports, "tableCellWithNestedTable", () => (parcelRequire("9UDEr")).tableCellWithNestedTable);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => (parcelRequire("9UDEr")).tableHeaderWithNestedTable);
$parcel$export(module.exports, "tableStage0", () => (parcelRequire("9UDEr")).tableStage0);
$parcel$export(module.exports, "tableWithCustomWidth", () => (parcelRequire("9UDEr")).tableWithCustomWidth);
$parcel$export(module.exports, "tableToJSON", () => (parcelRequire("9UDEr")).tableToJSON);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("9UDEr")).tableCell);
$parcel$export(module.exports, "toJSONTableCell", () => (parcelRequire("9UDEr")).toJSONTableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("9UDEr")).tableHeader);
$parcel$export(module.exports, "toJSONTableHeader", () => (parcelRequire("9UDEr")).toJSONTableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("9UDEr")).tableRow);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => (parcelRequire("9UDEr")).tableBackgroundColorPalette);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => (parcelRequire("9UDEr")).tableBackgroundBorderColor);
$parcel$export(module.exports, "tableBackgroundColorNames", () => (parcelRequire("9UDEr")).tableBackgroundColorNames);
$parcel$export(module.exports, "getCellAttrs", () => (parcelRequire("9UDEr")).getCellAttrs);
$parcel$export(module.exports, "getCellDomAttrs", () => (parcelRequire("9UDEr")).getCellDomAttrs);
$parcel$export(module.exports, "tablePrefixSelector", () => (parcelRequire("9UDEr")).tablePrefixSelector);
$parcel$export(module.exports, "tableCellSelector", () => (parcelRequire("9UDEr")).tableCellSelector);
$parcel$export(module.exports, "tableHeaderSelector", () => (parcelRequire("9UDEr")).tableHeaderSelector);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => (parcelRequire("9UDEr")).tableCellContentWrapperSelector);
$parcel$export(module.exports, "tableCellContentDomSelector", () => (parcelRequire("9UDEr")).tableCellContentDomSelector);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("8gSD8")).decisionList);
$parcel$export(module.exports, "decisionListSelector", () => (parcelRequire("8gSD8")).decisionListSelector);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("Khvpb")).decisionItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("43mJF")).taskList);
$parcel$export(module.exports, "taskListSelector", () => (parcelRequire("43mJF")).taskListSelector);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("iThOL")).taskItem);
$parcel$export(module.exports, "date", () => (parcelRequire("b2VmY")).date);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("dgJoa")).placeholder);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("gZoER")).layoutSection);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => (parcelRequire("gZoER")).layoutSectionWithSingleColumn);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("4EbxI")).layoutColumn);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("cCBEe")).inlineCard);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("21PS7")).blockCard);
$parcel$export(module.exports, "unsupportedBlock", () => (parcelRequire("d1d6m")).unsupportedBlock);
$parcel$export(module.exports, "unsupportedInline", () => (parcelRequire("6kr5W")).unsupportedInline);
$parcel$export(module.exports, "status", () => (parcelRequire("18bvk")).status);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("dx5eC")).nestedExpand);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("kshOv")).embedCard);
$parcel$export(module.exports, "extension", () => (parcelRequire("hhN5g")).extension);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("5BOuQ")).inlineExtension);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("5AxYU")).bodiedExtension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("47jug")).extensionFrame);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("47jug")).multiBodiedExtension);

var $7kC9H = parcelRequire("7kC9H");

var $6bbHe = parcelRequire("6bbHe");

var $5y0tR = parcelRequire("5y0tR");

var $bd7A9 = parcelRequire("bd7A9");

var $xjCuM = parcelRequire("xjCuM");

var $aXBFx = parcelRequire("aXBFx");

var $kjhhp = parcelRequire("kjhhp");

var $8vlrc = parcelRequire("8vlrc");

var $jnMM2 = parcelRequire("jnMM2");

var $lRTZM = parcelRequire("lRTZM");

var $M4hHz = parcelRequire("M4hHz");

var $dwptW = parcelRequire("dwptW");

var $abme3 = parcelRequire("abme3");

var $7DoMR = parcelRequire("7DoMR");

var $7lRBh = parcelRequire("7lRBh");

var $g7Cky = parcelRequire("g7Cky");

var $2FIVU = parcelRequire("2FIVU");

var $bFtEE = parcelRequire("bFtEE");

var $3DR6L = parcelRequire("3DR6L");

var $9X587 = parcelRequire("9X587");

var $5JeV5 = parcelRequire("5JeV5");

var $7agO8 = parcelRequire("7agO8");

var $92lix = parcelRequire("92lix");

var $7Xgp3 = parcelRequire("7Xgp3");

var $bIGZ7 = parcelRequire("bIGZ7");

var $9UDEr = parcelRequire("9UDEr");

var $8gSD8 = parcelRequire("8gSD8");

var $Khvpb = parcelRequire("Khvpb");

var $43mJF = parcelRequire("43mJF");

var $iThOL = parcelRequire("iThOL");

var $b2VmY = parcelRequire("b2VmY");

var $dgJoa = parcelRequire("dgJoa");

var $gZoER = parcelRequire("gZoER");

var $4EbxI = parcelRequire("4EbxI");

var $cCBEe = parcelRequire("cCBEe");

var $21PS7 = parcelRequire("21PS7");

var $d1d6m = parcelRequire("d1d6m");

var $6kr5W = parcelRequire("6kr5W");

var $18bvk = parcelRequire("18bvk");

var $dx5eC = parcelRequire("dx5eC");

var $kshOv = parcelRequire("kshOv");

var $hhN5g = parcelRequire("hhN5g");

var $5BOuQ = parcelRequire("5BOuQ");

var $5AxYU = parcelRequire("5AxYU");

var $47jug = parcelRequire("47jug");

});



parcelRegister("bzwTW", function(module, exports) {

$parcel$export(module.exports, "insideBreakoutLayout", () => $99a90b85f857f7e6$export$d7bc71cca336a3b);
$parcel$export(module.exports, "insideBlockNode", () => $99a90b85f857f7e6$export$42ddc573eb5a7b43);
$parcel$export(module.exports, "insideMultiBodiedExtension", () => $99a90b85f857f7e6$export$9f1e9347b0411934);
$parcel$export(module.exports, "insideTable", () => $99a90b85f857f7e6$export$244bf4b32387ef62);
const $99a90b85f857f7e6$var$isLayoutNode = (node)=>node.type.name === 'layoutSection';
const $99a90b85f857f7e6$var$hasBreakOutMark = (node)=>node.marks.some((m)=>m.type.name === 'breakout');
const $99a90b85f857f7e6$export$d7bc71cca336a3b = (path)=>path.some((item)=>$99a90b85f857f7e6$var$isLayoutNode(item) && $99a90b85f857f7e6$var$hasBreakOutMark(item));
const $99a90b85f857f7e6$export$42ddc573eb5a7b43 = (path, schema)=>{
    const { nodes: { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } } = schema;
    const blockNodeNames = [
        expand,
        nestedExpand,
        layoutColumn
    ].filter((node)=>Boolean(node)).map((node)=>node.name);
    return path && path.some((n)=>n.type && blockNodeNames.indexOf(n.type.name) > -1);
};
const $99a90b85f857f7e6$export$9f1e9347b0411934 = (path, schema)=>{
    const { nodes: { multiBodiedExtension: multiBodiedExtension } } = schema;
    return path.some((n)=>n.type === multiBodiedExtension);
};
const $99a90b85f857f7e6$export$244bf4b32387ef62 = (path, schema)=>{
    const { nodes: { table: table } } = schema;
    return path.some((n)=>n.type === table);
};

});


parcelRegister("12yAL", function(module, exports) {

$parcel$export(module.exports, "renderDocument", () => $af6d4930d9141440$export$59a54f98b9753d5c);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $kOFhM = parcelRequire("kOFhM");

var $4FBRr = parcelRequire("4FBRr");
var $aSk3Q = parcelRequire("aSk3Q");

var $gkwXh = parcelRequire("gkwXh");

var $d54NZ = parcelRequire("d54NZ");
var $4IuOY = parcelRequire("4IuOY");

var $eQNWQ = parcelRequire("eQNWQ");

var $VSDnB = parcelRequire("VSDnB");

var $8QpSo = parcelRequire("8QpSo");

var $knXBU = parcelRequire("knXBU");

var $1cjf7 = parcelRequire("1cjf7");

var $kgV4b = parcelRequire("kgV4b");
const $af6d4930d9141440$var$SUPPORTS_HIRES_TIMER_API = !!(typeof window !== 'undefined' && window.performance && performance.now);
const $af6d4930d9141440$var$withStopwatch = (cb)=>{
    const startTime = $af6d4930d9141440$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const output = cb();
    const endTime = $af6d4930d9141440$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const time = endTime - startTime;
    return {
        output: output,
        time: time
    };
};
const $af6d4930d9141440$var$_validation = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation)=>{
    let result;
    if (useSpecBasedValidator) {
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $4FBRr.transformMediaLinkMarks)(doc);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
        result = skipValidation ? transformedAdf || doc : (0, $4IuOY.validateADFEntity)(schema, transformedAdf || doc, dispatchAnalyticsEvent);
    } else result = (0, $eQNWQ.getValidDocument)(doc, schema, adfStage);
    if (!result) return result;
    // ProseMirror always require a child under doc
    if (result.type === 'doc' && useSpecBasedValidator) {
        if (Array.isArray(result.content) && result.content.length === 0) result.content.push({
            type: 'paragraph',
            content: []
        });
        // Just making sure doc is always valid
        if (!result.version) result.version = 1;
    }
    if ((0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) // Convert nested-table extensions into nested tables
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $aSk3Q.transformNestedTablesIncomingDocument)(result, {
            environment: 'renderer'
        });
        if (isTransformed) {
            dispatchAnalyticsEvent?.({
                action: (0, $gkwXh.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
            });
            result = transformedAdf;
        }
    } catch (e) {
        dispatchAnalyticsEvent?.({
            action: (0, $gkwXh.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB,
                errorStack: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
            }
        });
    }
    return result;
};
const $af6d4930d9141440$var$memoValidation = (0, $8QpSo.default)($af6d4930d9141440$var$_validation, (newArgs, lastArgs)=>{
    const [newDoc, newSchema, newADFStage, newUseSpecValidator, skipValidation] = newArgs;
    const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator, oldSkipValidation] = lastArgs;
    // we're ignoring changes to dispatchAnalyticsEvent in this check
    const result = $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator && skipValidation === oldSkipValidation;
    return result;
});
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $af6d4930d9141440$var$areDocsEqual = (docA, docB)=>{
    if (docA === docB) return true;
    if (typeof docA === 'string' && typeof docB === 'string') return docA === docB;
    // PMNode
    if (docA.type && docA.toJSON && docB.type && docB.toJSON) return JSON.stringify(docA.toJSON()) === JSON.stringify(docB.toJSON());
    // Object
    return JSON.stringify(docA) === JSON.stringify(docB);
};
const $af6d4930d9141440$var$_serializeFragment = (serializer, doc)=>{
    return serializer.serializeFragment(doc.content);
};
const $af6d4930d9141440$var$memoSerializeFragment = (0, $8QpSo.default)($af6d4930d9141440$var$_serializeFragment, (newArgs, lastArgs)=>{
    const [newSerializer, newDoc] = newArgs;
    const [oldSerializer, oldDoc] = lastArgs;
    return newSerializer === oldSerializer && $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc);
});
const $af6d4930d9141440$var$_createNodeAndCheck = (schema, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, dispatchAnalyticsEvent)=>{
    const pmNode = schema.nodeFromJSON(doc);
    try {
        pmNode.check();
    } catch (err) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB,
                errorStack: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
    }
    return pmNode;
};
const $af6d4930d9141440$var$memoCreateNodeAndCheck = (0, $8QpSo.default)($af6d4930d9141440$var$_createNodeAndCheck, (newArgs, lastArgs)=>{
    // ignore dispatchAnalyticsEvent
    const [newSchema, newDoc] = newArgs;
    const [oldSchema, oldDoc] = lastArgs;
    return newSchema === oldSchema && $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc);
});
const $af6d4930d9141440$export$59a54f98b9753d5c = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, serializer, schema = (0, $kOFhM.defaultSchema), adfStage = 'final', useSpecBasedValidator = false, rendererId = 'noid', dispatchAnalyticsEvent, unsupportedContentLevelsTracking, appearance, includeNodesCountInStats, skipValidation)=>{
    const stat = {
        sanitizeTime: 0
    };
    const { output: validDoc, time: sanitizeTime } = $af6d4930d9141440$var$withStopwatch(()=>{
        return $af6d4930d9141440$var$memoValidation(doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation);
    });
    // save sanitize time to stats
    stat.sanitizeTime = sanitizeTime;
    if (!validDoc) return {
        stat: stat,
        result: null
    };
    const { output: node, time: buildTreeTime } = $af6d4930d9141440$var$withStopwatch(()=>{
        return $af6d4930d9141440$var$memoCreateNodeAndCheck(schema, validDoc, dispatchAnalyticsEvent);
    });
    // save build tree time to stats
    stat.buildTreeTime = buildTreeTime;
    const { output: result, time: serializeTime } = $af6d4930d9141440$var$withStopwatch(()=>{
        return $af6d4930d9141440$var$memoSerializeFragment(serializer, node);
    });
    // save serialize tree time to stats
    stat.serializeTime = serializeTime;
    if (dispatchAnalyticsEvent && useSpecBasedValidator) {
        (0, $d54NZ.findAndTrackUnsupportedContentNodes)(node, schema, dispatchAnalyticsEvent);
        if (unsupportedContentLevelsTracking?.enabled) {
            const documentData = {
                doc: validDoc,
                appearance: appearance,
                rendererId: rendererId
            };
            (0, $1cjf7.trackUnsupportedContentLevels)(documentData, unsupportedContentLevelsTracking, dispatchAnalyticsEvent);
        }
    }
    if (includeNodesCountInStats) stat.nodesCount = (0, $kgV4b.countNodes)(doc);
    return {
        result: result,
        stat: stat,
        pmDoc: node
    };
};

});
parcelRegister("4FBRr", function(module, exports) {

$parcel$export(module.exports, "transformMediaLinkMarks", () => $75bd921bb3a8c47e$export$6528700f3fa2fe2a);

var $l1C1k = parcelRequire("l1C1k");
const $75bd921bb3a8c47e$export$6528700f3fa2fe2a = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $l1C1k.traverse)(adf, {
        mediaSingle: (node)=>{
            if (!node.marks || !node.content || node.content[0]?.type !== 'media') return node;
            let linkMark = null;
            node.marks.forEach((mark, i)=>{
                if (mark.type === 'link') {
                    linkMark = mark;
                    node.marks?.splice(i, 1);
                    isTransformed = true;
                }
            });
            if (node.marks.length === 0) delete node.marks;
            if (linkMark) {
                const mediaNode = node.content[0];
                // only add link mark if media node doesnt already have one
                if (mediaNode.marks?.every((mark)=>mark.type !== 'link')) mediaNode.marks.push(linkMark);
                else if (!mediaNode.marks) mediaNode.marks = [
                    linkMark
                ];
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("4IuOY", function(module, exports) {

$parcel$export(module.exports, "validateADFEntity", () => $2c0bbb60cfee2804$export$884cfad20dece33e);

var $905ey = parcelRequire("905ey");

var $gkwXh = parcelRequire("gkwXh");

var $d54NZ = parcelRequire("d54NZ");
const $2c0bbb60cfee2804$export$8e7fd962b4d3895d = 'unsupportedNodeAttribute';
const $2c0bbb60cfee2804$var$errorCallbackFor = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
marks, validate, dispatchAnalyticsEvent)=>{
    return (entity, error, options)=>{
        return $2c0bbb60cfee2804$export$468b008419c9a974(entity, error, options, marks, validate, dispatchAnalyticsEvent);
    };
};
const $2c0bbb60cfee2804$export$468b008419c9a974 = (entity, error, options, marks, validate, dispatchAnalyticsEvent)=>{
    if (entity && entity.type === $2c0bbb60cfee2804$export$8e7fd962b4d3895d) return entity;
    if (options.isMark) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(error.meta, 'mark');
    if (options.isNodeAttribute) {
        const entityType = entity && entity.type ? entity.type : undefined;
        return {
            type: $2c0bbb60cfee2804$export$8e7fd962b4d3895d,
            attrs: {
                type: {
                    nodeType: entityType
                },
                unsupported: error.meta
            }
        };
    }
    if (entity && marks.indexOf(entity.type) > -1) return;
    /**
	 * There's a inconsistency between ProseMirror and ADF.
	 * `content` is actually optional in ProseMirror.
	 * And, also empty `text` node is not valid.
	 */ if (error.code === 'MISSING_PROPERTIES' && entity.type === 'paragraph') return {
        type: 'paragraph',
        content: []
    };
    // TODO: We can repair missing content like `panel` without a `paragraph`.
    if (error.code === 'INVALID_CONTENT_LENGTH') {
        if (error.meta && options.allowUnsupportedBlock && entity.content) return $2c0bbb60cfee2804$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent);
        else // Can't fix it by wrapping
        if (dispatchAnalyticsEvent) $2c0bbb60cfee2804$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    }
    if (options.allowUnsupportedBlock) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(entity);
    if (options.allowUnsupportedInline) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(entity, 'inline');
    if (dispatchAnalyticsEvent) $2c0bbb60cfee2804$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    return entity;
};
function $2c0bbb60cfee2804$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent) {
    const meta = error.meta;
    if (meta.type === 'maximum') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    entity.content = entity.content.filter((x)=>!!x).map((child, index)=>{
        return index >= meta.requiredLength && child.type !== 'unsupportedBlock' ? $2c0bbb60cfee2804$export$87b732fa69cdf16e(child) : validate(child, $2c0bbb60cfee2804$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent)).entity;
    });
    if (meta.type === 'minimum') {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (entity.content.length === 0) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(entity);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        entity.content = entity.content.filter((x)=>!!x).map((child)=>{
            return child.type !== 'unsupportedBlock' ? $2c0bbb60cfee2804$export$87b732fa69cdf16e(child) : child;
        });
    }
    return entity;
}
function $2c0bbb60cfee2804$var$trackValidationError(dispatchAnalyticsEvent, error, entity) {
    if (!dispatchAnalyticsEvent) return;
    (0, $d54NZ.fireUnsupportedEvent)(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_ERROR, {
        type: entity.type || '',
        ancestry: entity.ancestorHierarchy || '',
        parentType: entity.parentType || '',
        marks: entity.marks || [],
        attrs: entity.attrs || {}
    }, error.code);
}
const $2c0bbb60cfee2804$export$884cfad20dece33e = (schema, node, dispatchAnalyticsEvent)=>{
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    const validate = (0, $905ey.validator)(nodes, marks, {
        allowPrivateAttributes: true
    });
    const emptyDoc = {
        type: 'doc',
        content: []
    };
    const { entity: entity = emptyDoc } = validate(node, $2c0bbb60cfee2804$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent));
    return entity;
};
function $2c0bbb60cfee2804$export$87b732fa69cdf16e(originalValue, type = 'block') {
    let unsupportedNodeType;
    switch(type){
        case 'inline':
            unsupportedNodeType = 'unsupportedInline';
            break;
        case 'mark':
            unsupportedNodeType = 'unsupportedMark';
            break;
        default:
            unsupportedNodeType = 'unsupportedBlock';
    }
    return {
        type: unsupportedNodeType,
        attrs: {
            originalValue: originalValue
        }
    };
}

});
parcelRegister("905ey", function(module, exports) {

$parcel$export(module.exports, "validator", () => $e861220f24467804$export$956325f45c5d174a);
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace

var $gsiq1 = parcelRequire("gsiq1");

var $iiazc = parcelRequire("iiazc");

var $1H4Aw = parcelRequire("1H4Aw");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e861220f24467804$var$mapMarksItems(spec, fn = (x)=>x) {
    if (spec.props && spec.props.marks) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items, ...rest } = spec.props.marks;
        return {
            ...spec,
            props: {
                ...spec.props,
                marks: {
                    ...rest,
                    /**
					 * `Text & MarksObject<Mark-1>` produces `items: ['mark-1']`
					 * `Text & MarksObject<Mark-1 | Mark-2>` produces `items: [['mark-1', 'mark-2']]`
					 */ items: items.length ? Array.isArray(items[0]) ? items.map(fn) : [
                        fn(items)
                    ] : [
                        []
                    ]
                }
            }
        };
    } else return spec;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e861220f24467804$var$partitionObject = (obj, predicate)=>Object.keys(obj).reduce((acc, key)=>{
        const result = predicate(key, obj[key], obj);
        acc[result ? 0 : 1].push(key);
        return acc;
    }, [
        [],
        []
    ]);
/**
 * Normalizes the structure of files imported from './specs'.
 * We denormalised the spec to save bundle size.
 */ function $e861220f24467804$var$createSpec(nodes, marks) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys($gsiq1).reduce((newSpecs, k)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const spec = {
            ...$gsiq1[k]
        };
        if (spec.props) {
            spec.props = {
                ...spec.props
            };
            if (spec.props.content) {
                // 'tableCell_content' => { type: 'array', items: [ ... ] }
                if ((0, $iiazc.isString)(spec.props.content)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                spec.props.content = $gsiq1[spec.props.content];
                // ['inline', 'emoji']
                if (Array.isArray(spec.props.content)) /**
					 * Flatten
					 *
					 * Input:
					 * [ { type: 'array', items: [ 'tableHeader' ] }, { type: 'array', items: [ 'tableCell' ] } ]
					 *
					 * Output:
					 * { type: 'array', items: [ [ 'tableHeader' ], [ 'tableCell' ] ] }
					 */ spec.props.content = {
                    type: 'array',
                    items: (spec.props.content || []).map((arr)=>arr.items)
                };
                else spec.props.content = {
                    ...spec.props.content
                };
                spec.props.content.items = spec.props.content.items// ['inline'] => [['emoji', 'hr', ...]]
                // ['media'] => [['media']]
                .map((item)=>(0, $iiazc.isString)(item) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Array.isArray($gsiq1[item]) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    $gsiq1[item] : [
                        item
                    ] : item)// [['emoji', 'hr', 'inline_code']] => [['emoji', 'hr', ['text', { marks: {} }]]]
                .map((item)=>item.map((subItem)=>// Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        Array.isArray($gsiq1[subItem]) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        $gsiq1[subItem] : (0, $iiazc.isString)(subItem) ? subItem : [
                            'text',
                            subItem
                        ])// Remove unsupported nodes & marks
                    // Filter nodes
                    .filter((subItem)=>{
                        if (nodes) {
                            // Node with overrides
                            // ['mediaSingle', { props: { content: { items: [ 'media', 'caption' ] } }}]
                            if (Array.isArray(subItem)) {
                                const isMainNodeSupported = nodes.indexOf(subItem[0]) > -1;
                                if (isMainNodeSupported && subItem[1]?.props?.content?.items) return subItem[1].props.content.items.every((item)=>nodes.indexOf(item) > -1);
                                return isMainNodeSupported;
                            }
                            return nodes.indexOf(subItem) > -1;
                        }
                        return true;
                    })// Filter marks
                    .map((subItem)=>Array.isArray(subItem) && marks ? /**
										 * TODO: Probably try something like immer, but it's 3.3kb gzipped.
										 * Not worth it just for this.
										 */ [
                            subItem[0],
                            $e861220f24467804$var$mapMarksItems(subItem[1])
                        ] : subItem));
            }
        }
        newSpecs[k] = spec;
        return newSpecs;
    }, {});
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e861220f24467804$var$getOptionsForType(type, list) {
    if (!list) return {};
    for(let i = 0, len = list.length; i < len; i++){
        const spec = list[i];
        let name = spec;
        let options = {};
        if (Array.isArray(spec)) [name, options] = spec;
        if (name === type) return options;
    }
    return false;
}
const $e861220f24467804$var$isValidatorSpecAttrs = (spec)=>{
    return !!spec.props;
};
function $e861220f24467804$export$66c739158ef99a42(spec, value) {
    if (!(0, $iiazc.isDefined)(value)) return !!spec.optional;
    if ($e861220f24467804$var$isValidatorSpecAttrs(spec)) {
        // If spec has ".props" it is ValidatorSpecAttrs and need to pipe back in recursively
        const [_, invalidKeys] = $e861220f24467804$var$partitionObject(spec.props, (key, subSpec)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            $e861220f24467804$export$66c739158ef99a42(subSpec, value[key]));
        return invalidKeys.length === 0;
    }
    // extension_node parameters has no type
    if (!(0, $iiazc.isDefined)(spec.type)) return !!spec.optional;
    switch(spec.type){
        case 'boolean':
            return (0, $iiazc.isBoolean)(value);
        case 'number':
            return (0, $iiazc.isNumber)(value) && ((0, $iiazc.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $iiazc.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'integer':
            return (0, $iiazc.isInteger)(value) && ((0, $iiazc.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $iiazc.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'string':
            const validatorFnPassed = (rule)=>typeof value === 'string' && (0, $iiazc.isDefined)((0, $1H4Aw.validatorFnMap)[rule]) && (0, $1H4Aw.validatorFnMap)[rule](value);
            return (0, $iiazc.isString)(value) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            ((0, $iiazc.isDefined)(spec.minLength) ? spec.minLength <= value.length : true) && ((0, $iiazc.isDefined)(spec.validatorFn) ? validatorFnPassed(spec.validatorFn) : true) && // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            (spec.pattern ? new RegExp(spec.pattern).test(value) : true);
        case 'object':
            return (0, $iiazc.isPlainObject)(value);
        case 'array':
            if (Array.isArray(value)) {
                const isTuple = !!spec.isTupleLike;
                const { minItems: minItems, maxItems: maxItems } = spec;
                if (minItems !== undefined && value.length < minItems || maxItems !== undefined && value.length > maxItems) return false;
                if (isTuple) {
                    // If value has fewer items than tuple has specs - we are fine with that.
                    const numberOfItemsToCheck = Math.min(spec.items.length, value.length);
                    return Array(numberOfItemsToCheck).fill(null).every((_, i)=>$e861220f24467804$export$66c739158ef99a42(spec.items[i], value[i]));
                } else return value.every((valueItem)=>// We check that at least one of the specs in the list (spec.items) matches each value from
                    spec.items.some((itemSpec)=>$e861220f24467804$export$66c739158ef99a42(itemSpec, valueItem)));
            }
            return false;
        case 'enum':
            return (0, $iiazc.isString)(value) && spec.values.indexOf(value) > -1;
    }
}
const $e861220f24467804$var$errorMessageFor = (type, message)=>`${type}: ${message}.`;
const $e861220f24467804$var$getUnsupportedOptions = (spec)=>{
    if (spec && spec.props && spec.props.content) {
        const { allowUnsupportedBlock: allowUnsupportedBlock, allowUnsupportedInline: allowUnsupportedInline } = spec.props.content;
        return {
            allowUnsupportedBlock: allowUnsupportedBlock,
            allowUnsupportedInline: allowUnsupportedInline
        };
    }
    return {};
};
const $e861220f24467804$var$invalidChildContent = (child, errorCallback, parentSpec)=>{
    const message = $e861220f24467804$var$errorMessageFor(child.type, 'invalid content');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...child
    }, {
        code: 'INVALID_CONTENT',
        message: message
    }, $e861220f24467804$var$getUnsupportedOptions(parentSpec));
};
const $e861220f24467804$var$unsupportedMarkContent = (errorCode, mark, errorCallback, errorMessage)=>{
    const message = errorMessage || $e861220f24467804$var$errorMessageFor(mark.type, 'unsupported mark');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...mark
    }, {
        code: errorCode,
        message: message,
        meta: mark
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: true
    });
};
const $e861220f24467804$var$unsupportedNodeAttributesContent = (entity, errorCode, invalidAttributes, message, errorCallback)=>{
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        type: entity.type
    }, {
        code: errorCode,
        message: message,
        meta: invalidAttributes
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: false,
        isNodeAttribute: true
    });
};
function $e861220f24467804$export$956325f45c5d174a(nodes, marks, options) {
    const validatorSpecs = $e861220f24467804$var$createSpec(nodes, marks);
    const { mode: mode = 'strict', allowPrivateAttributes: allowPrivateAttributes = false } = options || {};
    const validate = (entity, errorCallback, allowed, parentSpec)=>{
        const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
        return {
            entity: validationResult.entity,
            valid: validationResult.valid
        };
    };
    const validateNode = (entity, errorCallback, allowed, parentSpec, isMark = false)=>{
        const { type: type } = entity;
        const newEntity = {
            ...entity
        };
        const err = (code, msg, meta)=>{
            const message = $e861220f24467804$var$errorMessageFor(type, msg);
            if (errorCallback) return {
                valid: false,
                entity: errorCallback(newEntity, {
                    code: code,
                    message: message,
                    meta: meta
                }, $e861220f24467804$var$getUnsupportedOptions(parentSpec))
            };
            else throw new Error(message);
        };
        if (type) {
            const typeOptions = $e861220f24467804$var$getOptionsForType(type, allowed);
            if (typeOptions === false) return isMark ? {
                valid: false
            } : err('INVALID_TYPE', 'type not allowed here');
            const spec = validatorSpecs[type];
            if (!spec) return err('INVALID_TYPE', `${type}: No validation spec found for type!`);
            const specBasedValidationResult = specBasedValidationFor(spec, typeOptions, entity, err, newEntity, type, errorCallback, isMark);
            if (specBasedValidationResult.hasValidated && specBasedValidationResult.result) return specBasedValidationResult.result;
        } else return err('INVALID_TYPE', 'ProseMirror Node/Mark should contain a `type`');
        return {
            valid: true,
            entity: newEntity
        };
    };
    return validate;
    function marksValidationFor(validator, entity, errorCallback, newEntity, err) {
        let validationResult;
        if (validator.props && validator.props.marks) {
            const marksSet = allowedMarksFor(validator);
            const marksValidationResult = marksAfterValidation(entity, errorCallback, marksSet, validator);
            validationResult = {
                valid: true,
                entity: newEntity,
                marksValidationOutput: marksValidationResult
            };
        } else validationResult = marksForEntitySpecNotSupportingMarks(entity, newEntity, errorCallback, err);
        return validationResult;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function validatorFor(spec, typeOptions) {
        return {
            ...spec,
            ...typeOptions,
            // options with props can override props of spec
            ...spec.props ? {
                props: {
                    ...spec.props,
                    ...typeOptions['props'] || {}
                }
            } : {}
        };
    }
    function marksAfterValidation(entity, errorCallback, marksSet, validator) {
        return entity.marks ? entity.marks.map((mark)=>{
            const isAKnownMark = marks ? marks.indexOf(mark.type) > -1 : true;
            if (mode === 'strict' && isAKnownMark) {
                const finalResult = validateNode(mark, errorCallback, marksSet, validator, true);
                const finalMark = finalResult.entity;
                if (finalMark) return {
                    valid: true,
                    originalMark: mark,
                    newMark: finalMark
                };
                else if (finalResult.marksValidationOutput && finalResult.marksValidationOutput.length) return {
                    valid: false,
                    originalMark: mark,
                    errorCode: finalResult.marksValidationOutput[0].errorCode,
                    message: finalResult.marksValidationOutput[0].message
                };
                else return {
                    valid: false,
                    originalMark: mark,
                    errorCode: 'INVALID_TYPE'
                };
            } else return {
                valid: false,
                originalMark: mark,
                errorCode: 'INVALID_CONTENT'
            };
        }) : [];
    }
    function allowedMarksFor(validator) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items } = validator.props.marks;
        const marksSet = items.length ? Array.isArray(items[0]) ? items[0] : items : [];
        return marksSet;
    }
    function marksForEntitySpecNotSupportingMarks(prevEntity, newEntity, errorCallback, err) {
        const errorCode = 'REDUNDANT_MARKS';
        const currentMarks = prevEntity.marks || [];
        const newMarks = currentMarks.map((mark)=>{
            const isUnsupportedNodeAttributeMark = mark.type === 'unsupportedNodeAttribute';
            if (isUnsupportedNodeAttributeMark) return mark;
            return $e861220f24467804$var$unsupportedMarkContent(errorCode, mark, errorCallback);
        });
        if (newMarks.length) {
            newEntity.marks = newMarks;
            return {
                valid: true,
                entity: newEntity
            };
        } else return err('REDUNDANT_MARKS', 'redundant marks', {
            marks: Object.keys(currentMarks)
        });
    }
    function requiredPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.required) {
            if (!validatorSpec.required.every((prop)=>(0, $iiazc.isDefined)(prevEntity[prop]))) result = err('MISSING_PROPERTIES', 'required prop missing');
        }
        return result;
    }
    function textPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.text) {
            if ((0, $iiazc.isDefined)(prevEntity.text) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            !$e861220f24467804$export$66c739158ef99a42(validatorSpec.props.text, prevEntity.text)) result = err('INVALID_TEXT', `'text' validation failed`);
        }
        return result;
    }
    function contentLengthValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.content && prevEntity.content) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const { minItems: minItems, maxItems: maxItems } = validatorSpec.props.content;
            const length = prevEntity.content.length;
            if ((0, $iiazc.isDefined)(minItems) && minItems > length) result = err('INVALID_CONTENT_LENGTH', `'content' should have more than ${minItems} child`, {
                length: length,
                requiredLength: minItems,
                type: 'minimum'
            });
            else if ((0, $iiazc.isDefined)(maxItems) && maxItems < length) result = err('INVALID_CONTENT_LENGTH', `'content' should have less than ${maxItems} child`, {
                length: length,
                requiredLength: maxItems,
                type: 'maximum'
            });
        }
        return result;
    }
    function invalidAttributesFor(validatorSpec, prevEntity) {
        let invalidAttrs = [];
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let validatorAttrs = {};
        if (validatorSpec.props && validatorSpec.props.attrs) {
            const attrOptions = (0, $iiazc.makeArray)(validatorSpec.props.attrs);
            /**
			 * Attrs can be union type so try each path
			 * attrs: [{ props: { url: { type: 'string' } } }, { props: { data: {} } }],
			 * Gotcha: It will always report the last failure.
			 */ for(let i = 0, length = attrOptions.length; i < length; ++i){
                const attrOption = attrOptions[i];
                if (attrOption && attrOption.props) [, invalidAttrs] = $e861220f24467804$var$partitionObject(attrOption.props, (key, spec)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const valueToValidate = prevEntity.attrs[key];
                    return $e861220f24467804$export$66c739158ef99a42(spec, valueToValidate);
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                validatorAttrs = attrOption;
                if (!invalidAttrs.length) break;
            }
        }
        return {
            invalidAttrs: invalidAttrs,
            validatorAttrs: validatorAttrs
        };
    }
    function attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback) {
        const validatorSpecAllowsAttributes = validatorSpec.props && validatorSpec.props.attrs;
        if (prevEntity.attrs) {
            if (!validatorSpecAllowsAttributes) {
                if (isMark) return handleNoAttibutesAllowedInSpecForMark(prevEntity, prevEntity.attrs);
                const attrs = Object.keys(prevEntity.attrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, [], attrs, errorCallback);
            }
            const { hasUnsupportedAttrs: hasUnsupportedAttrs, redundantAttrs: redundantAttrs, invalidAttrs: invalidAttrs } = validateAttributes(validatorSpec, prevEntity, prevEntity.attrs);
            if (hasUnsupportedAttrs) {
                if (isMark) return handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback);
            }
        }
        return {
            valid: true,
            entity: prevEntity
        };
    }
    function validateAttributes(validatorSpec, prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const invalidAttributesResult = invalidAttributesFor(validatorSpec, prevEntity);
        const { invalidAttrs: invalidAttrs } = invalidAttributesResult;
        const validatorAttrs = invalidAttributesResult.validatorAttrs;
        const attrs = Object.keys(attributes).filter((k)=>!(allowPrivateAttributes && k.startsWith('__')));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const redundantAttrs = attrs.filter((a)=>!validatorAttrs.props[a]);
        const hasRedundantAttrs = redundantAttrs.length > 0;
        const hasUnsupportedAttrs = invalidAttrs.length || hasRedundantAttrs;
        return {
            hasUnsupportedAttrs: hasUnsupportedAttrs,
            invalidAttrs: invalidAttrs,
            redundantAttrs: redundantAttrs
        };
    }
    function handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback) {
        const attr = invalidAttrs.concat(redundantAttrs);
        let result = {
            valid: true,
            entity: prevEntity
        };
        const message = $e861220f24467804$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const errorCode = 'UNSUPPORTED_ATTRIBUTES';
        newEntity.marks = wrapUnSupportedNodeAttributes(prevEntity, newEntity, attr, errorCode, message, errorCallback);
        result = {
            valid: true,
            entity: newEntity
        };
        return result;
    }
    function handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs) {
        let errorCode = 'INVALID_ATTRIBUTES';
        let message = $e861220f24467804$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const hasRedundantAttrs = redundantAttrs.length;
        const hasBothInvalidAndRedundantAttrs = hasRedundantAttrs && invalidAttrs.length;
        if (!hasBothInvalidAndRedundantAttrs && hasRedundantAttrs) {
            errorCode = 'REDUNDANT_ATTRIBUTES';
            message = $e861220f24467804$var$errorMessageFor('redundant attributes found', redundantAttrs.join(', '));
        }
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function handleNoAttibutesAllowedInSpecForMark(prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const message = $e861220f24467804$var$errorMessageFor('redundant attributes found', Object.keys(attributes).join(', '));
        const errorCode = 'REDUNDANT_ATTRIBUTES';
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function wrapUnSupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, errorCode, message, errorCallback) {
        const invalidValues = {};
        // eslint-disable-next-line guard-for-in
        for(const invalidAttr in invalidAttrs){
            invalidValues[invalidAttrs[invalidAttr]] = prevEntity.attrs && prevEntity.attrs[invalidAttrs[invalidAttr]];
            if (newEntity.attrs) delete newEntity.attrs[invalidAttrs[invalidAttr]];
        }
        const unsupportedNodeAttributeValues = $e861220f24467804$var$unsupportedNodeAttributesContent(prevEntity, errorCode, invalidValues, message, errorCallback);
        const finalEntity = {
            ...newEntity
        };
        if (finalEntity.marks) {
            if (!unsupportedNodeAttributeValues) return finalEntity.marks;
            // If there is an existing unsupported node attribute mark, overwrite it to avoid duplicate marks
            const existingMark = finalEntity.marks.find((mark)=>mark.type === unsupportedNodeAttributeValues.type);
            if (existingMark) existingMark.attrs = unsupportedNodeAttributeValues.attrs;
            else finalEntity.marks.push(unsupportedNodeAttributeValues);
            return finalEntity.marks;
        } else return [
            unsupportedNodeAttributeValues
        ];
    }
    function extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type) {
        const result = {
            valid: true,
            entity: prevEntity
        };
        const [requiredProps, redundantProps] = $e861220f24467804$var$partitionObject(prevEntity, (k)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $iiazc.isDefined)(validatorSpec.props[k]));
        if (redundantProps.length) {
            if (mode === 'loose') {
                newEntity = {
                    type: type
                };
                requiredProps.reduce((acc, p)=>(0, $iiazc.copy)(prevEntity, acc, p), newEntity);
            } else {
                if (!((redundantProps.indexOf('marks') > -1 || redundantProps.indexOf('attrs') > -1) && redundantProps.length === 1)) return err('REDUNDANT_PROPERTIES', `redundant props found: ${redundantProps.join(', ')}`, {
                    props: redundantProps
                });
            }
        }
        return result;
    }
    function specBasedValidationFor(spec, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeOptions, prevEntity, err, newEntity, type, errorCallback, isMark) {
        const specBasedValidationResult = {
            hasValidated: false
        };
        const validatorSpec = validatorFor(spec, typeOptions);
        if (!validatorSpec) return specBasedValidationResult;
        // Required Props
        // For array format where `required` is an array
        const requiredPropertyValidatonResult = requiredPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!requiredPropertyValidatonResult.valid) return {
            hasValidated: true,
            result: requiredPropertyValidatonResult
        };
        if (!validatorSpec.props) {
            const props = Object.keys(prevEntity);
            // If there's no validator.props then there shouldn't be any key except `type`
            if (props.length > 1) return {
                hasValidated: true,
                result: err('REDUNDANT_PROPERTIES', `redundant props found: ${Object.keys(prevEntity).join(', ')}`, {
                    props: props
                })
            };
            return specBasedValidationResult;
        }
        // Check text
        const textPropertyValidationResult = textPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!textPropertyValidationResult.valid) return {
            hasValidated: true,
            result: textPropertyValidationResult
        };
        // Content Length
        const contentLengthValidationResult = contentLengthValidationFor(validatorSpec, prevEntity, err);
        if (!contentLengthValidationResult.valid) return {
            hasValidated: true,
            result: contentLengthValidationResult
        };
        // Required Props
        // For object format based on `optional` property
        const [, missingProps] = $e861220f24467804$var$partitionObject(validatorSpec.props, (k, v)=>{
            // if the validator is an array, then check
            // if the `required` field contains the key.
            const isOptional = Array.isArray(v) ? !validatorSpec.required?.includes(k) : v.optional;
            return isOptional || (0, $iiazc.isDefined)(prevEntity[k]);
        });
        if (missingProps.length) return {
            hasValidated: true,
            result: err('MISSING_PROPERTIES', 'required prop missing', {
                props: missingProps
            })
        };
        const attributesValidationResult = attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback);
        if (!attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        if (isMark && attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        const extraPropsValidationResult = extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type);
        if (!extraPropsValidationResult.valid) return {
            hasValidated: true,
            result: extraPropsValidationResult
        };
        // Children
        if (validatorSpec.props.content) {
            const contentValidatorSpec = validatorSpec.props.content;
            if (prevEntity.content) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const validateChildNode = (child, index)=>{
                    if (child === undefined) return child;
                    const validateChildMarks = (childEntity, marksValidationOutput, errorCallback, isLastValidationSpec, isParentTupleLike = false)=>{
                        let marksAreValid = true;
                        if (childEntity && childEntity.marks && marksValidationOutput) {
                            const validMarks = marksValidationOutput.filter((mark)=>mark.valid);
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            const finalMarks = marksValidationOutput.map((mr)=>{
                                if (mr.valid) return mr.newMark;
                                else {
                                    if (validMarks.length || isLastValidationSpec || isParentTupleLike || mr.errorCode === 'INVALID_TYPE' || mr.errorCode === 'INVALID_CONTENT' || mr.errorCode === 'REDUNDANT_ATTRIBUTES' || mr.errorCode === 'INVALID_ATTRIBUTES') return $e861220f24467804$var$unsupportedMarkContent(// Ignored via go/ees005
                                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                    mr.errorCode, mr.originalMark, errorCallback, mr.message);
                                    return;
                                }
                            }).filter(Boolean);
                            if (finalMarks.length) childEntity.marks = finalMarks;
                            else {
                                delete childEntity.marks;
                                marksAreValid = false;
                            }
                        }
                        return {
                            valid: marksAreValid,
                            entity: childEntity
                        };
                    };
                    const hasMultipleCombinationOfContentAllowed = !!contentValidatorSpec.isTupleLike;
                    if (hasMultipleCombinationOfContentAllowed) {
                        const { entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, (0, $iiazc.makeArray)(contentValidatorSpec.items[index] || contentValidatorSpec.items[contentValidatorSpec.items.length - 1]), validatorSpec);
                        const { entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, false, true);
                        return entity;
                    }
                    // Only go inside valid branch
                    const allowedSpecsForEntity = contentValidatorSpec.items.filter((item)=>Array.isArray(item) ? item.some(// [p, hr, ...] or [p, [text, {}], ...]
                        (spec)=>(Array.isArray(spec) ? spec[0] : spec) === child.type) : true);
                    if (allowedSpecsForEntity.length) {
                        if (allowedSpecsForEntity.length > 1) throw new Error('Consider using Tuple instead!');
                        const maybeArray = (0, $iiazc.makeArray)(allowedSpecsForEntity[0]);
                        const allowedSpecsForChild = maybeArray.filter((item)=>(Array.isArray(item) ? item[0] : item) === child.type);
                        if (allowedSpecsForChild.length === 0) return $e861220f24467804$var$invalidChildContent(child, errorCallback, validatorSpec);
                        /**
						 * When there's multiple possible branches try all of them.
						 * If all of them fails, throw the first one.
						 * e.g.- [['text', { marks: ['a'] }], ['text', { marks: ['b'] }]]
						 */ let firstError;
                        let firstChild;
                        for(let i = 0, len = allowedSpecsForChild.length; i < len; i++)try {
                            const allowedValueForCurrentSpec = [
                                allowedSpecsForChild[i]
                            ];
                            const { valid: valid, entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, allowedValueForCurrentSpec, validatorSpec);
                            if (valid) {
                                const isLastValidationSpec = i === allowedSpecsForChild.length - 1;
                                const { valid: marksAreValid, entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, isLastValidationSpec);
                                const unsupportedMarks = entity && entity.marks && entity.marks.filter((mark)=>mark.type === 'unsupportedMark') || [];
                                if (marksAreValid && !unsupportedMarks.length) return entity;
                                else firstChild = firstChild || newChildEntity;
                            } else firstChild = firstChild || newChildEntity;
                        } catch (error) {
                            firstError = firstError || error;
                        }
                        if (!errorCallback) throw firstError;
                        else return firstChild;
                    } else return $e861220f24467804$var$invalidChildContent(child, errorCallback, validatorSpec);
                };
                newEntity.content = prevEntity.content.map(validateChildNode).filter(Boolean);
            } else if (!contentValidatorSpec.optional) return {
                hasValidated: true,
                result: err('MISSING_PROPERTIES', 'missing `content` prop')
            };
        }
        // Marks
        if (prevEntity.marks) return {
            hasValidated: true,
            result: marksValidationFor(validatorSpec, prevEntity, errorCallback, newEntity, err)
        };
        return specBasedValidationResult;
    }
}

});
parcelRegister("gsiq1", function(module, exports) {

$parcel$export(module.exports, "alignment", () => (parcelRequire("5fjVx")).alignment);
$parcel$export(module.exports, "annotation", () => (parcelRequire("5fjVx")).annotation);
$parcel$export(module.exports, "backgroundColor", () => (parcelRequire("5fjVx")).backgroundColor);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("5fjVx")).blockCard);
$parcel$export(module.exports, "block_content", () => (parcelRequire("5fjVx")).block_content);
$parcel$export(module.exports, "blockRootOnly", () => (parcelRequire("5fjVx")).blockRootOnly);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("5fjVx")).blockquote);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("5fjVx")).bodiedExtension);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => (parcelRequire("5fjVx")).bodiedExtension_with_marks);
$parcel$export(module.exports, "border", () => (parcelRequire("5fjVx")).border);
$parcel$export(module.exports, "breakout", () => (parcelRequire("5fjVx")).breakout);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("5fjVx")).bulletList);
$parcel$export(module.exports, "caption", () => (parcelRequire("5fjVx")).caption);
$parcel$export(module.exports, "code", () => (parcelRequire("5fjVx")).code);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("5fjVx")).codeBlock);
$parcel$export(module.exports, "codeBlock_root_only", () => (parcelRequire("5fjVx")).codeBlock_root_only);
$parcel$export(module.exports, "text_with_no_marks", () => (parcelRequire("5fjVx")).text_with_no_marks);
$parcel$export(module.exports, "confluenceInlineComment", () => (parcelRequire("5fjVx")).confluenceInlineComment);
$parcel$export(module.exports, "dataConsumer", () => (parcelRequire("5fjVx")).dataConsumer);
$parcel$export(module.exports, "date", () => (parcelRequire("5fjVx")).date);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("5fjVx")).decisionItem);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("5fjVx")).decisionList);
$parcel$export(module.exports, "doc", () => (parcelRequire("5fjVx")).doc);
$parcel$export(module.exports, "em", () => (parcelRequire("5fjVx")).em);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("5fjVx")).embedCard);
$parcel$export(module.exports, "emoji", () => (parcelRequire("5fjVx")).emoji);
$parcel$export(module.exports, "expand", () => (parcelRequire("5fjVx")).expand);
$parcel$export(module.exports, "expand_root_only", () => (parcelRequire("5fjVx")).expand_root_only);
$parcel$export(module.exports, "extension", () => (parcelRequire("5fjVx")).extension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("5fjVx")).extensionFrame);
$parcel$export(module.exports, "extension_with_marks", () => (parcelRequire("5fjVx")).extension_with_marks);
$parcel$export(module.exports, "fragment", () => (parcelRequire("5fjVx")).fragment);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("5fjVx")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("5fjVx")).heading);
$parcel$export(module.exports, "heading_with_alignment", () => (parcelRequire("5fjVx")).heading_with_alignment);
$parcel$export(module.exports, "heading_with_indentation", () => (parcelRequire("5fjVx")).heading_with_indentation);
$parcel$export(module.exports, "heading_with_no_marks", () => (parcelRequire("5fjVx")).heading_with_no_marks);
$parcel$export(module.exports, "indentation", () => (parcelRequire("5fjVx")).indentation);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("5fjVx")).inlineCard);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("5fjVx")).inlineExtension);
$parcel$export(module.exports, "inlineExtension_with_marks", () => (parcelRequire("5fjVx")).inlineExtension_with_marks);
$parcel$export(module.exports, "inline_content", () => (parcelRequire("5fjVx")).inline_content);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("5fjVx")).layoutColumn);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("5fjVx")).layoutSection);
$parcel$export(module.exports, "layoutSection_full", () => (parcelRequire("5fjVx")).layoutSection_full);
$parcel$export(module.exports, "layoutSection_with_single_column", () => (parcelRequire("5fjVx")).layoutSection_with_single_column);
$parcel$export(module.exports, "link", () => (parcelRequire("5fjVx")).link);
$parcel$export(module.exports, "listItem", () => (parcelRequire("5fjVx")).listItem);
$parcel$export(module.exports, "media", () => (parcelRequire("5fjVx")).media);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("5fjVx")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("5fjVx")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("5fjVx")).mediaSingle);
$parcel$export(module.exports, "mediaSingle_caption", () => (parcelRequire("5fjVx")).mediaSingle_caption);
$parcel$export(module.exports, "mediaSingle_full", () => (parcelRequire("5fjVx")).mediaSingle_full);
$parcel$export(module.exports, "mention", () => (parcelRequire("5fjVx")).mention);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("5fjVx")).multiBodiedExtension);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("5fjVx")).nestedExpand);
$parcel$export(module.exports, "nestedExpand_content", () => (parcelRequire("5fjVx")).nestedExpand_content);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => (parcelRequire("5fjVx")).nestedExpand_with_no_marks);
$parcel$export(module.exports, "non_nestable_block_content", () => (parcelRequire("5fjVx")).non_nestable_block_content);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("5fjVx")).orderedList);
$parcel$export(module.exports, "panel", () => (parcelRequire("5fjVx")).panel);
$parcel$export(module.exports, "panel_with_nested_blockquote", () => (parcelRequire("5fjVx")).panel_with_nested_blockquote);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("5fjVx")).paragraph);
$parcel$export(module.exports, "paragraph_with_alignment", () => (parcelRequire("5fjVx")).paragraph_with_alignment);
$parcel$export(module.exports, "paragraph_with_indentation", () => (parcelRequire("5fjVx")).paragraph_with_indentation);
$parcel$export(module.exports, "paragraph_with_no_marks", () => (parcelRequire("5fjVx")).paragraph_with_no_marks);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("5fjVx")).placeholder);
$parcel$export(module.exports, "rule", () => (parcelRequire("5fjVx")).rule);
$parcel$export(module.exports, "status", () => (parcelRequire("5fjVx")).status);
$parcel$export(module.exports, "strike", () => (parcelRequire("5fjVx")).strike);
$parcel$export(module.exports, "strong", () => (parcelRequire("5fjVx")).strong);
$parcel$export(module.exports, "subsup", () => (parcelRequire("5fjVx")).subsup);
$parcel$export(module.exports, "table", () => (parcelRequire("5fjVx")).table);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("5fjVx")).tableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("5fjVx")).tableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("5fjVx")).tableRow);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("5fjVx")).taskItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("5fjVx")).taskList);
$parcel$export(module.exports, "text", () => (parcelRequire("5fjVx")).text);
$parcel$export(module.exports, "textColor", () => (parcelRequire("5fjVx")).textColor);
$parcel$export(module.exports, "text_code_inline", () => (parcelRequire("5fjVx")).text_code_inline);
$parcel$export(module.exports, "text_formatted", () => (parcelRequire("5fjVx")).text_formatted);
$parcel$export(module.exports, "text_link_inline", () => (parcelRequire("5fjVx")).text_link_inline);
$parcel$export(module.exports, "underline", () => (parcelRequire("5fjVx")).underline);
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $5fjVx = parcelRequire("5fjVx");

});
parcelRegister("5fjVx", function(module, exports) {

$parcel$export(module.exports, "alignment", () => $3d1dcf8b9eccd1a7$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $3d1dcf8b9eccd1a7$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $3d1dcf8b9eccd1a7$export$8c5a050822fd698c);
$parcel$export(module.exports, "block_content", () => $3d1dcf8b9eccd1a7$export$a31afb40076fa18b);
$parcel$export(module.exports, "blockCard", () => $3d1dcf8b9eccd1a7$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $3d1dcf8b9eccd1a7$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockRootOnly", () => $3d1dcf8b9eccd1a7$export$ebb5393736e9ba23);
$parcel$export(module.exports, "bodiedExtension", () => $3d1dcf8b9eccd1a7$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => $3d1dcf8b9eccd1a7$export$ee052cc5b2356e83);
$parcel$export(module.exports, "border", () => $3d1dcf8b9eccd1a7$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $3d1dcf8b9eccd1a7$export$89015c65f1c75e3f);
$parcel$export(module.exports, "bulletList", () => $3d1dcf8b9eccd1a7$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $3d1dcf8b9eccd1a7$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "code", () => $3d1dcf8b9eccd1a7$export$6565f9f03506010b);
$parcel$export(module.exports, "codeBlock", () => $3d1dcf8b9eccd1a7$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "codeBlock_root_only", () => $3d1dcf8b9eccd1a7$export$38d90d1aac6883a3);
$parcel$export(module.exports, "confluenceInlineComment", () => $3d1dcf8b9eccd1a7$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $3d1dcf8b9eccd1a7$export$3024f02c495408d6);
$parcel$export(module.exports, "date", () => $3d1dcf8b9eccd1a7$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $3d1dcf8b9eccd1a7$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $3d1dcf8b9eccd1a7$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $3d1dcf8b9eccd1a7$export$2a111da947c407d2);
$parcel$export(module.exports, "em", () => $3d1dcf8b9eccd1a7$export$c63c6f932822f543);
$parcel$export(module.exports, "embedCard", () => $3d1dcf8b9eccd1a7$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $3d1dcf8b9eccd1a7$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $3d1dcf8b9eccd1a7$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expand_root_only", () => $3d1dcf8b9eccd1a7$export$b2817c6954dd6d2c);
$parcel$export(module.exports, "extension", () => $3d1dcf8b9eccd1a7$export$1b45514b112dd749);
$parcel$export(module.exports, "extension_with_marks", () => $3d1dcf8b9eccd1a7$export$15be7c145cec614a);
$parcel$export(module.exports, "extensionFrame", () => $3d1dcf8b9eccd1a7$export$4fdcae991fd743e7);
$parcel$export(module.exports, "fragment", () => $3d1dcf8b9eccd1a7$export$f00aeb236b6f05af);
$parcel$export(module.exports, "hardBreak", () => $3d1dcf8b9eccd1a7$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $3d1dcf8b9eccd1a7$export$46e4a324ac90507f);
$parcel$export(module.exports, "heading_with_alignment", () => $3d1dcf8b9eccd1a7$export$c17edf9af655deaf);
$parcel$export(module.exports, "heading_with_indentation", () => $3d1dcf8b9eccd1a7$export$1902f9737466a0dc);
$parcel$export(module.exports, "heading_with_no_marks", () => $3d1dcf8b9eccd1a7$export$7b491e75f1be9278);
$parcel$export(module.exports, "indentation", () => $3d1dcf8b9eccd1a7$export$480c699bd4ec0d86);
$parcel$export(module.exports, "inline_content", () => $3d1dcf8b9eccd1a7$export$e23e6162adaa368d);
$parcel$export(module.exports, "inlineCard", () => $3d1dcf8b9eccd1a7$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtension", () => $3d1dcf8b9eccd1a7$export$16b353b2649bd8d9);
$parcel$export(module.exports, "inlineExtension_with_marks", () => $3d1dcf8b9eccd1a7$export$e37f10815f36843d);
$parcel$export(module.exports, "layoutColumn", () => $3d1dcf8b9eccd1a7$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $3d1dcf8b9eccd1a7$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSection_full", () => $3d1dcf8b9eccd1a7$export$941b63fbd931e449);
$parcel$export(module.exports, "layoutSection_with_single_column", () => $3d1dcf8b9eccd1a7$export$e0e9834198e8601d);
$parcel$export(module.exports, "link", () => $3d1dcf8b9eccd1a7$export$9c30223ca0a664fb);
$parcel$export(module.exports, "listItem", () => $3d1dcf8b9eccd1a7$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "media", () => $3d1dcf8b9eccd1a7$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $3d1dcf8b9eccd1a7$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $3d1dcf8b9eccd1a7$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $3d1dcf8b9eccd1a7$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingle_caption", () => $3d1dcf8b9eccd1a7$export$68b0ead306f9670f);
$parcel$export(module.exports, "mediaSingle_full", () => $3d1dcf8b9eccd1a7$export$f7fd577406abd5f8);
$parcel$export(module.exports, "mention", () => $3d1dcf8b9eccd1a7$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtension", () => $3d1dcf8b9eccd1a7$export$c3c04d555a8b9013);
$parcel$export(module.exports, "nestedExpand", () => $3d1dcf8b9eccd1a7$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpand_content", () => $3d1dcf8b9eccd1a7$export$9584f52f3ebd5d7e);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => $3d1dcf8b9eccd1a7$export$b756fc994eb0bc4f);
$parcel$export(module.exports, "non_nestable_block_content", () => $3d1dcf8b9eccd1a7$export$ed866000601e7fa5);
$parcel$export(module.exports, "orderedList", () => $3d1dcf8b9eccd1a7$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $3d1dcf8b9eccd1a7$export$21f42ab9b6679f44);
$parcel$export(module.exports, "panel_with_nested_blockquote", () => $3d1dcf8b9eccd1a7$export$5d60af6db74e5cd3);
$parcel$export(module.exports, "paragraph", () => $3d1dcf8b9eccd1a7$export$9c206ddddb32a9b);
$parcel$export(module.exports, "paragraph_with_alignment", () => $3d1dcf8b9eccd1a7$export$9ca11c06877e5c64);
$parcel$export(module.exports, "paragraph_with_indentation", () => $3d1dcf8b9eccd1a7$export$a3bd66932996fb7d);
$parcel$export(module.exports, "paragraph_with_no_marks", () => $3d1dcf8b9eccd1a7$export$f06f75eb1e56b0c5);
$parcel$export(module.exports, "placeholder", () => $3d1dcf8b9eccd1a7$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $3d1dcf8b9eccd1a7$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $3d1dcf8b9eccd1a7$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "strike", () => $3d1dcf8b9eccd1a7$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $3d1dcf8b9eccd1a7$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $3d1dcf8b9eccd1a7$export$b3401ee80eb31041);
$parcel$export(module.exports, "table", () => $3d1dcf8b9eccd1a7$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableCell", () => $3d1dcf8b9eccd1a7$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableHeader", () => $3d1dcf8b9eccd1a7$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableRow", () => $3d1dcf8b9eccd1a7$export$ce666bf02318c957);
$parcel$export(module.exports, "taskItem", () => $3d1dcf8b9eccd1a7$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $3d1dcf8b9eccd1a7$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $3d1dcf8b9eccd1a7$export$6f093cfa640b7166);
$parcel$export(module.exports, "text_code_inline", () => $3d1dcf8b9eccd1a7$export$5008c13f04d544f6);
$parcel$export(module.exports, "text_formatted", () => $3d1dcf8b9eccd1a7$export$d24a7becb4e0da7c);
$parcel$export(module.exports, "text_link_inline", () => $3d1dcf8b9eccd1a7$export$2a9d18d5b3064e6c);
$parcel$export(module.exports, "text_with_no_marks", () => $3d1dcf8b9eccd1a7$export$437a3d96346717e0);
$parcel$export(module.exports, "textColor", () => $3d1dcf8b9eccd1a7$export$32f78bffcd82ff28);
$parcel$export(module.exports, "underline", () => $3d1dcf8b9eccd1a7$export$425327af25286e5e);
const $3d1dcf8b9eccd1a7$export$8e53000a4ec837 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'alignment'
            ]
        },
        attrs: {
            props: {
                align: {
                    type: 'enum',
                    values: [
                        'center',
                        'end'
                    ]
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$8512c9afa7b24c3b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'annotation'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                annotationType: {
                    type: 'enum',
                    values: [
                        'inlineComment'
                    ]
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$8c5a050822fd698c = {
    props: {
        type: {
            type: 'enum',
            values: [
                'backgroundColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$a31afb40076fa18b = [
    'blockCard',
    'paragraph_with_no_marks',
    'paragraph_with_alignment',
    'paragraph_with_indentation',
    'mediaSingle_caption',
    'mediaSingle_full',
    'codeBlock',
    'taskList',
    'bulletList',
    'orderedList',
    'heading_with_no_marks',
    'heading_with_alignment',
    'heading_with_indentation',
    'mediaGroup',
    'decisionList',
    'rule',
    'panel',
    'panel_with_nested_blockquote',
    'blockquote',
    'extension_with_marks',
    'embedCard',
    'table',
    'expand',
    'bodiedExtension_with_marks'
];
const $3d1dcf8b9eccd1a7$export$c4c2f833baaebdb8 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        optional: true,
                        validatorFn: 'safeUrl'
                    },
                    datasource: {
                        props: {
                            id: {
                                type: 'string'
                            },
                            parameters: {
                                type: 'object'
                            },
                            views: {
                                items: [
                                    {
                                        props: {
                                            properties: {
                                                optional: true,
                                                type: 'object'
                                            },
                                            type: {
                                                type: 'string'
                                            }
                                        }
                                    }
                                ],
                                minItems: 1,
                                type: 'array'
                            }
                        }
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ]
    },
    required: [
        'attrs'
    ]
};
const $3d1dcf8b9eccd1a7$export$67dc04e652a298ca = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockquote'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'orderedList',
                    'bulletList',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$ebb5393736e9ba23 = [
    'multiBodiedExtension'
];
const $3d1dcf8b9eccd1a7$export$27903d543b563e39 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'non_nestable_block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$ee052cc5b2356e83 = [
    'bodiedExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$1edee58a52776cd9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'border'
            ]
        },
        attrs: {
            props: {
                size: {
                    type: 'number',
                    minimum: 1,
                    maximum: 3
                },
                color: {
                    pattern: '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$89015c65f1c75e3f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'breakout'
            ]
        },
        attrs: {
            props: {
                mode: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width'
                    ]
                },
                width: {
                    type: 'number',
                    optional: true
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$a140c94e5ea26bee = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bulletList'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_nested_decision'
                ]
            ],
            minItems: 1
        }
    }
};
const $3d1dcf8b9eccd1a7$export$8e3c2dfdc4f0453d = {
    props: {
        type: {
            type: 'enum',
            values: [
                'caption'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'hardBreak',
                    'mention',
                    'emoji',
                    'date',
                    'placeholder',
                    'inlineCard',
                    'status',
                    'text_formatted',
                    'text_code_inline'
                ]
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$6565f9f03506010b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'code'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$7bb0d5c671655cc4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'codeBlock'
            ]
        },
        attrs: {
            props: {
                language: {
                    type: 'string',
                    optional: true
                },
                uniqueId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'text_with_no_marks'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$38d90d1aac6883a3 = [
    'codeBlock',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$f3b72f8fc4684ecd = {
    props: {
        type: {
            type: 'enum',
            values: [
                'confluenceInlineComment'
            ]
        },
        attrs: {
            props: {
                reference: {
                    type: 'string'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$3024f02c495408d6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'dataConsumer'
            ]
        },
        attrs: {
            props: {
                sources: {
                    type: 'array',
                    items: [
                        {
                            type: 'string'
                        }
                    ],
                    minItems: 1
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$324d90190a8b822a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'date'
            ]
        },
        attrs: {
            props: {
                timestamp: {
                    minLength: 1,
                    type: 'string'
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$6959e16eeff859b4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$62d45a65fb43d95e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'decisionItem'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$2a111da947c407d2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'doc'
            ]
        },
        version: {
            type: 'enum',
            values: [
                1
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule',
                    'panel',
                    'panel_with_nested_blockquote',
                    'blockquote',
                    'extension_with_marks',
                    'embedCard',
                    'table',
                    'expand',
                    'bodiedExtension_with_marks',
                    'codeBlock_root_only',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'multiBodiedExtension',
                    'expand_root_only'
                ]
            ],
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$c63c6f932822f543 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'em'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$be4283d9a1cb1ff6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'embedCard'
            ]
        },
        attrs: {
            props: {
                url: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'wrap-right',
                        'wrap-left',
                        'align-end',
                        'align-start'
                    ]
                },
                width: {
                    type: 'number',
                    maximum: 100,
                    minimum: 0,
                    optional: true
                },
                originalHeight: {
                    type: 'number',
                    optional: true
                },
                originalWidth: {
                    type: 'number',
                    optional: true
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$a19185d1233fc4b2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'emoji'
            ]
        },
        attrs: {
            props: {
                shortName: {
                    type: 'string'
                },
                id: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$9f77e0932fb78f72 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'expand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'decisionList',
                    'taskList',
                    'table',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$b2817c6954dd6d2c = [
    'expand',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$1b45514b112dd749 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$15be7c145cec614a = [
    'extension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$4fdcae991fd743e7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extensionFrame'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_full',
                    'mediaSingle_caption',
                    'decisionList',
                    'taskList',
                    'table',
                    'extension_with_marks',
                    'bodiedExtension_with_marks',
                    'blockCard',
                    'embedCard'
                ]
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'dataConsumer',
                    'fragment'
                ]
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$f00aeb236b6f05af = {
    props: {
        type: {
            type: 'enum',
            values: [
                'fragment'
            ]
        },
        attrs: {
            props: {
                localId: {
                    minLength: 1,
                    type: 'string'
                },
                name: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$371da9dd35aba193 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'hardBreak'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'enum',
                    values: [
                        '\n'
                    ],
                    optional: true
                }
            },
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$46e4a324ac90507f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'heading'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$c17edf9af655deaf = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$1902f9737466a0dc = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$7b491e75f1be9278 = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$480c699bd4ec0d86 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'indentation'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$e23e6162adaa368d = [
    'text_formatted',
    'text_code_inline',
    'date',
    'emoji',
    'hardBreak',
    'inlineCard',
    'mention',
    'placeholder',
    'status',
    'inlineExtension_with_marks',
    'mediaInline'
];
const $3d1dcf8b9eccd1a7$export$cbf8224b64e0d942 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $3d1dcf8b9eccd1a7$export$16b353b2649bd8d9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$e37f10815f36843d = [
    'inlineExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$ab76e7c03cd6f650 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutColumn'
            ]
        },
        attrs: {
            props: {
                width: {
                    type: 'number',
                    minimum: 0,
                    maximum: 100
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$b3b6a70a7fa4a5be = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutSection'
            ]
        },
        content: {
            type: 'array',
            items: [
                'layoutColumn'
            ],
            minItems: 1,
            maxItems: 3,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'breakout'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$941b63fbd931e449 = [
    'layoutSection',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 2,
                maxItems: 3,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$e0e9834198e8601d = [
    'layoutSection',
    {
        props: {
            attrs: {
                props: {
                    columnRuleStyle: {
                        type: 'enum',
                        values: [
                            'solid'
                        ],
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 1,
                maxItems: 5,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$9c30223ca0a664fb = {
    props: {
        type: {
            type: 'enum',
            values: [
                'link'
            ]
        },
        attrs: {
            props: {
                href: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                title: {
                    type: 'string',
                    optional: true
                },
                id: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string',
                    optional: true
                },
                occurrenceKey: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$76c7e83ecc9cdf05 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'listItem'
            ]
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock'
                ],
                [
                    'paragraph_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'taskList',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$2b82905b9aebbab0 = [
    'listItem',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    [
                        'paragraph_with_no_marks',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'decisionList'
                    ],
                    [
                        'paragraph_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'taskList',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'decisionList'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$987d49ffe1b0900f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'media'
            ]
        },
        attrs: [
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'link',
                            'file'
                        ]
                    },
                    id: {
                        minLength: 1,
                        type: 'string'
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    collection: {
                        type: 'string'
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    occurrenceKey: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    }
                }
            },
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'external'
                        ]
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    url: {
                        type: 'string'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $3d1dcf8b9eccd1a7$export$2855e964765eac9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaGroup'
            ]
        },
        content: {
            type: 'array',
            items: [
                'media'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$38bab695e3f720f1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaInline'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'link',
                        'file',
                        'image'
                    ],
                    optional: true
                },
                url: {
                    type: 'string',
                    optional: true
                },
                id: {
                    minLength: 1,
                    type: 'string'
                },
                alt: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string'
                },
                occurrenceKey: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                },
                height: {
                    type: 'number',
                    optional: true
                },
                data: {
                    type: 'object',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$969fe3781ca15058 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaSingle'
            ]
        },
        attrs: [
            {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0,
                        maximum: 100,
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'percentage'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'pixel'
                        ]
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'link'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$68b0ead306f9670f = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    'media',
                    'caption'
                ],
                minItems: 1,
                maxItems: 2,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$f7fd577406abd5f8 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$af10954ff7b86f88 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$db83999c14438df4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mention'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                accessLevel: {
                    type: 'string',
                    optional: true
                },
                userType: {
                    type: 'enum',
                    values: [
                        'DEFAULT',
                        'SPECIAL',
                        'APP'
                    ],
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$c3c04d555a8b9013 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'multiBodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    type: 'string',
                    minLength: 1
                },
                extensionType: {
                    type: 'string',
                    minLength: 1
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'default',
                        'wide',
                        'full-width'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true,
                    minLength: 1
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'extensionFrame'
            ]
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$63cadbf5f4296627 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'nestedExpand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: 'nestedExpand_content'
    },
    required: [
        'content'
    ]
};
const $3d1dcf8b9eccd1a7$export$9584f52f3ebd5d7e = {
    type: 'array',
    items: [
        [
            'paragraph_with_no_marks',
            'heading_with_no_marks',
            'mediaSingle_caption',
            'mediaSingle_full',
            'mediaGroup',
            'codeBlock',
            'bulletList',
            'orderedList',
            'taskList',
            'decisionList',
            'rule',
            'panel',
            'blockquote'
        ]
    ],
    minItems: 1,
    allowUnsupportedBlock: true
};
const $3d1dcf8b9eccd1a7$export$b756fc994eb0bc4f = [
    'nestedExpand',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$ed866000601e7fa5 = [
    'paragraph_with_no_marks',
    'panel',
    'blockquote',
    'orderedList',
    'bulletList',
    'rule',
    'heading_with_no_marks',
    'codeBlock',
    'mediaGroup',
    'mediaSingle_caption',
    'mediaSingle_full',
    'decisionList',
    'taskList',
    'table',
    'blockCard',
    'embedCard',
    'extension_with_marks'
];
const $3d1dcf8b9eccd1a7$export$a5dc81035676e7a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'orderedList'
            ]
        },
        attrs: {
            props: {
                order: {
                    type: 'number',
                    minimum: 0,
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_nested_decision'
                ]
            ],
            minItems: 1
        }
    }
};
const $3d1dcf8b9eccd1a7$export$21f42ab9b6679f44 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'panel'
            ]
        },
        attrs: {
            props: {
                panelType: {
                    type: 'enum',
                    values: [
                        'info',
                        'note',
                        'tip',
                        'warning',
                        'error',
                        'success',
                        'custom'
                    ]
                },
                panelIcon: {
                    type: 'string',
                    optional: true
                },
                panelIconId: {
                    type: 'string',
                    optional: true
                },
                panelIconText: {
                    type: 'string',
                    optional: true
                },
                panelColor: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'heading_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'blockCard',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'rule',
                    'decisionList'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$5d60af6db74e5cd3 = [
    'panel',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_no_marks',
                        'heading_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'blockCard',
                        'mediaGroup',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'taskList',
                        'rule',
                        'decisionList',
                        'blockquote'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$9c206ddddb32a9b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'paragraph'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$9ca11c06877e5c64 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$a3bd66932996fb7d = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$f06f75eb1e56b0c5 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$c7187bbd1a7a9244 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'placeholder'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'string'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$fbeb3a3956e8a3c7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'rule'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$471f7ae5c4103ae1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'status'
            ]
        },
        attrs: {
            props: {
                text: {
                    minLength: 1,
                    type: 'string'
                },
                color: {
                    type: 'enum',
                    values: [
                        'neutral',
                        'purple',
                        'blue',
                        'red',
                        'yellow',
                        'green'
                    ]
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                style: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$4899a95d70ec5056 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strike'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$59ae2c325a998f89 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strong'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$b3401ee80eb31041 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'subsup'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'sub',
                        'sup'
                    ]
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$9852986a3ec5f6a0 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'table'
            ]
        },
        attrs: {
            props: {
                displayMode: {
                    type: 'enum',
                    values: [
                        'default',
                        'fixed'
                    ],
                    optional: true
                },
                isNumberColumnEnabled: {
                    type: 'boolean',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'align-end',
                        'align-start',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    minLength: 1,
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'tableRow'
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'fragment'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$e1e720e5f4603e6a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableCell'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    },
    required: [
        'content'
    ]
};
const $3d1dcf8b9eccd1a7$export$48884d2a5190dc73 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableHeader'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks',
                    'nestedExpand'
                ]
            ],
            minItems: 1
        }
    },
    required: [
        'content'
    ]
};
const $3d1dcf8b9eccd1a7$export$ce666bf02318c957 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableRow'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'tableCell',
                    'tableHeader'
                ]
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$6d8b0ef52e2e6390 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$375b6afcc5f4d291 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                'taskItem',
                [
                    'taskItem',
                    'taskList'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$6f093cfa640b7166 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'text'
            ]
        },
        text: {
            type: 'string',
            minLength: 1
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$5008c13f04d544f6 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'code',
                        'link',
                        'annotation'
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$d24a7becb4e0da7c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'link',
                        'em',
                        'strong',
                        'strike',
                        'subsup',
                        'underline',
                        'textColor',
                        'annotation',
                        'backgroundColor',
                        null
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$2a9d18d5b3064e6c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'link'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$437a3d96346717e0 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$32f78bffcd82ff28 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'textColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    type: 'string',
                    pattern: '^#[0-9a-fA-F]{6}$'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$425327af25286e5e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'underline'
            ]
        }
    }
};

});


parcelRegister("iiazc", function(module, exports) {

$parcel$export(module.exports, "isDefined", () => $2c8456da404b8e3f$export$4e62c701997796c1);
$parcel$export(module.exports, "isNumber", () => $2c8456da404b8e3f$export$7e4aa119212bc614);
$parcel$export(module.exports, "isInteger", () => $2c8456da404b8e3f$export$a287f47fed4544b8);
$parcel$export(module.exports, "isBoolean", () => $2c8456da404b8e3f$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isString", () => $2c8456da404b8e3f$export$844ec244b1367d54);
$parcel$export(module.exports, "isPlainObject", () => $2c8456da404b8e3f$export$53b83ca8eaab0383);
$parcel$export(module.exports, "copy", () => $2c8456da404b8e3f$export$784d13d8ee351f07);
$parcel$export(module.exports, "makeArray", () => $2c8456da404b8e3f$export$7b85fd78dd236198);
const $2c8456da404b8e3f$export$4e62c701997796c1 = (x)=>x != null;
const $2c8456da404b8e3f$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
const $2c8456da404b8e3f$export$a287f47fed4544b8 = (x)=>typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
const $2c8456da404b8e3f$export$f9ce7b637dfbe238 = (x)=>x === true || x === false || toString.call(x) === '[object Boolean]';
const $2c8456da404b8e3f$export$844ec244b1367d54 = (s)=>typeof s === 'string' || s instanceof String;
const $2c8456da404b8e3f$export$53b83ca8eaab0383 = (x)=>typeof x === 'object' && x !== null && !Array.isArray(x);
const $2c8456da404b8e3f$export$784d13d8ee351f07 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
source, dest, key)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dest[key] = source[key];
    return dest;
};
const $2c8456da404b8e3f$export$7b85fd78dd236198 = (maybeArray)=>Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];

});

parcelRegister("1H4Aw", function(module, exports) {

$parcel$export(module.exports, "validatorFnMap", () => $608e35270d0ca1e8$export$d1b377ca77ac267d);

var $iZOJ9 = parcelRequire("iZOJ9");
const $608e35270d0ca1e8$export$d1b377ca77ac267d = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    safeUrl: (0, $iZOJ9.isSafeUrl)
};

});



parcelRegister("1cjf7", function(module, exports) {

$parcel$export(module.exports, "trackUnsupportedContentLevels", () => $dad344c5873159ce$export$a43de96edd8d0a0);

var $4NUlu = parcelRequire("4NUlu");
var $2KwKW = parcelRequire("2KwKW");

var $gkwXh = parcelRequire("gkwXh");

var $knXBU = parcelRequire("knXBU");
const $dad344c5873159ce$var$rendersMap = {};
const $dad344c5873159ce$var$processLevelsAndTrack = (item, thresholds, dispatchAnalyticsEvent)=>{
    try {
        const { severity: severity, percentage: percentage, counts: { supportedNodes: supportedNodes, unsupportedNodes: unsupportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } } = (0, $2KwKW.getUnsupportedContentLevelData)(item.doc, thresholds);
        dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            attributes: {
                appearance: (0, $4NUlu.getAnalyticsAppearance)(item.appearance),
                platform: (0, $knXBU.PLATFORM).WEB,
                unsupportedContentLevelSeverity: severity,
                unsupportedContentLevelPercentage: percentage,
                unsupportedNodesCount: unsupportedNodes,
                supportedNodesCount: supportedNodes,
                unsupportedNodeTypeCount: unsupportedNodeTypeCount
            },
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
    } catch (err) {
        dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB,
                error: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
    }
};
const $dad344c5873159ce$var$schedule = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof window.requestIdleCallback === 'function') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn);
    else setTimeout(fn, 0);
};
const $dad344c5873159ce$var$DEFAULT_SAMPLING_RATE = 100;
const $dad344c5873159ce$export$a43de96edd8d0a0 = (item, trackingOptions, dispatchAnalyticsEvent)=>{
    const { thresholds: thresholds, samplingRates: samplingRates } = trackingOptions;
    const appearance = item.appearance ?? 'unknown';
    if (!$dad344c5873159ce$var$rendersMap[appearance]) $dad344c5873159ce$var$rendersMap[appearance] = new Set();
    // bail out if already processed a render from a given renderer instance
    const didProcessRenderer = $dad344c5873159ce$var$rendersMap[appearance].has(item.rendererId);
    if (didProcessRenderer) return;
    // otherwise track the render
    $dad344c5873159ce$var$rendersMap[appearance].add(item.rendererId);
    const sampleRate = samplingRates && samplingRates[appearance] || $dad344c5873159ce$var$DEFAULT_SAMPLING_RATE;
    // sample from the first available tracked render
    if ($dad344c5873159ce$var$rendersMap[appearance].size === 1) $dad344c5873159ce$var$schedule(()=>$dad344c5873159ce$var$processLevelsAndTrack(item, thresholds, dispatchAnalyticsEvent));
    // cleanup/refresh tracked renders at the sampling rate
    if ($dad344c5873159ce$var$rendersMap[appearance].size % sampleRate === 0) $dad344c5873159ce$var$rendersMap[appearance] = new Set();
};

});
parcelRegister("2KwKW", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedContentLevelData", () => $4210b4deee40727f$export$484b83e0462998d);

var $l1C1k = parcelRequire("l1C1k");
var $4210b4deee40727f$export$6632e71a22d31bf1 = /*#__PURE__*/ function(UNSUPPORTED_CONTENT_LEVEL_SEVERITY) {
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["NORMAL"] = "normal";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["DEGRADED"] = "degraded";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["BLOCKING"] = "blocking";
    return UNSUPPORTED_CONTENT_LEVEL_SEVERITY;
}({});
const $4210b4deee40727f$export$f9f8a29778652c3e = {
    DEGRADED: 10,
    BLOCKING: 25
};
const $4210b4deee40727f$var$buildUnsupportedContentLevelThresholds = (customThresholds)=>{
    return {
        degraded: customThresholds?.degraded || $4210b4deee40727f$export$f9f8a29778652c3e.DEGRADED,
        blocking: customThresholds?.blocking || $4210b4deee40727f$export$f9f8a29778652c3e.BLOCKING
    };
};
const $4210b4deee40727f$var$countSupportedUnsupportedNodes = (validDocument)=>{
    let unsupportedNodes = 0;
    let supportedNodes = 0;
    const unsupportedNodeTypeCount = {};
    const unsupportedNodeTypes = [
        'unsupportedInline',
        'unsupportedBlock',
        'confluenceUnsupportedInline',
        'confluenceUnsupportedBlock'
    ];
    (0, $l1C1k.traverse)(validDocument, {
        any: (node)=>{
            if (unsupportedNodeTypes.includes(node.type)) {
                const originalNode = node.attrs?.originalValue;
                if (originalNode) // start an independent traversal for the purpose of counting
                // unsupported content nodes (with nested children contributing towards
                // that count)
                (0, $l1C1k.traverse)(originalNode, {
                    any: (unsupportedNode, parent)=>{
                        unsupportedNodes++;
                        // Count the types of unsupported nodes
                        const parentType = parent.parent?.node?.type ?? 'unknown';
                        const type = `${parentType}/${unsupportedNode?.type ?? 'unknown'}`;
                        unsupportedNodeTypeCount[type] = (unsupportedNodeTypeCount?.[type] ?? 0) + 1;
                    }
                });
                // force the parent traversal (which is counting supported content nodes)
                // to skip traversal/counting of nested children of the unsupported nodes
                return false;
            } else supportedNodes++;
        }
    });
    return {
        unsupportedNodes: unsupportedNodes,
        supportedNodes: supportedNodes,
        unsupportedNodeTypeCount: unsupportedNodeTypeCount
    };
};
const $4210b4deee40727f$var$mapUnsupportedContentLevelToSeverity = (unsupportedContentLevelPercent, thresholds)=>{
    if (thresholds.degraded <= unsupportedContentLevelPercent && unsupportedContentLevelPercent < thresholds.blocking) return "degraded";
    if (thresholds.blocking <= unsupportedContentLevelPercent) return "blocking";
    return "normal";
};
const $4210b4deee40727f$export$484b83e0462998d = (validDocument, customThresholds)=>{
    const { unsupportedNodes: unsupportedNodes, supportedNodes: supportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } = $4210b4deee40727f$var$countSupportedUnsupportedNodes(validDocument);
    const thresholds = $4210b4deee40727f$var$buildUnsupportedContentLevelThresholds(customThresholds);
    const percentage = Math.round(unsupportedNodes / (unsupportedNodes + supportedNodes) * 100);
    const severity = $4210b4deee40727f$var$mapUnsupportedContentLevelToSeverity(percentage, thresholds);
    return {
        severity: severity,
        percentage: percentage,
        counts: {
            supportedNodes: supportedNodes,
            unsupportedNodes: unsupportedNodes,
            unsupportedNodeTypeCount: unsupportedNodeTypeCount
        }
    };
};

});


parcelRegister("kgV4b", function(module, exports) {

$parcel$export(module.exports, "countNodes", () => $7ac8dee2b321f8fd$export$1daf15cbaf649dad);

var $3Y1bF = parcelRequire("3Y1bF");
function $7ac8dee2b321f8fd$export$1daf15cbaf649dad(adfDocument) {
    return (0, $3Y1bF.reduce)(adfDocument, (acc, node)=>{
        acc[node.type] = (acc[node.type] || 0) + 1;
        return acc;
    }, {});
}

});
parcelRegister("3Y1bF", function(module, exports) {

$parcel$export(module.exports, "reduce", () => $de5bae64a9d3f36e$export$533b26079ad0b4b);

var $l1C1k = parcelRequire("l1C1k");
function $de5bae64a9d3f36e$export$533b26079ad0b4b(adf, callback, initial) {
    let result = initial;
    (0, $l1C1k.traverse)(adf, {
        any: (node)=>{
            result = callback(result, node);
        }
    });
    return result;
}

});



parcelRegister("1urn6", function(module, exports) {

$parcel$export(module.exports, "EditorMediaClientProvider", () => $d9518b7b87f036fd$export$77218b6ff680865f);

var $5uXOq = parcelRequire("5uXOq");

var $cEHh7 = parcelRequire("cEHh7");

var $9S8fM = parcelRequire("9S8fM");
const $d9518b7b87f036fd$export$77218b6ff680865f = ({ children: children, ssr: ssr })=>{
    const [mediaClientConfig, setMediaClientConfig] = (0, $5uXOq.useState)();
    const mediaProvider = (0, $9S8fM.useProvider)('mediaProvider');
    /**
	 * If a mediaClientConfig is provided then we will force
	 * skip the mediaClient from context
	 */ const shouldSkipContext = Boolean(ssr?.config || mediaProvider);
    const contextMediaClient = (0, $5uXOq.useContext)((0, $cEHh7.MediaClientContext));
    // MediaClientProvider currently requires a mediaClientConfig
    // And inserting the MediaClientProvider will cause a re-render
    // We should use MediaClientProvider once it no longer requires a config
    const mediaClient = (0, $5uXOq.useMemo)(()=>mediaClientConfig ? (0, $cEHh7.getMediaClient)(mediaClientConfig) : undefined, [
        mediaClientConfig
    ]);
    // Consumers can override the mediaClient for renderer,
    // by not providing both SSR config and mediaProvider,
    // and provide a top level mediaClient context
    // This is useful for testing and creating examples.
    (0, $5uXOq.useEffect)(()=>{
        if (ssr?.config) setMediaClientConfig(ssr.config);
        else if (mediaProvider) mediaProvider.then((provider)=>{
            setMediaClientConfig(provider.viewMediaClientConfig);
        });
    }, [
        mediaProvider,
        ssr
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cEHh7.MediaClientContext).Provider, {
        value: shouldSkipContext ? mediaClient : contextMediaClient
    }, children);
};

});

parcelRegister("1pTqN", function(module, exports) {

$parcel$export(module.exports, "ActiveHeaderIdProvider", () => $ae2d04c26b960a03$export$20439b49fdd0d26c);
$parcel$export(module.exports, "ActiveHeaderIdConsumer", () => $ae2d04c26b960a03$export$cddc3c6ebe2d2cec);

var $5uXOq = parcelRequire("5uXOq");
const { Provider: $ae2d04c26b960a03$export$20439b49fdd0d26c, Consumer: $ae2d04c26b960a03$var$Consumer } = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
/**
 * We need to expose this abstraction on top of the native Consumer in order to control when
 * The consumer will get notified when a match has happened. If we use the Consumer directly in
 * Expand components without this inner state, everytime a new prop comes in, and the `newActiveHeaderId`
 * is the same as before, we will set the expand to true forever, until the active header id changes.
 * Thus, the user won't be able to collapse the expand.
 *
 * By exposing `onNestedHeaderIdMatch` here we can control when will consumers be notified:
 * only when a `newActiveHeaderId` comes in from the Provider and the list of header ids includes it.
 */ const $ae2d04c26b960a03$export$cddc3c6ebe2d2cec = ({ nestedHeaderIds: nestedHeaderIds, onNestedHeaderIdMatch: onNestedHeaderIdMatch })=>{
    const [activeHeaderId, setActiveHeaderId] = (0, $5uXOq.useState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ae2d04c26b960a03$var$Consumer, null, (newActiveHeaderId)=>{
        if (!newActiveHeaderId || !nestedHeaderIds.includes(newActiveHeaderId)) setActiveHeaderId(undefined);
        else if (newActiveHeaderId !== activeHeaderId && nestedHeaderIds.includes(newActiveHeaderId)) {
            setActiveHeaderId(newActiveHeaderId);
            onNestedHeaderIdMatch();
        }
        return null;
    });
};

});

parcelRegister("jUVor", function(module, exports) {

$parcel$export(module.exports, "BreakoutSSRInlineScript", () => $5224f7c9e411dec4$export$cfc1361be0de4203);

var $5uXOq = parcelRequire("5uXOq");

var $eOOFp = parcelRequire("eOOFp");

var $VSDnB = parcelRequire("VSDnB");

var $OxITw = parcelRequire("OxITw");
function $5224f7c9e411dec4$export$cfc1361be0de4203({ noOpSSRInlineScript: noOpSSRInlineScript }) {
    /**
	 * Should only inline this script while SSR,
	 * not needed on the client side.
	 */ // For hydrateRoot there is a mismatch on client for this script.
    // So we want to add the script on client side but guard it with check to
    // not execute logic
    if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
        if (!noOpSSRInlineScript) return null;
        else window.__RENDERER_BYPASS_BREAKOUT_SSR__ = true;
    }
    const id = Math.floor(Math.random() * 9999990001) + 9999;
    const context = $5224f7c9e411dec4$export$92859d13f30c883e(id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("script", {
        "data-breakout-script-id": id,
        // To investigate if we can replace this.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: context
        },
        "data-testid": "breakout-ssr-inline-script"
    });
}
function $5224f7c9e411dec4$export$92859d13f30c883e(id) {
    return `
	 (function(window){
		if(typeof window !== 'undefined' && window.__RENDERER_BYPASS_BREAKOUT_SSR__) {
			return;
		}
    ${$5224f7c9e411dec4$export$47813c4121c8b4b3};
    (${$5224f7c9e411dec4$var$applyBreakoutAfterSSR.toString()})("${id}", breakoutConsts, ${Boolean((0, $VSDnB.fg)('platform-fix-table-ssr-resizing'))});
  })(window);
`;
}
const $5224f7c9e411dec4$export$47813c4121c8b4b3 = `
  var breakoutConsts = ${JSON.stringify((0, $eOOFp.breakoutConsts))};
  breakoutConsts.mapBreakpointToLayoutMaxWidth = ${(0, $eOOFp.breakoutConsts).mapBreakpointToLayoutMaxWidth.toString()};
  breakoutConsts.getBreakpoint = ${(0, $eOOFp.breakoutConsts).getBreakpoint.toString()};
  breakoutConsts.calcBreakoutWidth = ${(0, $eOOFp.breakoutConsts).calcBreakoutWidth.toString()};
  breakoutConsts.calcBreakoutWithCustomWidth = ${(0, $eOOFp.breakoutConsts).calcBreakoutWithCustomWidth.toString()};
  breakoutConsts.calcLineLength = ${(0, $eOOFp.breakoutConsts).calcLineLength.toString()};
  breakoutConsts.calcWideWidth = ${(0, $eOOFp.breakoutConsts).calcWideWidth.toString()};
  breakoutConsts.FullPagePadding = ${(0, $OxITw.FullPagePadding).toString()};
`;
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5224f7c9e411dec4$var$applyBreakoutAfterSSR(id, breakoutConsts, shouldFixTableResizing) {
    const MEDIA_NODE_TYPE = 'mediaSingle';
    const WIDE_LAYOUT_MODES = [
        'full-width',
        'wide',
        'custom'
    ];
    function findUp(element, condition) {
        if (!element) return;
        while(element.parentElement){
            if (condition(element)) return element.parentElement;
            element = element.parentElement;
        }
    }
    const renderer = findUp(document.querySelector('[data-breakout-script-id="' + id + '"]'), (elem)=>!!elem.parentElement?.classList.contains('ak-renderer-wrapper'));
    if (!renderer) return;
    const observer = new MutationObserver((mutationsList)=>{
        mutationsList.forEach((item)=>{
            if (item.target.nodeType !== Node.ELEMENT_NODE) return;
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            if (item.target.classList.contains('ak-renderer-document')) item.addedNodes.forEach((maybeNode)=>{
                // maybeNode may contain comments which doesn't have a dataset property
                if (maybeNode.nodeType !== Node.ELEMENT_NODE) return;
                let width;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const node = maybeNode;
                const mode = node.dataset.mode || node.dataset.layout || '';
                const resizedBreakout = node.dataset.hasWidth === 'true';
                if (!mode || !WIDE_LAYOUT_MODES.includes(mode)) return;
                // When flag is on we are using CSS to calculate the table width thus don't need logic below to set the width and left.
                if (!shouldFixTableResizing) {
                    if (node.classList.contains('pm-table-container') && mode === 'custom') {
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const rendererWidth = renderer.offsetWidth;
                        const effectiveWidth = rendererWidth - breakoutConsts.padding;
                        width = `${Math.min(parseInt(node.style.width), effectiveWidth)}px`;
                    } else if (resizedBreakout) width = breakoutConsts.calcBreakoutWithCustomWidth(mode, node.dataset.width || null, // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    renderer.offsetWidth);
                    else // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    width = breakoutConsts.calcBreakoutWidth(mode, renderer.offsetWidth);
                    if (node.style.width === width) return;
                    node.style.width = width;
                    // Tables require some special logic, as they are not using common css transform approach,
                    // because it breaks with sticky headers. This logic is copied from a table node:
                    // https://bitbucket.org/atlassian/atlassian-frontend/src/77938aee0c140d02ff99b98a03849be1236865b4/packages/editor/renderer/src/react/nodes/table.tsx#table.tsx-235:245
                    if (node.classList.contains('pm-table-container') && // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    !renderer.classList.contains('is-full-width')) {
                        const lineLength = breakoutConsts.calcLineLength();
                        const left = lineLength / 2 - parseInt(width) / 2;
                        if (left < 0 && parseInt(width) > lineLength) node.style.left = left + 'px';
                        else node.style.left = '';
                    }
                }
            });
            else if (/**
				 * The mutation observer is only called once per added node.
				 * The above condition only deals with direct children of <div class="ak-renderer-document" />
				 * When it is initially called on the direct children, not all the sub children have loaded.
				 * So nested media elements which are not immediately loaded as sub children are not available in the above conditional.
				 * Thus adding this conditional to deal with all media elements directly.
				 */ // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            item.target.dataset.nodeType === MEDIA_NODE_TYPE) // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            applyMediaBreakout(item.target);
        });
    });
    const applyMediaBreakout = (card)=>{
        // width was already set by another breakout script
        if (card.style.width) return;
        const tableParent = findUp(card, (elem)=>elem instanceof HTMLTableCellElement);
        // only apply the breakout to media elements not nested inside table
        // table sizing is not based on percentage width
        if (tableParent) return;
        const mode = card.dataset.mode || card.dataset.layout || '';
        const width = card.dataset.width;
        const isPixelBasedResizing = card.dataset.widthType === 'pixel';
        if (WIDE_LAYOUT_MODES.includes(mode)) card.style.width = '100%';
        else if (width && !isPixelBasedResizing) // Pixel based resizing has width set in pixels based on its width attribute
        // Thus, no need to override for non-wide layouts
        card.style.width = `${width}%`;
    };
    observer.observe(renderer, {
        childList: true,
        subtree: true
    });
    /**
	 * Using window load event to unsubscribe from mutation observer, as at this stage document is fully rendered.
	 * Experiment with DOMContentLoaded showed that some of the blocks were not processed at all.
	 * That's why window load is necessary.
	 *
	 * More info:
	 * – https://html.spec.whatwg.org/multipage/parsing.html#the-end
	 * – https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
	 * – https://developer.mozilla.org/en-US/docs/Web/API/Document/DOMContentLoaded_event
	 */ const disconnect = ()=>{
        observer.disconnect();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('load', disconnect);
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('load', disconnect);
}
const $5224f7c9e411dec4$export$2a0b3eeee3f2ea40 = (0, $eOOFp.breakoutConsts).calcLineLength;

});

parcelRegister("TPpI8", function(module, exports) {

$parcel$export(module.exports, "isInteractiveElement", () => $2d523c4d7c031fc5$export$3dee5e4542c672d9);


function $2d523c4d7c031fc5$export$3dee5e4542c672d9(element) {
    if ('href' in element && element.href != null) return true;
    if (element.classList.contains((0, $9e7f9e5fe795995b$export$42c8d07e41ed1e74))) return true;
    if (element.classList.contains((0, $025bde419ff72534$export$7a6526d4be3b7eb3))) return true;
    return false;
}

});
const $025bde419ff72534$export$7a6526d4be3b7eb3 = 'media-file-card-view';
const $025bde419ff72534$export$1b2a6cb6a124ba37 = 'media-file-card-view-selected';

/**
 * Classname for the media viewer popup that appears adjacent to the editor div. Use this to check
 * if the media viewer has appeared.
 */ const $9e7f9e5fe795995b$export$42c8d07e41ed1e74 = 'media-viewer-popup';


parcelRegister("3lRy2", function(module, exports) {

$parcel$export(module.exports, "TruncatedWrapper", () => $de95a93fc343bd51$export$79ad592494094f07);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");
const $de95a93fc343bd51$var$fadeOutStyles = (maxHeight, top, backgroundColor)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        position: 'relative',
        overflowY: 'hidden',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: `${maxHeight}px`,
        '&::after': {
            content: "''",
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: `${top}px`,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundImage: `linear-gradient( ${"var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0))"}, ${backgroundColor} )`
        }
    });
const $de95a93fc343bd51$var$FadeOut = (props)=>{
    const { children: children, backgroundColor: backgroundColor, fadeHeight: fadeHeight, height: height } = props;
    const top = height - fadeHeight;
    const styles = $de95a93fc343bd51$var$fadeOutStyles(height, top, backgroundColor);
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: styles
    }, children);
};
class $de95a93fc343bd51$export$79ad592494094f07 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
    }
    // TODO: Quality ticket as elevation.surface will be issue when sits top of modal. https://product-fabric.atlassian.net/browse/DSP-4123
    render() {
        const { height: height = 95, fadeHeight: fadeHeight = 24, backgroundColor: backgroundColor = "var(--ds-surface, white)", children: children } = this.props;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)($de95a93fc343bd51$var$FadeOut, {
            height: height,
            fadeHeight: fadeHeight,
            backgroundColor: backgroundColor
        }, children);
    }
}

});


parcelRegister("h17zy", function(module, exports) {

$parcel$export(module.exports, "useEmojiProvider", () => $502e0815e90e6f7b$export$d80cf6b7758b1c7e);

var $5uXOq = parcelRequire("5uXOq");

var $dGzaM = parcelRequire("dGzaM");

var $hXRXz = parcelRequire("hXRXz");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");
const $502e0815e90e6f7b$export$d80cf6b7758b1c7e = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    const emojiProvider = (0, $5uXOq.useMemo)(()=>{
        const dataProviders = new (0, $dGzaM.default)();
        dataProviders.setProvider('emojiProvider', (0, $hXRXz.getEmojiProviderWithCustomEmoji)(cloudId, atlassianAccountId) || undefined);
        return dataProviders;
    }, [
        cloudId,
        atlassianAccountId
    ]);
    return emojiProvider;
};

});

parcelRegister("4IoOR", function(module, exports) {

$parcel$export(module.exports, "convertWikiToAdf", () => $7c8efe67867622a1$export$3dfdef94497f0395);

var $kOFhM = parcelRequire("kOFhM");

var $hYNZx = parcelRequire("hYNZx");

var $dN5CS = parcelRequire("dN5CS");
const $7c8efe67867622a1$var$wikiTransformer = new (0, $dN5CS.WikiMarkupTransformer)((0, $kOFhM.defaultSchema));
const $7c8efe67867622a1$var$adfTransformer = new (0, $hYNZx.JSONTransformer)();
const $7c8efe67867622a1$export$3dfdef94497f0395 = (wiki)=>{
    if (wiki === null || wiki === undefined || wiki === '') return null;
    const pmNode = $7c8efe67867622a1$var$wikiTransformer.parse(wiki);
    return $7c8efe67867622a1$var$adfTransformer.encode(pmNode);
};

});
parcelRegister("dN5CS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "WikiMarkupTransformer", () => $4011ad83704160d6$export$caaa00407b56b900);
$parcel$export(module.exports, "default", () => $4011ad83704160d6$export$2e2bcd8739ae039);

var $kOFhM = parcelRequire("kOFhM");

var $lxtC7 = parcelRequire("lxtC7");

var $djcbG = parcelRequire("djcbG");

var $bOMPB = parcelRequire("bOMPB");
class $4011ad83704160d6$export$caaa00407b56b900 {
    constructor(schema = (0, $kOFhM.defaultSchema)){
        this.schema = schema;
    }
    // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
    // The following has to be a regex to remove all instances of null instead of the first
    sanitizeWikiMarkup(wikiMarkup) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return wikiMarkup.replace(/\0/g, '');
    }
    encode(node, context) {
        const wikiMarkup = (0, $lxtC7.encode)(node, $4011ad83704160d6$var$normalizeContextObject(context));
        // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
        const sanitizedWikiMarkup = this.sanitizeWikiMarkup(wikiMarkup);
        return sanitizedWikiMarkup;
    }
    parse(wikiMarkup, context) {
        // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
        const sanitizedWikiMarkup = this.sanitizeWikiMarkup(wikiMarkup);
        const tree = new (0, $djcbG.default)(this.schema, sanitizedWikiMarkup);
        return tree.getProseMirrorModel(this.buildContext($4011ad83704160d6$var$normalizeContextObject(context)));
    }
    buildContext(context) {
        return context ? {
            ...context,
            issueKeyRegex: context.conversion ? (0, $bOMPB.buildIssueKeyRegex)(context.conversion.inlineCardConversion) : undefined
        } : {};
    }
}
/**
 * Turns mentionConversion object keys to lowercase for case insensitivity matching
 * This is okay, because conversion context object contains mapping and that should be case insensitive
 */ const $4011ad83704160d6$var$normalizeContextObject = (context)=>{
    if (!context || !context.conversion || !context.conversion.mentionConversion) // nothing to normalize, return original object
    return context;
    const mentionConversion = {};
    // eslint-disable-next-line guard-for-in
    for(const key in context.conversion.mentionConversion)mentionConversion[key.toLowerCase()] = context.conversion.mentionConversion[key];
    context.conversion.mentionConversion = mentionConversion;
    return context;
};
var $4011ad83704160d6$export$2e2bcd8739ae039 = $4011ad83704160d6$export$caaa00407b56b900;

});
parcelRegister("lxtC7", function(module, exports) {

$parcel$export(module.exports, "encode", () => $f10f1fd2bcfd2732$export$c564cdbbe6da493);

var $03QYI = parcelRequire("03QYI");

var $6ises = parcelRequire("6ises");

var $hgytR = parcelRequire("hgytR");

var $b6sEJ = parcelRequire("b6sEJ");

var $73kPn = parcelRequire("73kPn");

var $1B6CN = parcelRequire("1B6CN");

var $8UMD2 = parcelRequire("8UMD2");

var $fIzNZ = parcelRequire("fIzNZ");

var $eTlm6 = parcelRequire("eTlm6");

var $6obXI = parcelRequire("6obXI");

var $h9tzi = parcelRequire("h9tzi");

var $abXFq = parcelRequire("abXFq");

var $flJtr = parcelRequire("flJtr");

var $czgKo = parcelRequire("czgKo");

var $acqkf = parcelRequire("acqkf");

var $1Nefo = parcelRequire("1Nefo");

var $69N10 = parcelRequire("69N10");

var $12A17 = parcelRequire("12A17");

var $bsbI5 = parcelRequire("bsbI5");
const $f10f1fd2bcfd2732$var$nodeEncoderMapping = {
    blockquote: $03QYI.blockquote,
    bulletList: $6ises.bulletList,
    taskList: $hgytR.taskList,
    decisionList: $b6sEJ.decisionList,
    codeBlock: $73kPn.codeBlock,
    doc: $1B6CN.doc,
    heading: $fIzNZ.heading,
    caption: $bsbI5.caption,
    mediaGroup: $eTlm6.mediaGroup,
    mediaInline: $6obXI.mediaInline,
    mediaSingle: (0, $eTlm6.mediaGroup),
    orderedList: $h9tzi.orderedList,
    panel: $abXFq.panel,
    paragraph: $flJtr.paragraph,
    rule: $czgKo.rule,
    table: $acqkf.table,
    blockCard: $69N10.blockCard,
    embedCard: $12A17.embedCard,
    expand: $8UMD2.expand
};
function $f10f1fd2bcfd2732$export$c564cdbbe6da493(node, context) {
    const encoder = $f10f1fd2bcfd2732$var$nodeEncoderMapping[node.type.name];
    try {
        if (encoder) return encoder(node, {
            context: context
        });
        return (0, $1Nefo.unknown)(node);
    } catch (err) {
        return (0, $1Nefo.unknown)(node);
    }
}

});
parcelRegister("03QYI", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $f393e710d4117486$export$67dc04e652a298ca);

var $lxtC7 = parcelRequire("lxtC7");
const $f393e710d4117486$export$67dc04e652a298ca = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $lxtC7.encode)(n, context));
    });
    return `{quote}${result.join('\n\n')}{quote}`;
};

});

parcelRegister("6ises", function(module, exports) {

$parcel$export(module.exports, "bulletList", () => $92e38ddcaccbcaf0$export$a140c94e5ea26bee);

var $bxtEu = parcelRequire("bxtEu");
const $92e38ddcaccbcaf0$export$a140c94e5ea26bee = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $bxtEu.listItem)(item, '*', context));
    });
    return result.join('\n');
};

});
parcelRegister("bxtEu", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $b39a87ae4fdec39c$export$76c7e83ecc9cdf05);

var $lxtC7 = parcelRequire("lxtC7");

var $flJtr = parcelRequire("flJtr");

var $1Nefo = parcelRequire("1Nefo");

var $73kPn = parcelRequire("73kPn");

var $eTlm6 = parcelRequire("eTlm6");

var $6obXI = parcelRequire("6obXI");
const $b39a87ae4fdec39c$export$76c7e83ecc9cdf05 = (node, prefix, context)=>{
    const result = [];
    let contentBuffer = [];
    node.forEach((n)=>{
        switch(n.type.name){
            case 'paragraph':
                contentBuffer.push((0, $flJtr.paragraph)(n, {
                    context: context
                }));
                break;
            case 'bulletList':
            case 'orderedList':
                {
                    if (contentBuffer.length) {
                        result.push(`${prefix} ${contentBuffer.join('\n')}`);
                        contentBuffer = [];
                    }
                    const nestedList = (0, $lxtC7.encode)(n, context).split('\n').map((line)=>{
                        if ([
                            '#',
                            '*'
                        ].indexOf(line.substr(0, 1)) !== -1) return `${prefix}${line}`;
                        return line;
                    }).join('\n');
                    result.push(nestedList);
                    break;
                }
            case 'codeBlock':
                contentBuffer.push((0, $73kPn.codeBlock)(n));
                break;
            case 'mediaInline':
                contentBuffer.push((0, $6obXI.mediaInline)(n, {
                    context: context
                }));
                break;
            case 'mediaSingle':
                // mediaSingle and mediaGroup are holding the same conversion logic
                contentBuffer.push((0, $eTlm6.mediaGroup)(n, {
                    context: context
                }));
                break;
            default:
                contentBuffer.push((0, $1Nefo.unknown)(n));
        }
    });
    if (contentBuffer.length) result.push(`${prefix} ${contentBuffer.join('\n')}`);
    return result.join('\n');
};

});
parcelRegister("flJtr", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $3fb83d21e304518d$export$9c206ddddb32a9b);

var $bK2QZ = parcelRequire("bK2QZ");
const $3fb83d21e304518d$export$9c206ddddb32a9b = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $bK2QZ.inlines)(n, {
            context: context
        });
    });
    return result;
};

});
parcelRegister("bK2QZ", function(module, exports) {

$parcel$export(module.exports, "inlines", () => $d36b73d9ad63ab63$export$96c94bfc00b85760);

var $91ILy = parcelRequire("91ILy");

var $e34Iq = parcelRequire("e34Iq");

var $6obXI = parcelRequire("6obXI");

var $7GCbZ = parcelRequire("7GCbZ");

var $6ayzl = parcelRequire("6ayzl");

var $5IuwX = parcelRequire("5IuwX");

var $1HDja = parcelRequire("1HDja");

var $1Nefo = parcelRequire("1Nefo");

var $c08Yp = parcelRequire("c08Yp");
const $d36b73d9ad63ab63$var$inlinesEncoderMapping = {
    emoji: $91ILy.emoji,
    hardBreak: $e34Iq.hardBreak,
    mediaInline: $6obXI.mediaInline,
    mention: $7GCbZ.mention,
    text: $6ayzl.text,
    inlineCard: $5IuwX.inlineCard,
    status: $1HDja.status,
    date: $c08Yp.date
};
const $d36b73d9ad63ab63$export$96c94bfc00b85760 = (node, opts)=>{
    const encoder = $d36b73d9ad63ab63$var$inlinesEncoderMapping[node.type.name];
    if (encoder) return encoder(node, opts);
    return (0, $1Nefo.unknown)(node);
};

});
parcelRegister("91ILy", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $15d1256cf1644afa$export$a19185d1233fc4b2);

var $g5UJK = parcelRequire("g5UJK");

var $1Nefo = parcelRequire("1Nefo");
const $15d1256cf1644afa$export$a19185d1233fc4b2 = (node)=>{
    const value = (0, $g5UJK.mapping)[node.attrs.id];
    if (value) return value;
    if (node.attrs.shortName) return node.attrs.shortName;
    return (0, $1Nefo.unknown)(node);
};

});
parcelRegister("g5UJK", function(module, exports) {

$parcel$export(module.exports, "mapping", () => $c03ab45b5b0f3a2b$export$83e1f26587c4acd2);
const $c03ab45b5b0f3a2b$export$83e1f26587c4acd2 = {
    '1f600': "\uD83D\uDE00",
    '1f603': "\uD83D\uDE03",
    '1f604': "\uD83D\uDE04",
    '1f601': "\uD83D\uDE01",
    '1f606': "\uD83D\uDE06",
    '1f605': "\uD83D\uDE05",
    '1f602': "\uD83D\uDE02",
    '1f923': "\uD83E\uDD23",
    '263a': "\u263A\uFE0F",
    '1f60a': "\uD83D\uDE0A",
    '1f607': "\uD83D\uDE07",
    '1f642': "\uD83D\uDE42",
    '1f643': "\uD83D\uDE43",
    '1f609': "\uD83D\uDE09",
    '1f60c': "\uD83D\uDE0C",
    '1f60d': "\uD83D\uDE0D",
    '1f618': "\uD83D\uDE18",
    '1f617': "\uD83D\uDE17",
    '1f619': "\uD83D\uDE19",
    '1f61a': "\uD83D\uDE1A",
    '1f60b': "\uD83D\uDE0B",
    '1f61c': "\uD83D\uDE1C",
    '1f61d': "\uD83D\uDE1D",
    '1f61b': "\uD83D\uDE1B",
    '1f911': "\uD83E\uDD11",
    '1f917': "\uD83E\uDD17",
    '1f913': "\uD83E\uDD13",
    '1f60e': "\uD83D\uDE0E",
    '1f921': "\uD83E\uDD21",
    '1f920': "\uD83E\uDD20",
    '1f60f': "\uD83D\uDE0F",
    '1f612': "\uD83D\uDE12",
    '1f61e': "\uD83D\uDE1E",
    '1f614': "\uD83D\uDE14",
    '1f61f': "\uD83D\uDE1F",
    '1f615': "\uD83D\uDE15",
    '1f641': "\uD83D\uDE41",
    '2639': "\u2639\uFE0F",
    '1f623': "\uD83D\uDE23",
    '1f616': "\uD83D\uDE16",
    '1f62b': "\uD83D\uDE2B",
    '1f629': "\uD83D\uDE29",
    '1f624': "\uD83D\uDE24",
    '1f620': "\uD83D\uDE20",
    '1f621': "\uD83D\uDE21",
    '1f636': "\uD83D\uDE36",
    '1f610': "\uD83D\uDE10",
    '1f611': "\uD83D\uDE11",
    '1f62f': "\uD83D\uDE2F",
    '1f626': "\uD83D\uDE26",
    '1f627': "\uD83D\uDE27",
    '1f62e': "\uD83D\uDE2E",
    '1f632': "\uD83D\uDE32",
    '1f635': "\uD83D\uDE35",
    '1f633': "\uD83D\uDE33",
    '1f631': "\uD83D\uDE31",
    '1f628': "\uD83D\uDE28",
    '1f630': "\uD83D\uDE30",
    '1f622': "\uD83D\uDE22",
    '1f625': "\uD83D\uDE25",
    '1f924': "\uD83E\uDD24",
    '1f62d': "\uD83D\uDE2D",
    '1f613': "\uD83D\uDE13",
    '1f62a': "\uD83D\uDE2A",
    '1f634': "\uD83D\uDE34",
    '1f644': "\uD83D\uDE44",
    '1f914': "\uD83E\uDD14",
    '1f925': "\uD83E\uDD25",
    '1f62c': "\uD83D\uDE2C",
    '1f910': "\uD83E\uDD10",
    '1f922': "\uD83E\uDD22",
    '1f927': "\uD83E\uDD27",
    '1f637': "\uD83D\uDE37",
    '1f912': "\uD83E\uDD12",
    '1f915': "\uD83E\uDD15",
    '1f608': "\uD83D\uDE08",
    '1f47f': "\uD83D\uDC7F",
    '1f479': "\uD83D\uDC79",
    '1f47a': "\uD83D\uDC7A",
    '1f4a9': "\uD83D\uDCA9",
    '1f47b': "\uD83D\uDC7B",
    '1f480': "\uD83D\uDC80",
    '2620': "\u2620\uFE0F",
    '1f47d': "\uD83D\uDC7D",
    '1f47e': "\uD83D\uDC7E",
    '1f916': "\uD83E\uDD16",
    '1f383': "\uD83C\uDF83",
    '1f63a': "\uD83D\uDE3A",
    '1f638': "\uD83D\uDE38",
    '1f639': "\uD83D\uDE39",
    '1f63b': "\uD83D\uDE3B",
    '1f63c': "\uD83D\uDE3C",
    '1f63d': "\uD83D\uDE3D",
    '1f640': "\uD83D\uDE40",
    '1f63f': "\uD83D\uDE3F",
    '1f63e': "\uD83D\uDE3E",
    '1f450': "\uD83D\uDC50",
    '1f64c': "\uD83D\uDE4C",
    '1f44f': "\uD83D\uDC4F",
    '1f64f': "\uD83D\uDE4F",
    '1f91d': "\uD83E\uDD1D",
    '1f44d': "\uD83D\uDC4D",
    '1f44e': "\uD83D\uDC4E",
    '1f44a': "\uD83D\uDC4A",
    '270a': "\u270A",
    '1f91b': "\uD83E\uDD1B",
    '1f91c': "\uD83E\uDD1C",
    '1f91e': "\uD83E\uDD1E",
    '270c': "\u270C\uFE0F",
    '1f918': "\uD83E\uDD18",
    '1f44c': "\uD83D\uDC4C",
    '1f448': "\uD83D\uDC48",
    '1f449': "\uD83D\uDC49",
    '1f446': "\uD83D\uDC46",
    '1f447': "\uD83D\uDC47",
    '261d': "\u261D\uFE0F",
    '270b': "\u270B",
    '1f91a': "\uD83E\uDD1A",
    '1f590': "\uD83D\uDD90\uFE0F",
    '1f596': "\uD83D\uDD96",
    '1f44b': "\uD83D\uDC4B",
    '1f919': "\uD83E\uDD19",
    '1f4aa': "\uD83D\uDCAA",
    '1f595': "\uD83D\uDD95",
    '270d': "\u270D\uFE0F",
    '1f933': "\uD83E\uDD33",
    '1f485': "\uD83D\uDC85",
    '1f48d': "\uD83D\uDC8D",
    '1f484': "\uD83D\uDC84",
    '1f48b': "\uD83D\uDC8B",
    '1f444': "\uD83D\uDC44",
    '1f445': "\uD83D\uDC45",
    '1f442': "\uD83D\uDC42",
    '1f443': "\uD83D\uDC43",
    '1f463': "\uD83D\uDC63",
    '1f441': "\uD83D\uDC41\uFE0F",
    '1f440': "\uD83D\uDC40",
    '1f5e3': "\uD83D\uDDE3\uFE0F",
    '1f464': "\uD83D\uDC64",
    '1f465': "\uD83D\uDC65",
    '1f476': "\uD83D\uDC76",
    '1f466': "\uD83D\uDC66",
    '1f467': "\uD83D\uDC67",
    '1f468': "\uD83D\uDC68",
    '1f469': "\uD83D\uDC69",
    '1f471-200d-2640-fe0f': "\uD83D\uDC71\u200D\u2640\uFE0F",
    '1f471': "\uD83D\uDC71",
    '1f471-200d-2642-fe0f': "\uD83D\uDC71\u200D\u2642\uFE0F",
    '1f474': "\uD83D\uDC74",
    '1f475': "\uD83D\uDC75",
    '1f472': "\uD83D\uDC72",
    '1f473-200d-2640-fe0f': "\uD83D\uDC73\u200D\u2640\uFE0F",
    '1f473': "\uD83D\uDC73",
    '1f473-200d-2642-fe0f': "\uD83D\uDC73\u200D\u2642\uFE0F",
    '1f46e-200d-2640-fe0f': "\uD83D\uDC6E\u200D\u2640\uFE0F",
    '1f46e': "\uD83D\uDC6E",
    '1f46e-200d-2642-fe0f': "\uD83D\uDC6E\u200D\u2642\uFE0F",
    '1f477-200d-2640-fe0f': "\uD83D\uDC77\u200D\u2640\uFE0F",
    '1f477': "\uD83D\uDC77",
    '1f477-200d-2642-fe0f': "\uD83D\uDC77\u200D\u2642\uFE0F",
    '1f482-200d-2640-fe0f': "\uD83D\uDC82\u200D\u2640\uFE0F",
    '1f482': "\uD83D\uDC82",
    '1f482-200d-2642-fe0f': "\uD83D\uDC82\u200D\u2642\uFE0F",
    '1f575-fe0f-200d-2640-fe0f': "\uD83D\uDD75\uFE0F\u200D\u2640\uFE0F",
    '1f575': "\uD83D\uDD75\uFE0F",
    '1f575-fe0f-200d-2642-fe0f': "\uD83D\uDD75\uFE0F\u200D\u2642\uFE0F",
    '1f469-200d-2695-fe0f': "\uD83D\uDC69\u200D\u2695\uFE0F",
    '1f468-200d-2695-fe0f': "\uD83D\uDC68\u200D\u2695\uFE0F",
    '1f469-200d-1f33e': "\uD83D\uDC69\u200D\uD83C\uDF3E",
    '1f468-200d-1f33e': "\uD83D\uDC68\u200D\uD83C\uDF3E",
    '1f469-200d-1f373': "\uD83D\uDC69\u200D\uD83C\uDF73",
    '1f468-200d-1f373': "\uD83D\uDC68\u200D\uD83C\uDF73",
    '1f469-200d-1f393': "\uD83D\uDC69\u200D\uD83C\uDF93",
    '1f468-200d-1f393': "\uD83D\uDC68\u200D\uD83C\uDF93",
    '1f469-200d-1f3a4': "\uD83D\uDC69\u200D\uD83C\uDFA4",
    '1f468-200d-1f3a4': "\uD83D\uDC68\u200D\uD83C\uDFA4",
    '1f469-200d-1f3eb': "\uD83D\uDC69\u200D\uD83C\uDFEB",
    '1f468-200d-1f3eb': "\uD83D\uDC68\u200D\uD83C\uDFEB",
    '1f469-200d-1f3ed': "\uD83D\uDC69\u200D\uD83C\uDFED",
    '1f468-200d-1f3ed': "\uD83D\uDC68\u200D\uD83C\uDFED",
    '1f469-200d-1f4bb': "\uD83D\uDC69\u200D\uD83D\uDCBB",
    '1f468-200d-1f4bb': "\uD83D\uDC68\u200D\uD83D\uDCBB",
    '1f469-200d-1f4bc': "\uD83D\uDC69\u200D\uD83D\uDCBC",
    '1f468-200d-1f4bc': "\uD83D\uDC68\u200D\uD83D\uDCBC",
    '1f469-200d-1f527': "\uD83D\uDC69\u200D\uD83D\uDD27",
    '1f468-200d-1f527': "\uD83D\uDC68\u200D\uD83D\uDD27",
    '1f469-200d-1f52c': "\uD83D\uDC69\u200D\uD83D\uDD2C",
    '1f468-200d-1f52c': "\uD83D\uDC68\u200D\uD83D\uDD2C",
    '1f469-200d-1f3a8': "\uD83D\uDC69\u200D\uD83C\uDFA8",
    '1f468-200d-1f3a8': "\uD83D\uDC68\u200D\uD83C\uDFA8",
    '1f469-200d-1f692': "\uD83D\uDC69\u200D\uD83D\uDE92",
    '1f468-200d-1f692': "\uD83D\uDC68\u200D\uD83D\uDE92",
    '1f469-200d-2708-fe0f': "\uD83D\uDC69\u200D\u2708\uFE0F",
    '1f468-200d-2708-fe0f': "\uD83D\uDC68\u200D\u2708\uFE0F",
    '1f469-200d-1f680': "\uD83D\uDC69\u200D\uD83D\uDE80",
    '1f468-200d-1f680': "\uD83D\uDC68\u200D\uD83D\uDE80",
    '1f469-200d-2696-fe0f': "\uD83D\uDC69\u200D\u2696\uFE0F",
    '1f468-200d-2696-fe0f': "\uD83D\uDC68\u200D\u2696\uFE0F",
    '1f936': "\uD83E\uDD36",
    '1f385': "\uD83C\uDF85",
    '1f478': "\uD83D\uDC78",
    '1f934': "\uD83E\uDD34",
    '1f470': "\uD83D\uDC70",
    '1f935': "\uD83E\uDD35",
    '1f47c': "\uD83D\uDC7C",
    '1f930': "\uD83E\uDD30",
    '1f647-200d-2640-fe0f': "\uD83D\uDE47\u200D\u2640\uFE0F",
    '1f647': "\uD83D\uDE47",
    '1f647-200d-2642-fe0f': "\uD83D\uDE47\u200D\u2642\uFE0F",
    '1f481': "\uD83D\uDC81",
    '1f481-200d-2642-fe0f': "\uD83D\uDC81\u200D\u2642\uFE0F",
    '1f481-200d-2640-fe0f': "\uD83D\uDC81\u200D\u2640\uFE0F",
    '1f645': "\uD83D\uDE45",
    '1f645-200d-2642-fe0f': "\uD83D\uDE45\u200D\u2642\uFE0F",
    '1f645-200d-2640-fe0f': "\uD83D\uDE45\u200D\u2640\uFE0F",
    '1f646': "\uD83D\uDE46",
    '1f646-200d-2642-fe0f': "\uD83D\uDE46\u200D\u2642\uFE0F",
    '1f646-200d-2640-fe0f': "\uD83D\uDE46\u200D\u2640\uFE0F",
    '1f64b': "\uD83D\uDE4B",
    '1f64b-200d-2642-fe0f': "\uD83D\uDE4B\u200D\u2642\uFE0F",
    '1f64b-200d-2640-fe0f': "\uD83D\uDE4B\u200D\u2640\uFE0F",
    '1f926-200d-2640-fe0f': "\uD83E\uDD26\u200D\u2640\uFE0F",
    '1f926-200d-2642-fe0f': "\uD83E\uDD26\u200D\u2642\uFE0F",
    '1f926': "\uD83E\uDD26",
    '1f937-200d-2640-fe0f': "\uD83E\uDD37\u200D\u2640\uFE0F",
    '1f937-200d-2642-fe0f': "\uD83E\uDD37\u200D\u2642\uFE0F",
    '1f937': "\uD83E\uDD37",
    '1f64e': "\uD83D\uDE4E",
    '1f64e-200d-2642-fe0f': "\uD83D\uDE4E\u200D\u2642\uFE0F",
    '1f64e-200d-2640-fe0f': "\uD83D\uDE4E\u200D\u2640\uFE0F",
    '1f64d': "\uD83D\uDE4D",
    '1f64d-200d-2642-fe0f': "\uD83D\uDE4D\u200D\u2642\uFE0F",
    '1f64d-200d-2640-fe0f': "\uD83D\uDE4D\u200D\u2640\uFE0F",
    '1f487': "\uD83D\uDC87",
    '1f487-200d-2642-fe0f': "\uD83D\uDC87\u200D\u2642\uFE0F",
    '1f487-200d-2640-fe0f': "\uD83D\uDC87\u200D\u2640\uFE0F",
    '1f486': "\uD83D\uDC86",
    '1f486-200d-2642-fe0f': "\uD83D\uDC86\u200D\u2642\uFE0F",
    '1f486-200d-2640-fe0f': "\uD83D\uDC86\u200D\u2640\uFE0F",
    '1f574': "\uD83D\uDD74\uFE0F",
    '1f483': "\uD83D\uDC83",
    '1f57a': "\uD83D\uDD7A",
    '1f46f': "\uD83D\uDC6F",
    '1f46f-200d-2642-fe0f': "\uD83D\uDC6F\u200D\u2642\uFE0F",
    '1f46f-200d-2640-fe0f': "\uD83D\uDC6F\u200D\u2640\uFE0F",
    '1f6b6-200d-2640-fe0f': "\uD83D\uDEB6\u200D\u2640\uFE0F",
    '1f6b6': "\uD83D\uDEB6",
    '1f6b6-200d-2642-fe0f': "\uD83D\uDEB6\u200D\u2642\uFE0F",
    '1f3c3-200d-2640-fe0f': "\uD83C\uDFC3\u200D\u2640\uFE0F",
    '1f3c3': "\uD83C\uDFC3",
    '1f3c3-200d-2642-fe0f': "\uD83C\uDFC3\u200D\u2642\uFE0F",
    '1f46b': "\uD83D\uDC6B",
    '1f46d': "\uD83D\uDC6D",
    '1f46c': "\uD83D\uDC6C",
    '1f491': "\uD83D\uDC91",
    '1f469-200d-2764-fe0f-200d-1f469': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC69",
    '1f468-200d-2764-fe0f-200d-1f468': "\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC68",
    '1f48f': "\uD83D\uDC8F",
    '1f469-200d-2764-fe0f-200d-1f48b-200d-1f469': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69",
    '1f468-200d-2764-fe0f-200d-1f48b-200d-1f468': "\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68",
    '1f46a': "\uD83D\uDC6A",
    '1f468-200d-1f469-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f468-200d-1f469-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f469-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f469-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f469-200d-1f469-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f469-200d-1f469-200d-1f467-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f466-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f467-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f468-200d-1f468-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67",
    '1f468-200d-1f468-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f469-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f469-200d-1f467-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f469-200d-1f466-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f469-200d-1f467-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f468-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC66",
    '1f468-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC67",
    '1f468-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f45a': "\uD83D\uDC5A",
    '1f455': "\uD83D\uDC55",
    '1f456': "\uD83D\uDC56",
    '1f454': "\uD83D\uDC54",
    '1f457': "\uD83D\uDC57",
    '1f459': "\uD83D\uDC59",
    '1f458': "\uD83D\uDC58",
    '1f460': "\uD83D\uDC60",
    '1f461': "\uD83D\uDC61",
    '1f462': "\uD83D\uDC62",
    '1f45e': "\uD83D\uDC5E",
    '1f45f': "\uD83D\uDC5F",
    '1f452': "\uD83D\uDC52",
    '1f3a9': "\uD83C\uDFA9",
    '1f393': "\uD83C\uDF93",
    '1f451': "\uD83D\uDC51",
    '26d1': "\u26D1\uFE0F",
    '1f392': "\uD83C\uDF92",
    '1f45d': "\uD83D\uDC5D",
    '1f45b': "\uD83D\uDC5B",
    '1f45c': "\uD83D\uDC5C",
    '1f4bc': "\uD83D\uDCBC",
    '1f453': "\uD83D\uDC53",
    '1f576': "\uD83D\uDD76\uFE0F",
    '1f302': "\uD83C\uDF02",
    '2602': "\u2602\uFE0F",
    '1f436': "\uD83D\uDC36",
    '1f431': "\uD83D\uDC31",
    '1f42d': "\uD83D\uDC2D",
    '1f439': "\uD83D\uDC39",
    '1f430': "\uD83D\uDC30",
    '1f98a': "\uD83E\uDD8A",
    '1f43b': "\uD83D\uDC3B",
    '1f43c': "\uD83D\uDC3C",
    '1f428': "\uD83D\uDC28",
    '1f42f': "\uD83D\uDC2F",
    '1f981': "\uD83E\uDD81",
    '1f42e': "\uD83D\uDC2E",
    '1f437': "\uD83D\uDC37",
    '1f43d': "\uD83D\uDC3D",
    '1f438': "\uD83D\uDC38",
    '1f435': "\uD83D\uDC35",
    '1f648': "\uD83D\uDE48",
    '1f649': "\uD83D\uDE49",
    '1f64a': "\uD83D\uDE4A",
    '1f412': "\uD83D\uDC12",
    '1f414': "\uD83D\uDC14",
    '1f427': "\uD83D\uDC27",
    '1f426': "\uD83D\uDC26",
    '1f424': "\uD83D\uDC24",
    '1f423': "\uD83D\uDC23",
    '1f425': "\uD83D\uDC25",
    '1f986': "\uD83E\uDD86",
    '1f985': "\uD83E\uDD85",
    '1f989': "\uD83E\uDD89",
    '1f987': "\uD83E\uDD87",
    '1f43a': "\uD83D\uDC3A",
    '1f417': "\uD83D\uDC17",
    '1f434': "\uD83D\uDC34",
    '1f984': "\uD83E\uDD84",
    '1f41d': "\uD83D\uDC1D",
    '1f41b': "\uD83D\uDC1B",
    '1f98b': "\uD83E\uDD8B",
    '1f40c': "\uD83D\uDC0C",
    '1f41a': "\uD83D\uDC1A",
    '1f41e': "\uD83D\uDC1E",
    '1f41c': "\uD83D\uDC1C",
    '1f577': "\uD83D\uDD77\uFE0F",
    '1f578': "\uD83D\uDD78\uFE0F",
    '1f422': "\uD83D\uDC22",
    '1f40d': "\uD83D\uDC0D",
    '1f98e': "\uD83E\uDD8E",
    '1f982': "\uD83E\uDD82",
    '1f980': "\uD83E\uDD80",
    '1f991': "\uD83E\uDD91",
    '1f419': "\uD83D\uDC19",
    '1f990': "\uD83E\uDD90",
    '1f420': "\uD83D\uDC20",
    '1f41f': "\uD83D\uDC1F",
    '1f421': "\uD83D\uDC21",
    '1f42c': "\uD83D\uDC2C",
    '1f988': "\uD83E\uDD88",
    '1f433': "\uD83D\uDC33",
    '1f40b': "\uD83D\uDC0B",
    '1f40a': "\uD83D\uDC0A",
    '1f406': "\uD83D\uDC06",
    '1f405': "\uD83D\uDC05",
    '1f403': "\uD83D\uDC03",
    '1f402': "\uD83D\uDC02",
    '1f404': "\uD83D\uDC04",
    '1f98c': "\uD83E\uDD8C",
    '1f42a': "\uD83D\uDC2A",
    '1f42b': "\uD83D\uDC2B",
    '1f418': "\uD83D\uDC18",
    '1f98f': "\uD83E\uDD8F",
    '1f98d': "\uD83E\uDD8D",
    '1f40e': "\uD83D\uDC0E",
    '1f416': "\uD83D\uDC16",
    '1f410': "\uD83D\uDC10",
    '1f40f': "\uD83D\uDC0F",
    '1f411': "\uD83D\uDC11",
    '1f415': "\uD83D\uDC15",
    '1f429': "\uD83D\uDC29",
    '1f408': "\uD83D\uDC08",
    '1f413': "\uD83D\uDC13",
    '1f983': "\uD83E\uDD83",
    '1f54a': "\uD83D\uDD4A\uFE0F",
    '1f407': "\uD83D\uDC07",
    '1f401': "\uD83D\uDC01",
    '1f400': "\uD83D\uDC00",
    '1f43f': "\uD83D\uDC3F\uFE0F",
    '1f43e': "\uD83D\uDC3E",
    '1f409': "\uD83D\uDC09",
    '1f432': "\uD83D\uDC32",
    '1f335': "\uD83C\uDF35",
    '1f384': "\uD83C\uDF84",
    '1f332': "\uD83C\uDF32",
    '1f333': "\uD83C\uDF33",
    '1f334': "\uD83C\uDF34",
    '1f331': "\uD83C\uDF31",
    '1f33f': "\uD83C\uDF3F",
    '2618': "\u2618\uFE0F",
    '1f340': "\uD83C\uDF40",
    '1f38d': "\uD83C\uDF8D",
    '1f38b': "\uD83C\uDF8B",
    '1f343': "\uD83C\uDF43",
    '1f342': "\uD83C\uDF42",
    '1f341': "\uD83C\uDF41",
    '1f344': "\uD83C\uDF44",
    '1f33e': "\uD83C\uDF3E",
    '1f490': "\uD83D\uDC90",
    '1f337': "\uD83C\uDF37",
    '1f339': "\uD83C\uDF39",
    '1f940': "\uD83E\uDD40",
    '1f33b': "\uD83C\uDF3B",
    '1f33c': "\uD83C\uDF3C",
    '1f338': "\uD83C\uDF38",
    '1f33a': "\uD83C\uDF3A",
    '1f30e': "\uD83C\uDF0E",
    '1f30d': "\uD83C\uDF0D",
    '1f30f': "\uD83C\uDF0F",
    '1f315': "\uD83C\uDF15",
    '1f316': "\uD83C\uDF16",
    '1f317': "\uD83C\uDF17",
    '1f318': "\uD83C\uDF18",
    '1f311': "\uD83C\uDF11",
    '1f312': "\uD83C\uDF12",
    '1f313': "\uD83C\uDF13",
    '1f314': "\uD83C\uDF14",
    '1f31a': "\uD83C\uDF1A",
    '1f31d': "\uD83C\uDF1D",
    '1f31e': "\uD83C\uDF1E",
    '1f31b': "\uD83C\uDF1B",
    '1f31c': "\uD83C\uDF1C",
    '1f319': "\uD83C\uDF19",
    '1f4ab': "\uD83D\uDCAB",
    '2b50': "\u2B50",
    '1f31f': "\uD83C\uDF1F",
    '2728': "\u2728",
    '26a1': "\u26A1",
    '1f525': "\uD83D\uDD25",
    '1f4a5': "\uD83D\uDCA5",
    '2604': "\u2604\uFE0F",
    '2600': "\u2600\uFE0F",
    '1f324': "\uD83C\uDF24\uFE0F",
    '26c5': "\u26C5",
    '1f325': "\uD83C\uDF25\uFE0F",
    '1f326': "\uD83C\uDF26\uFE0F",
    '1f308': "\uD83C\uDF08",
    '2601': "\u2601\uFE0F",
    '1f327': "\uD83C\uDF27\uFE0F",
    '26c8': "\u26C8\uFE0F",
    '1f329': "\uD83C\uDF29\uFE0F",
    '1f328': "\uD83C\uDF28\uFE0F",
    '2603': "\u2603\uFE0F",
    '26c4': "\u26C4",
    '2744': "\u2744\uFE0F",
    '1f32c': "\uD83C\uDF2C\uFE0F",
    '1f4a8': "\uD83D\uDCA8",
    '1f32a': "\uD83C\uDF2A\uFE0F",
    '1f32b': "\uD83C\uDF2B\uFE0F",
    '1f30a': "\uD83C\uDF0A",
    '1f4a7': "\uD83D\uDCA7",
    '1f4a6': "\uD83D\uDCA6",
    '2614': "\u2614",
    '1f992': "\uD83E\uDD92",
    '1f993': "\uD83E\uDD93",
    '1f994': "\uD83E\uDD94",
    '1f995': "\uD83E\uDD95",
    '1f996': "\uD83E\uDD96",
    '1f997': "\uD83E\uDD97",
    '1f34f': "\uD83C\uDF4F",
    '1f34e': "\uD83C\uDF4E",
    '1f350': "\uD83C\uDF50",
    '1f34a': "\uD83C\uDF4A",
    '1f34b': "\uD83C\uDF4B",
    '1f34c': "\uD83C\uDF4C",
    '1f349': "\uD83C\uDF49",
    '1f347': "\uD83C\uDF47",
    '1f353': "\uD83C\uDF53",
    '1f348': "\uD83C\uDF48",
    '1f352': "\uD83C\uDF52",
    '1f351': "\uD83C\uDF51",
    '1f34d': "\uD83C\uDF4D",
    '1f95d': "\uD83E\uDD5D",
    '1f951': "\uD83E\uDD51",
    '1f345': "\uD83C\uDF45",
    '1f346': "\uD83C\uDF46",
    '1f952': "\uD83E\uDD52",
    '1f955': "\uD83E\uDD55",
    '1f33d': "\uD83C\uDF3D",
    '1f336': "\uD83C\uDF36\uFE0F",
    '1f954': "\uD83E\uDD54",
    '1f360': "\uD83C\uDF60",
    '1f330': "\uD83C\uDF30",
    '1f95c': "\uD83E\uDD5C",
    '1f36f': "\uD83C\uDF6F",
    '1f950': "\uD83E\uDD50",
    '1f35e': "\uD83C\uDF5E",
    '1f956': "\uD83E\uDD56",
    '1f9c0': "\uD83E\uDDC0",
    '1f95a': "\uD83E\uDD5A",
    '1f373': "\uD83C\uDF73",
    '1f953': "\uD83E\uDD53",
    '1f95e': "\uD83E\uDD5E",
    '1f364': "\uD83C\uDF64",
    '1f357': "\uD83C\uDF57",
    '1f356': "\uD83C\uDF56",
    '1f355': "\uD83C\uDF55",
    '1f32d': "\uD83C\uDF2D",
    '1f354': "\uD83C\uDF54",
    '1f35f': "\uD83C\uDF5F",
    '1f959': "\uD83E\uDD59",
    '1f32e': "\uD83C\uDF2E",
    '1f32f': "\uD83C\uDF2F",
    '1f957': "\uD83E\uDD57",
    '1f958': "\uD83E\uDD58",
    '1f35d': "\uD83C\uDF5D",
    '1f35c': "\uD83C\uDF5C",
    '1f372': "\uD83C\uDF72",
    '1f365': "\uD83C\uDF65",
    '1f363': "\uD83C\uDF63",
    '1f371': "\uD83C\uDF71",
    '1f35b': "\uD83C\uDF5B",
    '1f359': "\uD83C\uDF59",
    '1f35a': "\uD83C\uDF5A",
    '1f358': "\uD83C\uDF58",
    '1f362': "\uD83C\uDF62",
    '1f361': "\uD83C\uDF61",
    '1f367': "\uD83C\uDF67",
    '1f368': "\uD83C\uDF68",
    '1f366': "\uD83C\uDF66",
    '1f370': "\uD83C\uDF70",
    '1f382': "\uD83C\uDF82",
    '1f36e': "\uD83C\uDF6E",
    '1f36d': "\uD83C\uDF6D",
    '1f36c': "\uD83C\uDF6C",
    '1f36b': "\uD83C\uDF6B",
    '1f37f': "\uD83C\uDF7F",
    '1f369': "\uD83C\uDF69",
    '1f36a': "\uD83C\uDF6A",
    '1f95b': "\uD83E\uDD5B",
    '1f37c': "\uD83C\uDF7C",
    '2615': "\u2615",
    '1f375': "\uD83C\uDF75",
    '1f376': "\uD83C\uDF76",
    '1f37a': "\uD83C\uDF7A",
    '1f37b': "\uD83C\uDF7B",
    '1f942': "\uD83E\uDD42",
    '1f377': "\uD83C\uDF77",
    '1f943': "\uD83E\uDD43",
    '1f378': "\uD83C\uDF78",
    '1f379': "\uD83C\uDF79",
    '1f37e': "\uD83C\uDF7E",
    '1f944': "\uD83E\uDD44",
    '1f374': "\uD83C\uDF74",
    '1f37d': "\uD83C\uDF7D\uFE0F",
    '1f95f': "\uD83E\uDD5F",
    '1f960': "\uD83E\uDD60",
    '1f961': "\uD83E\uDD61",
    '1f962': "\uD83E\uDD62",
    '1f963': "\uD83E\uDD63",
    '1f964': "\uD83E\uDD64",
    '1f965': "\uD83E\uDD65",
    '1f966': "\uD83E\uDD66",
    '1f967': "\uD83E\uDD67",
    '1f968': "\uD83E\uDD68",
    '1f969': "\uD83E\uDD69",
    '1f96a': "\uD83E\uDD6A",
    '1f96b': "\uD83E\uDD6B",
    '26bd': "\u26BD",
    '1f3c0': "\uD83C\uDFC0",
    '1f3c8': "\uD83C\uDFC8",
    '26be': "\u26BE",
    '1f3be': "\uD83C\uDFBE",
    '1f3d0': "\uD83C\uDFD0",
    '1f3c9': "\uD83C\uDFC9",
    '1f3b1': "\uD83C\uDFB1",
    '1f3d3': "\uD83C\uDFD3",
    '1f3f8': "\uD83C\uDFF8",
    '1f945': "\uD83E\uDD45",
    '1f3d2': "\uD83C\uDFD2",
    '1f3d1': "\uD83C\uDFD1",
    '1f3cf': "\uD83C\uDFCF",
    '26f3': "\u26F3",
    '1f3f9': "\uD83C\uDFF9",
    '1f3a3': "\uD83C\uDFA3",
    '1f94a': "\uD83E\uDD4A",
    '1f94b': "\uD83E\uDD4B",
    '26f8': "\u26F8\uFE0F",
    '1f3bf': "\uD83C\uDFBF",
    '26f7': "\u26F7\uFE0F",
    '1f3c2': "\uD83C\uDFC2",
    '1f3cb-fe0f-200d-2640-fe0f': "\uD83C\uDFCB\uFE0F\u200D\u2640\uFE0F",
    '1f3cb': "\uD83C\uDFCB\uFE0F",
    '1f3cb-fe0f-200d-2642-fe0f': "\uD83C\uDFCB\uFE0F\u200D\u2642\uFE0F",
    '1f93a': "\uD83E\uDD3A",
    '1f93c-200d-2640-fe0f': "\uD83E\uDD3C\u200D\u2640\uFE0F",
    '1f93c-200d-2642-fe0f': "\uD83E\uDD3C\u200D\u2642\uFE0F",
    '1f93c': "\uD83E\uDD3C",
    '1f938-200d-2640-fe0f': "\uD83E\uDD38\u200D\u2640\uFE0F",
    '1f938-200d-2642-fe0f': "\uD83E\uDD38\u200D\u2642\uFE0F",
    '1f938': "\uD83E\uDD38",
    '26f9-fe0f-200d-2640-fe0f': "\u26F9\uFE0F\u200D\u2640\uFE0F",
    '26f9': "\u26F9\uFE0F",
    '26f9-fe0f-200d-2642-fe0f': "\u26F9\uFE0F\u200D\u2642\uFE0F",
    '1f93e-200d-2640-fe0f': "\uD83E\uDD3E\u200D\u2640\uFE0F",
    '1f93e-200d-2642-fe0f': "\uD83E\uDD3E\u200D\u2642\uFE0F",
    '1f93e': "\uD83E\uDD3E",
    '1f3cc-fe0f-200d-2640-fe0f': "\uD83C\uDFCC\uFE0F\u200D\u2640\uFE0F",
    '1f3cc': "\uD83C\uDFCC\uFE0F",
    '1f3cc-fe0f-200d-2642-fe0f': "\uD83C\uDFCC\uFE0F\u200D\u2642\uFE0F",
    '1f3c4-200d-2640-fe0f': "\uD83C\uDFC4\u200D\u2640\uFE0F",
    '1f3c4': "\uD83C\uDFC4",
    '1f3c4-200d-2642-fe0f': "\uD83C\uDFC4\u200D\u2642\uFE0F",
    '1f3ca-200d-2640-fe0f': "\uD83C\uDFCA\u200D\u2640\uFE0F",
    '1f3ca': "\uD83C\uDFCA",
    '1f3ca-200d-2642-fe0f': "\uD83C\uDFCA\u200D\u2642\uFE0F",
    '1f93d-200d-2640-fe0f': "\uD83E\uDD3D\u200D\u2640\uFE0F",
    '1f93d-200d-2642-fe0f': "\uD83E\uDD3D\u200D\u2642\uFE0F",
    '1f93d': "\uD83E\uDD3D",
    '1f6a3-200d-2640-fe0f': "\uD83D\uDEA3\u200D\u2640\uFE0F",
    '1f6a3': "\uD83D\uDEA3",
    '1f6a3-200d-2642-fe0f': "\uD83D\uDEA3\u200D\u2642\uFE0F",
    '1f3c7': "\uD83C\uDFC7",
    '1f6b4-200d-2640-fe0f': "\uD83D\uDEB4\u200D\u2640\uFE0F",
    '1f6b4': "\uD83D\uDEB4",
    '1f6b4-200d-2642-fe0f': "\uD83D\uDEB4\u200D\u2642\uFE0F",
    '1f6b5-200d-2640-fe0f': "\uD83D\uDEB5\u200D\u2640\uFE0F",
    '1f6b5': "\uD83D\uDEB5",
    '1f6b5-200d-2642-fe0f': "\uD83D\uDEB5\u200D\u2642\uFE0F",
    '1f3bd': "\uD83C\uDFBD",
    '1f3c5': "\uD83C\uDFC5",
    '1f396': "\uD83C\uDF96\uFE0F",
    '1f947': "\uD83E\uDD47",
    '1f948': "\uD83E\uDD48",
    '1f949': "\uD83E\uDD49",
    '1f3c6': "\uD83C\uDFC6",
    '1f3f5': "\uD83C\uDFF5\uFE0F",
    '1f397': "\uD83C\uDF97\uFE0F",
    '1f3ab': "\uD83C\uDFAB",
    '1f39f': "\uD83C\uDF9F\uFE0F",
    '1f3aa': "\uD83C\uDFAA",
    '1f939-200d-2640-fe0f': "\uD83E\uDD39\u200D\u2640\uFE0F",
    '1f939-200d-2642-fe0f': "\uD83E\uDD39\u200D\u2642\uFE0F",
    '1f939': "\uD83E\uDD39",
    '1f3ad': "\uD83C\uDFAD",
    '1f3a8': "\uD83C\uDFA8",
    '1f3ac': "\uD83C\uDFAC",
    '1f3a4': "\uD83C\uDFA4",
    '1f3a7': "\uD83C\uDFA7",
    '1f3bc': "\uD83C\uDFBC",
    '1f3b9': "\uD83C\uDFB9",
    '1f941': "\uD83E\uDD41",
    '1f3b7': "\uD83C\uDFB7",
    '1f3ba': "\uD83C\uDFBA",
    '1f3b8': "\uD83C\uDFB8",
    '1f3bb': "\uD83C\uDFBB",
    '1f3b2': "\uD83C\uDFB2",
    '1f3af': "\uD83C\uDFAF",
    '1f3b3': "\uD83C\uDFB3",
    '1f3ae': "\uD83C\uDFAE",
    '1f3b0': "\uD83C\uDFB0",
    '1f6f7': "\uD83D\uDEF7",
    '1f931': "\uD83E\uDD31",
    '1f94c': "\uD83E\uDD4C",
    '1f9d6': "\uD83E\uDDD6",
    '1f9d7': "\uD83E\uDDD7",
    '1f9d8': "\uD83E\uDDD8",
    '1f9d6-200d-2640-fe0f': "\uD83E\uDDD6\u200D\u2640\uFE0F",
    '1f9d6-200d-2642-fe0f': "\uD83E\uDDD6\u200D\u2642\uFE0F",
    '1f9d7-200d-2640-fe0f': "\uD83E\uDDD7\u200D\u2640\uFE0F",
    '1f9d7-200d-2642-fe0f': "\uD83E\uDDD7\u200D\u2642\uFE0F",
    '1f9d8-200d-2640-fe0f': "\uD83E\uDDD8\u200D\u2640\uFE0F",
    '1f9d8-200d-2642-fe0f': "\uD83E\uDDD8\u200D\u2642\uFE0F",
    '1f697': "\uD83D\uDE97",
    '1f695': "\uD83D\uDE95",
    '1f699': "\uD83D\uDE99",
    '1f68c': "\uD83D\uDE8C",
    '1f68e': "\uD83D\uDE8E",
    '1f3ce': "\uD83C\uDFCE\uFE0F",
    '1f693': "\uD83D\uDE93",
    '1f691': "\uD83D\uDE91",
    '1f692': "\uD83D\uDE92",
    '1f690': "\uD83D\uDE90",
    '1f69a': "\uD83D\uDE9A",
    '1f69b': "\uD83D\uDE9B",
    '1f69c': "\uD83D\uDE9C",
    '1f6f4': "\uD83D\uDEF4",
    '1f6b2': "\uD83D\uDEB2",
    '1f6f5': "\uD83D\uDEF5",
    '1f3cd': "\uD83C\uDFCD\uFE0F",
    '1f6a8': "\uD83D\uDEA8",
    '1f694': "\uD83D\uDE94",
    '1f68d': "\uD83D\uDE8D",
    '1f698': "\uD83D\uDE98",
    '1f696': "\uD83D\uDE96",
    '1f6a1': "\uD83D\uDEA1",
    '1f6a0': "\uD83D\uDEA0",
    '1f69f': "\uD83D\uDE9F",
    '1f683': "\uD83D\uDE83",
    '1f68b': "\uD83D\uDE8B",
    '1f69e': "\uD83D\uDE9E",
    '1f69d': "\uD83D\uDE9D",
    '1f684': "\uD83D\uDE84",
    '1f685': "\uD83D\uDE85",
    '1f688': "\uD83D\uDE88",
    '1f682': "\uD83D\uDE82",
    '1f686': "\uD83D\uDE86",
    '1f687': "\uD83D\uDE87",
    '1f68a': "\uD83D\uDE8A",
    '1f689': "\uD83D\uDE89",
    '1f681': "\uD83D\uDE81",
    '1f6e9': "\uD83D\uDEE9\uFE0F",
    '2708': "\u2708\uFE0F",
    '1f6eb': "\uD83D\uDEEB",
    '1f6ec': "\uD83D\uDEEC",
    '1f680': "\uD83D\uDE80",
    '1f6f0': "\uD83D\uDEF0\uFE0F",
    '1f4ba': "\uD83D\uDCBA",
    '1f6f6': "\uD83D\uDEF6",
    '26f5': "\u26F5",
    '1f6e5': "\uD83D\uDEE5\uFE0F",
    '1f6a4': "\uD83D\uDEA4",
    '1f6f3': "\uD83D\uDEF3\uFE0F",
    '26f4': "\u26F4\uFE0F",
    '1f6a2': "\uD83D\uDEA2",
    '2693': "\u2693",
    '1f6a7': "\uD83D\uDEA7",
    '26fd': "\u26FD",
    '1f68f': "\uD83D\uDE8F",
    '1f6a6': "\uD83D\uDEA6",
    '1f6a5': "\uD83D\uDEA5",
    '1f5fa': "\uD83D\uDDFA\uFE0F",
    '1f5ff': "\uD83D\uDDFF",
    '1f5fd': "\uD83D\uDDFD",
    '26f2': "\u26F2",
    '1f5fc': "\uD83D\uDDFC",
    '1f3f0': "\uD83C\uDFF0",
    '1f3ef': "\uD83C\uDFEF",
    '1f3df': "\uD83C\uDFDF\uFE0F",
    '1f3a1': "\uD83C\uDFA1",
    '1f3a2': "\uD83C\uDFA2",
    '1f3a0': "\uD83C\uDFA0",
    '26f1': "\u26F1\uFE0F",
    '1f3d6': "\uD83C\uDFD6\uFE0F",
    '1f3dd': "\uD83C\uDFDD\uFE0F",
    '26f0': "\u26F0\uFE0F",
    '1f3d4': "\uD83C\uDFD4\uFE0F",
    '1f5fb': "\uD83D\uDDFB",
    '1f30b': "\uD83C\uDF0B",
    '1f3dc': "\uD83C\uDFDC\uFE0F",
    '1f3d5': "\uD83C\uDFD5\uFE0F",
    '26fa': "\u26FA",
    '1f6e4': "\uD83D\uDEE4\uFE0F",
    '1f6e3': "\uD83D\uDEE3\uFE0F",
    '1f3d7': "\uD83C\uDFD7\uFE0F",
    '1f3ed': "\uD83C\uDFED",
    '1f3e0': "\uD83C\uDFE0",
    '1f3e1': "\uD83C\uDFE1",
    '1f3d8': "\uD83C\uDFD8\uFE0F",
    '1f3da': "\uD83C\uDFDA\uFE0F",
    '1f3e2': "\uD83C\uDFE2",
    '1f3ec': "\uD83C\uDFEC",
    '1f3e3': "\uD83C\uDFE3",
    '1f3e4': "\uD83C\uDFE4",
    '1f3e5': "\uD83C\uDFE5",
    '1f3e6': "\uD83C\uDFE6",
    '1f3e8': "\uD83C\uDFE8",
    '1f3ea': "\uD83C\uDFEA",
    '1f3eb': "\uD83C\uDFEB",
    '1f3e9': "\uD83C\uDFE9",
    '1f492': "\uD83D\uDC92",
    '1f3db': "\uD83C\uDFDB\uFE0F",
    '26ea': "\u26EA",
    '1f54c': "\uD83D\uDD4C",
    '1f54d': "\uD83D\uDD4D",
    '1f54b': "\uD83D\uDD4B",
    '26e9': "\u26E9\uFE0F",
    '1f5fe': "\uD83D\uDDFE",
    '1f391': "\uD83C\uDF91",
    '1f3de': "\uD83C\uDFDE\uFE0F",
    '1f305': "\uD83C\uDF05",
    '1f304': "\uD83C\uDF04",
    '1f320': "\uD83C\uDF20",
    '1f387': "\uD83C\uDF87",
    '1f386': "\uD83C\uDF86",
    '1f307': "\uD83C\uDF07",
    '1f306': "\uD83C\uDF06",
    '1f3d9': "\uD83C\uDFD9\uFE0F",
    '1f303': "\uD83C\uDF03",
    '1f30c': "\uD83C\uDF0C",
    '1f309': "\uD83C\uDF09",
    '1f301': "\uD83C\uDF01",
    '1f6f8': "\uD83D\uDEF8",
    '231a': "\u231A",
    '1f4f1': "\uD83D\uDCF1",
    '1f4f2': "\uD83D\uDCF2",
    '1f4bb': "\uD83D\uDCBB",
    '2328': "\u2328\uFE0F",
    '1f5a5': "\uD83D\uDDA5\uFE0F",
    '1f5a8': "\uD83D\uDDA8\uFE0F",
    '1f5b1': "\uD83D\uDDB1\uFE0F",
    '1f5b2': "\uD83D\uDDB2\uFE0F",
    '1f579': "\uD83D\uDD79\uFE0F",
    '1f5dc': "\uD83D\uDDDC\uFE0F",
    '1f4bd': "\uD83D\uDCBD",
    '1f4be': "\uD83D\uDCBE",
    '1f4bf': "\uD83D\uDCBF",
    '1f4c0': "\uD83D\uDCC0",
    '1f4fc': "\uD83D\uDCFC",
    '1f4f7': "\uD83D\uDCF7",
    '1f4f8': "\uD83D\uDCF8",
    '1f4f9': "\uD83D\uDCF9",
    '1f3a5': "\uD83C\uDFA5",
    '1f4fd': "\uD83D\uDCFD\uFE0F",
    '1f39e': "\uD83C\uDF9E\uFE0F",
    '1f4de': "\uD83D\uDCDE",
    '260e': "\u260E\uFE0F",
    '1f4df': "\uD83D\uDCDF",
    '1f4e0': "\uD83D\uDCE0",
    '1f4fa': "\uD83D\uDCFA",
    '1f4fb': "\uD83D\uDCFB",
    '1f399': "\uD83C\uDF99\uFE0F",
    '1f39a': "\uD83C\uDF9A\uFE0F",
    '1f39b': "\uD83C\uDF9B\uFE0F",
    '23f1': "\u23F1\uFE0F",
    '23f2': "\u23F2\uFE0F",
    '23f0': "\u23F0",
    '1f570': "\uD83D\uDD70\uFE0F",
    '231b': "\u231B",
    '23f3': "\u23F3",
    '1f4e1': "\uD83D\uDCE1",
    '1f50b': "\uD83D\uDD0B",
    '1f50c': "\uD83D\uDD0C",
    '1f4a1': "\uD83D\uDCA1",
    '1f526': "\uD83D\uDD26",
    '1f56f': "\uD83D\uDD6F\uFE0F",
    '1f5d1': "\uD83D\uDDD1\uFE0F",
    '1f6e2': "\uD83D\uDEE2\uFE0F",
    '1f4b8': "\uD83D\uDCB8",
    '1f4b5': "\uD83D\uDCB5",
    '1f4b4': "\uD83D\uDCB4",
    '1f4b6': "\uD83D\uDCB6",
    '1f4b7': "\uD83D\uDCB7",
    '1f4b0': "\uD83D\uDCB0",
    '1f4b3': "\uD83D\uDCB3",
    '1f48e': "\uD83D\uDC8E",
    '2696': "\u2696\uFE0F",
    '1f527': "\uD83D\uDD27",
    '1f528': "\uD83D\uDD28",
    '2692': "\u2692\uFE0F",
    '1f6e0': "\uD83D\uDEE0\uFE0F",
    '26cf': "\u26CF\uFE0F",
    '1f529': "\uD83D\uDD29",
    '2699': "\u2699\uFE0F",
    '26d3': "\u26D3\uFE0F",
    '1f52b': "\uD83D\uDD2B",
    '1f4a3': "\uD83D\uDCA3",
    '1f52a': "\uD83D\uDD2A",
    '1f5e1': "\uD83D\uDDE1\uFE0F",
    '2694': "\u2694\uFE0F",
    '1f6e1': "\uD83D\uDEE1\uFE0F",
    '1f6ac': "\uD83D\uDEAC",
    '26b0': "\u26B0\uFE0F",
    '26b1': "\u26B1\uFE0F",
    '1f3fa': "\uD83C\uDFFA",
    '1f52e': "\uD83D\uDD2E",
    '1f4ff': "\uD83D\uDCFF",
    '1f488': "\uD83D\uDC88",
    '2697': "\u2697\uFE0F",
    '1f52d': "\uD83D\uDD2D",
    '1f52c': "\uD83D\uDD2C",
    '1f573': "\uD83D\uDD73\uFE0F",
    '1f48a': "\uD83D\uDC8A",
    '1f489': "\uD83D\uDC89",
    '1f321': "\uD83C\uDF21\uFE0F",
    '1f6bd': "\uD83D\uDEBD",
    '1f6b0': "\uD83D\uDEB0",
    '1f6bf': "\uD83D\uDEBF",
    '1f6c1': "\uD83D\uDEC1",
    '1f6c0': "\uD83D\uDEC0",
    '1f6ce': "\uD83D\uDECE\uFE0F",
    '1f511': "\uD83D\uDD11",
    '1f5dd': "\uD83D\uDDDD\uFE0F",
    '1f6aa': "\uD83D\uDEAA",
    '1f6cb': "\uD83D\uDECB\uFE0F",
    '1f6cf': "\uD83D\uDECF\uFE0F",
    '1f6cc': "\uD83D\uDECC",
    '1f5bc': "\uD83D\uDDBC\uFE0F",
    '1f6cd': "\uD83D\uDECD\uFE0F",
    '1f6d2': "\uD83D\uDED2",
    '1f381': "\uD83C\uDF81",
    '1f388': "\uD83C\uDF88",
    '1f38f': "\uD83C\uDF8F",
    '1f380': "\uD83C\uDF80",
    '1f38a': "\uD83C\uDF8A",
    '1f389': "\uD83C\uDF89",
    '1f38e': "\uD83C\uDF8E",
    '1f3ee': "\uD83C\uDFEE",
    '1f390': "\uD83C\uDF90",
    '2709': "\u2709\uFE0F",
    '1f4e9': "\uD83D\uDCE9",
    '1f4e8': "\uD83D\uDCE8",
    '1f4e7': "\uD83D\uDCE7",
    '1f48c': "\uD83D\uDC8C",
    '1f4e5': "\uD83D\uDCE5",
    '1f4e4': "\uD83D\uDCE4",
    '1f4e6': "\uD83D\uDCE6",
    '1f3f7': "\uD83C\uDFF7\uFE0F",
    '1f4ea': "\uD83D\uDCEA",
    '1f4eb': "\uD83D\uDCEB",
    '1f4ec': "\uD83D\uDCEC",
    '1f4ed': "\uD83D\uDCED",
    '1f4ee': "\uD83D\uDCEE",
    '1f4ef': "\uD83D\uDCEF",
    '1f4dc': "\uD83D\uDCDC",
    '1f4c3': "\uD83D\uDCC3",
    '1f4c4': "\uD83D\uDCC4",
    '1f4d1': "\uD83D\uDCD1",
    '1f4ca': "\uD83D\uDCCA",
    '1f4c8': "\uD83D\uDCC8",
    '1f4c9': "\uD83D\uDCC9",
    '1f5d2': "\uD83D\uDDD2\uFE0F",
    '1f5d3': "\uD83D\uDDD3\uFE0F",
    '1f4c6': "\uD83D\uDCC6",
    '1f4c5': "\uD83D\uDCC5",
    '1f4c7': "\uD83D\uDCC7",
    '1f5c3': "\uD83D\uDDC3\uFE0F",
    '1f5f3': "\uD83D\uDDF3\uFE0F",
    '1f5c4': "\uD83D\uDDC4\uFE0F",
    '1f4cb': "\uD83D\uDCCB",
    '1f4c1': "\uD83D\uDCC1",
    '1f4c2': "\uD83D\uDCC2",
    '1f5c2': "\uD83D\uDDC2\uFE0F",
    '1f5de': "\uD83D\uDDDE\uFE0F",
    '1f4f0': "\uD83D\uDCF0",
    '1f4d3': "\uD83D\uDCD3",
    '1f4d4': "\uD83D\uDCD4",
    '1f4d2': "\uD83D\uDCD2",
    '1f4d5': "\uD83D\uDCD5",
    '1f4d7': "\uD83D\uDCD7",
    '1f4d8': "\uD83D\uDCD8",
    '1f4d9': "\uD83D\uDCD9",
    '1f4da': "\uD83D\uDCDA",
    '1f4d6': "\uD83D\uDCD6",
    '1f516': "\uD83D\uDD16",
    '1f517': "\uD83D\uDD17",
    '1f4ce': "\uD83D\uDCCE",
    '1f587': "\uD83D\uDD87\uFE0F",
    '1f4d0': "\uD83D\uDCD0",
    '1f4cf': "\uD83D\uDCCF",
    '1f4cc': "\uD83D\uDCCC",
    '1f4cd': "\uD83D\uDCCD",
    '2702': "\u2702\uFE0F",
    '1f58a': "\uD83D\uDD8A\uFE0F",
    '1f58b': "\uD83D\uDD8B\uFE0F",
    '2712': "\u2712\uFE0F",
    '1f58c': "\uD83D\uDD8C\uFE0F",
    '1f58d': "\uD83D\uDD8D\uFE0F",
    '1f4dd': "\uD83D\uDCDD",
    '270f': "\u270F\uFE0F",
    '1f50d': "\uD83D\uDD0D",
    '1f50e': "\uD83D\uDD0E",
    '1f50f': "\uD83D\uDD0F",
    '1f510': "\uD83D\uDD10",
    '1f512': "\uD83D\uDD12",
    '1f513': "\uD83D\uDD13",
    '1f9e1': "\uD83E\uDDE1",
    '2764': "\u2764\uFE0F",
    '1f49b': "\uD83D\uDC9B",
    '1f49a': "\uD83D\uDC9A",
    '1f499': "\uD83D\uDC99",
    '1f49c': "\uD83D\uDC9C",
    '1f5a4': "\uD83D\uDDA4",
    '1f494': "\uD83D\uDC94",
    '2763': "\u2763\uFE0F",
    '1f495': "\uD83D\uDC95",
    '1f49e': "\uD83D\uDC9E",
    '1f493': "\uD83D\uDC93",
    '1f497': "\uD83D\uDC97",
    '1f496': "\uD83D\uDC96",
    '1f498': "\uD83D\uDC98",
    '1f49d': "\uD83D\uDC9D",
    '1f49f': "\uD83D\uDC9F",
    '262e': "\u262E\uFE0F",
    '271d': "\u271D\uFE0F",
    '262a': "\u262A\uFE0F",
    '1f549': "\uD83D\uDD49\uFE0F",
    '2638': "\u2638\uFE0F",
    '2721': "\u2721\uFE0F",
    '1f52f': "\uD83D\uDD2F",
    '1f54e': "\uD83D\uDD4E",
    '262f': "\u262F\uFE0F",
    '2626': "\u2626\uFE0F",
    '1f6d0': "\uD83D\uDED0",
    '26ce': "\u26CE",
    '2648': "\u2648",
    '2649': "\u2649",
    '264a': "\u264A",
    '264b': "\u264B",
    '264c': "\u264C",
    '264d': "\u264D",
    '264e': "\u264E",
    '264f': "\u264F",
    '2650': "\u2650",
    '2651': "\u2651",
    '2652': "\u2652",
    '2653': "\u2653",
    '1f194': "\uD83C\uDD94",
    '269b': "\u269B\uFE0F",
    '1f251': "\uD83C\uDE51",
    '2622': "\u2622\uFE0F",
    '2623': "\u2623\uFE0F",
    '1f4f4': "\uD83D\uDCF4",
    '1f4f3': "\uD83D\uDCF3",
    '1f236': "\uD83C\uDE36",
    '1f21a': "\uD83C\uDE1A",
    '1f238': "\uD83C\uDE38",
    '1f23a': "\uD83C\uDE3A",
    '1f237': "\uD83C\uDE37\uFE0F",
    '2734': "\u2734\uFE0F",
    '1f19a': "\uD83C\uDD9A",
    '1f4ae': "\uD83D\uDCAE",
    '1f250': "\uD83C\uDE50",
    '3299': "\u3299\uFE0F",
    '3297': "\u3297\uFE0F",
    '1f234': "\uD83C\uDE34",
    '1f235': "\uD83C\uDE35",
    '1f239': "\uD83C\uDE39",
    '1f232': "\uD83C\uDE32",
    '1f170': "\uD83C\uDD70\uFE0F",
    '1f171': "\uD83C\uDD71\uFE0F",
    '1f18e': "\uD83C\uDD8E",
    '1f191': "\uD83C\uDD91",
    '1f17e': "\uD83C\uDD7E\uFE0F",
    '1f198': "\uD83C\uDD98",
    '274c': "\u274C",
    '2b55': "\u2B55",
    '1f6d1': "\uD83D\uDED1",
    '26d4': "\u26D4",
    '1f4db': "\uD83D\uDCDB",
    '1f6ab': "\uD83D\uDEAB",
    '1f4af': "\uD83D\uDCAF",
    '1f4a2': "\uD83D\uDCA2",
    '2668': "\u2668\uFE0F",
    '1f6b7': "\uD83D\uDEB7",
    '1f6af': "\uD83D\uDEAF",
    '1f6b3': "\uD83D\uDEB3",
    '1f6b1': "\uD83D\uDEB1",
    '1f51e': "\uD83D\uDD1E",
    '1f4f5': "\uD83D\uDCF5",
    '1f6ad': "\uD83D\uDEAD",
    '2757': "\u2757",
    '2755': "\u2755",
    '2753': "\u2753",
    '2754': "\u2754",
    '203c': "\u203C\uFE0F",
    '2049': "\u2049\uFE0F",
    '1f505': "\uD83D\uDD05",
    '1f506': "\uD83D\uDD06",
    '303d': "\u303D\uFE0F",
    '26a0': "\u26A0\uFE0F",
    '1f6b8': "\uD83D\uDEB8",
    '1f531': "\uD83D\uDD31",
    '269c': "\u269C\uFE0F",
    '1f530': "\uD83D\uDD30",
    '267b': "\u267B\uFE0F",
    '2705': "\u2705",
    '1f22f': "\uD83C\uDE2F",
    '1f4b9': "\uD83D\uDCB9",
    '2747': "\u2747\uFE0F",
    '2733': "\u2733\uFE0F",
    '274e': "\u274E",
    '1f310': "\uD83C\uDF10",
    '1f4a0': "\uD83D\uDCA0",
    '24c2': "\u24C2\uFE0F",
    '1f300': "\uD83C\uDF00",
    '1f4a4': "\uD83D\uDCA4",
    '1f3e7': "\uD83C\uDFE7",
    '1f6be': "\uD83D\uDEBE",
    '267f': "\u267F",
    '1f17f': "\uD83C\uDD7F\uFE0F",
    '1f233': "\uD83C\uDE33",
    '1f202': "\uD83C\uDE02\uFE0F",
    '1f6c2': "\uD83D\uDEC2",
    '1f6c3': "\uD83D\uDEC3",
    '1f6c4': "\uD83D\uDEC4",
    '1f6c5': "\uD83D\uDEC5",
    '1f6b9': "\uD83D\uDEB9",
    '1f6ba': "\uD83D\uDEBA",
    '1f6bc': "\uD83D\uDEBC",
    '1f6bb': "\uD83D\uDEBB",
    '1f6ae': "\uD83D\uDEAE",
    '1f3a6': "\uD83C\uDFA6",
    '1f4f6': "\uD83D\uDCF6",
    '1f201': "\uD83C\uDE01",
    '1f523': "\uD83D\uDD23",
    '2139': "\u2139\uFE0F",
    '1f524': "\uD83D\uDD24",
    '1f521': "\uD83D\uDD21",
    '1f520': "\uD83D\uDD20",
    '1f196': "\uD83C\uDD96",
    '1f197': "\uD83C\uDD97",
    '1f199': "\uD83C\uDD99",
    '1f192': "\uD83C\uDD92",
    '1f195': "\uD83C\uDD95",
    '1f193': "\uD83C\uDD93",
    '30-20e3': "0\uFE0F\u20E3",
    '31-20e3': "1\uFE0F\u20E3",
    '32-20e3': "2\uFE0F\u20E3",
    '33-20e3': "3\uFE0F\u20E3",
    '34-20e3': "4\uFE0F\u20E3",
    '35-20e3': "5\uFE0F\u20E3",
    '36-20e3': "6\uFE0F\u20E3",
    '37-20e3': "7\uFE0F\u20E3",
    '38-20e3': "8\uFE0F\u20E3",
    '39-20e3': "9\uFE0F\u20E3",
    '1f51f': "\uD83D\uDD1F",
    '1f522': "\uD83D\uDD22",
    '23-20e3': "#\uFE0F\u20E3",
    '2a-20e3': "*\uFE0F\u20E3",
    '25b6': "\u25B6\uFE0F",
    '23f8': "\u23F8\uFE0F",
    '23ef': "\u23EF\uFE0F",
    '23f9': "\u23F9\uFE0F",
    '23fa': "\u23FA\uFE0F",
    '23cf': "\u23CF\uFE0F",
    '23ed': "\u23ED\uFE0F",
    '23ee': "\u23EE\uFE0F",
    '23e9': "\u23E9",
    '23ea': "\u23EA",
    '23eb': "\u23EB",
    '23ec': "\u23EC",
    '25c0': "\u25C0\uFE0F",
    '1f53c': "\uD83D\uDD3C",
    '1f53d': "\uD83D\uDD3D",
    '27a1': "\u27A1\uFE0F",
    '2b05': "\u2B05\uFE0F",
    '2b06': "\u2B06\uFE0F",
    '2b07': "\u2B07\uFE0F",
    '2197': "\u2197\uFE0F",
    '2198': "\u2198\uFE0F",
    '2199': "\u2199\uFE0F",
    '2196': "\u2196\uFE0F",
    '2195': "\u2195\uFE0F",
    '2194': "\u2194\uFE0F",
    '21aa': "\u21AA\uFE0F",
    '21a9': "\u21A9\uFE0F",
    '2934': "\u2934\uFE0F",
    '2935': "\u2935\uFE0F",
    '1f500': "\uD83D\uDD00",
    '1f501': "\uD83D\uDD01",
    '1f502': "\uD83D\uDD02",
    '1f504': "\uD83D\uDD04",
    '1f503': "\uD83D\uDD03",
    '1f3b5': "\uD83C\uDFB5",
    '1f3b6': "\uD83C\uDFB6",
    '2795': "\u2795",
    '2796': "\u2796",
    '2797': "\u2797",
    '2716': "\u2716\uFE0F",
    '1f4b2': "\uD83D\uDCB2",
    '1f4b1': "\uD83D\uDCB1",
    '2122': "\u2122\uFE0F",
    a9: "\xa9\uFE0F",
    ae: "\xae\uFE0F",
    '3030': "\u3030\uFE0F",
    '27b0': "\u27B0",
    '27bf': "\u27BF",
    '1f51a': "\uD83D\uDD1A",
    '1f519': "\uD83D\uDD19",
    '1f51b': "\uD83D\uDD1B",
    '1f51d': "\uD83D\uDD1D",
    '1f51c': "\uD83D\uDD1C",
    '2714': "\u2714\uFE0F",
    '2611': "\u2611\uFE0F",
    '1f518': "\uD83D\uDD18",
    '26aa': "\u26AA",
    '26ab': "\u26AB",
    '1f534': "\uD83D\uDD34",
    '1f535': "\uD83D\uDD35",
    '1f53a': "\uD83D\uDD3A",
    '1f53b': "\uD83D\uDD3B",
    '1f538': "\uD83D\uDD38",
    '1f539': "\uD83D\uDD39",
    '1f536': "\uD83D\uDD36",
    '1f537': "\uD83D\uDD37",
    '1f533': "\uD83D\uDD33",
    '1f532': "\uD83D\uDD32",
    '25aa': "\u25AA\uFE0F",
    '25ab': "\u25AB\uFE0F",
    '25fe': "\u25FE",
    '25fd': "\u25FD",
    '25fc': "\u25FC\uFE0F",
    '25fb': "\u25FB\uFE0F",
    '2b1b': "\u2B1B",
    '2b1c': "\u2B1C",
    '1f508': "\uD83D\uDD08",
    '1f507': "\uD83D\uDD07",
    '1f509': "\uD83D\uDD09",
    '1f50a': "\uD83D\uDD0A",
    '1f514': "\uD83D\uDD14",
    '1f515': "\uD83D\uDD15",
    '1f4e3': "\uD83D\uDCE3",
    '1f4e2': "\uD83D\uDCE2",
    '1f5e8': "\uD83D\uDDE8\uFE0F",
    '1f441-fe0f-200d-1f5e8-fe0f': "\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8\uFE0F",
    '1f4ac': "\uD83D\uDCAC",
    '1f4ad': "\uD83D\uDCAD",
    '1f5ef': "\uD83D\uDDEF\uFE0F",
    '2660': "\u2660\uFE0F",
    '2663': "\u2663\uFE0F",
    '2665': "\u2665\uFE0F",
    '2666': "\u2666\uFE0F",
    '1f0cf': "\uD83C\uDCCF",
    '1f3b4': "\uD83C\uDFB4",
    '1f004': "\uD83C\uDC04",
    '1f550': "\uD83D\uDD50",
    '1f551': "\uD83D\uDD51",
    '1f552': "\uD83D\uDD52",
    '1f553': "\uD83D\uDD53",
    '1f554': "\uD83D\uDD54",
    '1f555': "\uD83D\uDD55",
    '1f556': "\uD83D\uDD56",
    '1f557': "\uD83D\uDD57",
    '1f558': "\uD83D\uDD58",
    '1f559': "\uD83D\uDD59",
    '1f55a': "\uD83D\uDD5A",
    '1f55b': "\uD83D\uDD5B",
    '1f55c': "\uD83D\uDD5C",
    '1f55d': "\uD83D\uDD5D",
    '1f55e': "\uD83D\uDD5E",
    '1f55f': "\uD83D\uDD5F",
    '1f560': "\uD83D\uDD60",
    '1f561': "\uD83D\uDD61",
    '1f562': "\uD83D\uDD62",
    '1f563': "\uD83D\uDD63",
    '1f564': "\uD83D\uDD64",
    '1f565': "\uD83D\uDD65",
    '1f566': "\uD83D\uDD66",
    '1f567': "\uD83D\uDD67",
    '1f3f3': "\uD83C\uDFF3\uFE0F",
    '1f3f4': "\uD83C\uDFF4",
    '1f3c1': "\uD83C\uDFC1",
    '1f6a9': "\uD83D\uDEA9",
    '1f3f3-fe0f-200d-1f308': "\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08",
    '1f1e6-1f1eb': "\uD83C\uDDE6\uD83C\uDDEB",
    '1f1e6-1f1fd': "\uD83C\uDDE6\uD83C\uDDFD",
    '1f1e6-1f1f1': "\uD83C\uDDE6\uD83C\uDDF1",
    '1f1e9-1f1ff': "\uD83C\uDDE9\uD83C\uDDFF",
    '1f1e6-1f1f8': "\uD83C\uDDE6\uD83C\uDDF8",
    '1f1e6-1f1e9': "\uD83C\uDDE6\uD83C\uDDE9",
    '1f1e6-1f1f4': "\uD83C\uDDE6\uD83C\uDDF4",
    '1f1e6-1f1ee': "\uD83C\uDDE6\uD83C\uDDEE",
    '1f1e6-1f1f6': "\uD83C\uDDE6\uD83C\uDDF6",
    '1f1e6-1f1ec': "\uD83C\uDDE6\uD83C\uDDEC",
    '1f1e6-1f1f7': "\uD83C\uDDE6\uD83C\uDDF7",
    '1f1e6-1f1f2': "\uD83C\uDDE6\uD83C\uDDF2",
    '1f1e6-1f1fc': "\uD83C\uDDE6\uD83C\uDDFC",
    '1f1e6-1f1fa': "\uD83C\uDDE6\uD83C\uDDFA",
    '1f1e6-1f1f9': "\uD83C\uDDE6\uD83C\uDDF9",
    '1f1e6-1f1ff': "\uD83C\uDDE6\uD83C\uDDFF",
    '1f1e7-1f1f8': "\uD83C\uDDE7\uD83C\uDDF8",
    '1f1e7-1f1ed': "\uD83C\uDDE7\uD83C\uDDED",
    '1f1e7-1f1e9': "\uD83C\uDDE7\uD83C\uDDE9",
    '1f1e7-1f1e7': "\uD83C\uDDE7\uD83C\uDDE7",
    '1f1e7-1f1fe': "\uD83C\uDDE7\uD83C\uDDFE",
    '1f1e7-1f1ea': "\uD83C\uDDE7\uD83C\uDDEA",
    '1f1e7-1f1ff': "\uD83C\uDDE7\uD83C\uDDFF",
    '1f1e7-1f1ef': "\uD83C\uDDE7\uD83C\uDDEF",
    '1f1e7-1f1f2': "\uD83C\uDDE7\uD83C\uDDF2",
    '1f1e7-1f1f9': "\uD83C\uDDE7\uD83C\uDDF9",
    '1f1e7-1f1f4': "\uD83C\uDDE7\uD83C\uDDF4",
    '1f1e7-1f1e6': "\uD83C\uDDE7\uD83C\uDDE6",
    '1f1e7-1f1fc': "\uD83C\uDDE7\uD83C\uDDFC",
    '1f1e7-1f1f7': "\uD83C\uDDE7\uD83C\uDDF7",
    '1f1ee-1f1f4': "\uD83C\uDDEE\uD83C\uDDF4",
    '1f1fb-1f1ec': "\uD83C\uDDFB\uD83C\uDDEC",
    '1f1e7-1f1f3': "\uD83C\uDDE7\uD83C\uDDF3",
    '1f1e7-1f1ec': "\uD83C\uDDE7\uD83C\uDDEC",
    '1f1e7-1f1eb': "\uD83C\uDDE7\uD83C\uDDEB",
    '1f1e7-1f1ee': "\uD83C\uDDE7\uD83C\uDDEE",
    '1f1f0-1f1ed': "\uD83C\uDDF0\uD83C\uDDED",
    '1f1e8-1f1f2': "\uD83C\uDDE8\uD83C\uDDF2",
    '1f1e8-1f1e6': "\uD83C\uDDE8\uD83C\uDDE6",
    '1f1ee-1f1e8': "\uD83C\uDDEE\uD83C\uDDE8",
    '1f1e8-1f1fb': "\uD83C\uDDE8\uD83C\uDDFB",
    '1f1e7-1f1f6': "\uD83C\uDDE7\uD83C\uDDF6",
    '1f1f0-1f1fe': "\uD83C\uDDF0\uD83C\uDDFE",
    '1f1e8-1f1eb': "\uD83C\uDDE8\uD83C\uDDEB",
    '1f1f9-1f1e9': "\uD83C\uDDF9\uD83C\uDDE9",
    '1f1e8-1f1f1': "\uD83C\uDDE8\uD83C\uDDF1",
    '1f1e8-1f1f3': "\uD83C\uDDE8\uD83C\uDDF3",
    '1f1e8-1f1fd': "\uD83C\uDDE8\uD83C\uDDFD",
    '1f1e8-1f1e8': "\uD83C\uDDE8\uD83C\uDDE8",
    '1f1e8-1f1f4': "\uD83C\uDDE8\uD83C\uDDF4",
    '1f1f0-1f1f2': "\uD83C\uDDF0\uD83C\uDDF2",
    '1f1e8-1f1ec': "\uD83C\uDDE8\uD83C\uDDEC",
    '1f1e8-1f1e9': "\uD83C\uDDE8\uD83C\uDDE9",
    '1f1e8-1f1f0': "\uD83C\uDDE8\uD83C\uDDF0",
    '1f1e8-1f1f7': "\uD83C\uDDE8\uD83C\uDDF7",
    '1f1e8-1f1ee': "\uD83C\uDDE8\uD83C\uDDEE",
    '1f1ed-1f1f7': "\uD83C\uDDED\uD83C\uDDF7",
    '1f1e8-1f1fa': "\uD83C\uDDE8\uD83C\uDDFA",
    '1f1e8-1f1fc': "\uD83C\uDDE8\uD83C\uDDFC",
    '1f1e8-1f1fe': "\uD83C\uDDE8\uD83C\uDDFE",
    '1f1e8-1f1ff': "\uD83C\uDDE8\uD83C\uDDFF",
    '1f1e9-1f1f0': "\uD83C\uDDE9\uD83C\uDDF0",
    '1f1e9-1f1ef': "\uD83C\uDDE9\uD83C\uDDEF",
    '1f1e9-1f1f2': "\uD83C\uDDE9\uD83C\uDDF2",
    '1f1e9-1f1f4': "\uD83C\uDDE9\uD83C\uDDF4",
    '1f1ea-1f1e8': "\uD83C\uDDEA\uD83C\uDDE8",
    '1f1ea-1f1ec': "\uD83C\uDDEA\uD83C\uDDEC",
    '1f1f8-1f1fb': "\uD83C\uDDF8\uD83C\uDDFB",
    '1f1ec-1f1f6': "\uD83C\uDDEC\uD83C\uDDF6",
    '1f1ea-1f1f7': "\uD83C\uDDEA\uD83C\uDDF7",
    '1f1ea-1f1ea': "\uD83C\uDDEA\uD83C\uDDEA",
    '1f1ea-1f1f9': "\uD83C\uDDEA\uD83C\uDDF9",
    '1f1ea-1f1fa': "\uD83C\uDDEA\uD83C\uDDFA",
    '1f1eb-1f1f0': "\uD83C\uDDEB\uD83C\uDDF0",
    '1f1eb-1f1f4': "\uD83C\uDDEB\uD83C\uDDF4",
    '1f1eb-1f1ef': "\uD83C\uDDEB\uD83C\uDDEF",
    '1f1eb-1f1ee': "\uD83C\uDDEB\uD83C\uDDEE",
    '1f1eb-1f1f7': "\uD83C\uDDEB\uD83C\uDDF7",
    '1f1ec-1f1eb': "\uD83C\uDDEC\uD83C\uDDEB",
    '1f1f5-1f1eb': "\uD83C\uDDF5\uD83C\uDDEB",
    '1f1f9-1f1eb': "\uD83C\uDDF9\uD83C\uDDEB",
    '1f1ec-1f1e6': "\uD83C\uDDEC\uD83C\uDDE6",
    '1f1ec-1f1f2': "\uD83C\uDDEC\uD83C\uDDF2",
    '1f1ec-1f1ea': "\uD83C\uDDEC\uD83C\uDDEA",
    '1f1e9-1f1ea': "\uD83C\uDDE9\uD83C\uDDEA",
    '1f1ec-1f1ed': "\uD83C\uDDEC\uD83C\uDDED",
    '1f1ec-1f1ee': "\uD83C\uDDEC\uD83C\uDDEE",
    '1f1ec-1f1f7': "\uD83C\uDDEC\uD83C\uDDF7",
    '1f1ec-1f1f1': "\uD83C\uDDEC\uD83C\uDDF1",
    '1f1ec-1f1e9': "\uD83C\uDDEC\uD83C\uDDE9",
    '1f1ec-1f1f5': "\uD83C\uDDEC\uD83C\uDDF5",
    '1f1ec-1f1fa': "\uD83C\uDDEC\uD83C\uDDFA",
    '1f1ec-1f1f9': "\uD83C\uDDEC\uD83C\uDDF9",
    '1f1ec-1f1ec': "\uD83C\uDDEC\uD83C\uDDEC",
    '1f1ec-1f1f3': "\uD83C\uDDEC\uD83C\uDDF3",
    '1f1ec-1f1fc': "\uD83C\uDDEC\uD83C\uDDFC",
    '1f1ec-1f1fe': "\uD83C\uDDEC\uD83C\uDDFE",
    '1f1ed-1f1f9': "\uD83C\uDDED\uD83C\uDDF9",
    '1f1ed-1f1f3': "\uD83C\uDDED\uD83C\uDDF3",
    '1f1ed-1f1f0': "\uD83C\uDDED\uD83C\uDDF0",
    '1f1ed-1f1fa': "\uD83C\uDDED\uD83C\uDDFA",
    '1f1ee-1f1f8': "\uD83C\uDDEE\uD83C\uDDF8",
    '1f1ee-1f1f3': "\uD83C\uDDEE\uD83C\uDDF3",
    '1f1ee-1f1e9': "\uD83C\uDDEE\uD83C\uDDE9",
    '1f1ee-1f1f7': "\uD83C\uDDEE\uD83C\uDDF7",
    '1f1ee-1f1f6': "\uD83C\uDDEE\uD83C\uDDF6",
    '1f1ee-1f1ea': "\uD83C\uDDEE\uD83C\uDDEA",
    '1f1ee-1f1f2': "\uD83C\uDDEE\uD83C\uDDF2",
    '1f1ee-1f1f1': "\uD83C\uDDEE\uD83C\uDDF1",
    '1f1ee-1f1f9': "\uD83C\uDDEE\uD83C\uDDF9",
    '1f1ef-1f1f2': "\uD83C\uDDEF\uD83C\uDDF2",
    '1f1ef-1f1f5': "\uD83C\uDDEF\uD83C\uDDF5",
    '1f38c': "\uD83C\uDF8C",
    '1f1ef-1f1ea': "\uD83C\uDDEF\uD83C\uDDEA",
    '1f1ef-1f1f4': "\uD83C\uDDEF\uD83C\uDDF4",
    '1f1f0-1f1ff': "\uD83C\uDDF0\uD83C\uDDFF",
    '1f1f0-1f1ea': "\uD83C\uDDF0\uD83C\uDDEA",
    '1f1f0-1f1ee': "\uD83C\uDDF0\uD83C\uDDEE",
    '1f1fd-1f1f0': "\uD83C\uDDFD\uD83C\uDDF0",
    '1f1f0-1f1fc': "\uD83C\uDDF0\uD83C\uDDFC",
    '1f1f0-1f1ec': "\uD83C\uDDF0\uD83C\uDDEC",
    '1f1f1-1f1e6': "\uD83C\uDDF1\uD83C\uDDE6",
    '1f1f1-1f1fb': "\uD83C\uDDF1\uD83C\uDDFB",
    '1f1f1-1f1e7': "\uD83C\uDDF1\uD83C\uDDE7",
    '1f1f1-1f1f8': "\uD83C\uDDF1\uD83C\uDDF8",
    '1f1f1-1f1f7': "\uD83C\uDDF1\uD83C\uDDF7",
    '1f1f1-1f1fe': "\uD83C\uDDF1\uD83C\uDDFE",
    '1f1f1-1f1ee': "\uD83C\uDDF1\uD83C\uDDEE",
    '1f1f1-1f1f9': "\uD83C\uDDF1\uD83C\uDDF9",
    '1f1f1-1f1fa': "\uD83C\uDDF1\uD83C\uDDFA",
    '1f1f2-1f1f4': "\uD83C\uDDF2\uD83C\uDDF4",
    '1f1f2-1f1f0': "\uD83C\uDDF2\uD83C\uDDF0",
    '1f1f2-1f1ec': "\uD83C\uDDF2\uD83C\uDDEC",
    '1f1f2-1f1fc': "\uD83C\uDDF2\uD83C\uDDFC",
    '1f1f2-1f1fe': "\uD83C\uDDF2\uD83C\uDDFE",
    '1f1f2-1f1fb': "\uD83C\uDDF2\uD83C\uDDFB",
    '1f1f2-1f1f1': "\uD83C\uDDF2\uD83C\uDDF1",
    '1f1f2-1f1f9': "\uD83C\uDDF2\uD83C\uDDF9",
    '1f1f2-1f1ed': "\uD83C\uDDF2\uD83C\uDDED",
    '1f1f2-1f1f6': "\uD83C\uDDF2\uD83C\uDDF6",
    '1f1f2-1f1f7': "\uD83C\uDDF2\uD83C\uDDF7",
    '1f1f2-1f1fa': "\uD83C\uDDF2\uD83C\uDDFA",
    '1f1fe-1f1f9': "\uD83C\uDDFE\uD83C\uDDF9",
    '1f1f2-1f1fd': "\uD83C\uDDF2\uD83C\uDDFD",
    '1f1eb-1f1f2': "\uD83C\uDDEB\uD83C\uDDF2",
    '1f1f2-1f1e9': "\uD83C\uDDF2\uD83C\uDDE9",
    '1f1f2-1f1e8': "\uD83C\uDDF2\uD83C\uDDE8",
    '1f1f2-1f1f3': "\uD83C\uDDF2\uD83C\uDDF3",
    '1f1f2-1f1ea': "\uD83C\uDDF2\uD83C\uDDEA",
    '1f1f2-1f1f8': "\uD83C\uDDF2\uD83C\uDDF8",
    '1f1f2-1f1e6': "\uD83C\uDDF2\uD83C\uDDE6",
    '1f1f2-1f1ff': "\uD83C\uDDF2\uD83C\uDDFF",
    '1f1f2-1f1f2': "\uD83C\uDDF2\uD83C\uDDF2",
    '1f1f3-1f1e6': "\uD83C\uDDF3\uD83C\uDDE6",
    '1f1f3-1f1f7': "\uD83C\uDDF3\uD83C\uDDF7",
    '1f1f3-1f1f5': "\uD83C\uDDF3\uD83C\uDDF5",
    '1f1f3-1f1f1': "\uD83C\uDDF3\uD83C\uDDF1",
    '1f1f3-1f1e8': "\uD83C\uDDF3\uD83C\uDDE8",
    '1f1f3-1f1ff': "\uD83C\uDDF3\uD83C\uDDFF",
    '1f1f3-1f1ee': "\uD83C\uDDF3\uD83C\uDDEE",
    '1f1f3-1f1ea': "\uD83C\uDDF3\uD83C\uDDEA",
    '1f1f3-1f1ec': "\uD83C\uDDF3\uD83C\uDDEC",
    '1f1f3-1f1fa': "\uD83C\uDDF3\uD83C\uDDFA",
    '1f1f3-1f1eb': "\uD83C\uDDF3\uD83C\uDDEB",
    '1f1f0-1f1f5': "\uD83C\uDDF0\uD83C\uDDF5",
    '1f1f2-1f1f5': "\uD83C\uDDF2\uD83C\uDDF5",
    '1f1f3-1f1f4': "\uD83C\uDDF3\uD83C\uDDF4",
    '1f1f4-1f1f2': "\uD83C\uDDF4\uD83C\uDDF2",
    '1f1f5-1f1f0': "\uD83C\uDDF5\uD83C\uDDF0",
    '1f1f5-1f1fc': "\uD83C\uDDF5\uD83C\uDDFC",
    '1f1f5-1f1f8': "\uD83C\uDDF5\uD83C\uDDF8",
    '1f1f5-1f1e6': "\uD83C\uDDF5\uD83C\uDDE6",
    '1f1f5-1f1ec': "\uD83C\uDDF5\uD83C\uDDEC",
    '1f1f5-1f1fe': "\uD83C\uDDF5\uD83C\uDDFE",
    '1f1f5-1f1ea': "\uD83C\uDDF5\uD83C\uDDEA",
    '1f1f5-1f1ed': "\uD83C\uDDF5\uD83C\uDDED",
    '1f1f5-1f1f3': "\uD83C\uDDF5\uD83C\uDDF3",
    '1f1f5-1f1f1': "\uD83C\uDDF5\uD83C\uDDF1",
    '1f1f5-1f1f9': "\uD83C\uDDF5\uD83C\uDDF9",
    '1f1f5-1f1f7': "\uD83C\uDDF5\uD83C\uDDF7",
    '1f1f6-1f1e6': "\uD83C\uDDF6\uD83C\uDDE6",
    '1f1f7-1f1ea': "\uD83C\uDDF7\uD83C\uDDEA",
    '1f1f7-1f1f4': "\uD83C\uDDF7\uD83C\uDDF4",
    '1f1f7-1f1fa': "\uD83C\uDDF7\uD83C\uDDFA",
    '1f1f7-1f1fc': "\uD83C\uDDF7\uD83C\uDDFC",
    '1f1fc-1f1f8': "\uD83C\uDDFC\uD83C\uDDF8",
    '1f1f8-1f1f2': "\uD83C\uDDF8\uD83C\uDDF2",
    '1f1f8-1f1f9': "\uD83C\uDDF8\uD83C\uDDF9",
    '1f1f8-1f1e6': "\uD83C\uDDF8\uD83C\uDDE6",
    '1f1f8-1f1f3': "\uD83C\uDDF8\uD83C\uDDF3",
    '1f1f7-1f1f8': "\uD83C\uDDF7\uD83C\uDDF8",
    '1f1f8-1f1e8': "\uD83C\uDDF8\uD83C\uDDE8",
    '1f1f8-1f1f1': "\uD83C\uDDF8\uD83C\uDDF1",
    '1f1f8-1f1ec': "\uD83C\uDDF8\uD83C\uDDEC",
    '1f1f8-1f1fd': "\uD83C\uDDF8\uD83C\uDDFD",
    '1f1f8-1f1f0': "\uD83C\uDDF8\uD83C\uDDF0",
    '1f1f8-1f1ee': "\uD83C\uDDF8\uD83C\uDDEE",
    '1f1ec-1f1f8': "\uD83C\uDDEC\uD83C\uDDF8",
    '1f1f8-1f1e7': "\uD83C\uDDF8\uD83C\uDDE7",
    '1f1f8-1f1f4': "\uD83C\uDDF8\uD83C\uDDF4",
    '1f1ff-1f1e6': "\uD83C\uDDFF\uD83C\uDDE6",
    '1f1f0-1f1f7': "\uD83C\uDDF0\uD83C\uDDF7",
    '1f1f8-1f1f8': "\uD83C\uDDF8\uD83C\uDDF8",
    '1f1ea-1f1f8': "\uD83C\uDDEA\uD83C\uDDF8",
    '1f1f1-1f1f0': "\uD83C\uDDF1\uD83C\uDDF0",
    '1f1e7-1f1f1': "\uD83C\uDDE7\uD83C\uDDF1",
    '1f1f8-1f1ed': "\uD83C\uDDF8\uD83C\uDDED",
    '1f1f0-1f1f3': "\uD83C\uDDF0\uD83C\uDDF3",
    '1f1f1-1f1e8': "\uD83C\uDDF1\uD83C\uDDE8",
    '1f1f5-1f1f2': "\uD83C\uDDF5\uD83C\uDDF2",
    '1f1fb-1f1e8': "\uD83C\uDDFB\uD83C\uDDE8",
    '1f1f8-1f1e9': "\uD83C\uDDF8\uD83C\uDDE9",
    '1f1f8-1f1f7': "\uD83C\uDDF8\uD83C\uDDF7",
    '1f1f8-1f1ff': "\uD83C\uDDF8\uD83C\uDDFF",
    '1f1f8-1f1ea': "\uD83C\uDDF8\uD83C\uDDEA",
    '1f1e8-1f1ed': "\uD83C\uDDE8\uD83C\uDDED",
    '1f1f8-1f1fe': "\uD83C\uDDF8\uD83C\uDDFE",
    '1f1f9-1f1fc': "\uD83C\uDDF9\uD83C\uDDFC",
    '1f1f9-1f1ef': "\uD83C\uDDF9\uD83C\uDDEF",
    '1f1f9-1f1ff': "\uD83C\uDDF9\uD83C\uDDFF",
    '1f1f9-1f1ed': "\uD83C\uDDF9\uD83C\uDDED",
    '1f1f9-1f1f1': "\uD83C\uDDF9\uD83C\uDDF1",
    '1f1f9-1f1ec': "\uD83C\uDDF9\uD83C\uDDEC",
    '1f1f9-1f1f0': "\uD83C\uDDF9\uD83C\uDDF0",
    '1f1f9-1f1f4': "\uD83C\uDDF9\uD83C\uDDF4",
    '1f1f9-1f1f9': "\uD83C\uDDF9\uD83C\uDDF9",
    '1f1f9-1f1f3': "\uD83C\uDDF9\uD83C\uDDF3",
    '1f1f9-1f1f7': "\uD83C\uDDF9\uD83C\uDDF7",
    '1f1f9-1f1f2': "\uD83C\uDDF9\uD83C\uDDF2",
    '1f1f9-1f1e8': "\uD83C\uDDF9\uD83C\uDDE8",
    '1f1f9-1f1fb': "\uD83C\uDDF9\uD83C\uDDFB",
    '1f1fb-1f1ee': "\uD83C\uDDFB\uD83C\uDDEE",
    '1f1fa-1f1ec': "\uD83C\uDDFA\uD83C\uDDEC",
    '1f1fa-1f1e6': "\uD83C\uDDFA\uD83C\uDDE6",
    '1f1e6-1f1ea': "\uD83C\uDDE6\uD83C\uDDEA",
    '1f1ec-1f1e7': "\uD83C\uDDEC\uD83C\uDDE7",
    '1f1fa-1f1f8': "\uD83C\uDDFA\uD83C\uDDF8",
    '1f1fa-1f1fe': "\uD83C\uDDFA\uD83C\uDDFE",
    '1f1fa-1f1ff': "\uD83C\uDDFA\uD83C\uDDFF",
    '1f1fb-1f1fa': "\uD83C\uDDFB\uD83C\uDDFA",
    '1f1fb-1f1e6': "\uD83C\uDDFB\uD83C\uDDE6",
    '1f1fb-1f1ea': "\uD83C\uDDFB\uD83C\uDDEA",
    '1f1fb-1f1f3': "\uD83C\uDDFB\uD83C\uDDF3",
    '1f1fc-1f1eb': "\uD83C\uDDFC\uD83C\uDDEB",
    '1f1ea-1f1ed': "\uD83C\uDDEA\uD83C\uDDED",
    '1f1fe-1f1ea': "\uD83C\uDDFE\uD83C\uDDEA",
    '1f1ff-1f1f2': "\uD83C\uDDFF\uD83C\uDDF2",
    '1f1ff-1f1fc': "\uD83C\uDDFF\uD83C\uDDFC",
    '1f1e6-1f1e8': "\uD83C\uDDE6\uD83C\uDDE8",
    '1f1f9-1f1e6': "\uD83C\uDDF9\uD83C\uDDE6",
    '1f1e7-1f1fb': "\uD83C\uDDE7\uD83C\uDDFB",
    '1f1ed-1f1f2': "\uD83C\uDDED\uD83C\uDDF2",
    '1f1f8-1f1ef': "\uD83C\uDDF8\uD83C\uDDEF",
    '1f1fa-1f1f2': "\uD83C\uDDFA\uD83C\uDDF2",
    '1f1ea-1f1e6': "\uD83C\uDDEA\uD83C\uDDE6",
    '1f1e8-1f1f5': "\uD83C\uDDE8\uD83C\uDDF5",
    '1f1e9-1f1ec': "\uD83C\uDDE9\uD83C\uDDEC",
    '1f1f2-1f1eb': "\uD83C\uDDF2\uD83C\uDDEB",
    '1f1fa-1f1f3': "\uD83C\uDDFA\uD83C\uDDF3",
    '1f3f4-e0067-e0062-e0065-e006e-e0067-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F",
    '1f3f4-e0067-e0062-e0073-e0063-e0074-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74\uDB40\uDC7F",
    '1f3f4-e0067-e0062-e0077-e006c-e0073-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73\uDB40\uDC7F",
    '1f1ff': "\uD83C\uDDFF",
    '1f1fe': "\uD83C\uDDFE",
    '1f1fd': "\uD83C\uDDFD",
    '1f3fb': "\uD83C\uDFFB",
    '1f3fc': "\uD83C\uDFFC",
    '1f3fd': "\uD83C\uDFFD",
    '1f3fe': "\uD83C\uDFFE",
    '1f3ff': "\uD83C\uDFFF",
    '1f1fc': "\uD83C\uDDFC",
    '1f1fb': "\uD83C\uDDFB",
    '1f1fa': "\uD83C\uDDFA",
    '1f1f9': "\uD83C\uDDF9",
    '1f1f8': "\uD83C\uDDF8",
    '1f1f7': "\uD83C\uDDF7",
    '1f1f6': "\uD83C\uDDF6",
    '1f1f5': "\uD83C\uDDF5",
    '1f1f4': "\uD83C\uDDF4",
    '1f1f3': "\uD83C\uDDF3",
    '1f1f2': "\uD83C\uDDF2",
    '1f1f1': "\uD83C\uDDF1",
    '1f1f0': "\uD83C\uDDF0",
    '1f1ef': "\uD83C\uDDEF",
    '1f1ee': "\uD83C\uDDEE",
    '1f1ed': "\uD83C\uDDED",
    '1f1ec': "\uD83C\uDDEC",
    '1f1eb': "\uD83C\uDDEB",
    '1f1ea': "\uD83C\uDDEA",
    '1f1e9': "\uD83C\uDDE9",
    '1f1e8': "\uD83C\uDDE8",
    '1f1e7': "\uD83C\uDDE7",
    '1f1e6': "\uD83C\uDDE6",
    '2640': "\u2640\uFE0F",
    '2642': "\u2642\uFE0F",
    '2695': "\u2695\uFE0F",
    '1f468-200d-1f469-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-2764-fe0f-200d-1f468': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC68",
    '1f469-200d-2764-fe0f-200d-1f48b-200d-1f468': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68",
    '1f928': "\uD83E\uDD28",
    '1f929': "\uD83E\uDD29",
    '1f92a': "\uD83E\uDD2A",
    '1f92b': "\uD83E\uDD2B",
    '1f92c': "\uD83E\uDD2C",
    '1f92d': "\uD83E\uDD2D",
    '1f92e': "\uD83E\uDD2E",
    '1f92f': "\uD83E\uDD2F",
    '1f9d0': "\uD83E\uDDD0",
    '1f9d1': "\uD83E\uDDD1",
    '1f9d2': "\uD83E\uDDD2",
    '1f9d3': "\uD83E\uDDD3",
    '1f9d4': "\uD83E\uDDD4",
    '1f9d5': "\uD83E\uDDD5",
    '1f9e0': "\uD83E\uDDE0",
    '1f9e2': "\uD83E\uDDE2",
    '1f9d9': "\uD83E\uDDD9",
    '1f9da': "\uD83E\uDDDA",
    '1f9db': "\uD83E\uDDDB",
    '1f9dc': "\uD83E\uDDDC",
    '1f9dd': "\uD83E\uDDDD",
    '1f9de': "\uD83E\uDDDE",
    '1f9df': "\uD83E\uDDDF",
    '1f9e3': "\uD83E\uDDE3",
    '1f9e4': "\uD83E\uDDE4",
    '1f9e5': "\uD83E\uDDE5",
    '1f9e6': "\uD83E\uDDE6",
    '1f91f': "\uD83E\uDD1F",
    '1f932': "\uD83E\uDD32",
    '1f9d9-200d-2640-fe0f': "\uD83E\uDDD9\u200D\u2640\uFE0F",
    '1f9d9-200d-2642-fe0f': "\uD83E\uDDD9\u200D\u2642\uFE0F",
    '1f9da-200d-2640-fe0f': "\uD83E\uDDDA\u200D\u2640\uFE0F",
    '1f9da-200d-2642-fe0f': "\uD83E\uDDDA\u200D\u2642\uFE0F",
    '1f9db-200d-2640-fe0f': "\uD83E\uDDDB\u200D\u2640\uFE0F",
    '1f9db-200d-2642-fe0f': "\uD83E\uDDDB\u200D\u2642\uFE0F",
    '1f9dc-200d-2640-fe0f': "\uD83E\uDDDC\u200D\u2640\uFE0F",
    '1f9dc-200d-2642-fe0f': "\uD83E\uDDDC\u200D\u2642\uFE0F",
    '1f9dd-200d-2640-fe0f': "\uD83E\uDDDD\u200D\u2640\uFE0F",
    '1f9dd-200d-2642-fe0f': "\uD83E\uDDDD\u200D\u2642\uFE0F",
    '1f9de-200d-2640-fe0f': "\uD83E\uDDDE\u200D\u2640\uFE0F",
    '1f9de-200d-2642-fe0f': "\uD83E\uDDDE\u200D\u2642\uFE0F",
    '1f9df-200d-2640-fe0f': "\uD83E\uDDDF\u200D\u2640\uFE0F",
    '1f9df-200d-2642-fe0f': "\uD83E\uDDDF\u200D\u2642\uFE0F",
    'atlassian-check_mark': '(/)',
    'atlassian-cross_mark': '(x)',
    'atlassian-plus': '(+)',
    'atlassian-minus': '(-)',
    'atlassian-light_bulb_on': '(on)',
    'atlassian-light_bulb_off': '(off)',
    'atlassian-flag_on': '(flag)',
    'atlassian-flag_off': '(flagoff)',
    'atlassian-warning': '(!)',
    'atlassian-question_mark': '(?)',
    'atlassian-info': '(i)',
    'atlassian-yellow_star': '(*y)',
    'atlassian-blue_star': '(*b)',
    'atlassian-green_star': '(*g)',
    'atlassian-red_star': '(*r)'
};

});

parcelRegister("1Nefo", function(module, exports) {

$parcel$export(module.exports, "unknown", () => $6e7c0aa132a04ffb$export$19282c40b967aec6);

var $hYNZx = parcelRequire("hYNZx");
const $6e7c0aa132a04ffb$var$jsonTransformer = new (0, $hYNZx.JSONTransformer)();
const $6e7c0aa132a04ffb$export$19282c40b967aec6 = (node)=>{
    const content = JSON.stringify($6e7c0aa132a04ffb$var$jsonTransformer.encodeNode(node));
    return node.isBlock ? `{adf:display=block}
${content}
{adf}` : `{adf:display=inline}${content}{adf}`;
};

});


parcelRegister("e34Iq", function(module, exports) {

$parcel$export(module.exports, "hardBreak", () => $0b90673427e9e36d$export$371da9dd35aba193);
const $0b90673427e9e36d$export$371da9dd35aba193 = (_node)=>{
    return '\n';
};

});

parcelRegister("6obXI", function(module, exports) {

$parcel$export(module.exports, "mediaInline", () => $b266c76290bae2fd$export$38bab695e3f720f1);
const $b266c76290bae2fd$export$38bab695e3f720f1 = (node, { context: context } = {})=>{
    const fileName = context?.conversion?.mediaConversion?.[node.attrs.id]?.transform ?? node.attrs.id;
    return `[^${fileName}]`;
};

});

parcelRegister("7GCbZ", function(module, exports) {

$parcel$export(module.exports, "mention", () => $276f00c4f54975e4$export$db83999c14438df4);
const $276f00c4f54975e4$var$PREFIX = 'accountid:';
const $276f00c4f54975e4$var$UNKNOWN_USER = 'UNKNOWN_USER';
const $276f00c4f54975e4$var$addPrefix = (content)=>content.toLowerCase().startsWith($276f00c4f54975e4$var$PREFIX) ? content : `${$276f00c4f54975e4$var$PREFIX}${content}`;
const $276f00c4f54975e4$export$db83999c14438df4 = (node, { context: context } = {})=>{
    if (node.attrs.id === $276f00c4f54975e4$var$UNKNOWN_USER) return `[~${node.attrs.id}]`;
    const mentionKey = node.attrs.id.toLowerCase();
    const content = context && context.conversion && context.conversion.mentionConversion && context.conversion.mentionConversion[mentionKey] ? context.conversion.mentionConversion[mentionKey] : $276f00c4f54975e4$var$addPrefix(node.attrs.id);
    return `[~${content}]`;
};

});

parcelRegister("6ayzl", function(module, exports) {

$parcel$export(module.exports, "text", () => $774ee87c38efef1c$export$6f093cfa640b7166);

var $cG4PY = parcelRequire("cG4PY");

var $4yZSi = parcelRequire("4yZSi");

var $aDTWq = parcelRequire("aDTWq");

var $gdFeW = parcelRequire("gdFeW");

var $jo5YT = parcelRequire("jo5YT");

var $9fwgI = parcelRequire("9fwgI");

var $eKxrE = parcelRequire("eKxrE");

var $1x55I = parcelRequire("1x55I");

var $8tKGr = parcelRequire("8tKGr");
/**
 * The order of the mapping matters.
 * For example, textColor will be a macro {color} so
 * we want to process other marks before it.
 */ const $774ee87c38efef1c$var$markEncoderMapping = new Map([
    [
        'em',
        (0, $gdFeW.em)
    ],
    [
        'strike',
        (0, $9fwgI.strike)
    ],
    [
        'strong',
        (0, $eKxrE.strong)
    ],
    [
        'subsup',
        (0, $1x55I.subsup)
    ],
    [
        'underline',
        (0, $8tKGr.underline)
    ],
    [
        'textColor',
        (0, $aDTWq.textColor)
    ],
    [
        'link',
        (0, $jo5YT.link)
    ],
    [
        'code',
        (0, $4yZSi.code)
    ]
]);
/**
 * ADFEXP-131: Improved logic for escaping metacharacters "[" and "!"
 * Before this change, any instance of "[" and "!" was being escaped
 * "[" is used for mentions
 * "!" is used for media
 */ const $774ee87c38efef1c$var$MENTION_ESCAPE_PATTERN = '(\\[~)'; // Matches pattern like [~
const $774ee87c38efef1c$var$MEDIA_ESCAPE_PATTERN = '(![^ !]+)(!)'; // Matches non space content between two consecutive "!" e.g. !filename.txt!
const $774ee87c38efef1c$var$MEDIA_GROUP_ESCAPE_PATTERN = '(\\[\\^[^ ]+)(\\])'; // Matches non space content between two consecutive "[^" "]" e.g. [^filename.txt]
/**
 * Checks if the node's content needs to be escaped before continuing processing.
 * Currently, the `code` mark and `codeBlock` nodes handle their own escaping, and
 * therefore, should not be escaped here.
 *
 * @param node the current node to encode
 * @param parent the parent node, if exist
 * @returns true if the node should have its text escaped when encoding to wikimarkup.
 */ const $774ee87c38efef1c$var$isEscapeNeeded = (node, parent)=>{
    return !(parent && parent.type.name === 'codeBlock' || node.marks.find((m)=>m.type.name === 'code') !== undefined);
};
/**
 * ESS-2569: Removing the backsalshes from the regex
 * ADFEXP-131: Improved logic for escaping metacharacters "[" and "!"
 */ function $774ee87c38efef1c$var$escapingWikiFormatter(text) {
    const pattern = [
        $774ee87c38efef1c$var$MENTION_ESCAPE_PATTERN,
        ...(0, $cG4PY.macroKeywordTokenMap).map((macro)=>`(${macro.regex.source.replace('^', '')})`)
    ].join('|');
    return text// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(new RegExp(pattern, 'g'), '\\$&')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(new RegExp($774ee87c38efef1c$var$MEDIA_ESCAPE_PATTERN, 'g'), '\\$1\\$2') // Extra step required for media as currently both ends need to be escaped e.q. !filename.txt!
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(new RegExp($774ee87c38efef1c$var$MEDIA_GROUP_ESCAPE_PATTERN, 'g'), '\\$1\\$2');
}
const $774ee87c38efef1c$export$6f093cfa640b7166 = (node, { parent: parent } = {})=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    let result = $774ee87c38efef1c$var$isEscapeNeeded(node, parent) ? $774ee87c38efef1c$var$escapingWikiFormatter(node.text) : node.text;
    $774ee87c38efef1c$var$markEncoderMapping.forEach((encoder, markName)=>{
        const mark = node.marks.find((m)=>m.type.name === markName);
        if (mark) result = encoder(result, mark.attrs);
    });
    return result;
};

});
parcelRegister("cG4PY", function(module, exports) {

$parcel$export(module.exports, "macroKeywordTokenMap", () => $87fdd6b952f97dba$export$afcd7edeca61ca93);
$parcel$export(module.exports, "parseMacroKeyword", () => $87fdd6b952f97dba$export$39c29c0b4f759e52);
$parcel$export(module.exports, "parseOtherKeyword", () => $87fdd6b952f97dba$export$ce89e528658ee2ac);
$parcel$export(module.exports, "parseLeadingKeyword", () => $87fdd6b952f97dba$export$68162fc57528b560);
$parcel$export(module.exports, "parseIssueKeyword", () => $87fdd6b952f97dba$export$bcec6d03770b152c);

var $kSL4h = parcelRequire("kSL4h");

var $ayQVO = parcelRequire("ayQVO");
const $87fdd6b952f97dba$export$afcd7edeca61ca93 = [
    {
        type: (0, $kSL4h.TokenType).ADF_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{adf/i
    },
    {
        type: (0, $kSL4h.TokenType).ANCHOR_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{anchor/i
    },
    {
        type: (0, $kSL4h.TokenType).CODE_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{code/i
    },
    {
        type: (0, $kSL4h.TokenType).QUOTE_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{quote/i
    },
    {
        type: (0, $kSL4h.TokenType).NOFORMAT_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{noformat/i
    },
    {
        type: (0, $kSL4h.TokenType).PANEL_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{panel/i
    },
    {
        type: (0, $kSL4h.TokenType).COLOR_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{color/
    },
    {
        type: (0, $kSL4h.TokenType).LOREM_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{loremipsum/i
    }
];
/**
 * The order of this mapping determind which keyword
 * will be checked first, so it matters.
 */ const $87fdd6b952f97dba$var$keywordTokenMap = {
    '[': (0, $kSL4h.TokenType).LINK_FORMAT,
    http: (0, $kSL4h.TokenType).LINK_TEXT,
    ftp: (0, $kSL4h.TokenType).LINK_TEXT,
    jamfselfservice: (0, $kSL4h.TokenType).LINK_TEXT,
    irc: (0, $kSL4h.TokenType).LINK_TEXT,
    mailto: (0, $kSL4h.TokenType).LINK_TEXT,
    '\\\\': (0, $kSL4h.TokenType).FORCE_LINE_BREAK,
    '\r': (0, $kSL4h.TokenType).HARD_BREAK,
    '\n': (0, $kSL4h.TokenType).HARD_BREAK,
    '\r\n': (0, $kSL4h.TokenType).HARD_BREAK,
    '!': (0, $kSL4h.TokenType).MEDIA,
    '----': (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
    '---': (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
    '--': (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
    '{-}': (0, $kSL4h.TokenType).DELETED,
    '{+}': (0, $kSL4h.TokenType).INSERTED,
    '{*}': (0, $kSL4h.TokenType).STRONG,
    '{^}': (0, $kSL4h.TokenType).SUPERSCRIPT,
    '{~}': (0, $kSL4h.TokenType).SUBSCRIPT,
    '{_}': (0, $kSL4h.TokenType).EMPHASIS,
    '{{{}': (0, $kSL4h.TokenType).MONOSPACE,
    '{??}': (0, $kSL4h.TokenType).CITATION,
    '-': (0, $kSL4h.TokenType).DELETED,
    '+': (0, $kSL4h.TokenType).INSERTED,
    '*': (0, $kSL4h.TokenType).STRONG,
    '^': (0, $kSL4h.TokenType).SUPERSCRIPT,
    '~': (0, $kSL4h.TokenType).SUBSCRIPT,
    _: (0, $kSL4h.TokenType).EMPHASIS,
    '{{': (0, $kSL4h.TokenType).MONOSPACE,
    '??': (0, $kSL4h.TokenType).CITATION
};
const $87fdd6b952f97dba$var$keywordTokenMapKeys = Object.keys($87fdd6b952f97dba$var$keywordTokenMap);
function $87fdd6b952f97dba$export$39c29c0b4f759e52(input) {
    for(let i = 0; i < $87fdd6b952f97dba$export$afcd7edeca61ca93.length; i++){
        const keyword = $87fdd6b952f97dba$export$afcd7edeca61ca93[i];
        if (keyword.regex.test(input)) return {
            type: keyword.type
        };
    }
    return null;
}
function $87fdd6b952f97dba$export$ce89e528658ee2ac(input) {
    for(let i = 0; i < $87fdd6b952f97dba$var$keywordTokenMapKeys.length; i++){
        if (input.startsWith($87fdd6b952f97dba$var$keywordTokenMapKeys[i])) return {
            type: $87fdd6b952f97dba$var$keywordTokenMap[$87fdd6b952f97dba$var$keywordTokenMapKeys[i]]
        };
    }
    // Look for a emoji
    const char = input.charAt(0);
    if ([
        ':',
        '(',
        ';'
    ].indexOf(char) !== -1) return {
        // This potentially can be a emoji. The emoji parser will fail out if it's not
        type: (0, $kSL4h.TokenType).EMOJI
    };
    return null;
}
/**
 * These keywords only take effect when it's at the
 * beginning of the line
 * The order of the mapping matters. We should not put
 * LIST in front of RULER for example.
 */ const $87fdd6b952f97dba$var$leadingKeywordTokenMap = [
    {
        type: (0, $kSL4h.TokenType).QUOTE,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^bq\./
    },
    {
        type: (0, $kSL4h.TokenType).HEADING,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^h[1-6]\./
    },
    {
        type: (0, $kSL4h.TokenType).RULER,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^-{4,5}(\s|$)/
    },
    {
        type: (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^-{3}\s/
    },
    {
        type: (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^-{2}\s/
    },
    {
        // Lists are limited to max 20 levels of depth
        type: (0, $kSL4h.TokenType).LIST,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: new RegExp(`^([*#]{1,${(0, $ayQVO.MAX_LIST_DEPTH)}}|-) `)
    },
    {
        type: (0, $kSL4h.TokenType).TABLE,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^\|{1,2}/
    }
];
function $87fdd6b952f97dba$export$68162fc57528b560(input) {
    for(let i = 0; i < $87fdd6b952f97dba$var$leadingKeywordTokenMap.length; i++){
        const keyword = $87fdd6b952f97dba$var$leadingKeywordTokenMap[i];
        if (keyword.regex.test(input)) return {
            type: keyword.type
        };
    }
    return null;
}
function $87fdd6b952f97dba$export$bcec6d03770b152c(input, issueKeyRegex) {
    if (issueKeyRegex && issueKeyRegex.test(input)) return {
        type: (0, $kSL4h.TokenType).ISSUE_KEY
    };
    return null;
}

});
parcelRegister("kSL4h", function(module, exports) {

$parcel$export(module.exports, "TokenType", () => $160d182608400c84$export$f435f793048e7a0f);
$parcel$export(module.exports, "parseToken", () => $160d182608400c84$export$af8f4e8328578827);

var $4Foyv = parcelRequire("4Foyv");

var $30Un5 = parcelRequire("30Un5");

var $coK8g = parcelRequire("coK8g");

var $5RdHN = parcelRequire("5RdHN");

var $55t1E = parcelRequire("55t1E");

var $jor5q = parcelRequire("jor5q");

var $hZ14o = parcelRequire("hZ14o");

var $6xaH8 = parcelRequire("6xaH8");

var $jMpI6 = parcelRequire("jMpI6");

var $iDsRr = parcelRequire("iDsRr");

var $7tIdE = parcelRequire("7tIdE");

var $1MGc3 = parcelRequire("1MGc3");

var $ayQVO = parcelRequire("ayQVO");

var $kPrK8 = parcelRequire("kPrK8");

var $4ZFIG = parcelRequire("4ZFIG");

var $91y57 = parcelRequire("91y57");

var $1Mtv8 = parcelRequire("1Mtv8");

var $77w3e = parcelRequire("77w3e");

var $lf0Nr = parcelRequire("lf0Nr");

var $4s89q = parcelRequire("4s89q");

var $ir9MO = parcelRequire("ir9MO");

var $7E14k = parcelRequire("7E14k");

var $9MeiU = parcelRequire("9MeiU");

var $f50H1 = parcelRequire("f50H1");

var $bSil4 = parcelRequire("bSil4");

var $4Dfwq = parcelRequire("4Dfwq");

var $cjZPi = parcelRequire("cjZPi");

var $8tGpW = parcelRequire("8tGpW");

var $lyI5i = parcelRequire("lyI5i");

var $bOMPB = parcelRequire("bOMPB");
var $160d182608400c84$export$f435f793048e7a0f = /*#__PURE__*/ function(TokenType) {
    TokenType["ADF_MACRO"] = "ADF_MACRO";
    TokenType["ANCHOR_MACRO"] = "ANCHOR_MACRO";
    TokenType["CODE_MACRO"] = "CODE_MACRO";
    TokenType["QUOTE_MACRO"] = "QUOTE_MACRO";
    TokenType["NOFORMAT_MACRO"] = "NOFORMAT_MACRO";
    TokenType["PANEL_MACRO"] = "PANEL_MACRO";
    TokenType["COLOR_MACRO"] = "COLOR_MACRO";
    TokenType["LOREM_MACRO"] = "LOREM_MACRO";
    TokenType["QUOTE"] = "QUOTE";
    TokenType["STRING"] = "STRING";
    TokenType["ISSUE_KEY"] = "ISSUE_KEY";
    TokenType["LINK_FORMAT"] = "LINK_FORMAT";
    TokenType["LINK_TEXT"] = "LINK_TEXT";
    TokenType["MEDIA"] = "MEDIA";
    TokenType["HEADING"] = "HEADING";
    TokenType["LIST"] = "LIST";
    TokenType["TABLE"] = "TABLE";
    TokenType["RULER"] = "RULER";
    TokenType["HARD_BREAK"] = "HARD_BREAK";
    TokenType["DOUBLE_DASH_SYMBOL"] = "DOUBLE_DASH_SYMBOL";
    TokenType["TRIPLE_DASH_SYMBOL"] = "TRIPLE_DASH_SYMBOL";
    TokenType["QUADRUPLE_DASH_SYMBOL"] = "QUADRUPLE_DASH_SYMBOL";
    TokenType["STRONG"] = "STRONG";
    TokenType["MONOSPACE"] = "MONOSPACE";
    TokenType["SUPERSCRIPT"] = "SUPERSCRIPT";
    TokenType["SUBSCRIPT"] = "SUBSCRIPT";
    TokenType["EMPHASIS"] = "EMPHASIS";
    TokenType["CITATION"] = "CITATION";
    TokenType["DELETED"] = "DELETED";
    TokenType["INSERTED"] = "INSERTED";
    TokenType["EMOJI"] = "EMOJI";
    TokenType["FORCE_LINE_BREAK"] = "FORCE_LINE_BREAK";
    return TokenType;
}({});
const $160d182608400c84$var$tokenToTokenParserMapping = {
    ["DOUBLE_DASH_SYMBOL"]: (0, $55t1E.doubleDashSymbol),
    ["TRIPLE_DASH_SYMBOL"]: (0, $ir9MO.tripleDashSymbol),
    ["QUADRUPLE_DASH_SYMBOL"]: (0, $4ZFIG.quadrupleDashSymbol),
    ["RULER"]: (0, $91y57.ruler),
    ["STRONG"]: (0, $1Mtv8.strong),
    ["MONOSPACE"]: (0, $kPrK8.monospace),
    ["SUPERSCRIPT"]: (0, $lf0Nr.superscript),
    ["SUBSCRIPT"]: (0, $77w3e.subscript),
    ["EMPHASIS"]: (0, $hZ14o.emphasis),
    ["CITATION"]: (0, $coK8g.citation),
    ["DELETED"]: (0, $5RdHN.deleted),
    ["INSERTED"]: (0, $iDsRr.inserted),
    ["HARD_BREAK"]: (0, $6xaH8.hardbreak),
    ["LINK_FORMAT"]: (0, $7tIdE.linkFormat),
    ["LINK_TEXT"]: (0, $1MGc3.linkText),
    ["HEADING"]: (0, $jMpI6.heading),
    ["MEDIA"]: (0, $4Foyv.media),
    ["LIST"]: (0, $ayQVO.list),
    ["QUOTE"]: (0, $30Un5.blockquote),
    ["TABLE"]: (0, $4s89q.table),
    ["EMOJI"]: (0, $jor5q.emoji),
    ["ADF_MACRO"]: (0, $9MeiU.adfMacro),
    ["ANCHOR_MACRO"]: (0, $f50H1.anchorMacro),
    ["CODE_MACRO"]: (0, $bSil4.codeMacro),
    ["QUOTE_MACRO"]: (0, $4Dfwq.quoteMacro),
    ["NOFORMAT_MACRO"]: (0, $8tGpW.noformatMacro),
    ["PANEL_MACRO"]: (0, $7E14k.panelMacro),
    ["COLOR_MACRO"]: (0, $cjZPi.colorMacro),
    ["FORCE_LINE_BREAK"]: (0, $lyI5i.forceLineBreak),
    ["ISSUE_KEY"]: (0, $bOMPB.issueKey)
};
function $160d182608400c84$export$af8f4e8328578827(input, type, position, schema, context) {
    const tokenParser = $160d182608400c84$var$tokenToTokenParserMapping[type];
    if (tokenParser) try {
        return tokenParser({
            input: input,
            position: position,
            schema: schema,
            context: context
        });
    } catch (err) {
        if (context.tokenErrCallback && err instanceof Error) context.tokenErrCallback(err, type);
        return $160d182608400c84$var$fallback(input, position);
    }
    return $160d182608400c84$var$fallback(input, position);
}
function $160d182608400c84$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("4Foyv", function(module, exports) {

$parcel$export(module.exports, "media", () => $8b246e16d82e8dde$export$987d49ffe1b0900f);

var $4V377 = parcelRequire("4V377");

var $4ZUg7 = parcelRequire("4ZUg7");

var $eyO0H = parcelRequire("eyO0H");
const $8b246e16d82e8dde$export$987d49ffe1b0900f = ({ input: input, position: position, schema: schema, context: context })=>{
    const rawContentProcessor = (raw, length)=>{
        /**
		 * !image.gif|align=right, vspace=4|ignore-this!
		 * If it splits into more than 2 items, we ignore the rest
		 */ const [rawContent, rawAttrs = ''] = raw.split('|');
        const node = (0, $4V377.default)(schema, rawContent, (0, $4ZUg7.parseAttrs)(rawAttrs, ','), context);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    };
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: '!',
        closing: '!',
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});
parcelRegister("4V377", function(module, exports) {

$parcel$export(module.exports, "default", () => $2106e5f40786af56$export$2e2bcd8739ae039);

var $1MGc3 = parcelRequire("1MGc3");
const $2106e5f40786af56$var$defaultWidth = 200;
const $2106e5f40786af56$var$defaultHeight = 183;
const $2106e5f40786af56$var$clamp = (input, lower, upper)=>{
    if (upper !== undefined) input = input <= upper ? input : upper;
    if (lower !== undefined) input = input >= lower ? input : lower;
    return input;
};
function $2106e5f40786af56$export$2e2bcd8739ae039(schema, filename, attrs, context = {}) {
    const { media: media, mediaSingle: mediaSingle } = schema.nodes;
    const { link: link } = schema.marks;
    const mediaMarks = [];
    let mediaNodeAttrs = {};
    if (context?.defaults?.media?.width !== null) mediaNodeAttrs.width = context?.defaults?.media?.width ?? $2106e5f40786af56$var$defaultWidth;
    if (context?.defaults?.media?.height !== null) mediaNodeAttrs.height = context?.defaults?.media?.height ?? $2106e5f40786af56$var$defaultHeight;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mediaSingleAttrs = {
        layout: 'center'
    };
    if (attrs.width && attrs.width.endsWith('%')) {
        const parsed = parseInt(attrs.width, 10);
        if (!isNaN(parsed)) mediaSingleAttrs.width = $2106e5f40786af56$var$clamp(parsed, 0, 100);
        mediaNodeAttrs = {};
    } else {
        if (attrs.width) {
            const parsed = parseInt(attrs.width, 10);
            if (!isNaN(parsed)) mediaNodeAttrs.width = parsed;
        }
        if (attrs.height) {
            const parsed = parseInt(attrs.height, 10);
            if (!isNaN(parsed)) mediaNodeAttrs.height = parsed;
        }
    }
    if (attrs.href) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const href = attrs.href.replace(/^"(.+)"$/, '$1');
        mediaMarks.push(link.create({
            href: href
        }));
    }
    if (attrs.alt) {
        // strip wrapping quotes if they exist
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const altText = attrs.alt.replace(/^"(.+)"$/, '$1');
        mediaNodeAttrs.alt = altText;
    }
    if (filename.match((0, $1MGc3.LINK_TEXT_REGEXP))) {
        const externalMediaNode = media.createChecked({
            type: 'external',
            url: filename,
            ...mediaNodeAttrs
        }, undefined, mediaMarks);
        return mediaSingle.createChecked(mediaSingleAttrs, externalMediaNode);
    } else {
        // try to look up media ID from conversion context
        const id = context?.conversion?.mediaConversion?.[filename]?.transform ?? filename;
        // try to look up collection from media context
        const collection = context.hydration && context.hydration.media && context.hydration.media.targetCollectionId;
        const mediaNode = media.createChecked({
            id: id,
            type: 'file',
            collection: collection || '',
            ...mediaNodeAttrs
        }, undefined, mediaMarks);
        return mediaSingle.createChecked(mediaSingleAttrs, mediaNode);
    }
}

});
parcelRegister("1MGc3", function(module, exports) {

$parcel$export(module.exports, "LINK_TEXT_REGEXP", () => $49f89f13b4b7c481$export$f69d1dce349473aa);
$parcel$export(module.exports, "linkText", () => $49f89f13b4b7c481$export$cb7bcf09a05b7705);

var $iZOJ9 = parcelRequire("iZOJ9");

var $iqYHB = parcelRequire("iqYHB");
const $49f89f13b4b7c481$export$f69d1dce349473aa = // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
/^((?:(?:https?|ftps?):\/\/)|irc:\/\/|mailto:)([\w?!~^\/\\#$%&'()*+,\-.\/:;<=@]*[\w~^\/\\#$%&'()*+,\-\/:;<=@])/i;
const $49f89f13b4b7c481$export$cb7bcf09a05b7705 = ({ input: input, position: position, schema: schema })=>{
    const matches = input.substring(position).match($49f89f13b4b7c481$export$f69d1dce349473aa);
    if (!matches) return $49f89f13b4b7c481$var$fallback(input, position);
    const match = $49f89f13b4b7c481$var$trimBadEndChar(matches);
    // Remove mailto:
    const textRepresentation = match[1] === 'mailto:' ? match[2] : match[0];
    // parse and correctly encode any illegal characters, and
    // so no longer need to be encoded when used below
    const url = (0, $iqYHB.decode)($49f89f13b4b7c481$var$unescape(match[0]));
    if (!(0, $iZOJ9.isSafeUrl)(url)) return $49f89f13b4b7c481$var$fallback(input, position);
    const mark = schema.marks.link.create({
        href: url
    });
    const textNode = schema.text(textRepresentation, [
        mark
    ]);
    return {
        type: 'pmnode',
        nodes: [
            textNode
        ],
        length: match[0].length
    };
};
function $49f89f13b4b7c481$var$unescape(url) {
    let result = '';
    for(let i = 0; i < url.length; i++){
        const char = url[i];
        if (char !== '\\') {
            result += char;
            continue;
        }
        const nextChar = url[i + 1];
        if (nextChar) {
            result += nextChar;
            i++;
        }
    }
    return result;
}
function $49f89f13b4b7c481$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}
// removes bad characters from the end of regex match
function $49f89f13b4b7c481$var$trimBadEndChar(input) {
    return [
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        input[0].replace(/[.,>)\];}"\'!]*$/, ''),
        input[1],
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        input[2].replace(/[.,>)\];}"\'!]*$/, '')
    ];
}

});
parcelRegister("iqYHB", function(module, exports) {

$parcel$export(module.exports, "decode", () => $c6b4ec3136742c55$export$2f872c0f2117be69);
/**
 * returns a correctly percent-encoded & sanitized url.
 * Will fallback to using a DOM based implementation if the `URL` class
 * doesn't exist.
 *
 * @param raw a 'raw' url (possibly mixed percent-encoded).
 */ function $c6b4ec3136742c55$export$2f872c0f2117be69(raw) {
    if (typeof URL === 'function') {
        const decoded = new URL(raw);
        // IE11 doesn't support the `href` property in the `URL` class.
        // Fallback to the DOM below if it doesn't exist.
        if (decoded.href) return decoded.href;
    }
    // no `URL` class - pollyfill using the dom to parse and
    // decode. This should only be needed for IE11 or lower...
    const anchor = document.createElement('a');
    anchor.href = raw; // The DOM will parses even mixed %-encoded segments of a url when set.
    return anchor.href;
}

});



parcelRegister("4ZUg7", function(module, exports) {

$parcel$export(module.exports, "parseAttrs", () => $972abf9f01734b21$export$e1a9355cfd8f6c64);
function $972abf9f01734b21$export$e1a9355cfd8f6c64(str, sep = '|') {
    const output = {};
    if (!str) return output;
    const attributesStr = str.split(sep);
    attributesStr.forEach((attributeStr)=>{
        const [key, ...value] = attributeStr.split('=');
        // take only first value of the same keys
        if (!output[key]) output[key] = value.join('=');
    });
    return output;
}

});

parcelRegister("eyO0H", function(module, exports) {

$parcel$export(module.exports, "commonFormatter", () => $dee2bdf3f1017b16$export$a71d57024d3da1c5);

var $kSL4h = parcelRequire("kSL4h");

var $7tIdE = parcelRequire("7tIdE");

var $eWAZI = parcelRequire("eWAZI");

var $cG4PY = parcelRequire("cG4PY");

var $2weJO = parcelRequire("2weJO");
const $dee2bdf3f1017b16$var$processState = {
    START: 0,
    BUFFER: 1,
    END: 2,
    INLINE_MACRO: 3,
    LINK_FORMAT: 4,
    ESCAPE: 5
};
function $dee2bdf3f1017b16$export$a71d57024d3da1c5(input, position, schema, opt) {
    let index = position;
    let state = $dee2bdf3f1017b16$var$processState.START;
    const buffer = [];
    const openingSymbolLength = opt.opening.length;
    const closingSymbolLength = opt.closing.length;
    const openingWrapped = opt.opening.startsWith('{') && opt.opening.endsWith('}');
    const closingWrapped = opt.closing.startsWith('{') && opt.closing.endsWith('}');
    while(index < input.length){
        const char = input.charAt(index);
        const twoChar = input.substr(index, 2);
        const charsMatchClosingSymbol = input.substr(index, closingSymbolLength);
        switch(state){
            case $dee2bdf3f1017b16$var$processState.START:
                {
                    if (position > 0) {
                        /**
					 * If the previous char is a alphanumeric, then it's not a valid
					 * formatter
					 */ const charBeforeOpening = input.charAt(position - 1);
                        if (!openingWrapped && // Ignored via go/ees005
                        // eslint-disable-next-line require-unicode-regexp
                        /[a-zA-Z0-9]|[^\u0000-\u007F]/.test(charBeforeOpening) && charBeforeOpening !== '\u00A0') return $dee2bdf3f1017b16$var$fallback(input, index, openingSymbolLength);
                    }
                    const charAfterOpening = input.charAt(index + openingSymbolLength);
                    if (!input.substring(position).startsWith(opt.opening) || charAfterOpening === ' ') // this is not a valid formatter mark
                    return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                    state = $dee2bdf3f1017b16$var$processState.BUFFER;
                    index += openingSymbolLength;
                    continue;
                }
            case $dee2bdf3f1017b16$var$processState.BUFFER:
                {
                    // the linebreak would break the strong marks
                    const length = (0, $eWAZI.parseNewlineOnly)(input.substring(index));
                    if (length) return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                    if (charsMatchClosingSymbol === opt.closing) {
                        state = $dee2bdf3f1017b16$var$processState.END;
                        continue;
                    } else if (twoChar === '{{') {
                        // this is a monospace
                        buffer.push(twoChar);
                        index += 2;
                        continue;
                    } else if (char === '{') {
                        state = $dee2bdf3f1017b16$var$processState.INLINE_MACRO;
                        continue;
                    } else if (char === '[') {
                        state = $dee2bdf3f1017b16$var$processState.LINK_FORMAT;
                        continue;
                    } else if (char === '\\') {
                        state = $dee2bdf3f1017b16$var$processState.ESCAPE;
                        continue;
                    } else buffer.push(char);
                    break;
                }
            case $dee2bdf3f1017b16$var$processState.END:
                index += closingSymbolLength;
                // empty formatter mark is treated as normal text
                if (buffer.length === 0) return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                /**
				 * If the closing symbol is followed by a alphanumeric, it's
				 * not a valid formatter, and we keep looking for
				 * next valid closing formatter.
				 * ESS-1402: checking for the non-breaking space after closing symbol.
				 */ if (index < input.length) {
                    const charAfterEnd = input.charAt(index);
                    if (!closingWrapped && // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    /[a-zA-Z0-9]|[^\u0000-\u007F]/.test(charAfterEnd) && charAfterEnd !== '\u00A0') {
                        buffer.push(charsMatchClosingSymbol);
                        state = $dee2bdf3f1017b16$var$processState.BUFFER;
                        continue;
                    }
                }
                /**
				 * If the closing symbol has an empty space before it,
				 * it's not a valid formatter
				 */ if (buffer.length > 0 && buffer[buffer.length - 1].endsWith(' ')) return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                return opt.rawContentProcessor(buffer.join(''), index - position);
            case $dee2bdf3f1017b16$var$processState.INLINE_MACRO:
                {
                    const match = (0, $cG4PY.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        state = $dee2bdf3f1017b16$var$processState.BUFFER;
                        break;
                    }
                    /**
				 * Is not a problem send an empty context because we're only checking
				 * if it has a nested macro inside.
				 */ const token = (0, $kSL4h.parseToken)(input, match.type, index, schema, {});
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        state = $dee2bdf3f1017b16$var$processState.BUFFER;
                        continue;
                    } else if (match.type === (0, $kSL4h.TokenType).COLOR_MACRO) {
                        /**
					 * {color} is valid in formatter, we simply jump over the length
					 */ buffer.push(input.substr(index, token.length));
                        index += token.length;
                        state = $dee2bdf3f1017b16$var$processState.BUFFER;
                        continue;
                    } else // No macro are accepted in formater
                    return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                }
            case $dee2bdf3f1017b16$var$processState.LINK_FORMAT:
                {
                    /**
				 * We should "fly over" the link format and we dont want
				 * -awesome [link|https://www.atlass-ian.com] nice
				 * to be a strike through because of the '-' in link
				 *
				 * Also, is not a problem send an empty context because we're only
				 * checking if it has a nested macro inside.
				 */ const token = (0, $7tIdE.linkFormat)({
                        input: input,
                        schema: schema,
                        position: index,
                        context: {}
                    });
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        state = $dee2bdf3f1017b16$var$processState.BUFFER;
                        continue;
                    } else if (token.type === 'pmnode') {
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        state = $dee2bdf3f1017b16$var$processState.BUFFER;
                        continue;
                    }
                    return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                }
            case $dee2bdf3f1017b16$var$processState.ESCAPE:
                {
                    const token = (0, $2weJO.escapeHandler)(input, index);
                    buffer.push(token.text);
                    index += token.length;
                    state = $dee2bdf3f1017b16$var$processState.BUFFER;
                    continue;
                }
            default:
        }
        index++;
    }
    return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
}
function $dee2bdf3f1017b16$var$fallback(input, position, length) {
    return {
        type: 'text',
        text: input.substr(position, length),
        length: length
    };
}

});
parcelRegister("7tIdE", function(module, exports) {

$parcel$export(module.exports, "linkFormat", () => $0412731f8f85cc95$export$e1f888a4b6f2ee53);

var $kSL4h = parcelRequire("kSL4h");

var $29zBb = parcelRequire("29zBb");

var $9jjzg = parcelRequire("9jjzg");

var $gGleW = parcelRequire("gGleW");
// [http://www.example.com] and [Example|http://www.example.com]
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $0412731f8f85cc95$var$LINK_FORMAT_REGEXP = /^\[([^\[\]\n]+)]/;
const $0412731f8f85cc95$export$e1f888a4b6f2ee53 = ({ input: input, position: position, schema: schema, context: context })=>{
    const match = input.substring(position).match($0412731f8f85cc95$var$LINK_FORMAT_REGEXP);
    /**
	 * The following token types will be ignored in parsing
	 * the content of a table cell
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TABLE,
        (0, $kSL4h.TokenType).RULER,
        // We want to avoid recursion
        (0, $kSL4h.TokenType).LINK_TEXT,
        (0, $kSL4h.TokenType).LINK_FORMAT
    ];
    if (!match) return $0412731f8f85cc95$var$fallback();
    const content = (0, $gGleW.parseContentLink)(match[1]);
    const resolvedLink = (0, $9jjzg.resolveLink)(content, schema, context);
    if (resolvedLink) return resolvedLink;
    const nodes = (0, $29zBb.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: ignoreTokenTypes,
        input: match[0]
    });
    return {
        type: 'pmnode',
        nodes: nodes,
        length: match[0].length
    };
};
function $0412731f8f85cc95$var$fallback() {
    return {
        type: 'text',
        text: '[',
        length: 1
    };
}

});
parcelRegister("29zBb", function(module, exports) {

$parcel$export(module.exports, "parseString", () => $e7a948cf285a18ed$export$960addfb9e5a0cde);

var $04cDS = parcelRequire("04cDS");

var $cG4PY = parcelRequire("cG4PY");

var $kSL4h = parcelRequire("kSL4h");

var $eWAZI = parcelRequire("eWAZI");

var $2weJO = parcelRequire("2weJO");

var $20lXC = parcelRequire("20lXC");
const $e7a948cf285a18ed$var$processState = {
    NEWLINE: 0,
    BUFFER: 1,
    TOKEN: 2,
    ESCAPE: 3
};
function $e7a948cf285a18ed$export$960addfb9e5a0cde({ input: input, schema: schema, ignoreTokenTypes: ignoreTokenTypes = [], context: context, includeLeadingSpace: includeLeadingSpace = false }) {
    let index = 0;
    let state = $e7a948cf285a18ed$var$processState.NEWLINE;
    let buffer = [];
    let tokenType = (0, $kSL4h.TokenType).STRING;
    let newLines = [];
    const output = [];
    let inlineNodes = [];
    while(index < input.length){
        const char = input.charAt(index);
        switch(state){
            case $e7a948cf285a18ed$var$processState.NEWLINE:
                {
                    /**
				 * During this state, the parser will trim leading
				 * spaces and looking for any leading keywords.
				 */ const substring = input.substring(index);
                    const length = (0, $eWAZI.parseWhitespaceOnly)(substring);
                    if (length) {
                        index += length;
                        if (includeLeadingSpace) buffer.push(char);
                        continue;
                    }
                    const match = (0, $cG4PY.parseLeadingKeyword)(substring) || (0, $cG4PY.parseMacroKeyword)(substring) || (0, $cG4PY.parseOtherKeyword)(substring) || (0, $cG4PY.parseIssueKeyword)(substring, context.issueKeyRegex);
                    if (match && ignoreTokenTypes.indexOf(match.type) === -1) {
                        tokenType = match.type;
                        state = $e7a948cf285a18ed$var$processState.TOKEN;
                        continue;
                    } else {
                        state = $e7a948cf285a18ed$var$processState.BUFFER;
                        continue;
                    }
                }
            case $e7a948cf285a18ed$var$processState.BUFFER:
                {
                    /**
				 * During this state, the parser will start
				 * saving plaintext into the buffer until it hits
				 * a keyword
				 */ const substring = input.substring(index);
                    /**
				 * If the previous char is not a alphanumeric, we will parse
				 * format keywords.
				 * If the previous char is '{', we need to skip parse macro
				 * keyword
				 */ let match = null;
                    if (buffer.length > 0 && buffer[buffer.length - 1].endsWith('{')) match = (0, $cG4PY.parseOtherKeyword)(substring);
                    else match = (0, $cG4PY.parseMacroKeyword)(substring) || (0, $cG4PY.parseOtherKeyword)(substring) || (0, $cG4PY.parseIssueKeyword)(substring, context.issueKeyRegex);
                    if (match && ignoreTokenTypes.indexOf(match.type) === -1) {
                        tokenType = match.type;
                        state = $e7a948cf285a18ed$var$processState.TOKEN;
                        continue;
                    }
                    if (char === '\\') {
                        state = $e7a948cf285a18ed$var$processState.ESCAPE;
                        continue;
                    }
                    buffer.push(char);
                    break;
                }
            case $e7a948cf285a18ed$var$processState.TOKEN:
                {
                    const token = (0, $kSL4h.parseToken)(input, tokenType, index, schema, context);
                    if (token.type === 'text') buffer.push(token.text);
                    else if (token.type === 'pmnode') {
                        /*ESS-2539 We are keeping track of consecutive newLines in the newLines array
            Whenever more than two consecutive newLines are encountered, we start a new paragraph
          */ if (newLines.length >= 2 && (tokenType !== (0, $kSL4h.TokenType).HARD_BREAK || buffer.length > 0)) {
                            output.push(...(0, $20lXC.normalizePMNodes)(inlineNodes, schema));
                            // push newLines to the buffer as a separator between media nodes
                            inlineNodes = $e7a948cf285a18ed$var$isConsecutiveMediaGroups(inlineNodes, token.nodes) ? [
                                ...newLines
                            ] : [];
                            newLines = [];
                        }
                        if (inlineNodes.length === 0) newLines = [];
                        if (newLines.length > 0 && $e7a948cf285a18ed$var$isNewLineRequiredBetweenNodes(inlineNodes, buffer, token.nodes)) {
                            inlineNodes.push(...newLines);
                            newLines = [];
                        }
                        inlineNodes.push(...(0, $04cDS.createTextNode)(buffer.join(''), schema));
                        if (tokenType === (0, $kSL4h.TokenType).HARD_BREAK) newLines.push(...token.nodes);
                        else {
                            inlineNodes.push(...token.nodes);
                            if (token.nodes.length > 0) newLines = [];
                        }
                        buffer = []; // clear the buffer
                    }
                    index += token.length;
                    if (tokenType === (0, $kSL4h.TokenType).HARD_BREAK) state = $e7a948cf285a18ed$var$processState.NEWLINE;
                    else state = $e7a948cf285a18ed$var$processState.BUFFER;
                    continue;
                }
            case $e7a948cf285a18ed$var$processState.ESCAPE:
                {
                    const token = (0, $2weJO.escapeHandler)(input, index);
                    buffer.push(token.text);
                    index += token.length;
                    state = $e7a948cf285a18ed$var$processState.BUFFER;
                    continue;
                }
            default:
        }
        index++;
    }
    const bufferedStr = buffer.join('');
    if (bufferedStr.length > 0) {
        // Wrapping the rest of the buffer into a text node
        if (newLines.length >= 2) {
            // normalize the nodes already parsed if more than two consecutive newLines are encountered
            output.push(...(0, $20lXC.normalizePMNodes)(inlineNodes, schema));
            inlineNodes = [];
            newLines = [];
        }
        if (newLines.length > 0 && inlineNodes.length > 0 && !inlineNodes[inlineNodes.length - 1].isBlock) inlineNodes.push(...newLines);
        inlineNodes.push(...(0, $04cDS.createTextNode)(bufferedStr, schema));
    }
    return [
        ...output,
        ...inlineNodes
    ];
}
/* checks whether a newLine is required between two consecutive nodes
   Returns true for inline nodes, false for block nodes
*/ function $e7a948cf285a18ed$var$isNewLineRequiredBetweenNodes(currentNodes, buffer, nextNodes) {
    if (currentNodes.length === 0) return false;
    if (buffer.length > 0 && currentNodes[currentNodes.length - 1]?.isBlock) return false;
    if (buffer.length === 0) {
        if (nextNodes.length === 0) return false;
        if (nextNodes[0]?.type.name === 'hardBreak') return false;
        if (nextNodes[0]?.isBlock || currentNodes[currentNodes.length - 1]?.isBlock) return false;
    }
    return true;
}
function $e7a948cf285a18ed$var$isConsecutiveMediaGroups(currentNodes, nextNodes) {
    return currentNodes.length > 0 && currentNodes[currentNodes.length - 1]?.type.name === 'mediaGroup' && nextNodes[0]?.type.name === 'mediaGroup';
}

});
parcelRegister("04cDS", function(module, exports) {

$parcel$export(module.exports, "createTextNode", () => $e67b0538295ca231$export$b2ce9ad90858ed7a);
function $e67b0538295ca231$export$b2ce9ad90858ed7a(input, schema, marks) {
    if (input === '') return [];
    const node = schema.text(input, marks || []);
    return [
        node
    ];
}

});

parcelRegister("eWAZI", function(module, exports) {

$parcel$export(module.exports, "parseNewlineOnly", () => $b3a19bb1e901f2d4$export$1b7a83d725c8acf);
$parcel$export(module.exports, "parseWhitespaceOnly", () => $b3a19bb1e901f2d4$export$9c597b035e16623b);
function $b3a19bb1e901f2d4$export$877995a80ec11782(input) {
    const newlineLength = $b3a19bb1e901f2d4$export$1b7a83d725c8acf(input);
    if (newlineLength) return newlineLength;
    const whitespaceLength = $b3a19bb1e901f2d4$export$9c597b035e16623b(input);
    if (whitespaceLength) return whitespaceLength;
    // There is nether whitespace nor newline
    return 0;
}
function $b3a19bb1e901f2d4$export$9c597b035e16623b(input) {
    let index = 0;
    const char = input.charAt(index);
    if (char === '\t' || char === ' ') index++;
    return index;
}
function $b3a19bb1e901f2d4$export$1b7a83d725c8acf(input) {
    let index = 0;
    const char = input.charAt(index);
    if (char === '\r') {
        // CR (Unix)
        index++;
        if (input.charAt(index) === '\n') // CRLF (Windows)
        index++;
    } else if (char === '\n') // LF (MacOS)
    index++;
    return index;
}

});

parcelRegister("2weJO", function(module, exports) {

$parcel$export(module.exports, "escapeHandler", () => $35d0c4c2d3000f41$export$d16e8e6cf9622f9a);
/**
 * In Jira, following characters are escaped
 * private static final Pattern ESCAPING_PATTERN = Pattern.compile("(^|(?<!\\\\))\\\\([\\-\\#\\*\\_\\+\\?\\^\\~\\|\\%\\{\\}\\[\\]\\(\\)\\!\\@])");
 * https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-renderer/src/main/java/com/atlassian/renderer/v2/components/BackslashEscapeRendererComponent.java
 */ const $35d0c4c2d3000f41$var$escapedChar = [
    '-',
    '#',
    '*',
    '_',
    '+',
    '?',
    '^',
    '~',
    '|',
    '%',
    '{',
    '}',
    '[',
    ']',
    '(',
    ')',
    '!',
    '@'
];
function $35d0c4c2d3000f41$export$d16e8e6cf9622f9a(input, position) {
    const buffer = [];
    const char = input.charAt(position);
    const prevChar = input.charAt(position - 1);
    const nextChar = input.charAt(position + 1);
    /**
	 * Ported from Jira:
	 * If previous char is also a backslash, then this is not a valid escape
	 */ if ($35d0c4c2d3000f41$var$escapedChar.indexOf(nextChar) === -1 || prevChar === '\\') // Insert \ in buffer mode
    buffer.push(char);
    buffer.push(nextChar);
    return {
        type: 'text',
        text: buffer.join(''),
        length: 2
    };
}

});

parcelRegister("20lXC", function(module, exports) {

$parcel$export(module.exports, "normalizePMNodes", () => $50669f552f016dd9$export$e21f6b7efdaf8b5d);

var $4UJvN = parcelRequire("4UJvN");
function $50669f552f016dd9$export$e21f6b7efdaf8b5d(nodes, schema, parentNode) {
    return [
        $50669f552f016dd9$var$normalizeMediaGroups,
        $50669f552f016dd9$export$2cef2a4c047f9887,
        $50669f552f016dd9$export$cd936b894f116ed8
    ].reduce((currentNodes, normFunc)=>normFunc(currentNodes, schema, parentNode), nodes);
}
function $50669f552f016dd9$export$2cef2a4c047f9887(nodes, schema, parentNode) {
    // When we round-trip through ADF - WikiMarkup - ADF, expands get replaced by strong text.
    // That would result in the nested expand being in an invalid situation as it's no longer
    // nested in either a table or expand
    // This solves the issue for nested expands that sit in the root, which should cover every
    // case for Jira software
    const output = [];
    for (const node of nodes)if (node?.type?.name === 'nestedExpand' && parentNode === 'doc') output.push($50669f552f016dd9$var$convertNodeToExpand(node, schema));
    else output.push(node);
    return output;
}
function $50669f552f016dd9$export$cd936b894f116ed8(nodes, schema, _parentNode) {
    const output = [];
    let inlineNodeBuffer = [];
    for (const node of nodes){
        if (!node.isBlock) {
            inlineNodeBuffer.push(node);
            continue;
        }
        if (inlineNodeBuffer.length > 0) output.push(...(0, $4UJvN.createParagraphNodeFromInlineNodes)(inlineNodeBuffer, schema));
        inlineNodeBuffer = []; // clear buffer
        output.push(node);
    }
    if (inlineNodeBuffer.length > 0) output.push(...(0, $4UJvN.createParagraphNodeFromInlineNodes)(inlineNodeBuffer, schema));
    if (output.length === 0) return [
        (0, $4UJvN.createEmptyParagraphNode)(schema)
    ];
    return output;
}
/**
 * Normalize the list of the given nodes for media groups.
 * The rule is: if there are consecutive media group nodes (each with a single child media
 * node) separated by any space or a single newline, then merge them into one media group
 * with multiple child media nodes.
 * @param nodes list of nodes to normalize. Must not be null
 * @param schema
 */ function $50669f552f016dd9$var$normalizeMediaGroups(nodes, schema, _parentNode) {
    const output = [];
    let mediaGroupBuffer = [];
    let separatorBuffer = [];
    for (const n of nodes){
        if (n.type.name === 'mediaGroup' && n.childCount === 1) {
            mediaGroupBuffer.push(n);
            //separator buffer keeps track of the seperator(s) between each mediaGroup nodes,
            //so needs resetting every time we encounter a new mediaGroup node
            separatorBuffer = [];
            continue;
        }
        if (mediaGroupBuffer.length > 0) {
            if ($50669f552f016dd9$var$isSignificantSeparatorNode(n, separatorBuffer)) {
                output.push($50669f552f016dd9$var$createMergedMediaGroup(mediaGroupBuffer, schema));
                output.push(...separatorBuffer);
                output.push(n);
                mediaGroupBuffer = [];
                separatorBuffer = [];
            } else separatorBuffer.push(n);
            continue;
        }
        output.push(n);
    }
    if (mediaGroupBuffer.length > 0) output.push($50669f552f016dd9$var$createMergedMediaGroup(mediaGroupBuffer, schema));
    // Dump everything else from separator buffer if anything is left
    output.push(...separatorBuffer);
    return output;
}
/**
 * Creates a single mediaGroup whose children are the single media elements from the given mediaGroupNodes.
 * @param mediaGroupNodes list of mediaGroups that have a single child each
 * @param schema the schema
 */ function $50669f552f016dd9$var$createMergedMediaGroup(mediaGroupNodes, schema) {
    const { mediaGroup: mediaGroup } = schema.nodes;
    const mediaNodes = mediaGroupNodes.map((v)=>v.child(0));
    return mediaGroup.createChecked({}, mediaNodes);
}
function $50669f552f016dd9$var$isSignificantSeparatorNode(n, separatorBuffer) {
    return $50669f552f016dd9$var$isHardBreak(n, separatorBuffer) || !$50669f552f016dd9$var$isEmptyTextNode(n) || $50669f552f016dd9$var$isMediaGroupWithMultipleChildren(n);
}
/**
 * Existing media groups with more than one child is considered as a significant separator.
 */ function $50669f552f016dd9$var$isMediaGroupWithMultipleChildren(n) {
    return n.type.name === 'mediaGroup' && n.childCount > 1;
}
/**
 * If the current node is a hard break, AND there's already at least
 * one hard break in the separator buffer, then we want to return true.
 * @param n the current node to examine
 * @param separatorBuffer the existing separator buffer.
 */ function $50669f552f016dd9$var$isHardBreak(n, separatorBuffer) {
    return n.type.name === 'hardBreak' && separatorBuffer.map((v)=>v.type.name).indexOf('hardBreak') !== -1;
}
function $50669f552f016dd9$var$isEmptyTextNode(n) {
    return n.textContent !== undefined && n.textContent.trim().length === 0;
}
function $50669f552f016dd9$export$19b6d0f3f1dd6ddf(input) {
    // Line with only spaces is considered an empty line
    return input.trim().length === 0;
}
function $50669f552f016dd9$var$convertNodeToExpand(node, schema) {
    const { expand: expand } = schema.nodes;
    return expand.createChecked(node.attrs, node.content);
}

});
parcelRegister("4UJvN", function(module, exports) {

$parcel$export(module.exports, "createEmptyParagraphNode", () => $4ae1f625ac901e34$export$e930a5cfe8596ea0);
$parcel$export(module.exports, "createParagraphNodeFromInlineNodes", () => $4ae1f625ac901e34$export$f0eaed48ea684567);
function $4ae1f625ac901e34$export$e930a5cfe8596ea0(schema) {
    const { paragraph: paragraph } = schema.nodes;
    return paragraph.createChecked({}, []);
}
function $4ae1f625ac901e34$export$f0eaed48ea684567(inlineNodes, schema) {
    const { paragraph: paragraph } = schema.nodes;
    const result = [];
    const textNodes = inlineNodes.filter((node)=>node.type.name !== 'hardBreak');
    if (textNodes.length > 0) result.push(paragraph.createChecked({}, inlineNodes));
    return result;
}

});



parcelRegister("9jjzg", function(module, exports) {

$parcel$export(module.exports, "resolveLink", () => $c08b1d888f635e2c$export$c2baa561eb017101);

var $30RSK = parcelRequire("30RSK");

var $lRYXZ = parcelRequire("lRYXZ");

var $b0Iw2 = parcelRequire("b0Iw2");

var $k1MiS = parcelRequire("k1MiS");
// jira-components/jira-core/src/main/resources/system-contentlinkresolvers-plugin.xml
// attachment resolver: 10
// anchor resolver: 20 - unsupported
// jiraissue resolver: 30 - unsupported
// user profile: 40
//
// Fall back to url link resolver
const $c08b1d888f635e2c$var$linkResolverStrategies = [
    (0, $lRYXZ.attachmentLinkResolver),
    (0, $30RSK.mentionLinkResolver),
    (0, $k1MiS.issueLinkResolver),
    (0, $b0Iw2.urlLinkResolver)
];
function $c08b1d888f635e2c$export$c2baa561eb017101(link, schema, context) {
    const length = link.originalLinkText.length + 2;
    for (const resolver of $c08b1d888f635e2c$var$linkResolverStrategies){
        const resolvedLink = resolver(link, schema, context);
        if (resolvedLink) return {
            length: length,
            nodes: resolvedLink,
            type: 'pmnode'
        };
    }
    return undefined;
}

});
parcelRegister("30RSK", function(module, exports) {

$parcel$export(module.exports, "mentionLinkResolver", () => $bbe5fc702887fa8b$export$1da3b34e38fc6ca8);
function $bbe5fc702887fa8b$export$1da3b34e38fc6ca8(link, schema, context) {
    // [CS-1896] Empty mention nodes should fallback to plaintext
    if (link.notLinkBody.toLowerCase() === '~accountid:' || link.notLinkBody === '~') return [
        schema.nodes.paragraph.createChecked({}, [
            schema.nodes.text.create({})
        ])
    ];
    if (link.notLinkBody.startsWith('~')) {
        const mentionText = link.notLinkBody.substring(1);
        const mentionKey = mentionText.toLowerCase();
        const id = context.conversion && context.conversion.mentionConversion && context.conversion.mentionConversion[mentionKey] ? context.conversion.mentionConversion[mentionKey] : mentionText;
        return [
            schema.nodes.mention.createChecked({
                id: id
            })
        ];
    }
    return;
}

});

parcelRegister("lRYXZ", function(module, exports) {

$parcel$export(module.exports, "attachmentLinkResolver", () => $2514090e6b8dffff$export$ce918f41a76b8445);

var $4vpto = parcelRequire("4vpto");
function $2514090e6b8dffff$export$ce918f41a76b8445(link, schema, context) {
    if (link.attachmentName) return [
        (0, $4vpto.default)(schema, link.attachmentName, context)
    ];
    return;
}

});
parcelRegister("4vpto", function(module, exports) {

$parcel$export(module.exports, "default", () => $904a1bc635a5ad9a$export$2e2bcd8739ae039);
function $904a1bc635a5ad9a$export$2e2bcd8739ae039(schema, filename, context = {}) {
    const { media: media, mediaGroup: mediaGroup } = schema.nodes;
    // try to look up media ID from conversion context
    const id = context?.conversion?.mediaConversion?.[filename]?.transform ?? filename;
    // try to look up collection from media context
    const collection = context.hydration && context.hydration.media && context.hydration.media.targetCollectionId;
    const mediaNode = media.createChecked({
        id: id,
        type: 'file',
        collection: collection || ''
    });
    return mediaGroup.createChecked({}, mediaNode);
}

});


parcelRegister("b0Iw2", function(module, exports) {

$parcel$export(module.exports, "urlLinkResolver", () => $e20b005b86e07eab$export$b737d556d2167f9);

var $kSL4h = parcelRequire("kSL4h");

var $iZOJ9 = parcelRequire("iZOJ9");

var $29zBb = parcelRequire("29zBb");

var $gxAE9 = parcelRequire("gxAE9");
function $e20b005b86e07eab$export$b737d556d2167f9(link, schema, context) {
    const output = [];
    const url = link.notLinkBody;
    const textRepresentation = link.linkBody || link.notLinkBody;
    if (!(0, $iZOJ9.isSafeUrl)(url)) return;
    const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).LINK_TEXT,
        (0, $kSL4h.TokenType).ISSUE_KEY
    ];
    const rawContent = (0, $29zBb.parseString)({
        ignoreTokenTypes: ignoreTokenTypes,
        schema: schema,
        context: context,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        input: textRepresentation.replace(/^mailto:/, '')
    });
    const decoratedContent = rawContent.map((n)=>{
        const mark = schema.marks.link.create({
            href: url
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'link',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    });
    output.push(...decoratedContent);
    if (!$e20b005b86e07eab$var$hasTextNode(rawContent)) {
        const mark = schema.marks.link.create({
            href: url
        });
        const linkTextNode = schema.text(textRepresentation, [
            mark
        ]);
        output.push(linkTextNode);
    }
    return output;
}
function $e20b005b86e07eab$var$hasTextNode(nodes) {
    return nodes.find((n)=>{
        return n.type.name === 'text';
    });
}

});
parcelRegister("gxAE9", function(module, exports) {

$parcel$export(module.exports, "hasAnyOfMarks", () => $fd57502cc274f1df$export$30c14ec359b8cbf0);
$parcel$export(module.exports, "isDigit", () => $fd57502cc274f1df$export$727d9dbc4fbb948f);
$parcel$export(module.exports, "isBlank", () => $fd57502cc274f1df$export$7ee701e290d9865);
$parcel$export(module.exports, "isNotBlank", () => $fd57502cc274f1df$export$4d9e7a1c098df5e2);
$parcel$export(module.exports, "getSurroundingSymbols", () => $fd57502cc274f1df$export$ddec3d40bf5e3693);
$parcel$export(module.exports, "StringBuffer", () => $fd57502cc274f1df$export$83347051c3437dc9);
function $fd57502cc274f1df$export$30c14ec359b8cbf0(node, types) {
    return node.marks.findIndex((m)=>types.findIndex((t)=>m.type.name === t) !== -1) !== -1;
}
function $fd57502cc274f1df$export$727d9dbc4fbb948f(value) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!value.match(/^\d$/);
}
function $fd57502cc274f1df$export$7ee701e290d9865(value) {
    return value === null || value.trim() === '';
}
function $fd57502cc274f1df$export$4d9e7a1c098df5e2(value) {
    return !$fd57502cc274f1df$export$7ee701e290d9865(value);
}
const $fd57502cc274f1df$export$ddec3d40bf5e3693 = (trimmedInput, openingText, closingText)=>{
    const openingSymbol = trimmedInput.startsWith(`{${openingText}}`) ? `{${openingText}}` : openingText;
    const endIndex = trimmedInput.indexOf(closingText, openingSymbol === `{${openingText}}` ? openingText.length + 2 : openingText.length);
    const closingSymbol = endIndex > -1 && trimmedInput.charAt(endIndex - 1) === '{' && trimmedInput.charAt(endIndex + closingText.length) === '}' ? `{${closingText}}` : closingText;
    return {
        openingSymbol: openingSymbol,
        closingSymbol: closingSymbol
    };
};
class $fd57502cc274f1df$export$83347051c3437dc9 {
    constructor(buffer = ''){
        this.buffer = buffer;
    }
    indexOf(value) {
        return this.buffer.indexOf(value);
    }
    lastIndexOf(value) {
        return this.buffer.lastIndexOf(value);
    }
    charAt(index) {
        return this.buffer.charAt(index);
    }
    length() {
        return this.buffer.length;
    }
    delete(start, end) {
        this.buffer = this.buffer.substring(0, start) + this.buffer.substring(end);
    }
    append(value) {
        this.buffer += value;
    }
    substring(start, end) {
        return this.buffer.substring(start, end);
    }
    deleteCharAt(index) {
        this.delete(index, index + 1);
    }
    toString() {
        return this.buffer;
    }
}

});


parcelRegister("k1MiS", function(module, exports) {

$parcel$export(module.exports, "issueLinkResolver", () => $7a9a102a7215e3d4$export$f40ed0efa65d4e8);

var $bOMPB = parcelRequire("bOMPB");
function $7a9a102a7215e3d4$export$f40ed0efa65d4e8(link, schema, context) {
    const { originalLinkText: originalLinkText, linkTitle: linkTitle, notLinkBody: notLinkBody } = link;
    if (linkTitle === 'smart-card' || linkTitle === 'block-link' // TODO: Depricated should be removed in the next major release
    ) return [
        schema.nodes.blockCard.createChecked({
            url: notLinkBody
        })
    ];
    if (linkTitle === 'smart-link') return [
        schema.nodes.inlineCard.createChecked({
            url: notLinkBody
        })
    ];
    if (linkTitle === 'smart-embed') return [
        schema.nodes.embedCard.createChecked({
            url: notLinkBody
        })
    ];
    const issue = (0, $bOMPB.getIssue)(context, originalLinkText);
    if (issue) return (0, $bOMPB.buildInlineCard)(schema, issue);
    return undefined;
}

});
parcelRegister("bOMPB", function(module, exports) {

$parcel$export(module.exports, "INLINE_CARD_FROM_TEXT_STAMP", () => $ce5ca7baa00e39d0$export$a1a15f4d91e860d9);
$parcel$export(module.exports, "issueKey", () => $ce5ca7baa00e39d0$export$a0d841e329cebd91);
$parcel$export(module.exports, "getIssue", () => $ce5ca7baa00e39d0$export$34403cb88b30d33b);
$parcel$export(module.exports, "buildInlineCard", () => $ce5ca7baa00e39d0$export$cdebb4bc59c595a);
$parcel$export(module.exports, "buildIssueKeyRegex", () => $ce5ca7baa00e39d0$export$cd8701ad7512efee);

var $gxAE9 = parcelRequire("gxAE9");
const $ce5ca7baa00e39d0$export$a1a15f4d91e860d9 = /(#icft=)([A-Z][A-Z]+-[0-9]+)/;
const $ce5ca7baa00e39d0$export$a0d841e329cebd91 = ({ input: input, position: position, schema: schema, context: context })=>{
    // This scenario happens when context is empty
    if (!context.issueKeyRegex) return $ce5ca7baa00e39d0$var$fallback(input, position);
    const match = input.substring(position).match(context.issueKeyRegex);
    if (!match) return $ce5ca7baa00e39d0$var$fallback(input, position);
    const issue = $ce5ca7baa00e39d0$export$34403cb88b30d33b(context, match[0]);
    // This scenario happens when context doesn't has all the issues inside a markup
    if (!issue) return $ce5ca7baa00e39d0$var$fallback(input, position);
    const charBefore = input.charAt(position - 1);
    const charAfter = input.charAt(position + issue.key.length);
    if ((0, $gxAE9.isNotBlank)(charBefore) && $ce5ca7baa00e39d0$var$isNotAllowedChars(charBefore) || (0, $gxAE9.isNotBlank)(charAfter) && $ce5ca7baa00e39d0$var$isNotAllowedChars(charAfter)) return $ce5ca7baa00e39d0$var$fallback(input, position);
    return {
        type: 'pmnode',
        nodes: $ce5ca7baa00e39d0$export$cdebb4bc59c595a(schema, issue),
        length: match[0].length
    };
};
const $ce5ca7baa00e39d0$var$fallback = (input, position)=>({
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    });
const $ce5ca7baa00e39d0$export$34403cb88b30d33b = (context, key)=>context.conversion && context.conversion.inlineCardConversion && context.conversion.inlineCardConversion[key] ? {
        key: key,
        url: context.conversion.inlineCardConversion[key]
    } : null;
const $ce5ca7baa00e39d0$export$cdebb4bc59c595a = (schema, issue)=>{
    return [
        schema.nodes.inlineCard.createChecked({
            url: $ce5ca7baa00e39d0$var$withInlineCardFromTextStamp(issue)
        })
    ];
};
const $ce5ca7baa00e39d0$var$withInlineCardFromTextStamp = (issue)=>$ce5ca7baa00e39d0$export$a1a15f4d91e860d9.test(issue.url) ? issue.url : `${issue.url}#icft=${issue.key}`;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ce5ca7baa00e39d0$var$isNotAllowedChars = (char)=>!/\s|\(|\)|!|\.|\,|\/|\:/.test(char);
const $ce5ca7baa00e39d0$export$cd8701ad7512efee = (inlineCardConversion)=>{
    if (!inlineCardConversion) return undefined;
    const pattern = Object.keys(inlineCardConversion).join('|');
    if (!pattern) return undefined;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return new RegExp(`^(${pattern})`);
};

});



parcelRegister("gGleW", function(module, exports) {

$parcel$export(module.exports, "parseContentLink", () => $57e1d7866034b37b$export$3a250a08d37b0eae);

var $gxAE9 = parcelRequire("gxAE9");
/*
 * This implementation is ported from JIRA with minimal modifications
 * It uses a mutable "StringBuffer" to parse links. It would be ideal to
 *  move this to operating on immutable strings instead if possible
 *
 * TODO: CS-596 Replace string buffer usage with strings
 */ function $57e1d7866034b37b$var$trimIfPossible(s) {
    if (s === null) return null;
    return s.trim();
}
function $57e1d7866034b37b$var$extractLinkBody(buffer) {
    const indexOfBang = buffer.indexOf('!');
    const indexOfPipe = buffer.indexOf('|');
    const lastIndexOfBang = buffer.lastIndexOf('!');
    const notEscaped = indexOfBang === -1 || indexOfBang > indexOfPipe || indexOfBang === lastIndexOfBang;
    if (notEscaped) return $57e1d7866034b37b$var$divideOn(buffer, '|');
    const body = new (0, $gxAE9.StringBuffer)();
    let inEscape = false;
    for(let i = 0; i < buffer.length(); i++){
        const c = buffer.charAt(i);
        if (c === '!') inEscape = !inEscape;
        if (c === '|' && !inEscape) {
            buffer.delete(0, i + 1);
            return body.toString();
        }
        body.append(c);
    }
    return null;
}
function $57e1d7866034b37b$var$divideAfterLast(buffer, divider) {
    if (buffer.length() === 0) return null;
    return $57e1d7866034b37b$var$divideAfter(buffer, buffer.lastIndexOf(divider));
}
function $57e1d7866034b37b$var$divideAfter(buffer, index) {
    if (typeof index === 'string') index = buffer.indexOf(index);
    if (index < 0) return null;
    else if (index === buffer.length() - 1) {
        buffer.deleteCharAt(buffer.length() - 1);
        return null;
    } else {
        const body = buffer.substring(index + 1);
        buffer.delete(index, buffer.length());
        return body;
    }
}
/**
 * Split a StringBuffer on some dividing character. Return everything before the divider,
 * and remove that prefix _and_ the divider from the StringBuffer. If there is no divider,
 * return null.
 * <p/>
 * If the buffer begins with the divider, then the divider will be removed _and_ null returned.
 * If the buffer ends with the divider, everything before the divider is returned and the buffer
 * will remain empty.
 *
 * @param buffer  the text we want to divide. Will be modified during the operation
 * @param divider the character to divide the buffer on
 * @return the characters before the divider, or the default if there are none
 */ function $57e1d7866034b37b$var$divideOn(buffer, divider) {
    if (buffer.length() === 0) return null;
    const i = buffer.indexOf(divider);
    if (i < 0) return null;
    else if (i === 0) {
        buffer.deleteCharAt(0);
        return null;
    } else {
        const body = buffer.substring(0, i);
        buffer.delete(0, i + 1);
        return body;
    }
}
function $57e1d7866034b37b$var$extractNumber(buf) {
    const digits = new (0, $gxAE9.StringBuffer)();
    let i = 0;
    for(; i < buf.length() && (0, $gxAE9.isDigit)(buf.charAt(i)); i++)digits.append(buf.charAt(i));
    if (i > 0) buf.delete(0, i);
    try {
        return parseInt(digits.toString(), 10);
    } catch (e) {
        return 0;
    }
}
function $57e1d7866034b37b$export$2d20cd44728d07a1(linkText) {
    const originalLinkText = linkText;
    // we want to decode single quotes (represented by &#039;) back before parsing the link test
    if (linkText.indexOf('&#039;') !== -1) linkText = linkText.replace('&#039;', "'");
    const buf = new (0, $gxAE9.StringBuffer)(linkText);
    const linkBody = $57e1d7866034b37b$var$extractLinkBody(buf);
    const linkTitle = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideAfter(buf, '|'));
    const notLinkBody = buf.toString().trim();
    return {
        originalLinkText: originalLinkText,
        linkBody: linkBody,
        linkTitle: linkTitle,
        notLinkBody: notLinkBody
    };
}
function $57e1d7866034b37b$export$3a250a08d37b0eae(link) {
    if (typeof link === 'string') link = $57e1d7866034b37b$export$2d20cd44728d07a1(link);
    const { notLinkBody: notLinkBody } = link;
    let shortcutName = null;
    let shortcutValue = null;
    let spaceKey = null;
    let attachmentName = null;
    let anchor = null;
    let destinationTitle = '';
    let contentId = 0;
    // Don't treat it as a short link when it starts with "~"
    if (!notLinkBody.startsWith('~')) {
        const shortcutBuf = new (0, $gxAE9.StringBuffer)(notLinkBody);
        shortcutName = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideAfterLast(shortcutBuf, '@'));
        if ((0, $gxAE9.isNotBlank)(shortcutName)) shortcutValue = shortcutBuf.toString();
    }
    const buf = new (0, $gxAE9.StringBuffer)(notLinkBody);
    if ((0, $gxAE9.isBlank)(shortcutName)) {
        spaceKey = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideOn(buf, ':'));
        if (buf.indexOf('$') === 0) {
            buf.deleteCharAt(0);
            contentId = $57e1d7866034b37b$var$extractNumber(buf);
            if (contentId === 0) return {
                ...link,
                shortcutName: shortcutName,
                shortcutValue: shortcutValue,
                spaceKey: spaceKey,
                contentId: contentId,
                attachmentName: attachmentName,
                anchor: anchor,
                destinationTitle: destinationTitle
            };
        }
        attachmentName = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideAfter(buf, '^'));
        anchor = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideAfter(buf, '#'));
    }
    if (contentId === 0) destinationTitle = buf.toString().trim();
    return {
        ...link,
        shortcutName: shortcutName,
        shortcutValue: shortcutValue,
        spaceKey: spaceKey,
        contentId: contentId,
        attachmentName: attachmentName,
        anchor: anchor,
        destinationTitle: destinationTitle
    };
}

});




parcelRegister("30Un5", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $0c863b8155c1a336$export$67dc04e652a298ca);

var $4Dfwq = parcelRequire("4Dfwq");
// bq. foobarbaz
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $0c863b8155c1a336$var$BLOCKQUOTE_REGEXP = /^bq\.(.*)/;
const $0c863b8155c1a336$export$67dc04e652a298ca = ({ input: input, position: position, schema: schema, context: context })=>{
    const match = input.substring(position).match($0c863b8155c1a336$var$BLOCKQUOTE_REGEXP);
    if (!match) return $0c863b8155c1a336$var$fallback(input, position);
    const [, rawContent] = match;
    return (0, $4Dfwq.rawContentProcessor)('', rawContent, match[0].length, schema, context);
};
function $0c863b8155c1a336$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("4Dfwq", function(module, exports) {

$parcel$export(module.exports, "quoteMacro", () => $0723b4b23edf777c$export$8f9545cee64b3251);
$parcel$export(module.exports, "rawContentProcessor", () => $0723b4b23edf777c$export$c2a5e4612254bfa);

var $3JW2n = parcelRequire("3JW2n");

var $gxAE9 = parcelRequire("gxAE9");

var $20lXC = parcelRequire("20lXC");

var $29zBb = parcelRequire("29zBb");
const $0723b4b23edf777c$export$8f9545cee64b3251 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $3JW2n.commonMacro)(input.substring(position), schema, {
        keyword: 'quote',
        paired: true,
        rawContentProcessor: $0723b4b23edf777c$export$c2a5e4612254bfa,
        context: context
    });
};
const $0723b4b23edf777c$export$c2a5e4612254bfa = (_rawAttrs, rawContent, length, schema, context)=>{
    if (!rawContent.length) {
        const emptyQuote = $0723b4b23edf777c$var$emptyBlockquote(schema);
        return {
            type: 'pmnode',
            nodes: [
                emptyQuote
            ],
            length: length
        };
    }
    const parsedContent = (0, $29zBb.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: [],
        input: rawContent
    });
    const normalizedContent = (0, $20lXC.normalizePMNodes)(parsedContent, schema);
    return {
        type: 'pmnode',
        nodes: $0723b4b23edf777c$var$sanitize(normalizedContent, schema),
        length: length
    };
};
function $0723b4b23edf777c$var$emptyBlockquote(schema) {
    const p = schema.nodes.paragraph.createChecked({}, []);
    return schema.nodes.blockquote.createChecked({}, p);
}
function $0723b4b23edf777c$var$sanitize(nodes, schema) {
    const output = [];
    let contentBuffer = [];
    for (const n of nodes)switch(n.type.name){
        case 'paragraph':
        case 'bulletList':
        case 'orderedList':
        case 'codeBlock':
        case 'mediaSingle':
        case 'mediaGroup':
            /**
				 * blockquote supports nesting paragraphs, lists, codeblocks and media nodes
				 */ contentBuffer.push(n);
            break;
        case 'heading':
            /**
				 * If a heading is inside a list item
				 * - h1. Bold, Uppercase
				 * - h2. Bold, Italic
				 * - h3. Bold
				 * - h4. Bold, Gray
				 * - h5. Gray, Italic
				 * - h6. Gray
				 */ contentBuffer.push($0723b4b23edf777c$var$transformHeading(n, schema));
            break;
        default:
            /**
				 * Anything else should be lifted
				 */ if (contentBuffer.length) {
                const blockquote = schema.nodes.blockquote.createChecked({}, contentBuffer);
                output.push(blockquote);
                contentBuffer = [];
            }
            output.push(n);
    }
    if (contentBuffer.length) {
        const blockquote = schema.nodes.blockquote.createChecked({}, contentBuffer);
        output.push(blockquote);
    }
    return output;
}
function $0723b4b23edf777c$var$transformHeading(heading, schema) {
    const contentBuffer = [];
    heading.content.forEach((n)=>{
        const strong = schema.marks.strong.create();
        const italic = schema.marks.em.create();
        const gray = schema.marks.textColor.create({
            color: '#97a0af'
        });
        if (n.type.name === 'text') {
            if (n.text && heading.attrs.level === 1) // @ts-ignore assigning to readonly prop to transform text
            n.text = n.text.toUpperCase();
            if (heading.attrs.level <= 4 && !(0, $gxAE9.hasAnyOfMarks)(n, [
                'strong',
                'code'
            ])) n = n.mark([
                ...n.marks,
                strong
            ]);
            if ((heading.attrs.level === 5 || heading.attrs.level === 2) && !(0, $gxAE9.hasAnyOfMarks)(n, [
                'em',
                'code'
            ])) n = n.mark([
                ...n.marks,
                italic
            ]);
            if (heading.attrs.level > 3 && !(0, $gxAE9.hasAnyOfMarks)(n, [
                'textColor',
                'code'
            ])) n = n.mark([
                ...n.marks,
                gray
            ]);
        }
        contentBuffer.push(n);
    });
    return schema.nodes.paragraph.createChecked({}, contentBuffer);
}

});
parcelRegister("3JW2n", function(module, exports) {

$parcel$export(module.exports, "commonMacro", () => $108725731ca4984f$export$b6a12943ac1bb1ba);
function $108725731ca4984f$export$b6a12943ac1bb1ba(input, schema, opt) {
    /**
	 * Forging the opening regex, the result would look something like
	 * /^\{(quote)(?::([^\{\n\}]*))?\}/i
	 */ // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const opening = new RegExp(`^\{(${opt.keyword})(?::([^\{\n\}]*))?\}`, 'i');
    const matchOpening = input.match(opening);
    if (!matchOpening) return $108725731ca4984f$var$fallback(input);
    const [, name, rawAttrs] = matchOpening;
    const openingLength = matchOpening[0].length;
    if (!opt.paired) /**
		 * Some macros do not have a closing symbol, for example
		 * {anchor:here} {loremipsum}
		 */ return opt.rawContentProcessor(rawAttrs, '', openingLength, schema, opt.context);
    /**
	 * Forging the closing regex, the result would look something like
	 * /\{quote\}/
	 */ // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const closing = new RegExp(`\{${name}\}`);
    const matchClosing = closing.exec(input.substring(openingLength));
    let rawContent = '';
    if (matchClosing) rawContent = input.substring(openingLength, openingLength + matchClosing.index);
    const length = matchClosing ? openingLength + matchClosing.index + matchClosing[0].length : openingLength;
    return opt.rawContentProcessor(rawAttrs, rawContent, length, schema, opt.context);
}
function $108725731ca4984f$var$fallback(input) {
    return {
        type: 'text',
        text: input.substr(0, 1),
        length: 1
    };
}

});



parcelRegister("coK8g", function(module, exports) {

$parcel$export(module.exports, "citation", () => $624cf9f0f9a0e4f4$export$258632c953c109e9);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");

const $624cf9f0f9a0e4f4$export$258632c953c109e9 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).ISSUE_KEY
    ];
    // Add code mark to each text
    const contentDecorator = (n, index)=>{
        const mark = schema.marks.em.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'em',
            'code'
        ])) {
            if (index === 0) // @ts-ignore - [unblock prosemirror bump] allow assign to readonly
            n.text = `${0, $0c0aa3654d545c29$export$3bca9fae3002bd9b} ${n.text}`;
            return n.mark([
                ...n.marks,
                mark
            ]);
        }
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '??', '??');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});
const $0c0aa3654d545c29$export$3bca9fae3002bd9b = "\u2014";


parcelRegister("5RdHN", function(module, exports) {

$parcel$export(module.exports, "deleted", () => $b9ac580681c978af$export$bccbf0c716f226f4);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");
const $b9ac580681c978af$export$bccbf0c716f226f4 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).ISSUE_KEY,
        (0, $kSL4h.TokenType).TABLE
    ];
    /** Add strike mark to each text */ const contentDecorator = (n)=>{
        const mark = schema.marks.strike.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'strike',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '-', '-');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("55t1E", function(module, exports) {

$parcel$export(module.exports, "doubleDashSymbol", () => $74a06c4540bbf40b$export$65e3ca7c95899a2d);

var $1rQjR = parcelRequire("1rQjR");
const $74a06c4540bbf40b$var$token = {
    type: 'text',
    text: '\u2013',
    length: 2
};
const $74a06c4540bbf40b$var$fallback = {
    ...$74a06c4540bbf40b$var$token,
    text: '--'
};
const $74a06c4540bbf40b$export$65e3ca7c95899a2d = (0, $1rQjR.createDashTokenParser)($74a06c4540bbf40b$var$token, $74a06c4540bbf40b$var$fallback);

});
parcelRegister("1rQjR", function(module, exports) {

$parcel$export(module.exports, "createDashTokenParser", () => $75f433a8b52a8173$export$d43b58865d429e3c);
const $75f433a8b52a8173$export$d43b58865d429e3c = (token, fallback)=>({ input: input, position: position })=>{
        /**
		 * From Jira https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-renderer/src/main/java/com/atlassian/renderer/v2/components/phrase/DashRendererComponent.java
		 *  public static final Replacer EN_DASH = new Replacer(Pattern.compile("(^|\\s)--(\\s|$)"), "$1&#8211;$2", "--");
		 *  public static final Replacer EM_DASH = new Replacer(Pattern.compile("(^|\\s)---(\\s|$)"), "$1&#8212;$2", "---");
		 */ if (position > 0) {
            const charBeforeToken = input.charAt(position - 1);
            if (!$75f433a8b52a8173$var$isSpace(charBeforeToken)) return fallback;
        }
        if (position + token.length < input.length) {
            const charAfterToken = input.charAt(position + token.length);
            if (!$75f433a8b52a8173$var$isSpace(charAfterToken)) return fallback;
        }
        return token;
    };
const $75f433a8b52a8173$var$isSpace = (char)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /\s/.test(char);
};

});


parcelRegister("jor5q", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $487b5ddb28312972$export$a19185d1233fc4b2);
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $487b5ddb28312972$var$emptyOrSpecialCharRegex = new RegExp(/^$|[^A-Za-z0-9]/);
const $487b5ddb28312972$export$a19185d1233fc4b2 = ({ input: input, position: position, schema: schema })=>{
    const substring = input.substring(position);
    /**
	 * The length of wikimakrup emoji test ranges from 2 to 9 characters at the time of writing.
	 */ for(let i = 2; i <= 9 && i <= substring.length; ++i){
        const candidateText = substring.substring(0, i);
        const emojiId = $487b5ddb28312972$export$fabd2c9504f5bf35[candidateText];
        // Is current candidate an emoji AND next character empty string any special character?
        if (emojiId && $487b5ddb28312972$var$emptyOrSpecialCharRegex.test(substring.charAt(i))) return {
            type: 'pmnode',
            nodes: [
                schema.nodes.emoji.createChecked($487b5ddb28312972$export$797c048dfde076a1[emojiId])
            ],
            length: i
        };
    }
    return {
        type: 'text',
        text: substring.substr(0, 1),
        length: 1
    };
};
const $487b5ddb28312972$export$797c048dfde076a1 = {
    '1f642': {
        id: '1f642',
        shortName: ':slight_smile:',
        text: "\uD83D\uDE42"
    },
    '1f61e': {
        id: '1f61e',
        shortName: ':disappointed:',
        text: "\uD83D\uDE1E"
    },
    '1f61b': {
        id: '1f61b',
        shortName: ':stuck_out_tongue:',
        text: "\uD83D\uDE1B"
    },
    '1f603': {
        id: '1f603',
        shortName: ':smiley:',
        text: "\uD83D\uDE03"
    },
    '1f609': {
        id: '1f609',
        shortName: ':wink:',
        text: "\uD83D\uDE09"
    },
    '1f44d': {
        id: '1f44d',
        shortName: ':thumbsup:',
        text: "\uD83D\uDC4D"
    },
    '1f44e': {
        id: '1f44e',
        shortName: ':thumbsdown:',
        text: "\uD83D\uDC4E"
    },
    'atlassian-info': {
        id: 'atlassian-info',
        shortName: ':info:',
        text: ':info:'
    },
    'atlassian-check_mark': {
        id: 'atlassian-check_mark',
        shortName: ':check_mark:',
        text: ':check_mark:'
    },
    'atlassian-cross_mark': {
        id: 'atlassian-cross_mark',
        shortName: ':cross_mark:',
        text: ':cross_mark:'
    },
    'atlassian-warning': {
        id: 'atlassian-warning',
        shortName: ':warning:',
        text: ':warning:'
    },
    'atlassian-plus': {
        id: 'atlassian-plus',
        shortName: ':plus:',
        text: ':plus:'
    },
    'atlassian-minus': {
        id: 'atlassian-minus',
        shortName: ':minus:',
        text: ':minus:'
    },
    'atlassian-question_mark': {
        id: 'atlassian-question_mark',
        shortName: ':question:',
        text: ':question:'
    },
    'atlassian-light_bulb_on': {
        id: 'atlassian-light_bulb_on',
        shortName: ':light_bulb_on:',
        text: ':light_bulb_on:'
    },
    'atlassian-light_bulb_off': {
        id: 'atlassian-light_bulb_off',
        shortName: ':light_bulb_off:',
        text: ':light_bulb_off:'
    },
    'atlassian-yellow_star': {
        id: 'atlassian-yellow_star',
        shortName: ':yellow_star:',
        text: ':yellow_star:'
    },
    'atlassian-red_star': {
        id: 'atlassian-red_star',
        shortName: ':red_star:',
        text: ':red_star:'
    },
    'atlassian-green_star': {
        id: 'atlassian-green_star',
        shortName: ':green_star:',
        text: ':green_star:'
    },
    'atlassian-blue_star': {
        id: 'atlassian-blue_star',
        shortName: ':blue_star:',
        text: ':blue_star:'
    },
    'atlassian-flag_on': {
        id: 'atlassian-flag_on',
        shortName: ':flag_on:',
        text: ':flag_on:'
    },
    'atlassian-flag_off': {
        id: 'atlassian-flag_off',
        shortName: ':flag_off:',
        text: ':flag_off:'
    }
};
const $487b5ddb28312972$export$fabd2c9504f5bf35 = {
    ':)': '1f642',
    ':-)': '1f642',
    ':(': '1f61e',
    ':-(': '1f61e',
    ':P': '1f61b',
    ':-P': '1f61b',
    ':p': '1f61b',
    ':-p': '1f61b',
    ':D': '1f603',
    ':-D': '1f603',
    ';)': '1f609',
    ';-)': '1f609',
    '(y)': '1f44d',
    '(n)': '1f44e',
    '(i)': 'atlassian-info',
    '(/)': 'atlassian-check_mark',
    '(x)': 'atlassian-cross_mark',
    '(!)': 'atlassian-warning',
    '(+)': 'atlassian-plus',
    '(-)': 'atlassian-minus',
    '(?)': 'atlassian-question_mark',
    '(on)': 'atlassian-light_bulb_on',
    '(off)': 'atlassian-light_bulb_off',
    '(*)': 'atlassian-yellow_star',
    '(*y)': 'atlassian-yellow_star',
    '(*r)': 'atlassian-red_star',
    '(*g)': 'atlassian-green_star',
    '(*b)': 'atlassian-blue_star',
    '(flag)': 'atlassian-flag_on',
    '(flagoff)': 'atlassian-flag_off'
};

});

parcelRegister("hZ14o", function(module, exports) {

$parcel$export(module.exports, "emphasis", () => $5100d4ec4f1b4884$export$bef81ba411953b51);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");
const $5100d4ec4f1b4884$export$bef81ba411953b51 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a  mark
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).ISSUE_KEY,
        (0, $kSL4h.TokenType).TABLE
    ];
    // Add underline mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.em.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'em',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '_', '_');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("6xaH8", function(module, exports) {

$parcel$export(module.exports, "hardbreak", () => $bc70e1090faff3e6$export$ac55bb44695749c1);

var $eWAZI = parcelRequire("eWAZI");
const $bc70e1090faff3e6$export$ac55bb44695749c1 = ({ input: input, position: position, schema: schema })=>{
    // Look for normal hardbreak \r, \n, \r\n
    const length = (0, $eWAZI.parseNewlineOnly)(input.substring(position));
    if (length === 0) // not a valid hardbreak
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
    return {
        type: 'pmnode',
        nodes: [
            schema.nodes.hardBreak.createChecked()
        ],
        length: length
    };
};

});

parcelRegister("jMpI6", function(module, exports) {

$parcel$export(module.exports, "heading", () => $ed15d3e22c065f91$export$46e4a324ac90507f);

var $29zBb = parcelRequire("29zBb");

var $kSL4h = parcelRequire("kSL4h");
// h1. HEADING
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ed15d3e22c065f91$var$HEADING_REGEXP = /^h([1-6])\.(.*)/;
const $ed15d3e22c065f91$export$46e4a324ac90507f = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a strong mark
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL
    ];
    const match = input.substring(position).match($ed15d3e22c065f91$var$HEADING_REGEXP);
    if (!match) return $ed15d3e22c065f91$var$fallback(input, position);
    const level = parseInt(match[1], 10);
    const content = (0, $29zBb.parseString)({
        schema: schema,
        ignoreTokenTypes: ignoreTokenTypes,
        context: context,
        input: match[2]
    });
    try {
        const headingNode = schema.nodes.heading.createChecked({
            level: level
        }, content);
        return {
            type: 'pmnode',
            nodes: [
                headingNode
            ],
            length: match[0].length
        };
    } catch (err) {
        /**
		 * If the heading fails to rendering, we want to skip the text
		 * "h1."
		 */ return {
            type: 'text',
            text: '',
            length: 4
        };
    }
};
function $ed15d3e22c065f91$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});

parcelRegister("iDsRr", function(module, exports) {

$parcel$export(module.exports, "inserted", () => $33f79eddf582429a$export$744ba74fb86b8ca7);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");
const $33f79eddf582429a$export$744ba74fb86b8ca7 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).ISSUE_KEY,
        (0, $kSL4h.TokenType).TABLE
    ];
    // Add underline mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.underline.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'underline',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '+', '+');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("ayQVO", function(module, exports) {

$parcel$export(module.exports, "MAX_LIST_DEPTH", () => $4813b87fbe6448cc$export$d2a2f0ec33d903e1);
$parcel$export(module.exports, "list", () => $4813b87fbe6448cc$export$8837f4fc672e936d);

var $hnQWb = parcelRequire("hnQWb");

var $29zBb = parcelRequire("29zBb");

var $20lXC = parcelRequire("20lXC");

var $cG4PY = parcelRequire("cG4PY");

var $kSL4h = parcelRequire("kSL4h");

var $eWAZI = parcelRequire("eWAZI");

var $gxAE9 = parcelRequire("gxAE9");
const $4813b87fbe6448cc$export$d2a2f0ec33d903e1 = 20;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $4813b87fbe6448cc$var$LIST_ITEM_REGEXP = new RegExp(`^ *([*\\-#]{1,${$4813b87fbe6448cc$export$d2a2f0ec33d903e1}}) `);
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $4813b87fbe6448cc$var$EMPTY_LINE_REGEXP = /^[ \t]*\r?\n/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $4813b87fbe6448cc$var$RULER_SYMBOL_REGEXP = /^-{4,5}/;
const $4813b87fbe6448cc$var$processState = {
    NEW_LINE: 0,
    BUFFER: 1,
    END: 2,
    MACRO: 3
};
const $4813b87fbe6448cc$export$8837f4fc672e936d = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a listItem
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).LIST,
        (0, $kSL4h.TokenType).TABLE
    ];
    let index = position;
    let state = $4813b87fbe6448cc$var$processState.NEW_LINE;
    let buffer = [];
    let lastListSymbols = null;
    let builder = null;
    let contentBuffer = [];
    const output = [];
    while(index < input.length){
        const char = input.charAt(index);
        switch(state){
            case $4813b87fbe6448cc$var$processState.NEW_LINE:
                {
                    const substring = input.substring(index);
                    const listMatch = substring.match($4813b87fbe6448cc$var$LIST_ITEM_REGEXP);
                    if (listMatch) {
                        const [, symbols] = listMatch;
                        // Handle ruler in list
                        const rulerMatch = symbols.match($4813b87fbe6448cc$var$RULER_SYMBOL_REGEXP);
                        if (rulerMatch) {
                            const remainingAfterSymbol = input.substring(index + rulerMatch[0].length);
                            const emptyLineMatch = remainingAfterSymbol.match($4813b87fbe6448cc$var$EMPTY_LINE_REGEXP);
                            // If this is an empty line skip to the buffering step rather than match as a list element
                            if (emptyLineMatch) {
                                state = $4813b87fbe6448cc$var$processState.BUFFER;
                                continue;
                            }
                        }
                        if (!builder) {
                            // It happens because this is the first item of the list
                            builder = new (0, $hnQWb.ListBuilder)(schema, symbols);
                            lastListSymbols = symbols;
                        } else {
                            /**
						 * There is a builder, so we are in the middle of building a list
						 * and now there is a new list item
						 */ if (buffer.length > 0) {
                                // Wrap up previous list item and clear buffer
                                const content = (0, $29zBb.parseString)({
                                    ignoreTokenTypes: ignoreTokenTypes,
                                    schema: schema,
                                    context: context,
                                    input: buffer.join(''),
                                    includeLeadingSpace: true
                                });
                                contentBuffer.push(...content);
                                builder.add([
                                    {
                                        style: lastListSymbols,
                                        content: $4813b87fbe6448cc$var$sanitize((0, $20lXC.normalizePMNodes)(contentBuffer, schema), schema)
                                    }
                                ]);
                                buffer = [];
                                contentBuffer = [];
                            }
                            // We finished last list item here, going to the new one
                            lastListSymbols = symbols;
                            const type = (0, $hnQWb.getType)(symbols);
                            // If it's top level and doesn't match, create a new list
                            if (type !== builder.type && symbols.length === 1) {
                                output.push(...builder.buildPMNode());
                                builder = new (0, $hnQWb.ListBuilder)(schema, symbols);
                            }
                        }
                        index += listMatch[0].length;
                    }
                    // If we encounter an empty line, we should end the list
                    const emptyLineMatch = substring.match($4813b87fbe6448cc$var$EMPTY_LINE_REGEXP);
                    if (emptyLineMatch) {
                        state = $4813b87fbe6448cc$var$processState.END;
                        continue;
                    }
                    state = $4813b87fbe6448cc$var$processState.BUFFER;
                    continue;
                }
            case $4813b87fbe6448cc$var$processState.BUFFER:
                {
                    const length = (0, $eWAZI.parseNewlineOnly)(input.substring(index));
                    if (length) {
                        buffer.push(input.substr(index, length));
                        state = $4813b87fbe6448cc$var$processState.NEW_LINE;
                        index += length;
                        continue;
                    }
                    if (char === '{') {
                        state = $4813b87fbe6448cc$var$processState.MACRO;
                        continue;
                    } else buffer.push(char);
                    break;
                }
            case $4813b87fbe6448cc$var$processState.MACRO:
                {
                    const match = (0, $cG4PY.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        state = $4813b87fbe6448cc$var$processState.BUFFER;
                        break;
                    }
                    const token = (0, $kSL4h.parseToken)(input, match.type, index, schema, context);
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    state = $4813b87fbe6448cc$var$processState.BUFFER;
                    continue;
                }
            case $4813b87fbe6448cc$var$processState.END:
                if (!builder) // Something is really wrong here
                return $4813b87fbe6448cc$var$fallback(input, position);
                if (buffer.length > 0) {
                    // Wrap up previous list item and clear buffer
                    const content = (0, $29zBb.parseString)({
                        ignoreTokenTypes: ignoreTokenTypes,
                        schema: schema,
                        context: context,
                        input: buffer.join(''),
                        includeLeadingSpace: true
                    });
                    contentBuffer.push(...content);
                }
                builder.add([
                    {
                        style: lastListSymbols,
                        content: $4813b87fbe6448cc$var$sanitize((0, $20lXC.normalizePMNodes)(contentBuffer, schema), schema)
                    }
                ]);
                output.push(...builder.buildPMNode());
                return {
                    type: 'pmnode',
                    nodes: output,
                    length: index - position
                };
        }
        index++;
    }
    if (buffer.length > 0) {
        // Wrap up what's left in the buffer
        const content = (0, $29zBb.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: buffer.join(''),
            includeLeadingSpace: true
        });
        contentBuffer.push(...content);
    }
    if (builder) {
        builder.add([
            {
                style: lastListSymbols,
                content: $4813b87fbe6448cc$var$sanitize((0, $20lXC.normalizePMNodes)(contentBuffer, schema), schema)
            }
        ]);
        output.push(...builder.buildPMNode());
    }
    return {
        type: 'pmnode',
        nodes: output,
        length: index - position
    };
};
function $4813b87fbe6448cc$var$sanitize(nodes, schema) {
    return nodes.reduce((result, curr)=>{
        switch(curr.type.name){
            case 'blockquote':
                /**
				 * If a blockquote is inside a list item
				 * - Convert it to paragraph
				 */ curr.content.forEach((n)=>{
                    result.push(n);
                });
                break;
            case 'heading':
                {
                    /**
				 * If a heading is inside a list item
				 * - Convert the heading to paragraph
				 * - Convert text to upper case
				 * - Mark text with strong.
				 */ const contentBuffer = [];
                    curr.content.forEach((n)=>{
                        const mark = schema.marks.strong.create();
                        if (n.type.name === 'text') {
                            if (n.text) // @ts-ignore - [unblock prosemirror bump] allow assign to readonly
                            n.text = n.text.toUpperCase();
                            if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
                                'strong',
                                'code'
                            ])) contentBuffer.push(n.mark([
                                ...n.marks,
                                mark
                            ]));
                            else contentBuffer.push(n);
                        } else contentBuffer.push(n);
                    });
                    const p = schema.nodes.paragraph.createChecked({}, contentBuffer);
                    result.push(p);
                    break;
                }
            default:
                result.push(curr);
        }
        return result;
    }, []);
}
function $4813b87fbe6448cc$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("hnQWb", function(module, exports) {

$parcel$export(module.exports, "getType", () => $3303253e6091964c$export$e2b5c5db9e2009fd);
$parcel$export(module.exports, "ListBuilder", () => $3303253e6091964c$export$876cfa3161bef296);
const $3303253e6091964c$var$supportedContentType = [
    'paragraph',
    'orderedList',
    'bulletList',
    'mediaSingle',
    'codeBlock'
];
function $3303253e6091964c$export$e2b5c5db9e2009fd(bullets) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /#$/.test(bullets) ? 'orderedList' : 'bulletList';
}
class $3303253e6091964c$export$876cfa3161bef296 {
    constructor(schema, bullets){
        /**
	 * Build prosemirror bulletList or orderedList node
	 * @param {List} list
	 * @returns {PMNode}
	 */ this.parseList = (list)=>{
            const listNode = this.schema.nodes[list.type];
            const output = [];
            let listItemsBuffer = [];
            for(let i = 0; i < list.children.length; i++){
                const parsedContent = this.parseListItem(list.children[i]);
                for(let j = 0; j < parsedContent.length; j++){
                    const parsedNode = parsedContent[j];
                    if (parsedNode.type.name === 'listItem') {
                        listItemsBuffer.push(parsedNode);
                        continue;
                    }
                    /**
				 * If the node is not a listItem, then we need to
				 * wrap exisintg list and break out
				 */ if (listItemsBuffer.length) {
                        const list = listNode.createChecked({}, listItemsBuffer);
                        output.push(list);
                    }
                    output.push(parsedNode); // This is the break out node
                    listItemsBuffer = [];
                }
            }
            if (listItemsBuffer.length) {
                const list = listNode.createChecked({}, listItemsBuffer);
                output.push(list);
            }
            return output;
        };
        /**
	 * Build prosemirror listItem node
	 * This function would possibly return non listItem nodes
	 * which we need to break out later
	 * @param {ListItem} item
	 */ this.parseListItem = (item)=>{
            const output = [];
            if (!item.content) item.content = [];
            // Parse nested list
            const parsedChildren = item.children.reduce((result, list)=>{
                const parsedList = this.parseList(list);
                result.push(...parsedList);
                return result;
            }, []);
            // Append children to the content
            item.content.push(...parsedChildren);
            let contentBuffer = [];
            for(let i = 0; i < item.content.length; i++){
                const pmNode = item.content[i];
                /**
			 * Skip empty paragraph
			 */ if (pmNode.type.name === 'paragraph' && pmNode.childCount === 0) continue;
                /* Skip Empty spaces after rule */ if (this.isParagraphEmptyTextNode(pmNode)) continue;
                if ($3303253e6091964c$var$supportedContentType.indexOf(pmNode.type.name) === -1) {
                    const listItem = this.createListItem(contentBuffer, this.schema);
                    output.push(listItem);
                    output.push(pmNode);
                    contentBuffer = [];
                    continue;
                }
                contentBuffer.push(pmNode);
            }
            if (contentBuffer.length) {
                const listItem = this.createListItem(contentBuffer, this.schema);
                output.push(listItem);
            }
            return output;
        };
        this.schema = schema;
        this.root = {
            children: [],
            type: $3303253e6091964c$export$e2b5c5db9e2009fd(bullets)
        };
        this.lastDepth = 1;
        this.lastList = this.root;
    }
    /**
	 * Return the type of the base list
	 * @returns {ListType}
	 */ get type() {
        return this.root.type;
    }
    /**
	 * Add a list item to the builder
	 * @param {AddArgs[]} items
	 */ add(items) {
        for (const item of items){
            const { style: style, content: content } = item;
            // If there's no style, add to previous list item as multiline
            if (style === null) {
                this.appendToLastItem(content);
                continue;
            }
            const depth = style.length;
            const type = $3303253e6091964c$export$e2b5c5db9e2009fd(style);
            if (depth > this.lastDepth) {
                // Add children starting from last node
                this.createNest(depth - this.lastDepth, type);
                this.lastDepth = depth;
                this.lastList = this.addListItem(type, content);
            } else if (depth === this.lastDepth) // Add list item to current node
            this.lastList = this.addListItem(type, content);
            else {
                // Find node at depth and add list item
                this.lastList = this.findAncestor(this.lastDepth - depth);
                this.lastDepth = depth;
                this.lastList = this.addListItem(type, content);
            }
        }
    }
    /**
	 * Compile a prosemirror node from the root list
	 * @returns {PMNode[]}
	 */ buildPMNode() {
        return this.parseList(this.root);
    }
    /* Check if all paragraph's children nodes are text and empty */ isParagraphEmptyTextNode(node) {
        if (node.type.name !== 'paragraph' || !node.childCount) return false;
        for(let i = 0; i < node.childCount; i++){
            const n = node.content.child(i);
            if (n.type.name !== 'text') // Paragraph contains non-text node, so not empty
            return false;
            else if (n.textContent.trim() !== '') return false;
        }
        return true;
    }
    createListItem(content, schema) {
        if (content.length === 0 || [
            'paragraph',
            'mediaSingle'
        ].indexOf(content[0].type.name) === -1) // If the content is empty or the first element is not paragraph or mediaSingle.
        // this likely to be a nested list where the toplevel list is empty
        // For example: *# item 1
        // In this case we create an empty paragraph for the top level listNode
        content.unshift(this.schema.nodes.paragraph.createChecked());
        return schema.nodes.listItem.createChecked({}, content);
    }
    /**
	 * Add an item at the same level as the current list item
	 * @param {ListType} type
	 * @param {PMNode} content
	 * @returns {PMNode}
	 */ addListItem(type, content) {
        let list = this.lastList;
        // If the list is a different type, create a new list and add it to the parent node
        if (list.type !== type) {
            const parent = list.parent;
            const newList = {
                children: [],
                type: type,
                parent: parent
            };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            parent.children.push(newList);
            this.lastList = list = newList;
        }
        const listItem = {
            content: content,
            parent: list,
            children: []
        };
        list.children = [
            ...list.children,
            listItem
        ];
        return list;
    }
    /**
	 * Append the past content to the last accessed list node (multiline entries)
	 * @param {PMNode[]} content
	 */ appendToLastItem(content) {
        const { children: children } = this.lastList;
        const lastItem = children[children.length - 1];
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        lastItem.content.push(...content);
    }
    /**
	 * Created a nested list structure of N depth under the current node
	 * @param {number} depth
	 * @param {ListType} type
	 */ createNest(depth, type) {
        while(depth-- > 0){
            if (this.lastList.children.length === 0) {
                const listItem = {
                    parent: this.lastList,
                    children: []
                };
                this.lastList.children = [
                    listItem
                ];
            }
            const nextItem = this.lastList.children[this.lastList.children.length - 1];
            nextItem.children = [
                {
                    children: [],
                    parent: nextItem,
                    type: type
                }
            ];
            this.lastList = nextItem.children[0];
        }
    }
    /**
	 * Find the Nth list ancestor of the current list
	 * @param {number} depth
	 */ findAncestor(depth) {
        let list = this.lastList;
        while(depth-- > 0 && list.parent){
            const listItem = list.parent;
            if (listItem && listItem.parent) list = listItem.parent;
        }
        return list;
    }
}

});


parcelRegister("kPrK8", function(module, exports) {

$parcel$export(module.exports, "monospace", () => $7b1a1e7fbe87f62a$export$2b90969bbc9ff4c9);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");
const $7b1a1e7fbe87f62a$export$2b90969bbc9ff4c9 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).ADF_MACRO,
        (0, $kSL4h.TokenType).ANCHOR_MACRO,
        (0, $kSL4h.TokenType).CODE_MACRO,
        (0, $kSL4h.TokenType).QUOTE_MACRO,
        (0, $kSL4h.TokenType).NOFORMAT_MACRO,
        (0, $kSL4h.TokenType).PANEL_MACRO,
        (0, $kSL4h.TokenType).COLOR_MACRO,
        (0, $kSL4h.TokenType).LOREM_MACRO,
        (0, $kSL4h.TokenType).QUOTE,
        (0, $kSL4h.TokenType).STRING,
        (0, $kSL4h.TokenType).ISSUE_KEY,
        (0, $kSL4h.TokenType).LINK_FORMAT,
        (0, $kSL4h.TokenType).LINK_TEXT,
        (0, $kSL4h.TokenType).MEDIA,
        (0, $kSL4h.TokenType).HEADING,
        (0, $kSL4h.TokenType).LIST,
        (0, $kSL4h.TokenType).TABLE,
        (0, $kSL4h.TokenType).RULER,
        (0, $kSL4h.TokenType).HARD_BREAK,
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).STRONG,
        (0, $kSL4h.TokenType).MONOSPACE,
        (0, $kSL4h.TokenType).SUPERSCRIPT,
        (0, $kSL4h.TokenType).SUBSCRIPT,
        (0, $kSL4h.TokenType).EMPHASIS,
        (0, $kSL4h.TokenType).CITATION,
        (0, $kSL4h.TokenType).DELETED,
        (0, $kSL4h.TokenType).INSERTED,
        (0, $kSL4h.TokenType).EMOJI,
        (0, $kSL4h.TokenType).FORCE_LINE_BREAK
    ];
    // Add code mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.code.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && n.marks.length) return n;
        return n.mark([
            mark
        ]);
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '{{', '}}');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("4ZFIG", function(module, exports) {

$parcel$export(module.exports, "quadrupleDashSymbol", () => $819171e80205fd1c$export$95a7907a71f31921);
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $819171e80205fd1c$var$MULTI_DASH_REGEX = /^-{4,}(\s|$)/;
const $819171e80205fd1c$export$95a7907a71f31921 = ({ input: input, position: position })=>{
    // This won't be a ruler because ruler has been checked at leadingKeywordMapping
    const match = input.substring(position).match($819171e80205fd1c$var$MULTI_DASH_REGEX);
    if (!match) return {
        type: 'text',
        text: '----',
        length: 4
    };
    return {
        type: 'text',
        text: input.substr(position, match[0].length),
        length: match[0].length
    };
};

});

parcelRegister("91y57", function(module, exports) {

$parcel$export(module.exports, "ruler", () => $cf2c039554fba6e4$export$f9adada2013e846e);

var $i8dZb = parcelRequire("i8dZb");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $cf2c039554fba6e4$var$RULER_REGEX = /^-{4,5}(\s|$)/;
const $cf2c039554fba6e4$export$f9adada2013e846e = ({ input: input, position: position, schema: schema })=>{
    const match = input.substring(position).match($cf2c039554fba6e4$var$RULER_REGEX);
    if (match) return {
        type: 'pmnode',
        nodes: (0, $i8dZb.createRuleNode)(schema),
        length: match[0].length
    };
    return {
        type: 'text',
        text: input.substring(position, 1),
        length: 1
    };
};

});
parcelRegister("i8dZb", function(module, exports) {

$parcel$export(module.exports, "createRuleNode", () => $d0cc271b2b6d9a56$export$4267f2e5716b018a);
const $d0cc271b2b6d9a56$var$HORIZONTAL_LINE_INSIDE_MACRO = '---';
function $d0cc271b2b6d9a56$export$2e2bcd8739ae039(schema, containerNodeType) {
    const { paragraph: paragraph, rule: rule } = schema.nodes;
    if (containerNodeType) {
        const textNode = schema.text($d0cc271b2b6d9a56$var$HORIZONTAL_LINE_INSIDE_MACRO);
        return paragraph.createChecked({}, textNode);
    } else return rule.createChecked();
}
function $d0cc271b2b6d9a56$export$4267f2e5716b018a(schema) {
    const { rule: rule } = schema.nodes;
    const ruleNode = rule.createChecked();
    return [
        ruleNode
    ];
}

});


parcelRegister("1Mtv8", function(module, exports) {

$parcel$export(module.exports, "strong", () => $da489456937eda28$export$59ae2c325a998f89);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");
const $da489456937eda28$export$59ae2c325a998f89 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a strong mark
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).ISSUE_KEY,
        (0, $kSL4h.TokenType).TABLE
    ];
    // Adding strong mark to all text
    const contentDecorator = (pmNode)=>{
        const mark = schema.marks.strong.create();
        // We don't want to mix `code` mark with others
        if (pmNode.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(pmNode, [
            'strong',
            'code'
        ])) return pmNode.mark([
            ...pmNode.marks,
            mark
        ]);
        return pmNode;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '*', '*');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("77w3e", function(module, exports) {

$parcel$export(module.exports, "subscript", () => $af8d85604a001a66$export$bc5390e4688d2822);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");
const $af8d85604a001a66$export$bc5390e4688d2822 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a  mark
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).ISSUE_KEY,
        (0, $kSL4h.TokenType).TABLE
    ];
    // Adding subsup mark to all text
    const contentDecorator = (n)=>{
        const mark = schema.marks.subsup.create({
            type: 'sub'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'subsup',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '~', '~');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("lf0Nr", function(module, exports) {

$parcel$export(module.exports, "superscript", () => $6f4f331694cf9bb6$export$b4aab94a5fcfcead);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");
const $6f4f331694cf9bb6$export$b4aab94a5fcfcead = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a  mark
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).ISSUE_KEY,
        (0, $kSL4h.TokenType).TABLE
    ];
    // Adding subsup mark to all text
    const contentDecorator = (n)=>{
        const mark = schema.marks.subsup.create({
            type: 'sup'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'subsup',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '^', '^');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("4s89q", function(module, exports) {

$parcel$export(module.exports, "table", () => $8c7a9474c5649f43$export$9852986a3ec5f6a0);

var $48GZN = parcelRequire("48GZN");

var $29zBb = parcelRequire("29zBb");

var $20lXC = parcelRequire("20lXC");

var $7tIdE = parcelRequire("7tIdE");

var $4Foyv = parcelRequire("4Foyv");

var $jor5q = parcelRequire("jor5q");

var $kSL4h = parcelRequire("kSL4h");

var $eWAZI = parcelRequire("eWAZI");

var $cG4PY = parcelRequire("cG4PY");

var $gxAE9 = parcelRequire("gxAE9");
/*
  The following are currently NOT supported
  1. Macros
  2. Escape |
  3. Table of table
*/ // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8c7a9474c5649f43$var$CELL_REGEXP = /^([ \t]*)([|]+)([ \t]*)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8c7a9474c5649f43$var$EMPTY_LINE_REGEXP = /^[ \t]*\r?\n/;
const $8c7a9474c5649f43$var$processState = {
    END_TABLE: 2,
    BUFFER: 4,
    CLOSE_ROW: 5,
    NEW_ROW: 6,
    LINE_BREAK: 7,
    LINK: 8,
    MEDIA: 9,
    MACRO: 10,
    EMOJI: 11
};
const $8c7a9474c5649f43$export$9852986a3ec5f6a0 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a table cell
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TABLE,
        (0, $kSL4h.TokenType).RULER
    ];
    const output = [];
    let index = position;
    let currentState = $8c7a9474c5649f43$var$processState.NEW_ROW;
    let buffer = [];
    let cellsBuffer = [];
    let cellStyle = '';
    let builder = null;
    while(index < input.length){
        const char = input.charAt(index);
        const substring = input.substring(index);
        switch(currentState){
            case $8c7a9474c5649f43$var$processState.NEW_ROW:
                {
                    const tableMatch = substring.match($8c7a9474c5649f43$var$CELL_REGEXP);
                    if (tableMatch) {
                        if (!builder) builder = new (0, $48GZN.TableBuilder)(schema);
                        // Capture empty spaces
                        index += tableMatch[1].length;
                        cellStyle = tableMatch[2];
                        index += tableMatch[2].length;
                        currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                        continue;
                    }
                    currentState = $8c7a9474c5649f43$var$processState.END_TABLE;
                    continue;
                }
            case $8c7a9474c5649f43$var$processState.LINE_BREAK:
                {
                    const emptyLineMatch = substring.match($8c7a9474c5649f43$var$EMPTY_LINE_REGEXP);
                    if (emptyLineMatch) {
                        // If we encounter an empty line, we should end the table
                        $8c7a9474c5649f43$var$bufferToCells(cellStyle, buffer.join(''), cellsBuffer, schema, ignoreTokenTypes, context);
                        currentState = $8c7a9474c5649f43$var$processState.END_TABLE;
                        continue;
                    }
                    // If we enconter a new row
                    const cellMatch = substring.match($8c7a9474c5649f43$var$CELL_REGEXP);
                    if (cellMatch) currentState = $8c7a9474c5649f43$var$processState.CLOSE_ROW;
                    else currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                    continue;
                }
            case $8c7a9474c5649f43$var$processState.BUFFER:
                {
                    const length = (0, $eWAZI.parseNewlineOnly)(substring);
                    if (length) {
                        // Calculate the index of the end of the current cell,
                        // upto and including the new line
                        const endIndex = index;
                        // Calculate the index of the start of the current cell
                        const startIndex = input.lastIndexOf('|', endIndex) + 1;
                        const charsBefore = input.substring(startIndex, endIndex);
                        if (charsBefore === '' || charsBefore.match($8c7a9474c5649f43$var$EMPTY_LINE_REGEXP)) currentState = $8c7a9474c5649f43$var$processState.CLOSE_ROW;
                        else {
                            currentState = $8c7a9474c5649f43$var$processState.LINE_BREAK;
                            buffer.push(input.substr(index, length));
                        }
                        index += length;
                        continue;
                    }
                    switch(char){
                        case '|':
                            {
                                // This is now end of a cell, we should wrap the buffer into a cell
                                $8c7a9474c5649f43$var$bufferToCells(cellStyle, buffer.join(''), cellsBuffer, schema, ignoreTokenTypes, context);
                                buffer = [];
                                // Update cells tyle
                                const cellMatch = substring.match($8c7a9474c5649f43$var$CELL_REGEXP);
                                // The below if statement should aways be true, we leave it here to prevent any future code changes fall into infinite loop
                                if (cellMatch) {
                                    cellStyle = cellMatch[2];
                                    // Move into the cell content
                                    index += cellMatch[2].length;
                                    continue;
                                }
                                break;
                            }
                        case ':':
                        case ';':
                        case '(':
                            currentState = $8c7a9474c5649f43$var$processState.EMOJI;
                            continue;
                        case '[':
                            currentState = $8c7a9474c5649f43$var$processState.LINK;
                            continue;
                        case '!':
                            currentState = $8c7a9474c5649f43$var$processState.MEDIA;
                            continue;
                        case '{':
                            currentState = $8c7a9474c5649f43$var$processState.MACRO;
                            continue;
                        default:
                            buffer.push(char);
                            index++;
                            continue;
                    }
                    break;
                }
            case $8c7a9474c5649f43$var$processState.CLOSE_ROW:
                {
                    const bufferOutput = buffer.join('');
                    if (bufferOutput.trim().length > 0) {
                        $8c7a9474c5649f43$var$bufferToCells(cellStyle, bufferOutput, cellsBuffer, schema, ignoreTokenTypes, context);
                        buffer = [];
                    }
                    if (builder) {
                        builder.add(cellsBuffer);
                        cellsBuffer = [];
                    }
                    currentState = $8c7a9474c5649f43$var$processState.NEW_ROW;
                    continue;
                }
            case $8c7a9474c5649f43$var$processState.END_TABLE:
                if (builder) {
                    if (cellsBuffer.length) builder.add(cellsBuffer);
                    output.push(builder.buildPMNode());
                }
                return {
                    type: 'pmnode',
                    nodes: output,
                    length: index - position
                };
            case $8c7a9474c5649f43$var$processState.MEDIA:
                {
                    const token = (0, $4Foyv.media)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                    continue;
                }
            case $8c7a9474c5649f43$var$processState.EMOJI:
                {
                    const token = (0, $jor5q.emoji)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                    continue;
                }
            case $8c7a9474c5649f43$var$processState.LINK:
                {
                    /**
				 * We should "fly over" the link format and we dont want
				 * -awesome [link|https://www.atlass-ian.com] nice
				 * to be a strike through because of the '-' in link
				 */ const token = (0, $7tIdE.linkFormat)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                        continue;
                    } else if (token.type === 'pmnode') {
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                        continue;
                    }
                    break;
                }
            case $8c7a9474c5649f43$var$processState.MACRO:
                {
                    const match = (0, $cG4PY.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                        break;
                    }
                    const token = (0, $kSL4h.parseToken)(input, match.type, index, schema, context);
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                    continue;
                }
        }
        index++;
    }
    /**
	 * If there are left over content which didn't have a closing |
	 * For example
	 * |cell1|cell2|cell3
	 * we still want to create a new cell for the last cell3 if it's
	 * not empty.
	 */ const bufferOutput = buffer.join('');
    if (bufferOutput.trim().length > 0) $8c7a9474c5649f43$var$bufferToCells(cellStyle, bufferOutput, cellsBuffer, schema, ignoreTokenTypes, context);
    if (builder) {
        if (cellsBuffer.length) builder.add(cellsBuffer);
        output.push(builder.buildPMNode());
    }
    return {
        type: 'pmnode',
        nodes: output,
        length: index - position
    };
};
function $8c7a9474c5649f43$var$bufferToCells(style, buffer, cellsBuffer, schema, ignoreTokenTypes, context) {
    if (buffer.length) {
        let contentNode = (0, $29zBb.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: buffer
        });
        if (style === '||') contentNode = contentNode.map((e)=>{
            return $8c7a9474c5649f43$var$createTableHeader(e, schema);
        });
        cellsBuffer.push({
            style: style,
            content: (0, $20lXC.normalizePMNodes)(contentNode, schema)
        });
    }
}
function $8c7a9474c5649f43$var$createTableHeader(node, schema) {
    const mark = schema.marks.strong.create();
    return $8c7a9474c5649f43$var$traverseNodeAndAddMarks(node, mark, schema);
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8c7a9474c5649f43$var$traverseContent(node, mark, schema) {
    if (node.content.childCount === 0 || !node.content.child(0) || !node.content.firstChild || node.type.name === 'codeBlock') return node;
    for(let i = 0; i < node.content.childCount; i++){
        const child = node.content.child(i);
        const markedChild = $8c7a9474c5649f43$var$traverseNodeAndAddMarks(child, mark, schema);
        const updatedContent = node.content.replaceChild(i, markedChild);
        node = node.copy(updatedContent);
    }
    return node;
}
function $8c7a9474c5649f43$var$traverseNodeAndAddMarks(node, mark, schema) {
    if (node.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(node, [
        'strong',
        'code'
    ])) {
        const newNode = node.mark([
            ...node.marks,
            mark
        ]);
        return newNode;
    }
    return $8c7a9474c5649f43$var$traverseContent(node, mark, schema);
}

});
parcelRegister("48GZN", function(module, exports) {

$parcel$export(module.exports, "TableBuilder", () => $75a71ab9390c3135$export$9e18c07f56f31a89);
/**
 * Return the cell type based on the delimeter
 */ function $75a71ab9390c3135$var$getType(style) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /\|\|/.test(style) ? 'tableHeader' : 'tableCell';
}
class $75a71ab9390c3135$export$9e18c07f56f31a89 {
    constructor(schema){
        this.emptyTableCell = ()=>{
            const { tableCell: tableCell, paragraph: paragraph } = this.schema.nodes;
            return tableCell.createChecked({}, paragraph.createChecked());
        };
        this.emptyTableRow = ()=>{
            const { tableRow: tableRow } = this.schema.nodes;
            return tableRow.createChecked({}, this.emptyTableCell());
        };
        /**
	 * Build prosemirror table node
	 * @returns {PMNode}
	 */ this.buildTableNode = ()=>{
            const { root: root } = this;
            const { table: table } = this.schema.nodes;
            const content = root.rows.map(this.buildTableRowNode);
            if (content.length === 0) content.push(this.emptyTableRow());
            return table.createChecked({}, content);
        };
        /**
	 * Build prosemirror tr node
	 * @returns {PMNode}
	 */ this.buildTableRowNode = (row)=>{
            const { tableRow: tableRow } = this.schema.nodes;
            return tableRow.createChecked({}, row.cells.map(this.buildTableCellNode));
        };
        /**
	 * Build prosemirror td/th node
	 * @param {TableCell} cell
	 * @returns {PMNode}
	 */ this.buildTableCellNode = (cell)=>{
            const { type: type, content: content } = cell;
            if (content.length === 0) content.push(this.schema.nodes.paragraph.createChecked());
            const cellNode = this.schema.nodes[type];
            return cellNode.createChecked({}, content);
        };
        this.schema = schema;
        this.root = {
            rows: []
        };
    }
    /**
	 * Return the type of the base element
	 * @returns {string}
	 */ get type() {
        return 'table';
    }
    /**
	 * Add new cells to the table
	 * @param {AddCellArgs[]} cells
	 */ add(cells) {
        if (!cells.length) return;
        // Iterate the cells and create TH/TD based on the delimeter
        let index = 0;
        for (const cell of cells){
            const { content: content, style: style } = cell;
            const cellType = $75a71ab9390c3135$var$getType(style);
            // For the first item, determine if it's a new row or not
            if (index === 0) this.addRow();
            const newCell = {
                type: cellType,
                content: content
            };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.lastRow.cells.push(newCell);
            index += 1;
        }
    }
    /**
	 * Build a prosemirror table from the data
	 * @returns {PMNode}
	 */ buildPMNode() {
        return this.buildTableNode();
    }
    /**
	 * Add a new row to the table
	 */ addRow() {
        const { rows: rows } = this.root;
        const row = {
            cells: []
        };
        rows.push(row);
        this.lastRow = row;
    }
}

});


parcelRegister("ir9MO", function(module, exports) {

$parcel$export(module.exports, "tripleDashSymbol", () => $0a377f498827084a$export$edbcd749367de060);

var $1rQjR = parcelRequire("1rQjR");
const $0a377f498827084a$var$token = {
    type: 'text',
    text: '\u2014',
    length: 3
};
const $0a377f498827084a$var$fallback = {
    ...$0a377f498827084a$var$token,
    text: '---'
};
const $0a377f498827084a$export$edbcd749367de060 = (0, $1rQjR.createDashTokenParser)($0a377f498827084a$var$token, $0a377f498827084a$var$fallback);

});

parcelRegister("7E14k", function(module, exports) {

$parcel$export(module.exports, "panelMacro", () => $fa58ef1a18570456$export$5d7bf7e31a674541);

var $3JW2n = parcelRequire("3JW2n");

var $29zBb = parcelRequire("29zBb");

var $4ZUg7 = parcelRequire("4ZUg7");

var $20lXC = parcelRequire("20lXC");

var $fQoRM = parcelRequire("fQoRM");

var $1agyv = parcelRequire("1agyv");
const $fa58ef1a18570456$var$allowedNodeType = [
    'paragraph',
    'heading',
    'orderedList',
    'bulletList'
];
const $fa58ef1a18570456$export$5d7bf7e31a674541 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $3JW2n.commonMacro)(input.substring(position), schema, {
        keyword: 'panel',
        paired: true,
        context: context,
        rawContentProcessor: $fa58ef1a18570456$var$rawContentProcessor
    });
};
const $fa58ef1a18570456$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, context)=>{
    const output = [];
    const parsedAttrs = (0, $4ZUg7.parseAttrs)(rawAttrs);
    const nodeAttrs = {
        ...parsedAttrs,
        panelType: (0, $fQoRM.getPanelType)(parsedAttrs)
    };
    const parsedContent = (0, $29zBb.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: [],
        input: rawContent
    });
    const normalizedContent = (0, $20lXC.normalizePMNodes)(parsedContent, schema);
    let contentBuffer = parsedAttrs.title ? [
        (0, $1agyv.title)(parsedAttrs.title, schema)
    ] : [];
    for (const n of normalizedContent)if ($fa58ef1a18570456$var$allowedNodeType.indexOf(n.type.name) !== -1) contentBuffer.push(n);
    else {
        const panelNode = schema.nodes.panel.createChecked(nodeAttrs, contentBuffer.length ? contentBuffer : schema.nodes.paragraph.createChecked());
        contentBuffer = [];
        output.push(panelNode);
        output.push(n);
    }
    if (contentBuffer.length > 0) {
        const panelNode = schema.nodes.panel.createChecked(nodeAttrs, contentBuffer);
        output.push(panelNode);
    }
    return {
        type: 'pmnode',
        nodes: output.length ? output : [
            $fa58ef1a18570456$var$emptyPanel(schema)
        ],
        length: length
    };
};
function $fa58ef1a18570456$var$emptyPanel(schema) {
    const p = schema.nodes.paragraph.createChecked();
    return schema.nodes.panel.createChecked({}, p);
}

});
parcelRegister("fQoRM", function(module, exports) {

$parcel$export(module.exports, "getPanelType", () => $afb9d2bd4cb626dc$export$fa00fa3d6c22a747);

var $4PfBJ = parcelRequire("4PfBJ");
const $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX = {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    hexShort: /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    hexLong: /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    rgb: /^#?rgb\((\d+),\s*(\d+),\s*(\d+)\)$/,
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    prgb: /^#?rgb\((\d+)%,\s*(\d+)%,\s*(\d+)%\)$/
};
const $afb9d2bd4cb626dc$var$PANEL_TYPE_TO_RGB = {
    info: {
        r: 222,
        g: 235,
        b: 255
    },
    note: {
        r: 234,
        g: 230,
        b: 255
    },
    success: {
        r: 227,
        g: 252,
        b: 239
    },
    warning: {
        r: 255,
        g: 250,
        b: 230
    },
    error: {
        r: 255,
        g: 235,
        b: 230
    }
};
function $afb9d2bd4cb626dc$export$fa00fa3d6c22a747(attrs) {
    const rgb = $afb9d2bd4cb626dc$var$generateRgb(attrs.bgColor);
    if (!rgb) return 'info';
    let mapTo = 'info';
    let smallestDistance = Infinity;
    Object.keys($afb9d2bd4cb626dc$var$PANEL_TYPE_TO_RGB).forEach((panelType)=>{
        const distance = $afb9d2bd4cb626dc$var$distanceOfRgb($afb9d2bd4cb626dc$var$PANEL_TYPE_TO_RGB[panelType], rgb);
        if (distance < smallestDistance) {
            smallestDistance = distance;
            mapTo = panelType;
        }
    });
    return mapTo;
}
function $afb9d2bd4cb626dc$var$distanceOfRgb(a, b) {
    // https://en.wikipedia.org/wiki/Color_difference
    return Math.pow(a.r - b.r, 2) + Math.pow(a.g - b.g, 2) + Math.pow(a.b - b.b, 2);
}
function $afb9d2bd4cb626dc$var$generateRgb(color) {
    switch(true){
        case $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.hexShort.test(color) || $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.hexLong.test(color):
            return $afb9d2bd4cb626dc$var$parseHex(color);
        case $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.rgb.test(color):
            return $afb9d2bd4cb626dc$var$parseRgb(color);
        case $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.prgb.test(color):
            return $afb9d2bd4cb626dc$var$parsePrgb(color);
        default:
            return $afb9d2bd4cb626dc$var$parseColorName(color);
    }
}
function $afb9d2bd4cb626dc$var$parseHex(hex) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    hex = hex.replace($afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.hexShort, (_m, r, g, b)=>{
        return r + r + g + g + b + b;
    });
    const result = $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.hexLong.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}
function $afb9d2bd4cb626dc$var$parseRgb(rgb) {
    const result = rgb.match($afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.rgb);
    return result ? {
        r: parseInt(result[1], 10),
        g: parseInt(result[2], 10),
        b: parseInt(result[3], 10)
    } : null;
}
function $afb9d2bd4cb626dc$var$parsePrgb(prgb) {
    const result = prgb.match($afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.prgb);
    return result ? {
        r: Math.floor(255 * parseInt(result[1], 10) / 100),
        g: Math.floor(255 * parseInt(result[2], 10) / 100),
        b: Math.floor(255 * parseInt(result[4], 10) / 100)
    } : null;
}
function $afb9d2bd4cb626dc$var$parseColorName(color) {
    return (0, $4PfBJ.default)[color];
}

});
parcelRegister("4PfBJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe6de0fe9d8acfe8$export$2e2bcd8739ae039);
const $fe6de0fe9d8acfe8$var$mapping = {
    crimson: {
        r: 220,
        g: 20,
        b: 60
    },
    lightpink: {
        r: 255,
        g: 182,
        b: 193
    },
    pink: {
        r: 255,
        g: 192,
        b: 203
    },
    palevioletred: {
        r: 219,
        g: 112,
        b: 147
    },
    lavenderblush: {
        r: 255,
        g: 240,
        b: 245
    },
    hotpink: {
        r: 255,
        g: 105,
        b: 180
    },
    deeppink: {
        r: 255,
        g: 20,
        b: 147
    },
    mediumvioletred: {
        r: 199,
        g: 21,
        b: 133
    },
    orchid: {
        r: 218,
        g: 112,
        b: 214
    },
    thistle: {
        r: 216,
        g: 191,
        b: 216
    },
    plum: {
        r: 221,
        g: 160,
        b: 221
    },
    violet: {
        r: 238,
        g: 130,
        b: 238
    },
    fuchsia: {
        r: 255,
        g: 0,
        b: 255
    },
    darkmagenta: {
        r: 139,
        g: 0,
        b: 139
    },
    purple: {
        r: 128,
        g: 0,
        b: 128
    },
    mediumorchid: {
        r: 186,
        g: 85,
        b: 211
    },
    darkviolet: {
        r: 148,
        g: 0,
        b: 211
    },
    darkorchid: {
        r: 153,
        g: 50,
        b: 204
    },
    indigo: {
        r: 75,
        g: 0,
        b: 130
    },
    blueviolet: {
        r: 138,
        g: 43,
        b: 226
    },
    mediumpurple: {
        r: 147,
        g: 112,
        b: 219
    },
    darkslateblue: {
        r: 72,
        g: 61,
        b: 139
    },
    mediumslateblue: {
        r: 123,
        g: 104,
        b: 238
    },
    slateblue: {
        r: 106,
        g: 90,
        b: 205
    },
    ghostwhite: {
        r: 248,
        g: 248,
        b: 255
    },
    lavender: {
        r: 230,
        g: 230,
        b: 250
    },
    blue: {
        r: 0,
        g: 0,
        b: 255
    },
    mediumblue: {
        r: 0,
        g: 0,
        b: 205
    },
    darkblue: {
        r: 0,
        g: 0,
        b: 139
    },
    navy: {
        r: 0,
        g: 0,
        b: 128
    },
    midnightblue: {
        r: 25,
        g: 25,
        b: 112
    },
    royalblue: {
        r: 65,
        g: 105,
        b: 225
    },
    cornflowerblue: {
        r: 100,
        g: 149,
        b: 237
    },
    lightsteelblue: {
        r: 176,
        g: 196,
        b: 222
    },
    lightslategray: {
        r: 119,
        g: 136,
        b: 153
    },
    slategray: {
        r: 112,
        g: 128,
        b: 144
    },
    dodgerblue: {
        r: 30,
        g: 144,
        b: 255
    },
    aliceblue: {
        r: 240,
        g: 248,
        b: 255
    },
    steelblue: {
        r: 70,
        g: 130,
        b: 180
    },
    lightskyblue: {
        r: 135,
        g: 206,
        b: 250
    },
    skyblue: {
        r: 135,
        g: 206,
        b: 235
    },
    deepskyblue: {
        r: 0,
        g: 191,
        b: 255
    },
    lightblue: {
        r: 173,
        g: 216,
        b: 230
    },
    powderblue: {
        r: 176,
        g: 224,
        b: 230
    },
    cadetblue: {
        r: 95,
        g: 158,
        b: 160
    },
    darkturquoise: {
        r: 0,
        g: 206,
        b: 209
    },
    azure: {
        r: 240,
        g: 255,
        b: 255
    },
    lightcyan: {
        r: 224,
        g: 255,
        b: 255
    },
    paleturquoise: {
        r: 174,
        g: 238,
        b: 238
    },
    darkslategray: {
        r: 47,
        g: 79,
        b: 79
    },
    aqua: {
        r: 0,
        g: 255,
        b: 255
    },
    darkcyan: {
        r: 0,
        g: 139,
        b: 139
    },
    teal: {
        r: 0,
        g: 128,
        b: 128
    },
    mediumturquoise: {
        r: 72,
        g: 209,
        b: 204
    },
    lightseagreen: {
        r: 32,
        g: 178,
        b: 170
    },
    turquoise: {
        r: 64,
        g: 224,
        b: 208
    },
    aquamarine: {
        r: 127,
        g: 255,
        b: 212
    },
    mediumaquamarine: {
        r: 102,
        g: 205,
        b: 170
    },
    mediumspringgreen: {
        r: 0,
        g: 250,
        b: 154
    },
    mintcream: {
        r: 245,
        g: 255,
        b: 250
    },
    springgreen: {
        r: 0,
        g: 255,
        b: 127
    },
    mediumseagreen: {
        r: 60,
        g: 179,
        b: 113
    },
    seagreen: {
        r: 46,
        g: 139,
        b: 87
    },
    honeydew: {
        r: 240,
        g: 255,
        b: 240
    },
    darkseagreen: {
        r: 143,
        g: 188,
        b: 143
    },
    palegreen: {
        r: 152,
        g: 251,
        b: 152
    },
    lightgreen: {
        r: 144,
        g: 238,
        b: 144
    },
    limegreen: {
        r: 50,
        g: 205,
        b: 50
    },
    forestgreen: {
        r: 34,
        g: 139,
        b: 34
    },
    lime: {
        r: 0,
        g: 255,
        b: 0
    },
    green: {
        r: 0,
        g: 128,
        b: 0
    },
    darkgreen: {
        r: 0,
        g: 100,
        b: 0
    },
    lawngreen: {
        r: 124,
        g: 252,
        b: 0
    },
    chartreuse: {
        r: 127,
        g: 255,
        b: 0
    },
    greenyellow: {
        r: 173,
        g: 255,
        b: 47
    },
    darkolivegreen: {
        r: 85,
        g: 107,
        b: 47
    },
    olivedrab: {
        r: 107,
        g: 142,
        b: 35
    },
    yellowgreen: {
        r: 154,
        g: 205,
        b: 50
    },
    ivory: {
        r: 255,
        g: 255,
        b: 240
    },
    beige: {
        r: 245,
        g: 245,
        b: 220
    },
    lightyellow: {
        r: 255,
        g: 255,
        b: 224
    },
    lightgoldenrodyellow: {
        r: 250,
        g: 250,
        b: 210
    },
    yellow: {
        r: 255,
        g: 255,
        b: 0
    },
    olive: {
        r: 128,
        g: 128,
        b: 0
    },
    darkkhaki: {
        r: 189,
        g: 183,
        b: 107
    },
    khaki: {
        r: 240,
        g: 230,
        b: 140
    },
    palegoldenrod: {
        r: 238,
        g: 232,
        b: 170
    },
    lemonchiffon: {
        r: 255,
        g: 250,
        b: 205
    },
    gold: {
        r: 255,
        g: 215,
        b: 0
    },
    cornsilk: {
        r: 255,
        g: 248,
        b: 220
    },
    goldenrod: {
        r: 218,
        g: 165,
        b: 32
    },
    darkgoldenrod: {
        r: 184,
        g: 134,
        b: 11
    },
    orange: {
        r: 255,
        g: 128,
        b: 0
    },
    floralwhite: {
        r: 255,
        g: 250,
        b: 240
    },
    oldlace: {
        r: 253,
        g: 245,
        b: 230
    },
    wheat: {
        r: 245,
        g: 222,
        b: 179
    },
    moccasin: {
        r: 255,
        g: 228,
        b: 181
    },
    papayawhip: {
        r: 255,
        g: 239,
        b: 213
    },
    blanchedalmond: {
        r: 255,
        g: 235,
        b: 205
    },
    navajowhite: {
        r: 255,
        g: 222,
        b: 173
    },
    tan: {
        r: 210,
        g: 180,
        b: 140
    },
    antiquewhite: {
        r: 250,
        g: 235,
        b: 215
    },
    burlywood: {
        r: 222,
        g: 184,
        b: 135
    },
    bisque: {
        r: 255,
        g: 228,
        b: 196
    },
    darkorange: {
        r: 255,
        g: 140,
        b: 0
    },
    peru: {
        r: 205,
        g: 133,
        b: 63
    },
    linen: {
        r: 250,
        g: 240,
        b: 230
    },
    peachpuff: {
        r: 255,
        g: 218,
        b: 185
    },
    seashell: {
        r: 255,
        g: 245,
        b: 238
    },
    sandybrown: {
        r: 244,
        g: 164,
        b: 96
    },
    chocolate: {
        r: 210,
        g: 105,
        b: 30
    },
    saddlebrown: {
        r: 139,
        g: 69,
        b: 19
    },
    sienna: {
        r: 160,
        g: 82,
        b: 45
    },
    lightsalmon: {
        r: 255,
        g: 160,
        b: 122
    },
    coral: {
        r: 255,
        g: 127,
        b: 80
    },
    orangered: {
        r: 255,
        g: 69,
        b: 0
    },
    darksalmon: {
        r: 233,
        g: 150,
        b: 122
    },
    tomato: {
        r: 255,
        g: 99,
        b: 71
    },
    salmon: {
        r: 250,
        g: 128,
        b: 114
    },
    mistyrose: {
        r: 255,
        g: 228,
        b: 225
    },
    snow: {
        r: 255,
        g: 250,
        b: 250
    },
    rosybrown: {
        r: 188,
        g: 143,
        b: 143
    },
    lightcoral: {
        r: 240,
        g: 128,
        b: 128
    },
    indianred: {
        r: 205,
        g: 92,
        b: 92
    },
    brown: {
        r: 165,
        g: 42,
        b: 42
    },
    firebrick: {
        r: 178,
        g: 34,
        b: 34
    },
    red: {
        r: 255,
        g: 0,
        b: 0
    },
    darkred: {
        r: 139,
        g: 0,
        b: 0
    },
    maroon: {
        r: 128,
        g: 0,
        b: 0
    },
    white: {
        r: 255,
        g: 255,
        b: 255
    },
    gainsboro: {
        r: 220,
        g: 220,
        b: 220
    },
    lightgray: {
        r: 211,
        g: 211,
        b: 211
    },
    silver: {
        r: 192,
        g: 192,
        b: 192
    },
    darkgray: {
        r: 169,
        g: 169,
        b: 169
    },
    gray: {
        r: 128,
        g: 128,
        b: 128
    },
    dimgray: {
        r: 105,
        g: 105,
        b: 105
    },
    black: {
        r: 0,
        g: 0,
        b: 0
    },
    whitesmoke: {
        r: 245,
        g: 245,
        b: 245
    }
};
var $fe6de0fe9d8acfe8$export$2e2bcd8739ae039 = $fe6de0fe9d8acfe8$var$mapping;

});


parcelRegister("1agyv", function(module, exports) {

$parcel$export(module.exports, "title", () => $9eccd901f1df184b$export$fb184b623420d9be);
function $9eccd901f1df184b$export$fb184b623420d9be(text, schema) {
    const mark = schema.marks.strong.create();
    const title = schema.text(text, [
        mark
    ]);
    return schema.nodes.paragraph.createChecked({}, [
        title
    ]);
}

});


parcelRegister("9MeiU", function(module, exports) {

$parcel$export(module.exports, "adfMacro", () => $39fb2727ee273b16$export$8fb4b58db8f664fb);

var $3JW2n = parcelRequire("3JW2n");
const $39fb2727ee273b16$export$8fb4b58db8f664fb = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $3JW2n.commonMacro)(input.substring(position), schema, {
        keyword: 'adf',
        paired: true,
        context: context,
        rawContentProcessor: $39fb2727ee273b16$var$rawContentProcessor
    });
};
const $39fb2727ee273b16$var$rawContentProcessor = (_rawAttrs, rawContent, length, schema, _context)=>{
    try {
        const json = JSON.parse(rawContent);
        const node = schema.nodeFromJSON(json);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    } catch (_e) {
        const textContent = `Invalid ADF Macro: ${rawContent}`;
        const textNode = rawContent.length ? schema.text(textContent) : undefined;
        const { codeBlock: codeBlock } = schema.nodes;
        const node = codeBlock.create({
            language: undefined
        }, textNode);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    }
};

});

parcelRegister("f50H1", function(module, exports) {

$parcel$export(module.exports, "anchorMacro", () => $4b331e3d410cf176$export$e660dadc21580fa2);

var $3JW2n = parcelRequire("3JW2n");
const $4b331e3d410cf176$export$e660dadc21580fa2 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $3JW2n.commonMacro)(input.substring(position), schema, {
        keyword: 'anchor',
        paired: false,
        context: context,
        rawContentProcessor: $4b331e3d410cf176$var$rawContentProcessor
    });
};
const $4b331e3d410cf176$var$rawContentProcessor = (_rawAttrs, _rawContent, length, _schema, _context)=>{
    return {
        type: 'text',
        text: '',
        length: length
    };
};

});

parcelRegister("bSil4", function(module, exports) {

$parcel$export(module.exports, "codeMacro", () => $38ee74463de0ec95$export$db6c131ac26c7700);

var $3JW2n = parcelRequire("3JW2n");

var $4ZUg7 = parcelRequire("4ZUg7");

var $1agyv = parcelRequire("1agyv");
const $38ee74463de0ec95$var$SUPPORTED_CODEBOCK_LANGUAGES = [
    'abap',
    'actionscript',
    'ada',
    'arduino',
    'autoit',
    'c',
    'c++',
    'clojure',
    'coffeescript',
    'csharp',
    'css',
    'cuda',
    'd',
    'dart',
    'delphi',
    'elixir',
    'erlang',
    'fortran',
    'foxpro',
    'go',
    'groovy',
    'haskell',
    'haxe',
    'html',
    'java',
    'javascript',
    'json',
    'julia',
    'kotlin',
    'latex',
    'livescript',
    'lua',
    'mathematica',
    'matlab',
    'objective-c',
    'objective-j',
    'objectpascal',
    'ocaml',
    'octave',
    'perl',
    'php',
    'powershell',
    'prolog',
    'puppet',
    'python',
    'qml',
    'r',
    'racket',
    'restructuredtext',
    'ruby',
    'rust',
    'sass',
    'scala',
    'scheme',
    'shell',
    'smalltalk',
    'sql',
    'standardml',
    'swift',
    'tcl',
    'tex',
    'typescript',
    'vala',
    'vbnet',
    'verilog',
    'vhdl',
    'xml',
    'xquery'
];
const $38ee74463de0ec95$export$db6c131ac26c7700 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $3JW2n.commonMacro)(input.substring(position), schema, {
        keyword: 'code',
        paired: true,
        context: context,
        rawContentProcessor: $38ee74463de0ec95$var$rawContentProcessor
    });
};
const $38ee74463de0ec95$var$rawContentProcessor = (rawAttrs, rawContent, length, schema)=>{
    const output = [];
    const { codeBlock: codeBlock } = schema.nodes;
    const parsedAttrs = (0, $4ZUg7.parseAttrs)(rawAttrs);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const trimedContent = rawContent.replace(/^\s+|\s+$/g, '');
    const textNode = trimedContent.length ? schema.text(trimedContent) : undefined;
    if (parsedAttrs.title) output.push((0, $1agyv.title)(parsedAttrs.title, schema));
    const nodeAttrs = {
        ...parsedAttrs,
        language: $38ee74463de0ec95$var$getCodeLanguage(parsedAttrs)
    };
    output.push(codeBlock.createChecked(nodeAttrs, textNode));
    return {
        type: 'pmnode',
        nodes: output,
        length: length
    };
};
function $38ee74463de0ec95$var$getCodeLanguage(attrs) {
    const keys = Object.keys(attrs).map((key)=>key.toLowerCase());
    for (const language of $38ee74463de0ec95$var$SUPPORTED_CODEBOCK_LANGUAGES){
        if (keys.indexOf(language) !== -1) return language;
    }
    if (keys.indexOf('objc') !== -1) return 'objective-c';
    return 'java';
}

});

parcelRegister("cjZPi", function(module, exports) {

$parcel$export(module.exports, "colorMacro", () => $2374771f8fbda9ef$export$b557be495948d995);

var $kSL4h = parcelRequire("kSL4h");

var $3JW2n = parcelRequire("3JW2n");

var $4ZUg7 = parcelRequire("4ZUg7");

var $29zBb = parcelRequire("29zBb");

var $7p5zM = parcelRequire("7p5zM");

var $gxAE9 = parcelRequire("gxAE9");
const $2374771f8fbda9ef$export$b557be495948d995 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $3JW2n.commonMacro)(input.substring(position), schema, {
        keyword: 'color',
        paired: true,
        context: context,
        rawContentProcessor: $2374771f8fbda9ef$var$rawContentProcessor
    });
};
const $2374771f8fbda9ef$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, context)=>{
    // Removed ISSUE_KEY for https://getsupport.atlassian.com/browse/MOVE-1738018
    // Issue keys were not being migrated correctly if they were inside the color macro.
    const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TABLE
    ];
    const parsedAttrs = (0, $4ZUg7.parseAttrs)(rawAttrs);
    const content = (0, $29zBb.parseString)({
        ignoreTokenTypes: ignoreTokenTypes,
        schema: schema,
        context: context,
        input: rawContent
    });
    const decoratedContent = content.map((n)=>{
        const mark = schema.marks.textColor.create({
            color: (0, $7p5zM.getEditorColor)(parsedAttrs) || '#000000'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'textColor',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    });
    return {
        type: 'pmnode',
        nodes: decoratedContent,
        length: length
    };
};

});
parcelRegister("7p5zM", function(module, exports) {

$parcel$export(module.exports, "getEditorColor", () => $dace0eb9654d7c1b$export$c0cfc6f23e0b7578);

var $51H8P = parcelRequire("51H8P");
function $dace0eb9654d7c1b$export$c0cfc6f23e0b7578(attrs) {
    const keys = Object.keys(attrs);
    return (0, $51H8P.normalizeHexColor)(keys[0]);
}

});


parcelRegister("8tGpW", function(module, exports) {

$parcel$export(module.exports, "noformatMacro", () => $7fe042bf55811a5b$export$9199752eb9b2d5b4);

var $3JW2n = parcelRequire("3JW2n");

var $4ZUg7 = parcelRequire("4ZUg7");

var $1agyv = parcelRequire("1agyv");
const $7fe042bf55811a5b$export$9199752eb9b2d5b4 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $3JW2n.commonMacro)(input.substring(position), schema, {
        keyword: 'noformat',
        paired: true,
        context: context,
        rawContentProcessor: $7fe042bf55811a5b$var$rawContentProcessor
    });
};
const $7fe042bf55811a5b$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, _context)=>{
    const output = [];
    const { codeBlock: codeBlock } = schema.nodes;
    const parsedAttrs = (0, $4ZUg7.parseAttrs)(rawAttrs);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const trimedContent = rawContent.replace(/^\s+|\s+$/g, '');
    const textNode = trimedContent.length ? schema.text(trimedContent) : undefined;
    if (parsedAttrs.title) output.push((0, $1agyv.title)(parsedAttrs.title, schema));
    output.push(codeBlock.createChecked({}, textNode));
    return {
        type: 'pmnode',
        nodes: output,
        length: length
    };
};

});

parcelRegister("lyI5i", function(module, exports) {

$parcel$export(module.exports, "forceLineBreak", () => $90e9f72be02de2ac$export$2de3d7fd25cbc36);
/**
 * Jira is using the following regex to match force line break
 * private static final Pattern FORCE_NEWLINE = Pattern.compile("(?<!\\\\)\\\\{2}(?!\\S*\\\\)");
 */ // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $90e9f72be02de2ac$var$FORCE_LINE_BREAK_REGEX = /^\\{2}(?!\S*\\)/;
const $90e9f72be02de2ac$export$2de3d7fd25cbc36 = ({ input: input, position: position, schema: schema })=>{
    if (position > 0) {
        const charBefore = input.charAt(position - 1);
        if (charBefore === '\\') return $90e9f72be02de2ac$var$fallback(input, position);
    }
    const match = input.substring(position).match($90e9f72be02de2ac$var$FORCE_LINE_BREAK_REGEX);
    if (match) return {
        type: 'pmnode',
        nodes: [
            schema.nodes.hardBreak.createChecked()
        ],
        length: 2
    };
    return $90e9f72be02de2ac$var$fallback(input, position);
};
function $90e9f72be02de2ac$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 2),
        length: 2
    };
}

});



parcelRegister("4yZSi", function(module, exports) {

$parcel$export(module.exports, "code", () => $e115b67b9a7c1782$export$6565f9f03506010b);
const $e115b67b9a7c1782$export$6565f9f03506010b = (text)=>{
    return `{{${text}}}`;
};

});

parcelRegister("aDTWq", function(module, exports) {

$parcel$export(module.exports, "textColor", () => $ef3e88b1064ccc35$export$32f78bffcd82ff28);
const $ef3e88b1064ccc35$export$32f78bffcd82ff28 = (text, attrs)=>{
    return `{color:${attrs.color}}${text}{color}`;
};

});

parcelRegister("gdFeW", function(module, exports) {

$parcel$export(module.exports, "em", () => $e431017de2633455$export$c63c6f932822f543);

var $3ovek = parcelRequire("3ovek");
const $e431017de2633455$export$c63c6f932822f543 = (text)=>{
    if (text.startsWith("\u2014 ")) // This is a citation
    return (0, $3ovek.baseMarkPattern)(text.substring(2), '??');
    return (0, $3ovek.baseMarkPattern)(text, '_');
};

});
parcelRegister("3ovek", function(module, exports) {

$parcel$export(module.exports, "baseMarkPattern", () => $7f6f940a63ef31a6$export$3d8aed7830783c75);
/**
 * For text that has leading and ending space. We don't want to
 * convert it to `* strong *. Instead, we need it to be ` *strong* `
 */ const $7f6f940a63ef31a6$export$3d8aed7830783c75 = (text, token)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    if (/^\s*$/.test(text)) /**
		 * If it's a string with only whitespaces, wiki renderer
		 * will behave incorrect if we apply format on it
		 */ return text;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return text.replace(/^\s*/, `$&${token}`).replace(/\s*$/, `${token}$&`);
};

});


parcelRegister("jo5YT", function(module, exports) {

$parcel$export(module.exports, "link", () => $5614ddd827a3bd70$export$9c30223ca0a664fb);
const $5614ddd827a3bd70$export$9c30223ca0a664fb = (text, attrs)=>{
    return `[${text}|${attrs.href}]`;
};

});

parcelRegister("9fwgI", function(module, exports) {

$parcel$export(module.exports, "strike", () => $486b01102f007d8c$export$4899a95d70ec5056);

var $3ovek = parcelRequire("3ovek");
const $486b01102f007d8c$export$4899a95d70ec5056 = (text)=>{
    return (0, $3ovek.baseMarkPattern)(text, '-');
};

});

parcelRegister("eKxrE", function(module, exports) {

$parcel$export(module.exports, "strong", () => $5f94e33f4e7efc4b$export$59ae2c325a998f89);

var $3ovek = parcelRequire("3ovek");
const $5f94e33f4e7efc4b$export$59ae2c325a998f89 = (text)=>{
    return (0, $3ovek.baseMarkPattern)(text, '*');
};

});

parcelRegister("1x55I", function(module, exports) {

$parcel$export(module.exports, "subsup", () => $de8ae0bb6a3c8a22$export$b3401ee80eb31041);

var $3ovek = parcelRequire("3ovek");
const $de8ae0bb6a3c8a22$export$b3401ee80eb31041 = (text, attrs)=>{
    if (attrs.type === 'sub') return (0, $3ovek.baseMarkPattern)(text, '~');
    else return (0, $3ovek.baseMarkPattern)(text, '^');
};

});

parcelRegister("8tKGr", function(module, exports) {

$parcel$export(module.exports, "underline", () => $bb8b641056119651$export$425327af25286e5e);

var $3ovek = parcelRequire("3ovek");
const $bb8b641056119651$export$425327af25286e5e = (text)=>{
    return (0, $3ovek.baseMarkPattern)(text, '+');
};

});


parcelRegister("5IuwX", function(module, exports) {

$parcel$export(module.exports, "inlineCard", () => $c6769d560338119d$export$cbf8224b64e0d942);

var $1Nefo = parcelRequire("1Nefo");

var $bOMPB = parcelRequire("bOMPB");
const $c6769d560338119d$export$cbf8224b64e0d942 = (node)=>{
    if (!node.attrs.url) return (0, $1Nefo.unknown)(node);
    const match = node.attrs.url.match((0, $bOMPB.INLINE_CARD_FROM_TEXT_STAMP));
    if (!match) return `[${node.attrs.url}|${node.attrs.url}|smart-link]`;
    return `[${match[2]}]`;
};

});

parcelRegister("1HDja", function(module, exports) {

$parcel$export(module.exports, "status", () => $d0c82c4f36685012$export$471f7ae5c4103ae1);

var $aDTWq = parcelRequire("aDTWq");

const $d0c82c4f36685012$var$color = {
    grey: (0, $829f609a65d26a98$export$eaa8c8a70ac22806),
    purple: (0, $829f609a65d26a98$export$b48405b95304b5a1),
    blue: (0, $829f609a65d26a98$export$9dc1ef0f3f48059b),
    red: (0, $829f609a65d26a98$export$4a7404f376229999),
    yellow: (0, $829f609a65d26a98$export$59619663aa6500fb),
    green: (0, $829f609a65d26a98$export$940e1f69e873f202)
};
const $d0c82c4f36685012$export$471f7ae5c4103ae1 = (node)=>{
    const text = `*[ ${node.attrs.text.toUpperCase()} ]*`;
    const newAttrs = {
        ...node.attrs
    };
    if ($d0c82c4f36685012$var$color[node.attrs.color]) newAttrs.color = $d0c82c4f36685012$var$color[node.attrs.color];
    else newAttrs.color = $d0c82c4f36685012$var$color['grey'];
    return (0, $aDTWq.textColor)(text, newAttrs);
};

});

parcelRegister("c08Yp", function(module, exports) {

$parcel$export(module.exports, "date", () => $61a6161cda09885d$export$324d90190a8b822a);
const $61a6161cda09885d$export$324d90190a8b822a = (node)=>{
    const addLeadingZero = (val)=>{
        if (val < 10) return `0${val}`;
        return val;
    };
    const result = new Date(Number(node.attrs.timestamp));
    return `{{${result.getUTCFullYear()}-${addLeadingZero(result.getUTCMonth() + 1)}-${addLeadingZero(result.getUTCDate())}}}`;
};

});



parcelRegister("73kPn", function(module, exports) {

$parcel$export(module.exports, "codeBlock", () => $ef6a5d3a665df695$export$7bb0d5c671655cc4);

var $bK2QZ = parcelRequire("bK2QZ");
const $ef6a5d3a665df695$var$supportedLanguageInWiki = [
    'actionscript',
    'ada',
    'applescript',
    'bash',
    'c',
    'c#',
    'c++',
    'cpp',
    'css',
    'erlang',
    'go',
    'groovy',
    'haskell',
    'html',
    'java',
    'javascript',
    'js',
    'json',
    'lua',
    'none',
    'nyan',
    'objc',
    'perl',
    'php',
    'python',
    'r',
    'rainbow',
    'ruby',
    'scala',
    'sh',
    'sql',
    'swift',
    'visualbasic',
    'xml',
    'yaml'
];
const $ef6a5d3a665df695$export$7bb0d5c671655cc4 = (node)=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $bK2QZ.inlines)(n, {
            parent: node
        });
    });
    if ($ef6a5d3a665df695$var$supportedLanguageInWiki.indexOf(node.attrs.language) !== -1) return `{code:${node.attrs.language}}${result}{code}`;
    else return `{noformat}${result}{noformat}`;
};

});

parcelRegister("eTlm6", function(module, exports) {

$parcel$export(module.exports, "mediaGroup", () => $b3a3fb1c58065f07$export$2855e964765eac9);

var $bsbI5 = parcelRequire("bsbI5");

var $48ot6 = parcelRequire("48ot6");

var $1Nefo = parcelRequire("1Nefo");
const $b3a3fb1c58065f07$export$2855e964765eac9 = (node, opts = {})=>{
    const result = [];
    node.forEach((n)=>{
        switch(n.type.name){
            case 'media':
                result.push((0, $48ot6.media)(n, {
                    ...opts,
                    parent: node
                }));
                break;
            case 'caption':
                result.push((0, $bsbI5.caption)(n, opts));
                break;
            default:
                result.push((0, $1Nefo.unknown)(n));
                break;
        }
    });
    return result.join('\n');
};

});
parcelRegister("bsbI5", function(module, exports) {

$parcel$export(module.exports, "caption", () => $58b84b7bf3a1608d$export$8e3c2dfdc4f0453d);

var $bK2QZ = parcelRequire("bK2QZ");
const $58b84b7bf3a1608d$export$8e3c2dfdc4f0453d = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $bK2QZ.inlines)(n, {
            context: context
        });
    });
    return result;
};

});

parcelRegister("48ot6", function(module, exports) {

$parcel$export(module.exports, "media", () => $df984bb2074676e8$export$987d49ffe1b0900f);
const $df984bb2074676e8$export$987d49ffe1b0900f = (node, { context: context, parent: parent } = {})=>{
    const wikiAttrs = [];
    // Parent width takes precedence over internal dimension attributes
    if (parent && parent.attrs.width) // Parent width is defined in percents
    wikiAttrs.push(`width=${parent.attrs.width}%`);
    else {
        if (node.attrs.width) wikiAttrs.push(`width=${node.attrs.width}`);
        if (node.attrs.height) wikiAttrs.push(`height=${node.attrs.height}`);
    }
    if (node.attrs.alt) wikiAttrs.push(`alt="${node.attrs.alt}"`);
    if (node.marks.length) {
        const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
        if (linkMark) wikiAttrs.push(`href="${linkMark?.attrs.href}"`);
    }
    let fileName;
    if (node.attrs.type === 'external') fileName = node.attrs.url;
    else fileName = context?.conversion?.mediaConversion?.[node.attrs.id]?.transform ?? node.attrs.id;
    if (context?.conversion?.mediaConversion?.[node.attrs.id]?.embed === false) return `[^${fileName}]`;
    if (wikiAttrs.length) return `!${fileName}|${wikiAttrs.join(',')}!`;
    // default to thumbnail if no width or height is set
    return `!${fileName}|thumbnail!`;
};

});




parcelRegister("hgytR", function(module, exports) {

$parcel$export(module.exports, "taskList", () => $1fb2a139f9f264bf$export$375b6afcc5f4d291);

var $4kMeo = parcelRequire("4kMeo");
const $1fb2a139f9f264bf$var$nestedNode = (node, depth = 1)=>{
    const result = [];
    node.forEach((item)=>{
        if (item.type.name === 'taskList') result.push($1fb2a139f9f264bf$var$nestedNode(item, depth + 1));
        else result.push((0, $4kMeo.taskItem)(item, depth));
    });
    return result.join('\n');
};
const $1fb2a139f9f264bf$export$375b6afcc5f4d291 = (node)=>{
    return $1fb2a139f9f264bf$var$nestedNode(node);
};

});
parcelRegister("4kMeo", function(module, exports) {

$parcel$export(module.exports, "taskItem", () => $b96ea7b246afcc42$export$6d8b0ef52e2e6390);

var $bK2QZ = parcelRequire("bK2QZ");
const $b96ea7b246afcc42$export$6d8b0ef52e2e6390 = (node, nestedLevel, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        // Generate stars based on depth
        const prefix = Array(nestedLevel).fill('*').join('');
        if (node.attrs.state === 'DONE') result += `${prefix} -${(0, $bK2QZ.inlines)(n, {
            context: context
        })}-`;
        else result += `${prefix} ${(0, $bK2QZ.inlines)(n, {
            context: context
        })}`;
    });
    return result;
};

});


parcelRegister("b6sEJ", function(module, exports) {

$parcel$export(module.exports, "decisionList", () => $9054c6d3a6a22504$export$62d45a65fb43d95e);

var $h0oA4 = parcelRequire("h0oA4");
const $9054c6d3a6a22504$export$62d45a65fb43d95e = (node)=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $h0oA4.decisionItem)(item));
    });
    return result.join('\n');
};

});
parcelRegister("h0oA4", function(module, exports) {

$parcel$export(module.exports, "decisionItem", () => $6209b59f60b56dcd$export$6959e16eeff859b4);

var $bK2QZ = parcelRequire("bK2QZ");
const $6209b59f60b56dcd$export$6959e16eeff859b4 = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += `* <> ${(0, $bK2QZ.inlines)(n, {
            context: context
        })}`;
    });
    return result;
};

});


parcelRegister("1B6CN", function(module, exports) {

$parcel$export(module.exports, "doc", () => $5ce407caf0707589$export$2a111da947c407d2);

var $lxtC7 = parcelRequire("lxtC7");
const $5ce407caf0707589$export$2a111da947c407d2 = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $lxtC7.encode)(n, context));
    });
    return result.join('\n\n');
};

});

parcelRegister("8UMD2", function(module, exports) {

$parcel$export(module.exports, "expand", () => $dcda58106fc3b9ff$export$9f77e0932fb78f72);

var $lxtC7 = parcelRequire("lxtC7");
const $dcda58106fc3b9ff$export$9f77e0932fb78f72 = (node, { context: context } = {})=>{
    // Title of expand appears as a bold text, followed by empty line
    const result = [
        `*${node.attrs.title}*`,
        ''
    ];
    node.forEach((n)=>{
        result.push((0, $lxtC7.encode)(n, context));
    });
    return result.join('\n');
};

});

parcelRegister("fIzNZ", function(module, exports) {

$parcel$export(module.exports, "heading", () => $2a94cb79881b69b7$export$46e4a324ac90507f);

var $bK2QZ = parcelRequire("bK2QZ");
const $2a94cb79881b69b7$export$46e4a324ac90507f = (node)=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $bK2QZ.inlines)(n);
    });
    return `h${node.attrs.level}. ${result}`;
};

});

parcelRegister("h9tzi", function(module, exports) {

$parcel$export(module.exports, "orderedList", () => $c2a8fd1ebb40e986$export$a5dc81035676e7a);

var $bxtEu = parcelRequire("bxtEu");
const $c2a8fd1ebb40e986$export$a5dc81035676e7a = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $bxtEu.listItem)(item, '#', context));
    });
    return result.join('\n');
};

});

parcelRegister("abXFq", function(module, exports) {

$parcel$export(module.exports, "panel", () => $d8008c2d580ced87$export$21f42ab9b6679f44);

var $lxtC7 = parcelRequire("lxtC7");
const $d8008c2d580ced87$var$panelTypeColorMapping = {
    info: '#deebff',
    note: '#eae6ff',
    success: '#e3fcef',
    warning: '#fffae6',
    error: '#ffebe6'
};
const $d8008c2d580ced87$export$21f42ab9b6679f44 = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $lxtC7.encode)(n, context));
    });
    return `{panel:bgColor=${$d8008c2d580ced87$var$panelTypeColorMapping[node.attrs.panelType] || ''}}
${result.join('\n\n')}
{panel}`;
};

});

parcelRegister("czgKo", function(module, exports) {

$parcel$export(module.exports, "rule", () => $bf5c50b1fb980df8$export$fbeb3a3956e8a3c7);
const $bf5c50b1fb980df8$export$fbeb3a3956e8a3c7 = (_node)=>{
    return '----';
};

});

parcelRegister("acqkf", function(module, exports) {

$parcel$export(module.exports, "table", () => $6deed74ceb5bf80f$export$9852986a3ec5f6a0);

var $lxtC7 = parcelRequire("lxtC7");

var $1Nefo = parcelRequire("1Nefo");
const $6deed74ceb5bf80f$export$9852986a3ec5f6a0 = (node, opts = {})=>{
    try {
        const result = [];
        node.forEach((n)=>{
            result.push($6deed74ceb5bf80f$var$tableRow(n, opts));
        });
        return result.join('\n');
    } catch (err) {
        return (0, $1Nefo.unknown)(node);
    }
};
const $6deed74ceb5bf80f$var$tableRow = (node, opts = {})=>{
    let result = '';
    let separator = '|';
    node.forEach((n)=>{
        if (n.type.name === 'tableHeader') separator = '||';
        else separator = '|';
        result = `${result}${separator}${$6deed74ceb5bf80f$var$tableCell(n, opts)}`;
    });
    return `${result}${separator}`;
};
const $6deed74ceb5bf80f$var$tableCell = (node, { context: context } = {})=>{
    if ($6deed74ceb5bf80f$var$hasMergedCell(node)) // This is an advanced table
    throw new Error('Advanced feature of table is not supported');
    const result = [];
    node.forEach((n)=>{
        result.push((0, $lxtC7.encode)(n, context));
    });
    const output = result.join('\n').trim();
    // Return single whitespace if content of cell is empty
    // to preserve correct empty cell rendering in wiki
    return output === '' ? ' ' : output;
};
const $6deed74ceb5bf80f$var$hasMergedCell = (node)=>{
    if (!node.attrs) return false;
    if (node.attrs.colspan && node.attrs.colspan !== 1) return true;
    if (node.attrs.rowspan && node.attrs.rowspan !== 1) return true;
    return false;
};

});

parcelRegister("69N10", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $0c06383b3aca4143$export$c4c2f833baaebdb8);

var $1Nefo = parcelRequire("1Nefo");
const $0c06383b3aca4143$export$c4c2f833baaebdb8 = (node)=>{
    if (!node.attrs.url) return (0, $1Nefo.unknown)(node);
    return `[${node.attrs.url}|${node.attrs.url}|smart-card]`;
};

});

parcelRegister("12A17", function(module, exports) {

$parcel$export(module.exports, "embedCard", () => $c9c7f4b278041854$export$be4283d9a1cb1ff6);

var $1Nefo = parcelRequire("1Nefo");
const $c9c7f4b278041854$export$be4283d9a1cb1ff6 = (node)=>{
    if (!node.attrs.url) return (0, $1Nefo.unknown)(node);
    return `[${node.attrs.url}|${node.attrs.url}|smart-embed]`;
};

});


parcelRegister("djcbG", function(module, exports) {

$parcel$export(module.exports, "default", () => $74f62fc9e2776603$export$2e2bcd8739ae039);

var $29zBb = parcelRequire("29zBb");

var $20lXC = parcelRequire("20lXC");
class $74f62fc9e2776603$export$2e2bcd8739ae039 {
    constructor(schema, wikiMarkup){
        this.schema = schema;
        this.wikiMarkup = wikiMarkup;
    }
    /**
	 * Convert reduced macros tree into prosemirror model tree
	 */ getProseMirrorModel(context) {
        const content = (0, $29zBb.parseString)({
            context: context,
            ignoreTokenTypes: [],
            input: this.wikiMarkup,
            schema: this.schema
        });
        return this.schema.nodes.doc.createChecked({}, (0, $20lXC.normalizePMNodes)(content, this.schema, 'doc'));
    }
}

});



parcelRegister("6a30R", function(module, exports) {

$parcel$export(module.exports, "isExternalLink", () => $97cd92cd81dfd9ff$export$b98882f166bb7ce2);
$parcel$export(module.exports, "onLinkClick", () => $97cd92cd81dfd9ff$export$dccc97e4cadc9724);
$parcel$export(module.exports, "smartLinksDefault", () => $97cd92cd81dfd9ff$export$4f1b881d7a962ce6);
$parcel$export(module.exports, "useSmartCardProductType", () => $97cd92cd81dfd9ff$export$3f864e37674c79e7);
$parcel$export(module.exports, "useSmartCardIsAIEnabled", () => $97cd92cd81dfd9ff$export$af081b1242bfa300);
$parcel$export(module.exports, "SmartCardProviderWithAIHooks", () => $97cd92cd81dfd9ff$export$ca9fa6647337e334);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $8dO33 = parcelRequire("8dO33");

var $dn5wJ = parcelRequire("dn5wJ");

var $2vSU6 = parcelRequire("2vSU6");

var $2gCtH = parcelRequire("2gCtH");

var $iixvy = parcelRequire("iixvy");

var $93Yeu = parcelRequire("93Yeu");
const $97cd92cd81dfd9ff$var$isLeftClick = (event)=>event.button === 0;
const $97cd92cd81dfd9ff$var$isMiddleClick = (event)=>event.button === 1;
const $97cd92cd81dfd9ff$var$isCmdOrCtrlClick = (event)=>$97cd92cd81dfd9ff$var$isLeftClick(event) && (event.metaKey || event.ctrlKey);
const $97cd92cd81dfd9ff$export$b98882f166bb7ce2 = (url)=>{
    (0, $gKZoD.di)(window);
    try {
        const { hostname: hostname, pathname: pathname } = new URL(url);
        return(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        hostname !== window.location.hostname || ![
            '/jira',
            '/browse'
        ].some((includedPath)=>pathname.startsWith(includedPath)));
    } catch (err) {
        // Defaults to external link for invalid URLs to avoid further processing
        return true;
    }
};
const $97cd92cd81dfd9ff$export$dccc97e4cadc9724 = (event, url)=>{
    (0, $gKZoD.di)(window);
    if (!url) return;
    if ($97cd92cd81dfd9ff$export$b98882f166bb7ce2(url)) {
        event.preventDefault();
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(url, '_blank', 'noopener,noreferrer');
        return;
    }
    if (event.defaultPrevented) {
        // The default has already been prevented meaning that we need to open links in one
        // way or another to ensure we do eventually open the link
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        const mouseEvent = event;
        $97cd92cd81dfd9ff$var$isCmdOrCtrlClick(mouseEvent) || $97cd92cd81dfd9ff$var$isMiddleClick(mouseEvent) ? window.open(url, '_blank', 'noopener,noreferrer') : window.location.assign(url);
    }
};
const $97cd92cd81dfd9ff$export$4f1b881d7a962ce6 = {
    actionOptions: {
        hide: false,
        exclude: [
            (0, $dn5wJ.CardAction).ChangeStatusAction
        ]
    }
};
const $97cd92cd81dfd9ff$export$4761115a9e18aa47 = (projectType)=>{
    switch(projectType){
        case 0, $2vSU6.CORE_PROJECT:
            return 'JWM';
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return 'JSW';
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return 'JSM';
        case 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT:
            return 'JPD';
        default:
            return undefined;
    }
};
const $97cd92cd81dfd9ff$export$3f864e37674c79e7 = ()=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const product = (0, $5uXOq.useMemo)(()=>// Arbitrarily default to Jira Software if not specified
        $97cd92cd81dfd9ff$export$4761115a9e18aa47(projectType) ?? 'JSW', [
        projectType
    ]);
    return product;
};
const $97cd92cd81dfd9ff$export$af081b1242bfa300 = ()=>{
    const isAiOptInEnabled = (0, $2gCtH.useIsAiEnabledForIssue)();
    const isPremium = (0, $iixvy.useIsPremium)();
    const isAIFeatureEnabled = (0, $5uXOq.useMemo)(()=>isAiOptInEnabled && isPremium, [
        isAiOptInEnabled,
        isPremium
    ]);
    return isAIFeatureEnabled;
};
const $97cd92cd81dfd9ff$export$ca9fa6647337e334 = (props)=>{
    const product = $97cd92cd81dfd9ff$export$3f864e37674c79e7();
    const isAIEnabled = $97cd92cd81dfd9ff$export$af081b1242bfa300();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8dO33.SmartCardProvider), {
        product: product,
        isAdminHubAIEnabled: isAIEnabled,
        ...props
    }, props.children);
};

});
parcelRegister("dn5wJ", function(module, exports) {

$parcel$export(module.exports, "CardAction", () => $b402a0f22139e437$export$f40b7e0b762b928b);
var $b402a0f22139e437$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    return CardAction;
}({});

});

parcelRegister("iixvy", function(module, exports) {

$parcel$export(module.exports, "useIsPremium", () => $545133d1825caa45$export$1bb5840a003dc643);
$parcel$export(module.exports, "useOptInStatus", () => $545133d1825caa45$export$5e56b08674e48311);
$parcel$export(module.exports, "useAIOptIn", () => $545133d1825caa45$export$49e57b9044cda91c);

var $5uXOq = parcelRequire("5uXOq");

var $kTK0a = parcelRequire("kTK0a");
var $aIZdc = parcelRequire("aIZdc");

var $2vSU6 = parcelRequire("2vSU6");

var $2gCtH = parcelRequire("2gCtH");

var $5NH95 = parcelRequire("5NH95");

var $93Yeu = parcelRequire("93Yeu");

var $14XJw = parcelRequire("14XJw");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $cNd4s = parcelRequire("cNd4s");

var $4R6GH = parcelRequire("4R6GH");

var $ljlOe = parcelRequire("ljlOe");

var $44KLa = parcelRequire("44KLa");
const $545133d1825caa45$var$DISABLED = 'disabled';
const $545133d1825caa45$var$DISABLED_OPT_IN = 'disabled-opt-in';
const $545133d1825caa45$var$ENABLED = 'enabled';
const $545133d1825caa45$export$1bb5840a003dc643 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    if (!appEditions) return false;
    // currently admin hub AI BE endpoint for JWM already defaults to JSW value
    // so we reflect same logic for JWM here
    switch(projectType){
        case 0, $2vSU6.CORE_PROJECT:
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return appEditions.software === (0, $ldyPw.PREMIUM_EDITION);
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return appEditions.serviceDesk === (0, $ldyPw.PREMIUM_EDITION);
        default:
            return false;
    }
};
const $545133d1825caa45$export$10e0dafdd792475b = ()=>{
    // upsell us for standard but not free subscription admins
    const appEditions = (0, $k9JTq.useAppEditions)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    if (!appEditions) return false;
    switch(projectType){
        case 0, $2vSU6.CORE_PROJECT:
            return appEditions.core === (0, $ldyPw.STANDARD_EDITION);
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return appEditions.software === (0, $ldyPw.STANDARD_EDITION);
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return appEditions.serviceDesk === (0, $ldyPw.STANDARD_EDITION);
        default:
            return false;
    }
};
const $545133d1825caa45$export$bd66bcf1f00b19d2 = ()=>{
    const isOrgAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isPremium = $545133d1825caa45$export$1bb5840a003dc643();
    const isSupportedENV = !(0, $aIZdc.isFedRamp)();
    return isOrgAdmin && isPremium && isSupportedENV;
};
const $545133d1825caa45$export$1276193c77ae88bf = ()=>{
    const isOrgAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isStandard = $545133d1825caa45$export$10e0dafdd792475b();
    const isSupportedENV = !(0, $aIZdc.isFedRamp)();
    return isOrgAdmin && isStandard && isSupportedENV;
};
const $545133d1825caa45$export$5e56b08674e48311 = (isAIOptedIn, product)=>{
    const canOptIn = $545133d1825caa45$export$bd66bcf1f00b19d2();
    const canStartPremiumTrial = $545133d1825caa45$export$1276193c77ae88bf();
    if ((0, $aIZdc.isFedRamp)()) return $545133d1825caa45$var$DISABLED;
    // AI Upsell In Editor Experiment - implicitly checks product, fedramp, if edition is FREE and user is an admin
    const { experimentValue: aiUpsellInEditorCohort } = (0, $4R6GH.fg)('jira_free_ai_in_editor_v2_gate') ? (0, $5NH95.useAIUpsellInEditorRequirements)(product) : {
        experimentValue: 'not-enrolled'
    };
    if (aiUpsellInEditorCohort === 'variation') return $545133d1825caa45$var$DISABLED_OPT_IN;
    const isValidForGlobalOptIn = [
        product !== 'JPD',
        canOptIn
    ].every((condition)=>condition === true);
    const isValidForPremiumTrial = canStartPremiumTrial && product !== 'JPD';
    const globalOptInEnabled = isValidForGlobalOptIn || isValidForPremiumTrial ? $545133d1825caa45$var$DISABLED_OPT_IN : $545133d1825caa45$var$DISABLED;
    return isAIOptedIn ? $545133d1825caa45$var$ENABLED : globalOptInEnabled;
};
const $545133d1825caa45$export$49e57b9044cda91c = ({ editorPluginAIConfig: editorPluginAIConfig })=>{
    const { isAiOptInEnabled: isAiOptInEnabled, product: product } = editorPluginAIConfig || {};
    const optInStatus = $545133d1825caa45$export$5e56b08674e48311(isAiOptInEnabled, product);
    const isOrgAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const [showOptInModal, setShowOptInModal] = (0, $5uXOq.useState)(false);
    const [showPremiumTrialModal, setShowPremiumTrialModal] = (0, $5uXOq.useState)(false);
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const canStartTrial = $545133d1825caa45$export$1276193c77ae88bf();
    // AI Upsell In Editor Experiment
    const { isExperimentEnabled: isAIUpsellInEditorFreeEnabled, triggerUpsellFlow: triggerAIUpsellInEditorFreeFlow, UpsellModal: AIUpsellInEditorFreeModal } = (0, $4R6GH.fg)('jira_free_ai_in_editor_v2_gate') ? (0, $5NH95.useAIUpsellInEditorFree)(optInStatus, product) : {
        isExperimentEnabled: false,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        triggerUpsellFlow: ()=>{},
        UpsellModal: null
    };
    // Callback that will be called when AI buttons are clicked and opt in status is disabled-op-in
    const triggerOptInFlow = (0, $5uXOq.useCallback)(()=>{
        setShowOptInModal(true);
    }, [
        setShowOptInModal
    ]);
    // alt callback for standard admins to trigger a premium upsell in order to opt in
    const triggerUpsellFlow = (0, $5uXOq.useCallback)(()=>{
        setShowPremiumTrialModal(true);
    }, [
        setShowPremiumTrialModal
    ]);
    const aiOptInModal = (0, $5uXOq.useMemo)(()=>{
        const onCloseModal = ()=>setShowOptInModal(false);
        const adminLink = `${(0, $kTK0a.getATLContextUrl)('admin')}/o/${orgId}/atlassian-intelligence`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44KLa.OptInModal), {
            showOptInModal: showOptInModal,
            isOrgAdmin: isOrgAdmin,
            onCloseModal: onCloseModal,
            adminLink: adminLink
        });
    }, [
        orgId,
        isOrgAdmin,
        showOptInModal
    ]);
    const aiUpsellModal = (0, $5uXOq.useMemo)(()=>{
        const onCloseModal = ()=>setShowPremiumTrialModal(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ljlOe.AIUpsellPremiumTrialEntryPointContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44KLa.OptInUpsellModal), {
            "data-testid": "platform-react-hooks-use-ai-opt-in.upsell-modal",
            showPremiumTrialModal: showPremiumTrialModal,
            onCloseModal: onCloseModal
        }));
    }, [
        showPremiumTrialModal
    ]);
    if ((0, $aIZdc.isFedRamp)()) return {
        optInStatus: $545133d1825caa45$var$DISABLED,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        triggerOptInFlow: ()=>{},
        AIOptInModal: null
    };
    if (isAIUpsellInEditorFreeEnabled) return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerAIUpsellInEditorFreeFlow,
        AIOptInModal: AIUpsellInEditorFreeModal
    };
    if (optInStatus === $545133d1825caa45$var$DISABLED || optInStatus === $545133d1825caa45$var$ENABLED) return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerOptInFlow,
        AIOptInModal: null
    };
    if (canStartTrial && optInStatus === $545133d1825caa45$var$DISABLED_OPT_IN) return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerUpsellFlow,
        AIOptInModal: aiUpsellModal
    };
    return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerOptInFlow,
        AIOptInModal: aiOptInModal
    };
};

});
parcelRegister("5NH95", function(module, exports) {

$parcel$export(module.exports, "useAIUpsellInEditorRequirements", () => $26b3b3762ac33b52$export$38bfb0ec25eaa6b2);
$parcel$export(module.exports, "useAIUpsellInEditorFree", () => $26b3b3762ac33b52$export$beacfd188d344f95);
$parcel$export(module.exports, "AIUpsellButtonWrapper", () => $26b3b3762ac33b52$export$c44b9b0347b51c37);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aIZdc = parcelRequire("aIZdc");

var $2vSU6 = parcelRequire("2vSU6");

var $6s1PB = parcelRequire("6s1PB");

var $fmQtB = parcelRequire("fmQtB");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $cNd4s = parcelRequire("cNd4s");

var $4R6GH = parcelRequire("4R6GH");

var $4SswE = parcelRequire("4SswE");

var $7xCut = parcelRequire("7xCut");
/**
 * Duplicated from @confluence/editor-features/hooks/useAIUpsellInEditorFree
 *
 * This prevents an event from being fired again due to rerenders
 * We could export this for use within the package if needed
 */ const { fireEventOnce: $26b3b3762ac33b52$var$fireEventOnce } = (()=>{
    let hasFired = false;
    return {
        fireEventOnce: (fireFunction)=>{
            if (!hasFired) {
                fireFunction();
                hasFired = true;
            }
        }
    };
})();
const $26b3b3762ac33b52$var$useGetSupportedProjectType = (product)=>{
    const siteHasOnlyJira = (0, $4SswE.useSiteHasOnlyJira)();
    switch(product){
        case 'JSW':
            return 0, $2vSU6.SOFTWARE_PROJECT;
        case 'JSM':
            return 0, $2vSU6.SERVICE_DESK_PROJECT;
        case 'JWM':
            // If tenant is configured with only JWM and JSW, we can provide an upgrade link for JSW
            return siteHasOnlyJira ? (0, $2vSU6.SOFTWARE_PROJECT) : undefined;
        case 'JPD':
        default:
            return undefined;
    }
};
const $26b3b3762ac33b52$var$useGetSupportedEdition = (product)=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const projectType = $26b3b3762ac33b52$var$useGetSupportedProjectType(product);
    if (!appEditions) return undefined;
    if (projectType) return (0, $ldyPw.getEditionForProject)(projectType, appEditions);
    return undefined;
};
const $26b3b3762ac33b52$export$38bfb0ec25eaa6b2 = (product)=>{
    const isOrgAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const supportedEdition = $26b3b3762ac33b52$var$useGetSupportedEdition(product);
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [config, fireExperimentExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_free_ai_in_editor_v2_experiment');
    const statsigExperimentValue = config.get('cohort', 'not-enrolled');
    const siteMeetsRequirements = // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('jira_free_ai_in_editor_v2_gate') && supportedEdition === (0, $ldyPw.FREE_EDITION) && isOrgAdmin && !(0, $aIZdc.isFedRamp)();
    const experimentValue = siteMeetsRequirements ? statsigExperimentValue : 'not-enrolled';
    const fireExposure = (0, $5uXOq.useCallback)(()=>{
        fireExperimentExposure();
    }, [
        fireExperimentExposure
    ]);
    return {
        siteMeetsRequirements: siteMeetsRequirements,
        experimentValue: experimentValue,
        statsigExperimentValue: statsigExperimentValue,
        fireExperimentExposure: fireExposure
    };
};
const $26b3b3762ac33b52$export$beacfd188d344f95 = (optInStatus, product)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [showUpsellModal, setShowUpsellModal] = (0, $5uXOq.useState)(false);
    const { siteMeetsRequirements: siteMeetsRequirements, statsigExperimentValue: statsigExperimentValue, fireExperimentExposure: fireExperimentExposure } = $26b3b3762ac33b52$export$38bfb0ec25eaa6b2(product);
    const projectType = $26b3b3762ac33b52$var$useGetSupportedProjectType(product);
    const siteMeetsOptInRequirements = siteMeetsRequirements && // optInStatus 'disabled' means they are on control, 'disabled-opt-in' on variation
    optInStatus !== 'enabled';
    const experimentValue = siteMeetsOptInRequirements ? statsigExperimentValue : 'not-enrolled';
    // If the site is not FREE, or not on JSW/JSM, or the user is not billable, they are not enrolled
    const isEnrolledInExperiment = experimentValue !== 'not-enrolled';
    const isExperimentEnabled = isEnrolledInExperiment && experimentValue === 'variation';
    const triggerUpsellFlow = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'triggerUpsellFlow',
            actionSubject: 'aiUpsellInEditorFree'
        }), 'aiUpsellInEditorFreeTrigger', {});
        setShowUpsellModal(true);
        (0, $7xCut.setUpsellButtonWrapperClicked)(true);
    }, [
        createAnalyticsEvent
    ]);
    const UpsellModal = (0, $5uXOq.useMemo)(()=>showUpsellModal && projectType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fmQtB.AsyncAiUpsellInEditorFreeModal), {
            projectType: projectType,
            testId: "platform-react-hooks-use-ai-upsell-in-editor-free.growth-ai-upsell-in-editor-modal",
            onModalClose: ()=>setShowUpsellModal(false)
        }) : null, [
        showUpsellModal,
        projectType
    ]);
    return {
        isEnrolledInExperiment: isEnrolledInExperiment,
        isExperimentEnabled: isExperimentEnabled,
        fireExperimentExposure: fireExperimentExposure,
        triggerUpsellFlow: triggerUpsellFlow,
        UpsellModal: UpsellModal
    };
};
const $26b3b3762ac33b52$export$c44b9b0347b51c37 = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isClicked = (0, $7xCut.getUpsellButtonWrapperClicked)();
    (0, $5uXOq.useEffect)(()=>{
        $26b3b3762ac33b52$var$fireEventOnce(()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button viewed', 'aiUpsellInEditorFreeToolbarButton', {}));
    }, [
        createAnalyticsEvent
    ]);
    return !isClicked ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($26b3b3762ac33b52$var$AIUpsellButtonContainer, {
        "data-testid": "platform-react-hooks-use-ai-upsell-in-editor-free.ai-upsell-button-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($26b3b3762ac33b52$var$AIUpsellButtonInner, null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $26b3b3762ac33b52$var$AIUpsellButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko44q7 _11q7otc5 _ca0qt94y _u5f3t94y _n3tdt94y _19bvt94y _1e0c116y",
            __cmplp.className
        ])
    });
});
const $26b3b3762ac33b52$var$AIUpsellButtonInner = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _bfhkvuon",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fmQtB", function(module, exports) {

$parcel$export(module.exports, "AsyncAiUpsellInEditorFreeModal", () => $2c23576aa5eb8dba$export$827041a383456a6a);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2c23576aa5eb8dba$var$LazyAiUpsellInEditorFreeModal = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("d6LGc")), {
    ssr: false,
    moduleId: "./src/packages/growth/ai-upsell-in-editor-free-modal/src/ui/index.tsx"
});
const $2c23576aa5eb8dba$export$827041a383456a6a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "asyncAiUpsellInEditorFreeModal",
        packageName: "jira-growth-ai-upsell-in-editor-free-modal",
        teamName: "growth-tako",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2c23576aa5eb8dba$var$LazyAiUpsellInEditorFreeModal, props));

});
parcelRegister("d6LGc", function(module, exports) {

let $98b0d21b5b5937ec$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $98b0d21b5b5937ec$var$load("h2MrD"),
    $98b0d21b5b5937ec$var$load("bYT2S"),
    $98b0d21b5b5937ec$var$load("bQd01")
]).then(()=>parcelRequire('b738i'));

});


parcelRegister("4SswE", function(module, exports) {

$parcel$export(module.exports, "useSiteHasOnlyJira", () => $b6d886096eb5e5b4$export$8ce0db5ac54a6136);

var $cVzoY = parcelRequire("cVzoY");


var $9OXo1 = parcelRequire("9OXo1");
function $b6d886096eb5e5b4$export$8ce0db5ac54a6136() {
    const tenantContext = (0, $9OXo1.useTenantContext)();
    try {
        const [firstExplicitlyLicensedProduct, ...rest] = (0, $cVzoY.default)(tenantContext);
        return rest.length === 0 && firstExplicitlyLicensedProduct === (0, $c06e1abca7c13910$export$1346c9aa3cbb477d);
    } catch  {
        return false;
    }
}

});
const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';


parcelRegister("7xCut", function(module, exports) {

$parcel$export(module.exports, "getUpsellButtonWrapperClicked", () => $b8d3bd23ca283e73$export$f7d51ee95145148b);
$parcel$export(module.exports, "setUpsellButtonWrapperClicked", () => $b8d3bd23ca283e73$export$b595420beb43f9ce);

var $bSSG7 = parcelRequire("bSSG7");
const $b8d3bd23ca283e73$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalStorageProvider)('ai-upsell-in-editor-free');
function $b8d3bd23ca283e73$export$f7d51ee95145148b() {
    return Boolean($b8d3bd23ca283e73$export$c2ed3351cac403d1.get('upsellButtonWrapperClicked') ?? false);
}
function $b8d3bd23ca283e73$export$b595420beb43f9ce(value) {
    $b8d3bd23ca283e73$export$c2ed3351cac403d1.set('upsellButtonWrapperClicked', value);
}

});


parcelRegister("ljlOe", function(module, exports) {

$parcel$export(module.exports, "AIUpsellPremiumTrialEntryPointContext", () => $82777381236a0306$export$77aa5ca661b0742c);
$parcel$export(module.exports, "AIUpsellPremiumTrialEntryPointContextProvider", () => $82777381236a0306$export$dd0a751f23b19473);

var $5uXOq = parcelRequire("5uXOq");

var $4mO32 = parcelRequire("4mO32");

var $l37qh = parcelRequire("l37qh");

var $b3Gth = parcelRequire("b3Gth");
const $82777381236a0306$export$77aa5ca661b0742c = (0, $l37qh.createUseEntryPointContext)();
const $82777381236a0306$export$dd0a751f23b19473 = ({ children: children })=>{
    const entryPointParams = {};
    const entryPointResult = (0, $4mO32.useEntryPoint)((0, $b3Gth.entryPointPremiumUpgradeModal), entryPointParams);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82777381236a0306$export$77aa5ca661b0742c.Provider, {
        value: entryPointResult
    }, children);
};

});
parcelRegister("l37qh", function(module, exports) {

$parcel$export(module.exports, "createUseEntryPointContext", () => $6e7e19c2d291c94c$export$41bce2223126846b);

var $5uXOq = parcelRequire("5uXOq");
const $6e7e19c2d291c94c$export$41bce2223126846b = ()=>/*#__PURE__*/ (0, $5uXOq.createContext)({
        entryPointActions: {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            cancelPreload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            load () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            preload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            unload () {}
        },
        entryPointReferenceSubject: {
            getValue: ()=>null,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            subscribe: ()=>()=>{}
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        stopMetric () {}
    });

});


parcelRegister("44KLa", function(module, exports) {

$parcel$export(module.exports, "OptInModal", () => $bf7c19a18c627984$export$1697f043758ae8d2);
$parcel$export(module.exports, "OptInUpsellModal", () => $bf7c19a18c627984$export$bbf8d259a508a485);

var $5uXOq = parcelRequire("5uXOq");

var $1R1Ge = parcelRequire("1R1Ge");
var $i8Qvm = parcelRequire("i8Qvm");

var $4UN9Z = parcelRequire("4UN9Z");

var $7XluA = parcelRequire("7XluA");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ljlOe = parcelRequire("ljlOe");

var $ejjdc = parcelRequire("ejjdc");
const $bf7c19a18c627984$export$1697f043758ae8d2 = ({ showOptInModal: showOptInModal, onCloseModal: onCloseModal, isOrgAdmin: isOrgAdmin, adminLink: adminLink })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, showOptInModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
        testId: "platform-react-hooks-use-ai-opt-in.ui.ai-modal-test",
        width: "fit-content",
        onClose: onCloseModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4UN9Z.default), {
        source: "jira-editor",
        product: "jira",
        isOrgAdmin: isOrgAdmin,
        onAdminClose: onCloseModal,
        adminLink: adminLink
    })));
const $bf7c19a18c627984$export$bbf8d259a508a485 = ({ showPremiumTrialModal: showPremiumTrialModal, onCloseModal: onCloseModal })=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $5uXOq.useContext)((0, $ljlOe.AIUpsellPremiumTrialEntryPointContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            onClose: ()=>{
                entryPointActions.unload();
                const analyticsEvent = createAnalyticsEvent({
                    actionSubject: 'button',
                    action: 'clicked'
                });
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'closePremiumTrialModalFromIssueAiUpsell');
            }
        }), [
        entryPointActions,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, showPremiumTrialModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
        testId: "platform-react-hooks-use-ai-opt-in.ui.ai-premium-trial-modal-test",
        width: "fit-content",
        onClose: onCloseModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ejjdc.AIOptInPremiumUpsell), {
        onClose: onCloseModal
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "platform-react-hooks-use-ai-opt-in.ui.ai-premium-trial-entry-point-container",
        packageName: "platform-react-hooks-use-ai-opt-in",
        runtimeProps: runtimeProps
    }));
};

});
parcelRegister("4UN9Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $498daaeb8cd4c6ec$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $eCeGD = parcelRequire("eCeGD");
var $1GGwS = parcelRequire("1GGwS");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $c0x54 = parcelRequire("c0x54");


var $ek69Y = parcelRequire("ek69Y");

var $lJhAv = parcelRequire("lJhAv");
const $498daaeb8cd4c6ec$var$VisibleTextOrgAdminStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $498daaeb8cd4c6ec$var$AiOptIn = ({ source: source, product: product, isOrgAdmin: isOrgAdmin, image: image, headerText: headerText, bodyText: bodyText, width: width, testId: testId, onAdminCTA: onAdminCTA, onAdminClose: onAdminClose, adminBodyText: adminBodyText, adminHeaderText: adminHeaderText, adminCTAText: adminCTAText, adminCloseCTAText: adminCloseCTAText, adminLink: adminLink })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onLearnMoreClicked = (e)=>{
        e.stopPropagation();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogLearnMoreLink',
                attributes: {
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const formatMessageValues = {
        a: (s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                href: (0, $3490940fa7f2fa1c$export$550fac1a4ec3d365),
                target: "_blank",
                onClick: onLearnMoreClicked
            }, s),
        br: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null)
    };
    const defaultHeader = formatMessage((0, $ek69Y.messages).aiOptInDialogHeaderText);
    const header = headerText ?? defaultHeader;
    const body = bodyText ?? formatMessage((0, $ek69Y.messages).aiOptInDialogBodyText, formatMessageValues);
    const orgAdminBody = adminBodyText ?? formatMessage((0, $ek69Y.messages).aiOptInDialogAdminBodyText, formatMessageValues);
    const orgAdminHeader = adminHeaderText ?? defaultHeader;
    (0, $5uXOq.useEffect)(()=>{
        const preloadImages = (paths)=>{
            paths.forEach((path)=>{
                const img = new Image();
                img.src = path;
            });
        };
        preloadImages([
            (0, (/*@__PURE__*/$parcel$interopDefault($c0x54)))
        ]);
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'aiGlobalOptInDialog',
                attributes: {
                    source: source,
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source,
        product,
        isOrgAdmin
    ]);
    const onCloseClicked = (e)=>{
        e.stopPropagation();
        onAdminClose?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCloseButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const onCTAClicked = (e)=>{
        e.stopPropagation();
        onAdminCTA?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCTAButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lJhAv.OptInBackgroundBorder), {
        width: width,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lJhAv.OptInContainer), null, image ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lJhAv.ImageWrapper), null, image) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lJhAv.ImageWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c0x54))),
        height: "96px",
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lJhAv.ContentContainer), null, isOrgAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $498daaeb8cd4c6ec$var$VisibleTextOrgAdminStyles
    }, formatMessage((0, $ek69Y.messages).aiOptInAdminOnlyVisible)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lJhAv.HeaderWrapper), null, isOrgAdmin ? orgAdminHeader : header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lJhAv.BodyWrapper), {
        "data-testid": "dialog-body-text"
    }, isOrgAdmin ? orgAdminBody : body), isOrgAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lJhAv.ButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "subtle",
        onClick: onCloseClicked,
        testId: "admin-close-button"
    }, adminCloseCTAText ?? formatMessage((0, $ek69Y.messages).aiOptInDialogAdminMaybeLaterButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
        appearance: "primary",
        onClick: onCTAClicked,
        href: adminLink ?? (0, $3490940fa7f2fa1c$export$bae9a077d7ed5dfe),
        target: "_blank",
        testId: "admin-cta-button"
    }, adminCTAText ?? formatMessage((0, $ek69Y.messages).aiOptInDialogAdminGetStartedButtonText))))));
};
var $498daaeb8cd4c6ec$export$2e2bcd8739ae039 = $498daaeb8cd4c6ec$var$AiOptIn;

});
parcelRegister("c0x54", function(module, exports) {
module.exports = new URL("global-opt-in-default-image-banner.8c1c680b.svg", import.meta.url).toString();

});

const $3490940fa7f2fa1c$export$550fac1a4ec3d365 = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products';
const $3490940fa7f2fa1c$export$bae9a077d7ed5dfe = 'http://admin.atlassian.com/';

parcelRegister("ek69Y", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5fe19a2c65ae0a6d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5fe19a2c65ae0a6d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    /**
	 * Messages for the AI Global Opt-in component
	 */ aiOptInDialogHeaderText: {
        id: 'ai-opt-in.dialog.header.text',
        defaultMessage: 'Work smarter, not harder',
        description: 'Header text for AI Opt In Dialog'
    },
    aiOptInDialogBodyText: {
        id: 'ai-opt-in.dialog.body.text',
        defaultMessage: `Get up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration.`,
        description: 'Body text for AI Opt In Dialog'
    },
    aiOptInDialogLearnMoreLinkText: {
        id: 'ai-opt-in.dialog.learn-more.link.text',
        defaultMessage: 'Learn more about Atlassian Intelligence',
        description: 'Learn more link text for AI Opt In Dialog'
    },
    aiOptInDialogAdminBodyText: {
        id: 'ai-opt-in.dialog.admin.body.text',
        defaultMessage: 'Get your team up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration.',
        description: 'Body text for Admin version of AI Opt In Dialog'
    },
    aiOptInDialogAdminMaybeLaterButtonText: {
        id: 'ai-opt-in.dialog.admin.maybe-later.button.text',
        defaultMessage: 'Maybe later',
        description: 'Admin maybe later button text'
    },
    aiOptInDialogAdminGetStartedButtonText: {
        id: 'ai-opt-in.dialog.admin.get-started.button.text',
        defaultMessage: 'Get started',
        description: 'Admin get started button text'
    },
    aiOptInBannerBodyText: {
        id: 'ai-opt-in.banner.body.text',
        defaultMessage: "Work smarter, not harder. Express your interest in Atlassian Intelligence so your admin knows you\u2019d like them to activate it.",
        description: 'Body text for Banner version of AI Opt In Dialog'
    },
    aiOptInBannerLearnMoreText: {
        id: 'ai-opt-in.banner.learn.more.text',
        defaultMessage: 'Learn more',
        description: 'Learn more text for Banner cta of AI Opt In Dialog'
    },
    aiOptInAdminBannerBodyText: {
        id: 'ai-opt-in.banner.admin.body.text',
        defaultMessage: 'Get everyone up to speed quickly and consume information with ease. Turn on <a>Atlassian Intelligence</a> features for your users from Atlassian Administration.',
        description: 'Body text for Admin version of the Banner Ai Opt In'
    },
    aiOptInAdminOnlyVisible: {
        id: 'ai-opt-in.admin.only.visible.text',
        defaultMessage: 'This message is only visible to org admins.',
        description: 'Text message to let org admins know that the content is only visible to them.'
    }
});

});

parcelRegister("lJhAv", function(module, exports) {

$parcel$export(module.exports, "OptInBackgroundBorder", () => $1bcec8f5b168d85d$export$24c280970213bb11);
$parcel$export(module.exports, "OptInContainer", () => $1bcec8f5b168d85d$export$a0fab83bea8ccf2e);
$parcel$export(module.exports, "ImageWrapper", () => $1bcec8f5b168d85d$export$75f07c36086c2c81);
$parcel$export(module.exports, "ContentContainer", () => $1bcec8f5b168d85d$export$9d2b4227a95687cc);
$parcel$export(module.exports, "HeaderWrapper", () => $1bcec8f5b168d85d$export$960a49cc3d27a090);
$parcel$export(module.exports, "BodyWrapper", () => $1bcec8f5b168d85d$export$14966827497f4695);
$parcel$export(module.exports, "ButtonContainer", () => $1bcec8f5b168d85d$export$eddf54ea3db8d0f0);
/* styled.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $1bcec8f5b168d85d$export$24c280970213bb11 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $lD23V.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _2rko14y2 _11q71lxv _16qs1o46 _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _kqswh2mm",
            __cmplp.width ? "_1bsb1efm" : "_1bsbkbql",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$a0fab83bea8ccf2e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1e0c1txw _2lx21bp4 _bfhk1bhr",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$75f07c36086c2c81 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1k7a _1e0c1txw _1biu1k7a _1jpx1dfr _mezj1osq",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$9d2b4227a95687cc = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _2lx21bp4 _1wpz1fhb _4cvr1y6m",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$960a49cc3d27a090 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81bk4",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$14966827497f4695 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c81oud",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _1bsb1osq _19pku2gc _1bahesu3",
            __cmplp.className
        ])
    });
});

});


parcelRegister("ejjdc", function(module, exports) {

$parcel$export(module.exports, "AIOptInPremiumUpsell", () => $678322372bbc5cca$export$54e4ba490d2c6bb5);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $l1N8i = parcelRequire("l1N8i");

var $2C7j9 = parcelRequire("2C7j9");

var $c8oLN = parcelRequire("c8oLN");
var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");


var $gEusR = parcelRequire("gEusR");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $2ogyS = parcelRequire("2ogyS");

var $iau6N = parcelRequire("iau6N");
const $678322372bbc5cca$export$54e4ba490d2c6bb5 = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'screen',
            action: 'viewed'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'IssueAiUpsellDialog');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $678322372bbc5cca$var$containerBorderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        alignBlock: "stretch",
        xcss: $678322372bbc5cca$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignInline: "end",
        grow: "fill",
        xcss: $678322372bbc5cca$var$headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        onClick: onClose,
        label: formatMessage((0, $2ogyS.messages).closeModal),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2C7j9)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c8oLN.default), {
        all: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEusR.default), {
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        alignInline: "stretch",
        space: "space.200",
        xcss: $678322372bbc5cca$var$textContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "medium",
        as: "h2"
    }, formatMessage((0, $2ogyS.messages).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, formatMessage((0, $2ogyS.messages).body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignInline: "end",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iau6N.StartPremiumTrialButton), {
        onCloseParent: onClose
    })))));
};
const $678322372bbc5cca$var$containerBorderStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    boxShadow: 'elevation.shadow.overlay',
    borderRadius: 'border.radius',
    width: '438px',
    position: 'relative',
    padding: 'space.025',
    background: `linear-gradient(
      112.4deg,
      ${`var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`} 0%,
      ${`var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$export$c71e4279dd54a18d)})`} 100%
    )`
});
const $678322372bbc5cca$var$containerStyles = (0, $8CUq3.xcss)({
    borderRadius: 'border.radius',
    backgroundColor: 'elevation.surface.overlay',
    overflow: 'hidden'
});
const $678322372bbc5cca$var$headerStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    padding: 'space.075',
    right: 'space.025'
});
const $678322372bbc5cca$var$textContainerStyles = (0, $8CUq3.xcss)({
    padding: 'space.300'
});

});
parcelRegister("gEusR", function(module, exports) {

$parcel$export(module.exports, "default", () => $daf0e2023e742d66$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $dCLgq = parcelRequire("dCLgq");

var $8nOP6 = parcelRequire("8nOP6");

var $4aPxh = parcelRequire("4aPxh");
const $daf0e2023e742d66$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($4aPxh)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($8nOP6))
});
var $daf0e2023e742d66$export$2e2bcd8739ae039 = $daf0e2023e742d66$var$Illustration;
// for advanced use only
const $daf0e2023e742d66$export$a179c88182cb9d56 = [
    0,
    0,
    438,
    96
];

});
parcelRegister("8nOP6", function(module, exports) {
module.exports = new URL("ai-chat-loading-promoted-darkmode.f2ea2011.svg", import.meta.url).toString();

});

parcelRegister("4aPxh", function(module, exports) {
module.exports = new URL("ai-chat-loading-promoted.9a9a0213.svg", import.meta.url).toString();

});


parcelRegister("2ogyS", function(module, exports) {

$parcel$export(module.exports, "messages", () => $703e8ca8733c69fc$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $703e8ca8733c69fc$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.title",
        "defaultMessage": "Write better, work faster with Atlassian Intelligence"
    },
    body: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.body",
        "defaultMessage": "Use AI to brainstorm, summarize, change tone, edit and more, with Jira Premium."
    },
    closeModal: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.close-modal",
        "defaultMessage": "Close Modal"
    },
    tryItFreeButton: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.try-it-free-button",
        "defaultMessage": "Try it free"
    }
});

});

parcelRegister("iau6N", function(module, exports) {

$parcel$export(module.exports, "StartPremiumTrialButton", () => $d916fa2fae12e75a$export$a2651a739f515dd4);

var $5uXOq = parcelRequire("5uXOq");

var $9yOBd = parcelRequire("9yOBd");

var $8EYBJ = parcelRequire("8EYBJ");


var $47gW9 = parcelRequire("47gW9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ljlOe = parcelRequire("ljlOe");

var $2ogyS = parcelRequire("2ogyS");
const $d916fa2fae12e75a$export$a2651a739f515dd4 = ({ onCloseParent: onCloseParent })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { entryPointActions: entryPointActions } = (0, $5uXOq.useContext)((0, $ljlOe.AIUpsellPremiumTrialEntryPointContext));
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onClickAnalytics = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'openPremiumTrialModalFromIssueAiUpsell');
    }, [
        createAnalyticsEvent
    ]);
    const onClick = ()=>{
        // Nb. premium trial modal open is handled by entry point via ref
        onCloseParent && onCloseParent();
        onClickAnalytics();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        onClick: onClick,
        ref: triggerRef,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8EYBJ))), {
            size: "small",
            label: "",
            primaryColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`
        }),
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                    color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                    outline: 'none',
                    boxSizing: 'border-box',
                    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                    borderRadius: "var(--ds-space-050, 4px)",
                    height: "var(--ds-space-400, 32px)",
                    border: 'none',
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    gap: "var(--ds-space-025, 2px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    }, formatMessage((0, $2ogyS.messages).tryItFreeButton));
};

});





parcelRegister("kZkXS", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e32be9d7f5fa3f2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8e32be9d7f5fa3f2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    commentAddedContent: {
        "id": "contextual-summary.gadgets.activity-feed.activity-items.attachment-added.comment-added-content",
        "defaultMessage": "{author} commented on {issueLink}"
    }
});

});


parcelRegister("cSD1r", function(module, exports) {

$parcel$export(module.exports, "IssueCreated", () => $c5dc8f88111cfb56$export$4cfe312c27fa7aff);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");

var $koVbs = parcelRequire("koVbs");

var $kUujW = parcelRequire("kUujW");

var $i6Q86 = parcelRequire("i6Q86");

var $beAwS = parcelRequire("beAwS");

var $ckwn2 = parcelRequire("ckwn2");

var $153fj = parcelRequire("153fj");

var $kk4Uq = parcelRequire("kk4Uq");
const $c5dc8f88111cfb56$export$4cfe312c27fa7aff = ({ activity: { created: created, issueData: issueData, author: author } })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { fireSectionAnalytics: fireSectionAnalytics } = (0, $153fj.useSectionAnalytics)((0, $beAwS.SectionIds).RecentActivity, (0, $beAwS.BoundaryIds).RecentActivity);
    const onActivityItemClick = (0, $5uXOq.useCallback)((target)=>{
        fireSectionAnalytics(target, {
            boundaryId: (0, $beAwS.BoundaryIds).RecentActivity,
            activityType: (0, $beAwS.ActivityTypes).CREATED
        });
    }, [
        fireSectionAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        columnGap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i6Q86.UserAvatar), {
        author: author
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        rowGap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ckwn2.ActivityMessage), {
        author: author,
        issueData: issueData,
        onClick: onActivityItemClick
    }, ({ author: activityAuthor, issueLink: issueLink })=>formatMessage((0, $kk4Uq.default).issueCreatedContent, {
            author: activityAuthor,
            issueLink: issueLink
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kUujW.RelativeTime), {
        time: created
    }))));
};

});
parcelRegister("kk4Uq", function(module, exports) {

$parcel$export(module.exports, "default", () => $44c485ab575bf77d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $44c485ab575bf77d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issueCreatedContent: {
        "id": "contextual-summary.gadgets.activity-feed.activity-items.attachment-added.issue-created-content",
        "defaultMessage": "{author} created {issueLink}"
    }
});

});


parcelRegister("1XsfU", function(module, exports) {

$parcel$export(module.exports, "PriorityChanged", () => $d156687c71697ba5$export$f1145a366e4ca48a);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $5qRwM = parcelRequire("5qRwM");

var $koVbs = parcelRequire("koVbs");

var $kUujW = parcelRequire("kUujW");

var $i6Q86 = parcelRequire("i6Q86");

var $beAwS = parcelRequire("beAwS");

var $ckwn2 = parcelRequire("ckwn2");

var $153fj = parcelRequire("153fj");

var $fdtcV = parcelRequire("fdtcV");
const $d156687c71697ba5$var$PriorityIcon = ({ name: name, iconUrl: iconUrl })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        alignInline: "center",
        xcss: $d156687c71697ba5$var$priorityIconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
        src: iconUrl,
        alt: "",
        height: 16,
        width: 16
    }), name);
};
const $d156687c71697ba5$export$f1145a366e4ca48a = ({ activity: { created: created, issueData: issueData, author: author, data: { fromName: oldPriority, toName: newPriority, fromIconUrl: oldPriorityIcon, toIconUrl: newPriorityIcon } } })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { fireSectionAnalytics: fireSectionAnalytics } = (0, $153fj.useSectionAnalytics)((0, $beAwS.SectionIds).RecentActivity, (0, $beAwS.BoundaryIds).RecentActivity);
    const onActivityItemClick = (0, $5uXOq.useCallback)((target)=>{
        fireSectionAnalytics(target, {
            boundaryId: (0, $beAwS.BoundaryIds).RecentActivity,
            activityType: (0, $beAwS.ActivityTypes).PRIORITY_CHANGED
        });
    }, [
        fireSectionAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        columnGap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i6Q86.UserAvatar), {
        author: author
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        rowGap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ckwn2.ActivityMessage), {
        author: author,
        issueData: issueData,
        onClick: onActivityItemClick
    }, ({ author: activityAuthor, issueLink: issueLink })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $d156687c71697ba5$var$inlineStyles
        }, formatMessage((0, $fdtcV.default).priorityChangedContent, {
            author: activityAuthor,
            issueLink: issueLink,
            oldPriority: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d156687c71697ba5$var$PriorityIcon, {
                name: oldPriority,
                iconUrl: oldPriorityIcon
            }),
            newPriority: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d156687c71697ba5$var$PriorityIcon, {
                name: newPriority,
                iconUrl: newPriorityIcon
            })
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kUujW.RelativeTime), {
        time: created
    }))));
};
const $d156687c71697ba5$var$priorityIconWrapperStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    verticalAlign: 'text-top'
});
const $d156687c71697ba5$var$inlineStyles = (0, $8CUq3.xcss)({
    display: 'inline'
});

});
parcelRegister("fdtcV", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d8af862ceabed08$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1d8af862ceabed08$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    priorityChangedContent: {
        "id": "contextual-summary.gadgets.activity-feed.activity-items.attachment-added.priority-changed-content",
        "defaultMessage": "{author} changed the Priority from {oldPriority} to {newPriority} on {issueLink}"
    }
});

});


parcelRegister("53TL6", function(module, exports) {

$parcel$export(module.exports, "SingleFieldUpdated", () => $b1b652bf7a968aef$export$123d582efa4be09a);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");

var $koVbs = parcelRequire("koVbs");

var $kUujW = parcelRequire("kUujW");

var $i6Q86 = parcelRequire("i6Q86");

var $beAwS = parcelRequire("beAwS");

var $ckwn2 = parcelRequire("ckwn2");

var $153fj = parcelRequire("153fj");

var $h5fFR = parcelRequire("h5fFR");
const $b1b652bf7a968aef$export$123d582efa4be09a = ({ activity: { created: created, issueData: issueData, author: author, data: { fieldname: fieldName, newValue: newValue } } })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { fireSectionAnalytics: fireSectionAnalytics } = (0, $153fj.useSectionAnalytics)((0, $beAwS.SectionIds).RecentActivity, (0, $beAwS.BoundaryIds).RecentActivity);
    const onActivityItemClick = (0, $5uXOq.useCallback)((target)=>{
        fireSectionAnalytics(target, {
            boundaryId: (0, $beAwS.BoundaryIds).RecentActivity,
            activityType: (0, $beAwS.ActivityTypes).SINGLE_FIELD_UPDATED
        });
    }, [
        fireSectionAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        columnGap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i6Q86.UserAvatar), {
        author: author
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        rowGap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ckwn2.ActivityMessage), {
        author: author,
        issueData: issueData,
        onClick: onActivityItemClick
    }, ({ author: activityAuthor, issueLink: issueLink })=>formatMessage((0, $h5fFR.default).singleFieldUpdatedContent, {
            author: activityAuthor,
            issueLink: issueLink,
            fieldName: fieldName,
            newValue: newValue
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kUujW.RelativeTime), {
        time: created
    }))));
};

});
parcelRegister("h5fFR", function(module, exports) {

$parcel$export(module.exports, "default", () => $02cd83e3c730feaa$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $02cd83e3c730feaa$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    singleFieldUpdatedContent: {
        "id": "contextual-summary.gadgets.activity-feed.activity-items.attachment-added.single-field-updated-content",
        "defaultMessage": "{author} updated field \"{fieldName}\"{newValue, select, undefined {} other { to {newValue}}} on {issueLink}"
    }
});

});


parcelRegister("7cFa2", function(module, exports) {

$parcel$export(module.exports, "StatusChanged", () => $7cd768cfe8551538$export$a64ee343ee7d8fa1);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");

var $koVbs = parcelRequire("koVbs");

var $kUujW = parcelRequire("kUujW");

var $i6Q86 = parcelRequire("i6Q86");

var $beAwS = parcelRequire("beAwS");

var $ckwn2 = parcelRequire("ckwn2");

var $153fj = parcelRequire("153fj");

var $csNDW = parcelRequire("csNDW");
const $7cd768cfe8551538$export$a64ee343ee7d8fa1 = ({ activity: { created: created, issueData: issueData, author: author, data: { oldStatus: oldStatus, newStatus: newStatus } } })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { fireSectionAnalytics: fireSectionAnalytics } = (0, $153fj.useSectionAnalytics)((0, $beAwS.SectionIds).RecentActivity, (0, $beAwS.BoundaryIds).RecentActivity);
    const onActivityItemClick = (0, $5uXOq.useCallback)((target)=>{
        fireSectionAnalytics(target, {
            boundaryId: (0, $beAwS.BoundaryIds).RecentActivity,
            activityType: (0, $beAwS.ActivityTypes).STATUS_CHANGED
        });
    }, [
        fireSectionAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        columnGap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i6Q86.UserAvatar), {
        author: author
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        rowGap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ckwn2.ActivityMessage), {
        author: author,
        issueData: issueData,
        onClick: onActivityItemClick
    }, ({ author: activityAuthor, issueLink: issueLink })=>formatMessage((0, $csNDW.default).statusChangedContent, {
            author: activityAuthor,
            issueLink: issueLink,
            oldStatus: oldStatus,
            newStatus: newStatus
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kUujW.RelativeTime), {
        time: created
    }))));
};

});
parcelRegister("csNDW", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b88137e0170e090$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9b88137e0170e090$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    statusChangedContent: {
        "id": "contextual-summary.gadgets.activity-feed.activity-items.attachment-added.status-changed-content",
        "defaultMessage": "{author} changed the Status from {oldStatus} to {newStatus} on {issueLink}"
    }
});

});



parcelRegister("bJXyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5609660f9327e09a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5609660f9327e09a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "contextual-summary.gadgets.activity-feed.title",
        "defaultMessage": "Recent activity"
    },
    description: {
        "id": "contextual-summary.gadgets.activity-feed.description",
        "defaultMessage": "Stay up to date with what's happening across the project."
    },
    emptyStateTitle: {
        "id": "contextual-summary.gadgets.activity-feed.empty-state-title",
        "defaultMessage": "No activity yet"
    },
    emptyStateDescription: {
        "id": "contextual-summary.gadgets.activity-feed.empty-state-description",
        "defaultMessage": "Create a few issues and invite some teammates to your project to see your project activity."
    },
    todayLabel: {
        "id": "contextual-summary.gadgets.activity-feed.today-label",
        "defaultMessage": "Today"
    },
    yesterdayLabel: {
        "id": "contextual-summary.gadgets.activity-feed.yesterday-label",
        "defaultMessage": "Yesterday"
    }
});

});


parcelRegister("cRMny", function(module, exports) {

$parcel$export(module.exports, "RelatedProjects", () => $327a4cb873d3d0d2$export$9cafa0b13111f8a2);
/* index.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $7ymNM = parcelRequire("7ymNM");

var $3bDjY = parcelRequire("3bDjY");

var $l1N8i = parcelRequire("l1N8i");

var $fVnbM = parcelRequire("fVnbM");

var $172CC = parcelRequire("172CC");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $bKCrm = parcelRequire("bKCrm");

var $aFVvc = parcelRequire("aFVvc");

var $hDzhb = parcelRequire("hDzhb");

var $153fj = parcelRequire("153fj");

var $79GHn = parcelRequire("79GHn");

var $4BeU4 = parcelRequire("4BeU4");

var $beAwS = parcelRequire("beAwS");

var $6Akcp = parcelRequire("6Akcp");

var $ecMZy = parcelRequire("ecMZy");
const $327a4cb873d3d0d2$var$PROJECT_CREATE_OPTIONS = (0, $172CC.getJwmCreateProjectDrawerOptions)('jwmSummaryPage');
const $327a4cb873d3d0d2$export$9cafa0b13111f8a2 = ({ data: data })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { linksTarget: linksTarget } = (0, $79GHn.useSummaryFeatures)();
    const { data: permissions } = (0, $aFVvc.useProjectCreatePermissionsResource)();
    const { fireSectionAnalytics: fireSectionAnalytics } = (0, $153fj.useSectionAnalytics)((0, $beAwS.SectionIds).RelatedProjects, (0, $beAwS.BoundaryIds).RelatedProjects);
    const canCreateProject = Boolean(permissions?.canCreateProject);
    const createProjectRoute = `/jira/create-project?templateId=${$327a4cb873d3d0d2$var$PROJECT_CREATE_OPTIONS.defaultSelectedTemplateKey}`;
    let content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    const hasRecommendedProjects = data != null && data.length > 0;
    if (data != null && data.length === 0) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($327a4cb873d3d0d2$var$EmptyState, {
        withCreateProject: canCreateProject
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($327a4cb873d3d0d2$var$EmptyStateIllustration, null), canCreateProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bKCrm.ProjectCreateDrawerConsumer), null, ({ methods: { open: open } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "primary",
            onClick: ()=>{
                linksTarget === '_blank' ? // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.open(createProjectRoute, '_blank') : open($327a4cb873d3d0d2$var$PROJECT_CREATE_OPTIONS);
                fireSectionAnalytics('createProject', {
                    isEmpty: true
                });
            },
            testId: "contextual-summary.ui.gadgets.related-projects.create-project-button-empty"
        }, formatMessage((0, $ecMZy.default).createProject))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        href: "/jira/projects",
        target: linksTarget,
        component: (0, $hDzhb.default),
        onClick: ()=>fireSectionAnalytics('projectDirectory', {
                isEmpty: true
            })
    }, formatMessage((0, $ecMZy.default).viewAllProjects))));
    else if (data != null) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($327a4cb873d3d0d2$var$Grid, {
        "data-testid": "contextual-summary.ui.gadgets.related-projects.grid"
    }, canCreateProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bKCrm.ProjectCreateDrawerConsumer), null, ({ methods: { open: open } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($327a4cb873d3d0d2$var$CreateProject, {
            onClick: ()=>{
                linksTarget === '_blank' ? // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.open(createProjectRoute, '_blank') : open($327a4cb873d3d0d2$var$PROJECT_CREATE_OPTIONS);
                fireSectionAnalytics('createProject', {
                    isEmpty: false
                });
            },
            "data-testid": "contextual-summary.ui.gadgets.related-projects.create-project-button",
            className: (0, $bwpsq.default)([
                "_2rko1l7b _11c81oud _1e0c1txw _4cvr1h6o _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _19pk1b66 _2hwx1b66 _otyr1b66 _18u01b66 _1ul9idpf _1nrm18uv _1a3b18uv _9oik18uv _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _1di6k6hx _jomrk6hx _irr3k6hx",
                "_11q7glyw _19itglyw _syaz1fxt _80omtlke _k48p1pd9 _n3yiiw92 _1b3i2u25 _12dbfwzl _u7j629zg _y6l529zg _1k1529zg _9tyi17uj _1opp17uj _m21a17uj _1w911edt _b14k1edt _4jwe1edt"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($327a4cb873d3d0d2$var$CreateProjectIcon, {
            "data-icon": true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ymNM))), {
            label: formatMessage((0, $ecMZy.default).createProject)
        })), formatMessage((0, $ecMZy.default).createProject))), data.map(({ id: id, avatarUrl: avatarUrl, name: name, key: key, url: url, projectTypeKey: projectTypeKey }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($327a4cb873d3d0d2$var$Project, {
            "data-testid": "contextual-summary.ui.gadgets.related-projects.project",
            href: url,
            target: linksTarget,
            key: id,
            onClick: ()=>fireSectionAnalytics('relatedProject', {
                    projectTypeKey: projectTypeKey,
                    // Ensure position count starts at 1
                    resultPosition: index + 1
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($327a4cb873d3d0d2$var$ProjectAvatar, {
            src: `${avatarUrl}?size=xxlarge`,
            alt: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($327a4cb873d3d0d2$var$ProjectDetails, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: name
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($327a4cb873d3d0d2$var$ProjectName, null, name)), key)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($327a4cb873d3d0d2$var$AllProjects, {
        href: "/jira/projects",
        target: linksTarget,
        onClick: ()=>fireSectionAnalytics('projectDirectory', {
                isEmpty: false
            })
    }, formatMessage((0, $ecMZy.default).viewAllProjects)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4BeU4.ChartWithHeaderContainer), {
        header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            size: "small",
            as: "h2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $ecMZy.default).title)), hasRecommendedProjects ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $ecMZy.default).description) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $ecMZy.default).descriptionWhenEmpty)),
        chart: content
    });
};
var $327a4cb873d3d0d2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($327a4cb873d3d0d2$export$9cafa0b13111f8a2);
const $327a4cb873d3d0d2$var$buttonStyles = null;
const $327a4cb873d3d0d2$var$iconStyles = null;
const $327a4cb873d3d0d2$var$gridStyles = null;
const $327a4cb873d3d0d2$var$projectStyles = null;
const $327a4cb873d3d0d2$var$allProjectStyles = null;
const $327a4cb873d3d0d2$var$createProjectButtonStyles = null;
const $327a4cb873d3d0d2$var$projectNameStyles = null;
const $327a4cb873d3d0d2$var$projectAvatarStyles = null;
const $327a4cb873d3d0d2$var$createProjectIconStyles = null;
const $327a4cb873d3d0d2$var$createProjectStyles = null;
const $327a4cb873d3d0d2$var$emptyStateIllustrationStyles = null;
const $327a4cb873d3d0d2$var$baseEmptyStateStyles = null;
const $327a4cb873d3d0d2$var$withCreateProjectStyles = null;
const $327a4cb873d3d0d2$var$withoutCreateProjectStyles = null;
const $327a4cb873d3d0d2$var$Grid = ({ ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ...props,
        className: (0, $bwpsq.default)([
            "_zulpze3t _1e0c11p5 _yv0ewxkt _2hwxxmi2 _u5f3utpp _18m91wug"
        ])
    });
};
const $327a4cb873d3d0d2$var$Project = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
        ...props,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _11c81oud _1e0c1txw _4cvr1h6o _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _19pk1b66 _2hwx1b66 _otyr1b66 _18u01b66 _1ul9idpf _1nrm18uv _1a3b18uv _9oik18uv _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _1di6k6hx _jomrk6hx _irr3k6hx"
        ])
    }, children);
};
const $327a4cb873d3d0d2$var$CreateProject = ({ ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("button", {
        ...props,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _11c81oud _1e0c1txw _4cvr1h6o _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _19pk1b66 _2hwx1b66 _otyr1b66 _18u01b66 _1ul9idpf _1nrm18uv _1a3b18uv _9oik18uv _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _1di6k6hx _jomrk6hx _irr3k6hx",
            "_11q7glyw _19itglyw _syaz1fxt _80omtlke _k48p1pd9 _n3yiiw92 _1b3i2u25 _12dbfwzl _u7j629zg _y6l529zg _1k1529zg _9tyi17uj _1opp17uj _m21a17uj _1w911edt _b14k1edt _4jwe1edt"
        ])
    });
};
const $327a4cb873d3d0d2$var$CreateProjectIcon = ({ ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-icon": true,
        ...props,
        className: (0, $bwpsq.default)([
            "_19it1owy _2rkoftgi _syazkr0v _bfhk84zz _1e0c1txw _4cvr1h6o _1bah1h6o",
            "_16jlidpf _1o9zidpf _i0dl1wug _vchhusvi _4t3ickbl _1bsbckbl _2hwxutpp"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ymNM))), {
        label: ""
    }));
};
const $327a4cb873d3d0d2$var$ProjectAvatar = ({ ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        alt: "",
        ...props,
        className: (0, $bwpsq.default)([
            "_2rko1l7b",
            "_16jlidpf _1o9zidpf _i0dl1wug _vchhusvi _4t3ickbl _1bsbckbl _2hwxutpp"
        ])
    });
};
const $327a4cb873d3d0d2$var$ProjectName = ({ ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ...props,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _syaz1fxt _k48p1pd9 _o5721q9c _1bto1l2s"
        ])
    });
};
const $327a4cb873d3d0d2$var$ProjectDetails = ({ ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ...props,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _syaz1rc1"
        ])
    });
};
const $327a4cb873d3d0d2$var$AllProjects = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
        ...props,
        className: (0, $bwpsq.default)([
            "_1wpz1y6m"
        ])
    }, children);
};
const $327a4cb873d3d0d2$var$EmptyState = ({ withCreateProject: withCreateProject, children: children, ...props })=>{
    const combinedStyles = [
        $327a4cb873d3d0d2$var$baseEmptyStateStyles,
        withCreateProject ? $327a4cb873d3d0d2$var$withCreateProjectStyles : $327a4cb873d3d0d2$var$withoutCreateProjectStyles
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ...props,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _zulp1tr9 _1wpz1h6o _1e0c11p5 _ae4v1h6o _6a6z1h6o",
            withCreateProject ? "_1lmcd2gs" : "_1lmc4osr"
        ])
    }, children);
};
const $327a4cb873d3d0d2$var$EmptyStateIllustration = ({ ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Akcp.default), {
        ...props,
        className: (0, $bwpsq.default)([
            "_nd5l1gsw"
        ])
    });
};

});
parcelRegister("172CC", function(module, exports) {

$parcel$export(module.exports, "getJwmCreateProjectDrawerOptions", () => $30b27d3ea79ff2d5$export$c1785414279ee192);

var $2vSU6 = parcelRequire("2vSU6");
const $30b27d3ea79ff2d5$var$TEMPLATE_BLANK_PROJECT_TEAM_MANAGED = 'com.atlassian.jira-core-project-templates:jira-work-management-blank-project-team-managed';
const $30b27d3ea79ff2d5$export$c1785414279ee192 = (source, recommendationSessionId)=>({
        isNextGen: true,
        selectedProjectType: (0, $2vSU6.CORE_PROJECT),
        showExperienceSelection: false,
        defaultSelectedTemplateKey: $30b27d3ea79ff2d5$var$TEMPLATE_BLANK_PROJECT_TEAM_MANAGED,
        recommendedTemplate: {
            templateKey: $30b27d3ea79ff2d5$var$TEMPLATE_BLANK_PROJECT_TEAM_MANAGED,
            isSimplified: false
        },
        source: source,
        recommendationSessionId: recommendationSessionId
    });

});

parcelRegister("6Akcp", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dafa2b5cca6e8fc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $5dafa2b5cca6e8fc$var$EmptyIllustration = ({ className: className })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "140",
        viewBox: "0 0 270 197",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#related_proj_0_clip)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M38.1121 159.386L36.6245 161.141L73.9342 192.782L75.4219 191.027L38.1121 159.386Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M22.9727 98.5313L22.6646 100.811L73.6011 107.697L73.9092 105.418L22.9727 98.5313Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M69.1668 57.4796L67.4548 59.0156L94.3284 88.9667L96.0403 87.4307L69.1668 57.4796Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M174.162 69.7903L173.337 71.9375L222.285 90.7267L223.109 88.5795L174.162 69.7903Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M160.704 120.078L159.843 122.211L229.827 150.486L230.688 148.354L160.704 120.078Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M223.721 88.5916L221.444 88.8906L229.276 148.538L231.553 148.239L223.721 88.5916Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M67.4944 57.4183L22.0071 98.8086L23.5348 100.488L69.0221 59.0973L67.4944 57.4183Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M23.9733 99.3967L21.7368 99.9336L36.3085 160.629L38.5449 160.092L23.9733 99.3967Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M229.603 148.698L198.452 179.203L200.041 180.825L231.192 150.32L229.603 148.698Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M264.105 130.299L229.537 148.141L230.578 150.158L265.146 132.316L264.105 130.299Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M129.777 123.241L37.2278 158.953L38.045 161.071L130.594 125.359L129.777 123.241Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M222.268 88.5009L129.818 123.066L130.613 125.193L223.063 90.6272L222.268 88.5009Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M130.3 195.9C169.899 195.9 202 163.799 202 124.2C202 84.6012 169.899 52.5 130.3 52.5C90.701 52.5 58.5999 84.6012 58.5999 124.2C58.5999 163.799 90.701 195.9 130.3 195.9Z",
        fill: "url(#related_proj_0_linear)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        opacity: "0.5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.5",
        d: "M129 79.8008H99.7999C99.4999 80.6008 99.1 81.4008 98.7 82.3008H129V79.8008Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.5",
        d: "M73.9999 79.8008C73.3999 80.6008 72.6999 81.4008 72.0999 82.3008H96.2999C96.6058 81.442 96.9734 80.6065 97.3999 79.8008H73.9999Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.5",
        d: "M188.4 82.3008C187.823 81.426 187.188 80.5908 186.5 79.8008H164.7C165 80.6008 165.4 81.4008 165.7 82.3008H188.4Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.5",
        d: "M131.5 82.3008H163.3C162.9 81.4008 162.6 80.6008 162.2 79.8008H131.5V82.3008Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.5",
        d: "M129 166.1H97.2C97.6 166.9 97.8999 167.8 98.2999 168.6H129V166.1Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.5",
        d: "M72.0999 166.1L73.9999 168.6H95.7999L94.7999 166.1H72.0999Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.5",
        d: "M186.5 168.6C187.2 167.8 187.8 166.9 188.4 166.1H164.2C163.875 166.951 163.508 167.785 163.1 168.6H186.5Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.5",
        d: "M131.5 168.6H160.7C161.108 167.785 161.475 166.951 161.8 166.1H131.5V168.6Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.5",
        d: "M98.6998 82.3C99.0998 81.4 99.4998 80.6 99.7998 79.8C107 64.9 117.4 55 129 53.8V52.5H131.5V53.7H132.1C142.7 53.9 152.5 61.5 159.8 74.8C160.6 76.4 161.5 78.1 162.2 79.8C162.9 81.5 162.9 81.4 163.3 82.3C168.1 94 170.6 108.1 170.5 122.9H172.7C172.8 108.2 170.4 94.1 165.7 82.3C165.4 81.4 165 80.6 164.7 79.8C164.4 79 162.8 75.7 161.8 73.7C156.2 63.5 149.2 56.6 141.4 53.4C138.323 52.8926 135.216 52.5919 132.1 52.5C129 52.5 125.9 52.6 122.9 52.9C112.7 56.5 103.7 66.2 97.3998 79.8C96.9733 80.6057 96.6057 81.4412 96.2998 82.3C91.2998 93.8 88.1998 107.8 87.7998 122.9H90.0998C90.3473 108.942 93.2666 95.1599 98.6998 82.3Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.5",
        d: "M164.2 166.1C169.578 153.192 172.463 139.382 172.7 125.4H170.4C170.163 139.392 167.243 153.209 161.8 166.1C161.475 166.952 161.108 167.786 160.7 168.6C153.5 183.5 143.1 193.3 131.5 194.5V195.6H129V194.7H128.4C117.8 194.4 108 186.9 100.7 173.5L98.2999 168.6C97.8999 167.8 97.5999 166.9 97.1999 166.1C92.3999 154.3 89.8999 140.2 90.0999 125.4H87.7999C87.6999 140.2 90.0999 154.2 94.7999 166.1L95.7999 168.6C96.6999 170.7 97.6999 172.7 98.6999 174.6C104.3 184.8 111.3 191.8 119.1 195C122.2 195.4 125.2 195.7 128.4 195.8C131.506 195.917 134.616 195.783 137.7 195.4C147.8 191.9 156.8 182.1 163.1 168.6C163.508 167.786 163.875 166.952 164.2 166.1Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.5",
        d: "M131.5 79.8V53.7V52.5H129V53.8V79.8V82.3V122.9H131.5V82.3V79.8Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.5",
        d: "M131.5 166.1V125.4H129V166.1V168.6V194.7V195.6H131.5V194.5V168.6V166.1Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.5",
        d: "M129 125.4H131.5H170.4H172.7H201.9V122.9H172.7H170.5H131.5H129H90.0999H87.7999H58.8999V125.4H87.7999H90.0999H129Z",
        fill: "#B2D4FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        opacity: "0.4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.4",
        d: "M78.1999 155C77.959 155.028 77.7148 154.997 77.4884 154.91C77.262 154.822 77.06 154.682 76.8999 154.5C76.7084 154.331 76.555 154.123 76.4499 153.89C76.3449 153.657 76.2905 153.405 76.2905 153.15C76.2905 152.894 76.3449 152.642 76.4499 152.409C76.555 152.176 76.7084 151.968 76.8999 151.8L128.9 99.7995C129.252 99.4691 129.717 99.2852 130.2 99.2852C130.683 99.2852 131.148 99.4691 131.5 99.7995C131.691 99.9684 131.845 100.176 131.95 100.409C132.055 100.642 132.109 100.894 132.109 101.15C132.109 101.405 132.055 101.657 131.95 101.89C131.845 102.123 131.691 102.331 131.5 102.5L79.4999 154.5C79.3398 154.682 79.1379 154.822 78.9115 154.91C78.6851 154.997 78.4409 155.028 78.1999 155Z",
        fill: "url(#related_proj_1_linear)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M200.9 55.4995C177.8 46.0995 154.6 64.8995 131.5 55.4995V3.29948C154.6 12.6995 177.8 -6.10052 200.9 3.29948V55.4995Z",
        fill: "url(#related_proj_2_linear)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M130.2 102.9C129.739 102.901 129.296 102.725 128.961 102.409C128.626 102.092 128.425 101.66 128.4 101.2V3.3C128.4 2.82261 128.59 2.36477 128.927 2.02721C129.265 1.68964 129.723 1.5 130.2 1.5C130.677 1.5 131.135 1.68964 131.473 2.02721C131.81 2.36477 132 2.82261 132 3.3V101.2C131.974 101.66 131.773 102.092 131.439 102.409C131.104 102.725 130.66 102.901 130.2 102.9Z",
        fill: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M166.8 15.4994L170.9 23.8994L180.1 25.0994C180.259 25.1278 180.408 25.1987 180.53 25.3045C180.653 25.4104 180.745 25.5473 180.796 25.7008C180.847 25.8544 180.856 26.0189 180.821 26.177C180.787 26.3351 180.71 26.4811 180.6 26.5994L174 33.2994L175.5 42.5994C175.546 42.756 175.544 42.923 175.492 43.0781C175.441 43.2331 175.344 43.3687 175.213 43.4667C175.082 43.5647 174.925 43.6203 174.762 43.6262C174.598 43.632 174.437 43.5878 174.3 43.4994L166 39.2994L157.8 43.7994C157.655 43.8723 157.494 43.9048 157.332 43.8936C157.171 43.8824 157.016 43.8279 156.882 43.7357C156.749 43.6436 156.644 43.5173 156.576 43.3701C156.509 43.2229 156.483 43.0603 156.5 42.8994L158.1 33.5994L151.4 27.0994C151.29 26.9811 151.213 26.8351 151.179 26.677C151.144 26.5189 151.153 26.3544 151.204 26.2008C151.255 26.0473 151.347 25.9104 151.469 25.8045C151.592 25.6987 151.741 25.6278 151.9 25.5994L161.1 24.0994L165.2 15.4994C165.276 15.3525 165.39 15.2293 165.531 15.1433C165.673 15.0572 165.835 15.0117 166 15.0117C166.165 15.0117 166.327 15.0572 166.468 15.1433C166.609 15.2293 166.724 15.3525 166.8 15.4994Z",
        fill: "#FFF0B2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M68.3 68.7996C74.1542 68.7996 78.9 64.0538 78.9 58.1996C78.9 52.3454 74.1542 47.5996 68.3 47.5996C62.4457 47.5996 57.7 52.3454 57.7 58.1996C57.7 64.0538 62.4457 68.7996 68.3 68.7996Z",
        fill: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M199.2 190.6C205.054 190.6 209.8 185.855 209.8 180C209.8 174.146 205.054 169.4 199.2 169.4C193.346 169.4 188.6 174.146 188.6 180C188.6 185.855 193.346 190.6 199.2 190.6Z",
        fill: "url(#related_proj_3_linear)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M37.3 170.899C43.1542 170.899 47.9 166.153 47.9 160.299C47.9 154.445 43.1542 149.699 37.3 149.699C31.4457 149.699 26.7 154.445 26.7 160.299C26.7 166.153 31.4457 170.899 37.3 170.899Z",
        fill: "url(#related_proj_4_linear)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M230.4 154.3C233.106 154.3 235.3 152.106 235.3 149.4C235.3 146.694 233.106 144.5 230.4 144.5C227.694 144.5 225.5 146.694 225.5 149.4C225.5 152.106 227.694 154.3 230.4 154.3Z",
        fill: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M222.7 94.5988C225.406 94.5988 227.6 92.405 227.6 89.6988C227.6 86.9926 225.406 84.7988 222.7 84.7988C219.994 84.7988 217.8 86.9926 217.8 89.6988C217.8 92.405 219.994 94.5988 222.7 94.5988Z",
        fill: "#505F79"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M264.4 136.4C267.106 136.4 269.3 134.206 269.3 131.5C269.3 128.793 267.106 126.6 264.4 126.6C261.694 126.6 259.5 128.793 259.5 131.5C259.5 134.206 261.694 136.4 264.4 136.4Z",
        fill: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6.04613 73.1738L4.15063 74.4766L21.8622 100.247L23.7576 98.9443L6.04613 73.1738Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M5.2999 78.4992C8.0061 78.4992 10.1999 76.3054 10.1999 73.5992C10.1999 70.893 8.0061 68.6992 5.2999 68.6992C2.59371 68.6992 0.399902 70.893 0.399902 73.5992C0.399902 76.3054 2.59371 78.4992 5.2999 78.4992Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M22.7999 104.499C25.5061 104.499 27.6999 102.305 27.6999 99.5992C27.6999 96.893 25.5061 94.6992 22.7999 94.6992C20.0937 94.6992 17.8999 96.893 17.8999 99.5992C17.8999 102.305 20.0937 104.499 22.7999 104.499Z",
        fill: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M74.5999 196.9C77.3061 196.9 79.4999 194.706 79.4999 192C79.4999 189.293 77.3061 187.1 74.5999 187.1C71.8937 187.1 69.7 189.293 69.7 192C69.7 194.706 71.8937 196.9 74.5999 196.9Z",
        fill: "#505F79"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "related_proj_0_linear",
        x1: "79.5799",
        y1: "174.85",
        x2: "180.94",
        y2: "73.5",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.67",
        stopColor: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.99",
        stopColor: "#B2D4FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "related_proj_1_linear",
        x1: "76.3199",
        y1: "127.16",
        x2: "132.09",
        y2: "127.16",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: "#0052CC",
        stopOpacity: "0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: "#0052CC"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "related_proj_2_linear",
        x1: "135.77",
        y1: "59.8495",
        x2: "196.62",
        y2: "-1.00051",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.24",
        stopColor: "#FF991F"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: "#FFC400"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "related_proj_3_linear",
        x1: "191.7",
        y1: "187.46",
        x2: "206.69",
        y2: "172.47",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.05",
        stopColor: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.99",
        stopColor: "#B2D4FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "related_proj_4_linear",
        x1: "650.616",
        y1: "3695.4",
        x2: "968.404",
        y2: "3377.4",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.05",
        stopColor: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.99",
        stopColor: "#B2D4FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "related_proj_0_clip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M0.399902 0.599609H269.3V196.9H0.399902V0.599609Z",
        fill: "white"
    }))));
var $5dafa2b5cca6e8fc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($5dafa2b5cca6e8fc$var$EmptyIllustration);

});

parcelRegister("ecMZy", function(module, exports) {

$parcel$export(module.exports, "default", () => $45738bf3628533d7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $45738bf3628533d7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "contextual-summary.project-summary.related-projects.title",
        "defaultMessage": "Related projects"
    },
    description: {
        "id": "contextual-summary.project-summary.related-projects.description",
        "defaultMessage": "Connect with other projects your team frequently contributes to and align with other project dependencies."
    },
    descriptionWhenEmpty: {
        "id": "contextual-summary.project-summary.related-projects.description-when-empty",
        "defaultMessage": "Use projects to manage all your work in one place and stay aligned with stakeholders."
    },
    createProject: {
        "id": "contextual-summary.project-summary.related-projects.create-project",
        "defaultMessage": "Create a project"
    },
    viewAllProjects: {
        "id": "contextual-summary.project-summary.related-projects.view-all-projects",
        "defaultMessage": "View all projects"
    }
});

});


parcelRegister("7brUi", function(module, exports) {

$parcel$export(module.exports, "CsatOverTime", () => $fd7f599b9d762c9d$export$74a70c6bd601dea2);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $axDJ9 = parcelRequire("axDJ9");

var $kVYPm = parcelRequire("kVYPm");
const $fd7f599b9d762c9d$export$74a70c6bd601dea2 = ({ data: { averageCsat: averageCsat, csatOverTime: csatOverTime } })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $axDJ9.LineChart), {
        data: [
            ...csatOverTime.map(({ csat: csat, month: month })=>({
                    name: month,
                    count: csat
                }))
        ],
        title: formatMessage((0, $kVYPm.default).title),
        singleValue: averageCsat != null ? averageCsat.toString() : '-'
    });
};

});
parcelRegister("axDJ9", function(module, exports) {

$parcel$export(module.exports, "LineChart", () => $105e57e8503fa9e8$export$54d0e8420ac838ac);

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");

var $j66vR = parcelRequire("j66vR");
const $105e57e8503fa9e8$export$54d0e8420ac838ac = ({ data: data, title: title, singleValue: singleValue, xAxisLabel: xAxisLabel, yAxisLabel: yAxisLabel })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j66vR.default), {
        data: data,
        xAccessor: "name",
        yAccessor: "count"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j66vR.default).elements.Title, null, title), singleValue != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j66vR.default).elements.SubTitle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlockEnd: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "span",
        size: "xxlarge"
    }, singleValue))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j66vR.default).elements.Menu, {
        hide: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j66vR.default).elements.PointMarks, {
        hide: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j66vR.default).elements.Layout, {
        showBorder: false,
        overflow: "visible"
    }), xAxisLabel != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j66vR.default).elements.AxisBottom, {
        label: xAxisLabel
    }), yAxisLabel != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j66vR.default).elements.AxisLeft, {
        label: yAxisLabel
    }));
};

});
parcelRegister("j66vR", function(module, exports) {

$parcel$export(module.exports, "default", () => $de73a131239327e1$export$2e2bcd8739ae039);

var $17PP9 = parcelRequire("17PP9");

var $lOXm0 = parcelRequire("lOXm0");

var $hqZma = parcelRequire("hqZma");

var $cXzUG = parcelRequire("cXzUG");
parcelRequire("lWVLr");
var $7Nxvv = parcelRequire("7Nxvv");
var $lWVLr = parcelRequire("lWVLr");

var $e2CtX = parcelRequire("e2CtX");

var $erST8 = parcelRequire("erST8");

var $3B9ij = parcelRequire("3B9ij");

var $chU1I = parcelRequire("chU1I");
var $PfPCm = parcelRequire("PfPCm");

var $cgmj2 = parcelRequire("cgmj2");

var $doqD0 = parcelRequire("doqD0");
var $l6fAT = parcelRequire("l6fAT");

var $1Tf3y = parcelRequire("1Tf3y");

var $lA40p = parcelRequire("lA40p");

var $02ifK = parcelRequire("02ifK");

var $e0UVN = parcelRequire("e0UVN");

var $2pOyr = parcelRequire("2pOyr");

var $g5ijG = parcelRequire("g5ijG");

var $h4I5z = parcelRequire("h4I5z");

var $l5BNN = parcelRequire("l5BNN");

var $7OPXS = parcelRequire("7OPXS");

var $2OMIu = parcelRequire("2OMIu");
function $de73a131239327e1$export$2e2bcd8739ae039(_ref) {
    let { width: width, height: height, children: children, ...restProps } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $17PP9.ElementsProvider), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e0UVN.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $PfPCm.MenuProvider), {
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $02ifK.default), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)($de73a131239327e1$export$2e2bcd8739ae039.elements.Menu, {
                            disablePatternOption: true
                        }),
                        children,
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lWVLr.LayoutContainer), {
                            width: width,
                            height: height,
                            data: restProps.data,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e2CtX.DimensionsWrapper), {
                                children: (_ref2)=>{
                                    let { margin: margin, plotHeight: plotHeight, plotWidth: plotWidth, plotSvgRef: plotSvgRef } = _ref2;
                                    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7OPXS.PureLineChart), {
                                        svgRef: plotSvgRef,
                                        height: plotHeight,
                                        width: plotWidth,
                                        margin: margin,
                                        ...restProps
                                    });
                                }
                            })
                        })
                    ]
                })
            })
        })
    });
}
$de73a131239327e1$export$2e2bcd8739ae039.elements = {
    // All of the Axis Left components
    AxisLeft: (0, $cXzUG.AxisLeft).Component,
    AxisLeftText: (0, $cXzUG.AxisLeftText).Component,
    AxisLeftTick: (0, $cXzUG.AxisLeftTick).Component,
    AxisLeftLine: (0, $cXzUG.AxisLeftLine).Component,
    // AxisBottomComponents
    AxisBottom: (0, $hqZma.AxisBottom).Component,
    AxisBottomText: (0, $hqZma.AxisBottomText).Component,
    AxisBottomTick: (0, $hqZma.AxisBottomTick).Component,
    AxisBottomLine: (0, $hqZma.AxisBottomLine).Component,
    Layout: (0, $7Nxvv.Layout).Component,
    Title: (0, $l6fAT.Title).Component,
    SubTitle: (0, $doqD0.Subtitle).Component,
    Menu: (0, $chU1I.Menu).Component,
    Theme: (0, $cgmj2.Theme).Component,
    Legend: (0, $3B9ij.OrdinalLegend).Component,
    Grid: (0, $erST8.Grid).Component,
    // Linechart custom elements
    Scales: (0, $h4I5z.LineScales).Component,
    Tooltip: (0, $2pOyr.MultiSeriesTooltip).Component,
    TooltipHeader: (0, $1Tf3y.TooltipHeader).Component,
    TooltipRow: (0, $lA40p.TooltipRow).Component,
    TooltipOverlay: (0, $l5BNN.LineTooltipOverlayElement).Component,
    Mark: (0, $g5ijG.LinePath).Component,
    Marks: (0, $g5ijG.LineMarkElement).Component,
    AddMark: (0, $g5ijG.AddMark).Component,
    PointMarks: (0, $g5ijG.PointMarks).Component,
    DataTable: (0, $lOXm0.DataTable).Component
};

});
parcelRegister("g5ijG", function(module, exports) {

$parcel$export(module.exports, "LinePath", () => $bb5b523d53c602a9$export$7e9023be98b4a812);
$parcel$export(module.exports, "LineMarkElement", () => $bb5b523d53c602a9$export$83633c2b874e7fe8);
$parcel$export(module.exports, "AddMark", () => $bb5b523d53c602a9$export$9b27752060f27111);
$parcel$export(module.exports, "PointMarks", () => $bb5b523d53c602a9$export$6ac937313e6b7c6);
$parcel$export(module.exports, "LineMarkSlot", () => $bb5b523d53c602a9$export$3e69a2ec6d143702);
/* mark.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $hjll3 = parcelRequire("hjll3");

var $bT1Sw = parcelRequire("bT1Sw");

var $4mjAg = parcelRequire("4mjAg");

var $2OMIu = parcelRequire("2OMIu");
const $bb5b523d53c602a9$var$lineStyles = null;
function $bb5b523d53c602a9$var$_LinePath(_ref) {
    let { data: data = [], x: x, y: y, fill: fill = 'transparent', fillOpacity: fillOpacity, strokeOpacity: strokeOpacity = 1, curve: curve, defined: defined = ()=>true, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray } = _ref;
    const path = (0, $hjll3.line)().x((d)=>x(d)).y((d)=>y(d)).defined(defined);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
        d: path(data) || '',
        fill: fill,
        fillOpacity: fillOpacity,
        strokeOpacity: strokeOpacity,
        stroke: stroke,
        strokeWidth: strokeWidth,
        strokeDasharray: strokeDasharray,
        strokeLinecap: "round",
        className: (0, $bwpsq.default)([
            "_v5641de5"
        ])
    });
}
const $bb5b523d53c602a9$export$7e9023be98b4a812 = (0, $bT1Sw.element)($bb5b523d53c602a9$var$_LinePath);
const $bb5b523d53c602a9$export$83633c2b874e7fe8 = (0, $bT1Sw.element)((props)=>{
    const { stroke: stroke, x: x, y: y, lineGroups: lineGroups, strokeWidth: strokeWidth } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: Array.from(lineGroups).map((_ref2)=>{
            let [key, entries] = _ref2;
            return /*#__PURE__*/ (0, $2OMIu.jsx)($bb5b523d53c602a9$export$7e9023be98b4a812, {
                stroke: stroke(key),
                strokeWidth: strokeWidth,
                data: entries,
                x: x,
                y: y
            }, `${key}-${stroke(key)}`);
        })
    });
});
const $bb5b523d53c602a9$export$9b27752060f27111 = (0, $bT1Sw.element)((props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {});
});
const $bb5b523d53c602a9$export$6ac937313e6b7c6 = (0, $bT1Sw.element)((_ref3)=>{
    let { lineGroups: lineGroups, xScale: xScale, yScale: yScale, colorScale: colorScale, xAccessor: xAccessor, yAccessor: yAccessor, hide: hide = false } = _ref3;
    if (hide) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: Array.from(lineGroups).map((_ref4)=>{
            let [key, entries] = _ref4;
            return entries.map((entry)=>{
                const cx = xScale(xAccessor(entry));
                const cy = yScale(yAccessor(entry));
                if (!isNaN(cx) && !isNaN(cy)) return /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                    cx: cx,
                    cy: cy,
                    r: 4,
                    fill: "var(--ds-surface, #FFFFFF)",
                    stroke: colorScale(key),
                    strokeWidth: 2
                }, `line-mark-point-${key}-${xAccessor(entry)}`);
            });
        })
    });
});
function $bb5b523d53c602a9$export$3e69a2ec6d143702() {
    const { xScale: xScale, yScale: yScale, colorScale: colorScale, xAccessor: xAccessor, yAccessor: yAccessor, lineGroups: lineGroups, data: data, height: height } = (0, $4mjAg.useLineData)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($bb5b523d53c602a9$export$83633c2b874e7fe8, {
                stroke: (key)=>colorScale(key),
                x: (d)=>{
                    var _xScale;
                    return (_xScale = xScale(xAccessor(d))) !== null && _xScale !== void 0 ? _xScale : 0;
                },
                y: (d)=>{
                    var _yScale;
                    return (_yScale = yScale(yAccessor(d))) !== null && _yScale !== void 0 ? _yScale : height;
                },
                lineGroups: lineGroups,
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($bb5b523d53c602a9$export$9b27752060f27111, {
                xScale: xScale,
                yScale: yScale,
                colorScale: colorScale,
                xAccessor: xAccessor,
                yAccessor: yAccessor,
                lineGroups: lineGroups,
                data: data
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($bb5b523d53c602a9$export$6ac937313e6b7c6, {
                xScale: xScale,
                yScale: yScale,
                colorScale: colorScale,
                xAccessor: xAccessor,
                yAccessor: yAccessor,
                lineGroups: lineGroups,
                data: data
            })
        ]
    });
}

});
parcelRegister("4mjAg", function(module, exports) {

$parcel$export(module.exports, "LineDataProvider", () => $32c8687624435b7e$export$e9dcd4f541370089);
$parcel$export(module.exports, "useLineData", () => $32c8687624435b7e$export$253d7860b08dc7a0);

var $5uXOq = parcelRequire("5uXOq");

var $cgmj2 = parcelRequire("cgmj2");

var $h4I5z = parcelRequire("h4I5z");

var $2OMIu = parcelRequire("2OMIu");
const $32c8687624435b7e$var$DataContext = /*#__PURE__*/ (0, $5uXOq.createContext)({});
function $32c8687624435b7e$export$e9dcd4f541370089(_ref) {
    let { children: children, ...props } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgmj2.Theme), {
        fillStyles: (0, $cgmj2.DEFAULT_ORDINAL_COLORS),
        useThemeFillStyles: (0, $cgmj2.useThemeFillStyles),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h4I5z.LineScales), {
            ...props,
            children: (scales)=>/*#__PURE__*/ (0, $2OMIu.jsx)($32c8687624435b7e$var$DataContext.Provider, {
                    value: {
                        ...props,
                        ...scales
                    },
                    children: children
                })
        })
    });
}
function $32c8687624435b7e$export$253d7860b08dc7a0() {
    return (0, $5uXOq.useContext)($32c8687624435b7e$var$DataContext);
}

});
parcelRegister("h4I5z", function(module, exports) {

$parcel$export(module.exports, "LineScales", () => $03353df9c53e8a07$export$3067802c84a365ce);

var $hjll3 = parcelRequire("hjll3");

var $5uXOq = parcelRequire("5uXOq");

var $j66vR = parcelRequire("j66vR");

var $bT1Sw = parcelRequire("bT1Sw");
var $17PP9 = parcelRequire("17PP9");

var $5pfgu = parcelRequire("5pfgu");
var $38Bo0 = parcelRequire("38Bo0");
var $juXo4 = parcelRequire("juXo4");
var $lLx1Y = parcelRequire("lLx1Y");
var $2YVVm = parcelRequire("2YVVm");
const $03353df9c53e8a07$export$3067802c84a365ce = (0, $bT1Sw.element)((props)=>{
    const { data: data, x: x, y: y, color: color, width: width, height: height, log: log, yDomain: yDomain } = props;
    const { fillStyles: fillStyles, useThemeFillStyles: useThemeFillStyles } = (0, $17PP9.useElementProps)((0, $j66vR.default).elements.Theme);
    // TODO: children should come from hook
    const value = (0, $5uXOq.useMemo)(()=>{
        var _extentYValues$;
        const xScale = x(data[0]) instanceof Date || x(data[data.length - 1]) instanceof Date ? (0, $2YVVm.default)({
            // TODO: make sure this works with unique values
            // @ts-expect-error - extent might return [undefined, undefined]
            domain: (0, $hjll3.extent)(data, x),
            range: [
                0,
                width
            ]
        }) : (0, $lLx1Y.default)({
            // TODO: make sure this works with unique values
            domain: [
                ...new Set(data.map(x))
            ],
            range: [
                0,
                width
            ],
            padding: 0
        });
        // d3 max can handle null values
        const extentYValues = (0, $hjll3.extent)([
            ...data.map(y)
        ]);
        const yDomainOutput = [
            log ? 1 : extentYValues[0],
            (_extentYValues$ = extentYValues[1]) !== null && _extentYValues$ !== void 0 ? _extentYValues$ : 1
        ];
        if (yDomain && yDomain[0] !== null) yDomainOutput[0] = yDomain[0];
        if (yDomain && yDomain[1] !== null) yDomainOutput[1] = yDomain[1];
        const yScale = !props.log ? (0, $5pfgu.default)({
            domain: yDomainOutput,
            range: [
                height,
                0
            ]
        }) : (0, $38Bo0.default)({
            domain: yDomainOutput,
            range: [
                height,
                0
            ]
        });
        const { domain: domain, range: range } = useThemeFillStyles({
            fillStyles: fillStyles
        });
        const colorScale = (0, $juXo4.default)({
            domain: domain ? domain : data.map(color),
            range: range
        });
        const seriesData = (0, $hjll3.group)(data, x);
        return {
            xScale: xScale,
            yScale: yScale,
            colorScale: colorScale,
            seriesData: seriesData
        };
    }, [
        data,
        x,
        y,
        color,
        width,
        height,
        log,
        yDomain
    ]);
    return props.children(value);
});

});



parcelRegister("l5BNN", function(module, exports) {

$parcel$export(module.exports, "LineTooltipOverlayElement", () => $f5a7635727a4a866$export$3b8bee032f520d15);
$parcel$export(module.exports, "LineTooltipOverlay", () => $f5a7635727a4a866$export$5b99d955e74ee803);

var $5uXOq = parcelRequire("5uXOq");

var $bT1Sw = parcelRequire("bT1Sw");


var $lrseF = parcelRequire("lrseF");

var $13b02 = parcelRequire("13b02");

var $3xZ2d = parcelRequire("3xZ2d");

var $4mjAg = parcelRequire("4mjAg");

var $2OMIu = parcelRequire("2OMIu");
const $f5a7635727a4a866$export$3b8bee032f520d15 = (0, $bT1Sw.element)((props)=>{
    const { tooltipOpen: tooltipOpen, showTooltip: showTooltip, hideTooltip: hideTooltip, tooltipData: tooltipData, width: width, height: height, xScale: xScale, yScale: yScale, colorScale: colorScale, xAccessor: xAccessor, colorAccessor: colorAccessor, margin: margin, yAccessor: yAccessor, seriesData: seriesData, data: data, onClick: onClick } = props;
    const eventEmitters = (0, $13b02.default)({
        source: (0, $0277c50b98747247$export$69b1818e3c4e83f9)
    });
    (0, $3xZ2d.default)({
        dataKey: 'nearest',
        onPointerMove: (d)=>showTooltip(d),
        onPointerOut: ()=>hideTooltip(),
        onPointerDown: (d)=>onClick && onClick(d),
        allowedSources: [
            (0, $0277c50b98747247$export$69b1818e3c4e83f9)
        ],
        width: width,
        margin: margin,
        height: height,
        data: data,
        xScale: xScale,
        yScale: yScale,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        seriesData: seriesData
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            tooltipOpen && (tooltipData === null || tooltipData === void 0 ? void 0 : tooltipData.nearestSeriesData) && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                children: tooltipData === null || tooltipData === void 0 ? void 0 : tooltipData.nearestSeriesData.map((d)=>{
                    var _xScale, _yScale;
                    return /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                        cx: (_xScale = xScale(xAccessor(d))) !== null && _xScale !== void 0 ? _xScale : 0,
                        cy: (_yScale = yScale(yAccessor(d))) !== null && _yScale !== void 0 ? _yScale : height,
                        fill: colorScale(colorAccessor(d)),
                        r: 5
                    }, xScale(xAccessor(d)) + '-' + xAccessor(d) + '-' + colorAccessor(d));
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                style: {
                    cursor: onClick ? 'pointer' : 'default'
                },
                width: width,
                height: height,
                fill: "transparent",
                ...eventEmitters
            })
        ]
    });
});
function $f5a7635727a4a866$export$5b99d955e74ee803() {
    const { width: width, height: height, xScale: xScale, yScale: yScale, xAccessor: xAccessor, colorAccessor: colorAccessor, colorScale: colorScale, yAccessor: yAccessor, seriesData: seriesData, margin: margin, data: data } = (0, $4mjAg.useLineData)();
    const { showTooltip: showTooltip, tooltipData: tooltipData, tooltipOpen: tooltipOpen, hideTooltip: hideTooltip } = (0, $5uXOq.useContext)((0, $lrseF.default));
    return /*#__PURE__*/ (0, $2OMIu.jsx)($f5a7635727a4a866$export$3b8bee032f520d15, {
        tooltipOpen: tooltipOpen,
        showTooltip: showTooltip,
        hideTooltip: hideTooltip,
        tooltipData: tooltipData,
        width: width,
        height: height,
        xScale: xScale,
        yScale: yScale,
        xAccessor: xAccessor,
        colorScale: colorScale,
        colorAccessor: colorAccessor,
        yAccessor: yAccessor,
        margin: margin,
        seriesData: seriesData,
        data: data
    });
}

});

parcelRegister("7OPXS", function(module, exports) {

$parcel$export(module.exports, "PureLineChart", () => $5b158306225ae5bf$export$165a9edbbc19a7c);

var $hjll3 = parcelRequire("hjll3");

var $5uXOq = parcelRequire("5uXOq");

var $cMmlP = parcelRequire("cMmlP");

var $hi6Wp = parcelRequire("hi6Wp");

var $dnJJh = parcelRequire("dnJJh");

var $8j5jo = parcelRequire("8j5jo");

var $dluWU = parcelRequire("dluWU");

var $8eCyF = parcelRequire("8eCyF");

var $bwzl0 = parcelRequire("bwzl0");

var $and0K = parcelRequire("and0K");

var $8iaLp = parcelRequire("8iaLp");

var $g5ijG = parcelRequire("g5ijG");

var $b2QkR = parcelRequire("b2QkR");

var $l5BNN = parcelRequire("l5BNN");

var $4mjAg = parcelRequire("4mjAg");

var $2OMIu = parcelRequire("2OMIu");
function $5b158306225ae5bf$var$defaultColorAccessor() {
    return (d)=>'';
}
function $5b158306225ae5bf$var$useAccessors(_ref) {
    let { xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor } = _ref;
    // GENERATE ENCODINGS
    const [x, y, color] = (0, $5uXOq.useMemo)(()=>{
        const [x] = (0, $8j5jo.useSafeAccessors)(xAccessor);
        const [y] = (0, $8j5jo.useSafeAccessors)(yAccessor);
        const [color] = (0, $8j5jo.useSafeAccessors)(colorAccessor);
        return [
            x,
            y,
            color
        ];
    }, [
        xAccessor,
        yAccessor,
        colorAccessor
    ]);
    return {
        x: x,
        y: y,
        color: color
    };
}
function $5b158306225ae5bf$export$165a9edbbc19a7c(_ref2) {
    let { data: data, width: width, height: height, xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, margin: margin = (0, $dluWU.DEFAULT_MARGIN), svgRef: svgRef } = _ref2;
    const [plotHeight, plotWidth] = (0, $5uXOq.useMemo)(()=>[
            Math.max(0, height - margin.top - margin.bottom),
            Math.max(0, width - margin.left - margin.right)
        ], [
        height,
        margin,
        width
    ]);
    // GENERATE ACCESSORS
    const { x: x, y: y, color: color } = $5b158306225ae5bf$var$useAccessors({
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        colorAccessor: colorAccessor || $5b158306225ae5bf$var$defaultColorAccessor()
    });
    const groups = (0, $5uXOq.useMemo)(()=>(0, $hjll3.group)(data, color), [
        data,
        color
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $4mjAg.LineDataProvider), {
        data: data,
        x: x,
        y: y,
        color: color,
        width: plotWidth,
        height: plotHeight,
        xAccessor: x,
        yAccessor: y,
        colorAccessor: color,
        margin: margin,
        lineGroups: groups,
        children: [
            colorAccessor && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8iaLp.LineLegend), {}),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cMmlP.default), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $and0K.LineGrid), {}),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8eCyF.LineAxes), {}),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hi6Wp.default), {
                        innerRef: svgRef,
                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dnJJh.default), {
                            top: margin.top,
                            left: margin.left,
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g5ijG.LineMarkSlot), {}),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l5BNN.LineTooltipOverlay), {})
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b2QkR.LineTooltip), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bwzl0.DataTable), {})
        ]
    });
}

});
parcelRegister("8eCyF", function(module, exports) {

$parcel$export(module.exports, "LineAxes", () => $5fed8a5ca5f0a21a$export$b60d33194508b687);

var $hqZma = parcelRequire("hqZma");

var $cXzUG = parcelRequire("cXzUG");

var $4mjAg = parcelRequire("4mjAg");

var $2OMIu = parcelRequire("2OMIu");
function $5fed8a5ca5f0a21a$export$b60d33194508b687() {
    const { xScale: xScale, yScale: yScale, height: height, width: width } = (0, $4mjAg.useLineData)();
    // We should make this check better. Move out the string constructor.s
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cXzUG.AxisLeft), {
                scale: yScale
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hqZma.AxisBottom), {
                scale: xScale,
                top: height,
                left: width
            })
        ]
    });
}

});

parcelRegister("bwzl0", function(module, exports) {

$parcel$export(module.exports, "DataTable", () => $863e183463570046$export$df30df7ec97b32b5);

var $5uXOq = parcelRequire("5uXOq");

var $PfPCm = parcelRequire("PfPCm");

var $4mjAg = parcelRequire("4mjAg");

var $2OMIu = parcelRequire("2OMIu");

const $863e183463570046$var$LazyDataTableModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>Promise.resolve((parcelRequire("lOXm0"))).then((module)=>({
            default: module.DataTableModal
        })));
function $863e183463570046$export$df30df7ec97b32b5() {
    const { showDataTable: showDataTable, closeDataTable: closeDataTable } = (0, $PfPCm.useMenuData)();
    const { data: data } = (0, $4mjAg.useLineData)();
    return showDataTable ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            style: {
                visibility: 'hidden'
            }
        }),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($863e183463570046$var$LazyDataTableModal, {
            data: data,
            closeModal: closeDataTable
        })
    }) : null;
}

});

parcelRegister("and0K", function(module, exports) {

$parcel$export(module.exports, "LineGrid", () => $78d62519bed74a84$export$d8859dcc14f68e06);

var $erST8 = parcelRequire("erST8");

var $4mjAg = parcelRequire("4mjAg");

var $2OMIu = parcelRequire("2OMIu");
function $78d62519bed74a84$export$d8859dcc14f68e06() {
    const { xScale: xScale, yScale: yScale, height: height, width: width } = (0, $4mjAg.useLineData)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $erST8.Grid), {
        yScale: yScale,
        xScale: xScale,
        width: width,
        height: height
    });
}

});

parcelRegister("8iaLp", function(module, exports) {

$parcel$export(module.exports, "LineLegend", () => $60985a9bb04a87a3$export$596c258a3ca26f43);

var $3B9ij = parcelRequire("3B9ij");

var $4mjAg = parcelRequire("4mjAg");

var $2OMIu = parcelRequire("2OMIu");
function $60985a9bb04a87a3$export$596c258a3ca26f43() {
    const { data: data, colorAccessor: colorAccessor, colorScale: colorScale } = (0, $4mjAg.useLineData)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3B9ij.OrdinalLegend), {
        shape: "line",
        data: data,
        colorScale: colorScale,
        colorAccessor: colorAccessor,
        labelAccessor: colorAccessor
    });
}

});

parcelRegister("b2QkR", function(module, exports) {

$parcel$export(module.exports, "LineTooltip", () => $80a87a5f28cb8e5e$export$88204a09bcf12e49);

var $5uXOq = parcelRequire("5uXOq");

var $lrseF = parcelRequire("lrseF");

var $2pOyr = parcelRequire("2pOyr");

var $4mjAg = parcelRequire("4mjAg");

var $2OMIu = parcelRequire("2OMIu");
function $80a87a5f28cb8e5e$export$88204a09bcf12e49() {
    const { xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, colorScale: colorScale } = (0, $4mjAg.useLineData)();
    const { tooltipData: tooltipData, tooltipLeft: tooltipLeft, tooltipTop: tooltipTop } = (0, $5uXOq.useContext)((0, $lrseF.default));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2pOyr.MultiSeriesTooltip), {
        tooltipData: tooltipData,
        tooltipLeft: tooltipLeft,
        tooltipTop: tooltipTop,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        colorAccessor: colorAccessor,
        colorScale: colorScale
    });
}

});




parcelRegister("kVYPm", function(module, exports) {

$parcel$export(module.exports, "default", () => $97ffafc7ff9a7b37$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $97ffafc7ff9a7b37$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "contextual-summary.project-summary.csat-over-time.title",
        "defaultMessage": "Average CSAT over time"
    }
});

});







//# sourceMappingURL=async-summary.1bab997e.js.map
